webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  userIsLoged: function userIsLoged() {
    var _this = this;

    axios.post(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ROOT_URL + '/api/v1/get_user').then(function (response) {}, function (response) {
      console.log(response.data);
      _this.tokenValidCalls(response, _this);
    });
  },
  tokenValidCalls: function tokenValidCalls(response, out) {
    window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].STORAGE_TOKEN_KEY);
    window.localStorage.removeItem('system');
    out.$router.push({ path: 'login' });
  },
  selectTranslation: function selectTranslation(trans_cat, trans_es) {
    var lang = window.localStorage.getItem('lang');

    switch (lang) {
      case 'cat':
        return trans_cat;
        break;
      case 'es':
        return trans_es;
        break;

      default:
        return trans_cat;
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants = {
  STORAGE_TOKEN_KEY: 'token',
  OAUTH_CLIENT_ID: 3,
  OAUTH_GRANT_TYPE: 'password',
  OAUTH_CLIENT_SECRET: 'KZqojManXkH2YxPEwyQ0qzfJ1VXPuK8Na8zVjMNb',
  OAUTH_SERVER_URL: 'https://apimobile.enateinnova.com/oauth/token',
  ROOT_URL: 'https://apimobile.enateinnova.com'
};
/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  currentDayDaterange: function currentDayDaterange() {
    return moment().format('DD/MM/YYYY') + " - " + moment().add(1, 'days').format('DD/MM/YYYY');
  },
  currentMonthDaterange: function currentMonthDaterange() {
    return moment().subtract(30, 'days').format('DD/MM/YYYY') + " - " + moment().add(1, 'days').format('DD/MM/YYYY');
  },
  currentYearDaterange: function currentYearDaterange() {
    return "01" + moment().subtract(395, 'days').format('/MM/YYYY') + " - 01" + moment().add(1, 'days').format('/MM/YYYY');
  },
  getCurrentDateTime: function getCurrentDateTime() {
    return moment().format('DD/MM/YYYY HH:mm');
  },
  transformDateResponse: function transformDateResponse(date) {
    return moment(date, "DDMMYYYYHHmmss").format('DD/MM/YYYY HH:mm:ss');
  },
  correctDateTimeAPI: function correctDateTimeAPI(date_original) {
    var date = moment(date_original, "DD/MM/YYYY HH:mm:ss");
    if (date.isDST()) {
      return date.add(2, 'hours').format('DD/MM/YYYY HH:mm:ss');
    } else {
      return date.add(1, 'hours').format('DD/MM/YYYY HH:mm:ss');
    }
  },
  correctDateTimeRawAPI: function correctDateTimeRawAPI(date_original) {
    var date = moment(date_original, "DDMMYYYYHHmmss");
    if (date.isDST()) {
      return date.add(2, 'hours').format('DDMMYYYYHHmmss');
    } else {
      return date.add(1, 'hours').format('DDMMYYYYHHmmss');
    }
  },
  getmonthInYears: function getmonthInYears(month_number) {
    switch (month_number) {
      case 1:
        return 'Gener';
      case 2:
        return 'Febrer';
      case 3:
        return 'Març';
      case 4:
        return 'Abril';
      case 5:
        return 'Maig';
      case 6:
        return 'Juny';
      case 7:
        return 'Juliol';
      case 8:
        return 'Agost';
      case 9:
        return 'Setembre';
      case 10:
        return 'Octubre';
      case 11:
        return 'Novembre';
      case 12:
        return 'Desembre';
    }
  }
});

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-fe406300",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dates_intervals__ = __webpack_require__(4);

/* harmony default export */ __webpack_exports__["a"] = ({
  lineDataTransformCanvasJS: function lineDataTransformCanvasJS(graph_data, type_graph, name) {
    var graph_array = [];
    for (var i = 0; i < graph_data.length; i++) {
      graph_data[i].dateTime = __WEBPACK_IMPORTED_MODULE_0__dates_intervals__["a" /* default */].correctDateTimeRawAPI(graph_data[i].dateTime);
      if (i === 0) {
        if (graph_data[i].field.length > 1) {
          for (var c = 0; c < graph_data[i].field.length; c++) {
            graph_array.push({ "type": type_graph, xValueFormatString: 'DD/MM HH:mm', showInLegend: true, name: name[c], "dataPoints": [{ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1, parseInt(graph_data[i].dateTime[0] + graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8] + graph_data[i].dateTime[9]), graph_data[i].dateTime[10] + graph_data[i].dateTime[11]), "y": Math.round(graph_data[i].field[c].value * 100) / 100 }] });
          }
        } else {
          graph_array.push({ "type": type_graph, xValueFormatString: 'DD/MM HH:mm', showInLegend: true, name: name[0], "dataPoints": [{ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1, parseInt(graph_data[i].dateTime[0] + graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8] + graph_data[i].dateTime[9]), graph_data[i].dateTime[10] + graph_data[i].dateTime[11]), "y": Math.round(graph_data[i].field.value * 100) / 100 }] });
        }
      } else {
        if (graph_data[i].field.length > 1) {
          for (var c = 0; c < graph_data[i].field.length; c++) {
            graph_array[c].dataPoints.push({ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1, parseInt(graph_data[i].dateTime[0] + graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8] + graph_data[i].dateTime[9]), graph_data[i].dateTime[10] + graph_data[i].dateTime[11]), "y": Math.round(graph_data[i].field[c].value * 100) / 100 });
          }
        } else {
          graph_array[0].dataPoints.push({ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1, parseInt(graph_data[i].dateTime[0] + graph_data[i].dateTime[1]), parseInt(graph_data[i].dateTime[8] + graph_data[i].dateTime[9]), graph_data[i].dateTime[10] + graph_data[i].dateTime[11]), "y": Math.round(graph_data[i].field.value * 100) / 100 });
        }
      }
    }
    return graph_array;
  },
  dataTransYearlyFormCanvasJS: function dataTransYearlyFormCanvasJS(graph_data, type_graph, name) {
    var graph_array = [];
    var month = parseInt(graph_data[0].dateTime[2] + graph_data[0].dateTime[3]);
    var lecture = parseFloat(graph_data[0].field.value);

    for (var i = 1; i < graph_data.length; i++) {
      if (parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) !== month) {
        if (graph_array.length === 0) {
          graph_array.push({ "type": type_graph, xValueFormatString: 'MM/YYYY', showInLegend: false, name: name[0], color: "blue", "dataPoints": [{ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1), "y": Math.round((parseFloat(graph_data[i].field.value) - lecture) * 100) / 100 }] });
          month = parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]);
          lecture = parseFloat(graph_data[i].field.value);
        } else {
          graph_array[0].dataPoints.push({ "x": new Date(graph_data[i].dateTime[4] + graph_data[i].dateTime[5] + graph_data[i].dateTime[6] + graph_data[i].dateTime[7], parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]) - 1), "y": Math.round((parseFloat(graph_data[i].field.value) - lecture) * 100) / 100 });
          month = parseInt(graph_data[i].dateTime[2] + graph_data[i].dateTime[3]);
          lecture = parseFloat(graph_data[i].field.value);
        }
      }
    }

    return graph_array;
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = {"selected_device_t":"Seleccionar Dispositiu","partials":{"pot_contracted":"Pot. Contractada","pot_penalty":"Pot. Penalització","api":"Pot. Actual","current_tension":"Tensió actual","api_now":"Potència Activa Instantània","active_reactive":"Energia activa-reactiva","ae":"Energia Activa","ie":"Energia Reactiva","cosi":"Cosinus de Phi Instantàni","historical_active_power":"Històric potència activa","historical_active_reactive_energy":"Històric energia activa-reactiva"}}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {"electric_params":"Paràmetres Elèctrics","generator":"Grup Electrogen","pump_well":"Bomba-Bassa","partials":{"historical_active_power_diary":"Històric diari potència activa","historical_active_energy":"Finals de comptadors d'energia","total_energy":"Energia Activa Total Combinada","cos_phi_2":"Cosinus de phi φ","pot_contracted":"Pot. Contractada","pot_penalty":"Pot. Penalització","current_power":"Pot. Actual","status":"Estat","current_active_power":"Potència Activa Instantània","current_active_power_combined":"Potència Activa Instantània Combinada","cos_phi":"Cosinus de Phi Instantani","monthly_energy_consumed":"Històric anual d'energia consumida","generator_status":"Estat Grup","api_general":"Pot. General","api_generator":"Pot. Grup","current_tension":"Tensió actual","active_power":"Potència activa","active_power_now":"Potència Activa Instantània","active_reactive_energy":"Energia activa reactiva","Cos_phi":"Cosinus de phi","monthly_active_power":"Històric potencia activa mensual","pump_status":"Estat Bomba","flow_pump":"Cabal Bomba","counter_lecture":"Lec. Comptador","vol_raft":"Niv. Bassa","historical_pump_activations":"Històric activacions bomba","historical_low_level":"Històric nivell bassa"}}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {"selected_device_t":"Seleccionar Dispositivo","partials":{"pot_contracted":"Pot. Contratada","pot_penalty":"Pot. Penalización","api":"Pot. Actual","current_tension":"Tensión actual","api_now":"Potencia Activa Instantánea","active_reactive":"Energía activa-reactiva","ae":"Energía Activa","ie":"Energía Reactiva","cosi":"Coseno de Phi instantáneo","historical_active_power":"Histórico potencia activa","historical_active_reactive_energy":"Histórico energía activa-reactiva"}}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {"electric_params":"Parámetros Eléctricos","generator":"Grupo Electrógeno","pump_well":"Bomba-Balsa","partials":{"historical_active_power_diary":"Histórico diario potencia activa","historical_active_energy":"Finals de comptadors d'energia","total_energy":"Energia Activa Total Combinada","cos_phi_2":"Coseno de phi φ","pot_penalty":"Pot. Penalización","current_power":"Pot. Actual","status":"Estado","current_active_power":"Potencia Activa Instantánea","current_active_power_combined":"Potencia Activa Instantánea Combinada","cos_phi":"Coseno de Phi Instantáneo","monthly_energy_consumed":"Histórico anual de energía consumida","generator_status":"Estado Grupo","pot_contracted":"Pot. Contratada","api_general":"Pot. General","api_generator":"Pot. Grupo","current_tension":"Tensión actual","active_power":"Potencia activa","active_power_now":"Potencia Activa Instantánea","active_reactive_energy":"Energía activa reactiva","Cos_phi":"Coseno de phi","monthly_active_power":"Histórico potencia activa mensual","pump_status":"Estado Bomba","flow_pump":"Caudal Bomba","counter_lecture":"Lec. Contador","vol_raft":"Niv. Balsa","historical_pump_activations":"Histórico activaciones bomba","historical_low_level":"Histórico nivel balsa"}}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

module.exports = {"generator":"Grup Electrogen","pump":"Bomba-Bassa","diffs":"Magnetos-Diferencials","partials":{"raft_level":"Nivell Bassa","cabdal":"Cabal Aigua","pump_status":"Estat Bomba","shuntings":"Maniobres","start_mode":"Mode d'arranc","physical_selector":"Selector fisic","shunting":"Maniobra","historical_shunting":"Històric maniobres","historical_raft_level":"Històric nivell bassa","contracted_power":"Pot. Contractada","general_power":"Pot. General","generator_power":"Pot. Grup","shunting_status":"Estat Maniobra","selector_status":"Estat Selector","contactor_status":"Estat Contactor","net_supply":"XARXA","generator":"GRUP","generator_status":"Estat Grup","emergency_stop":"Parada d'emergència","deactivated":"DESACTIVAT","compare_powers":"Comparativa Pot. General - Pot. Grup","mag_diff_well":"Mag/Dif Pou","mag_diff_raft":"Mag/Dif Bassa","status":"Estat"}}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = {"generator":"Grupo Electrógeno","pump":"Bomba-Balsa","diffs":"Magnetos-Diferenciales","partials":{"raft_level":"Nivel Balsa","cabdal":"Caudal Agua","pump_status":"Estado Bomba","shuntings":"Maniobras","start_mode":"Modo de arranque","physical_selector":"Selector físico","shunting":"Maniobra","historical_shunting":"Histórico maniobras","historical_raft_level":"Histórico nivel balsa","contracted_power":"Pot. Contratada","general_power":"Pot. General","generator_power":"Pot. Grupo","shunting_status":"Estado Maniobra","selector_status":"Estado Selector","contactor_status":"Estat Contactor","net_supply":"RED","generator":"GRUPO","generator_status":"Estado Grupo","emergency_stop":"Parada de emergencia","deactivated":"DESACTIVADO","compare_powers":"Comparativa Pot. General - Pot. Grupo","mag_diff_well":"Mag/Dif Pozo","mag_diff_raft":"Mag/Dif Balsa","status":"Estado"}}

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports) {

module.exports = {"aside":{},"breadcrumb":{},"footer":{},"header":{"select_system":"Seleccionar Sistema ","profile":"Perfil","logout":"Sortir"},"sidebar":{"general_info":"Informació general","start":"Inici","devices":"Dispositius","shunttings":"Maniobres","status_system":"Estat sistema","notifications":"Notificacions","messages":"Missatges","events":"Esdeveniments","informs":"Informes i Històrics","maximeters":"Maxímetre","export_inform":"Exportar Informació","inf_energetic":"Inf. Energétic","inf_costs":"Inf. Costos","invoice_simulation":"Simulació Factura","annually_inform":"Inf. Anual","app_info":"Informació APP","sce_info":"Informació SCE"},"navbar":{}}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = {"aside":{},"breadcrumb":{},"footer":{},"header":{"select_system":"Seleccionad Sistema","profile":"Perfil","logout":"Salir"},"sidebar":{"general_info":"Información general","start":"Inicio","devices":"Dispositivos","shunttings":"Maniobras","status_system":"Estado sistema","notifications":"Notificaciones","messages":"Mensajes","events":"Eventos","informs":"Informes e Históricos","maximeters":"Maxímetro","export_inform":"Exportar Información","inf_energetic":"Inf. Energético","inf_costs":"Inf. Costes","invoice_simulation":"Simulación Factura","annually_inform":"Inf. Anual","app_info":"Información APP","sce_info":"Información SCE"},"navbar":{}}

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_Full_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_SelectSystem_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_SelectSystem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_SelectSystem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Home_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Device_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Device_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Device_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Shuntting_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Shuntting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Shuntting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Notifications_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Notifications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Messages_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Events_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Maximeter_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Maximeter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Maximeter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_ExportData_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_ExportData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_ExportData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_EnergeticInform_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_EnergeticInform_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_EnergeticInform_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_CostsInform_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_CostsInform_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_CostsInform_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_InvoiceSimulation_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_InvoiceSimulation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_InvoiceSimulation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_InfoApp_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_InfoApp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_InfoApp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Profile_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Profile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Settings_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_CabalTemp_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_CabalTemp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_CabalTemp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_AnuallSumary_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_AnuallSumary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_AnuallSumary_vue__);
























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/home',
    name: 'Seleccionar Sistema',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full_vue___default.a,
    children: [{
      path: '/',
      name: '',
      component: __WEBPACK_IMPORTED_MODULE_4__views_SelectSystem_vue___default.a
    }, {
      path: 'home',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_5__views_Home_vue___default.a
    }, {
      path: 'device',
      name: 'Device',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Device_vue___default.a
    }, {
      path: 'shunting',
      name: 'Shunting',
      component: __WEBPACK_IMPORTED_MODULE_7__views_Shuntting_vue___default.a
    }, {
      path: 'notifications',
      name: 'Notifications',
      component: __WEBPACK_IMPORTED_MODULE_8__views_Notifications_vue___default.a
    }, {
      path: 'messages',
      name: 'Messages',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Messages_vue___default.a
    }, {
      path: 'events',
      name: 'Events',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Events_vue___default.a
    }, {
      path: 'maximeter',
      name: 'Maximeter',
      component: __WEBPACK_IMPORTED_MODULE_11__views_Maximeter_vue___default.a
    }, {
      path: 'export_data',
      name: 'ExportData',
      component: __WEBPACK_IMPORTED_MODULE_12__views_ExportData_vue___default.a
    }, {
      path: 'energetic_inform',
      name: 'EnergeticInform',
      component: __WEBPACK_IMPORTED_MODULE_13__views_EnergeticInform_vue___default.a
    }, {
      path: 'costs_inform',
      name: 'CostsInform',
      component: __WEBPACK_IMPORTED_MODULE_14__views_CostsInform_vue___default.a
    }, {
      path: 'invoice_simulation',
      name: 'InvoiceSimulation',
      component: __WEBPACK_IMPORTED_MODULE_15__views_InvoiceSimulation_vue___default.a
    }, {
      path: 'anuall_sumary',
      name: 'AnuallSumary',
      component: __WEBPACK_IMPORTED_MODULE_20__views_AnuallSumary_vue___default.a
    }, {
      path: 'info',
      name: 'InfoApp',
      component: __WEBPACK_IMPORTED_MODULE_16__views_InfoApp_vue___default.a
    }, {
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_17__views_Profile_vue___default.a
    }, {
      path: 'settings',
      name: 'Settings',
      component: __WEBPACK_IMPORTED_MODULE_18__views_Settings_vue___default.a
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Login_vue___default.a
  }, {
    path: '/cabal_temp',
    name: 'CabalTemp',
    component: __WEBPACK_IMPORTED_MODULE_19__views_CabalTemp_vue___default.a
  }, {
    path: '/select_system',
    name: 'SelectSystem',
    component: __WEBPACK_IMPORTED_MODULE_4__views_SelectSystem_vue___default.a
  }]
}));

/***/ }),
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */,
/* 242 */
/***/ (function(module, exports) {

/*
 CanvasJS HTML5 & JavaScript Charts - v1.9.8 GA - http://canvasjs.com/ 
 Copyright 2017 fenopix

  --------------------- License Information --------------------
 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
     http://canvasjs.com/license-canvasjs/

*/
(function() {
    function U(a, d) {
        a.prototype = Pa(d.prototype);
        a.prototype.constructor = a;
        a.base = d.prototype
    }

    function Pa(a) {
        function d() {}
        d.prototype = a;
        return new d
    }

    function Ha(a, d, b) {
        "millisecond" === b ? a.setMilliseconds(a.getMilliseconds() + 1 * d) : "second" === b ? a.setSeconds(a.getSeconds() + 1 * d) : "minute" === b ? a.setMinutes(a.getMinutes() + 1 * d) : "hour" === b ? a.setHours(a.getHours() + 1 * d) : "day" === b ? a.setDate(a.getDate() + 1 * d) : "week" === b ? a.setDate(a.getDate() + 7 * d) : "month" === b ? a.setMonth(a.getMonth() + 1 * d) : "year" === b && a.setFullYear(a.getFullYear() +
            1 * d);
        return a
    }

    function O(a, d) {
        var b = !1;
        0 > a && (b = !0, a *= -1);
        a = "" + a;
        for (d = d ? d : 1; a.length < d;) a = "0" + a;
        return b ? "-" + a : a
    }

    function ka(a) {
        if (!a) return a;
        a = a.replace(/^\s\s*/, "");
        for (var d = /\s/, b = a.length; d.test(a.charAt(--b)););
        return a.slice(0, b + 1)
    }

    function Qa(a) {
        a.roundRect = function(a, b, c, f, g, h, l, k) {
            l && (this.fillStyle = l);
            k && (this.strokeStyle = k);
            "undefined" === typeof g && (g = 5);
            this.lineWidth = h;
            this.beginPath();
            this.moveTo(a + g, b);
            this.lineTo(a + c - g, b);
            this.quadraticCurveTo(a + c, b, a + c, b + g);
            this.lineTo(a + c, b + f - g);
            this.quadraticCurveTo(a + c, b + f, a + c - g, b + f);
            this.lineTo(a + g, b + f);
            this.quadraticCurveTo(a, b + f, a, b + f - g);
            this.lineTo(a, b + g);
            this.quadraticCurveTo(a, b, a + g, b);
            this.closePath();
            l && this.fill();
            k && 0 < h && this.stroke()
        }
    }

    function ya(a, d) {
        return a - d
    }

    function Ia(a, d) {
        return a.x - d.x
    }

    function G(a) {
        var d = ((a & 16711680) >> 16).toString(16),
            b = ((a & 65280) >> 8).toString(16);
        a = ((a & 255) >> 0).toString(16);
        d = 2 > d.length ? "0" + d : d;
        b = 2 > b.length ? "0" + b : b;
        a = 2 > a.length ? "0" + a : a;
        return "#" + d + b + a
    }

    function Ra(a, d) {
        var b = this.length >>> 0,
            c = Number(d) ||
            0,
            c = 0 > c ? Math.ceil(c) : Math.floor(c);
        for (0 > c && (c += b); c < b; c++)
            if (c in this && this[c] === a) return c;
        return -1
    }

    function x(a) {
        return null === a || "undefined" === typeof a
    }

    function qa(a) {
        a.indexOf || (a.indexOf = Ra);
        return a
    }

    function Ja(a, d, b) {
        b = b || "normal";
        var c = a + "_" + d + "_" + b,
            f = Ka[c];
        if (isNaN(f)) {
            try {
                a = "position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:" + a + "; font-size:" + d + "px; font-weight:" + b + ";";
                if (!ba) {
                    var g = document.body;
                    ba = document.createElement("span");
                    ba.innerHTML = "";
                    var h = document.createTextNode("Mpgyi");
                    ba.appendChild(h);
                    g.appendChild(ba)
                }
                ba.style.display = "";
                ba.setAttribute("style", a);
                f = Math.round(ba.offsetHeight);
                ba.style.display = "none"
            } catch (l) {
                f = Math.ceil(1.1 * d)
            }
            f = Math.max(f, d);
            Ka[c] = f
        }
        return f
    }

    function I(a, d) {
        var b = [];
        if (b = {
                solid: [],
                shortDash: [3, 1],
                shortDot: [1, 1],
                shortDashDot: [3, 1, 1, 1],
                shortDashDotDot: [3, 1, 1, 1, 1, 1],
                dot: [1, 2],
                dash: [4, 2],
                dashDot: [4, 2, 1, 2],
                longDash: [8, 2],
                longDashDot: [8, 2, 1, 2],
                longDashDotDot: [8, 2, 1, 2, 1, 2]
            }[a || "solid"])
            for (var c =
                    0; c < b.length; c++) b[c] *= d;
        else b = [];
        return b
    }

    function K(a, d, b, c) {
        if (a.addEventListener) a.addEventListener(d, b, c || !1);
        else if (a.attachEvent) a.attachEvent("on" + d, function(c) {
            c = c || window.event;
            c.preventDefault = c.preventDefault || function() {
                c.returnValue = !1
            };
            c.stopPropagation = c.stopPropagation || function() {
                c.cancelBubble = !0
            };
            b.call(a, c)
        });
        else return !1
    }

    function La(a, d, b) {
        a *= Q;
        d *= Q;
        a = b.getImageData(a, d, 2, 2).data;
        d = !0;
        for (b = 0; 4 > b; b++)
            if (a[b] !== a[b + 4] | a[b] !== a[b + 8] | a[b] !== a[b + 12]) {
                d = !1;
                break
            }
        return d ? a[0] <<
            16 | a[1] << 8 | a[2] : 0
    }

    function L(a, d, b) {
        return a in d ? d[a] : b[a]
    }

    function ra(a, d, b) {
        if (u && Ma) {
            var c = a.getContext("2d");
            sa = c.webkitBackingStorePixelRatio || c.mozBackingStorePixelRatio || c.msBackingStorePixelRatio || c.oBackingStorePixelRatio || c.backingStorePixelRatio || 1;
            Q = za / sa;
            a.width = d * Q;
            a.height = b * Q;
            za !== sa && (a.style.width = d + "px", a.style.height = b + "px", c.scale(Q, Q))
        } else a.width = d, a.height = b
    }

    function Sa(a) {
        if (!Aa) {
            var d = !1,
                b = !1;
            "undefined" === typeof ca.Chart.creditHref ? (a.creditHref = "http://canvasjs.com/",
                a.creditText = "CanvasJS.com") : (d = a.updateOption("creditText"), b = a.updateOption("creditHref"));
            if (a.creditHref && a.creditText) {
                a._creditLink || (a._creditLink = document.createElement("a"), a._creditLink.setAttribute("class", "canvasjs-chart-credit"), a._creditLink.setAttribute("style", "outline:none;margin:0px;position:absolute;right:2px;top:" + (a.height - 14) + "px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"), a._creditLink.setAttribute("tabIndex", -1), a._creditLink.setAttribute("target", "_blank"));
                if (0 === a.renderCount || d || b) a._creditLink.setAttribute("href", a.creditHref), a._creditLink.innerHTML = a.creditText;
                a._creditLink && a.creditHref && a.creditText ? (a._creditLink.parentElement || a._canvasJSContainer.appendChild(a._creditLink), a._creditLink.style.top = a.height - 14 + "px") : a._creditLink.parentElement && a._canvasJSContainer.removeChild(a._creditLink)
            }
        }
    }

    function ga(a, d) {
        var b = document.createElement("canvas");
        b.setAttribute("class", "canvasjs-chart-canvas");
        ra(b, a, d);
        u || "undefined" === typeof G_vmlCanvasManager || G_vmlCanvasManager.initElement(b);
        return b
    }

    function Ba(a, d, b) {
        if (a && d && b) {
            b = b + "." + d;
            var c = "image/" + d;
            a = a.toDataURL(c);
            var f = !1,
                g = document.createElement("a");
            g.download = b;
            g.href = a;
            g.target = "_blank";
            if ("undefined" !== typeof Blob && new Blob) {
                for (var h = a.replace(/^data:[a-z/]*;base64,/, ""), h = atob(h), l = new ArrayBuffer(h.length), l = new Uint8Array(l), k = 0; k < h.length; k++) l[k] = h.charCodeAt(k);
                d = new Blob([l.buffer], {
                    type: "image/" + d
                });
                try {
                    window.navigator.msSaveBlob(d,
                        b), f = !0
                } catch (m) {
                    g.dataset.downloadurl = [c, g.download, g.href].join(":"), g.href = window.URL.createObjectURL(d)
                }
            }
            if (!f) try {
                event = document.createEvent("MouseEvents"), event.initMouseEvent("click", !0, !1, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), g.dispatchEvent ? g.dispatchEvent(event) : g.fireEvent && g.fireEvent("onclick")
            } catch (n) {
                d = window.open(), d.document.write("<img src='" + a + "'></img><div>Please right click on the image and save it to your device</div>"), d.document.close()
            }
        }
    }

    function T(a, d, b) {
        d.getAttribute("state") !==
            b && (d.setAttribute("state", b), d.setAttribute("type", "button"), d.style.position = "relative", d.style.margin = "0px 0px 0px 0px", d.style.padding = "3px 4px 0px 4px", d.style.cssFloat = "left", d.setAttribute("title", a._cultureInfo[b + "Text"]), d.innerHTML = "<img style='height:16px;' src='" + Ta[b].image + "' alt='" + a._cultureInfo[b + "Text"] + "' />")
    }

    function ta() {
        for (var a = null, d = 0; d < arguments.length; d++) a = arguments[d], a.style && (a.style.display = "inline")
    }

    function Y() {
        for (var a = null, d = 0; d < arguments.length; d++)(a = arguments[d]) &&
            a.style && (a.style.display = "none")
    }

    function M(a, d, b, c) {
        this._defaultsKey = a;
        this.parent = c;
        this._eventListeners = [];
        c = {};
        b && (ia[b] && ia[b][a]) && (c = ia[b][a]);
        this.options = d ? d : {
            _isPlaceholder: !0
        };
        this.setOptions(this.options, c)
    }

    function A(a, d) {
        d = d || {};
        A.base.constructor.call(this, "Chart", d, d.theme ? d.theme : "theme1");
        var b = this;
        this._containerId = a;
        this._objectsInitialized = !1;
        this.overlaidCanvasCtx = this.ctx = null;
        this._indexLabels = [];
        this._panTimerId = 0;
        this._lastTouchEventType = "";
        this._lastTouchData = null;
        this.isAnimating = !1;
        this.renderCount = 0;
        this.panEnabled = this.disableToolTip = this.animatedRender = !1;
        this._defaultCursor = "default";
        this.plotArea = {
            canvas: null,
            ctx: null,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            width: 0,
            height: 0
        };
        this._dataInRenderedOrder = [];
        if (this.container = "string" === typeof this._containerId ? document.getElementById(this._containerId) : this._containerId) {
            this.container.innerHTML = "";
            var c = 0,
                f = 0,
                c = this.options.width ? this.width : 0 < this.container.clientWidth ? this.container.clientWidth : this.width,
                f = this.options.height ? this.height :
                0 < this.container.clientHeight ? this.container.clientHeight : this.height;
            this.width = c;
            this.height = f;
            this.x1 = this.y1 = 0;
            this.x2 = this.width;
            this.y2 = this.height;
            this._selectedColorSet = "undefined" !== typeof ha[this.colorSet] ? ha[this.colorSet] : ha.colorSet1;
            this._canvasJSContainer = document.createElement("div");
            this._canvasJSContainer.setAttribute("class", "canvasjs-chart-container");
            this._canvasJSContainer.style.position = "relative";
            this._canvasJSContainer.style.textAlign = "left";
            this._canvasJSContainer.style.cursor =
                "auto";
            u || (this._canvasJSContainer.style.height = "0px");
            this.container.appendChild(this._canvasJSContainer);
            this.canvas = ga(c, f);
            this.canvas.style.position = "absolute";
            this.canvas.getContext && (this._canvasJSContainer.appendChild(this.canvas), this.ctx = this.canvas.getContext("2d"), this.ctx.textBaseline = "top", Qa(this.ctx), u ? this.plotArea.ctx = this.ctx : (this.plotArea.canvas = ga(c, f), this.plotArea.canvas.style.position = "absolute", this.plotArea.canvas.setAttribute("class", "plotAreaCanvas"), this._canvasJSContainer.appendChild(this.plotArea.canvas),
                    this.plotArea.ctx = this.plotArea.canvas.getContext("2d")), this.overlaidCanvas = ga(c, f), this.overlaidCanvas.style.position = "absolute", this._canvasJSContainer.appendChild(this.overlaidCanvas), this.overlaidCanvasCtx = this.overlaidCanvas.getContext("2d"), this.overlaidCanvasCtx.textBaseline = "top", this._eventManager = new la(this), K(window, "resize", function() {
                    b._updateSize() && b.render()
                }), this._toolBar = document.createElement("div"), this._toolBar.setAttribute("class", "canvasjs-chart-toolbar"), this._toolBar.style.cssText =
                "position: absolute; right: 1px; top: 1px;", this._canvasJSContainer.appendChild(this._toolBar), this.bounds = {
                    x1: 0,
                    y1: 0,
                    x2: this.width,
                    y2: this.height
                }, K(this.overlaidCanvas, "click", function(a) {
                    b._mouseEventHandler(a)
                }), K(this.overlaidCanvas, "mousemove", function(a) {
                    b._mouseEventHandler(a)
                }), K(this.overlaidCanvas, "mouseup", function(a) {
                    b._mouseEventHandler(a)
                }), K(this.overlaidCanvas, "mousedown", function(a) {
                    b._mouseEventHandler(a);
                    Y(b._dropdownMenu)
                }), K(this.overlaidCanvas, "mouseout", function(a) {
                    b._mouseEventHandler(a)
                }),
                K(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart", function(a) {
                    b._touchEventHandler(a)
                }), K(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove", function(a) {
                    b._touchEventHandler(a)
                }), K(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend", function(a) {
                    b._touchEventHandler(a)
                }), K(this.overlaidCanvas, window.navigator.msPointerEnabled ? "MSPointerCancel" : "touchcancel", function(a) {
                    b._touchEventHandler(a)
                }), this.toolTip =
                new S(this, this.options.toolTip), this.data = null, this.axisX = [], this.axisX2 = [], this.axisY = [], this.axisY2 = [], this.sessionVariables = {
                    axisX: [],
                    axisX2: [],
                    axisY: [],
                    axisY2: []
                })
        } else window.console && window.console.log('CanvasJS Error: Chart Container with id "' + this._containerId + '" was not found')
    }

    function ua(a, d) {
        for (var b = [], c, f = 0; f < a.length; f++)
            if (0 == f) b.push(a[0]);
            else {
                var g, h, l;
                l = f - 1;
                g = 0 === l ? 0 : l - 1;
                h = l === a.length - 1 ? l : l + 1;
                c = Math.abs((a[h].x - a[g].x) / (0 === a[h].x - a[l].x ? 0.01 : a[h].x - a[l].x)) * (d - 1) / 2 + 1;
                var k =
                    (a[h].x - a[g].x) / c;
                c = (a[h].y - a[g].y) / c;
                b[b.length] = a[l].x > a[g].x && 0 < k || a[l].x < a[g].x && 0 > k ? {
                    x: a[l].x + k / 3,
                    y: a[l].y + c / 3
                } : {
                    x: a[l].x,
                    y: a[l].y + c / 9
                };
                l = f;
                g = 0 === l ? 0 : l - 1;
                h = l === a.length - 1 ? l : l + 1;
                c = Math.abs((a[h].x - a[g].x) / (0 === a[l].x - a[g].x ? 0.01 : a[l].x - a[g].x)) * (d - 1) / 2 + 1;
                k = (a[h].x - a[g].x) / c;
                c = (a[h].y - a[g].y) / c;
                b[b.length] = a[l].x > a[g].x && 0 < k || a[l].x < a[g].x && 0 > k ? {
                    x: a[l].x - k / 3,
                    y: a[l].y - c / 3
                } : {
                    x: a[l].x,
                    y: a[l].y - c / 9
                };
                b[b.length] = a[f]
            }
        return b
    }

    function Na(a, d) {
        if (null === a || "undefined" === typeof a) return d;
        var b = parseFloat(a.toString()) *
            (0 <= a.toString().indexOf("%") ? d / 100 : 1);
        return !isNaN(b) && b <= d && 0 <= b ? b : d
    }

    function ja(a, d, b, c, f) {
        "undefined" === typeof f && (f = 0);
        this._padding = f;
        this._x1 = a;
        this._y1 = d;
        this._x2 = b;
        this._y2 = c;
        this._rightOccupied = this._leftOccupied = this._bottomOccupied = this._topOccupied = this._padding
    }

    function W(a, d) {
        W.base.constructor.call(this, "TextBlock", d);
        this.ctx = a;
        this._isDirty = !0;
        this._wrappedText = null
    }

    function ma(a, d) {
        ma.base.constructor.call(this, "Title", d, a.theme, a);
        this.chart = a;
        this.canvas = a.canvas;
        this.ctx = this.chart.ctx;
        this.optionsName = "title";
        if (x(this.options.margin) && a.options.subtitles)
            for (var b = a.options.subtitles, c = 0; c < b.length; c++)
                if ((x(b[c].horizontalAlign) && "center" === this.horizontalAlign || b[c].horizontalAlign === this.horizontalAlign) && (x(b[c].verticalAlign) && "top" === this.verticalAlign || b[c].verticalAlign === this.verticalAlign) && !b[c].dockInsidePlotArea === !this.dockInsidePlotArea) {
                    this.margin = 0;
                    break
                }
        "undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
        this.height =
            this.width = null;
        this.bounds = {
            x1: null,
            y1: null,
            x2: null,
            y2: null
        }
    }

    function va(a, d) {
        va.base.constructor.call(this, "Subtitle", d, a.theme, a);
        this.chart = a;
        this.canvas = a.canvas;
        this.ctx = this.chart.ctx;
        this.optionsName = "subtitles";
        this.isOptionsInArray = !0;
        "undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
        this.height = this.width = null;
        this.bounds = {
            x1: null,
            y1: null,
            x2: null,
            y2: null
        }
    }

    function wa(a, d) {
        wa.base.constructor.call(this, "Legend", d, a.theme, a);
        this.chart =
            a;
        this.canvas = a.canvas;
        this.ctx = this.chart.ctx;
        this.ghostCtx = this.chart._eventManager.ghostCtx;
        this.items = [];
        this.optionsName = "legend";
        this.height = this.width = 0;
        this.orientation = null;
        this.dataSeries = [];
        this.bounds = {
            x1: null,
            y1: null,
            x2: null,
            y2: null
        };
        "undefined" === typeof this.options.fontSize && (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
        this.lineHeight = Ja(this.fontFamily, this.fontSize, this.fontWeight);
        this.horizontalSpacing = this.fontSize
    }

    function Ca(a, d) {
        Ca.base.constructor.call(this, d);
        this.chart = a;
        this.canvas = a.canvas;
        this.ctx = this.chart.ctx
    }

    function $(a, d, b, c) {
        $.base.constructor.call(this, "DataSeries", d, a.theme, a);
        this.chart = a;
        this.canvas = a.canvas;
        this._ctx = a.canvas.ctx;
        this.index = b;
        this.noDataPointsInPlotArea = 0;
        this.id = c;
        this.chart._eventManager.objectMap[c] = {
            id: c,
            objectType: "dataSeries",
            dataSeriesIndex: b
        };
        this.dataPointIds = [];
        this.plotUnit = [];
        this.axisY = this.axisX = null;
        this.optionsName = "data";
        this.isOptionsInArray = !0;
        null === this.fillOpacity && (this.type.match(/area/i) ? this.fillOpacity =
            0.7 : this.fillOpacity = 1);
        this.axisPlacement = this.getDefaultAxisPlacement();
        "undefined" === typeof this.options.indexLabelFontSize && (this.indexLabelFontSize = this.chart.getAutoFontSize(this.indexLabelFontSize))
    }

    function B(a, d, b, c, f) {
        B.base.constructor.call(this, "Axis", d, a.theme, a);
        this.chart = a;
        this.canvas = a.canvas;
        this.ctx = a.ctx;
        this.intervalStartPosition = this.maxHeight = this.maxWidth = 0;
        this.labels = [];
        this.dataSeries = [];
        this._stripLineLabels = this._ticks = this._labels = null;
        this.dataInfo = {
            min: Infinity,
            max: -Infinity,
            viewPortMin: Infinity,
            viewPortMax: -Infinity,
            minDiff: Infinity
        };
        this.isOptionsInArray = !0;
        "axisX" === b ? ("left" === c || "bottom" === c ? (this.optionsName = "axisX", x(this.chart.sessionVariables.axisX[f]) && (this.chart.sessionVariables.axisX[f] = {}), this.sessionVariables = this.chart.sessionVariables.axisX[f]) : (this.optionsName = "axisX2", x(this.chart.sessionVariables.axisX2[f]) && (this.chart.sessionVariables.axisX2[f] = {}), this.sessionVariables = this.chart.sessionVariables.axisX2[f]), this.options.interval || (this.intervalType =
            null), "theme2" === this.chart.theme && x(this.options.lineThickness) && (this.lineThickness = 2)) : "left" === c || "top" === c ? (this.optionsName = "axisY", x(this.chart.sessionVariables.axisY[f]) && (this.chart.sessionVariables.axisY[f] = {}), this.sessionVariables = this.chart.sessionVariables.axisY[f]) : (this.optionsName = "axisY2", x(this.chart.sessionVariables.axisY2[f]) && (this.chart.sessionVariables.axisY2[f] = {}), this.sessionVariables = this.chart.sessionVariables.axisY2[f]);
        "undefined" === typeof this.options.titleFontSize &&
            (this.titleFontSize = this.chart.getAutoFontSize(this.titleFontSize));
        "undefined" === typeof this.options.labelFontSize && (this.labelFontSize = this.chart.getAutoFontSize(this.labelFontSize));
        this.type = b;
        "axisX" !== b || d && "undefined" !== typeof d.gridThickness || (this.gridThickness = 0);
        this._position = c;
        this.lineCoordinates = {
            x1: null,
            y1: null,
            x2: null,
            y2: null,
            width: null
        };
        this.labelAngle = (this.labelAngle % 360 + 360) % 360;
        90 < this.labelAngle && 270 > this.labelAngle ? this.labelAngle -= 180 : 270 <= this.labelAngle && 360 >= this.labelAngle &&
            (this.labelAngle -= 360);
        if (this.options.stripLines && 0 < this.options.stripLines.length)
            for (this.stripLines = [], d = 0; d < this.options.stripLines.length; d++) this.stripLines.push(new na(this.chart, this.options.stripLines[d], a.theme, ++this.chart._eventManager.lastObjectId, this));
        this._titleTextBlock = null;
        this.hasOptionChanged("viewportMinimum") && null === this.viewportMinimum && (this.options.viewportMinimum = void 0, this.sessionVariables.viewportMinimum = null);
        this.hasOptionChanged("viewportMinimum") || isNaN(this.sessionVariables.newViewportMinimum) ||
            null === this.sessionVariables.newViewportMinimum ? this.sessionVariables.newViewportMinimum = null : this.viewportMinimum = this.sessionVariables.newViewportMinimum;
        this.hasOptionChanged("viewportMaximum") && null === this.viewportMaximum && (this.options.viewportMaximum = void 0, this.sessionVariables.viewportMaximum = null);
        this.hasOptionChanged("viewportMaximum") || isNaN(this.sessionVariables.newViewportMaximum) || null === this.sessionVariables.newViewportMaximum ? this.sessionVariables.newViewportMaximum = null : this.viewportMaximum =
            this.sessionVariables.newViewportMaximum;
        null !== this.minimum && null !== this.viewportMinimum && (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));
        null !== this.maximum && null !== this.viewportMaximum && (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));
        this.trackChanges("viewportMinimum");
        this.trackChanges("viewportMaximum")
    }

    function na(a, d, b, c, f) {
        na.base.constructor.call(this, "StripLine", d, b, f);
        this.id = c;
        this.chart = a;
        this.ctx = this.chart.ctx;
        this.label = this.label;
        this.axis = f;
        this.optionsName = "stripLines";
        this.isOptionsInArray = !0;
        this._thicknessType = "pixel";
        null !== this.startValue && null !== this.endValue && (this.value = f.logarithmic ? Math.sqrt((this.startValue.getTime ? this.startValue.getTime() : this.startValue) * (this.endValue.getTime ? this.endValue.getTime() : this.endValue)) : ((this.startValue.getTime ? this.startValue.getTime() : this.startValue) + (this.endValue.getTime ? this.endValue.getTime() : this.endValue)) / 2, this.thickness = f.logarithmic ? Math.log(this.endValue / this.startValue) / Math.log(f.logarithmBase) :
            Math.max(this.endValue - this.startValue), this._thicknessType = "value")
    }

    function S(a, d) {
        S.base.constructor.call(this, "ToolTip", d, a.theme, a);
        this.chart = a;
        this.canvas = a.canvas;
        this.ctx = this.chart.ctx;
        this.currentDataPointIndex = this.currentSeriesIndex = -1;
        this._timerId = 0;
        this._prevY = this._prevX = NaN;
        this.optionsName = "toolTip";
        this._initialize()
    }

    function la(a) {
        this.chart = a;
        this.lastObjectId = 0;
        this.objectMap = [];
        this.rectangularRegionEventSubscriptions = [];
        this.previousDataPointEventObject = null;
        this.ghostCanvas =
            ga(this.chart.width, this.chart.height);
        this.ghostCtx = this.ghostCanvas.getContext("2d");
        this.mouseoveredObjectMaps = []
    }

    function oa(a) {
        var d;
        a && pa[a] && (d = pa[a]);
        oa.base.constructor.call(this, "CultureInfo", d)
    }

    function Da(a) {
        this.chart = a;
        this.ctx = this.chart.plotArea.ctx;
        this.animations = [];
        this.animationRequestId = null
    }
    var z = {},
        u = !!document.createElement("canvas").getContext,
        ca = {
            Chart: {
                width: 500,
                height: 400,
                zoomEnabled: !1,
                zoomType: "x",
                backgroundColor: "white",
                theme: "theme1",
                animationEnabled: !1,
                animationDuration: 1200,
                dataPointWidth: null,
                dataPointMinWidth: null,
                dataPointMaxWidth: null,
                colorSet: "colorSet1",
                culture: "en",
                creditText: "CanvasJS",
                interactivityEnabled: !0,
                exportEnabled: !1,
                exportFileName: "Chart",
                rangeChanging: null,
                rangeChanged: null,
                publicProperties: {
                    title: "readWrite",
                    subtitles: "readWrite",
                    toolTip: "readWrite",
                    legend: "readWrite",
                    axisX: "readWrite",
                    axisY: "readWrite",
                    axisX2: "readWrite",
                    axisY2: "readWrite",
                    data: "readWrite",
                    options: "readWrite",
                    bounds: "readOnly",
                    container: "readOnly"
                }
            },
            Title: {
                padding: 0,
                text: null,
                verticalAlign: "top",
                horizontalAlign: "center",
                fontSize: 20,
                fontFamily: "Calibri",
                fontWeight: "normal",
                fontColor: "black",
                fontStyle: "normal",
                borderThickness: 0,
                borderColor: "black",
                cornerRadius: 0,
                backgroundColor: u ? "transparent" : null,
                margin: 5,
                wrap: !0,
                maxWidth: null,
                dockInsidePlotArea: !1,
                publicProperties: {
                    options: "readWrite",
                    bounds: "readOnly",
                    chart: "readOnly"
                }
            },
            Subtitle: {
                padding: 0,
                text: null,
                verticalAlign: "top",
                horizontalAlign: "center",
                fontSize: 14,
                fontFamily: "Calibri",
                fontWeight: "normal",
                fontColor: "black",
                fontStyle: "normal",
                borderThickness: 0,
                borderColor: "black",
                cornerRadius: 0,
                backgroundColor: null,
                margin: 2,
                wrap: !0,
                maxWidth: null,
                dockInsidePlotArea: !1,
                publicProperties: {
                    options: "readWrite",
                    bounds: "readOnly",
                    chart: "readOnly"
                }
            },
            Legend: {
                name: null,
                verticalAlign: "center",
                horizontalAlign: "right",
                fontSize: 14,
                fontFamily: "calibri",
                fontWeight: "normal",
                fontColor: "black",
                fontStyle: "normal",
                cursor: null,
                itemmouseover: null,
                itemmouseout: null,
                itemmousemove: null,
                itemclick: null,
                dockInsidePlotArea: !1,
                reversed: !1,
                backgroundColor: u ? "transparent" : null,
                borderColor: u ?
                    "transparent" : null,
                borderThickness: 0,
                cornerRadius: 0,
                maxWidth: null,
                maxHeight: null,
                markerMargin: null,
                itemMaxWidth: null,
                itemWidth: null,
                itemWrap: !0,
                itemTextFormatter: null,
                publicProperties: {
                    options: "readWrite",
                    bounds: "readOnly",
                    chart: "readOnly"
                }
            },
            ToolTip: {
                enabled: !0,
                shared: !1,
                animationEnabled: !0,
                content: null,
                contentFormatter: null,
                reversed: !1,
                backgroundColor: u ? "rgba(255,255,255,.9)" : "rgb(255,255,255)",
                borderColor: null,
                borderThickness: 2,
                cornerRadius: 5,
                fontSize: 14,
                fontColor: "black",
                fontFamily: "Calibri, Arial, Georgia, serif;",
                fontWeight: "normal",
                fontStyle: "italic",
                publicProperties: {
                    options: "readWrite",
                    chart: "readOnly"
                }
            },
            Axis: {
                minimum: null,
                maximum: null,
                viewportMinimum: null,
                viewportMaximum: null,
                interval: null,
                intervalType: null,
                reversed: !1,
                logarithmic: !1,
                logarithmBase: 10,
                title: null,
                titleFontColor: "black",
                titleFontSize: 20,
                titleFontFamily: "arial",
                titleFontWeight: "normal",
                titleFontStyle: "normal",
                titleWrap: !0,
                titleMaxWidth: null,
                titleBackgroundColor: u ? "transparent" : null,
                titleBorderColor: u ? "transparent" : null,
                titleBorderThickness: 0,
                titleCornerRadius: 0,
                labelAngle: 0,
                labelFontFamily: "arial",
                labelFontColor: "black",
                labelFontSize: 12,
                labelFontWeight: "normal",
                labelFontStyle: "normal",
                labelAutoFit: !0,
                labelWrap: !0,
                labelMaxWidth: null,
                labelFormatter: null,
                labelBackgroundColor: u ? "transparent" : null,
                labelBorderColor: u ? "transparent" : null,
                labelBorderThickness: 0,
                labelCornerRadius: 0,
                prefix: "",
                suffix: "",
                includeZero: !0,
                tickLength: 5,
                tickColor: "black",
                tickThickness: 1,
                lineColor: "black",
                lineThickness: 1,
                lineDashType: "solid",
                gridColor: "A0A0A0",
                gridThickness: 0,
                gridDashType: "solid",
                interlacedColor: u ? "transparent" : null,
                valueFormatString: null,
                margin: 2,
                stripLines: [],
                publicProperties: {
                    options: "readWrite",
                    bounds: "readOnly",
                    chart: "readOnly"
                }
            },
            StripLine: {
                value: null,
                startValue: null,
                endValue: null,
                color: "orange",
                opacity: null,
                thickness: 2,
                lineDashType: "solid",
                label: "",
                labelPlacement: "inside",
                labelAlign: "far",
                labelWrap: !0,
                labelMaxWidth: null,
                labelBackgroundColor: u ? "transparent" : null,
                labelBorderColor: u ? "transparent" : null,
                labelBorderThickness: 0,
                labelCornerRadius: 0,
                labelFontFamily: "arial",
                labelFontColor: "orange",
                labelFontSize: 12,
                labelFontWeight: "normal",
                labelFontStyle: "normal",
                labelFormatter: null,
                showOnTop: !1,
                publicProperties: {
                    options: "readWrite",
                    axis: "readOnly",
                    bounds: "readOnly",
                    chart: "readOnly"
                }
            },
            DataSeries: {
                name: null,
                dataPoints: null,
                label: "",
                bevelEnabled: !1,
                highlightEnabled: !0,
                cursor: "default",
                indexLabel: "",
                indexLabelPlacement: "auto",
                indexLabelOrientation: "horizontal",
                indexLabelFontColor: "black",
                indexLabelFontSize: 12,
                indexLabelFontStyle: "normal",
                indexLabelFontFamily: "Arial",
                indexLabelFontWeight: "normal",
                indexLabelBackgroundColor: null,
                indexLabelLineColor: "gray",
                indexLabelLineThickness: 1,
                indexLabelLineDashType: "solid",
                indexLabelMaxWidth: null,
                indexLabelWrap: !0,
                indexLabelFormatter: null,
                lineThickness: 2,
                lineDashType: "solid",
                connectNullData: !1,
                nullDataLineDashType: "dash",
                color: null,
                lineColor: null,
                risingColor: "white",
                fillOpacity: null,
                startAngle: 0,
                radius: null,
                innerRadius: null,
                type: "column",
                xValueType: "number",
                axisXType: "primary",
                axisYType: "primary",
                axisXIndex: 0,
                axisYIndex: 0,
                xValueFormatString: null,
                yValueFormatString: null,
                zValueFormatString: null,
                percentFormatString: null,
                showInLegend: null,
                legendMarkerType: null,
                legendMarkerColor: null,
                legendText: null,
                legendMarkerBorderColor: u ? "transparent" : null,
                legendMarkerBorderThickness: 0,
                markerType: "circle",
                markerColor: null,
                markerSize: null,
                markerBorderColor: u ? "transparent" : null,
                markerBorderThickness: 0,
                mouseover: null,
                mouseout: null,
                mousemove: null,
                click: null,
                toolTipContent: null,
                visible: !0,
                publicProperties: {
                    options: "readWrite",
                    axisX: "readWrite",
                    axisY: "readWrite",
                    chart: "readOnly"
                }
            },
            TextBlock: {
                x: 0,
                y: 0,
                width: null,
                height: null,
                maxWidth: null,
                maxHeight: null,
                padding: 0,
                angle: 0,
                text: "",
                horizontalAlign: "center",
                fontSize: 12,
                fontFamily: "calibri",
                fontWeight: "normal",
                fontColor: "black",
                fontStyle: "normal",
                borderThickness: 0,
                borderColor: "black",
                cornerRadius: 0,
                backgroundColor: null,
                textBaseline: "top"
            },
            CultureInfo: {
                decimalSeparator: ".",
                digitGroupSeparator: ",",
                zoomText: "Zoom",
                panText: "Pan",
                resetText: "Reset",
                menuText: "More Options",
                saveJPGText: "Save as JPEG",
                savePNGText: "Save as PNG",
                printText: "Print",
                days: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                shortDays: "Sun Mon Tue Wed Thu Fri Sat".split(" "),
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ")
            }
        },
        pa = {
            en: {}
        },
        ha = {
            colorSet1: "#369EAD #C24642 #7F6084 #86B402 #A2D1CF #C8B631 #6DBCEB #52514E #4F81BC #A064A1 #F79647".split(" "),
            colorSet2: "#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #33558B".split(" "),
            colorSet3: "#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(" ")
        },
        ia = {
            theme1: {
                Chart: {
                    colorSet: "colorSet1"
                },
                Title: {
                    fontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    fontSize: 33,
                    fontColor: "#3A3A3A",
                    fontWeight: "bold",
                    verticalAlign: "top",
                    margin: 5
                },
                Subtitle: {
                    fontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    fontSize: 16,
                    fontColor: "#3A3A3A",
                    fontWeight: "bold",
                    verticalAlign: "top",
                    margin: 5
                },
                Axis: {
                    titleFontSize: 26,
                    titleFontColor: "#666666",
                    titleFontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    labelFontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    labelFontSize: 18,
                    labelFontColor: "grey",
                    tickColor: "#BBBBBB",
                    tickThickness: 2,
                    gridThickness: 2,
                    gridColor: "#BBBBBB",
                    lineThickness: 2,
                    lineColor: "#BBBBBB"
                },
                Legend: {
                    verticalAlign: "bottom",
                    horizontalAlign: "center",
                    fontFamily: u ? "monospace, sans-serif,arial black" : "calibri"
                },
                DataSeries: {
                    indexLabelFontColor: "grey",
                    indexLabelFontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    indexLabelFontSize: 18,
                    indexLabelLineThickness: 1
                }
            },
            theme2: {
                Chart: {
                    colorSet: "colorSet2"
                },
                Title: {
                    fontFamily: "impact, charcoal, arial black, sans-serif",
                    fontSize: 32,
                    fontColor: "#333333",
                    verticalAlign: "top",
                    margin: 5
                },
                Subtitle: {
                    fontFamily: "impact, charcoal, arial black, sans-serif",
                    fontSize: 14,
                    fontColor: "#333333",
                    verticalAlign: "top",
                    margin: 5
                },
                Axis: {
                    titleFontSize: 22,
                    titleFontColor: "rgb(98,98,98)",
                    titleFontFamily: u ? "monospace, sans-serif,arial black" : "arial",
                    titleFontWeight: "bold",
                    labelFontFamily: u ? "monospace, Courier New, Courier" : "arial",
                    labelFontSize: 16,
                    labelFontColor: "grey",
                    labelFontWeight: "bold",
                    tickColor: "grey",
                    tickThickness: 2,
                    gridThickness: 2,
                    gridColor: "grey",
                    lineColor: "grey",
                    lineThickness: 0
                },
                Legend: {
                    verticalAlign: "bottom",
                    horizontalAlign: "center",
                    fontFamily: u ? "monospace, sans-serif,arial black" : "arial"
                },
                DataSeries: {
                    indexLabelFontColor: "grey",
                    indexLabelFontFamily: u ? "Courier New, Courier, monospace" : "arial",
                    indexLabelFontWeight: "bold",
                    indexLabelFontSize: 18,
                    indexLabelLineThickness: 1
                }
            },
            theme3: {
                Chart: {
                    colorSet: "colorSet1"
                },
                Title: {
                    fontFamily: u ? "Candara, Optima, Trebuchet MS, Helvetica Neue, Helvetica, Trebuchet MS, serif" : "calibri",
                    fontSize: 32,
                    fontColor: "#3A3A3A",
                    fontWeight: "bold",
                    verticalAlign: "top",
                    margin: 5
                },
                Subtitle: {
                    fontFamily: u ? "Candara, Optima, Trebuchet MS, Helvetica Neue, Helvetica, Trebuchet MS, serif" : "calibri",
                    fontSize: 16,
                    fontColor: "#3A3A3A",
                    fontWeight: "bold",
                    verticalAlign: "top",
                    margin: 5
                },
                Axis: {
                    titleFontSize: 22,
                    titleFontColor: "rgb(98,98,98)",
                    titleFontFamily: u ? "Verdana, Geneva, Calibri, sans-serif" : "calibri",
                    labelFontFamily: u ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif" : "calibri",
                    labelFontSize: 18,
                    labelFontColor: "grey",
                    tickColor: "grey",
                    tickThickness: 2,
                    gridThickness: 2,
                    gridColor: "grey",
                    lineThickness: 2,
                    lineColor: "grey"
                },
                Legend: {
                    verticalAlign: "bottom",
                    horizontalAlign: "center",
                    fontFamily: u ? "monospace, sans-serif,arial black" : "calibri"
                },
                DataSeries: {
                    bevelEnabled: !0,
                    indexLabelFontColor: "grey",
                    indexLabelFontFamily: u ? "Candara, Optima, Calibri, Verdana, Geneva, sans-serif" : "calibri",
                    indexLabelFontSize: 18,
                    indexLabelLineColor: "lightgrey",
                    indexLabelLineThickness: 2
                }
            }
        },
        E = {
            numberDuration: 1,
            yearDuration: 314496E5,
            monthDuration: 2592E6,
            weekDuration: 6048E5,
            dayDuration: 864E5,
            hourDuration: 36E5,
            minuteDuration: 6E4,
            secondDuration: 1E3,
            millisecondDuration: 1,
            dayOfWeekFromInt: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ")
        },
        Ka = {},
        ba = null,
        Ea = function() {
            var a = /D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,
                d = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                b = "Sun Mon Tue Wed Thu Fri Sat".split(" "),
                c = "January February March April May June July August September October November December".split(" "),
                f = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                g = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
                h = /[^-+\dA-Z]/g;
            return function(l, k, m) {
                var n = m ? m.days : d,
                    p = m ? m.months : c,
                    e = m ? m.shortDays : b,
                    r = m ? m.shortMonths : f;
                m = "";
                var q = !1;
                l = l && l.getTime ? l : l ? new Date(l) : new Date;
                if (isNaN(l)) throw SyntaxError("invalid date");
                "UTC:" === k.slice(0, 4) && (k = k.slice(4), q = !0);
                m = q ? "getUTC" : "get";
                var s = l[m + "Date"](),
                    v = l[m + "Day"](),
                    w = l[m + "Month"](),
                    y = l[m + "FullYear"](),
                    t = l[m + "Hours"](),
                    u = l[m + "Minutes"](),
                    Z = l[m + "Seconds"](),
                    aa = l[m + "Milliseconds"](),
                    x = q ? 0 : l.getTimezoneOffset();
                return m = k.replace(a, function(a) {
                    switch (a) {
                        case "D":
                            return s;
                        case "DD":
                            return O(s, 2);
                        case "DDD":
                            return e[v];
                        case "DDDD":
                            return n[v];
                        case "M":
                            return w + 1;
                        case "MM":
                            return O(w + 1, 2);
                        case "MMM":
                            return r[w];
                        case "MMMM":
                            return p[w];
                        case "Y":
                            return parseInt(String(y).slice(-2));
                        case "YY":
                            return O(String(y).slice(-2), 2);
                        case "YYY":
                            return O(String(y).slice(-3), 3);
                        case "YYYY":
                            return O(y, 4);
                        case "h":
                            return t % 12 || 12;
                        case "hh":
                            return O(t % 12 || 12, 2);
                        case "H":
                            return t;
                        case "HH":
                            return O(t, 2);
                        case "m":
                            return u;
                        case "mm":
                            return O(u, 2);
                        case "s":
                            return Z;
                        case "ss":
                            return O(Z, 2);
                        case "f":
                            return String(aa).slice(0, 1);
                        case "ff":
                            return O(String(aa).slice(0, 2), 2);
                        case "fff":
                            return O(String(aa).slice(0, 3), 3);
                        case "t":
                            return 12 > t ? "a" : "p";
                        case "tt":
                            return 12 > t ? "am" : "pm";
                        case "T":
                            return 12 > t ? "A" : "P";
                        case "TT":
                            return 12 > t ? "AM" : "PM";
                        case "K":
                            return q ? "UTC" : (String(l).match(g) || [""]).pop().replace(h, "");
                        case "z":
                            return (0 < x ? "-" : "+") + Math.floor(Math.abs(x) / 60);
                        case "zz":
                            return (0 < x ? "-" : "+") + O(Math.floor(Math.abs(x) / 60), 2);
                        case "zzz":
                            return (0 < x ? "-" : "+") + O(Math.floor(Math.abs(x) / 60), 2) + O(Math.abs(x) % 60, 2);
                        default:
                            return a.slice(1, a.length - 1)
                    }
                })
            }
        }(),
        da = function(a, d, b) {
            if (null === a) return "";
            a = Number(a);
            var c = 0 > a ? !0 : !1;
            c && (a *= -1);
            var f = b ? b.decimalSeparator : ".",
                g = b ? b.digitGroupSeparator : ",",
                h = "";
            d = String(d);
            var h = 1,
                l = b = "",
                k = -1,
                m = [],
                n = [],
                p = 0,
                e = 0,
                r = 0,
                q = !1,
                s = 0,
                l = d.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);
            d = null;
            for (var v = 0; l && v < l.length; v++)
                if (d = l[v], "." === d && 0 > k) k = v;
                else {
                    if ("%" === d) h *= 100;
                    else if ("\u2030" === d) {
                        h *= 1E3;
                        continue
                    } else if ("," === d[0] && "." === d[d.length - 1]) {
                        h /= Math.pow(1E3, d.length - 1);
                        k = v + d.length - 1;
                        continue
                    } else "E" !== d[0] && "e" !== d[0] || "0" !== d[d.length - 1] || (q = !0);
                    0 > k ? (m.push(d), "#" === d || "0" === d ? p++ : "," === d && r++) : (n.push(d), "#" !== d && "0" !== d || e++)
                }
            q && (d = Math.floor(a), l = -Math.floor(Math.log(a) / Math.LN10 + 1), s = 0 === a ? 0 : 0 === d ? -(p + l) : String(d).length - p, h /= Math.pow(10, s));
            0 > k && (k = v);
            h = (a * h).toFixed(e);
            d = h.split(".");
            h = (d[0] + "").split("");
            a = (d[1] + "").split("");
            h && "0" === h[0] && h.shift();
            for (q = l = v = e = k = 0; 0 < m.length;)
                if (d = m.pop(), "#" === d || "0" === d)
                    if (k++, k === p) {
                        var w = h,
                            h = [];
                        if ("0" === d)
                            for (d = p - e - (w ? w.length : 0); 0 < d;) w.unshift("0"), d--;
                        for (; 0 < w.length;) b = w.pop() + b, q++, 0 === q % l && (v === r && 0 < w.length) && (b = g + b)
                    } else 0 < h.length ? (b = h.pop() + b, e++, q++) : "0" === d && (b = "0" + b, e++, q++), 0 === q % l && (v === r && 0 < h.length) && (b = g + b);
            else "E" !== d[0] && "e" !== d[0] || "0" !== d[d.length - 1] || !/[eE][+-]*[0]+/.test(d) ? "," === d ? (v++, l = q, q = 0, 0 < h.length &&
                (b = g + b)) : b = 1 < d.length && ('"' === d[0] && '"' === d[d.length - 1] || "'" === d[0] && "'" === d[d.length - 1]) ? d.slice(1, d.length - 1) + b : d + b : (d = 0 > s ? d.replace("+", "").replace("-", "") : d.replace("-", ""), b += d.replace(/[0]+/, function(a) {
                return O(s, a.length)
            }));
            g = "";
            for (m = !1; 0 < n.length;) d = n.shift(), "#" === d || "0" === d ? 0 < a.length && 0 !== Number(a.join("")) ? (g += a.shift(), m = !0) : "0" === d && (g += "0", m = !0) : 1 < d.length && ('"' === d[0] && '"' === d[d.length - 1] || "'" === d[0] && "'" === d[d.length - 1]) ? g += d.slice(1, d.length - 1) : "E" !== d[0] && "e" !== d[0] || "0" !== d[d.length -
                1] || !/[eE][+-]*[0]+/.test(d) ? g += d : (d = 0 > s ? d.replace("+", "").replace("-", "") : d.replace("-", ""), g += d.replace(/[0]+/, function(a) {
                return O(s, a.length)
            }));
            b += (m ? f : "") + g;
            return c ? "-" + b : b
        },
        xa = function(a) {
            var d = 0,
                b = 0;
            a = a || window.event;
            a.offsetX || 0 === a.offsetX ? (d = a.offsetX, b = a.offsetY) : a.layerX || 0 == a.layerX ? (d = a.layerX, b = a.layerY) : (d = a.pageX - a.target.offsetLeft, b = a.pageY - a.target.offsetTop);
            return {
                x: d,
                y: b
            }
        },
        Ma = !0,
        za = window.devicePixelRatio || 1,
        sa = 1,
        Q = Ma ? za / sa : 1,
        Aa = window && window.location && window.location.href &&
        window.location.href.indexOf && (-1 !== window.location.href.indexOf("canvasjs.com") || -1 !== window.location.href.indexOf("fiddle")),
        Ta = {
            reset: {
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAKRSURBVEiJrdY/iF1FFMfxzwnZrGISUSR/JLGIhoh/QiRNBLWxMLIWEkwbgiAoFgoW2mhlY6dgpY2IlRBRxBSKhSAKIklWJRYuMZKAhiyopAiaTY7FvRtmZ+/ed9/zHRjezLw5v/O9d86cuZGZpmURAfdn5o9DfdZNLXpjz+LziPgyIl6MiG0jPTJzZBuyDrP4BVm0P/AKbljTb4ToY/gGewYA7KyCl+1b3DUYANvwbiHw0gCAGRzBOzjTAXEOu0cC4Ch+r5x/HrpdrcZmvIDFSucMtnYCYC++6HmNDw8FKDT34ETrf639/azOr5vwRk/g5fbeuABtgC04XWk9VQLciMP4EH/3AFzErRNC7MXlQmsesSoHsGPE23hmEoBW+61K66HMXFmIMvN8myilXS36R01ub+KfYvw43ZXwYDX+AHP4BAci4pFJomfmr/ihmNofESsBImJGk7mlncrM45n5JPbhz0kAWpsv+juxaX21YIPmVJS2uNzJMS6ZNexC0d+I7fUWXLFyz2kSZlpWPvASlmqAf/FXNXf3FAF2F/1LuFifAlionB6dRuSI2IwHi6lzmXmp6xR8XY0fiIh7psAwh+3FuDkRHQVjl+a8lkXjo0kLUKH7XaV5oO86PmZ1FTzyP4K/XGl9v/zwfbW7BriiuETGCP5ch9bc9f97HF/vcFzCa5gdEPgWq+t/4v0V63oE1uF4h0DiFJ7HnSWMppDdh1dxtsPvJ2wcBNAKbsJXa0Ck5opdaBPsRNu/usba09i1KsaAVzmLt3sghrRjuK1Tf4xkegInxwy8gKf7dKMVH2QRsV5zXR/Cftyu+aKaKbbkQrsdH+PTzLzcqzkOQAVzM+7FHdiqqe2/YT4zF/t8S/sPmawyvC974vcAAAAASUVORK5CYII="
            },
            pan: {
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAJVSURBVFiFvZe7a1RBGMV/x2hWI4JpfKCIiSBKOoOCkID/wP4BFqIIFkE02ChIiC8QDKlSiI3YqRBsBVGwUNAUdiIEUgjiAzQIIsuKJsfizsXr5t7d+8jmwLDfzHz3nLOzc7+ZxTZlGyDgZiWOCuJ9wH2gCUyuqQFgF/AGcKJNrYkBYBj40CIet+muGQi/96kM4WS7C/Tm5VUg7whJg8BkEGkCR4BDYfodsADUgP6wErO5iCtswsuJb32hdbXy8qzL5TIdmzJinHdZoZIBZcSFkGlAKs1Z3YCketZcBtouuaQNkrblMiBpBrhme7mAgU4wMCvpcFsDkq4C54DFVRTH9h+i6vlE0r5UA5ImgCuh28jB28iIs7BIVCOeStoZD64P4uPAjUTygKSx2FsK2TIwkugfk9Qkfd/E+yMWHQCeSRqx/R3gOp3LazfaS2C4B5gHDgD7U9x3E3uAH7KNpC3AHHAwTL4FHgM9GQ8vAaPA0dB/Abxqk2/gBLA9MXba9r1k/d4LfA3JtwueBeM58ucS+edXnAW23wP10N3advEi9CXizTnyN4bPS7Zn4sH/dq3t18AY4e1YLYSy3g/csj2VnFshZPuOpOeSKHCodUINuGj7YetE6je1PV9QoNPJ9StNHKodx7nRbiWrGHBGXAi5DUiqtQwtpcWK0Jubt8CltA5MEV1IfwO7+VffPwGfia5m34CT4bXujIIX0Qna1/cGMNqV/wUJE2czxD8CQ4X5Sl7Jz7SILwCDpbjKPBRMHAd+EtX4HWV5Spdc2w8kDQGPbH8py/MXMygM69/FKz4AAAAASUVORK5CYII="
            },
            zoom: {
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK6wAACusBgosNWgAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAMqSURBVFiFvdfbj91TFMDxz57U6GUEMS1aYzyMtCSSDhWjCZMInpAI3khE/QHtgzdRkXgSCS8SES9epKLi0oRKNETjRahREq2KS1stdRujtDPtbA97n5zdn9+5zJxTK9k5v3POXmt991p7r71+IcaoGwkhTOIebMRqzOBTvIG3Y4zTXRmqSoyx5cAKbMJOHMFJnMZ8/jyFaXyMR7G6nb1aH22cP4BvcBxziG3GKfyTIR9D6BYg1KUghPBCDveFlb/24Av8iuUYw41YVsz5G7uxKcZ4aMEpwGt5NY3V/YbHsQ6rcAHOw/kYxigewr5CZw4fYGxBKcCLOFEYehXrMdRhr5yLETxVScsOLOkKAPfn1TYMPIvLFrShUlS2FDZm8XRHACzFAWl3R2xbqPMCYhmeLCAOYEMngAczbcTvuHYxzguIy/FesR9e6gSwU/OoPYHBHgHgviIKX2Flq7k34KhmcVnbi/PC8JX4MgMcxb118wZwdz5aISscqx7VRcox7MrPQ7i+btIAJrAkf9+bI9EPmZY2IAxiTSuAldLq4Y9+AcSUh78KP0tbAcwU35cXMD1JCIFUoGiehlqAz6TNB1f1C0DK+0h+nsNPrQC2a4bqGmlD9kOGcWt+Po6pVgDvSxfJaSkFd4UQBvoAsBYbCoB3a2flM7slA0R8iyt6rAFDeDPbm8eOTpVwGD9qVq7nLbIaZnmksPU1JtsCZMXNmpdRxFasWITzh6Xj3LCzra1OxcD2QjHiGVzdpfORnMqZio2PcF23ABdJF1Np4BPptlyPi6WzPYBzpJZtHe7A6xW9cnyP8TqA//SEIYRL8Bxul7rihvwgtVn78WcGGZXa9HGd5TDujDHuOePXNiHdKjWgZX/YbsxLx/ktqbjVzTlcjUSnvI5JrdlUVp6WesZZ6R1hRrpq9+EVTGS9jTjYAuKIouGpbcurEkIYxC051KNSamazsc+xK8b4S0VnEi/j0hqTP+M27O258egQwZuzs7pI7Mf4WQXIEDc5s9sux+5+1Py2EmP8UOq6GvWhIScxfdYjUERiAt9Jd84J6a16zf8JEKT3yCm8g1UxRv8CC4pyRhzR1uUAAAAASUVORK5CYII="
            },
            menu: {
                image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAgCAYAAAAbifjMAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK6wAACusBgosNWgAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDcvMTUvMTTPsvU0AAAAP0lEQVRIie2SMQoAIBDDUvH/X667g8sJJ9KOhYYOkW0qGaU1MPdC0vGSbV19EACo3YMPAFH5BUBUjsqfAPpVXtNgGDfxEDCtAAAAAElFTkSuQmCC"
            }
        };
    (function() {
        z.fSDec = function(a) {
            for (var d = "", b = 0; b < a.length; b++) d += String.fromCharCode(a[b] - 111);
            return d
        };
        z.str = {
            tv: [195, 225, 216, 208, 219, 143, 197, 212, 225,
                226, 216, 222, 221
            ],
            fntStr: [223, 231, 143, 178, 208, 219, 216, 209, 225, 216, 155, 143, 187, 228, 210, 216, 211, 208, 143, 182, 225, 208, 221, 211, 212, 155, 143, 187, 228, 210, 216, 211, 208, 143, 194, 208, 221, 226, 143, 196, 221, 216, 210, 222, 211, 212, 155, 143, 176, 225, 216, 208, 219, 155, 143, 226, 208, 221, 226, 156, 226, 212, 225, 216, 213],
            tBl: [227, 212, 231, 227, 177, 208, 226, 212, 219, 216, 221, 212],
            fnt: [213, 222, 221, 227],
            fSy: [213, 216, 219, 219, 194, 227, 232, 219, 212],
            fTx: [213, 216, 219, 219, 195, 212, 231, 227],
            gr: [214, 225, 212, 232],
            ct: [210, 227, 231],
            tp: [227, 222, 223]
        };
        delete ca[z.fSDec([178,
            215, 208, 225, 227
        ])][z.fSDec([210, 225, 212, 211, 216, 227, 183, 225, 212, 213])];
        z.pro = {
            sCH: ca[z.fSDec([178, 215, 208, 225, 227])][z.fSDec([210, 225, 212, 211, 216, 227, 183, 225, 212, 213])]
        };
        z.fAWm = function(a) {
            if ("undefined" === typeof z.pro.sCH && !Aa) {
                var d = a[z.fSDec(z.str.ct)];
                d[z.fSDec(z.str.tBl)] = z.fSDec(z.str.tp);
                d[z.fSDec(z.str.fnt)] = 11 + z.fSDec(z.str.fntStr);
                d[z.fSDec(z.str.fSy)] = z.fSDec(z.str.gr);
                d[z.fSDec(z.str.fTx)](z.fSDec(z.str.tv), 2, a.height - 11 - 2)
            }
        }
    })();
    (function() {
        z.ckDec = function(a) {
            for (var d = "", b = 0; b < a.length; b++) d +=
                String.fromCharCode(a[b] - 111);
            return d
        };
        z.str.ckn = [206, 206, 210, 230, 217, 198, 226, 195, 225];
        z.str.tem = [195, 225, 216, 208, 219, 143, 191, 212, 225, 216, 222, 211, 143, 215, 208, 226, 143, 180, 231, 223, 216, 225, 212, 211, 144];
        z.str.ctm = [191, 219, 212, 208, 226, 212, 143, 210, 222, 221, 227, 208, 210, 227, 143, 226, 208, 219, 212, 226, 175, 210, 208, 221, 229, 208, 226, 217, 226, 157, 210, 222, 220];
        z.str.ltm = [213, 222, 225, 143, 219, 216, 210, 212, 221, 226, 212, 143, 222, 225, 143, 227, 225, 216, 208, 219, 143, 212, 231, 227, 212, 221, 227, 216, 222, 221];
        z.str.ckve = [212, 231, 223, 216,
            225, 212, 226, 172
        ];
        z.str.mco = [225, 214, 209, 208, 151, 161, 164, 164, 155, 161, 164, 164, 155, 161, 164, 164, 155, 159, 157, 164, 152];
        z.str.mcw = [198, 215, 216, 227, 212];
        z.str.mct = [225, 214, 209, 208, 151, 161, 162, 160, 155, 161, 168, 155, 164, 163, 155, 159, 157, 166, 152];
        z.str.mcr = [193, 212, 211];
        z.fNg = function(a) {
            if (!Aa) try {
                var d;
                a: {
                    var b = RegExp(z.ckDec(z.str.ckn) + "=.*", "gi"),
                        c = new Date,
                        f = document.cookie.match(b),
                        g = localStorage && localStorage.getItem("lclStg") && JSON.parse(localStorage.getItem("lclStg")).name.match(z.ckDec(z.str.ckn)) ? JSON.parse(localStorage.getItem("lclStg")) : null;
                    if (f && 0 < f.length || g) {
                        var h, b = [],
                            l = [],
                            k = null;
                        if (f)
                            for (var m = f[0].split("; "), f = 0; f < m.length; f++) b.push(m[f].split("=")[0]), l.push(m[f].split("=")[1]);
                        g && (k = g);
                        h = {
                            ckVal: Number(l[0]),
                            lSVal: k ? Number(k.val) : null
                        };
                        g = null;
                        h && h.ckVal && h.lSVal ? g = Math.min(h.ckVal, h.lSVal) : h && h.ckVal ? g = h.ckVal : h && h.lSVal && (g = h.lSVal);
                        if (2592E6 < Math.round(Math.abs(g - c.getTime()))) {
                            d = !0;
                            break a
                        }
                    } else {
                        l = new Date;
                        k = l.getTime();
                        l.setTime(k + 31536E6);
                        var n = {
                            name: z.ckDec(z.str.ckn),
                            val: (new Date).getTime()
                        };
                        document.cookie = z.ckDec(z.str.ckn) +
                            "=" + (new Date).getTime() + "; " + z.ckDec(z.str.ckve) + l.toUTCString() + "; path=/;";
                        localStorage.setItem("lclStg", JSON.stringify(n))
                    }
                    d = !1
                }
                if (d) {
                    d = 20;
                    var p = a.plotArea.ctx;
                    p.font = "bold " + d + (u ? "px Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif" : "px Lucida Sans Unicode");
                    var e = z.ckDec(z.str.tem),
                        r = p.measureText(e).width;
                    p.fillStyle = u ? z.ckDec(z.str.mco) : z.ckDec(z.str.mcw);
                    p.fillRect(a.plotArea.x2 - r - 8, a.plotArea.y2 - 2.5 * d - 8, r + 4, 2.5 * d + 8);
                    p.fillStyle = u ? z.ckDec(z.str.mct) : z.ckDec(z.str.mcr);
                    p.textBaseline =
                        "top";
                    p.fillText(e, a.plotArea.x2 - r - 4, a.plotArea.y2 - 2.5 * d - 2);
                    d = 14;
                    p.font = d + (u ? "px Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif" : "px Lucida Sans Unicode");
                    e = z.ckDec(z.str.ctm);
                    r = p.measureText(e).width;
                    p.fillStyle = u ? z.ckDec(z.str.mct) : z.ckDec(z.str.mcr);
                    p.fillText(e, a.plotArea.x2 - r - 4, a.plotArea.y2 - 2 * d - 4);
                    e = z.ckDec(z.str.ltm);
                    r = p.measureText(e).width;
                    p.fillText(e, a.plotArea.x2 - r - 4, a.plotArea.y2 - d - 4)
                }
            } catch (q) {}
        }
    })();
    M.prototype.setOptions = function(a, d) {
        if (ca[this._defaultsKey]) {
            var b =
                ca[this._defaultsKey],
                c;
            for (c in b) "publicProperties" !== c && b.hasOwnProperty(c) && (this[c] = a && c in a ? a[c] : d && c in d ? d[c] : b[c])
        }
    };
    M.prototype.get = function(a) {
        var d = ca[this._defaultsKey];
        if ("options" === a) return this.options && this.options._isPlaceholder ? null : this.options;
        if (d.hasOwnProperty(a) || d.publicProperties && d.publicProperties.hasOwnProperty(a)) return this[a];
        window.console && window.console.log('Property "' + a + "\" doesn't exist. Please check for typo.")
    };
    M.prototype.set = function(a, d, b) {
        b = "undefined" ===
            typeof b ? !0 : b;
        var c = ca[this._defaultsKey];
        if ("options" === a) this.createUserOptions(d);
        else if (c.hasOwnProperty(a) || c.publicProperties && c.publicProperties.hasOwnProperty(a) && "readWrite" === c.publicProperties[a]) this.options._isPlaceholder && this.createUserOptions(), this.options[a] = d;
        else {
            window.console && (c.publicProperties && c.publicProperties.hasOwnProperty(a) && "readOnly" === c.publicProperties[a] ? window.console.log('Property "' + a + '" is read-only.') : window.console.log('Property "' + a + "\" doesn't exist. Please check for typo."));
            return
        }
        b && (chart = this.chart || this, chart.render())
    };
    M.prototype.addTo = function(a, d, b, c) {
        c = "undefined" === typeof c ? !0 : c;
        var f = ca[this._defaultsKey];
        f.hasOwnProperty(a) || f.publicProperties && f.publicProperties.hasOwnProperty(a) && "readWrite" === f.publicProperties[a] ? (this.options._isPlaceholder && this.createUserOptions(), "undefined" === typeof this.options[a] && (this.options[a] = []), a = this.options[a], b = "undefined" === typeof b || null === b ? a.length : b, a.splice(b, 0, d), c && (chart = this.chart || this, chart.render())) : window.console &&
            (f.publicProperties && f.publicProperties.hasOwnProperty(a) && "readOnly" === f.publicProperties[a] ? window.console.log('Property "' + a + '" is read-only.') : window.console.log('Property "' + a + "\" doesn't exist. Please check for typo."))
    };
    M.prototype.createUserOptions = function(a) {
        if ("undefined" !== typeof a || this.options._isPlaceholder)
            if (this.parent.options._isPlaceholder && this.parent.createUserOptions(), this.isOptionsInArray) {
                this.parent.options[this.optionsName] || (this.parent.options[this.optionsName] = []);
                var d =
                    this.parent.options[this.optionsName],
                    b = d.length;
                this.options._isPlaceholder || (qa(d), b = d.indexOf(this.options));
                this.options = "undefined" === typeof a ? {} : a;
                d[b] = this.options
            } else this.options = "undefined" === typeof a ? {} : a, a = this.parent.options, this.optionsName ? d = this.optionsName : (d = this._defaultsKey) && 0 !== d.length ? (b = d.charAt(0).toLowerCase(), 1 < d.length && (b = b.concat(d.slice(1))), d = b) : d = void 0, a[d] = this.options
    };
    M.prototype.remove = function(a) {
        a = "undefined" === typeof a ? !0 : a;
        if (this.isOptionsInArray) {
            var d =
                this.parent.options[this.optionsName];
            qa(d);
            var b = d.indexOf(this.options);
            0 <= b && d.splice(b, 1)
        } else delete this.parent.options[this.optionsName];
        a && (chart = this.chart || this, chart.render())
    };
    M.prototype.updateOption = function(a) {
        var d = ca[this._defaultsKey],
            b = this.options.theme ? this.options.theme : this.chart && this.chart.options.theme ? this.chart.options.theme : "theme1",
            c = {},
            f = this[a];
        b && (ia[b] && ia[b][this._defaultsKey]) && (c = ia[b][this._defaultsKey]);
        a in d && (f = a in this.options ? this.options[a] : c && a in c ?
            c[a] : d[a]);
        if (f === this[a]) return !1;
        this[a] = f;
        return !0
    };
    M.prototype.trackChanges = function(a) {
        if (!this.sessionVariables) throw "Session Variable Store not set";
        this.sessionVariables[a] = this.options[a]
    };
    M.prototype.isBeingTracked = function(a) {
        this.options._oldOptions || (this.options._oldOptions = {});
        return this.options._oldOptions[a] ? !0 : !1
    };
    M.prototype.hasOptionChanged = function(a) {
        if (!this.sessionVariables) throw "Session Variable Store not set";
        return this.sessionVariables[a] !== this.options[a]
    };
    M.prototype.addEventListener =
        function(a, d, b) {
            a && d && (this._eventListeners[a] = this._eventListeners[a] || [], this._eventListeners[a].push({
                context: b || this,
                eventHandler: d
            }))
        };
    M.prototype.removeEventListener = function(a, d) {
        if (a && d && this._eventListeners[a])
            for (var b = this._eventListeners[a], c = 0; c < b.length; c++)
                if (b[c].eventHandler === d) {
                    b[c].splice(c, 1);
                    break
                }
    };
    M.prototype.removeAllEventListeners = function() {
        this._eventListeners = []
    };
    M.prototype.dispatchEvent = function(a, d, b) {
        if (a && this._eventListeners[a]) {
            d = d || {};
            for (var c = this._eventListeners[a],
                    f = 0; f < c.length; f++) c[f].eventHandler.call(c[f].context, d)
        }
        "function" === typeof this[a] && this[a].call(b || this.chart, d)
    };
    U(A, M);
    A.prototype._updateOptions = function() {
        var a = this;
        this.updateOption("width");
        this.updateOption("height");
        this.updateOption("dataPointWidth");
        this.updateOption("dataPointMinWidth");
        this.updateOption("dataPointMaxWidth");
        this.updateOption("interactivityEnabled");
        this.updateOption("theme");
        this.updateOption("colorSet") && (this._selectedColorSet = "undefined" !== typeof ha[this.colorSet] ?
            ha[this.colorSet] : ha.colorSet1);
        this.updateOption("backgroundColor");
        this.backgroundColor || (this.backgroundColor = "rgba(0,0,0,0)");
        this.updateOption("culture");
        this._cultureInfo = new oa(this.options.culture);
        this.updateOption("animationEnabled");
        this.animationEnabled = this.animationEnabled && u;
        this.updateOption("animationDuration");
        this.updateOption("rangeChanging");
        this.updateOption("rangeChanged");
        this.updateOption("exportEnabled");
        this.updateOption("exportFileName");
        this.updateOption("zoomType");
        this.options.zoomEnabled ?
            (this._zoomButton || (Y(this._zoomButton = document.createElement("button")), T(this, this._zoomButton, "pan"), this._toolBar.appendChild(this._zoomButton), K(this._zoomButton, "click", function() {
                a.zoomEnabled ? (a.zoomEnabled = !1, a.panEnabled = !0, T(a, a._zoomButton, "zoom")) : (a.zoomEnabled = !0, a.panEnabled = !1, T(a, a._zoomButton, "pan"));
                a.render()
            })), this._resetButton || (Y(this._resetButton = document.createElement("button")), T(this, this._resetButton, "reset"), this._toolBar.appendChild(this._resetButton), K(this._resetButton,
                "click",
                function() {
                    a.toolTip.hide();
                    a.zoomEnabled || a.panEnabled ? (a.zoomEnabled = !0, a.panEnabled = !1, T(a, a._zoomButton, "pan"), a._defaultCursor = "default", a.overlaidCanvas.style.cursor = a._defaultCursor) : (a.zoomEnabled = !1, a.panEnabled = !1);
                    if (a.sessionVariables.axisX)
                        for (var b = 0; b < a.sessionVariables.axisX.length; b++) a.sessionVariables.axisX[b].newViewportMinimum = null, a.sessionVariables.axisX[b].newViewportMaximum = null;
                    if (a.sessionVariables.axisX2)
                        for (b = 0; b < a.sessionVariables.axisX2.length; b++) a.sessionVariables.axisX2[b].newViewportMinimum =
                            null, a.sessionVariables.axisX2[b].newViewportMaximum = null;
                    if (a.sessionVariables.axisY)
                        for (b = 0; b < a.sessionVariables.axisY.length; b++) a.sessionVariables.axisY[b].newViewportMinimum = null, a.sessionVariables.axisY[b].newViewportMaximum = null;
                    if (a.sessionVariables.axisY2)
                        for (b = 0; b < a.sessionVariables.axisY2.length; b++) a.sessionVariables.axisY2[b].newViewportMinimum = null, a.sessionVariables.axisY2[b].newViewportMaximum = null;
                    a.resetOverlayedCanvas();
                    Y(a._zoomButton, a._resetButton);
                    a._dispatchRangeEvent("rangeChanging",
                        "reset");
                    a.render();
                    a._dispatchRangeEvent("rangeChanged", "reset")
                }), this.overlaidCanvas.style.cursor = a._defaultCursor), this.zoomEnabled || this.panEnabled || (this._zoomButton ? (a._zoomButton.getAttribute("state") === a._cultureInfo.zoomText ? (this.panEnabled = !0, this.zoomEnabled = !1) : (this.zoomEnabled = !0, this.panEnabled = !1), ta(a._zoomButton, a._resetButton)) : (this.zoomEnabled = !0, this.panEnabled = !1))) : this.panEnabled = this.zoomEnabled = !1;
        this._menuButton ? this.exportEnabled ? ta(this._menuButton) : Y(this._menuButton) :
            this.exportEnabled && u && (this._menuButton = document.createElement("button"), T(this, this._menuButton, "menu"), this._toolBar.appendChild(this._menuButton), K(this._menuButton, "click", function() {
                "none" !== a._dropdownMenu.style.display || a._dropDownCloseTime && 500 >= (new Date).getTime() - a._dropDownCloseTime.getTime() || (a._dropdownMenu.style.display = "block", a._menuButton.blur(), a._dropdownMenu.focus())
            }, !0));
        if (!this._dropdownMenu && this.exportEnabled && u) {
            this._dropdownMenu = document.createElement("div");
            this._dropdownMenu.setAttribute("tabindex", -1);
            this._dropdownMenu.style.cssText = "position: absolute; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 1px;top: 25px;min-width: 120px;outline: 0;border: 1px solid silver;font-size: 14px;font-family: Calibri, Verdana, sans-serif;padding: 5px 0px 5px 0px;text-align: left;background-color: #fff;line-height: 20px;box-shadow: 2px 2px 10px #888888;";
            a._dropdownMenu.style.display = "none";
            this._toolBar.appendChild(this._dropdownMenu);
            K(this._dropdownMenu,
                "blur",
                function() {
                    Y(a._dropdownMenu);
                    a._dropDownCloseTime = new Date
                }, !0);
            var d = document.createElement("div");
            d.style.cssText = "padding: 2px 15px 2px 10px";
            d.innerHTML = this._cultureInfo.printText;
            this._dropdownMenu.appendChild(d);
            K(d, "mouseover", function() {
                this.style.backgroundColor = "#EEEEEE"
            }, !0);
            K(d, "mouseout", function() {
                this.style.backgroundColor = "transparent"
            }, !0);
            K(d, "click", function() {
                a.print();
                Y(a._dropdownMenu)
            }, !0);
            d = document.createElement("div");
            d.style.cssText = "padding: 2px 15px 2px 10px";
            d.innerHTML = this._cultureInfo.saveJPGText;
            this._dropdownMenu.appendChild(d);
            K(d, "mouseover", function() {
                this.style.backgroundColor = "#EEEEEE"
            }, !0);
            K(d, "mouseout", function() {
                this.style.backgroundColor = "transparent"
            }, !0);
            K(d, "click", function() {
                Ba(a.canvas, "jpeg", a.exportFileName);
                Y(a._dropdownMenu)
            }, !0);
            d = document.createElement("div");
            d.style.cssText = "padding: 2px 15px 2px 10px";
            d.innerHTML = this._cultureInfo.savePNGText;
            this._dropdownMenu.appendChild(d);
            K(d, "mouseover", function() {
                this.style.backgroundColor =
                    "#EEEEEE"
            }, !0);
            K(d, "mouseout", function() {
                this.style.backgroundColor = "transparent"
            }, !0);
            K(d, "click", function() {
                Ba(a.canvas, "png", a.exportFileName);
                Y(a._dropdownMenu)
            }, !0)
        }
        "none" !== this._toolBar.style.display && this._zoomButton && (this.panEnabled ? T(a, a._zoomButton, "zoom") : T(a, a._zoomButton, "pan"), a._resetButton.getAttribute("state") !== a._cultureInfo.resetText && T(a, a._resetButton, "reset"));
        this.options.toolTip && this.toolTip.options !== this.options.toolTip && (this.toolTip.options = this.options.toolTip);
        for (var b in this.toolTip.options) this.toolTip.options.hasOwnProperty(b) &&
            this.toolTip.updateOption(b)
    };
    A.prototype._updateSize = function() {
        var a = 0,
            d = 0;
        this.options.width ? a = this.width : this.width = a = 0 < this.container.clientWidth ? this.container.clientWidth : this.width;
        this.options.height ? d = this.height : this.height = d = 0 < this.container.clientHeight ? this.container.clientHeight : this.height;
        return this.canvas.width !== a * Q || this.canvas.height !== d * Q ? (ra(this.canvas, a, d), ra(this.overlaidCanvas, a, d), ra(this._eventManager.ghostCanvas, a, d), !0) : !1
    };
    A.prototype._initialize = function() {
        this._animator ?
            this._animator.cancelAllAnimations() : this._animator = new Da(this);
        this.removeAllEventListeners();
        this.disableToolTip = !1;
        this._axes = [];
        this.pieDoughnutClickHandler = null;
        this.animationRequestId && this.cancelRequestAnimFrame.call(window, this.animationRequestId);
        this._updateOptions();
        this.animatedRender = u && this.animationEnabled && 0 === this.renderCount;
        this._updateSize();
        this.clearCanvas();
        this.ctx.beginPath();
        this.axisX = [];
        this.axisX2 = [];
        this.axisY = [];
        this.axisY2 = [];
        this._indexLabels = [];
        this._dataInRenderedOrder = [];
        this._events = [];
        this._eventManager && this._eventManager.reset();
        this.plotInfo = {
            axisPlacement: null,
            axisXValueType: null,
            plotTypes: []
        };
        this.layoutManager = new ja(0, 0, this.width, this.height, 2);
        this.plotArea.layoutManager && this.plotArea.layoutManager.reset();
        this.data = [];
        var a = 0;
        if (this.options.data)
            for (var d = 0; d < this.options.data.length; d++)
                if (a++, !this.options.data[d].type || 0 <= A._supportedChartTypes.indexOf(this.options.data[d].type)) {
                    var b = new $(this, this.options.data[d], a - 1, ++this._eventManager.lastObjectId);
                    null === b.name && (b.name = "DataSeries " + a);
                    null === b.color ? 1 < this.options.data.length ? (b._colorSet = [this._selectedColorSet[b.index % this._selectedColorSet.length]], b.color = this._selectedColorSet[b.index % this._selectedColorSet.length]) : b._colorSet = "line" === b.type || "stepLine" === b.type || "spline" === b.type || "area" === b.type || "stepArea" === b.type || "splineArea" === b.type || "stackedArea" === b.type || "stackedArea100" === b.type || "rangeArea" === b.type || "rangeSplineArea" === b.type || "candlestick" === b.type || "ohlc" === b.type ? [this._selectedColorSet[0]] : this._selectedColorSet : b._colorSet = [b.color];
                    null === b.markerSize && (("line" === b.type || "stepLine" === b.type || "spline" === b.type || 0 <= b.type.toLowerCase().indexOf("area")) && b.dataPoints && b.dataPoints.length < this.width / 16 || "scatter" === b.type) && (b.markerSize = 8);
                    "bubble" !== b.type && "scatter" !== b.type || !b.dataPoints || (b.dataPoints.some ? b.dataPoints.some(function(a) {
                        return a.x
                    }) && b.dataPoints.sort(Ia) : b.dataPoints.sort(Ia));
                    this.data.push(b);
                    var c = b.axisPlacement,
                        f;
                    "normal" === c ? "xySwapped" ===
                        this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with bar chart' : "none" === this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with pie chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement = "normal") : "xySwapped" === c ? "normal" === this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with line, area, column or pie chart' : "none" === this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with pie chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement =
                            "xySwapped") : "none" == c && ("normal" === this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with line, area, column or bar chart' : "xySwapped" === this.plotInfo.axisPlacement ? f = 'You cannot combine "' + b.type + '" with bar chart' : null === this.plotInfo.axisPlacement && (this.plotInfo.axisPlacement = "none"));
                    if (f && window.console) {
                        window.console.log(f);
                        return
                    }
                }
        /*var g = this;
        this.addEventListener("dataAnimationIterationEnd", function() {
            z.fAWm && z.fAWm(g);
            0 !== g.axisX.length && z.fNg && z.fNg(g)
        });
        Sa(this);*/
        this._objectsInitialized = !0
    };
    A._supportedChartTypes = qa("line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc rangeColumn rangeBar rangeArea rangeSplineArea pie doughnut funnel".split(" "));
    A.prototype.render = function(a) {
        a && (this.options = a);
        this._initialize();
        var d = [];
        for (a = 0; a < this.data.length; a++)
            if ("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) {
                if (!this.data[a].axisYType ||
                    "primary" === this.data[a].axisYType)
                    if (this.options.axisY && 0 < this.options.axisY.length) {
                        if (!this.axisY.length)
                            for (var b = 0; b < this.options.axisY.length; b++) "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY[b] = new B(this, this.options.axisY[b], "axisY", "left", b)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY[b] = new B(this, this.options.axisY[b], "axisY", "bottom", b));
                        this.data[a].axisY = this.axisY[0 <= this.data[a].axisYIndex && this.data[a].axisYIndex < this.axisY.length ?
                            this.data[a].axisYIndex : 0];
                        this.axisY[0 <= this.data[a].axisYIndex && this.data[a].axisYIndex < this.axisY.length ? this.data[a].axisYIndex : 0].dataSeries.push(this.data[a])
                    } else this.axisY.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY[0] = new B(this, this.options.axisY, "axisY", "left", 0)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY[0] = new B(this, this.options.axisY, "axisY", "bottom", 0))), this.data[a].axisY = this.axisY[0], this.axisY[0].dataSeries.push(this.data[a]);
                if ("secondary" === this.data[a].axisYType)
                    if (this.options.axisY2 && 0 < this.options.axisY2.length) {
                        if (!this.axisY2.length)
                            for (b = 0; b < this.options.axisY2.length; b++) "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY2[b] = new B(this, this.options.axisY2[b], "axisY", "right", b)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY2[b] = new B(this, this.options.axisY2[b], "axisY", "top", b));
                        this.data[a].axisY = this.axisY2[0 <= this.data[a].axisYIndex && this.data[a].axisYIndex < this.axisY2.length ?
                            this.data[a].axisYIndex : 0];
                        this.axisY2[0 <= this.data[a].axisYIndex && this.data[a].axisYIndex < this.axisY2.length ? this.data[a].axisYIndex : 0].dataSeries.push(this.data[a])
                    } else this.axisY2.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisY2[0] = new B(this, this.options.axisY2, "axisY", "right", 0)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisY2[0] = new B(this, this.options.axisY2, "axisY", "top", 0))), this.data[a].axisY = this.axisY2[0], this.axisY2[0].dataSeries.push(this.data[a]);
                if (!this.data[a].axisXType || "primary" === this.data[a].axisXType)
                    if (this.options.axisX && 0 < this.options.axisX.length) {
                        if (!this.axisX.length)
                            for (b = 0; b < this.options.axisX.length; b++) "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX[b] = new B(this, this.options.axisX[b], "axisX", "bottom", b)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX[b] = new B(this, this.options.axisX[b], "axisX", "left", b));
                        this.data[a].axisX = this.axisX[0 <= this.data[a].axisXIndex && this.data[a].axisXIndex <
                            this.axisX.length ? this.data[a].axisXIndex : 0];
                        this.axisX[0 <= this.data[a].axisXIndex && this.data[a].axisXIndex < this.axisX.length ? this.data[a].axisXIndex : 0].dataSeries.push(this.data[a])
                    } else this.axisX.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX[0] = new B(this, this.options.axisX, "axisX", "bottom", 0)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX[0] = new B(this, this.options.axisX, "axisX", "left", 0))), this.data[a].axisX = this.axisX[0], this.axisX[0].dataSeries.push(this.data[a]);
                if ("secondary" === this.data[a].axisXType)
                    if (this.options.axisX2 && 0 < this.options.axisX2.length) {
                        if (!this.axisX2.length)
                            for (b = 0; b < this.options.axisX2.length; b++) "normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX2[b] = new B(this, this.options.axisX2[b], "axisX", "top", b)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX2[b] = new B(this, this.options.axisX2[b], "axisX", "right", b));
                        this.data[a].axisX = this.axisX2[0 <= this.data[a].axisXIndex && this.data[a].axisXIndex < this.axisX2.length ?
                            this.data[a].axisXIndex : 0];
                        this.axisX2[0 <= this.data[a].axisXIndex && this.data[a].axisXIndex < this.axisX2.length ? this.data[a].axisXIndex : 0].dataSeries.push(this.data[a])
                    } else this.axisX2.length || ("normal" === this.plotInfo.axisPlacement ? this._axes.push(this.axisX2[0] = new B(this, this.options.axisX2, "axisX", "top", 0)) : "xySwapped" === this.plotInfo.axisPlacement && this._axes.push(this.axisX2[0] = new B(this, this.options.axisX2, "axisX", "right", 0))), this.data[a].axisX = this.axisX2[0], this.axisX2[0].dataSeries.push(this.data[a])
            }
        if (this.axisY) {
            for (b =
                1; b < this.axisY.length; b++) "undefined" === typeof this.axisY[b].options.gridThickness && (this.axisY[b].gridThickness = 0);
            for (b = 0; b < this.axisY.length - 1; b++) "undefined" === typeof this.axisY[b].options.margin && (this.axisY[b].margin = 10)
        }
        if (this.axisY2) {
            for (b = 1; b < this.axisY2.length; b++) "undefined" === typeof this.axisY2[b].options.gridThickness && (this.axisY2[b].gridThickness = 0);
            for (b = 0; b < this.axisY2.length - 1; b++) "undefined" === typeof this.axisY2[b].options.margin && (this.axisY2[b].margin = 10)
        }
        this.axisY && 0 < this.axisY.length &&
            (this.axisY2 && 0 < this.axisY2.length) && (0 < this.axisY[0].gridThickness && "undefined" === typeof this.axisY2[0].options.gridThickness ? this.axisY2[0].gridThickness = 0 : 0 < this.axisY2[0].gridThickness && "undefined" === typeof this.axisY[0].options.gridThickness && (this.axisY[0].gridThickness = 0));
        if (this.axisX)
            for (b = 0; b < this.axisX.length; b++) "undefined" === typeof this.axisX[b].options.gridThickness && (this.axisX[b].gridThickness = 0);
        if (this.axisX2)
            for (b = 0; b < this.axisX2.length; b++) "undefined" === typeof this.axisX2[b].options.gridThickness &&
                (this.axisX2[b].gridThickness = 0);
        this.axisX && 0 < this.axisX.length && (this.axisX2 && 0 < this.axisX2.length) && (0 < this.axisX[0].gridThickness && "undefined" === typeof this.axisX2[0].options.gridThickness ? this.axisX2[0].gridThickness = 0 : 0 < this.axisX2[0].gridThickness && "undefined" === typeof this.axisX[0].options.gridThickness && (this.axisX[0].gridThickness = 0));
        b = !1;
        if (0 < this._axes.length && (this.zoomEnabled || this.panEnabled))
            for (a = 0; a < this._axes.length; a++)
                if (null !== this._axes[a].viewportMinimum || null !== this._axes[a].viewportMaximum) {
                    b = !0;
                    break
                }
        b ? ta(this._zoomButton, this._resetButton) : (Y(this._zoomButton, this._resetButton), this.options.zoomEnabled && (this.zoomEnabled = !0, this.panEnabled = !1));
        this._processData();
        this.options.title && (this.title = new ma(this, this.options.title), this.title.dockInsidePlotArea ? d.push(this.title) : this.title.render());
        if (this.options.subtitles)
            for (this.subtitles = [], a = 0; a < this.options.subtitles.length; a++) b = new va(this, this.options.subtitles[a]), this.subtitles.push(b), b.dockInsidePlotArea ? d.push(b) : b.render();
        this.legend = new wa(this, this.options.legend);
        for (a = 0; a < this.data.length; a++)(this.data[a].showInLegend || "pie" === this.data[a].type || "doughnut" === this.data[a].type) && this.legend.dataSeries.push(this.data[a]);
        this.legend.dockInsidePlotArea ? d.push(this.legend) : this.legend.render();
        if ("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) B.setLayoutAndRender(this.axisX, this.axisX2, this.axisY, this.axisY2, this.plotInfo.axisPlacement, this.layoutManager.getFreeSpace());
        else if ("none" ===
            this.plotInfo.axisPlacement) this.preparePlotArea();
        else return;
        for (a = 0; a < d.length; a++) d[a].render();
        var c = [];
        if (this.animatedRender) {
            var f = ga(this.width, this.height);
            f.getContext("2d").drawImage(this.canvas, 0, 0, this.width, this.height)
        }
        for (a = 0; a < this.plotInfo.plotTypes.length; a++)
            for (var d = this.plotInfo.plotTypes[a], g = 0; g < d.plotUnits.length; g++) {
                var h = d.plotUnits[g],
                    l = null;
                h.targetCanvas = null;
                this.animatedRender && (h.targetCanvas = ga(this.width, this.height), h.targetCanvasCtx = h.targetCanvas.getContext("2d"));
                "line" === h.type ? l = this.renderLine(h) : "stepLine" === h.type ? l = this.renderStepLine(h) : "spline" === h.type ? l = this.renderSpline(h) : "column" === h.type ? l = this.renderColumn(h) : "bar" === h.type ? l = this.renderBar(h) : "area" === h.type ? l = this.renderArea(h) : "stepArea" === h.type ? l = this.renderStepArea(h) : "splineArea" === h.type ? l = this.renderSplineArea(h) : "stackedColumn" === h.type ? l = this.renderStackedColumn(h) : "stackedColumn100" === h.type ? l = this.renderStackedColumn100(h) : "stackedBar" === h.type ? l = this.renderStackedBar(h) : "stackedBar100" ===
                    h.type ? l = this.renderStackedBar100(h) : "stackedArea" === h.type ? l = this.renderStackedArea(h) : "stackedArea100" === h.type ? l = this.renderStackedArea100(h) : "bubble" === h.type ? l = l = this.renderBubble(h) : "scatter" === h.type ? l = this.renderScatter(h) : "pie" === h.type ? this.renderPie(h) : "doughnut" === h.type ? this.renderPie(h) : "candlestick" === h.type ? l = this.renderCandlestick(h) : "ohlc" === h.type ? l = this.renderCandlestick(h) : "rangeColumn" === h.type ? l = this.renderRangeColumn(h) : "rangeBar" === h.type ? l = this.renderRangeBar(h) : "rangeArea" ===
                    h.type ? l = this.renderRangeArea(h) : "rangeSplineArea" === h.type && (l = this.renderRangeSplineArea(h));
                for (b = 0; b < h.dataSeriesIndexes.length; b++) this._dataInRenderedOrder.push(this.data[h.dataSeriesIndexes[b]]);
                this.animatedRender && l && c.push(l)
            }
        this.animatedRender && 0 < this._indexLabels.length && (a = ga(this.width, this.height).getContext("2d"), c.push(this.renderIndexLabels(a)));
        var k = this;
        0 < c.length ? (k.disableToolTip = !0, k._animator.animate(200, k.animationDuration, function(a) {
            k.ctx.clearRect(0, 0, k.width, k.height);
            k.ctx.drawImage(f, 0, 0, Math.floor(k.width * Q), Math.floor(k.height * Q), 0, 0, k.width, k.height);
            for (var b = 0; b < c.length; b++) l = c[b], 1 > a && "undefined" !== typeof l.startTimePercent ? a >= l.startTimePercent && l.animationCallback(l.easingFunction(a - l.startTimePercent, 0, 1, 1 - l.startTimePercent), l) : l.animationCallback(l.easingFunction(a, 0, 1, 1), l);
            k.dispatchEvent("dataAnimationIterationEnd", {
                chart: k
            })
        }, function() {
            c = [];
            for (var a = 0; a < k.plotInfo.plotTypes.length; a++)
                for (var b = k.plotInfo.plotTypes[a], d = 0; d < b.plotUnits.length; d++) b.plotUnits[d].targetCanvas =
                    null;
            f = null;
            k.disableToolTip = !1
        })) : (0 < k._indexLabels.length && k.renderIndexLabels(), k.dispatchEvent("dataAnimationIterationEnd", {
            chart: k
        }));
        this.attachPlotAreaEventHandlers();
        this.zoomEnabled || (this.panEnabled || !this._zoomButton || "none" === this._zoomButton.style.display) || Y(this._zoomButton, this._resetButton);
        this.toolTip._updateToolTip();
        this.renderCount++
    };
    A.prototype.attachPlotAreaEventHandlers = function() {
        this.attachEvent({
            context: this,
            chart: this,
            mousedown: this._plotAreaMouseDown,
            mouseup: this._plotAreaMouseUp,
            mousemove: this._plotAreaMouseMove,
            cursor: this.zoomEnabled ? "col-resize" : "move",
            cursor: this.panEnabled ? "move" : "default",
            capture: !0,
            bounds: this.plotArea
        })
    };
    A.prototype.categoriseDataSeries = function() {
        for (var a = "", d = 0; d < this.data.length; d++)
            if (a = this.data[d], a.dataPoints && (0 !== a.dataPoints.length && a.visible) && 0 <= A._supportedChartTypes.indexOf(a.type)) {
                for (var b = null, c = !1, f = null, g = !1, h = 0; h < this.plotInfo.plotTypes.length; h++)
                    if (this.plotInfo.plotTypes[h].type === a.type) {
                        c = !0;
                        b = this.plotInfo.plotTypes[h];
                        break
                    }
                c || (b = {
                    type: a.type,
                    totalDataSeries: 0,
                    plotUnits: []
                }, this.plotInfo.plotTypes.push(b));
                for (h = 0; h < b.plotUnits.length; h++)
                    if (b.plotUnits[h].axisYType === a.axisYType && b.plotUnits[h].axisXType === a.axisXType && b.plotUnits[h].axisYIndex === a.axisYIndex && b.plotUnits[h].axisXIndex === a.axisXIndex) {
                        g = !0;
                        f = b.plotUnits[h];
                        break
                    }
                g || (f = {
                    type: a.type,
                    previousDataSeriesCount: 0,
                    index: b.plotUnits.length,
                    plotType: b,
                    axisXType: a.axisXType,
                    axisYType: a.axisYType,
                    axisYIndex: a.axisYIndex,
                    axisXIndex: a.axisXIndex,
                    axisY: "primary" ===
                        a.axisYType ? this.axisY[0 <= a.axisYIndex && a.axisYIndex < this.axisY.length ? a.axisYIndex : 0] : this.axisY2[0 <= a.axisYIndex && a.axisYIndex < this.axisY2.length ? a.axisYIndex : 0],
                    axisX: "primary" === a.axisXType ? this.axisX[0 <= a.axisXIndex && a.axisXIndex < this.axisX.length ? a.axisXIndex : 0] : this.axisX2[0 <= a.axisXIndex && a.axisXIndex < this.axisX2.length ? a.axisXIndex : 0],
                    dataSeriesIndexes: [],
                    yTotals: []
                }, b.plotUnits.push(f));
                b.totalDataSeries++;
                f.dataSeriesIndexes.push(d);
                a.plotUnit = f
            }
        for (d = 0; d < this.plotInfo.plotTypes.length; d++)
            for (b =
                this.plotInfo.plotTypes[d], h = a = 0; h < b.plotUnits.length; h++) b.plotUnits[h].previousDataSeriesCount = a, a += b.plotUnits[h].dataSeriesIndexes.length
    };
    A.prototype.assignIdToDataPoints = function() {
        for (var a = 0; a < this.data.length; a++) {
            var d = this.data[a];
            if (d.dataPoints)
                for (var b = d.dataPoints.length, c = 0; c < b; c++) d.dataPointIds[c] = ++this._eventManager.lastObjectId
        }
    };
    A.prototype._processData = function() {
        this.assignIdToDataPoints();
        this.categoriseDataSeries();
        for (var a = 0; a < this.plotInfo.plotTypes.length; a++)
            for (var d =
                    this.plotInfo.plotTypes[a], b = 0; b < d.plotUnits.length; b++) {
                var c = d.plotUnits[b];
                "line" === c.type || "stepLine" === c.type || "spline" === c.type || "column" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "bar" === c.type || "bubble" === c.type || "scatter" === c.type ? this._processMultiseriesPlotUnit(c) : "stackedColumn" === c.type || "stackedBar" === c.type || "stackedArea" === c.type ? this._processStackedPlotUnit(c) : "stackedColumn100" === c.type || "stackedBar100" === c.type || "stackedArea100" === c.type ? this._processStacked100PlotUnit(c) :
                    "candlestick" !== c.type && "ohlc" !== c.type && "rangeColumn" !== c.type && "rangeBar" !== c.type && "rangeArea" !== c.type && "rangeSplineArea" !== c.type || this._processMultiYPlotUnit(c)
            }
    };
    A.prototype._processMultiseriesPlotUnit = function(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
            for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, f, g = !1, h = 0; h < a.dataSeriesIndexes.length; h++) {
                var l = this.data[a.dataSeriesIndexes[h]],
                    k = 0,
                    m = !1,
                    n = !1,
                    p;
                if ("normal" === l.axisPlacement || "xySwapped" === l.axisPlacement) var e = a.axisX.sessionVariables.newViewportMinimum ?
                    a.axisX.sessionVariables.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : a.axisX.logarithmic ? 0 : -Infinity,
                    r = a.axisX.sessionVariables.newViewportMaximum ? a.axisX.sessionVariables.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;
                if (l.dataPoints[k].x && l.dataPoints[k].x.getTime || "dateTime" === l.xValueType) g = !0;
                for (k = 0; k < l.dataPoints.length; k++) {
                    "undefined" === typeof l.dataPoints[k].x && (l.dataPoints[k].x = k + (a.axisX.logarithmic ? 1 : 0));
                    l.dataPoints[k].x.getTime ? (g = !0, c = l.dataPoints[k].x.getTime()) : c = l.dataPoints[k].x;
                    f = l.dataPoints[k].y;
                    c < b.min && (b.min = c);
                    c > b.max && (b.max = c);
                    f < d.min && (d.min = f);
                    f > d.max && (d.max = f);
                    if (0 < k) {
                        if (a.axisX.logarithmic) {
                            var q = c / l.dataPoints[k - 1].x;
                            1 > q && (q = 1 / q);
                            b.minDiff > q && 1 !== q && (b.minDiff = q)
                        } else q = c - l.dataPoints[k -
                            1].x, 0 > q && (q *= -1), b.minDiff > q && 0 !== q && (b.minDiff = q);
                        null !== f && null !== l.dataPoints[k - 1].y && (a.axisY.logarithmic ? (q = f / l.dataPoints[k - 1].y, 1 > q && (q = 1 / q), d.minDiff > q && 1 !== q && (d.minDiff = q)) : (q = f - l.dataPoints[k - 1].y, 0 > q && (q *= -1), d.minDiff > q && 0 !== q && (d.minDiff = q)))
                    }
                    if (c < e && !m) null !== f && (p = c);
                    else {
                        if (!m && (m = !0, 0 < k)) {
                            k -= 2;
                            continue
                        }
                        if (c > r && !n) n = !0;
                        else if (c > r && n) continue;
                        l.dataPoints[k].label && (a.axisX.labels[c] = l.dataPoints[k].label);
                        c < b.viewPortMin && (b.viewPortMin = c);
                        c > b.viewPortMax && (b.viewPortMax = c);
                        null ===
                            f ? b.viewPortMin === c && p < c && (b.viewPortMin = p) : (f < d.viewPortMin && (d.viewPortMin = f), f > d.viewPortMax && (d.viewPortMax = f))
                    }
                }
                this.plotInfo.axisXValueType = l.xValueType = g ? "dateTime" : "number"
            }
    };
    A.prototype._processStackedPlotUnit = function(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
            for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, f, g = !1, h = [], l = [], k = Infinity, m = 0; m < a.dataSeriesIndexes.length; m++) {
                var n = this.data[a.dataSeriesIndexes[m]],
                    p = 0,
                    e = !1,
                    r = !1,
                    q;
                if ("normal" === n.axisPlacement || "xySwapped" ===
                    n.axisPlacement) var s = this.sessionVariables.axisX.newViewportMinimum ? this.sessionVariables.axisX.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : -Infinity,
                    v = this.sessionVariables.axisX.newViewportMaximum ? this.sessionVariables.axisX.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ?
                    this.options.axisX.maximum : Infinity;
                if (n.dataPoints[p].x && n.dataPoints[p].x.getTime || "dateTime" === n.xValueType) g = !0;
                for (p = 0; p < n.dataPoints.length; p++) {
                    "undefined" === typeof n.dataPoints[p].x && (n.dataPoints[p].x = p + (a.axisX.logarithmic ? 1 : 0));
                    n.dataPoints[p].x.getTime ? (g = !0, c = n.dataPoints[p].x.getTime()) : c = n.dataPoints[p].x;
                    x(n.dataPoints[p].y) ? f = 0 : (f = n.dataPoints[p].y, 0 === m && (k = Math.min(f, k)));
                    c < b.min && (b.min = c);
                    c > b.max && (b.max = c);
                    if (0 < p) {
                        if (a.axisX.logarithmic) {
                            var w = c / n.dataPoints[p - 1].x;
                            1 > w && (w = 1 /
                                w);
                            b.minDiff > w && 1 !== w && (b.minDiff = w)
                        } else w = c - n.dataPoints[p - 1].x, 0 > w && (w *= -1), b.minDiff > w && 0 !== w && (b.minDiff = w);
                        null !== f && null !== n.dataPoints[p - 1].y && (a.axisY.logarithmic ? 0 < f && (w = f / n.dataPoints[p - 1].y, 1 > w && (w = 1 / w), d.minDiff > w && 1 !== w && (d.minDiff = w)) : (w = f - n.dataPoints[p - 1].y, 0 > w && (w *= -1), d.minDiff > w && 0 !== w && (d.minDiff = w)))
                    }
                    if (c < s && !e) null !== n.dataPoints[p].y && (q = c);
                    else {
                        if (!e && (e = !0, 0 < p)) {
                            p -= 2;
                            continue
                        }
                        if (c > v && !r) r = !0;
                        else if (c > v && r) continue;
                        n.dataPoints[p].label && (a.axisX.labels[c] = n.dataPoints[p].label);
                        c < b.viewPortMin && (b.viewPortMin = c);
                        c > b.viewPortMax && (b.viewPortMax = c);
                        null === n.dataPoints[p].y ? b.viewPortMin === c && q < c && (b.viewPortMin = q) : (a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + Math.abs(f), 0 <= f ? h[c] = h[c] ? h[c] + f : f : l[c] = l[c] ? l[c] + f : f)
                    }
                }
                this.plotInfo.axisXValueType = n.xValueType = g ? "dateTime" : "number"
            }
            for (p in h) h.hasOwnProperty(p) && !isNaN(p) && (a = h[p], a < d.min && (d.min = Math.min(a, k)), a > d.max && (d.max = a), p < b.viewPortMin || p > b.viewPortMax || (a < d.viewPortMin && (d.viewPortMin = Math.min(a, k)), a > d.viewPortMax &&
                (d.viewPortMax = a)));
            for (p in l) l.hasOwnProperty(p) && !isNaN(p) && (a = l[p], a < d.min && (d.min = Math.min(a, k)), a > d.max && (d.max = a), p < b.viewPortMin || p > b.viewPortMax || (a < d.viewPortMin && (d.viewPortMin = Math.min(a, k)), a > d.viewPortMax && (d.viewPortMax = a)))
        }
    };
    A.prototype._processStacked100PlotUnit = function(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
            for (var d = a.axisY.dataInfo, b = a.axisX.dataInfo, c, f, g = !1, h = !1, l = !1, k = [], m = 0; m < a.dataSeriesIndexes.length; m++) {
                var n = this.data[a.dataSeriesIndexes[m]],
                    p = 0,
                    e = !1,
                    r = !1,
                    q;
                if ("normal" === n.axisPlacement || "xySwapped" === n.axisPlacement) var s = this.sessionVariables.axisX.newViewportMinimum ? this.sessionVariables.axisX.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : -Infinity,
                    v = this.sessionVariables.axisX.newViewportMaximum ? this.sessionVariables.axisX.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum :
                    this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;
                if (n.dataPoints[p].x && n.dataPoints[p].x.getTime || "dateTime" === n.xValueType) g = !0;
                for (p = 0; p < n.dataPoints.length; p++) {
                    "undefined" === typeof n.dataPoints[p].x && (n.dataPoints[p].x = p + (a.axisX.logarithmic ? 1 : 0));
                    n.dataPoints[p].x.getTime ? (g = !0, c = n.dataPoints[p].x.getTime()) : c = n.dataPoints[p].x;
                    f = x(n.dataPoints[p].y) ? null : n.dataPoints[p].y;
                    c < b.min && (b.min = c);
                    c > b.max && (b.max = c);
                    if (0 < p) {
                        if (a.axisX.logarithmic) {
                            var w = c / n.dataPoints[p -
                                1].x;
                            1 > w && (w = 1 / w);
                            b.minDiff > w && 1 !== w && (b.minDiff = w)
                        } else w = c - n.dataPoints[p - 1].x, 0 > w && (w *= -1), b.minDiff > w && 0 !== w && (b.minDiff = w);
                        x(f) || null === n.dataPoints[p - 1].y || (a.axisY.logarithmic ? 0 < f && (w = f / n.dataPoints[p - 1].y, 1 > w && (w = 1 / w), d.minDiff > w && 1 !== w && (d.minDiff = w)) : (w = f - n.dataPoints[p - 1].y, 0 > w && (w *= -1), d.minDiff > w && 0 !== w && (d.minDiff = w)))
                    }
                    if (c < s && !e) null !== f && (q = c);
                    else {
                        if (!e && (e = !0, 0 < p)) {
                            p -= 2;
                            continue
                        }
                        if (c > v && !r) r = !0;
                        else if (c > v && r) continue;
                        n.dataPoints[p].label && (a.axisX.labels[c] = n.dataPoints[p].label);
                        c < b.viewPortMin && (b.viewPortMin = c);
                        c > b.viewPortMax && (b.viewPortMax = c);
                        null === f ? b.viewPortMin === c && q < c && (b.viewPortMin = q) : (a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + Math.abs(f), 0 <= f ? h = !0 : 0 > f && (l = !0), k[c] = k[c] ? k[c] + Math.abs(f) : Math.abs(f))
                    }
                }
                this.plotInfo.axisXValueType = n.xValueType = g ? "dateTime" : "number"
            }
            a.axisY.logarithmic ? (d.max = x(d.viewPortMax) ? 99 * Math.pow(a.axisY.logarithmBase, -0.05) : Math.max(d.viewPortMax, 99 * Math.pow(a.axisY.logarithmBase, -0.05)), d.min = x(d.viewPortMin) ? 1 : Math.min(d.viewPortMin,
                1)) : h && !l ? (d.max = x(d.viewPortMax) ? 99 : Math.max(d.viewPortMax, 99), d.min = x(d.viewPortMin) ? 1 : Math.min(d.viewPortMin, 1)) : h && l ? (d.max = x(d.viewPortMax) ? 99 : Math.max(d.viewPortMax, 99), d.min = x(d.viewPortMin) ? -99 : Math.min(d.viewPortMin, -99)) : !h && l && (d.max = x(d.viewPortMax) ? -1 : Math.max(d.viewPortMax, -1), d.min = x(d.viewPortMin) ? -99 : Math.min(d.viewPortMin, -99));
            d.viewPortMin = d.min;
            d.viewPortMax = d.max;
            a.dataPointYSums = k
        }
    };
    A.prototype._processMultiYPlotUnit = function(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
            for (var d =
                    a.axisY.dataInfo, b = a.axisX.dataInfo, c, f, g, h, l = !1, k = 0; k < a.dataSeriesIndexes.length; k++) {
                var m = this.data[a.dataSeriesIndexes[k]],
                    n = 0,
                    p = !1,
                    e = !1,
                    r, q, s;
                if ("normal" === m.axisPlacement || "xySwapped" === m.axisPlacement) var v = this.sessionVariables.axisX.newViewportMinimum ? this.sessionVariables.axisX.newViewportMinimum : this.options.axisX && this.options.axisX.viewportMinimum ? this.options.axisX.viewportMinimum : this.options.axisX && this.options.axisX.minimum ? this.options.axisX.minimum : -Infinity,
                    w = this.sessionVariables.axisX.newViewportMaximum ?
                    this.sessionVariables.axisX.newViewportMaximum : this.options.axisX && this.options.axisX.viewportMaximum ? this.options.axisX.viewportMaximum : this.options.axisX && this.options.axisX.maximum ? this.options.axisX.maximum : Infinity;
                if (m.dataPoints[n].x && m.dataPoints[n].x.getTime || "dateTime" === m.xValueType) l = !0;
                for (n = 0; n < m.dataPoints.length; n++) {
                    "undefined" === typeof m.dataPoints[n].x && (m.dataPoints[n].x = n + (a.axisX.logarithmic ? 1 : 0));
                    m.dataPoints[n].x.getTime ? (l = !0, c = m.dataPoints[n].x.getTime()) : c = m.dataPoints[n].x;
                    if ((f = m.dataPoints[n].y) && f.length) {
                        g = Math.min.apply(null, f);
                        h = Math.max.apply(null, f);
                        q = !0;
                        for (var y = 0; y < f.length; y++) null === f.k && (q = !1);
                        q && (p || (s = r), r = c)
                    }
                    c < b.min && (b.min = c);
                    c > b.max && (b.max = c);
                    g < d.min && (d.min = g);
                    h > d.max && (d.max = h);
                    0 < n && (a.axisX.logarithmic ? (q = c / m.dataPoints[n - 1].x, 1 > q && (q = 1 / q), b.minDiff > q && 1 !== q && (b.minDiff = q)) : (q = c - m.dataPoints[n - 1].x, 0 > q && (q *= -1), b.minDiff > q && 0 !== q && (b.minDiff = q)), f && (null !== f[0] && m.dataPoints[n - 1].y && null !== m.dataPoints[n - 1].y[0]) && (a.axisY.logarithmic ? (q = f[0] /
                        m.dataPoints[n - 1].y[0], 1 > q && (q = 1 / q), d.minDiff > q && 1 !== q && (d.minDiff = q)) : (q = f[0] - m.dataPoints[n - 1].y[0], 0 > q && (q *= -1), d.minDiff > q && 0 !== q && (d.minDiff = q))));
                    if (!(c < v) || p) {
                        if (!p && (p = !0, 0 < n)) {
                            n -= 2;
                            r = s;
                            continue
                        }
                        if (c > w && !e) e = !0;
                        else if (c > w && e) continue;
                        m.dataPoints[n].label && (a.axisX.labels[c] = m.dataPoints[n].label);
                        c < b.viewPortMin && (b.viewPortMin = c);
                        c > b.viewPortMax && (b.viewPortMax = c);
                        if (b.viewPortMin === c && f)
                            for (y = 0; y < f.length; y++)
                                if (null === f[y] && r < c) {
                                    b.viewPortMin = r;
                                    break
                                }
                        null === f ? b.viewPortMin === c && r < c &&
                            (b.viewPortMin = r) : (g < d.viewPortMin && (d.viewPortMin = g), h > d.viewPortMax && (d.viewPortMax = h))
                    }
                }
                this.plotInfo.axisXValueType = m.xValueType = l ? "dateTime" : "number"
            }
    };
    A.prototype.getDataPointAtXY = function(a, d, b) {
        b = b || !1;
        for (var c = [], f = this._dataInRenderedOrder.length - 1; 0 <= f; f--) {
            var g = null;
            (g = this._dataInRenderedOrder[f].getDataPointAtXY(a, d, b)) && c.push(g)
        }
        a = null;
        d = !1;
        for (b = 0; b < c.length; b++)
            if ("line" === c[b].dataSeries.type || "stepLine" === c[b].dataSeries.type || "area" === c[b].dataSeries.type || "stepArea" === c[b].dataSeries.type)
                if (f =
                    L("markerSize", c[b].dataPoint, c[b].dataSeries) || 8, c[b].distance <= f / 2) {
                    d = !0;
                    break
                }
        for (b = 0; b < c.length; b++) d && "line" !== c[b].dataSeries.type && "stepLine" !== c[b].dataSeries.type && "area" !== c[b].dataSeries.type && "stepArea" !== c[b].dataSeries.type || (a ? c[b].distance <= a.distance && (a = c[b]) : a = c[b]);
        return a
    };
    A.prototype.getObjectAtXY = function(a, d, b) {
        var c = null;
        if (b = this.getDataPointAtXY(a, d, b || !1)) c = b.dataSeries.dataPointIds[b.dataPointIndex];
        else if (u) c = La(a, d, this._eventManager.ghostCtx);
        else
            for (b = 0; b < this.legend.items.length; b++) {
                var f =
                    this.legend.items[b];
                a >= f.x1 && (a <= f.x2 && d >= f.y1 && d <= f.y2) && (c = f.id)
            }
        return c
    };
    A.prototype.getAutoFontSize = function(a, d, b) {
        a /= 400;
        return Math.max(10, Math.round(Math.min(this.width, this.height) * a))
    };
    A.prototype.resetOverlayedCanvas = function() {
        this.overlaidCanvasCtx.clearRect(0, 0, this.width, this.height)
    };
    A.prototype.clearCanvas = function() {
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.backgroundColor && (this.ctx.fillStyle = this.backgroundColor, this.ctx.fillRect(0, 0, this.width, this.height))
    };
    A.prototype.attachEvent =
        function(a) {
            this._events.push(a)
        };
    A.prototype._touchEventHandler = function(a) {
        if (a.changedTouches && this.interactivityEnabled) {
            var d = [],
                b = a.changedTouches,
                c = b ? b[0] : a,
                f = null;
            switch (a.type) {
                case "touchstart":
                case "MSPointerDown":
                    d = ["mousemove", "mousedown"];
                    this._lastTouchData = xa(c);
                    this._lastTouchData.time = new Date;
                    break;
                case "touchmove":
                case "MSPointerMove":
                    d = ["mousemove"];
                    break;
                case "touchend":
                case "MSPointerUp":
                    d = "touchstart" === this._lastTouchEventType || "MSPointerDown" === this._lastTouchEventType ? ["mouseup",
                        "click"
                    ] : ["mouseup"];
                    break;
                default:
                    return
            }
            if (!(b && 1 < b.length)) {
                f = xa(c);
                f.time = new Date;
                try {
                    var g = f.y - this._lastTouchData.y,
                        h = f.time - this._lastTouchData.time;
                    if (15 < Math.abs(g) && (this._lastTouchData.scroll || 200 > h)) {
                        this._lastTouchData.scroll = !0;
                        var l = window.parent || window;
                        l && l.scrollBy && l.scrollBy(0, -g)
                    }
                } catch (k) {}
                this._lastTouchEventType = a.type;
                if (this._lastTouchData.scroll && this.zoomEnabled) this.isDrag && this.resetOverlayedCanvas(), this.isDrag = !1;
                else
                    for (b = 0; b < d.length; b++) f = d[b], g = document.createEvent("MouseEvent"),
                        g.initMouseEvent(f, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), c.target.dispatchEvent(g), a.preventManipulation && a.preventManipulation(), a.preventDefault && a.preventDefault()
            }
        }
    };
    A.prototype._dispatchRangeEvent = function(a, d) {
        var b = {
            chart: this
        };
        b.type = a;
        b.trigger = d;
        var c = [];
        this.axisX && 0 < this.axisX.length && c.push("axisX");
        this.axisX2 && 0 < this.axisX2.length && c.push("axisX2");
        this.axisY && 0 < this.axisY.length && c.push("axisY");
        this.axisY2 && 0 < this.axisY2.length && c.push("axisY2");
        for (var f = 0; f < c.length; f++)
            if (x(b[c[f]]) && (b[c[f]] = []), "axisY" === c[f])
                for (var g = 0; g < this.axisY.length; g++) b[c[f]].push({
                    viewportMinimum: this[c[f]][g].sessionVariables.newViewportMinimum,
                    viewportMaximum: this[c[f]][g].sessionVariables.newViewportMaximum
                });
            else if ("axisY2" === c[f])
            for (g = 0; g < this.axisY2.length; g++) b[c[f]].push({
                viewportMinimum: this[c[f]][g].sessionVariables.newViewportMinimum,
                viewportMaximum: this[c[f]][g].sessionVariables.newViewportMaximum
            });
        else if ("axisX" === c[f])
            for (g = 0; g < this.axisX.length; g++) b[c[f]].push({
                viewportMinimum: this[c[f]][g].sessionVariables.newViewportMinimum,
                viewportMaximum: this[c[f]][g].sessionVariables.newViewportMaximum
            });
        else if ("axisX2" === c[f])
            for (g = 0; g < this.axisX2.length; g++) b[c[f]].push({
                viewportMinimum: this[c[f]][g].sessionVariables.newViewportMinimum,
                viewportMaximum: this[c[f]][g].sessionVariables.newViewportMaximum
            });
        this.dispatchEvent(a, b, this)
    };
    A.prototype._mouseEventHandler = function(a) {
        "undefined" === typeof a.target && a.srcElement && (a.target = a.srcElement);
        var d = xa(a),
            b = a.type,
            c, f;
        a.which ? f = 3 == a.which : a.button && (f = 2 == a.button);
        A.capturedEventParam &&
            (c = A.capturedEventParam, "mouseup" === b && (A.capturedEventParam = null, c.chart.overlaidCanvas.releaseCapture ? c.chart.overlaidCanvas.releaseCapture() : document.documentElement.removeEventListener("mouseup", c.chart._mouseEventHandler, !1)), c.hasOwnProperty(b) && ("mouseup" !== b || c.chart.overlaidCanvas.releaseCapture ? a.target === c.chart.overlaidCanvas && c[b].call(c.context, d.x, d.y) : a.target !== c.chart.overlaidCanvas && (c.chart.isDrag = !1)));
        if (this.interactivityEnabled)
            if (this._ignoreNextEvent) this._ignoreNextEvent = !1;
            else if (a.preventManipulation && a.preventManipulation(), a.preventDefault && a.preventDefault(), !f) {
            if (!A.capturedEventParam && this._events) {
                for (var g = 0; g < this._events.length; g++)
                    if (this._events[g].hasOwnProperty(b))
                        if (c = this._events[g], f = c.bounds, d.x >= f.x1 && d.x <= f.x2 && d.y >= f.y1 && d.y <= f.y2) {
                            c[b].call(c.context, d.x, d.y);
                            "mousedown" === b && !0 === c.capture ? (A.capturedEventParam = c, this.overlaidCanvas.setCapture ? this.overlaidCanvas.setCapture() : document.documentElement.addEventListener("mouseup", this._mouseEventHandler, !1)) : "mouseup" === b && (c.chart.overlaidCanvas.releaseCapture ? c.chart.overlaidCanvas.releaseCapture() : document.documentElement.removeEventListener("mouseup", this._mouseEventHandler, !1));
                            break
                        } else c = null;
                a.target.style.cursor = c && c.cursor ? c.cursor : this._defaultCursor
            }
            b = this.plotArea;
            if (d.x < b.x1 || d.x > b.x2 || d.y < b.y1 || d.y > b.y2) this.toolTip && this.toolTip.enabled ? this.toolTip.hide() : this.resetOverlayedCanvas();
            this.isDrag && this.zoomEnabled || !this._eventManager || this._eventManager.mouseEventHandler(a)
        }
    };
    A.prototype._plotAreaMouseDown =
        function(a, d) {
            this.isDrag = !0;
            this.dragStartPoint = {
                x: a,
                y: d
            }
        };
    A.prototype._plotAreaMouseUp = function(a, d) {
        if (("normal" === this.plotInfo.axisPlacement || "xySwapped" === this.plotInfo.axisPlacement) && this.isDrag) {
            var b = d - this.dragStartPoint.y,
                c = a - this.dragStartPoint.x,
                f = 0 <= this.zoomType.indexOf("x"),
                g = 0 <= this.zoomType.indexOf("y"),
                h = !1;
            this.resetOverlayedCanvas();
            if ("xySwapped" === this.plotInfo.axisPlacement) var l = g,
                g = f,
                f = l;
            if (this.panEnabled || this.zoomEnabled) {
                if (this.panEnabled)
                    for (f = g = 0; f < this._axes.length; f++) b =
                        this._axes[f], b.logarithmic ? b.viewportMinimum < b.minimum ? (g = b.minimum / b.viewportMinimum, b.sessionVariables.newViewportMinimum = b.viewportMinimum * g, b.sessionVariables.newViewportMaximum = b.viewportMaximum * g, h = !0) : b.viewportMaximum > b.maximum && (g = b.viewportMaximum / b.maximum, b.sessionVariables.newViewportMinimum = b.viewportMinimum / g, b.sessionVariables.newViewportMaximum = b.viewportMaximum / g, h = !0) : b.viewportMinimum < b.minimum ? (g = b.minimum - b.viewportMinimum, b.sessionVariables.newViewportMinimum = b.viewportMinimum +
                            g, b.sessionVariables.newViewportMaximum = b.viewportMaximum + g, h = !0) : b.viewportMaximum > b.maximum && (g = b.viewportMaximum - b.maximum, b.sessionVariables.newViewportMinimum = b.viewportMinimum - g, b.sessionVariables.newViewportMaximum = b.viewportMaximum - g, h = !0);
                else if ((!f || 2 < Math.abs(c)) && (!g || 2 < Math.abs(b)) && this.zoomEnabled) {
                    if (!this.dragStartPoint) return;
                    b = f ? this.dragStartPoint.x : this.plotArea.x1;
                    c = g ? this.dragStartPoint.y : this.plotArea.y1;
                    f = f ? a : this.plotArea.x2;
                    g = g ? d : this.plotArea.y2;
                    2 < Math.abs(b - f) && 2 < Math.abs(c -
                        g) && this._zoomPanToSelectedRegion(b, c, f, g) && (h = !0)
                }
                h && (this._ignoreNextEvent = !0, this._dispatchRangeEvent("rangeChanging", "zoom"), this.render(), this._dispatchRangeEvent("rangeChanged", "zoom"), h && (this.zoomEnabled && "none" === this._zoomButton.style.display) && (ta(this._zoomButton, this._resetButton), T(this, this._zoomButton, "pan"), T(this, this._resetButton, "reset")))
            }
        }
        this.isDrag = !1
    };
    A.prototype._plotAreaMouseMove = function(a, d) {
        if (this.isDrag && "none" !== this.plotInfo.axisPlacement) {
            var b = 0,
                c = 0,
                f = b = null,
                f =
                0 <= this.zoomType.indexOf("x"),
                g = 0 <= this.zoomType.indexOf("y"),
                h = this;
            "xySwapped" === this.plotInfo.axisPlacement && (b = g, g = f, f = b);
            b = this.dragStartPoint.x - a;
            c = this.dragStartPoint.y - d;
            2 < Math.abs(b) && 8 > Math.abs(b) && (this.panEnabled || this.zoomEnabled) ? this.toolTip.hide() : this.panEnabled || this.zoomEnabled || this.toolTip.mouseMoveHandler(a, d);
            if ((!f || 2 < Math.abs(b) || !g || 2 < Math.abs(c)) && (this.panEnabled || this.zoomEnabled))
                if (this.panEnabled) f = {
                    x1: f ? this.plotArea.x1 + b : this.plotArea.x1,
                    y1: g ? this.plotArea.y1 + c : this.plotArea.y1,
                    x2: f ? this.plotArea.x2 + b : this.plotArea.x2,
                    y2: g ? this.plotArea.y2 + c : this.plotArea.y2
                }, clearTimeout(h._panTimerId), h._panTimerId = setTimeout(function(b, c, e, f) {
                    return function() {
                        h._zoomPanToSelectedRegion(b, c, e, f, !0) && (h._dispatchRangeEvent("rangeChanging", "pan"), h.render(), h._dispatchRangeEvent("rangeChanged", "pan"), h.dragStartPoint.x = a, h.dragStartPoint.y = d)
                    }
                }(f.x1, f.y1, f.x2, f.y2), 0);
                else if (this.zoomEnabled) {
                this.resetOverlayedCanvas();
                b = this.overlaidCanvasCtx.globalAlpha;
                this.overlaidCanvasCtx.fillStyle =
                    "#A89896";
                var c = f ? this.dragStartPoint.x : this.plotArea.x1,
                    l = g ? this.dragStartPoint.y : this.plotArea.y1,
                    k = f ? a - this.dragStartPoint.x : this.plotArea.x2 - this.plotArea.x1,
                    m = g ? d - this.dragStartPoint.y : this.plotArea.y2 - this.plotArea.y1;
                this.validateRegion(c, l, f ? a : this.plotArea.x2 - this.plotArea.x1, g ? d : this.plotArea.y2 - this.plotArea.y1, "xy" !== this.zoomType).isValid && (this.resetOverlayedCanvas(), this.overlaidCanvasCtx.fillStyle = "#99B2B5");
                this.overlaidCanvasCtx.globalAlpha = 0.7;
                this.overlaidCanvasCtx.fillRect(c,
                    l, k, m);
                this.overlaidCanvasCtx.globalAlpha = b
            }
        } else this.toolTip.mouseMoveHandler(a, d)
    };
    A.prototype._zoomPanToSelectedRegion = function(a, d, b, c, f) {
        a = this.validateRegion(a, d, b, c, f);
        d = a.axesWithValidRange;
        b = a.axesRanges;
        if (a.isValid)
            for (c = 0; c < d.length; c++) f = b[c], d[c].setViewPortRange(f.val1, f.val2);
        return a.isValid
    };
    A.prototype.validateRegion = function(a, d, b, c, f) {
        f = f || !1;
        for (var g = 0 <= this.zoomType.indexOf("x"), h = 0 <= this.zoomType.indexOf("y"), l = !1, k = [], m = [], n = [], p = 0; p < this.axisX.length; p++) this.axisX[p] &&
            g && m.push(this.axisX[p]);
        for (p = 0; p < this.axisX2.length; p++) this.axisX2[p] && g && m.push(this.axisX2[p]);
        for (p = 0; p < this.axisY.length; p++) this.axisY[p] && h && m.push(this.axisY[p]);
        for (p = 0; p < this.axisY2.length; p++) this.axisY2[p] && h && m.push(this.axisY2[p]);
        for (g = 0; g < m.length; g++) {
            var h = m[g],
                p = h.convertPixelToValue({
                    x: a,
                    y: d
                }),
                e = h.convertPixelToValue({
                    x: b,
                    y: c
                });
            if (p > e) var r = e,
                e = p,
                p = r;
            if (isFinite(h.dataInfo.minDiff))
                if (!(h.logarithmic && e / p < Math.pow(h.dataInfo.minDiff, 3) || !h.logarithmic && Math.abs(e - p) < 3 * Math.abs(h.dataInfo.minDiff) ||
                        p < h.minimum || e > h.maximum)) k.push(h), n.push({
                    val1: p,
                    val2: e
                }), l = !0;
                else if (!f) {
                l = !1;
                break
            }
        }
        return {
            isValid: l,
            axesWithValidRange: k,
            axesRanges: n
        }
    };
    A.prototype.preparePlotArea = function() {
        var a = this.plotArea;
        !u && (0 < a.x1 || 0 < a.y1) && a.ctx.translate(a.x1, a.y1);
        if ((this.axisX[0] || this.axisX2[0]) && (this.axisY[0] || this.axisY2[0])) {
            var d = this.axisX[0] ? this.axisX[0].lineCoordinates : this.axisX2[0].lineCoordinates;
            if (this.axisY && 0 < this.axisY.length && this.axisY[0]) {
                var b = this.axisY[0];
                a.x1 = d.x1 < d.x2 ? d.x1 : b.lineCoordinates.x1;
                a.y1 = d.y1 < b.lineCoordinates.y1 ? d.y1 : b.lineCoordinates.y1;
                a.x2 = d.x2 > b.lineCoordinates.x2 ? d.x2 : b.lineCoordinates.x2;
                a.y2 = d.y2 > d.y1 ? d.y2 : b.lineCoordinates.y2;
                a.width = a.x2 - a.x1;
                a.height = a.y2 - a.y1
            }
            this.axisY2 && 0 < this.axisY2.length && this.axisY2[0] && (b = this.axisY2[0], a.x1 = d.x1 < d.x2 ? d.x1 : b.lineCoordinates.x1, a.y1 = d.y1 < b.lineCoordinates.y1 ? d.y1 : b.lineCoordinates.y1, a.x2 = d.x2 > b.lineCoordinates.x2 ? d.x2 : b.lineCoordinates.x2, a.y2 = d.y2 > d.y1 ? d.y2 : b.lineCoordinates.y2, a.width = a.x2 - a.x1, a.height = a.y2 - a.y1)
        } else d =
            this.layoutManager.getFreeSpace(), a.x1 = d.x1, a.x2 = d.x2, a.y1 = d.y1, a.y2 = d.y2, a.width = d.width, a.height = d.height;
        u || (a.canvas.width = a.width, a.canvas.height = a.height, a.canvas.style.left = a.x1 + "px", a.canvas.style.top = a.y1 + "px", (0 < a.x1 || 0 < a.y1) && a.ctx.translate(-a.x1, -a.y1));
        a.layoutManager = new ja(a.x1, a.y1, a.x2, a.y2, 2)
    };
    A.prototype.renderIndexLabels = function(a) {
        var d = a || this.plotArea.ctx,
            b = this.plotArea,
            c = 0,
            f = 0,
            g = 0,
            h = 0,
            l = c = h = f = g = 0,
            k = 0;
        for (a = 0; a < this._indexLabels.length; a++) {
            var m = this._indexLabels[a],
                n = m.chartType.toLowerCase(),
                p, e, l = L("indexLabelFontColor", m.dataPoint, m.dataSeries),
                k = L("indexLabelFontSize", m.dataPoint, m.dataSeries);
            p = L("indexLabelFontFamily", m.dataPoint, m.dataSeries);
            e = L("indexLabelFontStyle", m.dataPoint, m.dataSeries);
            var h = L("indexLabelFontWeight", m.dataPoint, m.dataSeries),
                r = L("indexLabelBackgroundColor", m.dataPoint, m.dataSeries),
                f = L("indexLabelMaxWidth", m.dataPoint, m.dataSeries),
                g = L("indexLabelWrap", m.dataPoint, m.dataSeries),
                q = L("indexLabelLineDashType", m.dataPoint, m.dataSeries),
                s = L("indexLabelLineColor",
                    m.dataPoint, m.dataSeries),
                v = x(m.dataPoint.indexLabelLineThickness) ? x(m.dataSeries.options.indexLabelLineThickness) ? 0 : m.dataSeries.options.indexLabelLineThickness : m.dataPoint.indexLabelLineThickness,
                c = 0 < v ? Math.min(10, ("normal" === this.plotInfo.axisPlacement ? this.plotArea.height : this.plotArea.width) << 0) : 0,
                w = {
                    percent: null,
                    total: null
                },
                y = null;
            if (0 <= m.dataSeries.type.indexOf("stacked") || "pie" === m.dataSeries.type || "doughnut" === m.dataSeries.type) w = this.getPercentAndTotal(m.dataSeries, m.dataPoint);
            if (m.dataSeries.indexLabelFormatter ||
                m.dataPoint.indexLabelFormatter) y = {
                chart: this,
                dataSeries: m.dataSeries,
                dataPoint: m.dataPoint,
                index: m.indexKeyword,
                total: w.total,
                percent: w.percent
            };
            var t = m.dataPoint.indexLabelFormatter ? m.dataPoint.indexLabelFormatter(y) : m.dataPoint.indexLabel ? this.replaceKeywordsWithValue(m.dataPoint.indexLabel, m.dataPoint, m.dataSeries, null, m.indexKeyword) : m.dataSeries.indexLabelFormatter ? m.dataSeries.indexLabelFormatter(y) : m.dataSeries.indexLabel ? this.replaceKeywordsWithValue(m.dataSeries.indexLabel, m.dataPoint, m.dataSeries,
                null, m.indexKeyword) : null;
            if (null !== t && "" !== t) {
                var w = L("indexLabelPlacement", m.dataPoint, m.dataSeries),
                    y = L("indexLabelOrientation", m.dataPoint, m.dataSeries),
                    D = m.direction,
                    Z = m.dataSeries.axisX,
                    aa = m.dataSeries.axisY,
                    z = !1,
                    r = new W(d, {
                        x: 0,
                        y: 0,
                        maxWidth: f ? f : 0.5 * this.width,
                        maxHeight: g ? 5 * k : 1.5 * k,
                        angle: "horizontal" === y ? 0 : -90,
                        text: t,
                        padding: 0,
                        backgroundColor: r,
                        horizontalAlign: "left",
                        fontSize: k,
                        fontFamily: p,
                        fontWeight: h,
                        fontColor: l,
                        fontStyle: e,
                        textBaseline: "top"
                    });
                r.measureText();
                m.dataSeries.indexLabelMaxWidth =
                    r.maxWidth;
                if (0 <= n.indexOf("line") || 0 <= n.indexOf("area") || 0 <= n.indexOf("bubble") || 0 <= n.indexOf("scatter")) {
                    if (m.dataPoint.x < Z.viewportMinimum || m.dataPoint.x > Z.viewportMaximum || m.dataPoint.y < aa.viewportMinimum || m.dataPoint.y > aa.viewportMaximum) continue
                } else if (0 <= n.indexOf("column")) {
                    if (m.dataPoint.x < Z.viewportMinimum || m.dataPoint.x > Z.viewportMaximum || m.bounds.y1 > b.y2 || m.bounds.y2 < b.y1) continue
                } else if (0 <= n.indexOf("bar")) {
                    if (m.dataPoint.x < Z.viewportMinimum || m.dataPoint.x > Z.viewportMaximum || m.bounds.x1 >
                        b.x2 || m.bounds.x2 < b.x1) continue
                } else if (m.dataPoint.x < Z.viewportMinimum || m.dataPoint.x > Z.viewportMaximum) continue;
                f = h = 2;
                "horizontal" === y ? (l = r.width, k = r.height) : (k = r.width, l = r.height);
                if ("normal" === this.plotInfo.axisPlacement) {
                    if (0 <= n.indexOf("line") || 0 <= n.indexOf("area")) w = "auto", h = 4;
                    else if (0 <= n.indexOf("stacked")) "auto" === w && (w = "inside");
                    else if ("bubble" === n || "scatter" === n) w = "inside";
                    p = m.point.x - l / 2;
                    "inside" !== w ? (f = b.y1, g = b.y2, 0 < D ? (e = m.point.y - k - h - c, e < f && (e = "auto" === w ? Math.max(m.point.y, f) + h + c :
                        f + h + c, z = e + k > m.point.y)) : (e = m.point.y + h + c, e > g - k - h - c && (e = "auto" === w ? Math.min(m.point.y, g) - k - h - c : g - k - h - c, z = e < m.point.y))) : (f = Math.max(m.bounds.y1, b.y1), g = Math.min(m.bounds.y2, b.y2), c = 0 <= n.indexOf("range") ? 0 < D ? Math.max(m.bounds.y1, b.y1) + k / 2 + h : Math.min(m.bounds.y2, b.y2) - k / 2 - h : (Math.max(m.bounds.y1, b.y1) + Math.min(m.bounds.y2, b.y2)) / 2, 0 < D ? (e = Math.max(m.point.y, c) - k / 2, e < f && ("bubble" === n || "scatter" === n) && (e = Math.max(m.point.y - k - h, b.y1 + h))) : (e = Math.min(m.point.y, c) - k / 2, e > g - k - h && ("bubble" === n || "scatter" === n) &&
                        (e = Math.min(m.point.y + h, b.y2 - k - h))), e = Math.min(e, g - k))
                } else 0 <= n.indexOf("line") || 0 <= n.indexOf("area") || 0 <= n.indexOf("scatter") ? (w = "auto", f = 4) : 0 <= n.indexOf("stacked") ? "auto" === w && (w = "inside") : "bubble" === n && (w = "inside"), e = m.point.y - k / 2, "inside" !== w ? (h = b.x1, g = b.x2, 0 > D ? (p = m.point.x - l - f - c, p < h && (p = "auto" === w ? Math.max(m.point.x, h) + f + c : h + f + c, z = p + l > m.point.x)) : (p = m.point.x + f + c, p > g - l - f - c && (p = "auto" === w ? Math.min(m.point.x, g) - l - f - c : g - l - f - c, z = p < m.point.x))) : (h = Math.max(m.bounds.x1, b.x1), Math.min(m.bounds.x2,
                    b.x2), c = 0 <= n.indexOf("range") ? 0 > D ? Math.max(m.bounds.x1, b.x1) + l / 2 + f : Math.min(m.bounds.x2, b.x2) - l / 2 - f : (Math.max(m.bounds.x1, b.x1) + Math.min(m.bounds.x2, b.x2)) / 2, p = 0 > D ? Math.max(m.point.x, c) - l / 2 : Math.min(m.point.x, c) - l / 2, p = Math.max(p, h));
                "vertical" === y && (e += k);
                r.x = p;
                r.y = e;
                r.render(!0);
                v && ("inside" !== w && (0 > n.indexOf("bar") && m.point.x > b.x1 && m.point.x < b.x2 || !z) && (0 > n.indexOf("column") && m.point.y > b.y1 && m.point.y < b.y2 || !z)) && (d.lineWidth = v, d.strokeStyle = s ? s : "gray", d.setLineDash && d.setLineDash(I(q, v)), d.beginPath(),
                    d.moveTo(m.point.x, m.point.y), 0 <= n.indexOf("bar") ? d.lineTo(p + (0 < m.direction ? 0 : l), e + ("horizontal" === y ? k : -k) / 2) : 0 <= n.indexOf("column") ? d.lineTo(p + l / 2, e + ((0 < m.direction ? k : -k) + ("horizontal" === y ? k : -k)) / 2) : d.lineTo(p + l / 2, e + ((e < m.point.y ? k : -k) + ("horizontal" === y ? k : -k)) / 2), d.stroke())
            }
        }
        d = {
            source: d,
            dest: this.plotArea.ctx,
            animationCallback: F.fadeInAnimation,
            easingFunction: F.easing.easeInQuad,
            animationBase: 0,
            startTimePercent: 0.7
        };
        for (a = 0; a < this._indexLabels.length; a++) m = this._indexLabels[a], r = L("indexLabelBackgroundColor",
            m.dataPoint, m.dataSeries), m.dataSeries.indexLabelBackgroundColor = x(r) ? u ? "transparent" : null : r;
        return d
    };
    A.prototype.renderLine = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = this._eventManager.ghostCtx;
            d.save();
            var c = this.plotArea;
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            for (var c = [], f = null, g = 0; g < a.dataSeriesIndexes.length; g++) {
                var h = a.dataSeriesIndexes[g],
                    l = this.data[h];
                d.lineWidth = l.lineThickness;
                var k = l.dataPoints,
                    m = "solid";
                if (d.setLineDash) {
                    var n =
                        I(l.nullDataLineDashType, l.lineThickness),
                        m = l.lineDashType,
                        p = I(m, l.lineThickness);
                    d.setLineDash(p)
                }
                var e = l.id;
                this._eventManager.objectMap[e] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: h
                };
                e = G(e);
                b.strokeStyle = e;
                b.lineWidth = 0 < l.lineThickness ? Math.max(l.lineThickness, 4) : 0;
                var e = l._colorSet,
                    r = e = l.lineColor = l.options.lineColor ? l.options.lineColor : e[0];
                d.strokeStyle = e;
                var q = !0,
                    s = 0,
                    v, w;
                d.beginPath();
                if (0 < k.length) {
                    for (var y = !1, s = 0; s < k.length; s++)
                        if (v = k[s].x.getTime ? k[s].x.getTime() : k[s].x, !(v < a.axisX.dataInfo.viewPortMin ||
                                v > a.axisX.dataInfo.viewPortMax && (!l.connectNullData || !y)))
                            if ("number" !== typeof k[s].y) 0 < s && !(l.connectNullData || y || q) && (d.stroke(), u && b.stroke()), y = !0;
                            else {
                                v = a.axisX.convertValueToPixel(v);
                                w = a.axisY.convertValueToPixel(k[s].y);
                                var t = l.dataPointIds[s];
                                this._eventManager.objectMap[t] = {
                                    id: t,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: h,
                                    dataPointIndex: s,
                                    x1: v,
                                    y1: w
                                };
                                q || y ? (!q && l.connectNullData ? (d.setLineDash && (l.options.nullDataLineDashType || m === l.lineDashType && l.lineDashType !== l.nullDataLineDashType) && (d.stroke(),
                                    m = l.nullDataLineDashType, d.setLineDash(n)), d.lineTo(v, w), u && b.lineTo(v, w)) : (d.beginPath(), d.moveTo(v, w), u && (b.beginPath(), b.moveTo(v, w))), y = q = !1) : (d.lineTo(v, w), u && b.lineTo(v, w), 0 == s % 500 && (d.stroke(), d.beginPath(), d.moveTo(v, w), u && (b.stroke(), b.beginPath(), b.moveTo(v, w))));
                                s < k.length - 1 && (r !== (k[s].lineColor || e) || m !== (k[s].lineDashType || l.lineDashType)) && (d.stroke(), d.beginPath(), d.moveTo(v, w), r = k[s].lineColor || e, d.strokeStyle = r, d.setLineDash && (k[s].lineDashType ? (m = k[s].lineDashType, d.setLineDash(I(m,
                                    l.lineThickness))) : (m = l.lineDashType, d.setLineDash(p))));
                                if (0 < k[s].markerSize || 0 < l.markerSize) {
                                    var D = l.getMarkerProperties(s, v, w, d),
                                        f = D.color;
                                    c.push(D);
                                    t = G(t);
                                    u && c.push({
                                        x: v,
                                        y: w,
                                        ctx: b,
                                        type: D.type,
                                        size: D.size,
                                        color: t,
                                        borderColor: t,
                                        borderThickness: D.borderThickness
                                    })
                                }(k[s].indexLabel || l.indexLabel || k[s].indexLabelFormatter || l.indexLabelFormatter) && this._indexLabels.push({
                                    chartType: "line",
                                    dataPoint: k[s],
                                    dataSeries: l,
                                    point: {
                                        x: v,
                                        y: w
                                    },
                                    direction: 0 > k[s].y === a.axisY.reversed ? 1 : -1,
                                    color: e
                                })
                            }
                    d.stroke();
                    u && b.stroke()
                }
            }
            P.drawMarkers(c);
            l.markerColor = f;
            d.restore();
            d.beginPath();
            u && b.beginPath();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderStepLine = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = this._eventManager.ghostCtx;
            d.save();
            var c = this.plotArea;
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            for (var c = [], f = null, g = 0; g < a.dataSeriesIndexes.length; g++) {
                var h = a.dataSeriesIndexes[g],
                    l = this.data[h];
                d.lineWidth = l.lineThickness;
                var k = l.dataPoints,
                    m = "solid";
                if (d.setLineDash) {
                    var n = I(l.nullDataLineDashType, l.lineThickness),
                        m = l.lineDashType,
                        p = I(m, l.lineThickness);
                    d.setLineDash(p)
                }
                var e = l.id;
                this._eventManager.objectMap[e] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: h
                };
                e = G(e);
                b.strokeStyle = e;
                b.lineWidth = 0 < l.lineThickness ? Math.max(l.lineThickness, 4) : 0;
                var e = l._colorSet,
                    r = e = l.lineColor = l.options.lineColor ? l.options.lineColor : e[0];
                d.strokeStyle = e;
                var q = !0,
                    s = 0,
                    v, w;
                d.beginPath();
                if (0 < k.length) {
                    for (var y = !1, s = 0; s < k.length; s++)
                        if (v = k[s].getTime ? k[s].x.getTime() : k[s].x, !(v < a.axisX.dataInfo.viewPortMin || v > a.axisX.dataInfo.viewPortMax && (!l.connectNullData || !y)))
                            if ("number" !== typeof k[s].y) 0 < s && !(l.connectNullData || y || q) && (d.stroke(), u && b.stroke()), y = !0;
                            else {
                                var t = w;
                                v = a.axisX.convertValueToPixel(v);
                                w = a.axisY.convertValueToPixel(k[s].y);
                                var D = l.dataPointIds[s];
                                this._eventManager.objectMap[D] = {
                                    id: D,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: h,
                                    dataPointIndex: s,
                                    x1: v,
                                    y1: w
                                };
                                q || y ? (!q && l.connectNullData ? (d.setLineDash &&
                                    (l.options.nullDataLineDashType || m === l.lineDashType && l.lineDashType !== l.nullDataLineDashType) && (d.stroke(), m = l.nullDataLineDashType, d.setLineDash(n)), d.lineTo(v, t), d.lineTo(v, w), u && (b.lineTo(v, t), b.lineTo(v, w))) : (d.beginPath(), d.moveTo(v, w), u && (b.beginPath(), b.moveTo(v, w))), y = q = !1) : (d.lineTo(v, t), u && b.lineTo(v, t), d.lineTo(v, w), u && b.lineTo(v, w), 0 == s % 500 && (d.stroke(), d.beginPath(), d.moveTo(v, w), u && (b.stroke(), b.beginPath(), b.moveTo(v, w))));
                                s < k.length - 1 && (r !== (k[s].lineColor || e) || m !== (k[s].lineDashType ||
                                    l.lineDashType)) && (d.stroke(), d.beginPath(), d.moveTo(v, w), r = k[s].lineColor || e, d.strokeStyle = r, d.setLineDash && (k[s].lineDashType ? (m = k[s].lineDashType, d.setLineDash(I(m, l.lineThickness))) : (m = l.lineDashType, d.setLineDash(p))));
                                if (0 < k[s].markerSize || 0 < l.markerSize) t = l.getMarkerProperties(s, v, w, d), f = t.color, c.push(t), D = G(D), u && c.push({
                                    x: v,
                                    y: w,
                                    ctx: b,
                                    type: t.type,
                                    size: t.size,
                                    color: D,
                                    borderColor: D,
                                    borderThickness: t.borderThickness
                                });
                                (k[s].indexLabel || l.indexLabel || k[s].indexLabelFormatter || l.indexLabelFormatter) &&
                                this._indexLabels.push({
                                    chartType: "stepLine",
                                    dataPoint: k[s],
                                    dataSeries: l,
                                    point: {
                                        x: v,
                                        y: w
                                    },
                                    direction: 0 > k[s].y === a.axisY.reversed ? 1 : -1,
                                    color: e
                                })
                            }
                    d.stroke();
                    u && b.stroke()
                }
            }
            P.drawMarkers(c);
            l.markerColor = f;
            d.restore();
            d.beginPath();
            u && b.beginPath();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderSpline = function(a) {
        function d(a) {
            a = ua(a, 2);
            if (0 < a.length) {
                b.beginPath();
                u && c.beginPath();
                b.moveTo(a[0].x, a[0].y);
                a[0].newStrokeStyle &&
                    (b.strokeStyle = a[0].newStrokeStyle);
                a[0].newLineDashArray && b.setLineDash(a[0].newLineDashArray);
                u && c.moveTo(a[0].x, a[0].y);
                for (var d = 0; d < a.length - 3; d += 3)
                    if (b.bezierCurveTo(a[d + 1].x, a[d + 1].y, a[d + 2].x, a[d + 2].y, a[d + 3].x, a[d + 3].y), u && c.bezierCurveTo(a[d + 1].x, a[d + 1].y, a[d + 2].x, a[d + 2].y, a[d + 3].x, a[d + 3].y), 0 < d && 0 === d % 3E3 || a[d + 3].newStrokeStyle || a[d + 3].newLineDashArray) b.stroke(), b.beginPath(), b.moveTo(a[d + 3].x, a[d + 3].y), a[d + 3].newStrokeStyle && (b.strokeStyle = a[d + 3].newStrokeStyle), a[d + 3].newLineDashArray &&
                        b.setLineDash(a[d + 3].newLineDashArray), u && (c.stroke(), c.beginPath(), c.moveTo(a[d + 3].x, a[d + 3].y));
                b.stroke();
                u && c.stroke()
            }
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = this._eventManager.ghostCtx;
            b.save();
            var f = this.plotArea;
            b.beginPath();
            b.rect(f.x1, f.y1, f.width, f.height);
            b.clip();
            for (var f = [], g = null, h = 0; h < a.dataSeriesIndexes.length; h++) {
                var l = a.dataSeriesIndexes[h],
                    k = this.data[l];
                b.lineWidth = k.lineThickness;
                var m = k.dataPoints,
                    n = "solid";
                if (b.setLineDash) {
                    var p =
                        I(k.nullDataLineDashType, k.lineThickness),
                        n = k.lineDashType,
                        e = I(n, k.lineThickness);
                    b.setLineDash(e)
                }
                var r = k.id;
                this._eventManager.objectMap[r] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: l
                };
                r = G(r);
                c.strokeStyle = r;
                c.lineWidth = 0 < k.lineThickness ? Math.max(k.lineThickness, 4) : 0;
                var r = k._colorSet,
                    q = r = k.lineColor = k.options.lineColor ? k.options.lineColor : r[0];
                b.strokeStyle = r;
                var s = 0,
                    v, w, y = [];
                b.beginPath();
                if (0 < m.length)
                    for (w = !1, s = 0; s < m.length; s++)
                        if (v = m[s].getTime ? m[s].x.getTime() : m[s].x, !(v < a.axisX.dataInfo.viewPortMin ||
                                v > a.axisX.dataInfo.viewPortMax && (!k.connectNullData || !w)))
                            if ("number" !== typeof m[s].y) 0 < s && !w && (k.connectNullData ? b.setLineDash && (0 < y.length && (k.options.nullDataLineDashType || !m[s - 1].lineDashType)) && (y[y.length - 1].newLineDashArray = p, n = k.nullDataLineDashType) : (d(y), y = [])), w = !0;
                            else {
                                v = a.axisX.convertValueToPixel(v);
                                w = a.axisY.convertValueToPixel(m[s].y);
                                var t = k.dataPointIds[s];
                                this._eventManager.objectMap[t] = {
                                    id: t,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: l,
                                    dataPointIndex: s,
                                    x1: v,
                                    y1: w
                                };
                                y[y.length] = {
                                    x: v,
                                    y: w
                                };
                                s < m.length - 1 && (q !== (m[s].lineColor || r) || n !== (m[s].lineDashType || k.lineDashType)) && (q = m[s].lineColor || r, y[y.length - 1].newStrokeStyle = q, b.setLineDash && (m[s].lineDashType ? (n = m[s].lineDashType, y[y.length - 1].newLineDashArray = I(n, k.lineThickness)) : (n = k.lineDashType, y[y.length - 1].newLineDashArray = e)));
                                if (0 < m[s].markerSize || 0 < k.markerSize) {
                                    var D = k.getMarkerProperties(s, v, w, b),
                                        g = D.color;
                                    f.push(D);
                                    t = G(t);
                                    u && f.push({
                                        x: v,
                                        y: w,
                                        ctx: c,
                                        type: D.type,
                                        size: D.size,
                                        color: t,
                                        borderColor: t,
                                        borderThickness: D.borderThickness
                                    })
                                }(m[s].indexLabel ||
                                    k.indexLabel || m[s].indexLabelFormatter || k.indexLabelFormatter) && this._indexLabels.push({
                                    chartType: "spline",
                                    dataPoint: m[s],
                                    dataSeries: k,
                                    point: {
                                        x: v,
                                        y: w
                                    },
                                    direction: 0 > m[s].y === a.axisY.reversed ? 1 : -1,
                                    color: r
                                });
                                w = !1
                            }
                d(y)
            }
            P.drawMarkers(f);
            k.markerColor = g;
            b.restore();
            b.beginPath();
            u && c.beginPath();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    var N = function(a, d, b, c, f, g, h, l, k, m, n, p, e) {
        "undefined" === typeof e && (e = 1);
        h = h || 0;
        l = l || "black";
        var r = 15 < c - d && 15 < f - b ? 8 : 0.35 * Math.min(c - d, f - b);
        a.beginPath();
        a.moveTo(d, b);
        a.save();
        a.fillStyle = g;
        a.globalAlpha = e;
        a.fillRect(d, b, c - d, f - b);
        a.globalAlpha = 1;
        0 < h && (e = 0 === h % 2 ? 0 : 0.5, a.beginPath(), a.lineWidth = h, a.strokeStyle = l, a.moveTo(d, b), a.rect(d - e, b - e, c - d + 2 * e, f - b + 2 * e), a.stroke());
        a.restore();
        !0 === k && (a.save(), a.beginPath(), a.moveTo(d, b), a.lineTo(d + r, b + r), a.lineTo(c - r, b + r), a.lineTo(c, b), a.closePath(), h = a.createLinearGradient((c + d) / 2, b + r, (c + d) / 2, b), h.addColorStop(0, g), h.addColorStop(1, "rgba(255, 255, 255, .4)"),
            a.fillStyle = h, a.fill(), a.restore());
        !0 === m && (a.save(), a.beginPath(), a.moveTo(d, f), a.lineTo(d + r, f - r), a.lineTo(c - r, f - r), a.lineTo(c, f), a.closePath(), h = a.createLinearGradient((c + d) / 2, f - r, (c + d) / 2, f), h.addColorStop(0, g), h.addColorStop(1, "rgba(255, 255, 255, .4)"), a.fillStyle = h, a.fill(), a.restore());
        !0 === n && (a.save(), a.beginPath(), a.moveTo(d, b), a.lineTo(d + r, b + r), a.lineTo(d + r, f - r), a.lineTo(d, f), a.closePath(), h = a.createLinearGradient(d + r, (f + b) / 2, d, (f + b) / 2), h.addColorStop(0, g), h.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
            a.fillStyle = h, a.fill(), a.restore());
        !0 === p && (a.save(), a.beginPath(), a.moveTo(c, b), a.lineTo(c - r, b + r), a.lineTo(c - r, f - r), a.lineTo(c, f), h = a.createLinearGradient(c - r, (f + b) / 2, c, (f + b) / 2), h.addColorStop(0, g), h.addColorStop(1, "rgba(255, 255, 255, 0.1)"), a.fillStyle = h, h.addColorStop(0, g), h.addColorStop(1, "rgba(255, 255, 255, 0.1)"), a.fillStyle = h, a.fill(), a.closePath(), a.restore())
    };
    A.prototype.renderColumn = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = 0,
                g, h, l, k = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                f = this.dataPointMinWidth = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                m = this.dataPointMaxWidth = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.width, 0.9 * (this.plotArea.width / a.plotType.totalDataSeries)) << 0,
                n = a.axisX.dataInfo.minDiff;
            isFinite(n) || (n = 0.3 * Math.abs(a.axisX.range));
            n = this.dataPointWidth =
                this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.width * (a.axisX.logarithmic ? Math.log(n) / Math.log(a.axisX.range) : Math.abs(n) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;
            this.dataPointMaxWidth && f > m && (f = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, m));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && m < f) && (m = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, f));
            n < f && (n = f);
            n > m && (n = m);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width,
                c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (c = 0; c < a.dataSeriesIndexes.length; c++) {
                var m = a.dataSeriesIndexes[c],
                    p = this.data[m],
                    e = p.dataPoints;
                if (0 < e.length)
                    for (var r = 5 < n && p.bevelEnabled ? !0 : !1, f = 0; f < e.length; f++)
                        if (e[f].getTime ? l = e[f].x.getTime() : l = e[f].x, !(l < a.axisX.dataInfo.viewPortMin || l > a.axisX.dataInfo.viewPortMax) && "number" === typeof e[f].y) {
                            g = a.axisX.convertValueToPixel(l);
                            h =
                                a.axisY.convertValueToPixel(e[f].y);
                            g = a.axisX.reversed ? g + a.plotType.totalDataSeries * n / 2 - (a.previousDataSeriesCount + c) * n << 0 : g - a.plotType.totalDataSeries * n / 2 + (a.previousDataSeriesCount + c) * n << 0;
                            var q = a.axisX.reversed ? g - n << 0 : g + n << 0,
                                s;
                            0 <= e[f].y ? s = k : (s = h, h = k);
                            h > s && (b = h, h = s, s = b);
                            b = e[f].color ? e[f].color : p._colorSet[f % p._colorSet.length];
                            N(d, g, h, q, s, b, 0, null, r && 0 <= e[f].y, 0 > e[f].y && r, !1, !1, p.fillOpacity);
                            b = p.dataPointIds[f];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: m,
                                dataPointIndex: f,
                                x1: g,
                                y1: h,
                                x2: q,
                                y2: s
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, g, h, q, s, b, 0, null, !1, !1, !1, !1);
                            (e[f].indexLabel || p.indexLabel || e[f].indexLabelFormatter || p.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "column",
                                dataPoint: e[f],
                                dataSeries: p,
                                point: {
                                    x: g + (q - g) / 2,
                                    y: 0 > e[f].y === a.axisY.reversed ? h : s
                                },
                                direction: 0 > e[f].y === a.axisY.reversed ? 1 : -1,
                                bounds: {
                                    x1: g,
                                    y1: Math.min(h, s),
                                    x2: q,
                                    y2: Math.max(h, s)
                                },
                                color: b
                            })
                        }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            a = Math.min(k, a.axisY.bounds.y2);
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.yScaleAnimation,
                easingFunction: F.easing.easeOutQuart,
                animationBase: a
            }
        }
    };
    A.prototype.renderStackedColumn = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = [],
                g = [],
                h = [],
                l = 0,
                k, m = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                l = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                n = this.dataPointMaxWidth ? this.dataPointMaxWidth :
                this.dataPointWidth ? this.dataPointWidth : 0.15 * this.width << 0,
                p = a.axisX.dataInfo.minDiff;
            isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
            p = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.width * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;
            this.dataPointMaxWidth && l > n && (l = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, n));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && n < l) && (n = Math.max(this.dataPointWidth ? this.dataPointWidth :
                -Infinity, l));
            p < l && (p = l);
            p > n && (p = n);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (n = 0; n < a.dataSeriesIndexes.length; n++) {
                var e = a.dataSeriesIndexes[n],
                    r = this.data[e],
                    q = r.dataPoints;
                if (0 < q.length) {
                    var s = 5 < p && r.bevelEnabled ? !0 : !1;
                    d.strokeStyle = "#4572A7 ";
                    for (l = 0; l < q.length; l++)
                        if (b = q[l].x.getTime ? q[l].x.getTime() :
                            q[l].x, !(b < a.axisX.dataInfo.viewPortMin || b > a.axisX.dataInfo.viewPortMax) && "number" === typeof q[l].y) {
                            var c = a.axisX.convertValueToPixel(b),
                                v = c - a.plotType.plotUnits.length * p / 2 + a.index * p << 0,
                                w = v + p << 0,
                                y;
                            if (a.axisY.logarithmic) h[b] = q[l].y + (h[b] ? h[b] : 0), 0 < h[b] && (k = a.axisY.convertValueToPixel(h[b]), y = f[b] ? f[b] : m, f[b] = k);
                            else if (k = a.axisY.convertValueToPixel(q[l].y), 0 <= q[l].y) {
                                var t = f[b] ? f[b] : 0;
                                k -= t;
                                y = m - t;
                                f[b] = t + (y - k)
                            } else t = g[b] ? g[b] : 0, y = k + t, k = m + t, g[b] = t + (y - k);
                            b = q[l].color ? q[l].color : r._colorSet[l % r._colorSet.length];
                            N(d, v, k, w, y, b, 0, null, s && 0 <= q[l].y, 0 > q[l].y && s, !1, !1, r.fillOpacity);
                            b = r.dataPointIds[l];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: e,
                                dataPointIndex: l,
                                x1: v,
                                y1: k,
                                x2: w,
                                y2: y
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, v, k, w, y, b, 0, null, !1, !1, !1, !1);
                            (q[l].indexLabel || r.indexLabel || q[l].indexLabelFormatter || r.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "stackedColumn",
                                dataPoint: q[l],
                                dataSeries: r,
                                point: {
                                    x: c,
                                    y: 0 <= q[l].y ? k : y
                                },
                                direction: 0 > q[l].y === a.axisY.reversed ? 1 :
                                    -1,
                                bounds: {
                                    x1: v,
                                    y1: Math.min(k, y),
                                    x2: w,
                                    y2: Math.max(k, y)
                                },
                                color: b
                            })
                        }
                }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            a = Math.min(m, a.axisY.bounds.y2);
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.yScaleAnimation,
                easingFunction: F.easing.easeOutQuart,
                animationBase: a
            }
        }
    };
    A.prototype.renderStackedColumn100 = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = [],
                g = [],
                h = [],
                l = 0,
                k, m = a.axisY.convertValueToPixel(a.axisY.logarithmic ?
                    a.axisY.viewportMinimum : 0),
                l = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                n = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : 0.15 * this.width << 0,
                p = a.axisX.dataInfo.minDiff;
            isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
            p = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.width * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;
            this.dataPointMaxWidth &&
                l > n && (l = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, n));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && n < l) && (n = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, l));
            p < l && (p = l);
            p > n && (p = n);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (n = 0; n < a.dataSeriesIndexes.length; n++) {
                var e =
                    a.dataSeriesIndexes[n],
                    r = this.data[e],
                    q = r.dataPoints;
                if (0 < q.length)
                    for (var s = 5 < p && r.bevelEnabled ? !0 : !1, l = 0; l < q.length; l++)
                        if (b = q[l].x.getTime ? q[l].x.getTime() : q[l].x, !(b < a.axisX.dataInfo.viewPortMin || b > a.axisX.dataInfo.viewPortMax) && "number" === typeof q[l].y) {
                            c = a.axisX.convertValueToPixel(b);
                            k = 0 !== a.dataPointYSums[b] ? 100 * (q[l].y / a.dataPointYSums[b]) : 0;
                            var v = c - a.plotType.plotUnits.length * p / 2 + a.index * p << 0,
                                w = v + p << 0,
                                y;
                            if (a.axisY.logarithmic) {
                                h[b] = k + (h[b] ? h[b] : 0);
                                if (0 >= h[b]) continue;
                                k = a.axisY.convertValueToPixel(h[b]);
                                y = f[b] ? f[b] : m;
                                f[b] = k
                            } else if (k = a.axisY.convertValueToPixel(k), 0 <= q[l].y) {
                                var t = f[b] ? f[b] : 0;
                                k -= t;
                                y = m - t;
                                f[b] = t + (y - k)
                            } else t = g[b] ? g[b] : 0, y = k + t, k = m + t, g[b] = t + (y - k);
                            b = q[l].color ? q[l].color : r._colorSet[l % r._colorSet.length];
                            N(d, v, k, w, y, b, 0, null, s && 0 <= q[l].y, 0 > q[l].y && s, !1, !1, r.fillOpacity);
                            b = r.dataPointIds[l];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: e,
                                dataPointIndex: l,
                                x1: v,
                                y1: k,
                                x2: w,
                                y2: y
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, v, k, w, y, b, 0, null, !1, !1, !1, !1);
                            (q[l].indexLabel ||
                                r.indexLabel || q[l].indexLabelFormatter || r.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "stackedColumn100",
                                dataPoint: q[l],
                                dataSeries: r,
                                point: {
                                    x: c,
                                    y: 0 <= q[l].y ? k : y
                                },
                                direction: 0 > q[l].y === a.axisY.reversed ? 1 : -1,
                                bounds: {
                                    x1: v,
                                    y1: Math.min(k, y),
                                    x2: w,
                                    y2: Math.max(k, y)
                                },
                                color: b
                            })
                        }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            a = Math.min(m, a.axisY.bounds.y2);
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.yScaleAnimation,
                easingFunction: F.easing.easeOutQuart,
                animationBase: a
            }
        }
    };
    A.prototype.renderBar =
        function(a) {
            var d = a.targetCanvasCtx || this.plotArea.ctx;
            if (!(0 >= a.dataSeriesIndexes.length)) {
                var b = null,
                    c = this.plotArea,
                    f = 0,
                    g, h, l, k = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                    f = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                    m = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / a.plotType.totalDataSeries)) << 0,
                    n = a.axisX.dataInfo.minDiff;
                isFinite(n) ||
                    (n = 0.3 * Math.abs(a.axisX.range));
                n = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.height * (a.axisX.logarithmic ? Math.log(n) / Math.log(a.axisX.range) : Math.abs(n) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;
                this.dataPointMaxWidth && f > m && (f = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, m));
                !this.dataPointMaxWidth && (this.dataPointMinWidth && m < f) && (m = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, f));
                n < f && (n = f);
                n > m && (n = m);
                d.save();
                u && this._eventManager.ghostCtx.save();
                d.beginPath();
                d.rect(c.x1, c.y1, c.width, c.height);
                d.clip();
                u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
                for (c = 0; c < a.dataSeriesIndexes.length; c++) {
                    var m = a.dataSeriesIndexes[c],
                        p = this.data[m],
                        e = p.dataPoints;
                    if (0 < e.length) {
                        var r = 5 < n && p.bevelEnabled ? !0 : !1;
                        d.strokeStyle = "#4572A7 ";
                        for (f = 0; f < e.length; f++)
                            if (e[f].getTime ? l = e[f].x.getTime() : l = e[f].x, !(l < a.axisX.dataInfo.viewPortMin || l > a.axisX.dataInfo.viewPortMax) && "number" ===
                                typeof e[f].y) {
                                h = a.axisX.convertValueToPixel(l);
                                g = a.axisY.convertValueToPixel(e[f].y);
                                h = a.axisX.reversed ? h + a.plotType.totalDataSeries * n / 2 - (a.previousDataSeriesCount + c) * n << 0 : h - a.plotType.totalDataSeries * n / 2 + (a.previousDataSeriesCount + c) * n << 0;
                                var q = a.axisX.reversed ? h - n << 0 : h + n << 0,
                                    s;
                                0 <= e[f].y ? s = k : (s = g, g = k);
                                b = e[f].color ? e[f].color : p._colorSet[f % p._colorSet.length];
                                N(d, s, h, g, q, b, 0, null, r, !1, !1, !1, p.fillOpacity);
                                b = p.dataPointIds[f];
                                this._eventManager.objectMap[b] = {
                                    id: b,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: m,
                                    dataPointIndex: f,
                                    x1: s,
                                    y1: h,
                                    x2: g,
                                    y2: q
                                };
                                b = G(b);
                                u && N(this._eventManager.ghostCtx, s, h, g, q, b, 0, null, !1, !1, !1, !1);
                                (e[f].indexLabel || p.indexLabel || e[f].indexLabelFormatter || p.indexLabelFormatter) && this._indexLabels.push({
                                    chartType: "bar",
                                    dataPoint: e[f],
                                    dataSeries: p,
                                    point: {
                                        x: 0 <= e[f].y ? g : s,
                                        y: h + (q - h) / 2
                                    },
                                    direction: 0 > e[f].y === a.axisY.reversed ? 1 : -1,
                                    bounds: {
                                        x1: Math.min(s, g),
                                        y1: h,
                                        x2: Math.max(s, g),
                                        y2: q
                                    },
                                    color: b
                                })
                            }
                    }
                }
                d.restore();
                u && this._eventManager.ghostCtx.restore();
                a = Math.max(k, a.axisX.bounds.x2);
                return {
                    source: d,
                    dest: this.plotArea.ctx,
                    animationCallback: F.xScaleAnimation,
                    easingFunction: F.easing.easeOutQuart,
                    animationBase: a
                }
            }
        };
    A.prototype.renderStackedBar = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = [],
                g = [],
                h = [],
                l = 0,
                k, m = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                l = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                n = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ?
                this.dataPointWidth : 0.15 * this.height << 0,
                p = a.axisX.dataInfo.minDiff;
            isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
            p = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.height * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;
            this.dataPointMaxWidth && l > n && (l = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, n));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && n < l) && (n = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity,
                l));
            p < l && (p = l);
            p > n && (p = n);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (n = 0; n < a.dataSeriesIndexes.length; n++) {
                var e = a.dataSeriesIndexes[n],
                    r = this.data[e],
                    q = r.dataPoints;
                if (0 < q.length) {
                    var s = 5 < p && r.bevelEnabled ? !0 : !1;
                    d.strokeStyle = "#4572A7 ";
                    for (l = 0; l < q.length; l++)
                        if (b = q[l].x.getTime ? q[l].x.getTime() :
                            q[l].x, !(b < a.axisX.dataInfo.viewPortMin || b > a.axisX.dataInfo.viewPortMax) && "number" === typeof q[l].y) {
                            var c = a.axisX.convertValueToPixel(b),
                                v = c - a.plotType.plotUnits.length * p / 2 + a.index * p << 0,
                                w = v + p << 0,
                                y;
                            if (a.axisY.logarithmic) h[b] = q[l].y + (h[b] ? h[b] : 0), 0 < h[b] && (y = f[b] ? f[b] : m, f[b] = k = a.axisY.convertValueToPixel(h[b]));
                            else if (k = a.axisY.convertValueToPixel(q[l].y), 0 <= q[l].y) {
                                var t = f[b] ? f[b] : 0;
                                y = m + t;
                                k += t;
                                f[b] = t + (k - y)
                            } else t = g[b] ? g[b] : 0, y = k - t, k = m - t, g[b] = t + (k - y);
                            b = q[l].color ? q[l].color : r._colorSet[l % r._colorSet.length];
                            N(d, y, v, k, w, b, 0, null, s, !1, !1, !1, r.fillOpacity);
                            b = r.dataPointIds[l];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: e,
                                dataPointIndex: l,
                                x1: y,
                                y1: v,
                                x2: k,
                                y2: w
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, y, v, k, w, b, 0, null, !1, !1, !1, !1);
                            (q[l].indexLabel || r.indexLabel || q[l].indexLabelFormatter || r.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "stackedBar",
                                dataPoint: q[l],
                                dataSeries: r,
                                point: {
                                    x: 0 <= q[l].y ? k : y,
                                    y: c
                                },
                                direction: 0 > q[l].y === a.axisY.reversed ? 1 : -1,
                                bounds: {
                                    x1: Math.min(y,
                                        k),
                                    y1: v,
                                    x2: Math.max(y, k),
                                    y2: w
                                },
                                color: b
                            })
                        }
                }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            a = Math.max(m, a.axisX.bounds.x2);
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.xScaleAnimation,
                easingFunction: F.easing.easeOutQuart,
                animationBase: a
            }
        }
    };
    A.prototype.renderStackedBar100 = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = [],
                g = [],
                h = [],
                l = 0,
                k, m = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum :
                    0),
                l = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1,
                n = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : 0.15 * this.height << 0,
                p = a.axisX.dataInfo.minDiff;
            isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
            p = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.height * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) / a.plotType.plotUnits.length) << 0;
            this.dataPointMaxWidth && l > n && (l = Math.min(this.dataPointWidth ?
                this.dataPointWidth : Infinity, n));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && n < l) && (n = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, l));
            p < l && (p = l);
            p > n && (p = n);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (n = 0; n < a.dataSeriesIndexes.length; n++) {
                var e = a.dataSeriesIndexes[n],
                    r = this.data[e],
                    q = r.dataPoints;
                if (0 < q.length) {
                    var s = 5 < p && r.bevelEnabled ? !0 : !1;
                    d.strokeStyle = "#4572A7 ";
                    for (l = 0; l < q.length; l++)
                        if (b = q[l].x.getTime ? q[l].x.getTime() : q[l].x, !(b < a.axisX.dataInfo.viewPortMin || b > a.axisX.dataInfo.viewPortMax) && "number" === typeof q[l].y) {
                            var c = a.axisX.convertValueToPixel(b),
                                v;
                            v = 0 !== a.dataPointYSums[b] ? 100 * (q[l].y / a.dataPointYSums[b]) : 0;
                            var w = c - a.plotType.plotUnits.length * p / 2 + a.index * p << 0,
                                y = w + p << 0;
                            if (a.axisY.logarithmic) {
                                h[b] = v + (h[b] ? h[b] : 0);
                                if (0 >= h[b]) continue;
                                v = f[b] ? f[b] : m;
                                f[b] = k = a.axisY.convertValueToPixel(h[b])
                            } else if (k =
                                a.axisY.convertValueToPixel(v), 0 <= q[l].y) {
                                var t = f[b] ? f[b] : 0;
                                v = m + t;
                                k += t;
                                f[b] = t + (k - v)
                            } else t = g[b] ? g[b] : 0, v = k - t, k = m - t, g[b] = t + (k - v);
                            b = q[l].color ? q[l].color : r._colorSet[l % r._colorSet.length];
                            N(d, v, w, k, y, b, 0, null, s, !1, !1, !1, r.fillOpacity);
                            b = r.dataPointIds[l];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: e,
                                dataPointIndex: l,
                                x1: v,
                                y1: w,
                                x2: k,
                                y2: y
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, v, w, k, y, b, 0, null, !1, !1, !1, !1);
                            (q[l].indexLabel || r.indexLabel || q[l].indexLabelFormatter || r.indexLabelFormatter) &&
                            this._indexLabels.push({
                                chartType: "stackedBar100",
                                dataPoint: q[l],
                                dataSeries: r,
                                point: {
                                    x: 0 <= q[l].y ? k : v,
                                    y: c
                                },
                                direction: 0 > q[l].y === a.axisY.reversed ? 1 : -1,
                                bounds: {
                                    x1: Math.min(v, k),
                                    y1: w,
                                    x2: Math.max(v, k),
                                    y2: y
                                },
                                color: b
                            })
                        }
                }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            a = Math.max(m, a.axisX.bounds.x2);
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.xScaleAnimation,
                easingFunction: F.easing.easeOutQuart,
                animationBase: a
            }
        }
    };
    A.prototype.renderArea = function(a) {
        function d() {
            t && (0 < n.lineThickness &&
                b.stroke(), a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? y = w : 0 > a.axisY.viewportMaximum ? y = g.y1 : 0 < a.axisY.viewportMinimum && (y = f.y2), b.lineTo(q, y), b.lineTo(t.x, y), b.closePath(), b.globalAlpha = n.fillOpacity, b.fill(), b.globalAlpha = 1, u && (c.lineTo(q, y), c.lineTo(t.x, y), c.closePath(), c.fill()), b.beginPath(), b.moveTo(q, s), c.beginPath(), c.moveTo(q, s), t = {
                    x: q,
                    y: s
                })
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = this._eventManager.ghostCtx,
                f = a.axisX.lineCoordinates,
                g = a.axisY.lineCoordinates,
                h = [],
                l = null,
                k = this.plotArea;
            b.save();
            u && c.save();
            b.beginPath();
            b.rect(k.x1, k.y1, k.width, k.height);
            b.clip();
            u && (c.beginPath(), c.rect(k.x1, k.y1, k.width, k.height), c.clip());
            for (k = 0; k < a.dataSeriesIndexes.length; k++) {
                var m = a.dataSeriesIndexes[k],
                    n = this.data[m],
                    p = n.dataPoints,
                    h = n.id;
                this._eventManager.objectMap[h] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: m
                };
                h = G(h);
                c.fillStyle = h;
                var h = [],
                    e = !0,
                    r = 0,
                    q, s, v, w = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                    y, t = null;
                if (0 < p.length) {
                    var D = n._colorSet[r % n._colorSet.length],
                        x = n.lineColor = n.options.lineColor || D,
                        aa = x;
                    b.fillStyle = D;
                    b.strokeStyle = x;
                    b.lineWidth = n.lineThickness;
                    var z = "solid";
                    if (b.setLineDash) {
                        var A = I(n.nullDataLineDashType, n.lineThickness),
                            z = n.lineDashType,
                            R = I(z, n.lineThickness);
                        b.setLineDash(R)
                    }
                    for (var J = !0; r < p.length; r++)
                        if (v = p[r].x.getTime ? p[r].x.getTime() : p[r].x, !(v < a.axisX.dataInfo.viewPortMin || v > a.axisX.dataInfo.viewPortMax && (!n.connectNullData || !J)))
                            if ("number" !== typeof p[r].y) n.connectNullData ||
                                (J || e) || d(), J = !0;
                            else {
                                q = a.axisX.convertValueToPixel(v);
                                s = a.axisY.convertValueToPixel(p[r].y);
                                e || J ? (!e && n.connectNullData ? (b.setLineDash && (n.options.nullDataLineDashType || z === n.lineDashType && n.lineDashType !== n.nullDataLineDashType) && (b.stroke(), z = n.nullDataLineDashType, b.setLineDash(A)), b.lineTo(q, s), u && c.lineTo(q, s)) : (b.beginPath(), b.moveTo(q, s), u && (c.beginPath(), c.moveTo(q, s)), t = {
                                    x: q,
                                    y: s
                                }), J = e = !1) : (b.lineTo(q, s), u && c.lineTo(q, s), 0 == r % 250 && d());
                                r < p.length - 1 && (aa !== (p[r].lineColor || x) || z !== (p[r].lineDashType ||
                                    n.lineDashType)) && (d(), aa = p[r].lineColor || x, b.strokeStyle = aa, b.setLineDash && (p[r].lineDashType ? (z = p[r].lineDashType, b.setLineDash(I(z, n.lineThickness))) : (z = n.lineDashType, b.setLineDash(R))));
                                var H = n.dataPointIds[r];
                                this._eventManager.objectMap[H] = {
                                    id: H,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: m,
                                    dataPointIndex: r,
                                    x1: q,
                                    y1: s
                                };
                                0 !== p[r].markerSize && (0 < p[r].markerSize || 0 < n.markerSize) && (v = n.getMarkerProperties(r, q, s, b), l = v.color, h.push(v), H = G(H), u && h.push({
                                    x: q,
                                    y: s,
                                    ctx: c,
                                    type: v.type,
                                    size: v.size,
                                    color: H,
                                    borderColor: H,
                                    borderThickness: v.borderThickness
                                }));
                                (p[r].indexLabel || n.indexLabel || p[r].indexLabelFormatter || n.indexLabelFormatter) && this._indexLabels.push({
                                    chartType: "area",
                                    dataPoint: p[r],
                                    dataSeries: n,
                                    point: {
                                        x: q,
                                        y: s
                                    },
                                    direction: 0 > p[r].y === a.axisY.reversed ? 1 : -1,
                                    color: D
                                })
                            }
                    d();
                    P.drawMarkers(h);
                    n.markerColor = l
                }
            }
            b.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderSplineArea =
        function(a) {
            function d() {
                var d = ua(y, 2);
                if (0 < d.length) {
                    if (0 < n.lineThickness) {
                        b.beginPath();
                        b.moveTo(d[0].x, d[0].y);
                        d[0].newStrokeStyle && (b.strokeStyle = d[0].newStrokeStyle);
                        d[0].newLineDashArray && b.setLineDash(d[0].newLineDashArray);
                        for (var e = 0; e < d.length - 3; e += 3)
                            if (b.bezierCurveTo(d[e + 1].x, d[e + 1].y, d[e + 2].x, d[e + 2].y, d[e + 3].x, d[e + 3].y), u && c.bezierCurveTo(d[e + 1].x, d[e + 1].y, d[e + 2].x, d[e + 2].y, d[e + 3].x, d[e + 3].y), d[e + 3].newStrokeStyle || d[e + 3].newLineDashArray) b.stroke(), b.beginPath(), b.moveTo(d[e + 3].x, d[e +
                                3].y), d[e + 3].newStrokeStyle && (b.strokeStyle = d[e + 3].newStrokeStyle), d[e + 3].newLineDashArray && b.setLineDash(d[e + 3].newLineDashArray);
                        b.stroke()
                    }
                    b.beginPath();
                    b.moveTo(d[0].x, d[0].y);
                    u && (c.beginPath(), c.moveTo(d[0].x, d[0].y));
                    for (e = 0; e < d.length - 3; e += 3) b.bezierCurveTo(d[e + 1].x, d[e + 1].y, d[e + 2].x, d[e + 2].y, d[e + 3].x, d[e + 3].y), u && c.bezierCurveTo(d[e + 1].x, d[e + 1].y, d[e + 2].x, d[e + 2].y, d[e + 3].x, d[e + 3].y);
                    a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? v = s : 0 > a.axisY.viewportMaximum ? v =
                        g.y1 : 0 < a.axisY.viewportMinimum && (v = f.y2);
                    w = {
                        x: d[0].x,
                        y: d[0].y
                    };
                    b.lineTo(d[d.length - 1].x, v);
                    b.lineTo(w.x, v);
                    b.closePath();
                    b.globalAlpha = n.fillOpacity;
                    b.fill();
                    b.globalAlpha = 1;
                    u && (c.lineTo(d[d.length - 1].x, v), c.lineTo(w.x, v), c.closePath(), c.fill())
                }
            }
            var b = a.targetCanvasCtx || this.plotArea.ctx;
            if (!(0 >= a.dataSeriesIndexes.length)) {
                var c = this._eventManager.ghostCtx,
                    f = a.axisX.lineCoordinates,
                    g = a.axisY.lineCoordinates,
                    h = [],
                    l = null,
                    k = this.plotArea;
                b.save();
                u && c.save();
                b.beginPath();
                b.rect(k.x1, k.y1, k.width,
                    k.height);
                b.clip();
                u && (c.beginPath(), c.rect(k.x1, k.y1, k.width, k.height), c.clip());
                for (k = 0; k < a.dataSeriesIndexes.length; k++) {
                    var m = a.dataSeriesIndexes[k],
                        n = this.data[m],
                        p = n.dataPoints,
                        h = n.id;
                    this._eventManager.objectMap[h] = {
                        objectType: "dataSeries",
                        dataSeriesIndex: m
                    };
                    h = G(h);
                    c.fillStyle = h;
                    var h = [],
                        e = 0,
                        r, q, s = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                        v, w = null,
                        y = [];
                    if (0 < p.length) {
                        var t = n._colorSet[e % n._colorSet.length],
                            D = n.lineColor = n.options.lineColor || t,
                            x = D;
                        b.fillStyle =
                            t;
                        b.strokeStyle = D;
                        b.lineWidth = n.lineThickness;
                        var z = "solid";
                        if (b.setLineDash) {
                            var A = I(n.nullDataLineDashType, n.lineThickness),
                                z = n.lineDashType,
                                B = I(z, n.lineThickness);
                            b.setLineDash(B)
                        }
                        for (q = !1; e < p.length; e++)
                            if (r = p[e].x.getTime ? p[e].x.getTime() : p[e].x, !(r < a.axisX.dataInfo.viewPortMin || r > a.axisX.dataInfo.viewPortMax && (!n.connectNullData || !q)))
                                if ("number" !== typeof p[e].y) 0 < e && !q && (n.connectNullData ? b.setLineDash && (0 < y.length && (n.options.nullDataLineDashType || !p[e - 1].lineDashType)) && (y[y.length - 1].newLineDashArray =
                                    A, z = n.nullDataLineDashType) : (d(), y = [])), q = !0;
                                else {
                                    r = a.axisX.convertValueToPixel(r);
                                    q = a.axisY.convertValueToPixel(p[e].y);
                                    var R = n.dataPointIds[e];
                                    this._eventManager.objectMap[R] = {
                                        id: R,
                                        objectType: "dataPoint",
                                        dataSeriesIndex: m,
                                        dataPointIndex: e,
                                        x1: r,
                                        y1: q
                                    };
                                    y[y.length] = {
                                        x: r,
                                        y: q
                                    };
                                    e < p.length - 1 && (x !== (p[e].lineColor || D) || z !== (p[e].lineDashType || n.lineDashType)) && (x = p[e].lineColor || D, y[y.length - 1].newStrokeStyle = x, b.setLineDash && (p[e].lineDashType ? (z = p[e].lineDashType, y[y.length - 1].newLineDashArray = I(z, n.lineThickness)) :
                                        (z = n.lineDashType, y[y.length - 1].newLineDashArray = B)));
                                    if (0 !== p[e].markerSize && (0 < p[e].markerSize || 0 < n.markerSize)) {
                                        var J = n.getMarkerProperties(e, r, q, b),
                                            l = J.color;
                                        h.push(J);
                                        R = G(R);
                                        u && h.push({
                                            x: r,
                                            y: q,
                                            ctx: c,
                                            type: J.type,
                                            size: J.size,
                                            color: R,
                                            borderColor: R,
                                            borderThickness: J.borderThickness
                                        })
                                    }(p[e].indexLabel || n.indexLabel || p[e].indexLabelFormatter || n.indexLabelFormatter) && this._indexLabels.push({
                                        chartType: "splineArea",
                                        dataPoint: p[e],
                                        dataSeries: n,
                                        point: {
                                            x: r,
                                            y: q
                                        },
                                        direction: 0 > p[e].y === a.axisY.reversed ? 1 : -1,
                                        color: t
                                    });
                                    q = !1
                                }
                        d();
                        P.drawMarkers(h);
                        n.markerColor = l
                    }
                }
                b.restore();
                u && this._eventManager.ghostCtx.restore();
                return {
                    source: b,
                    dest: this.plotArea.ctx,
                    animationCallback: F.xClipAnimation,
                    easingFunction: F.easing.linear,
                    animationBase: 0
                }
            }
        };
    A.prototype.renderStepArea = function(a) {
        function d() {
            t && (0 < n.lineThickness && b.stroke(), a.axisY.logarithmic || 0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum ? y = w : 0 > a.axisY.viewportMaximum ? y = g.y1 : 0 < a.axisY.viewportMinimum && (y = f.y2), b.lineTo(q, y), b.lineTo(t.x, y), b.closePath(),
                b.globalAlpha = n.fillOpacity, b.fill(), b.globalAlpha = 1, u && (c.lineTo(q, y), c.lineTo(t.x, y), c.closePath(), c.fill()), b.beginPath(), b.moveTo(q, s), c.beginPath(), c.moveTo(q, s), t = {
                    x: q,
                    y: s
                })
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = this._eventManager.ghostCtx,
                f = a.axisX.lineCoordinates,
                g = a.axisY.lineCoordinates,
                h = [],
                l = null,
                k = this.plotArea;
            b.save();
            u && c.save();
            b.beginPath();
            b.rect(k.x1, k.y1, k.width, k.height);
            b.clip();
            u && (c.beginPath(), c.rect(k.x1, k.y1, k.width, k.height),
                c.clip());
            for (k = 0; k < a.dataSeriesIndexes.length; k++) {
                var m = a.dataSeriesIndexes[k],
                    n = this.data[m],
                    p = n.dataPoints,
                    h = n.id;
                this._eventManager.objectMap[h] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: m
                };
                h = G(h);
                c.fillStyle = h;
                var h = [],
                    e = !0,
                    r = 0,
                    q, s, v, w = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                    y, t = null,
                    D = !1;
                if (0 < p.length) {
                    var x = n._colorSet[r % n._colorSet.length],
                        z = n.lineColor = n.options.lineColor || x,
                        A = z;
                    b.fillStyle = x;
                    b.strokeStyle = z;
                    b.lineWidth = n.lineThickness;
                    var B = "solid";
                    if (b.setLineDash) {
                        var R =
                            I(n.nullDataLineDashType, n.lineThickness),
                            B = n.lineDashType,
                            J = I(B, n.lineThickness);
                        b.setLineDash(J)
                    }
                    for (; r < p.length; r++)
                        if (v = p[r].x.getTime ? p[r].x.getTime() : p[r].x, !(v < a.axisX.dataInfo.viewPortMin || v > a.axisX.dataInfo.viewPortMax && (!n.connectNullData || !D))) {
                            var H = s;
                            "number" !== typeof p[r].y ? (n.connectNullData || (D || e) || d(), D = !0) : (q = a.axisX.convertValueToPixel(v), s = a.axisY.convertValueToPixel(p[r].y), e || D ? (!e && n.connectNullData ? (b.setLineDash && (n.options.nullDataLineDashType || B === n.lineDashType && n.lineDashType !==
                                n.nullDataLineDashType) && (b.stroke(), B = n.nullDataLineDashType, b.setLineDash(R)), b.lineTo(q, H), b.lineTo(q, s), u && (c.lineTo(q, H), c.lineTo(q, s))) : (b.beginPath(), b.moveTo(q, s), u && (c.beginPath(), c.moveTo(q, s)), t = {
                                x: q,
                                y: s
                            }), D = e = !1) : (b.lineTo(q, H), u && c.lineTo(q, H), b.lineTo(q, s), u && c.lineTo(q, s), 0 == r % 250 && d()), r < p.length - 1 && (A !== (p[r].lineColor || z) || B !== (p[r].lineDashType || n.lineDashType)) && (d(), A = p[r].lineColor || z, b.strokeStyle = A, b.setLineDash && (p[r].lineDashType ? (B = p[r].lineDashType, b.setLineDash(I(B, n.lineThickness))) :
                                (B = n.lineDashType, b.setLineDash(J)))), H = n.dataPointIds[r], this._eventManager.objectMap[H] = {
                                id: H,
                                objectType: "dataPoint",
                                dataSeriesIndex: m,
                                dataPointIndex: r,
                                x1: q,
                                y1: s
                            }, 0 !== p[r].markerSize && (0 < p[r].markerSize || 0 < n.markerSize) && (v = n.getMarkerProperties(r, q, s, b), l = v.color, h.push(v), H = G(H), u && h.push({
                                x: q,
                                y: s,
                                ctx: c,
                                type: v.type,
                                size: v.size,
                                color: H,
                                borderColor: H,
                                borderThickness: v.borderThickness
                            })), (p[r].indexLabel || n.indexLabel || p[r].indexLabelFormatter || n.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "stepArea",
                                dataPoint: p[r],
                                dataSeries: n,
                                point: {
                                    x: q,
                                    y: s
                                },
                                direction: 0 > p[r].y === a.axisY.reversed ? 1 : -1,
                                color: x
                            }))
                        }
                    d();
                    P.drawMarkers(h);
                    n.markerColor = l
                }
            }
            b.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderStackedArea = function(a) {
        function d() {
            if (!(1 > k.length)) {
                for (0 < t.lineThickness && b.stroke(); 0 < k.length;) {
                    var a = k.pop();
                    b.lineTo(a.x, a.y);
                    u && v.lineTo(a.x, a.y)
                }
                b.closePath();
                b.globalAlpha =
                    t.fillOpacity;
                b.fill();
                b.globalAlpha = 1;
                b.beginPath();
                u && (v.closePath(), v.fill(), v.beginPath());
                k = []
            }
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = null,
                f = [],
                g = null,
                h = this.plotArea,
                l = [],
                k = [],
                m = [],
                n = [],
                p = 0,
                e, r, q, s = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                v = this._eventManager.ghostCtx;
            u && v.beginPath();
            b.save();
            u && v.save();
            b.beginPath();
            b.rect(h.x1, h.y1, h.width, h.height);
            b.clip();
            u && (v.beginPath(), v.rect(h.x1, h.y1, h.width, h.height),
                v.clip());
            for (var w = [], h = 0; h < a.dataSeriesIndexes.length; h++) {
                var y = a.dataSeriesIndexes[h],
                    t = this.data[y],
                    D = t.dataPoints;
                t.dataPointIndexes = [];
                for (p = 0; p < D.length; p++) y = D[p].x.getTime ? D[p].x.getTime() : D[p].x, t.dataPointIndexes[y] = p, w[y] || (m.push(y), w[y] = !0);
                m.sort(ya)
            }
            for (h = 0; h < a.dataSeriesIndexes.length; h++) {
                y = a.dataSeriesIndexes[h];
                t = this.data[y];
                D = t.dataPoints;
                w = !0;
                k = [];
                p = t.id;
                this._eventManager.objectMap[p] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: y
                };
                p = G(p);
                v.fillStyle = p;
                if (0 < m.length) {
                    var c = t._colorSet[0],
                        x = t.lineColor = t.options.lineColor || c,
                        z = x;
                    b.fillStyle = c;
                    b.strokeStyle = x;
                    b.lineWidth = t.lineThickness;
                    var A = "solid";
                    if (b.setLineDash) {
                        var B = I(t.nullDataLineDashType, t.lineThickness),
                            A = t.lineDashType,
                            R = I(A, t.lineThickness);
                        b.setLineDash(R)
                    }
                    for (var J = !0, p = 0; p < m.length; p++) {
                        q = m[p];
                        var H = null,
                            H = 0 <= t.dataPointIndexes[q] ? D[t.dataPointIndexes[q]] : {
                                x: q,
                                y: null
                            };
                        if (!(q < a.axisX.dataInfo.viewPortMin || q > a.axisX.dataInfo.viewPortMax && (!t.connectNullData || !J)))
                            if ("number" !== typeof H.y) t.connectNullData || (J || w) || d(),
                                J = !0;
                            else {
                                e = a.axisX.convertValueToPixel(q);
                                var ea = l[q] ? l[q] : 0;
                                if (a.axisY.logarithmic) {
                                    n[q] = H.y + (n[q] ? n[q] : 0);
                                    if (0 >= n[q]) continue;
                                    r = a.axisY.convertValueToPixel(n[q])
                                } else r = a.axisY.convertValueToPixel(H.y), r -= ea;
                                k.push({
                                    x: e,
                                    y: s - ea
                                });
                                l[q] = s - r;
                                w || J ? (!w && t.connectNullData ? (b.setLineDash && (t.options.nullDataLineDashType || A === t.lineDashType && t.lineDashType !== t.nullDataLineDashType) && (b.stroke(), A = t.nullDataLineDashType, b.setLineDash(B)), b.lineTo(e, r), u && v.lineTo(e, r)) : (b.beginPath(), b.moveTo(e, r), u && (v.beginPath(),
                                    v.moveTo(e, r))), J = w = !1) : (b.lineTo(e, r), u && v.lineTo(e, r), 0 == p % 250 && (d(), b.moveTo(e, r), u && v.moveTo(e, r), k.push({
                                    x: e,
                                    y: s - ea
                                })));
                                p < D.length - 1 && (z !== (D[p].lineColor || x) || A !== (D[p].lineDashType || t.lineDashType)) && (d(), b.beginPath(), b.moveTo(e, r), k.push({
                                    x: e,
                                    y: s - ea
                                }), z = D[p].lineColor || x, b.strokeStyle = z, b.setLineDash && (D[p].lineDashType ? (A = D[p].lineDashType, b.setLineDash(I(A, t.lineThickness))) : (A = t.lineDashType, b.setLineDash(R))));
                                if (0 <= t.dataPointIndexes[q]) {
                                    var fa = t.dataPointIds[t.dataPointIndexes[q]];
                                    this._eventManager.objectMap[fa] = {
                                        id: fa,
                                        objectType: "dataPoint",
                                        dataSeriesIndex: y,
                                        dataPointIndex: t.dataPointIndexes[q],
                                        x1: e,
                                        y1: r
                                    }
                                }
                                0 <= t.dataPointIndexes[q] && 0 !== H.markerSize && (0 < H.markerSize || 0 < t.markerSize) && (q = t.getMarkerProperties(t.dataPointIndexes[q], e, r, b), g = q.color, f.push(q), markerColor = G(fa), u && f.push({
                                    x: e,
                                    y: r,
                                    ctx: v,
                                    type: q.type,
                                    size: q.size,
                                    color: markerColor,
                                    borderColor: markerColor,
                                    borderThickness: q.borderThickness
                                }));
                                (H.indexLabel || t.indexLabel || H.indexLabelFormatter || t.indexLabelFormatter) &&
                                this._indexLabels.push({
                                    chartType: "stackedArea",
                                    dataPoint: H,
                                    dataSeries: t,
                                    point: {
                                        x: e,
                                        y: r
                                    },
                                    direction: 0 > D[p].y === a.axisY.reversed ? 1 : -1,
                                    color: c
                                })
                            }
                    }
                    d();
                    b.moveTo(e, r);
                    u && v.moveTo(e, r)
                }
                delete t.dataPointIndexes;
                t.markerColor = g
            }
            P.drawMarkers(f);
            b.restore();
            u && v.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderStackedArea100 = function(a) {
        function d() {
            for (0 < t.lineThickness && b.stroke(); 0 < k.length;) {
                var a = k.pop();
                b.lineTo(a.x, a.y);
                u && v.lineTo(a.x, a.y)
            }
            b.closePath();
            b.globalAlpha = t.fillOpacity;
            b.fill();
            b.globalAlpha = 1;
            b.beginPath();
            u && (v.closePath(), v.fill(), v.beginPath());
            k = []
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = null,
                f = this.plotArea,
                g = [],
                h = null,
                l = [],
                k = [],
                m = [],
                n = [],
                p = 0,
                e, r, q, s = a.axisY.convertValueToPixel(a.axisY.logarithmic ? a.axisY.viewportMinimum : 0),
                v = this._eventManager.ghostCtx;
            b.save();
            u && v.save();
            b.beginPath();
            b.rect(f.x1, f.y1, f.width, f.height);
            b.clip();
            u && (v.beginPath(), v.rect(f.x1, f.y1, f.width, f.height), v.clip());
            for (var w = [], f = 0; f < a.dataSeriesIndexes.length; f++) {
                var y = a.dataSeriesIndexes[f],
                    t = this.data[y],
                    x = t.dataPoints;
                t.dataPointIndexes = [];
                for (p = 0; p < x.length; p++) y = x[p].x.getTime ? x[p].x.getTime() : x[p].x, t.dataPointIndexes[y] = p, w[y] || (m.push(y), w[y] = !0);
                m.sort(ya)
            }
            for (f = 0; f < a.dataSeriesIndexes.length; f++) {
                y = a.dataSeriesIndexes[f];
                t = this.data[y];
                x = t.dataPoints;
                w = !0;
                c = t.id;
                this._eventManager.objectMap[c] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: y
                };
                c = G(c);
                v.fillStyle = c;
                k = [];
                if (0 < m.length) {
                    var c = t._colorSet[p % t._colorSet.length],
                        z = t.lineColor = t.options.lineColor || c,
                        A = z;
                    b.fillStyle = c;
                    b.strokeStyle = z;
                    b.lineWidth = t.lineThickness;
                    var B = "solid";
                    if (b.setLineDash) {
                        var E = I(t.nullDataLineDashType, t.lineThickness),
                            B = t.lineDashType,
                            R = I(B, t.lineThickness);
                        b.setLineDash(R)
                    }
                    for (var J = !0, p = 0; p < m.length; p++) {
                        q = m[p];
                        var H = null,
                            H = 0 <= t.dataPointIndexes[q] ? x[t.dataPointIndexes[q]] : {
                                x: q,
                                y: null
                            };
                        if (!(q < a.axisX.dataInfo.viewPortMin || q > a.axisX.dataInfo.viewPortMax &&
                                (!t.connectNullData || !J)))
                            if ("number" !== typeof H.y) t.connectNullData || (J || w) || d(), J = !0;
                            else {
                                var ea;
                                ea = 0 !== a.dataPointYSums[q] ? 100 * (H.y / a.dataPointYSums[q]) : 0;
                                e = a.axisX.convertValueToPixel(q);
                                var fa = l[q] ? l[q] : 0;
                                if (a.axisY.logarithmic) {
                                    n[q] = ea + (n[q] ? n[q] : 0);
                                    if (0 >= n[q]) continue;
                                    r = a.axisY.convertValueToPixel(n[q])
                                } else r = a.axisY.convertValueToPixel(ea), r -= fa;
                                k.push({
                                    x: e,
                                    y: s - fa
                                });
                                l[q] = s - r;
                                w || J ? (!w && t.connectNullData ? (b.setLineDash && (t.options.nullDataLineDashType || B === t.lineDashType && t.lineDashType !==
                                    t.nullDataLineDashType) && (b.stroke(), B = t.nullDataLineDashType, b.setLineDash(E)), b.lineTo(e, r), u && v.lineTo(e, r)) : (b.beginPath(), b.moveTo(e, r), u && (v.beginPath(), v.moveTo(e, r))), J = w = !1) : (b.lineTo(e, r), u && v.lineTo(e, r), 0 == p % 250 && (d(), b.moveTo(e, r), u && v.moveTo(e, r), k.push({
                                    x: e,
                                    y: s - fa
                                })));
                                p < x.length - 1 && (A !== (x[p].lineColor || z) || B !== (x[p].lineDashType || t.lineDashType)) && (d(), b.beginPath(), b.moveTo(e, r), k.push({
                                    x: e,
                                    y: s - fa
                                }), A = x[p].lineColor || z, b.strokeStyle = A, b.setLineDash && (x[p].lineDashType ? (B = x[p].lineDashType,
                                    b.setLineDash(I(B, t.lineThickness))) : (B = t.lineDashType, b.setLineDash(R))));
                                if (0 <= t.dataPointIndexes[q]) {
                                    var Fa = t.dataPointIds[t.dataPointIndexes[q]];
                                    this._eventManager.objectMap[Fa] = {
                                        id: Fa,
                                        objectType: "dataPoint",
                                        dataSeriesIndex: y,
                                        dataPointIndex: t.dataPointIndexes[q],
                                        x1: e,
                                        y1: r
                                    }
                                }
                                0 <= t.dataPointIndexes[q] && 0 !== H.markerSize && (0 < H.markerSize || 0 < t.markerSize) && (q = t.getMarkerProperties(p, e, r, b), h = q.color, g.push(q), markerColor = G(Fa), u && g.push({
                                    x: e,
                                    y: r,
                                    ctx: v,
                                    type: q.type,
                                    size: q.size,
                                    color: markerColor,
                                    borderColor: markerColor,
                                    borderThickness: q.borderThickness
                                }));
                                (H.indexLabel || t.indexLabel || H.indexLabelFormatter || t.indexLabelFormatter) && this._indexLabels.push({
                                    chartType: "stackedArea100",
                                    dataPoint: H,
                                    dataSeries: t,
                                    point: {
                                        x: e,
                                        y: r
                                    },
                                    direction: 0 > x[p].y === a.axisY.reversed ? 1 : -1,
                                    color: c
                                })
                            }
                    }
                    d();
                    b.moveTo(e, r);
                    u && v.moveTo(e, r)
                }
                delete t.dataPointIndexes;
                t.markerColor = h
            }
            P.drawMarkers(g);
            b.restore();
            u && v.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderBubble = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = this.plotArea,
                c = 0,
                f, g;
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(b.x1, b.y1, b.width, b.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(b.x1, b.y1, b.width, b.height), this._eventManager.ghostCtx.clip());
            for (var h = -Infinity, l = Infinity, k = 0; k < a.dataSeriesIndexes.length; k++)
                for (var m = a.dataSeriesIndexes[k], n = this.data[m],
                        p = n.dataPoints, e = 0, c = 0; c < p.length; c++) f = p[c].getTime ? f = p[c].x.getTime() : f = p[c].x, f < a.axisX.dataInfo.viewPortMin || f > a.axisX.dataInfo.viewPortMax || "undefined" === typeof p[c].z || (e = p[c].z, e > h && (h = e), e < l && (l = e));
            for (var r = 25 * Math.PI, b = Math.max(Math.pow(0.25 * Math.min(b.height, b.width) / 2, 2) * Math.PI, r), k = 0; k < a.dataSeriesIndexes.length; k++)
                if (m = a.dataSeriesIndexes[k], n = this.data[m], p = n.dataPoints, 0 < p.length)
                    for (d.strokeStyle = "#4572A7 ", c = 0; c < p.length; c++)
                        if (f = p[c].getTime ? f = p[c].x.getTime() : f = p[c].x, !(f < a.axisX.dataInfo.viewPortMin ||
                                f > a.axisX.dataInfo.viewPortMax) && "number" === typeof p[c].y) {
                            f = a.axisX.convertValueToPixel(f);
                            g = a.axisY.convertValueToPixel(p[c].y);
                            var e = p[c].z,
                                q = 2 * Math.max(Math.sqrt((h === l ? b / 2 : r + (b - r) / (h - l) * (e - l)) / Math.PI) << 0, 1),
                                e = n.getMarkerProperties(c, d);
                            e.size = q;
                            d.globalAlpha = n.fillOpacity;
                            P.drawMarker(f, g, d, e.type, e.size, e.color, e.borderColor, e.borderThickness);
                            d.globalAlpha = 1;
                            var s = n.dataPointIds[c];
                            this._eventManager.objectMap[s] = {
                                id: s,
                                objectType: "dataPoint",
                                dataSeriesIndex: m,
                                dataPointIndex: c,
                                x1: f,
                                y1: g,
                                size: q
                            };
                            q = G(s);
                            u && P.drawMarker(f, g, this._eventManager.ghostCtx, e.type, e.size, q, q, e.borderThickness);
                            (p[c].indexLabel || n.indexLabel || p[c].indexLabelFormatter || n.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "bubble",
                                dataPoint: p[c],
                                dataSeries: n,
                                point: {
                                    x: f,
                                    y: g
                                },
                                direction: 1,
                                bounds: {
                                    x1: f - e.size / 2,
                                    y1: g - e.size / 2,
                                    x2: f + e.size / 2,
                                    y2: g + e.size / 2
                                },
                                color: null
                            })
                        }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.fadeInAnimation,
                easingFunction: F.easing.easeInQuad,
                animationBase: 0
            }
        }
    };
    A.prototype.renderScatter = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = this.plotArea,
                c = 0,
                f, g;
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(b.x1, b.y1, b.width, b.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(b.x1, b.y1, b.width, b.height), this._eventManager.ghostCtx.clip());
            for (var h = 0; h < a.dataSeriesIndexes.length; h++) {
                var l = a.dataSeriesIndexes[h],
                    k = this.data[l],
                    m = k.dataPoints;
                if (0 < m.length) {
                    d.strokeStyle = "#4572A7 ";
                    Math.pow(0.3 * Math.min(b.height, b.width) / 2, 2);
                    for (var n = 0, p = 0, c = 0; c < m.length; c++)
                        if (f = m[c].getTime ? f = m[c].x.getTime() : f = m[c].x, !(f < a.axisX.dataInfo.viewPortMin || f > a.axisX.dataInfo.viewPortMax) && "number" === typeof m[c].y) {
                            f = a.axisX.convertValueToPixel(f);
                            g = a.axisY.convertValueToPixel(m[c].y);
                            var e = k.getMarkerProperties(c, f, g, d);
                            d.globalAlpha = k.fillOpacity;
                            P.drawMarker(e.x, e.y, e.ctx, e.type, e.size, e.color, e.borderColor, e.borderThickness);
                            d.globalAlpha =
                                1;
                            Math.sqrt((n - f) * (n - f) + (p - g) * (p - g)) < Math.min(e.size, 5) && m.length > Math.min(this.plotArea.width, this.plotArea.height) || (n = k.dataPointIds[c], this._eventManager.objectMap[n] = {
                                id: n,
                                objectType: "dataPoint",
                                dataSeriesIndex: l,
                                dataPointIndex: c,
                                x1: f,
                                y1: g
                            }, n = G(n), u && P.drawMarker(e.x, e.y, this._eventManager.ghostCtx, e.type, e.size, n, n, e.borderThickness), (m[c].indexLabel || k.indexLabel || m[c].indexLabelFormatter || k.indexLabelFormatter) && this._indexLabels.push({
                                chartType: "scatter",
                                dataPoint: m[c],
                                dataSeries: k,
                                point: {
                                    x: f,
                                    y: g
                                },
                                direction: 1,
                                bounds: {
                                    x1: f - e.size / 2,
                                    y1: g - e.size / 2,
                                    x2: f + e.size / 2,
                                    y2: g + e.size / 2
                                },
                                color: null
                            }), n = f, p = g)
                        }
                }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.fadeInAnimation,
                easingFunction: F.easing.easeInQuad,
                animationBase: 0
            }
        }
    };
    A.prototype.renderCandlestick = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx,
            b = this._eventManager.ghostCtx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = null,
                c = this.plotArea,
                f = 0,
                g, h, l, k, m, n, f = this.dataPointMinWidth ?
                this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1;
            g = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : 0.015 * this.width;
            var p = a.axisX.dataInfo.minDiff;
            isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
            p = this.dataPointWidth ? this.dataPointWidth : 0.7 * c.width * (a.axisX.logarithmic ? Math.log(p) / Math.log(a.axisX.range) : Math.abs(p) / Math.abs(a.axisX.range)) << 0;
            this.dataPointMaxWidth && f > g && (f = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, g));
            !this.dataPointMaxWidth &&
                (this.dataPointMinWidth && g < f) && (g = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, f));
            p < f && (p = f);
            p > g && (p = g);
            d.save();
            u && b.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (b.beginPath(), b.rect(c.x1, c.y1, c.width, c.height), b.clip());
            for (var e = 0; e < a.dataSeriesIndexes.length; e++) {
                var r = a.dataSeriesIndexes[e],
                    q = this.data[r],
                    s = q.dataPoints;
                if (0 < s.length)
                    for (var v = 5 < p && q.bevelEnabled ? !0 : !1, f = 0; f < s.length; f++)
                        if (s[f].getTime ? n = s[f].x.getTime() : n = s[f].x, !(n < a.axisX.dataInfo.viewPortMin ||
                                n > a.axisX.dataInfo.viewPortMax) && null !== s[f].y && s[f].y.length && "number" === typeof s[f].y[0] && "number" === typeof s[f].y[1] && "number" === typeof s[f].y[2] && "number" === typeof s[f].y[3]) {
                            g = a.axisX.convertValueToPixel(n);
                            h = a.axisY.convertValueToPixel(s[f].y[0]);
                            l = a.axisY.convertValueToPixel(s[f].y[1]);
                            k = a.axisY.convertValueToPixel(s[f].y[2]);
                            m = a.axisY.convertValueToPixel(s[f].y[3]);
                            var w = g - p / 2 << 0,
                                y = w + p << 0,
                                c = s[f].color ? s[f].color : q._colorSet[0],
                                t = Math.round(Math.max(1, 0.15 * p)),
                                x = 0 === t % 2 ? 0 : 0.5,
                                z = q.dataPointIds[f];
                            this._eventManager.objectMap[z] = {
                                id: z,
                                objectType: "dataPoint",
                                dataSeriesIndex: r,
                                dataPointIndex: f,
                                x1: w,
                                y1: h,
                                x2: y,
                                y2: l,
                                x3: g,
                                y3: k,
                                x4: g,
                                y4: m,
                                borderThickness: t,
                                color: c
                            };
                            d.strokeStyle = c;
                            d.beginPath();
                            d.lineWidth = t;
                            b.lineWidth = Math.max(t, 4);
                            "candlestick" === q.type ? (d.moveTo(g - x, l), d.lineTo(g - x, Math.min(h, m)), d.stroke(), d.moveTo(g - x, Math.max(h, m)), d.lineTo(g - x, k), d.stroke(), N(d, w, Math.min(h, m), y, Math.max(h, m), s[f].y[0] <= s[f].y[3] ? q.risingColor : c, t, c, v, v, !1, !1, q.fillOpacity), u && (c = G(z), b.strokeStyle = c, b.moveTo(g -
                                x, l), b.lineTo(g - x, Math.min(h, m)), b.stroke(), b.moveTo(g - x, Math.max(h, m)), b.lineTo(g - x, k), b.stroke(), N(b, w, Math.min(h, m), y, Math.max(h, m), c, 0, null, !1, !1, !1, !1))) : "ohlc" === q.type && (d.moveTo(g - x, l), d.lineTo(g - x, k), d.stroke(), d.beginPath(), d.moveTo(g, h), d.lineTo(w, h), d.stroke(), d.beginPath(), d.moveTo(g, m), d.lineTo(y, m), d.stroke(), u && (c = G(z), b.strokeStyle = c, b.moveTo(g - x, l), b.lineTo(g - x, k), b.stroke(), b.beginPath(), b.moveTo(g, h), b.lineTo(w, h), b.stroke(), b.beginPath(), b.moveTo(g, m), b.lineTo(y, m), b.stroke()));
                            (s[f].indexLabel || q.indexLabel || s[f].indexLabelFormatter || q.indexLabelFormatter) && this._indexLabels.push({
                                chartType: q.type,
                                dataPoint: s[f],
                                dataSeries: q,
                                point: {
                                    x: w + (y - w) / 2,
                                    y: a.axisY.reversed ? k : l
                                },
                                direction: 1,
                                bounds: {
                                    x1: w,
                                    y1: Math.min(l, k),
                                    x2: y,
                                    y2: Math.max(l, k)
                                },
                                color: c
                            })
                        }
            }
            d.restore();
            u && b.restore();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.fadeInAnimation,
                easingFunction: F.easing.easeInQuad,
                animationBase: 0
            }
        }
    };
    A.prototype.renderRangeColumn = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = 0,
                g, h, f = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1;
            g = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth : 0.03 * this.width;
            var l = a.axisX.dataInfo.minDiff;
            isFinite(l) || (l = 0.3 * Math.abs(a.axisX.range));
            l = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.width * (a.axisX.logarithmic ? Math.log(l) / Math.log(a.axisX.range) : Math.abs(l) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) <<
                0;
            this.dataPointMaxWidth && f > g && (f = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, g));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && g < f) && (g = Math.max(this.dataPointWidth ? this.dataPointWidth : -Infinity, f));
            l < f && (l = f);
            l > g && (l = g);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (var k = 0; k < a.dataSeriesIndexes.length; k++) {
                var m =
                    a.dataSeriesIndexes[k],
                    n = this.data[m],
                    p = n.dataPoints;
                if (0 < p.length)
                    for (var e = 5 < l && n.bevelEnabled ? !0 : !1, f = 0; f < p.length; f++)
                        if (p[f].getTime ? h = p[f].x.getTime() : h = p[f].x, !(h < a.axisX.dataInfo.viewPortMin || h > a.axisX.dataInfo.viewPortMax) && null !== p[f].y && p[f].y.length && "number" === typeof p[f].y[0] && "number" === typeof p[f].y[1]) {
                            b = a.axisX.convertValueToPixel(h);
                            c = a.axisY.convertValueToPixel(p[f].y[0]);
                            g = a.axisY.convertValueToPixel(p[f].y[1]);
                            var r = a.axisX.reversed ? b + a.plotType.totalDataSeries * l / 2 - (a.previousDataSeriesCount +
                                    k) * l << 0 : b - a.plotType.totalDataSeries * l / 2 + (a.previousDataSeriesCount + k) * l << 0,
                                q = a.axisX.reversed ? r - l << 0 : r + l << 0,
                                b = p[f].color ? p[f].color : n._colorSet[f % n._colorSet.length];
                            if (c > g) {
                                var s = c,
                                    c = g;
                                g = s
                            }
                            s = n.dataPointIds[f];
                            this._eventManager.objectMap[s] = {
                                id: s,
                                objectType: "dataPoint",
                                dataSeriesIndex: m,
                                dataPointIndex: f,
                                x1: r,
                                y1: c,
                                x2: q,
                                y2: g
                            };
                            N(d, r, c, q, g, b, 0, b, e, e, !1, !1, n.fillOpacity);
                            b = G(s);
                            u && N(this._eventManager.ghostCtx, r, c, q, g, b, 0, null, !1, !1, !1, !1);
                            if (p[f].indexLabel || n.indexLabel || p[f].indexLabelFormatter ||
                                n.indexLabelFormatter) this._indexLabels.push({
                                chartType: "rangeColumn",
                                dataPoint: p[f],
                                dataSeries: n,
                                indexKeyword: 0,
                                point: {
                                    x: r + (q - r) / 2,
                                    y: p[f].y[1] >= p[f].y[0] ? g : c
                                },
                                direction: p[f].y[1] >= p[f].y[0] ? -1 : 1,
                                bounds: {
                                    x1: r,
                                    y1: Math.min(c, g),
                                    x2: q,
                                    y2: Math.max(c, g)
                                },
                                color: b
                            }), this._indexLabels.push({
                                chartType: "rangeColumn",
                                dataPoint: p[f],
                                dataSeries: n,
                                indexKeyword: 1,
                                point: {
                                    x: r + (q - r) / 2,
                                    y: p[f].y[1] >= p[f].y[0] ? c : g
                                },
                                direction: p[f].y[1] >= p[f].y[0] ? 1 : -1,
                                bounds: {
                                    x1: r,
                                    y1: Math.min(c, g),
                                    x2: q,
                                    y2: Math.max(c, g)
                                },
                                color: b
                            })
                        }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.fadeInAnimation,
                easingFunction: F.easing.easeInQuad,
                animationBase: 0
            }
        }
    };
    A.prototype.renderRangeBar = function(a) {
        var d = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var b = null,
                c = this.plotArea,
                f = 0,
                g, h, l, f = this.dataPointMinWidth ? this.dataPointMinWidth : this.dataPointWidth ? this.dataPointWidth : 1;
            g = this.dataPointMaxWidth ? this.dataPointMaxWidth : this.dataPointWidth ? this.dataPointWidth :
                Math.min(0.15 * this.height, 0.9 * (this.plotArea.height / a.plotType.totalDataSeries)) << 0;
            var k = a.axisX.dataInfo.minDiff;
            isFinite(k) || (k = 0.3 * Math.abs(a.axisX.range));
            k = this.dataPointWidth ? this.dataPointWidth : 0.9 * (c.height * (a.axisX.logarithmic ? Math.log(k) / Math.log(a.axisX.range) : Math.abs(k) / Math.abs(a.axisX.range)) / a.plotType.totalDataSeries) << 0;
            this.dataPointMaxWidth && f > g && (f = Math.min(this.dataPointWidth ? this.dataPointWidth : Infinity, g));
            !this.dataPointMaxWidth && (this.dataPointMinWidth && g < f) && (g = Math.max(this.dataPointWidth ?
                this.dataPointWidth : -Infinity, f));
            k < f && (k = f);
            k > g && (k = g);
            d.save();
            u && this._eventManager.ghostCtx.save();
            d.beginPath();
            d.rect(c.x1, c.y1, c.width, c.height);
            d.clip();
            u && (this._eventManager.ghostCtx.beginPath(), this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height), this._eventManager.ghostCtx.clip());
            for (var m = 0; m < a.dataSeriesIndexes.length; m++) {
                var n = a.dataSeriesIndexes[m],
                    p = this.data[n],
                    e = p.dataPoints;
                if (0 < e.length) {
                    var r = 5 < k && p.bevelEnabled ? !0 : !1;
                    d.strokeStyle = "#4572A7 ";
                    for (f = 0; f < e.length; f++)
                        if (e[f].getTime ?
                            l = e[f].x.getTime() : l = e[f].x, !(l < a.axisX.dataInfo.viewPortMin || l > a.axisX.dataInfo.viewPortMax) && null !== e[f].y && e[f].y.length && "number" === typeof e[f].y[0] && "number" === typeof e[f].y[1]) {
                            c = a.axisY.convertValueToPixel(e[f].y[0]);
                            g = a.axisY.convertValueToPixel(e[f].y[1]);
                            h = a.axisX.convertValueToPixel(l);
                            h = a.axisX.reversed ? h + a.plotType.totalDataSeries * k / 2 - (a.previousDataSeriesCount + m) * k << 0 : h - a.plotType.totalDataSeries * k / 2 + (a.previousDataSeriesCount + m) * k << 0;
                            var q = a.axisX.reversed ? h - k << 0 : h + k << 0;
                            c > g && (b = c, c =
                                g, g = b);
                            b = e[f].color ? e[f].color : p._colorSet[f % p._colorSet.length];
                            N(d, c, h, g, q, b, 0, null, r, !1, !1, !1, p.fillOpacity);
                            b = p.dataPointIds[f];
                            this._eventManager.objectMap[b] = {
                                id: b,
                                objectType: "dataPoint",
                                dataSeriesIndex: n,
                                dataPointIndex: f,
                                x1: c,
                                y1: h,
                                x2: g,
                                y2: q
                            };
                            b = G(b);
                            u && N(this._eventManager.ghostCtx, c, h, g, q, b, 0, null, !1, !1, !1, !1);
                            if (e[f].indexLabel || p.indexLabel || e[f].indexLabelFormatter || p.indexLabelFormatter) this._indexLabels.push({
                                chartType: "rangeBar",
                                dataPoint: e[f],
                                dataSeries: p,
                                indexKeyword: 0,
                                point: {
                                    x: e[f].y[1] >=
                                        e[f].y[0] ? c : g,
                                    y: h + (q - h) / 2
                                },
                                direction: e[f].y[1] >= e[f].y[0] ? -1 : 1,
                                bounds: {
                                    x1: Math.min(c, g),
                                    y1: h,
                                    x2: Math.max(c, g),
                                    y2: q
                                },
                                color: b
                            }), this._indexLabels.push({
                                chartType: "rangeBar",
                                dataPoint: e[f],
                                dataSeries: p,
                                indexKeyword: 1,
                                point: {
                                    x: e[f].y[1] >= e[f].y[0] ? g : c,
                                    y: h + (q - h) / 2
                                },
                                direction: e[f].y[1] >= e[f].y[0] ? 1 : -1,
                                bounds: {
                                    x1: Math.min(c, g),
                                    y1: h,
                                    x2: Math.max(c, g),
                                    y2: q
                                },
                                color: b
                            })
                        }
                }
            }
            d.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: d,
                dest: this.plotArea.ctx,
                animationCallback: F.fadeInAnimation,
                easingFunction: F.easing.easeInQuad,
                animationBase: 0
            }
        }
    };
    A.prototype.renderRangeArea = function(a) {
        function d() {
            if (w) {
                var a = null;
                0 < m.lineThickness && b.stroke();
                for (var d = l.length - 1; 0 <= d; d--) a = l[d], b.lineTo(a.x, a.y), c.lineTo(a.x, a.y);
                b.closePath();
                b.globalAlpha = m.fillOpacity;
                b.fill();
                b.globalAlpha = 1;
                c.fill();
                if (0 < m.lineThickness) {
                    b.beginPath();
                    b.moveTo(a.x, a.y);
                    for (d = 0; d < l.length; d++) a = l[d], b.lineTo(a.x, a.y);
                    b.stroke()
                }
                b.beginPath();
                b.moveTo(r, q);
                c.beginPath();
                c.moveTo(r, q);
                w = {
                    x: r,
                    y: q
                };
                l = [];
                l.push({
                    x: r,
                    y: s
                })
            }
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = this._eventManager.ghostCtx,
                f = [],
                g = null,
                h = this.plotArea;
            b.save();
            u && c.save();
            b.beginPath();
            b.rect(h.x1, h.y1, h.width, h.height);
            b.clip();
            u && (c.beginPath(), c.rect(h.x1, h.y1, h.width, h.height), c.clip());
            for (h = 0; h < a.dataSeriesIndexes.length; h++) {
                var l = [],
                    k = a.dataSeriesIndexes[h],
                    m = this.data[k],
                    n = m.dataPoints,
                    f = m.id;
                this._eventManager.objectMap[f] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: k
                };
                f = G(f);
                c.fillStyle = f;
                var f = [],
                    p = !0,
                    e = 0,
                    r, q, s, v, w = null;
                if (0 < n.length) {
                    var y =
                        m._colorSet[e % m._colorSet.length],
                        t = m.lineColor = m.options.lineColor || y,
                        x = t;
                    b.fillStyle = y;
                    b.strokeStyle = t;
                    b.lineWidth = m.lineThickness;
                    var z = "solid";
                    if (b.setLineDash) {
                        var A = I(m.nullDataLineDashType, m.lineThickness),
                            z = m.lineDashType,
                            B = I(z, m.lineThickness);
                        b.setLineDash(B)
                    }
                    for (var E = !0; e < n.length; e++)
                        if (v = n[e].x.getTime ? n[e].x.getTime() : n[e].x, !(v < a.axisX.dataInfo.viewPortMin || v > a.axisX.dataInfo.viewPortMax && (!m.connectNullData || !E)))
                            if (null !== n[e].y && n[e].y.length && "number" === typeof n[e].y[0] && "number" ===
                                typeof n[e].y[1]) {
                                r = a.axisX.convertValueToPixel(v);
                                q = a.axisY.convertValueToPixel(n[e].y[0]);
                                s = a.axisY.convertValueToPixel(n[e].y[1]);
                                p || E ? (m.connectNullData && !p ? (b.setLineDash && (m.options.nullDataLineDashType || z === m.lineDashType && m.lineDashType !== m.nullDataLineDashType) && (l[l.length - 1].newLineDashArray = B, z = m.nullDataLineDashType, b.setLineDash(A)), b.lineTo(r, q), u && c.lineTo(r, q), l.push({
                                    x: r,
                                    y: s
                                })) : (b.beginPath(), b.moveTo(r, q), w = {
                                    x: r,
                                    y: q
                                }, l = [], l.push({
                                    x: r,
                                    y: s
                                }), u && (c.beginPath(), c.moveTo(r, q))), E = p = !1) : (b.lineTo(r, q), l.push({
                                    x: r,
                                    y: s
                                }), u && c.lineTo(r, q), 0 == e % 250 && d());
                                v = m.dataPointIds[e];
                                this._eventManager.objectMap[v] = {
                                    id: v,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: k,
                                    dataPointIndex: e,
                                    x1: r,
                                    y1: q,
                                    y2: s
                                };
                                e < n.length - 1 && (x !== (n[e].lineColor || t) || z !== (n[e].lineDashType || m.lineDashType)) && (d(), x = n[e].lineColor || t, l[l.length - 1].newStrokeStyle = x, b.strokeStyle = x, b.setLineDash && (n[e].lineDashType ? (z = n[e].lineDashType, l[l.length - 1].newLineDashArray = I(z, m.lineThickness), b.setLineDash(l[l.length - 1].newLineDashArray)) :
                                    (z = m.lineDashType, l[l.length - 1].newLineDashArray = B, b.setLineDash(B))));
                                if (0 !== n[e].markerSize && (0 < n[e].markerSize || 0 < m.markerSize)) {
                                    var R = m.getMarkerProperties(e, r, s, b);
                                    f.push(R);
                                    var J = G(v);
                                    u && f.push({
                                        x: r,
                                        y: s,
                                        ctx: c,
                                        type: R.type,
                                        size: R.size,
                                        color: J,
                                        borderColor: J,
                                        borderThickness: R.borderThickness
                                    });
                                    R = m.getMarkerProperties(e, r, q, b);
                                    g = R.color;
                                    f.push(R);
                                    J = G(v);
                                    u && f.push({
                                        x: r,
                                        y: q,
                                        ctx: c,
                                        type: R.type,
                                        size: R.size,
                                        color: J,
                                        borderColor: J,
                                        borderThickness: R.borderThickness
                                    })
                                }
                                if (n[e].indexLabel || m.indexLabel || n[e].indexLabelFormatter ||
                                    m.indexLabelFormatter) this._indexLabels.push({
                                    chartType: "rangeArea",
                                    dataPoint: n[e],
                                    dataSeries: m,
                                    indexKeyword: 0,
                                    point: {
                                        x: r,
                                        y: q
                                    },
                                    direction: n[e].y[0] > n[e].y[1] === a.axisY.reversed ? -1 : 1,
                                    color: y
                                }), this._indexLabels.push({
                                    chartType: "rangeArea",
                                    dataPoint: n[e],
                                    dataSeries: m,
                                    indexKeyword: 1,
                                    point: {
                                        x: r,
                                        y: s
                                    },
                                    direction: n[e].y[0] > n[e].y[1] === a.axisY.reversed ? 1 : -1,
                                    color: y
                                })
                            } else E || p || d(), E = !0;
                    d();
                    P.drawMarkers(f);
                    m.markerColor = g
                }
            }
            b.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    A.prototype.renderRangeSplineArea = function(a) {
        function d(a, d) {
            var e = ua(q, 2);
            if (0 < e.length) {
                if (0 < k.lineThickness) {
                    b.strokeStyle = d;
                    b.setLineDash && b.setLineDash(a);
                    b.beginPath();
                    b.moveTo(e[0].x, e[0].y);
                    for (var f = 0; f < e.length - 3; f += 3) {
                        if (e[f].newStrokeStyle || e[f].newLineDashArray) b.stroke(), b.beginPath(), b.moveTo(e[f].x, e[f].y), e[f].newStrokeStyle && (b.strokeStyle = e[f].newStrokeStyle), e[f].newLineDashArray && b.setLineDash(e[f].newLineDashArray);
                        b.bezierCurveTo(e[f + 1].x, e[f + 1].y, e[f + 2].x, e[f + 2].y, e[f + 3].x, e[f + 3].y)
                    }
                    b.stroke()
                }
                b.beginPath();
                b.moveTo(e[0].x, e[0].y);
                u && (c.beginPath(), c.moveTo(e[0].x, e[0].y));
                for (f = 0; f < e.length - 3; f += 3) b.bezierCurveTo(e[f + 1].x, e[f + 1].y, e[f + 2].x, e[f + 2].y, e[f + 3].x, e[f + 3].y), u && c.bezierCurveTo(e[f + 1].x, e[f + 1].y, e[f + 2].x, e[f + 2].y, e[f + 3].x, e[f + 3].y);
                e = ua(s, 2);
                b.lineTo(s[s.length - 1].x, s[s.length - 1].y);
                for (f = e.length - 1; 2 < f; f -= 3) b.bezierCurveTo(e[f - 1].x, e[f - 1].y, e[f - 2].x, e[f - 2].y, e[f - 3].x, e[f - 3].y), u && c.bezierCurveTo(e[f -
                    1].x, e[f - 1].y, e[f - 2].x, e[f - 2].y, e[f - 3].x, e[f - 3].y);
                b.closePath();
                b.globalAlpha = k.fillOpacity;
                b.fill();
                u && (c.closePath(), c.fill());
                b.globalAlpha = 1;
                if (0 < k.lineThickness) {
                    b.strokeStyle = d;
                    b.setLineDash && b.setLineDash(a);
                    b.beginPath();
                    b.moveTo(e[0].x, e[0].y);
                    for (var g = f = 0; f < e.length - 3; f += 3, g++) {
                        if (q[g].newStrokeStyle || q[g].newLineDashArray) b.stroke(), b.beginPath(), b.moveTo(e[f].x, e[f].y), q[g].newStrokeStyle && (b.strokeStyle = q[g].newStrokeStyle), q[g].newLineDashArray && b.setLineDash(q[g].newLineDashArray);
                        b.bezierCurveTo(e[f + 1].x, e[f + 1].y, e[f + 2].x, e[f + 2].y, e[f + 3].x, e[f + 3].y)
                    }
                    b.stroke()
                }
                b.beginPath()
            }
        }
        var b = a.targetCanvasCtx || this.plotArea.ctx;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var c = this._eventManager.ghostCtx,
                f = [],
                g = null,
                h = this.plotArea;
            b.save();
            u && c.save();
            b.beginPath();
            b.rect(h.x1, h.y1, h.width, h.height);
            b.clip();
            u && (c.beginPath(), c.rect(h.x1, h.y1, h.width, h.height), c.clip());
            for (h = 0; h < a.dataSeriesIndexes.length; h++) {
                var l = a.dataSeriesIndexes[h],
                    k = this.data[l],
                    m = k.dataPoints,
                    f = k.id;
                this._eventManager.objectMap[f] = {
                    objectType: "dataSeries",
                    dataSeriesIndex: l
                };
                f = G(f);
                c.fillStyle = f;
                var f = [],
                    n = 0,
                    p, e, r, q = [],
                    s = [];
                if (0 < m.length) {
                    var v = k._colorSet[n % k._colorSet.length],
                        w = k.lineColor = k.options.lineColor || v,
                        y = w;
                    b.fillStyle = v;
                    b.lineWidth = k.lineThickness;
                    var t = "solid",
                        x;
                    if (b.setLineDash) {
                        var z = I(k.nullDataLineDashType, k.lineThickness),
                            t = k.lineDashType;
                        x = I(t, k.lineThickness)
                    }
                    for (e = !1; n < m.length; n++)
                        if (p = m[n].x.getTime ? m[n].x.getTime() : m[n].x, !(p < a.axisX.dataInfo.viewPortMin || p > a.axisX.dataInfo.viewPortMax && (!k.connectNullData ||
                                !e)))
                            if (null !== m[n].y && m[n].y.length && "number" === typeof m[n].y[0] && "number" === typeof m[n].y[1]) {
                                p = a.axisX.convertValueToPixel(p);
                                e = a.axisY.convertValueToPixel(m[n].y[0]);
                                r = a.axisY.convertValueToPixel(m[n].y[1]);
                                var A = k.dataPointIds[n];
                                this._eventManager.objectMap[A] = {
                                    id: A,
                                    objectType: "dataPoint",
                                    dataSeriesIndex: l,
                                    dataPointIndex: n,
                                    x1: p,
                                    y1: e,
                                    y2: r
                                };
                                q[q.length] = {
                                    x: p,
                                    y: e
                                };
                                s[s.length] = {
                                    x: p,
                                    y: r
                                };
                                n < m.length - 1 && (y !== (m[n].lineColor || w) || t !== (m[n].lineDashType || k.lineDashType)) && (y = m[n].lineColor || w, q[q.length -
                                    1].newStrokeStyle = y, b.setLineDash && (m[n].lineDashType ? (t = m[n].lineDashType, q[q.length - 1].newLineDashArray = I(t, k.lineThickness)) : (t = k.lineDashType, q[q.length - 1].newLineDashArray = x)));
                                if (0 !== m[n].markerSize && (0 < m[n].markerSize || 0 < k.markerSize)) {
                                    var B = k.getMarkerProperties(n, p, e, b),
                                        g = B.color;
                                    f.push(B);
                                    var E = G(A);
                                    u && f.push({
                                        x: p,
                                        y: e,
                                        ctx: c,
                                        type: B.type,
                                        size: B.size,
                                        color: E,
                                        borderColor: E,
                                        borderThickness: B.borderThickness
                                    });
                                    B = k.getMarkerProperties(n, p, r, b);
                                    f.push(B);
                                    E = G(A);
                                    u && f.push({
                                        x: p,
                                        y: r,
                                        ctx: c,
                                        type: B.type,
                                        size: B.size,
                                        color: E,
                                        borderColor: E,
                                        borderThickness: B.borderThickness
                                    })
                                }
                                if (m[n].indexLabel || k.indexLabel || m[n].indexLabelFormatter || k.indexLabelFormatter) this._indexLabels.push({
                                    chartType: "splineArea",
                                    dataPoint: m[n],
                                    dataSeries: k,
                                    indexKeyword: 0,
                                    point: {
                                        x: p,
                                        y: e
                                    },
                                    direction: m[n].y[0] <= m[n].y[1] ? -1 : 1,
                                    color: v
                                }), this._indexLabels.push({
                                    chartType: "splineArea",
                                    dataPoint: m[n],
                                    dataSeries: k,
                                    indexKeyword: 1,
                                    point: {
                                        x: p,
                                        y: r
                                    },
                                    direction: m[n].y[0] <= m[n].y[1] ? 1 : -1,
                                    color: v
                                });
                                e = !1
                            } else 0 < n && !e && (k.connectNullData ? b.setLineDash &&
                                (0 < q.length && (k.options.nullDataLineDashType || !m[n - 1].lineDashType)) && (q[q.length - 1].newLineDashArray = z, t = k.nullDataLineDashType) : (d(x, w), q = [], s = [])), e = !0;
                    d(x, w);
                    P.drawMarkers(f);
                    k.markerColor = g
                }
            }
            b.restore();
            u && this._eventManager.ghostCtx.restore();
            return {
                source: b,
                dest: this.plotArea.ctx,
                animationCallback: F.xClipAnimation,
                easingFunction: F.easing.linear,
                animationBase: 0
            }
        }
    };
    var Ga = function(a, d, b, c, f, g, h, l, k) {
        if (!(0 > b)) {
            "undefined" === typeof l && (l = 1);
            if (!u) {
                var m = Number((h % (2 * Math.PI)).toFixed(8));
                Number((g %
                    (2 * Math.PI)).toFixed(8)) === m && (h -= 1E-4)
            }
            a.save();
            a.globalAlpha = l;
            "pie" === f ? (a.beginPath(), a.moveTo(d.x, d.y), a.arc(d.x, d.y, b, g, h, !1), a.fillStyle = c, a.strokeStyle = "white", a.lineWidth = 2, a.closePath(), a.fill()) : "doughnut" === f && (a.beginPath(), a.arc(d.x, d.y, b, g, h, !1), 0 <= k && a.arc(d.x, d.y, k * b, h, g, !0), a.closePath(), a.fillStyle = c, a.strokeStyle = "white", a.lineWidth = 2, a.fill());
            a.globalAlpha = 1;
            a.restore()
        }
    };
    A.prototype.renderPie = function(a) {
        function d() {
            if (m && n) {
                for (var a = 0, b = 0, c = 0, d = 0, f = 0; f < n.length; f++) {
                    var g =
                        n[f],
                        h = m.dataPointIds[f],
                        l = {
                            id: h,
                            objectType: "dataPoint",
                            dataPointIndex: f,
                            dataSeriesIndex: 0
                        };
                    r.push(l);
                    var p = {
                            percent: null,
                            total: null
                        },
                        q = null,
                        p = k.getPercentAndTotal(m, g);
                    if (m.indexLabelFormatter || g.indexLabelFormatter) q = {
                        chart: k.options,
                        dataSeries: m,
                        dataPoint: g,
                        total: p.total,
                        percent: p.percent
                    };
                    p = g.indexLabelFormatter ? g.indexLabelFormatter(q) : g.indexLabel ? k.replaceKeywordsWithValue(g.indexLabel, g, m, f) : m.indexLabelFormatter ? m.indexLabelFormatter(q) : m.indexLabel ? k.replaceKeywordsWithValue(m.indexLabel,
                        g, m, f) : g.label ? g.label : "";
                    k._eventManager.objectMap[h] = l;
                    l.center = {
                        x: t.x,
                        y: t.y
                    };
                    l.y = g.y;
                    l.radius = B;
                    l.percentInnerRadius = F;
                    l.indexLabelText = p;
                    l.indexLabelPlacement = m.indexLabelPlacement;
                    l.indexLabelLineColor = g.indexLabelLineColor ? g.indexLabelLineColor : m.options.indexLabelLineColor ? m.options.indexLabelLineColor : g.color ? g.color : m._colorSet[f % m._colorSet.length];
                    l.indexLabelLineThickness = x(g.indexLabelLineThickness) ? m.indexLabelLineThickness : g.indexLabelLineThickness;
                    l.indexLabelLineDashType = g.indexLabelLineDashType ?
                        g.indexLabelLineDashType : m.indexLabelLineDashType;
                    l.indexLabelFontColor = g.indexLabelFontColor ? g.indexLabelFontColor : m.indexLabelFontColor;
                    l.indexLabelFontStyle = g.indexLabelFontStyle ? g.indexLabelFontStyle : m.indexLabelFontStyle;
                    l.indexLabelFontWeight = g.indexLabelFontWeight ? g.indexLabelFontWeight : m.indexLabelFontWeight;
                    l.indexLabelFontSize = g.indexLabelFontSize ? g.indexLabelFontSize : m.indexLabelFontSize;
                    l.indexLabelFontFamily = g.indexLabelFontFamily ? g.indexLabelFontFamily : m.indexLabelFontFamily;
                    l.indexLabelBackgroundColor =
                        g.indexLabelBackgroundColor ? g.indexLabelBackgroundColor : m.options.indexLabelBackgroundColor ? m.options.indexLabelBackgroundColor : m.indexLabelBackgroundColor;
                    l.indexLabelMaxWidth = g.indexLabelMaxWidth ? g.indexLabelMaxWidth : m.indexLabelMaxWidth ? m.indexLabelMaxWidth : 0.33 * e.width;
                    l.indexLabelWrap = "undefined" !== typeof g.indexLabelWrap ? g.indexLabelWrap : m.indexLabelWrap;
                    l.startAngle = 0 === f ? m.startAngle ? m.startAngle / 180 * Math.PI : 0 : r[f - 1].endAngle;
                    l.startAngle = (l.startAngle + 2 * Math.PI) % (2 * Math.PI);
                    l.endAngle = l.startAngle +
                        2 * Math.PI / u * Math.abs(g.y);
                    g = (l.endAngle + l.startAngle) / 2;
                    g = (g + 2 * Math.PI) % (2 * Math.PI);
                    l.midAngle = g;
                    if (l.midAngle > Math.PI / 2 - w && l.midAngle < Math.PI / 2 + w) {
                        if (0 === a || r[c].midAngle > l.midAngle) c = f;
                        a++
                    } else if (l.midAngle > 3 * Math.PI / 2 - w && l.midAngle < 3 * Math.PI / 2 + w) {
                        if (0 === b || r[d].midAngle > l.midAngle) d = f;
                        b++
                    }
                    l.hemisphere = g > Math.PI / 2 && g <= 3 * Math.PI / 2 ? "left" : "right";
                    l.indexLabelTextBlock = new W(k.plotArea.ctx, {
                        fontSize: l.indexLabelFontSize,
                        fontFamily: l.indexLabelFontFamily,
                        fontColor: l.indexLabelFontColor,
                        fontStyle: l.indexLabelFontStyle,
                        fontWeight: l.indexLabelFontWeight,
                        horizontalAlign: "left",
                        backgroundColor: l.indexLabelBackgroundColor,
                        maxWidth: l.indexLabelMaxWidth,
                        maxHeight: l.indexLabelWrap ? 5 * l.indexLabelFontSize : 1.5 * l.indexLabelFontSize,
                        text: l.indexLabelText,
                        padding: 0,
                        textBaseline: "top"
                    });
                    l.indexLabelTextBlock.measureText()
                }
                h = g = 0;
                p = !1;
                for (f = 0; f < n.length; f++) l = r[(c + f) % n.length], 1 < a && (l.midAngle > Math.PI / 2 - w && l.midAngle < Math.PI / 2 + w) && (g <= a / 2 && !p ? (l.hemisphere = "right", g++) : (l.hemisphere = "left", p = !0));
                p = !1;
                for (f = 0; f < n.length; f++) l =
                    r[(d + f) % n.length], 1 < b && (l.midAngle > 3 * Math.PI / 2 - w && l.midAngle < 3 * Math.PI / 2 + w) && (h <= b / 2 && !p ? (l.hemisphere = "left", h++) : (l.hemisphere = "right", p = !0))
            }
        }

        function b(a) {
            var b = k.plotArea.ctx;
            b.clearRect(e.x1, e.y1, e.width, e.height);
            b.fillStyle = k.backgroundColor;
            b.fillRect(e.x1, e.y1, e.width, e.height);
            for (b = 0; b < n.length; b++) {
                var c = r[b].startAngle,
                    d = r[b].endAngle;
                if (d > c) {
                    var f = 0.07 * B * Math.cos(r[b].midAngle),
                        g = 0.07 * B * Math.sin(r[b].midAngle),
                        l = !1;
                    if (n[b].exploded) {
                        if (1E-9 < Math.abs(r[b].center.x - (t.x + f)) || 1E-9 < Math.abs(r[b].center.y -
                                (t.y + g))) r[b].center.x = t.x + f * a, r[b].center.y = t.y + g * a, l = !0
                    } else if (0 < Math.abs(r[b].center.x - t.x) || 0 < Math.abs(r[b].center.y - t.y)) r[b].center.x = t.x + f * (1 - a), r[b].center.y = t.y + g * (1 - a), l = !0;
                    l && (f = {}, f.dataSeries = m, f.dataPoint = m.dataPoints[b], f.index = b, k.toolTip.highlightObjects([f]));
                    Ga(k.plotArea.ctx, r[b].center, r[b].radius, n[b].color ? n[b].color : m._colorSet[b % m._colorSet.length], m.type, c, d, m.fillOpacity, r[b].percentInnerRadius)
                }
            }
            a = k.plotArea.ctx;
            a.save();
            a.fillStyle = "black";
            a.strokeStyle = "grey";
            a.textBaseline =
                "middle";
            a.lineJoin = "round";
            for (b = b = 0; b < n.length; b++) c = r[b], c.indexLabelText && (c.indexLabelTextBlock.y -= c.indexLabelTextBlock.height / 2, d = 0, d = "left" === c.hemisphere ? "inside" !== m.indexLabelPlacement ? -(c.indexLabelTextBlock.width + p) : -c.indexLabelTextBlock.width / 2 : "inside" !== m.indexLabelPlacement ? p : -c.indexLabelTextBlock.width / 2, c.indexLabelTextBlock.x += d, c.indexLabelTextBlock.render(!0), c.indexLabelTextBlock.x -= d, c.indexLabelTextBlock.y += c.indexLabelTextBlock.height / 2, "inside" !== c.indexLabelPlacement &&
                0 < c.indexLabelLineThickness && (d = c.center.x + B * Math.cos(c.midAngle), f = c.center.y + B * Math.sin(c.midAngle), a.strokeStyle = c.indexLabelLineColor, a.lineWidth = c.indexLabelLineThickness, a.setLineDash && a.setLineDash(I(c.indexLabelLineDashType, c.indexLabelLineThickness)), a.beginPath(), a.moveTo(d, f), a.lineTo(c.indexLabelTextBlock.x, c.indexLabelTextBlock.y), a.lineTo(c.indexLabelTextBlock.x + ("left" === c.hemisphere ? -p : p), c.indexLabelTextBlock.y), a.stroke()), a.lineJoin = "miter");
            a.save()
        }

        function c(a, b) {
            var c = 0,
                c = a.indexLabelTextBlock.y -
                a.indexLabelTextBlock.height / 2,
                d = a.indexLabelTextBlock.y + a.indexLabelTextBlock.height / 2,
                e = b.indexLabelTextBlock.y - b.indexLabelTextBlock.height / 2,
                f = b.indexLabelTextBlock.y + b.indexLabelTextBlock.height / 2;
            return c = b.indexLabelTextBlock.y > a.indexLabelTextBlock.y ? e - d : c - f
        }

        function f(a) {
            for (var b = null, d = 1; d < n.length; d++)
                if (b = (a + d + r.length) % r.length, r[b].hemisphere !== r[a].hemisphere) {
                    b = null;
                    break
                } else if (r[b].indexLabelText && b !== a && (0 > c(r[b], r[a]) || ("right" === r[a].hemisphere ? r[b].indexLabelTextBlock.y >= r[a].indexLabelTextBlock.y :
                    r[b].indexLabelTextBlock.y <= r[a].indexLabelTextBlock.y))) break;
            else b = null;
            return b
        }

        function g(a, b, d) {
            d = (d || 0) + 1;
            if (1E3 < d) return 0;
            b = b || 0;
            var e = 0,
                k = t.y - 1 * s,
                l = t.y + 1 * s;
            if (0 <= a && a < n.length) {
                var h = r[a];
                if (0 > b && h.indexLabelTextBlock.y < k || 0 < b && h.indexLabelTextBlock.y > l) return 0;
                var p = 0,
                    m = 0,
                    m = p = p = 0;
                0 > b ? h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 > k && h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 + b < k && (b = -(k - (h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 + b))) : h.indexLabelTextBlock.y +
                    h.indexLabelTextBlock.height / 2 < k && h.indexLabelTextBlock.y + h.indexLabelTextBlock.height / 2 + b > l && (b = h.indexLabelTextBlock.y + h.indexLabelTextBlock.height / 2 + b - l);
                b = h.indexLabelTextBlock.y + b;
                k = 0;
                k = "right" === h.hemisphere ? t.x + Math.sqrt(Math.pow(s, 2) - Math.pow(b - t.y, 2)) : t.x - Math.sqrt(Math.pow(s, 2) - Math.pow(b - t.y, 2));
                m = t.x + B * Math.cos(h.midAngle);
                p = t.y + B * Math.sin(h.midAngle);
                p = Math.sqrt(Math.pow(k - m, 2) + Math.pow(b - p, 2));
                m = Math.acos(B / s);
                p = Math.acos((s * s + B * B - p * p) / (2 * B * s));
                b = p < m ? b - h.indexLabelTextBlock.y : 0;
                k = null;
                for (l = 1; l < n.length; l++)
                    if (k = (a - l + r.length) % r.length, r[k].hemisphere !== r[a].hemisphere) {
                        k = null;
                        break
                    } else if (r[k].indexLabelText && r[k].hemisphere === r[a].hemisphere && k !== a && (0 > c(r[k], r[a]) || ("right" === r[a].hemisphere ? r[k].indexLabelTextBlock.y <= r[a].indexLabelTextBlock.y : r[k].indexLabelTextBlock.y >= r[a].indexLabelTextBlock.y))) break;
                else k = null;
                m = k;
                p = f(a);
                l = k = 0;
                0 > b ? (l = "right" === h.hemisphere ? m : p, e = b, null !== l && (m = -b, b = h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 - (r[l].indexLabelTextBlock.y +
                    r[l].indexLabelTextBlock.height / 2), b - m < q && (k = -m, l = g(l, k, d + 1), +l.toFixed(y) > +k.toFixed(y) && (e = b > q ? -(b - q) : -(m - (l - k)))))) : 0 < b && (l = "right" === h.hemisphere ? p : m, e = b, null !== l && (m = b, b = r[l].indexLabelTextBlock.y - r[l].indexLabelTextBlock.height / 2 - (h.indexLabelTextBlock.y + h.indexLabelTextBlock.height / 2), b - m < q && (k = m, l = g(l, k, d + 1), +l.toFixed(y) < +k.toFixed(y) && (e = b > q ? b - q : m - (k - l)))));
                e && (d = h.indexLabelTextBlock.y + e, b = 0, b = "right" === h.hemisphere ? t.x + Math.sqrt(Math.pow(s, 2) - Math.pow(d - t.y, 2)) : t.x - Math.sqrt(Math.pow(s,
                    2) - Math.pow(d - t.y, 2)), h.midAngle > Math.PI / 2 - w && h.midAngle < Math.PI / 2 + w ? (k = (a - 1 + r.length) % r.length, k = r[k], a = r[(a + 1 + r.length) % r.length], "left" === h.hemisphere && "right" === k.hemisphere && b > k.indexLabelTextBlock.x ? b = k.indexLabelTextBlock.x - 15 : "right" === h.hemisphere && ("left" === a.hemisphere && b < a.indexLabelTextBlock.x) && (b = a.indexLabelTextBlock.x + 15)) : h.midAngle > 3 * Math.PI / 2 - w && h.midAngle < 3 * Math.PI / 2 + w && (k = (a - 1 + r.length) % r.length, k = r[k], a = r[(a + 1 + r.length) % r.length], "right" === h.hemisphere && "left" === k.hemisphere &&
                    b < k.indexLabelTextBlock.x ? b = k.indexLabelTextBlock.x + 15 : "left" === h.hemisphere && ("right" === a.hemisphere && b > a.indexLabelTextBlock.x) && (b = a.indexLabelTextBlock.x - 15)), h.indexLabelTextBlock.y = d, h.indexLabelTextBlock.x = b, h.indexLabelAngle = Math.atan2(h.indexLabelTextBlock.y - t.y, h.indexLabelTextBlock.x - t.x))
            }
            return e
        }

        function h() {
            var a = k.plotArea.ctx;
            a.fillStyle = "grey";
            a.strokeStyle = "grey";
            a.font = "16px Arial";
            a.textBaseline = "middle";
            for (var b = a = 0, d = 0, l = !0, b = 0; 10 > b && (1 > b || 0 < d); b++) {
                if (m.radius || !m.radius &&
                    "undefined" !== typeof m.innerRadius && null !== m.innerRadius && B - d <= E) l = !1;
                l && (B -= d);
                d = 0;
                if ("inside" !== m.indexLabelPlacement) {
                    s = B * v;
                    for (a = 0; a < n.length; a++) {
                        var h = r[a];
                        h.indexLabelTextBlock.x = t.x + s * Math.cos(h.midAngle);
                        h.indexLabelTextBlock.y = t.y + s * Math.sin(h.midAngle);
                        h.indexLabelAngle = h.midAngle;
                        h.radius = B;
                        h.percentInnerRadius = F
                    }
                    for (var w, u, a = 0; a < n.length; a++) {
                        var h = r[a],
                            x = f(a);
                        if (null !== x) {
                            w = r[a];
                            u = r[x];
                            var z = 0,
                                z = c(w, u) - q;
                            if (0 > z) {
                                for (var A = u = 0, D = 0; D < n.length; D++) D !== a && r[D].hemisphere === h.hemisphere &&
                                    (r[D].indexLabelTextBlock.y < h.indexLabelTextBlock.y ? u++ : A++);
                                u = z / (u + A || 1) * A;
                                var A = -1 * (z - u),
                                    C = D = 0;
                                "right" === h.hemisphere ? (D = g(a, u), A = -1 * (z - D), C = g(x, A), +C.toFixed(y) < +A.toFixed(y) && +D.toFixed(y) <= +u.toFixed(y) && g(a, -(A - C))) : (D = g(x, u), A = -1 * (z - D), C = g(a, A), +C.toFixed(y) < +A.toFixed(y) && +D.toFixed(y) <= +u.toFixed(y) && g(x, -(A - C)))
                            }
                        }
                    }
                } else
                    for (a = 0; a < n.length; a++) h = r[a], s = "pie" === m.type ? 0.7 * B : 0.8 * B, x = t.x + s * Math.cos(h.midAngle), u = t.y + s * Math.sin(h.midAngle), h.indexLabelTextBlock.x = x, h.indexLabelTextBlock.y = u;
                for (a = 0; a < n.length; a++)
                    if (h = r[a], x = h.indexLabelTextBlock.measureText(), 0 !== x.height && 0 !== x.width) x = x = 0, "right" === h.hemisphere ? (x = e.x2 - (h.indexLabelTextBlock.x + h.indexLabelTextBlock.width + p), x *= -1) : x = e.x1 - (h.indexLabelTextBlock.x - h.indexLabelTextBlock.width - p), 0 < x && (!l && h.indexLabelText && (u = "right" === h.hemisphere ? e.x2 - h.indexLabelTextBlock.x : h.indexLabelTextBlock.x - e.x1, 0.3 * h.indexLabelTextBlock.maxWidth > u ? h.indexLabelText = "" : h.indexLabelTextBlock.maxWidth = 0.85 * u, 0.3 * h.indexLabelTextBlock.maxWidth <
                        u && (h.indexLabelTextBlock.x -= "right" === h.hemisphere ? 2 : -2)), Math.abs(h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 - t.y) < B || Math.abs(h.indexLabelTextBlock.y + h.indexLabelTextBlock.height / 2 - t.y) < B) && (x /= Math.abs(Math.cos(h.indexLabelAngle)), 9 < x && (x *= 0.3), x > d && (d = x)), x = x = 0, 0 < h.indexLabelAngle && h.indexLabelAngle < Math.PI ? (x = e.y2 - (h.indexLabelTextBlock.y + h.indexLabelTextBlock.height / 2 + 5), x *= -1) : x = e.y1 - (h.indexLabelTextBlock.y - h.indexLabelTextBlock.height / 2 - 5), 0 < x && (!l && h.indexLabelText && (u = 0 < h.indexLabelAngle &&
                        h.indexLabelAngle < Math.PI ? -1 : 1, 0 === g(a, x * u) && g(a, 2 * u)), Math.abs(h.indexLabelTextBlock.x - t.x) < B && (x /= Math.abs(Math.sin(h.indexLabelAngle)), 9 < x && (x *= 0.3), x > d && (d = x)));
                var G = function(a, b, c) {
                    for (var d = [], e = 0; d.push(r[b]), b !== c; b = (b + 1 + n.length) % n.length);
                    d.sort(function(a, b) {
                        return a.y - b.y
                    });
                    for (b = 0; b < d.length; b++)
                        if (c = d[b], e < 0.7 * a) e += c.indexLabelTextBlock.height, c.indexLabelTextBlock.text = "", c.indexLabelText = "", c.indexLabelTextBlock.measureText();
                        else break
                };
                (function() {
                    for (var a = -1, b = -1, d = 0, e = !1, g = 0; g <
                        n.length; g++)
                        if (e = !1, w = r[g], w.indexLabelText) {
                            var h = f(g);
                            if (null !== h) {
                                var k = r[h];
                                z = 0;
                                z = c(w, k);
                                var l;
                                if (l = 0 > z) {
                                    l = w.indexLabelTextBlock.x;
                                    var m = w.indexLabelTextBlock.y - w.indexLabelTextBlock.height / 2,
                                        q = w.indexLabelTextBlock.y + w.indexLabelTextBlock.height / 2,
                                        s = k.indexLabelTextBlock.y - k.indexLabelTextBlock.height / 2,
                                        t = k.indexLabelTextBlock.x + k.indexLabelTextBlock.width,
                                        v = k.indexLabelTextBlock.y + k.indexLabelTextBlock.height / 2;
                                    l = w.indexLabelTextBlock.x + w.indexLabelTextBlock.width < k.indexLabelTextBlock.x - p ||
                                        l > t + p || m > v + p || q < s - p ? !1 : !0
                                }
                                l ? (0 > a && (a = g), h !== a && (b = h, d += -z), 0 === g % Math.max(n.length / 10, 3) && (e = !0)) : e = !0;
                                e && (0 < d && 0 <= a && 0 <= b) && (G(d, a, b), b = a = -1, d = 0)
                            }
                        }
                    0 < d && G(d, a, b)
                })()
            }
        }

        function l() {
            k.plotArea.layoutManager.reset();
            k.title && (k.title.dockInsidePlotArea || "center" === k.title.horizontalAlign && "center" === k.title.verticalAlign) && k.title.render();
            if (k.subtitles)
                for (var a = 0; a < k.subtitles.length; a++) {
                    var b = k.subtitles[a];
                    (b.dockInsidePlotArea || "center" === b.horizontalAlign && "center" === b.verticalAlign) && b.render()
                }
            k.legend &&
                (k.legend.dockInsidePlotArea || "center" === k.legend.horizontalAlign && "center" === k.legend.verticalAlign) && k.legend.render();
            z.fNg && z.fNg(k)
        }
        var k = this;
        if (!(0 >= a.dataSeriesIndexes.length)) {
            var m = this.data[a.dataSeriesIndexes[0]],
                n = m.dataPoints,
                p = 10,
                e = this.plotArea,
                r = [],
                q = 2,
                s, v = 1.3,
                w = 20 / 180 * Math.PI,
                y = 6,
                t = {
                    x: (e.x2 + e.x1) / 2,
                    y: (e.y2 + e.y1) / 2
                },
                u = 0;
            a = !1;
            for (var A = 0; A < n.length; A++) u += Math.abs(n[A].y), !a && ("undefined" !== typeof n[A].indexLabel && null !== n[A].indexLabel && 0 < n[A].indexLabel.toString().length) && (a = !0), !a && ("undefined" !== typeof n[A].label && null !== n[A].label && 0 < n[A].label.toString().length) && (a = !0);
            if (0 !== u) {
                a = a || "undefined" !== typeof m.indexLabel && null !== m.indexLabel && 0 < m.indexLabel.toString().length;
                var B = "inside" !== m.indexLabelPlacement && a ? 0.75 * Math.min(e.width, e.height) / 2 : 0.92 * Math.min(e.width, e.height) / 2;
                m.radius && (B = Na(m.radius, B));
                var E = "undefined" !== typeof m.innerRadius && null !== m.innerRadius ? Na(m.innerRadius, B) : 0.7 * B;
                m.radius = B;
                "doughnut" === m.type && (m.innerRadius = E);
                var F = Math.min(E / B, (B -
                    1) / B);
                this.pieDoughnutClickHandler = function(a) {
                    k.isAnimating || !x(a.dataSeries.explodeOnClick) && !a.dataSeries.explodeOnClick || (a = a.dataPoint, a.exploded = a.exploded ? !1 : !0, 1 < this.dataPoints.length && k._animator.animate(0, 500, function(a) {
                        b(a);
                        l()
                    }))
                };
                d();
                h();
                h();
                h();
                h();
                this.disableToolTip = !0;
                this._animator.animate(0, this.animatedRender ? this.animationDuration : 0, function(a) {
                    var b = k.plotArea.ctx;
                    b.clearRect(e.x1, e.y1, e.width, e.height);
                    b.fillStyle = k.backgroundColor;
                    b.fillRect(e.x1, e.y1, e.width, e.height);
                    a =
                        r[0].startAngle + 2 * Math.PI * a;
                    for (b = 0; b < n.length; b++) {
                        var c = 0 === b ? r[b].startAngle : d,
                            d = c + (r[b].endAngle - r[b].startAngle),
                            f = !1;
                        d > a && (d = a, f = !0);
                        var g = n[b].color ? n[b].color : m._colorSet[b % m._colorSet.length];
                        d > c && Ga(k.plotArea.ctx, r[b].center, r[b].radius, g, m.type, c, d, m.fillOpacity, r[b].percentInnerRadius);
                        if (f) break
                    }
                    l()
                }, function() {
                    k.disableToolTip = !1;
                    k._animator.animate(0, k.animatedRender ? 500 : 0, function(a) {
                        b(a);
                        l()
                    })
                })
            }
        }
    };
    A.prototype.animationRequestId = null;
    A.prototype.requestAnimFrame = function() {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(a) {
                window.setTimeout(a, 1E3 / 60)
            }
    }();
    A.prototype.cancelRequestAnimFrame = window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;
    A.prototype.set = function(a, d, b) {
        b = "undefined" === typeof b ? !0 : b;
        "options" === a ? (this.options = d,
            b && this.render()) : A.base.set.call(this, a, d, b)
    };
    A.prototype.exportChart = function(a) {
        a = "undefined" === typeof a ? {} : a;
        var d = a.format ? a.format : "png",
            b = a.fileName ? a.fileName : this.exportFileName;
        if (a.toDataURL) return this.canvas.toDataURL("image/" + d);
        Ba(this.canvas, d, b)
    };
    A.prototype.print = function() {
        var a = this.exportChart({
                toDataURL: !0
            }),
            d = document.createElement("iframe");
        d.setAttribute("class", "canvasjs-chart-print-frame");
        d.setAttribute("style", "position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;");
        d.style.height = this.height + "px";
        this._canvasJSContainer.appendChild(d);
        var b = this,
            c = d.contentWindow || d.contentDocument.document || d.contentDocument;
        c.document.open();
        c.document.write('<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="' + a + '"/><body/></html>');
        c.document.close();
        setTimeout(function() {
            c.focus();
            c.print();
            setTimeout(function() {
                b._canvasJSContainer.removeChild(d)
            }, 1E3)
        }, 500)
    };
    ja.prototype.registerSpace = function(a, d) {
        "top" === a ? this._topOccupied +=
            d.height : "bottom" === a ? this._bottomOccupied += d.height : "left" === a ? this._leftOccupied += d.width : "right" === a && (this._rightOccupied += d.width)
    };
    ja.prototype.unRegisterSpace = function(a, d) {
        "top" === a ? this._topOccupied -= d.height : "bottom" === a ? this._bottomOccupied -= d.height : "left" === a ? this._leftOccupied -= d.width : "right" === a && (this._rightOccupied -= d.width)
    };
    ja.prototype.getFreeSpace = function() {
        return {
            x1: this._x1 + this._leftOccupied,
            y1: this._y1 + this._topOccupied,
            x2: this._x2 - this._rightOccupied,
            y2: this._y2 - this._bottomOccupied,
            width: this._x2 - this._x1 - this._rightOccupied - this._leftOccupied,
            height: this._y2 - this._y1 - this._bottomOccupied - this._topOccupied
        }
    };
    ja.prototype.reset = function() {
        this._rightOccupied = this._leftOccupied = this._bottomOccupied = this._topOccupied = this._padding
    };
    U(W, M);
    W.prototype.render = function(a) {
        a && this.ctx.save();
        var d = this.ctx.font;
        this.ctx.textBaseline = this.textBaseline;
        var b = 0;
        this._isDirty && this.measureText(this.ctx);
        this.ctx.translate(this.x, this.y + b);
        "middle" === this.textBaseline && (b = -this._lineHeight /
            2);
        this.ctx.font = this._getFontString();
        this.ctx.rotate(Math.PI / 180 * this.angle);
        var c = 0,
            f = this.padding,
            g = null;
        (0 < this.borderThickness && this.borderColor || this.backgroundColor) && this.ctx.roundRect(0, b, this.width, this.height, this.cornerRadius, this.borderThickness, this.backgroundColor, this.borderColor);
        this.ctx.fillStyle = this.fontColor;
        for (b = 0; b < this._wrappedText.lines.length; b++) g = this._wrappedText.lines[b], "right" === this.horizontalAlign ? c = this.width - g.width - this.padding : "left" === this.horizontalAlign ?
            c = this.padding : "center" === this.horizontalAlign && (c = (this.width - 2 * this.padding) / 2 - g.width / 2 + this.padding), this.ctx.fillText(g.text, c, f), f += g.height;
        this.ctx.font = d;
        a && this.ctx.restore()
    };
    W.prototype.setText = function(a) {
        this.text = a;
        this._isDirty = !0;
        this._wrappedText = null
    };
    W.prototype.measureText = function() {
        this._lineHeight = Ja(this.fontFamily, this.fontSize, this.fontWeight);
        if (null === this.maxWidth) throw "Please set maxWidth and height for TextBlock";
        this._wrapText(this.ctx);
        this._isDirty = !1;
        return {
            width: this.width,
            height: this.height
        }
    };
    W.prototype._getLineWithWidth = function(a, d, b) {
        a = String(a);
        if (!a) return {
            text: "",
            width: 0
        };
        var c = b = 0,
            f = a.length - 1,
            g = Infinity;
        for (this.ctx.font = this._getFontString(); c <= f;) {
            var g = Math.floor((c + f) / 2),
                h = a.substr(0, g + 1);
            b = this.ctx.measureText(h).width;
            if (b < d) c = g + 1;
            else if (b > d) f = g - 1;
            else break
        }
        b > d && 1 < h.length && (h = h.substr(0, h.length - 1), b = this.ctx.measureText(h).width);
        d = !0;
        if (h.length === a.length || " " === a[h.length]) d = !1;
        d && (a = h.split(" "), 1 < a.length && a.pop(), h = a.join(" "), b = this.ctx.measureText(h).width);
        return {
            text: h,
            width: b
        }
    };
    W.prototype._wrapText = function() {
        var a = new String(ka(String(this.text))),
            d = [],
            b = this.ctx.font,
            c = 0,
            f = 0;
        for (this.ctx.font = this._getFontString(); 0 < a.length;) {
            var g = this.maxHeight - 2 * this.padding,
                h = this._getLineWithWidth(a, this.maxWidth - 2 * this.padding, !1);
            h.height = this._lineHeight;
            d.push(h);
            var l = f,
                f = Math.max(f, h.width),
                c = c + h.height,
                a = ka(a.slice(h.text.length, a.length));
            g && c > g && (h = d.pop(), c -= h.height, f = l)
        }
        this._wrappedText = {
            lines: d,
            width: f,
            height: c
        };
        this.width = f + 2 * this.padding;
        this.height = c + 2 * this.padding;
        this.ctx.font = b
    };
    W.prototype._getFontString = function() {
        var a;
        a = "" + (this.fontStyle ? this.fontStyle + " " : "");
        a += this.fontWeight ? this.fontWeight + " " : "";
        a += this.fontSize ? this.fontSize + "px " : "";
        var d = this.fontFamily ? this.fontFamily + "" : "";
        !u && d && (d = d.split(",")[0], "'" !== d[0] && '"' !== d[0] && (d = "'" + d + "'"));
        return a += d
    };
    U(ma, M);
    ma.prototype.render = function() {
        if (this.text) {
            var a = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
                d = a.layoutManager.getFreeSpace(),
                b = d.x1,
                c = d.y1,
                f =
                0,
                g = 0,
                h = this.chart._menuButton && this.chart.exportEnabled && "top" === this.verticalAlign ? 22 : 0,
                l, k;
            "top" === this.verticalAlign || "bottom" === this.verticalAlign ? (null === this.maxWidth && (this.maxWidth = d.width - 4 - h * ("center" === this.horizontalAlign ? 2 : 1)), g = 0.5 * d.height - this.margin - 2, f = 0) : "center" === this.verticalAlign && ("left" === this.horizontalAlign || "right" === this.horizontalAlign ? (null === this.maxWidth && (this.maxWidth = d.height - 4), g = 0.5 * d.width - this.margin - 2) : "center" === this.horizontalAlign && (null === this.maxWidth &&
                (this.maxWidth = d.width - 4), g = 0.5 * d.height - 4));
            this.wrap || (g = Math.min(g, Math.max(1.5 * this.fontSize, this.fontSize + 2.5 * this.padding)));
            var g = new W(this.ctx, {
                    fontSize: this.fontSize,
                    fontFamily: this.fontFamily,
                    fontColor: this.fontColor,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    horizontalAlign: this.horizontalAlign,
                    verticalAlign: this.verticalAlign,
                    borderColor: this.borderColor,
                    borderThickness: this.borderThickness,
                    backgroundColor: this.backgroundColor,
                    maxWidth: this.maxWidth,
                    maxHeight: g,
                    cornerRadius: this.cornerRadius,
                    text: this.text,
                    padding: this.padding,
                    textBaseline: "top"
                }),
                m = g.measureText();
            "top" === this.verticalAlign || "bottom" === this.verticalAlign ? ("top" === this.verticalAlign ? (c = d.y1 + 2, k = "top") : "bottom" === this.verticalAlign && (c = d.y2 - 2 - m.height, k = "bottom"), "left" === this.horizontalAlign ? b = d.x1 + 2 : "center" === this.horizontalAlign ? b = d.x1 + d.width / 2 - m.width / 2 : "right" === this.horizontalAlign && (b = d.x2 - 2 - m.width - h), l = this.horizontalAlign, this.width = m.width, this.height = m.height) : "center" === this.verticalAlign && ("left" === this.horizontalAlign ?
                (b = d.x1 + 2, c = d.y2 - 2 - (this.maxWidth / 2 - m.width / 2), f = -90, k = "left", this.width = m.height, this.height = m.width) : "right" === this.horizontalAlign ? (b = d.x2 - 2, c = d.y1 + 2 + (this.maxWidth / 2 - m.width / 2), f = 90, k = "right", this.width = m.height, this.height = m.width) : "center" === this.horizontalAlign && (c = a.y1 + (a.height / 2 - m.height / 2), b = a.x1 + (a.width / 2 - m.width / 2), k = "center", this.width = m.width, this.height = m.height), l = "center");
            g.x = b;
            g.y = c;
            g.angle = f;
            g.horizontalAlign = l;
            g.render(!0);
            a.layoutManager.registerSpace(k, {
                width: this.width + ("left" ===
                    k || "right" === k ? this.margin + 2 : 0),
                height: this.height + ("top" === k || "bottom" === k ? this.margin + 2 : 0)
            });
            this.bounds = {
                x1: b,
                y1: c,
                x2: b + this.width,
                y2: c + this.height
            };
            this.ctx.textBaseline = "top"
        }
    };
    U(va, M);
    va.prototype.render = ma.prototype.render;
    U(wa, M);
    wa.prototype.render = function() {
        var a = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
            d = a.layoutManager.getFreeSpace(),
            b = null,
            c = 0,
            f = 0,
            g = 0,
            h = 0,
            l = this.markerMargin = this.chart.options.legend && !x(this.chart.options.legend.markerMargin) ? this.chart.options.legend.markerMargin :
            0.3 * this.fontSize;
        this.height = 0;
        var k = [],
            m = [];
        "top" === this.verticalAlign || "bottom" === this.verticalAlign ? (this.orientation = "horizontal", b = this.verticalAlign, g = this.maxWidth = null !== this.maxWidth ? this.maxWidth : d.width, h = this.maxHeight = null !== this.maxHeight ? this.maxHeight : 0.5 * d.height) : "center" === this.verticalAlign && (this.orientation = "vertical", b = this.horizontalAlign, g = this.maxWidth = null !== this.maxWidth ? this.maxWidth : 0.5 * d.width, h = this.maxHeight = null !== this.maxHeight ? this.maxHeight : d.height);
        for (var n =
                0; n < this.dataSeries.length; n++) {
            var p = this.dataSeries[n];
            if ("pie" !== p.type && "doughnut" !== p.type && "funnel" !== p.type) {
                var e = p.legendMarkerType = p.legendMarkerType ? p.legendMarkerType : "line" !== p.type && "stepLine" !== p.type && "spline" !== p.type && "scatter" !== p.type && "bubble" !== p.type || !p.markerType ? $.getDefaultLegendMarker(p.type) : p.markerType,
                    r = p.legendText ? p.legendText : this.itemTextFormatter ? this.itemTextFormatter({
                        chart: this.chart,
                        legend: this.options,
                        dataSeries: p,
                        dataPoint: null
                    }) : p.name,
                    q = p.legendMarkerColor =
                    p.legendMarkerColor ? p.legendMarkerColor : p.markerColor ? p.markerColor : p._colorSet[0],
                    s = p.markerSize || "line" !== p.type && "stepLine" !== p.type && "spline" !== p.type ? 0.75 * this.lineHeight : 0,
                    v = p.legendMarkerBorderColor ? p.legendMarkerBorderColor : p.markerBorderColor,
                    w = p.legendMarkerBorderThickness ? p.legendMarkerBorderThickness : p.markerBorderThickness ? Math.max(1, Math.round(0.2 * s)) : 0,
                    r = this.chart.replaceKeywordsWithValue(r, p.dataPoints[0], p, n),
                    e = {
                        markerType: e,
                        markerColor: q,
                        text: r,
                        textBlock: null,
                        chartType: p.type,
                        markerSize: s,
                        lineColor: p._colorSet[0],
                        dataSeriesIndex: p.index,
                        dataPointIndex: null,
                        markerBorderColor: v,
                        markerBorderThickness: w
                    };
                k.push(e)
            } else
                for (var u = 0; u < p.dataPoints.length; u++) {
                    var t = p.dataPoints[u],
                        e = t.legendMarkerType ? t.legendMarkerType : p.legendMarkerType ? p.legendMarkerType : $.getDefaultLegendMarker(p.type),
                        r = t.legendText ? t.legendText : p.legendText ? p.legendText : this.itemTextFormatter ? this.itemTextFormatter({
                            chart: this.chart,
                            legend: this.options,
                            dataSeries: p,
                            dataPoint: t
                        }) : t.name ? t.name : "DataPoint: " + (u + 1),
                        q =
                        t.legendMarkerColor ? t.legendMarkerColor : p.legendMarkerColor ? p.legendMarkerColor : t.color ? t.color : p.color ? p.color : p._colorSet[u % p._colorSet.length],
                        s = 0.75 * this.lineHeight,
                        v = t.legendMarkerBorderColor ? t.legendMarkerBorderColor : p.legendMarkerBorderColor ? p.legendMarkerBorderColor : t.markerBorderColor ? t.markerBorderColor : p.markerBorderColor,
                        w = t.legendMarkerBorderThickness ? t.legendMarkerBorderThickness : p.legendMarkerBorderThickness ? p.legendMarkerBorderThickness : t.markerBorderThickness || p.markerBorderThickness ?
                        Math.max(1, Math.round(0.2 * s)) : 0,
                        r = this.chart.replaceKeywordsWithValue(r, t, p, u),
                        e = {
                            markerType: e,
                            markerColor: q,
                            text: r,
                            textBlock: null,
                            chartType: p.type,
                            markerSize: s,
                            dataSeriesIndex: n,
                            dataPointIndex: u,
                            markerBorderColor: v,
                            markerBorderThickness: w
                        };
                    (t.showInLegend || p.showInLegend && !1 !== t.showInLegend) && k.push(e)
                }
        }!0 === this.reversed && k.reverse();
        if (0 < k.length) {
            p = null;
            q = u = r = t = 0;
            r = null !== this.itemWidth ? null !== this.itemMaxWidth ? Math.min(this.itemWidth, this.itemMaxWidth, g) : this.itemMaxWidth = Math.min(this.itemWidth,
                g) : null !== this.itemMaxWidth ? Math.min(this.itemMaxWidth, g) : this.itemMaxWidth = g;
            s = 0 === s ? 0.75 * this.lineHeight : s;
            r -= s + l;
            for (n = 0; n < k.length; n++) {
                e = k[n];
                if ("line" === e.chartType || "spline" === e.chartType || "stepLine" === e.chartType) r -= 2 * 0.1 * this.lineHeight;
                if (!(0 >= h || "undefined" === typeof h || 0 >= r || "undefined" === typeof r)) {
                    if ("horizontal" === this.orientation) {
                        e.textBlock = new W(this.ctx, {
                            x: 0,
                            y: 0,
                            maxWidth: r,
                            maxHeight: this.itemWrap ? h : this.lineHeight,
                            angle: 0,
                            text: e.text,
                            horizontalAlign: "left",
                            fontSize: this.fontSize,
                            fontFamily: this.fontFamily,
                            fontWeight: this.fontWeight,
                            fontColor: this.fontColor,
                            fontStyle: this.fontStyle,
                            textBaseline: "middle"
                        });
                        e.textBlock.measureText();
                        null !== this.itemWidth && (e.textBlock.width = this.itemWidth - (s + l + ("line" === e.chartType || "spline" === e.chartType || "stepLine" === e.chartType ? 2 * 0.1 * this.lineHeight : 0)));
                        if (!p || p.width + Math.round(e.textBlock.width + s + l + (0 === p.width ? 0 : this.horizontalSpacing) + ("line" === e.chartType || "spline" === e.chartType || "stepLine" === e.chartType ? 2 * 0.1 * this.lineHeight : 0)) > g) p = {
                            items: [],
                            width: 0
                        }, m.push(p), this.height += u, u = 0;
                        u = Math.max(u, e.textBlock.height)
                    } else e.textBlock = new W(this.ctx, {
                        x: 0,
                        y: 0,
                        maxWidth: r,
                        maxHeight: !0 === this.itemWrap ? h : 1.5 * this.fontSize,
                        angle: 0,
                        text: e.text,
                        horizontalAlign: "left",
                        fontSize: this.fontSize,
                        fontFamily: this.fontFamily,
                        fontWeight: this.fontWeight,
                        fontColor: this.fontColor,
                        fontStyle: this.fontStyle,
                        textBaseline: "middle"
                    }), e.textBlock.measureText(), null !== this.itemWidth && (e.textBlock.width = this.itemWidth - (s + l + ("line" === e.chartType || "spline" === e.chartType ||
                        "stepLine" === e.chartType ? 2 * 0.1 * this.lineHeight : 0))), this.height < h - this.lineHeight ? (p = {
                        items: [],
                        width: 0
                    }, m.push(p)) : (p = m[t], t = (t + 1) % m.length), this.height += e.textBlock.height;
                    e.textBlock.x = p.width;
                    e.textBlock.y = 0;
                    p.width += Math.round(e.textBlock.width + s + l + (0 === p.width ? 0 : this.horizontalSpacing) + ("line" === e.chartType || "spline" === e.chartType || "stepLine" === e.chartType ? 2 * 0.1 * this.lineHeight : 0));
                    p.items.push(e);
                    this.width = Math.max(p.width, this.width);
                    q = e.textBlock.width + (s + l + ("line" === e.chartType || "spline" ===
                        e.chartType || "stepLine" === e.chartType ? 2 * 0.1 * this.lineHeight : 0))
                }
            }
            this.itemWidth = q;
            this.height = !1 === this.itemWrap ? m.length * this.lineHeight : this.height + u;
            this.height = Math.min(h, this.height);
            this.width = Math.min(g, this.width)
        }
        "top" === this.verticalAlign ? (f = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width / 2, c = d.y1) : "center" === this.verticalAlign ? (f = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width /
            2, c = d.y1 + d.height / 2 - this.height / 2) : "bottom" === this.verticalAlign && (f = "left" === this.horizontalAlign ? d.x1 : "right" === this.horizontalAlign ? d.x2 - this.width : d.x1 + d.width / 2 - this.width / 2, c = d.y2 - this.height);
        this.items = k;
        for (n = 0; n < this.items.length; n++) e = k[n], e.id = ++this.chart._eventManager.lastObjectId, this.chart._eventManager.objectMap[e.id] = {
            id: e.id,
            objectType: "legendItem",
            legendItemIndex: n,
            dataSeriesIndex: e.dataSeriesIndex,
            dataPointIndex: e.dataPointIndex
        };
        (0 < this.borderThickness && this.borderColor || this.backgroundColor) &&
        this.ctx.roundRect(f, c, this.width, this.height, this.cornerRadius, this.borderThickness, this.backgroundColor, this.borderColor);
        for (n = d = 0; n < m.length; n++) {
            p = m[n];
            for (t = u = 0; t < p.items.length; t++) {
                e = p.items[t];
                q = e.textBlock.x + f + (0 === t ? 0.2 * s : this.horizontalSpacing);
                v = c + d;
                r = q;
                this.chart.data[e.dataSeriesIndex].visible || (this.ctx.globalAlpha = 0.5);
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.rect(f, c, g, Math.max(h - h % this.lineHeight, 0));
                this.ctx.clip();
                if ("line" === e.chartType || "stepLine" === e.chartType || "spline" ===
                    e.chartType) this.ctx.strokeStyle = e.lineColor, this.ctx.lineWidth = Math.ceil(this.lineHeight / 8), this.ctx.beginPath(), this.ctx.moveTo(q - 0.1 * this.lineHeight, v + this.lineHeight / 2), this.ctx.lineTo(q + 0.85 * this.lineHeight, v + this.lineHeight / 2), this.ctx.stroke(), r -= 0.1 * this.lineHeight;
                P.drawMarker(q + s / 2, v + this.lineHeight / 2, this.ctx, e.markerType, e.markerSize, e.markerColor, e.markerBorderColor, e.markerBorderThickness);
                e.textBlock.x = q + l + s;
                if ("line" === e.chartType || "stepLine" === e.chartType || "spline" === e.chartType) e.textBlock.x +=
                    0.1 * this.lineHeight;
                e.textBlock.y = Math.round(v + this.lineHeight / 2);
                e.textBlock.render(!0);
                this.ctx.restore();
                u = 0 < t ? Math.max(u, e.textBlock.height) : e.textBlock.height;
                this.chart.data[e.dataSeriesIndex].visible || (this.ctx.globalAlpha = 1);
                q = G(e.id);
                this.ghostCtx.fillStyle = q;
                this.ghostCtx.beginPath();
                this.ghostCtx.fillRect(r, e.textBlock.y - this.lineHeight / 2, e.textBlock.x + e.textBlock.width - r, e.textBlock.height);
                e.x1 = this.chart._eventManager.objectMap[e.id].x1 = r;
                e.y1 = this.chart._eventManager.objectMap[e.id].y1 =
                    e.textBlock.y - this.lineHeight / 2;
                e.x2 = this.chart._eventManager.objectMap[e.id].x2 = e.textBlock.x + e.textBlock.width;
                e.y2 = this.chart._eventManager.objectMap[e.id].y2 = e.textBlock.y + e.textBlock.height - this.lineHeight / 2
            }
            d += u
        }
        0 < k.length && a.layoutManager.registerSpace(b, {
            width: this.width + 2 + 2,
            height: this.height + 5 + 5
        });
        this.bounds = {
            x1: f,
            y1: c,
            x2: f + this.width,
            y2: c + this.height
        }
    };
    U(Ca, M);
    Ca.prototype.render = function() {
        var a = this.chart.layoutManager.getFreeSpace();
        this.ctx.fillStyle = "red";
        this.ctx.fillRect(a.x1, a.y1,
            a.x2, a.y2)
    };
    U($, M);
    $.prototype.getDefaultAxisPlacement = function() {
        var a = this.type;
        if ("column" === a || "line" === a || "stepLine" === a || "spline" === a || "area" === a || "stepArea" === a || "splineArea" === a || "stackedColumn" === a || "stackedLine" === a || "bubble" === a || "scatter" === a || "stackedArea" === a || "stackedColumn100" === a || "stackedLine100" === a || "stackedArea100" === a || "candlestick" === a || "ohlc" === a || "rangeColumn" === a || "rangeArea" === a || "rangeSplineArea" === a) return "normal";
        if ("bar" === a || "stackedBar" === a || "stackedBar100" === a || "rangeBar" ===
            a) return "xySwapped";
        if ("pie" === a || "doughnut" === a || "funnel" === a) return "none";
        window.console.log("Unknown Chart Type: " + a);
        return null
    };
    $.getDefaultLegendMarker = function(a) {
        if ("column" === a || "stackedColumn" === a || "stackedLine" === a || "bar" === a || "stackedBar" === a || "stackedBar100" === a || "bubble" === a || "scatter" === a || "stackedColumn100" === a || "stackedLine100" === a || "stepArea" === a || "candlestick" === a || "ohlc" === a || "rangeColumn" === a || "rangeBar" === a || "rangeArea" === a || "rangeSplineArea" === a) return "square";
        if ("line" ===
            a || "stepLine" === a || "spline" === a || "pie" === a || "doughnut" === a || "funnel" === a) return "circle";
        if ("area" === a || "splineArea" === a || "stackedArea" === a || "stackedArea100" === a) return "triangle";
        window.console.log("Unknown Chart Type: " + a);
        return null
    };
    $.prototype.getDataPointAtX = function(a, d) {
        if (!this.dataPoints || 0 === this.dataPoints.length) return null;
        var b = {
                dataPoint: null,
                distance: Infinity,
                index: NaN
            },
            c = null,
            f = 0,
            g = 0,
            h = 1,
            l = Infinity,
            k = 0,
            m = 0,
            n = 0;
        "none" !== this.chart.plotInfo.axisPlacement && (this.axisX.logarithmic ? (n =
            Math.log(this.dataPoints[this.dataPoints.length - 1].x / this.dataPoints[0].x), n = 1 < n ? Math.min(Math.max((this.dataPoints.length - 1) / n * Math.log(a / this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0) : (n = this.dataPoints[this.dataPoints.length - 1].x - this.dataPoints[0].x, n = 0 < n ? Math.min(Math.max((this.dataPoints.length - 1) / n * (a - this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0));
        for (;;) {
            g = 0 < h ? n + f : n - f;
            if (0 <= g && g < this.dataPoints.length) {
                var c = this.dataPoints[g],
                    p = this.axisX.logarithmic ? c.x > a ? c.x / a : a / c.x : Math.abs(c.x -
                        a);
                p < b.distance && (b.dataPoint = c, b.distance = p, b.index = g);
                c = p;
                c <= l ? l = c : 0 < h ? k++ : m++;
                if (1E3 < k && 1E3 < m) break
            } else if (0 > n - f && n + f >= this.dataPoints.length) break; - 1 === h ? (f++, h = 1) : h = -1
        }
        return d || b.dataPoint.x !== a ? d && null !== b.dataPoint ? b : null : b
    };
    $.prototype.getDataPointAtXY = function(a, d, b) {
        if (!this.dataPoints || 0 === this.dataPoints.length || a < this.chart.plotArea.x1 || a > this.chart.plotArea.x2 || d < this.chart.plotArea.y1 || d > this.chart.plotArea.y2) return null;
        b = b || !1;
        var c = [],
            f = 0,
            g = 0,
            h = 1,
            l = !1,
            k = Infinity,
            m = 0,
            n = 0,
            p = 0;
        "none" !==
        this.chart.plotInfo.axisPlacement && (p = (this.chart.axisX[0] ? this.chart.axisX[0] : this.chart.axisX2[0]).getXValueAt({
            x: a,
            y: d
        }), this.axisX.logarithmic ? (g = Math.log(this.dataPoints[this.dataPoints.length - 1].x / this.dataPoints[0].x), p = 1 < g ? Math.min(Math.max((this.dataPoints.length - 1) / g * Math.log(p / this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) : 0) : (g = this.dataPoints[this.dataPoints.length - 1].x - this.dataPoints[0].x, p = 0 < g ? Math.min(Math.max((this.dataPoints.length - 1) / g * (p - this.dataPoints[0].x) >> 0, 0), this.dataPoints.length) :
            0));
        for (;;) {
            g = 0 < h ? p + f : p - f;
            if (0 <= g && g < this.dataPoints.length) {
                var e = this.chart._eventManager.objectMap[this.dataPointIds[g]],
                    r = this.dataPoints[g],
                    q = null;
                if (e) {
                    switch (this.type) {
                        case "column":
                        case "stackedColumn":
                        case "stackedColumn100":
                        case "bar":
                        case "stackedBar":
                        case "stackedBar100":
                        case "rangeColumn":
                        case "rangeBar":
                            a >= e.x1 && (a <= e.x2 && d >= e.y1 && d <= e.y2) && (c.push({
                                    dataPoint: r,
                                    dataPointIndex: g,
                                    dataSeries: this,
                                    distance: Math.min(Math.abs(e.x1 - a), Math.abs(e.x2 - a), Math.abs(e.y1 - d), Math.abs(e.y2 - d))
                                }),
                                l = !0);
                            break;
                        case "line":
                        case "stepLine":
                        case "spline":
                        case "area":
                        case "stepArea":
                        case "stackedArea":
                        case "stackedArea100":
                        case "splineArea":
                        case "scatter":
                            var s = L("markerSize", r, this) || 4,
                                v = b ? 20 : s,
                                q = Math.sqrt(Math.pow(e.x1 - a, 2) + Math.pow(e.y1 - d, 2));
                            q <= v && c.push({
                                dataPoint: r,
                                dataPointIndex: g,
                                dataSeries: this,
                                distance: q
                            });
                            g = Math.abs(e.x1 - a);
                            g <= k ? k = g : 0 < h ? m++ : n++;
                            q <= s / 2 && (l = !0);
                            break;
                        case "rangeArea":
                        case "rangeSplineArea":
                            s = L("markerSize", r, this) || 4;
                            v = b ? 20 : s;
                            q = Math.min(Math.sqrt(Math.pow(e.x1 - a, 2) + Math.pow(e.y1 -
                                d, 2)), Math.sqrt(Math.pow(e.x1 - a, 2) + Math.pow(e.y2 - d, 2)));
                            q <= v && c.push({
                                dataPoint: r,
                                dataPointIndex: g,
                                dataSeries: this,
                                distance: q
                            });
                            g = Math.abs(e.x1 - a);
                            g <= k ? k = g : 0 < h ? m++ : n++;
                            q <= s / 2 && (l = !0);
                            break;
                        case "bubble":
                            s = e.size;
                            q = Math.sqrt(Math.pow(e.x1 - a, 2) + Math.pow(e.y1 - d, 2));
                            q <= s / 2 && (c.push({
                                dataPoint: r,
                                dataPointIndex: g,
                                dataSeries: this,
                                distance: q
                            }), l = !0);
                            break;
                        case "pie":
                        case "doughnut":
                            s = e.center;
                            v = "doughnut" === this.type ? e.percentInnerRadius * e.radius : 0;
                            q = Math.sqrt(Math.pow(s.x - a, 2) + Math.pow(s.y - d, 2));
                            q < e.radius &&
                                q > v && (q = Math.atan2(d - s.y, a - s.x), 0 > q && (q += 2 * Math.PI), q = Number(((180 * (q / Math.PI) % 360 + 360) % 360).toFixed(12)), s = Number(((180 * (e.startAngle / Math.PI) % 360 + 360) % 360).toFixed(12)), v = Number(((180 * (e.endAngle / Math.PI) % 360 + 360) % 360).toFixed(12)), 0 === v && 1 < e.endAngle && (v = 360), s >= v && 0 !== r.y && (v += 360, q < s && (q += 360)), q > s && q < v && (c.push({
                                    dataPoint: r,
                                    dataPointIndex: g,
                                    dataSeries: this,
                                    distance: 0
                                }), l = !0));
                            break;
                        case "candlestick":
                            if (a >= e.x1 - e.borderThickness / 2 && a <= e.x2 + e.borderThickness / 2 && d >= e.y2 - e.borderThickness / 2 && d <=
                                e.y3 + e.borderThickness / 2 || Math.abs(e.x2 - a + e.x1 - a) < e.borderThickness && d >= e.y1 && d <= e.y4) c.push({
                                dataPoint: r,
                                dataPointIndex: g,
                                dataSeries: this,
                                distance: Math.min(Math.abs(e.x1 - a), Math.abs(e.x2 - a), Math.abs(e.y2 - d), Math.abs(e.y3 - d))
                            }), l = !0;
                            break;
                        case "ohlc":
                            if (Math.abs(e.x2 - a + e.x1 - a) < e.borderThickness && d >= e.y2 && d <= e.y3 || a >= e.x1 && a <= (e.x2 + e.x1) / 2 && d >= e.y1 - e.borderThickness / 2 && d <= e.y1 + e.borderThickness / 2 || a >= (e.x1 + e.x2) / 2 && a <= e.x2 && d >= e.y4 - e.borderThickness / 2 && d <= e.y4 + e.borderThickness / 2) c.push({
                                dataPoint: r,
                                dataPointIndex: g,
                                dataSeries: this,
                                distance: Math.min(Math.abs(e.x1 - a), Math.abs(e.x2 - a), Math.abs(e.y2 - d), Math.abs(e.y3 - d))
                            }), l = !0
                    }
                    if (l || 1E3 < m && 1E3 < n) break
                }
            } else if (0 > p - f && p + f >= this.dataPoints.length) break; - 1 === h ? (f++, h = 1) : h = -1
        }
        a = null;
        for (d = 0; d < c.length; d++) a ? c[d].distance <= a.distance && (a = c[d]) : a = c[d];
        return a
    };
    $.prototype.getMarkerProperties = function(a, d, b, c) {
        var f = this.dataPoints;
        return {
            x: d,
            y: b,
            ctx: c,
            type: f[a].markerType ? f[a].markerType : this.markerType,
            size: f[a].markerSize ? f[a].markerSize : this.markerSize,
            color: f[a].markerColor ? f[a].markerColor : this.markerColor ? this.markerColor : f[a].color ? f[a].color : this.color ? this.color : this._colorSet[a % this._colorSet.length],
            borderColor: f[a].markerBorderColor ? f[a].markerBorderColor : this.markerBorderColor ? this.markerBorderColor : null,
            borderThickness: f[a].markerBorderThickness ? f[a].markerBorderThickness : this.markerBorderThickness ? this.markerBorderThickness : null
        }
    };
    U(B, M);
    B.prototype.createExtraLabelsForLog = function(a) {
        a = (a || 0) + 1;
        if (!(5 < a)) {
            var d = this.logLabelValues[0] ||
                this.intervalStartPosition;
            if (Math.log(this.range) / Math.log(d / this.viewportMinimum) < this.noTicks - 1) {
                for (var b = B.getNiceNumber((d - this.viewportMinimum) / Math.min(Math.max(2, this.noTicks - this.logLabelValues.length), 3), !0), c = Math.ceil(this.viewportMinimum / b) * b; c < d; c += b) c < this.viewportMinimum || this.logLabelValues.push(c);
                this.logLabelValues.sort(ya);
                this.createExtraLabelsForLog(a)
            }
        }
    };
    B.prototype.createLabels = function() {
        var a, d, b = 0,
            c = 0,
            f, g = 0,
            h = 0,
            c = 0,
            l = this.interval,
            k = 0,
            m, n = 0.6 * this.chart.height,
            b = !1;
        if (this.dataSeries &&
            0 < this.dataSeries.length)
            for (c = 0; c < this.dataSeries.length; c++) "dateTime" === this.dataSeries[c].xValueType && (b = !0);
        if ("axisX" === this.type && b && !this.logarithmic)
            for (this.intervalStartPosition = this.getLabelStartPoint(new Date(this.viewportMinimum), this.intervalType, this.interval), f = Ha(new Date(this.viewportMaximum), this.interval, this.intervalType), b = this.intervalStartPosition; b < f; Ha(b, l, this.intervalType)) a = b.getTime(), a = this.labelFormatter ? this.labelFormatter({
                chart: this.chart,
                axis: this.options,
                value: b,
                label: this.labels[b] ? this.labels[b] : null
            }) : "axisX" === this.type && this.labels[a] ? this.labels[a] : Ea(b, this.valueFormatString, this.chart._cultureInfo), a = new W(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: g,
                backgroundColor: this.labelBackgroundColor,
                borderColor: this.labelBorderColor,
                borderThickness: this.labelBorderThickness,
                cornerRadius: this.labelCornerRadius,
                maxHeight: h,
                angle: this.labelAngle,
                text: this.prefix + a + this.suffix,
                horizontalAlign: "left",
                fontSize: this.labelFontSize,
                fontFamily: this.labelFontFamily,
                fontWeight: this.labelFontWeight,
                fontColor: this.labelFontColor,
                fontStyle: this.labelFontStyle,
                textBaseline: "middle"
            }), this._labels.push({
                position: b.getTime(),
                textBlock: a,
                effectiveHeight: null
            });
        else {
            f = this.viewportMaximum;
            if (this.labels) {
                a = Math.ceil(l);
                for (var l = Math.ceil(this.intervalStartPosition), p = !1, b = l; b < this.viewportMaximum; b += a)
                    if (this.labels[b]) p = !0;
                    else {
                        p = !1;
                        break
                    }
                p && (this.interval = a, this.intervalStartPosition = l)
            }
            if (this.logarithmic && !this.equidistantInterval) {
                this.logLabelValues || (this.logLabelValues = [], this.createExtraLabelsForLog());
                for (var e = 0; e < this.logLabelValues.length; e++) b = this.logLabelValues[e], b < this.viewportMinimum || (a = this.labelFormatter ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.options,
                    value: b,
                    label: this.labels[b] ? this.labels[b] : null
                }) : "axisX" === this.type && this.labels[b] ? this.labels[b] : da(b, this.valueFormatString, this.chart._cultureInfo), a = new W(this.ctx, {
                    x: 0,
                    y: 0,
                    maxWidth: g,
                    maxHeight: h,
                    angle: this.labelAngle,
                    text: this.prefix + a + this.suffix,
                    backgroundColor: this.labelBackgroundColor,
                    borderColor: this.labelBorderColor,
                    borderThickness: this.labelBorderThickness,
                    cornerRadius: this.labelCornerRadius,
                    horizontalAlign: "left",
                    fontSize: this.labelFontSize,
                    fontFamily: this.labelFontFamily,
                    fontWeight: this.labelFontWeight,
                    fontColor: this.labelFontColor,
                    fontStyle: this.labelFontStyle,
                    textBaseline: "middle",
                    borderThickness: 0
                }), this._labels.push({
                    position: b,
                    textBlock: a,
                    effectiveHeight: null
                }))
            }
            for (b = this.intervalStartPosition; b <= f; b = parseFloat((this.logarithmic && this.equidistantInterval ? b * Math.pow(this.logarithmBase, this.interval) :
                    b + this.interval).toFixed(14))) a = this.labelFormatter ? this.labelFormatter({
                chart: this.chart,
                axis: this.options,
                value: b,
                label: this.labels[b] ? this.labels[b] : null
            }) : "axisX" === this.type && this.labels[b] ? this.labels[b] : da(b, this.valueFormatString, this.chart._cultureInfo), a = new W(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: g,
                maxHeight: h,
                angle: this.labelAngle,
                text: this.prefix + a + this.suffix,
                horizontalAlign: "left",
                backgroundColor: this.labelBackgroundColor,
                borderColor: this.labelBorderColor,
                borderThickness: this.labelBorderThickness,
                cornerRadius: this.labelCornerRadius,
                fontSize: this.labelFontSize,
                fontFamily: this.labelFontFamily,
                fontWeight: this.labelFontWeight,
                fontColor: this.labelFontColor,
                fontStyle: this.labelFontStyle,
                textBaseline: "middle"
            }), this._labels.push({
                position: b,
                textBlock: a,
                effectiveHeight: null
            })
        }
        if ("bottom" === this._position || "top" === this._position) k = this.logarithmic && !this.equidistantInterval && 2 <= this._labels.length ? this.lineCoordinates.width * Math.log(Math.min(this._labels[this._labels.length - 1].position / this._labels[this._labels.length -
            2].position, this._labels[1].position / this._labels[0].position)) / Math.log(this.range) : this.lineCoordinates.width / (this.logarithmic && this.equidistantInterval ? Math.log(this.range) / Math.log(this.logarithmBase) : Math.abs(this.range)) * E[this.intervalType + "Duration"] * this.interval, g = "undefined" === typeof this.options.labelMaxWidth ? 0.5 * this.chart.width >> 0 : this.options.labelMaxWidth, this.chart.panEnabled || (h = "undefined" === typeof this.options.labelWrap || this.labelWrap ? 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize);
        else if ("left" === this._position || "right" === this._position) k = this.logarithmic && !this.equidistantInterval && 2 <= this._labels.length ? this.lineCoordinates.height * Math.log(Math.min(this._labels[this._labels.length - 1].position / this._labels[this._labels.length - 2].position, this._labels[1].position / this._labels[0].position)) / Math.log(this.range) : this.lineCoordinates.height / (this.logarithmic && this.equidistantInterval ? Math.log(this.range) / Math.log(this.logarithmBase) : Math.abs(this.range)) * E[this.intervalType +
            "Duration"] * this.interval, this.chart.panEnabled || (g = "undefined" === typeof this.options.labelMaxWidth ? 0.3 * this.chart.width >> 0 : this.options.labelMaxWidth), h = "undefined" === typeof this.options.labelWrap || this.labelWrap ? 0.3 * this.chart.height >> 0 : 1.5 * this.labelFontSize;
        for (c = 0; c < this._labels.length; c++) {
            a = this._labels[c].textBlock;
            a.maxWidth = g;
            a.maxHeight = h;
            var r = a.measureText();
            m = r.height
        }
        f = [];
        p = l = 0;
        if (this.labelAutoFit || this.options.labelAutoFit)
            if (x(this.labelAngle) || (this.labelAngle = (this.labelAngle %
                    360 + 360) % 360, 90 < this.labelAngle && 270 > this.labelAngle ? this.labelAngle -= 180 : 270 <= this.labelAngle && 360 >= this.labelAngle && (this.labelAngle -= 360)), "bottom" === this._position || "top" === this._position)
                if (g = 0.9 * k >> 0, p = 0, !this.chart.panEnabled && 1 <= this._labels.length) {
                    this.sessionVariables.labelFontSize = this.labelFontSize;
                    this.sessionVariables.labelMaxWidth = g;
                    this.sessionVariables.labelMaxHeight = h;
                    this.sessionVariables.labelAngle = this.labelAngle;
                    this.sessionVariables.labelWrap = this.labelWrap;
                    for (b = 0; b < this._labels.length; b++) {
                        a =
                            this._labels[b].textBlock;
                        for (var q, s = a.text.split(" "), c = 0; c < s.length; c++) e = s[c], this.ctx.font = a.fontStyle + " " + a.fontWeight + " " + a.fontSize + "px " + a.fontFamily, e = this.ctx.measureText(e), e.width > p && (q = b, p = e.width)
                    }
                    b = 0;
                    for (b = this.intervalStartPosition < this.viewportMinimum ? 1 : 0; b < this._labels.length; b++)
                        if (a = this._labels[b].textBlock, r = a.measureText(), b < this._labels.length - 1 && (e = b + 1, d = this._labels[e].textBlock, d = d.measureText()), f.push(a.height), this.sessionVariables.labelMaxHeight = Math.max.apply(Math,
                                f), Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), c = g * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (h - a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), x(this.options.labelAngle) && isNaN(this.options.labelAngle) && 0 !== this.options.labelAngle)
                            if (this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? h : Math.min((c - g * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), c), s = (n - (m + a.fontSize / 2) *
                                    Math.cos(Math.PI / 180 * Math.abs(-25))) / Math.sin(Math.PI / 180 * Math.abs(-25)), !x(this.options.labelWrap)) this.labelWrap ? x(this.options.labelMaxWidth) ? (this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, p), s), this.sessionVariables.labelWrap = this.labelWrap, r.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25)) : (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelAngle = this.sessionVariables.labelMaxWidth > g ?
                                -25 : this.sessionVariables.labelAngle) : x(this.options.labelMaxWidth) ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelMaxWidth = g, r.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = s)) : (this.sessionVariables.labelAngle = this.sessionVariables.labelMaxWidth > g ? -25 : this.sessionVariables.labelAngle, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight =
                                h, this.sessionVariables.labelWrap = this.labelWrap);
                            else {
                                if (x(this.options.labelWrap))
                                    if (!x(this.options.labelMaxWidth)) this.options.labelMaxWidth < g ? (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight = c) : (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth, this.sessionVariables.labelMaxHeight = h);
                                    else if (!x(d))
                                    if (c = r.width + d.width >> 0, e = this.labelFontSize, p < g) c - 2 * g > l && (l = c - 2 * g, c >= 2 * g && c < 2.2 * g ? (this.sessionVariables.labelMaxWidth =
                                        g, x(this.options.labelFontSize) && 12 < e && (e = Math.floor(12 / 13 * e), a.measureText()), this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? e : this.options.labelFontSize, this.sessionVariables.labelAngle = this.labelAngle) : c >= 2.2 * g && c < 2.8 * g ? (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = s, this.sessionVariables.labelFontSize = e) : c >= 2.8 * g && c < 3.2 * g ? (this.sessionVariables.labelMaxWidth = Math.max(g, p), this.sessionVariables.labelWrap = !0, x(this.options.labelFontSize) && 12 < this.labelFontSize &&
                                        (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? e : this.options.labelFontSize, this.sessionVariables.labelAngle = this.labelAngle) : c >= 3.2 * g && c < 3.6 * g ? (this.sessionVariables.labelAngle = -25, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelMaxWidth = s, this.sessionVariables.labelFontSize = this.labelFontSize) : c > 3.6 * g && c < 5 * g ? (x(this.options.labelFontSize) && 12 < e && (e = Math.floor(12 / 13 * e), a.measureText()), this.sessionVariables.labelFontSize =
                                        x(this.options.labelFontSize) ? e : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth = s) : c > 5 * g && (this.sessionVariables.labelWrap = !0, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelFontSize = e, this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelAngle = this.labelAngle));
                                    else if (q === b && (0 === q && p + this._labels[q + 1].textBlock.measureText().width - 2 * g > l || q === this._labels.length - 1 && p + this._labels[q -
                                        1].textBlock.measureText().width - 2 * g > l || 0 < q && q < this._labels.length - 1 && p + this._labels[q + 1].textBlock.measureText().width - 2 * g > l && p + this._labels[q - 1].textBlock.measureText().width - 2 * g > l)) l = 0 === q ? p + this._labels[q + 1].textBlock.measureText().width - 2 * g : p + this._labels[q - 1].textBlock.measureText().width - 2 * g, this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? e : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelAngle = -25, this.sessionVariables.labelMaxWidth =
                                    s;
                                else if (0 === l)
                                    for (this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? e : this.options.labelFontSize, this.sessionVariables.labelWrap = !0, c = 0; c < this._labels.length; c++) a = this._labels[c].textBlock, a.maxWidth = this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, p), s), r = a.measureText(), c < this._labels.length - 1 && (e = c + 1, d = this._labels[e].textBlock, d.maxWidth = this.sessionVariables.labelMaxWidth = Math.min(Math.max(g, p), s), d = d.measureText(), r.width + d.width >> 0 > 2 * g && (this.sessionVariables.labelAngle = -25))
                            }
                    else(this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? h : Math.min((c - g * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), c), s = 0 != this.labelAngle ? (n - (m + a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) : g, this.sessionVariables.labelMaxHeight = h = this.labelWrap ? (n - s * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle))) / Math.cos(Math.PI / 180 *
                        Math.abs(this.labelAngle)) : 1.5 * this.labelFontSize, x(this.options.labelWrap)) ? x(this.options.labelWrap) && (this.labelWrap && !x(this.options.labelMaxWidth) ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : s, this.sessionVariables.labelMaxHeight = h) : (this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxWidth = s, this.sessionVariables.labelMaxHeight = c < 0.9 * k ? 0.9 * k : c, this.sessionVariables.labelWrap =
                        this.labelWrap)) : (this.options.labelWrap ? (this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : s) : (x(this.options.labelMaxWidth), this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : s, this.sessionVariables.labelWrap = this.labelWrap), this.sessionVariables.labelMaxHeight = h);
                    for (c = 0; c < this._labels.length; c++) a = this._labels[c].textBlock, a.maxWidth = this.labelMaxWidth = this.sessionVariables.labelMaxWidth,
                        a.fontSize = this.sessionVariables.labelFontSize, a.angle = this.labelAngle = this.sessionVariables.labelAngle, a.wrap = this.labelWrap = this.sessionVariables.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText()
                } else
                    for (b = 0; b < this._labels.length; b++) a = this._labels[b].textBlock, a.maxWidth = this.labelMaxWidth = x(this.options.labelMaxWidth) ? this.sessionVariables.labelMaxWidth : this.options.labelMaxWidth, a.fontSize = this.labelFontSize = x(this.options.labelFontSize) ? this.sessionVariables.labelFontSize :
                        this.options.labelFontSize, a.angle = this.labelAngle = x(this.options.labelAngle) ? this.sessionVariables.labelAngle : this.labelAngle, a.wrap = this.labelWrap = x(this.options.labelWrap) ? this.sessionVariables.labelWrap : this.options.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
        else if ("left" === this._position || "right" === this._position)
            if (g = x(this.options.labelMaxWidth) ? 0.3 * this.chart.width >> 0 : this.options.labelMaxWidth, h = "undefined" === typeof this.options.labelWrap || this.labelWrap ?
                0.3 * this.chart.height >> 0 : 1.5 * this.labelFontSize, !this.chart.panEnabled && 1 <= this._labels.length) {
                this.sessionVariables.labelFontSize = this.labelFontSize;
                this.sessionVariables.labelMaxWidth = g;
                this.sessionVariables.labelMaxHeight = h;
                this.sessionVariables.labelAngle = x(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle;
                this.sessionVariables.labelWrap = this.labelWrap;
                for (b = 0; b < this._labels.length; b++)(a = this._labels[b].textBlock, r = a.measureText(), b < this._labels.length - 1 && (e = b + 1, d = this._labels[e].textBlock,
                    d = d.measureText()), f.push(a.height), this.sessionVariables.labelMaxHeight = Math.max.apply(Math, f), c = g * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (h - a.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), x(this.options.labelAngle) && isNaN(this.options.labelAngle) && 0 !== this.options.labelAngle) ? x(this.options.labelWrap) ? x(this.options.labelWrap) && (x(this.options.labelMaxWidth) ? x(d) || (k = r.height + d.height >>
                    0, k - 2 * h > p && (p = k - 2 * h, k >= 2 * h && k < 2.4 * h ? (x(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize) : k >= 2.4 * h && k < 2.8 * h ? (this.sessionVariables.labelMaxHeight = c, this.sessionVariables.labelFontSize = this.labelFontSize, this.sessionVariables.labelWrap = !0) : k >= 2.8 * h && k < 3.2 * h ? (this.sessionVariables.labelMaxHeight =
                        h, this.sessionVariables.labelWrap = !0, x(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelAngle = x(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle) : k >= 3.2 * h && k < 3.6 * h ? (this.sessionVariables.labelMaxHeight = c, this.sessionVariables.labelWrap = !0, this.sessionVariables.labelFontSize =
                        this.labelFontSize) : k > 3.6 * h && k < 10 * h ? (x(this.options.labelFontSize) && 12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelAngle = x(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle) : k > 10 * h && k < 50 * h && (x(this.options.labelFontSize) &&
                        12 < this.labelFontSize && (this.labelFontSize = Math.floor(12 / 13 * this.labelFontSize), a.measureText()), this.sessionVariables.labelFontSize = x(this.options.labelFontSize) ? this.labelFontSize : this.options.labelFontSize, this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelMaxWidth = g, this.sessionVariables.labelAngle = x(this.sessionVariables.labelAngle) ? 0 : this.sessionVariables.labelAngle))) : (this.sessionVariables.labelMaxHeight = h, this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth :
                    this.sessionVariables.labelMaxWidth)) : (this.sessionVariables.labelMaxWidth = this.labelWrap ? this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth : this.labelMaxWidth ? this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth : g, this.sessionVariables.labelMaxHeight = h) : (this.sessionVariables.labelAngle = this.labelAngle, this.sessionVariables.labelMaxWidth = 0 === this.labelAngle ? g : Math.min((c - h * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle))) /
                    Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), h), x(this.options.labelWrap)) ? x(this.options.labelWrap) && (this.labelWrap && !x(this.options.labelMaxWidth) ? (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth > this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth, this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxHeight = c) : (this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : g, this.sessionVariables.labelMaxHeight =
                    0 === this.labelAngle ? h : c, x(this.options.labelMaxWidth) && (this.sessionVariables.labelAngle = this.labelAngle))) : this.options.labelWrap ? (this.sessionVariables.labelMaxHeight = 0 === this.labelAngle ? h : c, this.sessionVariables.labelWrap = this.labelWrap, this.sessionVariables.labelMaxWidth = g) : (this.sessionVariables.labelMaxHeight = h, x(this.options.labelMaxWidth), this.sessionVariables.labelMaxWidth = this.options.labelMaxWidth ? this.options.labelMaxWidth : this.sessionVariables.labelMaxWidth, this.sessionVariables.labelWrap =
                    this.labelWrap);
                for (c = 0; c < this._labels.length; c++) a = this._labels[c].textBlock, a.maxWidth = this.labelMaxWidth = this.sessionVariables.labelMaxWidth, a.fontSize = this.labelFontSize = this.sessionVariables.labelFontSize, a.angle = this.labelAngle = this.sessionVariables.labelAngle, a.wrap = this.labelWrap = this.sessionVariables.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText()
            } else
                for (b = 0; b < this._labels.length; b++) a = this._labels[b].textBlock, a.maxWidth = this.labelMaxWidth = x(this.options.labelMaxWidth) ?
                    this.sessionVariables.labelMaxWidth : this.options.labelMaxWidth, a.fontSize = this.labelFontSize = x(this.options.labelFontSize) ? this.sessionVariables.labelFontSize : this.options.labelFontSize, a.angle = this.labelAngle = x(this.options.labelAngle) ? this.sessionVariables.labelAngle : this.labelAngle, a.wrap = this.labelWrap = x(this.options.labelWrap) ? this.sessionVariables.labelWrap : this.options.labelWrap, a.maxHeight = this.sessionVariables.labelMaxHeight, a.measureText();
        for (b = 0; b < this.stripLines.length; b++) {
            var g = this.stripLines[b],
                v;
            if ("outside" === g.labelPlacement) {
                h = this.sessionVariables.labelMaxWidth;
                if ("bottom" === this._position || "top" === this._position) v = "undefined" === typeof g.options.labelWrap ? this.sessionVariables.labelMaxHeight : g.labelWrap ? 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize;
                if ("left" === this._position || "right" === this._position) v = "undefined" === typeof g.options.labelWrap ? this.sessionVariables.labelMaxHeight : g.labelWrap ? 0.8 * this.chart.width >> 0 : 1.5 * this.labelFontSize;
                d = x(g.options.labelBackgroundColor) ? "#EEEEEE" :
                    g.options.labelBackgroundColor
            } else h = "bottom" === this._position || "top" === this._position ? 0.9 * this.chart.width >> 0 : 0.9 * this.chart.height >> 0, v = "undefined" === typeof g.options.labelWrap || g.labelWrap ? "bottom" === this._position || "top" === this._position ? 0.8 * this.chart.width >> 0 : 0.8 * this.chart.height >> 0 : 1.5 * this.labelFontSize, d = x(g.options.labelBackgroundColor) ? x(g.startValue) && 0 !== g.startValue ? u ? "transparent" : null : "#EEEEEE" : g.options.labelBackgroundColor;
            a = new W(this.ctx, {
                x: 0,
                y: 0,
                backgroundColor: d,
                borderColor: g.labelBorderColor,
                borderThickness: g.labelBorderThickness,
                cornerRadius: g.labelCornerRadius,
                maxWidth: g.options.labelMaxWidth ? g.options.labelMaxWidth : h,
                maxHeight: v,
                angle: this.labelAngle,
                text: g.labelFormatter ? g.labelFormatter({
                    chart: this.chart,
                    axis: this,
                    stripLine: g
                }) : g.label,
                horizontalAlign: "left",
                fontSize: "outside" === g.labelPlacement ? g.options.labelFontSize ? g.options.labelFontSize : this.labelFontSize : g.labelFontSize,
                fontFamily: "outside" === g.labelPlacement ? g.options.labelFontFamily ? g.options.labelFontFamily : this.labelFontFamily : g.labelFontFamily,
                fontWeight: "outside" === g.labelPlacement ? g.options.fontWeight ? g.options.fontWeight : this.fontWeight : g.fontWeight,
                fontColor: g.options.labelFontColor || g.color,
                fontStyle: "outside" === g.labelPlacement ? g.options.fontStyle ? g.options.fontStyle : this.fontWeight : g.fontStyle,
                textBaseline: "middle"
            });
            this._stripLineLabels.push({
                position: g.value,
                textBlock: a,
                effectiveHeight: null,
                stripLine: g
            })
        }
    };
    B.prototype.createLabelsAndCalculateWidth = function() {
        var a = 0,
            d = 0;
        this._labels = [];
        this._stripLineLabels = [];
        if ("left" === this._position || "right" === this._position) {
            this.createLabels();
            for (d = 0; d < this._labels.length; d++) {
                var b = this._labels[d].textBlock,
                    c = b.measureText(),
                    f = 0,
                    f = 0 === this.labelAngle ? c.width : c.width * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)) + (c.height - b.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle));
                a < f && (a = f);
                this._labels[d].effectiveWidth = f
            }
            for (d = 0; d < this._stripLineLabels.length; d++) "outside" === this._stripLineLabels[d].stripLine.labelPlacement && (this._stripLineLabels[d].stripLine.value >
                this.viewportMinimum && this._stripLineLabels[d].stripLine.value < this.viewportMaximum) && (b = this._stripLineLabels[d].textBlock, c = b.measureText(), f = 0 === this.labelAngle ? c.width : c.width * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)) + (c.height - b.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)), a < f && (a = f), this._stripLineLabels[d].effectiveWidth = f)
        }
        return (this.title ? this._titleTextBlock.measureText().height + 2 : 0) + a + this.tickLength + 5
    };
    B.prototype.createLabelsAndCalculateHeight = function() {
        var a = 0;
        this._labels = [];
        this._stripLineLabels = [];
        var d, b = 0;
        this.createLabels();
        if ("bottom" === this._position || "top" === this._position) {
            for (b = 0; b < this._labels.length; b++) {
                d = this._labels[b].textBlock;
                var c = d.measureText(),
                    f = 0,
                    f = 0 === this.labelAngle ? c.height : c.width * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (c.height - d.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle));
                a < f && (a = f);
                this._labels[b].effectiveHeight = f
            }
            for (b = 0; b < this._stripLineLabels.length; b++) "outside" === this._stripLineLabels[b].stripLine.labelPlacement &&
                (d = this._stripLineLabels[b].textBlock, c = d.measureText(), f = 0 === this.labelAngle ? c.height : c.width * Math.sin(Math.PI / 180 * Math.abs(this.labelAngle)) + (c.height - d.fontSize / 2) * Math.cos(Math.PI / 180 * Math.abs(this.labelAngle)), a < f && (a = f), this._stripLineLabels[b].effectiveHeight = f)
        }
        return (this.title ? this._titleTextBlock.measureText().height + 2 : 0) + a + this.tickLength + 5
    };
    B.setLayoutAndRender = function(a, d, b, c, f, g) {
        var h, l, k, m, n = a[0] ? a[0].chart : d[0].chart,
            p = n.ctx;
        if (a && 0 < a.length)
            for (var e = 0; e < a.length; e++) a[e] && a[e].calculateAxisParameters();
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].calculateAxisParameters();
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e].calculateAxisParameters();
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].calculateAxisParameters();
        var r = 0,
            q = 0,
            s = 0,
            v = 0,
            w = 0,
            u = 0,
            t = 0,
            z, A, B = l = 0,
            E, F, G, J;
        E = F = G = J = !1;
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e] && a[e].title && (a[e]._titleTextBlock = new W(a[e].ctx, {
                text: a[e].title,
                horizontalAlign: "center",
                fontSize: a[e].titleFontSize,
                fontFamily: a[e].titleFontFamily,
                fontWeight: a[e].titleFontWeight,
                fontColor: a[e].titleFontColor,
                fontStyle: a[e].titleFontStyle,
                borderColor: a[e].titleBorderColor,
                borderThickness: a[e].titleBorderThickness,
                backgroundColor: a[e].titleBackgroundColor,
                cornerRadius: a[e].titleCornerRadius,
                textBaseline: "top"
            }));
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e] && d[e].title && (d[e]._titleTextBlock = new W(d[e].ctx, {
                text: d[e].title,
                horizontalAlign: "center",
                fontSize: d[e].titleFontSize,
                fontFamily: d[e].titleFontFamily,
                fontWeight: d[e].titleFontWeight,
                fontColor: d[e].titleFontColor,
                fontStyle: d[e].titleFontStyle,
                borderColor: d[e].titleBorderColor,
                borderThickness: d[e].titleBorderThickness,
                backgroundColor: d[e].titleBackgroundColor,
                cornerRadius: d[e].titleCornerRadius,
                textBaseline: "top"
            }));
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e] && b[e].title && (b[e]._titleTextBlock = new W(b[e].ctx, {
                text: b[e].title,
                horizontalAlign: "center",
                fontSize: b[e].titleFontSize,
                fontFamily: b[e].titleFontFamily,
                fontWeight: b[e].titleFontWeight,
                fontColor: b[e].titleFontColor,
                fontStyle: b[e].titleFontStyle,
                borderColor: b[e].titleBorderColor,
                borderThickness: b[e].titleBorderThickness,
                backgroundColor: b[e].titleBackgroundColor,
                cornerRadius: b[e].titleCornerRadius,
                textBaseline: "top"
            }));
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e] && c[e].title && (c[e]._titleTextBlock = new W(c[e].ctx, {
                text: c[e].title,
                horizontalAlign: "center",
                fontSize: c[e].titleFontSize,
                fontFamily: c[e].titleFontFamily,
                fontWeight: c[e].titleFontWeight,
                fontColor: c[e].titleFontColor,
                fontStyle: c[e].titleFontStyle,
                borderColor: c[e].titleBorderColor,
                borderThickness: c[e].titleBorderThickness,
                backgroundColor: c[e].titleBackgroundColor,
                cornerRadius: c[e].titleCornerRadius,
                textBaseline: "top"
            }));
        if ("normal" === f) {
            var v = [],
                w = [],
                u = [],
                t = [],
                H = [],
                I = [],
                M = [],
                K = [];
            if (a && 0 < a.length)
                for (e = 0; e < a.length; e++) a[e] && a[e].title && (a[e]._titleTextBlock.maxWidth = a[e].titleMaxWidth || g.width, a[e]._titleTextBlock.maxHeight = a[e].titleWrap ? 0.8 * g.height : 1.5 * a[e].titleFontSize, a[e]._titleTextBlock.angle = 0);
            if (d && 0 < d.length)
                for (e = 0; e < d[e].length; e++) d[e] && d[e].title && (d[e]._titleTextBlock.maxWidth = d[e].titleMaxWidth || g.width, d[e]._titleTextBlock.maxHeight = d[e].titleWrap ?
                    0.8 * g.height : 1.5 * d[e].titleFontSize, d[e]._titleTextBlock.angle = 0);
            if (b && 0 < b.length)
                for (e = 0; e < b.length; e++) b[e] && b[e].title && (b[e]._titleTextBlock.maxWidth = b[e].titleMaxWidth || g.height, b[e]._titleTextBlock.maxHeight = b[e].titleWrap ? 0.8 * g.width : 1.5 * b[e].titleFontSize, b[e]._titleTextBlock.angle = -90);
            if (c && 0 < c.length)
                for (e = 0; e < c.length; e++) c[e] && c[e].title && (c[e]._titleTextBlock.maxWidth = c[e].titleMaxWidth || g.height, c[e]._titleTextBlock.maxHeight = c[e].titleWrap ? 0.8 * g.width : 1.5 * c[e].titleFontSize, c[e]._titleTextBlock.angle =
                    90);
            for (; 4 > r;) {
                var N = 0,
                    Q = 0,
                    P = 0,
                    O = 0,
                    L = f = 0,
                    C = 0,
                    S = 0,
                    X = 0,
                    V = 0,
                    U = 0,
                    T = 0;
                if (b && 0 < b.length)
                    for (u = [], e = U = 0; e < b.length; e++) u.push(Math.ceil(b[e] ? b[e].createLabelsAndCalculateWidth() : 0)), U += u[e], C += b[e] ? b[e].margin : 0;
                else u.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateWidth() : 0));
                M.push(u);
                if (c && 0 < c.length)
                    for (t = [], e = T = 0; e < c.length; e++) t.push(Math.ceil(c[e] ? c[e].createLabelsAndCalculateWidth() : 0)), T += t[e], S += c[e] ? c[e].margin : 0;
                else t.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateWidth() : 0));
                K.push(t);
                h = Math.round(g.x1 + U + C);
                k = Math.round(g.x2 - T - S > n.width - 10 ? n.width - 10 : g.x2 - T - S);
                if (a && 0 < a.length)
                    for (v = [], e = X = 0; e < a.length; e++) a[e] && (a[e].lineCoordinates = {}), a[e].lineCoordinates.width = Math.abs(k - h), a[e].title && (a[e]._titleTextBlock.maxWidth = 0 < a[e].titleMaxWidth && a[e].titleMaxWidth < a[e].lineCoordinates.width ? a[e].titleMaxWidth : a[e].lineCoordinates.width), v.push(Math.ceil(a[e] ? a[e].createLabelsAndCalculateHeight() : 0)), X += v[e], f += a[e] ? a[e].margin : 0;
                else v.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateHeight() :
                    0));
                H.push(v);
                if (d && 0 < d.length)
                    for (w = [], e = V = 0; e < d.length; e++) d[e] && (d[e].lineCoordinates = {}), d[e].lineCoordinates.width = Math.abs(k - h), d[e].title && (d[e]._titleTextBlock.maxWidth = 0 < d[e].titleMaxWidth && d[e].titleMaxWidth < d[e].lineCoordinates.width ? d[e].titleMaxWidth : d[e].lineCoordinates.width), w.push(Math.ceil(d[e] ? d[e].createLabelsAndCalculateHeight() : 0)), V += w[e], L += d[e] ? d[e].margin : 0;
                else w.push(Math.ceil(d[0] ? d[0].createLabelsAndCalculateHeight() : 0));
                I.push(w);
                if (a && 0 < a.length)
                    for (e = 0; e < a.length; e++) a[e] &&
                        (a[e].lineCoordinates.x1 = h, a[e].lineCoordinates.x2 = Math.round(g.x2 - T - S > n.width - 10 ? n.width - 10 : g.x2 - T - S), a[e]._labels && 1 < a[e]._labels.length && (l = m = 0, m = a[e]._labels[1], l = "dateTime" === a[e].chart.plotInfo.axisXValueType ? a[e]._labels[a[e]._labels.length - 2] : a[e]._labels[a[e]._labels.length - 1], q = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), s = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) +
                            (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle))), a[e] && (a[e].labelAutoFit && !x(z) && !x(A)) && (l = 0, 0 < a[e].labelAngle ? A + s > k && (l += 0 < a[e].labelAngle ? A + s - k - T : 0) : 0 > a[e].labelAngle ? z - q < h && z - q < a[e].viewportMinimum && (B = h - (C + a[e].tickLength + u + z - q + a[e].labelFontSize / 2)) : 0 === a[e].labelAngle && (A + s > k && (l = A + s / 2 - k - T), z - q < h && z - q < a[e].viewportMinimum && (B = h - C - a[e].tickLength - u - z + q / 2)), a[e].viewportMaximum === a[e].maximum && a[e].viewportMinimum === a[e].minimum && 0 < a[e].labelAngle &&
                            0 < l ? k -= l : a[e].viewportMaximum === a[e].maximum && a[e].viewportMinimum === a[e].minimum && 0 > a[e].labelAngle && 0 < B ? h += B : a[e].viewportMaximum === a[e].maximum && a[e].viewportMinimum === a[e].minimum && 0 === a[e].labelAngle && (0 < B && (h += B), 0 < l && (k -= l))), n.panEnabled ? X = n.sessionVariables.axisX.height : n.sessionVariables.axisX.height = X, l = Math.round(g.y2 - X - f + N), m = Math.round(g.y2), a[e].lineCoordinates.x2 = k, a[e].lineCoordinates.width = k - h, a[e].lineCoordinates.y1 = l, a[e].lineCoordinates.y2 = l, a[e].bounds = {
                            x1: h,
                            y1: l,
                            x2: k,
                            y2: m - (X +
                                f - v[e] - N),
                            width: k - h,
                            height: m - l
                        }), N += v[e] + a[e].margin;
                if (d && 0 < d.length)
                    for (e = 0; e < d.length; e++) d[e].lineCoordinates.x1 = Math.round(g.x1 + U + C), d[e].lineCoordinates.x2 = Math.round(g.x2 - T - S > n.width - 10 ? n.width - 10 : g.x2 - T - S), d[e].lineCoordinates.width = Math.abs(k - h), d[e]._labels && 1 < d[e]._labels.length && (m = d[e]._labels[1], l = "dateTime" === d[e].chart.plotInfo.axisXValueType ? d[e]._labels[d[e]._labels.length - 2] : d[e]._labels[d[e]._labels.length - 1], q = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) +
                        (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), s = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle))), n.panEnabled ? V = n.sessionVariables.axisX2.height : n.sessionVariables.axisX2.height = V, l = Math.round(g.y1), m = Math.round(g.y2 + d[e].margin), d[e].lineCoordinates.y1 = l + V + L - Q, d[e].lineCoordinates.y2 = l, d[e].bounds = {
                        x1: h,
                        y1: l + (V + L - w[e] - Q),
                        x2: k,
                        y2: m,
                        width: k -
                            h,
                        height: m - l
                    }, Q += w[e] + d[e].margin;
                if (b && 0 < b.length)
                    for (e = 0; e < b.length; e++) C = 10, b[e] && (h = Math.round(a[0] ? a[0].lineCoordinates.x1 : d[0].lineCoordinates.x1), C = b[e]._labels && 0 < b[e]._labels.length ? b[e]._labels[b[e]._labels.length - 1].textBlock.height / 2 : 10, l = Math.round(g.y1 + V + L < Math.max(C, 10) ? Math.max(C, 10) : g.y1 + V + L), k = Math.round(a[0] ? a[0].lineCoordinates.x1 : d[0].lineCoordinates.x1), C = 0 < a.length ? 0 : b[e]._labels[0].textBlock.height / 2, m = Math.round(g.y2 - X - f - C), b[e].lineCoordinates = {
                        x1: k - P,
                        y1: l,
                        x2: k - P,
                        y2: m,
                        height: Math.abs(m -
                            l)
                    }, b[e].bounds = {
                        x1: h - (u[e] + P),
                        y1: l,
                        x2: k,
                        y2: m,
                        width: k - h,
                        height: m - l
                    }, b[e].title && (b[e]._titleTextBlock.maxWidth = 0 < b[e].titleMaxWidth && b[e].titleMaxWidth < b[e].lineCoordinates.height ? b[e].titleMaxWidth : b[e].lineCoordinates.height), P += u[e] + b[e].margin);
                if (c && 0 < c.length)
                    for (e = 0; e < c.length; e++) c[e] && (h = Math.round(a[0] ? a[0].lineCoordinates.x2 : d[0].lineCoordinates.x2), k = Math.round(h), C = c[e]._labels && 0 < c[e]._labels.length ? c[e]._labels[c[e]._labels.length - 1].textBlock.height / 2 : 0, l = Math.round(g.y1 + V + L < Math.max(C,
                        10) ? Math.max(C, 10) : g.y1 + V + L), C = 0 < a.length ? 0 : c[e]._labels[0].textBlock.height / 2, m = Math.round(g.y2 - (X + f + C)), c[e].lineCoordinates = {
                        x1: h + O,
                        y1: l,
                        x2: h + O,
                        y2: m,
                        height: Math.abs(m - l)
                    }, c[e].bounds = {
                        x1: h,
                        y1: l,
                        x2: k + (t[e] + O),
                        y2: m,
                        width: k - h,
                        height: m - l
                    }, c[e].title && (c[e]._titleTextBlock.maxWidth = 0 < c[e].titleMaxWidth && c[e].titleMaxWidth < c[e].lineCoordinates.height ? c[e].titleMaxWidth : c[e].lineCoordinates.height), O += t[e] + c[e].margin);
                if (a && 0 < a.length)
                    for (e = 0; e < a.length; e++) a[e] && (a[e].calculateValueToPixelConversionParameters(),
                        a[e]._labels && 1 < a[e]._labels.length && (z = (a[e].logarithmic ? Math.log(a[e]._labels[1].position / a[e].viewportMinimum) / a[e].conversionParameters.lnLogarithmBase : a[e]._labels[1].position - a[e].viewportMinimum) * Math.abs(a[e].conversionParameters.pixelPerUnit) + a[e].lineCoordinates.x1, A = "dateTime" === a[e].chart.plotInfo.axisXValueType ? (a[e].logarithmic ? Math.log(a[e]._labels[a[e]._labels.length - 2].position / a[e].viewportMinimum) / a[e].conversionParameters.lnLogarithmBase : a[e]._labels[a[e]._labels.length - 2].position -
                            a[e].viewportMinimum) * Math.abs(a[e].conversionParameters.pixelPerUnit) + a[e].lineCoordinates.x1 : (a[e].logarithmic ? Math.log(a[e]._labels[a[e]._labels.length - 1].position / a[e].viewportMinimum) / a[e].conversionParameters.lnLogarithmBase : a[e]._labels[a[e]._labels.length - 1].position - a[e].viewportMinimum) * Math.abs(a[e].conversionParameters.pixelPerUnit) + a[e].lineCoordinates.x1));
                if (d && 0 < d.length)
                    for (e = 0; e < d.length; e++) d[e].calculateValueToPixelConversionParameters(), d[e]._labels && 1 < d[e]._labels.length && (z =
                        (d[e].logarithmic ? Math.log(d[e]._labels[1].position / d[e].viewportMinimum) / d[e].conversionParameters.lnLogarithmBase : d[e]._labels[1].position - d[e].viewportMinimum) * Math.abs(d[e].conversionParameters.pixelPerUnit) + d[e].lineCoordinates.x1, A = "dateTime" === d[e].chart.plotInfo.axisXValueType ? (d[e].logarithmic ? Math.log(d[e]._labels[d[e]._labels.length - 2].position / d[e].viewportMinimum) / d[e].conversionParameters.lnLogarithmBase : d[e]._labels[d[e]._labels.length - 2].position - d[e].viewportMinimum) * Math.abs(d[e].conversionParameters.pixelPerUnit) +
                        d[e].lineCoordinates.x1 : (d[e].logarithmic ? Math.log(d[e]._labels[d[e]._labels.length - 1].position / d[e].viewportMinimum) / d[e].conversionParameters.lnLogarithmBase : d[e]._labels[d[e]._labels.length - 1].position - d[e].viewportMinimum) * Math.abs(d[e].conversionParameters.pixelPerUnit) + d[e].lineCoordinates.x1);
                if (b && 0 < b.length)
                    for (e = 0; e < b.length; e++) b[e].calculateValueToPixelConversionParameters();
                if (c && 0 < c.length)
                    for (e = 0; e < c.length; e++) c[e].calculateValueToPixelConversionParameters();
                if (0 < r) {
                    if (a && 0 < a.length)
                        for (e =
                            0; e < a.length; e++) E = H[r - 1][e] === H[r][e] ? !0 : !1;
                    else E = !0;
                    if (d && 0 < d.length)
                        for (e = 0; e < d.length; e++) F = I[r - 1][e] === I[r][e] ? !0 : !1;
                    else F = !0;
                    if (b && 0 < b.length)
                        for (e = 0; e < b.length; e++) G = M[r - 1][e] === M[r][e] ? !0 : !1;
                    else G = !0;
                    if (c && 0 < c.length)
                        for (e = 0; e < c.length; e++) J = K[r - 1][e] === K[r][e] ? !0 : !1;
                    else J = !0
                }
                if (E && F && G && J) break;
                r++
            }
            p.save();
            p.beginPath();
            a[0] && p.rect(5, a[0].bounds.y1, a[0].chart.width - 10, a[0].bounds.height);
            d[0] && p.rect(5, d[d.length - 1].bounds.y1, d[0].chart.width - 10, d[0].bounds.height);
            p.clip();
            if (a && 0 <
                a.length)
                for (e = 0; e < a.length; e++) a[e].renderLabelsTicksAndTitle();
            if (d && 0 < d.length)
                for (e = 0; e < d.length; e++) d[e].renderLabelsTicksAndTitle();
            p.restore();
            if (b && 0 < b.length)
                for (e = 0; e < b.length; e++) b[e].renderLabelsTicksAndTitle();
            if (c && 0 < c.length)
                for (e = 0; e < c.length; e++) c[e].renderLabelsTicksAndTitle()
        } else {
            z = [];
            A = [];
            B = [];
            q = [];
            s = [];
            H = [];
            I = [];
            M = [];
            if (a && 0 < a.length)
                for (e = 0; e < a.length; e++) a[e] && a[e].title && (a[e]._titleTextBlock.maxWidth = a[e].titleMaxWidth || g.width, a[e]._titleTextBlock.maxHeight = a[e].titleWrap ?
                    0.8 * g.height : 1.5 * a[e].titleFontSize, a[e]._titleTextBlock.angle = -90);
            if (d && 0 < d.length)
                for (e = 0; e < d.length; e++) d[e] && d[e].title && (d[e]._titleTextBlock.maxWidth = d[e].titleMaxWidth || g.width, d[e]._titleTextBlock.maxHeight = d[e].titleWrap ? 0.8 * g.height : 1.5 * d[e].titleFontSize, d[e]._titleTextBlock.angle = 90);
            if (b && 0 < b.length)
                for (e = 0; e < b.length; e++) b[e] && b[e].title && (b[e]._titleTextBlock.maxWidth = b[e].titleMaxWidth || g.width, b[e]._titleTextBlock.maxHeight = b[e].titleWrap ? 0.8 * g.height : 1.5 * b[e].titleFontSize, b[e]._titleTextBlock.angle =
                    0);
            if (c && 0 < c.length)
                for (e = 0; e < c.length; e++) c[e] && c[e].title && (c[e]._titleTextBlock.maxWidth = c[e].titleMaxWidth || g.width, c[e]._titleTextBlock.maxHeight = c[e].titleWrap ? 0.8 * g.height : 1.5 * c[e].titleFontSize, c[e]._titleTextBlock.angle = 0);
            for (; 4 > r;) {
                V = X = U = O = S = C = L = f = P = K = Q = N = 0;
                if (a && 0 < a.length)
                    for (B = [], e = X = 0; e < a.length; e++) B.push(Math.ceil(a[e] ? a[e].createLabelsAndCalculateWidth() : 0)), X += B[e], f += a[e] ? a[e].margin : 0;
                else B.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateWidth() : 0));
                I.push(B);
                if (d && 0 < d.length)
                    for (q = [], e = V = 0; e < d.length; e++) q.push(Math.ceil(d[e] ? d[e].createLabelsAndCalculateWidth() : 0)), V += q[e], L += d[e] ? d[e].margin : 0;
                else q.push(Math.ceil(d[0] ? d[0].createLabelsAndCalculateWidth() : 0));
                M.push(q);
                if (b && 0 < b.length)
                    for (e = 0; e < b.length; e++) b[e].lineCoordinates = {}, h = Math.round(g.x1 + X + f), k = Math.round(g.x2 - V - L > n.width - 10 ? n.width - 10 : g.x2 - V - L), b[e].labelAutoFit && !x(v) && (0 < !a.length && (h = 0 > b[e].labelAngle ? Math.max(h, v) : 0 === b[e].labelAngle ? Math.max(h, v / 2) : h), 0 < !d.length && (k = 0 < b[e].labelAngle ? k - w / 2 : 0 === b[e].labelAngle ?
                        k - w / 2 : k)), b[e].lineCoordinates.x1 = h, b[e].lineCoordinates.x2 = k, b[e].lineCoordinates.width = Math.abs(k - h), b[e].title && (b[e]._titleTextBlock.maxWidth = 0 < b[e].titleMaxWidth && b[e].titleMaxWidth < b[e].lineCoordinates.width ? b[e].titleMaxWidth : b[e].lineCoordinates.width);
                if (c && 0 < c.length)
                    for (e = 0; e < c.length; e++) c[e].lineCoordinates = {}, h = Math.round(g.x1 + X + f), k = Math.round(g.x2 - V - L > c[e].chart.width - 10 ? c[e].chart.width - 10 : g.x2 - V - L), c[e] && c[e].labelAutoFit && !x(u) && (0 < !a.length && (h = 0 < c[e].labelAngle ? Math.max(h, u) :
                        0 === c[e].labelAngle ? Math.max(h, u / 2) : h), 0 < !d.length && (k -= t / 2)), c[e].lineCoordinates.x1 = h, c[e].lineCoordinates.x2 = k, c[e].lineCoordinates.width = Math.abs(k - h), c[e].title && (c[e]._titleTextBlock.maxWidth = 0 < c[e].titleMaxWidth && c[e].titleMaxWidth < c[e].lineCoordinates.width ? c[e].titleMaxWidth : c[e].lineCoordinates.width);
                if (b && 0 < b.length)
                    for (z = [], e = O = 0; e < b.length; e++) z.push(Math.ceil(b[e] ? b[e].createLabelsAndCalculateHeight() : 0)), O += z[e] + b[e].margin, C += b[e].margin;
                else z.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateHeight() :
                    0));
                s.push(z);
                if (c && 0 < c.length)
                    for (A = [], e = U = 0; e < c.length; e++) A.push(Math.ceil(c[e] ? c[e].createLabelsAndCalculateHeight() : 0)), U += A[e], S += c[e].margin;
                else A.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateHeight() : 0));
                H.push(A);
                if (b && 0 < b.length)
                    for (e = 0; e < b.length; e++) 0 < b[e]._labels.length && (m = b[e]._labels[0], l = b[e]._labels[b[e]._labels.length - 1], v = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)),
                        w = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) + (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle)));
                if (c && 0 < c.length)
                    for (e = 0; e < c.length; e++) c[e] && 0 < c[e]._labels.length && (m = c[e]._labels[0], l = c[e]._labels[c[e]._labels.length - 1], u = m.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(m.textBlock.angle)) + (m.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(m.textBlock.angle)), t = l.textBlock.width * Math.cos(Math.PI / 180 * Math.abs(l.textBlock.angle)) +
                        (l.textBlock.height - l.textBlock.fontSize / 2) * Math.sin(Math.PI / 180 * Math.abs(l.textBlock.angle)));
                if (n.panEnabled)
                    for (e = 0; e < b.length; e++) z[e] = n.sessionVariables.axisY.height;
                else
                    for (e = 0; e < b.length; e++) n.sessionVariables.axisY.height = z[e];
                if (b && 0 < b.length)
                    for (e = b.length - 1; 0 <= e; e--) l = Math.round(g.y2), m = Math.round(g.y2 > b[e].chart.height - 10 ? b[e].chart.height - 10 : g.y2), b[e].lineCoordinates.y1 = l - (z[e] + b[e].margin + N), b[e].lineCoordinates.y2 = l - (z[e] + b[e].margin + N), b[e].bounds = {
                        x1: h,
                        y1: l - (z[e] + N + b[e].margin),
                        x2: k,
                        y2: m - (N + b[e].margin),
                        width: k - h,
                        height: z[e]
                    }, b[e].title && (b[e]._titleTextBlock.maxWidth = 0 < b[e].titleMaxWidth && b[e].titleMaxWidth < b[e].lineCoordinates.width ? b[e].titleMaxWidth : b[e].lineCoordinates.width), N += z[e] + b[e].margin;
                if (c && 0 < c.length)
                    for (e = c.length - 1; 0 <= e; e--) c[e] && (l = Math.round(g.y1), m = Math.round(g.y1 + (A[e] + c[e].margin + Q)), c[e].lineCoordinates.y1 = m, c[e].lineCoordinates.y2 = m, c[e].bounds = {
                        x1: h,
                        y1: l + (c[e].margin + Q),
                        x2: k,
                        y2: m,
                        width: k - h,
                        height: U
                    }, c[e].title && (c[e]._titleTextBlock.maxWidth = 0 <
                        c[e].titleMaxWidth && c[e].titleMaxWidth < c[e].lineCoordinates.width ? c[e].titleMaxWidth : c[e].lineCoordinates.width), Q += A[e] + c[e].margin);
                if (a && 0 < a.length)
                    for (e = 0; e < a.length; e++) {
                        C = a[e]._labels && 0 < a[e]._labels.length ? a[e]._labels[0].textBlock.fontSize / 2 : 0;
                        h = Math.round(g.x1 + f);
                        l = c && 0 < c.length ? Math.round(c[0] ? c[0].lineCoordinates.y2 : g.y1 < Math.max(C, 10) ? Math.max(C, 10) : g.y1) : g.y1 < Math.max(C, 10) ? Math.max(C, 10) : g.y1;
                        k = Math.round(g.x1 + X + f);
                        m = b && 0 < b.length ? Math.round(b[0] ? b[0].lineCoordinates.y1 : g.y2 - O > n.height -
                            Math.max(C, 10) ? n.height - Math.max(C, 10) : g.y2 - O) : g.y2 > n.height - Math.max(C, 10) ? n.height - Math.max(C, 10) : g.y2;
                        if (b && 0 < b.length)
                            for (C = 0; C < b.length; C++) b[C] && b[C].labelAutoFit && (k = 0 > b[C].labelAngle ? Math.max(k, v) : 0 === b[C].labelAngle ? Math.max(k, v / 2) : k, h = 0 > b[C].labelAngle || 0 === b[C].labelAngle ? k - X : h);
                        if (c && 0 < c.length)
                            for (C = 0; C < c.length; C++) c[C] && c[C].labelAutoFit && (k = c[C].lineCoordinates.x1, h = k - X);
                        a[e].lineCoordinates = {
                            x1: k - K,
                            y1: l,
                            x2: k - K,
                            y2: m,
                            height: Math.abs(m - l)
                        };
                        a[e].bounds = {
                            x1: k - (B[e] + K),
                            y1: l,
                            x2: k,
                            y2: m,
                            width: k -
                                h,
                            height: m - l
                        };
                        a[e].title && (a[e]._titleTextBlock.maxWidth = 0 < a[e].titleMaxWidth && a[e].titleMaxWidth < a[e].lineCoordinates.height ? a[e].titleMaxWidth : a[e].lineCoordinates.height);
                        a[e].calculateValueToPixelConversionParameters();
                        K += B[e] + a[e].margin
                    }
                if (d && 0 < d.length)
                    for (e = 0; e < d.length; e++) {
                        C = d[e]._labels && 0 < d[e]._labels.length ? d[e]._labels[0].textBlock.fontSize / 2 : 0;
                        h = Math.round(g.x1 - f);
                        l = c && 0 < c.length ? Math.round(c[0] ? c[0].lineCoordinates.y2 : g.y1 < Math.max(C, 10) ? Math.max(C, 10) : g.y1) : g.y1 < Math.max(C, 10) ? Math.max(C,
                            10) : g.y1;
                        k = Math.round(g.x2 - V - L);
                        m = b && 0 < b.length ? Math.round(b[0] ? b[0].lineCoordinates.y1 : g.y2 - O > n.height - Math.max(C, 10) ? n.height - Math.max(C, 10) : g.y2 - O) : g.y2 > n.height - Math.max(C, 10) ? n.height - Math.max(C, 10) : g.y2;
                        if (b && 0 < b.length)
                            for (C = 0; C < b.length; C++) b[C] && b[C].labelAutoFit && (k = 0 > b[C].labelAngle ? Math.max(k, v) : 0 === b[e].labelAngle ? Math.max(k, v / 2) : k, h = 0 > b[C].labelAngle || 0 === b[C].labelAngle ? k - V : h);
                        if (c && 0 < c.length)
                            for (C = 0; C < c.length; C++) c[C] && c[C].labelAutoFit && (k = c[C].lineCoordinates.x2, h = k - V);
                        d[e].lineCoordinates = {
                            x1: k + P,
                            y1: l,
                            x2: k + P,
                            y2: m,
                            height: Math.abs(m - l)
                        };
                        d[e].bounds = {
                            x1: h,
                            y1: l,
                            x2: k,
                            y2: m,
                            width: k - h,
                            height: m - l
                        };
                        d[e].title && (d[e]._titleTextBlock.maxWidth = 0 < d[e].titleMaxWidth && d[e].titleMaxWidth < d[e].lineCoordinates.height ? d[e].titleMaxWidth : d[e].lineCoordinates.height);
                        d[e].calculateValueToPixelConversionParameters();
                        P += q[e] + d[e].margin
                    }
                if (b && 0 < b.length)
                    for (e = 0; e < b.length; e++) b[e].calculateValueToPixelConversionParameters();
                if (c && 0 < c.length)
                    for (e = 0; e < c.length; e++) c[e].calculateValueToPixelConversionParameters();
                if (0 < r) {
                    if (a && 0 < a.length)
                        for (e = 0; e < a.length; e++) E = I[r - 1][e] === I[r][e] ? !0 : !1;
                    else E = !0;
                    if (d && 0 < d.length)
                        for (e = 0; e < d.length; e++) F = M[r - 1][e] === M[r][e] ? !0 : !1;
                    else F = !0;
                    if (b && 0 < b.length)
                        for (e = 0; e < b.length; e++) G = s[r - 1][e] === s[r][e] ? !0 : !1;
                    else G = !0;
                    if (c && 0 < c.length)
                        for (e = 0; e < c.length; e++) J = H[r - 1][e] === H[r][e] ? !0 : !1;
                    else J = !0
                }
                if (E && F && G && J) break;
                r++
            }
            if (b && 0 < b.length)
                for (e = 0; e < b.length; e++) b[e].renderLabelsTicksAndTitle();
            if (c && 0 < c.length)
                for (e = 0; e < c.length; e++) c[e].renderLabelsTicksAndTitle();
            if (a && 0 < a.length)
                for (e =
                    0; e < a.length; e++) a[e].renderLabelsTicksAndTitle();
            if (d && 0 < d.length)
                for (e = 0; e < d.length; e++) d[e].renderLabelsTicksAndTitle()
        }
        n.preparePlotArea();
        g = n.plotArea;
        p.save();
        p.beginPath();
        p.rect(g.x1, g.y1, Math.abs(g.x2 - g.x1), Math.abs(g.y2 - g.y1));
        p.clip();
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e].renderStripLinesOfThicknessType("value");
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].renderStripLinesOfThicknessType("value");
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e].renderStripLinesOfThicknessType("value");
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].renderStripLinesOfThicknessType("value");
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e].renderInterlacedColors();
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].renderInterlacedColors();
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e].renderInterlacedColors();
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].renderInterlacedColors();
        p.restore();
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e].renderGrid();
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].renderGrid();
        if (b && 0 <
            b.length)
            for (e = 0; e < b.length; e++) b[e].renderGrid();
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].renderGrid();
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e].renderAxisLine();
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].renderAxisLine();
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e].renderAxisLine();
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].renderAxisLine();
        if (a && 0 < a.length)
            for (e = 0; e < a.length; e++) a[e].renderStripLinesOfThicknessType("pixel");
        if (d && 0 < d.length)
            for (e = 0; e < d.length; e++) d[e].renderStripLinesOfThicknessType("pixel");
        if (b && 0 < b.length)
            for (e = 0; e < b.length; e++) b[e].renderStripLinesOfThicknessType("pixel");
        if (c && 0 < c.length)
            for (e = 0; e < c.length; e++) c[e].renderStripLinesOfThicknessType("pixel")
    };
    B.prototype.renderLabelsTicksAndTitle = function() {
        var a = !1,
            d = 0,
            b = 0,
            c = 1,
            f = 0;
        0 !== this.labelAngle && 360 !== this.labelAngle && (c = 1.2);
        if ("undefined" === typeof this.options.interval) {
            if ("bottom" === this._position || "top" === this._position)
                if (this.logarithmic && !this.equidistantInterval && this.labelAutoFit) {
                    for (var d = [], c = 0 !== this.labelAngle &&
                            360 !== this.labelAngle ? 1 : 1.2, g, h = this.viewportMaximum, l = this.lineCoordinates.width / Math.log(this.range), k = this._labels.length - 1; 0 <= k; k--) {
                        n = this._labels[k];
                        if (n.position < this.viewportMinimum) break;
                        n.position > this.viewportMaximum || !(k === this._labels.length - 1 || g < Math.log(h / n.position) * l / c) || (d.push(n), h = n.position, g = n.textBlock.width * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + n.textBlock.height * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)))
                    }
                    this._labels = d
                } else {
                    for (k = 0; k < this._labels.length; k++) n =
                        this._labels[k], n.position < this.viewportMinimum || (n = n.textBlock.width * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + n.textBlock.height * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)), d += n);
                    d > this.lineCoordinates.width * c && this.labelAutoFit && (a = !0)
                }
            if ("left" === this._position || "right" === this._position)
                if (this.logarithmic && !this.equidistantInterval && this.labelAutoFit) {
                    for (var d = [], m, h = this.viewportMaximum, l = this.lineCoordinates.height / Math.log(this.range), k = this._labels.length - 1; 0 <= k; k--) {
                        n = this._labels[k];
                        if (n.position < this.viewportMinimum) break;
                        n.position > this.viewportMaximum || !(k === this._labels.length - 1 || m < Math.log(h / n.position) * l) || (d.push(n), h = n.position, m = n.textBlock.height * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + n.textBlock.width * Math.abs(Math.sin(Math.PI / 180 * this.labelAngle)))
                    }
                    this._labels = d
                } else {
                    for (k = 0; k < this._labels.length; k++) n = this._labels[k], n.position < this.viewportMinimum || (n = n.textBlock.height * Math.abs(Math.cos(Math.PI / 180 * this.labelAngle)) + n.textBlock.width * Math.abs(Math.sin(Math.PI /
                        180 * this.labelAngle)), b += n);
                    b > this.lineCoordinates.height * c && this.labelAutoFit && (a = !0)
                }
        }
        if ("bottom" === this._position) {
            for (var n, k = 0; k < this._labels.length; k++) n = this._labels[k], n.position < this.viewportMinimum || n.position > this.viewportMaximum || (b = this.getPixelCoordinatesOnAxis(n.position), a && 0 !== f++ % 2 && this.labelAutoFit || (this.tickThickness && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (b.x << 0) + 0.5 : b.x << 0, this.ctx.beginPath(), this.ctx.moveTo(c,
                b.y << 0), this.ctx.lineTo(c, b.y + this.tickLength << 0), this.ctx.stroke()), 0 === n.textBlock.angle ? (b.x -= n.textBlock.width / 2, b.y += this.tickLength + n.textBlock.fontSize / 2) : (b.x -= 0 > this.labelAngle ? n.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0, b.y += this.tickLength + Math.abs(0 > this.labelAngle ? n.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) - 5 : 5)), n.textBlock.x = b.x, n.textBlock.y = b.y, n.textBlock.render(!0)));
            this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.lineCoordinates.x1 +
                this.lineCoordinates.width / 2 - this._titleTextBlock.width / 2, this._titleTextBlock.y = this.bounds.y2 - this._titleTextBlock.height - 3, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0))
        } else if ("top" === this._position) {
            for (k = 0; k < this._labels.length; k++) n = this._labels[k], n.position < this.viewportMinimum || n.position > this.viewportMaximum || (b = this.getPixelCoordinatesOnAxis(n.position), a && 0 !== f++ % 2 && this.labelAutoFit || (this.tickThickness && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle =
                this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (b.x << 0) + 0.5 : b.x << 0, this.ctx.beginPath(), this.ctx.moveTo(c, b.y << 0), this.ctx.lineTo(c, b.y - this.tickLength << 0), this.ctx.stroke()), 0 === n.textBlock.angle ? (b.x -= n.textBlock.width / 2, b.y -= this.tickLength + n.textBlock.height / 2) : (b.x += (n.textBlock.height - this.tickLength - this.labelFontSize / 2) * Math.sin(Math.PI / 180 * this.labelAngle) - (0 < this.labelAngle ? n.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0), b.y -= this.tickLength + (n.textBlock.height / 2 * Math.cos(Math.PI /
                180 * this.labelAngle) + (0 < this.labelAngle ? n.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) : 0))), n.textBlock.x = b.x, n.textBlock.y = b.y, n.textBlock.render(!0)));
            this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.lineCoordinates.x1 + this.lineCoordinates.width / 2 - this._titleTextBlock.width / 2, this._titleTextBlock.y = this.bounds.y1 + 1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0))
        } else if ("left" === this._position) {
            for (k = 0; k < this._labels.length; k++) n =
                this._labels[k], n.position < this.viewportMinimum || n.position > this.viewportMaximum || (b = this.getPixelCoordinatesOnAxis(n.position), a && 0 !== f++ % 2 && this.labelAutoFit || (this.tickThickness && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth % 2 ? (b.y << 0) + 0.5 : b.y << 0, this.ctx.beginPath(), this.ctx.moveTo(b.x << 0, c), this.ctx.lineTo(b.x - this.tickLength << 0, c), this.ctx.stroke()), 0 === this.labelAngle ? (n.textBlock.y = b.y, n.textBlock.x = b.x - n.textBlock.width * Math.cos(Math.PI /
                    180 * this.labelAngle) - this.tickLength - 5) : (n.textBlock.y = b.y - n.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle), n.textBlock.x = 0 < this.labelAngle ? b.x - n.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : b.x - n.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) + (n.textBlock.height - n.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) - this.tickLength), n.textBlock.render(!0)));
            this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.bounds.x1 + 1, this._titleTextBlock.y =
                this.lineCoordinates.height / 2 + this._titleTextBlock.width / 2 + this.lineCoordinates.y1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0))
        } else if ("right" === this._position) {
            for (k = 0; k < this._labels.length; k++) n = this._labels[k], n.position < this.viewportMinimum || n.position > this.viewportMaximum || (b = this.getPixelCoordinatesOnAxis(n.position), a && 0 !== f++ % 2 && this.labelAutoFit || (this.tickThickness && (this.ctx.lineWidth = this.tickThickness, this.ctx.strokeStyle = this.tickColor, c = 1 === this.ctx.lineWidth %
                2 ? (b.y << 0) + 0.5 : b.y << 0, this.ctx.beginPath(), this.ctx.moveTo(b.x << 0, c), this.ctx.lineTo(b.x + this.tickLength << 0, c), this.ctx.stroke()), 0 === this.labelAngle ? (n.textBlock.y = b.y, n.textBlock.x = b.x + this.tickLength + 5) : (n.textBlock.y = 0 > this.labelAngle ? b.y : b.y - (n.textBlock.height - n.textBlock.fontSize / 2 - 5) * Math.cos(Math.PI / 180 * this.labelAngle), n.textBlock.x = 0 < this.labelAngle ? b.x + (n.textBlock.height - n.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) + this.tickLength : b.x + this.tickLength + 5), n.textBlock.render(!0)));
            this.title && (this._titleTextBlock.measureText(), this._titleTextBlock.x = this.bounds.x2 - 1, this._titleTextBlock.y = this.lineCoordinates.height / 2 - this._titleTextBlock.width / 2 + this.lineCoordinates.y1, this.titleMaxWidth = this._titleTextBlock.maxWidth, this._titleTextBlock.render(!0))
        }
    };
    B.prototype.renderInterlacedColors = function() {
        var a = this.chart.plotArea.ctx,
            d, b, c = this.chart.plotArea,
            f = 0;
        d = !0;
        if (("bottom" === this._position || "top" === this._position) && this.interlacedColor)
            for (a.fillStyle = this.interlacedColor,
                f = 0; f < this._labels.length; f++) d ? (d = this.getPixelCoordinatesOnAxis(this._labels[f].position), b = f + 1 > this._labels.length - 1 ? this.getPixelCoordinatesOnAxis(this.viewportMaximum) : this.getPixelCoordinatesOnAxis(this._labels[f + 1].position), a.fillRect(Math.min(b.x, d.x), c.y1, Math.abs(b.x - d.x), Math.abs(c.y1 - c.y2)), d = !1) : d = !0;
        else if (("left" === this._position || "right" === this._position) && this.interlacedColor)
            for (a.fillStyle = this.interlacedColor, f = 0; f < this._labels.length; f++) d ? (b = this.getPixelCoordinatesOnAxis(this._labels[f].position),
                d = f + 1 > this._labels.length - 1 ? this.getPixelCoordinatesOnAxis(this.viewportMaximum) : this.getPixelCoordinatesOnAxis(this._labels[f + 1].position), a.fillRect(c.x1, Math.min(b.y, d.y), Math.abs(c.x1 - c.x2), Math.abs(d.y - b.y)), d = !1) : d = !0;
        a.beginPath()
    };
    B.prototype.renderStripLinesOfThicknessType = function(a) {
        if (this.stripLines && 0 < this.stripLines.length && a) {
            for (var d = this, b, c = 0, f = 0, g = !1, h = !1, l = [], k = [], h = !1, c = 0; c < this.stripLines.length; c++) {
                var m = this.stripLines[c];
                m._thicknessType === a && ("pixel" === a && (m.value < this.viewportMinimum ||
                    m.value > this.viewportMaximum || x(m.value) || isNaN(this.range)) || l.push(m))
            }
            for (c = 0; c < this._stripLineLabels.length; c++)
                if (m = this.stripLines[c], b = this._stripLineLabels[c], !(b.position < this.viewportMinimum || b.position > this.viewportMaximum || isNaN(this.range))) {
                    a = this.getPixelCoordinatesOnAxis(b.position);
                    if ("outside" === b.stripLine.labelPlacement)
                        if (m && (this.ctx.strokeStyle = m.color, "pixel" === m._thicknessType && (this.ctx.lineWidth = m.thickness)), "bottom" === this._position) {
                            var n = 1 === this.ctx.lineWidth % 2 ? (a.x <<
                                0) + 0.5 : a.x << 0;
                            this.ctx.beginPath();
                            this.ctx.moveTo(n, a.y << 0);
                            this.ctx.lineTo(n, a.y + this.tickLength << 0);
                            this.ctx.stroke();
                            0 === this.labelAngle ? (a.x -= b.textBlock.width / 2, a.y += this.tickLength + b.textBlock.fontSize / 2) : (a.x -= 0 > this.labelAngle ? b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0, a.y += this.tickLength + Math.abs(0 > this.labelAngle ? b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) - 5 : 5))
                        } else "top" === this._position ? (n = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0, this.ctx.beginPath(), this.ctx.moveTo(n,
                                a.y << 0), this.ctx.lineTo(n, a.y - this.tickLength << 0), this.ctx.stroke(), 0 === this.labelAngle ? (a.x -= b.textBlock.width / 2, a.y -= this.tickLength + b.textBlock.height) : (a.x += (b.textBlock.height - this.tickLength - this.labelFontSize / 2) * Math.sin(Math.PI / 180 * this.labelAngle) - (0 < this.labelAngle ? b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) : 0), a.y -= this.tickLength + (b.textBlock.height * Math.cos(Math.PI / 180 * this.labelAngle) + (0 < this.labelAngle ? b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle) : 0)))) : "left" ===
                            this._position ? (n = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, this.ctx.beginPath(), this.ctx.moveTo(a.x << 0, n), this.ctx.lineTo(a.x - this.tickLength << 0, n), this.ctx.stroke(), 0 === this.labelAngle ? a.x = a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : (a.y -= b.textBlock.width * Math.sin(Math.PI / 180 * this.labelAngle), a.x = 0 < this.labelAngle ? a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) - this.tickLength - 5 : a.x - b.textBlock.width * Math.cos(Math.PI / 180 * this.labelAngle) + (b.textBlock.height -
                                b.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI / 180 * this.labelAngle) - this.tickLength)) : "right" === this._position && (n = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, this.ctx.beginPath(), this.ctx.moveTo(a.x << 0, n), this.ctx.lineTo(a.x + this.tickLength << 0, n), this.ctx.stroke(), 0 === this.labelAngle ? a.x = a.x + this.tickLength + 5 : (a.y = 0 > this.labelAngle ? a.y : a.y - (b.textBlock.height - b.textBlock.fontSize / 2 - 5) * Math.cos(Math.PI / 180 * this.labelAngle), a.x = 0 < this.labelAngle ? a.x + (b.textBlock.height - b.textBlock.fontSize / 2 - 5) * Math.sin(Math.PI /
                                180 * this.labelAngle) + this.tickLength : a.x + this.tickLength + 5));
                    else b.textBlock.angle = -90, "bottom" === this._position ? (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.height - 3, b.textBlock.measureText(), a.x - b.textBlock.height > this.chart.plotArea.x1 ? x(m.startValue) ? a.x -= b.textBlock.height - b.textBlock.fontSize / 2 : a.x -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3 : (b.textBlock.angle = 90, x(m.startValue) ? a.x += b.textBlock.height - b.textBlock.fontSize /
                            2 : a.x += b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3), a.y = -90 === b.textBlock.angle ? "near" === b.stripLine.labelAlign ? this.chart.plotArea.y2 - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 + b.textBlock.width) / 2 : this.chart.plotArea.y1 + b.textBlock.width + 3 : "near" === b.stripLine.labelAlign ? this.chart.plotArea.y2 - b.textBlock.width - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 - b.textBlock.width) / 2 : this.chart.plotArea.y1 + 3) : "top" === this._position ?
                        (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.height - 3, b.textBlock.measureText(), a.x - b.textBlock.height > this.chart.plotArea.x1 ? x(m.startValue) ? a.x -= b.textBlock.height - b.textBlock.fontSize / 2 : a.x -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3 : (b.textBlock.angle = 90, x(m.startValue) ? a.x += b.textBlock.height - b.textBlock.fontSize / 2 : a.x += b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3), a.y = -90 === b.textBlock.angle ? "near" === b.stripLine.labelAlign ?
                            this.chart.plotArea.y1 + b.textBlock.width + 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 + b.textBlock.width) / 2 : this.chart.plotArea.y2 - 3 : "near" === b.stripLine.labelAlign ? this.chart.plotArea.y1 + 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.y2 + this.chart.plotArea.y1 - b.textBlock.width) / 2 : this.chart.plotArea.y2 - b.textBlock.width - 3) : "left" === this._position ? (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth :
                            this.chart.plotArea.width - 3, b.textBlock.angle = 0, b.textBlock.measureText(), a.y - b.textBlock.height > this.chart.plotArea.y1 ? x(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize + 3 : a.y - b.textBlock.height < this.chart.plotArea.y2 ? a.y += b.textBlock.fontSize / 2 + 3 : x(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize + 3, a.x = "near" === b.stripLine.labelAlign ? this.chart.plotArea.x1 + 3 : "center" === b.stripLine.labelAlign ?
                            (this.chart.plotArea.x2 + this.chart.plotArea.x1) / 2 - b.textBlock.width / 2 : this.chart.plotArea.x2 - b.textBlock.width - 3) : "right" === this._position && (b.textBlock.maxWidth = this.options.stripLines[c].labelMaxWidth ? this.options.stripLines[c].labelMaxWidth : this.chart.plotArea.width - 3, b.textBlock.angle = 0, b.textBlock.measureText(), a.y - +b.textBlock.height > this.chart.plotArea.y1 ? x(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 - 3 : a.y - b.textBlock.height <
                            this.chart.plotArea.y2 ? a.y += b.textBlock.fontSize / 2 + 3 : x(m.startValue) ? a.y -= b.textBlock.height - b.textBlock.fontSize / 2 : a.y -= b.textBlock.height / 2 - b.textBlock.fontSize / 2 + 3, a.x = "near" === b.stripLine.labelAlign ? this.chart.plotArea.x2 - b.textBlock.width - 3 : "center" === b.stripLine.labelAlign ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) / 2 - b.textBlock.width / 2 : this.chart.plotArea.x1 + 3);
                    b.textBlock.x = a.x;
                    b.textBlock.y = a.y;
                    k.push(b)
                }
            if (!h) {
                h = !1;
                this.ctx.save();
                this.ctx.beginPath();
                this.ctx.rect(this.chart.plotArea.x1,
                    this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);
                this.ctx.clip();
                for (c = 0; c < l.length; c++) m = l[c], m.showOnTop ? g || (g = !0, this.chart.addEventListener("dataAnimationIterationEnd", function() {
                    this.ctx.save();
                    this.ctx.beginPath();
                    this.ctx.rect(this.chart.plotArea.x1, this.chart.plotArea.y1, this.chart.plotArea.width, this.chart.plotArea.height);
                    this.ctx.clip();
                    for (f = 0; f < l.length; f++) m = l[f], m.showOnTop && m.render();
                    this.ctx.restore()
                }, m)) : m.render();
                for (c = 0; c < k.length; c++) b = k[c], b.stripLine.showOnTop ?
                    h || (h = !0, this.chart.addEventListener("dataAnimationIterationEnd", function() {
                        for (f = 0; f < k.length; f++) b = k[f], "inside" === b.stripLine.labelPlacement && b.stripLine.showOnTop && (d.ctx.save(), d.ctx.beginPath(), d.ctx.rect(d.chart.plotArea.x1, d.chart.plotArea.y1, d.chart.plotArea.width, d.chart.plotArea.height), d.ctx.clip(), b.textBlock.render(!0), d.ctx.restore())
                    }, b.textBlock)) : "inside" === b.stripLine.labelPlacement && b.textBlock.render(!0);
                this.ctx.restore();
                h = !0
            }
            if (h)
                for (h = !1, c = 0; c < k.length; c++) b = k[c], b.stripLine.showOnTop ?
                    h || (h = !0, this.chart.addEventListener("dataAnimationIterationEnd", function() {
                        for (f = 0; f < k.length; f++) b = k[f], "outside" === b.stripLine.labelPlacement && b.stripLine.showOnTop && b.textBlock.render(!0)
                    }, b.textBlock)) : "outside" === b.stripLine.labelPlacement && b.textBlock.render(!0)
        }
    };
    B.prototype.renderGrid = function() {
        if (this.gridThickness && 0 < this.gridThickness) {
            var a = this.chart.ctx;
            a.save();
            var d, b = this.chart.plotArea;
            a.lineWidth = this.gridThickness;
            a.strokeStyle = this.gridColor;
            a.setLineDash && a.setLineDash(I(this.gridDashType,
                this.gridThickness));
            if ("bottom" === this._position || "top" === this._position)
                for (c = 0; c < this._labels.length; c++) this._labels[c].position < this.viewportMinimum || this._labels[c].position > this.viewportMaximum || (a.beginPath(), d = this.getPixelCoordinatesOnAxis(this._labels[c].position), d = 1 === a.lineWidth % 2 ? (d.x << 0) + 0.5 : d.x << 0, a.moveTo(d, b.y1 << 0), a.lineTo(d, b.y2 << 0), a.stroke());
            else if ("left" === this._position || "right" === this._position)
                for (var c = 0; c < this._labels.length; c++) this._labels[c].position < this.viewportMinimum ||
                    this._labels[c].position > this.viewportMaximum || (a.beginPath(), d = this.getPixelCoordinatesOnAxis(this._labels[c].position), d = 1 === a.lineWidth % 2 ? (d.y << 0) + 0.5 : d.y << 0, a.moveTo(b.x1 << 0, d), a.lineTo(b.x2 << 0, d), a.stroke());
            a.restore()
        }
    };
    B.prototype.renderAxisLine = function() {
        var a = this.chart.ctx;
        a.save();
        if ("bottom" === this._position || "top" === this._position) {
            if (this.lineThickness) {
                a.lineWidth = this.lineThickness;
                a.strokeStyle = this.lineColor ? this.lineColor : "black";
                a.setLineDash && a.setLineDash(I(this.lineDashType,
                    this.lineThickness));
                var d = 1 === this.lineThickness % 2 ? (this.lineCoordinates.y1 << 0) + 0.5 : this.lineCoordinates.y1 << 0;
                a.beginPath();
                a.moveTo(this.lineCoordinates.x1, d);
                a.lineTo(this.lineCoordinates.x2, d);
                a.stroke()
            }
        } else "left" !== this._position && "right" !== this._position || !this.lineThickness || (a.lineWidth = this.lineThickness, a.strokeStyle = this.lineColor, a.setLineDash && a.setLineDash(I(this.lineDashType, this.lineThickness)), d = 1 === this.lineThickness % 2 ? (this.lineCoordinates.x1 << 0) + 0.5 : this.lineCoordinates.x1 <<
            0, a.beginPath(), a.moveTo(d, this.lineCoordinates.y1), a.lineTo(d, this.lineCoordinates.y2), a.stroke());
        a.restore()
    };
    B.prototype.getPixelCoordinatesOnAxis = function(a) {
        var d = {};
        if ("bottom" === this._position || "top" === this._position) d.x = this.convertValueToPixel(a), d.y = this.lineCoordinates.y1;
        if ("left" === this._position || "right" === this._position) d.y = this.convertValueToPixel(a), d.x = this.lineCoordinates.x2;
        return d
    };
    B.prototype.convertPixelToValue = function(a) {
        if ("undefined" === typeof a) return null;
        var d = 0,
            d = 0,
            d = "number" === typeof a ? a : "left" === this._position || "right" === this._position ? a.y : a.x;
        return d = this.logarithmic ? Math.pow(this.logarithmBase, (d - this.conversionParameters.reference) / this.conversionParameters.pixelPerUnit) * this.viewportMinimum : this.conversionParameters.minimum + (d - this.conversionParameters.reference) / this.conversionParameters.pixelPerUnit
    };
    B.prototype.convertValueToPixel = function(a) {
        return this.logarithmic ? this.conversionParameters.reference + this.conversionParameters.pixelPerUnit * Math.log(a /
            this.conversionParameters.minimum) / this.conversionParameters.lnLogarithmBase + 0.5 << 0 : this.conversionParameters.reference + this.conversionParameters.pixelPerUnit * (a - this.conversionParameters.minimum) + 0.5 << 0
    };
    B.prototype.setViewPortRange = function(a, d) {
        this.sessionVariables.newViewportMinimum = this.viewportMinimum = Math.min(a, d);
        this.sessionVariables.newViewportMaximum = this.viewportMaximum = Math.max(a, d)
    };
    B.prototype.getXValueAt = function(a) {
        if (!a) return null;
        var d = null;
        "left" === this._position ? d = this.convertPixelToValue(a.y) :
            "bottom" === this._position && (d = this.convertPixelToValue(a.x));
        return d
    };
    B.prototype.calculateValueToPixelConversionParameters = function(a) {
        a = {
            pixelPerUnit: null,
            minimum: null,
            reference: null
        };
        var d = this.lineCoordinates.width,
            b = this.lineCoordinates.height;
        a.minimum = this.viewportMinimum;
        if ("bottom" === this._position || "top" === this._position) this.logarithmic ? (a.lnLogarithmBase = Math.log(this.logarithmBase), a.pixelPerUnit = (this.reversed ? -1 : 1) * d * a.lnLogarithmBase / Math.log(Math.abs(this.range))) : a.pixelPerUnit =
            (this.reversed ? -1 : 1) * d / Math.abs(this.range), a.reference = this.reversed ? this.lineCoordinates.x2 : this.lineCoordinates.x1;
        if ("left" === this._position || "right" === this._position) this.logarithmic ? (a.lnLogarithmBase = Math.log(this.logarithmBase), a.pixelPerUnit = (this.reversed ? 1 : -1) * b * a.lnLogarithmBase / Math.log(Math.abs(this.range))) : a.pixelPerUnit = (this.reversed ? 1 : -1) * b / Math.abs(this.range), a.reference = this.reversed ? this.lineCoordinates.y1 : this.lineCoordinates.y2;
        this.conversionParameters = a
    };
    B.prototype.calculateAxisParameters =
        function() {
            if (this.logarithmic) this.calculateLogarithamicAxisParameters();
            else {
                var a = this.chart.layoutManager.getFreeSpace(),
                    d = !1,
                    b = !1;
                "bottom" === this._position || "top" === this._position ? (this.maxWidth = a.width, this.maxHeight = a.height) : (this.maxWidth = a.height, this.maxHeight = a.width);
                var a = "axisX" === this.type ? "xySwapped" === this.chart.plotInfo.axisPlacement ? 62 : 70 : "xySwapped" === this.chart.plotInfo.axisPlacement ? 50 : 40,
                    c = 4;
                "axisX" === this.type && (c = 600 > this.maxWidth ? 8 : 6);
                var a = Math.max(c, Math.floor(this.maxWidth /
                        a)),
                    f, g, h, c = 0;
                if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = this.minimum;
                if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = this.maximum;
                if ("axisX" === this.type) {
                    if (this.dataSeries && 0 < this.dataSeries.length)
                        for (f = 0; f < this.dataSeries.length; f++) "dateTime" === this.dataSeries[f].xValueType && (b = !0);
                    f = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin;
                    g = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax;
                    0 === g - f && (c = "undefined" === typeof this.options.interval ? 0.4 : this.options.interval, g += c, f -= c);
                    Infinity !== this.dataInfo.minDiff ? h = this.dataInfo.minDiff : 1 < g - f ? h = 0.5 * Math.abs(g - f) : (h = 1, b && (d = !0))
                } else "axisY" === this.type && (f = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, g = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, isFinite(f) || isFinite(g) ? isFinite(f) ? isFinite(g) || (g = f) : f = g : (g = "undefined" === typeof this.options.interval ? -Infinity : this.options.interval,
                    f = 0), 0 === f && 0 === g ? (g += 9, f = 0) : 0 === g - f ? (c = Math.min(Math.abs(0.01 * Math.abs(g)), 5), g += c, f -= c) : f > g ? (c = Math.min(Math.abs(0.01 * Math.abs(g - f)), 5), 0 <= g ? f = g - c : g = f + c) : (c = Math.min(Math.abs(0.01 * Math.abs(g - f)), 0.05), 0 !== g && (g += c), 0 !== f && (f -= c)), h = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - f ? 0.5 * Math.abs(g - f) : 1, this.includeZero && (null === this.viewportMinimum || isNaN(this.viewportMinimum)) && 0 < f && (f = 0), this.includeZero && (null === this.viewportMaximum || isNaN(this.viewportMaximum)) && 0 > g && (g = 0));
                c = (isNaN(this.viewportMaximum) ||
                    null === this.viewportMaximum ? g : this.viewportMaximum) - (isNaN(this.viewportMinimum) || null === this.viewportMinimum ? f : this.viewportMinimum);
                if ("axisX" === this.type && b) {
                    this.intervalType || (c / 1 <= a ? (this.interval = 1, this.intervalType = "millisecond") : c / 2 <= a ? (this.interval = 2, this.intervalType = "millisecond") : c / 5 <= a ? (this.interval = 5, this.intervalType = "millisecond") : c / 10 <= a ? (this.interval = 10, this.intervalType = "millisecond") : c / 20 <= a ? (this.interval = 20, this.intervalType = "millisecond") : c / 50 <= a ? (this.interval = 50, this.intervalType =
                            "millisecond") : c / 100 <= a ? (this.interval = 100, this.intervalType = "millisecond") : c / 200 <= a ? (this.interval = 200, this.intervalType = "millisecond") : c / 250 <= a ? (this.interval = 250, this.intervalType = "millisecond") : c / 300 <= a ? (this.interval = 300, this.intervalType = "millisecond") : c / 400 <= a ? (this.interval = 400, this.intervalType = "millisecond") : c / 500 <= a ? (this.interval = 500, this.intervalType = "millisecond") : c / (1 * E.secondDuration) <= a ? (this.interval = 1, this.intervalType = "second") : c / (2 * E.secondDuration) <= a ? (this.interval = 2, this.intervalType =
                            "second") : c / (5 * E.secondDuration) <= a ? (this.interval = 5, this.intervalType = "second") : c / (10 * E.secondDuration) <= a ? (this.interval = 10, this.intervalType = "second") : c / (15 * E.secondDuration) <= a ? (this.interval = 15, this.intervalType = "second") : c / (20 * E.secondDuration) <= a ? (this.interval = 20, this.intervalType = "second") : c / (30 * E.secondDuration) <= a ? (this.interval = 30, this.intervalType = "second") : c / (1 * E.minuteDuration) <= a ? (this.interval = 1, this.intervalType = "minute") : c / (2 * E.minuteDuration) <= a ? (this.interval = 2, this.intervalType =
                            "minute") : c / (5 * E.minuteDuration) <= a ? (this.interval = 5, this.intervalType = "minute") : c / (10 * E.minuteDuration) <= a ? (this.interval = 10, this.intervalType = "minute") : c / (15 * E.minuteDuration) <= a ? (this.interval = 15, this.intervalType = "minute") : c / (20 * E.minuteDuration) <= a ? (this.interval = 20, this.intervalType = "minute") : c / (30 * E.minuteDuration) <= a ? (this.interval = 30, this.intervalType = "minute") : c / (1 * E.hourDuration) <= a ? (this.interval = 1, this.intervalType = "hour") : c / (2 * E.hourDuration) <= a ? (this.interval = 2, this.intervalType = "hour") :
                        c / (3 * E.hourDuration) <= a ? (this.interval = 3, this.intervalType = "hour") : c / (6 * E.hourDuration) <= a ? (this.interval = 6, this.intervalType = "hour") : c / (1 * E.dayDuration) <= a ? (this.interval = 1, this.intervalType = "day") : c / (2 * E.dayDuration) <= a ? (this.interval = 2, this.intervalType = "day") : c / (4 * E.dayDuration) <= a ? (this.interval = 4, this.intervalType = "day") : c / (1 * E.weekDuration) <= a ? (this.interval = 1, this.intervalType = "week") : c / (2 * E.weekDuration) <= a ? (this.interval = 2, this.intervalType = "week") : c / (3 * E.weekDuration) <= a ? (this.interval =
                            3, this.intervalType = "week") : c / (1 * E.monthDuration) <= a ? (this.interval = 1, this.intervalType = "month") : c / (2 * E.monthDuration) <= a ? (this.interval = 2, this.intervalType = "month") : c / (3 * E.monthDuration) <= a ? (this.interval = 3, this.intervalType = "month") : c / (6 * E.monthDuration) <= a ? (this.interval = 6, this.intervalType = "month") : (this.interval = c / (1 * E.yearDuration) <= a ? 1 : c / (2 * E.yearDuration) <= a ? 2 : c / (4 * E.yearDuration) <= a ? 4 : Math.floor(B.getNiceNumber(c / (a - 1), !0) / E.yearDuration), this.intervalType = "year"));
                    if (null === this.viewportMinimum ||
                        isNaN(this.viewportMinimum)) this.viewportMinimum = f - h / 2;
                    if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = g + h / 2;
                    d ? this.autoValueFormatString = "MMM DD YYYY HH:mm" : "year" === this.intervalType ? this.autoValueFormatString = "YYYY" : "month" === this.intervalType ? this.autoValueFormatString = "MMM YYYY" : "week" === this.intervalType ? this.autoValueFormatString = "MMM DD YYYY" : "day" === this.intervalType ? this.autoValueFormatString = "MMM DD YYYY" : "hour" === this.intervalType ? this.autoValueFormatString =
                        "hh:mm TT" : "minute" === this.intervalType ? this.autoValueFormatString = "hh:mm TT" : "second" === this.intervalType ? this.autoValueFormatString = "hh:mm:ss TT" : "millisecond" === this.intervalType && (this.autoValueFormatString = "fff'ms'");
                    this.valueFormatString || (this.valueFormatString = this.autoValueFormatString)
                } else {
                    this.intervalType = "number";
                    c = B.getNiceNumber(c, !1);
                    this.interval = this.options && 0 < this.options.interval ? this.options.interval : B.getNiceNumber(c / (a - 1), !0);
                    if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum =
                        "axisX" === this.type ? f - h / 2 : Math.floor(f / this.interval) * this.interval;
                    if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = "axisX" === this.type ? g + h / 2 : Math.ceil(g / this.interval) * this.interval;
                    0 === this.viewportMaximum && 0 === this.viewportMinimum && (0 === this.options.viewportMinimum ? this.viewportMaximum += 10 : 0 === this.options.viewportMaximum && (this.viewportMinimum -= 10), this.options && "undefined" === typeof this.options.interval && (this.interval = B.getNiceNumber((this.viewportMaximum - this.viewportMinimum) /
                        (a - 1), !0)))
                }
                if (null === this.minimum || null === this.maximum)
                    if ("axisX" === this.type ? (f = null !== this.minimum ? this.minimum : this.dataInfo.min, g = null !== this.maximum ? this.maximum : this.dataInfo.max, 0 === g - f && (c = "undefined" === typeof this.options.interval ? 0.4 : this.options.interval, g += c, f -= c), h = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - f ? 0.5 * Math.abs(g - f) : 1) : "axisY" === this.type && (f = null !== this.minimum ? this.minimum : this.dataInfo.min, g = null !== this.maximum ? this.maximum : this.dataInfo.max, isFinite(f) ||
                            isFinite(g) ? 0 === f && 0 === g ? (g += 9, f = 0) : 0 === g - f ? (c = Math.min(Math.abs(0.01 * Math.abs(g)), 5), g += c, f -= c) : f > g ? (c = Math.min(Math.abs(0.01 * Math.abs(g - f)), 5), 0 <= g ? f = g - c : g = f + c) : (c = Math.min(Math.abs(0.01 * Math.abs(g - f)), 0.05), 0 !== g && (g += c), 0 !== f && (f -= c)) : (g = "undefined" === typeof this.options.interval ? -Infinity : this.options.interval, f = 0), h = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : 1 < g - f ? 0.5 * Math.abs(g - f) : 1, this.includeZero && (null === this.minimum || isNaN(this.minimum)) && 0 < f && (f = 0), this.includeZero && (null ===
                                this.maximum || isNaN(this.maximum)) && 0 > g && (g = 0)), "axisX" === this.type && b) {
                        if (null === this.minimum || isNaN(this.minimum)) this.minimum = f - h / 2;
                        if (null === this.maximum || isNaN(this.maximum)) this.maximum = g + h / 2
                    } else this.intervalType = "number", null === this.minimum && (this.minimum = "axisX" === this.type ? f - h / 2 : Math.floor(f / this.interval) * this.interval, this.minimum = Math.min(this.minimum, null === this.sessionVariables.viewportMinimum || isNaN(this.sessionVariables.viewportMinimum) ? Infinity : this.sessionVariables.viewportMinimum)),
                        null === this.maximum && (this.maximum = "axisX" === this.type ? g + h / 2 : Math.ceil(g / this.interval) * this.interval, this.maximum = Math.max(this.maximum, null === this.sessionVariables.viewportMaximum || isNaN(this.sessionVariables.viewportMaximum) ? -Infinity : this.sessionVariables.viewportMaximum)), 0 === this.maximum && 0 === this.minimum && (0 === this.options.minimum ? this.maximum += 10 : 0 === this.options.maximum && (this.minimum -= 10));
                this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum);
                this.viewportMaximum = Math.min(this.viewportMaximum,
                    this.maximum);
                this.range = this.viewportMaximum - this.viewportMinimum;
                this.intervalStartPosition = "axisX" === this.type && b ? this.getLabelStartPoint(new Date(this.viewportMinimum), this.intervalType, this.interval) : Math.floor((this.viewportMinimum + 0.2 * this.interval) / this.interval) * this.interval;
                if (!this.valueFormatString && (this.valueFormatString = "#,##0.##", 1 > this.range)) {
                    d = Math.floor(Math.abs(Math.log(this.range) / Math.LN10)) + 2;
                    if (isNaN(d) || !isFinite(d)) d = 2;
                    if (2 < d)
                        for (b = 0; b < d - 2; b++) this.valueFormatString += "#"
                }
            }
        };
    B.prototype.calculateLogarithamicAxisParameters = function() {
        var a = this.chart.layoutManager.getFreeSpace(),
            d = Math.log(this.logarithmBase),
            b;
        "bottom" === this._position || "top" === this._position ? (this.maxWidth = a.width, this.maxHeight = a.height) : (this.maxWidth = a.height, this.maxHeight = a.width);
        var a = "axisX" === this.type ? 500 > this.maxWidth ? 7 : Math.max(7, Math.floor(this.maxWidth / 100)) : Math.max(Math.floor(this.maxWidth / 50), 3),
            c, f, g, h;
        h = 1;
        if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum =
            this.minimum;
        if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = this.maximum;
        "axisX" === this.type ? (c = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, f = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, 1 === f / c && (h = Math.pow(this.logarithmBase, "undefined" === typeof this.options.interval ? 0.4 : this.options.interval), f *= h, c /= h), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : f / c > this.logarithmBase ? f / c * Math.pow(this.logarithmBase,
            0.5) : this.logarithmBase) : "axisY" === this.type && (c = null !== this.viewportMinimum ? this.viewportMinimum : this.dataInfo.viewPortMin, f = null !== this.viewportMaximum ? this.viewportMaximum : this.dataInfo.viewPortMax, 0 >= c && !isFinite(f) ? (f = "undefined" === typeof this.options.interval ? 0 : this.options.interval, c = 1) : 0 >= c ? c = f : isFinite(f) || (f = c), 1 === c && 1 === f ? (f *= this.logarithmBase - 1 / this.logarithmBase, c = 1) : 1 === f / c ? (h = Math.min(f * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 5)), f *= h, c /= h) : c > f ? (h = Math.min(c /
                f * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 5)), 1 <= f ? c = f / h : f = c * h) : (h = Math.min(f / c * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 0.04)), 1 !== f && (f *= h), 1 !== c && (c /= h)), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : f / c > this.logarithmBase ? f / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase, this.includeZero && (null === this.viewportMinimum || isNaN(this.viewportMinimum)) && 1 < c && (c = 1), this.includeZero && (null === this.viewportMaximum || isNaN(this.viewportMaximum)) &&
            1 > f && (f = 1));
        h = (isNaN(this.viewportMaximum) || null === this.viewportMaximum ? f : this.viewportMaximum) / (isNaN(this.viewportMinimum) || null === this.viewportMinimum ? c : this.viewportMinimum);
        linearRange = (isNaN(this.viewportMaximum) || null === this.viewportMaximum ? f : this.viewportMaximum) - (isNaN(this.viewportMinimum) || null === this.viewportMinimum ? c : this.viewportMinimum);
        this.intervalType = "number";
        h = Math.pow(this.logarithmBase, B.getNiceNumber(Math.abs(Math.log(h) / d), !1));
        this.options && 0 < this.options.interval ? this.interval =
            this.options.interval : (this.interval = B.getNiceExponent(Math.log(h) / d / (a - 1), !0), b = B.getNiceNumber(linearRange / (a - 1), !0));
        if (null === this.viewportMinimum || isNaN(this.viewportMinimum)) this.viewportMinimum = "axisX" === this.type ? c / Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.floor(Math.log(c) / d / this.interval));
        if (null === this.viewportMaximum || isNaN(this.viewportMaximum)) this.viewportMaximum = "axisX" === this.type ? f * Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.ceil(Math.log(f) / d /
            this.interval));
        1 === this.viewportMaximum && 1 === this.viewportMinimum && (1 === this.options.viewportMinimum ? this.viewportMaximum *= this.logarithmBase - 1 / this.logarithmBase : 1 === this.options.viewportMaximum && (this.viewportMinimum /= this.logarithmBase - 1 / this.logarithmBase), this.options && "undefined" === typeof this.options.interval && (this.interval = B.getNiceExponent(Math.ceil(Math.log(h) / d) / (a - 1)), b = B.getNiceNumber((this.viewportMaximum - this.viewportMinimum) / (a - 1), !0)));
        if (null === this.minimum || null === this.maximum) "axisX" ===
            this.type ? (c = null !== this.minimum ? this.minimum : this.dataInfo.min, f = null !== this.maximum ? this.maximum : this.dataInfo.max, 1 === f / c && (h = Math.pow(this.logarithmBase, "undefined" === typeof this.options.interval ? 0.4 : this.options.interval), f *= h, c /= h), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : f / c > this.logarithmBase ? f / c * Math.pow(this.logarithmBase, 0.5) : this.logarithmBase) : "axisY" === this.type && (c = null !== this.minimum ? this.minimum : this.dataInfo.min, f = null !== this.maximum ? this.maximum : this.dataInfo.max,
                isFinite(c) || isFinite(f) ? 1 === c && 1 === f ? (f *= this.logarithmBase, c /= this.logarithmBase) : 1 === f / c ? (h = Math.pow(this.logarithmBase, this.interval), f *= h, c /= h) : c > f ? (h = Math.min(0.01 * (c / f), 5), 1 <= f ? c = f / h : f = c * h) : (h = Math.min(f / c * Math.pow(this.logarithmBase, 0.01), Math.pow(this.logarithmBase, 0.04)), 1 !== f && (f *= h), 1 !== c && (c /= h)) : (f = "undefined" === typeof this.options.interval ? 0 : this.options.interval, c = 1), g = Infinity !== this.dataInfo.minDiff ? this.dataInfo.minDiff : f / c > this.logarithmBase ? f / c * Math.pow(this.logarithmBase, 0.5) :
                this.logarithmBase, this.includeZero && (null === this.minimum || isNaN(this.minimum)) && 1 < c && (c = 1), this.includeZero && (null === this.maximum || isNaN(this.maximum)) && 1 > f && (f = 1)), this.intervalType = "number", null === this.minimum && (this.minimum = "axisX" === this.type ? c / Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.floor(Math.log(c) / d / this.interval)), this.minimum = Math.min(this.minimum, null === this.sessionVariables.viewportMinimum || isNaN(this.sessionVariables.viewportMinimum) ? "undefined" === typeof this.sessionVariables.newViewportMinimum ?
                Infinity : this.sessionVariables.newViewportMinimum : this.sessionVariables.viewportMinimum)), null === this.maximum && (this.maximum = "axisX" === this.type ? f * Math.sqrt(g) : Math.pow(this.logarithmBase, this.interval * Math.ceil(Math.log(f) / d / this.interval)), this.maximum = Math.max(this.maximum, null === this.sessionVariables.viewportMaximum || isNaN(this.sessionVariables.viewportMaximum) ? "undefined" === typeof this.sessionVariables.newViewportMaximum ? 0 : this.sessionVariables.newViewportMaximum : this.sessionVariables.viewportMaximum)),
            1 === this.maximum && 1 === this.minimum && (1 === this.options.minimum ? this.maximum *= this.logarithmBase - 1 / this.logarithmBase : 1 === this.options.maximum && (this.minimum /= this.logarithmBase - 1 / this.logarithmBase));
        this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum);
        this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum);
        this.viewportMinimum > this.viewportMaximum && (!this.options.viewportMinimum && !this.options.minimum || this.options.viewportMaximum || this.options.maximum ? this.options.viewportMinimum ||
            this.options.minimum || !this.options.viewportMaximum && !this.options.maximum || (this.viewportMinimum = this.minimum = (this.options.viewportMaximum || this.options.maximum) / Math.pow(this.logarithmBase, 2 * Math.ceil(this.interval))) : this.viewportMaximum = this.maximum = this.options.viewportMinimum || this.options.minimum);
        c = Math.pow(this.logarithmBase, Math.floor(Math.log(this.viewportMinimum) / (d * this.interval) + 0.2) * this.interval);
        this.range = this.viewportMaximum / this.viewportMinimum;
        this.noTicks = a;
        if (!this.options.interval &&
            this.range < Math.pow(this.logarithmBase, 8 > this.viewportMaximum || 3 > a ? 2 : 3)) {
            for (d = Math.floor(this.viewportMinimum / b + 0.5) * b; d < this.viewportMinimum;) d += b;
            this.equidistantInterval = !1;
            this.intervalStartPosition = d;
            this.interval = b
        } else this.options.interval || (b = Math.ceil(this.interval), this.range > this.interval && (this.interval = b, c = Math.pow(this.logarithmBase, Math.floor(Math.log(this.viewportMinimum) / (d * this.interval) + 0.2) * this.interval))), this.equidistantInterval = !0, this.intervalStartPosition = c;
        if (!this.valueFormatString &&
            (this.valueFormatString = "#,##0.##", 1 > this.viewportMinimum)) {
            d = Math.floor(Math.abs(Math.log(this.viewportMinimum) / Math.LN10)) + 2;
            if (isNaN(d) || !isFinite(d)) d = 2;
            if (2 < d)
                for (b = 0; b < d - 2; b++) this.valueFormatString += "#"
        }
    };
    B.getNiceExponent = function(a, d) {
        var b = Math.floor(Math.log(a) / Math.LN10),
            c = a / Math.pow(10, b),
            c = 0 > b ? 1 >= c ? 1 : 5 >= c ? 5 : 10 : Math.max(Math.floor(c), 1);
        return Number((c * Math.pow(10, b)).toFixed(20))
    };
    B.getNiceNumber = function(a, d) {
        var b = Math.floor(Math.log(a) / Math.LN10),
            c = a / Math.pow(10, b);
        return Number(((d ?
            1.5 > c ? 1 : 3 > c ? 2 : 7 > c ? 5 : 10 : 1 >= c ? 1 : 2 >= c ? 2 : 5 >= c ? 5 : 10) * Math.pow(10, b)).toFixed(20))
    };
    B.prototype.getLabelStartPoint = function() {
        var a = E[this.intervalType + "Duration"] * this.interval,
            a = new Date(Math.floor(this.viewportMinimum / a) * a);
        if ("millisecond" !== this.intervalType)
            if ("second" === this.intervalType) 0 < a.getMilliseconds() && (a.setSeconds(a.getSeconds() + 1), a.setMilliseconds(0));
            else if ("minute" === this.intervalType) {
            if (0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setMinutes(a.getMinutes() + 1), a.setSeconds(0), a.setMilliseconds(0)
        } else if ("hour" ===
            this.intervalType) {
            if (0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setHours(a.getHours() + 1), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)
        } else if ("day" === this.intervalType) {
            if (0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setDate(a.getDate() + 1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)
        } else if ("week" === this.intervalType) {
            if (0 < a.getDay() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setDate(a.getDate() +
                (7 - a.getDay())), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)
        } else if ("month" === this.intervalType) {
            if (1 < a.getDate() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) a.setMonth(a.getMonth() + 1), a.setDate(1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)
        } else "year" === this.intervalType && (0 < a.getMonth() || 1 < a.getDate() || 0 < a.getHours() || 0 < a.getMinutes() || 0 < a.getSeconds() || 0 < a.getMilliseconds()) && (a.setFullYear(a.getFullYear() + 1), a.setMonth(0),
            a.setDate(1), a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0));
        return a
    };
    U(na, M);
    na.prototype.createUserOptions = function(a) {
        if ("undefined" !== typeof a || this.options._isPlaceholder) {
            var d = 0;
            this.parent.options._isPlaceholder && this.parent.createUserOptions();
            this.options._isPlaceholder || (qa(this.parent.stripLines), d = this.parent.options.stripLines.indexOf(this.options));
            this.options = "undefined" === typeof a ? {} : a;
            this.parent.options.stripLines[d] = this.options
        }
    };
    na.prototype.render = function() {
        this.ctx.save();
        var a = this.parent.getPixelCoordinatesOnAxis(this.value),
            d = Math.abs("pixel" === this._thicknessType ? this.thickness : this.parent.conversionParameters.pixelPerUnit * this.thickness);
        if (0 < d) {
            var b = null === this.opacity ? 1 : this.opacity;
            this.ctx.strokeStyle = this.color;
            this.ctx.beginPath();
            var c = this.ctx.globalAlpha;
            this.ctx.globalAlpha = b;
            G(this.id);
            var f, g, h, l;
            this.ctx.lineWidth = d;
            this.ctx.setLineDash && this.ctx.setLineDash(I(this.lineDashType, d));
            if ("bottom" === this.parent._position || "top" === this.parent._position) f =
                g = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0, h = this.chart.plotArea.y1, l = this.chart.plotArea.y2, this.bounds = {
                    x1: f - d / 2,
                    y1: h,
                    x2: g + d / 2,
                    y2: l
                };
            else if ("left" === this.parent._position || "right" === this.parent._position) h = l = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0, f = this.chart.plotArea.x1, g = this.chart.plotArea.x2, this.bounds = {
                x1: f,
                y1: h - d / 2,
                x2: g,
                y2: l + d / 2
            };
            this.ctx.moveTo(f, h);
            this.ctx.lineTo(g, l);
            this.ctx.stroke();
            this.ctx.globalAlpha = c
        }
        this.ctx.restore()
    };
    U(S, M);
    S.prototype._initialize = function() {
        if (this.enabled) {
            this.container =
                document.createElement("div");
            this.container.setAttribute("class", "canvasjs-chart-tooltip");
            this.container.style.position = "absolute";
            this.container.style.height = "auto";
            this.container.style.boxShadow = "1px 1px 2px 2px rgba(0,0,0,0.1)";
            this.container.style.zIndex = "1000";
            this.container.style.display = "none";
            var a;
            a = '<div style=" width: auto;height: auto;min-width: 50px;';
            a += "line-height: auto;";
            a += "margin: 0px 0px 0px 0px;";
            a += "padding: 5px;";
            a += "font-family: Calibri, Arial, Georgia, serif;";
            a += "font-weight: normal;";
            a += "font-style: " + (u ? "italic;" : "normal;");
            a += "font-size: 14px;";
            a += "color: #000000;";
            a += "text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";
            a += "text-align: left;";
            a += "border: 2px solid gray;";
            a += u ? "background: rgba(255,255,255,.9);" : "background: rgb(255,255,255);";
            a += "text-indent: 0px;";
            a += "white-space: nowrap;";
            a += "border-radius: 5px;";
            a += "-moz-user-select:none;";
            a += "-khtml-user-select: none;";
            a += "-webkit-user-select: none;";
            a += "-ms-user-select: none;";
            a += "user-select: none;";
            u || (a += "filter: alpha(opacity = 90);",
                a += "filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');");
            a += '} "> Sample Tooltip</div>';
            this.container.innerHTML = a;
            this.contentDiv = this.container.firstChild;
            this.container.style.borderRadius = this.contentDiv.style.borderRadius;
            this.chart._canvasJSContainer.appendChild(this.container)
        }
    };
    S.prototype.mouseMoveHandler = function(a, d) {
        this._lastUpdated && 40 > (new Date).getTime() - this._lastUpdated || (this._lastUpdated = (new Date).getTime(), this._updateToolTip(a, d))
    };
    S.prototype._updateToolTip = function(a, d, b) {
        b = "undefined" === typeof b ? !0 : b;
        this.container || this._initialize();
        this.enabled || this.hide();
        if (!this.chart.disableToolTip) {
            if ("undefined" === typeof a || "undefined" === typeof d) {
                if (isNaN(this._prevX) || isNaN(this._prevY)) return;
                a = this._prevX;
                d = this._prevY
            } else this._prevX = a, this._prevY = d;
            var c = null,
                f = null,
                g = [],
                h = 0;
            if (this.shared && this.enabled && "none" !== this.chart.plotInfo.axisPlacement) {
                if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
                    f = [];
                    if (this.chart.axisX)
                        for (var l =
                                0; l < this.chart.axisX.length; l++) {
                            for (var h = this.chart.axisX[l].convertPixelToValue({
                                    y: d
                                }), k = null, c = 0; c < this.chart.axisX[l].dataSeries.length; c++)(k = this.chart.axisX[l].dataSeries[c].getDataPointAtX(h, b)) && 0 <= k.index && (k.dataSeries = this.chart.axisX[l].dataSeries[c], null !== k.dataPoint.y && f.push(k));
                            k = null
                        }
                    if (this.chart.axisX2)
                        for (l = 0; l < this.chart.axisX2.length; l++) {
                            h = this.chart.axisX2[l].convertPixelToValue({
                                y: d
                            });
                            k = null;
                            for (c = 0; c < this.chart.axisX2[l].dataSeries.length; c++)(k = this.chart.axisX2[l].dataSeries[c].getDataPointAtX(h,
                                b)) && 0 <= k.index && (k.dataSeries = this.chart.axisX2[l].dataSeries[c], null !== k.dataPoint.y && f.push(k));
                            k = null
                        }
                } else {
                    f = [];
                    if (this.chart.axisX)
                        for (l = 0; l < this.chart.axisX.length; l++)
                            for (h = this.chart.axisX[l].convertPixelToValue({
                                    x: a
                                }), k = null, c = 0; c < this.chart.axisX[l].dataSeries.length; c++)(k = this.chart.axisX[l].dataSeries[c].getDataPointAtX(h, b)) && 0 <= k.index && (k.dataSeries = this.chart.axisX[l].dataSeries[c], null !== k.dataPoint.y && f.push(k));
                    if (this.chart.axisX2)
                        for (l = 0; l < this.chart.axisX2.length; l++)
                            for (h =
                                this.chart.axisX2[l].convertPixelToValue({
                                    x: a
                                }), k = null, c = 0; c < this.chart.axisX2[l].dataSeries.length; c++)(k = this.chart.axisX2[l].dataSeries[c].getDataPointAtX(h, b)) && 0 <= k.index && (k.dataSeries = this.chart.axisX2[l].dataSeries[c], null !== k.dataPoint.y && f.push(k))
                }
                if (0 === f.length) return;
                f.sort(function(a, b) {
                    return a.distance - b.distance
                });
                b = f[0];
                for (c = 0; c < f.length; c++) f[c].dataPoint.x.valueOf() === b.dataPoint.x.valueOf() && g.push(f[c]);
                f = null
            } else {
                if (k = this.chart.getDataPointAtXY(a, d, b)) this.currentDataPointIndex =
                    k.dataPointIndex, this.currentSeriesIndex = k.dataSeries.index;
                else if (u)
                    if (k = La(a, d, this.chart._eventManager.ghostCtx), 0 < k && "undefined" !== typeof this.chart._eventManager.objectMap[k]) {
                        k = this.chart._eventManager.objectMap[k];
                        if ("legendItem" === k.objectType) return;
                        this.currentSeriesIndex = k.dataSeriesIndex;
                        this.currentDataPointIndex = 0 <= k.dataPointIndex ? k.dataPointIndex : -1
                    } else this.currentDataPointIndex = -1;
                else this.currentDataPointIndex = -1;
                if (0 <= this.currentSeriesIndex) {
                    f = this.chart.data[this.currentSeriesIndex];
                    k = {};
                    if (0 <= this.currentDataPointIndex) c = f.dataPoints[this.currentDataPointIndex], k.dataSeries = f, k.dataPoint = c, k.index = this.currentDataPointIndex, k.distance = Math.abs(c.x - h);
                    else {
                        if (!this.enabled || "line" !== f.type && "stepLine" !== f.type && "spline" !== f.type && "area" !== f.type && "stepArea" !== f.type && "splineArea" !== f.type && "stackedArea" !== f.type && "stackedArea100" !== f.type && "rangeArea" !== f.type && "rangeSplineArea" !== f.type && "candlestick" !== f.type && "ohlc" !== f.type) return;
                        h = f.axisX.convertPixelToValue({
                            x: a
                        });
                        k = f.getDataPointAtX(h,
                            b);
                        k.dataSeries = f;
                        this.currentDataPointIndex = k.index;
                        c = k.dataPoint
                    }
                    if (!x(k.dataPoint.y))
                        if (k.dataSeries.axisY)
                            if (0 < k.dataPoint.y.length) {
                                for (c = b = 0; c < k.dataPoint.y.length; c++) k.dataPoint.y[c] < k.dataSeries.axisY.viewportMinimum ? b-- : k.dataPoint.y[c] > k.dataSeries.axisY.viewportMaximum && b++;
                                b < k.dataPoint.y.length && b > -k.dataPoint.y.length && g.push(k)
                            } else "column" === f.type || "bar" === f.type ? 0 > k.dataPoint.y ? 0 > k.dataSeries.axisY.viewportMinimum && k.dataSeries.axisY.viewportMaximum >= k.dataPoint.y && g.push(k) : k.dataSeries.axisY.viewportMinimum <=
                                k.dataPoint.y && 0 <= k.dataSeries.axisY.viewportMaximum && g.push(k) : "bubble" === f.type ? (b = this.chart._eventManager.objectMap[f.dataPointIds[k.index]].size / 2, k.dataPoint.y >= k.dataSeries.axisY.viewportMinimum - b && k.dataPoint.y <= k.dataSeries.axisY.viewportMaximum + b && g.push(k)) : (0 <= k.dataSeries.type.indexOf("100") || "stackedColumn" === f.type || "stackedBar" === f.type || k.dataPoint.y >= k.dataSeries.axisY.viewportMinimum && k.dataPoint.y <= k.dataSeries.axisY.viewportMaximum) && g.push(k);
                    else g.push(k)
                }
            }
            if (0 < g.length && (this.highlightObjects(g),
                    this.enabled))
                if (b = "", b = this.getToolTipInnerHTML({
                        entries: g
                    }), null !== b) {
                    this.contentDiv.innerHTML = b;
                    this.contentDiv.innerHTML = b;
                    b = !1;
                    "none" === this.container.style.display && (b = !0, this.container.style.display = "block");
                    try {
                        this.contentDiv.style.background = this.backgroundColor ? this.backgroundColor : u ? "rgba(255,255,255,.9)" : "rgb(255,255,255)", this.borderColor = this.contentDiv.style.borderRightColor = this.contentDiv.style.borderLeftColor = this.contentDiv.style.borderColor = this.options.borderColor ? this.options.borderColor :
                            g[0].dataPoint.color ? g[0].dataPoint.color : g[0].dataSeries.color ? g[0].dataSeries.color : g[0].dataSeries._colorSet[g[0].index % g[0].dataSeries._colorSet.length], this.contentDiv.style.borderWidth = this.borderThickness || 0 === this.borderThickness ? this.borderThickness + "px" : "2px", this.contentDiv.style.borderRadius = this.cornerRadius || 0 === this.cornerRadius ? this.cornerRadius + "px" : "5px", this.container.style.borderRadius = this.contentDiv.style.borderRadius, this.contentDiv.style.fontSize = this.fontSize || 0 === this.fontSize ?
                            this.fontSize + "px" : "14px", this.contentDiv.style.color = this.fontColor ? this.fontColor : "#000000", this.contentDiv.style.fontFamily = this.fontFamily ? this.fontFamily : "Calibri, Arial, Georgia, serif;", this.contentDiv.style.fontWeight = this.fontWeight ? this.fontWeight : "normal", this.contentDiv.style.fontStyle = this.fontStyle ? this.fontStyle : u ? "italic" : "normal"
                    } catch (m) {}
                    "pie" === g[0].dataSeries.type || "doughnut" === g[0].dataSeries.type || "funnel" === g[0].dataSeries.type || "bar" === g[0].dataSeries.type || "rangeBar" === g[0].dataSeries.type ||
                        "stackedBar" === g[0].dataSeries.type || "stackedBar100" === g[0].dataSeries.type ? a = a - 10 - this.container.clientWidth : (a = g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x) - this.container.clientWidth << 0, a -= 10);
                    0 > a && (a += this.container.clientWidth + 20);
                    a + this.container.clientWidth > Math.max(this.chart.container.clientWidth, this.chart.width) && (a = Math.max(0, Math.max(this.chart.container.clientWidth, this.chart.width) - this.container.clientWidth));
                    a += "px";
                    d = 1 !== g.length || this.shared || "line" !== g[0].dataSeries.type &&
                        "stepLine" !== g[0].dataSeries.type && "spline" !== g[0].dataSeries.type && "area" !== g[0].dataSeries.type && "stepArea" !== g[0].dataSeries.type && "splineArea" !== g[0].dataSeries.type ? "bar" === g[0].dataSeries.type || "rangeBar" === g[0].dataSeries.type || "stackedBar" === g[0].dataSeries.type || "stackedBar100" === g[0].dataSeries.type ? g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x) : d : g[0].dataSeries.axisY.convertValueToPixel(g[0].dataPoint.y);
                    d = -d + 10;
                    0 < d + this.container.clientHeight + 5 && (d -= d + this.container.clientHeight +
                        5 - 0);
                    this.container.style.left = a;
                    this.container.style.bottom = d + "px";
                    !this.animationEnabled || b ? this.disableAnimation() : this.enableAnimation()
                } else this.hide(!1)
        }
    };
    S.prototype.highlightObjects = function(a) {
        var d = this.chart.overlaidCanvasCtx;
        this.chart.resetOverlayedCanvas();
        d.clearRect(0, 0, this.chart.width, this.chart.height);
        d.save();
        var b = this.chart.plotArea,
            c = 0;
        d.beginPath();
        d.rect(b.x1, b.y1, b.x2 - b.x1, b.y2 - b.y1);
        d.clip();
        for (b = 0; b < a.length; b++) {
            var f = a[b];
            if ((f = this.chart._eventManager.objectMap[f.dataSeries.dataPointIds[f.index]]) &&
                f.objectType && "dataPoint" === f.objectType) {
                var c = this.chart.data[f.dataSeriesIndex],
                    g = c.dataPoints[f.dataPointIndex],
                    h = f.dataPointIndex;
                !1 === g.highlightEnabled || !0 !== c.highlightEnabled && !0 !== g.highlightEnabled || ("line" === c.type || "stepLine" === c.type || "spline" === c.type || "scatter" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "stackedArea" === c.type || "stackedArea100" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type ? (g = c.getMarkerProperties(h, f.x1, f.y1, this.chart.overlaidCanvasCtx),
                    g.size = Math.max(1.5 * g.size << 0, 10), g.borderColor = g.borderColor || "#FFFFFF", g.borderThickness = g.borderThickness || Math.ceil(0.1 * g.size), P.drawMarkers([g]), "undefined" !== typeof f.y2 && (g = c.getMarkerProperties(h, f.x1, f.y2, this.chart.overlaidCanvasCtx), g.size = Math.max(1.5 * g.size << 0, 10), g.borderColor = g.borderColor || "#FFFFFF", g.borderThickness = g.borderThickness || Math.ceil(0.1 * g.size), P.drawMarkers([g]))) : "bubble" === c.type ? (g = c.getMarkerProperties(h, f.x1, f.y1, this.chart.overlaidCanvasCtx), g.size = f.size, g.color =
                    "white", g.borderColor = "white", d.globalAlpha = 0.3, P.drawMarkers([g]), d.globalAlpha = 1) : "column" === c.type || "stackedColumn" === c.type || "stackedColumn100" === c.type || "bar" === c.type || "rangeBar" === c.type || "stackedBar" === c.type || "stackedBar100" === c.type || "rangeColumn" === c.type ? N(d, f.x1, f.y1, f.x2, f.y2, "white", 0, null, !1, !1, !1, !1, 0.3) : "pie" === c.type || "doughnut" === c.type ? Ga(d, f.center, f.radius, "white", c.type, f.startAngle, f.endAngle, 0.3, f.percentInnerRadius) : "candlestick" === c.type ? (d.globalAlpha = 1, d.strokeStyle =
                    f.color, d.lineWidth = 2 * f.borderThickness, c = 0 === d.lineWidth % 2 ? 0 : 0.5, d.beginPath(), d.moveTo(f.x3 - c, Math.min(f.y2, f.y3)), d.lineTo(f.x3 - c, Math.min(f.y1, f.y4)), d.stroke(), d.beginPath(), d.moveTo(f.x3 - c, Math.max(f.y1, f.y4)), d.lineTo(f.x3 - c, Math.max(f.y2, f.y3)), d.stroke(), N(d, f.x1, Math.min(f.y1, f.y4), f.x2, Math.max(f.y1, f.y4), "transparent", 2 * f.borderThickness, f.color, !1, !1, !1, !1), d.globalAlpha = 1) : "ohlc" === c.type && (d.globalAlpha = 1, d.strokeStyle = f.color, d.lineWidth = 2 * f.borderThickness, c = 0 === d.lineWidth % 2 ? 0 : 0.5,
                    d.beginPath(), d.moveTo(f.x3 - c, f.y2), d.lineTo(f.x3 - c, f.y3), d.stroke(), d.beginPath(), d.moveTo(f.x3, f.y1), d.lineTo(f.x1, f.y1), d.stroke(), d.beginPath(), d.moveTo(f.x3, f.y4), d.lineTo(f.x2, f.y4), d.stroke(), d.globalAlpha = 1))
            }
        }
        d.restore();
        d.globalAlpha = 1;
        d.beginPath()
    };
    S.prototype.getToolTipInnerHTML = function(a) {
        var d = a.entries,
            b = null,
            c = null,
            f = null,
            g = 0;
        a = "";
        for (var h = !0, l = 0; l < d.length; l++)
            if (d[l].dataSeries.toolTipContent || d[l].dataPoint.toolTipContent) {
                h = !1;
                break
            }
        if (h && (this.content && "function" === typeof this.content ||
                this.contentFormatter)) d = {
            chart: this.chart,
            toolTip: this.options,
            entries: d
        }, b = this.contentFormatter ? this.contentFormatter(d) : this.content(d);
        else if (this.shared && "none" !== this.chart.plotInfo.axisPlacement) {
            for (var k = null, m = "", l = 0; l < d.length; l++)
                if (c = d[l].dataSeries, f = d[l].dataPoint, g = d[l].index, a = "", 0 === l && (h && !this.content) && (this.chart.axisX && 0 < this.chart.axisX.length ? m += "undefined" !== typeof this.chart.axisX[0].labels[f.x] ? this.chart.axisX[0].labels[f.x] : "{x}" : this.chart.axisX2 && 0 < this.chart.axisX2.length &&
                        (m += "undefined" !== typeof this.chart.axisX2[0].labels[f.x] ? this.chart.axisX2[0].labels[f.x] : "{x}"), m += "</br>", m = this.chart.replaceKeywordsWithValue(m, f, c, g)), null !== f.toolTipContent && ("undefined" !== typeof f.toolTipContent || null !== c.options.toolTipContent)) {
                    if ("line" === c.type || "stepLine" === c.type || "spline" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "column" === c.type || "bar" === c.type || "scatter" === c.type || "stackedColumn" === c.type || "stackedColumn100" === c.type || "stackedBar" ===
                        c.type || "stackedBar100" === c.type || "stackedArea" === c.type || "stackedArea100" === c.type) this.chart.axisX && 1 < this.chart.axisX.length && (a += k != c.axisXIndex ? c.axisX.title ? c.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), a += f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y}", k = c.axisXIndex;
                    else if ("bubble" === c.type) this.chart.axisX &&
                        1 < this.chart.axisX.length && (a += k != c.axisXIndex ? c.axisX.title ? c.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), a += f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}";
                    else if ("rangeColumn" === c.type || "rangeBar" === c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type) this.chart.axisX && 1 < this.chart.axisX.length &&
                        (a += k != c.axisXIndex ? c.axisX.title ? c.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" : ""), a += f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}";
                    else if ("candlestick" === c.type || "ohlc" === c.type) this.chart.axisX && 1 < this.chart.axisX.length && (a += k != c.axisXIndex ? c.axisX.title ? c.axisX.title + "<br/>" : "X:{axisXIndex}<br/>" :
                        ""), a += f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}";
                    null === b && (b = "");
                    !0 === this.reversed ? (b = this.chart.replaceKeywordsWithValue(a, f, c, g) + b, l < d.length - 1 && (b = "</br>" + b)) : (b += this.chart.replaceKeywordsWithValue(a,
                        f, c, g), l < d.length - 1 && (b += "</br>"));
                    c.toolTipContent = a
                }
            null !== b && (b = m + b)
        } else {
            c = d[0].dataSeries;
            f = d[0].dataPoint;
            g = d[0].index;
            if (null === f.toolTipContent || "undefined" === typeof f.toolTipContent && null === c.options.toolTipContent) return null;
            if ("line" === c.type || "stepLine" === c.type || "spline" === c.type || "area" === c.type || "stepArea" === c.type || "splineArea" === c.type || "column" === c.type || "bar" === c.type || "scatter" === c.type || "stackedColumn" === c.type || "stackedColumn100" === c.type || "stackedBar" === c.type || "stackedBar100" ===
                c.type || "stackedArea" === c.type || "stackedArea100" === c.type) a = f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (f.label ? "{label}" : "{x}") + ":</span>&nbsp;&nbsp;{y}";
            else if ("bubble" === c.type) a = f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ?
                "" : "'color:{color};'") + "\"'>" + (f.label ? "{label}" : "{x}") + ":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}";
            else if ("pie" === c.type || "doughnut" === c.type || "funnel" === c.type) a = f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (f.name ? "{name}:</span>&nbsp;&nbsp;" : f.label ? "{label}:</span>&nbsp;&nbsp;" : "</span>") + "{y}";
            else if ("rangeColumn" === c.type || "rangeBar" ===
                c.type || "rangeArea" === c.type || "rangeSplineArea" === c.type) a = f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content : "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (f.label ? "{label}" : "{x}") + " :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}";
            else if ("candlestick" === c.type || "ohlc" === c.type) a = f.toolTipContent ? f.toolTipContent : c.toolTipContent ? c.toolTipContent : this.content && "function" !== typeof this.content ? this.content :
                "<span style='\"" + (this.options.fontColor ? "" : "'color:{color};'") + "\"'>" + (f.label ? "{label}" : "{x}") + "</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}";
            null === b && (b = "");
            b += this.chart.replaceKeywordsWithValue(a, f, c, g)
        }
        this.content = a;
        return b
    };
    S.prototype.enableAnimation = function() {
        this.container.style.WebkitTransition || (this.container.style.WebkitTransition = "left .2s ease-out, bottom .2s ease-out", this.container.style.MozTransition =
            "left .2s ease-out, bottom .2s ease-out", this.container.style.MsTransition = "left .2s ease-out, bottom .2s ease-out", this.container.style.transition = "left .2s ease-out, bottom .2s ease-out")
    };
    S.prototype.disableAnimation = function() {
        this.container.style.WebkitTransition && (this.container.style.WebkitTransition = "", this.container.style.MozTransition = "", this.container.style.MsTransition = "", this.container.style.transition = "")
    };
    S.prototype.hide = function(a) {
        this.container && (this.container.style.display = "none",
            this.currentSeriesIndex = -1, this._prevY = this._prevX = NaN, ("undefined" === typeof a || a) && this.chart.resetOverlayedCanvas())
    };
    S.prototype.show = function(a, d, b) {
        this._updateToolTip(a, d, "undefined" === typeof b ? !1 : b)
    };
    A.prototype.getPercentAndTotal = function(a, d) {
        var b = null,
            c = null,
            f = null;
        if (0 <= a.type.indexOf("stacked")) c = 0, b = d.x.getTime ? d.x.getTime() : d.x, b in a.plotUnit.yTotals && (c = a.plotUnit.yTotals[b], f = isNaN(d.y) ? 0 : 0 === c ? 0 : 100 * (d.y / c));
        else if ("pie" === a.type || "doughnut" === a.type) {
            for (i = c = 0; i < a.dataPoints.length; i++) isNaN(a.dataPoints[i].y) ||
                (c += a.dataPoints[i].y);
            f = isNaN(d.y) ? 0 : 100 * (d.y / c)
        }
        return {
            percent: f,
            total: c
        }
    };
    A.prototype.replaceKeywordsWithValue = function(a, d, b, c, f) {
        var g = this;
        f = "undefined" === typeof f ? 0 : f;
        if ((0 <= b.type.indexOf("stacked") || "pie" === b.type || "doughnut" === b.type) && (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"))) {
            var h = "#percent",
                l = "#total",
                k = this.getPercentAndTotal(b, d),
                l = isNaN(k.total) ? l : k.total,
                h = isNaN(k.percent) ? h : k.percent;
            do {
                k = "";
                if (b.percentFormatString) k = b.percentFormatString;
                else {
                    var k = "#,##0.",
                        m = Math.max(Math.ceil(Math.log(1 /
                            Math.abs(h)) / Math.LN10), 2);
                    if (isNaN(m) || !isFinite(m)) m = 2;
                    for (var n = 0; n < m; n++) k += "#";
                    b.percentFormatString = k
                }
                a = a.replace("#percent", da(h, k, g._cultureInfo));
                a = a.replace("#total", da(l, b.yValueFormatString ? b.yValueFormatString : "#,##0.########", g._cultureInfo))
            } while (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"))
        }
        return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g, function(a) {
            if ('"' === a[0] && '"' === a[a.length - 1] || "'" === a[0] && "'" === a[a.length - 1]) return a.slice(1, a.length - 1);
            a = ka(a.slice(1, a.length - 1));
            a = a.replace("#index",
                f);
            var e = null;
            try {
                var h = a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);
                h && 0 < h.length && (e = ka(h[2]), a = ka(h[1]))
            } catch (k) {}
            h = null;
            if ("color" === a) return d.color ? d.color : b.color ? b.color : b._colorSet[c % b._colorSet.length];
            if (d.hasOwnProperty(a)) h = d;
            else if (b.hasOwnProperty(a)) h = b;
            else return "";
            h = h[a];
            null !== e && (h = h[e]);
            if ("x" === a)
                if ("dateTime" === g.plotInfo.axisXValueType || "dateTime" === b.xValueType || d.x && d.x.getTime) {
                    if (g.plotInfo.plotTypes[0].plotUnits[0].axisX && !g.plotInfo.plotTypes[0].plotUnits[0].axisX.logarithmic) return Ea(h,
                        d.xValueFormatString ? d.xValueFormatString : b.xValueFormatString ? b.xValueFormatString : b.xValueFormatString = g.axisX && g.axisX.autoValueFormatString ? g.axisX.autoValueFormatString : "DD MMM YY", g._cultureInfo)
                } else return da(h, d.xValueFormatString ? d.xValueFormatString : b.xValueFormatString ? b.xValueFormatString : b.xValueFormatString = "#,##0.########", g._cultureInfo);
            else return "y" === a ? da(h, d.yValueFormatString ? d.yValueFormatString : b.yValueFormatString ? b.yValueFormatString : b.yValueFormatString = "#,##0.########",
                g._cultureInfo) : "z" === a ? da(h, d.zValueFormatString ? d.zValueFormatString : b.zValueFormatString ? b.zValueFormatString : b.zValueFormatString = "#,##0.########", g._cultureInfo) : h
        })
    };
    la.prototype.reset = function() {
        this.lastObjectId = 0;
        this.objectMap = [];
        this.rectangularRegionEventSubscriptions = [];
        this.previousDataPointEventObject = null;
        this.eventObjects = [];
        u && (this.ghostCtx.clearRect(0, 0, this.chart.width, this.chart.height), this.ghostCtx.beginPath())
    };
    la.prototype.getNewObjectTrackingId = function() {
        return ++this.lastObjectId
    };
    la.prototype.mouseEventHandler = function(a) {
        if ("mousemove" === a.type || "click" === a.type) {
            var d = [],
                b = xa(a),
                c = null;
            if ((c = this.chart.getObjectAtXY(b.x, b.y, !1)) && "undefined" !== typeof this.objectMap[c])
                if (c = this.objectMap[c], "dataPoint" === c.objectType) {
                    var f = this.chart.data[c.dataSeriesIndex],
                        g = f.dataPoints[c.dataPointIndex],
                        h = c.dataPointIndex;
                    c.eventParameter = {
                        x: b.x,
                        y: b.y,
                        dataPoint: g,
                        dataSeries: f.options,
                        dataPointIndex: h,
                        dataSeriesIndex: f.index,
                        chart: this.chart
                    };
                    c.eventContext = {
                        context: g,
                        userContext: g,
                        mouseover: "mouseover",
                        mousemove: "mousemove",
                        mouseout: "mouseout",
                        click: "click"
                    };
                    d.push(c);
                    c = this.objectMap[f.id];
                    c.eventParameter = {
                        x: b.x,
                        y: b.y,
                        dataPoint: g,
                        dataSeries: f.options,
                        dataPointIndex: h,
                        dataSeriesIndex: f.index,
                        chart: this.chart
                    };
                    c.eventContext = {
                        context: f,
                        userContext: f.options,
                        mouseover: "mouseover",
                        mousemove: "mousemove",
                        mouseout: "mouseout",
                        click: "click"
                    };
                    d.push(this.objectMap[f.id])
                } else "legendItem" === c.objectType && (f = this.chart.data[c.dataSeriesIndex], g = null !== c.dataPointIndex ? f.dataPoints[c.dataPointIndex] : null,
                    c.eventParameter = {
                        x: b.x,
                        y: b.y,
                        dataSeries: f.options,
                        dataPoint: g,
                        dataPointIndex: c.dataPointIndex,
                        dataSeriesIndex: c.dataSeriesIndex,
                        chart: this.chart
                    }, c.eventContext = {
                        context: this.chart.legend,
                        userContext: this.chart.legend.options,
                        mouseover: "itemmouseover",
                        mousemove: "itemmousemove",
                        mouseout: "itemmouseout",
                        click: "itemclick"
                    }, d.push(c));
            f = [];
            for (b = 0; b < this.mouseoveredObjectMaps.length; b++) {
                g = !0;
                for (c = 0; c < d.length; c++)
                    if (d[c].id === this.mouseoveredObjectMaps[b].id) {
                        g = !1;
                        break
                    }
                g ? this.fireEvent(this.mouseoveredObjectMaps[b],
                    "mouseout", a) : f.push(this.mouseoveredObjectMaps[b])
            }
            this.mouseoveredObjectMaps = f;
            for (b = 0; b < d.length; b++) {
                f = !1;
                for (c = 0; c < this.mouseoveredObjectMaps.length; c++)
                    if (d[b].id === this.mouseoveredObjectMaps[c].id) {
                        f = !0;
                        break
                    }
                f || (this.fireEvent(d[b], "mouseover", a), this.mouseoveredObjectMaps.push(d[b]));
                "click" === a.type ? this.fireEvent(d[b], "click", a) : "mousemove" === a.type && this.fireEvent(d[b], "mousemove", a)
            }
        }
    };
    la.prototype.fireEvent = function(a, d, b) {
        if (a && d) {
            var c = a.eventParameter,
                f = a.eventContext,
                g = a.eventContext.userContext;
            g && (f && g[f[d]]) && g[f[d]].call(g, c);
            "mouseout" !== d ? g.cursor && g.cursor !== b.target.style.cursor && (b.target.style.cursor = g.cursor) : (b.target.style.cursor = this.chart._defaultCursor, delete a.eventParameter, delete a.eventContext);
            "click" === d && ("dataPoint" === a.objectType && this.chart.pieDoughnutClickHandler) && this.chart.pieDoughnutClickHandler.call(this.chart.data[a.dataSeriesIndex], c)
        }
    };
    U(oa, M);
    Da.prototype.animate = function(a, d, b, c, f) {
        var g = this;
        this.chart.isAnimating = !0;
        f = f || F.easing.linear;
        b && this.animations.push({
            startTime: (new Date).getTime() +
                (a ? a : 0),
            duration: d,
            animationCallback: b,
            onComplete: c
        });
        for (a = []; 0 < this.animations.length;)
            if (d = this.animations.shift(), b = (new Date).getTime(), c = 0, d.startTime <= b && (c = f(Math.min(b - d.startTime, d.duration), 0, 1, d.duration), c = Math.min(c, 1), isNaN(c) || !isFinite(c)) && (c = 1), 1 > c && a.push(d), d.animationCallback(c), 1 <= c && d.onComplete) d.onComplete();
        this.animations = a;
        0 < this.animations.length ? this.animationRequestId = this.chart.requestAnimFrame.call(window, function() {
            g.animate.call(g)
        }) : this.chart.isAnimating = !1
    };
    Da.prototype.cancelAllAnimations = function() {
        this.animations = [];
        this.animationRequestId && this.chart.cancelRequestAnimFrame.call(window, this.animationRequestId);
        this.animationRequestId = null;
        this.chart.isAnimating = !1
    };
    var F = {
            yScaleAnimation: function(a, d) {
                if (0 !== a) {
                    var b = d.dest,
                        c = d.source.canvas,
                        f = d.animationBase;
                    b.drawImage(c, 0, 0, c.width, c.height, 0, f - f * a, b.canvas.width / Q, a * b.canvas.height / Q)
                }
            },
            xScaleAnimation: function(a, d) {
                if (0 !== a) {
                    var b = d.dest,
                        c = d.source.canvas,
                        f = d.animationBase;
                    b.drawImage(c, 0, 0,
                        c.width, c.height, f - f * a, 0, a * b.canvas.width / Q, b.canvas.height / Q)
                }
            },
            xClipAnimation: function(a, d) {
                if (0 !== a) {
                    var b = d.dest,
                        c = d.source.canvas;
                    b.save();
                    0 < a && b.drawImage(c, 0, 0, c.width * a, c.height, 0, 0, c.width * a / Q, c.height / Q);
                    b.restore()
                }
            },
            fadeInAnimation: function(a, d) {
                if (0 !== a) {
                    var b = d.dest,
                        c = d.source.canvas;
                    b.save();
                    b.globalAlpha = a;
                    b.drawImage(c, 0, 0, c.width, c.height, 0, 0, b.canvas.width / Q, b.canvas.height / Q);
                    b.restore()
                }
            },
            easing: {
                linear: function(a, d, b, c) {
                    return b * a / c + d
                },
                easeOutQuad: function(a, d, b, c) {
                    return -b *
                        (a /= c) * (a - 2) + d
                },
                easeOutQuart: function(a, d, b, c) {
                    return -b * ((a = a / c - 1) * a * a * a - 1) + d
                },
                easeInQuad: function(a, d, b, c) {
                    return b * (a /= c) * a + d
                },
                easeInQuart: function(a, d, b, c) {
                    return b * (a /= c) * a * a * a + d
                }
            }
        },
        P = {
            drawMarker: function(a, d, b, c, f, g, h, l) {
                if (b) {
                    var k = 1;
                    b.fillStyle = g ? g : "#000000";
                    b.strokeStyle = h ? h : "#000000";
                    b.lineWidth = l ? l : 0;
                    "circle" === c ? (b.moveTo(a, d), b.beginPath(), b.arc(a, d, f / 2, 0, 2 * Math.PI, !1), g && b.fill(), l && (h ? b.stroke() : (k = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = k))) :
                        "square" === c ? (b.beginPath(), b.rect(a - f / 2, d - f / 2, f, f), g && b.fill(), l && (h ? b.stroke() : (k = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = k))) : "triangle" === c ? (b.beginPath(), b.moveTo(a - f / 2, d + f / 2), b.lineTo(a + f / 2, d + f / 2), b.lineTo(a, d - f / 2), b.closePath(), g && b.fill(), l && (h ? b.stroke() : (k = b.globalAlpha, b.globalAlpha = 0.15, b.strokeStyle = "black", b.stroke(), b.globalAlpha = k)), b.beginPath()) : "cross" === c && (b.strokeStyle = g, b.lineWidth = f / 4, b.beginPath(), b.moveTo(a - f / 2, d - f / 2), b.lineTo(a + f /
                            2, d + f / 2), b.stroke(), b.moveTo(a + f / 2, d - f / 2), b.lineTo(a - f / 2, d + f / 2), b.stroke())
                }
            },
            drawMarkers: function(a) {
                for (var d = 0; d < a.length; d++) {
                    var b = a[d];
                    P.drawMarker(b.x, b.y, b.ctx, b.type, b.size, b.color, b.borderColor, b.borderThickness)
                }
            }
        },
        Oa = {
            Chart: A,
            addColorSet: function(a, d) {
                ha[a] = d
            },
            addCultureInfo: function(a, d) {
                pa[a] = d
            },
            formatNumber: function(a, d, b) {
                b = b || "en";
                if (pa[b]) return da(a, d || "#,##0.##", new oa(b));
                throw "Unknown Culture Name";
            },
            formatDate: function(a, d, b) {
                b = b || "en";
                if (pa[b]) return Ea(a, d || "DD MMM YYYY",
                    new oa(b));
                throw "Unknown Culture Name";
            }
        };
    Oa.Chart.version = "v1.9.8 GA";
    window.CanvasJS = Oa
})();
/*
  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.

  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
  Licensed under the Apache License, Version 2.0
*/
document.createElement("canvas").getContext || function() {
    function V() {
        return this.context_ || (this.context_ = new C(this))
    }

    function W(a, b, c) {
        var g = M.call(arguments, 2);
        return function() {
            return a.apply(b, g.concat(M.call(arguments)))
        }
    }

    function N(a) {
        return String(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;")
    }

    function O(a) {
        a.namespaces.g_vml_ || a.namespaces.add("g_vml_", "urn:schemas-microsoft-com:vml", "#default#VML");
        a.namespaces.g_o_ || a.namespaces.add("g_o_", "urn:schemas-microsoft-com:office:office", "#default#VML");
        a.styleSheets.ex_canvas_ || (a = a.createStyleSheet(), a.owningElement.id = "ex_canvas_", a.cssText = "canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}")
    }

    function X(a) {
        var b = a.srcElement;
        switch (a.propertyName) {
            case "width":
                b.getContext().clearRect();
                b.style.width = b.attributes.width.nodeValue + "px";
                b.firstChild.style.width = b.clientWidth + "px";
                break;
            case "height":
                b.getContext().clearRect(), b.style.height = b.attributes.height.nodeValue + "px", b.firstChild.style.height = b.clientHeight +
                    "px"
        }
    }

    function Y(a) {
        a = a.srcElement;
        a.firstChild && (a.firstChild.style.width = a.clientWidth + "px", a.firstChild.style.height = a.clientHeight + "px")
    }

    function D() {
        return [
            [1, 0, 0],
            [0, 1, 0],
            [0, 0, 1]
        ]
    }

    function t(a, b) {
        for (var c = D(), g = 0; 3 > g; g++)
            for (var e = 0; 3 > e; e++) {
                for (var f = 0, d = 0; 3 > d; d++) f += a[g][d] * b[d][e];
                c[g][e] = f
            }
        return c
    }

    function P(a, b) {
        b.fillStyle = a.fillStyle;
        b.lineCap = a.lineCap;
        b.lineJoin = a.lineJoin;
        b.lineWidth = a.lineWidth;
        b.miterLimit = a.miterLimit;
        b.shadowBlur = a.shadowBlur;
        b.shadowColor = a.shadowColor;
        b.shadowOffsetX =
            a.shadowOffsetX;
        b.shadowOffsetY = a.shadowOffsetY;
        b.strokeStyle = a.strokeStyle;
        b.globalAlpha = a.globalAlpha;
        b.font = a.font;
        b.textAlign = a.textAlign;
        b.textBaseline = a.textBaseline;
        b.arcScaleX_ = a.arcScaleX_;
        b.arcScaleY_ = a.arcScaleY_;
        b.lineScale_ = a.lineScale_
    }

    function Q(a) {
        var b = a.indexOf("(", 3),
            c = a.indexOf(")", b + 1),
            b = a.substring(b + 1, c).split(",");
        if (4 != b.length || "a" != a.charAt(3)) b[3] = 1;
        return b
    }

    function E(a, b, c) {
        return Math.min(c, Math.max(b, a))
    }

    function F(a, b, c) {
        0 > c && c++;
        1 < c && c--;
        return 1 > 6 * c ? a + 6 * (b - a) * c :
            1 > 2 * c ? b : 2 > 3 * c ? a + 6 * (b - a) * (2 / 3 - c) : a
    }

    function G(a) {
        if (a in H) return H[a];
        var b, c = 1;
        a = String(a);
        if ("#" == a.charAt(0)) b = a;
        else if (/^rgb/.test(a)) {
            c = Q(a);
            b = "#";
            for (var g, e = 0; 3 > e; e++) g = -1 != c[e].indexOf("%") ? Math.floor(255 * (parseFloat(c[e]) / 100)) : +c[e], b += v[E(g, 0, 255)];
            c = +c[3]
        } else if (/^hsl/.test(a)) {
            e = c = Q(a);
            b = parseFloat(e[0]) / 360 % 360;
            0 > b && b++;
            g = E(parseFloat(e[1]) / 100, 0, 1);
            e = E(parseFloat(e[2]) / 100, 0, 1);
            if (0 == g) g = e = b = e;
            else {
                var f = 0.5 > e ? e * (1 + g) : e + g - e * g,
                    d = 2 * e - f;
                g = F(d, f, b + 1 / 3);
                e = F(d, f, b);
                b = F(d, f, b - 1 / 3)
            }
            b = "#" +
                v[Math.floor(255 * g)] + v[Math.floor(255 * e)] + v[Math.floor(255 * b)];
            c = c[3]
        } else b = Z[a] || a;
        return H[a] = {
            color: b,
            alpha: c
        }
    }

    function C(a) {
        this.m_ = D();
        this.mStack_ = [];
        this.aStack_ = [];
        this.currentPath_ = [];
        this.fillStyle = this.strokeStyle = "#000";
        this.lineWidth = 1;
        this.lineJoin = "miter";
        this.lineCap = "butt";
        this.miterLimit = 1 * q;
        this.globalAlpha = 1;
        this.font = "10px sans-serif";
        this.textAlign = "left";
        this.textBaseline = "alphabetic";
        this.canvas = a;
        var b = "width:" + a.clientWidth + "px;height:" + a.clientHeight + "px;overflow:hidden;position:absolute",
            c = a.ownerDocument.createElement("div");
        c.style.cssText = b;
        a.appendChild(c);
        b = c.cloneNode(!1);
        b.style.backgroundColor = "red";
        b.style.filter = "alpha(opacity=0)";
        a.appendChild(b);
        this.element_ = c;
        this.lineScale_ = this.arcScaleY_ = this.arcScaleX_ = 1
    }

    function R(a, b, c, g) {
        a.currentPath_.push({
            type: "bezierCurveTo",
            cp1x: b.x,
            cp1y: b.y,
            cp2x: c.x,
            cp2y: c.y,
            x: g.x,
            y: g.y
        });
        a.currentX_ = g.x;
        a.currentY_ = g.y
    }

    function S(a, b) {
        var c = G(a.strokeStyle),
            g = c.color,
            c = c.alpha * a.globalAlpha,
            e = a.lineScale_ * a.lineWidth;
        1 > e && (c *= e);
        b.push("<g_vml_:stroke",
            ' opacity="', c, '"', ' joinstyle="', a.lineJoin, '"', ' miterlimit="', a.miterLimit, '"', ' endcap="', $[a.lineCap] || "square", '"', ' weight="', e, 'px"', ' color="', g, '" />')
    }

    function T(a, b, c, g) {
        var e = a.fillStyle,
            f = a.arcScaleX_,
            d = a.arcScaleY_,
            k = g.x - c.x,
            n = g.y - c.y;
        if (e instanceof w) {
            var h = 0,
                l = g = 0,
                u = 0,
                m = 1;
            if ("gradient" == e.type_) {
                h = e.x1_ / f;
                c = e.y1_ / d;
                var p = s(a, e.x0_ / f, e.y0_ / d),
                    h = s(a, h, c),
                    h = 180 * Math.atan2(h.x - p.x, h.y - p.y) / Math.PI;
                0 > h && (h += 360);
                1E-6 > h && (h = 0)
            } else p = s(a, e.x0_, e.y0_), g = (p.x - c.x) / k, l = (p.y - c.y) / n, k /= f * q,
                n /= d * q, m = x.max(k, n), u = 2 * e.r0_ / m, m = 2 * e.r1_ / m - u;
            f = e.colors_;
            f.sort(function(a, b) {
                return a.offset - b.offset
            });
            d = f.length;
            p = f[0].color;
            c = f[d - 1].color;
            k = f[0].alpha * a.globalAlpha;
            a = f[d - 1].alpha * a.globalAlpha;
            for (var n = [], r = 0; r < d; r++) {
                var t = f[r];
                n.push(t.offset * m + u + " " + t.color)
            }
            b.push('<g_vml_:fill type="', e.type_, '"', ' method="none" focus="100%"', ' color="', p, '"', ' color2="', c, '"', ' colors="', n.join(","), '"', ' opacity="', a, '"', ' g_o_:opacity2="', k, '"', ' angle="', h, '"', ' focusposition="', g, ",", l, '" />')
        } else e instanceof
        I ? k && n && b.push("<g_vml_:fill", ' position="', -c.x / k * f * f, ",", -c.y / n * d * d, '"', ' type="tile"', ' src="', e.src_, '" />') : (e = G(a.fillStyle), b.push('<g_vml_:fill color="', e.color, '" opacity="', e.alpha * a.globalAlpha, '" />'))
    }

    function s(a, b, c) {
        a = a.m_;
        return {
            x: q * (b * a[0][0] + c * a[1][0] + a[2][0]) - r,
            y: q * (b * a[0][1] + c * a[1][1] + a[2][1]) - r
        }
    }

    function z(a, b, c) {
        isFinite(b[0][0]) && (isFinite(b[0][1]) && isFinite(b[1][0]) && isFinite(b[1][1]) && isFinite(b[2][0]) && isFinite(b[2][1])) && (a.m_ = b, c && (a.lineScale_ = aa(ba(b[0][0] * b[1][1] - b[0][1] *
            b[1][0]))))
    }

    function w(a) {
        this.type_ = a;
        this.r1_ = this.y1_ = this.x1_ = this.r0_ = this.y0_ = this.x0_ = 0;
        this.colors_ = []
    }

    function I(a, b) {
        if (!a || 1 != a.nodeType || "IMG" != a.tagName) throw new A("TYPE_MISMATCH_ERR");
        if ("complete" != a.readyState) throw new A("INVALID_STATE_ERR");
        switch (b) {
            case "repeat":
            case null:
            case "":
                this.repetition_ = "repeat";
                break;
            case "repeat-x":
            case "repeat-y":
            case "no-repeat":
                this.repetition_ = b;
                break;
            default:
                throw new A("SYNTAX_ERR");
        }
        this.src_ = a.src;
        this.width_ = a.width;
        this.height_ = a.height
    }

    function A(a) {
        this.code = this[a];
        this.message = a + ": DOM Exception " + this.code
    }
    var x = Math,
        k = x.round,
        J = x.sin,
        K = x.cos,
        ba = x.abs,
        aa = x.sqrt,
        q = 10,
        r = q / 2;
    navigator.userAgent.match(/MSIE ([\d.]+)?/);
    var M = Array.prototype.slice;
    O(document);
    var U = {
        init: function(a) {
            a = a || document;
            a.createElement("canvas");
            a.attachEvent("onreadystatechange", W(this.init_, this, a))
        },
        init_: function(a) {
            a = a.getElementsByTagName("canvas");
            for (var b = 0; b < a.length; b++) this.initElement(a[b])
        },
        initElement: function(a) {
            if (!a.getContext) {
                a.getContext =
                    V;
                O(a.ownerDocument);
                a.innerHTML = "";
                a.attachEvent("onpropertychange", X);
                a.attachEvent("onresize", Y);
                var b = a.attributes;
                b.width && b.width.specified ? a.style.width = b.width.nodeValue + "px" : a.width = a.clientWidth;
                b.height && b.height.specified ? a.style.height = b.height.nodeValue + "px" : a.height = a.clientHeight
            }
            return a
        }
    };
    U.init();
    for (var v = [], d = 0; 16 > d; d++)
        for (var B = 0; 16 > B; B++) v[16 * d + B] = d.toString(16) + B.toString(16);
    var Z = {
            aliceblue: "#F0F8FF",
            antiquewhite: "#FAEBD7",
            aquamarine: "#7FFFD4",
            azure: "#F0FFFF",
            beige: "#F5F5DC",
            bisque: "#FFE4C4",
            black: "#000000",
            blanchedalmond: "#FFEBCD",
            blueviolet: "#8A2BE2",
            brown: "#A52A2A",
            burlywood: "#DEB887",
            cadetblue: "#5F9EA0",
            chartreuse: "#7FFF00",
            chocolate: "#D2691E",
            coral: "#FF7F50",
            cornflowerblue: "#6495ED",
            cornsilk: "#FFF8DC",
            crimson: "#DC143C",
            cyan: "#00FFFF",
            darkblue: "#00008B",
            darkcyan: "#008B8B",
            darkgoldenrod: "#B8860B",
            darkgray: "#A9A9A9",
            darkgreen: "#006400",
            darkgrey: "#A9A9A9",
            darkkhaki: "#BDB76B",
            darkmagenta: "#8B008B",
            darkolivegreen: "#556B2F",
            darkorange: "#FF8C00",
            darkorchid: "#9932CC",
            darkred: "#8B0000",
            darksalmon: "#E9967A",
            darkseagreen: "#8FBC8F",
            darkslateblue: "#483D8B",
            darkslategray: "#2F4F4F",
            darkslategrey: "#2F4F4F",
            darkturquoise: "#00CED1",
            darkviolet: "#9400D3",
            deeppink: "#FF1493",
            deepskyblue: "#00BFFF",
            dimgray: "#696969",
            dimgrey: "#696969",
            dodgerblue: "#1E90FF",
            firebrick: "#B22222",
            floralwhite: "#FFFAF0",
            forestgreen: "#228B22",
            gainsboro: "#DCDCDC",
            ghostwhite: "#F8F8FF",
            gold: "#FFD700",
            goldenrod: "#DAA520",
            grey: "#808080",
            greenyellow: "#ADFF2F",
            honeydew: "#F0FFF0",
            hotpink: "#FF69B4",
            indianred: "#CD5C5C",
            indigo: "#4B0082",
            ivory: "#FFFFF0",
            khaki: "#F0E68C",
            lavender: "#E6E6FA",
            lavenderblush: "#FFF0F5",
            lawngreen: "#7CFC00",
            lemonchiffon: "#FFFACD",
            lightblue: "#ADD8E6",
            lightcoral: "#F08080",
            lightcyan: "#E0FFFF",
            lightgoldenrodyellow: "#FAFAD2",
            lightgreen: "#90EE90",
            lightgrey: "#D3D3D3",
            lightpink: "#FFB6C1",
            lightsalmon: "#FFA07A",
            lightseagreen: "#20B2AA",
            lightskyblue: "#87CEFA",
            lightslategray: "#778899",
            lightslategrey: "#778899",
            lightsteelblue: "#B0C4DE",
            lightyellow: "#FFFFE0",
            limegreen: "#32CD32",
            linen: "#FAF0E6",
            magenta: "#FF00FF",
            mediumaquamarine: "#66CDAA",
            mediumblue: "#0000CD",
            mediumorchid: "#BA55D3",
            mediumpurple: "#9370DB",
            mediumseagreen: "#3CB371",
            mediumslateblue: "#7B68EE",
            mediumspringgreen: "#00FA9A",
            mediumturquoise: "#48D1CC",
            mediumvioletred: "#C71585",
            midnightblue: "#191970",
            mintcream: "#F5FFFA",
            mistyrose: "#FFE4E1",
            moccasin: "#FFE4B5",
            navajowhite: "#FFDEAD",
            oldlace: "#FDF5E6",
            olivedrab: "#6B8E23",
            orange: "#FFA500",
            orangered: "#FF4500",
            orchid: "#DA70D6",
            palegoldenrod: "#EEE8AA",
            palegreen: "#98FB98",
            paleturquoise: "#AFEEEE",
            palevioletred: "#DB7093",
            papayawhip: "#FFEFD5",
            peachpuff: "#FFDAB9",
            peru: "#CD853F",
            pink: "#FFC0CB",
            plum: "#DDA0DD",
            powderblue: "#B0E0E6",
            rosybrown: "#BC8F8F",
            royalblue: "#4169E1",
            saddlebrown: "#8B4513",
            salmon: "#FA8072",
            sandybrown: "#F4A460",
            seagreen: "#2E8B57",
            seashell: "#FFF5EE",
            sienna: "#A0522D",
            skyblue: "#87CEEB",
            slateblue: "#6A5ACD",
            slategray: "#708090",
            slategrey: "#708090",
            snow: "#FFFAFA",
            springgreen: "#00FF7F",
            steelblue: "#4682B4",
            tan: "#D2B48C",
            thistle: "#D8BFD8",
            tomato: "#FF6347",
            turquoise: "#40E0D0",
            violet: "#EE82EE",
            wheat: "#F5DEB3",
            whitesmoke: "#F5F5F5",
            yellowgreen: "#9ACD32"
        },
        H = {},
        L = {},
        $ = {
            butt: "flat",
            round: "round"
        },
        d = C.prototype;
    d.clearRect = function() {
        this.textMeasureEl_ && (this.textMeasureEl_.removeNode(!0), this.textMeasureEl_ = null);
        this.element_.innerHTML = ""
    };
    d.beginPath = function() {
        this.currentPath_ = []
    };
    d.moveTo = function(a, b) {
        var c = s(this, a, b);
        this.currentPath_.push({
            type: "moveTo",
            x: c.x,
            y: c.y
        });
        this.currentX_ = c.x;
        this.currentY_ = c.y
    };
    d.lineTo = function(a, b) {
        var c = s(this, a, b);
        this.currentPath_.push({
            type: "lineTo",
            x: c.x,
            y: c.y
        });
        this.currentX_ = c.x;
        this.currentY_ = c.y
    };
    d.bezierCurveTo =
        function(a, b, c, g, e, f) {
            e = s(this, e, f);
            a = s(this, a, b);
            c = s(this, c, g);
            R(this, a, c, e)
        };
    d.quadraticCurveTo = function(a, b, c, g) {
        a = s(this, a, b);
        c = s(this, c, g);
        g = {
            x: this.currentX_ + 2 / 3 * (a.x - this.currentX_),
            y: this.currentY_ + 2 / 3 * (a.y - this.currentY_)
        };
        R(this, g, {
            x: g.x + (c.x - this.currentX_) / 3,
            y: g.y + (c.y - this.currentY_) / 3
        }, c)
    };
    d.arc = function(a, b, c, g, e, f) {
        c *= q;
        var d = f ? "at" : "wa",
            k = a + K(g) * c - r,
            n = b + J(g) * c - r;
        g = a + K(e) * c - r;
        e = b + J(e) * c - r;
        k != g || f || (k += 0.125);
        a = s(this, a, b);
        k = s(this, k, n);
        g = s(this, g, e);
        this.currentPath_.push({
            type: d,
            x: a.x,
            y: a.y,
            radius: c,
            xStart: k.x,
            yStart: k.y,
            xEnd: g.x,
            yEnd: g.y
        })
    };
    d.rect = function(a, b, c, g) {
        this.moveTo(a, b);
        this.lineTo(a + c, b);
        this.lineTo(a + c, b + g);
        this.lineTo(a, b + g);
        this.closePath()
    };
    d.strokeRect = function(a, b, c, g) {
        var e = this.currentPath_;
        this.beginPath();
        this.moveTo(a, b);
        this.lineTo(a + c, b);
        this.lineTo(a + c, b + g);
        this.lineTo(a, b + g);
        this.closePath();
        this.stroke();
        this.currentPath_ = e
    };
    d.fillRect = function(a, b, c, g) {
        var e = this.currentPath_;
        this.beginPath();
        this.moveTo(a, b);
        this.lineTo(a + c, b);
        this.lineTo(a +
            c, b + g);
        this.lineTo(a, b + g);
        this.closePath();
        this.fill();
        this.currentPath_ = e
    };
    d.createLinearGradient = function(a, b, c, g) {
        var e = new w("gradient");
        e.x0_ = a;
        e.y0_ = b;
        e.x1_ = c;
        e.y1_ = g;
        return e
    };
    d.createRadialGradient = function(a, b, c, g, e, f) {
        var d = new w("gradientradial");
        d.x0_ = a;
        d.y0_ = b;
        d.r0_ = c;
        d.x1_ = g;
        d.y1_ = e;
        d.r1_ = f;
        return d
    };
    d.drawImage = function(a, b) {
        var c, g, e, d, r, y, n, h;
        e = a.runtimeStyle.width;
        d = a.runtimeStyle.height;
        a.runtimeStyle.width = "auto";
        a.runtimeStyle.height = "auto";
        var l = a.width,
            u = a.height;
        a.runtimeStyle.width =
            e;
        a.runtimeStyle.height = d;
        if (3 == arguments.length) c = arguments[1], g = arguments[2], r = y = 0, n = e = l, h = d = u;
        else if (5 == arguments.length) c = arguments[1], g = arguments[2], e = arguments[3], d = arguments[4], r = y = 0, n = l, h = u;
        else if (9 == arguments.length) r = arguments[1], y = arguments[2], n = arguments[3], h = arguments[4], c = arguments[5], g = arguments[6], e = arguments[7], d = arguments[8];
        else throw Error("Invalid number of arguments");
        var m = s(this, c, g),
            p = [];
        p.push(" <g_vml_:group", ' coordsize="', 10 * q, ",", 10 * q, '"', ' coordorigin="0,0"', ' style="width:',
            10, "px;height:", 10, "px;position:absolute;");
        if (1 != this.m_[0][0] || this.m_[0][1] || 1 != this.m_[1][1] || this.m_[1][0]) {
            var t = [];
            t.push("M11=", this.m_[0][0], ",", "M12=", this.m_[1][0], ",", "M21=", this.m_[0][1], ",", "M22=", this.m_[1][1], ",", "Dx=", k(m.x / q), ",", "Dy=", k(m.y / q), "");
            var v = s(this, c + e, g),
                w = s(this, c, g + d);
            c = s(this, c + e, g + d);
            m.x = x.max(m.x, v.x, w.x, c.x);
            m.y = x.max(m.y, v.y, w.y, c.y);
            p.push("padding:0 ", k(m.x / q), "px ", k(m.y / q), "px 0;filter:progid:DXImageTransform.Microsoft.Matrix(", t.join(""), ", sizingmethod='clip');")
        } else p.push("top:",
            k(m.y / q), "px;left:", k(m.x / q), "px;");
        p.push(' ">', '<g_vml_:image src="', a.src, '"', ' style="width:', q * e, "px;", " height:", q * d, 'px"', ' cropleft="', r / l, '"', ' croptop="', y / u, '"', ' cropright="', (l - r - n) / l, '"', ' cropbottom="', (u - y - h) / u, '"', " />", "</g_vml_:group>");
        this.element_.insertAdjacentHTML("BeforeEnd", p.join(""))
    };
    d.stroke = function(a) {
        var b = [];
        b.push("<g_vml_:shape", ' filled="', !!a, '"', ' style="position:absolute;width:', 10, "px;height:", 10, 'px;"', ' coordorigin="0,0"', ' coordsize="', 10 * q, ",", 10 * q, '"',
            ' stroked="', !a, '"', ' path="');
        for (var c = {
                x: null,
                y: null
            }, d = {
                x: null,
                y: null
            }, e = 0; e < this.currentPath_.length; e++) {
            var f = this.currentPath_[e];
            switch (f.type) {
                case "moveTo":
                    b.push(" m ", k(f.x), ",", k(f.y));
                    break;
                case "lineTo":
                    b.push(" l ", k(f.x), ",", k(f.y));
                    break;
                case "close":
                    b.push(" x ");
                    f = null;
                    break;
                case "bezierCurveTo":
                    b.push(" c ", k(f.cp1x), ",", k(f.cp1y), ",", k(f.cp2x), ",", k(f.cp2y), ",", k(f.x), ",", k(f.y));
                    break;
                case "at":
                case "wa":
                    b.push(" ", f.type, " ", k(f.x - this.arcScaleX_ * f.radius), ",", k(f.y - this.arcScaleY_ *
                        f.radius), " ", k(f.x + this.arcScaleX_ * f.radius), ",", k(f.y + this.arcScaleY_ * f.radius), " ", k(f.xStart), ",", k(f.yStart), " ", k(f.xEnd), ",", k(f.yEnd))
            }
            if (f) {
                if (null == c.x || f.x < c.x) c.x = f.x;
                if (null == d.x || f.x > d.x) d.x = f.x;
                if (null == c.y || f.y < c.y) c.y = f.y;
                if (null == d.y || f.y > d.y) d.y = f.y
            }
        }
        b.push(' ">');
        a ? T(this, b, c, d) : S(this, b);
        b.push("</g_vml_:shape>");
        this.element_.insertAdjacentHTML("beforeEnd", b.join(""))
    };
    d.fill = function() {
        this.stroke(!0)
    };
    d.closePath = function() {
        this.currentPath_.push({
            type: "close"
        })
    };
    d.save = function() {
        var a = {};
        P(this, a);
        this.aStack_.push(a);
        this.mStack_.push(this.m_);
        this.m_ = t(D(), this.m_)
    };
    d.restore = function() {
        this.aStack_.length && (P(this.aStack_.pop(), this), this.m_ = this.mStack_.pop())
    };
    d.translate = function(a, b) {
        z(this, t([
            [1, 0, 0],
            [0, 1, 0],
            [a, b, 1]
        ], this.m_), !1)
    };
    d.rotate = function(a) {
        var b = K(a);
        a = J(a);
        z(this, t([
            [b, a, 0],
            [-a, b, 0],
            [0, 0, 1]
        ], this.m_), !1)
    };
    d.scale = function(a, b) {
        this.arcScaleX_ *= a;
        this.arcScaleY_ *= b;
        z(this, t([
            [a, 0, 0],
            [0, b, 0],
            [0, 0, 1]
        ], this.m_), !0)
    };
    d.transform = function(a, b, c, d, e, f) {
        z(this, t([
            [a,
                b, 0
            ],
            [c, d, 0],
            [e, f, 1]
        ], this.m_), !0)
    };
    d.setTransform = function(a, b, c, d, e, f) {
        z(this, [
            [a, b, 0],
            [c, d, 0],
            [e, f, 1]
        ], !0)
    };
    d.drawText_ = function(a, b, c, d, e) {
        var f = this.m_;
        d = 0;
        var r = 1E3,
            t = 0,
            n = [],
            h;
        h = this.font;
        if (L[h]) h = L[h];
        else {
            var l = document.createElement("div").style;
            try {
                l.font = h
            } catch (u) {}
            h = L[h] = {
                style: l.fontStyle || "normal",
                variant: l.fontVariant || "normal",
                weight: l.fontWeight || "normal",
                size: l.fontSize || 10,
                family: l.fontFamily || "sans-serif"
            }
        }
        var l = h,
            m = this.element_;
        h = {};
        for (var p in l) h[p] = l[p];
        p = parseFloat(m.currentStyle.fontSize);
        m = parseFloat(l.size);
        "number" == typeof l.size ? h.size = l.size : -1 != l.size.indexOf("px") ? h.size = m : -1 != l.size.indexOf("em") ? h.size = p * m : -1 != l.size.indexOf("%") ? h.size = p / 100 * m : -1 != l.size.indexOf("pt") ? h.size = m / 0.75 : h.size = p;
        h.size *= 0.981;
        p = h.style + " " + h.variant + " " + h.weight + " " + h.size + "px " + h.family;
        m = this.element_.currentStyle;
        l = this.textAlign.toLowerCase();
        switch (l) {
            case "left":
            case "center":
            case "right":
                break;
            case "end":
                l = "ltr" == m.direction ? "right" : "left";
                break;
            case "start":
                l = "rtl" == m.direction ? "right" :
                    "left";
                break;
            default:
                l = "left"
        }
        switch (this.textBaseline) {
            case "hanging":
            case "top":
                t = h.size / 1.75;
                break;
            case "middle":
                break;
            default:
            case null:
            case "alphabetic":
            case "ideographic":
            case "bottom":
                t = -h.size / 2.25
        }
        switch (l) {
            case "right":
                d = 1E3;
                r = 0.05;
                break;
            case "center":
                d = r = 500
        }
        b = s(this, b + 0, c + t);
        n.push('<g_vml_:line from="', -d, ' 0" to="', r, ' 0.05" ', ' coordsize="100 100" coordorigin="0 0"', ' filled="', !e, '" stroked="', !!e, '" style="position:absolute;width:1px;height:1px;">');
        e ? S(this, n) : T(this, n, {
            x: -d,
            y: 0
        }, {
            x: r,
            y: h.size
        });
        e = f[0][0].toFixed(3) + "," + f[1][0].toFixed(3) + "," + f[0][1].toFixed(3) + "," + f[1][1].toFixed(3) + ",0,0";
        b = k(b.x / q) + "," + k(b.y / q);
        n.push('<g_vml_:skew on="t" matrix="', e, '" ', ' offset="', b, '" origin="', d, ' 0" />', '<g_vml_:path textpathok="true" />', '<g_vml_:textpath on="true" string="', N(a), '" style="v-text-align:', l, ";font:", N(p), '" /></g_vml_:line>');
        this.element_.insertAdjacentHTML("beforeEnd", n.join(""))
    };
    d.fillText = function(a, b, c, d) {
        this.drawText_(a, b, c, d, !1)
    };
    d.strokeText = function(a,
        b, c, d) {
        this.drawText_(a, b, c, d, !0)
    };
    d.measureText = function(a) {
        this.textMeasureEl_ || (this.element_.insertAdjacentHTML("beforeEnd", '<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'), this.textMeasureEl_ = this.element_.lastChild);
        var b = this.element_.ownerDocument;
        this.textMeasureEl_.innerHTML = "";
        this.textMeasureEl_.style.font = this.font;
        this.textMeasureEl_.appendChild(b.createTextNode(a));
        return {
            width: this.textMeasureEl_.offsetWidth
        }
    };
    d.clip = function() {};
    d.arcTo = function() {};
    d.createPattern = function(a, b) {
        return new I(a, b)
    };
    w.prototype.addColorStop = function(a, b) {
        b = G(b);
        this.colors_.push({
            offset: a,
            color: b.color,
            alpha: b.alpha
        })
    };
    d = A.prototype = Error();
    d.INDEX_SIZE_ERR = 1;
    d.DOMSTRING_SIZE_ERR = 2;
    d.HIERARCHY_REQUEST_ERR = 3;
    d.WRONG_DOCUMENT_ERR = 4;
    d.INVALID_CHARACTER_ERR = 5;
    d.NO_DATA_ALLOWED_ERR = 6;
    d.NO_MODIFICATION_ALLOWED_ERR = 7;
    d.NOT_FOUND_ERR = 8;
    d.NOT_SUPPORTED_ERR = 9;
    d.INUSE_ATTRIBUTE_ERR = 10;
    d.INVALID_STATE_ERR = 11;
    d.SYNTAX_ERR = 12;
    d.INVALID_MODIFICATION_ERR =
        13;
    d.NAMESPACE_ERR = 14;
    d.INVALID_ACCESS_ERR = 15;
    d.VALIDATION_ERR = 16;
    d.TYPE_MISMATCH_ERR = 17;
    G_vmlCanvasManager = U;
    CanvasRenderingContext2D = C;
    CanvasGradient = w;
    CanvasPattern = I;
    DOMException = A
}();
/*
 CanvasJS jQuery Charting Plugin - http://canvasjs.com/ 
 Copyright 2013 fenopix
*/
(function(b, c, d, e) {
    b.fn.CanvasJSChart = function(a) {
        if (a) {
            var b = this.first();
            a = new CanvasJS.Chart(this[0], a);
            b.children(".canvasjs-chart-container").data("canvasjsChartRef", a);
            a.render();
            return this
        }
        return this.first().children(".canvasjs-chart-container").data("canvasjsChartRef")
    }
})(jQuery, window, document);


/***/ }),
/* 243 */
/***/ (function(module, exports) {

/*
All of the code within the ZingChart software is developed and copyrighted by ZingChart, Inc., and may not be copied,
replicated, or used in any other software or application without prior permission from ZingChart. All usage must coincide with the
ZingChart End User License Agreement which can be requested by email at support@zingchart.com.

Build 2.8.8
*/
if(typeof(ZC)==="undefined"){eval(function(p,a,c,k,e,d){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--){d[e(c)]=k[c]||e(c)}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('if(2u.ZC={AT:1f(e,t){if(e.1K)1m e.1K(t);1k(1a i=0,n=e.1h;i<n;i++)if(e[i]===t)1m i;1m-1},fL:"2.8.8",lQ:"",14Z:!1,yD:["1c","qR","1y","8Y","bF","1M","81","bE","2Q","ej","5A","6M","6d","7v","6t","8t","5h","6z","3L","7k","9k","oF","96","9q","b1","iw","74","eZ","8q","80","rC","ao","ap","5O","zH","8f","5y","rc","8M","aV"],nc:{Lf:["Lh","Ln"],Lp:["Lq","KT"],Kk:["Kg","Hw"],Im:["Hf-b9","xq-b9"],xr:["5h-3L","xr"],2Q:["8V","5A"],74:["pn","74"],kr:["Hk"]},uL:{9k:"3L"},Hl:1f(e,t){1a i=[].7y.4s(7Z).6p(2);1m ZC.kh(e,t).8H(t,i)},kh:1f(e,t){1k(1a i=e.2l("."),n=i.xq(),a=0;a<i.1h;a++)t=t[i[a]];1m t[n]},4b:{1T:{},2b:0,2N:1f(e,t){ZC.4b.1T[e]=t,ZC.4b.2b++,ZC.4b.2b>oy&&(ZC.4b.1T={},ZC.4b.2b=0)}},Jl:0,TS:{},3q:4P.ij,gs:[],kN:"1T:4d/xN;ky,Ju///Jw==",mX:!1,eO:{},nU:[],ay:[],bW:0,Fp:"1T:4d/9Y;ky,Iu+Q/Jd+Jg+Sf/Sl/UJ/Sd//Sq+Ss/So+Rs/Ri/Rr/Rw/Uk+Tv/Tg+Th+Tm/Tr/Tu+Rg/Pm/Ot/Ov/Ox/Oy/Pb/Hx/Pc/Pf/On/Nu+Nv+Nz/Pl+Qr/Qk/Rb+Qi+Qh/Py+Qc/Jz+Ic/Zg/Nd+Lg+Lc/Lm/Kl+Ko+Ky/Kz/Mx+Na/Nj/Nf/Mt+Ms/Mo+Ir/K0/Iv/Rk+r+Rm+Rq+Nx/Pr/Gy/Qg==",bG:{"zc.nl":"1T:4d/xN;ky,Qd+Qb+Qa/PW/Pw/Pn/Pv+Pt/Po/Px+Qu/Rd++Rc/Ra+Qz/Qx/Qw+Qv+ck/Qq/Qp+Qo/Qn/Qm/Ql+Qj/Op+Pk/Om+Ol/Oj+Oi+Og/Od+Nt/Oa+NC+Nw+Oc/Oo+Pj++Pi+Pg/Ow/Tq/Tp++Tn/Tl+Tj/T4/Tc/Tb+o/Tk/OV/Ug+Up+Un/Um+Uj+Uh/Uf+Ty+Uc/Ua+TE+Tx+Sc+Sy/Ry/Rv/C/Rp"},Ro:!1,Rn:"",b2:1c,3a:1c,2B:1c,3I:1c,3l:!1,bN:!1,Gp:1f(){ZC.b2=ZC.3a=ZC.2B=ZC.3I=!1;1a e=!!2e.4N("3a").9j,t=!1;e&&(t="1f"==1w 2e.4N("3a").9j("2d").pI),ZC.3a=e&&t,ZC.2B=2e.Sa.Sb("7g://8B.w3.dQ/TR/Sv/Uq#Sp","1.1");1a i=2e.3o.2X(2e.4N("3A")),n=2e.4N("7q:2P");n.7V="t2",n.4l("id","Sn"),n.4l("xa",1n 93),i.2X(n),n.1H.Cg="3P(#2n#Cf)",ZC.3I=!n||"4g"==1w n.xa,i.6s.aN(i);1a a=!1;9d.sA&&9d.sA["fY/x-x9-b2"]?a=9d.sA["fY/x-x9-b2"].Sh:2e.4q&&-1===9d.Sg.1K("Rh")&&(a=1n c1(\'4I { 1a sD = 1n mx("x6.x6");if (sD) { sD = 1c; 1m hR; } } 4G (e) { 1m dk; }\')()),ZC.b2=a?1:0},8U:!(2e.x5&&"Jh"===2e.x5),6O:!!/x4 (\\d+\\.\\d+);/.5x(9d.cS)&&5V(5o.$1)<8,cF:!!/x4 (\\d+\\.\\d+);/.5x(9d.cS)&&5V(5o.$1)<9,2H:/Jc|Jb|uk Ja|IZ|IY CE|IG/.5x(9d.cS),y8:/Iz/.5x(9d.cS),y7:/Iy/.5x(9d.cS),h5:"qt"in 2u,pP:"IS"in 2u,RF:[],WF:[],DT:[0,0],Jj:1c,2A:1f(e,t,i,n,a,l){1c===ZC.1d(i)&&(i=!0),1c===ZC.1d(n)&&(n=!0),1c===ZC.1d(a)&&(a=!1);1a o=(l=l||[]).1h;1k(1a r in e)if(0===o||o>0&&-1===ZC.AT(l,r))if(e[r]3z 3K){if(n){(1c===ZC.1d(t[r])||"7c"!==r&&!a)&&(t[r]=[]);1k(1a C=0,A=e[r].1h;C<A;C++)t[r].1i(e[r][C])}}1t e[r]3z 93&&!(e[r]3z c1)?n&&(1c===ZC.1d(t[r])&&(t[r]={}),t[r]3z 93&&!(t[r]3z c1)&&ZC.2A(e[r],t[r],i)):(1c===ZC.1d(t[r])||i)&&(t[r]=e[r])},tf:1f(e,t){t||(t=[]);1k(1a i=0,n=e.1h;i<n;i++)t.1i(e[i])},Jv:1f(e,t){1a i={};ZC.2A(e,i),ZC.2A(t,e),ZC.2A(i,e)},6v:1f(e,t,i){if("fX"!==1o.pr){1w t===ZC.1b[31]&&(t=!0);1a n,a,l=(i=i||[]).1h;1k(1a o in e)if(e.8d(o)&&(0===l||l>0&&-1===ZC.AT(i,o))){1a r=o.2s(0,1);if("."!==r&&"#"!==r)if(e[o]3z 3K)if(ZC.U9(o)!==o){1k(e[ZC.U9(o)]=[],n=0,a=e[o].1h;n<a;n++)ZC.6v(e[o][n]),e[ZC.U9(o)].1i(e[o][n]);4o e[o]}1t 1k(n=0,a=e[o].1h;n<a;n++)ZC.6v(e[o][n]);1t e[o]3z 93&&!(e[o]3z c1)?(ZC.U9(o)!==o&&(e[ZC.U9(o)]={},ZC.2A(e[o],e[ZC.U9(o)]),4o e[o]),t&&ZC.6v(e[ZC.U9(o)],t,i)):ZC.U9(o)!==o&&(e[ZC.U9(o)]=e[o],4o e[o])}}},Z7:1f(e,t){1k(1a i in e)if(e.8d(i)){1a n;if((n=i.1E(t+"-",""))!==i)if(e[n]=e[i],e[i]3z 3K)1k(1a a=0,l=e[i].1h;a<l;a++)ZC.Z7(e[i][a],t);1t e[i]3z 93&&!(e[i]3z c1)&&ZC.Z7(e[i],t)}},q0:1f(e){1k(1a t="",i=0,n=e.1h;i<n;i++){1a a=i%2==0?i:e.1h-i;t+=e.2s(a,a+1)}1m t=t.1E(/\\./g,"d")},yy:1f(e){1a t=e;1m t=t.1E("*","&"),t=t.1E("9","3"),t=t.1E("l","1")},lI:1f(e){1m e.1E(/[a-zA-Z]/g,1f(e){1m 5X.eh((e<="Z"?90:122)>=(e=e.eM(0)+13)?e:e-26)})},yA:1f(e,t){1a i=ZC.WV(ZC.xn(e)),n=ZC.WV(ZC.jy(t)),a=i.1h;if(0===a)1m"";1k(1a l,o,r=i[a-1],C=i[0],A=wW,s=1A.4i(6+52/a)*A;0!==s;){o=s>>>2&3;1k(1a Z=a-1;Z>0;Z--)l=((r=i[Z-1])>>>5^C<<2)+(C>>>3^r<<4)^(s^C)+(n[3&Z^o]^r),C=i[Z]-=l;l=((r=i[a-1])>>>5^C<<2)+(C>>>3^r<<4)^(s^C)+(n[3&Z^o]^r),C=i[0]-=l,s-=A}1m Kd(ZC.yd(ZC.sf(i)))},Kb:1f(e,t){e=fi(e);1a i=ZC.WV(ZC.jy(e)),n=ZC.WV(ZC.jy(t)),a=i.1h;if(0===a)1m"";1===a&&(i[a++]=0);1k(1a l,o,r=i[a-1],C=i[0],A=1A.4i(6+52/a),s=0;A-->0;){o=(s+=wW)>>>2&3;1k(1a Z=0;Z<a-1;Z++)l=(r>>>5^(C=i[Z+1])<<2)+(C>>>3^r<<4)^(s^C)+(n[3&Z^o]^r),r=i[Z]+=l;l=(r>>>5^(C=i[0])<<2)+(C>>>3^r<<4)^(s^C)+(n[3&Z^o]^r),r=i[a-1]+=l}1m ZC.yc(ZC.sf(i))},WV:1f(e){1k(1a t=1n 3K(1A.4h(e.1h/4)),i=0;i<t.1h;i++)t[i]=e[4*i]+(e[4*i+1]<<8)+(e[4*i+2]<<16)+(e[4*i+3]<<24);1m t},sf:1f(e){1k(1a t=[],i=0;i<e.1h;i++)t.1i(3R&e[i],e[i]>>>8&3R,e[i]>>>16&3R,e[i]>>>24&3R);1m t},yc:1f(e){1k(1a t="",i=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],n=0;n<e.1h;n++)t+=i[e[n]>>4]+i[15&e[n]];1m t},xn:1f(e){1k(1a t=[],i="yR"===e.5v(0,2)?2:0;i<e.1h;i+=2)t.1i(5w(e.5v(i,2),16));1m t},yd:1f(e){1k(1a t="",i=0;i<e.1h;i++)0!==e[i]&&(t+=5X.eh(e[i]));1m t},jy:1f(e){1k(1a t=[],i=0;i<e.1h;i++)t.1i(e.eM(i));1m t},1l:1f(e){1m-1!==5X(e).1K("e-")?0:""===(e=5X(e).1E(/[^0-9\\.\\-]/gi,""))?0:1A.43(e)},1W:1f(e){1m e=5V(e),8a(e)?0:e},4t:1f(e,t){1m 1w t===ZC.1b[31]&&(t=2),5V(4P(e).4v(t))},2i:1f(e){1m 1A.3i(e)},2q:1f(e){1m"dk"!==e&&"0"!==e&&("hR"===e||"1"===e||!!e&&!0)},8C:1f(e){1a t=(e=5X(e).1E(/[^0-9\\.\\%\\-]/gi,"")).1K("%");1m-1!==t&&(e=e.2s(0,t),e=ZC.1W(e)/100),e},n7:1f(e){1m 2u.z7?2u.z7(e):e},1d:1f(e){1m 1c===e||1w e===ZC.1b[31]?1c:e},7O:1f(e,t){1m 1c===e||1w e===ZC.1b[31]?t:e},i0:1f(e){1m(e%=2j)<0&&(e+=2j),e},IB:1f(e,t){1m ZC.1W(e)+""==e+""?t?ZC.1W(e):ZC.2i(e):-1!==(e+="").1K("%")?ZC.1W(e.1E("%",""))/100:-1!==e.1K("px")?ZC.1W(e.1E("px","")):ZC.1W(e)},QG:1f(e){1m 5w(e,16)},ON:1f(e){1m ZC.1l(e).aq(16)},hc:1f(e,t){1m 5w(e+(t-e)*1A.cW(),10)},5m:1f(e,t,i){1m e=e<t?t:e,e=e>i?i:e},DU:1f(e,t,i,n){1m n?t<e&&e<i||i<e&&e<t:t<=e&&e<=i||i<=e&&e<=t},BN:1f(e,t){1m 1A.1V(e,t)},CV:1f(e,t){1m 1A.2h(e,t)},dT:1f(e){1k(1a t=0,i=e.1h,n=-4P.ij;t<i;t++)n=1A.1V(n,e[t]);1m n},dS:1f(e){1k(1a t=0,i=e.1h,n=4P.ij;t<i;t++)n=1A.2h(n,e[t]);1m n},z1:1f(){1k(1a e=(Jt*1A.cW()+1<<0).aq(16);e.1h<6;)e="0"+e;1m"#"+e},pK:1f(e,t){1k(1a i,n=ZC.1W(t),a=4P.ij,l=0,o=0,r=e.1h;o<r;o++)(i=1A.3i(ZC.1W(e[o])-n))<a&&(l=o,a=i);1m l},Js:1f(e){1a t=e.2l(".");1m t[t.1h-1]||""},GO:1f(e){1m e.1E(/^\\s\\s*/,"").1E(/\\s\\s*$/,"")},HH:1f(e,t){1m t=t||1A.E,eV(1A.2W(e)/1A.2W(t))?1A.2W(e)/1A.2W(t):0},TF:1f(e){1m 2j*e/(2*1A.PI)},ST:1f(e){1m 2*e*1A.PI/2j},ED:1f(e){1m 1A.db(ZC.ST(e))},EL:1f(e){1m 1A.dL(ZC.ST(e))},P2:1f(e){1m!8a(5V(e))&&eV(e)},EB:1f(e){1m-1!==e.1K("-")?e.1E(/(\\-[a-z0-9])/g,1f(e){1m e.5D().1E("-","")}):e},U9:1f(e){1m e.5D()!==e&&-1===e.1K("-")&&e.2s(0,1).aJ()===e.2s(0,1)?e.1E(/([A-Z])/g,1f(e){1m"-"+e.aJ()}).1E(/([0-9]+)/g,1f(e){1m"-"+e.aJ()}).1E("-3d","3d"):e},Jq:1f(e){1m ZC.XN.eE(e)},AK:1f(e){1m 2e.cA(e)},m2:1f(e,t){1m e[0].1h<t[0].1h?1:e[0].1h>t[0].1h?-1:0},YZ:1f(e){2u.5G(e,1o.r0)},bn:1f(e,t){1m t>=0&&t<=20?e.4v(t):""+e},mS:1f(e,t,i,n){1a a=t.S[i].BX,l=t.S[n].BX;if(e==a)1m i;if(e==l)1m n;1a o=ZC.1l((i+n)/2);if(!t.S[o]){1k(;!t.S[o]&&o<n;)o++;if(o===n){1k(o=ZC.1l((i+n)/2);!t.S[o]&&o>i;)o--;if(o===i)1m 1c}}1a r=t.S[o].BX;1m o!==i&&o!==n?e==r?o:e>r?ZC.mS(e,t,o,n):ZC.mS(e,t,i,o):e==r?o:1c},ak:1f(e){1a t,i,n,a,l=[1,1,0,0];if(1o.3G.va&&!ZC.3I&&ZC.AK(e)){1a o=ZC.AK(e);1k(t="";o&&(""===t||"1Z"===t);)t=ZC.A4(o).2K("5H")||"",o=o.6s;-1!==(i=t.1K("9y("))&&(n=t.1K(")",i),a=t.2s(i+7,n-i).2l(","),l=[ZC.1W(a[0]),ZC.1W(a[3]),ZC.1W(a[4]),ZC.1W(a[5])])}1m l}},ZC.tk=!1,ZC.a3=5L,ZC.aa=60*ZC.a3,ZC.HR=60*ZC.aa,ZC.9C=24*ZC.HR,ZC.ec=30*ZC.9C,ZC.YR=uf*ZC.9C,ZC.3y=0,2u.3c=2u.3c||{},3c.5d=3c.5d||1f(e){1a t=1w e;if("4g"!==t||1c===e)1m"2Y"===t&&(e=\'"\'+e.1E("\\\\","\\\\\\\\").1E(\'"\',\'"\')+\'"\'),5X(e);1a i,n,a=[],l=e&&e.zg===3K;1k(i in e)"1f"!=1w e[i]&&("2Y"===(t=1w(n=e[i]))?n=\'"\'+n.1E("\\\\","\\\\\\\\").1E(\'"\',\'\\\\"\')+\'"\':"4g"===t&&1c!==n&&(n=3c.5d(n)),a.1i((l?"":\'"\'+i+\'":\')+5X(n)));1m(l?"[":"{")+5X(a)+(l?"]":"}")},3c.1q=3c.1q||1f(KQ){1m""===KQ&&(KQ=\'""\'),7t("("+KQ+")")},ZC.1b=["1R-1r","2c-46","2c-6n","4u","1y-1s","6g","-2o-1M zc-2o-1M","6c","7y","1S","cb","ek","6h","mr-8P","6h-8P","-6F-c","aZ","1S-3B","77","1s","1L","2b","-2J-c","4S-2g","zc-3i zc-6r","a8-6h","3d-7e","x-2c","y-2c","z-2c",\'" 9n="\',"mk","~9D(3R,3R,3R,0)","~9I(3R,3R,3R)","-2o-1M ","-cu-1B-","7g://8B.w3.dQ/xj/2B","7g://8B.w3.dQ/q9/j5","Jp","Jo","Jn","Jm","Hr","Hp","Ha","If-GU-Hs","d5, 1 d3 du 6P:6P:6P di","6I","7R","6f","1z-x","1z-y","1z-v","Id","9L-7Y","4S-8N","4S-2w","2v-1u","2v-2x","2v-2a","2v-1J","1F-1r","1F-1s","Ip 4L","iy dU 6C","6C.5f.6j-2y","-2y-1N-ic","5H-5z-5K","5H-5z","bg-4d-1s","bg-4d-1L","2J-3U","1R-3U","ex-3U"],1f(){1a e=!1,t=/zh/.5x(1f(){zh})?/\\bb\\b/:/.*/;ZC.C9=1f(){},ZC.C9.C7=1f(i){1f n(){!e&&1g.$i&&1g.$i.8H(1g,7Z)}1a a=1g.5a;e=!0;1a l=1n 1g;e=!1;1k(1a o in i)l[o]="1f"==1w l[o]&&"1f"==1w a[o]&&t.5x(i[o])?1f(e,t){1m 1f(){1a i=1g.b;1g.b=a[e];1a n=t.8H(1g,7Z);1m 1g.b=i,n}}(o,i[o]):i[o];1m n.5a=l,n.zg=n,n.C7=7Z.Il,n}}(),ZC.wv=1f(e){1g.H=e,1g.ny=1f(e,t){1a i,n=1g,a=n.B9.6V;if(1c!==ZC.1d(t)&&1c!==ZC.1d(a[t])&&(a=a[t]),1c!==ZC.1d(a[e])){1a l=a[e];1m 1c===ZC.1d(l[2])&&(l[2]=ZC.AO.QJ(l[1],10)),1c===ZC.1d(l[3])&&(l[3]=ZC.AO.QJ(l[1],10)),l}1a o=["#Ik","#Ii","#Ig","#Ib","#HD","#Ly","#Mr"];i=1c!==ZC.1d(o[e-n.B9.6V.1h])?o[e-n.B9.6V.1h]:"#"+ZC.XN.eE(e).5v(e%20,6);1a r=ZC.AO.QJ(i,10),C=ZC.AO.QJ(i,20),A="#tn";1m n.B9.6V&&n.B9.6V[0]&&n.B9.6V[0][0]&&(A=n.B9.6V[0][0]),[A,i,r,C]},1g.kW=1f(e){e&&ZC.2A(e,1g.B9,!0)},1g.qY=1f(e){1a t=1g;1c!==ZC.1d(t.NR[e])&&(ZC.6v(t.NR[e]),ZC.2A(t.NR[e],t.B9))},1g.NR={},ZC.2A(1o.v8,1g.NR),1g.NR.cP={6V:[["#2O","#Mq","#Mn","#Ml"],["#2O","#Mk","#Mh","#Lz"],["#2O","#Mg","#Mc","#Mb"],["#2O","#LM","#LF","#Mi"],["#2O","#Np","#Nn","#Nm"],["#2O","#Nl","#Ni","#Mv"]],2U:{cO:{e5:{2k:.5,"1R-1r":"#4J",1r:"#4e","2p-2b":15,6u:1,1D:"tu..."}},"1R-1r":"#sN #Nc",5F:{"2p-2b":14,6u:1,1r:"#2O","1R-1r":"#Mz #My",3u:6},7X:{"2p-2b":11,6u:1,1r:"#8I","2v-1u":30,3u:6},7d:{"2p-2b":10,1r:"#8I",1s:"100%",6u:1,"1D-3s":"2x",1L:20,2v:"3e 0 0 3e",3u:5},iO:{"2p-2b":12,1r:"#8I","1D-3s":"3E","9r-3s":"6o",1D:""},4z:{"2p-2b":11,"1y-1s":2,"1y-1r":"#fQ",1N:{7M:!0},"3N-1y":{"1y-1s":1,"1y-1r":"#fQ"},2g:{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#zQ",2k:.2},"4Q-2g":{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#z6",2k:.1},3W:{2f:1,2b:6,6c:ZC.1b[18],"1y-1s":2,"1y-1r":"#fQ"},"4Q-3W":{2f:1,2b:4,6c:ZC.1b[18],"1y-1s":1,"1y-1r":"#fQ"},1G:{1r:"#zQ",7M:!0}},"1X-x":{2Q:{1L:16},3n:{1L:16}},"1X-y":{2Q:{1s:16},3n:{1s:16}},1U:{"1R-1r":"#2O","1F-1s":1,2k:.75,"1F-2k":.75,"1F-1r":"#cT","3H-6T":3,5S:{3u:"4 6",1r:"#2O","1F-1s":1,"1F-1r":"#fQ","1R-1r":"#fQ"},9P:{3u:"2 6","1R-1r":"#7S","1F-1s":1,"1F-1r":"#cT"},1O:{"1F-1r":"#8I","1F-1s":1}},1B:{"1S-3B":{7M:!0},1O:{3H:1,"1y-1s":1,"1F-1s":1},"2J-1O":{"1y-1s":1,"1F-1s":1}},2g:{"1y-1s":1,"1y-1r":"#4J",2k:1,"1z-1G":{1D:"%l",3u:"3 6"},"1B-1G":{3u:"3 6"}}},1y:{1B:{"3H-2k":.5,1O:{2b:4},"2J-1O":{2b:5}}},1M:{1B:{"3H-2k":.5,1O:{2b:4},"2J-1O":{2b:5}}},5A:{1B:{"3f-2c":90,3H:0}},6d:{1B:{"3f-2c":180,3H:0}},5O:{2r:{"4K-a1":[0,0]},1B:{3H:0}},8f:{1B:{3H:0}},8q:{1B:{3H:0}},80:{1B:{"3f-2c":0,3H:0}},6t:{1B:{1O:{2b:4},"2J-1O":{2b:5}}},8t:{1B:{1O:{2b:4},"2J-1O":{2b:5}}},5h:{1B:{1O:{"1F-1s":0},"2J-1O":{"1F-1s":0}}},6z:{1B:{1O:{"1F-1s":0},"2J-1O":{"1F-1s":0}}},3L:{1B:{"1F-1s":1}},96:{1B:{"1F-1s":1}},74:{1B:{1O:{2b:3},"2J-1O":{2b:4}},"1z-k":{2g:{2k:.5,"1R-1r":"#8S #78"}}},8M:{"1z-r":{"1R-1r":"-1",2g:{2k:.5,"1R-1r":"#8S #78"},1N:{"1Y-r":0},9k:{2b:1,2z:[{"1R-1r":"#4J",2k:.8},{"1R-1r":"#cT",2k:.8}]}}},ao:{2r:{2v:"50 100"},4z:{"1y-1s":0,3W:{"1y-1s":0},"4Q-3W":{"1y-1s":0},2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}},"1z-y":{2g:{2k:.25,"1R-1r":"-1 #9a"}},"1z-y-n":{2g:{2k:.25,"1R-1r":"-1 #9a"}},1B:{"1F-1s":1}},ap:{2r:{2v:"50 100"},"1z-x":{1G:{"2p-2c":3T}},"1z-x-n":{1G:{"2p-2c":90}},4z:{"1y-1s":0,3W:{"1y-1s":0},"4Q-3W":{"1y-1s":0},2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}},"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"},2g:{2k:.25,"1R-1r":"#9a -1"}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"},2g:{2k:.25,"1R-1r":"#9a -1"}},1B:{"1F-1s":1}},5y:{1B:{1O:{1I:"3x",2b:4},"2J-1O":{2b:5}}},8Y:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":0,"1y-1s":1}},81:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":0,"1y-1s":1}},b1:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},6M:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},7v:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},7k:{1B:{"1F-1s":1}},"-":""},1g.NR.9b={6V:[["#2O","#zP","#zP","#z5"],["#2O","#zO","#zO","#Lw"],["#2O","#t7","#t7","#KR"],["#2O","#zM","#zM","#Kv"],["#2O","#zz","#zz","#Kt"],["#2O","#zJ","#zJ","#Kq"],["#2O","#zG","#zG","#Km"],["#2O","#zE","#zE","#Kj"],["#2O","#zC","#zC","#t7"]],2U:{cO:{e5:{2k:.5,"1R-1r":"#4J",1r:"#4e","2p-2b":15,6u:1,1D:"tu..."}},"1R-1r":"#kz",5F:{"2p-2b":21,6u:1,1r:"#dY","1R-1r":"1Z",3u:6},7X:{"2p-2b":11,6u:1,1r:"#dY","2v-1u":30,3u:6},7d:{"2p-2b":10,1r:"#dY",1s:"100%",6u:1,"1D-3s":"2x",1L:20,2v:"3e 0 0 3e",3u:5},iO:{"2p-2b":12,1r:"#8I","1D-3s":"3E","9r-3s":"6o",1D:"No dU","1R-1r":"#Lv",2k:.8},4z:{"2p-2b":11,"1y-1s":1,"1y-1r":"#dJ",1N:{"2p-2b":12,7M:!0,1r:"#Lt"},"3N-1y":{"1y-1s":1,"1y-1r":"#7N"},2g:{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#Lr",2k:1},"4Q-2g":{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#z6",2k:.1},3W:{2f:1,2b:5,6c:ZC.1b[18],"1y-1s":1,"1y-1r":"#dJ"},"4Q-3W":{2f:1,2b:3,6c:ZC.1b[18],"1y-1s":1,"1y-1r":"#c9"},1G:{1r:"#dY",7M:!0}},"1z-x":{gy:!0,2g:{2f:!1}},1X:{2Q:{"1R-1r":"#ta",2v:1},3n:{"1R-1r":"#c9","1F-9B":6}},"1X-x":{2Q:{1L:16,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"},3n:{1L:10,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"}},"1X-y":{2Q:{1s:16,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"},3n:{1s:10,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"}},"1X-xi":{2Q:{1s:16,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"},3n:{1s:10,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"}},"1X-yi":{2Q:{1L:16,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"},3n:{1L:10,"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"}},2w:{"1R-1r":"#2O","1F-1s":1,"1F-1r":"#c9",4c:!0,4K:{"1R-1r":"#4J"},6D:{2k:0},3n:{1s:11,"1F-1s":2,"1F-9B":3,"1y-1r":"#t3","1F-1r":"#c9","1R-1r":"#ta"},"3n-1u":{1L:11},"3n-2a":{1L:11}},2C:{3H:1,"3H-2c":45,"3H-6T":1,"3H-2k":.25,"1F-1s":1,"1F-1r":"#2O","1F-2k":1},3C:{"dp-3C":1,"1R-1r":"#lZ"},1U:{"1R-1r":"#2O","1F-1s":1,3H:0,"3H-2k":.2,2k:1,"1F-2k":1,"1F-1r":"#e0",5S:{3u:"5 0 5 10",1r:"#Lo","1R-1r":"1Z","1F-1s":0,"1F-1u":"gW 2R 1Z","1F-2a":"88 2R #e0"},9P:{3u:"5 0 5 10","1F-1u":"88 2R #e0"},ti:{"1R-1r":"#ta","1y-1r":"#t3",2v:2,1L:8,"1y-1s":2,"1y-1H":"g1"},aF:{"1y-1r":"#t3","1y-1s":2,1H:"Lj"},1O:{"1F-1r":"#2O","1F-1s":1},"3b-on":{"1R-1r":"#lZ"},"3b-6N":{"1R-1r":"#tm"},1X:{2Q:{"1R-1r":"1Z","2v-1u":3,"2v-2a":3},3n:{"1R-1r":"#tm","1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z","1F-9B":6,1s:12,1L:12}}},1B:{"1S-3B":{7M:!0},1O:{3H:0,"1y-1s":1,"1F-1s":1,"1F-1r":"#2O"},"2J-1O":{"1y-1s":1,"1F-1s":1},Eu:!0},2g:{"1y-1s":1,"1y-1r":"#dJ",2k:1,"1z-1G":{1D:"%l",3u:"3 6"},"1B-1G":{3u:"3 6"}}},1y:{1B:{"1y-1s":2,3H:0,1O:{2b:4},"2J-3U":{},"2J-1O":{2b:5,"1F-1s":1,"1F-1r":"#2O"}}},1M:{1B:{"1y-1s":2,3H:0,"2k-1M":.25,"1R-1r-1H":"2R",1O:{2b:4},"2J-3U":{},"2J-1O":{2b:5,"1F-1s":1,"1F-1r":"#2O"}}},5A:{1B:{"3f-2c":90,3H:0}},6d:{1B:{"3f-2c":180,3H:0}},5O:{2r:{"4K-a1":[0,0]},1B:{3H:0},"1z-x":{2g:{2f:!0}}},8f:{1B:{3H:0}},8q:{1B:{3H:0,7w:{"1F-1s":1,"1F-1r":"#2O",1L:8}}},80:{1B:{"3f-2c":0,3H:0,7w:{"1F-1s":1,"1F-1r":"#2O",1s:8}}},6t:{1B:{"1y-1r":"%n0-0","1F-1r":"%n0-0",1O:{2b:5},"2J-1O":{2b:6}},"1z-x":{2g:{2f:!0}}},8t:{1B:{"1y-1r":"%n0-0","1F-1r":"%n0-0",1O:{2b:4},"2J-1O":{2b:5}},"1z-x":{2g:{2f:!0}}},5h:{1B:{1O:{"1F-1s":1,"1F-1r":"#2O"},"2J-1O":{"1F-1s":1,"1F-1r":"#2O"}},"1z-x":{2g:{2f:!0}}},6z:{1B:{1O:{"1F-1s":1,"1F-1r":"#2O"},"2J-1O":{"1F-1s":1,"1F-1r":"#2O"}},"1z-x":{2g:{2f:!0}}},3L:{1B:{3H:0,"1F-1s":1,"1S-3B":{6c:"in","2p-2b":16,1D:"%2o-8k-1S%"}}},96:{1B:{"1F-1s":1}},74:{1B:{3H:0,"1y-1s":2,"1R-1r":"%6V-1","6D-1M":!0,1O:{2b:4},"2J-1O":{2b:5,"1F-1r":"#2O"}},"1z-k":{2g:{"1y-1s":1,"1y-1H":"2R","1y-1r":"#dJ","1y-f6-2b":6,"1y-ik-2b":6,2k:1,"1R-1r":"#2O #Li"},3W:{"1y-1r":"#dJ","1y-1s":1,2b:10}},"1z-r":{},"1z-v":{"3N-1y":{"1y-1r":"#dJ","1y-1s":1},3W:{"1y-1r":"#dJ","1y-1s":1},2g:{"1y-1r":"#h2","1y-1s":1}}},8M:{1B:{3H:0},1z:{"2b-7b":1},"1z-r":{h1:3T,3W:{2b:11,"1y-1s":2},"1R-1r":-1,2g:{"1R-1r":"#2O"},9k:{2b:8,"1R-1r":"#h2"},3E:{2b:20,"1R-1r":"#2O","1F-1s":6,"1F-1r":"#z5"}}},ao:{2r:{2v:"50 100"},4z:{"1y-1s":0,3W:{"1y-1s":0},"4Q-3W":{"1y-1s":0},2g:{"1y-1s":1,"1y-1H":"2R","1y-1r":"#h2","1y-f6-2b":6,"1y-ik-2b":6,2k:1},"4Q-2g":{"1y-1s":0}},"1z-x":{2f:!1,2g:{2f:0}},"1z-y":{2g:{"1R-1r":"-1",2k:1}},"1z-y-n":{2g:{"1R-1r":"-1"}},1B:{"1F-1s":1,"1F-1r":"#2O",3H:0,"2J-3U":{"1y-1r":"-1","1F-1r":"-1"}}},ap:{2r:{2v:"50 100"},"1z-x":{2f:!1,2g:{2f:0},1G:{"2p-2c":3T}},"1z-x-n":{1G:{"2p-2c":90}},4z:{"1y-1s":0,3W:{"1y-1s":0},"4Q-3W":{"1y-1s":0},2g:{"1y-1s":1,"1y-1H":"2R","1y-1r":"#h2","1y-f6-2b":6,"1y-ik-2b":6,2k:1},"4Q-2g":{"1y-1s":0}},"1z-y":{2g:{"1R-1r":"-1",2k:1},1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"},2g:{"1R-1r":"-1"}},1B:{"1F-1s":1,"1F-1r":"#2O",3H:0,"2J-3U":{"1y-1r":"-1","1F-1r":"-1"}}},5y:{1B:{"1R-1r":"%6V-1",1O:{1I:"3x",2b:4},"2J-1O":{2b:5}}},8Y:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":0,"1y-1s":1}},81:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":0,"1y-1s":1}},b1:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},6M:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},7v:{4z:{"1y-1r":"#78",3W:{2f:!1}},1B:{"1F-1s":1}},7k:{1B:{"1F-1s":1}},aV:{1B:{"1F-1s":0,3H:0,2k:.75,"1R-1r":"%6V-1"}},an:{5f:{"6j-2y":{2f:!0,1s:"Tt",3u:"5 0","1R-1r":"#n6","1F-1s":0,"1F-1r":"#n6",2G:"1J",76:{2f:ZC.2H,2k:0},aU:{"1R-1r":"#4e",1I:"nn",2k:1},1N:{"1R-1r":"#n6","1D-3s":"1J",3u:"4 20 4 15","1F-1s":0,"1F-1r":"#n6","2p-2b":"Bs",1r:"#2O","2J-3U":{"1R-1r":"#Us"}},8P:{"1y-1s":1,"1y-1r":"#yw"}},"6j-2y[2H]":{1N:{3u:"6 10 6 6"}}}},"-":""},1g.NR.9b.2U["9w-x"]=1g.NR.9b.2U["9w-y"]=1g.NR.9b.2U.2g,1g.NR.ba={},ZC.2A(1g.NR.9b,1g.NR.ba,!0,!0),ZC.2A({2U:{"1R-1r":"#6X",5F:{1r:"#2O"},7X:{1r:"#2O"},7d:{1r:"#2O"},4z:{"1y-1r":"#7N",1N:{1r:"#7N"},"3N-1y":{"1y-1r":"#7N"},2g:{"1y-1r":"#9a"},"4Q-2g":{"1y-1r":"#9a"},3W:{"1y-1r":"#7N"},"4Q-3W":{"1y-1r":"#7N"},1G:{1r:"#7N"}},1X:{2Q:{"1R-1r":"#11i"},3n:{"1R-1r":"#c9"}},"1X-x":{2Q:{"1F-1u":"gW 2R 1Z","1F-2x":"5p 2R #7N","1F-2a":"5p 2R #7N","1F-1J":"5p 2R #7N"},3n:{"1F-1u":"1Z","1F-2x":"1Z","1F-2a":"1Z","1F-1J":"1Z"}},"1X-y":{2Q:{"1F-1u":"5p 2R #7N","1F-2x":"gW 2R 1Z","1F-2a":"5p 2R #7N","1F-1J":"5p 2R #7N"}},2w:{"1R-1r":"#6X"},2C:{"1F-1r":"#4e"},1U:{"1R-1r":"#6X",5S:{1r:"#2O",ti:{"1R-1r":"#dY","1y-1r":"#tj"}},9P:{1r:"#7N","1R-1r":"#dY","1F-1u":"gW 2R 1Z","1F-2x":"5p 2R #c9","1F-2a":"5p 2R #c9","1F-1J":"5p 2R #c9"},ti:{"1R-1r":"#dY","1y-1r":"#tj"},aF:{"1y-1r":"#tj"},"3b-6Q":{1r:"#7N"},"3b-on":{"1R-1r":"#tm"},"3b-6N":{"1R-1r":"#lZ"},1O:{"1F-1r":"#4e"},1N:{1r:"#7N"}},1B:{1O:{"1F-1r":"#6X"}},2g:{"1y-1r":"#7N","1z-1G":{"1R-1r":"#lZ"},"1B-1G":{"1R-1r":"#6X",1r:"#tn","1F-1r":"#12D"}}},1y:{1B:{"2J-1O":{"1F-1r":"#6X"}}},1M:{1B:{"2J-1O":{"1F-1r":"#6X"}}},8q:{1B:{7w:{"1F-1r":"#6X"}}},80:{1B:{7w:{"1F-1r":"#6X"}}},5h:{1B:{1O:{"1F-1r":"#6X"},"2J-1O":{"1F-1r":"#6X"}}},6z:{1B:{1O:{"1F-1r":"#6X"},"2J-1O":{"1F-1r":"#6X"}}},3L:{1B:{"1F-1r":"#6X"}},74:{1B:{"2J-1O":{"1F-1r":"#6X"}},"1z-k":{2g:{"1y-1r":"#9a","1R-1r":"#6X #12C"},3W:{"1y-1r":"#7N"}},"1z-v":{"3N-1y":{"1y-1r":"#9a"},3W:{"1y-1r":"#9a"},2g:{"1y-1r":"#9a"}}},8M:{"1z-r":{2g:{"1R-1r":"#6X"},9k:{"1R-1r":"#12B"}}},ao:{4z:{2g:{"1y-1r":"#9a"}},1B:{"1F-1r":"#6X","2J-3U":{"1y-1r":"#9a","1F-1r":"#6X"}}},ap:{4z:{2g:{"1y-1r":"#9a"}},"1z-y":{2g:{2k:.25,"1R-1r":"#yB -1"}},"1z-y-n":{2g:{2k:.25,"1R-1r":"#yB -1"}},1B:{"1F-1r":"#6X","2J-3U":{"1y-1r":"#9a","1F-1r":"#6X"}}},an:{5f:{"6j-2y":{aU:{"1R-1r":"#tn"}}}},"-":""},1g.NR.ba,!0,!0),1g.NR.ba.2U["9w-x"]=1g.NR.ba.2U["9w-y"]=1g.NR.ba.2U.2g,1g.NR.jQ={2U:{5F:{1s:"100%",3u:"1 2 2","2p-2b":10},7X:{1s:"100%",3u:"1 2 2","2v-1u":14,"2p-2b":9},2r:{1s:"100%",1L:"100%",2v:"18 4 4 4"},4z:{2f:0},2C:{3H:0,"1F-9B":7},1U:{2f:0},2w:{2f:0},2g:{"1y-1s":1,"1y-1r":"#7S",2k:1,"1z-1G":{1D:"%l",3u:"3 6"},"1B-1G":{"1F-1r":"#7S","1F-9B":5,3u:"3 6"}},1B:{3H:0,"1S-3B":{2f:0},"2J-3U":{2f:0},"2J-1O":{2f:0},"1V-ng":sJ,"1V-cZ":sJ}},1y:{1B:{"1y-1s":1,1O:{1I:"1Z"}}},8Y:{"3d-7e":{5q:20,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0,3C:.9}},1M:{1B:{"1y-1s":1,1O:{1I:"1Z"}}},81:{"3d-7e":{5q:20,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0,3C:.9}},6t:{4z:{1Y:5},1B:{1O:{2b:3,3H:!1,2k:.8}}},8t:{4z:{1Y:5},1B:{1O:{2b:3,3H:!1,2k:.8}}},5h:{4z:{1Y:15},1B:{1O:{"3f-1I":"1Z",3H:!1,2k:.8},"2h-2b":3,"1V-2b":9}},6z:{4z:{1Y:15},1B:{1O:{"3f-1I":"1Z",3H:!1,2k:.8},"2h-2b":3,"1V-2b":9}},3L:{2r:{2v:"18 4 4 4"},1B:{"1S-3B":{2f:0}},1z:{"2b-7b":.95}},7k:{2r:{2v:"32 4 4 4"},1B:{"1S-3B":{2f:0}},1z:{"2b-7b":1}},96:{2r:{2v:"18 4 4 4"},1B:{"1S-3B":{2f:0}},1z:{"2b-7b":.95}},74:{2r:{2v:"18 4 4 4"},1B:{"1y-1s":1,1O:{3H:0,2b:2}},1z:{"2b-7b":.95}},6M:{"3d-7e":{5q:20,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0,3C:.9}},7v:{"3d-7e":{5q:20,2c:45,"x-2c":0,"y-2c":-20,"z-2c":0,3C:.9}},aV:{2r:{2v:"18 4 4 4"},1B:{"1F-1s":0}},8M:{2r:{2v:"18 4 4 4"},1B:{Gc:[5]},4z:{2f:1},1z:{"2b-7b":.9},"1z-r":{"1R-1r":"-1",h1:3T,3W:{2f:0},1N:{2f:0},2g:{2f:0},9k:{2b:6,"1R-1r":"#h2",2z:[]},3E:{"1F-1s":0,2b:2,"1R-1r":"#2O"}}},ao:{2r:{2v:"18 4 4 4"}},ap:{2r:{2v:"18 4 4 4"}},8q:{1B:{"2Q-8O":.5,7w:{"1F-1s":0,1L:4}}},80:{1B:{"2Q-8O":.5,7w:{"1F-1s":0,1s:4}}},5y:{1B:{"1y-1s":1,1O:{2f:0},"2J-3U":{2f:0}}},"-":""},1g.NR.12x={6V:[["#4e","#12w","#yw","#12u"],["#4e","#12s","#12r","#12q"],["#4e","#12p","#12o","#12j"],["#4e","#12i","#12G","#e0"],["#4e","#12V","#137","#136"],["#4e","#132","#yF","#12U"],["#4e","#yj","#yl","#12S"]],2U:{"1R-1r":"#111",5F:{1r:"#2O"},7X:{1r:"#8I"},4z:{"2p-2b":11,"1y-1s":2,"1y-1r":"#7S",2g:{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#7S",2k:.2},"4Q-2g":{2f:1,"1y-1s":1,"1y-1H":"2R","1y-1r":"#7S",2k:.2},3W:{2f:1,2b:6,6c:ZC.1b[18],"1y-1s":2,"1y-1r":"#7S"},"4Q-3W":{2f:1,2b:4,6c:ZC.1b[18],"1y-1s":1,"1y-1r":"#7S"},1G:{1r:"#2O"},1N:{1r:"#2O"}}},74:{"1z-k":{2g:{2k:.5,"1R-1r":"#Ur #8I"}}},"-":""},1g.NR.12Q=1g.NR.jQ,1g.B9={an:{5f:{aC:[{id:"xs",3Z:"4q"},{id:"xE",3Z:"4q"},{id:"xD",3Z:"1Z"},{id:"xH",3Z:"1Z"},{id:"xI",3Z:"1Z"},{id:"xC",3Z:"1Z"},{id:"3D",3Z:"1Z"},{id:"xB",3Z:"1Z"},{id:"xo",3Z:"1Z"},{id:"xz",3Z:ZC.cF?"1Z":"4q"},{id:"oW",3Z:ZC.cF?"1Z":"4q"}],dP:{1I:1,2G:"rb"},4X:{2v:"10 3e 3e 10",1s:30,1L:22,3u:4,1N:{"1R-1r":"#l7","1F-1s":1,"1F-1r":"#12H"},"1N-6N":{"1R-1r":"#8S","1F-1r":"#78"}},7Q:{"1R-1r":"#2O",1r:"#4e"},"6j-2y":{3u:0,"1F-1s":1,"1F-1r":"#4e",76:{2f:ZC.2H,2v:"5 3e 3e 5",2k:.8,"1R-1r":"#8I #4J","1F-9B":8,1s:40,1L:40},aU:{"1R-1r":"#2O #yl",1I:"vg",2k:.8},1N:{"1R-1r":"#11J","1D-3s":"1J",3u:"4 20 4 8","1F-1s":1,"1F-1r":"#4e",1r:"#2O","2J-3U":{"1R-1r":"#12e"}},8P:{"1y-1s":1,"1y-1r":"#cH"}},"6j-2y[2H]":{1N:{3u:"6 10 6 6"}}}},6V:[],2U:{5F:{1s:"100%",6u:1,"2p-2b":13},7X:{1s:"100%",6u:1,"2p-2b":11},1X:{2Q:{"1R-1r":"#sN","1F-1r":"#78"},3n:{"1R-1r":"#78","1F-1r":"#7S","1F-1s":2,"1F-1u":"5p 2R #8S","1F-1J":"5p 2R #8S","1F-2x":"5p 2R #4J","1F-2a":"5p 2R #4J"}},"1X-x":{2Q:{1L:16},3n:{1L:16}},"1X-y":{2Q:{1s:16},3n:{1s:16}},"1X-xi":{2Q:{1s:16},3n:{1s:16}},"1X-yi":{2Q:{1L:16},3n:{1L:16}},2w:{1s:"100%",1L:50,2v:"3e 50 20 50","1F-1s":1,3H:0,"1R-1r":"#yj","1F-1r":"#4J",4K:{2k:.5,"1R-1r":"#8I"},6D:{2k:.1,"1R-1r":"#4J"},3n:{1s:9,1L:16,"1F-1s":1,"1y-1s":1,"1y-1r":"#111","1F-1r":"#11F","1F-9B":2,"1R-1r":"#yF"},"3n-1u":{1s:16,1L:9},"3n-2a":{1s:16,1L:9}},2r:{1s:"100%",1L:"100%",2v:"60 50 65 50"},"2r[2w]":{2v:"60 50 105 50"},4z:{"1y-1s":1,2g:{"1y-1s":1,"1y-1r":"#78"},3W:{2b:6,"1y-1s":2},"4Q-2g":{"1y-1s":1,"1y-1r":"#78"},"4Q-3W":{2b:4,"1y-1s":1},1G:{6u:1,3u:6,7M:!0},1N:{3u:2,"3e-3s":!0,7M:!0},1O:{"1y-1s":1,"1y-1r":"#4e","1R-1r":"#7S"},"5H[5z]":{1N:{"2p-2b":10,3u:2,1r:"#4e","1R-1r":"#2O"}}},"4z[3d]":{"1R-1r":"#7S"},"1z-y[2n]":{1G:{"2p-2c":3T},1N:{"1D-3s":"2x"}},"1z-y[5u]":{1G:{"2p-2c":90},1N:{"1D-3s":"1J"}},1B:{4L:{"1y-1s":1,"1y-1r":"#8I",2b:.5},"1S-3B":{7M:!0,1D:"%v",6u:1,6c:"3e",3H:1},"2C-1D":"%v",3H:1,"1y-1s":1,1O:{1I:"9o",3H:1},"5M-3U":{3H:!0,"3H-Gk":2,"3H-6T":1,"3H-2k":.91}},2C:{3H:1,3u:"4 8","3H-6T":3,"1Y-y":ZC.2H?-40:-20},"2C[4M]":{3u:"4 8","1Y-y":0},2g:{1O:{1I:"3x"},"1B-1G[bq]":{1D:\'<b 1H="1r:%1r">%1B-1D:</b> %2o-1S\',3u:10,"1R-1r":"#2O #8S","1F-1s":1,"1F-1r":"#4J",1r:"#4e","1D-3s":"1J"},"1B-1G[a7]":{1D:\'<b 1H="1r:%1r">%1B-1D:</b> %2o-1S\',3u:5,"1R-1r":"#2O #8S","1F-1s":1,"1F-1r":"#4J",1r:"#4e","1D-3s":"1J"}},3C:{"dp-3C":1,"1F-1s":0,"1R-1r":"#l7",2k:.25,1G:{2f:!1,"1R-1r":"#2O","2p-2b":10,3u:2,"1F-1s":1,"1F-1r":"#4J"}},7G:{"1F-1s":1,"1F-1r":"#4e","1R-1r":"#cT",2b:4},"1U[2G]":{2v:10},1U:{"1R-1r":"#8S",2k:1,3H:1,2v:"10 10 3e 3e",3u:"4 2 4 2",1N:{"1D-3s":"1J",2v:"2 6 2 4",3u:"2 4"},"1N-6N":{2k:.25},1O:{3H:0,2b:6,"1F-1r":"#4J","1F-1s":1},5S:{"2p-2b":12,"1D-3s":"1J",6u:1},9P:{"1D-3s":"1J"},aF:{"1y-1r":"#4e","1y-1s":1},"3b-6Q":{1r:"#4e"},"3b-on":{"1R-1r":"#yU"},"3b-6N":{"1R-1r":"#4J"},1X:{2Q:{1s:12,1L:12,"1R-1r":"#sN","1F-1r":"#78"},3n:{1s:12,1L:12,"1R-1r":"#78","1F-1r":"#7S","1F-1s":2,"1F-1u":"5p 2R #8S","1F-1J":"5p 2R #8S","1F-2x":"5p 2R #4J","1F-2a":"5p 2R #4J"}}}},5A:{1B:{"1S-3B":{6c:"1u-4R"}}},6M:{1B:{"1S-3B":{6c:"1u-4R"}},"3d-7e":{5q:40,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0}},b1:{"3d-7e":{5q:40,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0}},6d:{"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x[2n]":{1G:{"2p-2c":3T}},"1z-x[5u]":{1G:{"2p-2c":90}},1B:{"1S-3B":{6c:"1u-4R"}}},bF:{"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x[2n]":{1G:{"2p-2c":3T}},"1z-x[5u]":{1G:{"2p-2c":90}}},bE:{1B:{"3f-2c":0},"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x[2n]":{1G:{"2p-2c":3T}},"1z-x[5u]":{1G:{"2p-2c":90}}},7v:{"1z-y":{1G:{"2p-2c":0}},"1z-x":{1G:{"2p-2c":3T}},"1z-y-n":{1G:{"2p-2c":0}},"1z-x-n":{1G:{"2p-2c":90}},"3d-7e":{5q:40,2c:45,"x-2c":0,"y-2c":-20,"z-2c":0},1B:{"1S-3B":{6c:"1u-4R"}}},80:{"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x":{1G:{"2p-2c":3T}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x-n":{1G:{"2p-2c":90}}},1y:{1B:{"1y-1s":4,1O:{1I:"3x",2b:4}}},1M:{1B:{"1y-1s":4,1O:{1I:"3x",2b:4},"1S-3B":{6c:"1u"}}},8Y:{"3d-7e":{5q:40,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0},1B:{"1F-1s":1,"1y-1s":1,1O:{1I:"3x",2b:4,2k:1,2f:0}}},81:{"3d-7e":{5q:40,2c:45,"x-2c":-20,"y-2c":0,"z-2c":0},1B:{"1F-1s":1,"1y-1s":1,1O:{1I:"3x",2b:4,2k:1,2f:0},"1S-3B":{6c:"1u"}}},6t:{4z:{1Y:10},1B:{1O:{1I:"3x",2b:4},"1S-3B":{6c:"1u"}}},4x:{4z:{1Y:10},1B:{"2k-1M":.4,1O:{1I:"1Z"},"1S-3B":{6c:"1u"}}},8t:{4z:{1Y:10},"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x":{1G:{"2p-2c":3T}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x-n":{1G:{"2p-2c":90}},1B:{1O:{1I:"3x",2b:4},"1S-3B":{6c:"1u"}}},5h:{4z:{1Y:40},1B:{1O:{1I:"3x","3f-1I":"8x","3f-1Y-x":-.2,"3f-1Y-y":-.2},"2J-1O":{"3f-1I":"8x","3f-1Y-x":-.2,"3f-1Y-y":-.2},"1S-3B":{6c:"6o",1D:"%2o-2b-1S"},"2C-1D":"%2o-2b-1S"}},6z:{4z:{1Y:40},"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x":{1G:{"2p-2c":3T}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x-n":{1G:{"2p-2c":90}},1B:{1O:{1I:"3x","3f-1I":"8x","3f-1Y-x":-.2,"3f-1Y-y":-.2},"2J-1O":{"3f-1I":"8x","3f-1Y-x":-.2,"3f-1Y-y":-.2},"1S-3B":{6c:"6o",1D:"%2o-2b-1S"},"2C-1D":"%2o-2b-1S"}},iw:{"1z-y":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x":{1G:{"2p-2c":3T}},"1z-y-n":{1G:{"2p-2c":0},1N:{"1D-3s":"3E"}},"1z-x-n":{1G:{"2p-2c":90}}},3L:{2r:{2v:"35 5 5 5"},1z:{"2b-7b":"3e","1y-1s":0,2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}},1B:{"3f-1I":"8x","1S-3B":{97:{"1y-1s":1},6c:"4R",1D:"%t",2f:1}}},7k:{"3d-7e":{"x-2c":38,"y-2c":0,"z-2c":0},2r:{2v:"25 5 5 5"},1z:{"2b-7b":"3e","1y-1s":0,2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}},1B:{"3f-1I":"9l","1S-3B":{97:{"1y-1s":1},6c:"4R",1D:"%t",2f:1}}},96:{2r:{2v:"40 5 15 5"},1z:{"2b-7b":.8,"1y-1s":0,2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}},1B:{"3f-1I":"8x","1S-3B":{97:{"1y-1s":1},1D:"%t",2f:1}}},aV:{2r:{2v:"30 10 10 10"},1B:{2k:.5,"1F-1s":4},1z:{"2b-7b":.65,"1y-1s":0,2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0}}},74:{4z:{2g:{"1y-1s":1,"1y-1r":"#4J","1R-1r":"-1"},3W:{"1y-1s":1},1N:{"3e-3s":!1}},1z:{2f:0,"2b-7b":.7},"1z-k":{"3N-2c":3T},2r:{2v:"40 5 5 5"},1B:{"1y-1s":4,7e:"1y",1O:{1I:"3x"}}},8M:{4z:{2g:{"1F-1s":1,"1F-1r":"#4J","1R-1r":"-1"}},1z:{"1y-1s":0,2g:{"1y-1s":0},"4Q-2g":{"1y-1s":0},"2b-7b":.7},"1z-r":{"3N-2c":3T,"1R-1r":"#2O",2g:{"1y-1s":0},3W:{6c:"5N"},1N:{"1Y-r":"-45%"}},1B:{2b:"85%"},2r:{2v:"40 5 5 5"}},8f:{1B:{"1y-1s":1,"1F-1s":1,"2C-1D":"11B:&8J;$%bu<br>11A:&8J;$%u3<br>11z:&8J;$%u2<br>i1:&8J;$%7p"}},5y:{1B:{"1y-1s":2,"1S-3B":{1D:"%2o-2h-1S - %2o-1V-1S"},"2C-1D":"%2o-2h-1S - %2o-1V-1S"}},"-":""},1g.PG=1f(e,t){1a i,n=1g,a=!1;1m 1c!==ZC.1d(i=n.B9.2U[e])&&1c!==ZC.1d(i.3Z)&&(a=a||ZC.2q(i.3Z)),1c!==ZC.1d(n.B9[t])&&1c!==ZC.1d(i=n.B9[t][e])&&1c!==ZC.1d(i.3Z)&&(a=a||ZC.2q(i.3Z)),a},1g.2t=1f(e,t,i,n){1a a,l,o,r=1g;i=1c===ZC.1d(i)||ZC.2q(i),n=1c!==ZC.1d(n)&&ZC.2q(n),t 3z 3K||(t=1n 3K(t));1a C=[],A="";1k(l=0,o=t.1h;l<o;l++)if(/(\\(\\w+\\))(.*)/.5x(t[l])){1a s=5o.$1;A=t[l].1E(s,"2U"),-1===ZC.AT(C,A)&&C.1i(A),A=t[l].1E(s,s.2s(1,s.1h-1)),-1===ZC.AT(C,A)&&C.1i(A)}1t-1===ZC.AT(C,t[l])&&C.1i(t[l]),/an(.*)/.5x(t[l])&&-1===ZC.AT(C,t[l].1E("an","6C"))&&C.1i(t[l].1E("an","6C")),/6C(.*)/.5x(t[l])&&-1===ZC.AT(C,t[l].1E("6C","an"))&&C.1i(t[l].1E("6C","an"));1a Z={};1k(l=0,o=C.1h;l<o;l++){1k(1a c=C[l].2l("."),u=r.B9,p=0,h=c.1h;p<h;p++)if(1c!==ZC.1d(a=u[c[p]]))u=a;1t if(1c!==ZC.1d(a=u[ZC.U9(c[p])]))u=a;1t{if(1c===ZC.1d(a=u[ZC.EB(c[p])])){u=1c;1p}u=a}if(u)1k(1a 1b in u)1c!==ZC.1d(u[1b])&&(n||"4g"!=1w u[1b]||u[1b].1h)&&(i||1c===ZC.1d(e[1b])?r.H.QK&&1c!==ZC.1d(r.H.QK[1b])||(Z[1b]=u[1b]):i&&"4g"==1w u[1b]&&(r.H.QK&&1c!==ZC.1d(r.H.QK[1b])||(Z[1b]=u[1b])))}ZC.2A(Z,e)}},ZC.AO={11y:1f(e,t){1k(1a i=[],n=0,a=e.p.1h;n<a;n++)if(e.p[n]){1a l=(e.p[n][0]-e.x)/e.w,o=(e.p[n][1]-e.y)/e.h;i.1i([t.x+t.w*l,t.y+t.h*o])}1t i.1i(1c);1m{l:t.w*e.l/e.w,r:t.w*e.r/e.w,p:i}},zY:1f(e,t,i){1a n=2e.e6("gf")[0],a=2e.4N("11j");a.1I="1D/7u",a.4T=t+"?v"+ZC.fL;1a l=!1;a.hv=a.fv=1f(){if(!(l||1g.f4&&"11t"!==1g.f4&&"aE"!==1g.f4)){l=!0,a.hv=a.fv=1c,n&&a.6s&&n.aN(a);1a e=1n 5o("1o-(.+?).2h.js","g").3j(t);e&&ZC.WF.1i(e[1]),i&&i(t)}},a.li=1f(){!e&&1o.HP[0]&&(e=1o.HP[0]),e?e.NM({8L:ZC.1b[63],aR:"bj cq gh ("+a.4T+")"},"11s 6C"):zU("bj cq gh ("+a.4T+")")},n.hL(a,n.11r)},z1:1f(){1m"#"+ZC.XN.eE(ZC.hc(0,sJ)).5v(ZC.hc(0,20),6)},WI:1f(){},qM:1f(e,t){1m 1o[e]||t&&t.dn&&t.dn[e]||1o.gA(1c,e)||t&&1o.gA(t.K,e)},C2:1f(e,t,i,n,a){i 3z 3K||(i=[i]);1a l=1;1m 1c!==ZC.1d(n)&&i.1i(n),a&&(l=2,i.1i(a)),"4D"===e&&(e=ZC.1b[47]),"5P"===e&&(e=ZC.1b[49]),"6k"===e&&(e=ZC.1b[48]),1o[e]&&"b3"!==e&&(1c!==ZC.1d(n)?i[i.1h-l]=1o[e].8H(1o,i):1o[e].8H(1o,i)),t&&t.dn[e]&&(1c!==ZC.1d(n)?i[i.1h-l]=t.dn[e].8H(1o,i):t.dn[e].8H(1o,i)),1o.gA(1c,e)&&(1c!==ZC.1d(n)?i[i.1h-l]=1o.gM(1c,e,i,n):1o.gM(1c,e,i)),t&&1o.gA(t.K,e)&&(1c!==ZC.1d(n)?i[i.1h-l]=1o.gM(t.K,e,i,n):1o.gM(t.K,e,i)),i[i.1h-l]},NZ:1f(e,t){if(t.AA%2j!=0){1k(1a i=[[-t.I/2,-t.F/2],[t.I/2,-t.F/2],[t.I/2,t.F/2],[-t.I/2,t.F/2]],n="",a=0;a<4;a++)i[a]=[t.iX+t.I/2+t.BJ+ZC.3y+i[a][0]*ZC.ED(t.AA)-i[a][1]*ZC.EL(t.AA),t.iY+t.F/2+t.BD+ZC.3y+i[a][0]*ZC.EL(t.AA)+i[a][1]*ZC.ED(t.AA)],n+=ZC.1l(i[a][0])+","+ZC.1l(i[a][1])+",";1m t.D=i,ZC.P.GC("4x",t.E5,t.IM)+\'3g="\'+e+\'-1G-1M zc-1G-1M" id="\'+t.K+"-1M"+ZC.1b[30]+n.2s(0,n.1h-1)+\'" />\'}1m ZC.P.GC("5t",t.E5,t.IM)+\'3g="\'+e+\'-1G-1M zc-1G-1M" id="\'+t.K+"-1M"+ZC.1b[30]+ZC.1l(t.iX+t.BJ+ZC.3y)+","+ZC.1l(t.iY+t.BD+ZC.3y)+","+ZC.1l(t.iX+t.BJ+t.I+ZC.3y)+","+ZC.1l(t.iY+t.BD+t.F+ZC.3y)+\'" />\'},MW:1f(e){1a t,i="",n=e.1K(\'id="\');if(-1!==n){1a a=e.1K(\'"\',n+4);-1!==a&&(i=e.2s(n+4,a))}if(ZC.4b.1T["1M-sR-"+i])1m ZC.4b.1T["1M-sR-"+i];1a l=0;if(-1!==e.1K(\'2P="5t"\')?(l+=8p,5===(t=/9n=\\"(\\-*\\d+),(\\-*\\d+),(\\-*\\d+),(\\-*\\d+)\\"/.3j(e)).1h&&(l+=(ZC.1l(t[3])-ZC.1l(t[1]))*(ZC.1l(t[4])-ZC.1l(t[2])))):-1!==e.1K(\'2P="3x"\')?(l+=100,t=/9n=\\"(\\-*\\d+),(\\-*\\d+),(\\-*\\d+)\\"/.3j(e),1c!==ZC.1d(t[3])&&(l+=ZC.1l(t[3])/10)):-1!==e.1K(\'2P="4x"\')?-1!==e.1K("1T-2Z")?l+=hH:l+=5L:l+=1,-1!==e.1K("1T-z-3V")){1a o=/1T-z-3V=\\"(\\-*\\d+)\\"/.3j(e);o&&2===o.1h&&(l*=ZC.1l(1A.5k(10,ZC.1l(o[1]))))}1m""!==i&&ZC.4b.2N("1M-sR-"+i,l),l},uJ:1f(e,t,i){1k(1a n=[],a=0,l=e.1h;a<l;a++)if(1c!==ZC.1d(e[a])){1a o=e[a].7y(0);1c!==ZC.1d(o[0])&&"2Y"!=1w o[0]&&(o[0]+=t),1c!==ZC.1d(o[1])&&"2Y"!=1w o[1]&&(o[1]+=i),1c!==ZC.1d(o[2])&&"2Y"!=1w o[2]&&o.1h<=4&&(o[2]+=t),1c!==ZC.1d(o[3])&&"2Y"!=1w o[3]&&o.1h<=4&&(o[3]+=i),n.1i(o)}1t n.1i(1c);1m n},OS:1f(e,t){1a i;t=t||{},e=e||{};1a n={};if(1c!==ZC.1d(i=e.8g)&&(n.8g=i),1c!==ZC.1d(i=e["5E"])&&(n["5E"]=ZC.2q(i)),1c!==ZC.1d(i=e["5E-e1"])&&(n["5E-e1"]=i),1c!==ZC.1d(i=e.a8)&&(n.a8=ZC.2q(i)),1c!==ZC.1d(i=e[ZC.1b[25]])&&(n[ZC.1b[25]]=ZC.1l(i)),1c!==ZC.1d(i=e[ZC.1b[14]])?n[ZC.1b[14]]=i:1c===ZC.1d(t[ZC.1b[14]])&&1c!==ZC.1d(i=ZC.HA[ZC.1b[14]])&&(n[ZC.1b[14]]=i),1c!==ZC.1d(i=e[ZC.1b[13]])?n[ZC.1b[13]]=i:1c===ZC.1d(t[ZC.1b[13]])&&1c!==ZC.1d(i=ZC.HA[ZC.1b[13]])&&(n[ZC.1b[13]]=i),1c!==ZC.1d(i=e[ZC.1b[12]])&&(n[ZC.1b[12]]=ZC.1l(i)),1c!==ZC.1d(i=e["6h-yZ"])&&(n["6h-yZ"]=i),1c!==ZC.1d(i=e.5H)&&1c!==ZC.1d(i.1I))1P(i.1I){1j"5z":n[ZC.1b[68]]=!0,1c!==ZC.1d(i.1D)&&(i.4q=i.1D),1c!==ZC.1d(i.4q)&&(n[ZC.1b[67]]=i.4q)}1m n},GM:1f(e,t,i,n){1a a,l=e,o=e+"",r=!1;if(n&&1c!==ZC.1d(t[ZC.1b[68]])&&t[ZC.1b[68]]&&""+4P(o)===o&&(o=ZC.AO.Y2(4P(o),t[ZC.1b[67]],t.ch,t.cn),r=!0),1c===ZC.1d(t[ZC.1b[14]])&&1c!==ZC.1d(e=ZC.HA[ZC.1b[14]])&&(t[ZC.1b[14]]=e),1c===ZC.1d(t[ZC.1b[13]])&&1c!==ZC.1d(e=ZC.HA[ZC.1b[13]])&&(t[ZC.1b[13]]=e),1c!==ZC.1d(t[ZC.1b[12]])&&-1!==t[ZC.1b[12]]&&1w t["1V-6h"]!==ZC.1b[31]&&-1!==t["1V-6h"]&&(t[ZC.1b[12]]=ZC.BN(t["1V-6h"],t[ZC.1b[12]])),!r)if(1c!==ZC.1d(t.a8)&&t.a8)o=4P(o).11l(ZC.CV(20,t[ZC.1b[25]])),1c!==ZC.1d(t[ZC.1b[14]])&&(o=o.1E(/\\./g,t[ZC.1b[14]]));1t{if(1c!==ZC.1d(t["5E"])&&t["5E"]){a="";1a C=t["5E-e1"]||"";if("2Y"!=1w C&&C.1h){""+ZC.1W(C[0])!==C[0]&&(C=[5L].4w(C));1k(1a A=1,s=C[0]||5L,Z=C.7y(1),c=1c,u=0;u<Z.1h;u++)0===Z[u].1K("#")&&(c=u,Z[u]=Z[u].2s(1));if(Z.1h){if(1c!==c)A=c;1t if(1c!==ZC.1d(t["1V-cC"]))A=t["1V-cC"];1t{1a p=ZC.HH(ZC.2i(4P(o)),s);A=1A.4i(p),A=ZC.CV(A,Z.1h-1)}a=Z[A];1a h=(o=""+4P(o)/1A.5k(s,A)).2l(".");2===h.1h&&h[1].1h>=9&&(o=1c!==ZC.1d(t[ZC.1b[12]])&&-1!==t[ZC.1b[12]]?""+ZC.4t(o,t[ZC.1b[12]]):""+ZC.4t(o))}}1t{1a 1b=ZC.HH(ZC.2i(4P(o)))/1A.bm;1P(ZC.2i(4P(o))){1j 5L:1b=3;1p;1j hH:1b=6;1p;1j sV:1b=9}if(1c!==ZC.1d(t["1V-cC"])&&(1b=3*t["1V-cC"]),"KB"===C.5D())o=""+4P(o)/iv,a="KB";1t if("MB"===C.5D())o=""+4P(o)/11H,a="MB";1t if("GB"===C.5D())o=""+4P(o)/11v,a="GB";1t if("TB"===C.5D())o=""+4P(o)/11I,a="TB";1t if("PB"===C.5D())o=""+4P(o)/11W,a="PB";1t if(1b>=0&&1b<3)1P(C){2n:o=o,a="";1p;1j"K":o=""+4P(o)/5L,a="K";1p;1j"M":o=""+4P(o)/hH,a="M";1p;1j"B":o=""+4P(o)/sV,a="B"}1t 1b>=3&&1b<6&&""===C||"K"===C.5D()?(o=""+4P(o)/5L,a="K"):1b>=6&&1b<9&&""===C||"M"===C.5D()?(o=""+4P(o)/hH,a="M"):(1b>=9&&""===C||"B"===C.5D())&&(o=""+4P(o)/sV,a="B")}if(ZC.P2(o))if(1c!==ZC.1d(t[ZC.1b[12]])&&-1!==t[ZC.1b[12]])o=ZC.bn(4P(o),ZC.BN(0,ZC.1l(t[ZC.1b[12]])));1t{1a d=o.2l(".")[1]||"";-1!==t["1V-6h"]&&t["1V-6h"]<d.1h&&(o=ZC.bn(4P(o),ZC.BN(0,ZC.1l(t["1V-6h"]))))}1c!==ZC.1d(t[ZC.1b[14]])&&(o=o.1E(/\\./g,t[ZC.1b[14]]))}if(!8a(o)&&"2Y"!=1w l){if(1c!==ZC.1d(t[ZC.1b[12]])&&-1!==t[ZC.1b[12]]&&ZC.P2(o)&&(1c!==ZC.1d(t["5E"])&&t["5E"]||(o=ZC.bn(4P(o),ZC.BN(0,ZC.1l(t[ZC.1b[12]]))))),1c!==ZC.1d(t[ZC.1b[13]])||1c!==ZC.1d(t[ZC.1b[14]])){1k(1a f=o.2l("."),g="",B=0,v=f[0].1h;B<v;B++){1a b=f[0].2s(B,B+1);g+=b,-1===ZC.AT(["-","+"],b)&&(f[0].1h-B-1)%3==0&&f[0].1h-B-1!=0&&(g+=t[ZC.1b[13]])}o=g+(1c!==ZC.1d(f[1])?t[ZC.1b[14]]+f[1]:"")}1c!==ZC.1d(t["5E"])&&t["5E"]&&(o+=a)}}1m o},rB:1f(e){1a t=e.1K("("),i="",n="";-1!==t?(i=ZC.GO(e.2s(0,t)),n=ZC.GO(e.2s(t+1,e.1h-1))):i=ZC.GO(e);1a a=[],l="";if(""!==n){1a o=!1,r=!1,C=!1;l="";1k(1a A=0,s=n.1h;A<s;A++){1a Z=n.2s(A,A+1);1P(Z){1j"\\\\":C?(l+="\\\\",C=!1):C=!0;1p;1j\'"\':C?(l+=\'"\',C=!1):r?(a.1i(l),l="",r=!1):o?l+=Z:r=!0;1p;1j"\'":C?(l+="\'",C=!1):o?(a.1i(l),l="",o=!1):r?l+=Z:o=!0;1p;1j" ":(o||r)&&(l+=Z);1p;1j",":o||r?l+=Z:(""!==l&&a.1i(l),l="");1p;2n:l+=Z}}}1m""!==l&&a.1i(l),[i,a]},eD:1f(e){1m e.aq().1E(/^([0-9])$/,"0$1")},Y2:1f(e,t,i,n){t=t||ZC.HA["5z-s7"].iR,1w i===ZC.1b[31]&&(i=!1),1w n===ZC.1b[31]&&(n=0),i&&(e+=md*n);1a a,l,o,r,C,A,s,Z,c=1n 9H;c.12d(e),i?(a=c.12c(),l=c.12b(),o=c.12a(),r=c.129(),C=c.124(),A=c.123(),s=c.121(),Z=c.11Z()):(a=c.11Y(),l=c.11X(),o=c.11V(),r=c.11K(),C=c.11U(),A=c.11S(),s=c.11R(),Z=c.xW());1k(1a u=[["mm",ZC.AO.eD(s+1)],["dd",ZC.AO.eD(A)],["Y",Z],["y",Z.aq().5v(2,2)],["F",ZC.HA["jG-fW"][s]],["m",s+1],["M",ZC.HA["jG-5E"][s]],["n",s],["d",A],["D",ZC.HA["jT-5E"][C]],["j",A],["l",ZC.HA["jT-fW"][C]],["N",C+1],["w",C],["S",1f(){1m A%10==1?"st":A%10==2?"nd":A%10==3?"rd":"th"}],["a",a<12?"am":"pm"],["A",a<12?"AM":"PM"],["g",a%12||12],["G",a],["h",ZC.AO.eD(a%12||12)],["H",ZC.AO.eD(a)],["i",ZC.AO.eD(l)],["s",ZC.AO.eD(o)],["q",r]],p=0;p<u.1h;p++)t=t.1E("%"+u[p][0],u[p][1]);1m t},lp:{},YV:1f(e,t){1a i=1c;if(t&&t.BO?i=t.BO:t&&t.A&&t.A.BO&&(i=t.A.BO),"2Y"==1w e&&-1!==e.1K("%1r-")&&ZC.ay.1h>0)1k(1a n=0;n<ZC.ay.1h;n++)-1===e.1K("(+")&&-1===e.1K("(-")||(e=e.1E(/%1r-(\\d+?)\\((\\+|\\-)(\\d+?)\\)/gi,1f(){1a e=ZC.AO.G3(ZC.ay[ZC.1l(7Z[1])]);1m"+"===7Z[2]?e=ZC.AO.QJ(e,ZC.1l(7Z[3])):"-"===7Z[2]&&(e=ZC.AO.JE(e,ZC.1l(7Z[3]))),e})),e=e.1E("%1r-"+n,ZC.ay[n]);1t"2Y"==1w e&&i&&-1!==e.1K("%6V-")&&(e=i[ZC.1l(e.1E("%6V-",""))]);1m e},G3:1f(e,t){1a i,n,a,l;if(1c!==ZC.1d(ZC.AO.lp[e]))1m ZC.AO.lp[e];1a o=ZC.GO(5X(e)),r=1,C=!1;1m 0===o.1h?"":("9D("===(o=o.1E("yR","#")).2s(0,5)?(i=1n 5o("9D\\\\((\\\\d{1,3}),\\\\s*(\\\\d{1,3}),\\\\s*(\\\\d{1,3}),\\\\s*([0-9.]+)\\\\)","gi").3j(o))&&(1===(n=ZC.ON(i[1])).1h&&(n="0"+n),1===(a=ZC.ON(i[2])).1h&&(a="0"+a),1===(l=ZC.ON(i[3])).1h&&(l="0"+l),o="#"+n+a+l,r=ZC.BN(0,ZC.CV(1,5V(i[4]))),C=!0):"9I("===o.2s(0,4)?(i=1n 5o("9I\\\\((\\\\d{1,3}),\\\\s*(\\\\d{1,3}),\\\\s*(\\\\d{1,3})\\\\)","gi").3j(o))&&(1===(n=ZC.ON(i[1])).1h&&(n="0"+n),1===(a=ZC.ON(i[2])).1h&&(a="0"+a),1===(l=ZC.ON(i[3])).1h&&(l="0"+l),o="#"+n+a+l):"#"===o.2s(0,1)?4===o.1h?o="#"+o.2s(1,2)+o.2s(1,2)+o.2s(2,3)+o.2s(2,3)+o.2s(3,4)+o.2s(3,4):7!==o.1h&&(o=""):1c!==ZC.1d(ZC.P.sY[o.5D()])&&(o="#"+ZC.P.sY[o.5D()]),"1Z"!==o&&"b0"!==o||(o="-1"),t||(ZC.AO.lp[e]=o),t&&C?[o,r]:o)},ls:{},ea:1f(e,t){if(-1===e&&(e="#kz",t=0),1c!==ZC.1d(ZC.AO.ls[e+","+t]))1m ZC.AO.ls[e+","+t];4===e.1h&&(e=e.2s(0,1)+e.2s(1,2)+e.2s(1,2)+e.2s(2,3)+e.2s(2,3)+e.2s(3,4)+e.2s(3,4));1a i="9D("+[ZC.QG(e.2s(1,3)),ZC.QG(e.2s(3,5)),ZC.QG(e.2s(5,7)),t].2I(",")+")";1m ZC.AO.ls[e+","+t]=i,i},yQ:1f(e,t,i){e/=3R,t/=3R,i/=3R;1a n,a,l,o=1A.1V(e,t,i),r=1A.2h(e,t,i);l=o;1a C=o-r;if(a=0===o?0:C/o,o===r)n=0;1t{1P(o){1j e:n=(t-i)/C+(t<i?6:0);1p;1j t:n=(i-e)/C+2;1p;1j i:n=(e-t)/C+4}n/=6}1m[n,a,l]},yO:1f(e,t,i){1a n,a,l,o=1A.4i(6*e),r=6*e-o,C=i*(1-t),A=i*(1-r*t),s=i*(1-(1-r)*t);1P(o%6){1j 0:n=i,a=s,l=C;1p;1j 1:n=A,a=i,l=C;1p;1j 2:n=C,a=i,l=s;1p;1j 3:n=C,a=A,l=i;1p;1j 4:n=s,a=C,l=i;1p;1j 5:n=i,a=C,l=A}1m[3R*n,3R*a,3R*l]},JE:1f(e,t){if(-1===e)1m-1;if(t>=100)1m"#cH";e=ZC.AO.G3(e),1w t===ZC.1b[31]&&(t=10);1a i=ZC.QG(e.2s(1,3)),n=ZC.QG(e.2s(3,5)),a=ZC.QG(e.2s(5,7)),l=ZC.AO.yQ(i,n,a);l[2]=t>0?1A.1V(0,l[2]-l[2]*t/100):1A.2h(1,l[2]-l[2]*t/100);1a o=ZC.AO.yO(l[0],l[1],l[2]);1m o[0]=ZC.1l(o[0])<16?"0"+ZC.ON(o[0]):ZC.ON(o[0]),o[1]=ZC.1l(o[1])<16?"0"+ZC.ON(o[1]):ZC.ON(o[1]),o[2]=ZC.1l(o[2])<16?"0"+ZC.ON(o[2]):ZC.ON(o[2]),e="#"+o[0]+o[1]+o[2]},QJ:1f(e,t){if(-1===e)1m-1;if(t>=100)1m"#kz";e=ZC.AO.G3(e),1w t===ZC.1b[31]&&(t=10);1a i=5w(e.5v(1,2),16),n=5w(e.5v(3,2),16),a=5w(e.5v(5,2),16);1m"#"+(0|bz+i+(bz-i)*t/100).aq(16).5v(1)+(0|bz+n+(bz-n)*t/100).aq(16).5v(1)+(0|bz+a+(bz-a)*t/100).aq(16).5v(1)},lu:1f(e,t){1a i=5w(e.5v(1,2),16),n=5w(e.5v(3,2),16),a=5w(e.5v(5,2),16);1m ZC.1d(t)?"9I("+i+","+n+","+a+")":{r:i,g:n,b:a}},yN:1f(e,t,i){1m"#"+((1<<24)+(e<<16)+(t<<8)+i).aq(16).7y(1)},rs:1f(e,t,i){1a n=ZC.AO.lu(e);1m(11P*n.r+11N*n.g+114*n.b)/5L>=128?i:t},11M:1f(e,t,i){e=ZC.AO.G3(e),t=ZC.AO.G3(t);1a n=ZC.AO.lu(e),a=ZC.AO.lu(t),l={};1k(1a o in n)l[o]=1A.4i(i*n[o]+(1-i)*a[o]);1m ZC.AO.yN(l.r,l.g,l.b)},kB:1f(){},pG:1f(){},gc:1f(e,t){1a i;1k(i=0;i<t.1h;i++)e[t[i]]=1c;1k(i in e)0===i.1K("11L")&&"1f"==1w e[i]&&(e[i]=1c)}},ZC.P={sY:{12g:"cH",13b:"147",14v:"14u",14q:"14p",14o:"yf",14n:"14m",14l:"148",14i:"14g",14f:"14e",14d:"14c",14b:"yf",14x:"14M",14X:"14W",14V:"14T",14S:"14R",14Q:"14P",14O:"14N",14L:"14J",14F:"14C",14B:"14A",14y:"wG",145:"13D"},GC:1f(e,t,i){1m"<1M"+(i&&!t&&"ib"!==i?\' 1H="4O:\'+i+\'"\':"")+(t&&"7G"!==i||"ib"===i?\' 7K="7u:;"\':"")+\' 2P="\'+e+\'" \'},nm:1f(e){1a t;if(ZC.A4.6A.a6)4I{t=2e.4N("<mo />")}4G(r){t=2e.4N("mo")}1t t=2e.4N("mo");t.id=e.id+"-mo",t.1H.dW="9c",e.2X(t);1a i=1c,n=t.144||t.13A;if(!(i=n.2e?n.2e:n).3o){1a a=i.4N("13z");i.2X(a);1a l=i.4N("13y");a.2X(l);1a o=i.4N("lE");a.2X(o)}1m i},C1:1f(e){1a t;if(1w ZC.bO===ZC.1b[31]){if(ZC.cF)t=!1;1t{t=!0;4I{2e.13x("13w")}4G(i){t=!1}}t&&!ZC.2H&&(t=!1),t&&(t="13v"in 2e.eJ),ZC.bO=t}1t t=ZC.bO;if(t)1P(e){1j"6Z":1j"6I":e="4D";1p;1j"7R":e="6k";1p;1j"7B":1j"6f":e="5P";1p;1j"3F":e="4D"}1m e},sw:1f(e,t){1a i,n,a,l=[],o=t.JP,r=t.OB,C=t.P5,A=o-C/2;if(e.1h>0){1a s=0,Z=0;1k(0!==o&&(s=ZC.1l(A*ZC.ED(r)+C),Z=ZC.1l(A*ZC.EL(r)+C)),i=0,n=e.1h;i<n;i++)if(1c!==ZC.1d(e[i])){1a c=[];1k(a=0;a<e[i].1h;a++)c[a]=e[i][a];1a u=c.1h;if(2===u||4===u)1k(a=0;a<u;a++)c[a]=e[i][a]+(a%2?Z+t.BD:s+t.BJ);l.1i(c)}1t l.1i(1c)}1m l},n4:1f(e,t,i,n,a){1w a===ZC.1b[31]&&(a=!1);1a l,o,r=[e[0],e[1]];1P(e.1h>=4&&(r[2]=e[2],r[3]=e[3]),e.1h>=6&&(r[4]=e[4],r[5]=e[5]),7===e.1h&&(r[6]=e[6]),t){1j"3a":1j"2B":if(i.CX){1a C,A;C=A=i.AY%2==1?.5:0,ZC.A4.6A.a6&&ZC.8U&&"2B"===t&&(C=i.AY%2==1?.5:0,A=i.AY%2==1?0:.5),r[0]=1A.43(r[0])-C,r[1]=1A.43(r[1])-A,4===r.1h&&(r[2]=1A.43(r[2])-C,r[3]=1A.43(r[3])-A)}"2B"===t&&(r[0]=5V(r[0].4v(4)),r[1]=5V(r[1].4v(4)),4===r.1h&&(r[2]=5V(r[2].4v(4)),r[3]=5V(r[3].4v(4)))),"3a"!==t||n||1w i.BJ!==ZC.1b[31]&&1w i.BD!==ZC.1b[31]&&(r[0]+=i.BJ,r[1]+=i.BD,4===r.1h&&(r[2]+=i.BJ,r[3]+=i.BD));1p;1j"3I":i.AA%2j==0?(l=10,o=i.AY%2==1?0:l/2):(l=1,o=0),i.CX?(r[0]=l*ZC.1l(ZC.1l(l*r[0])/l)-o,r[1]=l*ZC.1l(ZC.1l(l*r[1])/l)-o,4!==r.1h&&7!==r.1h||(r[2]=l*ZC.1l(ZC.1l(l*r[2])/l)-o,r[3]=l*ZC.1l(ZC.1l(l*r[3])/l)-o),7===r.1h&&(r[4]=l*ZC.1l(ZC.1l(l*r[4])/l)-o,r[5]=l*ZC.1l(ZC.1l(l*r[5])/l)-o)):(r[0]=ZC.1l(l*r[0]),r[1]=ZC.1l(l*r[1]),4!==r.1h&&7!==r.1h||(r[2]=ZC.1l(l*r[2]),r[3]=ZC.1l(l*r[3])),7===r.1h&&(r[4]=ZC.1l(l*r[4]),r[5]=ZC.1l(l*r[5])))}1m r},jb:1f(e,t,i,n,a){1a l,o,r,C,A,s,Z;if(i.QQ&&(i.E["8u-dZ-2M"]=!0),!i.E["8u-dZ-2M"]){1k(l=0,o=e.1h;l<o;l++)e[l]&&(e[l][0]=5V(4P(e[l][0]).4v(2)),e[l][1]=5V(4P(e[l][1]).4v(2)));if(i.O1&&(Z=i.K+":"+i.AA+":"+e.2I("#"),ZC.4b.1T["2M-2S-"+Z]))1m ZC.4b.1T["2M-2S-"+Z].2l("#")}1a c=[ZC.3q,ZC.3q,-ZC.3q,-ZC.3q],u=[],p=!1;1k(l=0,o=e.1h;l<o;l++)if(1c!==ZC.1d(e[l])){if(i.E["8u-dZ-2M"]){if(r=e[l],"3I"===t){1a h=i.AA%2j==0?10:1;r[0]=ZC.1l(h*r[0]),r[1]=ZC.1l(h*r[1]),4===r.1h&&(r[2]=ZC.1l(h*r[2]),r[3]=ZC.1l(h*r[3]))}}1t r=ZC.P.n4(e[l],t,i,n,a);if(1c!==ZC.1d(r)&&!8a(r[0])&&!8a(r[1])&&eV(r[0])&&eV(r[1]))if(o<=20&&n&&(c[0]=ZC.CV(c[0],r[0]/("3I"===t?10:1)),c[1]=ZC.CV(c[1],r[1]/("3I"===t?10:1)),c[2]=ZC.BN(c[2],r[0]/("3I"===t?10:1)),c[3]=ZC.BN(c[3],r[1]/("3I"===t?10:1))),0===l)u.1i(("2B"===t?"M ":"m ")+r[0]+" "+r[1]);1t if(p&&(u.1i(("2B"===t?"M ":"m ")+r[0]+" "+r[1]),p=!1),2===r.1h)u.1i(("2B"===t?"L ":"l ")+r[0]+" "+r[1]);1t if(4===r.1h)u.1i(("2B"===t?"Q ":"qb ")+r[0]+" "+r[1]+" "+r[2]+" "+r[3]),"3I"===t&&u.1i("l "+r[2]+" "+r[3]);1t if(6===r.1h)if("2B"===t){1a 1b=0;r[3]%2j==r[4]%2j&&(1b=r[4]>=r[3]?.uH:-.uH),C=ZC.AN.BM(r[0],r[1],r[2],r[3]+1b),A=ZC.AN.BM(r[0],r[1],r[2],r[4]-1b),s="0 0",0===r[5]?r[4]-r[3]>2j?(s="0 1",A[0]=C[0],A[1]=C[1]):s=r[4]-r[3]<=180?"0 1":"1 1":r[3]-r[4]>2j?(s="0 0",A[0]=C[0],A[1]=C[1]):s=r[3]-r[4]<=180?"0 0":"1 0",u.1i("a "+r[2]+","+r[2]+" 0 "+s+" "+(A[0]-C[0])+","+(A[1]-C[1]))}1t"3I"===t&&(r[2]*=10,C=ZC.AN.BM(r[0],r[1],r[2],r[3]),A=ZC.AN.BM(r[0],r[1],r[2],r[4]),s=1===r[5]?"at":"wa",u.1i(s+" "+ZC.1l(r[0]-r[2])+","+ZC.1l(r[1]-r[2])+","+ZC.1l(r[0]+r[2])+","+ZC.1l(r[1]+r[2])+" "+ZC.1l(C[0])+","+ZC.1l(C[1])+" "+ZC.1l(A[0])+","+ZC.1l(A[1])));1t 7===r.1h&&u.1i(("2B"===t?"C ":"c ")+r[0]+" "+r[1]+" "+r[2]+" "+r[3]+" "+r[4]+" "+r[5])}1t p=!0;1m i.E["8u-dZ-2M"]||i.O1&&ZC.4b.2N("2M-2S-"+Z,u.2I("#")),i.H&&o<=20&&n&&(i.H.E[i.K+"-cJ"]=c),u},M8:1f(e,t){1a i,n,a=e.13u||e.vf;1m t=ZC.1l(t||"0"),a&&a.7z?a.7z.1h>0?(i=a.7z[t].b8,n=a.7z[t].bo):a.sT.1h>0&&(i=a.sT[t].b8,n=a.sT[t].bo):(i=e.b8,n=e.bo),[ZC.1l(i||"0"),ZC.1l(n||"0")]},F1:1f(e,t,i){i=i||2e;1a n;1m 1c!==ZC.1d(t)?i.v5?n=i.v5(t,e):(n=i.4N(e)).4l("dX",t):n=i.4N(e),"7q:"===e.2s(0,4)&&(n.7V="t2"),n},ES:1f(e){1a t;e 3z 3K||(e=[e]);1k(1a i=0,n=e.1h;i<n;i++)"4g"!=1w(t=e[i])&&(t=ZC.AK(e[i])),t&&(1w t.gq!==ZC.1b[31]?t.gq.aN(t):1w t.6s!==ZC.1b[31]&&t.6s.aN(t))},G2:1f(e,t){1k(1a i in t)if("2Y"==1w i&&"4g"!=1w t[i]&&"1f"!=1w t[i])4I{e.4l(i,t[i])}4G(n){}},PC:1f(e,t){1k(1a i in t)"2Y"==1w i&&"4g"!=1w t[i]&&"1f"!=1w t[i]&&(e.1H[i]=t[i])},o7:1f(e){1a t;if(e===2e)1m!0;if(!e)1m!1;if(!e.6s)1m!1;if(e.1H){if("1Z"===e.1H.3J)1m!1;if("9c"===e.1H.dW)1m!1}if(2u.gl){if("1Z"===(t=2u.gl(e,"")).3J)1m!1;if("9c"===t.dW)1m!1}if(t=e.ma){if("1Z"===t.3J)1m!1;if("9c"===t.dW)1m!1}1m ZC.P.o7(e.6s)},SW:1f(e){1a t=e.7V||ZC.A4(e).3Q("3g");1m 1c!==ZC.1d(t)&&"4g"==1w t&&(t=1w t.dD!==ZC.1b[31]?t.dD:""),t||""},IL:1f(e,t,i,n,a,l,o,r){if(e)1P(o=o||"",t){1j"3a":r?e.9j("2d").tz(i,n,a,l):e.1s=e.1s;1p;1j"3I":1j"2B":1a C=e.6W.1h;if(C>iv&&1w e.4n!==ZC.1b[31])1m 8j(e.4n="");if(C>0)1k(1a A=C-1;A>=0;A--)""===o?e.aN(e.6W[A]):0===e.6W[A].id.1K(o+"-")&&e.aN(e.6W[A])}},E6:1f(e,t){1P("2Y"==1w e&&(e=ZC.AK(e)),t){1j"3a":1m e.9j("2d");1j"2B":1j"3I":1m e}},JU:1f(e,t){1P(t){1j"2B":1m ZC.P.sO(e);1j"3I":1j"3a":1m ZC.P.HO(e)}},H6:1f(e,t){1P(t){1j"2B":1m ZC.P.sO(e);1j"3I":1m ZC.P.HO(e);1j"3a":1m ZC.P.uY(e)}},sO:1f(e){1a t;if(ZC.AK(e.id))1m ZC.AK(e.id);1a i=ZC.P.F1("g",ZC.1b[36]);1m 1c!==ZC.1d(t=e.id)&&i.4l("id",t),1c!==ZC.1d(t=e.2m)&&i.4l("3g",t),1c!==ZC.1d(t=e.8s)&&i.4l("z-2V",t),1c!==ZC.1d(t=e["3r-2M"])&&i.4l("3r-2M",t),e.9e?e.p.hL(i,e.9e.p8):e.p.2X(i),i},XA:1f(e){1a t;ZC.P.ES(e.id);1a i=ZC.P.F1("zI",ZC.1b[36]);1m i.id=e.id,1c!==ZC.1d(e.cx)?((t=ZC.P.F1("3x",ZC.1b[36])).id=e.id+"-2P",ZC.P.G2(t,{cx:e.cx,cy:e.cy,r:e.r})):((t=ZC.P.F1("13q",ZC.1b[36])).id=e.id+"-2P",ZC.P.G2(t,{2S:e.2M})),i.2X(t),i},uY:1f(e){1a t;if(ZC.AK(e.id))1m ZC.AK(e.id);1a i=2e.4N("3a"),n=i.1H;if(1c!==ZC.1d(t=e.id)&&(i.id=t),1c!==ZC.1d(t=e.2m)&&(i.7V=t),1c!==ZC.1d(t=e.wh)){1a a=(""+t).2l("/");e[ZC.1b[19]]=a[0],e[ZC.1b[20]]=a[1]}if(1c!==ZC.1d(t=e.tl)){1a l=(""+t).2l("/");e.1u=l[0],e.1J=l[1]}1m i.1s=e[ZC.1b[19]],i.1L=e[ZC.1b[20]],1c!==ZC.1d(t=e.1J)&&(n.1J=t+"px"),1c!==ZC.1d(t=e.1u)&&(n.1u=t+"px"),1c!==ZC.1d(t=e.3J)&&(n.3J=t),1c!==ZC.1d(t=e.2G)&&(n.2G=t),1c!==ZC.1d(t=e.8s)&&(n.9V=t),e.p.2X(i),i},HO:1f(e){1a t,i,n,a,l,o;if(ZC.AK(e.id))1m n=ZC.AK(e.id),1c!==ZC.1d(t=e.wh)&&(l=(""+t).2l("/"),n.1H.1s=l[0]+"px",n.1H.1L=l[1]+"px"),1c!==ZC.1d(t=e.tl)&&(o=(""+t).2l("/"),n.1H.1u=o[0]+"px",n.1H.1J=o[1]+"px"),n;(a=(n=2e.4N("3A")).1H).yK="lF",1c!==ZC.1d(t=e.wh)&&(l=(""+t).2l("/"),e[ZC.1b[19]]=l[0],e[ZC.1b[20]]=l[1]),1c!==ZC.1d(t=e.tl)&&(o=(""+t).2l("/"),e.1u=o[0],e.1J=o[1]),1c!==ZC.1d(t=e.id)&&(n.id=t),1c!==ZC.1d(t=e.2m)&&""!==t&&(n.7V=t);1k(1a r=[["1u","","px"],["1J","","px"],[ZC.1b[19],"","px"],[ZC.1b[20],"","px"],"2G","9R",["8Z","sK|sS"],["8s","9V"],"3r","3J",["6S","","px"],"6U","6R","cD","eb","cR","oX","1r","1F","uT","jH","om","jF","1R","4O",["2v","ko|nP|nL|jW","px"],["ko","","px"],["nP","","px"],["nL","","px"],["jW","","px"],["3u","cK|dv|dt|dj","px"],["cK","","px"],["dv","","px"],["dt","","px"],["dj","","px"],"c0","kO"],C=1c,A=1c,s=1c,Z=0,c=r.1h;Z<c;Z++)if("2Y"==1w r[Z]&&(r[Z]=[r[Z]]),t=1c,1c!==ZC.1d(i=e[r[Z][0]])&&(t=i),1c!==ZC.1d(t)){1c!==ZC.1d(r[Z][1])&&""!==r[Z][1]||(r[Z][1]=r[Z][0]);1k(1a u=r[Z][1].2l("|"),p=0,h=u.1h;p<h;p++){1a 1b=t+(1c===ZC.1d(r[Z][2])?"":r[Z][2]);a[u[p]]=1b,"6U"===u[p]&&(C=1b),"6S"===u[p]&&(A=ZC.1l(1b)),"6R"===u[p]&&(s=1b)}}1m 1c!==ZC.1d(t=e.3k)&&(a.3k=t,1!==ZC.1W(t)&&(a.kO="2k(3k = "+ZC.1l(100*ZC.1W(t))+")",a.3k=t)),1c!==ZC.1d(t=e.p)&&(e.9e?t.hL(n,e.9e.p8):t.2X(n)),1c!==ZC.1d(t=e.4a)&&(n.4n=ZC.n7(t),-1!==t.1K("<")&&-1!==t.1K(">")&&ZC.A4(n).9s().4Z(1f(){1c!==ZC.1d(C)&&(1c!==ZC.1d(1g.1H.6U)&&""!==1g.1H.6U||(1g.1H.6U=C)),1c!==ZC.1d(A)&&(1c!==ZC.1d(1g.1H.6S)&&""!==1g.1H.6S||(1g.1H.6S=A+"px")),1c!==ZC.1d(s)&&(1c!==ZC.1d(1g.1H.6R)&&""!==1g.1H.6R||(1g.1H.6R=s))})),e.aO&&(n.1H.13o="ey-7c",n.1H.bB="aO"),e.4O&&"ib"===e.4O&&(n.1H.4O="8v"),n},W1:1c,lC:1f(e,t,i,n,a,l,o){1a r,C,A,s;1c===ZC.1d(o)&&(o=!1);1a Z=!1;"[o6]"===t.2s(0,10)&&(Z=!0,t=t.2s(10)),s=e+"-1D-ka",-1!==e.1K("-5T")&&(s="zc-1D-ka");1a c="{{"+t+"}}"+i.1E(/[^a-z]/gi,"").aJ()+n+l+a;if(ZC.4b.1T["1D-1s-"+c]&&!o)1m ZC.4b.1T["1D-1s-"+c];if(ZC.4b.1T["1D-1L-"+c]&&o)1m ZC.4b.1T["1D-1L-"+c];1a u=t;u=u.1E(/<hr>/g,\'<hr 1H="2v:0;3u:0">\');1a p;1m(p=ZC.AK(s))?(ZC.P.W1&&ZC.P.W1===e+i+n+l+a||(p.1H.6U=i,p.1H.6S=n+"px",p.1H.6R=a,p.1H.c0=Z?"130%":-1!==l?ZC.1l(l)+"px":"130%",ZC.P.W1=e+i+n+l+a),p.4n=u):(p=ZC.P.HO({id:s,p:2e.3o,tl:"-6J/-6J",4a:u,2G:"4A",6U:i,6S:n,2m:"zc-1D-ka",6R:a})).1H.c0=Z?"130%":-1!==l?ZC.1l(l)+"px":"130%",-1===t.1K("<")||-1===t.1K(">")||Z||ZC.A4(p).9s().4Z(1f(){"BR"!==1g.8h.5D()&&(1c!==ZC.1d(1g.1H.6U)&&""!==1g.1H.6U||(1g.1H.6U=i),1c!==ZC.1d(1g.1H.6S)&&""!==1g.1H.6S||(1g.1H.6S=n+"px"),1g.1H.c0=-1!==l?ZC.1l(l)+"px":"130%","B"!==1g.8h.5D()&&"13d"!==1g.8h.5D()&&(1c!==ZC.1d(1g.1H.6R)&&""!==1g.1H.6R||(1g.1H.6R=a)))}),(r=p.i4())&&r.1s>0?(C=r.1s,o&&(A=r.1L)):(C=ZC.2H&&ZC.A4.6A.7A?p.sM:ZC.A4(p).1s(),o&&(A=ZC.2H&&ZC.A4.6A.7A?p.sL:ZC.A4(p).1L())),o?(ZC.4b.2N("1D-1L-"+c,A),A):(ZC.4b.2N("1D-1s-"+c,C),C)}},!2e.g0&&2e.uR&&(2e.g0=1f(e){1m 2e.uR("."+e)}),ZC.A4=1f(e,t,i){1a n,a,l,o,r=1g;if(1w i===ZC.1b[31]&&(i=!0),i)1m 1n ZC.A4(e,t,!1);if(r.OW=[],r.Q5=e,r.MC=t,r.1h=0,r.MC=r.MC||2e.e6("3o")[0],"4g"==1w r.Q5)r.OW=[r.Q5];1t if("2Y"==1w r.Q5)1k(1a C=r.Q5.2l(","),A=0;A<C.1h;A++){1a s=ZC.GO(C[A]),Z=!1;if(2===(n=s.2l(">")).1h&&(Z=!0,ZC.A4(n[0]).4Z(1f(){1a e=1g;ZC.A4(n[1],1g).4Z(1f(){1g.6s===e&&r.OW.1i(1g)})})),2===(n=s.2l(" ")).1h&&(Z=!0,ZC.A4(n[0]).4Z(1f(){ZC.A4(n[1],1g).4Z(1f(){r.OW.1i(1g)})})),!Z)if("#"===s.2s(0,1))ZC.AK(s.2s(1))&&(r.OW=[ZC.AK(s.2s(1))]);1t if("."===s.2s(0,1))if(2e.g0){if(r.MC.g0)a=r.MC.g0(s.2s(1));1t if(a=2e.g0(s.2s(1)),r.MC!==2e){1a c=[];1k(l=0,o=a.1h;l<o;l++)ZC.A4.vY(a[l],r.MC)&&c.1i(a[l]);a=c}1k(l=0,o=a.1h;l<o;l++)r.OW.1i(a[l])}1t{1a u=1n 5o("(^|\\\\s)"+s.2s(1)+"(\\\\s|$)","i"),p=r.MC.e6("*"),h="";1k(l=0,o=p.1h;l<o;l++)"4g"==1w(h=p[l].7V)&&(h=1w h.dD!==ZC.1b[31]?h.dD:""),""!==h&&u.5x(h)&&r.OW.1i(p[l])}1t 1k(l=0,o=(a=r.MC.e6(s)).1h;l<o;l++)r.OW.1i(a[l])}1m r.1h=r.OW.1h,1g},ZC.A4.5a={7s:1f(){1k(1a e,t=[],i=0,n=1g.OW.1h;i<n;i++){1a a=[1g.OW[i]];if((e=7Z.1h)>1)1k(1a l=1;l<e;l++)a.1i(7Z[l]);t.1i(7Z[0].8H(1g,a))}1m t},4Z:1f(){1k(1a e,t=0,i=1g.OW.1h;t<i;t++){1a n=[1g.OW[t]];if((e=7Z.1h)>1)1k(1a a=1;a<e;a++)n.1i(7Z[a]);7Z[0].8H(1g.OW[t],n)}1m 1g},9s:1f(){1a e=[];1m 1g.4Z(1f(){1k(1a t=0,i=1g.6W.1h;t<i;t++)1===1g.6W[t].fM&&e.1i(1g.6W[t])}),1g.OW=e,1g},3m:1f(){1g.7s.4s(1g,1f(e){e&&e.6s&&e.6s.aN(e)})},ly:1f(){1g.7s.4s(1g,1f(e){if(e)1k(;e.6W.1h;)e.aN(e.6W[e.6W.1h-1])})},mi:1f(e){1w e===ZC.1b[31]&&(e=!0);1a t,i,n=1g.7s.4s(1g,1f(n){if(!n)1m 1c;if(n===2u){1a a=2e.3o;1m n.uX?(t=n.uX,i=n.13m):a&&a.gq&&a.gq.m5?(t=a.gq.m5,i=a.gq.uW):a&&a.m5&&(t=a.m5,i=a.uW),{1s:t,1L:i}}1a l,o,r=e?"8K":ZC.A4(n).fE("3J");if(2u.gl){1a C=2u.gl(n,1c);l=C.t1(ZC.1b[19]).7y(0,-2),o=C.t1(ZC.1b[20]).7y(0,-2)}1t if(n.i4){1a A=n.i4();l=A.1s?A.1s:n.sM,o=A.1L?A.1L:n.sL}1t l=n.sM,o=n.sL;if("1Z"===r||""===r||1w r===ZC.1b[31]){1a s=n.1H,Z=s.dW,c=s.2G,u=s.3J;s.dW="9c",s.2G="4A",s.3J="8K",t=l,i=o,s.3J=u,s.2G=c,s.dW=Z}1t t=l||0,i=o||0;1m{1s:t,1L:i}});1m 1===n.1h?n[0]:n},fE:1f(e){1a t=1g.7s.4s(1g,1f(e,t){if("3J"===t)1m e.1H.3J;1a i,n=2e;if(t=ZC.EB(t),!e||e===n)1m mk;if("3k"===t&&1w e.13i!==ZC.1b[31]){1a a=(ZC.A4(e).fE("kO")||"").ln(/2k\\(3k=(.*)\\)/);1m a&&a[1]?5V(a[1])/100:1}if(-1!==ZC.AT(["8Z","sK","sS"],t))1m(i=e.1H["8Z"])?i:(i=e.1H.sK)?i:(i=e.1H.sS)?i:"1Z";1a l=e.1H?e.1H[t]:1c;if(!l)if(n.mh&&n.mh.gl){1a o=n.mh.gl(e,1c);t=t.1E(/([A-Z])/g,"-$1").aJ(),l=o?o.t1(t):1c}1t if(e.ma&&(l=e.ma[t],/^\\d/.5x(l)&&!/px$/.5x(l)&&"6R"!==t)){1a r=e.1H.1J,C=e.tp.1J;e.tp.1J=e.ma.1J,e.1H.1J=l||0,l=e.1H.143+"px",e.1H.1J=r,e.tp.1J=C}1m"3k"===t&&(l=5V(l)),/uk/.5x(9d.cS)&&-1!==ZC.AT(["1J","1u","2x","2a"],t)&&"8F"===ZC.A4(e).fE("2G")&&(l="3e"),"3e"===l?1c:l},e);1m 1===t.1h?t[0]:t},wh:1f(){1a e;1m 1g.OW[0]?1c!==ZC.1d(e=ZC.A4(1g.OW[0]).mi())?[ZC.1l(e[ZC.1b[19]]),ZC.1l(e[ZC.1b[20]])]:[0,0]:1c},1s:1f(e){1a t;if(1w e===ZC.1b[31]){1a i=1g.7s.4s(1g,1f(e){1m 1c!==ZC.1d(t=ZC.A4(e).mi())?ZC.1l(t[ZC.1b[19]]):0});1m 1===i.1h?i[0]:i}1m 1g.7s.4s(1g,1f(e,t){e.1H.1s=t+"px"},e),1g},1L:1f(e){1a t;if(1w e===ZC.1b[31]){1a i=1g.7s.4s(1g,1f(e){1m 1c!==ZC.1d(t=ZC.A4(e).mi())?ZC.1l(t[ZC.1b[20]]):0});1m 1===i.1h?i[0]:i}1m 1g.7s.4s(1g,1f(e,t){e.1H.1L=t+"px"},e),1g},aG:1f(){1m ZC.A4.1X().1J},aI:1f(){1m ZC.A4.1X().1u},2K:1f(e,t){if(1w t===ZC.1b[31]){1a i=1g.7s.4s(1g,1f(t){1a i=ZC.A4(t).fE(e);1m-1!==(""+i).1K("px")?ZC.1l(i):i});1m 1===i.1h?i[0]:i}1m 1g.7s.4s(1g,1f(e,t,i){e.1H[t]=i},e,t),1g},3Q:1f(e,t){if(1w t===ZC.1b[31]){1a i=1g.7s.4s(1g,1f(t){1m t.bT(e)});1m 1===i.1h?i[0]:i}1m 1g.7s.4s(1g,1f(e,t,i){e.4l(t,i)},e,t),1g},8z:1f(e){if(1w e===ZC.1b[31]){1a t=1g.7s.4s(1g,1f(e){1m e.1S});1m 1===t.1h?t[0]:t}1m 1g.7s.4s(1g,1f(e,t){e.1S=t},e),1g},4k:1f(){1m 1g.7s.4s(1g,1f(e){e.1H.3J="8K"}),1g},5c:1f(){1m 1g.7s.4s(1g,1f(e){e.1H.3J="1Z"}),1g},1Y:1f(){1a e=1g.7s.4s(1g,1f(e){if(!(e&&(e.x&&e.y||1c!==!e.6s&&"1Z"!==ZC.A4(e).fE("3J"))))1m mk;1a t,i,n,a,l,o,r,C={1u:0,1J:0},A={1u:0,1J:0},s=e&&e.w6;1m s&&((i=s.3o)===e&&(C={1u:i.13X,1J:i.13V}),t=s.eJ,1w e.i4!==ZC.1b[31]&&(A=e.i4()),n=s.mh||s.13S,a=t.m9||i.m9||0,l=t.mj||i.mj||0,o=n.vI||t.aI,r=n.vy||t.aG,C={1u:A.1u+o-a,1J:A.1J+r-l}),C});1m 1===e.1h?e[0]:e},3p:1f(e,t,i){if(""!==(e=ZC.A4.io(e))){if(i||(i=!ZC.tk||{tg:!0}),-1!==e.1K(" ")){1k(1a n=e.2l(/\\s+/),a=0;a<n.1h;a++)1g.3p(n[a],t,i);1m 1g}1m 1g.7s.4s(1g,1f(e,t,n){1f a(e){1a t=(e=e||2u.uv).2T||e.t4,i=ZC.A4.C1(e);1c!==i&&n.4s(t,i)}ZC.A4.IP||(ZC.A4.IP=[]),ZC.A4.IP.1i([e,t,n,a]),e.m7?e.m7(t,a,i):e.iW("on"+t,a)},e,t),1g}},3h:1f(e,t){if(""!==(e=ZC.A4.io(e))){if(-1!==e.1K(" ")){1k(1a i=e.2l(/\\s+/),n=0;n<i.1h;n++)1g.3h(i[n],t);1m 1g}1m 1g.7s.4s(1g,1f(e,t,i){if(1w ZC.A4.IP!==ZC.1b[31])1k(1a n=0,a=ZC.A4.IP.1h;n<a;n++)if((ZC.A4.IP[n][0]===e||e.8h&&"13N"===e.8h.5D()&&e.id===ZC.A4.IP[n][0].id)&&ZC.A4.IP[n][1]===t&&ZC.A4.IP[n][2]===i){e.uu?e.uu(t,ZC.A4.IP[n][3],!0):e.13L("on"+t,ZC.A4.IP[n][3]),ZC.A4.IP.6p(n,1);1p}},e,t),1g}},4c:1f(e,t,i){1f n(t){1a i=(t=t||2u.uv).2T||t.t4,n=i.7V||"";"4g"==1w n&&(n=1w n.dD!==ZC.1b[31]&&1c!==ZC.1d(n.dD)?n.dD:"");1a a,o,r=ZC.A4.9F[e],C=1c,A=1c,s=[];1k(a=0,o=r.1h;a<o;a++)("4g"==1w r[a][0]&&i===r[l][0]||"2Y"==1w r[a][0]&&("."===r[a][0].2s(0,1)&&-1!==ZC.AT(n.2l(" "),r[a][0].1E(".",""))||"#"===r[a][0].2s(0,1)&&i.id===r[a][0].2s(1)))&&(C=r[a][1],A=ZC.A4.C1(t),1c!==ZC.1d(C)&&1c!==ZC.1d(A)&&s.1i([C,i,A]));1k(a=0,o=s.1h;a<o;a++)s[a][0].4s(s[a][1],s[a][2])}if(""!==(e=ZC.A4.io(e))){if(i||(i=!ZC.tk||{tg:!0}),0===e.1K("e2")&&(i={tg:!1}),-1!==e.1K(" ")){1k(1a a=e.2l(/\\s+/),l=0;l<a.1h;l++)1g.4c(a[l],t,i);1m 1g}1a o=1g.Q5;1m ZC.A4.9F||(ZC.A4.9F={}),ZC.A4.9F[e]||(ZC.A4.9F[e]=[],2e.m7?2e.m7(e,n,i):2e.iW("on"+e,n)),ZC.A4.9F[e].1i([o,t]),1g}},4f:1f(e,t){if(""!==(e=ZC.A4.io(e))){1a i,n,a;if(-1!==e.1K(" ")){1k(n=0,a=(i=e.2l(/\\s+/)).1h;n<a;n++)1g.4f(i[n],t);1m 1g}1a l=1g.Q5;if(ZC.A4.9F||(ZC.A4.9F={}),i=ZC.A4.9F[e])1k(n=i.1h-1;n>=0;n--)i[n][0]!==l||t&&i[n][1]!==t||ZC.A4.9F[e].6p(n,1);1m 1g}}},ZC.A4.13H=1f(e){1k(1a t=[],i=0;i<ZC.A4.9F[e].1h;i++)t.1i(ZC.A4.9F[e][i][0]);1m t.2I(",")},ZC.A4.io=1f(e){1m ZC.cF&&(e=ZC.GO(e.1E(/4D|5P|6k/,""))),e},ZC.A4.4b={},ZC.A4.6A={},1f(){1a e=/(7A)[ \\/]([\\w.]+)/,t=/(l8)(?:.*af)?[ \\/]([\\w.]+)/,i=/(a6) ([\\w.]+)/,n=/(Bo)(?:.*? rv:([\\w.]+))?/,a=/(uV)(?:.*? rv:([\\w.]+))?/,l=1f(l){l=l.aJ();1a o=e.3j(l)||t.3j(l)||i.3j(l)||a.3j(l)||l.1K("13c")<0&&n.3j(l)||[];1m[o[1]||"",o[2]||"0"]}(9d.cS);l[0]&&("uV"===l[0]&&(l[0]="a6"),ZC.A4.6A[l[0]]=!0,ZC.A4.6A.af=l[1])}(),ZC.A4.1X=1f(){1a e={1u:0,1J:0},t=2e,i=t.eJ,n=t.3o;1m i&&(i.aI||i.aG)?(e.1J=i.aG,e.1u=i.aI):n&&(e.1J=n.aG,e.1u=n.aI),e},ZC.A4.C1=1f(e){if(e.vf=e,e.2T||(e.2T=e.t4||2e),3!==e.2T.fM&&8!==e.2T.fM||(e.2T=e.2T.6s),1c===ZC.1d(e.b8)&&1c!==ZC.1d(e.cv)){1a t=e.2T.w6||2e,i=t.eJ,n=t.3o;e.b8=e.cv+(i&&i.aG||n&&n.aG||0)-(i&&i.mj||n&&n.mj||0),e.bo=e.dR+(i&&i.aI||n&&n.aI||0)-(i&&i.m9||n&&n.m9||0)}1m e.8T||e.76===mk||(e.8T=1&e.76?1:2&e.76?3:4&e.76?2:0),e.6L||(e.6L=1f(){1g.Xn=!1}),e.w1||(e.w1=1f(){1g.Xl=!0}),e},ZC.A4.vY=1f(e,t){if(e===t)1m!0;1k(;e!==t&&e.6s;)if((e=e.6s)===t)1m!0;1m!1},ZC.A4.av=1f(e){1a t=e.3P||"",i=e.1I||"bp",n=e.1T||"",a=!0;1w e.aw!==ZC.1b[31]&&(a=ZC.2q(e.aw)),""===n.1E(/\\&/g,"")&&(n="");1a l=e.dh||1c,o=e.4L||1c,r=e.aD||1c,C=1c;4I{2u.mx?C=1n mx("Xd.Ws"):2u.hk&&(C=1n hk)}4G(s){}1a A="qn:"===2u.7W.iS;if(C){a&&(C.fv=1f(){4===C.f4&&((A||C.6Q>=p4&&C.6Q<eF)&&r&&r(C.wo,C.6Q,C,t),C.6Q>=t6&&o&&o(C,C.6Q,C.s4,t),C.fv=1n 2u.c1,C=1c)}),2u.mx||(C.li=1f(){o&&o(C,0,"",t)}),"wt"===i.5D()?(C.bu("wt",t,a),C.d0("X-Wz-Wv","hk"),C.d0("Xr-1I","fY/x-8B-4E-Xf")):(""!==n&&(-1===t.1K("?")&&(t+="?"),t+="&"+n),C.bu("bp",t,a)),l&&l(C);4I{C.8r(n),a||((A||C.6Q>=p4&&C.6Q<eF)&&r&&r(C.wo,C.6Q,C,t),C.6Q>=t6&&o&&o(C,C.6Q,C.s4,t),C=1c)}4G(Z){A&&o&&(o(C,C.6Q,C.s4,t),C.fv=1n 2u.c1,C=1c)}}},ZC.AN={Dy:1f(e,t){1f i(e,t){-1===ZC.AT(e,t)&&e.1i(t)}1a n,a,l=1o.3G.v9,o=[],r=0;1k(n=0;n<e.1h;n++)e[n]+=t;1a C=-1;1k(n=1;n<e.1h;n++)ZC.2i(e[n]-e[n-1])<l?(o[r]=o[r]||{2h:-1,1V:-1,2z:[]},-1===o[r].2h&&(o[r].2h=n>1?e[n-2]:t,-1===C&&(C=o[r].2h),o[r].2h),i(o[r].2z,n-1),i(o[r].2z,n)):o[r]&&(o[r].1V=e[n],o[r].1V,r++);o[r]&&-1===o[r].1V&&(o[r].1V=2j+t);1a A=o.1h;if(A>1&&o[A-1].1V-o[0].2h==2j){1k(a=0;a<o[0].2z.1h;a++)e[o[0].2z[a]]+=2j;o[A-1].2z=o[A-1].2z.4w(o[0].2z),o[A-1].1V+=o[0].2h,o=o.6p(1)}1k(o.1h>1&&(o[o.1h-1].1V=o[0].2h+2j),n=0;n<o.1h;n++){1a s=o[n],Z=s.2z.1h,c=(s.1V-s.2h)/(Z+4);c=ZC.CV(c,l);1a u=0;1k(a=0;a<s.2z.1h;a++)u+=e[s.2z[a]];u/=s.2z.1h;1k(1a p=!0;p;)1k(p=!1,a=1;a<s.2z.1h;a++)if(e[s.2z[a]]-e[s.2z[a-1]]<c){e[s.2z[a-1]]<u?(e[s.2z[a-1]]-=.45,e[s.2z[a]]+=.hE):e[s.2z[a]]+=.25,p=!0;1p}}1m e},dE:1f(e){1m 1A.3i(e-ZC.1l(e))<1A.5k(10,-10)},XG:1f(e,t,i){1m i=i||1,!(e.x>t.x+t.1s+i)&&(!(t.x>e.x+e.1s+i)&&(!(e.y>t.y+t.1L+i)&&!(t.y>e.y+e.1L+i)))},bS:1f(e,t,i){1m i=i||1,!(e.iX>t.iX+t.I+i)&&(!(t.iX>e.iX+e.I+i)&&(!(e.iY>t.iY+t.F+i)&&!(t.iY>e.iY+e.F+i)))},Yn:1f(e,t){1m e.iX>=t.iX&&e.iX<=t.iX+t.I&&e.iY>=t.iY&&e.iY<=t.iY+t.F&&e.iX+e.I>=t.iX&&e.iX+e.I<=t.iX+t.I&&e.iY+e.F>=t.iY&&e.iY+e.F<=t.iY+t.F},jP:1f(e,t,i){1k(1a n=1A.5B(e/1A.PI),a=1A.5B(t/1A.PI),l=1A.2h(n,a),o=1A.1V(n,a),r=ZC.3q,C=0,A=l+o;A>o-l;A-=l/50){1a s=l*l*1A.jO((A*A+l*l-o*o)/(2*A*l))+o*o*1A.jO((A*A+o*o-l*l)/(2*A*o))-.5*1A.5B((-A+l+o)*(A+l-o)*(A-l+o)*(A+l+o));1A.3i(s-i)<r&&(r=1A.3i(s-i),C=A)}1m C},BM:1f(e,t,i,n){1m[e+i*1A.db(2*n*1A.PI/2j),t+i*1A.dL(2*n*1A.PI/2j)]},iI:1f(e,t,i,n,a){1a l=ZC.TF(1A.aA((n-t)/(i-e)));1m[e+ZC.1l(ZC.ED(l)*a),t+ZC.1l(ZC.EL(l)*a)]},JK:1f(e,t,i,n,a,l){if(a=1c===ZC.1d(a)?0:a,l=1c===ZC.1d(l)||l,i-e!=0){1a o=0,r=0,C=1A.aA((n-t)/(i-e));1m(a<1||l)&&(o=a/2.5*1A.db(C),r=a/2.5*1A.dL(C)),[(e+i)/2+(e<i?o:-o),(t+n)/2+r]}1m[e,(t+n)/2]},s3:1f(e,t){1a i=(e[1]-t[1])/(e[0]-t[0]);1m[i,e[1]-i*e[0]]},hO:1f(e,t,i,n){if(t[0]===n[0]&&t[1]===n[1])1m t;if(e[0]===i[0]&&e[1]===i[1])1m e;1a a=ZC.AN.s3(e,t),l=a[0],o=a[1],r=ZC.AN.s3(i,n),C=r[0],A=(r[1]-o)/(l-C);1m[A,l*A+o]},PO:1f(e,t,i){1c===ZC.1d(t)&&(t=5);1a n=0,a=0;1c!==ZC.1d(i)&&(n=i[0],a=i[1]);1k(1a l,o,r,C="",A=ZC.6O?ZC.3y:0,s=0,Z=e.1h;s<Z;s++)e[s]&&(0===s?(o=e[s][0]+A+n,r=e[s][1]+A+a,l=s,C+=1A.43(o,10)+","+1A.43(r,10)+","):1A.5B((e[s][0]+A-o)*(e[s][0]+A-o)+(e[s][1]+A-r)*(e[s][1]+A-r))>t&&e[s-1]&&(1A.5B((e[s][0]-e[s-1][0])*(e[s][0]-e[s-1][0])+(e[s][1]-e[s-1][1])*(e[s][1]-e[s-1][1]))>t&&s-l>1&&(C+=1A.43(e[s-1][0]+A+n,10)+","+1A.43(e[s-1][1]+A+a,10)+","),o=e[s][0]+A+n,r=e[s][1]+A+a,l=s,C+=1A.43(o,10)+","+1A.43(r,10)+","));1m C=C.2s(0,C.1h-1)},YU:1f(e,t){if(1c===ZC.1d(e)||e.1h<2)1m"";1c===ZC.1d(t)&&(t=6,ZC.2H&&(t+=10));1a i,n,a,l,o,r=[];1k(i=0,n=e.1h;i<n;i++)(0===i||i>0&&1c!==ZC.1d(e[i])&&1c!==ZC.1d(e[i-1])&&e[i].2I("/")!==e[i-1].2I("/")||1c===ZC.1d(e[i]))&&r.1i(e[i]);1a C=[],A=[],s=!1;1k(i=0,n=r.1h;i<n;i++)if(r[i]){1a Z,c,u,p,h=r[i][0],1b=r[i][1];if(r[i-1]&&(u=r[i-1][0],p=r[i-1][1],u===h&&(u-=.1)),r[i+1]&&(Z=r[i+1][0],c=r[i+1][1],Z===h&&(Z+=.1)),0===i)a=1A.aA((c-1b)/(Z-h)),o=l=ZC.TF(a),Z>=h&&(o+=180),C.1i(ZC.AN.BM(h,1b,t,l+90),ZC.AN.BM(h,1b,t,o),ZC.AN.BM(h,1b,t,l+3T));1t if(i===r.1h-1)a=1A.aA((p-1b)/(u-h)),o=l=ZC.TF(a),u>=h&&(o+=180),s?(A.1i(ZC.AN.BM(h,1b,t,l+3T),ZC.AN.BM(h,1b,t,o),ZC.AN.BM(h,1b,t,l+90)),s=!1):C.1i(ZC.AN.BM(h,1b,t,l+3T),ZC.AN.BM(h,1b,t,o),ZC.AN.BM(h,1b,t,l+90));1t{1a d=1A.aA((c-1b)/(Z-h)),f=1A.aA((1b-p)/(h-u));o=ZC.TF((d+f)/2),C.1i(ZC.AN.BM(h,1b,t,o+3T)),Z>=h&&u>=h?(C.1i(ZC.AN.BM(h,1b,t,o+180)),C.1i(ZC.AN.BM(h,1b,t,o+90)),A.1i(ZC.AN.BM(h,1b,t,o)),s=!0):Z<=h&&u<=h?(C.1i(ZC.AN.BM(h,1b,t,o)),C.1i(ZC.AN.BM(h,1b,t,o+90)),A.1i(ZC.AN.BM(h,1b,t,o+180)),s=!0):A.1i(ZC.AN.BM(h,1b,t,o+90))}}1k(i=A.1h-1;i>=0;i--)C.1i(A[i]);1m C},g5:1f(e,t){1a i=0,n=0,a=[];1P(e+=""){1j"cd":1j"h":i=1,n=t;1p;1j"9r":1j"v":i=t,n=1;1p;2n:a=e.2l("x"),1c!==ZC.1d(a[0])&&ZC.1l(a[0])+""===a[0]&&(i=ZC.1l(a[0])),1c!==ZC.1d(a[1])&&ZC.1l(a[1])+""===a[1]&&(n=ZC.1l(a[1])),0===n&&0===i?(i=1A.4h(1A.5B(t)),n=1A.4h(t/i)):(0===n&&(n=1A.4h(t/i)),0===i&&(i=1A.4h(t/n)))}1m[i,n]},wg:1f(e,t){1m.5*(2*t[1]+(-t[0]+t[2])*e+(2*t[0]-5*t[1]+4*t[2]-t[3])*e*e+(-t[0]+3*t[1]-3*t[2]+t[3])*e*e*e)},wi:1f(e,t){1a i,n,a,l,o,r=e.1h,C=[],A=[],s=[];1k(i=0;i<r-1;i++)n=e[i+1]-e[i],a=t[i+1]-t[i],A.1i(n),C.1i(a),s.1i(a/n);1a Z=[s[0]];1k(i=0;i<A.1h-1;i++){l=s[i];1a c=s[i+1];if(l*c<=0)Z.1i(0);1t{n=A[i];1a u=A[i+1];o=n+u,Z.1i(3*o/((o+u)/l+(o+n)/c))}}Z.1i(s[s.1h-1]);1a p=[],h=[];1k(i=0;i<Z.1h-1;i++){l=s[i];1a 1b=Z[i],d=1/A[i];o=1b+Z[i+1]-l-l,p.1i((l-1b-o)*d),h.1i(o*d*d)}1m 1f(i){1a n=e.1h-1;if(i===e[n])1m t[n];1k(1a a,l=0,o=h.1h-1;l<=o;){a=1A.4i(.5*(l+o));1a r=e[a];if(r<i)l=a+1;1t{if(!(r>i))1m t[a];o=a-1}}n=1A.1V(0,o);1a C=i-e[n],A=C*C;1m t[n]+Z[n]*C+p[n]*A+h[n]*C*A}},XZ:1f(e,t,i,n){1c===ZC.1d(n)&&(n=1/(i/t.1h*4));1a a,l,o=[];if(e)if((a=[].4w(t))[1]&&a[2]){a[0]=a[0]||a[1]||a[2]||a[3],a[1]=a[1]||a[2]||a[0]||a[3],a[2]=a[2]||a[3]||a[1]||a[0],a[3]=a[3]||a[2]||a[1]||a[0];1a r=ZC.AN.wi([0,1,2,3],a);1k(l=1;l<=2;l+=n)o.1i([l-1,r(l)])}1t o.1i([]);1t 1k(1a C=1;C<t.1h-2;C++)if(1!==n)if((a=[t[C-1],t[C],t[C+1],t[C+2]])[1]&&a[2])1k(a[0]=a[0]||a[1]||a[2]||a[3],a[1]=a[1]||a[2]||a[0]||a[3],a[2]=a[2]||a[3]||a[1]||a[0],a[3]=a[3]||a[2]||a[1]||a[0],l=0;l<=1;l+=n){1a A=C+l,s=ZC.AN.wg(l,a);o.1i([A-1,s])}1t o.1i([]);1t o.1i([C-1,t[C]]);1m o},gz:1f(e){1k(1a t=1A.43(ZC.HH(ZC.2i(e))/1A.bm),i=[1,2,4,5,6,8,10],n=ZC.3q,a=1,l=0;l<i.1h;l++){1a o=i[l]*1A.5k(10,t)-e;ZC.2i(o)<n&&(a=i[l],n=ZC.2i(o))}1m a*1A.5k(10,t)},rY:1f(e,t){1a i,n;1m i=1A.4i(1A.2W(e)/1A.2W(10)),n=e/1A.5k(10,i),(t?n<1.5?1:n<3?2:n<7?5:10:n<=1?1:n<=2?2:n<=5?5:10)*1A.5k(10,i)},W5:1f(e,t,i,n,a,l){1c===ZC.1d(a)&&(a=!0),l=1c===ZC.1d(l)?10:1A.2h(1A.1V(2,l),100),1c!==ZC.1d(n)&&0!==n||(n=1);1a o,r,C,A,s,Z,c=1A.4i(ZC.HH(ZC.2i(t))/1A.bm);e===t&&(t+=1A.5k(10,c)),o=e,r=t,A=ZC.AN.rY(r-o,!1),1c===ZC.1d(i)?(C=A/(l-1),C=ZC.AN.rY(C,!0),C*=n):C=i,a?(s=1A.4i(o/C)*C,Z=1A.4h(r/C)*C):(s=o,Z=r,C=1c===ZC.1d(i)?A/(l-1):i);1a u=1A.4i(ZC.HH(ZC.2i(C))/1A.bm),p=u<0?ZC.2i(u):0;if(0===p){1a h=(""+C).2l(".");2===h.1h&&(p=h[1].1h)}1m[s,Z,C,p,C]}},ZC.XN={eE:1f(e){1m ZC.XN.vQ(ZC.XN.wd(ZC.XN.vP(e)))},wd:1f(e){1m ZC.XN.vs(ZC.XN.vu(ZC.XN.vq(e),8*e.1h))},vQ:1f(e){1k(1a t,i="",n=0,a=e.1h;n<a;n++)t=e.eM(n),i+="vz".fq(t>>>4&15)+"vz".fq(15&t);1m i},vP:1f(e){1k(1a t,i,n="",a=-1,l=e.1h;++a<l;)t=e.eM(a),i=a+1<l?e.eM(a+1):0,Yc<=t&&t<=XM&&XL<=i&&i<=XJ&&(t=Xy+((vo&t)<<10)+(vo&i),a++),t<=127?n+=5X.eh(t):t<=Xt?n+=5X.eh(192|t>>>6&31,128|63&t):t<=lq?n+=5X.eh(Wq|t>>>12&15,128|t>>>6&63,128|63&t):t<=Wp&&(n+=5X.eh(Vp|t>>>18&7,128|t>>>12&63,128|t>>>6&63,128|63&t));1m n},vq:1f(e){1a t,i=3K(e.1h>>2);1k(t=0;t<i.1h;t++)i[t]=0;1k(t=0;t<8*e.1h;t+=8)i[t>>5]|=(3R&e.eM(t/8))<<t%32;1m i},vs:1f(e){1k(1a t="",i=0;i<32*e.1h;i+=8)t+=5X.eh(e[i>>5]>>>i%32&3R);1m t},vu:1f(e,t){1f i(e,t,i,n,a,l){1m r(C(r(r(t,e),r(n,l)),a),i)}1f n(e,t,n,a,l,o,r){1m i(t&n|~t&a,e,t,l,o,r)}1f a(e,t,n,a,l,o,r){1m i(t&a|n&~a,e,t,l,o,r)}1f l(e,t,n,a,l,o,r){1m i(t^n^a,e,t,l,o,r)}1f o(e,t,n,a,l,o,r){1m i(n^(t|~a),e,t,l,o,r)}1f r(e,t){1a i=(lq&e)+(lq&t);1m(e>>16)+(t>>16)+(i>>16)<<16|lq&i}1f C(e,t){1m e<<t|e>>>32-t}e[t>>5]|=128<<t%32,e[14+(t+64>>>9<<4)]=t;1k(1a A=Vl,s=-Vj,Z=-Vi,c=Vh,u=0,p=e.1h;u<p;u+=16){1a h=A,1b=s,d=Z,f=c;s=o(s=o(s=o(s=o(s=l(s=l(s=l(s=l(s=a(s=a(s=a(s=a(s=n(s=n(s=n(s=n(s,Z=n(Z,c=n(c,A=n(A,s,Z,c,e[u],7,-Ut),s,Z,e[u+1],12,-UO),A,s,e[u+2],17,Uy),c,A,e[u+3],22,-Ux),Z=n(Z,c=n(c,A=n(A,s,Z,c,e[u+4],7,-Uw),s,Z,e[u+5],12,Uv),A,s,e[u+6],17,-Uu),c,A,e[u+7],22,-Vq),Z=n(Z,c=n(c,A=n(A,s,Z,c,e[u+8],7,Vd),s,Z,e[u+9],12,-Wo),A,s,e[u+10],17,-Wm),c,A,e[u+11],22,-Wl),Z=n(Z,c=n(c,A=n(A,s,Z,c,e[u+12],7,Wk),s,Z,e[u+13],12,-Wj),A,s,e[u+14],17,-Wh),c,A,e[u+15],22,Wd),Z=a(Z,c=a(c,A=a(A,s,Z,c,e[u+1],5,-Vz),s,Z,e[u+6],9,-Vy),A,s,e[u+11],14,Vx),c,A,e[u],20,-Vu),Z=a(Z,c=a(c,A=a(A,s,Z,c,e[u+5],5,-Yr),s,Z,e[u+10],9,10H),A,s,e[u+15],14,-10E),c,A,e[u+4],20,-10C),Z=a(Z,c=a(c,A=a(A,s,Z,c,e[u+9],5,10y),s,Z,e[u+14],9,-10n),A,s,e[u+3],14,-10t),c,A,e[u+8],20,10q),Z=a(Z,c=a(c,A=a(A,s,Z,c,e[u+13],5,-10p),s,Z,e[u+2],9,-10o),A,s,e[u+7],14,10z),c,A,e[u+12],20,-10M),Z=l(Z,c=l(c,A=l(A,s,Z,c,e[u+5],4,-112),s,Z,e[u+8],11,-11f),A,s,e[u+11],16,11e),c,A,e[u+14],23,-113),Z=l(Z,c=l(c,A=l(A,s,Z,c,e[u+1],4,-110),s,Z,e[u+4],11,10O),A,s,e[u+7],16,-10Z),c,A,e[u+10],23,-10X),Z=l(Z,c=l(c,A=l(A,s,Z,c,e[u+13],4,10W),s,Z,e[u],11,-10V),A,s,e[u+3],16,-10U),c,A,e[u+6],23,10T),Z=l(Z,c=l(c,A=l(A,s,Z,c,e[u+9],4,-10S),s,Z,e[u+12],11,-10R),A,s,e[u+15],16,10Q),c,A,e[u+2],23,-10l),Z=o(Z,c=o(c,A=o(A,s,Z,c,e[u],6,-Zx),s,Z,e[u+7],10,10k),A,s,e[u+14],15,-Zu),c,A,e[u+5],21,-Zq),Z=o(Z,c=o(c,A=o(A,s,Z,c,e[u+12],6,Zo),s,Z,e[u+3],10,-Zn),A,s,e[u+10],15,-Zk),c,A,e[u+1],21,-Zf),Z=o(Z,c=o(c,A=o(A,s,Z,c,e[u+8],6,Zd),s,Z,e[u+15],10,-Za),A,s,e[u+6],15,-Yz),c,A,e[u+13],21,Yw),Z=o(Z,c=o(c,A=o(A,s,Z,c,e[u+4],6,-Zw),s,Z,e[u+11],10,-10j),A,s,e[u+2],15,10i),c,A,e[u+9],21,-10h),A=r(A,h),s=r(s,1b),Z=r(Z,d),c=r(c,f)}1m 3K(A,s,Z,c)}},1w 1o===ZC.1b[31]&&(1o={10f:!0}),1o.10d={},1o.gd={},1o.10b={},1o.5Y={},1o.5Y.2b=0,1o.5Y.1T={},1o.5Y.ai=1f(e,t,i,n){1a a;if(1c!==ZC.1d(1o.5Y.1T[i]))(a=1o.5Y.1T[i]).pY=!0,ZC.v4=!0,n||(a.$i(t),a.K=i),ZC.v4=!1;1t{1P(e){1j"DQ":a=1n ZC.DQ(t);1p;1j"HQ":a=1n ZC.HQ(t);1p;1j"DS":a=1n ZC.DS(t);1p;1j"QL":a=1n ZC.QL(t);1p;1j"CZ":a=1n ZC.CZ(t)}a.K=i,1o.5Y.2b++,1o.5Y.2b>1o.3G.uZ?(1o.5Y.1T={},1o.5Y.2b=0):1o.5Y.1T[i]=a}1m a},1o.fI={},1o.v8={},1o.cQ=2,1o.Cb=!1,1o.oJ=1,1o.zW={1y:"xy",8Y:"3d,1y",1M:"xy",81:"3d,1M",bF:"yx",bE:"yx",5A:"xy",6M:"3d,5A",6d:"yx",7v:"3d,6d",6t:"xy",5h:"xy",8t:"yx",6z:"yx",3L:"r",7k:"3d,3L",96:"r",8M:"r",8q:"5A",80:"6d",ao:"xy",ap:"yx",5O:"xy",74:"r",5y:"xy",rc:"yx",8f:"xy,5A",aV:"r"},1o.4C={9Z:!1,aS:!1,e8:!1,8l:!1,lT:!1},1o.z2=1f(e){1k(1a t=0;t<e.1h;t++)if(e[t].4T&&e[t].4T.1K("1o.2h.js")>-1)1m e[t].4T.2l("1o.2h.js")[0]+"gH/";1m"./gH/"}(2e.e6("gf")[0].6W),1o.3G={kw:1,Db:1,kk:1,rM:1,qq:1,tN:0,v9:10,us:0,Du:0,p6:-1,sU:0,GC:1,g3:0,pa:0,jL:0,pL:1,bA:0,l1:0,A3:mN,tF:mN,ha:1,y9:0,xX:0,qD:1,og:0,va:0,n9:0,uZ:iv},1o.hz=0,1o.rA=1,1o.tP=6J,1o.xS=Zy,1o.e4=1c,1o.hw=0,1o.ui=0,1o.tQ=0,1o.r0=0,1o.s8={},1o.ed="5e",1o.pr="9q",1o.kG=1c,1o.pW=("qn:"===2e.7W.iS?"7g:":2e.7W.iS)+"//8w.1o.bv/",1o.iE=!1,1o.lH="5e",1o.eL={1L:106,1s:102},1o.uM=0,1o.iU=11,1o.9W="mY tW 101,mY ZR,mY tW,uC,uF,qr-qv",ZC.2H&&(1o.9W="mY tW,uC,uF,qr-qv"),1o.qf=1f(e,t){1k(1a i=(""+e).2l(","),n=0,a=i.1h;n<a;n++){1a l=ZC.GO(i[n]);l=ZC.uL[l]||l,-1!==ZC.AT(["2Q","ej","rC","eZ"],l)&&(l="v"+l);1a o=1o.zW[l];1c!==ZC.1d(o)&&1o.qf(o),-1===ZC.AT(ZC.RF,l)&&ZC.RF.1i(l)}t&&1o.iz(1c,ZC.RF,t)},1o.iz=1f(e,t,i){1f n(){1f l(){++a===t.1h?i():n()}1a o,r=!0;1o.Cz(t[a])?o=1o.z2+"1o-"+t[a]+".2h.js":r=!1,r?ZC.AO.zY(e,o,l):l()}1a a=0;if(0===t.1h)i();1t{if(!2e.e6("gf")[0])1m 8j i();n()}},1o.Cz=1f(e){1m-1!==ZC.AT(ZC.RF,e)&&-1===ZC.AT(ZC.WF,e)},1o.LD=[],ZC.6O||1f(){1k(1a e in ZC.bG)ZC.bG.8d(e)&&(1o.LD[e]=1n cV,1o.LD[e].4T=ZC.bG[e])}(),1w Zz!==ZC.1b[31]&&(1o.LD["zc.Gu"]=1n cV,1o.LD["zc.Gu"].4T=ZC.kN),1o.3j=1f(e,t,i){1m 1o.k6?1o.k6(e,t,i):1c},1o.Gr=1f(O){1a QN=O.gF||"",F6="",G,M4=1c;1c!==ZC.1d(G=O.1T)&&("2Y"==1w G?F6=G:M4=3c.1q(3c.5d(G)));1a DH=1c;if(""!==QN)ZC.A4.av({1I:"bp",3P:QN,aw:!1,1T:1o.hw?"ja=ZI":"",4L:1f(){1m!1},aD:1f(K7){1f 1W(e){ZC.4b.1T["1T-"+QN]=K7,O.bJ="3e",ZC.2A(e.b3,O)}4I{DH=3c.1q(K7),1W(DH)}4G(J5){4I{DH=7t("("+K7+")"),1W(DH)}4G(J5){1m!1}}}});1t{if(""!==F6)4I{DH=3c.1q(F6)}4G(J5){1m!1}1t 1c!==M4&&(DH=M4);1c===ZC.1d(O.bJ)&&(O.bJ="3e"),ZC.2A(DH.b3,O)}1m 1o.b3(O)},1o.ZO=1c,1o.aY={},1o.b3=1f(e,t){if(1c===ZC.1d(t)&&(t=!1),t)1m 1o.Gr(e);1c===ZC.1d(ZC.3a)&&ZC.Gp();1a i=e.bJ||"3e";"ig"===i&&(i="3e"),ZC.2H&&"3e"===i&&(i="2B");1a n=!1;if("!"===i.2s(0,1)&&(n=!0,i=i.2s(1)),n||("3e"===i||"3a"===i&&!ZC.3a||"2B"===i&&!ZC.2B||"3I"===i&&!ZC.3I||"b2"===i&&!ZC.b2)&&(ZC.2B?i="2B":ZC.3a?i="3a":ZC.3I?i="3I":ZC.b2&&(i="b2")),"3I"===i&&1c===ZC.1d(1o.ZO)&&(1o.ZO=!1),"b2"!==i)1m 1o.tV(e,i);1o.10g(e)},2e.iW&&("aE"===2e.f4?1o.ZO=!0:2e.iW("fv",1f(){"aE"===2e.f4&&(1o.ZO=!0)})),1o.Yy=1o.Yu=1f(e,t){ZC.HA[e]=t},1o.HP=[],1o.XQ={},1o.Zh=0,1o.Zj=0,1o.Zm=!1,1o.t5=!1,1o.u5=!1,1o.Zp=!1,1o.2K=1c,1o.WP=1f(e){if(e.2T.id){1k(1a t=1c,i=0,n=1o.HP.1h;i<n;i++)e.2T.id.5v(0,1o.HP[i].K.1h+1)===1o.HP[i].K+"-"&&(t=1o.HP[i]);1m t}},ZC.5g={id:1c,on:!1,ts:1c,1I:1c,eX:-1,mp:[-1,-1]},1w 1o.MD===ZC.1b[31]&&(1o.MD=1f(e){1a t;if("mV"===1o.lH)1P(ZC.bO=!1,e.1I){1j"4D":1k(1a i=!1,n=0;n<1o.HP.1h;n++)t=ZC.A4("#"+1o.HP[n].K+"-1u"),ZC.DU(e.7z[0].b8,t.1Y().1J,t.1Y().1J+t.1s())&&ZC.DU(e.7z[0].bo,t.1Y().1u,t.1Y().1u+t.1L())&&(i=!0,ZC.5g.id=1o.HP[n].K);i&&(ZC.5g.on=!0);1p;1j"6k":if(ZC.5g.on&&2===e.7z.1h){e.6L();1a a=(e.7z[0].cv-e.7z[1].cv)*(e.7z[0].cv-e.7z[1].cv)+(e.7z[0].dR-e.7z[1].dR)*(e.7z[0].dR-e.7z[1].dR);a=1A.43(1A.5B(a));1a l=[1A.43((e.7z[0].cv+e.7z[1].cv)/2),1A.43((e.7z[0].dR+e.7z[1].dR)/2)];if(-1===ZC.5g.eX)ZC.5g.eX=a,ZC.5g.mp=l,ZC.5g.ts=(1n 9H).bi();1t if((1n 9H).bi()-ZC.5g.ts>100){if(a>ZC.5g.eX+50)ZC.5g.1I="mV-in",1o.3j(ZC.5g.id,"g4");1t if(a<ZC.5g.eX-50)ZC.5g.1I="mV-4R",1o.3j(ZC.5g.id,"g2");1t{ZC.5g.1I="Zr";1a o={};l[0]>ZC.5g.mp[0]+10?(o["x-"]=!0,o.rj=ZC.2i(ZC.5g.mp[0]-l[0])):l[0]<ZC.5g.mp[0]-10&&(o["x+"]=!0,o.rj=ZC.2i(ZC.5g.mp[0]-l[0])),l[1]>ZC.5g.mp[1]+10?(o["y+"]=!0,o.rk=ZC.2i(ZC.5g.mp[1]-l[1])):l[1]<ZC.5g.mp[1]-10&&(o["y-"]=!0,o.rk=ZC.2i(ZC.5g.mp[1]-l[1])),ZC.5g.mp=l,1o.3j(ZC.5g.id,"ro",o)}ZC.5g.ts=(1n 9H).bi()}}1p;1j"5P":ZC.5g.id=1c,ZC.5g.on=!1,ZC.5g.1I=1c,ZC.5g.ts=1c,ZC.5g.eX=-1,ZC.5g.mp=[-1,-1]}if(2u.ZC){2u.ZC.DT=[e.b8,e.bo];1a r=1o.WP(e);if(r){if(!1o.4C.9Z){if(e.1I===ZC.1b[47]&&(2u.ZC.jj=[e.b8,e.bo]),"4D"===e.1I&&r.AI)1k(1a C=0;C<r.AI.1h;C++)r.AI[C].LK();if(-1!==ZC.AT(["6Z","7B","6Z"],e.1I)&&"Fw"!==e.2T.8h.5D())1m;if("7B"===e.1I&&(t=ZC.A4("#"+r.K+"-1u"),ZC.DU(e.b8,t.1Y().1J,t.1Y().1J+t.1s(),!0)&&ZC.DU(e.bo,t.1Y().1u,t.1Y().1u+t.1L(),!0)))1m;ZC.AO.C2(e.1I,r,1o.ih(e,r))}1o.4C.9Z=!1}}},ZC.A4(2e).3p(ZC.P.C1("6Z"),1o.MD).3p(ZC.P.C1("7B"),1o.MD).3p(ZC.P.C1(ZC.1b[48]),1o.MD).3p(ZC.P.C1(ZC.1b[47]),1o.MD).3p(ZC.P.C1(ZC.1b[49]),1o.MD)),1o.ih=1f(e,t){1a i=ZC.P.M8(e),n=t.ki(i[0],i[1]),a=ZC.A4("#"+t.K+"-1u"),l=1A.43(i[0]-a.1Y().1J),o=1A.43(i[1]-a.1Y().1u),r="1Z";1m/(.*)\\-1z\\1b(.*)\\-1N\\zF\\-1M(.*)/.5x(e.2T.id)&&(r="1z-5F"),/(.*)\\-1z\\1b(.*)\\-1N\\1b(\\d+)\\-1M(.*)/.5x(e.2T.id)&&(r="1z-1N"),/(.*)\\-cu\\-1B\\-(\\d+)\\-2o\\-(\\d+)(.*)/.5x(e.2T.id)&&(r="2o"),/(.*)\\-1U\\-1N\\1b(\\d+)\\-1M/.5x(e.2T.id)&&(r="1U-1N"),/(.*)\\-1U\\-1O\\1b(\\d+)\\-1M/.5x(e.2T.id)&&(r="1U-1O"),/(.*)\\-2y\\-1N\\-(.*)/.5x(e.2T.id)&&(r="2y-1N"),/(.*)\\-2w\\-3M\\-x(.*)/.5x(e.2T.id)&&(r="2w"),/(.*)\\-2P\\-(.*?)\\-1M/.5x(e.2T.id)&&(r="2P"),/(.*)\\-1G\\-(.*?)\\-1M/.5x(e.2T.id)&&(r="1G"),{id:t.K,ev:ZC.A4.C1(e),9O:e.2T.id,4u:n?n.K:1c,2T:r,x:l,y:o,2r:!!n&&(l>=n.Q.iX&&l<=n.Q.iX+n.Q.I&&o>=n.Q.iY&&o<=n.Q.iY+n.Q.F),e2:ZC.2H}},1w 1o.S6===ZC.1b[31]&&(1o.S6=1f(e){1k(1a t=0,i=1o.HP.1h;t<i;t++)1o.HP[t].9h();if(ZC.2H&&ZC.3l)ZC.3l=!1;1t if(ZC.2H||!(e.8T>1)){1a n=1o.WP(e);if(n){if("3F"===e.1I&&ZC.jj&&(ZC.2i(ZC.jj[0]-e.b8)>2||ZC.2i(ZC.jj[1]-e.bo)>2))1m;1o.4C.9Z||ZC.AO.C2("9v"===e.1I?"9v":"3F",n,1o.ih(e,n)),1o.4C.9Z=!1,e.2T.id!==n.K+"-2y-1M"?n.9h():1o.YS(e)}}},ZC.2H?(ZC.A4(2e).3p("6k",1f(){ZC.3l=!0}),ZC.A4(2e).3p("5P",1f(){ZC.3l=!1})):(ZC.A4(2e).3p("3F",1o.S6),ZC.A4(2e).3p("9v",1o.S6))),1w 1o.tG===ZC.1b[31]&&(1o.tG=1f(e){e.7z.1h>0&&(ZC.bO=!0)},ZC.A4(2e).3p("4D",1o.tG)),1w 1o.YS===ZC.1b[31]&&(1o.YS=1f(e,t,i){if(!e||"Fw"===e.2T.8h.5D()||"vS"===e.2T.8h.5D()||-1!==ZC.P.SW(e.2T).1K("zc-1X")||-1!==e.2T.id.1K("-1U-")||-1!==e.2T.id.1K("-2w-")||1o.3G.bA){1a n,a,l,o,r,C;i=i||{};1a A=1c===ZC.1d(t)?1o.WP(e):1o.79(t);if(A){if(-1!==ZC.AT(A.KL,ZC.1b[38]))1m!1;if(1c===ZC.1d(t)?(a=ZC.P.M8(e),n=A.ki(a[0],a[1])):n=1c!==ZC.1d(i[ZC.1b[3]])?A.OQ(i[ZC.1b[3]]):A.AI[0],!n)1m!1;1a s=ZC.A4("#"+A.K+"-1u");1c===ZC.1d(t)?(l=a[0]-s.1Y().1J,o=a[1]-s.1Y().1u):(l=A.I/2,o=A.F/2);1a Z={};e&&(Z=1o.ih(e,A));1a c=ZC.AO.C2("fm",A,Z,!0);if(!c&&1w c!==ZC.1b[31]&&(!e&&!i["6l-7o"]||e&&e.2T.id!==A.K+"-2y-1M"))1m e.6L(),!1;1a u=ZC.ak(A.K);A.qN(n?n.L:-1,e);1a p=-1;if(0!==1o.tP)p=1o.tP;1t 1k(1a h=ZC.AK(A.K);-1===p&&1c!==h.6s;)"3e"!==(p=ZC.1l(ZC.A4(h).2K("9V")))&&""!==p&&1c!==ZC.1d(p)||(p=-1),h=h.6s;p&&-1!==p&&1c!==ZC.1d(p)||(p=1);1a 1b=ZC.A4("#"+A.K+"-2y");if(1b.2K("9V",1o.rA+p+1),1c===ZC.1d(t)){if(e.2T.id===A.K+"-6F-9Y"||e.2T.id===A.K+"-6F-dg")1m!0;e.6L()}if(!ZC.AK(A.K+"-2y"))1m!1;l=s.1Y().1J,o=s.1Y().1u;1a d=s.1s(),f=s.1L();1c===ZC.1d(t)?(r=(a=ZC.P.M8(e))[0]||ZC.DT[0],C=a[1]||ZC.DT[1]):(r=l+A.I/2,C=o+5);1a g=!1;if(A.VD("d7",!1),A.NS>0&&(A.VD("d7",!0),g=!0),A.VD("d8",!1),A.NS<A.QI.1h-1&&(A.VD("d8",!0),g=!0),A.VD("4X",g,!0),r>=l&&r<=l+d*u[0]&&C>=o&&C<=o+f*u[1]){ZC.A4(".zc-2y").4Z(1f(){1g.id!==A.K+"-2y"&&A.9h()}),A.SM=[r,C,1c===ZC.1d(t)?e.2T.id:t],1b.2K("3k",0).4k();1a B=ZC.1l(1b.2K(ZC.1b[19]))+ZC.1l(1b.2K("dj"))+ZC.1l(1b.2K("dv")),v=ZC.1l(1b.2K(ZC.1b[20]))+ZC.1l(1b.2K("cK"))+ZC.1l(1b.2K("dt")),b=1,E=!1;A.o.5f&&A.o.5f["6j-2y"]&&A.o.5f["6j-2y"]&&(b=A.o.5f["6j-2y"].2k?A.o.5f["6j-2y"].2k:1,E=A.o.5f["6j-2y"].118),1b.2K("3k",b).5c();1a m,K;if("cP"!==A.LI&&E){if(E){1a F=A.B9.NR[A.LI].an.5f["6j-2y"];ZC.2A(A.o.5f["6j-2y"],F),m="1J"!==A.o.5f["6j-2y"].2G&&ZC.1d(A.o.5f["6j-2y"].2G)?s.1Y().1J+s.1s()-B:s.1Y().1J}K=s.1Y().1u,1b.2K("1J",ZC.BN(1,m)+"px").2K("1u",ZC.BN(1,K)+"px").2K(ZC.1b[20],s.1L()+"px").2K("3B-Ga","1F-3B").4k(),1b=ZC.A4("#"+A.K+"-2y"),E&&1b.OW[0].119>s.1L()&&1b.2K("9R-y","1X")}1t{if(1c===ZC.1d(t)&&e.2T.id===A.K+"-2y-1M"){ZC.AK(A.K+"-2y").1H.cK=0;1a D=ZC.A4("#"+A.K+"-2y-1M").3Q("9n").2l(","),I=ZC.1l(D[3])-ZC.1l(D[1]);ZC.AK(A.K+"-2y").1H.qw=ZC.1l(D[0])>A.I/2?"100% 0% !7x":"0% 0% !7x",m=l+(ZC.1l(D[0])>A.I/2?ZC.1l(D[2])-B:ZC.1l(D[0])),K=o+(ZC.1l(D[1])>A.F/1.25?ZC.1l(D[3])-v-I:ZC.1l(D[3]))}1t ZC.AK(A.K+"-2y").1H.qw="50% 0% !7x",m=A.SM[0]-B/2,K=A.SM[1],v>A.F*u[1]?K=o:K-o+v>A.F*u[1]&&(K=ZC.BN(K-v,A.F*u[1]-v)),m<l&&(m=ZC.BN(m,l)),m+B>l+A.I*u[0]&&(m=ZC.CV(l+A.I*u[0]-B/2,m-B/2));if(i.2G)1P(i.2G){1j"1u":1p;1j"1u-1J":m=m-(A.I*u[0]-B)/2+5;1p;1j"1u-2x":m=m+(A.I*u[0]-B)/2-5;1p;1j"2a":K=K+(A.F*u[1]-v)-10;1p;1j"2a-1J":K=K+(A.F*u[1]-v)-10,m=m-(A.I*u[0]-B)/2+5;1p;1j"2a-2x":K=K+(A.F*u[1]-v)-10,m=m+(A.I*u[0]-B)/2-5;1p;1j"1J":K=K+(A.F*u[1]-v)/2-5,m=m-(A.I*u[0]-B)/2+5;1p;1j"2x":K=K+(A.F*u[1]-v)/2-5,m=m+(A.I*u[1]-B)/2-5}1t 1c!==ZC.1d(i.x)&&1c!==ZC.1d(i.y)&&(m=l+ZC.1l(i.x),K=o+ZC.1l(i.y));if(1b.2K("1J",ZC.BN(1,m)+"px").2K("1u",ZC.BN(1,K)+"px").4k(),ZC.6O){1a X=ZC.A4("#"+A.K+"-2y 3A").1s()[0]||120;1b.2K(ZC.1b[19],X+"px")}}1m A.ep=!0,!1}}}},ZC.A4(2e).3p("fm",1o.YS)),1o.sb=1f(e,t){if(1o.2K)1m 1o.2K.Fs?1o.2K.Fs(e,t):1o.2K.11a(e+"{"+t+"}",0)},1o.wh=1f(e,t,i){"3e"===t&&(t="100%"),"3e"===i&&(i="100%");1a n,a,l=[0,0];1m-1===(""+t).1K("%")&&-1===(""+i).1K("%")||(l=e.wh()),n=-1!==(""+t).1K("%")?l[0]*5w(t,10)/100:5w(t,10),a=-1!==(""+i).1K("%")?l[1]*5w(i,10)/100:5w(i,10),[n,a]},1o.IP={},1o.3p=1f(e,t,i){e=e||"1o-jt",1o.IP[e]||(1o.IP[e]={}),1o.IP[e][t]?1o.IP[e][t].1i({fn:i}):1o.IP[e][t]=[{fn:i}]},1o.3h=1f(e,t,i){if(e=e||"1o-jt",1o.IP[e]&&1o.IP[e][t])if(i){1k(1a n=0,a=1o.IP[e][t].1h;n<a;n++)if(1o.IP[e][t][n].fn===i){1o.IP[e][t].6p(n,1);1p}}1t 1o.IP[e][t]=1c},1o.gM=1f(e,t,i,n){if(e=e||"1o-jt",1o.IP[e]&&1o.IP[e][t]){1k(1a a=0,l=1o.IP[e][t].1h;a<l;a++)1c!==ZC.1d(n)?i[i.1h-1]=1o.IP[e][t][a].fn.8H(1o,i):1o.IP[e][t][a].fn.8H(1o,i);if(1c!==ZC.1d(n))1m i[i.1h-1]}},1o.gA=1f(e,t){1m e=e||"1o-jt",1o.IP[e]&&1o.IP[e][t]},1o.tV=1f(e,t){1f i(){if(!1b.E.wh||1b.E.wh!==1b.I+"/"+1b.F){1k(1a e=!1,t=0;t<1o.HP.1h;t++)1o.HP[t].K===1b.K&&(e=!0);e&&1b.bM()}1b.l6=!1}1f n(){1b.l6?1b.V5.1s!==1b.I&&(iQ(1b.tH),1b.V5.1s=1b.I,1b.V5.1L=1b.F,1b.tH=5G(i,1o.3G.tF)):(1b.l6=!0,1b.V5={1s:1b.I,1L:1b.F},1b.tH=5G(i,1o.3G.tF))}ZC.6v(e,!1);1a a,l,o,r,C,A,s,Z,c=[];if(1c!==ZC.1d(a=e.i9)&&(c=a.2l(",")),1c!==ZC.1d(a=e.4B))1P(a){1j"8F":c=[ZC.1b[38],ZC.1b[39],ZC.1b[40],ZC.1b[41],ZC.1b[44]]}1a u="";if(1c!==ZC.1d(a=e.11c)&&(u=a),1c!==ZC.1d(a=e.id)&&(u=a),ZC.AK(u)){1a p=1c;1k(o=0;o<1o.HP.1h;o++)1o.HP[o].K===u&&(p=1o.HP[o].M7);if(1c!==ZC.1d(p)){if(""!==p)1m;1o.3j(u,"9M")}1o.aY[u]={},ZC.2A(e,1o.aY[u]);1a h=!1,1b=1c;1k(o=0;o<1o.HP.1h;o++)1o.HP[o].K===u&&(1o.HP[o]=1n ZC.RD,1b=1o.HP[o],h=!0);if(h||((1b=1n ZC.RD).M7="lY",1o.HP.1i(1b)),1b.K=u,1o.XQ[u]=!0,"3I"!==t||1o.ZO||1o.tV(e,t),!1o.u5){1o.u5=!0;1a d={".zc-1H":"2p-9g:"+1o.9W+";2p-2b:"+1o.iU+"px;2p-7a:5e;2p-1H:5e;1D-c3:1Z;1D-3H:1Z;",".zc-1H *":"2p-9g:"+1o.9W+";2p-2b:"+1o.iU+"px;2p-7a:5e;2p-1H:5e;1D-c3:1Z;1D-3H:1Z;",".zc-1u *":"1D-3s:1J;2v:3e;1D-3H:1Z;",".zc-2y *":"1D-3s:1J;2v:3e;",".zc-3X 1D":"-7A-e2-6B:1Z;-7A-bt-9K:1Z;-10F-bt-9K:1Z;-y0-bt-9K:1Z;-ms-bt-9K:1Z;bt-9K:1Z;",".zc-5U":"-7A-bt-9K:1Z;-7A-e2-6B:1Z;-7A-j0-5M-1r:b0;",".zc-2Z":"-7A-bt-9K:1Z;-7A-e2-6B:1Z;-7A-j0-5M-1r:b0;",".zc-10G":"-7A-bt-9K:1Z;-7A-e2-6B:1Z;-7A-j0-5M-1r:b0;",".zc-2w-4K":"4O:2n;-7A-bt-9K:1Z;-7A-e2-6B:1Z;-7A-j0-5M-1r:b0;",".zc-6x":"2G:4A;9R:9c;1F:86 2R #2O;1R:#VI 3P("+(ZC.6O?"//":ZC.Fp)+") no-6G 3E ax",".zc-6x-1":"3u:Wa 86 86 86;1D-3s:3E !7x;",".zc-6x-1 a":"1r:#Fn;2p-2b:rZ;1y-1L:125%;",".zc-6x-2":"3u:86;1r:#2O;1D-3s:3E !7x;",".zc-6x-3":"3u:86;1D-3s:3E;1y-1L:125%;",".zc-6x-3 3A":"1R-1r:#Fn;1y-1L:125%;1r:#2O;1F:88 2R #2O;3u:86 ax;2p-7a:6u;1s:Vt;2v:0 3e;4O:8v;1D-3s:3E",".zc-6x-4":"1r:#2O;1y-1L:125%;",".zc-6x-4 3A":"8Z:2x;1r:#2O;1y-1L:125%;",".zc-4H":"1F:86 2R #2O;1R:#4J",".zc-4L":"1F:86 2R #2O;1R:#wu",".zc-4p":"1F:86 2R #2O;1R:#4J",".zc-4E-5j-1G":"3u:dA ax 5p;1D-3s:1J;1r:#2O",".zc-4E-5j-ah":"3u:5p ss",".zc-4E-5j-84":"3u:ss ss 5p !7x",".zc-4E-5j-ah bR":"1D-3s:1J;1R:#2O;1r:#4e;1F:88 2R #8I;",".zc-4E-5j-1G ad":"1r:#4e;3u:5p;2v:0 86 0 0;1R-1r:#4J;",".zc-4E-5j-ah ad":"1r:#4e;3u:5p;2v:0;1R-1r:#2O",".zc-4E-5j-84 ad":"3u:dA ax !7x;2v:0 Uz 0 0 !7x;1R-1r:#8S !7x;1F:5p V4 #7S !7x",".zc-4E-s0":"2p-2b:Vg !7x;Vm-Xz:-88;1y-1L:125%",".zc-4E-s1":"2p-2b:rZ !7x;1y-1L:125%",".zc-4E-s1 a":"1r:#2O;3u:Yb ax;2G:jk;1u:dA;1F:88 2R #8I;1F-2a:gW 2R #8I",".zc-c8-6D":"1R-1r:#2O;1r:#8I !7x",".zc-c8-f5":"1R-1r:#4J;1r:#78 !7x",".zc-4p 1G":"3J:Yd-8K;2G:jk;1u:-5p",".zc-cs 3A":"2G:4A;1D-3s:3E;3u:86;1R:#4J;1r:#2O",".zc-fZ-6O":"3u:0;2G:4A;2p-2b:Bs;2p-7a:6u;2p-9g:"+1o.9W+";1r:#l7;1D-3s:1J",".zc-fZ":"3u:0;2G:4A;","#zc-5T":"3J:8K;2G:4A;1u:0;1J:0;1s:100%;1L:100%;2v:0;3u:0;1R:#2O;",".zc-2y":"2G:4A;3J:1Z;1R-6G:no-6G !7x;1R-2G:50% 0% !7x;",".zc-2y-dV":"2p-2b:88;3u:0;1y-1L:88;1F-2a:88 2R #4e",".zc-2y-1N":"4O:8v;Cr-8O:lF",".zc-9f":"1R:#8S",".zc-9f 3A.zc-9f-xY":"2G:4A;1F:5p 2R #7S;3u:ax Yh;1R-1r:#8I;1r:#2O",".zc-fB":"1R-1r:#2O;1r:#4e;1F:5p 2R #4J",".zc-2g-1G-6q":"1F-hs:hs",".zc-2g-1G-6q td":"3u:dA ax 5p 5p",".zc-1T-6q":"1F-hs:hs",".zc-1T-6q q1":"2p-9g:"+1o.9W+";1D-3s:1J;2p-2b:rZ;2p-7a:o0;3u:Cl rV Cl dA;1R-1r:#7S;1F-2a:5p 2R #cT",".zc-1T-6q th":"2p-9g:"+1o.9W+";1D-3s:1J;2p-2b:Yo;2p-7a:o0;3u:5p rV 5p dA;1R-1r:#78;1F-2a:88 2R #cT",".zc-1T-6q td":"2p-9g:"+1o.9W+";1D-3s:1J;2p-2b:wN;3u:88 rV 88 dA;1R-1r:#kz;1F-2a:88 2R #8S;Cr-8O:lF",".zc-aK":"1u:0;1J:0;2G:jk",".zc-3i":"1u:0;1J:0;2G:4A"};ZC.cF||(d[".zc-1T-6q th:cq(:84-Cq)"]="1F-2x:88 g1 #cT",d[".zc-1T-6q td:cq(:84-Cq)"]="1F-2x:88 2R #8S");1a f=2e.e6("gf")[0],g=2e.4N("1H");if(g.1I="1D/2K",g.4l("1T-Co","1o"),f.2X(g),!1o.2K)1k(o=0,r=2e.f9.1h;o<r;o++)2e.f9[o].Cp&&"1o"===2e.f9[o].Cp.bT("1T-Co")&&(1o.2K=2e.f9[o]);1o.2K||(1o.2K=2e.f9[2e.f9.1h-1]);1k(1a B in d)1c!==ZC.1d(1o.s8[B])?1o.sb(B,1o.s8[B]):1o.sb(B,d[B])}"3I"!==t||1o.t5||(2e.Xh.2N("7q","ps:pp-pH-bv:3I"),2e.Xi().Xk=".t2 { Cg:3P(#2n#Cf); }",1o.t5=!0);1a v="";1o.kG&&(v=1o.kG),e.1T&&1c!==ZC.1d(a=e.1T.bU)&&(v=a),1c!==ZC.1d(a=e.bU)&&(v=a);1a b={1T:!1,cG:!1,2K:!1,6K:!1};if(1c!==ZC.1d(a=e.4b))1k(1a E in b)1c!==ZC.1d(l=a[E])&&(b[E]=ZC.2q(l));1a m=!1;1c!==ZC.1d(a=e.5T)&&(m=ZC.2q(a));1a K=!0;1c!==ZC.1d(a=e["3e-bM"])&&(K=ZC.2q(a));1a F=ZC.A4("#"+u);C=(e[ZC.1b[19]]||"100%")+"",A=(e[ZC.1b[20]]||""+1o.eL.1L)+"","3e"===C&&(C="100%"),"3e"===A&&(A="100%");1a D=1o.wh(F,C,A);s=D[0],Z=D[1],m&&(s=ZC.A4(2u).1s(),Z=ZC.A4(2u).1L(),2e.3o.1H.9R="9c"),s<10&&(s=1o.eL.1s),Z<10&&(Z=1o.eL.1L),s=0===s?1o.eL.1s:s,Z=0===Z?1o.eL.1L:Z;1a I=e.gF||"",X=e.xR||"",x=1c,y="",L=1c;1c!==ZC.1d(a=e.1T)&&("2Y"==1w a?y=a:L=1o.3G.qD?3c.1q(3c.5d(a)):a),1c!==ZC.1d(a=e.cG)&&("2Y"==1w a&&(a=3c.1q(a)),x=a),1c!==ZC.1d(a=e.wO)&&(1b.dm=ZC.2q(a)),1b.dm&&(1b.FW=1c),1b.JD=C+"/"+A,1b.AB=t,1b.A=1b,1b.iX=0,1b.iY=0,1b.I=s,1b.F=Z,1b.FU=C,1b.MO=A,1b.QN=I,1b.F6=y,1b.M4=L,1b.QP=X,1b.MJ=x,1b.UF=!1,1c!==ZC.1d(e.ra)&&ZC.2q(e.ra)&&(1b.QT=!0),1b.LQ=m,1b.RR=b,1b.KL=c,1b.LI=v,1b.H=1b,1b.E.dc=!1,1c!==ZC.1d(a=e.dc)&&(1b.E.dc=ZC.2q(a)),1c!==ZC.1d(a=e.nk)&&(1b.E.nk=a),1c!==ZC.1d(a=e.o1)&&(1b.E.o1=a),1c!==ZC.1d(a=e.nE)&&(1b.E.nE=a),1c!==ZC.1d(a=e.r4)&&(1b.E.r4=a);1a Y={};1c!==ZC.1d(a=e.Xq)&&(Y[ZC.1b[0]]=a),1c!==ZC.1d(a=e[ZC.1b[0]])&&(Y[ZC.1b[0]]=a),1c!==ZC.1d(a=e[ZC.1b[61]])&&(Y[ZC.1b[61]]=a),1c!==ZC.1d(a=e[ZC.1b[62]])&&(Y[ZC.1b[62]]=a),1c!==ZC.1d(a=e.1r)&&(Y.1r=a),1b.E.7Q=Y,1c!==ZC.1d(a=e["3e-2t-gH"])&&(1b.z4=ZC.2q(a)),1c!==ZC.1d(a=e.hq)&&(1b.dn=a),1c!==ZC.1d(a=e.gH)&&(1b.l2=a),1c!==ZC.1d(a=e.5K)&&(1b.CG=a),1c!==ZC.1d(a=e.11g)&&(1b.NP=a),1c!==ZC.1d(a=e.iP)&&1c!==ZC.1d(1o.fI[a])&&(1b.ez=a,ZC.HA=1o.fI[a]),1c!==ZC.1d(a=e["4b-13G"])&&(1b.MZ=a);1k(1a w in 1o.aY)if(!1o.XQ[w]){4o 1o.aY[w],4o ZC.TS[w];1k(1a M in 1o.5Y.1T)0===M.1K(w+"-")&&(4o 1o.5Y.1T[M],1o.5Y.2b--)}if(1b.b3(),F.2K("9R","9c"),1b.LQ&&F.2K("2G","4A").2K("1u",0).2K("1J",0),(-1!==1b.FU.1K("%")||-1!==1b.MO.1K("%")||1b.LQ||1b.QT)&&K){1a H=1b.QT||1b.LQ?ZC.A4(2u):F,N=H.1s(),S=H.1L(),O=0;1b.l6=!1,1b.YP=2u.fH(1f(){1a e;if(ZC.AK(u)&&!1b.lU){1a t=ZC.A4("#"+u+"-1u"),i=!1;if(-1!==(""+1b.FU).1K("%")&&t.1h&&H.1h&&t.1s()!==H.1s()&&(i=!0),0!==O||H.1s()===N&&H.1L()===S&&!i){if(H.1s()+H.1L()>0&&(H.1s()!==N||H.1L()!==S)&&(e=1b.LQ||1b.QT?1o.wh(H,""+H.1s(),""+H.1L()):1o.wh(H,1b.FU,1b.MO))[0]>10&&e[1]>10){1k(1b.I=e[0],1b.F=e[1],N=H.1s(),S=H.1L(),o=0,r=1b.AI.1h;o<r;o++)1b.AI[o].M6[0]=0;n()}}1t if(N=H.1s(),S=H.1L(),N>10&&S>10){1k(-1!==(""+1b.FU).1K("%")?1b.I=N*ZC.IB(1b.FU):1b.I=N,-1!==(""+1b.MO).1K("%")?1b.F=S*ZC.IB(1b.MO):1b.F=S,o=0,r=1b.AI.1h;o<r;o++)1b.AI[o].M6[0]=0;n()}O++}1t 2u.9N(1b.YP)},1o.3G.A3)}1m 1b}},2u.1o=1o,ZC.A4.6A.a6&&5V(ZC.A4.6A.af)<9){1a t9=2u.Fo;2u.Fo=1f(){1k(;1o.HP.1h;)1o.3j(1o.HP[0].K,"9M");ZC.A4(2e).3h(ZC.P.C1("6Z"),1o.MD).3h(ZC.P.C1("7B"),1o.MD).3h(ZC.P.C1(ZC.1b[48]),1o.MD).3h(ZC.P.C1(ZC.1b[47]),1o.MD).3h(ZC.P.C1(ZC.1b[49]),1o.MD).3h("3F",1o.S6).3h("fm",1o.YS),1o.HP=[],t9&&t9()}}1o.fI.pS={aO:!1,"6h-8P":".","mr-8P":"","2y-pg":"13J rU Ad","2y-pb":"13O rU Ad","2y-fF":"xu","2y-6F":"xF 13Q","2y-p1":"hS As 141","2y-p0":"hS As 13C","2y-xL":"l0 13p","2y-xA":"l0 13B","2y-xM":"l0 8l","2y-xZ":"l0 13h","2y-oY":"hS dU Ak","2y-oo":"Bc dU Ak","2y-jl":"13l dU","2y-g4":"Al In","2y-g2":"Al 13n","2y-fR":"hS 13s","2y-4H":"hS 13t","2y-4p":"tD Bu","2y-pj":"B3 To 2D","2y-ph":"B3 To 3D","2y-hM":"sZ oA","2y-kb":"Bc oA","2y-oP":"sZ 14D Fl","2y-p2":"sZ 14I Fl","2y-5T":"Fh Fd","2y-ic":"11k Fh Fd","2y-d7":"Go tU","2y-d8":"Go 11u","5z-s7":{sa:"%d %M %Y<br>%g:%i:%s %A<br>%q ms",my:"%d %M %Y<br>%g:%i:%s %A",iR:"%d %M %Y<br>%g:%i %A",mB:"%d %M %Y<br>%g %A",ew:"%d %M %Y",ft:"%M %Y",mD:"%Y"},"jT-5E":["11x","11C","11D","12l","d5","12y","12z"],"jT-fW":["Ki","Lx","MQ","Ng","Ma","Md","Mm"],"jG-5E":["d3","Mp","HT","Io","Au","Hd","Hg","Hh","Hm","Hn","Hu","Ka"],"jG-fW":["Kc","Ji","It","Jf","Au","Si","Sk","Sx","S8","U5","Ui","Ul"],"rF-aX":"sI...","8w-aX":"Os...","7Q-aX-fW":"sI. tu...","7Q-aX-5E":"sI...","7Q-aX-jQ":"...","4L-5S":"An Bp Pa Ph","4L-aR":"Bp Ns:","4L-7p":"i1","4p-5S":"tD Bu Rx","4p-zq":"Cv 3c dU","4p-zo":"Cv U7 14Y","4p-zn":"tM Qy:","4p-zm":"3c dU:","4p-z8":"tM Fz Ny","4p-zj":"if Gs Oz to Td Sz or RO Rt to Kh IN","4p-zS":"Fz Iq is Hj...","4p-fT":"tD","4p-mO":"Gz","4p-zT":"tM HJ Hz Mw Kr.\\n\\Ks Gs!","6x-7p":"i1","4H-gp":"zf 3c","4H-gk":"zd 3c","4H-7p":"i1","4H-8H":"Ll","cs-7p":"i1","1U-yV":"rU %3b% of %9Q%"},ZC.HA=1o.fI.pS,1o.79=1f(e){1k(1a t=0;t<1o.HP.1h;t++)if(1o.HP[t].K===e)1m 1o.HP[t];1m 1c},1o.tw=1f(e,t){1m e.OQ(t)},1o.13F=1f(e){e.A8&&e.A8.eT();1k(1a t=0;t<e.AI.1h;t++)e.AI[t].LK()},1o.Lk=1f(e,t,i){1m e.nS(t,i)},1o.Kw=1f(e){e&&e.o4(!0)},1o.Gl=1f(e){ZC.WF.1i(e)},1o.Gi=1f(e){1m e.l2.2l(",")},1o.Kx=1f(e,t,i){1P(1o.Gl(e),t){1j"aL":1o.3p(1c,"gg",1f(t,n){1k(1a a=n[ZC.1b[16]].1h,l=0;l<a;l++)if(n[ZC.1b[16]][l].1I===e){1a o=n[ZC.1b[16]][l];o.id?o.id=o.id:o.id=e.1E(/-/g,"")+l,n[ZC.1b[16]][l]=i(o)}1m n});1p;1j"KK":1o.3p(1c,"gg",1f(t,n){1a a=1o.79(t.id);if(-1!==1o.Gi(a).1K(e))1k(1a l=n[ZC.1b[16]].1h,o=1c,r=0;r<l;r++)(o=n[ZC.1b[16]][r]).8d(e)&&(n[ZC.1b[16]][r]=i(o,t.id));1m n})}},1o.Nb=1f(e,t,i){1m i=i||"2Q",e.B9.ny(t,i)},1o.Kf=1f(e,t,i){1a n,a;1P(i=i||"1G"){1j"2P":1k(n=0,a=e.FE.1h;n<a;n++)if(e.FE[n].GX===t||n===t)1m e.FE[n].BE;1p;1j"1G":1k(n=0,a=e.BW.1h;n<a;n++)if(e.BW[n].GX===t||n===t)1m e.BW[n]}1m 1c},1o.ai=1f(e,t){1P(t){1j"1H":1m 1n ZC.CZ(e);1j"2P":1m 1n ZC.DS(e);1j"3B":1m 1n ZC.HQ(e);1j"Hy":1m 1n ZC.DQ(e)}1m 1c},1o.gy=1f(e){ZC.6v(e)},1o.1Q=1f(e,t){ZC.2A(e,t)},1o.Ih=1f(e,t,i,n){1m ZC.AO.Y2(e,t,i,n)},1o.Hb=1f(e,t){1m ZC.AO.GM(e,t)},1o.Hq=1f(e,t,i){ZC.AO.C2(e,t,i)},1o.ir=[],1o.mf=1f(e,t){1o.ir.1i({4s:e,7o:t})},1o.3j=1f(e,t,i){1m 1o.79(e)?1o.Fx(e,t,i):1o.k6?1o.k6(e,t,i):8j 0},1o.Fx=1f(e,t,i){1a n,a,l;i=i||{},2e.cA("zc-5T")&&!i.pE&&(e="zc-5T"),"2Y"==1w i&&(i=3c.1q(i));1a o,r,C,A,s=1o.79(e);if(1c!==ZC.1d(i[ZC.1b[53]])&&(s.E[ZC.1b[53]]=ZC.2q(i[ZC.1b[53]])),s)1P(t){1j"d7":s.I0&&s.NS>0&&(ZC.AO.C2("Ix",s,s.FH()),s.NS--,1o.3j(s.K,"b4",{1T:s.QI[s.NS]}));1p;1j"d8":s.I0&&s.NS<s.QI.1h-1&&(ZC.AO.C2("IF",s,s.FH()),s.NS++,1o.3j(s.K,"b4",{1T:s.QI[s.NS]}));1p;1j"qx":if(1w s.E["4B-i9"]===ZC.1b[31]&&(s.E["4B-i9"]=s.KL.2I(",")),""===i.4B&&1w s.E["4B-i9"]!==ZC.1b[31])s.KL=s.E["4B-i9"].2l(",");1t{s.KL=[];1a Z=(""+i.4B).2l(",");-1!==ZC.AT(Z,"8F")&&s.KL.1i(ZC.1b[38],"yt",ZC.1b[39],ZC.1b[40],ZC.1b[41])}1p;1j"St":ZC.DT[0]=ZC.1d(i.x)?i.x:ZC.DT[0],ZC.DT[1]=ZC.1d(i.y)?i.y:ZC.DT[1],i["6l-7o"]=!0,1o.YS(1c,s.K,i);1p;1j"Ud":s.9h();1p;1j"9M":1j"Tw":1k(ZC.AO.C2("Pd",s,{id:e,6C:s}),4o 1o.XQ[e],a=0,l=s.AI.1h;a<l;a++)s.AI[a].M6[0]=0,s.AI[a].BI&&(s.AI[a].BI.J6=!1,s.AI[a].3h(!1,!0)),s.H3&&(s.H3.J6=!1);ZC.3l=!1,s.gP(),s.r3(i,!0),1o.3G.GC&&s.gc(),s.YP&&2u.9N(s.YP),s.YN&&2u.9N(s.YN),1o.IP[e]&&4o 1o.IP[e],ZC.P.ES([e+"-fP",e+"-1u",e+"-1D-ka",e+"-nF",e+"-7Q"]),s.jm||4o 1o.aY[e],4o ZC.TS[e],4o ZC.4b.1T["2B-5t"];1k(1a c in 1o.5Y.1T)0===c.1K(e+"-")&&(4o 1o.5Y.1T[c],1o.5Y.2b--);1a u=ZC.AT(1o.HP,s);-1!==u&&1o.HP.6p(u,1),1o.HP.1h||(1o.hg=1c,4o 1o.LD["zc.nl"]),s=1c,ZC.AO.C2("9M",1c,{id:e});1p;1j"Ok":1m s.AB;1j"3v":s.r3(i);1p;1j"fF":s.rK(i);1p;1j"2t":s.xQ(i);1p;1j"4S":s.kA();1p;1j"Qt":s.po(i.1D);1p;1j"Pq":ZC.P.ES([s.K+"-fB",s.K+"-9f"]);1p;1j"Su":if(!ZC.AK(s.K+"-fB"))1m ZC.P.HO({2m:"zc-3i zc-1H zc-9f",id:s.K+"-9f",p:ZC.AK(s.K+"-1u"),wh:s.I+"/"+s.F,3k:.75}),ZC.P.HO({2m:"zc-3i zc-1H zc-fB",id:s.K+"-fB",p:ZC.AK(s.K+"-1u"),tl:(s.F-i[ZC.1b[20]])/2+"/"+(s.I-i[ZC.1b[19]])/2,wh:i[ZC.1b[19]]+"/"+i[ZC.1b[20]],3k:1}),ZC.AK(s.K+"-fB");1p;1j"Lb":s.y3(i);1p;1j"6F":s.ku();1p;1j"5T":s.qI();1p;1j"ic":1o.3j("zc-5T","9M"),ZC.P.ES("zc-5T");1p;1j"bM":s.lU=!0;1a p=s.I,h=s.F,1b=s.JD.2l("/"),d=!1,f=1b[0],g=1b[1];1c!==ZC.1d(n=i[ZC.1b[19]])&&(f=n),1c!==ZC.1d(n=i[ZC.1b[20]])&&(g=n),1c!==ZC.1d(n=i.1z)&&(d=ZC.2q(n)),s.jm&&(1o.aY[s.K][ZC.1b[19]]=f,1o.aY[s.K][ZC.1b[20]]=g);1a B=1o.wh(ZC.A4("#"+s.K),f,g);(i.3t||(p!==B[0]||h!==B[1])&&B[0]>10&&B[1]>10)&&(s.I=B[0],s.F=B[1],1c!==ZC.1d(n=i.3t)&&(s.o.3t=n),""===s.M7&&(s.E["6l-7o"]=!0,s.E[ZC.1b[53]]=!0,s.bM(d),s.FU=f,s.MO=g,s.lU=!1));1p;1j"Kp":1j"Ku":(o=s.C8(i[ZC.1b[3]]))&&o.pU(i,"5c");1p;1j"hM":1j"kb":ZC.DT[0]=ZC.1d(i.x)?i.x:ZC.DT[0],ZC.DT[1]=ZC.1d(i.y)?i.y:ZC.DT[1],(o=s.C8(i[ZC.1b[3]]))&&s.YX(o.K,"hM"===t);1p;1j"Bx":1j"Mu":1j"By":if(o=s.C8(i[ZC.1b[3]])){1a v=i.ev||{};(r=o.HZ(i.3S,i.4W))&&r.S.1h&&!i.xy?(C=r.L,A=ZC.1l(i.5Q||"0"),v.9O=o.K+ZC.1b[35]+C+"-2o-"+A,v.3O=!0):v.9O=o.K+"-xy-"+ZC.1l(i.y||"0")+"-"+ZC.1l(i.x||"0"),"By"===t?(v.8T=0,o.T3(v)):o.A.A8&&("Bx"===t?o.A.A8.eI(v,i.1T):o.A.A8.5c())}1p;1j"Qf":ZC.mX=!0;1p;1j"Pz":ZC.mX=!1;1p;1j"Ps":if(o=s.C8(i[ZC.1b[3]])){r=o.HZ(i.3S,i.4W),C=ZC.1l(r?r.L:0),A=ZC.1l(i.5Q||"0");1a b=o.AX.A7[C].FO(A);o.LK(),b.6e()}1p;1j"Qs":1j"Oh":(o=s.C8(i[ZC.1b[3]]))&&o.pU(i,"4k");1p;1j"Of":ZC.AK(s.K+"-4H")?ZC.P.ES(s.K+"-4H"):s.j9();1p;1j"OJ":ZC.AK(s.K+"-4p")?ZC.P.ES(s.K+"-4p"):s.lj();1p;1j"wz":ZC.AK(s.K+"-6x")?ZC.P.ES([s.K+"-6x",s.K+"-6x-4K"]):s.qC();1p;1j"Or":(o=s.C8(i[ZC.1b[3]]))&&o.Q2(i);1p;1j"Rf":1m(o=s.C8(i[ZC.1b[3]]))?o.AF:1c;1j"Ti":1j"Uo":1m ZC.fL;1j"Rz":1m(o=s.C8(i[ZC.1b[3]]))?o.F7:1c;1j"Ru":(o=s.C8(i[ZC.1b[3]]))&&(1c===ZC.1d(s.o[ZC.1b[16]][o.L][ZC.1b[26]])&&(s.o[ZC.1b[16]][o.L][ZC.1b[26]]={}),ZC.2A(i,s.o[ZC.1b[16]][o.L][ZC.1b[26]]),1c===ZC.1d(o.o[ZC.1b[26]])&&(o.o[ZC.1b[26]]={}),ZC.2A(i,o.o[ZC.1b[26]]),1o.4C.lT=!0,o.nV(),o.K2(!0,!0),1o.4C.lT=!1);1p;1j"Sj":1m s.L3;1j"Nr":1a E=0;1c!==ZC.1d(n=i.3b)&&(E=ZC.1l(n)),s.L3=E,ZC.YZ(1f(){s.3v(),s.1q(),s.1v()},!0);1p;1j"Nq":ZC.A4(2e).3h(ZC.P.C1(ZC.1b[48]),1o.MD).3h(ZC.P.C1(ZC.1b[47]),1o.MD).3h(ZC.P.C1(ZC.1b[49]),1o.MD).3h("3F",1o.S6).3h("fm",1o.YS),s.D5&&s.D5.3h()}1a m;1k(1o.oQ&&1c!==(m=1o.oQ(e,t,i))&&(n=m),1o.p9&&1c!==(m=1o.p9(e,t,i))&&(n=m),1o.q6&&1c!==(m=1o.q6(e,t,i))&&(n=m),1o.rg&&1c!==(m=1o.rg(e,t,i))&&(n=m),1o.pC&&1c!==(m=1o.pC(e,t,i))&&(n=m),1o.ql&&1c!==(m=1o.ql(e,t,i))&&(n=m),a=0,l=1o.ir.1h;a<l;a++)t===1o.ir[a].4s&&1c!==(m=1o.ir[a].7o.4s(1o,e,i))&&(n=m);1m n},1o.mf("wA",1f(e,t){1a i=1o.79(e);i.DE["6j-2y"]=i.DE["6j-2y"]||{},i.DE["6j-2y"]["5C-2z"]=i.DE["6j-2y"]["5C-2z"]||[];1k(1a n=t.id||"",a=i.DE["6j-2y"]["5C-2z"],l=!1,o=0;o<a.1h;o++)if(a[o].id===n){l=!0;1p}l||i.DE["6j-2y"]["5C-2z"].1i(t)}),1o.oQ=1f(e,t,i){1a n;2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a a,l,o,r,C,A,s,Z,c,u,p,h,1b,d,f,g,B,v,b,E,m=1o.79(e),K=!(1c!==ZC.1d(i.3O)&&!ZC.2q(i.3O)),F=1c!==ZC.1d(i.4X)&&ZC.2q(i.4X),D=1w i.eK!==ZC.1b[31]&&ZC.2q(i.eK);if(m){1a I=["Ex","ET","nT","Fb","Ew","Az","Am","b4"];1P(-1===ZC.AT(I,t)&&((l=m.FH()).aY=i,ZC.AO.C2(t,m,l)),t){1j"Iw":if(!(a=m.C8(i[ZC.1b[3]])))1m 1c;a.I5&&a.I5.ND&&(a.I5.ND(),a.I5.3h()),a.I6&&a.I6.ND&&(a.I6.ND(),a.I6.3h());1p;1j"Jy":1m(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))?o.kF(i[ZC.1b[9]]||1):1c;1j"Jx":1m(a=m.C8(i[ZC.1b[3]]))&&(r=a.BL(i.8L||""))?1c!==ZC.1d(i[ZC.1b[9]])?r.B2?r.B2(i[ZC.1b[9]]):1c:1c!==ZC.1d(i.mu)&&r.N8?r.N8(i.mu):1c:1c;1j"u7":if(!(a=m.C8(i[ZC.1b[3]])))1m 1c;1a X={id:"K",x:"iX",y:"iY",1s:"I",1L:"F",1r:"BZ",hd:"B6",cY:"AY",gt:"BU",gr:"AQ",gj:"A0",g9:"AC"};1P(i.4g){1j"2U":l={};1k(u in X)l[u]=a[X[u]];1m ZC.2A({1I:a.AF},l),l;1j"2r":l={};1k(u in X)l[u]=a.Q[X[u]];1m l;1j"1z":if(!(r=a.BL(i.8L||"")))1m 1c;l={};1k(u in X)l[u]=r[X[u]];1m ZC.2A({1I:r.AF,1D:r.M?r.M.AP||"":"",Jr:1c!==r.FD&&"5z"===r.FD.o.1I,6Y:r.EA,Jk:r.SB,Ho:r.A9,6g:r.W,6c:r.B7,h1:r.EM,cj:r.H1,Hc:r.A6,GR:r.BV},l),r.M&&""!==r.M.AP&&(l.1G={x:r.M.iX,y:r.M.iY,1s:r.M.I,1L:r.M.F,2c:r.M.AA}),"v"===r.AF?ZC.2A({fo:r.CA,Hi:r.EV,Fj:r.B8,Fc:r.BS,Fa:r.GV,Ez:r.HF},l):"1z-r"===i.8L?ZC.2A({Ht:r.DM},l):ZC.2A({Fj:r.W[r.X],Fc:r.W[r.A1],Fa:r.W[r.E7],Ez:r.W[r.EF],L0:r.X,Ld:r.A1,12E:r.E7,12A:r.EF},l),l;1j"1B":if(!(o=a.HZ(i.3S,i.4W)))1m 1c;l={};1k(u in X)l[u]=o[X[u]];1a x=o.AL&&a.E["1B"+o.L+".2f"];1m ZC.2A({2f:x,id:o.GX,2V:o.L,1I:o.AF,1D:o.AP,6g:o.W,3w:o.BK,nv:o.CB,12v:o.KO,7H:o.DV,hI:o.L8},l),o.TM&&ZC.2A({1O:{2f:o.TM.AL,2b:o.TM.AH,1I:o.TM.DP,gj:o.TM.A0,g9:o.TM.AC,gt:o.TM.BU,gr:o.TM.AQ}},l),l;1j"2o":if(o=a.HZ(i.3S,i.4W)){if(b=1c!==ZC.1d(i.5Q)?ZC.1l(i.5Q):0,!o.S[b])1m 1c;C=o.FO(b),(l={}).cJ=C.H.E[C.K+"-cJ"];1k(u in X)-1!==ZC.AT(["x","y",ZC.1b[19],ZC.1b[20]],u)?l[u]=C[X[u]]:l[u]=C.N[X[u]];if(ZC.2A({3S:o.L,2V:C.L,2b:C.AH,1S:C.AE,hF:C.BX,12h:C.J7},l),-1!==o.AF.1K("3L")&&ZC.2A({bD:C.B1,a2:C.BH,7y:C.A.PN,8o:100*C.AE/C.A.A.KF[C.L]},l),o.L8){1a y={};1k(u in o.L8)o.L8[u]3z 3K?y[u]=o.L8[u][b]:y[u]=o.L8[u];l.hI=y}1m l}1m 1c}1p;1j"vK":1a L=[],Y=i.x,w=i.y,M=ZC.ak(m.K);Y/=M[0],w/=M[1];1k(1a H=0;H<m.AI.1h;H++){a=m.AI[H];1k(1a N=0;N<a.AX.A7.1h;N++){o=a.AX.A7[N];1a S=a.BL(o.BT("k")[0]),O=a.BL(o.BT("v")[0]);if(S&&O){if(S.O4&&S.O4){1a P=S.O4(S.D9?w:Y),k=S.O4(S.D9?w:Y,1c,!0);L.1i({hm:"7U-1z",hn:ZC.2i(Y-S.I3(P)),4u:a.K,7i:o.L,Di:S.BB,12n:P,12m:k,Aa:S.BW[P]||"",Dh:S.W[P],12k:S.N8(S.D9?w:Y)})}if(O.N8){1a G=O.N8(O.D9?Y:w,!0);L.1i({hm:"1S-1z",hn:ZC.2i(O.D9?Y:w-O.B2(G)),4u:a.K,7i:o.L,Di:O.BB,Dh:G})}1k(1a z,T=ZC.3q,J=1c,Q=0,W=o.S.1h;Q<W;Q++)if(1c!==(C=o.FO(Q)))1P(a.AJ.3t){1j"xy":1j"yx":1a R=!1;"5A"===C.A.AF?(z=C.5J("h")||C.F,ZC.DU(Y,C.iX-C.I/2,C.iX+C.I/2)&&ZC.DU(w,C.iY,C.iY+z)&&(R=!0,T=1)):"6d"===C.A.AF&&(z=C.5J("w")||C.I,ZC.DU(Y,C.iX,C.iX+z)&&ZC.DU(w,C.iY-C.F/2,C.iY+C.F/2)&&(R=!0,T=1)),((n=1A.5B((C.iX-Y)*(C.iX-Y)+(C.iY-w)*(C.iY-w)))<T||R)&&(J={hm:"2o",hn:T,4u:a.K,7i:o.L,4W:o.GX,7l:C.L,Ec:C.AE,gB:1c===C.BX?S.W[C.L]:C.BX},R||(T=n));1p;1j"":1a V=C.kK();(n=1A.5B((V[0]-Y)*(V[0]-Y)+(V[1]-w)*(V[1]-w)))<T&&(J={hm:"2o",hn:T,4u:a.K,7i:o.L,4W:o.GX,7l:C.L,Ec:C.AE,gB:1c===C.BX?S.W[C.L]:C.BX},T=n)}J&&L.1i(J)}}}1m L;1j"3O":i.2F?(a=m.C8(i[ZC.1b[3]]))&&(a.OU(),a.QF()):1c!==ZC.1d(i[ZC.1b[3]])&&(a=m.C8(i[ZC.1b[3]]))?m.PB(1f(){a.K2(D,D)}):m.K2();1p;1j"12L":(a=m.C8(i[ZC.1b[3]]))&&(1c!==ZC.1d(i["dp-3U"])&&ZC.2q(i["dp-3U"])?m.E["2U-3U-"+a.L]=3c.5d(a.E):m.E["2U-3U-"+a.L]=1c,m.o[ZC.1b[16]][a.L].1I=a.o.1I=a.AF=i.1I,K&&m.K2());1p;1j"12f":m.o[ZC.1b[16]].1i(i.1T||{}),K&&m.K2();1p;1j"Ex":if(1o.4C.8l=!0,h={},1b=i.kT?"kT":"1T",1c!==ZC.1d(i[1b])&&("4g"==1w i[1b]?ZC.2A(i[1b],h):h=3c.1q(i[1b])),ZC.6v(h),a=m.C8(i[ZC.1b[3]])){1a U=[];1k(1c===ZC.1d(a.o[ZC.1b[11]])&&(a.o[ZC.1b[11]]=[]),p=(1c!==ZC.1d(i.3S)||1c!==ZC.1d(i.4W))&&(o=a.HZ(i.3S,i.4W))?o.L:a.o[ZC.1b[11]].1h,A=0,s=a.o[ZC.1b[11]].1h;A<=s;A++)A===p&&U.1i(h),a.o[ZC.1b[11]][A]&&U.1i(a.o[ZC.1b[11]][A]);ZC.AO.C2("11G",m,{id:m.K,4u:a.K,3S:p,1T:h}),m.o[ZC.1b[16]][a.L][ZC.1b[11]]=a.o[ZC.1b[11]]=U,m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,m.PB(1f(){a.K2(D,D)}))}1p;1j"ET":1o.4C.8l=!0,(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))&&(a.o[ZC.1b[11]].6p(o.L,1),m.o[ZC.1b[16]][a.L][ZC.1b[11]]=a.o[ZC.1b[11]],m.E.4F=ZC.GO(3c.5d(m.o)),ZC.AO.C2("11E",m,{id:m.K,4u:a.K,3S:o.L}),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,m.PB(1f(){a.K2(D,D)})));1p;1j"nT":if(1o.4C.8l=!0,h={},1c!==ZC.1d(i.1T)&&("4g"==1w i.1T?ZC.2A(i.1T,h):h=3c.1q(i.1T)),ZC.6v(h),a=m.C8(i[ZC.1b[3]])){if(a.BI&&(a.BI.HS=!1,a.E["ei-2w-1q"]=!0),1c!==ZC.1d(i.4g))1P(i.4g){1j"5F":ZC.2A(h,a.o.5F);1p;1j"cu":1j"ek":ZC.2A(h,a.o[ZC.1b[11]]);1p;1j"2r":ZC.2A(h,a.o.2r);1p;1j"1U":ZC.2A(h,a.o.1U);1p;1j"1B":ZC.2A(h,a.o.1B);1p;1j"2Z":ZC.2A(h,a.o.5W[0])}1t ZC.2A(h,a.o);1P(i.4g){1j"5F":m.o[ZC.1b[16]][a.L].5F=a.o.5F;1p;1j"cu":1j"ek":m.o[ZC.1b[16]][a.L][ZC.1b[11]]=a.o[ZC.1b[11]];1p;1j"2r":m.o[ZC.1b[16]][a.L].2r=a.o.2r;1p;1j"1U":m.o[ZC.1b[16]][a.L].1U=a.o.1U;1p;1j"1B":m.o[ZC.1b[16]][a.L].1B=a.o.1B;1p;1j"2Z":m.o[ZC.1b[16]][a.L].5W[0]=a.o.5W[0],m.XH(m.o),a.o.5W=m.o[ZC.1b[16]][a.L].5W;1p;2n:m.o[ZC.1b[16]][a.L]=a.o}m.E.4F=ZC.GO(3c.5d(m.o)),ZC.AO.C2("nT",m,{id:m.K,4u:a.K,1T:h,4g:i.4g}),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,m.PB(1f(){a.K2(D,D)}))}1p;1j"Fb":1o.4C.8l=!0,h={},1b=i.kT?"kT":"1T",1c!==ZC.1d(i[1b])&&("4g"==1w i[1b]?ZC.2A(i[1b],h):h=3c.1q(i[1b])),ZC.6v(h),(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))&&(1c===ZC.1d(m.o[ZC.1b[16]][a.L][ZC.1b[11]])&&(m.o[ZC.1b[16]][a.L][ZC.1b[11]]=[]),ZC.2A(h,a.o[ZC.1b[11]][o.L]),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L]=a.o[ZC.1b[11]][o.L],m.E.4F=ZC.GO(3c.5d(m.o)),ZC.AO.C2("11p",m,{id:m.K,4u:a.K,3S:o.L,1T:h}),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,m.PB(1f(){a.K2(D,D)})));1p;1j"Ew":1o.4C.8l=!0,(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))&&(b=0,1c!==ZC.1d(i.5Q)&&(b=ZC.1l(i.5Q)),n=0,1c!==ZC.1d(i[ZC.1b[9]])&&(n=i[ZC.1b[9]]),ZC.AO.C2("11T",m,{id:m.K,4u:a.K,3S:o.L,5Q:b,7U:b,1S:n,1D:n}),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L][ZC.1b[5]][b]=a.o[ZC.1b[11]][o.L][ZC.1b[5]][b]=n,m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D)));1p;1j"11Q":if(1o.4C.8l=!0,a=m.C8(i[ZC.1b[3]])){1k(d=i.1z||ZC.1b[50],f=0,g=a.BK.1h;f<g;f++)d===a.BK[f].BB&&1c!==ZC.1d(a.o[d])&&(a.o[d][ZC.1b[5]]=i[ZC.1b[5]],m.o[ZC.1b[16]][a.L][d]=m.o[ZC.1b[16]][a.L][d]||{},m.o[ZC.1b[16]][a.L][d][ZC.1b[5]]=i[ZC.1b[5]]);m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D))}1p;1j"13a":if(1o.4C.8l=!0,a=m.C8(i[ZC.1b[3]])){1k(d=i.1z||ZC.1b[50],f=0,g=a.BK.1h;f<g;f++)if(d===a.BK[f].BB&&1c!==ZC.1d(a.o[d])&&1c!==ZC.1d(a.o[d][ZC.1b[5]])){1k(b=1c===ZC.1d(i.5Q)?a.o[d][ZC.1b[5]].1h:ZC.1l(i.5Q),(v=a.o[d][ZC.1b[5]]).1i(1c),A=v.1h-1;A>b;A--)v[A]=v[A-1];v[b]=i[ZC.1b[9]]||"",m.o[ZC.1b[16]][a.L][d][ZC.1b[5]]=v}m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D))}1p;1j"14a":if(1o.4C.8l=!0,a=m.C8(i[ZC.1b[3]])){1k(d=i.1z||ZC.1b[50],f=0,g=a.BK.1h;f<g;f++)d===a.BK[f].BB&&1c!==ZC.1d(a.o[d])&&1c!==ZC.1d(a.o[d][ZC.1b[5]])&&(b=1c===ZC.1d(i.5Q)?a.o[d][ZC.1b[5]].1h-1:ZC.1l(i.5Q),(v=a.o[d][ZC.1b[5]]).6p(b,1),m.o[ZC.1b[16]][a.L][d][ZC.1b[5]]=v);m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D))}1p;1j"Az":1o.4C.8l=!0,a=m.C8(i[ZC.1b[3]]);1a j=i[ZC.1b[9]]3z 3K;if(a&&(o=a.HZ(i.3S,i.4W))){B=a.o[ZC.1b[11]][o.L][ZC.1b[5]],b=1c===ZC.1d(i.5Q)?B.1h:i.5Q,B.1i(1c);1a q=B.1h;1k(b=ZC.BN(0,ZC.CV(b,q)),A=q-1;A>b;A--)B[A]=B[A-1];if(B[b]=i[ZC.1b[9]],!j)1k(f=0,g=a.BK.1h;f<g;f++)if(d=a.BK[f].BB,"k"===a.BK[f].AF&&1c!==ZC.1d(i[d+"-1S"])&&1c!==ZC.1d(a.o[d])&&1c!==ZC.1d(a.o[d][ZC.1b[5]])){1k((v=a.o[d][ZC.1b[5]]).1i(1c),A=v.1h-1;A>b;A--)v[A]=v[A-1];v[b]=i[d+"-1S"],m.o[ZC.1b[16]][a.L][d][ZC.1b[5]]=v}ZC.AO.C2("13r",m,{id:m.K,4u:a.K,3S:o.L,5Q:b,7U:b,1S:i[ZC.1b[9]],1D:i[ZC.1b[9]]}),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L][ZC.1b[5]]=a.o[ZC.1b[11]][o.L][ZC.1b[5]],m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D))}1p;1j"Am":if(1o.4C.8l=!0,(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))){B=a.o[ZC.1b[11]][o.L][ZC.1b[5]],b=1c===ZC.1d(i.5Q)?o.S.1h-1:ZC.1l(i.5Q);1a $=!0;if(1c!==ZC.1d(i.gB))1k($=!1,f=0,g=o.S.1h;f<g;f++){if(1c===o.S[f]&&f===i.gB){$=!0,b=f;1p}if(o.S[f]&&1c!==ZC.1d(o.S[f].BX)&&o.S[f].BX===i.gB){$=!0,b=f;1p}}if($&&ZC.DU(b,0,o.S.1h-1)){1k(B.6p(b,1),f=0,g=a.BK.1h;f<g;f++)d=a.BK[f].BB,"k"===a.BK[f].AF&&1c!==ZC.1d(i[d])&&ZC.2q(i[d])&&1c!==ZC.1d(a.o[d])&&1c!==ZC.1d(a.o[d][ZC.1b[5]])&&((v=a.o[d][ZC.1b[5]]).6p(b,1),m.o[ZC.1b[16]][a.L][d][ZC.1b[5]]=v);($||o.S[b])&&(ZC.AO.C2("13k",m,{id:m.K,4u:a.K,3S:o.L,5Q:b,7U:b,1S:o.S[b]?o.S[b].AE:1c,1D:o.S[b]?o.S[b].AE:1c}),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L][ZC.1b[5]]=a.o[ZC.1b[11]][o.L][ZC.1b[5]],m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&(a.E["6l-7o"]=!0,a.K2(D,D)))}}1p;1j"b4":if(h={},1c!==ZC.1d(i.1T))if("4g"==1w i.1T)1o.3G.qD?h=3c.1q(3c.5d(i.1T)):ZC.2A(i.1T,h);1t 4I{h=3c.1q(i.1T)}4G(ue){1m m.NM(ue,"3c nb"),!1}ZC.6v(h),1c===ZC.1d(i[ZC.1b[53]])&&(m.E[ZC.1b[53]]=!1),a=1c,1c!==ZC.1d(i[ZC.1b[3]])&&(a=m.C8(i[ZC.1b[3]])),ZC.AO.C2("b4",m,{id:m.K,4u:a?a.K:1c,1T:h});1a ee,te,ie=["x","y",ZC.1b[19],ZC.1b[20]];if(a){1k(ee=0;ee<ie.1h;ee++)4o m.E["2U-"+a.L+"-"+ie[ee]];m.o[ZC.1b[16]][a.L]=a.o=h;1a ne=!1;if(h.gd)ne=!0;1t if(h.5W)1k(A=0;A<h.5W.1h;A++)"1o.4U"===h.5W[A].1I&&(ne=!0);ne&&m.XH(m.o),m.E.4F=ZC.GO(3c.5d(m.o)),K&&(a.E["6l-7o"]=!0,F&&m.NS++,m.PB(1f(){m.1q(a.K),m.AI[a.L].1v()}))}1t{1k(ee=0;ee<ie.1h;ee++)1k(te=0;te<m.AI.1h;te++)4o m.E["2U-"+te+"-"+ie[ee]];m.o=h,m.E.4F=ZC.GO(3c.5d(m.o)),m.XH(m.o),K&&(F&&m.NS++,m.K2())}1p;1j"13Z":1m(a=m.C8(i[ZC.1b[3]]))?1c!==ZC.1d(i.3S)||1c!==ZC.1d(i.4W)?(o=a.HZ(i.3S,i.4W,0))?a.o[ZC.1b[11]][o.L]:1c:a.o[ZC.1b[11]]:1c;1j"dH":1j"13Y":if(1o.4C.8l=!0,a=m.C8(i[ZC.1b[3]])){if(1c!==ZC.1d(i.3S)||1c!==ZC.1d(i.4W)?(o=a.HZ(i.3S,i.4W,0),h="dH"===t?{}:a.o[ZC.1b[11]]&&a.o[ZC.1b[11]][o.L]?a.o[ZC.1b[11]][o.L]:{}):h="dH"===t?[]:a.o[ZC.1b[11]]||[],1c!==ZC.1d(i.1T)&&("4g"==1w i.1T?ZC.2A(i.1T,h):ZC.2A(3c.1q(i.1T),h)),ZC.6v(h),1c!==ZC.1d(i.3S)||1c!==ZC.1d(i.4W))o=a.HZ(i.3S,i.4W,0),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L]=a.o[ZC.1b[11]][o.L]=h,h.8d("2f")&&(a.E["1B"+o.L+".2f"]=h.2f);1t 1k(m.o[ZC.1b[16]][a.L][ZC.1b[11]]=a.o[ZC.1b[11]]=h,A=0;A<h.1h;A++)h[A].8d("2f")&&(a.E["1B"+A+".2f"]=h[A].2f);m.E.4F=ZC.GO(3c.5d(m.o)),a.LT("on-9X"),K&&m.PB(1f(){a.K2(D,D)})}1p;1j"13M":if(a=m.C8(i[ZC.1b[3]])){if(1c!==ZC.1d(i.3S)||1c!==ZC.1d(i.4W))1m(o=a.HZ(i.3S,i.4W,0))?a.o[ZC.1b[11]][o.L][ZC.1b[5]]||[]:[];1k(E=[],A=0,s=a.AX.A7.1h;A<s;A++)E.1i(a.o[ZC.1b[11]][A][ZC.1b[5]]||[]);1m E}1m 1c;1j"rH":1j"13K":1o.4C.8l=!0,E=[],1c!==ZC.1d(i[ZC.1b[5]])&&(E="4g"==1w i[ZC.1b[5]]?i[ZC.1b[5]]:3c.1q(i[ZC.1b[5]]));1a ae=!1;if(a=m.C8(i[ZC.1b[3]])){if(1c===ZC.1d(i.3S)&&1c===ZC.1d(i.4W)||(E=[E],ae=!0),ae||"rH"!==t){1k(o=a.HZ(i.3S,i.4W,0),A=0,s=E.1h;A<s;A++)if(a.AX.A7[o.L+A])if("rH"===t)ae&&(m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L+A][ZC.1b[5]]=a.o[ZC.1b[11]][o.L+A][ZC.1b[5]]=E[A]);1t{1a le=m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L+A][ZC.1b[5]],oe=E[A].1h>0&&1c!==ZC.1d(E[A][0])&&E[A][0].1h>1,re=!0;if(1c!==ZC.1d(n=i.13I)&&(re=ZC.2q(n)),oe){1a Ce=le.1h;1k(Z=0,c=E[A].1h;Z<c;Z++){1k(1a Ae=!1,se=Ce-1;se>=0;se--){if(E[A][Z][0]>le[se][0]){le.1i(E[A][Z]),Ae=!0;1p}if(E[A][Z][0]===le[se][0]){Ae=!0;1p}}Ae&&re||le.1i(E[A][Z])}}1t 1k(Z=0,c=E[A].1h;Z<c;Z++)le.1i(E[A][Z]);i["1V-6g"]&&ZC.1l(i["1V-6g"])<le.1h&&(le=le.7y(-i["1V-6g"])),m.o[ZC.1b[16]][a.L][ZC.1b[11]][o.L+A][ZC.1b[5]]=a.o[ZC.1b[11]][o.L+A][ZC.1b[5]]=le}}1t{1k(f=0;f<E.1h;f++)m.o[ZC.1b[16]][a.L][ZC.1b[11]][f]=m.o[ZC.1b[16]][a.L][ZC.1b[11]][f]||{},a.o[ZC.1b[11]][f]=a.o[ZC.1b[11]][f]||{},m.o[ZC.1b[16]][a.L][ZC.1b[11]][f][ZC.1b[5]]=a.o[ZC.1b[11]][f][ZC.1b[5]]=E[f];if(a.o[ZC.1b[11]].1h>E.1h)1k(f=E.1h;f<a.o[ZC.1b[11]].1h;f++)4o m.o[ZC.1b[16]][a.L][ZC.1b[11]][f],4o a.o[ZC.1b[11]][f]}a.LT("on-9X"),m.E.4F=ZC.GO(3c.5d(m.o)),K&&a.K2(D,D)}1p;1j"11h":if((a=m.C8(i[ZC.1b[3]]))&&a.BC){1a Ze=!0;1w a.BC.o.2f===ZC.1b[31]||a.BC.o.2f||(Ze=!1),a.BC.o.2f=!Ze,a.BC.3v(!1),a.BC.1q(),a.BC.1v()}1p;1j"gE":1j"yL":(a=m.C8(i[ZC.1b[3]]))&&a.BC&&("gE"===t?(ZC.AO.C2("Yt",m,a.HX()),ZC.AO.C2("Xp",m,a.HX())):(ZC.AO.C2("Xo",m,a.HX()),ZC.AO.C2("Xm",m,a.HX())),a.BC.N4="gE"===t,a.BC.W6(),a.BC.3v(!1),a.BC.1q(),a.BC.1v());1p;1j"Xj":(a=m.C8(i[ZC.1b[3]]))&&a.BC&&(o=a.HZ(i.3S,i.4W))&&(a.BC.pM(ZC.1l(o.L)),a.BC.W6(),a.BC.3v(!0),a.BC.YL=!0,a.BC.1q(),a.BC.1v());1p;1j"Xg":(a=m.C8(i[ZC.1b[3]]))&&m.rI(a.K);1p;1j"gT":1m h=3c.1q(m.E.4F),ZC.6v(h,!0),h;1j"Xc":1m h=3c.1q(m.E.7d),ZC.6v(h,!0),h;1j"Xs":1m m.AI.1h;1j"Yf":1m(a=m.C8(i[ZC.1b[3]]))?a.AX.A7.1h:0;1j"Yq":if(a=m.C8(i[ZC.1b[3]])){1a ce=[];1k(A=0;A<a.BK.1h;A++)ce.1i(a.BK[A].BB);1m ce}1m[];1j"Yp":1m(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))?o.S.1h:1c;1j"Yl":1m(a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))&&1c!==ZC.1d(i.5Q)&&(C=o.S[ZC.1l(i.5Q)])?o.EC?[C.BX,C.AE]:C.AE:1c;1j"Yj":if((a=m.C8(i[ZC.1b[3]]))&&(o=a.HZ(i.3S,i.4W))){1k(E=[],A=0,s=o.S.1h;A<s;A++)o.S[A]?o.EC?E.1i([o.S[A].BX,o.S[A].AE]):E.1i(o.S[A].AE):E.1i(1c);1m E}1m 1c}}1m 1c},ZC.Bn=ZC.C9.C7({$i:1f(){1a e=1g;e.O9=1c,e.o={},e.HU=1c,e.JO=1c,e.E={},e.E4=[],e.IA=1c,e.OC=""},H9:1f(e,t,i,n,a){1a l=1g;if(e.IA){a=a||l.OC;1a o=e.IA.4s(l,n,a);i&&o&&(o[i+"-3U"]?o=o[i+"-3U"]:o[i+"Ca"]&&(o=o[i+"Ca"]));1a r,C,A=l.aj(),s={},Z={};1k(1a c in o)r=ZC.EB(c),C=ZC.U9(c),"oO"===r?s.A0=s.AC=ZC.AO.G3(o[c]):"Yg"===r?s.F2=s.FP=s.FA=s.EY=o[c]:"3u"===c?s.FM=s.FN=s.FV=s.EO=o[c]:A[r]?s[A[r]]=o[c]:s[r]=o[c],Z[C]=o[c];t.o||ZC.2A(o,s),ZC.2A(s,t),t.o&&(ZC.2A(Z,t.o),t.KS())}},1q:1f(){1a e,t,i,n,a=1g;"fX"!==1o.pr&&ZC.6v(a.o);1a l="";if(1w a.H!==ZC.1b[31]&&(l=a.H.AB),ZC.Z7(a.o,"ig"),""!==l&&ZC.Z7(a.o,l),1o.3G.pL&&a.o["pq-ac"]&&1w a.H!==ZC.1b[31])1k(t=0;t<a.o["pq-ac"].1h;t++)i=a.o["pq-ac"][t],n=!0,1c!==ZC.1d(i["2h-1s"])&&ZC.1l(i["2h-1s"])>a.H.I&&(n=!1),1c!==ZC.1d(i["1V-1s"])&&ZC.1l(i["1V-1s"])<a.H.I&&(n=!1),1c!==ZC.1d(i["2h-1L"])&&ZC.1l(i["2h-1L"])>a.H.F&&(n=!1),1c!==ZC.1d(i["1V-1L"])&&ZC.1l(i["1V-1L"])<a.H.F&&(n=!1),n&&ZC.2A(i,a.o);1k(a.o.ac&&(a.E4=a.o.ac),t=0;t<a.E4.1h;t++)if("*"===a.E4[t].cz&&a.E4[t].js){a.o["js-cz"]=a.E4[t].js,a.E4.6p(t,1);1p}if((e=a.o["js-cz"])&&("7u:"===e.2s(0,11)||e.1K("(")<e.1K(")")))4I{a.OC="";1a o=e.1E("7u:",""),r=e.1K("("),C=e.1K(")");-1!==r&&-1!==C&&(a.OC=o.5v(r+1,C-r-1),o=o.5v(0,r)),a.IA=ZC.kh(o,2u)}4G(s){}if(1w a.H!==ZC.1b[31]&&1c!==a.H.QK)1k(1a A in a.H.QK)a.H.QK.8d(A)&&1c===ZC.1d(a.o[A])&&(a.o[A]=a.H.QK[A])},aj:1f(){1m{}},ef:1f(e,t,i){1k(1a n=t.2l(","),a=i.2l(","),l=0,o=a.1h;l<o;l++)e[n[l]]=a[l]},Xu:1f(){1m 1g.o},Ya:1f(e){1g.o=e},tX:1f(){1m 1g.E},bT:1f(e){1m 1g.E[e]},4l:1f(e,t){1g.E[e]=t},qm:1f(e){1a t=1g.aj();1m t[e]?1g[t[e]]:1c},mR:1f(e,t){1a i=1g.aj();i[e]&&(1g[i[e]]=t)},1C:1f(e,t,i){1c===t&&(t=!0);1a n=1g;e&&(n.HU||(n.HU={},ZC.2A(n.o,n.HU,!0,i)),n.JO||(n.JO={}),ZC.2A(e,n.JO,!0,i),ZC.2A(e,n.o,!0,i)),1w n.j7!==ZC.1b[31]&&n.j7()&&e&&ZC.2A(e,n.o)},j7:1f(){},4y:1f(e){1k(1a t=0,i=e.1h;t<i;t++)1g.o.8d(e[t][0])&&1g.ZA(e[t][0],e[t][1],e[t][2],e[t][3],e[t][4])},ZA:1f(e,t,i,n,a){1a l,o=1g;if(1c!==(l=o.o[e])&&1w l!==ZC.1b[31]){if(i)1P(-1!==i.1K("p")&&(l=ZC.8C(l),i=i.1E("p","")),-1!==i.1K("a")&&(l=ZC.2i(l),i=i.1E("a","")),i){1j"i":l=ZC.1l(l);1p;1j"f":l=ZC.1W(l);1p;1j"b":l=ZC.2q(l);1p;1j"c":l=ZC.AO.YV(l,o),(l=ZC.AO.G3(l,o))3z 3K&&("1r"===e||"2p-1r"===e?(o.o["1D-2k"]=l[1],o.WB=l[1],o.E["1D-2k"]=l[1]):e===ZC.1b[61]?(o.o["1F-2k"]=l[1],o.NU=l[1],o.E["b-2k"]=l[1]):("1y-1r"===e&&(o.E["l-2k"]=l[1]),1c===ZC.1d(o.o.2k)&&(o.C6=l[1])),l=l[0])}1c!==ZC.1d(n)&&1c!==ZC.1d(a)&&(l=ZC.5m(l,n,a)),o[t]=l}},DD:1f(){1k(1a e=1g,t=!1,i=0,n=e.E4.1h;i<n;i++){1a a=!1;4I{a=1n c1("1m ("+e.JC(e.E4[i].cz)+")")()}4G(l){a=!1}a&&(t=!0,e.1C(e.E4[i]))}1m t},Bm:1f(e){1k(1a t=1g,i="",n=0,a=e.1h;n<a;n++){1a l=!1;4I{l=1n c1("1m ("+t.JC(e[n].cz)+")")()}4G(o){l=!1}l&&(i+="<"+e[n].cz+">")}1m""!==i?[i,ZC.XN.eE(i)]:1c},JC:1f(){1m!0},1Q:1f(e){1a t=1g;ZC.2A(e.o,t.o),e.HU&&(t.HU=t.HU||{},ZC.2A(e.HU,t.HU)),e.JO&&(t.JO=t.JO||{},ZC.2A(e.JO,t.JO)),ZC.2A(e.E,t.E),ZC.2A(e.E4,t.E4)}}),ZC.CZ=ZC.Bn.C7({$i:1f(e){1g.b(e);1a t=1g;e&&e.H&&(t.H=e.H),t.K="",t.DJ=1c,t.AL=!0,t.A0="-1",t.AC="-1",t.GK="",t.HE="",t.VG=!0,t.D8="",t.LZ="6G",t.T2="50% 50%",t.WK="",t.KJ=1,t.NB="9l",t.N1=90,t.VR=0,t.VS=0,t.AY=0,t.B6="#4e",t.G8="",t.EW=0,t.G4=0,t.AQ=0,t.BU="#4e",t.C6=1,t.NU=1,t.T0="mv",t.ZU="43",t.M3=!1,t.OB=45,t.JP=2,t.SY=.75,t.RW="#4J",t.P5=0,t.CX=!0,t.OG=!1,t.L1=!1,t.t0=!1,t.OH=1c,t.BF=""},aj:1f(){1a e=1g.b();1m 1g.ef(e,"2f,gj,g9,Xx,Xw,z9,Vn,qw,Wc,Vv,Wr,xh,10A,10w,cY,hd,10u,10s,11d,gr,gt,117,2k,Gv,3H,115,10Y,10P,Zs,Zb,3g,1F","AL,A0,AC,GK,HE,D8,LZ,T2,WK,KJ,NB,N1,VR,VS,AY,B6,G8,EW,G4,AQ,BU,NU,C6,T0,M3,OB,JP,SY,RW,P5,DJ,BF"),e},1Q:1f(e){1g.b(e);1k(1a t=1g,i="AL,A0,AC,GK,HE,D8,VG,LZ,T2,WK,KJ,NB,N1,VR,VS,AY,B6,G8,EW,G4,AQ,BU,NU,C6,T0,M3,OB,JP,SY,RW,P5,CX,L1,DJ,H,BF".2l(","),n=0,a=i.1h;n<a;n++)1w e[i[n]]!==ZC.1b[31]&&(t[i[n]]=e[i[n]])},j7:1f(){1a e,t,i=1g,n=!1;if((i.o["3g"]||i.o.2m||i.o.id)&&1c!==i.H&&1c!==i.H.N){if(e=i.o["3g"]||i.o.2m)1k(1a a=e.2l(/(\\s+)/),l=0,o=a.1h;l<o;l++)(t=i.H.N["."+a[l]])&&(n=!0,ZC.2A(t,i.o));(e=i.o.id)&&(t=i.H.N["#"+e])&&(n=!0,ZC.2A(t,i.o))}1m 1c!==i.O9&&(t=i.H.N[i.O9])&&(n=!0,ZC.2A(t,i.o)),n},KS:1f(e){1a t,i=1g;1P(1c===ZC.1d(e)&&(e=i.AY),i.G8){1j"g1":i.EW=ZC.BN(1,.75*e),i.G4=1.75*e;1p;1j"fX":i.EW=4*e,i.G4=3*e;1p;1j"fC":i.EW=4*e,i.G4=2*e;1p;2n:i.EW=0,i.G4=0}1c!==(t=ZC.1d(i.o["1y-f6-2b"]))&&(i.EW=5w(t,10)),1c!==(t=ZC.1d(i.o["1y-ik-2b"]))&&(i.G4=5w(t,10))},1q:1f(){1a e,t,i,n,a,l,o,r,C;1g.b();1a A=1g;if(1c!==(e=ZC.1d(A.o.7c))&&!A.t0){1a s=-1,Z=-1;1w A.E.7i!==ZC.1b[31]&&(s=ZC.1l(A.E.7i)),1w A.E.7l!==ZC.1b[31]&&(Z=ZC.1l(A.E.7l));1a c,u,p;1k(o=0,r=e.1h;o<r;o++){if(c=-1,u=-1,e[o].7r){if(1c!==(t=ZC.1d(e[o].7r["2o-2V"]))){if(u=0,p=[],"4g"==1w t)p=t;1t if("2Y"==1w t){if(-1!==t.1K(","))p=t.2l(",");1t if(-1!==t.1K("-"))1k(i=t.2l("-"),n=ZC.1l(i[0]);n<=ZC.1l(i[1]);n++)p.1i(n)}1t p=[t];-1!==ZC.AT(p,Z)&&(u=1)}if(1c!==(t=e[o].7r["1B-2V"])&&1w t!==ZC.1b[31]){if(c=0,p=[],"4g"==1w t)p=t;1t if("2Y"==1w t){if(-1!==t.1K(","))p=t.2l(",");1t if(-1!==t.1K("-"))1k(i=t.2l("-"),n=ZC.1l(i[0]);n<ZC.1l(i[1]);n++)p.1i(n)}1t p=[t];-1!==ZC.AT(p,s)&&(c=1)}}0!==c&&0!==u&&A.1C(e[o])}}if(1c!==(e=A.OH)&&A.1C(e),e=A.o[ZC.1b[0]]){if(e=ZC.AO.YV(e,1g),"9I("===5X(e).2s(0,4))1k(a=1n 5o("9I\\\\((\\\\d{1,3}),\\\\s*(\\\\d{1,3}),\\\\s*(\\\\d{1,3})\\\\)");l=a.3j(e);)e=e.1E(l[0],ZC.AO.G3(l[0]));if("9D("===5X(e).2s(0,5))1k(a=1n 5o("9D\\\\((\\\\d{1,3}),\\\\s*(\\\\d{1,3}),\\\\s*(\\\\d{1,3})\\\\,\\\\s*([0-9.]+)\\\\)");l=a.3j(e);){1a h=ZC.AO.G3(l[0],A);e=e.1E(l[0],h[0]),A.o.2k=h[1],A.C6=h[1],A.E["bg-2k"]=h[1],1c===ZC.1d(A.E["b-2k"])&&(A.E["b-2k"]=1),1c===ZC.1d(A.E["l-2k"])&&(A.E["l-2k"]=1)}1a 1b=ZC.GO(5X(e)).2l(/\\s+|;|,/);A.A0=ZC.AO.G3(1b[0]),A.AC=1===1b.1h?A.A0:ZC.AO.G3(1b[1])}if(!(1c===ZC.1d(A.o[ZC.1b[62]])&&1c===ZC.1d(A.o[ZC.1b[61]])&&1c===ZC.1d(A.o["1y-1H"])||1c===ZC.1d(A.o["1F-1u"])&&1c===ZC.1d(A.o["1F-2x"])&&1c===ZC.1d(A.o["1F-2a"])&&1c===ZC.1d(A.o["1F-1J"])&&1c===ZC.1d(A.o.1F))){1a d=["1u","2x","2a","1J"],f={1u:[0,"2R","#4e"],2x:[0,"2R","#4e"],2a:[0,"2R","#4e"],1J:[0,"2R","#4e"]};if(A.HU=A.HU||{},e=A.HU.1F)1k(C=e.2l(/\\s/),o=0;o<4;o++)f[d[o]]=[ZC.1l(C[0]||"0"),ZC.GO(C[1]||"2R"),ZC.AO.G3(C[2]||"#cH")];if(1c!==ZC.1d(A.HU[ZC.1b[62]]))1k(o=0;o<4;o++)f[d[o]][0]=A.HU[ZC.1b[62]];if(1c!==ZC.1d(A.HU["1y-1H"]))1k(o=0;o<4;o++)f[d[o]][1]=A.HU["1y-1H"];if(1c!==ZC.1d(A.HU[ZC.1b[61]]))1k(o=0;o<4;o++)f[d[o]][2]=A.HU[ZC.1b[61]];1k(o=0;o<4;o++)(e=A.HU["1F-"+d[o]])&&(C=e.2l(/\\s/),f[d[o]]=[ZC.1l(C[0]||"0"),ZC.GO(C[1]||"2R"),ZC.AO.G3(C[2]||"#cH")]);if(A.JO=A.JO||{},e=A.JO.1F)1k(C=e.2l(/\\s/),o=0;o<4;o++)f[d[o]]=[ZC.1l(C[0]||"0"),ZC.GO(C[1]||"2R"),ZC.AO.G3(C[2]||"#cH")];if(1c!==ZC.1d(A.JO[ZC.1b[62]]))1k(o=0;o<4;o++)f[d[o]][0]=A.JO[ZC.1b[62]];if(1c!==ZC.1d(A.JO["1y-1H"]))1k(o=0;o<4;o++)f[d[o]][1]=A.JO["1y-1H"];if(1c!==ZC.1d(A.JO[ZC.1b[61]]))1k(o=0;o<4;o++)f[d[o]][2]=A.JO[ZC.1b[61]];1k(o=0;o<4;o++)(e=A.JO["1F-"+d[o]])&&(C=e.2l(/\\s/),f[d[o]]=[ZC.1l(C[0]||"0"),ZC.GO(C[1]||"2R"),ZC.AO.G3(C[2]||"#cH")]);1k(o=0;o<4;o++)1c===ZC.1d(A.o["1F-"+d[o]])&&(A.o["1F-"+d[o]]=f[d[o]].2I(" "))}A.4y([["2f","AL","b"],["1R-1r-1","A0","c"],["1R-1r-2","AC","c"],["4Y-hX","GK"],["4Y-rT","HE"],["1R-3r","VG","b"],["1R-4d","D8"],["1R-6G","LZ"],["1R-2G","T2"],["1R-gw","WK"],["1R-1z","KJ","f"],["3f-1I","NB"],["3f-2c","N1","i"],["3f-1Y-x","VR","f"],["3f-1Y-y","VS","f"],[ZC.1b[4],"AY","i"],["1y-1r","B6","c"],["1y-1H","G8",""],["3g","DJ"],["2m","DJ"],["1F","BF"]]),"1Z"===A.NB&&(A.AC=A.A0,A.NB="9l"),""!==A.BF&&(C=A.BF.2l(/\\s/),A.AQ=ZC.1l(C[0]||"0"),A.G8=ZC.GO(C[1]||"2R"),A.BU=ZC.AO.G3(C[2]||"#cH")),A.GK=ZC.AO.YV(A.GK,1g),A.KS(),A.4y([["1y-f6-2b","EW","i"],["1y-ik-2b","G4","i"],[ZC.1b[62],"AQ","i"],[ZC.1b[61],"BU","c"],["2k","C6","f",0,1],["3H","M3","b"],["3H-2c","OB","i",0,2j],["3H-6T","JP","i"],["3H-2k","SY","f",0,1],["3H-1r","RW","c"],["3H-Gk","P5","i"]]),A.NU=A.C6,A.4y([["1F-2k","NU","f",0,1]])}}),ZC.CN={kd:1f(e,t,i){1a n,a,l;if(e&&i&&0!==i.1h){if(!t.E["8u-dZ-2M"])1k(n=0,a=i.1h;n<a;n++)i[n]&&(i[n][0]=5V(4P(i[n][0]).4v(2)),i[n][1]=5V(4P(i[n][1]).4v(2)));1a o=!1,r=i.1h;1k(n=0;n<r;n++)1c!==ZC.1d(i[n])&&(l=[i[n][0],i[n][1]],1c!==ZC.1d(i[n][2])&&l.1i(i[n][2],i[n][3]),1c!==ZC.1d(i[n][4])&&l.1i(i[n][4],i[n][5]),t.OG&&(l[0]=1A.43(l[0]),l[1]=1A.43(l[1]),4===l.1h&&(l[2]=1A.43(l[2]),l[3]=1A.43(l[3]))),t.CX&&t.AY%2==1&&(l[0]-=.5,l[1]-=.5,4===l.1h&&(l[2]-=.5,l[3]-=.5))),0===n?e.en(l[0],l[1]):i[n]?(o&&(e.en(l[0],l[1]),o=!1),2===l.1h?e.ip(l[0],l[1]):4===l.1h?e.uN(l[0],l[1],l[2],l[3]):6===l.1h&&e.6y(l[0],l[1],l[2],ZC.ST(l[3]),ZC.ST(l[4]),l[5])):o=!0}},2E:1f(e,t){1a i=t.H.AB;if(1!==t.C6&&t.L1&&(1c===ZC.1d(t.o[ZC.1b[61]])&&(t.BU=t.A0),1c===ZC.1d(t.o[ZC.1b[62]])))1P(i){1j"3a":t.AQ=.2;1p;1j"2B":t.AQ=.1;1p;1j"3I":t.AQ=.2,t.E.oa=t.C6/10}},1v:1f(e,t,i,n,a,l){if(1c===ZC.1d(a)&&(a=2),1c===ZC.1d(n)&&(n=!1),1c===ZC.1d(l)&&(l=!1),e&&i&&0!==i.1h&&t){!l&&i.1h>2&&1c!==i[0]&&1c!==i[i.1h-1]&&i[0].2I(",")===i[i.1h-1].2I(",")&&(t.T0="43");1a o,r,C,A,s,Z,c=t.H.AB;if("3a"!==c||0!==t.AY&&"-1"!==t.B6){if(t.M3&&1c!==ZC.1d(t.C5)&&!n){t.C5=t.C5||t.Z;1a u,p=ZC.P.sw(i,t);1w t.oz!==ZC.1b[31]?u=t.oz:((u=1n ZC.DS(t)).1Q(t),u.K=t.K+"-sh",u.M3=!1,u.AY+=u.P5,u.B6=u.RW),u.C6=t.C6*u.SY,1w t.109===ZC.1b[31]&&(t.oz=u),u.CX=!1,o=ZC.P.E6(t.C5,c),ZC.CN.2E(o,u),ZC.CN.1v(o,u,p,!1,1,l)}1a h=ZC.1l(t.EW||"0"),1b=ZC.1l(t.G4||"0");"2R"===t.G8&&(h=1b=0);1a d=i.1h;1w t.AA===ZC.1b[31]&&(t.AA=0),"3a"===c&&(e.ZD=t.ZU,e.Gv=t.T0,e.mG=ZC.AO.ea(ZC.AO.G3(t.B6),n?t.NU:t.C6),e.cY=t.AY,e.mF());1a f=!1;if(-1!==ZC.AT(["2B","3I"],c))r=l?[]:ZC.P.jb(i,c,t,n);1t{1a g=!1;"fC"!==t.G8&&(g=e.mq)&&e.mq(0===h||0===1b?[]:[h,1b]);1a B=0,v=[ZC.3q,ZC.3q,-ZC.3q,-ZC.3q];1k(Z=0;Z<d;Z++)if(1c!==i[Z]){if(1c!==(C=ZC.bN?i[Z]:ZC.P.n4(i[Z],c,t,n))&&!8a(C[0])&&!8a(C[1])&&eV(C[0])&&eV(C[1]))if(d<=6&&n&&(v[0]=ZC.CV(v[0],C[0]),v[1]=ZC.CV(v[1],C[1]),v[2]=ZC.BN(v[2],C[0]),v[3]=ZC.BN(v[3],C[1])),0===Z)2===C.1h?e.en(C[0],C[1]):6===C.1h&&e.6y(C[0],C[1],C[2],ZC.ST(C[3]),ZC.ST(C[4]),C[5]);1t if(f&&(e.en(C[0],C[1]),f=!1),g||0===h||0===1b||4===C.1h||6===C.1h||7===C.1h)2===C.1h?e.ip(C[0],C[1]):4===C.1h?e.uN(C[0],C[1],C[2],C[3]):6===C.1h?e.6y(C[0],C[1],C[2],ZC.ST(C[3]),ZC.ST(C[4]),C[5]):7===C.1h&&e.ZF(C[0],C[1],C[2],C[3],C[4],C[5]);1t if(1c!==i[Z-1]){1a b=ZC.P.n4(i[Z-1],c,t,n),E=b[4===b.1h?2:0],m=b[4===b.1h?3:1],K=C[0],F=C[1],D=h+1b,I=K-E,X=F-m,x=1A.5B(I*I+X*X)+B;if(x>h){B=0;1a y;y="fC"===t.G8?1A.4i(ZC.2i(x/((D+t.AY+1b)/2))):1A.4i(ZC.2i(x/D));1a L=1A.nR(X,I),Y=1A.db(L),w=1A.dL(L),M=E,H=m,N=h;1k(A=0;A<y;A++)"fC"===t.G8&&(D=A%2?t.AY+1b:h+1b,N=A%2?t.AY:h),I=Y*D,X=w*D,e.en(M,H),e.ip(M+Y*N,H+w*N),M+=I,H+=X;e.en(M,H),(x=1A.5B((K-M)*(K-M)+(F-H)*(F-H)))>h?e.ip(M+Y*h,H+w*h):x>0&&e.ip(M+Y*x,H+w*x),e.en(K,F)}1t B=x}}1t f=!0;t.H&&d<=6&&n&&(t.H.E[t.K+"-cJ"]=v)}1P(c){1j"3a":e.oj=t.hY,e.3Y();1p;1j"2B":1j"3I":if(1c===ZC.1d(t.o["1u-3U"])&&t.H.O1&&(!n||t.E.sc)){if(s=t.E.sc?t.A0+"-"+t.AC+"-"+t.D8+"-"+t.AY+"-"+t.G8+"-"+t.C6+"-"+t.BJ+"-"+t.BD:t.B6+"-"+t.AY+"-"+t.G8+"-"+t.C6+"-"+t.BJ+"-"+t.BD,1c===ZC.1d(t.H.NT[a])){t.H.NT[a]={cL:s,bZ:e,2M:r,1H:t,aB:n};1p}if(t.H.NT[a].cL===s&&t.H.NT[a].2M.1h<ox){A=t.H.NT[a].2M,r&&r[0]&&(A.1h>0&&A[A.1h-1].1E(/[A-Z]+/,"")===r[0].1E(/[A-Z]+/,"")&&(r[0]=""),t.H.NT[a].2M=t.H.NT[a].2M.4w(r));1p}"2B"===c?ZC.CN.VN(t.H.NT[a].bZ,t.H.NT[a].1H,t.H.NT[a].2M.2I(" "),t.H.NT[a].aB):ZC.CN.VQ(t.H.NT[a].bZ,t.H.NT[a].1H,t.H.NT[a].2M.2I(" "),t.H.NT[a].aB),t.H.NT[a]={cL:s,bZ:e,2M:r,1H:t,aB:n};1p}"2B"===c?ZC.CN.VN(e,t,r.2I(" "),n,l):ZC.CN.VQ(e,t,r.2I(" "),n)}if(1c!==ZC.1d(t.o["1u-3U"])&&!t.Y3&&!t.E["b7-1u"]&&!t.VX){1a S=1n ZC.HQ(t.A);S.1Q(t),S.VX=!0,S.M3=!1,S.Z=t.Z,S.1C(t.o["1u-3U"]),S.K=t.K+"-1u",S.1q(),"2B"===c?ZC.CN.VN(e,S,r.2I(" "),n,l):"3I"===c?ZC.CN.VQ(e,S,r.2I(" "),n):ZC.CN.1v(e,S,i,n,a,l)}}}},mb:1f(e,t,i){1a n,a,l,o;ZC.1d(t)&&(t=!1),i=i||"h";1a r=[],C=[];1k(n=0,a=e.1h;n<a;n++)e[n]&&("h"===i?(C.1i(e[n][0]),r.1i(e[n][1])):(C.1i(e[n][1]),r.1i(e[n][0])),0===n&&(C.1i(C[0]),r.1i(r[0])));1k(C.1i(C[C.1h-1]),r.1i(r[r.1h-1]),e=[],l=1,o=r.1h;l<o-1;l++){1a A=[r[l-1],r[l],r[l+1],r[l+2]],s=ZC.2i(C[l+1]-C[l]),Z=1/(s/A.1h),c=ZC.AN.XZ(t,A,s,Z);1k(n=0,a=c.1h;n<a;n++)1c!==ZC.1d(c[n][0])&&1c!==ZC.1d(c[n][1])?"h"===i?e.1i([C[l]+c[n][0]*s,c[n][1]]):e.1i([c[n][1],C[l]+c[n][0]*s]):e.1i(1c)}1m e},mP:1f(e,t,i){t.H&&t.H.FW?(1c===ZC.1d(t.H.FW[e.id])&&(t.H.FW[e.id]=2e.rp()),t.H.FW[e.id].2X(i)):e.2X(i)},VN:1f(e,t,i,n,a){if(""!==i||a){1a l,o,r,C,A,s,Z;ZC.4b.1T["2B-5t"]||(ZC.4b.1T["2B-5t"]=ZC.P.F1("5t",ZC.1b[36])),l=a?ZC.4b.1T["2B-5t"].kP(!0):ZC.P.F1("2M",ZC.1b[36]);1a c={};if(t.DJ&&""!==t.DJ&&(c["3g"]=t.DJ),a||(c.d=i),a){t.I<0&&(t.iX-=t.I,t.I=-t.I),t.F<0&&(t.iY+=t.F,t.F=-t.F);1a u=0,p=0,h=1;t.CX&&(h=0,u=p=t.AY/2,0===t.iX&&(u=0),0===t.iY&&(p=0)),0===h||t.I<=3||t.F<=3?(o=1A.4i(t.iX)+u,r=1A.4i(t.iY)+p,C=1A.4h(t.I)-2*u,A=1A.4h(t.F)-2*u,s=t.F2,Z=t.F2):(o=5V(t.iX.4v(h))+u,r=5V(t.iY.4v(h))+p,C=5V(t.I.4v(h))-2*u,A=5V(t.F.4v(h))-2*p,s=t.F2,Z=t.F2),c.x=o,c.y=r,c[ZC.1b[19]]=ZC.BN(0,C),c[ZC.1b[20]]=ZC.BN(0,A),c.rx=s,c.ry=Z,t.H&&(t.H.E[t.K+"-cJ"]=[c.x,c.y,c.x+c[ZC.1b[19]],c.y+c[ZC.1b[20]]])}1a 1b="";1w t.K===ZC.1b[31]||""===t.K?1w t.H!==ZC.1b[31]&&(1b=t.H.qH+"-2M-"+ZC.bW,ZC.bW++):1b=t.K+"-2M";1a d="";if(1w t.BJ!==ZC.1b[31]&&1w t.BD!==ZC.1b[31]&&(0===t.BJ&&0===t.BD||(d+="7f("+t.BJ+" "+t.BD+")")),1w t.AA!==ZC.1b[31]&&0!==t.AA){1a f=t.AA;1w t.E.cx!==ZC.1b[31]&&(f+=","+(ZC.4t(t.E.cx)-.5)),1w t.E.cy!==ZC.1b[31]&&(f+=","+(ZC.4t(t.E.cy)-.5)),d+=" gb("+f+")"}n&&-1!==t.E.3f?(c.3f=t.E.3f,c["3f-3k"]=t.C6):c.3f="1Z",c["3Y-103"]=t.T0,c["3Y-104"]=t.ZU,t.AY>0&&(c.3Y=t.B6,c["3Y-1s"]=t.AY,c["3Y-3k"]=n?t.NU:t.C6,"2R"===t.G8||0===t.EW&&0===t.G4||("fC"===t.G8?c["3Y-oS"]=[t.EW,t.G4,t.AY,t.G4].2I(" "):c["3Y-oS"]=t.EW+","+t.G4)),l.id=1b,""!==d&&(c.5H=d),t.o["8u-1y"]&&t.AY>0?(l.4l("3Y",c.3Y),l.4l("3Y-1s",c["3Y-1s"]),l.4l("3Y-3k",c["3Y-3k"]),l.4l("d",i)):ZC.P.G2(l,c),ZC.CN.mP(e,t,l);1a g;if((!t.E.1F||"4q"===t.E.1F)&&1w t.E.5b!==ZC.1b[31])if("2Y"==1w t.E.5b)ZC.AK(1b+"-5b")||(g=a?ZC.P.F1("5t",ZC.1b[36]):ZC.P.F1("2M",ZC.1b[36]),ZC.P.G2(g,{id:1b+"-5b",5H:d,3f:t.E.5b,"3f-3k":t.C6}),a?ZC.P.G2(g,{x:o,y:r,1s:ZC.BN(0,C),1L:ZC.BN(0,A),rx:s,ry:Z}):ZC.P.G2(g,{d:i}),ZC.CN.mP(e,t,g));1t if(!ZC.AK(1b+"-5b")){1a B=t.E.5b,v=ZC.P.F1("4d",ZC.1b[36]);v.al?"zc."===t.D8.2s(0,3)?v.al(ZC.1b[37],"7K",ZC.bG[t.D8]):v.al(ZC.1b[37],"7K",t.D8):"zc."===t.D8.2s(0,3)?v.4l("4T",ZC.bG[t.D8]):v.4l("4T",t.D8),1c!==ZC.1d(t.E["3r-2M"])&&ZC.P.G2(v,{"3r-2M":"3P(#"+t.E["3r-2M"]+")"}),ZC.P.G2(v,{id:1b+"-5b",x:B[1],y:B[2],"3f-3k":t.C6,1s:t.E[ZC.1b[69]],1L:t.E[ZC.1b[70]],wl:"1Z"}),ZC.CN.mP(e,t,v)}}},VQ:1f(e,t,i,n){1a a;n&&(i+=" x e");1a l,o,r,C,A,s="";1w t.K===ZC.1b[31]||""===t.K?1w t.H!==ZC.1b[31]&&(s=t.H.qH+"-2M-"+ZC.bW,ZC.bW++):s=t.K+"-2M";1a Z=ZC.P.F1("7q:2P");Z.1H.2G="4A",Z.1H.o5=t.AA,Z.id=s;1a c=ZC.P.F1("7q:2M");if(c.v=i,c.4l("107",i),Z.2X(c),0===t.AY)Z.iL=!1;1t{1a u=ZC.P.F1("7q:3Y");if(r=t.C6,1w t.E.oa!==ZC.1b[31]&&(r=t.E.oa),1w t.E.3Y!==ZC.1b[31])l=t.E.3Y.7a,o=t.E.3Y.1r,r=t.E.3Y.3k,C=t.E.3Y.cg;1t{1P(C="2R",t.G8){1j"2R":C="2R";1p;1j"g1":C="nw";1p;1j"fX":C="ns";1p;2n:C=t.G8}"2R"!==C&&"0 0"!=(a=ZC.CV(6,t.EW*t.AY)+" "+ZC.CV(8,t.G4*t.AY))&&(C=a),l=t.AY,o=t.B6}ZC.P.G2(u,{7a:l+"px",1r:o,3k:r,10a:10,10c:"7M",10e:"43",cg:C}),Z.2X(u)}n&&1w t.E.3f!==ZC.1b[31]&&-1!==t.E.3f?(Z.aB=!0,Z.2X(t.E.3f)):Z.aB=!1,ZC.P.G2(Z,{uU:"0 0",uQ:t.AA%2j==0?"100 100":t.H.I+" "+t.H.F});1a p=0,h=0;if(t.AA%2j!=0&&1w t.E.cx!==ZC.1b[31]&&1w t.E.cy!==ZC.1b[31]){1a 1b=t.H.I/2-t.E.cx,d=t.H.F/2-t.E.cy,f=0===d?0:ZC.TF(1A.aA(1b/d));t.E.cy>t.H.F/2&&(f+=180);1a g=1A.5B(1b*1b+d*d);p=1b-g*ZC.EL(f-t.AA),h=d-g*ZC.ED(f-t.AA)}1a B=0-p;1c!==ZC.1d(t.BJ)&&(B+=t.BJ);1a v=0-h;if(1c!==ZC.1d(t.BD)&&(v+=t.BD),Z.1H.1J=B+"px",Z.1H.1u=v+"px",e.2X(Z),t.AA%2j==0?(Z.1H.1s="ax",Z.1H.1L="ax"):(Z.1H.1s=t.H.I+"px",Z.1H.1L=t.H.F+"px"),("4q"===t.E.1F||1w t.E.5b!==ZC.1b[31])&&1w t.E.5b!==ZC.1b[31]){1a b=t.E.5b;1===b.1h?((Z=ZC.P.F1("7q:2P")).1H.2G="4A",Z.1H.o5=t.AA,(c=ZC.P.F1("7q:2M")).v=i,Z.2X(c),Z.2X(b[0]),Z.iL=!1,ZC.P.G2(Z,{id:s+"-5b",aB:!0,uU:"0 0",uQ:t.AA%2j==0?"100 100":t.H.I+" "+t.H.F}),Z.1H.1J=B+"px",Z.1H.1u=v+"px",e.2X(Z),t.AA%2j==0?(Z.1H.1s="ax",Z.1H.1L="ax"):(Z.1H.1s=t.H.I+"px",Z.1H.1L=t.H.F+"px")):3===b.1h&&((A=ZC.P.F1("5U")).id=s+"-5U","zc."===t.D8.2s(0,3)?A.4T=ZC.bG[t.D8]:A.4T=t.D8,A.1H.2G="4A",A.1H.1J=b[1]+"px",A.1H.1u=b[2]+"px",A.1H.1s=t.E[ZC.1b[69]]+"px",A.1H.1L=t.E[ZC.1b[70]]+"px",e.2X(A))}}},ZC.DS=ZC.CZ.C7({$i:1f(e){1g.b(e);1a t=1g;t.A=e,t.Z=1c,t.C5=1c,t.GX="",t.iX=-1,t.iY=-1,t.DP="4x",t.D=[],t.CY=[0,0,0,0],t.AA=0,t.AH=0,t.KU=0,t.BJ=0,t.BD=0,t.sG=0,t.DR=0,t.B1=0,t.BH=2j,t.CK=0,t.TH=!1,t.108=!1,t.eU=0,t.q5="",t.O1=!1,t.lJ=1,t.JJ=1,t.E5=1c,t.FC=1c,t.IM="3e",t.K3=!1,t.hY="7d-tY",t.QQ=!1},aj:1f(){1a e=1g.b();1m 1g.ef(e,"Zi,x,y,2S,cJ,Zv,Yv,Yx,3P,2T,lg,j1,Zc,2b,w4,2c,2P,7M,4O","GX,iX,iY,D,CY,B1,BH,CK,E5,FC,BJ,BD,DR,AH,KU,AA,DP,K3,IM"),e},8e:1f(){},1Q:1f(e){1g.b(e);1a t,i,n=1g,a="BJ,BD,DR,AH,KU,AA,DP,K3,IM".2l(",");1k(t=0,i=a.1h;t<i;t++)1w e[a[t]]!==ZC.1b[31]&&(n[a[t]]=e[a[t]]);if(e.D&&e.D.1h>0)1k(n.D=[],t=0,i=e.D.1h;t<i;t++)n.D.1i(e.D[t])},h9:1f(e,t){1a i=1g;-1!==(""+e).1K("fd")&&(t="y"),-1!==(""+e).1K("fc")&&(t="x"),e=ZC.1W((""+e).1E("fd","").1E("fc",""));1a n=1o.4U.4U[i.eU];1m n&&(e=1o.4U.Zl(n.c5.x,n.c5.y,n.c5.1s,n.c5.1L,"x"===t?[e,0]:[0,e],n.c5.vX,{2Z:i.eU,1N:i.q5,3C:n.c5.3C,lg:n.c5.lg,j1:n.c5.j1},!0)),e=ZC.1l("x"===t?e[0]:e[1])},qs:1f(e,t){1a i,n=1g;-1!==(""+e).1K("8z")&&(t="y"),-1!==(""+e).1K("7U")&&(t="x"),e=ZC.1W((""+e).1E("7U","").1E("8z",""));1a a=n.H||1o.HP[0];if(a){1a l=n.A||a.AI[0];l&&("x"===t?1c!==(i=l.BT("k")[0])&&(e=ZC.1l(i.B2(e))):1c!==(i=l.BT("v")[0])&&(e=ZC.1l(i.B2(e))))}1m ZC.1l(e)},c6:1f(e,t,i){1a n=1g;t=t||"x";1a a=""+e;if(-1!==a.1K("fd")||-1!==a.1K("fc"))1m n.h9(e,t);if(-1!==a.1K("8z")||-1!==a.1K("7U"))1m n.qs(e,t);if(""+ZC.1W(e)!==a)1m-1!==(e+="").1K("%")?n.c6(5V(e.1E("%",""))/100,t,!0):-1!==e.1K("px")?n.c6(5V(e.1E("px","")),t):n.c6(5V(e),t);1a l=1w n.E["p-x"]!==ZC.1b[31]?n.E["p-x"]:n.A.iX,o=1w n.E["p-y"]!==ZC.1b[31]?n.E["p-y"]:n.A.iY,r=1w n.E["p-1s"]!==ZC.1b[31]?n.E["p-1s"]:n.A.I,C=1w n.E["p-1L"]!==ZC.1b[31]?n.E["p-1L"]:n.A.F;1m(e>=1||e<0||1o.3G.us)&&!i?"x"===t?l+5V(e):o+5V(e):e>=0&&e<1||i?"x"===t?(r=r||1,1A.43(l+r*e)):(C=C||1,1A.43(o+C*e)):8j 0},9p:1f(e){1a t,i=1g;if(i.TH)1m-1!==(""+i.o.x).1K("fc")?i.iX=i.h9(i.o.x,"x"):i.ZA("x","iX"),-1!==(""+i.o.y).1K("fd")?i.iY=i.h9(i.o.y,"y"):i.ZA("y","iY"),8j i.eN();1===e?(1c!==(t=ZC.1d(i.o.x))&&(i.iX=i.c6(t,"x")),1c!==(t=ZC.1d(i.o.y))&&(i.iY=i.c6(t,"y")),-1===i.iX&&(i.iX=i.A.iX),-1===i.iY&&(i.iY=i.A.iY)):2===e&&(i.eN(),i.I=i.CY[2]-i.CY[0],i.F=i.CY[3]-i.CY[1])},eN:1f(){1a e,t=1g,i=ZC.3q,n=ZC.3q,a=-ZC.3q,l=-ZC.3q;1P(t.DP){1j"5C":i=0,n=0,a=0,l=0;1p;1j"3x":1j"6y":1j"3L":i=t.iX-t.AH,n=t.iY-t.AH,a=t.iX+t.AH,l=t.iY+t.AH;1p;2n:1k(1a o=0,r=t.D.1h;o<r;o++)1c!==(e=t.D[o])&&(i=1A.2h(i,e[0]),n=1A.2h(n,e[1]),a=1A.1V(a,e[0]),l=1A.1V(l,e[1]))}t.CY=[i,n,a,l]},FB:1f(){1a e,t=1g;if("3L"===t.DP){1a i=1,n=[],a=t.B1+t.AA,l=t.BH+t.AA,o=t.AH+1A.4i(t.AQ/2),r=t.CK-1A.4i(t.AQ/2);1k(o>50&&(i=2),o>100&&(i=4),0===r?a%2j!=l%2j&&n.1i([t.iX,t.iY]):n.1i(ZC.AN.BM(t.iX,t.iY,r,a),ZC.AN.BM(t.iX,t.iY,(o+r)/2,a-.25*t.AQ),ZC.AN.BM(t.iX,t.iY,o,a)),e=a;e<=l;e+=i)n.1i(ZC.AN.BM(t.iX,t.iY,o,e));if(n.1i(ZC.AN.BM(t.iX,t.iY,o,l)),n.1i(ZC.AN.BM(t.iX,t.iY,(o+r)/2,l+.25*t.AQ)),0===r)a%2j!=l%2j&&n.1i([t.iX,t.iY]);1t{1k(n.1i(ZC.AN.BM(t.iX,t.iY,r,l)),e=l;e>=a;e-=i)n.1i(ZC.AN.BM(t.iX,t.iY,r,e));n.1i(ZC.AN.BM(t.iX,t.iY,r,a))}1m n.1i([n[0][0],n[0][1]]),ZC.AN.PO(n,1A.2h(5,o/5),[t.BJ,t.BD])}if(0===t.AA||"fA"!==t.DP&&"5t"!==t.DP)1m ZC.AN.PO(t.D,1A.2h(5,t.AH/5),[t.BJ,t.BD]);1a C,A,s,Z,c,u,p,h,1b=[];1k(s=ZC.1l((t.CY[0]+t.CY[2])/2),Z=ZC.1l((t.CY[1]+t.CY[3])/2),C=0,A=t.D.1h;C<A;C++)1c!==t.D[C]&&(c=t.D[C][0]-s,u=t.D[C][1]-Z,p=c*ZC.ED(t.AA)-u*ZC.EL(t.AA),h=c*ZC.EL(t.AA)+u*ZC.ED(t.AA),1b[C]=[p+s,h+Z]);1m ZC.AN.PO(1b,1A.2h(5,t.AH/5),[t.BJ,t.BD])},lL:1f(){1a e,t,i,n,a,l,o,r,C,A=1g,s=ZC.6O?ZC.3y:0;1P(A.DP){1j"1y":if(i=[].4w(A.D),0!==A.AA)1k(n=(A.CY[0]+A.CY[2])/2,a=(A.CY[1]+A.CY[3])/2,e=0,t=i.1h;e<t;e++)1c!==i[e]&&(l=i[e][0]-n,o=i[e][1]-a,r=l*ZC.ED(A.AA)-o*ZC.EL(A.AA),C=l*ZC.EL(A.AA)+o*ZC.ED(A.AA),i[e]=[r+n,C+a]);1a Z=["4x"];1k(e=0,t=i.1h;e<t-1;e++)1c!==i[e]&&1c!==i[e+1]&&Z.1i(ZC.AN.PO(ZC.AN.YU([i[e],i[e+1]]),4,[A.BJ,A.BD]));1m Z;1j"9u":1j"8n":1m["3x",ZC.1l(A.iX+s+A.BJ)+","+ZC.1l(A.iY+s+A.BD)+","+ZC.1l(A.AH)];1j"3x":1j"6y":1m["3x",ZC.1l(A.iX+s+A.BJ)+","+ZC.1l(A.iY+s+A.BD)+","+ZC.1l(A.AH+2)];1j"3L":1m["4x",A.FB()];2n:1a c,u=["4x"];1k(i=[],e=0,t=A.D.1h;e<t;e++)if(1c!==A.D[e])if(6===A.D[e].1h)1k(1a p=A.D[e][3];p<A.D[e][4];p+=1)i.1i(ZC.AN.BM(A.D[e][0],A.D[e][1],A.D[e][2],p));1t if(4===A.D[e].1h&&i[e-1]){1a h={x:i[i.1h-1][0],y:i[i.1h-1][1]},1b={x:A.D[e][2],y:A.D[e][3]},d={x:A.D[e][0],y:A.D[e][1]};1k(c=0;c<=1;c+=.1)i.1i([(1-c)*(1-c)*h.x+2*c*(1-c)*d.x+c*c*1b.x,(1-c)*(1-c)*h.y+2*c*(1-c)*d.y+c*c*1b.y])}1t if(7===A.D[e].1h&&i[e-1]){1a f={x:i[i.1h-1][0],y:i[i.1h-1][1]},g={x:A.D[e][0],y:A.D[e][1]},B={x:A.D[e][2],y:A.D[e][3]},v={x:A.D[e][4],y:A.D[e][5]};1k(c=0;c<=1;c+=.1){1a b=(1-c)*(1-c)*(1-c),E=3*c*(1-c)*(1-c),m=3*c*c*(1-c),K=c*c*c;i.1i([b*f.x+E*g.x+m*B.x+K*v.x,b*f.y+E*g.y+m*B.y+K*v.y])}}1t i.1i(A.D[e]);1t i.1h>-1&&u.1i(ZC.AN.PO(i,1A.2h(5,A.AH/5),[A.BJ,A.BD])),i=[];if(0!==A.AA)1k(n=ZC.1l((A.CY[0]+A.CY[2])/2),a=ZC.1l((A.CY[1]+A.CY[3])/2),e=0,t=i.1h;e<t;e++)1c!==i[e]&&(l=i[e][0]-n,o=i[e][1]-a,r=l*ZC.ED(A.AA)-o*ZC.EL(A.AA),C=l*ZC.EL(A.AA)+o*ZC.ED(A.AA),i[e]=[r+n,C+a]);1m i.1h>-1&&u.1i(ZC.AN.PO(i,1A.2h(5,A.AH/5),[A.BJ,A.BD])),u}},1q:1f(e){1a t,i,n,a,l,o,r;1c===ZC.1d(e)&&(e=!1),1g.o.cX||e||1g.b();1a C=1g;if(!C.o.cX&&!e){C.4y([["2Z","eU"]]),"2Y"==1w C.o.1N&&C.4y([["1N","q5"]]),0!==C.eU&&(1c===ZC.1d(C.o["2Z-1N"])||C.o["2Z-1N"])&&(C.o["2Z-1N"]=!0,C.o["2Z-b7-z-3V"]=!0);1a A=["1Y-x","1Y-y"];1k(i=0;i<2;i++){1a s=A[i],Z="1Y-x"===s?"fc":"fd";if(1c!==(t=C.o[s])&&1w t!==ZC.1b[31]&&-1!==(t=""+t).1K(Z)){t=ZC.1W(t.1E(Z,""));1a c=1o.4U.4U[C.eU];c&&(t=1o.4U.7f(s.1E("1Y-"),t,C.A.I,C.A.F,c.c5.vX),C.o[s]=t)}}1k(C.4y([["3P","E5"],["2T","FC"],["4O","IM"],["id","GX"],["2c","AA","i"],["8F","K3","b"],["7M","K3","b"],[ZC.1b[1],"B1","f"],[ZC.1b[2],"BH","f"],[ZC.1b[8],"CK","i"],[ZC.1b[21],"AH","f"],["2b-2","KU","f"],["8u-dZ-2M","QQ","b"],["1I","DP"],["2S","D"],["1Y-x","BJ"],["1Y-y","BD"],["1Y-z","sG","i"],["1Y-r","DR","i"],["z-3V","lJ","i"],["z-2V","JJ","f"],["10N","hY"]]),C.BJ=ZC.IB(C.BJ,!0),C.BD=ZC.IB(C.BD,!0),C.BJ>-1&&C.BJ<1&&1w C.E["p-1s"]!==ZC.1b[31]&&(C.BJ*=C.E["p-1s"]),C.BD>-1&&C.BD<1&&1w C.E["p-1L"]!==ZC.1b[31]&&(C.BD*=C.E["p-1L"]),C.AH=ZC.BN(1,C.AH),C.KU=ZC.BN(1,C.KU),1c!==C.o["z-3V"]&&1w C.o["z-3V"]!==ZC.1b[31]||(C.lJ=C.JJ),"fA"!==C.DP&&"5t"!==C.DP||C.4y([[ZC.1b[19],"AH","f"],[ZC.1b[20],"KU","f"]]),C.lG?(C.D=3c.1q(3c.5d(C.F8)),C.lG=!1):C.F8=3c.1q(3c.5d(C.D)),i=0,n=C.D.1h;i<n;i++)if(1c!==C.D[i])1k(1a u=0;u<C.D[i].1h;u++)-1===(""+C.D[i][u]).1K("fd")&&-1===(""+C.D[i][u]).1K("fc")||(C.lG=!0,C.D[i][u]=C.h9(C.D[i][u],u%2==0?"x":"y")),-1===(""+C.D[i][u]).1K("7U")&&-1===(""+C.D[i][u]).1K("8z")||(C.lG=!0,C.D[i][u]=C.qs(C.D[i][u],u%2==0?"x":"y"))}if(C.o.cX=1c,C.AA=C.AA%2j,C.9p(1),"2Q"!==C.DP){1a p=C.AH;1P(C.DP){1j"5C":1p;1j"Af":p=C.AH;1a h=.1*C.AH;C.D=[[C.iX-p,C.iY+p-h],[C.iX,C.iY-p-h],[C.iX+p,C.iY+p-h],[C.iX-p,C.iY+p-h]];1p;1j"9o":p=ZC.1l(.9*C.AH),C.D=[[C.iX-p,C.iY-p],[C.iX-p,C.iY+p],[C.iX+p,C.iY+p],[C.iX+p,C.iY-p],[C.iX-p,C.iY-p]];1p;1j"Ah":p=ZC.1l(1.2*C.AH),C.D=[[C.iX-p,C.iY],[C.iX,C.iY+p],[C.iX+p,C.iY],[C.iX,C.iY-p],[C.iX-p,C.iY]];1p;1j"11b":C.D=[[C.iX-p/2,C.iY+C.KU],[C.iX+p/2,C.iY+C.KU],[C.iX+p,C.iY-C.KU],[C.iX-p,C.iY-C.KU],[C.iX-p/2,C.iY+C.KU]];1p;1j"fA":1j"5t":C.D=[[C.iX-p/2,C.iY-C.KU/2],[C.iX+p/2,C.iY-C.KU/2],[C.iX+p/2,C.iY+C.KU/2],[C.iX-p/2,C.iY+C.KU/2],[C.iX-p/2,C.iY-C.KU/2]];1p;1j"10L":C.D=[[C.iX-p/2,C.iY-C.KU/2],[C.iX+3*p/2,C.iY-C.KU/2],[C.iX+p,C.iY+C.KU/2],[C.iX-p,C.iY+C.KU/2],[C.iX-p/2,C.iY-C.KU/2]];1p;1j"8n":p=C.AH,C.D=[[C.iX,C.iY-p],[C.iX,C.iY+p],1c,[C.iX-p,C.iY],[C.iX+p,C.iY]];1p;1j"9u":p=C.AH,C.D=[[C.iX-p,C.iY-p],[C.iX+p,C.iY+p],1c,[C.iX-p,C.iY+p],[C.iX+p,C.iY-p]];1p;1j"bk":p=C.AH/4,C.D=[[C.iX-2*p,C.iY+p],[C.iX-p,C.iY],[C.iX,C.iY+p],[C.iX+p,C.iY-p],[C.iX+2*p,C.iY]];1p;1j"10r":p=C.AH/4,C.D=[[C.iX-2*p,C.iY+2*p],[C.iX-2*p,C.iY+p],[C.iX-p,C.iY],[C.iX,C.iY+p],[C.iX+p,C.iY-p],[C.iX+2*p,C.iY],[C.iX+2*p,C.iY+2*p],[C.iX-2*p,C.iY+2*p]];1p;1j"10v":C.CX=!1,p=C.AH/4,C.D=[[C.iX-2*p,C.iY+2*p],[C.iX-2*p,C.iY-p],[C.iX-p,C.iY-p],[C.iX-p,C.iY+2*p],[C.iX-2*p,C.iY+2*p],[C.iX-2*p,C.iY+2*p-p],1c,[C.iX-p/2,C.iY+2*p],[C.iX-p/2,C.iY],[C.iX+p/2,C.iY],[C.iX+p/2,C.iY+2*p],[C.iX-p/2,C.iY+2*p],[C.iX-p/2,C.iY+2*p-p],1c,[C.iX+2*p,C.iY+2*p],[C.iX+2*p,C.iY-2*p],[C.iX+p,C.iY-2*p],[C.iX+p,C.iY+2*p],[C.iX+2*p,C.iY+2*p],[C.iX+2*p,C.iY+2*p-p]];1p;1j"7G":p=2*C.AH;1a 1b=C.AA;C.AA=0;1a d=ZC.AN.BM(C.iX,C.iY,p,1b-35),f=ZC.AN.BM(C.iX,C.iY,p,1b+35);C.D=[[C.iX,C.iY],d,1c,[C.iX,C.iY],f];1p;1j"10x":1j"10B":1j"Ac":1j"10D":1j"10I":1j"10J":1j"10K":1k(C.D=[],p=2*C.AH,l=2j/(a=ZC.1l(C.DP.1E("ys",""))),o=a%2==0?0:-90,r=p/(a>4?2:7-a),i=0+o;i<2j+o;i+=l)C.D.1i(ZC.AN.BM(C.iX,C.iY,.75*p,i),ZC.AN.BM(C.iX,C.iY,.75*r,i+l/2));C.D.1i([C.D[0][0],C.D[0][1]]);1p;1j"10m":1j"Ys":1j"Vw":1j"VY":1j"W3":1j"Wb":1j"Wf":1k(C.D=[],p=C.AH,l=2j/(a=ZC.1l(C.DP.1E("Wg",""))),o=a%2==0?0:-90,1c!==ZC.1d(C.o["2c-1Y"])&&(o=ZC.1l(C.o["2c-1Y"])),i=0+o;i<2j+o;i+=l)C.D.1i(ZC.AN.BM(C.iX,C.iY,p,i));C.D.1i([C.D[0][0],C.D[0][1]]);1p;1j"Wi":1j"Wn":1j"Vr":1j"vg":1j"Va":1j"Vb":1j"Vc":1k(C.D=[],p=2*C.AH,l=2j/(2*(a=ZC.1l(C.DP.1E("aU","")))),r=.75*p,i=0+(o=a%2==0?0:-90);i<2j+o;i+=2*l){1a g=i+l/2;C.D.1i(ZC.AN.BM(C.iX,C.iY,.75*p,g),ZC.AN.BM(C.iX,C.iY,.75*p,g+l),ZC.AN.BM(C.iX,C.iY,.75*r,g+l+0*l),ZC.AN.BM(C.iX,C.iY,.75*r,g+2*l-0*l))}C.D.1i([C.D[0][0],C.D[0][1]]);1p;1j"nn":p*=2;1a B=C.iX,v=C.iY-10;C.D=C.D.4w([[B-p/2,v-C.KU/2],[B+p/2,v-C.KU/2],[B+p/2,v+C.KU/2],[B-p/2,v+C.KU/2],[B-p/2,v-C.KU/2],1c]),v+=5,C.D=C.D.4w([[B-p/2,v-C.KU/2],[B+p/2,v-C.KU/2],[B+p/2,v+C.KU/2],[B-p/2,v+C.KU/2],[B-p/2,v-C.KU/2],1c]),v+=5,C.D=C.D.4w([[B-p/2,v-C.KU/2],[B+p/2,v-C.KU/2],[B+p/2,v+C.KU/2],[B-p/2,v+C.KU/2],[B-p/2,v-C.KU/2],1c]);1p;1j"Vf":1k(C.CX=!1,C.D=[],i=0;i<=2j;i+=5)C.D.1i([C.iX+C.AH*ZC.ED(i),C.iY+C.KU*ZC.EL(i)]);C.D.1i([C.D[0][0],C.D[0][1]]);1p;1j"6y":C.CX=!1,C.D=[ZC.AN.BM(C.iX,C.iY,C.AH,C.B1),[C.iX,C.iY,C.AH,C.B1,C.BH,0]];1p;1j"3L":1k(1a b=(C.o["3L-5H"]||"").2l(/=|,/);C.B1<0||C.BH<0;)C.B1+=2j,C.BH+=2j;C.CX=!1;1a E=!1;-1!==ZC.AT(["2B","3I"],C.H.AB)&&C.B1%2j==C.BH%2j&&(C.B1+=.hE,C.BH-=.hE,E=!0);1a m,K,F,D,I,X=C.iX,x=C.iY,y=ZC.4t(C.B1,2),L=ZC.4t(C.BH,2),Y=ZC.4t((y+L)/2,2),w=p,M=C.CK,H=0===M&&y%2j!=L%2j&&!E;1P(C.D=[],"3x"!==b[0]&&(0===M?y%2j==L%2j||E||C.D.1i([X,x]):C.D.1i(ZC.AN.BM(X,x,M,y))),b[0]){1j"7M":1j"vw":C.D.1i(ZC.AN.BM(X,x,w,y),ZC.AN.BM(X,x,w-("vw"===b[0]?ZC.1l(b[1]):0),L)),H||C.D.1i(ZC.AN.BM(X,x,M,L));1p;1j"6B":C.D.1i(ZC.AN.BM(X,x,w,y),[X,x,w,y,L,0]),H||(m=1.5*ZC.1l(b[1])*2j/(2*1A.PI*w),C.D.1i(ZC.AN.BM(X,x,w,L),ZC.AN.BM(X,x,M,L),[X,x,M,L,Y+m,1],ZC.AN.BM(X,x,M-ZC.1l(b[1]),Y),ZC.AN.BM(X,x,M,Y-m),[X,x,M,Y-m,y,1]));1p;1j"Vk":m=ZC.1l(b[1]),D=ZC.AN.BM(X,x,(M+w)/2,y),99===m||-99===m?C.D.1i([D[0],D[1],(w-M)/2,y+180,y,99===m?1:0]):C.D.1i(ZC.AN.BM(X,x,(M+w)/2,y+m)),C.D.1i(ZC.AN.BM(X,x,w,y),[X,x,w,y,L,0]),I=ZC.AN.BM(X,x,(M+w)/2,L),H?99===m||-99===m?C.D.1i(ZC.AN.BM(X,x,w,L),[I[0],I[1],(w-M)/2,L,L+180,99===m?0:1]):C.D.1i(ZC.AN.BM(X,x,(M+w)/2,L+m)):(99===m||-99===m?C.D.1i([I[0],I[1],(w-M)/2,L,L+180,99===m?0:1]):C.D.1i(ZC.AN.BM(X,x,(M+w)/2,L+m)),C.D.1i(ZC.AN.BM(X,x,M,L),[X,x,M,L,y,1]));1p;1j"3x":1a N=ZC.1W(b[1]||"1"),S=(5+ZC.2i(L-y)%2j*50/2j)*N;F=L%2j==y%2j||E?[X,x]:ZC.AN.BM(X,x,(w+M)/2,(y+L)/2),C.D.1i(ZC.AN.BM(F[0],F[1],S,0),[F[0],F[1],S,0,2j,0]);1p;1j"Vo":m=ZC.1l(b[1]),K=ZC.1l(2*w*ZC.EL(m/2)),F=ZC.AN.BM(X,x,w,y),C.D.1i(ZC.AN.BM(X,x,w-K,y),[F[0],F[1],K,y+180,y+90+(90-(180-m)/2),1],[X,x,w,y+m,L,0]),H||C.D.1i(ZC.AN.BM(X,x,M,L),[X,x,M,L,y,1]);1p;1j"Vs":1k(1a O=w,P=1,k=0;w*P+k>=O;)P=ZC.4t(P-.sP,2),K=ZC.1l(w*P/ZC.ED((L-y)/2)),k=ZC.1l(w*P*1A.Xv(ZC.ST((L-y)/2)));F=ZC.AN.BM(X,x,K,Y),C.D.1i(ZC.AN.BM(X,x,w*P,y),[F[0],F[1],k,Y-(2j-(180-(L-y)))/2,Y+(2j-(180-(L-y)))/2,0]),H||C.D.1i(ZC.AN.BM(X,x,M,L),[X,x,M,L,y,1]);1p;2n:C.D.1i(ZC.AN.BM(X,x,w,y),[X,x,w,y,L,0]),0===M?y%2j==L%2j||E||C.D.1i([X,x]):C.D.1i(ZC.AN.BM(X,x,w,L),ZC.AN.BM(X,x,M,L),[X,x,M,L,y,1])}C.D.1i([C.D[0][0],C.D[0][1]])}}C.9p(2)},1v:1f(){1a e=1g;if("1Z"!==e.DP&&("5C"===e.DP||"3x"===e.DP||"6y"===e.DP||0!==e.D.1h)){1a t,i,n={x:"iX",y:"iY",1s:"I",1L:"F",2b:"AH"};if(e.o["2a-3U"]&&!e.Y3&&!e.VX&&!e.g7){1a a=1n ZC.DS(e.A);a.1Q(e),a.g7=!0,a.M3=!1,a.Z=e.Z,a.1C(e.o["2a-3U"]),a.K=e.K+"-2a",a.1q(),i=!1;1k(t in n)1c===ZC.1d(a.o[t])||-1===(""+a.o[t]).1K("+")&&-1===(""+a.o[t]).1K("-")||(a.o[t]=a[n[t]]=e[n[t]]+ZC.1l(a.o[t])),i&&a.1q();a.1v()}1a l=e.H.AB;1P(e.M3&&e.C5&&e.m3(),l){1j"3a":e.fG();1p;1j"2B":e.VN();1p;1j"3I":e.VQ()}if(e.o["1u-3U"]&&!e.Y3&&!e.VX&&!e.g7){1a o=1n ZC.DS(e.A);o.1Q(e),o.VX=!0,o.M3=!1,o.Z=e.Z,o.1C(e.o["1u-3U"]),o.K=e.K+"-1u",o.1q(),i=!1;1k(t in n)1c===ZC.1d(o.o[t])||-1===(""+o.o[t]).1K("+")&&-1===(""+o.o[t]).1K("-")||(o.o[t]=o[n[t]]=e[n[t]]+ZC.1l(o.o[t]),i=!0);i&&o.1q(),o.1v()}}},m3:1f(){1a e,t=1g,i=1n ZC.DS(t.A);i.K=t.K+"-sh",i.1Q(t),i.O1=t.O1,i.Z=t.C5,i.M3=!1,i.Y3=!0,i.A0=i.AC=i.RW,i.GK=i.HE="",i.D8="",i.G8="2R",i.BU=i.RW,i.AY=0,i.C6=i.SY*t.C6,i.K=t.K+"-sh";1a n=(t.JP-t.P5)*ZC.ED(t.OB)+t.P5,a=(t.JP-t.P5)*ZC.EL(t.OB)+t.P5;if(i.iX=t.iX+5w(n,10),i.iY=t.iY+5w(a,10),i.AH=t.AH+t.P5,t.D.1h>0){e=[];1k(1a l=0,o=t.D.1h;l<o;l++)if(1c!==t.D[l]){1k(1a r=[],C=0;C<t.D[l].1h;C++)r[C]=t.D[l][C];r[0]=t.D[l][0]+5w(n,10),r[1]=t.D[l][1]+5w(a,10),e.1i(r)}1t e.1i(1c)}i.CY=[t.CY[0]+n,t.CY[1]+a,t.CY[2]+n,t.CY[3]+a],i.D=e,i.1v()},oh:1f(){1a e=1g;1m{lc:"-1"===e.B6?"9D(3R,3R,3R,0)":1===e.C6?e.B6:ZC.AO.ea(ZC.AO.G3(e.B6),e.C6),bc:"-1"===e.BU?"9D(3R,3R,3R,0)":1===e.NU?e.BU:ZC.AO.ea(ZC.AO.G3(e.BU),e.NU),pi:"-1"===e.A0?"9D(3R,3R,3R,0)":1===e.C6?e.A0:ZC.AO.ea(ZC.AO.G3(e.A0),e.C6),p3:"-1"===e.AC?"9D(3R,3R,3R,0)":1===e.C6?e.AC:ZC.AO.ea(ZC.AO.G3(e.AC),e.C6)}},XW:1f(e){1a t,i,n,a=1g;1P(a.DP){1j"3x":1j"6y":1j"3L":t=a.iX,i=a.iY,n=a.AH;1p;2n:t=a.CY[0]+(a.CY[2]-a.CY[0])/2,i=a.CY[1]+(a.CY[3]-a.CY[1])/2,n=ZC.2i(ZC.ED(a.N1)*(a.CY[2]-a.CY[0])/2+ZC.EL(a.N1)*(a.CY[3]-a.CY[1])/2)}ZC.P2(t)||(t=0),ZC.P2(i)||(i=0),ZC.P2(n)||(n=0);1a l=a.VR,o=a.VS;if(ZC.2i(l)<=1&&(l=l*(a.CY[2]-a.CY[0])/2),ZC.2i(o)<=1&&(o=o*(a.CY[3]-a.CY[1])/2),t+=l,i+=o,"8x"===e)1m{cx:t,cy:i,r:ZC.2i(n)};if("9l"===e){1a r=n*ZC.ED(a.N1),C=n*ZC.EL(a.N1),A=t-r,s=i-C,Z=t+r,c=i+C;1m ZC.1l(s)===ZC.1l(c)&&ZC.2i(Z-A)<5&&(c+=1),ZC.1l(A)===ZC.1l(Z)&&ZC.2i(c-s)<5&&(Z+=1),{x1:A,y1:s,x2:Z,y2:c}}},R4:1f(){1a e,t=1g;ZC.4b.1T[t.D8]?e=ZC.4b.1T[t.D8]:((e=1n cV).4T=t.D8,ZC.4b.1T[t.D8]=e),1!==t.KJ&&(e.nG?(e.1s=e.nG,e.1L=e.wf):(e.nG=e.1s,e.wf=e.1L));1a i,n;1P(i=e.1s*t.KJ,n=e.1L*t.KJ,t.WK){1j"x":i=t.I;1p;1j"y":n=t.F;1p;1j"xy":1j"Yi":i=t.I,n=t.F}1a a,l,o,r,C=t.T2.2l(" "),A=C[0]||"",s=0,Z=0;1P(A){1j"":1j"1J":a=0,s=0;1p;1j"3E":a=(t.I-i)/2,s=.5;1p;1j"2x":a=t.I-i,s=1;1p;2n:-1!==A.1K("%")?(s=ZC.1l(A.1E(/[^0-9\\-]/g,""))/100,a=(t.I-i)*s):(s=ZC.1l(A.1E(/[^0-9\\-]/g,""))/t.I,a=ZC.1l(A.1E(/[^0-9\\-]/g,"")))}o=a/t.I,1w t.KN!==ZC.1b[31]?a+=t.iX+t.BJ:a+=t.CY[0]+t.BJ;1a c=C[1]||"";1P(c){1j"":1j"1u":l=0,Z=0;1p;1j"6o":l=(t.F-n)/2,Z=.5;1p;1j"2a":l=t.F-n,Z=1;1p;2n:-1!==c.1K("%")?(Z=ZC.1l(c.1E(/[^0-9\\-]/g,""))/100,l=(t.F-n)*Z):(Z=ZC.1l(c.1E(/[^0-9\\-]/g,""))/t.F,l=ZC.1l(c.1E(/[^0-9\\-]/g,"")))}if(r=l/t.F,1w t.KN!==ZC.1b[31]?l+=t.iY+t.BD:l+=t.CY[1]+t.BD,"3L"===t.DP){1a u=t.AA+t.B1+(t.BH-t.B1)*s,p=ZC.AN.BM(t.iX,t.iY,t.CK+(t.AH-t.CK)*Z,u);a=p[0]-e.1s/2,l=p[1]-e.1L/2}1m t.E[ZC.1b[69]]=i,t.E[ZC.1b[70]]=n,{4d:e,x:ZC.1l(a)+.5,y:ZC.1l(l)+.5,cx:ZC.1W(o),cy:ZC.1W(r),wp:s,wq:Z}},Z8:1f(e){1k(1a t=1g,i=t.GK.2l(/\\s+|;/),n=t.HE.2l(/\\s+|;/),a=0,l=i.1h;a<l;a++){1a o=ZC.AO.G3(i[a],t);"4g"!=1w o&&(o=[o,t.C6]);1a r=ZC.AO.ea(o[0],o[1]),C=ZC.1W(n[a]||"1");ZC.DU(C,0,1)||(C=1),e.hQ(C,r)}},fG:1f(){1a e,t,i,n,a,l,o,r,C=1g,A=C.Z.9j("2d");A.gS(),"4x"===C.DP||"1y"===C.DP?(t=C.CY[0]+(C.CY[2]-C.CY[0])/2,i=C.CY[1]+(C.CY[3]-C.CY[1])/2):(t=C.iX,i=C.iY);1a s=C.oh(),Z=s.lc,c=s.bc,u=s.pi,p=s.p3;if(u!==p||""!==C.GK&&""!==C.HE){1a h=C.XW(C.NB);"8x"===C.NB?n=A.v6(h.cx,h.cy,1,h.cx,h.cy,h.r):"9l"===C.NB&&(n=A.v7(h.x1,h.y1,h.x2,h.y2)),""!==C.GK&&""!==C.HE?C.Z8(n):(n.hQ(0,u),n.hQ(1,p)),A.cU=n}1t""!==C.D8&&-1!==ZC.AT(["6G","hR",!0],C.LZ)&&"-1"===C.A0&&"-1"===C.AC&&(u="9D(3R,3R,3R,0)"),A.cU=u;1P(C.DP){1j"5C":if((e=C.o.3P)&&(ZC.4b.1T[e]?a=ZC.4b.1T[e]:((a=1n cV).4T=e,ZC.4b.1T[e]=a),a.1s=C.o[ZC.1b[19]]?C.o[ZC.1b[19]]:a.1s,a.1L=C.o[ZC.1b[20]]?C.o[ZC.1b[20]]:a.1L,A.cM(a,C.iX-a.1s/2+C.BJ,C.iY-a.1L/2+C.BD,a.1s,a.1L),0===u.1K("#")&&7===u.1h)){1k(1a 1b=5w(u.2s(1,3),16),d=5w(u.2s(3,5),16),f=5w(u.2s(5,7),16),g=A.Yk(C.iX-a.1s/2+C.BJ,C.iY-a.1L/2+C.BD,a.1s,a.1L),B=0;B<g.1T.1h;B+=4)g.1T[B]=1b|g.1T[B],g.1T[B+1]=d|g.1T[B+1],g.1T[B+2]=f|g.1T[B+2];A.Ym(g,C.iX-a.1s/2+C.BJ,C.iY-a.1L/2+C.BD)}1p;1j"8n":1j"9u":1j"1y":1j"bk":1j"6y":A.mG=Z,A.cY=C.AY;1p;2n:A.mG=c,A.cY=C.AQ}0!==C.AA&&(A.7f(t,i),8a(C.AA)||A.gb(ZC.ST(C.AA)),A.7f(-t,-i));1a v=-1===ZC.AT(["9u","8n","6y","1y","bk"],C.DP);1P(8a(C.BJ)||8a(C.BD)||0===C.BJ&&0===C.BD||!v&&"6y"!==C.DP||A.7f(C.BJ,C.BD),A.mF(),C.DP){1j"3x":1j"6y":A.mq&&"3x"===C.DP&&(C.KS(C.AQ),A.mq(0===C.EW||0===C.G4?[]:[C.EW,C.G4])),A.6y(C.iX,C.iY,C.AH,ZC.ST(C.B1),ZC.ST(C.BH),!1);1p;1j"1y":1p;2n:-1!==ZC.AT(["9o","8n"],C.DP)&&(C.OG=!0),ZC.CN.kd(A,C,C.D),-1!==ZC.AT(["9o","8n"],C.DP)&&(C.OG=!1)}if(A.oj=C.hY,v)if(""!==C.D8&&-1===ZC.AT(ZC.gs,C.D8)){A.3f(),A.gS(),A.3r();1a b;b=A.da,A.da=C.C6;1a E=C.R4();1P(a=E.4d,C.LZ){1j"6G":1j!0:1j"hR":l=C.CY[0]-(a.1s-(C.CY[2]-C.CY[0]))/2,o=C.CY[1]-(a.1L-(C.CY[3]-C.CY[1]))/2,A.7f(l,o),r=A.uA(a,"6G"),A.cU=r,A.3f(),A.7f(-l,-o);1p;1j"no-6G":1j!1:1j"dk":A.cM(a,E.x-C.BJ,E.y-C.BD,C.E[ZC.1b[69]],C.E[ZC.1b[70]])}A.da=b,A.hx()}1t A.3f();1P(A.mE(),A.mF(),C.DP){1j"3x":1j"6y":A.6y(C.iX,C.iY,C.AH,ZC.ST(C.B1),ZC.ST(C.BH),!1),("3x"===C.DP&&C.AQ>0||"6y"===C.DP&&C.AY>0)&&A.3Y(),A.mE();1p;1j"8n":1j"9u":1j"1y":1j"bk":C.AY>0&&(ZC.CN.2E(A,C),C.o.4V?(C.CX=!1,C.QQ=!0,ZC.CN.1v(A,C,ZC.CN.mb(C.D,!1,C.o.bB||"h"))):ZC.CN.1v(A,C,C.D));1p;2n:if(C.AQ>0){1a m=C.B6,K=C.AY;C.B6=C.BU,C.AY=C.AQ,C.KS(),ZC.CN.2E(A,C),ZC.CN.1v(A,C,C.D,!0),C.B6=m,C.AY=K,C.KS()}A.mE()}A.hx()},oV:1f(e){1a t=1g,i=e.6w,n=i.4d,a=!0;1P(t.LZ){2n:a=!0;1p;1j"no-6G":1j"dk":1j!1:a=!1}1a l=t.D8;0===n.4T.1K("1T:")&&(l=n.4T),n.1s*=t.KJ,n.1L*=t.KJ;1a o=""===t.K?"8Q-"+ZC.bW++:t.K+"-8Q";ZC.P.ES(o);1a r=ZC.P.F1("4d",ZC.1b[36]);r.al?r.al(ZC.1b[37],"7K",l):r.4l("4T",l),ZC.P.G2(r,{id:o+"-4d",wl:"1Z",1s:t.E[ZC.1b[69]],1L:t.E[ZC.1b[70]]});1a C=n.1s,A=n.1L;if(!a){C=A=1;1a s,Z;t.I>0&&t.F>0?(s=t.I,Z=t.F):(s=t.CY[2]-t.CY[0],Z=t.CY[3]-t.CY[1]);1a c=ZC.1l(s*i.cx),u=ZC.1l(Z*i.cy);if("3L"===t.DP){C=t.H?t.H.I:t.A.I,A=t.H?t.H.F:t.A.F;1a p=t.AA+t.B1+(t.BH-t.B1)*i.wp,h=ZC.AN.BM(t.iX,t.iY,t.CK+(t.AH-t.CK)*i.wq,p);c=h[0]-n.1s/2,u=h[1]-n.1L/2}t.E["8Q-4d-id"]=o+"-4d",t.E["8Q-tx"]=c,t.E["8Q-ty"]=u,ZC.P.G2(r,{5H:"7f("+c+","+u+")"})}1a 1b=ZC.P.F1("8Q",ZC.1b[36]);ZC.P.G2(1b,{x:a?e.x:0,y:a?e.y:0,1s:C,1L:A,id:o,Wt:a||"3L"===t.DP?"wr":"Wu"}),t.H.K8.6W[0].2X(1b),1b.2X(r),t.E.5b="3P(#"+o+")"},WR:1f(e){1c!==e&&1w e!==ZC.1b[31]||(e=!1);1a t,i,n=1g;if(n.A0!==n.AC||""!==n.GK&&""!==n.HE){1a a=""===n.K?"4Y-"+ZC.bW++:n.K+"-4Y";(n.TH||e&&!ZC.AK(a))&&(e=!1),ZC.A4.6A.a6&&9===ZC.1l(ZC.A4.6A.af)&&(e=!1),ZC.AK(a)&&!e&&ZC.P.ES(a);1a l=n.XW(n.NB);if("8x"===n.NB?(t=e?ZC.AK(a):ZC.P.F1("Ww",ZC.1b[36]),ZC.P.G2(t,{cx:ZC.1l(l.cx),cy:ZC.1l(l.cy),r:ZC.1l(l.r),fx:ZC.1l(l.cx),fy:ZC.1l(l.cy)})):"9l"===n.NB&&(t=e?ZC.AK(a):ZC.P.F1("Wx",ZC.1b[36]),ZC.P.G2(t,{x1:ZC.1l(l.x1),x2:ZC.1l(l.x2),y1:ZC.1l(l.y1),y2:ZC.1l(l.y2)})),!e){if(ZC.P.G2(t,{id:a,Wy:"wr"}),n.H.K8.6W[0].2X(t),""!==n.GK&&""!==n.HE)1k(1a o=n.GK.2l(/\\s+|;/),r=n.HE.2l(/\\s+|;/),C=0,A=o.1h;C<A;C++){1a s=ZC.AO.G3(o[C],n);"4g"!=1w s&&(s=[s,n.C6]),o[C]=s[0];1a Z=r[C]||1;ZC.DU(Z,0,1)||(Z=1);1a c=s[1];i=o[C],"-1"===o[C]&&(c=0,i="9I(3R,3R,3R)");1a u=ZC.P.F1("8y",ZC.1b[36]);ZC.P.G2(u,{1Y:Z,"8y-1r":i,"8y-3k":c}),t.2X(u)}1t{1a p=1,h=n.A0;"-1"===n.A0&&(p=0,h="9I(3R,3R,3R)");1a 1b=ZC.P.F1("8y",ZC.1b[36]);ZC.P.G2(1b,{1Y:0,"8y-1r":h,"8y-3k":p});1a d=1,f=n.AC;"-1"===n.AC&&(d=0,f="9I(3R,3R,3R)");1a g=ZC.P.F1("8y",ZC.1b[36]);ZC.P.G2(g,{1Y:1,"8y-1r":f,"8y-3k":d}),t.2X(1b),t.2X(g)}n.E.3f="3P(#"+a+")"}}1t"-1"!==n.A0&&(n.E.3f=n.A0)},oU:1f(){1a e=1g;if("4g"==1w e.E.5b&&1w e.H!==ZC.1b[31]&&e.H){1a t=e.lL()[1].2l(",");if("3x"===e.DP)e.H.K8.2X(ZC.P.XA({id:e.K+"mw-3r",cx:t[0],cy:t[1],r:t[2]})),e.E["3r-2M"]=e.K+"mw-3r";1t if(t.1h>6){1k(1a i="",n=0,a=t.1h;n<a;n+=2)i+=ZC.1l(t[n])+ZC.1l(e.BJ)+","+(ZC.1l(t[n+1])+ZC.1l(e.BD))+" ";e.H.K8.2X(ZC.P.XA({id:e.K+"mw-3r",2M:i})),e.E["3r-2M"]=e.K+"mw-3r"}}},VN:1f(){1a e,t,i,n,a,l,o=1g,r=o.Z;if("4x"===o.DP||"1y"===o.DP?(t=o.CY[0]+(o.CY[2]-o.CY[0])/2,i=o.CY[1]+(o.CY[3]-o.CY[1])/2):(t=o.iX,i=o.iY),o.E.cx=t,o.E.cy=i,o.E.3f=-1,""!==o.D8){1a C=o.R4();o.oV({6w:C,x:t-C.4d.1s/2,y:i-C.4d.1L/2})}1P(o.VG&&o.oU(),o.WR(),o.DP){1j"5C":if(e=o.o.3P){1a A,s=!1;ZC.4b.1T[e]?n=ZC.4b.1T[e]:((n=1n cV).4T=e,ZC.4b.1T[e]=n),(s=e.1K(".2B")>0&&e.1K("#")>=0)?(A=ZC.P.F1("2B",ZC.1b[36]),ZC.P.G2(A,{Xa:"0 0 8 8",3f:o.E.3f}),l=ZC.P.F1("Xb",ZC.1b[36])):l=ZC.P.F1("4d",ZC.1b[36]),l.al?l.al(ZC.1b[37],"7K",e):l.4l("4T",e);1a Z=o.o[ZC.1b[19]]?o.o[ZC.1b[19]]:n.1s,c=o.o[ZC.1b[20]]?o.o[ZC.1b[20]]:n.1L;n.1s=Z,n.1L=c,s?ZC.P.G2(A,{id:o.K+"-4d",x:o.iX-n.1s/2+o.BJ,y:o.iY-n.1L/2+o.BD,1s:n.1s,1L:n.1L}):ZC.P.G2(l,{id:o.K+"-4d",x:o.iX-n.1s/2+o.BJ,y:o.iY-n.1L/2+o.BD,1s:n.1s,1L:n.1L}),s?(A.2X(l),r.2X(A)):r.2X(l)}1p;1j"3x":if(!ZC.AK(o.K+"-3x")&&(a=ZC.P.F1("3x",ZC.1b[36]),-1!==o.E.3f?ZC.P.G2(a,{3f:o.E.3f,"3f-3k":o.C6}):ZC.P.G2(a,{3f:"1Z"}),o.DJ&&""!==o.DJ&&ZC.P.G2(a,{"3g":o.DJ}),ZC.P.G2(a,{id:o.K+"-3x",cx:o.iX+o.BJ,cy:o.iY+o.BD,r:o.AH}),o.AQ>0&&(ZC.P.G2(a,{3Y:o.BU,"3Y-1s":o.AQ,"3Y-3k":o.NU}),o.KS(o.AQ),"2R"===o.G8||0===o.EW&&0===o.G4||ZC.P.G2(a,{"3Y-oS":"fC"===o.G8?[o.EW,o.G4,o.AY,o.G4].2I(" "):[o.EW,o.G4].2I(",")})),o.H&&o.H.FW?(o.H.FW[r.id]||(o.H.FW[r.id]=2e.rp()),o.H.FW[r.id].2X(a)):r.2X(a),1w o.E.5b!==ZC.1b[31]))if("2Y"==1w o.E.5b)a=ZC.P.F1("3x",ZC.1b[36]),ZC.P.G2(a,{id:o.K+"-5b",3f:o.E.5b,"3f-3k":o.C6,cx:o.iX+o.BJ,cy:o.iY+o.BD,r:o.AH,"3Y-1s":0}),o.H&&o.H.FW?o.H.FW[r.id].2X(a):r.2X(a);1t{1a u=o.E.5b;(l=ZC.P.F1("4d",ZC.1b[36])).al&&l.al(ZC.1b[37],"7K",o.D8),o.E["3r-2M"]&&ZC.P.G2(l,{"3r-2M":"3P(#"+o.E["3r-2M"]+(ZC.A4.6A.7A?"-2P":"")+")"}),ZC.P.G2(l,{id:o.K+"-5b",x:u[1],y:u[2],1s:u[0].1s,1L:u[0].1L}),r.2X(l)}1p;1j"8n":1j"9u":1j"1y":1j"bk":1j"6y":o.AY>0&&(ZC.CN.2E(r,o),o.o.4V?(o.CX=!1,o.QQ=!0,ZC.CN.1v(r,o,ZC.CN.mb(o.D,!1,o.o.bB||"h"))):ZC.CN.1v(r,o,o.D));1p;2n:1a p=o.B6,h=o.AY;o.B6=o.BU,o.AY=o.AQ,o.KS(),ZC.CN.2E(r,o),ZC.CN.1v(r,o,o.D,!0,0),o.B6=p,o.AY=h,o.KS()}},WQ:1f(e,t){1c!==t&&1w t!==ZC.1b[31]||(t=!1);1a i,n=1g;if(n.A0!==n.AC||""!==n.GK&&""!==n.HE){1a a=""===n.K?"4Y-"+ZC.bW++:n.K+"-4Y";if(t&&!ZC.AK(a)&&(t=!1),ZC.AK(a)&&!t&&ZC.A4(a).3m(),i=t?ZC.AK(a):ZC.P.F1("7q:3f"),t&&(e=ZC.A4("#"+a).3Q("p5")),""!==n.GK&&""!==n.HE){1k(1a l=n.GK.2l(/\\s+|;/),o=n.HE.2l(/\\s+|;/),r="",C="",A="",s=0,Z=l.1h;s<Z;s++){l[s]=ZC.AO.G3(l[s]);1a c="-1"===l[s]?"9I(3R,3R,3R)":l[s],u=o[s]||1;ZC.DU(u,0,1)||(u=1);1a p=ZC.1l(100*u);0===s?r=c:s===Z-1?C=c:A+=p+"% "+ZC.AO.G3(c)+","}""!==A&&(A=A.2s(0,A.1h-1)),"8x"===n.NB?ZC.P.G2(i,{id:a,1I:"vZ",p5:e,1r:r,m1:C,hX:A}):"9l"===n.NB&&ZC.P.G2(i,{id:a,1I:"4Y",9E:"w5",2c:3T-n.N1-n.AA,1r:r,m1:C,hX:A})}1t{1a h=n.A0;"-1"===n.A0&&(h="9I(3R,3R,3R)");1a 1b=n.AC;"-1"===n.AC&&(1b="9I(3R,3R,3R)"),"8x"===n.NB?ZC.P.G2(i,{id:a,1I:"vZ",p5:e,1r:1b,m1:h}):"9l"===n.NB&&ZC.P.G2(i,{id:a,1I:"4Y",9E:"w5",2c:3T-n.N1-n.AA,1r:h,m1:1b})}1a d=1w n.E.dr!==ZC.1b[31]?n.E.dr:n.C6;ZC.P.G2(i,{3k:n.C6,"o:dr":d}),n.E.3f=i}1t i=ZC.P.F1("7q:3f"),"-1"!==n.A0&&(ZC.P.G2(i,{1I:"2R",1r:n.A0,3k:n.C6}),n.E.3f=i)},VQ:1f(){1a e,t,i,n,a,l,o=1g,r=o.Z;"4x"===o.DP||"1y"===o.DP?(t=o.CY[0]+(o.CY[2]-o.CY[0])/2,i=o.CY[1]+(o.CY[3]-o.CY[1])/2):(t=o.iX,i=o.iY),o.E.cx=t,o.E.cy=i,o.E.3f=-1;1a C=-1===ZC.AT(["9u","8n","6y","1y","bk"],o.DP),A=ZC.P.F1("7q:3f");if(""!==o.D8){1a s=o.R4();1P(n=s.4d,o.LZ){2n:A.1I="uE",A.4T=o.D8,ZC.P.G2(A,{2G:s.cx+","+s.cy,3k:o.C6,"o:dr":o.C6}),o.E.5b=[A];1p;1j"no-6G":1j"dk":1j!1:o.E.5b=[n,s.x,s.y]}}o.WQ("0,0");1a Z=ZC.P.F1("7q:3Y");1P(o.DP){1j"5C":(e=o.o.3P)&&(ZC.4b.1T[e]?n=ZC.4b.1T[e]:((n=1n cV).4T=e,ZC.4b.1T[e]=n),(l=ZC.P.F1("5U")).id=o.K+"-5U",l.4T=e,l.1H.2G="4A",1!==o.KJ&&(l.1s*=o.KJ,l.1L*=o.KJ,l.1H.1s=l.1s+"px",l.1H.1L=l.1L+"px"),l.1H.1J=o.iX-n.1s/2+o.BJ+"px",l.1H.1u=o.iY-n.1L/2+o.BD+"px",r.2X(l));1p;1j"8n":1j"9u":1j"1y":1j"bk":1j"6y":Z.7a=o.AY+"px",Z.1r=o.B6;1p;2n:Z.7a=o.AQ+"px",Z.1r=o.BU}1P(Z.3k=o.NU,o.G8){1j"2R":Z.cg="2R";1p;1j"g1":Z.cg="nw";1p;1j"fX":Z.cg="ns"}1P(-1===ZC.AT(["8n","9u","1y","bk"],o.DP)&&(o.E.3Y=Z),o.DP){1j"3x":1j"6y":if(!ZC.AK(o.K+"-3x")&&(a=ZC.P.F1("3x"===o.DP?"7q:vR":"7q:6y"),a.id=o.K+"-3x",a.1H.2G="4A",-1!==o.E.3f&&C?a.2X(o.E.3f):a.aB=!1,o.AQ>0||o.AY>0?a.2X(Z):a.iL=!1,a.1H.1J=o.iX+o.BJ-o.AH+"px",a.1H.1u=o.iY+o.BD-o.AH+"px",a.1H.1s=2*o.AH+"px",a.1H.1L=2*o.AH+"px","6y"===o.DP&&ZC.P.G2(a,{zX:o.BH+90,uw:o.B1+90}),r.2X(a),C&&1w o.E.5b!==ZC.1b[31])){1a c=o.E.5b;1===c.1h?((a=ZC.P.F1("7q:vR")).id=o.K+"-5b",a.1H.2G="4A",r.2X(a),a.2X(c[0]),a.1H.1J=o.iX+o.BJ-o.AH+"px",a.1H.1u=o.iY+o.BD-o.AH+"px",a.1H.1s=2*o.AH+"px",a.1H.1L=2*o.AH+"px",a.iL=!1,"6y"===o.DP&&ZC.P.G2(a,{zX:o.BH+90,uw:o.B1+90})):3===c.1h&&((l=ZC.P.F1("5U")).id=o.K+"-5U",l.4T=o.D8,l.1H.2G="4A",l.1H.1J=c[1]+"px",l.1H.1u=c[2]+"px",1!==o.KJ&&(l.1s*=o.KJ,l.1L*=o.KJ,l.1H.1s=l.1s+"px",l.1H.1L=l.1L+"px"),r.2X(l))}1p;1j"8n":1j"9u":1j"1y":1j"bk":o.AY>0&&(ZC.CN.2E(r,o),o.o.4V?(o.CX=!1,o.QQ=!0,ZC.CN.1v(r,o,ZC.CN.mb(o.D,!1,o.o.bB||"h"))):ZC.CN.1v(r,o,o.D));1p;2n:1a u=o.B6,p=o.AY;o.B6=o.BU,o.AY=o.AQ,o.KS(),ZC.CN.2E(r,o),ZC.CN.1v(r,o,o.D,!0,0),o.B6=u,o.AY=p,o.KS()}}}),ZC.HQ=ZC.DS.C7({$i:1f(e){1g.b(e);1a t=1g;t.DP="3B",t.I=0,t.F=0,t.ov="",t.E2=-1,t.E3=-1,t.DN=-1,t.DZ=-1,t.F2=0,t.FP=0,t.EY=0,t.FA=0,t.os=!1,t.KN=!1,t.EQ="2a",t.EU=0,t.M0=0,t.H0=8,t.G1=8,t.XD=[1,1],t.DI=1c,t.OE=1c,t.PR=!1,t.OG=!0,t.PS="",t.OA="",t.NK="",t.P4="",t.WL="tl",t.F9=!1},aj:1f(){1a e=1g.b();1m 1g.ef(e,"1s,1L,17C,13P,13E,13T,6B,13U,Gn,13W,142,13R,13e,13f,2G,uT,jH,om,jF,13g","I,F,F2,FP,EY,FA,KN,EQ,DI,H0,G1,EU,M0,ov,PS,OA,NK,P4,F9"),e},8e:1f(){},m0:1f(e,t,i){1a n=1g;if(t=t||"w",ZC.1W(e)+""!=e+"")1m-1!==(e+="").1K("%")?n.m0(ZC.1W(e.1E("%",""))/100,t,!0):-1!==e.1K("px")?n.m0(ZC.1W(e.1E("px","")),t):n.m0(ZC.1W(e),t);1a a=1w n.E["p-1s"]!==ZC.1b[31]?n.E["p-1s"]:n.A.I,l=1w n.E["p-1L"]!==ZC.1b[31]?n.E["p-1L"]:n.A.F;1m(e=ZC.2i(e))>1&&!i?ZC.1l(e):e<=1||i?"w"===t?ZC.1l(a*e):ZC.1l(l*e):8j 0},6b:1f(e,t,i,n,a){1a l,o,r=1g;if(i=i||0,n=n||0,t=t||"4q",a=a||"n","4q"===t){1a C=5X(e).2l(/\\s+|;|,/);1m 1===C.1h?[r.6b(C[0],"tb",i,n,a),r.6b(C[0],"lr",i,n,a),r.6b(C[0],"tb",i,n,a),r.6b(C[0],"lr",i,n,a)]:2===C.1h?[r.6b(C[0],"tb",i,n,a),r.6b(C[1],"lr",i,n,a),r.6b(C[0],"tb",i,n,a),r.6b(C[1],"lr",i,n,a)]:3===C.1h?[r.6b(C[0],"tb",i,n,a),r.6b(C[1],"lr",i,n,a),r.6b(C[2],"tb",i,n,a),r.6b(C[1],"lr",i,n,a)]:[r.6b(C[0],"tb",i,n,a),r.6b(C[1],"lr",i,n,a),r.6b(C[2],"tb",i,n,a),r.6b(C[3],"lr",i,n,a)]}1m e+""=="3e"?-2:e+""=="4M"&&"y"===a?"4M":ZC.1W(e)+""!=e+""?-1!==(e+="").1K("%")?r.6b(ZC.1W(e.1E("%",""))/100,t):-1!==e.1K("px")?r.6b(ZC.1W(e.1E("px","")),t):r.6b(ZC.1W(e),t):((r.A||1w r.E["p-1s"]!==ZC.1b[31])&&(l=1w r.E["p-1s"]!==ZC.1b[31]?r.E["p-1s"]:r.A.I),(r.A||1w r.E["p-1L"]!==ZC.1b[31])&&(o=1w r.E["p-1L"]!==ZC.1b[31]?r.E["p-1L"]:r.A.F),(e=ZC.2i(e))>=1?ZC.1l(e):e<1?"lr"===t?ZC.1l((r.A?l:i)*e):ZC.1l((r.A?o:n)*e):8j 0)},1Q:1f(e){1g.b(e);1k(1a t=1g,i="I,F,E2,DN,DZ,E3,F2,FP,EY,FA,KN,EQ,DI,XD,H0,G1,EU,M0,ov,PS,OA,NK,P4,F9".2l(","),n=0,a=i.1h;n<a;n++)1w e[i[n]]!==ZC.1b[31]&&(t[i[n]]=e[i[n]])},9p:1f(e){1a t,i,n,a,l,o=1g;if(2!==(e=e||1))if(o.TH)o.4y([["x","iX"],["y","iY"],[ZC.1b[19],"I"],[ZC.1b[20],"F"]]);1t{1a r=1w o.E["p-x"]!==ZC.1b[31]?o.E["p-x"]:o.A.iX,C=1w o.E["p-y"]!==ZC.1b[31]?o.E["p-y"]:o.A.iY,A=1w o.E["p-1s"]!==ZC.1b[31]?o.E["p-1s"]:o.A.I,s=1w o.E["p-1L"]!==ZC.1b[31]?o.E["p-1L"]:o.A.F;if(!o.PR){1a Z=0,c=0,u=0,p=0;if(1c!==ZC.1d(o.o.2v)){1a h=""+o.o.2v;if(-1!==h.1K("4M")){1a 1b=o.6b(h,"4q",0,0,"y");"4M"===1b[0]&&(o.E["d-2v-1u"]=o.E["d-2v"]=!0),"4M"===1b[1]&&(o.E["d-2v-2x"]=o.E["d-2v"]=!0),"4M"===1b[2]&&(o.E["d-2v-2a"]=o.E["d-2v"]=!0),"4M"===1b[3]&&(o.E["d-2v-1J"]=o.E["d-2v"]=!0),o.o.2v=h.1E(/4M/g,"20")}}"4M"===o.o.2v&&(o.E["d-2v"]=o.E["d-2v-1u"]=o.E["d-2v-2x"]=o.E["d-2v-2a"]=o.E["d-2v-1J"]=!0,o.o.2v=1c),1w o.E["ei-f3"]===ZC.1b[31]||1c!==ZC.1d(o.o["94-3t"])&&ZC.2q(o.o["94-3t"])||(1c!==ZC.1d(o.o[ZC.1b[57]])&&1c===ZC.1d(o.o[ZC.1b[59]])&&(o.o[ZC.1b[59]]="3e"),1c!==ZC.1d(o.o[ZC.1b[59]])&&1c===ZC.1d(o.o[ZC.1b[57]])&&(o.o[ZC.1b[57]]="3e"),1c!==ZC.1d(o.o[ZC.1b[60]])&&1c===ZC.1d(o.o[ZC.1b[58]])&&(o.o[ZC.1b[58]]="3e"),1c!==ZC.1d(o.o[ZC.1b[58]])&&1c===ZC.1d(o.o[ZC.1b[60]])&&(o.o[ZC.1b[60]]="3e"));1k(1a d=[ZC.1b[57],ZC.1b[58],ZC.1b[59],ZC.1b[60]],f=0,g=d.1h;f<g;f++)"4M"===o.o[d[f]]&&(o.E["d-"+d[f]]=o.E["d-2v"]=!0,o.o[d[f]]=1c);1c!==(t=ZC.1d(o.o.2v))&&(i=o.6b(t,"4q"),1c===ZC.1d(o.o[ZC.1b[57]])&&(Z=i[0]),1c===ZC.1d(o.o[ZC.1b[58]])&&(c=i[1]),1c===ZC.1d(o.o[ZC.1b[59]])&&(u=i[2]),1c===ZC.1d(o.o[ZC.1b[60]])&&(p=i[3])),1c!==(t=ZC.1d(o.o[ZC.1b[57]]))&&(Z=i=o.6b(t,"tb")),1c!==(t=ZC.1d(o.o[ZC.1b[58]]))&&(c=i=o.6b(t,"lr")),1c!==(t=ZC.1d(o.o[ZC.1b[59]]))&&(u=i=o.6b(t,"tb")),1c!==(t=ZC.1d(o.o[ZC.1b[60]]))&&(p=i=o.6b(t,"lr"));1a B=[Z,c,u,p];1c!==ZC.1d(o.o.x)&&(o.iX=o.c6(o.o.x,"x")),1c!==ZC.1d(o.o.y)&&(o.iY=o.c6(o.o.y,"y"));1a v;if(1c!==(t=ZC.1d(o.o[ZC.1b[19]]))){1a b=ZC.8C(t);v=-1!==(""+t).1K("%"),o.I=b>1&&!v?ZC.1l(b):-2===p&&-2===c?ZC.1l(A*b):-2===p&&-2!==c?ZC.1l((A-c)*b):-2!==p&&-2===c?ZC.1l((A-p)*b):ZC.1l((A-p-c)*b),-1!==o.iX?(o.DZ=o.iX-r,o.E3=r+A-o.DZ-o.I):-2===p&&-2===c?(o.DZ=o.E3=(A-o.I)/2,o.iX=r+o.DZ):-2===p&&-2!==c?(o.E3=c,o.DZ=A-o.E3-o.I,o.iX=r+o.DZ):(o.DZ=p,o.iX=r+o.DZ,o 3z ZC.DQ?o.E3=c:o.E3=A-o.DZ-o.I)}1t-1!==o.iX?(o.DZ=o.iX-r,o.E3=-2===c?0:c,o.I=A-o.DZ-o.E3):-2===p&&-2===c?(o.DZ=o.E3=0,o.iX=r+o.DZ,o.I=A-o.DZ-o.E3):-2===p&&-2!==c?(o.E3=c,o.DZ=0,o.iX=r+o.DZ,o.I=A-o.DZ-o.E3):-2!==p&&-2===c?(o.DZ=p,o 3z ZC.DQ?o.E3=c:o.E3=0,o.iX=r+o.DZ,o.I=A-o.DZ-o.E3):(o.DZ=p,o.E3=c,o.iX=r+o.DZ,o.I=A-o.DZ-o.E3);if(1c!==(t=ZC.1d(o.o[ZC.1b[20]]))){1a E=ZC.8C(t);v=-1!==(""+t).1K("%"),o.F=E>1&&!v?ZC.1l(E):-2===Z&&-2===u?ZC.1l(s*E):-2===Z&&-2!==u?ZC.1l((s-u)*E):-2!==Z&&-2===u?ZC.1l((s-Z)*E):ZC.1l((s-Z-u)*E),-1!==o.iY?(o.E2=o.iY-C,o.DN=C+s-o.E2-o.F):-2===Z&&-2===u?(o.E2=o.DN=(s-o.F)/2,o.iY=C+o.E2):-2===Z&&-2!==u?(o.DN=u,o.E2=s-o.DN-o.F,o.iY=C+o.E2):(o.E2=Z,o.iY=C+o.E2,o 3z ZC.DQ?o.DN=u:o.DN=s-o.E2-o.F)}1t-1!==o.iY?(o.E2=o.iY-C,o.DN=-2===u?0:u,o.F=s-o.E2-o.DN):-2===Z&&-2===Z?(o.E2=o.E2=0,o.iY=C+o.E2,o.F=s-o.E2-o.DN):-2===Z&&-2!==u?(o.DN=u,o.E2=0,o.iY=C+o.E2,o.F=s-o.E2-o.DN):-2===Z&&-2!==u?(o.E2=Z,o 3z ZC.DQ?o.DN=u:o.DN=0,o.iY=C+o.E2,o.F=s-o.E2-o.DN):(o.E2=Z,o.DN=u,o.iY=C+o.E2,o.F=s-o.E2-o.DN);if(1c!==(t=ZC.1d(o.o.2G))){if(o.A&&1w o.A.iX!==ZC.1b[31]&&1w o.A.iY!==ZC.1b[31]&&1w o.A.I!==ZC.1b[31]&&1w o.A.F!==ZC.1b[31]){1P(n=0,a=0,(l=5X(t).2l(/\\s+/))[0]){1j"1J":n=0;1p;1j"2x":n=1;1p;1j"3E":n=.5;1p;2n:(n=ZC.IB(l[0]))>1&&(n/=o.A.I)}1P(l[1]){1j"1u":a=0;1p;1j"2a":a=1;1p;1j"6o":a=.5;1p;2n:(a=ZC.IB(l[1]))>1&&(a/=o.A.F)}}o.E["2G-6w"]=[n,a],o.iX=o.A.iX+ZC.1l(n*(o.A.I-o.I-B[1]-B[3]))+B[3],o.iY=o.A.iY+ZC.1l(a*(o.A.F-o.F-B[0]-B[2]))+B[0]}o.CY=[o.iX,o.iY,o.iX+o.I,o.iY+o.F]}}},1q:1f(){1g.b();1a e,t=1g;if(!t.o.cX){if(t.4y([["bh","WL"],["5t-FI","F9","b"],["3E-3N","os","b"],["6B","KN","b"],["6B-1I","13j"],["6B-2G","EQ"],["6B-7r","DI"],["6B-fD","XD"],["6B-1s","H0","i"],["6B-1L","G1","i"],["6B-1Y","EU","i"],["6B-sm","M0","i"],["1F-1u","PS"],["1F-2x","OA"],["1F-2a","NK"],["1F-1J","P4"]]),1c!==(e=ZC.1d(t.o["1F-9B"]))){1a i=5X(e).2l(/\\s+|;|,/);2===i.1h?(t.F2=t.FP=ZC.1l(i[0]),t.EY=t.FA=ZC.1l(i[1])):4===i.1h?(t.F2=ZC.1l(i[0]),t.FP=ZC.1l(i[1]),t.EY=ZC.1l(i[2]),t.FA=ZC.1l(i[3])):t.F2=t.FP=t.EY=t.FA=ZC.1l(i[0])}1c!==ZC.1d(t.o["6B-mL"])&&(t.OE=1n ZC.DS(t.A)),t.4y([["1F-9B-1u-1J","F2","i"],["1F-9B-1u-2x","FP","i"],["1F-9B-2a-2x","EY","i"],["1F-9B-2a-1J","FA","i"]])}},WC:1f(e){1a t=e.2l(/\\s/);1m t[0]=ZC.1l(t[0]),t[2]=ZC.AO.G3(t[2]),t},1v:1f(){1a e=1g;if(1c!==e.DI&&!(e.DI 3z 3K)&&"uo"===e.A.O2){1a t=e.A.UX(e.DI);e.DI=[t[0],t[1]],e.DI[0]-=e.BJ,e.DI[1]-=e.BD}if(e.os&&(e.iX-=e.I/2,e.iY-=e.F/2),"-1"!==e.BU&&0!==e.AQ||e.PS+e.OA+e.NK+e.P4!==""||"-1"!==e.A0||"-1"!==e.AC||""!==e.D8||""!==e.GK||""!==e.HE){1a i=e.H.AB;e.M3&&e.C5&&e.m3();1a n,a={x:"iX",y:"iY",1s:"I",1L:"F"};if(e.o["2a-3U"]&&!e.Y3&&!e.g7&&!e.VX){1a l=1n ZC.HQ(-1===e.A.iX&&-1===e.A.iY?e:e.A);l.1Q(e),l.g7=!0,l.M3=!1,l.Z=e.Z,l.WL=e.WL,l.1C(e.o["2a-3U"]),l.K=e.K+"-2a",l.1q(),l.gU();1k(n in a)1c===ZC.1d(l.o[n])||-1===(""+l.o[n]).1K("+")&&-1===(""+l.o[n]).1K("-")||(l[a[n]]=e[a[n]]+ZC.1l(l.o[n]));l.1v()}if(e.PS+e.OA+e.NK+e.P4===""){1P(i){1j"3a":e.fG();1p;1j"2B":e.VN();1p;1j"3I":e.VQ()}if(e.KN&&e.OE){1a o,r;if(e.DI&&2===e.DI.1h?(o=e.DI[0],r=e.DI[1]):e.E.cp&&(o=e.E.cp[0],r=e.E.cp[1]),e.OE.Z=e.OE.C5=e.Z,e.OE.1Q(e),e.OE.1C(e.o["6B-mL"]),e.OE.K=e.K+"-6B-mL",e.OE.o.x=o,e.OE.o.y=r,e.E.cm){1a C=e.E.cm[0],A=e.E.cm[1],s=1A.nR(ZC.1l(A)-ZC.1l(r),ZC.1l(C)-ZC.1l(o));8a(s)&&(s=0),1c===ZC.1d(e.OE.o.2c)&&(e.OE.o.2c=ZC.TF(s))}e.OE.1q(),e.OE.1v()}}1t{1a Z=e.AQ,c=e.BU,u=e.G8;1P(e.AQ=0,i){1j"3a":e.fG();1p;1j"2B":e.VN();1p;1j"3I":e.VQ()}e.AQ=Z;1a p=e.A0,h=e.AC;e.A0=e.AC="-1";1k(1a 1b,d=["1u","2x","2a","1J"],f=["PS","OA","NK","P4"],g=0;g<d.1h;g++)if(""!==(1b=e[f[g]])&&"1Z"!==1b){1a B=e.WC(1b);1P(e.AQ=B[0],e.G8=B[1],e.BU=B[2],i){1j"3a":e.fG(d[g]);1p;1j"2B":e.VN(d[g]);1p;1j"3I":e.VQ(d[g])}e.AQ=Z,e.BU=c,e.G8=u}e.A0=p,e.AC=h}if(e.o["1u-3U"]&&!e.Y3&&!e.VX&&!e.g7){1a v=1n ZC.HQ(-1===e.A.iX&&-1===e.A.iY?e:e.A);v.1Q(e),v.VX=!0,v.M3=!1,v.Z=e.Z,v.WL=e.WL,v.1C(e.o["1u-3U"]),v.K=e.K+"-1u",v.1q(),v.gU();1k(n in a)1c===ZC.1d(v.o[n])||-1===(""+v.o[n]).1K("+")&&-1===(""+v.o[n]).1K("-")||(v[a[n]]=e[a[n]]+ZC.1l(v.o[n]));v.1v()}}},gU:1f(){1a e=1g;1P(e.WL){1j"tl":1p;1j"tr":e.iX-=e.I;1p;1j"bl":e.iY-=e.F;1p;1j"br":e.iX-=e.I,e.iY-=e.F;1p;1j"c":e.iX-=e.I/2,e.iY-=e.F/2;1p;1j"t":e.iX-=e.I/2;1p;1j"r":e.iX-=e.I,e.iY-=e.F/2;1p;1j"b":e.iX-=e.I/2,e.iY-=e.F;1p;1j"l":e.iY-=e.F/2}},m3:1f(){1a e=1g,t=1n ZC.HQ(e.A);t.K=e.K+"-sh",t.1Q(e),t.Z=e.C5,t.M3=!1,t.Y3=!0,t.PS=t.OA=t.NK=t.P4="",t.A0=t.AC=t.RW,t.GK=t.HE="",t.D8="",t.G8="2R",t.BU=t.RW,t.AY=0;1a i=e.JP*ZC.ED(e.OB),n=e.JP*ZC.EL(e.OB);t.I=e.I+("3I"===e.H.AB?0:.5)-ZC.ED(e.OB)*e.P5/2,t.F=e.F+("3I"===e.H.AB?0:.5)-ZC.EL(e.OB)*e.P5/2,t.NU=t.C6=t.SY*e.C6,t.K=e.K+"-sh",t.iX=e.iX+ZC.1l(i),t.iY=e.iY+ZC.1l(n),t.1v()},XW:1f(e){1a t,i=1g,n=i.iX,a=i.iY,l=n+i.I/2,o=a+i.F/2,r=i.VR,C=i.VS;if(ZC.2i(r)<=1&&(r=r*i.I/2),ZC.2i(C)<=1&&(C=C*i.F/2),l+=r,o+=C,"8x"===e){1a A=ZC.1l((i.I+i.F)/2),s=ZC.CV(i.I,i.F);1m t=s<A/4?(s+A)/2:s,{cx:l,cy:o,r:ZC.2i(t)}}if("9l"===e){1a Z=(t=i.I>=i.F?ZC.2i(ZC.EL(i.N1))>.5?i.F/2:i.I/2:ZC.2i(ZC.ED(i.N1))>.5?i.I/2:i.F/2)*ZC.ED(i.N1),c=t*ZC.EL(i.N1);1m{x1:l-Z,y1:o-c,x2:l+Z,y2:o+c}}},VV:1f(e){1a t,i=1g;1w e===ZC.1b[31]&&(e="4q");1a n,a,l=i.iX,o=i.iY;i.D=[],n=a=i.AQ/2;1a r=1;1P(i.H.AB){1j"3I":r=2,i.AQ%2==1&&(n=ZC.1l((i.AQ-1)/2),a=ZC.1l((i.AQ+1)/2))}1a C=1c,A=ZC.4t(l+n,2),s=ZC.4t(l-a,2),Z=ZC.4t(o+n,2),c=ZC.4t(o-a,2),u=i.DI&&2===i.DI.1h,p=ZC.1l(i.EU*(i.I-i.H0)/100),h=ZC.1l(i.EU*(i.F-i.G1)/100),1b=0!==i.F2||0!==i.FP||0!==i.EY||0!==i.FA,d=i.XD[0],f=i.XD[1];1P(i.EQ){1j"1u":i.E.cm=[i.iX+i.I/2+p,i.iY];1p;1j"2a":i.E.cm=[i.iX+i.I/2+p,i.iY+i.F];1p;1j"1J":i.E.cm=[i.iX,i.iY+i.F/2+h];1p;1j"2x":i.E.cm=[i.iX+i.I,i.iY+i.F/2+h]}if(1b){1a g,B=ZC.CV(i.I/2,i.F/2);"1u"!==e&&"4q"!==e||(0!==i.F2?(g=i.I/2>=i.F2&&i.F/2>=i.F2?ZC.2i(i.F2):B,i.D.1i([A,Z+g]),i.F2>0&&i.D.1i([A,Z,A+r*g,Z]),i.D.1i([A+g,Z])):i.D.1i([A,Z]),i.KN&&"1u"===i.EQ&&(i.D.1i([A+i.I/2-d*i.H0/2-i.AQ/2+p,Z]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[A+i.I/2-i.AQ/2+p,Z-i.G1],i.D.1i(C)),i.M0>0&&(t=i.D[i.D.1h-1],i.D.1i([t[0],t[1]-i.M0*(i.G1>0?1:-1)]),i.D.1i([t[0],t[1]])),i.D.1i([A+i.I/2-i.AQ/2+f*i.H0/2+p,Z])),"1u"===e&&(0!==i.FP?(g=i.I/2>=i.FP&&i.F/2>=i.FP?ZC.2i(i.FP):B,i.D.1i([s+i.I-g,Z])):i.D.1i([s+i.I,Z]))),"2x"!==e&&"4q"!==e||(0!==i.FP?(g=i.I/2>=i.FP&&i.F/2>=i.FP?ZC.2i(i.FP):B,i.D.1i([s+i.I-g,Z]),i.FP>0?i.D.1i([s+i.I,Z,s+i.I,Z+r*g]):i.D.1i([s+i.I,Z+g])):i.D.1i([s+i.I,Z]),i.KN&&"2x"===i.EQ&&(i.D.1i([s+i.I,Z+i.F/2-d*i.G1/2-i.AQ/2+h]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[s+i.I+i.H0,Z+i.F/2-i.AQ/2+h],i.D.1i(C)),i.D.1i([s+i.I,Z+i.F/2+f*i.G1/2-i.AQ/2+h])),"2x"===e&&(0!==i.EY?(g=i.I/2>=i.EY&&i.F/2>=i.EY?ZC.2i(i.EY):B,i.D.1i([s+i.I,c+i.F-g])):i.D.1i([s+i.I,c+i.F]))),"2a"!==e&&"4q"!==e||(0!==i.EY?(g=i.I/2>=i.EY&&i.F/2>=i.EY?ZC.2i(i.EY):B,i.D.1i([s+i.I,c+i.F-g]),i.EY>0?i.D.1i([s+i.I,c+i.F,s+i.I-r*g,c+i.F]):i.D.1i([s+i.I-g,c+i.F])):i.D.1i([s+i.I,c+i.F]),i.KN&&"2a"===i.EQ&&(i.D.1i([s+i.I/2+d*i.H0/2+i.AQ/2+p,c+i.F]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[s+i.I/2+i.AQ/2+p,c+i.F+i.G1],i.D.1i(C)),i.M0>0&&(t=i.D[i.D.1h-1],i.D.1i([t[0],t[1]+i.M0*(i.G1>0?1:-1)]),i.D.1i([t[0],t[1]])),i.D.1i([s+i.I/2-f*i.H0/2+i.AQ/2+p,c+i.F])),"2a"===e&&(0!==i.FA?(g=i.I/2>=i.FA&&i.F/2>=i.FA?ZC.2i(i.FA):B,i.D.1i([A+g,c+i.F])):i.D.1i([A,c+i.F]))),"1J"!==e&&"4q"!==e||(0!==i.FA?(g=i.I/2>=i.FA&&i.F/2>=i.FA?ZC.2i(i.FA):B,i.D.1i([A+g,c+i.F]),i.FA>0?i.D.1i([A,c+i.F,A,c+i.F-r*g]):i.D.1i([A,c+i.F-g])):i.D.1i([A,c+i.F]),i.KN&&"1J"===i.EQ&&(i.D.1i([A,c+i.F/2+d*i.G1/2+i.AQ/2+h]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[A-i.H0,c+i.F/2+i.AQ/2+h],i.D.1i(C)),i.D.1i([A,c+i.F/2-f*i.G1/2+i.AQ/2+h])),0!==i.F2?(g=i.I/2>=i.F2&&i.F/2>=i.F2?ZC.2i(i.F2):B,i.D.1i([A,Z+g])):(i.D.1i([A,Z]),i.D.1i([A+.1,Z])))}1t"1u"!==e&&"4q"!==e||(i.D.1i([A,Z]),i.KN&&"1u"===i.EQ&&(i.D.1i([A+i.I/2-d*i.H0/2-i.AQ/2+p,Z]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[A+i.I/2-i.AQ/2+p,Z-i.G1],i.D.1i(C)),i.M0>0&&(t=i.D[i.D.1h-1],i.D.1i([t[0],t[1]-i.M0*(i.G1>0?1:-1)]),i.D.1i([t[0],t[1]])),i.D.1i([A+i.I/2+f*i.H0/2-i.AQ/2+p,Z])),"1u"===e&&i.D.1i([s+i.I,Z])),"2x"!==e&&"4q"!==e||(i.D.1i([s+i.I,Z]),i.KN&&"2x"===i.EQ&&(i.D.1i([s+i.I,Z+i.F/2-i.AQ/2-d*i.G1/2+h]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[s+i.I+i.H0,Z+i.F/2-i.AQ/2+h],i.D.1i(C)),i.D.1i([s+i.I,Z+i.F/2-i.AQ/2+f*i.G1/2+h])),"2x"===e&&i.D.1i([s+i.I,c+i.F])),"2a"!==e&&"4q"!==e||(i.D.1i([s+i.I,c+i.F]),i.KN&&"2a"===i.EQ&&(i.D.1i([s+i.I/2+d*i.H0/2+i.AQ/2+p,c+i.F]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[s+i.I/2+i.AQ/2+p,c+i.F+i.G1],i.D.1i(C)),i.M0>0&&(t=i.D[i.D.1h-1],i.D.1i([t[0],t[1]+i.M0*(i.G1>0?1:-1)]),i.D.1i([t[0],t[1]])),i.D.1i([s+i.I/2-f*i.H0/2+i.AQ/2+p,c+i.F])),"2a"===e&&i.D.1i([A,c+i.F])),"1J"!==e&&"4q"!==e||(i.D.1i([A,c+i.F]),i.KN&&"1J"===i.EQ&&(i.D.1i([A,c+i.F/2+i.AQ/2+d*i.G1/2+h]),u?i.D.1i([i.DI[0],i.DI[1]]):(C=[A-i.H0,c+i.F/2+i.AQ/2+h],i.D.1i(C)),i.D.1i([A,c+i.F/2+i.AQ/2-f*i.G1/2+h])),i.D.1i([A,Z]),i.D.1i([A+.1,Z]));C&&(i.E.cp=C)},fG:1f(e){e=e||"4q";1a t,i,n,a=1g,l=a.Z.9j("2d");l.gS(),l.oj=a.hY;1a o=a.iX,r=a.iY,C=a.oh(),A=C.bc,s=C.pi,Z=C.p3;if("4q"===e)if(s!==Z||""!==a.GK&&""!==a.HE){1a c=a.XW(a.NB);"8x"===a.NB?t=l.v6(c.cx,c.cy,1,c.cx,c.cy,c.r):"9l"===a.NB&&(c.x1=8a(c.x1)?0:c.x1,c.x2=8a(c.x2)?0:c.x2,c.y1=8a(c.y1)?0:c.y1,c.y2=8a(c.y2)?0:c.y2,t=l.v7(c.x1,c.y1,c.x2,c.y2)),""!==a.GK&&""!==a.HE?a.Z8(t):(t.hQ(0,s),t.hQ(1,Z)),l.cU=t}1t""!==a.D8&&-1!==ZC.AT(["6G","hR",!0],a.LZ)&&"-1"===a.A0&&"-1"===a.AC&&(s="9D(3R,3R,3R,0)"),l.cU=s;l.mG=A,l.cY=a.AQ,l.7f(a.BJ,a.BD),0!==a.AA&&(l.7f(o+a.I/2,r+a.F/2),l.gb(ZC.ST(a.AA)),l.7f(-(o+a.I/2),-(r+a.F/2))),l.mF(),a.VV(e);1a u=a.F2+a.FP+a.EY+a.FA!==0;n=a.AY,a.AY=a.AQ;1a p=a.G8;if(a.G8="",a.KS(),ZC.CN.kd(l,a,a.D),a.AY=n,a.G8=p,a.KS(),"4q"===e)if(""!==a.D8&&-1===ZC.AT(ZC.gs,a.D8)){l.3f(),l.gS(),l.3r();1a h=l.da;l.da=a.C6;1a 1b=a.R4(),d=1b.4d;1P(a.LZ){2n:l.7f(a.iX,a.iY),i=l.uA(d,"6G"),l.cU=i,l.3f(),l.7f(-1b.x,-1b.y);1p;1j"no-6G":1j"dk":1j!1:l.cM(d,1b.x-a.BJ,1b.y-a.BD,a.E[ZC.1b[69]],a.E[ZC.1b[70]])}l.da=h,l.hx()}1t l.3f();if(a.AQ>0){1a f=a.B6;n=a.AY,a.B6=a.BU,a.AY=a.AQ,a.KS(),ZC.CN.2E(l,a),a.T0=u?"43":"9o",a.EW+a.G4>0&&(a.T0="mv"),a.ZU=u?"43":"ni",a.E["b7-1u"]=!0,a.E.1F=e,ZC.CN.1v(l,a,a.D,!0),a.B6=f,a.AY=n,a.KS()}l.mE(),l.hx()},VN:1f(e){e=e||"4q";1a t=1g,i=t.Z;t.E.3f=-1;1a n=!1;if("4q"===e){if(""!==t.D8&&-1===ZC.AT(ZC.gs,t.D8)){1a a=t.R4();t.oV({6w:a,x:t.iX,y:t.iY}),n=!0}t.WR()}if(t.VV(e),n&&"6G"!==t.LZ&&(t.eN(),t.KN)){1a l=0,o=0;t.CY[1]<t.iY&&(o=t.CY[3]-t.CY[1]-t.F),t.CY[0]<t.iX&&(l=t.CY[2]-t.CY[0]-t.I),1c===ZC.1d(t.E["8Q-tx"])?t.E["8Q-tx"]=l:t.E["8Q-tx"]+=l,1c===ZC.1d(t.E["8Q-ty"])?t.E["8Q-ty"]=o:t.E["8Q-ty"]+=o,ZC.P.G2(ZC.AK(t.E["8Q-4d-id"]),{5H:"7f("+t.E["8Q-tx"]+","+t.E["8Q-ty"]+")"})}1a r=t.F2+t.FP+t.EY+t.FA!==0;t.E.cx=t.iX+t.I/2,t.E.cy=t.iY+t.F/2,t.VG&&t.oU();1a C=t.B6,A=t.AY;t.B6=t.BU,t.AY=t.AQ,t.KS(),ZC.CN.2E(i,t),t.T0=r?"43":"9o",t.EW+t.G4>0&&(t.T0="mv"),t.ZU=r?"43":"ni";1a s=!1;ZC.A4.6A.a6||!t.F9||t.KN||""!==t.PS||""!==t.OA||""!==t.NK||""!==t.P4||0!==t.F2||0!==t.FP||0!==t.EY||0!==t.FA||(s=!0),t.E["b7-1u"]=!0,t.E.1F=e,ZC.CN.1v(i,t,t.D,!0,1c,s),t.B6=C,t.AY=A,t.KS()},VQ:1f(e){e=e||"4q";1a t=1g,i=t.Z;if("4q"===e){1a n=ZC.P.F1("7q:3f");if(""!==t.D8&&-1===ZC.AT(ZC.gs,t.D8)){1a a=t.R4(),l=a.4d;1P(t.LZ){2n:n.1I="uE",n.4T=t.D8,ZC.P.G2(n,{2G:a.cx+","+a.cy,3k:t.C6,"o:dr":t.C6}),t.E.5b=[n];1p;1j"no-6G":1j"dk":1j!1:t.E.5b=[l,a.x,a.y]}}t.WQ("0.5,0.5")}1a o=ZC.P.F1("7q:3Y");1P(o.7a=t.AQ+"px",o.1r=t.BU,o.3k=t.C6,t.G8){1j"2R":o.cg="2R";1p;1j"g1":o.cg="nw";1p;1j"fX":o.cg="ns"}t.E.3Y=o,t.VV(e);1a r=t.F2+t.FP+t.EY+t.FA!==0;t.E.cx=t.iX+t.I/2,t.E.cy=t.iY+t.F/2;1a C=t.B6,A=t.AY;t.B6=t.BU,t.AY=t.AQ,t.KS(),ZC.CN.2E(i,t),t.T0=r?"43":"9o",t.EW+t.G4>0&&(t.T0="mv"),t.ZU=r?"43":"ni",t.E.1F=e,ZC.CN.1v(i,t,t.D,"4q"===e),t.B6=C,t.AY=A,t.KS()}}),ZC.QL=ZC.DS.C7({$i:1f(e){1g.b(e);1a t=1g;t.WG=1c,t.BE=1c,t.M=1c,t.SD=1c,t.A8=1c,t.K3=!1,t.O1=!1,t.KV=!1,t.nX=!1},1q:1f(){1a e,t=1g;t.BE=1o.5Y.ai("3B"===t.WG.1I?"HQ":"DS",t.A,t.K+"-2P",t.WG.cX),t.BE.1C(t.WG),t.BE.iX=t.iX,t.BE.iY=t.iY,t.BE.K=t.K+"-bx",t.BE.O1=t.O1,t.nX||1c===ZC.1d(e=t.BE.o.2S)||(t.BE.o.2S=ZC.AO.uJ(e,t.A.iX,t.A.iY),t.nX=!0),t.BE.1q(),1c!==ZC.1d(e=t.BE.o.1G)&&1c!==ZC.1d(e.1D)&&""!==e.1D&&(1w e.2f===ZC.1b[31]||ZC.2q(e.2f))&&(t.M=1o.5Y.ai("DQ",t,t.A.K+"-2P-1G-"+t.GX,ZC.bN),ZC.bN||t.M.1C(e)),1c!==ZC.1d(e=t.BE.o["8F"])&&(t.K3=ZC.2q(e)),1c!==ZC.1d(e=t.BE.o.7M)&&(t.K3=ZC.2q(e)),1c!==ZC.1d(e=t.BE.o.4M)&&(t.KV=ZC.2q(e)),1c!==ZC.1d(e=t.BE.o.97)&&(t.SD=1n ZC.DS(t),t.SD.1C(e),t.SD.1q())},1v:1f(){1a e,t=1g;if(t.BE.Z=t.Z,t.BE.C5=t.C5,t.BE.9p(2),t.BE.VX=!1,"3B"===t.BE.o.1I&&(t.iX-=t.BE.I/2,t.iY-=t.BE.F/2,t.BE.iX-=t.BE.I/2,t.BE.iY-=t.BE.F/2),t.BE.1v(),t.M){if(t.M.Z=t.M.C5=t.Z,t.M.IE=ZC.AK(t.A.A.K+"-1D"),t.M.K=t.A.K+"-2P-1G-"+t.GX,t.M.GG=t.A.K+"-2P-1G zc-2P-1G",t.M.o.bh=t.M.o.bh||"c",!t.WG["2Z-1N"])1P(t.DP){2n:t.M.x=t.iX,t.M.y=t.iY;1p;1j"1y":1j"4x":1j"5t":1j"fA":t.M.o.x=ZC.1l((t.BE.CY[0]+t.BE.CY[2])/2),t.M.o.y=ZC.1l((t.BE.CY[1]+t.BE.CY[3])/2)}if(ZC.bN||t.M.1q(),t.M.iX=t.M.iX+t.BE.BJ,t.M.iY=t.M.iY+t.BE.BD,t.M.AL){if(t.SD&&t.SD.D.1h>0){if(!ZC.AK(t.A.K+"-2F-5l")){1a i=t.A.A.I+"/"+t.A.A.F;ZC.P.JU({2m:"zc-3i",wh:i,id:t.A.K+"-2F-5l",p:ZC.AK(t.A.A.K+"-2F-5l")},t.A.A.AB),ZC.P.H6({2m:ZC.1b[24],id:t.A.K+"-2F-5l-c",p:ZC.AK(t.A.K+"-2F-5l"),wh:i},t.A.A.AB)}1a n=t.SD.D,a=t.SD.o.bh||"",l=n[n.1h-1];1P(a){1j"l":t.M.iX=l[0]+t.BE.BJ,t.M.iY=l[1]-t.M.F/2+t.BE.BD;1p;1j"r":t.M.iX=l[0]-t.M.I+t.BE.BJ,t.M.iY=l[1]-t.M.F/2+t.BE.BD;1p;1j"t":t.M.iX=l[0]-t.M.I/2+t.BE.BJ,t.M.iY=l[1]+t.BE.BD;1p;1j"b":t.M.iX=l[0]-t.M.I/2+t.BE.BJ,t.M.iY=l[1]-t.M.F+t.BE.BD;1p;2n:t.M.iX=l[0]-t.M.I/2+t.BE.BJ,t.M.iY=l[1]-t.M.F/2+t.BE.BD}e=ZC.P.E6(ZC.AK(t.A.K+"-2F-5l-c"),t.A.H.AB),ZC.CN.2E(e,t.SD),ZC.CN.1v(e,t.SD,n)}if(t.M.VX=!1,t.WG["2Z-1N"]&&(t.M.GG=t.A.K+"-nK-1G zc-nK-1G",t.M.iX<t.A.iX||t.M.iX+t.M.I>t.A.iX+t.A.I||t.M.iY<t.A.iY||t.M.iY+t.M.F>t.A.iY+t.A.F))1m;t.M.1v(),t.E["6F-3a"]?t.M.EH(ZC.AK(t.E["6F-3a"])):t.M.EH()}}}}),ZC.DQ=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.IE=1c,t.GG="",t.AP=1c,t.O3="3E",t.JQ="6o",t.DG=1o.iU,t.GB=1o.9W,t.BZ="#4e",t.iA=!1,t.MX=!1,t.QO=!1,t.K4="1Z",t.7C="5e",t.Y1=0,t.FM=2,t.FN=2,t.FV=2,t.EO=2,t.qL=!1,t.hU=!1,t.FF=-1,t.KI=0,t.NF=0,t.OL=ZC.3q,t.gN=!1,t.o9=!0,t.WJ=1o.uM,t.o3=1.65,t.WB=1,t.VO=!1,t.A8=1c,t.V0=!1,t.ll=!1},aj:1f(){1a e=1g.b();1m 1g.ef(e,"cR,oX,6S,6U,1r,6u,6R,bs,gL,eb,cK,dv,dt,dj,1D","O3,JQ,DG,GB,BZ,iA,7C,MX,QO,K4,FM,FN,FV,EO,AP"),e},1Q:1f(e){1g.b(e);1k(1a t=1g,i="O3,JQ,DG,GB,BZ,iA,7C,MX,K4,QO,FM,FN,FV,EO,AP".2l(","),n=0,a=i.1h;n<a;n++)1w e[i[n]]!==ZC.1b[31]&&(t[i[n]]=e[i[n]])},KC:1f(e){1m e},lk:1f(e){1m"6u"===e||"14E"===e||"na"===e||"o0"===e||"14G"===e||"14H"===e||"wu"===e},gn:1f(e){1a t=1g;if(t.WJ)1m e.1E(/(<([^>]+)>)/gi,"").1h*t.DG/(t.o3*(t.lk(t.7C)?.87:1)*(t.MX?.95:1));1a i="";1m 1w t.o["4a-4B"]!==ZC.1b[31]&&ZC.2q(t.o["4a-4B"])&&(i="[o6]"),ZC.P.lC(1g.H.K,i+e,1g.GB,1g.DG,1g.7C,1g.FF)},1q:1f(){1g.I=1g.F=1g.NF=1g.KI=0,1g.b();1a e,t,i,n,a,l=1g;if(!l.o.cX){if(l.ZA("1D","AP"),1c!==ZC.1d(l.AP)&&(l.AP=""+l.AP,l.AP=l.KC(l.AP),l.AP=l.AP.1E(/\\n/g,"<br>").1E(/\\\\n/g,"<br>"),"2B"===l.H.AB&&(l.AP=l.AP.1E(/&8J;/g," "))),l.4y([["ix","o9","b"],["8u-1s","WJ","b"],["1V-1s","OL","i"],["1y-1L","FF","i"],["1s-fD","o3","f"],["14K-1D","hU","b"],["3r-1D","qL","b"],["6u","iA","b"],["bs","MX","b"],["gL","QO","b"],["1D-c3","K4"],["aO","gN","b"],["1D-3s","O3"],["3s","O3"],["9r-3s","JQ"],["2p-2b","DG","f"],["1V-sB","Y1","i"],["2p-9g","GB"],["2p-2c","AA","i"],["1r","BZ","c"],["2p-1r","BZ","c"],["1D-2k","WB","f",0,1],["14z-o5","V0","b"]]),l.DG=ZC.BN(1,l.DG),1c===ZC.1d(l.o["1D-2k"])&&(l.WB=l.C6),l.iA&&(l.7C="6u"),1c!==(e=ZC.1d(l.o["2p-7a"]))&&(l.7C=e),1c===ZC.1d(l.o["1D-c3"])&&(l.K4=l.QO?"gL":"1Z"),1c!==(e=ZC.1d(l.o["2p-1H"]))&&(l.MX="bs"===e||"bP"===e),1c!==(e=ZC.1d(l.o.3u))){1a o=5X(e).2l(/\\s+|;|,/);t=1===o.1h?[ZC.1l(o[0]),ZC.1l(o[0]),ZC.1l(o[0]),ZC.1l(o[0])]:2===o.1h?[ZC.1l(o[0]),ZC.1l(o[1]),ZC.1l(o[0]),ZC.1l(o[1])]:3===o.1h?[ZC.1l(o[0]),ZC.1l(o[1]),ZC.1l(o[2]),ZC.1l(o[0])]:[ZC.1l(o[0]),ZC.1l(o[1]),ZC.1l(o[2]),ZC.1l(o[3])],l.FM=t[0],l.FN=t[1],l.FV=t[2],l.EO=t[3]}if(l.4y([["3u-1u","FM","i"],["3u-2x","FN","i"],["3u-2a","FV","i"],["3u-1J","EO","i"]]),l.AP){l.Y1>0&&l.AP.1h>l.Y1&&(l.AP=l.AP.2s(0,l.Y1)+"...");1a r=l.AP.2l(/<br>|<br\\/>|<br \\/>|\\n/),C="";1w l.o["4a-4B"]!==ZC.1b[31]&&ZC.2q(l.o["4a-4B"])&&(r=[l.AP],C="[o6]");r.1h;1k(l.KI=ZC.P.lC(1g.H.K,C+l.AP,1g.GB,1g.DG,1g.7C,1g.FF,!0)+l.FM+l.FV,i=0,n=r.1h;i<n;i++)l.NF=ZC.BN(l.NF,l.gn(r[i])+l.EO+l.FN)}1t l.AP="",l.NF=ZC.1l(1.25*l.DG),l.KI=-1===l.FF?ZC.1l(1.25*l.DG):l.FF;if((1c===ZC.1d(l.o[ZC.1b[19]])||8a(l.I)||0===l.I)&&(l.I=l.NF),(1c===ZC.1d(l.o[ZC.1b[20]])||8a(l.F)||0===l.F)&&(l.F=l.KI),l.I=ZC.CV(l.I,l.OL),l.hU&&l.NF>l.I&&!l.E.o8&&l.I>2*l.DG){1a A,s="",Z=0,c=l.AP.1E(/<br>/gi," [##] ").2l(/\\s|<br>/),u=[];1k(i=0,n=c.1h;i<n;i++)if((A=l.gn(c[i]))>.9*l.I){1a p=1A.4h(A/l.I*.9),h=1A.4h(c[i].1h/p);1k(a=0;a<p;a++)u.1i(c[i].5v(a*h,h))}1t u.1i(c[i]);1k(i=0,n=u.1h;i<n;i++)""!==u[i]&&("[##]"===u[i]?(s+="<br>",Z=0):(Z+=A=1+l.gn(u[i]+" "))>.9*l.I?(i>0&&(s+="<br>"),s+=u[i]+" ",Z=A):s+=u[i]+" ");s=(s=s.1E(/<br><br>/g,"<br>").1E(/ <br> <br>/g," <br>")).1E(/(.+?)<br> $/g,"$1");1a 1b=l.o.1D;l.o.1D=s,l.E.o8=!0,l.1q(),l.o.1D=1b,l.E.o8=!1}if(!(1c!==ZC.1d(l.o[ZC.1b[19]])&&1c!==ZC.1d(l.o[ZC.1b[20]])||1c===ZC.1d(l.o.2G)&&1c===ZC.1d(l.o.2v)&&1c===ZC.1d(l.o[ZC.1b[57]])&&1c===ZC.1d(l.o[ZC.1b[58]])&&1c===ZC.1d(l.o[ZC.1b[59]])&&1c===ZC.1d(l.o[ZC.1b[60]]))){l.iX=-1,l.iY=-1;1a d=l.o[ZC.1b[19]],f=l.o[ZC.1b[20]];1c===ZC.1d(d)&&(l.o[ZC.1b[19]]=l.I),1c===ZC.1d(f)&&(l.o[ZC.1b[20]]=l.F),l.9p(),l.o[ZC.1b[19]]=d,l.o[ZC.1b[20]]=f}if(1w l.o["4a-4B"]===ZC.1b[31]||!l.o["4a-4B"]){1a g=1A.4h((l.NF-l.EO-l.FN)/l.DG);g>0&&(l.AP=l.AP.1E(/<hr>/g,1n 3K(g).2I("\\14U")))}}l.gU()},1v:1f(){1a e,t,i,n,a,l,o,r,C,A,s,Z=1g;if(!Z.VO&&!Z.o9){1a c=!0;1c!==ZC.1d(Z.o.ww)&&(c=ZC.2q(Z.o.ww));1a u,p,h={x:Z.iX+Z.EO-1,y:Z.iY+Z.FM-1,1s:Z.I-Z.EO-Z.FN+2,1L:Z.F-Z.FM-Z.FV+2,1I:Z.E.sX||""},1b=[[0,0]];1k(c&&(1b=[[0,0],[0,2],[0,-4],[0,4],[0,-8],[3,0],[-6,0],[5,0],[-10,0]]),p=0;p<1b.1h;p++){1k(u=!0,h.x+=1b[p][0],h.y+=1b[p][0],a=0,l=Z.H.SL.1h;a<l;a++)ZC.AN.XG(h,Z.H.SL[a],-2)&&(u=!1);if(u){Z.iX=h.x,Z.iY=h.y;1p}}if(!u)1m;Z.H.SL.1i(h)}1a d=Z.H.AB;if(e=ZC.P.E6(Z.Z,d),Z.VO||Z.b(),!Z.ll&&(Z.o[ZC.1b[19]]||!(Z.I-Z.EO-Z.FN<2))&&(Z.o[ZC.1b[20]]||!(Z.KI-Z.FM-Z.FV<2))){1a f=Z.AA%2j==0?"0":"";if((Z.VO||1o.hz&&"3a"===d)&&(f=""),ZC.3I&&"2B"===d&&""===Z.GG&&(Z.GG=Z.K+"-3g"),!Z.VO&&ZC.AK(Z.K)&&(d="1b",ZC.bN))1m ZC.AK(Z.K).1H.1u=Z.iY+Z.BD+"px",8j(ZC.AK(Z.K).1H.1J=Z.iX+Z.BJ+"px");1a g=1w Z.E["4a-4B"]!==ZC.1b[31]&&Z.E["4a-4B"],B=g;1w Z.o["4a-4B"]!==ZC.1b[31]&&(g=ZC.2q(Z.o["4a-4B"]));1a v=[Z.AP];g||(v=Z.AP.2l(/<br>|<br\\/>|<br \\/>|\\n/)),g&&!B&&"2B"===d&&"0"===f&&(f="14k");1a b,E,m,K,F,D,I,X,x,y,L,Y,w,M,H,N,S,O,P,k,G,z,T=Z.IE?Z.IE:Z.Z.6s;1P(d+f){1j"14w":1j"149":1j"yJ":if(n=1,!g)1P(Z.JQ){1j"6o":n+=(Z.F-Z.KI)/2;1p;1j"2a":n+=Z.F-Z.KI}if(o=ZC.P.HO({id:Z.K,2m:Z.GG,tl:ZC.4t(Z.iY+Z.BD)+"/"+ZC.4t(Z.iX+Z.BJ),wh:Z.I+"/"+Z.F,2G:"4A",3u:0,2v:0,9R:g?"2f":"9c",cR:Z.O3}),g&&(B||d+f!=="yJ"||(T=ZC.AK(Z.H.K+"-1u")),T.2X(o)),ZC.P.HO({id:Z.K+"-t",2m:""!==Z.GG?Z.GG+"-t":"",p:o,1s:Z.I-Z.EO-Z.FN,1L:g?1c:Z.KI-Z.FM-Z.FV,tl:n+"/0",4a:Z.AP+"",2G:"4A",yK:"lF",3k:Z.WB,1r:Z.BZ,6R:Z.7C,cD:Z.MX?"bP":"5e",eb:Z.K4,6S:Z.DG,6U:Z.GB,ko:Z.FM,nP:Z.FN,nL:Z.FV,jW:Z.EO,oX:Z.JQ,cR:Z.O3,c0:-1===Z.FF?"125%":Z.FF+"px",aO:Z.gN,3u:0}),Z.E["2K-3J"]&&(o.1H.3J=Z.E["2K-3J"],Z.E["2K-3J"]=1c),B&&Z.H&&Z.H.A8&&!Z.o[ZC.1b[19]]&&!Z.o[ZC.1b[20]]){1a J=ZC.A4("#"+Z.K+"-t");"3a"===d&&(ZC.AK(Z.H.K+"-2C-c").1s=J.1s()+Z.EO+Z.FN,ZC.AK(Z.H.K+"-2C-c").1L=J.1L()+Z.FM+Z.FV),Z.H.A8.3v(),Z.I=J.1s()+Z.EO+Z.FN,Z.F=J.1L()+Z.FM+Z.FV,Z.1v()}1p;1j"3a":1a Q=!1;if(ZC.A4.6A.l8&&Z.AA%90==0&&0!==Z.AA&&(Z.AA+=.5,Q=!0),e=Z.Z.9j("2d"),1o.3G.g3&&(ZC.d4||(ZC.d4={})),!1o.3G.g3||1o.3G.g3&&!ZC.d4[Z.K]){1k(1o.3G.g3&&(ZC.d4[Z.K]=2e.4N("3a"),ZC.d4[Z.K].1s=Z.NF,ZC.d4[Z.K].1L=Z.KI),b=-1===Z.FF?0:ZC.4t(Z.FF-1.25*Z.DG)/2,a=0,l=v.1h;a<l;a++)if(""!==ZC.GO(v[a])){1P(t=1===l?Z.NF:Z.gn(v[a])+Z.FN+Z.EO,E=v[a],m=-1===E.1K("<")?E:E.1E(/<.+?>/gi,"").1E(/<\\/.+?>/gi,""),i=0,n=0,Z.O3){1j"3E":i+=(Z.I-t)/2;1p;1j"2x":i+=Z.I-t}1P(Z.JQ){1j"6o":n+=(Z.F-Z.KI)/2;1p;1j"2a":n+=Z.F-Z.KI}if(K=0,E!==m){1k(;D=/<(.+?)>(.*?)<\\/(.+?)>/.3j(E);){1P(I="",X="",(A=/(.+?)1H=(.+?)(\\\'|")(.*?)/.3j(D[1]))&&(X=A[2].1E(/\\\'|"/g,"")),D[3]){1j"b":1j"yM":I="2p-7a:6u";1p;1j"i":1j"em":I="2p-1H:bs";1p;1j"u":I="1D-c3:gL"}y=\'[[7D 1H="\'+(""===I?"":I+";")+X+\'"]]\'+D[2]+"[[/7D]]",E=E.1E(D[0],y)}1k(L=!1,P=0,k=(D=(E=E.1E(/\\[\\[/g,"<").1E(/\\]\\]/g,">").1E(/<7D/g,"[[*]]<7D").1E(/<\\/7D>/g,"</7D>[[*]]")).2l("[[*]]")).1h;P<k;P++)if(""!==D[P]){if(r=Z.BZ,Y=Z.7C,w=Z.MX,M=Z.QO,H=Z.DG,N=Z.GB,O=Z.FF,S=Z.K4,F=D[P],s=/<7D 1H=(.+?)>(.+?)<\\/(.+?)>/.3j(D[P]))1k(F=s[2],G=0,z=(x=s[1].1E(/\\\'|"/g,"").2l(/;|:/)).1h;G<z-1;G+=2)1P(ZC.GO(x[G])){1j"2p-2b":H=ZC.1l(ZC.GO(x[G+1]));1p;1j"2p-9g":N=ZC.GO(x[G+1]);1p;1j"2p-7a":Y=ZC.GO(x[G+1]);1p;1j"2p-1H":-1!==ZC.AT(["bs","bP"],ZC.GO(x[G+1]))&&(w=!0);1p;1j"1D-c3":S=ZC.GO(x[G+1]);1p;1j"1y-1L":O=ZC.1l(ZC.GO(x[G+1]));1p;1j"1r":r=ZC.AO.G3(ZC.GO(x[G+1]))}0===a&&(b=-1===O?0:ZC.4t(O-1.25*H)/2);1a W={bI:a,bZ:e,i:w,fw:Y,fs:H,lh:O,ff:N,c:r,t:F,dx:i,dy:n};W.dy+=ZC.4t(b),W.dy+=L||Z.lk(Y)||M?2:0,Z.rh(W),L=w,K++,i+=ZC.P.lC(1g.H.K,F,N,H,Y,O)}1c!==ZC.1d(O)&&1c!==ZC.1d(H)&&(b+=-1===O?1.25*H:O)}1t Z.rh({bI:a,bZ:e,i:Z.MX,fw:Z.7C,fs:Z.DG,lh:Z.FF,ff:Z.GB,c:Z.BZ,t:v[a],dx:i,dy:n+b}),b+=-1===Z.FF?1.25*Z.DG:Z.FF}}1t e.cM(ZC.d4[Z.K],Z.iX+Z.BJ,Z.iY+Z.BD);Q&&(Z.AA-=.5);1p;1j"3I":1P(n=0,Z.JQ){1j"1u":n-=(Z.F-Z.KI)/2;1p;1j"2a":n+=(Z.F-Z.KI)/2}1a R=ZC.P.F1("7q:1y"),V=Z.iX+Z.BJ+Z.I/2,U=Z.iY+Z.BD+Z.F/2,j=ZC.ED(Z.AA)*(Z.I-Z.EO-Z.FN)/2,q=ZC.EL(Z.AA)*(Z.I-Z.EO-Z.FN)/2,$=ZC.1l(V-j-ZC.ED(90-Z.AA)*n),ee=ZC.1l(U-q+ZC.EL(90-Z.AA)*n),te=ZC.1l(V+j-ZC.ED(90-Z.AA)*n),ie=ZC.1l(U+q+ZC.EL(90-Z.AA)*n);$===te&&($-=.8E,te+=.8E),ee===ie&&(ee-=.8E,ie+=.8E),r=Z.BZ,0!==Z.AA&&Z.C6<1&&(r=ZC.AO.QJ(r,99*(1-Z.C6))),ZC.P.G2(R,{id:Z.K+"-1y",6l:$+"px,"+ee+"px",to:te+"px,"+ie+"px",14h:r}),R.aB=!0,R.iL=!1;1a ne=ZC.P.F1("7q:2M");ne.4l("14j",!0),R.2X(ne);1a ae=ZC.P.F1("7q:14r"),le=Z.AP.1E(/<br>|<br\\/>|<br \\/>/gi,"\\n").1E(/<.+?>/gi,"").1E(/<\\/.+?>/gi,"");ZC.P.G2(ae,{on:!0,2Y:le}),ZC.P.PC(ae,{1r:r,6R:Z.7C,cD:Z.MX?"bP":"5e",eb:Z.K4,6S:Z.DG+"px",6U:Z.GB,"v-1D-3s":Z.O3}),R.2X(ae),e.2X(R);1p;1j"2B":1j"14s":1a oe=Z.iX+Z.EO+Z.BJ,re=Z.iY+Z.FM+Z.BD;if(o=ZC.P.F1("1D",ZC.1b[36]),ZC.P.G2(o,{x:ZC.4t(oe),y:ZC.4t(re),id:Z.K,"3g":Z.GG,3k:Z.WB}),Z.E["2K-3J"]&&(o.1H.3J=Z.E["2K-3J"],Z.E["2K-3J"]=1c),Z.gN&&ZC.P.G2(o,{"1D-bh":ZC.A4.6A.a6?"":"6n","14t-4B":"rl",bB:"aO","qP-ey":"ey-7c"}),Z.qL&&(Z.H.K8.2X(ZC.P.XA({id:Z.K+"-3r",2M:[[Z.iX+Z.EO+Z.AQ+Z.BJ,Z.iY+Z.FM+Z.AQ+Z.BD].2I(","),[Z.iX+Z.I-Z.FN-Z.AQ+Z.BJ,Z.iY+Z.FM+Z.AQ+Z.BD].2I(","),[Z.iX+Z.I-Z.FN-Z.AQ+Z.BJ,Z.iY+Z.F-Z.FV-Z.AQ+Z.BD].2I(","),[Z.iX+Z.EO+Z.AQ+Z.BJ,Z.iY+Z.F-Z.FV-Z.AQ+Z.BD].2I(","),[Z.iX+Z.EO+Z.AQ+Z.BJ,Z.iY+Z.FM+Z.AQ+Z.BD].2I(",")].2I(" ")})),ZC.P.G2(o,{"3r-2M":"3P(#"+Z.K+"-3r)"})),Z.AA%2j!=0&&o.4l("5H","gb("+Z.AA+" "+(oe+(Z.I-Z.EO-Z.FN)/2)+" "+(re+(Z.F-Z.FM-Z.FV)/2)+")"),g&&T.2X(o),g){ZC.P.ES(Z.K+"-8Z");1a Ce=ZC.P.F1("3A");ZC.P.PC(Ce,{2G:"4A",1J:0,1u:0,1s:Z.I-Z.EO-Z.FN+"px",1L:Z.F-Z.FM-Z.FV+"px",1r:Z.BZ,6S:Z.DG+"px",6U:Z.GB,6R:Z.7C,eb:Z.K4,cR:Z.O3,cD:Z.MX?"bs":"5e"}),Ce.id=Z.K+"-8Z",Ce.7V="zc-1H zc-4a-4B",Ce.4n=v[0],1===Z.o["z-2V"]?ZC.AK(Z.H.K+"-1u").1C(Ce):ZC.AK(Z.H.K+"-1u").hL(Ce,ZC.AK(Z.H.K+"-5U")),B&&Z.H&&Z.H.A8&&(Z.o[ZC.1b[19]]||Z.o[ZC.1b[20]]||(Z.H.A8.3v(),Ce.1H.1s="",Ce.1H.1L="",Z.I=ZC.A4(Ce).1s()+Z.EO+Z.FN,Z.F=ZC.A4(Ce).1L()+Z.FM+Z.FV,Z.1v()))}1t 1k(b=-1===Z.FF?0:ZC.4t(Z.FF-1.25*Z.DG)/2,a=0,l=v.1h;a<l;a++){1P(t=1===l?Z.NF:Z.gn(v[a])+Z.FN+Z.EO,E=v[a],m=-1===E.1K("<")?E:E.1E(/<.+?>/gi,"").1E(/<\\/.+?>/gi,""),i=0,n=Z.DG,Z.O3){1j"3E":i=(Z.I-t)/2;1p;1j"2x":i=Z.I-t}1P(Z.JQ){1j"6o":n+=(Z.F-Z.KI)/2;1p;1j"2a":n+=Z.F-Z.KI}if(K=0,E!==m){1k(;D=/<(.+?)>(.*?)<\\/(.+?)>/.3j(E);){1P(I="",X="",(A=/(.+?)1H=(.+?)(\\\'|")(.*?)/.3j(D[1]))&&(X=A[2].1E(/\\\'|"/g,"")),D[3]){1j"b":1j"yM":I="2p-7a:6u";1p;1j"i":1j"em":I="2p-1H:bs";1p;1j"u":I="1D-c3:gL"}y=\'[[7D 1H="\'+(""===I?"":I+";")+X+\'"]]\'+D[2]+"[[/7D]]",E=E.1E(D[0],y)}1k(L=!1,P=0,k=(D=(E=E.1E(/\\[\\[/g,"<").1E(/\\]\\]/g,">").1E(/<7D/g,"[[*]]<7D").1E(/<\\/7D>/g,"</7D>[[*]]")).2l("[[*]]")).1h;P<k;P++)if(""!==D[P]){if(r=Z.BZ,Y=Z.7C,w=Z.MX,M=Z.QO,H=Z.DG,N=Z.GB,S=Z.K4,O=Z.FF,F=D[P],s=/<7D 1H=(.+?)>(.+?)<\\/(.+?)>/.3j(D[P]))1k(F=s[2],G=0,z=(x=s[1].1E(/\\\'|"/g,"").2l(/;|:/)).1h;G<z-1;G+=2)1P(ZC.GO(x[G])){1j"2p-2b":H=ZC.1l(ZC.GO(x[G+1]));1p;1j"2p-9g":N=ZC.GO(x[G+1]);1p;1j"2p-7a":Y=ZC.GO(x[G+1]);1p;1j"2p-1H":-1!==ZC.AT(["bs","bP"],ZC.GO(x[G+1]))&&(w=!0);1p;1j"1D-c3":S=ZC.GO(x[G+1]);1p;1j"1y-1L":O=ZC.1l(ZC.GO(x[G+1]));1p;1j"1r":r=ZC.AO.G3(ZC.GO(x[G+1]))}n=H,C=ZC.P.F1("yP",ZC.1b[36]),0===K?(ZC.P.G2(C,{x:ZC.4t(oe+i),y:ZC.4t(re+n),dy:ZC.4t(b)}),b+=-1===O?1.25*H:ZC.BN(1.5*H,O)):ZC.P.G2(C,{dx:L||Z.lk(Y)||M?2:0}),ZC.P.G2(C,{1r:r,3f:r}),ZC.P.PC(C,{6R:Y,cD:w?"bP":"5e",eb:S,6S:H+"px",6U:N,yI:"3e"});1a Ae=2e.4N("7D");Ae.4n=F,F=Ae.11O||Ae.rR,Ae=1c,C.rR=F,o.2X(C),L=w,K++}}1t Z.gN&&ZC.A4.6A.a6&&(i+=t-Z.EO-Z.FN),C=ZC.P.F1("yP",ZC.1b[36]),ZC.P.G2(C,{x:ZC.4t(oe+i),y:ZC.4t(re+n),1r:Z.BZ,3f:Z.BZ,dy:ZC.4t(b)}),ZC.P.PC(C,{6R:Z.7C,cD:Z.MX?"bP":"5e",eb:Z.K4,6S:Z.DG+"px",6U:Z.GB,yI:"3e"}),C.rR=m,o.2X(C),b+=-1===Z.FF?1.25*Z.DG:Z.FF}}g||!Z.VO&&o&&T&&(Z.H.FW?(-1!==ZC.P.SW(T).1K("zc-1D")&&1c===ZC.1d(Z.H.FW[T.id])&&(Z.H.FW[T.id]=2e.rp()),Z.H.FW[T.id]?Z.H.FW[T.id].2X(o):T.2X(o)):T.2X(o))}},rh:1f(e){1a t=1g,i=e.bI,n=e.bZ,a=e.i,l=e.fw,o=e.fs,r=e.ff,C=e.c,A=e.dx,s=e.dy,Z=e.t;n.gS(),n.da=t.WB;1a c="";if(c=(a?"bs":"5e")+" 5e "+l+" "+o+"px "+r,n.2p=c,n.cU=C,n.cR="1J",n.yX="yY",n.7f(t.iX+t.BJ,t.iY+t.BD),0!==t.AA&&(n.7f(t.I/2,t.F/2),n.gb(ZC.ST(t.AA)),n.7f(-t.I/2,-t.F/2)),n.7f(t.EO,t.FM+o),n.7f(A,s),n.pI(Z,0,0),1o.3G.g3){1a u=ZC.d4[t.K].9j("2d");u.2p=c,u.cU=C,u.cR="1J",u.yX="yY",u.pI(Z,t.EO,t.FM+o+1.25*i*o)}n.hx()},EH:1f(e){1a t=1g;if(ZC.3a&&"3a"===t.H.AB&&(e||(e=ZC.AK(t.H.K+"-lw-c")),!1o.hz&&t.AA%2j==0)){1a i=t.Z;t.Z=e,t.VO=!0;1a n=t.H.AB;t.H.AB="3a",t.1v(),t.VO=!1,t.H.AB=n,t.Z=i}}}),ZC.RD=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.CG="4F",t.NN={aZ:!0,2U:!0,"2F-2a":!0,"2F-1u":!0,4U:!0,2r:!0,4j:!0,2g:!0,"8F":!0,"1S-3B":!0},t.dm=!1,t.ez="pS",t.QK=1c,t.JD="",t.UF=!1,t.RR={},t.MZ="",t.11m={},t.QN="",t.F6="",t.M4={},t.HI=1c,t.AI=[],t.LI="",t.A8=1c,t.H3=1c,t.D5=1c,t.B9=1n ZC.wv(t),t.QP="",t.MJ=1c,t.NT=[1c,1c,1c,1c],t.O1=!1,t.N9="x",t.K3=!1,t.TR=!1,t.yk=!1,t.kX=!1,t.H1=!1,t.m6={},t.NP=1c,t.QA={},t.LQ=!1,t.QT=!1,t.11n=1c,t.SM=[],t.N={},t.MU=1c,t.DE=1c,t.U3=0,t.hp=0,t.lD=1,t.MB=1c,t.S4="",t.yz="F*11o$11q!",t.M7="",t.dn={},t.ZY=!1,t.AB="",t.K8=1c,t.ZH=!1,t.QH=["",""],t.L3=0,t.KL=[],t.mQ=0,t.n2=0,t.ep=!1,t.l2="",t.z4=!0,t.I0=1c,t.QI=[],t.NS=0,t.11w=!1,t.S5={},t.jm=!1,t.FW=1o.3G.kw?{}:1c,t.lU=!1,t.SL=[]},q8:1f(e){1a t=1g;if(e)1k(1a i=t.SL.1h-1;i>=0;i--)t.SL[i].1I===e&&t.SL.6p(i,1);1t t.SL=[]},2L:1f(){1m-1!==ZC.AT(1g.KL,ZC.1b[44])},mc:1f(e){1m e=e||"",ZC.AK(1g.K+"-3X-c"+(""===e?e:"-"+e))},9h:1f(){1a e;(e=ZC.AK(1g.K+"-2y"))&&(e.1H.3J="1Z"),1g.ep=!1},ZK:1f(){1k(1a e=1g,t=e.NT.1h,i=0;i<t;i++)if(1c!==ZC.1d(e.NT[i])){1P(e.AB){1j"2B":ZC.CN.VN(e.NT[i].bZ,e.NT[i].1H,e.NT[i].2M.2I(" "),e.NT[i].aB);1p;1j"3I":ZC.CN.VQ(e.NT[i].bZ,e.NT[i].1H,e.NT[i].2M.2I(" "),e.NT[i].aB)}e.NT[i]=1c}},rS:1f(){1f WW(e){if(ZC.pu&&ZC.pu 3z 3K){1a t=ZC.XN.eE(ZC.q0(ZC.lI(e)));-1!==ZC.AT(ZC.pu,t)&&(s.yk=!0)}}1a s=1g,i,A5,F5;ZC.h7=ZC.h7||1o.h7||"",ZC.cI=ZC.cI||1o.cI||"",ZC.lQ=ZC.lQ||1o.lQ||"";1a g8;g8="qn:"===2e.7W.iS?ZC.12J||"":2e.7W.12K;1a ca=[g8],CR=g8.2l(".");1k("8B"===CR[0]?ca.1i(g8.1E("8B.","")):ca.1i("8B."+g8),i=0;i<=CR.1h-2;i++){1k(1a qo="*",j=i;j<CR.1h;j++)qo+="."+CR[j];ca.1i(qo)}if(-1!==ZC.AT(ca,"yo")||-1!==ZC.AT(ca,"127.0.0.1"))s.TR=!0,s.kX=!0,WW("yo");1t{1a lM=[["2u.AC.12M.12N","Q^12O]12P`12R^`12T[12I"],["2u.12W.12X","12Y/12Z+131/133/138/+139+12t/12F="]];1k(i=0,A5=lM.1h;i<A5;i++)4I{if(7t(lM[i][0])===ZC.lI(lM[i][1])){s.TR=!0;1p}}4G(e){}1k(i=0,A5=ca.1h;i<A5;i++){1a qd=ZC.XN.eE(ZC.q0(ZC.lI(ca[i])));ZC.h7 3z 3K&&-1!==ZC.AT(ZC.h7,qd)&&(s.TR=!0,WW(qd))}ZC.cI 3z 3K&&2===ZC.cI.1h&&(F5=ZC.yy(s.yz),F5=F5.1E("O","0"),s.S4=ZC.yA(ZC.cI[0],F5),s.S4===ZC.cI[1]&&(s.TR=!0,s.kX=!0,WW(ZC.cI[0])))}},kW:1f(){1a e=1g;if(1c!==e.MJ)ZC.6v(e.MJ),e.2t();1t if(1c===ZC.1d(ZC.4b.1T["cG-"+e.QP])){1a t=["f0-2Y"===e.MZ?"eG="+1A.cW():"",1o.hw?"ja="+e.AB:""].2I("&");ZC.A4.av({1I:"bp",3P:e.QP,q2:"1D",dh:1f(t){e.RR.cG||"7g-fu"!==e.MZ||t.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:t,4L:1f(t,i,n,a){1m e.NM({8L:ZC.1b[63],aR:"bj cq gh ("+a+")"},ZC.1b[64]),!1},aD:1f(t){1a i;4I{i=3c.1q(t),ZC.4b.1T["cG-"+e.QP]=t}4G(n){1m e.NM(n,"3c nb"),!1}e.MJ=i,ZC.6v(e.MJ),e.2t()}})}1t{1a i;4I{i=3c.1q(ZC.4b.1T["cG-"+e.QP])}4G(n){1m e.NM(n,"3c nb"),!1}e.MJ=i,ZC.6v(e.MJ),e.2t()}},2t:1f(e,t){1a i=1g;if(i.M7="2t",""!==(t=t||i.QN)&&0!==t.1K("7u:"))if(1c===ZC.1d(ZC.4b.1T["1T-"+t])){1a n=["f0-2Y"===i.MZ?"eG="+1A.cW():"",1o.hw?"ja="+i.AB:""].2I("&");ZC.A4.av({1I:"bp",3P:t,q2:"1D",dh:1f(e){i.RR.1T||"7g-fu"!==i.MZ||e.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:n,4L:1f(e,t,n,a){1m i.NM({8L:ZC.1b[63],aR:"bj cq gh ("+a+")"},ZC.1b[64]),!1},aD:1f(t){i.gV(e,t)}})}1t i.gV(e,ZC.4b.1T["1T-"+t]),ZC.4b.1T["1T-"+t]=1c;1t""!==i.F6?i.gV(e,i.F6):1c!==i.M4&&(i.qg?i.M4=3c.1q(3c.5d(i.qg)):i.qg=3c.1q(3c.5d(i.M4)),i.gV(e,i.M4))},gV:1f(e,t){1a i=1g;ZC.TS[i.K]=(1n 9H).bi(),ZC.AO.qM("yC",i)?ZC.AO.C2("yC",i,i.FH(),t,1f(t){i.q7(e,t)}):i.q7(e,t)},kR:1f(e){1a t,i,n=1g;if(!1o.3G.rM)1m[];e||(e=n.o);1a a=[];if(e.aZ)1k(t=0,i=e.aZ.1h;t<i;t++){1a l=e.aZ[t].1I||"1c";if(-1===ZC.AT(ZC.yD,l)){"3d"===l.2s(l.1h-2)&&(l=l.2s(0,l.1h-2));1k(1a o in ZC.nc)ZC.nc.8d(o)&&-1!==ZC.AT(ZC.nc[o],l)&&(l=o);1o.qf(l),a.1i(l)}}1k(n.yE(e),t=0,i=ZC.RF.1h;t<i;t++)""!==ZC.GO(ZC.RF[t])&&-1===ZC.AT(ZC.WF,ZC.GO(ZC.RF[t]))&&a.1i(ZC.GO(ZC.RF[t]));1m a},yE:1f(e){1a t=1g;e||(e=t.o)},q7:1f(JB,TB){1a s=1g,G;s.E.xU=1o.3G.qq?TB:"N/A";1a DH=1c;if("2Y"==1w TB)4I{DH=3c.1q(TB)}4G(J5){4I{DH=7t("("+TB+")")}4G(J5){1m s.NM(J5,"3c nb"),!1}}1t DH=TB;1c===ZC.1d(DH[ZC.1b[16]])&&(DH={aZ:[DH]}),s.E.7d="N/A",1o.3G.qq&&(s.E.7d=ZC.GO(3c.5d(DH))),1o.iz(s,s.kR(DH),1f(){DH=ZC.AO.C2("gg",s,s.FH(),DH),1o.iz(s,s.kR(DH),1f(){if(ZC.AO.C2("Ls",s,{id:s.K}),1c===ZC.1d(JB))s.XH(DH),s.o=DH,s.dm?(s.1q(),s.1v()):s.PB(1f(){s.1q(),s.1v()});1t{1a e=s.OQ(JB);if(1c!==e&&1c!==ZC.1d(G=DH[ZC.1b[16]])){1a t=G.1h>1?G[e.L]:G[0];t.id||(t.id=e.o.id||""),s.o[ZC.1b[16]][e.L]=t,s.PB(1f(){s.1q(JB),s.AI[e.L].1v()})}}})})},XH:1f(DH){1a s=1g,G,i,A5,j,J2;1k(1c===ZC.1d(DH[ZC.1b[16]])&&(DH={aZ:[DH]}),1===DH[ZC.1b[16]].1h&&1c===ZC.1d(DH[ZC.1b[16]][0])&&(DH[ZC.1b[16]]=[{1I:"1c"}]),i=0,A5=DH[ZC.1b[16]].1h;i<A5;i++)if(1c!==ZC.1d(DH[ZC.1b[16]][i])){if(1c!==ZC.1d(G=DH[ZC.1b[16]][i].5W)){1a FE=[];1k(DH[ZC.1b[16]][i][ZC.1b[10]]=DH[ZC.1b[16]][i][ZC.1b[10]]||[],j=0,J2=G.1h;j<J2;j++)if(G[j].gu&&G[j]["2Z-1N"]||FE.1i(G[j]),1c!==ZC.1d(G[j].1I)&&0===G[j].1I.1K("1o."))4I{1a LS=G[j].x7||{},EG=G[j].1I+"."+(LS.8L||"");LS[ZC.1b[3]]=i;1a fV=7t(EG).4s(s,LS,DH,G[j]);1k(1a gv in fV)fV.8d(gv)&&("1G"===fV[gv].mK?DH[ZC.1b[16]][i][ZC.1b[10]].1i(fV[gv]):FE.1i(fV[gv]))}4G(e){}DH[ZC.1b[16]][i].5W=FE}1a mU;if(1c!==ZC.1d(mU=DH[ZC.1b[16]][i].gd))1k(1a zD=s.nS(DH,i),k=0;k<mU.1h;k++){1a ga=mU[k];if(1c!==ZC.1d(ga.1I)&&1c!==ZC.1d(1o.gd[ga.1I])&&"1f"==1w 1o.gd[ga.1I].1q)4I{1a BP={};ZC.2A(ga,BP),BP.2U=zD.2U,BP.6C={id:s.K,1s:s.I,1L:s.F};1a o=1o.gd[ga.1I].1q.4s(s,BP);if(1c!==ZC.1d(G=o.Kn))1k(j=0;j<G.1h;j++)DH[ZC.1b[16]].1i({}),ZC.2A(G[j],DH[ZC.1b[16]][DH[ZC.1b[16]].1h-1]);if(1c!==ZC.1d(G=o[ZC.1b[10]]))1k(1c===ZC.1d(DH[ZC.1b[16]][i][ZC.1b[10]])&&(DH[ZC.1b[16]][i][ZC.1b[10]]=[]),j=0;j<G.1h;j++)DH[ZC.1b[16]][i][ZC.1b[10]].1i(G[j]);if(1c!==ZC.1d(G=o.5W))1k(1c===ZC.1d(DH[ZC.1b[16]][i].5W)&&(DH[ZC.1b[16]][i].5W=[]),j=0;j<G.1h;j++)DH[ZC.1b[16]][i].5W.1i(G[j])}4G(e){}}}},zw:1f(e,t){1a i=1g;1P(e){1j"1y":1m 1n ZC.nM(i);1j"1M":1m 1n ZC.nN(i);1j"bF":1m 1n ZC.Bg(i);1j"bE":1m 1n ZC.Bf(i);1j"2Q":1j"5A":1j"8V":1m 1n ZC.kU(i);1j"6d":1m 1n ZC.kV(i);1j"9q":1j"iw":1j"b1":1k(1a n=!1,a=i.o[ZC.1b[16]][t][ZC.1b[11]],l=0,o=a.1h;l<o;l++)a[l]&&a[l].1I&&-1!==a[l].1I.1K("3d")&&(n=!0);1m n?1n ZC.qX(i):i.o[ZC.1b[16]][t].1B&&i.o[ZC.1b[16]][t].1I&&i.o[ZC.1b[16]][t].1B&&i.o[ZC.1b[16]][t].1B.1I&&-1!==i.o[ZC.1b[16]][t].1B.1I.1K("3d")?1n ZC.qX(i):"9q"===e?1n ZC.qU(i):1n ZC.Bd(i);1j"6t":1m 1n ZC.Bb(i);1j"8t":1m 1n ZC.Ba(i);1j"5h":1m 1n ZC.AS(i);1j"6z":1m 1n ZC.Ar(i);1j"9k":1j"3L":1m 1n ZC.nI(i);1j"96":1m 1n ZC.Ay(i);1j"74":1j"pn":1m 1n ZC.Ax(i);1j"aV":1m 1n ZC.Dn(i);1j"eZ":1j"8q":1m 1n ZC.Et(i);1j"80":1m 1n ZC.Es(i);1j"rC":1j"ao":1m 1n ZC.El(i);1j"ap":1m 1n ZC.Ek(i);1j"zH":1j"5O":1m 1n ZC.Em(i);1j"8f":1m 1n ZC.Ei(i);1j"5y":1m 1n ZC.Ev(i);1j"rc":1m 1n ZC.Eo(i);1j"8M":1m 1n ZC.Eh(i);1j"8Y":1m 1n ZC.Ff(i);1j"81":1m 1n ZC.Ey(i);1j"oF":1j"7k":1m 1n ZC.Fm(i);1j"ej":1j"6M":1m 1n ZC.Fi(i);1j"7v":1m 1n ZC.Fk(i);1j"qR":1m 1n ZC.zZ(i);2n:1m 1n ZC.Ao(i)}},OQ:1f(e){1k(1a t=1g,i=0,n=t.AI.1h;i<n;i++)if(t.AI[i].K===t.K+"-2U-"+e||t.AI[i].K===t.K+"-2U-id"+e||t.AI[i].K===e||i===e)1m t.AI[i];1m 1c},ki:1f(e,t){1a i=1g,n=ZC.A4("#"+i.K+("2B"===i.AB?"-1u":"-3X")),a=ZC.ak(i.K);e-=n.1Y().1J,t-=n.1Y().1u;1k(1a l=1c,o=0,r=i.AI.1h;o<r;o++)ZC.DU(e,i.AI[o].iX,i.AI[o].iX+i.AI[o].I*a[0])&&ZC.DU(t,i.AI[o].iY,i.AI[o].iY+i.AI[o].F*a[1])&&(l=i.AI[o]);1m l},o4:1f(e){1a t,i=1g;if(1w i.E.zK===ZC.1b[31]){1w e===ZC.1b[31]&&(e=!1),i.4y([["bU","LI"]]),i.o[ZC.1b[16]]&&1===i.o[ZC.1b[16]].1h&&1c!==ZC.1d(t=i.o[ZC.1b[16]][0].bU)&&(i.LI=t),""===i.LI&&(i.LI="9b"),i.LI=5X(i.LI).1E("1o","cP");1k(1a n=i.LI.2l(/\\s+|;|,/),a=0,l=n.1h;a<l;a++)i.B9.qY(n[a]);i.B9.kW(i.MJ),ZC.2H&&i.B9.qY("2H"),e||(i.E.zK=!0)}},1q:1f(e){1a t,i,n,a,l,o,r=1g;r.N9="x",r.E.4F=ZC.GO(3c.5d(r.o)),ZC.2A(r.o.zN,r.NN),1===r.o[ZC.1b[16]].1h&&ZC.2A(r.o[ZC.1b[16]][0].zN,r.NN);1a C=r.FH();if(1c!==ZC.1d(e)&&(C[ZC.1b[3]]=e),ZC.AO.C2("La",r,C),r.M7="1q",r.QH[1]=r.QH[0],r.QH[0]="",r.QH[0]+=r.I+":"+r.F+":",1c!==ZC.1d(t=r.o[ZC.1b[16]]))1k(r.QH[0]+=t.1h+":",a=0;a<t.1h;a++)r.QH[0]+=(t[a].1I||"")+":",r.QH[0]+=(t[a].x||"")+":"+(t[a].y||"")+":"+(t[a][ZC.1b[19]]||"")+":"+(t[a][ZC.1b[20]]||"")+":",1c!==ZC.1d(t[a][ZC.1b[11]])&&(r.QH[0]+=t[a][ZC.1b[11]].1h+":");if(ZC.AK(r.K+"-3X-c")&&r.3v(e,!1),1w ZC.n5!==ZC.1b[31]&&(r.H3=1n ZC.n5(r)),1c===ZC.1d(e)){r.o4(),r.B9.B9["2p-9g"]&&(1o.9W=r.B9.B9["2p-9g"]);1a A=!!r.o.5f;if(r.B9.2t(r.o,"6C",!1,!0),r.4y([["5f","DE"],["zR","QK"]]),r.o[ZC.1b[16]]&&1===r.o[ZC.1b[16]].1h&&(i=r.o[ZC.1b[16]][0],1c!==ZC.1d(t=i.5f)&&(r.DE=t),1c!==ZC.1d(t=i.zR)&&(r.QK=t)),ZC.6v(r.QK),ZC.2A(r.B9.B9.an.5f,r.DE,!1,!0,!0),r.DE.aC)1k(a=r.DE.aC.1h-1;a>=0;a--)1k(o=0;o<a;o++)if(r.DE.aC[a].id===r.DE.aC[o].id){r.DE.aC.6p(a,1);1p}if(A||4o r.o.5f,ZC.6v(r.DE),r.N={},1c!==ZC.1d(t=r.o.1H))1k(n in t)"3P"!==n&&(r.N[n]=t[n]);if(r.o[ZC.1b[16]]&&1===r.o[ZC.1b[16]].1h&&(i=r.o[ZC.1b[16]][0],1c!==ZC.1d(t=i.1H)))1k(n in t)"3P"!==n&&(r.N[n]=t[n]);ZC.6v(r.N),r.NN[ZC.1b[16]]&&r.b(),r.4y([["iP","ez"],["mR-iP","ez"],["3t","N9"],["h-8O","mQ","i"],["v-8O","n2","i"],["7M","K3","b"],["4k-7Q","ZY","b"]]),r.o[ZC.1b[16]]&&1===r.o[ZC.1b[16]].1h&&(i=r.o[ZC.1b[16]][0],1c!==ZC.1d(t=i.iP)&&(r.ez=t),1c!==ZC.1d(t=i["mR-iP"])&&(r.ez=t),1c!==ZC.1d(t=i.7M)&&(r.K3=ZC.2q(t)),1c!==ZC.1d(t=i["4k-7Q"])&&(r.ZY=ZC.2q(t))),1c!==ZC.1d(t=1o.fI[r.ez])&&(ZC.HA=t),r.AI=[]}1a s=0,Z=0,c=r.I,u=r.F;if(1c!==ZC.1d(r.o.2v)||1c!==ZC.1d(r.o[ZC.1b[57]])||1c!==ZC.1d(r.o[ZC.1b[58]])||1c!==ZC.1d(r.o[ZC.1b[59]])||1c!==ZC.1d(r.o[ZC.1b[60]])){1a p=1n ZC.HQ(r);p.1C(r.o,!1,!1),p.1q(),s=p.DZ,Z=p.E2,c=c-p.DZ-p.E3,u=u-p.E2-p.DN}1a h,1b,d=r.OQ(e);if(1c!==ZC.1d(h=r.o[ZC.1b[16]])){1a f=0;1k(a=0,l=h.1h;a<l;a++)1b=0,1c!==ZC.1d(t=h[a].3b)&&(1b=ZC.1l(t)),f+=r.L3===1b?1:0;1a g=ZC.AN.g5(r.N9,f),B=ZC.1l(g[0]),v=ZC.1l(g[1]),b=0,E=0,m=0;1k(a=0,l=h.1h;a<l;a++){if(1b=0,1c===d&&1c!==ZC.1d(t=h[a].3b)&&(1b=ZC.1l(t)),(1c===d||m===d.L)&&r.L3===1b){if(r.AI[m]=r.zw(h[a].1I||"1c",a),r.AI[m].O9=r.AI[m].AF+"2U",r.B9.2t(r.AI[m].o,"2U"),r.B9.2t(r.AI[m].o,h[a].1I||"1c"),r.AI[m].1C(r.o.2U),r.AI[m].1C(h[a]),r.AI[m].L=m,1c===ZC.1d(h[m].id)||""===h[m].id?r.AI[m].K=r.K+"-2U-id"+m:r.AI[m].K=r.K+"-2U-"+h[a].id,h.1h>0){1k(1a K=0,F=0,D=ZC.1l((c-(v+1)*r.mQ)/v),I=ZC.1l((u-(B+1)*r.n2)/B),X=["x","y",ZC.1b[19],ZC.1b[20]],x=0;x<X.1h;x++)1c!==ZC.1d(r.E["2U-"+m+"-"+X[x]])&&(4o r.E["2U-"+m+"-"+X[x]],4o r.AI[m].o[X[x]]);1c===ZC.1d(r.AI[m].o.x)?r.E["2U-"+m+"-x"]=r.AI[m].o.x=ZC.1l(r.iX+(b+1)*r.mQ+b*D)+s:(K=ZC.IB(r.AI[m].o.x))<1&&(K=ZC.1l(r.I*K)),1c===ZC.1d(r.AI[m].o.y)?r.E["2U-"+m+"-y"]=r.AI[m].o.y=ZC.1l(r.iY+(E+1)*r.n2+E*I)+Z:(F=ZC.IB(r.AI[m].o.y))<1&&(F=ZC.1l(r.F*F)),1c===ZC.1d(r.AI[m].o[ZC.1b[19]])&&(r.E["2U-"+m+"-1s"]=r.AI[m].o[ZC.1b[19]]=1A.1V(D,D-K)),1c===ZC.1d(r.AI[m].o[ZC.1b[20]])&&(r.E["2U-"+m+"-1L"]=r.AI[m].o[ZC.1b[20]]=1A.1V(I,I-F))}r.AI[m].1q()}r.L3===1b&&(m++,++b===v&&(E++,b=0))}}1c===ZC.1d(e)&&1c!==ZC.1d(t=r.o.cO)&&(r.HI={1I:"jc",ds:10},ZC.2A(t,r.HI))},j3:1f(e,t){t=t||"";1a i=[];1k(1a n in e)if("4g"==1w e[n])1k(1a a=1g.j3(e[n],t+"."+n),l=0,o=a.1h;l<o;l++)-1===ZC.AT(i,a[l])&&i.1i(a[l]);1t{1a r=t+"."+n;"1R-4d"!==n&&"z9"!==n||""===e[n]||"zc."===e[n].2s(0,3)||(!ZC.6O&&ZC.mZ&&"za"===e[n].2s(0,8)&&(e[n]=ZC.mZ[e[n].2s(8)]),"!"===e[n].fq(0)&&(e[n]=e[n].2s(1),1g.E["bd-8D"]=1g.E["bd-8D"]||[],1g.E["bd-8D"].1i(e[n])),i.1i([e[n],"4d"])),"4T"===n&&""!==e[n]&&"zc."!==e[n].2s(0,3)&&-1!==r.1K(".8D.")&&(!ZC.6O&&ZC.mZ&&"za"===e[n].2s(0,8)&&(e[n]=ZC.mZ[e[n].2s(8)]),"!"===e[n].fq(0)&&(e[n]=e[n].2s(1),1g.E["bd-8D"]=1g.E["bd-8D"]||[],1g.E["bd-8D"].1i(e[n])),i.1i([e[n],"4d"])),".6K"===r.5v(r.1h-4,4)&&"2Y"==1w e[n]&&i.1i([e[n],"6K"]),"3P"===n&&(-1!==r.1K(".1H.")&&i.1i([e[n],"2K"]),-1!==r.1K(".6K.")&&i.1i([e[n],"6K"]),-1!==r.1K(".1O.")&&i.1i([e[n],"4d"])),"2Y"==1w e[n]&&"3P"!==n&&(0===e[n].1K("3P:")&&n===ZC.1b[5]||0===e[n].1K("7u:"))&&-1===ZC.AT(["5K","1D","Is"],ZC.EB(n))&&i.1i([e[n],"1T"])}1m i},PB:1f(J1){1f od(i){if(!(i>=IX.1h)){1a F6,MA,KA=IX[i][0],n3=IX[i][1];if("3P:"===KA.2s(0,4)){1a QN=KA.2s(4);s.QA["3P:"+QN]="[]";4I{F6=["f0-2Y"===s.MZ?"eG="+1A.cW():""].2I("&"),ZC.A4.av({1I:"bp",3P:QN,dh:1f(e){s.RR.1T||"7g-fu"!==s.MZ||e.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:F6,4L:1f(e,t,i,n){1m s.NM({8L:ZC.1b[63],aR:"bj cq gh ("+n+")"},ZC.1b[64]),!1},aD:1f(e,t,i,n){s.QA["3P:"+n]=e,U3++}})}4G(J5){1m s.NM(J5,ZC.1b[64]),!1}}1t if("7u:"===KA.2s(0,11))if("zc.Hv.2t"===s.QA[KA]){s.QA[KA]="[]";1a DX=ZC.AO.rB(KA.2s(11)),O={id:s.K,r8:KA,5I:1f(e){s.QA[KA]=e,U3++}},ZQ=DX[0];O.7Z=DX[1];4I{1a Z0=7t(ZQ).4s(s,O);1c!==ZC.1d(Z0)&&Z0&&(s.QA[KA]=Z0,U3++)}4G(J5){1m s.NM(J5,"ri 1T 6C"),!1}}1t U3++;1t"4d"===n3?(LD[KA]=1n cV,LD[KA].xf="xd",LD[KA].hv=1f(){U3++},LD[KA].li=1f(){1a e=ZC.2q(s.o.Ij);if(ZC.gs.1i(KA),e)1m s.NM({8L:ZC.1b[63],aR:"bj cq gh ("+1g.4T+")"},"bj 6C (4d)"),!1;1g.4T=ZC.kN,U3++},LD[KA].4T=KA,ZC.4b.1T[KA]=LD[KA]):"2K"===n3?(F6=["f0-2Y"===s.MZ?"eG="+1A.cW():""].2I("&"),ZC.A4.av({1I:"bp",3P:KA,dh:1f(e){s.RR.2K||"7g-fu"!==s.MZ||e.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:F6,4L:1f(e,t,i){1m s.NM(i,"bj 6C"),!1},aD:1f(e){1k(1a t={},i=e.ln(/[a-zA-Z0-9\\.\\#\\-](.+?)\\{((.|\\s)+?)\\}/gi),n=0,a=i.1h;n<a;n++){MA=i[n].2l("{");1a l=ZC.GO(MA[0]),o=l.2l(/\\s+/);if(1===o.1h||2===o.1h&&ZC.GO(o[0])==="#"+s.K){t[l=ZC.GO(1===o.1h?o[0]:o[1])]||(t[l]={});1k(1a r=0,C=(MA=MA[1].1E("}","").2l(";")).1h;r<C;r++){1a A=MA[r].2l(":");2===A.1h&&(t[l][ZC.GO(A[0])]=""+ZC.GO(A[1]))}}}1c!==ZC.1d(s.o.1H)?ZC.2A(t,s.o.1H):1c!==ZC.1d(s.o[ZC.1b[16]])&&1===s.o[ZC.1b[16]].1h&&s.o[ZC.1b[16]][0].1H&&ZC.2A(t,s.o[ZC.1b[16]][0].1H),U3++}})):"6K"===n3&&(F6=["f0-2Y"===s.MZ?"eG="+1A.cW():""].2I("&"),ZC.A4.av({1I:"bp",3P:KA,dh:1f(e){s.RR.6K||"7g-fu"!==s.MZ||e.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:F6,4L:1f(e,t,i){1m s.NM(i,"bj 6C"),!1},aD:1f(e,t,i,n){s.m6[n]=e,U3++}}))}}1a s=1g;if(1o.3G.rM){1a IX=s.j3(s.o).4w(s.j3(s.MJ));if(0!==IX.1h){1a U3=0,LD={},nA=0;s.E["bd-8D"]=s.E["bd-8D"]||[];1a C4=2u.fH(1f(){if(U3>=IX.1h){2u.9N(C4),s.nj(s.o);1k(1a e in LD)if(0!==e.1K("1T:")&&-1===ZC.AT(s.E["bd-8D"],e))4I{1a t=2e.4N("3a");t.1s=LD[e].1s,t.1L=LD[e].1L,t.9j("2d").cM(LD[e],0,0);1a i=t.jz("4d/9Y");LD[e].hv=1c,LD[e].li=1c,LD[e].4T=i,ZC.4b.1T[e]=LD[e]}4G(n){}2u.5G(1f(){1o.XQ[s.K]&&J1()},1)}1t od(++nA)},20);od(nA)}1t 1o.XQ[s.K]&&J1()}1t 1o.XQ[s.K]&&J1()},nj:1f(BY){1a s=1g;1k(1a p in BY)if("4g"==1w BY[p])s.nj(BY[p]);1t 1k(1a F6 in s.QA)F6===BY[p]&&(BY[p]=7t(s.QA[F6]))},bM:1f(e){1a t,i,n,a,l=1g;if(l.E.bM=!0,l.E.wh=l.I+"/"+l.F,l.o[ZC.1b[16]])if(l.jm)1o.3j(l.K,"9M"),1o.b3(1o.aY[l.K]);1t if(1w e===ZC.1b[31]&&(e=!1),ZC.AO.C2("bM",l,l.FH()),e=!1);1t{1k(i=0;i<l.AI.1h;i++)1k(a=0;a<l.AI[i].AX.A7.1h;a++)l.E["g-"+i+"-p-"+a+".2f"]=l.AI[i].E["1B"+a+".2f"];1k(i=0;i<l.AI.1h;i++)l.E["g-"+l.AI[i].L+"-aW"]=3c.5d(l.AI[i].CW);1k(1a o=l.o[ZC.1b[16]],r=[ZC.1b[10],"5W"],C=0,A=o.1h;C<A;C++)1k(1a s=0;s<r.1h;s++){1a Z=r[s],c=[];if(1c!==ZC.1d(o[C][Z])){1k(i=0,n=o[C][Z].1h;i<n;i++)o[C][Z][i].gu||c.1i(o[C][Z][i]);o[C][Z]=c}}if(l.XH(l.o),l.o=ZC.AO.C2("gg",l,l.FH(),l.o),ZC.A4("#"+l.K+"-1u").1s(l.I).1L(l.F),l.E["6l-7o"]&&(ZC.A4("#"+l.K+"-fP").1s(l.I).1L(l.F),4o l.E["6l-7o"]),1===(t=ZC.A4("#"+l.K+"-5U")).1h&&t.1s(l.I).1L(l.F).2K("3r","5t(88,"+(l.I-1)+"px,"+(l.F-1)+"px,88)"),"2B"===l.AB&&(l.K8.4l(ZC.1b[19],l.I),l.K8.4l(ZC.1b[20],l.F)),"3a"===l.AB||"3I"===l.AB){1k(ZC.A4("#"+l.K+"-3X").1s(l.I).1L(l.F),i=0,n=l.AI.1h;i<n;i++)ZC.A4("#"+l.AI[i].K+"-2J").3m();ZC.A4("#"+l.K+"-3X>3A").1s(l.I).1L(l.F)}1k("3a"===l.AB&&((t=ZC.AK(l.K+"-3X-c"))&&(t.1s=l.I,t.1L=l.F),(t=ZC.AK(l.K+"-3X-c-1u"))&&(t.1s=l.I,t.1L=l.F),ZC.A4("#"+l.K+"-2F-2a 3a, #"+l.K+"-2F-1u 3a, #"+l.K+"-b5 3a").4Z(1f(){1g.1s=l.I,1g.1L=l.F})),"3I"===l.AB&&ZC.A4("#"+l.K+"-2F-2a 3A, #"+l.K+"-2F-1u 3A, #"+l.K+"-b5 3A").4Z(1f(){1g.1H.1s=l.I+"px",1g.1H.1L=l.F+"px"}),l.1q(),i=0,n=l.AI.1h;i<n;i++)l.AI[i].U1&&l.AI[i].U1(),l.AI[i].HC=!0,l.AI[i].ru=l.AI[i].GA,l.AI[i].GA=!1;1k(l.1v(),i=0;i<l.AI.1h;i++)1k(a=0;a<l.AI[i].AX.A7.1h;a++)4o l.E["g-"+i+"-p-"+a+".2f"];1k(i=0;i<l.AI.1h;i++)l.AI[i].HC=!1,l.AI[i].GA=l.AI[i].ru,4o l.AI[i].ru,4o l.E["g-"+l.AI[i].L+"-aW"]}},rN:1f(){1a e=1g.o[ZC.1b[16]],t=[ZC.1b[10],"5W"];if(e)1k(1a i=0,n=e.1h;i<n;i++)1k(1a a=0;a<t.1h;a++){1a l=t[a],o=[];if(1c!==ZC.1d(e[i][l])){1k(1a r=0,C=e[i][l].1h;r<C;r++)e[i][l][r].gu||o.1i(e[i][l][r]);e[i][l]=o}}},3v:1f(e,t,i){1a n=1g;1k(1a a in n.E)-1!==a.1K("-1G-")&&-1!==a.1K("-cJ")&&4o n.E[a];if(1w t===ZC.1b[31]&&(t=!0),ZC.A4("."+n.K+"-4X-1M").4f("3F",n.nQ),ZC.A4("."+n.K+"-4X-1M").3m(),1c!==ZC.1d(e))n.OQ(e).3v();1t{t&&n.rN(),n.nx();1k(1a l=0,o=n.AI.1h;l<o;l++)"3I"===n.AB&&i?n.AI[l].9M():n.AI[l].3v();1a r,C,A;1c!==(r=ZC.AK(n.K+"-3X-c"))&&ZC.P.IL(r,n.AB,n.iX,n.iY,n.I,n.F),1c!==(A=ZC.AK(n.K+"-3X-c-1u"))&&ZC.P.IL(A,n.AB,n.iX,n.iY,n.I,n.F),1c!==(C=ZC.AK(n.K+"-7T-c"))&&(ZC.P.IL(C,n.AB,n.iX,n.iY,n.I,n.F),ZC.A4("#"+n.K+"-2y-1M").3m()),n.A8&&n.A8.5c(),ZC.A4("."+n.K+"-2y-1N").3m(),ZC.P.ES([n.K+"-2y-7T",n.K+"-2y"]),ZC.P.ES(n.K+"-fZ-1D"),1c!==n.I0&&ZC.P.ES([n.K+"-4X-2M",n.K+"-4X-c7-2M",n.K+"-4X-dG-2M",n.K+"-4X-4Y",n.K+"-4X-c7-4Y",n.K+"-4X-dG-4Y"])}},qJ:1f(){1a e,t,i,n=1g,a=n.I+"/"+n.F,l=ZC.P.HO({id:n.K+"-fP",2G:"jk",p:ZC.AK(n.K)});ZC.P.PC(l,{1L:"100%"===n.MO?n.MO:n.F+"px",1s:"100%"===n.FU?n.FU:n.I+"px"});1a o=ZC.P.HO({2m:"zc-aK zc-1u",wh:a,id:n.K+"-1u",9R:"9c",2G:"4A",p:l});1P(1o.Sr&&(o.1H.1J="-0.86",o.1H.1u="-0.86"),n.AB){1j"2B":n.K8=ZC.P.F1("2B",ZC.1b[36]),n.K8.al&&n.K8.al(1c,"j5",ZC.1b[37]),ZC.P.G2(n.K8,{af:"1.1",id:n.K+"-2B","3g":"zc-2B",1s:n.I,1L:n.F,3J:"8K"}),o.2X(n.K8);1a r=ZC.P.F1("lX",ZC.1b[36]);if(r.id=n.K+"-lX",n.K8.2X(r),ZC.P.JU({2m:"zc-aK zc-3X",wh:a,id:n.K+"-3X",p:n.K8},n.AB),n.hD=[],n.o[ZC.1b[16]])1k(e=0,t=n.o[ZC.1b[16]].1h;e<t;e++)if((i=n.o[ZC.1b[16]][e].Sw)&&i.1h)1k(1a C=0;C<i.1h;C++)if("2K"===i[C].1I&&i[C].3P){1a A=ZC.P.F1("Rj",ZC.1b[36]);ZC.P.G2(A,{dX:"7g://8B.w3.dQ/q9/Rl",7K:i[C].3P,aK:"Tz",1I:"1D/2K"}),n.hD.1i(i[C].3P),r.2X(A)}1p;1j"3I":1j"3a":ZC.P.HO({2m:"zc-aK zc-3X",wh:a,id:n.K+"-3X",p:o})}},rJ:1f(){},1v:1f(){1a e=1g;e.M7="1v";1a t=e.I+"/"+e.F;if(e.gP(),1c===ZC.AK(e.K+"-1u")){e.qJ();1a i=ZC.AK(e.K+"-3X");if(e.NN[ZC.1b[16]]&&ZC.P.H6({2m:"zc-3i",id:e.K+"-3X-c",wh:t,p:i},e.AB),e.H.2L())ZC.P.H6({2m:"zc-3i",id:e.K+"-3X-c-1u",wh:t,p:i},e.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+ZC.1b[15],p:i,wh:t,3J:"1Z"},e.AB);1t{ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-2a",p:i},e.AB),1o.3G.n9&&ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-4U",p:i},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-aZ",p:i},e.AB),1o.3G.n9||ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-4U",p:i},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-1u",p:i},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2J",p:i},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-5l",p:i},e.AB),ZC.P.JU({2m:"zc-3i zc-1D",wh:t,id:e.K+"-1D",p:i},e.AB);1a n="1U",a="b5";("1U"===e.o["1u-6r"]||e.o[ZC.1b[16]]&&1===e.o[ZC.1b[16]].1h&&"1U"===e.o[ZC.1b[16]][0]["1u-6r"])&&(n="b5",a="1U"),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-"+n,p:i},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-"+a,p:i},e.AB);1a l=ZC.AK(e.K+"-b5");e.NN["8F"]&&ZC.P.H6({2m:ZC.1b[24],id:e.K+"-8F-c",wh:t,p:l},e.AB),e.NN.2g&&ZC.P.H6({2m:ZC.1b[24]+" zc-2g-c",id:e.K+"-2g-c",wh:t,p:l},e.AB),(ZC.A4.6A.l8&&ZC.1l(ZC.A4.6A.af)<=9.5||ZC.2H||"cP"!==e.LI)&&ZC.P.H6({2m:ZC.1b[24],id:e.K+"-7T-c",wh:t,p:l},e.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+ZC.1b[15],p:l,wh:t,3J:"1Z"},e.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-lw-c",p:l,wh:t,3J:"1Z"},e.AB),ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-1D-1u",p:i},e.AB)}if(!1o.3G.bA){1a o=2e.4N("5U");if(o.id=e.K+"-5U",o.7V="zc-5U",o.4l("nO","#"+e.K+"-2Z"),o.4l("Ub",""),ZC.P.PC(o,{2G:"4A",gr:0,1s:e.I+2*ZC.3y+"px",1L:e.F+2*ZC.3y+"px",1J:-ZC.3y+"px",1u:-ZC.3y+"px",9V:0,3k:0,kO:"2k(3k=0)",3r:"5t("+(ZC.3y+1)+"px,"+(e.I+ZC.3y-1)+"px,"+(e.F+ZC.3y-1)+"px,"+(ZC.3y+1)+"px)"}),o.4T=(ZC.6O?"//":"")+ZC.kN,ZC.AK(e.K+"-1u").2X(o),!e.H.2L()){1a r=2e.4N("2Z");r.7V="zc-2Z",ZC.P.G2(r,{id:e.K+"-2Z",8L:e.K+"-2Z"}),ZC.AK(e.K+"-1u").2X(r)}}}e.Z=ZC.AK(e.K+"-3X-c"),e.b();1a C,A,s=!1,Z=!1;1k(C=0,A=e.AI.1h;C<A;C++){e.AI[C].1v(),(1c!==e.AI[C].D0&&e.AI[C].D0.AL||1c!==e.AI[C].K5&&e.AI[C].K5.AL)&&(s=!0);1k(1a c=0;c<e.AI[C].BK.1h;c++)if(e.AI[C].BK[c].H1){Z=!0;1p}}if(e.FW){1k(1a u in e.FW)ZC.AK(u).2X(e.FW[u]);e.FW=1c}if(e.E[ZC.1b[53]]=1c,e.TR||e.UF||(e.YN?e.qp():e.YN=2u.fH(1f(){e.rS(),e.TR||e.UF?(2u.9N(e.YN),ZC.P.ES(e.K+"-fZ-1D")):ZC.AK(e.K+"-fZ-1D")||e.qp()},ox)),-1===ZC.AT(e.KL,ZC.1b[38])&&e.qN(),-1===ZC.AT(e.KL,ZC.1b[41])?(1w ZC.r9!==ZC.1b[31]&&(e.A8=1n ZC.r9(e)),Z&&e.H3.3p(),s&&1w ZC.K1!==ZC.1b[31]&&(e.D5=1n ZC.K1(e),e.D5.3p()),ZC.2H&&(e.gK=1f(t){ZC.e3={xy:ZC.P.M8(t),ts:(1n 9H).bi()},t.2T.id===e.K+"-2y-1M"?(ZC.3l=!1,e.A8&&e.A8.5c(),1o.YS(t)):(1c===e.DE||1c===ZC.1d(e.DE["3b-1X"])||e.DE["3b-1X"]||t.6L(),ZC.3l=!1,e.9h(),e.A8&&e.A8.5c(),e.YQ(t))},e.OP=1f(){2u.iQ(e.y5),e.ho=1c},e.rQ=1f(t){if(ZC.e3){1a i=ZC.P.M8(t);if(ZC.2i(i[0]-ZC.e3.xy[0])>100&&(1n 9H).bi()-ZC.e3.ts<5L){1a n=e.FH();n.bB=i[0]>ZC.e3.xy[0]?"2x":"1J",ZC.AO.C2("e3",e,n)}ZC.e3=1c}e.ep||ZC.3l||1o.S6(t),e.OP(t)},ZC.A4("#"+e.K+"-5U").3p("4D",e.gK).3p("6k",e.OP).3p("5P",e.rQ),ZC.A4("#"+e.K+"-2y-1M").4c("4D",e.gK)),e.gO=1f(t){1a i=e.FH();i.ev=t,ZC.AO.C2("ar",e,i)},ZC.A4("#"+e.K+"-5U").3p("ar",e.gO),ZC.A4("#"+e.K+"-2Z").3p("ar",e.gO),e.qK=1f(t){27===t.Ta&&e.QT&&(e.kx||e.gC())},ZC.A4(2e).3p("xT",e.qK),e.gC=1f(){ZC.A4("#"+e.K+ZC.1b[66]).4f("3F",e.gC),ZC.kn=1c,ZC.P.ES(e.K+"-1T-6q"),e.9M(),1o.e4&&ZC.AK(1o.e4)&&(ZC.AK(1o.e4).1H.3J="1Z")},ZC.A4("#"+e.K+ZC.1b[66]).4c("3F",e.gC)):ZC.2H&&(e.rG=1f(e){1m e.6L(),1o.S6(e),!1},ZC.A4("#"+e.K+"-5U").3p("4D",e.rG)),1c!==e.HI){1a p=ZC.1l(e.HI.ds);p=p>=50?p:5L*p,2u.5G(1f(){e.MV(),e.2t()},p)}e.M7="",ZC.TS[e.K]=(1n 9H).bi()-ZC.TS[e.K],e.E["cw-aE"]&&(ZC.AO.C2("aE",e,e.FH()),e.E["cw-aE"]=1c),e.E["cw-2t"]&&(ZC.AO.C2("2t",e,e.FH()),e.E["cw-2t"]=1c)},bf:1f(e){1k(1a t=1g,i=0;i<t.AI.1h;i++)t.AI[i].BI&&t.AI[i].BI.qc(e)},pD:1f(){1a e=1g,t=2e.4N("3a");t.1s=e.I,t.1L=e.F,t.4l("3g","");1k(1a i=0;i<e.AI.1h;i++)e.AI[i].BI&&e.AI[i].BI.qc(!0,t);1m t},Tf:1f(){1a e=1g;1c===ZC.1d(ZC.qi)&&(ZC.qi=1f(e){1o.3j(e.id,"wz")}),1o.3j(e.K,"wA",{1D:"xt gZ","1f":"ZC.qi()",6H:100})},qp:1f(){1a e,t=1g,i={},n=t.DE.dP;t.B9.2t(i,"6C.5f.dP"),n&&ZC.2A(n,i),1===t.o[ZC.1b[16]].1h&&t.o[ZC.1b[16]][0].5f&&(e=t.o[ZC.1b[16]][0].5f.dP)&&ZC.2A(e,i);1a a=ZC.5m(ZC.1l(i.1I||1),1,2),l=i.2G||"br";-1===ZC.AT(["tl","tr","br","bl"],l)&&(l="br"),t.Ts=l;1a o=32,r=146,C=0,A=1,s="";ZC.6O&&(o=30,r=168,C=8,A=1),r=126,o=22;1a Z={9b:["#SO","#Ou"],ba:["#wG","#Oq"]},c=Z.9b;if(1o.kG&&(c="9b"===t.LI||"cP"===t.LI?Z.9b:Z.ba),1===t.o[ZC.1b[16]].1h)if(t.o[ZC.1b[16]][0][ZC.1b[0]]){1a u=ZC.AO.G3(t.o[ZC.1b[16]][0][ZC.1b[0]]);7===u.1h&&(c=ZC.AO.rs(u,Z.ba,Z.9b))}1t if(t.o[ZC.1b[16]][0].bU){1a p=t.o[ZC.1b[16]][0].bU;c="9b"===p||"cP"===p?Z.9b:Z.ba}1a h=1w 2u!==ZC.1b[31]&&2u.7W?2u.7W.wQ:"",1b=1w 2u!==ZC.1b[31]&&2u.7W?2u.7W.xm:"";s=\'<a 5F="ri Ob by gZ" 1H="1r:\'+c[0]+\' !7x;2p-2b:wN !7x;3J:8K !7x;3k:1 !7x; 1D-c3:1Z;" 7K="7g://8B.1o.bv/?wQ=\'+h+"&xm="+1b+\'">Pu   <7D 1H="1r:\'+c[1]+\'; 2p-7a:6u;">gZ</7D></a>\';1a d,f;1P(l){1j"br":d=t.F-o,f=t.I-r;1p;1j"bl":d=t.F-o,f=6;1p;1j"tr":d=2,f=t.I-r;1p;1j"tl":d=2,f=6}1c!==ZC.1d(e=ZC.AK(t.K+"-1u"))&&ZC.P.HO({2m:ZC.6O?"-6O":"",p:e,id:t.K+"-fZ-1D",tl:d+"/"+f,wh:r+"/"+(o-C),1r:ZC.6O?1===a?"#l7":"#2O":"",3u:C,3k:A,2G:"4A",4O:"8v",6U:1o.9W,4a:s},t.AB)},nx:1f(){1a e=1g;ZC.A4("#"+e.K+"-2y").4f(ZC.1b[47],e.T9),ZC.A4("."+e.K+"-2y-1N").4f(ZC.1b[47],e.T9),ZC.A4("."+e.K+"-2y-1N").4f("3F 5P",e.nz).4f("6Z",e.nh).4f("7B",e.nB),e.E["2y-1N-hq"]=!1,1c!==e.H3&&e.H3.3h(),1c!==e.D5&&e.D5.3h(),ZC.2H&&(ZC.A4("#"+e.K+"-5U").3h("4D",e.gK).3h("6k",e.OP).3h("5P",e.rQ),ZC.A4("#"+e.K+"-2y-1M").4f("4D",e.gK),ZC.A4("#"+e.K+"-5U").3h("4D",e.rG)),ZC.A4("#"+e.K+"-5U").3h("ar",e.gO),ZC.A4("#"+e.K+"-2Z").3h("ar",e.gO),ZC.A4(2e).3h("xT",e.qK),ZC.A4("#"+e.K+ZC.1b[66]).4f("3F",e.gC)},VD:1f(e,t,i){1w i===ZC.1b[31]&&(i=!1);1a n=ZC.AK("zc-2y-"+(i?"dV":"1N")+"-"+e);n&&(n.1H.3J=t?"8K":"1Z")},qN:1f(LB,ev){1f kf(e){1m""!==e&&e?"3P("+(0===e.1K("zc.")?ZC.bG[e]:e)+")":"1Z"}1f J3(e){1m\'<3A id="\'+s.K+"-2y-dV-"+e+\'" 3g="zc-2y-dV" 1H="1R-1r:\'+DY.A0+";1R-4d:"+kf(DY.D8)+" 6G-x 50% 0%;1F-2a-1s:"+U0[ZC.1b[4]]+";1F-2a-1r:"+U0["1y-1r"]+\';">&8J;</3A>\'}1f GP(e,t,i){t=t||ZC.HA["2y-"+e];1a n=1w i!==ZC.1b[31]&&i?" zc-5C-2y-1N "+s.K+"-5C-2y-1N":"";1m\'<3A 3g="\'+s.K+"-2y-1N"+n+\'" 1H="1s:\'+s.MU.o.1s+";1r:"+DY.BZ+";2p-9g:"+DY.GB+";2p-2b:"+DY.DG+"px;1R-1r:"+DY.A0+";1R-4d:"+kf(DY.D8)+" 6G-x 50% 0%;1F-1u:"+(ZC.6O?DY.AQ:1)+"px 2R "+DY.BU+";1F-1J:"+DY.AQ+"px 2R "+DY.BU+";1F-2x:"+DY.AQ+"px 2R "+DY.BU+";3u:"+DY.FM+"px "+DY.FN+"px "+DY.FV+"px "+DY.EO+"px;1D-3s:"+DY.O3+";"+(ZC.HA.aO?"qP-ey:ey-7c;bB:aO;":"")+\'" id="\'+s.K+"-2y-1N-"+e+\'">\'+t+"</3A>"}1f xw(e,t,i){1a n=1w i!==ZC.1b[31]&&i?" zc-5C-2y-5S "+s.K+"-5C-2y-5S":"";1m\'<3A 3g="zc-2y-5S \'+s.K+"-2y-5S"+n+\'" 1H="1r:\'+DY.BZ+";1R-1r:#cT;1F-1u:"+(ZC.6O?DY.AQ:1)+"px 2R "+DY.BU+";1F-1J:"+DY.AQ+"px 2R "+DY.BU+";1F-2x:"+DY.AQ+"px 2R "+DY.BU+";3u:"+DY.FM+"px "+DY.FN+"px "+DY.FV+"px "+DY.EO+"px;1D-3s:"+DY.O3+";"+(ZC.HA.aO?"qP-ey:ey-7c;bB:aO;":"")+\'" id="\'+s.K+"-2y-1N-"+e+\'">\'+t+"</3A>"}1f FZ(e){if(ok)1m{3Z:"1Z"};1k(1a t=0,i=RM.1h;t<i;t++)if(RM[t].id===e)1m RM[t];1m{3Z:"4q"}}if(!1o.3G.xX){1a s=1g,G,i,A5,j,J2;1w LB===ZC.1b[31]&&(LB=-1);1a DE={};ZC.2A(s.DE,DE),-1!==LB&&s.o[ZC.1b[16]][LB]&&ZC.2A(s.o[ZC.1b[16]][LB].5f,DE,1c,1c,!0),ZC.A4("#"+s.K+"-2y").3m();1a RM=[];1k(1w ZC.AM===ZC.1b[31]&&RM.1i({id:"3D",3Z:"1Z"},{id:"xK",3Z:"1Z"},{id:"xJ",3Z:"1Z"}),i=DE.aC.1h-1;i>0;i--)1k(1a xO=DE.aC[i].id,ii=i-1;ii>=0;ii--)DE.aC[ii].id===xO&&DE.aC.6p(ii,1);if(1c!==ZC.1d(G=DE.aC))1k(i=0,A5=G.1h;i<A5;i++){1a N6=!1;1k(j=0,J2=RM.1h;j<J2;j++)RM[j].id===G[i].id&&(N6=!0);N6||RM.1i(G[i])}1a JA=DE["6j-2y"],OD=DE["6j-2y[2H]"];1k(i=0,A5=RM.1h;i<A5;i++)1c!==ZC.1d(RM[i]["1f"])&&(1c===ZC.1d(JA)&&(JA={}),1c===ZC.1d(JA["5C-2z"])&&(JA["5C-2z"]=[]),JA["5C-2z"].1i(RM[i]));JA["5C-2z"]&&JA["5C-2z"].3V(1f(e,t){1m ZC.1l(e.6H||"0")>ZC.1l(t.6H||"0")}),s.MU=1n ZC.DQ(s);1a kY=s.LI.2l(/\\s+|;|,/);1k(i=0,A5=kY.1h;i<A5;i++)if(s.B9.NR[kY[i]]){1a hC=s.B9.NR[kY[i]].an||{};hC&&hC.5f&&hC.5f.y4&&ZC.2A(hC.5f.y4,s.MU.o)}s.B9.2t(s.MU.o,ZC.1b[65]),JA&&s.MU.1C(JA),ZC.2H&&(s.B9.2t(s.MU.o,ZC.1b[65]+"[2H]"),OD&&s.MU.1C(OD)),s.MU.WJ=!0,s.MU.1q();1a DY,L9,U0,ok,GL;if(s.MU.AL||!s.kX){if(!ZC.AK(s.K+"-2y-1M")){1a nH=!!(s.DE&&s.DE["6j-2y"]&&s.DE["6j-2y"].76)&&ZC.1d(s.DE["6j-2y"].76.2f);if(nH||"cP"!==s.LI&&nH){GL=1n ZC.DQ(s),s.B9.2t(GL.o,ZC.1b[65]+".76"),JA&&ZC.1d(1c!==(G=JA.76))&&GL.1C(G),ZC.2H&&(s.B9.2t(GL.o,ZC.1b[65]+"[2H].76"),OD&&1c!==ZC.1d(G=OD.76)&&GL.1C(G)),ZC.2A(s.MU.o,JA);1a jX="1J"===JA.2G||"cP"===s.LI;if(GL.K=s.K+"-2y-7T",GL.IE=ZC.AK(s.K+"-b5"),GL.Z=GL.C5=ZC.AK(s.K+"-7T-c"),GL.WJ=!0,GL.1q(),GL.AL){GL.1v();1a DB=ZC.A4("#"+s.H.K+"-1u");if(""===GL.AP){1a MY=1n ZC.DS(s);if(MY.CX=!1,s.B9.2t(MY.o,ZC.1b[65]+".aU"),JA&&1c!==ZC.1d(G=JA.aU)&&MY.1C(G),ZC.2H&&(s.B9.2t(MY.o,ZC.1b[65]+"[2H].aU"),OD&&1c!==ZC.1d(G=OD.aU)&&MY.1C(G)),MY.K=s.K+"-2y-7T-aU",MY.IE=ZC.AK(s.K+"-b5"),MY.Z=ZC.AK(s.K+"-7T-c"),MY.iX=jX?GL.iX+GL.I/2:DB.1s()-(GL.iX+GL.I/2),MY.iY=GL.iY+GL.F/2,MY.AH=ZC.CV(GL.I,GL.F)/4.5,MY.1q(),MY.1v(),"nn"!==MY.DP){1a Q9=1n ZC.DS(s);Q9.1Q(GL),Q9.K=s.K+"-2y-7T-aU-Sm",Q9.IE=ZC.AK(s.K+"-b5"),Q9.Z=ZC.AK(s.K+"-7T-c"),Q9.DP="3x",Q9.AH=ZC.CV(GL.I,GL.F)/7,Q9.1q(),Q9.iX=jX?GL.iX+GL.I/2:DB.1s()-(GL.iX+GL.I/2),Q9.iY=GL.iY+GL.F/2,Q9.1v()}}1a oM=jX?GL.iX:DB.1s()-(GL.iX+GL.I);ZC.AK(s.K+"-2Z").4n+=ZC.P.GC("5t")+\'id="\'+s.K+"-2y-1M"+ZC.1b[30]+ZC.1l(oM+ZC.3y)+","+ZC.1l(GL.iY+ZC.3y)+","+ZC.1l(oM+GL.I+ZC.3y)+","+ZC.1l(GL.iY+GL.F+ZC.3y)+\'" />\'}}}DY=1n ZC.DQ(s),s.B9.2t(DY.o,ZC.1b[65]+".1N"),JA&&1c!==ZC.1d(G=JA.1N)&&DY.1C(G),ZC.2H&&(s.B9.2t(DY.o,ZC.1b[65]+"[2H].1N"),OD&&1c!==ZC.1d(G=OD.1N)&&DY.1C(G)),DY.WJ=!0,DY.1q(),L9=1n ZC.DQ(s),L9.1Q(DY),s.B9.2t(L9.o,ZC.1b[65]+".1N.2J-3U"),JA&&1c!==ZC.1d(JA.1N)&&1c!==ZC.1d(G=JA.1N[ZC.1b[71]])&&L9.1C(G),ZC.2H&&(s.B9.2t(L9.o,ZC.1b[65]+"[2H].1N.2J-3U"),OD&&1c!==ZC.1d(OD.1N)&&1c!==ZC.1d(G=OD.1N[ZC.1b[71]])&&L9.1C(G)),L9.WJ=!0,L9.1q(),U0={},JA&&1c!==ZC.1d(JA.8P)&&(U0=JA.8P);1a JM=[],EI=1c;if(ok=1c!==ZC.1d(s.MU.o.ly)&&ZC.2q(s.MU.o.ly),ZC.2H&&"1Z"!==(EI=FZ("xs")).3Z&&(1c===s.DE||1c===ZC.1d(s.DE["3b-1X"])||s.DE["3b-1X"]?JM.1i(GP("pb",EI.1D)):JM.1i(GP("pg",EI.1D)),JM.1i(J3("Ia"))),"1Z"!==(EI=FZ("xu")).3Z&&(JM.1i(GP("fF",EI.1D)),JM.1i(J3("fF"))),1w ZC.wP!==ZC.1b[31]){EI=FZ("Mj"),"1Z"!==EI.3Z&&("1Z"!==(EI=FZ("Mf")).3Z&&JM.1i(GP("p1",EI.1D?EI.1D:1c)),"1Z"!==(EI=FZ("xo")).3Z&&JM.1i(GP("p0",EI.1D?EI.1D:1c)),JM.1i(J3("8w")));1a T6=["Nk","Nh","xz","oW","xG","xB","xF"],oH=0,oK=0;1k(i=0;i<T6.1h;i++)"xG"===T6[i]&&ZC.AK(s.K+"-1T-6q")&&(T6[i]="Lu"),"1Z"!==(EI=FZ(T6[i])).3Z&&(oH++,oK=i,JM.1i(GP(T6[i].aJ(),EI.1D)));oH>0&&JM.1i(J3(T6[oK].aJ()))}if(-1!==LB){1a H1=!1;1k(j=0,J2=s.AI[LB].BK.1h;j<J2;j++)s.AI[LB].BK[j].H1&&(H1=!0);if(H1&&1w ZC.n5!==ZC.1b[31]){1a hT=!1;EI=FZ("Pp"),"1Z"!==EI.3Z&&(JM.1i(GP("g4",EI.1D)),hT=!0),EI=FZ("150"),"1Z"!==EI.3Z&&(JM.1i(GP("g2",EI.1D)),hT=!0),EI=FZ("16j"),"1Z"!==EI.3Z&&(JM.1i(GP("fR",EI.1D)),hT=!0),hT&&JM.1i(J3("3C"))}}1a i5=!1,oL=!1;if(-1!==LB&&(-1!==ZC.AT(["1y","1M","2Q","5A","6d","3L","9q"],s.AI[LB].AF)&&(i5=!0,s.X4="2d"),-1!==ZC.AT(["8Y","81","ej","6M","7v","7k","b1"],s.AI[LB].AF)&&(oL=!0,s.X4="3d")),(i5||oL)&&"1Z"!==(EI=FZ("3D")).3Z&&"1Z"!==(EI=FZ(i5?"xK":"xJ")).3Z&&(JM.1i(GP(i5?"ph":"pj",EI.1D)),JM.1i(J3("18E"))),-1!==LB){1a C=s.AI[LB],oG=!1,k2=!1;1k(j=0;j<C.BK.1h;j++){1a B=C.BK[j];0===B.BB.1K(ZC.1b[51])&&(oG=!0),"2W"===B.CA&&(k2=!0)}oG&&"1Z"!==(EI=FZ("18D")).3Z&&"1Z"!==(EI=FZ(k2?"xI":"xH")).3Z&&(JM.1i(GP(k2?"oP":"p2",EI.1D)),JM.1i(J3("fo"))),(C.D0||C.K5)&&"1Z"!==(EI=FZ("oA")).3Z&&"1Z"!==(EI=FZ(C.eH?"18C":"18B")).3Z&&(JM.1i(GP(C.eH?"kb":"hM",EI.1D)),JM.1i(J3("2g")))}1a k5=0;if(1w ZC.zv!==ZC.1b[31]&&("1Z"!==(EI=FZ("xE")).3Z&&(JM.1i(GP("4H",EI.1D)),k5++),"1Z"!==(EI=FZ("xD")).3Z&&(JM.1i(GP("4p",EI.1D)),k5++)),k5>0&&JM.1i(J3("b5")),"1Z"===(EI=FZ("xC")).3Z||s.LQ||(s.QT?(EI=FZ("18o"),JM.1i(GP("ic",EI.1D)),JM.1i(J3("ic"))):(JM.1i(GP("5T",EI.1D)),JM.1i(J3("5T")))),s.I0&&("1Z"!==(EI=FZ("18t")).3Z&&JM.1i(GP("d7",EI.1D)),"1Z"!==(EI=FZ("18p")).3Z&&JM.1i(GP("d8",EI.1D)),JM.1i(J3("4X"))),JM.1h>0&&-1!==JM[JM.1h-1].1K("zc-2y-dV")&&JM.6p(JM.1h-1,1),s.oT={},-1!==LB){1a B5;if(JA&&1c!==ZC.1d(B5=JA["5C-2z"]))1k(JM.1h>0&&JM.1i(J3("5C")),i=0,A5=B5.1h;i<A5;i++){1a kc=!0;if(1c!==ZC.1d(B5[i].3Z)&&("1Z"===B5[i].3Z?kc=!1:"4q"!==B5[i].3Z&&(kc=!ev||7t(B5[i].3Z).4s(s,1o.ih(ev,s),B5[i].id,ev))),kc){1a AP,K=B5[i].id||"5C-"+i;"dV"===B5[i].id||"dV"===B5[i].1I?JM.1i(J3(K)):"5S"===B5[i].1I?(AP=B5[i].1D||"qQ xv "+i,JM.1i(xw(K,AP,!0))):(AP=B5[i].1D||"qQ xv "+i,s.oT[K]={fn:B5[i]["1f"]||"",3P:B5[i].3P||"",2T:B5[i].2T||""},JM.1i(GP(K,AP,!0)))}}}s.TR||(JM.1i(J3("1o")),JM.1i(GP("yb","xt gZ"))),ZC.P.HO({id:s.K+"-2y",p:2e.3o,2m:"zc-2y zc-1H",1u:1c===ZC.1d(GL)?0:GL.iY+GL.F/2,1J:1c===ZC.1d(GL)?0:GL.iX+GL.I/2,om:s.MU.AQ+"px 2R "+s.MU.BU,1R:(-1===s.MU.A0?"b0":s.MU.A0)+" "+kf(s.MU.D8),cK:s.MU.FM,dv:s.MU.FN,dt:s.MU.FV,dj:s.MU.EO,4a:JM.2I("")}),s.E["2y-1N-hq"]||(s.nz=1f(e){1a t,i=1!==e.2T.fM?e.2T.6s.id:e.2T.id,n=i.2s(0,i.1K("-2y-1N-")),a=1o.79(n);ZC.2H&&a.OP();1a l=a.ki(a.SM[0],a.SM[1]);a.9h(),ZC.2H&&1o.S6(e);1a o=i.1E(a.K+"-2y-1N-","");a.xP({4u:l?l.K:1c,oR:o,ev:ZC.A4.C1(e)});1a r=a.o["8w-j2"]||a.o[ZC.1b[16]][0]["8w-j2"]||"";1P(o){1j"pj":1j"ph":l&&a.rI(l.K);1p;1j"pg":s.DE=s.DE||{},s.DE["3b-1X"]=!0;1p;1j"pb":s.DE=s.DE||{},s.DE["3b-1X"]=!1;1p;1j"hM":a.YX(l.K,!0);1p;1j"kb":a.YX(l.K,!1);1p;1j"oP":a.rE(l.K,"m4");1p;1j"p2":a.rE(l.K,"2W");1p;1j"fF":a.rK();1p;1j"p1":a.O7("9Y");1p;1j"p0":a.O7("dg");1p;1j"xL":a.O7("fJ",""===r?1c:{fn:r});1p;1j"xA":a.O7("2B",""===r?1c:{fn:r});1p;1j"jl":1o.3j(a.K,"jl");1p;1j"xM":1o.3j(a.K,"x3",""===r?1c:{fn:r});1p;1j"xZ":(t=FZ("oW"))["5C-1f"]?a.rL({4u:l?l.K:1c,oR:o,j2:r,"1f":t["5C-1f"]}):1o.3j(a.K,"x0",""===r?1c:{fn:r});1p;1j"oY":1j"oo":1o.3j(a.K,"wX",{ou:o});1p;1j"6F":a.ku();1p;1j"4H":a.j9();1p;1j"4p":a.lj();1p;1j"5T":a.qI();1p;1j"d7":1o.3j(a.K,"d7");1p;1j"d8":1o.3j(a.K,"d8");1p;1j"g4":l&&(a.H3.C=l,a.ld({4u:l.K}));1p;1j"g2":l&&(a.H3.C=l,a.jA({4u:l.K}));1p;1j"fR":l&&(a.H3.C=l,a.ks({4u:l.K}));1p;1j"yb":a.qC();1p;2n:1c!==ZC.1d(G=s.oT[o])&&(""!==G.fn?a.rL({4u:l?l.K:1c,oR:o,"1f":G.fn}):""!==G.3P&&l&&l.UQ(e,G.3P,G.2T))}},s.nh=1f(){1g.1H.oO=L9.A0,1g.1H.1r=L9.BZ,1g.1H.jF=1g.1H.jH=L9.AQ+"px 2R "+L9.BU},s.nB=1f(){1g.1H.oO=DY.A0,1g.1H.1r=DY.BZ,1g.1H.jF=1g.1H.jH=DY.AQ+"px 2R "+DY.BU},s.T9=1f(e){1m e.6L(),!1},ZC.A4("#"+s.K+"-2y").4c(ZC.1b[47],s.T9),ZC.A4("."+s.K+"-2y-1N").4c(ZC.1b[47],s.T9),ZC.A4("."+s.K+"-2y-1N").4c("3F 5P",s.nz).4c("6Z",s.nh).4c("7B",s.nB),s.E["2y-1N-hq"]=!0)}}},9M:1f(){1a e=1g;e.nx(),1o.HP.1h-=1,e.3v(),ZC.A4("#zc-5T").3m(),2e.3o.1H.9R=""},MV:1f(e,t){1a i,n=1g;if(1c===ZC.1d(t)&&(t=!1),(t||n.ZY)&&-1===ZC.AT(n.KL,ZC.1b[41]))if(n.ZH=!0,t&&ZC.P.HO({id:n.K+"-nF",p:ZC.AK(n.K),wh:n.I+"/"+n.F}),n.E.dc||1o.3G.y9)n.ZH=!1;1t{1a a=ZC.A4("#"+n.K);if(!(1w a.1Y()===ZC.1b[31]||a.1s()+a.1L()===0||n.E.dc&&n.TR)){1a l=a.1Y().1J+ZC.1l(a.2K("1F-1J-1s"))+(1c===e?n.iX:e.iX),o=a.1Y().1u+ZC.1l(a.2K("1F-1u-1s"))+(1c===e?n.iY:e.iY);(ZC.y8||ZC.y7)&&(l-=ZC.A4(2u).aG(),o-=ZC.A4(2u).aI());1a r=1c===e?n.I:e.I,C=1c===e?n.F:e.F,A=ZC.1l(.8*n.I),s=30,Z=1n ZC.DQ(n);n.B9.2t(Z.o,"6C.5f.7Q"),Z.1C(n.E.7Q),1c!==n.DE&&1c!==ZC.1d(i=n.DE.7Q)&&Z.1C(i),Z.1q();1a c,u=ZC.HA["7Q-aX-fW"];if(ZC.6O)c=Z.A0;1t{1a p=n.E.nk||ZC.bG["zc.nl"];c=Z.A0+" 3P("+p+") no-6G 3E 3E"}(r<180||C<90)&&(c=Z.A0,s=-12),r<120&&r>60?(A=60,u=ZC.HA["7Q-aX-5E"]):r<60&&(A=20,u=ZC.HA["7Q-aX-jQ"]),u=n.E.o1||u;1a h=ZC.P.HO({id:n.K+"-7Q",p:2e.3o,tl:o+"/"+l,1s:r-2*Z.AQ,1L:C-2*Z.AQ,2G:"4A",3k:.8,1F:Z.AQ+"px 2R "+Z.BU,1R:c});ZC.P.HO({id:n.K+"-7Q-1D",p:h,1s:A,4a:u,cR:"3E",jW:ZC.1l((r-A)/2),ko:ZC.1l(C/2+s),6U:1o.9W,6S:1o.iU,1r:Z.BZ,6R:"6u"})}}},gP:1f(){1a e=1g;ZC.P.ES(e.K+"-nF"),e.E.dc||(e.ZH=!1,ZC.P.ES([e.K+"-7Q-1D",e.K+"-7Q"]))},nS:1f(e,t){1a i,n,a=1g;i=1c!==ZC.1d(n=e[ZC.1b[16]])?n:[e];1a l=e.3t||"",o=ZC.AN.g5(l,i.1h),r=i[t],C=a.I/o[1],A=a.F/o[0],s=1A.4i(t/o[1]),Z=t%o[1]*C,c=s*A;r&&(1c!==ZC.1d(n=r.x)&&(Z=ZC.8C(n))<=1&&(Z=ZC.1l(Z*a.I)),1c!==ZC.1d(n=r.y)&&(c=ZC.8C(n))<=1&&(c=ZC.1l(c*a.F)),1c!==ZC.1d(n=r[ZC.1b[19]])&&(C=ZC.8C(n))<=1&&(C=ZC.1l(C*a.I)),1c!==ZC.1d(n=r[ZC.1b[20]])&&(A=ZC.8C(n))<=1&&(A=ZC.1l(A*a.F)));1a u=[0,0,0,0];1m r.2r&&1c!==ZC.1d(r.2r.2v)&&(u=1n ZC.HQ(1c).6b(r.2r.2v,"4q",C,A)),{2U:{x:ZC.1l(Z),y:ZC.1l(c),1s:ZC.1l(C),1L:ZC.1l(A),2V:t},2r:{x:u[3],y:u[0],1s:C-u[1]-u[3],1L:A-u[0]-u[2]}}},K2:1f(){1a e=1g;1c===ZC.1d(e.o[ZC.1b[16]])&&(e.o={aZ:[e.o]}),e.MV(),1o.iz(e,e.kR(),1f(){e.o=ZC.AO.C2("gg",e,e.FH(),e.o),1o.XQ[e.K]&&e.PB(1f(){e.1q(),e.1v()})})},b3:1f(){1a e=1g;!1f(){1f t(){""!==e.QP||1c!==e.MJ?e.kW():e.2t()}e.UF||e.rS(),e.MV(1c,!0),1o.r0>0?ZC.YZ(t):t()}()},YQ:1f(e){1a t=1g;1c===ZC.1d(t.ho)&&(t.ho=(1n 9H).bi(),t.y5=2u.5G(1f(){1c!==ZC.1d(t.ho)&&(t.ho=1c,1o.YS(e))},183))},FH:1f(){1a e,t=1g,i=0,n=0;1m i=1w t.SM[0]!==ZC.1b[31]?t.SM[0]-i:0,n=1w t.SM[1]!==ZC.1b[31]?t.SM[1]-n:0,e=t.LI?t.LI:"9b",{id:t.K,1s:t.I,1L:t.F,bJ:t.AB,x:i,y:n,9O:t.SM[2],bU:e}},y3:1f(e){1a t=1g;e=e||{},1c!==ZC.1d(e.r8)&&(t.QA[e.r8]=e.1T||"[]",t.U3++)},ld:1f(){},jA:1f(){},ks:1f(){},PQ:1f(){},r3:1f(e,t){1a i=1g;if(e=e||{},1c!==ZC.1d(e[ZC.1b[3]])){1a n=i.OQ(e[ZC.1b[3]]);1c!==n&&n.3v()}1t i.3v(1c,1c,t);ZC.K1&&ZC.K1.5R&&(ZC.K1.5R[i.K]=1c)},po:1f(e){e=e||ZC.HA["rF-aX"];1a t=1g;if(1c===ZC.AK(t.K+"-9f")){ZC.P.HO({2m:"zc-3i zc-1H zc-9f",id:t.K+"-9f",p:ZC.AK(t.K+"-1u"),wh:t.I+"/"+t.F,3k:.75}),ZC.P.HO({2m:"zc-9f-xY",id:t.K+"-9f-t",p:ZC.AK(t.K+"-9f"),4a:e});1a i=ZC.A4("#"+t.K+"-9f-t");i.2K("1u",t.F/2-i.1L()/2+"px").2K("1J",t.I/2-i.1s()/2+"px")}},kA:1f(){ZC.P.ES(1g.K+"-9f")},qC:1f(){1a e=1g;ZC.AO.C2("18n",e,e.FH()),ZC.P.HO({2m:"zc-3i",id:e.K+"-6x-4K",p:ZC.AK(e.K+"-1u"),wh:e.I+"/"+e.F,1R:"#7S",3k:.75});1a t=ZC.CV(18e,e.I),i=ZC.CV(xV,e.F),n=ZC.BN(0,(e.I-t)/2),a=ZC.BN(0,(e.F-i)/2),l=ZC.P.HO({2m:"zc-6x zc-1H",id:e.K+"-6x",p:ZC.AK(e.K+"-1u"),tl:a+"/"+n,wh:t-(ZC.8U?0:10)+"/"+(i-(ZC.8U?0:10))}),o="";""!==e.S4&&(o="qQ 185 1k<br />"+e.S4),l.4n=\'<3A 3g="zc-6x-1"><a 7K="7g://8B.1o.bv" 2T="pR">1o.bv</a></3A><3A 3g="zc-6x-2">&1Q;18h-\'+(1n 9H).xW()+\'</3A><3A 3g="zc-6x-3"><3A id="\'+e.K+\'-6x-7p">\'+ZC.HA["6x-7p"]+\'</3A></3A><3A 3g="zc-6x-4" 1H="3u:\'+(i-xV)+\'px 86 86 86;"><3A>&8J;<br />18i \'+ZC.fL+" ["+e.AB+"]</3A>"+o+"</3A>",ZC.A4("#"+e.K+"-6x-7p").3p("3F",1f(){ZC.AO.C2("18k",e,e.FH()),ZC.P.ES([e.K+"-6x",e.K+"-6x-4K"])})},NM:1f(e,t){1a i=1g;if(ZC.AO.qM("4L",i))ZC.AO.C2("4L",i,{id:i.K,4L:e,17I:t,4F:i.E.4F||i.E.xU});1t{1a n="";n+="4g"==1w e?e.8L+":"+e.aR+"\\n\\n":e+"\\n\\n",1c!==ZC.1d(t)&&(n+="17D:"+t+"\\n\\n"),n+="3c 1T:\\n\\n"+i.E.4F+"\\n\\n",i.gP(),1c===ZC.AK(i.K+"-1u")&&i.qJ(),ZC.P.HO({2m:"zc-3i zc-4L zc-1H",id:i.K+"-4L",p:ZC.AK(i.K+"-1u"),wh:i.I-(ZC.8U?0:10)+"/"+(i.F-(ZC.8U?0:10))}).4n=\'<3A 3g="zc-4E-5j-1G zc-4E-s0">\'+ZC.HA["4L-5S"]+\'</3A><3A 3g="zc-4E-5j-1G zc-4E-s1">\'+ZC.HA["4L-aR"]+\'</3A><3A 3g="zc-4E-5j-ah"><bR id="\'+i.K+\'-4L-aR" 1H="1s:\'+(i.I-35)+"px;1L:"+(i.F-135)+\'px;"></bR></3A><3A 3g="zc-4E-5j-ah zc-4E-5j-84"><ad 1I="76" 1S="\'+ZC.HA["4L-7p"]+\'" id="\'+i.K+\'-4L-7p" /></3A>\',ZC.A4("#"+i.K+"-4L-aR").8z(ZC.GO(n)),ZC.A4("#"+i.K+"-4L-7p").3p("3F",1f(){ZC.P.ES(i.K+"-4L")})}},j9:1f(){},lj:1f(){},qI:1f(){1a e=1g,t=2e.4N("3A");t.id="zc-5T",t.1H.9V=1o.xS,t.1H.9R="9c";1a i=2e.3o,n=!1;1o.e4&&ZC.AK(1o.e4)&&(n=!0,(i=ZC.AK(1o.e4)).1H.3J="8K"),i.2X(t),ZC.kn={};1a a,l;1k(a=0,l=e.AI.1h;a<l;a++){1a o=e.AI[a];if(1c!==o.AX)1k(1a r=0,C=o.AX.A7.1h;r<C;r++)ZC.kn["g-"+o.L+"-p-"+r]=o.E["1B"+r+".2f"]}ZC.P.ES(e.K+"-1T-6q");1a A,s=3c.1q(e.E.4F),Z=s[ZC.1b[16]];1k(a=Z.1h-1;a>=0;a--)if(Z[a].gu)Z.6p(a,1);1t{if(1c!==ZC.1d(Z[a].5W))1k(A=Z[a].5W.1h-1;A>=0;A--)Z[a].5W[A].gu&&Z[a].5W.6p(A,1);if(1c!==ZC.1d(Z[a][ZC.1b[10]]))1k(A=Z[a][ZC.1b[10]].1h-1;A>=0;A--)Z[a][ZC.1b[10]][A].gu&&Z[a][ZC.1b[10]].6p(A,1)}n||2u.1X(0,0),1o.b3({id:"zc-5T",bJ:e.AB,1s:ZC.A4(n?i:2u).1s(),1L:ZC.A4(n?i:2u).1L(),ra:!0,bU:e.LI,gH:e.l2,1T:s,cG:e.MJ,xR:e.QP})},rE:1f(e,t){1a i,n,a,l=1g,o=0,r=!1;1k(i=0,n=l.AI.1h;i<n;i++)if(e===l.AI[i].K){1k(o=i,a=0;a<l.AI[i].AX.A7.1h;a++)if(l.AI[i].AX.A7[a].IJ){r=!0;1p}1a C;1k(C=l.AI[o].AJ["3d"]||r?l.o[ZC.1b[16]][i]:l.AI[i].o,a=0;a<10;a++){1a A=ZC.1b[51]+(0===a?"":"-"+a);1c===ZC.1d(C[A])&&1c===ZC.1d(C[ZC.EB(A)])&&1c!==l.AI[i].BL(A)?C[A]={fo:t}:(1c!==ZC.1d(C[A])&&(C[A].fo=t),1c!==ZC.1d(C[ZC.EB(A)])&&(C[ZC.EB(A)].fo=t))}}4o l.E["2U"+o+".3C"],l.AI[o].AJ["3d"]||r?l.K2():l.AI[o].K2(!0,!0)},YX:1f(e,t){1a i=1g;if(i.D5){1k(1a n=0,a=i.AI.1h;n<a;n++)e===i.AI[n].K&&(i.AI[n].eH=t,i.AI[n].E["2g-on"]=t);if(t){1a l=ZC.A4("#"+i.K+"-1u"),o={dK:ZC.DT[0]-l.1Y().1J,i2:ZC.DT[1]-l.1Y().1u,1I:ZC.1b[48],2T:{id:i.K+"-5U"}};i.D5.PZ(o)}1t ZC.K1.i3(i.K)}},rI:1f(e){1k(1a t=1g,i=["1y","1M","2Q","5A","6d","3L","9q"],n=0,a=t.AI.1h;n<a;n++)if(e===t.AI[n].K){1a l=t.o[ZC.1b[16]][n];if("9q"===l.1I)1k(1a o=0,r=l[ZC.1b[11]].1h;o<r;o++){1a C=l[ZC.1b[11]][o];C.1I=C.1I||"1y","3d"===t.X4?C.1I=C.1I.1E("3d",""):-1!==ZC.AT(i,C.1I)&&(C.1I=C.1I+"3d")}1t"3d"===t.X4?l.1I=l.1I.1E("3d",""):-1!==ZC.AT(i,l.1I)&&(l.1I=l.1I+"3d")}t.X4="3d"===t.X4?"2d":"3d",t.E.4F=ZC.GO(3c.5d(t.o)),t.K2()},rK:1f(e){1k(1a t,i=1g,n=0;n<i.AI.1h;n++)4o i.E["g"+n+"-1U-eo"];if(e=e||{},ZC.AO.C2("fF",i,{id:i.K,4u:e[ZC.1b[3]]}),1c!==ZC.1d(t=e[ZC.1b[3]])){1a a=i.C8(t);1c!==a&&(i.MV(a),i.2t(a.K))}1t i.QI=[],i.NS=-1,i.MV(),i.rN(),i.2t()},xQ:1f(e){1a t,i=1g;if(e=e||{},1c!==ZC.1d(t=e[ZC.1b[3]])){1a n=i.C8(t);1c!==n&&1c!==ZC.1d(e.gF)&&(i.MV(n),i.2t(t,e.gF))}1t 1c!==ZC.1d(t=e.gF)&&(i.QN=t,i.MV(),i.2t())},ku:1f(){},O7:1f(){},V8:1f(){},xP:1f(e){1a t=1g;ZC.2A(t.FH(),e),ZC.AO.C2("18u",t,e)},rL:1f(O){1a s=1g;4I{1a DX=ZC.AO.rB(O["1f"]);O["1f"]=DX[0],O.7Z=DX[1],ZC.2A(s.FH(),O),7t(O["1f"]).4s(s,O)}4G(J5){1m s.NM(J5,"ri 1T 6C"),!1}},C8:1f(e){1a t=1g;1m 1c!==ZC.1d(e)?t.OQ(e):t.AI.1h>0?t.AI[0]:1c},3p:1f(e,t){1o.3p(1g.K,e,t)},3h:1f(e,t){1o.3h(1g.K,e,t)},3j:1f(e,t){1m 1o.3j(1g.K,e,t)},gc:1f(){1k(1a e=0,t=1g.AI.1h;e<t;e++)1g.AI[e].gc()}}),ZC.RD.5a.wR=1f(e){1a t,i,n,a,l,o=1g;if(e=e||{},e.7Y="ro",t=1c!==ZC.1d(e[ZC.1b[3]])?o.OQ(e[ZC.1b[3]]):o.AI[0]){1k(i=0,n=t.BT("k").1h;i<n;i++){1a r=t.BT("k")[i];if(a=1===r.L?"":"-"+r.L,r.H1&&(1c===ZC.1d(e["7L"+a])||e["7L"+a])){e["7L"+a]=!0,l=r.I/ZC.CV(r.I,e.rj||50);1a C,A=r.X,s=r.A1;e["x-"]?(C=ZC.CV(r.X-r.E7,ZC.1l((r.A1-r.X)/l)),A=r.X-C,s=r.A1-C):e["x+"]&&(C=ZC.CV(r.EF-r.A1,ZC.1l((r.A1-r.X)/l)),A=r.X+C,s=r.A1+C),e["4r"+a]=A,e["4m"+a]=s}}1k(i=0,n=t.BT("v").1h;i<n;i++){1a Z=t.BT("v")[i];if(a=1===Z.L?"":"-"+Z.L,Z.H1&&(1c===ZC.1d(e["7P"+a])||e["7P"+a])){e["7P"+a]=!0,l=Z.F/ZC.CV(Z.F,e.rk||50);1a c,u=Z.B8,p=Z.BS;e["y-"]?(c=ZC.CV(Z.B8-Z.GV,ZC.1l((Z.BS-Z.B8)/l)),u=Z.B8-c,p=Z.BS-c):e["y+"]&&(c=ZC.CV(Z.HF-Z.BS,ZC.1l((Z.BS-Z.B8)/l)),u=Z.B8+c,p=Z.BS+c),Z.QM&&1===Z.EA&&(u=1A.43(u),p=1A.43(p)),e["5s"+a]=u,e["5r"+a]=p}}o.PQ(e)}},ZC.RD.5a.ld=1f(e){1a t,i,n,a,l=1g;if(e=e||{},e.7Y="g4",t=1c!==ZC.1d(e[ZC.1b[3]])?l.OQ(e[ZC.1b[3]]):l.AI[0]){1k(i=0,n=t.BT("k").1h;i<n;i++){1a o=t.BT("k")[i];if(a=1===o.L?"":"-"+o.L,o.H1&&(1c===ZC.1d(e["7L"+a])||e["7L"+a])){e["7L"+a]=!0;1a r=o.A1-o.X,C=o.X+(r<2?0:ZC.1l(r/4)),A=o.A1-(r<2?0:ZC.1l(r/4));C<A?(e["4r"+a]=C,e["4m"+a]=A):(e["4r"+a]=o.X,e["4m"+a]=o.A1)}}1k(i=0,n=t.BT("v").1h;i<n;i++){1a s=t.BT("v")[i];if(a=1===s.L?"":"-"+s.L,s.H1&&(1c===ZC.1d(e["7P"+a])||e["7P"+a])){e["7P"+a]=!0;1a Z=s.BS-s.B8,c=s.B8+ZC.1W(Z/4),u=s.BS-ZC.1W(Z/4);s.QM&&1===s.EA&&(c=1A.43(c),u=1A.43(u)),c<u&&(e["5s"+a]=c,e["5r"+a]=u)}}l.PQ(e)}},ZC.RD.5a.jA=1f(e){1a t,i,n,a,l,o,r,C=1g;if(e=e||{},e.7Y="g2",e.h8=!0,t=1c!==ZC.1d(e[ZC.1b[3]])?C.OQ(e[ZC.1b[3]]):C.AI[0]){1k(i=0,n=t.BT("k").1h;i<n;i++){1a A=t.BT("k")[i];if(r=1===A.L?"":"-"+A.L,A.H1&&(1c===ZC.1d(e["7L"+r])||e["7L"+r]))if(e["7L"+r]=!0,t.BI&&t.BI.LH){1a s=ZC.1l(t.BI.NH[A.BB][ZC.1b[5]].1h*t.BI.JN/t.BI.B4.I),Z=ZC.1l(t.BI.NH[A.BB][ZC.1b[5]].1h*t.BI.HY/t.BI.B4.I);a=ZC.BN(2,Z-s),(l=ZC.BN(0,s-ZC.1l(a/2)))<(o=ZC.CV(t.BI.NH[A.BB][ZC.1b[5]].1h-1,Z+ZC.1l(a/2)))&&(e["4r"+r]=l,e["4m"+r]=o)}1t a=ZC.BN(2,A.A1-A.X),(l=ZC.BN(A.E7,A.X-ZC.1l(a/2)))<(o=ZC.CV(A.EF,A.A1+ZC.1l(a/2)))&&(e["4r"+r]=l,e["4m"+r]=o)}1k(i=0,n=t.BT("v").1h;i<n;i++){1a c=t.BT("v")[i];if(r=1===c.L?"":"-"+c.L,c.H1&&(1c===ZC.1d(e["7P"+r])||e["7P"+r])){e["7P"+r]=!0;1a u=c.BS-c.B8,p=ZC.BN(c.GV,c.B8-ZC.1W(u/2)),h=ZC.CV(c.HF,c.BS+ZC.1W(u/2));c.QM&&1===c.EA&&(1A.43(h)-1A.43(p)>1?(p=1A.43(p),h=1A.43(h)):(p=1A.4i(p),h=1A.4h(h))),(p=ZC.BN(c.GV,p))<(h=ZC.CV(c.HF,h))&&(e["5s"+r]=p,e["5r"+r]=h)}}C.PQ(e)}},ZC.RD.5a.ks=1f(e){1a t,i,n,a,l,o=1g;1k(e=e||{},i=1c!==ZC.1d(e[ZC.1b[3]])?o.OQ(e[ZC.1b[3]]):o.AI[0],e.7Y="fR",n=0,a=i.BT("k").1h;n<a;n++)if(t=i.BT("k")[n],l=1===t.L?"":"-"+t.L,e["7L"+l]=!0,e["4r"+l]=1c,e["4m"+l]=1c,i.o[t.BB]&&(i.o[t.BB]["3C-to"]=1c,i.o[t.BB]["3C-to-6g"]=1c),i.BI&&i.BI.LH){1a r=i.BI.NH[t.BB][ZC.1b[5]];e["8W"+l+"-aw"]=r[0],e["98"+l+"-aw"]=r[r.1h-1]}1k(n=0,a=i.BT("v").1h;n<a;n++)t=i.BT("v")[n],i.o[t.BB]&&(i.o[t.BB]["3C-to"]=1c,i.o[t.BB]["3C-to-6g"]=1c),t.DW=1c!==ZC.1d(t.E[ZC.1b[12]])&&-1!==t.E[ZC.1b[12]]?t.E[ZC.1b[12]]:1c,l=1===t.L?"":"-"+t.L,t.LO=1c,e["7P"+l]=!0,e["5s"+l]=1c,e["5r"+l]=1c;o.PQ(e)},ZC.RD.5a.PQ=1f(e){1a t,i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b=1g;(e=e||{}).id=1b.K;1a d=1c!==ZC.1d(e.3C)&&!e.3C;if(i=1c!==ZC.1d(e[ZC.1b[3]])?1b.OQ(e[ZC.1b[3]]):1b.AI[0]){d&&(1b.E["2U."+i.L+".bK-3C"]=!0),1b.E["2U."+i.L+".bK-3C"]&&(d=!0),1w e.1X===ZC.1b[31]&&(ZC.P.IL(ZC.AK(i.K+"-1X-x-c"),i.A.AB,i.iX,i.iY,i.I,i.F),ZC.P.IL(ZC.AK(i.K+"-1X-y-c"),i.A.AB,i.iX,i.iY,i.I,i.F)),i.BI&&(i.BI.HS=!1);1a f=1b.E["2U"+i.L+".3C"]||{};1k(e.rn=!1,(l=i.BT("v")[0])&&1c!==ZC.1d(e.5s)&&1c!==ZC.1d(e.5r)&&(e.5s===l.GV&&e.5r===l.HF||(e.rn=!0)),C=0,A=i.BT("k").1h;C<A;C++)if(a=i.BT("k")[C],s=1===a.L?"":"-"+a.L,1c!==ZC.1d(e["8W"+s])&&1c!==ZC.1d(e["98"+s]))if(e["8W"+s]===e["98"+s])4o e["8W"+s],4o e["98"+s];1t{1k(1a g=!1,B=!1,v=0,b=a.W.1h;v<b&&(e["8W"+s]<=a.W[v]&&!g&&(e["4r"+s]=v,g=!0),e["98"+s]<=a.W[v]&&!B&&(e["4m"+s]=v,B=!0),!g||!B);v++);g||(e["4r"+s]=0),B||(e["4m"+s]=a.W.1h-1),e["7L"+s]=!0,e.rm=!(g&&B)}1t n=i.BI&&i.BI.LH&&e.h8?i.BI.NH[a.BB][ZC.1b[5]]:a.W,1c!==ZC.1d(t=n[e["4r"+s]])&&(e["8W"+s]=t),1c!==ZC.1d(t=n[e["4m"+s]])&&(e["98"+s]=t),e.rm=!(e["4r"+s]===a.E7&&e["4m"+s]===a.EF);"fR"===e.7Y&&(e.rm=!1,e.rn=!1);1a E=ZC.AO.C2("3C",i.A,e,!0);if(e.aw&&!d)1m;if(i.BI&&i.BI.LH){n=i.BI.NH[a.BB][ZC.1b[5]];1a m=ZC.dS(n),K=ZC.dT(n);1c!==ZC.1d(e.8W)&&1w e.8W!==ZC.1b[31]?(o=ZC.1l(i.BI.B4.I*(e.8W-m)/(K-m)),o=ZC.BN(o,0)):o=0,1c!==ZC.1d(e.98)&&1w e.98!==ZC.1b[31]?(r=ZC.1l(i.BI.B4.I*(e.98-m)/(K-m)),r=ZC.CV(r,i.BI.B4.I)):r=i.BI.B4.I,d||i.BI.3O(o,r,i.BI.MM,i.BI.IQ)}if(E||1w E===ZC.1b[31]){1k(C=0,A=i.BT("k").1h;C<A;C++)e["7L"+(s=1===(a=i.BT("k")[C]).L?"":"-"+a.L)]&&(d||a.a4(e["4r"+s],e["4m"+s]),f["4r"+s]=e["4r"+s],f["4m"+s]=e["4m"+s]);1k(C=0,A=i.BT("v").1h;C<A;C++)e["7P"+(s=1===(l=i.BT("v")[C]).L?"":"-"+l.L)]&&1c!==ZC.1d(l)&&(d||l.a4(e["5s"+s],e["5r"+s]),f["5s"+s]=e["5s"+s],f["5r"+s]=e["5r"+s]);if(d&&(1b.H3.C=i),1b.H3.1q(),1b.H3.mI)1k(1b.E["2U"+i.L+".3C"]=f,p=0,h=1b.AI.1h;p<h;p++)i.K!==1b.AI[p].K&&1b.AI[p].H3&&ZC.2q(1b.AI[p].H3.o.6a)&&(1b.E["2U"+1b.AI[p].L+".3C"]=f);if(i.BI&&!e.2w&&i.BI.3O(e.4r,e.4m,e.5s,e.5r,!0),d)1m;if(i.3v(!0),(l=i.BT("v")[0])&&(l.7I[0]||l.7I[1])){1k(1a F=l.7I[0]?ZC.3q:l.GV,D=l.7I[1]?-ZC.3q:l.HF,I=0,X=i.AX.A7.1h;I<X;I++)if(i.AX.A7[I].AL&&-1!==ZC.AT(i.AX.A7[I].BK,l.BB))if(a.EC){1k(C=0,A=i.AX.A7[I].S.1h;C<A;C++)if((u=i.AX.A7[I].S[C])&&ZC.DU(u.BX,a.W[a.X],a.W[a.A1]))1k(l.7I[0]&&(F=ZC.CV(F,u.CM)),l.7I[1]&&(D=ZC.BN(D,u.CM)),Z=0,c=u.DL.1h;Z<c;Z++)l.7I[0]&&(F=ZC.CV(F,u.DL[Z])),l.7I[1]&&(D=ZC.BN(D,u.DL[Z]))}1t 1k(C=a.X;C<=a.A1;C++)if(u=i.AX.A7[I].S[C])1k(l.7I[0]&&(F=ZC.CV(F,u.CM)),l.7I[1]&&(D=ZC.BN(D,u.CM)),Z=0,c=u.DL.1h;Z<c;Z++)l.7I[0]&&(F=ZC.CV(F,u.DL[Z])),l.7I[1]&&(D=ZC.BN(D,u.DL[Z]));"2W"===l.CA&&(F=ZC.HH(F,l.EV),D=ZC.HH(D,l.EV)),l.RN(F,D,!0),l.IW();1a x=i.BT("v");1k(C=0;C<x.1h;C++)x[C].BB!==l.BB&&x[C].dI===l.BB&&(x[C].RN(F,D,!0),x[C].IW())}1a y=ZC.2q(e.qz);i.E["b7-2w"]=!0;1a L=["1u","2x","2a","1J"];1k(C=0;C<L.1h;C++)(i.Q.E["d-2v-"+L[C]]||i.E["2r.d-2v-"+L[C]]||ZC.2q(i.Q.o["94-3t"]))&&(i.o.2r["2v-"+L[C]]=i.Q.o["2v-"+L[C]]="4M",i.E["2r.d-2v"]=i.E["2r.d-2v-"+L[C]]=!0);i.nu(),i.1v(!y),1b.H3.C=1c,ZC.AO.C2("18y",i.A,e)}}},1o.rg=1f(e,t,i){2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a n,a,l,o,r,C,A,s,Z,c=1o.79(e);if(1c!==ZC.1d(i[ZC.1b[53]])&&(c.E[ZC.1b[53]]=ZC.2q(i[ZC.1b[53]])),c)1P(t){1j"18A":if(o={},l=c.C8(i[ZC.1b[3]]))1k(n=0,a=l.BK.1h;n<a;n++){1a u=l.BK[n];"k"===u.AF?o[u.BB]={4r:u.X,4m:u.A1,wU:u.W[u.X],xl:u.W[u.A1]}:o[u.BB]={5s:u.B8,5r:u.BS,wU:u.W[u.X],xl:u.W[u.A1]}}1m o;1j"ro":c.wR(i);1p;1j"g4":c.ld(i);1p;1j"g2":c.jA(i);1p;1j"qz":if(l=c.C8(i[ZC.1b[3]]),1c!==ZC.1d(i.l3)&&i.l3)1k(n=0,a=l.BT("k").1h;n<a;n++)i["4r"+(A=1===(r=l.BT("k")[n]).L?"":"-"+r.L)]=i.4r||1c,i["4m"+A]=i.4m||1c,i["8W"+A]=i.8W||1c,i["98"+A]=i.98||1c;1k(n=0,a=l.BT("k").1h;n<a;n++)1c===i["4r"+(A=1===(r=l.BT("k")[n]).L?"":"-"+r.L)]&&1c===ZC.1d(i["4m"+A])&&1c===ZC.1d(i["8W"+A])&&1c===ZC.1d(i["98"+A])||(i["7L"+A]=!0),"2W"===r.CA&&(1c!==ZC.1d(i["4r"+A])&&(i["4r"+A]=ZC.HH(i["4r"+A],r.EV)),1c!==ZC.1d(i["4m"+A])&&(i["4m"+A]=ZC.HH(i["4m"+A],r.EV)));if(1c!==ZC.1d(i.kE)&&i.kE)1k(n=0,a=l.BT("v").1h;n<a;n++)i["5s"+(A=1===(C=l.BT("v")[n]).L?"":"-"+C.L)]=i.5s||1c,i["5r"+A]=i.5r||1c;1k(n=0,a=l.BT("v").1h;n<a;n++)A=1===(C=l.BT("v")[n]).L?"":"-"+C.L,1c===ZC.1d(i["5s"+A])&&1c===ZC.1d(i["5r"+A])||(i["7P"+A]=!0),"2W"===C.CA&&(1c!==ZC.1d(i["5s"+A])&&(i["5s"+A]=ZC.HH(i["5s"+A],C.EV)),1c!==ZC.1d(i["5r"+A])&&(i["5r"+A]=ZC.HH(i["5r"+A],C.EV)));c.PQ(i);1p;1j"18G":if(l=c.C8(i[ZC.1b[3]]),1c!==ZC.1d(i.l3)&&i.l3)1k(n=0,a=l.BT("k").1h;n<a;n++)i["4r"+(A=1===(r=l.BT("k")[n]).L?"":"-"+r.L)]=i.4r||1c,i["4m"+A]=i.4m||1c;1k(n=0,a=l.BT("k").1h;n<a;n++)A=1===(r=l.BT("k")[n]).L?"":"-"+r.L,1c===ZC.1d(i["4r"+A])&&1c===ZC.1d(i["4m"+A])||(l.BI&&l.BI.LH?(i.h8=!0,i["8W"+A+"-aw"]=i["4r"+A],i["4r"+A]=ZC.pK(l.BI.NH[r.BB][ZC.1b[5]],i["4r"+A])):-1!==(s=ZC.AT(r.W,i["4r"+A]))&&(i["4r"+A]=s),l.BI&&l.BI.LH?(i.h8=!0,i["98"+A+"-aw"]=i["4m"+A],i["4m"+A]=ZC.pK(l.BI.NH[r.BB][ZC.1b[5]],i["4m"+A])):-1!==(Z=ZC.AT(r.W,i["4m"+A]))&&(i["4m"+A]=Z),i["7L"+A]=!0);if(1c!==ZC.1d(i.kE)&&i.kE)1k(n=0,a=l.BT("v").1h;n<a;n++)i["5s"+(A=1===(C=l.BT("v")[n]).L?"":"-"+C.L)]=i.5s||1c,i["5r"+A]=i.5r||1c;1k(n=0,a=l.BT("v").1h;n<a;n++)A=1===(C=l.BT("v")[n]).L?"":"-"+C.L,1c===ZC.1d(i["5s"+A])&&1c===ZC.1d(i["5r"+A])||(i["7P"+A]=!0);c.PQ(i);1p;1j"fR":c.ks(i)}1m 1c},ZC.wP={},ZC.AO.kB=1f(e,t,i,n){"qT"===(n=n||"9Y")&&(n="dg");1a a=2e.4N("3a");a.1s=t,a.1L=i,a.1H.1s=t+"px",a.1H.1L=i+"px";1a l=a.9j("2d");e 3z 3K||(e=[e]);1k(1a o,r=0,C=e.1h;r<C;r++)if(-1===e[r].7V.1K("zc-no-6F")){1a A=!1;4I{e[r].jz("4d/"+n)}4G(Z){A=!0}if(!A)if(o=e[r].bT("1T-3r")){1a s=o.2l(",");l.cM(e[r],ZC.BN(0,s[0]),ZC.BN(0,s[1]),ZC.CV(s[2],e[r].1s),ZC.CV(s[3],e[r].1L),ZC.BN(0,s[0]),ZC.BN(0,s[1]),ZC.CV(s[2],e[r].1s),ZC.CV(s[3],e[r].1L))}1t l.cM(e[r],0,0,e[r].1s,e[r].1L,0,0,t,i)}1m a.jz("4d/"+n)},ZC.AO.pG=1f(e,t,i,n,a){1c===ZC.1d(a)&&(a=!1);1a l=ZC.AO.kB(e,t,i,n);if(a){1a o=2e.4N("5U");1m o.4T=l,o}l=l.1E("4d/"+n,"4d/py-kr"),2e.7W.7K=l},ZC.RD.5a.ku=1f(){1a e=1g,t=[];if(!e.kx){e.kx=!0;1a i=2e.3o.6W,n=ZC.A4(2e.3o).2K(ZC.1b[0]),a=ZC.A4(2e.3o).2K("1R-4d");ZC.A4(2e.3o).2K(ZC.1b[0],"#2O").2K("1R-4d","1Z");1k(1a l=0,o=i.1h;l<o;l++)1===i[l].fM&&(t[l]=i[l].1H.3J,i[l].1H.3J="1Z");2e.3o.2X(ZC.AK(e.K+"-fP")),2u.5G(1f(){2u.6F(),2u.5G(1f(){ZC.A4(2e.3o).2K(ZC.1b[0],n).2K("1R-4d",a),ZC.AK(e.K+"-fP")&&ZC.AK(e.K).2X(ZC.AK(e.K+"-fP"));1k(1a l=0,o=i.1h;l<o;l++)1===i[l].fM&&(i[l].1H.3J=t[l]);e.kx=!1},5L)},50)}},ZC.RD.5a.O7=1f(e,t,i,n){1f a(){1a a={2B:Z=Z.1E(/<jx(.+?)<\\/jx>/g,""),w:l.I,h:l.F,t:e,fn:r};ZC.2A(t,a);1a A,s;if(1o.iE&&"fJ"!==e&&"2B"!==e&&!o){1a c="ky=1&";1k(s in a)c+=s+"="+fi(a[s])+"&";ZC.A4.av({1I:"iG",3P:1o.pW,1T:c,aD:1f(t,a,o){if(l.kA(),i)n&&n(t,a,o);1t{1a r=2e.4N("5U");r.4T=t,r.id=l.K+"-6F-"+e,C.2X(r)}}})}1t{ZC.AK(l.K+"-8w")&&ZC.P.ES(l.K+"-8w");1a u=ZC.P.HO({2m:"zc-3i zc-1H",id:l.K+"-8w",p:ZC.AK(l.K+"-1u"),3J:"1Z"}),p=(A=1c!==ZC.1d(a.cL)&&1c!==ZC.1d(a.3b)?ZC.P.nm(ZC.AK(l.K+"-8w")):2e).4N("zx");p.7Y=1o.pW,p.9E="iG",p.18I="184/4E-1T",1c!==ZC.1d(a.cL)&&1c!==ZC.1d(a.3b)?A.3o.2X(p):u.2X(p),p.1H.3J="1Z";1k(s in a){1a h=A.4N("zV");h.1I="9c",h.8L=s,h.1S=a[s],p.2X(h)}p.fT(),p=1c,1c!==ZC.1d(a.cL)&&1c!==ZC.1d(a.3b)&&2u.5G(1f(){ZC.A4("#"+l.K+"-8w").3m()},uh),2u.5G(1f(){l.kA()},5L)}}1a l=1g;if(t=t||{},1w i===ZC.1b[31]&&(i=!1),!ZC.AK(l.K+"-cs")){e=e||"9Y";1a o=t.fN,r=t.fn||"";ZC.P.IL(ZC.AK(l.K+"-2g-c"),l.AB,0,0,l.I,l.F),ZC.A4(".zc-2g-1G").3m();1a C,A,s=("3a"===l.AB||1o.iE||1o.3G.ha)&&"fJ"!==e&&"2B"!==e;if(ZC.2H||!s||i||o||(C=ZC.P.HO({2m:"zc-3i zc-cs zc-1H",id:l.K+"-cs",8s:5,p:ZC.AK(l.K+"-1u"),wh:l.I+"/"+l.F}),A=ZC.P.HO({id:l.K+"-cs-7p",p:C,8s:10,tl:"5/"+(l.I-15),4a:ZC.HA["cs-7p"]}),ZC.A4(A).2K("4O","8v").2K("1J",l.I-15-ZC.A4(A).1s()+"px"),ZC.A4(A).3p("3F",1f(){ZC.A4(C).3m()})),ZC.2H&&(o=!0),!1o.3G.ha||o||"2B"!==l.AB||"9Y"!==e&&"dg"!==e){1a Z;if("3a"===l.AB&&"fJ"!==e&&"2B"!==e){1a c=2e.4N("3a");c.1s=l.I,c.1L=l.F;1a u,p;1k(u=0,p=l.AI.1h;u<p;u++)l.AI[u].BC&&l.AI[u].BC.EH(c);1a h=[];ZC.A4("#"+l.K+" 3a").4Z(1f(){-1===ZC.AT([l.K+"-2g-c",l.K+"-7T-c"],1g.id)&&h.1i(1g)}),h.1i(c),h.1i(l.pD());1a 1b=ZC.AO.pG(h,l.I,l.F,e,!0);1b.id=l.K+"-6F-"+e,C.2X(1b)}1t if(i||l.po(ZC.HA["8w-aX"]),"3I"===l.AB||"3a"===l.AB&&("fJ"===e||"2B"===e)){1a d=2e.4N("3A"),f="zc-8w-2B-"+l.K;d.id=f,d.1H.3J="1Z",2e.3o.2X(d),1o.b3({id:f,bJ:"!2B",wO:!0,1s:l.I,1L:l.F,1T:l.E.4F,cG:l.MJ,bU:l.LI,dc:!0,hq:{2t:1f(){2u.5G(1f(){1a e=1o.79(f);if(e.E["4M-2F"])1a t=2u.fH(1f(){"9i"===e.E["4M-2F"]&&(2u.9N(t),e.bf(!0),Z=ZC.AK(f+"-1u").4n,e.bf(!1),1o.3j(f,"9M",{pE:!0}),a())},100);1t e.bf(!0),Z=ZC.AK(f+"-1u").4n,e.bf(!1),1o.3j(f,"9M",{pE:!0}),a()},100)}}})}1t"2B"===l.AB&&(l.bf(!0),Z=ZC.AK(l.K+"-1u").4n,a(),l.bf(!1));s&&!i&&(ZC.A4(A).2K("4O","8v").2K("1J",l.I-15-ZC.A4(A).1s()+"px"),ZC.A4(A).3p("3F",1f(){ZC.A4(C).3m()}))}1t 1o.3j(l.K,"xk",{5I:1f(a){if(-1!==a){1a o=2e.4N("5U");o.id=l.K+"-6F-"+e,o.4T=a,C.2X(o)}1t ZC.P.ES(l.K+"-cs"),1o.3G.ha=0,l.O7(e,t,i,n)}})}},ZC.RD.5a.V8=1f(e){1a t=1g;e=e||"9Y";1a i=[],n=2e.4N("3a");n.1s=t.I,n.1L=t.F;1a a,l;1k(a=0,l=t.AI.1h;a<l;a++)t.AI[a].BC&&t.AI[a].BC.EH(n);1m ZC.A4("#"+t.K+" 3a").4Z(1f(){-1===ZC.AT([t.K+"-2g-c",t.K+"-2C-c"],1g.id)&&i.1i(1g)}),i.1i(n),i.1i(t.pD()),ZC.AO.kB(i,t.I,t.F,e)},ZC.AO.nf=1f(e,t,i){if(!ZC.cF){i=i||"fY/py-kr";1a n=2e.4N("a");9d.wM?9d.wM(1n jr([e],{1I:i}),t):iy&&"fN"in n?(n.7K=iy.pl(1n jr([e],{1I:i})),n.4l("fN",t),2e.3o.2X(n),n.3F(),2e.3o.aN(n)):7W.7K="1T:fY/py-kr,"+fi(e)}},ZC.AO.hV=1f(e,t){1a i,n,a,l,o,r,C,A,s,Z,c,u,p,h=[],1b="",d=[];1k("89"===(t=t||"6K")&&h.1i(\'<4a dX:o="ps:pp-pH-bv:qj:qj" dX:x="ps:pp-pH-bv:qj:wZ" dX="7g://8B.w3.dQ/TR/18s-18K">\',"<gf>","\\18z!--[if 194 qy 9]><jq><x:wB><x:wC><x:wD><x:wF>gZ</x:wF><x:wE><x:18m/></x:wE></x:wD></x:wC></x:wB></jq><![17W]--\\17L",\'<1H>td{1F:1Z;2p-9g:17J,qr-qv} .8X{qy-8X-5K:"0.6P";} .1D{qy-8X-5K:"@";}</1H>\',"<wy 8L=17H 17E=18j.18g>","<wy qa=xg-8>","</gf>","<3o>"),i=0,n=e.AI.1h;i<n;i++){1a f=e.AI[i],g=f.AX.A7,B={},v=[],b=f.BT("k")[0];"4a"!==t&&"89"!==t&&"dN"!==t||(h.1i("<6q>"),f.IT&&""!==f.IT.AP&&(d.1i([f.IT.AP]),h.1i("<q1>"+f.IT.AP+"</q1>")),h.1i("<wS>"),h.1i("<tr>")),c=[],p=[];1a E="188",m=!1;1k(b&&(b.FD&&"5z"===b.FD.o.1I&&(E="9H",m=!0),b.M&&b.M.AP&&(E=b.M.AP.1E(/\\"|\\\'/g,""))),"6K"===t?c.1i(\'"\'+E+\'"\'):"dN"===t?p.1i(E):"4a"!==t&&"89"!==t||c.1i("<th>"+E+"</th>"),a=0,l=g.1h;a<l;a++)(1c===ZC.1d(g[a].o["8w"])||ZC.2q(g[a].o["8w"]))&&(u=(u=1c!==ZC.1d(g[a].AP)?g[a].AP+"":"km "+a).1E(/\\"|\\\'/g,""),"6K"===t?c.1i(\'"\'+u+\'"\'):"dN"===t?p.1i(u):"4a"!==t&&"89"!==t||c.1i("<th"+("89"===t?\' wT="mH" 3g="1D"\':"")+">"+u+"</th>"),v.1i(""));if("6K"===t?h.1i(c.2I(",")):"dN"===t?d.1i(p):"4a"!==t&&"89"!==t||h.1i(c.2I("")),"4a"!==t&&"89"!==t||(h.1i("</tr>"),h.1i("</wS>"),h.1i("<x8>")),b){1k(C=0,A=b.W.1h;C<A;C++)B[C+""]={kM:!1,cZ:[].4w(v)};1k(a=0,l=g.1h;a<l;a++)if(1c===ZC.1d(g[a].o["8w"])||ZC.2q(g[a].o["8w"]))1k(o=0,r=g[a].S.1h;o<r;o++){1a K=g[a].S[o];K&&(B[C=K.BX?""+K.BX:""+o]=B[C]||{kM:!0,cZ:[].4w(v)},B[C].cZ[a]=K.AE,B[C].kM=!0)}1a F=[];1k(C in B)B[C].kM&&F.1i([C,B[C].cZ]);F.3V(1f(e,t){1m e[0]-t[0]});1a D=1c;1k(s=0,Z=F.1h;s<Z;s++){if("4a"!==t&&"89"!==t||h.1i("<tr>"),"3L"!==f.AF&&"7k"!==f.AF&&"96"!==f.AF||b.W[F[s][0]]&&(F[s][0]=b.W[F[s][0]]),b.BW[F[s][0]]&&(F[s][0]=b.BW[F[s][0]]),b.W[F[s][0]]&&(F[s][0]=b.W[F[s][0]]),D=f.A.FH(),D.5j=s,D.mH=0,D[ZC.1b[9]]=F[s][0],F[s][0]=ZC.AO.C2("wI",f.A,D,F[s][0],1c),ZC.1d(F[s][1]))1k(1a I=0;I<F[s][1].1h;I++)(D=f.A.FH()).5j=s,D.mH=I+1,D[ZC.1b[9]]=F[s][1][I],F[s][1][I]=ZC.AO.C2("wI",f.A,D,F[s][1][I],1c);m&&(F[s][0]=ZC.AO.Y2(F[s][0],"%Y-%mm-%dd %H:%i:%s",f.UG,f.N2),"6K"===t&&(F[s][0]=\'"\'+F[s][0]+\'"\')),"6K"===t?h.1i([].4w(F[s][0]).4w(F[s][1]).2I(",")):"dN"===t?d.1i([].4w(F[s][0]).4w(F[s][1])):"4a"!==t&&"89"!==t||h.1i("<td"+("89"===t?\' wT="5j"\':"")+">"+[].4w(F[s][0]).4w(F[s][1]).2I("</td><td>")+"</td>"),"4a"!==t&&"89"!==t||h.1i("</tr>")}}"4a"!==t&&"89"!==t||(h.1i("</x8>"),h.1i("</6q>")),n>1&&i<n-1&&("6K"===t?h.1i("","",""):"4a"!==t&&"89"!==t||h.1i("<p>&8J;</p>"))}1m"89"===t&&h.1i("</3o>","</4a>"),"dN"===t?d:("6K"===t?1b=h.2I("\\n"):"4a"!==t&&"89"!==t||(1b=h.2I("")),1b)},1o.q6=1f(e,t,i){1f n(e){ZC.A4.av({1I:"iG",3P:l,1T:e,aD:1f(e,t,i){o&&o(e,t,i)}})}1a a,l,o,r,C,A="",s="";2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a Z=1o.79(e);if(Z)1P(t){1j"xk":if(r="9Y",1c!==ZC.1d(a=i.5K)&&(r=a),1c!==ZC.1d(a=i.wV)&&(r=a),"qT"===r&&(r="dg"),1o.3G.ha&&"2B"===Z.AB&&("9Y"===r||"dg"===r)){Z.bf(!0);1a c=ZC.AK(Z.K+"-2B").6s.4n,u=c.1K(">"),p=c.1K("</2B>");c=\'<2B dX:j5="7g://8B.w3.dQ/q9/j5" dX="7g://8B.w3.dQ/xj/2B" af="1.1" 1s="\'+Z.I+\'" 1L="\'+Z.F+\'">[iH]\'+c.2s(u+1,p+6),c=c.1E(/<jx(.+?)<\\/jx>/g,"");1a h=1f(){1a e,t=2u.iy||2u.18Z||2u;e=t.pl&&2u.jr?t.pl(1n 2u.jr([c],{1I:"4d/2B+jq;qa-ob-16"})):"1T:4d/2B+jq;qa=xg-8,"+fi(c),Z.bf(!1);1a n=1n 2u.cV;n.xf="xd",n.4T=e,n.hv=1f(){1a t=2e.4N("3a"),a=t.9j("2d");if(t.1s=n.1s,t.1L=n.1L,a.cM(n,0,0,t.1s,t.1L),i.5I&&"1f"==1w i.5I)4I{i.5I(t.jz("4d/"+r))}4G(l){i.5I(e)}}},1b=0,d=1f(){1a e=1n hk;e.bu("qm",Z.hD[1b]),e.xc="1D",e.pV=1f(e){1a t=e.2T.xb,i=t.ln(/191?:\\/\\/[^ \\)]+/g),n=0;i.18q(1f(e){1a a=1n hk;a.bu("qm",e),a.xc="18x",a.pV=1f(a){1a l=1n 17K;l.pV=1f(a){t=t.1E(1n 5o(e),a.2T.18F),++n===i.1h&&(c=c.1E("[iH]","[iH]<1H><![18O["+t+"]]></1H>"),++1b===Z.hD.1h?(c=c.1E("[iH]",""),h()):d())},l.17Z(a.2T.xb)},a.8r()})},e.8r()};Z.hD.1h?d():(c=c.1E("[iH]",""),h())}if("3a"!==Z.AB&&!1o.iE)1m-1;if("3a"===Z.AB){if(!i.5I||"1f"!=1w i.5I)1m Z.V8(r);4I{i.5I(Z.V8(r))}4G(B){i.5I(-1)}}1t Z.O7(r,{},!0,i.5I);1p;1j"17U":1j"17F":if(!i.fN&&"3a"!==Z.AB&&!1o.iE)1m-1;if(r="9Y",C={},1c!==ZC.1d(a=i.x7)&&(C=a),1c!==ZC.1d(a=i.cL)&&(C.cL=a),1c!==ZC.1d(a=i.3b)&&(C.3b=a),1c!==ZC.1d(a=i.5K)&&(r=a),1c!==ZC.1d(a=i.wV)&&(r=a),1c!==ZC.1d(a=i.j2)&&(A=a),l=Z.E.r4||"",1c!==ZC.1d(a=i.3P)&&(l=a),o=1c,1c!==ZC.1d(a=i.5I)&&(o=a),"qT"===r&&(r="dg"),i.fN&&("3a"!==Z.AB||"fJ"===r))1m C.fN=!0,""!==A&&(C.fn=A),8j Z.O7(r,C);if(""!==l){if("3a"===Z.AB)1m n(Z.V8(r));Z.O7(r,C,!0,1f(e){1m n(e)})}1p;1j"jl":if(l=Z.E.nE||"",1c!==ZC.1d(a=i.3P)&&(l=a),s=ZC.AO.186(Z),""===l)1m s;o=1c,1c!==ZC.1d(a=i.5I)&&(o=a),ZC.A4.av({1I:"iG",3P:l,1T:s,aD:1f(e,t,i){o&&o(e,t,i)}});1p;1j"x3":s=ZC.AO.hV(Z,"6K"),ZC.AO.nf(s,(i.fn||Z.K)+".6K","1D/6K;wY:ob-8");1p;1j"x0":s=ZC.AO.hV(Z,"89"),ZC.AO.nf(s,(i.fn||Z.K)+".89","fY/189.ms-wZ;wY:ob-8");1p;1j"181":1a f=ZC.AO.hV(Z,"dN");if(!i.5I||"1f"!=1w i.5I)1m f;4I{i.5I(f,i.fn||Z.K)}4G(B){i.5I(-1)}1p;1j"wX":if("oY"===i.ou)if(s=ZC.AO.hV(Z,"4a"),ZC.AK(Z.K+"-1T-6q"))ZC.AK(Z.K+"-1T-6q").4n=s;1t{1a g=ZC.P.HO({id:Z.K+"-1T-6q",2m:"zc-1T-6q "+Z.K+"-1T-6q"});ZC.P.PC(g,{1s:Z.I+"px","1V-1L":"18c",9R:"3e"}),g.4n=s,ZC.AK(Z.K).6s.hL(g,ZC.AK(Z.K).p8)}1t"oo"===i.ou&&ZC.P.ES(Z.K+"-1T-6q")}1m 1c},ZC.zv={},ZC.AO.WI=1f(e){1k(1a t,i="",n=!1,a=!1,l=0,o="",r=0,C=(e=e.1E(/\\t|\\r|\\n/g,"")).1h;r<C;r++)1P(t=e.5v(r,1)){1j\'"\':n=!n,i+=e.5v(r,1),o=t;1p;1j"{":i+=e.5v(r,1),n||(i+="\\n"+1n 3K(l+1).2I("    "),l++,o=t);1p;1j"}":n||(i+="\\n"+1n 3K(l).2I("    "),l--,o=t),i+=e.5v(r,1);1p;1j"[":1a A=e.1K("]",r),s=e.1K("}",r);s=-1===s?zu:s;1a Z=e.1K("{",r);Z=-1===Z?zu:Z,A<ZC.CV(s,Z)?(a=!0,i+=e.5v(r,1)):(a=!1,i+=e.5v(r,1),i+="\\n"+1n 3K(l+1).2I("    "),l++),o=t;1p;1j"]":a&&(a=!1),"}"===o&&(l--,i+="\\n"+1n 3K(l).2I("    ")),i+=e.5v(r,1),o=t;1p;1j" ":n&&(i+=e.5v(r,1),o=t);1p;1j",":i+=e.5v(r,1),n||a||(i+="\\n"+1n 3K(l).2I("    ")),o=t;1p;2n:i+=e.5v(r,1),o=t}1m i},ZC.RD.5a.j9=1f(){1a e=1g;ZC.AO.C2("18f",e,e.FH());1a t=ZC.P.HO({2m:"zc-3i zc-4H zc-1H",id:e.K+"-4H",p:ZC.AK(e.K+"-1u"),wh:e.I-(ZC.8U?0:10)+"/"+(e.F-(ZC.8U?0:10))});t.1H.9V=99,t.4n=ZC.n7(\'<3A 3g="zc-4E-5j-1G zc-4E-s1">&8J;<a 7K="7u:8j(0)" id="\'+e.K+\'-4H-gk" 3g="zc-c8-6D">\'+ZC.HA["4H-gk"]+\'</a>&8J;<a 7K="7u:8j(0)" id="\'+e.K+\'-4H-gp" 3g="zc-c8-f5">\'+ZC.HA["4H-gp"]+\'</a></3A><3A 3g="zc-4E-5j-ah"><bR id="\'+e.K+\'-4H-4F" 1H="1s:\'+(e.I-35)+"px;1L:"+(e.F-95)+\'px;"></bR></3A><3A 3g="zc-4E-5j-ah zc-4E-5j-84" id="\'+e.K+\'-4H-zt"><ad 1I="76" 1S="\'+ZC.HA["4H-7p"]+\'" id="\'+e.K+\'-4H-7p" /></3A>\'),1o.oJ&&(ZC.AK(e.K+"-4H-zt").4n+=\'<ad 1I="76" 1S="\'+ZC.HA["4H-8H"]+\'" id="\'+e.K+\'-4H-8H" />\'),ZC.A4("#"+e.K+"-4H-4F").8z(ZC.AO.WI(e.E.7d)),ZC.A4("#"+e.K+"-4H-gp").3p("3F",1f(){ZC.AK(e.K+"-4H-gp").7V="zc-c8-6D",ZC.AK(e.K+"-4H-gk").7V="zc-c8-f5",ZC.A4("#"+e.K+"-4H-4F").8z(ZC.AO.WI(e.E.4F))}),ZC.A4("#"+e.K+"-4H-gk").3p("3F",1f(){ZC.AK(e.K+"-4H-gp").7V="zc-c8-f5",ZC.AK(e.K+"-4H-gk").7V="zc-c8-6D",ZC.A4("#"+e.K+"-4H-4F").8z(ZC.AO.WI(e.E.7d))}),ZC.A4("#"+e.K+"-4H-7p").3p("3F",1f(){ZC.AO.C2("zs",e,e.FH()),ZC.P.ES(e.K+"-4H")}),1o.oJ&&ZC.A4("#"+e.K+"-4H-8H").3p("3F",1f(){ZC.AO.C2("zs",e,e.FH());1a t=ZC.A4("#"+e.K+"-4H-4F").8z();ZC.P.ES(e.K+"-4H"),1o.3j(e.K,"b4",{1T:t})})},ZC.RD.5a.lj=1f(){1a e=1g;if(e.I<eF||e.F<eF)2u.bu("7g://8B.1o.bv/zL/","","");1t{1a t=ZC.P.HO({2m:"zc-3i zc-4p zc-1H",id:e.K+"-4p",p:ZC.AK(e.K+"-1u"),wh:e.I-(ZC.8U?0:10)+"/"+(e.F-(ZC.8U?0:10))}),i="";i+=\'<3A 3g="zc-4E-5j-1G zc-4E-s0">\'+ZC.HA["4p-5S"]+\'</3A><3A 3g="zc-4E-5j-1G"><ad 1I="zp" id="\'+e.K+\'-oN" fK="fK" /><1G 1k="\'+e.K+\'-oN">\'+ZC.HA["4p-zq"]+"</1G>",ZC.3a&&(i+=\'&8J;&8J;&8J;&8J;&8J;<ad 1I="zp" id="\'+e.K+\'-oq" fK="fK" /><1G 1k="\'+e.K+\'-oq">\'+ZC.HA["4p-zo"]+"</1G>"),i+=\'</3A><3A 3g="zc-4E-5j-1G zc-4E-s1">\'+ZC.HA["4p-zn"]+\'</3A><3A 3g="zc-4E-5j-ah"><bR id="\'+e.K+\'-4p-zb" 1H="1s:\'+(e.I-35)+"px;1L:"+((e.F-eF)/2-10)+\'px;"></bR></3A><3A 3g="zc-4E-5j-1G zc-4E-s1">\'+ZC.HA["4p-zm"]+\'</3A><3A 3g="zc-4E-5j-ah"><bR id="\'+e.K+\'-4p-4F" 1H="1s:\'+(e.I-35)+"px;1L:"+(e.F-17Y)/2+\'px;"></bR></3A><3A 3g="zc-4E-5j-1G zc-4E-s1">\'+ZC.HA["4p-z8"]+(e.I>=17M?" <7D>("+ZC.HA["4p-zj"]+")</7D>":"")+\'</3A><3A 3g="zc-4E-5j-ah"><ad 1I="1D" id="\'+e.K+\'-4p-or" 1H="1s:\'+(e.I-35)+\'px;" /></3A><3A 3g="zc-4E-5j-ah zc-4E-5j-84"><ad 1I="76" 1S="\'+ZC.HA["4p-fT"]+\'" id="\'+e.K+\'-4p-fT" /><ad 1I="76" 1S="\'+ZC.HA["4p-mO"]+\'" id="\'+e.K+\'-4p-mO" /></3A>\',t.4n=ZC.n7(i),ZC.A4("#"+e.K+"-4p-4F").8z("17P\\n----------\\n"+ZC.AO.WI(e.E.4F)+"\\n\\17V\\n----------\\n"+ZC.AO.WI(e.E.7d)),ZC.A4("#"+e.K+"-4p-mO").3p("3F",1f(){ZC.P.ES(e.K+"-4p")}),ZC.A4("#"+e.K+"-4p-fT").3p("3F",1f(){1a t=/^((\\w+\\+*\\-*)+\\.?)+@((\\w+\\+*\\-*)+\\.?)*[\\w-]+\\.[a-z]{2,6}$/,i=ZC.A4("#"+e.K+"-4p-or");if(t.5x(i.8z())){1a n="";ZC.3a&&(n=e.V8("9Y"));1a a=("zf:"+e.E.4F+" zd:"+e.E.7d).1E(/\\r|\\n|\\t|(\\s{2,})/g,""),l="",o=[];ZC.A4("#"+e.K+"-oq").3Q("fK")&&o.1i("****18P:",n),ZC.A4("#"+e.K+"-oN").3Q("fK")&&o.1i("****3c:",a),o.1i("****18Q:",ZC.A4("#"+e.K+"-4p-zb").8z(),"****18R:",i.8z(),"****fL:",ZC.fL,"****18S:",e.I,"****18T:",e.F,"****iy:",2u.7W.7K,"****UA:",9d.cS,"****18U:",e.AB.5D(),"****18V:",zl.1s+"x"+zl.1L);1k(1a r=0;r<o.1h-1;r+=2)l+=o[r]+fi(o[r+1]);l+="****18W";1a C=ZC.P.nm(ZC.AK(e.K+"-4p")),A=C.4N("zx");A.7Y=2e.7W.iS+"//8B.1o.bv/zL/18X.18Y",A.9E="iG",C.3o.2X(A);1a s=C.4N("zV");s.1I="1D",s.8L="1T",s.1S=l,A.2X(s),A.fT(),2u.5G(1f(){zU(ZC.HA["4p-zT"]),ZC.P.ES(e.K+"-4p")},5L)}1t i.8z(ZC.HA["4p-zS"])})}},ZC.RD.5a.rJ=1f(){1a e,t,i,n=1g;ZC.P.ES([n.K+"-4X-2M",n.K+"-4X-c7-2M",n.K+"-4X-dG-2M",n.K+"-4X-4Y",n.K+"-4X-c7-4Y",n.K+"-4X-dG-4Y"]),1c!==ZC.1d(e=n.o.4X)&&(n.I0=1n ZC.DQ(n),n.B9.2t(n.I0.o,"6C.5f.4X"),n.I0.1C(e),n.I0.1q(),n.I0.ll=!0,t=1n ZC.DS(n),n.B9.2t(t.o,"6C.5f.4X.1N"),t.1C(e.1N),t.1q(),i=1n ZC.DS(n),n.B9.2t(i.o,"6C.5f.4X.1N-6N"),i.1C(e.1N),i.1C(e["1N-6N"]),i.1q());1a a="";if(n.I0){n.I0.K=n.K+"-4X",n.I0.Z=n.I0.C5=ZC.AK(n.K+"-8F-c"),n.I0.1v();1a l=n.I0.iX+n.I0.EO,o=n.I0.iY+n.I0.FM,r=n.I0.I-n.I0.EO-n.I0.FN,C=n.I0.F-n.I0.FM-n.I0.FV,A=1n ZC.DS(n);A.K=n.K+"-4X-c7",A.1Q(t),A.CX=!1,0===n.NS&&A.1Q(i),A.D=[[l,o+C/2],[l+r/3,o],[l+r/3,o+C],[l,o+C/2]],A.IE=ZC.AK(n.A.K+"-1D"),A.Z=A.C5=ZC.AK(n.K+"-8F-c"),A.1q(),A.1v(),n.NS>0&&(a+=ZC.P.GC("5t",!0)+\'3g="\'+n.K+\'-4X-1M zc-4X-1M" id="\'+n.K+"-4X-c7-1M"+ZC.1b[30],a+=ZC.1l(l+ZC.3y)+","+ZC.1l(o+ZC.3y)+","+ZC.1l(l+r/3+ZC.3y)+","+ZC.1l(o+C+ZC.3y),a+=\'" />\');1a s=1n ZC.DS(n);s.K=n.K+"-4X-dG",s.1Q(t),s.CX=!1,n.NS!==n.QI.1h-1&&0!==n.QI.1h||s.1Q(i),s.D=[[l+r,o+C/2],[l+2*r/3,o],[l+2*r/3,o+C],[l+r,o+C/2]],s.IE=ZC.AK(n.A.K+"-1D"),s.Z=s.C5=ZC.AK(n.K+"-8F-c"),s.1q(),s.1v(),n.NS<n.QI.1h-1&&(a+=ZC.P.GC("5t",!0)+\'3g="\'+n.K+\'-4X-1M zc-4X-1M" id="\'+n.K+"-4X-dG-1M"+ZC.1b[30],a+=ZC.1l(l+2*r/3+ZC.3y)+","+ZC.1l(o+ZC.3y)+","+ZC.1l(l+r+ZC.3y)+","+ZC.1l(o+C+ZC.3y),a+=\'" />\'),""!==a&&(ZC.AK(n.K+"-2Z").4n+=a),n.nQ=1f(e){e.2T.id===n.K+"-4X-c7-1M"?1o.3j(n.K,"d7"):e.2T.id===n.K+"-4X-dG-1M"&&1o.3j(n.K,"d8")},ZC.A4("."+n.K+"-4X-1M").4c("3F",n.nQ)}},ZC.AM={fg:1,E1:0,E0:0,FQ:40},ZC.DF={si:1f(e,t){1a i,n;1m t.AA%180==0?(i=1n ZC.CF(e,-e.I/2,t.iY-e.iY-e.F/4,0),n=1n ZC.CF(e,e.I/2,t.iY-e.iY-e.F/4,0)):(i=1n ZC.CF(e,t.iX-e.iX-e.I/4,-e.F/2,0),n=1n ZC.CF(e,t.iX-e.iX-e.I/4,e.F/2,0)),ZC.TF(1A.aA((n.E9[1]-i.E9[1])/(n.E9[0]-i.E9[0])))+(t.AA%180==0?0:t.AA%2j==90?90:-90)},DA:1f(e,t,i,n,a,l,o,r,C){C=C||"z";1a A,s,Z,c,u=1n ZC.Z2(e,t);1P(C){1j"x":A=1n ZC.CF(t,i,a,o),s=1n ZC.CF(t,n,a,o),Z=1n ZC.CF(t,n,l,r),c=1n ZC.CF(t,i,l,r);1p;1j"y":A=1n ZC.CF(t,i,a,o),s=1n ZC.CF(t,i,l,o),Z=1n ZC.CF(t,n,l,r),c=1n ZC.CF(t,n,a,r);1p;1j"z":A=1n ZC.CF(t,i,a,o),s=1n ZC.CF(t,i,a,r),Z=1n ZC.CF(t,n,l,r),c=1n ZC.CF(t,n,l,o)}1m u.2N(A),u.2N(s),u.2N(Z),u.2N(c),u},D6:1f(e,t,i,n){1w n===ZC.1b[31]&&(n=!1);1a a,l=1c,o=1c;i 3z 3K?l=i:(l=i.2S,o=i.u8);1k(1a r=1n ZC.Z2(e,t),C=0,A=l.1h;C<A;C++)1c!==ZC.1d(l[C])&&(n?r.2N(l[C],o?o[C]:1c):r.2N(1n ZC.CF(t,l[C][0],l[C][1],l[C][2]),o?1n ZC.CF(t,o[C][0],o[C][1],o[C][2]):1c));1m(a=e.o["z-193"])&&(r.M9=[ZC.1l(a),ZC.1l(a),ZC.1l(a)]),r}},ZC.CF=ZC.C9.C7({$i:1f(e,t,i,n){1g.1q(e,t,i,n)},1q:1f(e,t,i,n){1a a=1g;a.C=e,a.iX=t,a.iY=i,n-=a.C.F7.5q/2,a.iZ=n,a.EK=0,a.EJ=0,a.eA=0,a.E9=[];1a l=a.C.F7.2c,o=a.C.F7.3C;if(a.C.F7.7J){1a r={x:t,y:i,z:n},C={x:0,y:0,z:0},A={x:a.C.F7[ZC.1b[27]],y:a.C.F7[ZC.1b[28]],z:a.C.F7[ZC.1b[29]]},s=2*1A.PI/2j,Z=1A.dL(A.x*s),c=1A.dL(A.y*s),u=1A.dL(A.z*s),p=1A.db(A.x*s),h=1A.db(A.y*s),1b=1A.db(A.z*s);a.EK=h*(u*(r.y-C.y)+1b*(r.x-C.x))-c*(r.z-C.z),a.EJ=Z*(h*(r.z-C.z)+c*(u*(r.y-C.y)+1b*(r.x-C.x)))+p*(1b*(r.y-C.y)-u*(r.x-C.x)),a.eA=p*(h*(r.z-C.z)+c*(u*(r.y-C.y)+1b*(r.x-C.x)))-Z*(1b*(r.y-C.y)-u*(r.x-C.x)),a.E9[0]=ZC.AM.E1+ZC.AM.fg/(ZC.AM.fg+a.eA)*a.EK*o,a.E9[1]=ZC.AM.E0+ZC.AM.fg/(ZC.AM.fg+a.eA)*a.EJ*o}1t a.E9[0]=ZC.AM.E1+t+n*ZC.ED(l)*o,a.E9[1]=ZC.AM.E0+i-n*ZC.EL(l)*o}}),ZC.Z2=ZC.C9.C7({$i:1f(e,t){1a i=1g;i.C=t,i.N=e,i.K="",i.K3=!1,i.M9=[1,1,1],i.FS=-1,i.D=[],i.P1=[],i.SG=-6J,i.ZJ=-6J,i.lf=6J,i.la=6J,i.nJ=6J,i.l9=0,i.hf=0,i.qV=0},2N:1f(e,t){1a i=1g;i.D.1i(e),i.P1.1i(t||e)},Ck:1f(){1k(1a e=1g,t=e.P1.1h,i=0;i<t;i++){1a n=e.P1[i];e.SG=ZC.BN(e.SG,n.iZ),ZC.2q(e.C.F7.7J)?(e.lf=ZC.CV(e.lf,n.iZ),e.ZJ=ZC.BN(e.ZJ,n.eA),e.hf+=n.iY):(e.la=ZC.CV(e.la,n.iX),e.nJ=ZC.CV(e.nJ,n.iY),e.l9+=n.iX,e.hf+=n.iY,e.qV+=n.iZ)}e.l9/=t,e.hf/=t,e.qV/=t},FB:1f(){1k(1a e=1g,t="",i=0,n=e.D.1h;i<n;i++)t+=ZC.1l(e.D[i].E9[0]+ZC.3y)+","+ZC.1l(e.D[i].E9[1]+ZC.3y)+",";1m t=t.2s(0,t.1h-1)}}),ZC.UR=ZC.C9.C7({$i:1f(){1a e=1g;e.f1=[],e.18M={},e.WD=[],e.SA={}},3v:1f(){1a e=1g;e.f1=[],e.WD=[],e.SA={}},2N:1f(e){1g.f1.1i(e)},Cc:1f(e,t){1m 1===1o.cQ?e[0][0]>t[0][0]?-1:e[0][0]<t[0][0]?1:e[0][1]>t[0][1]?1:e[0][1]<t[0][1]?-1:e[0][2]>t[0][2]?-1:e[0][2]<t[0][2]?1:e[0][3]>t[0][3]?-1:e[0][3]<t[0][3]?1:0:2===1o.cQ?-1!==e[0][3]||-1!==t[0][3]?e[0][3]>t[0][3]?1:e[0][3]<t[0][3]?-1:0:e[0][0]>t[0][0]?-1:e[0][0]<t[0][0]?1:e[0][1]>t[0][1]?1:e[0][1]<t[0][1]?-1:e[0][2]>t[0][2]?1:e[0][2]<t[0][2]?-1:0:3===1o.cQ?e[0]>t[0]?-1:e[0]<t[0]?1:0:8j 0}}),ZC.r9=ZC.C9.C7({$i:1f(e){1a t=1g;t.H=e,t.V7=!1,t.OM=mN,t.GD=0,t.I9=0,t.GS=20,t.B7="",t.CD=[],t.A8=1c},eT:1f(){1a e=1g;ZC.2H||(e.V7?(1c!==ZC.1d(e.C4)&&2u.9N(e.C4),e.C4=2u.fH(1f(){1a t=e.H.K,i=ZC.A4("#"+t+("2B"===e.H.AB?"-1u":"-3X")),n=ZC.DT[0]-i.1Y().1J,a=ZC.DT[1]-i.1Y().1u;ZC.DU(n,e.GD,e.GD+e.A8.I)&&ZC.DU(a,e.I9,e.I9+e.A8.F)||(1c!==ZC.1d(e.C4)&&2u.9N(e.C4),e.5c())},e.OM)):e.5c())},3v:1f(){1a e=1g;ZC.P.IL(ZC.AK(e.H.K+"-2C-c"),e.H.AB,e.iX,e.iY,e.I,e.F,e.K)},5c:1f(){if(!ZC.mX){1a e=1g,t=e.H.K;ZC.P.ES([t+"-2C-1D",t+"-2C",t+"-2C-1D-8Z"]),"2B"===e.H.AB&&ZC.A4("zI").4Z(1f(){-1!==1g.id.1K("-18L-3r")&&ZC.P.ES(1g.id)})}},4k:1f(e){1a t,i=1g;1c!==ZC.1d(i.C4)&&2u.9N(i.C4);1a n=i.H.K;if(0!==ZC.A4("#"+n+"-2C-c").1h&&i.A8){1a a=ZC.ak(i.H.K),l=ZC.P.M8(e),o=ZC.A4("#"+n+("2B"===i.H.AB?"-1u":"-3X")),r=l[0]-o.1Y().1J-i.A8.I*a[0]/2,C=l[1]-o.1Y().1u-i.A8.F*a[1],A=r,s=1+2*i.A8.JP;if(1c!==ZC.1d(i.A8.o.x)&&((r=ZC.IB(i.A8.o.x,!0))>0&&r<1&&(r=ZC.1l(i.H.I*r)),i.A8.o.7m&&(r-=i.A8.I/2)),1c!==ZC.1d(i.A8.o.y)&&((C=ZC.IB(i.A8.o.y,!0))>0&&C<1&&(C=ZC.1l(i.H.F*C)),i.A8.o.7m&&(C-=i.A8.F/2)),r+=ZC.1l(i.A8.E["1Y-x"]),C+=ZC.1l(i.A8.E["1Y-y"]),"2B"===i.H.AB||!i.A8.o[ZC.1b[7]]){1a Z=0,c=!1,u=i.A8.EQ;r/a[0]<s&&(Z=A/a[0]-s-i.A8.H0/2,r=s),r/a[0]+i.A8.I>i.H.I-s&&(Z=A/a[0]+i.A8.I-i.H.I+s+i.A8.H0/2,r=(i.H.I-s-i.A8.I)*a[0]),C/a[1]<s&&(i.CD.2o||!i.A8.o[ZC.1b[7]]?(C=s+ZC.1l(i.A8.E["1Y-y"]),C=i.CD.2o?C<s?s:C:C<s?l[1]-o.1Y().1u-ZC.1l(i.A8.E["1Y-y"]):C,u="1u",c=!0):C=s+(l[1]-o.1Y().1u-ZC.1l(i.A8.E["1Y-y"]))),C/a[1]+i.A8.F>i.H.F-s&&(C=i.H.F-s-i.A8.F,!i.CD.2o&&i.A8.o[ZC.1b[7]]||(u="1u",c=!0)),0===Z&&!c||"xy"===i.A8.o[ZC.1b[7]]||i.A8.Z&&(i.3v(),c&&(i.A8.EQ=u),Z=ZC.CV(Z,i.A8.I/2-i.A8.H0/2),Z=48*(Z=ZC.BN(Z,-i.A8.I/2+i.A8.H0/2))/(i.A8.I/2-i.A8.H0/2),i.A8.EU=Z,i.A8.AL&&i.A8.1v())}1P(i.GD=r,i.I9=C,i.H.AB){1j"2B":1c===ZC.1d(i.A8.o.x)&&1c===ZC.1d(i.A8.o.y)&&ZC.AK(n+"-2C").4l("5H","7f("+r/a[0]+","+C/a[1]+")"),i.A8.E["4a-4B"]&&ZC.P.PC(ZC.AK(n+"-2C-1D-8Z"),{1J:(""===i.B7?r/a[0]:i.A8.iX)+i.A8.EO+"px",1u:(""===i.B7?C/a[1]:i.A8.iY)+i.A8.FM+"px"});1p;1j"3I":1c===ZC.1d(i.A8.o.x)&&1c===ZC.1d(i.A8.o.y)&&ZC.P.PC(ZC.AK(n+"-2C"),{1J:r+"px",1u:C+"px"});1p;1j"3a":1c!==ZC.1d(i.CD.x)&&(r=i.CD.x),1c!==ZC.1d(i.CD.y)&&(C=i.CD.y);1a p=i.A8.E["4a-4B"]?0:20;1P(i.A8.WL){1j"tl":1p;1j"tr":r-=i.A8.I;1p;1j"bl":C-=i.A8.F;1p;1j"br":r-=i.A8.I,C-=i.A8.F;1p;1j"c":r-=i.A8.I/2,C-=i.A8.F/2;1p;1j"t":r-=i.A8.I/2;1p;1j"r":r-=i.A8.I,C-=i.A8.F/2;1p;1j"b":r-=i.A8.I/2,C-=i.A8.F;1p;1j"l":C-=i.A8.F/2}ZC.P.PC(ZC.AK(n+"-2C-c"),{1J:r/a[0]-p+"px",1u:C/a[1]-p+"px"}),1c!==(t=ZC.AK(n+"-2C-1D"))&&(t.1H.3J="1Z",ZC.P.PC(t,{1s:i.A8.I+"px",1L:i.A8.F+"px",1J:r/a[0]+"px",1u:C/a[1]+"px"}),t.1H.3J="8K")}}},gx:1f(e){1g.4k(e)},eI:1f(e,t){1a i,n,a,l=1g,o=l.H.K,r=e.9O||e.2T.id,C=r.1E(/--([a-zA-Z0-9]+)/,"").1E("-bx-1M","-1M").1E("-1M-2M","").1E("-2M","").1E("-1O-3x","").1E("-1O","").2l("-").9m(),A=r.2l("--"),s=!1,Z=!1,c=!1;"2o"===C[1]&&"1B"===C[3]&&"cu"===C[4]&&(s=!0),ZC.P.ES([o+"-2C-1D",o+"-2C",o+"-2C-1D-8Z"]);1a u,p,h;if(s){if(!(u=l.H.OQ(C[5])))1m;if(p=u.AX.A7[C[2]],h=p.FO(C[0]),"xy"===u.AJ.3t&&h.SU(),!h)1m;ZC.A4("#"+o+"-2U-"+C[5]+"-1B-"+C[2]+"-bg-2J-c").4k()}1t"1U"===C[2]&&0===C[1].1K("1N")&&(Z=!0),0!==C[2].1K("1z")||0!==C[1].1K("1N")&&0!==C[1].1K("1O")||(c=!0),u=l.H.OQ(C[3]);if(ZC.AK(o+"-2C")||(ZC.P.JU({id:o+"-2C",p:ZC.AK(o+"-3X"),2m:"zc-3i zc-2C",wh:l.H.I+"/"+l.H.F,9R:"9c"},l.H.AB),ZC.P.H6({id:o+"-2C-c",p:ZC.AK(o+"-2C"),2m:"zc-3i",tl:"-4J/-4J",1s:140,1L:60},l.H.AB)),l.A8=1o.5Y.ai("DQ",l,o+"-2C-1D"),l.A8.O9="2C",l.A8.A=l.H,u&&u.A8&&l.A8.1Q(u.A8),s)l.A8.1C(p.A8.o),u.CW["p"+p.L]&&u.CW["p"+p.L]["n"+h.L]&&l.A8.1C(p.A8.o[ZC.1b[73]]),2===A.1h&&l.A8.1C(p.oI(A[1]));1t{1a 1b=!1;if(Z&&u.BC&&1c!==ZC.1d(u.BC.o.2C)&&(l.A8.o.1D="",l.A8.1C(u.BC.o.2C),1b=!0),c){l.A8.1C({"1R-1r":"#2O","1F-1s":1,"1F-1r":"#4J"});1a d=u.BL(C[2].1E(/\\1b/g,"-"));if(d&&1c!==ZC.1d(d.o.2C)&&(l.A8.o.1D="",l.A8.1C(d.o.2C),1b=!0),0===C[1].1K("7E"))d&&(-1!==C[1].1K("zF")&&d.o.1G&&d.o.1G.2C?(l.A8.o.1D="",l.A8.1C(d.o.1G.2C),1b=!0):d.o.1N&&d.o.1N.2C&&(l.A8.o.1D="",l.A8.1C(d.o.1N.2C),1b=!0));1t if(0===C[1].1K("aH")){1a f=ZC.1l(C[1].1E("aH",""));d.PX[f]&&d.PX[f].o.1G&&d.PX[f].o.1G.2C&&(l.A8.o.1D="",l.A8.1C(d.PX[f].o.1G.2C),1b=!0)}}if("2P"===C[2])if(l.A8.1C({"1R-1r":"#2O","1F-1s":1,"1F-1r":"#4J"}),e.2T.bT("1T-mT"))l.A8.1C({1D:e.2T.bT("1T-2C-1D")}),1b=!0;1t 1k(n=0,a=u.FE.1h;n<a;n++)if(1c!==ZC.1d(u.FE[n])){1a g=u.FE[n]3z ZC.QL?u.FE[n].BE:u.FE[n];u.K+"-2P-"+C[1]===u.FE[n].K&&1c!==ZC.1d(i=g.o.2C)&&(l.A8.1C(i),l.A8.o.7m&&(l.A8.o.x=g.iX,l.A8.o.y=g.iY),1b=!0)}if("1G"===C[2])1k(l.A8.1C({"1R-1r":"#2O","1F-1s":1,"1F-1r":"#4J"}),n=0,a=u.BW.1h;n<a;n++)u.K+"-1G-"+C[1]===u.BW[n].K&&1c!==ZC.1d(i=u.BW[n].o.2C)&&(l.A8.1C(i),l.A8.o.7m&&(l.A8.o.x=u.BW[n].iX+u.BW[n].I/2,l.A8.o.y=u.BW[n].iY+u.BW[n].F/2),1b=!0);if("xy"===C[2]&&(l.A8.1C({"1R-1r":"#2O","1F-1s":1,"1F-1r":"#4J"}),1b=!0),!1b)1m}t&&l.A8.1C(t),l.V7=!1,l.OM=mN,1c!==ZC.1d(i=l.A8.o.18w)&&(l.V7=ZC.2q(i)),1c!==ZC.1d(i=l.A8.o.iC)&&(l.OM=ZC.1l(i)),1c!==ZC.1d(i=l.A8.o[ZC.1b[7]])?l.B7=i:l.B7="",1c!==ZC.1d(i=l.A8.o.6T)&&(l.GS=ZC.1l(i)),l.A8.iX=0,l.A8.iY=0,l.A8.Z=l.A8.C5=ZC.AK(o+"-2C-c");1a B;if(s){B=h.XP(),h.H9(B),1c!==ZC.1d(B["1y-1r"])?l.A8.A0=l.A8.AC=ZC.AO.JE(B["1y-1r"]):l.A8.A0=l.A8.AC=ZC.AO.JE(B[ZC.1b[0]]),l.A8.BU=B[ZC.1b[61]],l.A8.BZ=B.1r,1c!==ZC.1d(p.o.ac)?(l.ZV||(l.ZV=1n ZC.I8(p.A),l.ZV.E["Av-1q"]=!0),l.ZV.1C(p.o),l.ZV.1q(),l.ZV.JC=1f(e){1m h.JC(e)},l.ZV.DD()&&l.ZV.1q(),l.A8.AP=l.ZV.JT):l.A8.AP=p.JT;1a v=ZC.AO.OS(l.A8.o,p.o);l.A8.KC=1f(e){1m h.KC(e,v)},l.A8.E.7i=h.A.L,l.A8.E.7l=h.L}1t if(Z){1k(p=u.AX.A7[C[1].1E("7E","")],l.A8.1C(p.o["1U-2C"]),h=1c,n=0,a=p.S.1h;n<a;n++)if(1c!==p.S[n]){h=p.FO(n);1p}if(h){if("-1"===(B=h.XP())[ZC.1b[0]])1m;l.A8.A0=l.A8.AC=ZC.AO.JE(B[ZC.1b[0]]),l.A8.BZ=B.1r}1t l.A8.A0=l.A8.AC=ZC.AO.JE(p.BO[1]),l.A8.BZ=p.BO[0];l.A8.AP=p.YA,l.A8.KC=1f(e){1m e=e.1E(/%1B-sd/g,p.YA),e=e.1E(/%1B-1D|%t/g,p.AP)}}1t if(c){if(0===C[1].1K("7E")){1a b=C[1].1E("7E","").2l("1b"),E=1===b.1h?ZC.1l(b[0]):ZC.1l(b[1]);l.A8.KC=1f(e){e=e||"%1z-1S";1a t=d.BW[E]||d.W[E];if(d.FD){1a i={"5H-5z":!0,"5H-5z-5K":d.FD.o.4q||d.FD.o.1D||"",ch:u.UG,cn:u.N2};t=ZC.AO.GM(t,i,l.A,!!d.FD&&d.FD)}"8X"==1w t&&d.IH&&1c!==ZC.1d(d.IH[t])&&(t=d.IH[t]),e=(e=e.1E(/%1D|%1N-1D|%1z-1S|%v/g,t)).1E(/%2C-1D/g,d.tv[E]||"");1k(1a n in d.o)d.o.8d(n)&&"1T-"===n.2s(0,5)&&(e=e.1E("%"+n,d.o[n][E]||"","g"));1m e}}}1t l.A8.KC=1f(e){1m e};if(1c===ZC.1d(l.A8.o["1D-2k"])&&(l.A8.o["1D-2k"]=1),l.A8.1q(),!s&&"3a"!==l.H.AB&&l.A8.o.7m&&(l.A8.iX=l.A8.iX-l.A8.I/2+l.A8.BJ,l.A8.iY=l.A8.iY-l.A8.F/2+l.A8.BD),l.A8.AL){l.A8.IA&&(s&&l.A8.H9(l.A8,l.A8,1c,h.MK(e,!1)),l.A8.1q()),l.A8.E["4a-4B"]=!1,1c!==ZC.1d(i=l.A8.o["4a-4B"])&&(l.A8.E["4a-4B"]=ZC.2q(i)),s&&(l.A8.JC=1f(e){1m h.JC(e)},l.A8.DD()&&l.A8.1q());1a m,K;if("3a"!==l.H.AB&&"3I"!==l.H.AB||0===l.A8.AA)m=l.A8.I+l.A8.JP,K=l.A8.F+l.A8.JP,m+=40,K+=40,l.A8.E["1Y-x"]=l.A8.BJ,l.A8.E["1Y-y"]=l.A8.BD;1t{1a F=1.25*ZC.BN(l.A8.I,l.A8.F)+l.A8.JP;m=F,K=F,l.A8.iX+=(F-l.A8.I)/2,l.A8.iY+=(F-l.A8.F)/2,l.A8.E["1Y-x"]=-(F-l.A8.I)/2+l.A8.BJ,l.A8.E["1Y-y"]=-(F-l.A8.F)/2+l.A8.BD}if(ZC.A4("#"+o+"-2C-c").3Q(ZC.1b[19],m).3Q(ZC.1b[20],K),"3I"===l.H.AB&&ZC.P.PC(ZC.AK(o+"-2C-c"),{1u:0,1J:0}),l.A8.Q4=l.A8.BJ,l.A8.KZ=l.A8.BD,l.A8.BJ=0,l.A8.BD=0,!e.1I&&s&&("3a"===l.H.AB?(1c===ZC.1d(l.A8.o.x)&&(l.A8.o.x=h.iX-l.A8.I/2),1c===ZC.1d(l.A8.o.y)&&(l.A8.o.y=h.iY-l.A8.F)):(1c===ZC.1d(l.A8.o.x)&&(l.A8.iX=h.iX-l.A8.I/2),1c===ZC.1d(l.A8.o.y)&&(l.A8.iY=h.iY-l.A8.F-20))),s&&(l.CD=l.zB(h),""!==l.B7&&("3a"!==l.H.AB?(l.A8.o.x=l.A8.iX=l.CD.x,l.A8.o.y=l.A8.iY=l.CD.y):(l.A8.o.x=l.A8.iX=0,l.A8.o.y=l.A8.iY=0),l.A8.EQ=l.CD.cp,l.A8.EU=l.CD.co)),l.A8.AL&&""!==l.A8.AP&&("3a"===l.H.AB&&(l.A8.E["4a-4B"]||(l.A8.iX=20,l.A8.iY=20)),l.A8.1v()),(e.1I&&s||e.3O)&&(h.iF(),h.C.QF(!0)),e.1I||"3a"===l.H.AB)l.4k(e);1t if(l.A8.E["4a-4B"]){1a D=l.A8.iX+l.A8.EO,I=l.A8.iY+l.A8.FM;ZC.P.PC(ZC.AK(o+"-2C-1D-8Z"),{1J:D+"px",1u:I+"px",9V:1o.rA})}}},zB:1f(e){1a t,i=1g,n={},a=i.A8.H0,l=i.A8.G1,o=i.A8.I,r=i.A8.F;if(i.A8.E["4a-4B"]&&("cd"===i.B7||"9r"===i.B7||"2o:"===i.B7.2s(0,5))&&(i.A8.iX=-6J,i.A8.iY=-6J,i.A8.AL)){i.A8.1v();1a C=ZC.A4("#"+i.H.K+"-2C-1D-"+("3a"===i.H.AB?"t":"8Z"));o=C.1s()+i.A8.EO+i.A8.FN,r=C.1L()+i.A8.FM+i.A8.FV,1c!==ZC.1d(i.A8.o[ZC.1b[19]])&&(o=ZC.1l(i.A8.o[ZC.1b[19]])),1c!==ZC.1d(i.A8.o[ZC.1b[20]])&&(r=ZC.1l(i.A8.o[ZC.1b[20]]))}if("cd"===i.B7)e.iX+e.I/2<e.C.iX+e.C.I/2?(n.x=e.iX+0*e.I+i.GS,n.y=e.iY+0*e.F/2-r/2,n.cp="1J"):(n.x=e.iX-o-i.GS,n.y=e.iY+0*e.F/2-r/2,n.cp="2x"),n.y<5&&(t=5-n.y,n.co=-ZC.1l(100*t/(r-l)),n.y=5),n.y+r>i.H.F-5&&(t=i.H.F-5-n.y-r,n.co=-ZC.1l(100*t/(r-l)),n.y=i.H.F-5-r);1t if("9r"===i.B7)e.iY+e.F/2<e.C.iY+e.C.F/2?(n.y=e.iY+0*e.F+i.GS,n.x=e.iX+0*e.I/2-o/2,n.cp="1u"):(n.y=e.iY-r-i.GS,n.x=e.iX+0*e.I/2-o/2,n.cp="2a"),n.x<5&&(t=5-n.x,n.co=-ZC.1l(100*t/(i.A8.I-a)),n.x=5),n.x+o>i.H.I-5&&(t=i.H.I-5-n.x-o,n.co=-ZC.1l(100*t/(o-a)),n.x=i.H.I-5-o);1t if("2o:"===i.B7.2s(0,5)&&e.cc){1P(n=e.cc(i.A8,i.B7.2s(5)),n.2o=!0,n.a0=i.B7.2s(5),n.a0){1j"1J":n.x=n.x-o+i.A8.Q4,n.y=n.y-r/2+i.A8.KZ;1p;1j"2x":n.x=n.x+i.A8.Q4,n.y=n.y-r/2+i.A8.KZ;1p;1j"1u":n.x=n.x-o/2+i.A8.Q4,n.y=n.y-r+i.A8.KZ;1p;1j"2a":n.x=n.x-o/2+i.A8.Q4,n.y=n.y+i.A8.KZ;1p;1j"3E":n.x=n.x-o/2+i.A8.Q4,n.y=n.y-r/2+i.A8.KZ}n.cp=i.A8.EQ}if(n.2o){1a A=0;n.y+r>i.H.F-5&&("1u"===n.a0||"2a"===n.a0?(n.y=n.y-r-("2a"===n.a0?0:i.A8.G1)-i.A8.KZ,n.cp="2a"):n.y=i.H.F-r-5),n.y<5&&("1u"===n.a0||"2a"===n.a0?(n.y=n.y+("1u"===n.a0?0:i.A8.G1)+r-i.A8.KZ,n.cp="1u"):n.y=5),n.x+o>i.H.I-5&&("1J"===n.a0||"2x"===n.a0?(n.x=n.x-o-i.A8.Q4-5,n.cp="2x"):(A=48*(o-i.H.I+n.x+i.A8.H0/2)/(i.A8.I/2),n.x=i.H.I-o-i.A8.Q4-5),n.co=A),n.x<5&&("1J"===n.a0||"2x"===n.a0?(n.x=n.x+i.A8.I-i.A8.Q4+5,n.cp="1J"):(A=48*(n.x-i.A8.H0/2)/(i.A8.I/2),n.x=5),n.co=A)}1m n}}),ZC.n5=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.H=e,t.J6=!1,t.C=1c,t.PM=1c,t.U8=1c,t.HV=0,t.LA=0,t.HW=0,t.LC=0,t.AD=1c,t.AU=1c,t.Z5=!1,t.yH=0,t.mI=!1,t.M=1c},1q:1f(){1a e=1g;e.C&&(e.C.H3&&e.1C(e.C.H3.o),e.b(),e.ZA("dp-3C","mI","b"),e.M=1n ZC.DQ(e),e.C.A.B9.2t(e.M.o,"2U.3C.1G"),e.M.1C(e.o.1G),e.M.1q(),e.o.1G&&!1!==e.o.1G.2f&&(e.M.AL=!0))},3h:1f(){1a e=1g;1o.3G.bA?ZC.A4(2e.3o).3h("6I 4D",e.QW):ZC.A4("#"+e.H.K+"-5U").3h("6I 4D",e.QW),ZC.A4(".zc-2o-1M").4f("6I 4D",e.QW),ZC.A4(2e.3o).3h("7R 6k",e.TZ),ZC.A4(2e.3o).3h("6f 5P",e.VF)},3p:1f(){1a e=1g,t=e.H.K;e.QW=1f(i){if((!ZC.2H||"mV"!==1o.lH)&&!(i.8T>1||-1!==ZC.P.SW(i.2T).1K("zc-2y-1N")||ZC.3l)&&(i.1I!==ZC.1b[47]||!ZC.bO)&&-1===i.2T.id.1K("-1U-5S-1M")&&(ZC.2H||i.6L(),e.H.9h(),(ZC.2H||!(i.8T>1))&&("3I"!==e.H.AB||-1===i.2T.7V.1K("zc-2o-1M")))){i.Ab&&(e.Z5=!0);1a n=ZC.P.M8(i),a=ZC.ak(e.H.K),l=ZC.A4("#"+t+"-1u").1Y(),o=(n[0]-l.1J)/a[0],r=(n[1]-l.1u)/a[1];e.PM=o,e.U8=r,e.Z5&&(e.yH=o);1k(1a C,A=!1,s=0,Z=e.H.AI.1h;s<Z;s++)C=e.H.AI[s].Q,ZC.DU(o,C.iX-5,C.iX+C.I+5)&&ZC.DU(r,C.iY-5,C.iY+C.F+5)&&(e.C=e.H.AI[s]);if(1c!==e.C){if(e.C.H3&&1c!==ZC.1d(e.C.H3.o.6D)&&!ZC.2q(e.C.H3.o.6D))1m;C=e.C.Q,e.C.AX.A7.1h>0&&(e.AD=e.C.BL(e.C.AX.A7[0].BT("k")[0]),e.AU=e.C.BL(e.C.AX.A7[0].BT("v")[0])),1c!==e.AD&&1c!==e.AU&&e.C.AJ["4S-cj"]&&(e.AD.H1||e.AU.H1)&&(e.HV=e.AD.D9?r:o,e.HW=e.AU.D9?o:r,A=!0,e.AD.H1?e.AD.D9?e.HV=ZC.5m(e.HV,C.iY,C.iY+C.F):e.HV=ZC.5m(e.HV,C.iX,C.iX+C.I):e.HV=e.AD.D9?C.iY:C.iX,e.AU.H1?e.AU.D9?e.HW=ZC.5m(e.HW,C.iX,C.iX+C.I):e.HW=ZC.5m(e.HW,C.iY,C.iY+C.F):e.HW=e.AU.D9?C.iX:C.iY)}1m A&&(e.LA=e.HV,e.LC=e.HW,e.J6=!0,ZC.A4(2e.3o).3p("7R 6k",e.TZ),ZC.A4(2e.3o).3p("6f 5P",e.VF),e.Z5?2e.3o.1H.4O="8v":(e.1q(),e.C.AJ["3d"]||ZC.P.HO({id:t+"-3C",p:ZC.AK(t+"-1u"),1u:-9,1J:-9,wh:"1/1",2G:"4A",1F:e.AQ+"px 2R "+e.BU,1R:e.A0,3k:e.C6}),e.M.AL&&(ZC.P.HO({id:t+"-6l",p:ZC.AK(t+"-1u"),1u:-6J,1J:-6J,2G:"4A",cK:e.M.FM,dv:e.M.FN,dt:e.M.FV,dj:e.M.EO,1F:e.M.AQ+"px 2R "+e.M.BU,1R:e.M.A0,1r:e.M.BZ,6U:e.M.GB,6R:e.M.7C,cD:e.M.MX?"bP":"5e",6S:e.M.DG,1D:""}),ZC.P.HO({id:t+"-to",p:ZC.AK(t+"-1u"),1u:-6J,1J:-6J,2G:"4A",cK:e.M.FM,dv:e.M.FN,dt:e.M.FV,dj:e.M.EO,1F:e.M.AQ+"px 2R "+e.M.BU,1R:e.M.A0,1r:e.M.BZ,6U:e.M.GB,6R:e.M.7C,cD:e.M.MX?"bP":"5e",6S:e.M.DG,1D:""})),2e.3o.1H.4O="9w")),!!ZC.2H&&8j 0}},e.TZ=1f(i){if(i.1I!==ZC.1b[48]||!ZC.bO){ZC.2H||i.6L(),ZC.3l=!0,e.C||(ZC.3l=!1,e.J6=!1,ZC.A4(2e.3o).3h("7R 6k",e.TZ),ZC.A4(2e.3o).3h("6f 5P",e.VF),2e.3o.1H.4O="3e",ZC.P.ES([t+"-3C",t+"-6l",t+"-to"]));1a n,a;if(e.J6){e.C.A.A8.5c();1a l=ZC.P.M8(i),o=ZC.ak(e.H.K),r=ZC.A4("#"+t+"-1u").1Y(),C=(l[0]-r.1J)/o[0],A=(l[1]-r.1u)/o[1];if(i.iB){1a s=ZC.CV(C-e.PM,A-e.U8);C=e.PM+s,A=e.U8+s}if(e.LA=e.AD.D9?A:C,e.LC=e.AU.D9?C:A,!e.Z5){1a Z=e.C.Q;n=e.AD.AR?e.AD.BV:e.AD.A6,a=e.AD.AR?e.AD.A6:e.AD.BV,e.AD.H1?e.AD.D9?(e.AD.Y5&&(e.HV=e.AD.iY+n+e.AD.A9*ZC.1l((e.HV-e.AD.iY-n)/e.AD.A9),e.LA=e.AD.iY+n+e.AD.A9*ZC.1l((e.LA-e.AD.iY-n)/e.AD.A9)),e.HV=ZC.5m(e.HV,Z.iY+a,Z.iY+Z.F-n),e.LA=ZC.5m(e.LA,Z.iY+a,Z.iY+Z.F-n)):(e.AD.Y5&&(e.HV=e.AD.iX+n+e.AD.A9*ZC.1l((e.HV-e.AD.iX-n)/e.AD.A9),e.LA=e.AD.iX+n+e.AD.A9*ZC.1l((e.LA-e.AD.iX-n)/e.AD.A9)),e.HV=ZC.5m(e.HV,Z.iX+n,Z.iX+Z.I-a),e.LA=ZC.5m(e.LA,Z.iX+n,Z.iX+Z.I-a)):(e.HV=e.AD.D9?Z.iY+a:Z.iX+n,e.LA=e.AD.D9?Z.iY+Z.F-n:Z.iX+Z.I-a),n=e.AU.AR?e.AU.A6:e.AU.BV,a=e.AU.AR?e.AU.BV:e.AU.A6,e.AU.H1?e.AU.D9?(e.AU.Y5&&(e.HW=e.AU.iX+n+e.AU.A9*ZC.1l((e.HW-e.AU.iX-n)/e.AU.A9),e.LC=e.AU.iX+n+e.AU.A9*ZC.1l((e.LC-e.AU.iX-n)/e.AU.A9)),e.HW=ZC.5m(e.HW,Z.iX+a,Z.iX+Z.I-n),e.LC=ZC.5m(e.LC,Z.iX+a,Z.iX+Z.I-n)):(e.AU.Y5&&(e.HW=e.AU.iY+n+e.AU.A9*ZC.1l((e.HW-e.AU.iY-n)/e.AU.A9),e.LC=e.AU.iY+n+e.AU.A9*ZC.1l((e.LC-e.AU.iY-n)/e.AU.A9)),e.HW=ZC.5m(e.HW,Z.iY+n,Z.iY+Z.F-a),e.LC=ZC.5m(e.LC,Z.iY+n,Z.iY+Z.F-a)):(e.HW=e.AU.D9?Z.iX+a:Z.iY+n,e.LC=e.AU.D9?Z.iX+Z.I-n:Z.iY+Z.F-a);1a c,u,p,h,1b=ZC.A4.6A.a6?0:2*e.AQ;e.C.AJ["3d"]&&(1b=0);1a d=ZC.AK(t+"-3C");if(e.AD.D9&&e.AU.D9?(c=ZC.2i(e.LC-e.HW-1b),u=ZC.2i(e.LA-e.HV-1b),p=ZC.CV(e.HW,e.LC),h=ZC.CV(e.HV,e.LA)):(c=ZC.2i(e.LA-e.HV-1b),u=ZC.2i(e.LC-e.HW-1b),p=ZC.CV(e.HV,e.LA),h=ZC.CV(e.HW,e.LC)),e.C.AJ["3d"]){e.C.NW();1a f=ZC.AK(e.H.K+"-2g-c");f&&(ZC.P.IL(f,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F),ZC.A4(".zc-2g-1G").3m()),(d=1n ZC.DS(e)).Z=f,d.A0=d.AC=e.A0,d.BU=e.BU,d.AQ=e.AQ,d.C6=e.C6,d.D=[[p,h],[p+c,h],[p+c,h+u],[p,h+u],[p,h]];1k(1a g=0;g<d.D.1h;g++){1a B=1n ZC.CF(e.C,d.D[g][0]-ZC.AM.E1,d.D[g][1]-ZC.AM.E0,0);d.D[g][0]=B.E9[0],d.D[g][1]=B.E9[1]}d.1q(),d.1v()}1t ZC.P.PC(d,{1s:c+"px",1L:u+"px",1J:p+"px",1u:h+"px"});if(e.M.AL){1a v=ZC.CV(e.HV,e.LA),b=ZC.BN(e.HV,e.LA),E=ZC.CV(e.HW,e.LC),m=ZC.BN(e.HW,e.LC),K=ZC.AK(t+"-6l"),F=ZC.AK(t+"-to"),D={6h:1c===ZC.1d(e.AU.DW)?1:e.AU.DW};K.4n=e.AD.G0(e.AD.O4(v))+"/"+e.AU.G0(-1,e.AU.N8(E),D),F.4n=e.AD.G0(e.AD.O4(b))+"/"+e.AU.G0(-1,e.AU.N8(m),D),ZC.P.PC(K,{1J:p-e.AQ-ZC.1l(ZC.A4(K).1s())+"px",1u:h-e.AQ-ZC.1l(ZC.A4(K).1L())+"px"}),ZC.P.PC(F,{1J:p+e.AQ+e.M.AQ+c+"px",1u:h+e.AQ+e.M.AQ+u+"px"})}}}1m!1}},e.VF=1f(i){if((i.1I!==ZC.1b[49]||!ZC.bO)&&e.C){if(ZC.3l=!1,e.J6=!1,2e.3o.1H.4O="3e",ZC.P.ES([t+"-3C",t+"-6l",t+"-to"]),e.C.AJ["3d"]){e.C.NW();1a n=ZC.AK(e.H.K+"-2g-c");n&&(ZC.P.IL(n,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F),ZC.A4(".zc-2g-1G").3m())}if(ZC.A4(2e.3o).3h("7R 6k",e.TZ),ZC.A4(2e.3o).3h("6f 5P",e.VF),e.Z5)e.Z5=!1;1t{1a a,l,o,r,C,A,s,Z,c,u={4u:e.C.K};if(ZC.2i(e.HV-e.LA)>10&&ZC.2i(e.HW-e.LC)>10){1a p,h,1b=!1,d=!1;1k(r=0,C=(o=e.C.BT("k")).1h;r<C;r++)(p=o[r])&&o[r].H1&&(A=1===p.L?"":"-"+p.L,a=p.O4(ZC.CV(e.HV,e.LA)),l=p.O4(ZC.BN(e.HV,e.LA)),ZC.2i(l-a)>=1&&(u["7L"+A]=!0,u["4r"+A]=ZC.CV(a,l),u["4m"+A]=ZC.BN(a,l),"2W"===p.CA&&(u["8W"+A]=p.W[ZC.1l(ZC.HH(u["4r"+A],p.EV))],u["98"+A]=p.W[ZC.1l(ZC.HH(u["4m"+A],p.EV))],4o u["4r"+A],4o u["4m"+A]),1b=!0));1k(r=0,C=(o=e.C.BT("v")).1h;r<C;r++)(h=o[r])&&o[r].H1&&(A=1===h.L?"":"-"+h.L,s=h.N8(ZC.BN(e.HW,e.LC)),Z=h.N8(ZC.CV(e.HW,e.LC)),c=(h.HF-h.GV)/1A.5k(10,10),ZC.2i(Z-s)>=c&&(u["7P"+A]=!0,u["5s"+A]=ZC.CV(s,Z),u["5r"+A]=ZC.BN(s,Z),d=!0));1b||d?(1o.4C.9Z=!0,e.C.A.PQ(u)):1o.4C.9Z=!0}1t(ZC.2i(e.HV-e.LA)>5||ZC.2i(e.HW-e.LC)>5)&&(1o.4C.9Z=!0);e.C=1c}}},ZC.2H&&"5e"!==1o.lH||(1o.3G.bA?ZC.A4(2e.3o).3p("6I 4D",e.QW):ZC.A4("#"+t+"-5U").3p("6I 4D",e.QW),ZC.A4(".zc-2o-1M").4c("6I 4D",e.QW))}}),ZC.oi=ZC.CZ.C7({$i:1f(e){1g.b(e);1a t=1g;t.HS=!0,t.q4=!1,t.C=e,t.H=e.A,t.J6=!1,t.h4=!1,t.GY=1c,t.B4=1c,t.Z=1c,t.JN=0,t.HY=0,t.P3=0,t.ZX=0,t.LH=!1,t.NH=1c,t.lO=!1,t.BW=1c,t.lN=!1},1q:1f(){1f e(e){1m[n+".3M",n+".3M-"+e,n+".3n",n+".3n-"+e]}1a t,i=1g;i.K=i.C.K+"-2w",i.4y([["4c","q4","b"],["aw","LH","b"],["2h-6T","P3","i"],["2h-6T-x","P3","i"],["2h-6T-y","P3","i"],["2f","AL","b"]]);1a n="("+i.C.AF+").2w",a=i.H.B9;i.B4=1n ZC.HQ(i.C),i.B4.K=i.C.K+"-2w-15P",a.2t(i.B4.o,[n]),i.B4.1C(i.o),i.B4.1q(),i.o.1G&&(i.BW=[]),i.o.3n&&i.o.3n.1G&&(i.J0=1n ZC.DQ(i.C),i.J0.1C(i.o.3n.1G),i.J0.1C({1D:" "}),i.J0.1q(),i.J0.AL&&(i.lN=!0)),i.OT=1n ZC.CZ(i.C),a.2t(i.OT.o,[n+".4K"]),1c!==ZC.1d(t=i.o.4K)&&i.OT.1C(t),i.OT.1q(),i.U4=1n ZC.CZ(i.C),a.2t(i.U4.o,[n+".6D"]),1c!==ZC.1d(t=i.o.6D)&&i.U4.1C(t),i.U4.1q(),i.II=1n ZC.HQ(i.B4),i.H7=1n ZC.HQ(i.B4),i.J4=1n ZC.HQ(i.B4),i.GW=1n ZC.HQ(i.B4),a.2t(i.II.o,e("1J")),a.2t(i.H7.o,e("2x")),a.2t(i.J4.o,e("1u")),a.2t(i.GW.o,e("2a"));1k(1a l=["3n","3M"],o=0;o<l.1h;o++)1c!==ZC.1d(t=i.o[l[o]])&&(i.II.1C(t),i.H7.1C(t),i.J4.1C(t),i.GW.1C(t)),1c!==ZC.1d(t=i.o[l[o]+"-1J"])&&i.II.1C(t),1c!==ZC.1d(t=i.o[l[o]+"-2x"])&&i.H7.1C(t),1c!==ZC.1d(t=i.o[l[o]+"-1u"])&&i.J4.1C(t),1c!==ZC.1d(t=i.o[l[o]+"-2a"])&&i.GW.1C(t);i.II.1q(),i.H7.1q(),i.J4.1q(),i.GW.1q()},pO:1f(){1a e=1g;e.NH={};1k(1a t,i=e.C.BK,n=0,a=i.1h;n<a;n++)(t=i[n])&&("k"===t.AF?e.NH[t.BB]={yq:t.E7,yp:t.EF,q3:t.W[t.E7],qh:t.W[t.EF],15N:t.A9,6g:[].4w(t.W)}:e.NH[t.BB]={q3:t.GV,qh:t.HF})},qc:1f(e,t){1k(1a i=1g,n=["x-1J","x-2x","y-1u","y-2a"],a=0;a<n.1h;a++)if(e){1a l=1n ZC.HQ(i.C);1P(l.K=i.C.K+"-2w-4K-"+n[a],l.A0=l.AC=i.OT.A0,l.C6=i.OT.C6,l.Z=l.C5=t||ZC.AK(i.C.K+"-2w-c"),n[a]){1j"x-1J":l.iX=i.B4.iX,l.iY=i.B4.iY,l.I=ZC.A4(i.lR).2K(ZC.1b[19]),l.F=i.B4.F;1p;1j"x-2x":l.iX=i.B4.iX+i.B4.I-ZC.A4(i.X7).2K(ZC.1b[19]),l.iY=i.B4.iY,l.I=ZC.A4(i.X7).2K(ZC.1b[19]),l.F=i.B4.F;1p;1j"y-1u":l.iX=i.B4.iX,l.iY=i.B4.iY,l.I=i.B4.I,l.F=ZC.A4(i.lS).2K(ZC.1b[20]);1p;1j"y-2a":l.iX=i.B4.iX,l.iY=i.B4.iY+i.B4.F-ZC.A4(i.VW).2K(ZC.1b[20]),l.I=i.B4.I,l.F=ZC.A4(i.VW).2K(ZC.1b[20])}l.1v()}1t ZC.P.ES(i.C.K+"-2w-4K-"+n[a]+"-2M")},1v:1f(){1a e,t=1g;t.PP=ZC.2H?40:ZC.6O?0:20;1a i,n,a,l,o,r,C,A;if(t.AL){t.Z=t.B4.Z=t.B4.C5=ZC.AK(t.C.K+"-2w-c"),t.B4.1v();1a s=ZC.AK(t.H.K+"-1u"),Z=t.C.BT("k")[0],c=t.C.BT("v")[0];if(1c===t.NH&&t.pO(),"2B"!==t.H.AB?(e=ZC.AK(t.C.K+"-2w"))&&ZC.P.PC(e,{3r:t.C.M1(0,"3a",t.B4)}):(e=ZC.AK(t.C.K+"-3r-2w-2P"))&&ZC.P.G2(e,{2S:t.C.M1(0,"2B",t.B4)}),0===t.P3&&Z&&(t.P3=ZC.BN(1,ZC.1l(2*t.B4.I/Z.W.1h)),"2W"===Z.CA&&(t.P3=ZC.BN(1,ZC.1l(t.P3/Z.EV)))),t.BW){1a u=ZC.6O?ZC.AK(t.H.K):1c;ZC.A4("."+t.C.K+"-2w-1N",u).3m();1k(1a p=[],h=0;h<t.BW.1h;h++){1a 1b=(t.BW[h].x-Z.iX)/Z.I,d=ZC.1l(t.B4.iX+1b*t.B4.I),f=1n ZC.DQ(t.C);if(f.1C({"1y-1s":1,"1y-1r":"#4J",1D:t.BW[h].1D,x:d,y:t.B4.iY}),f.1C(t.o.1G),f.1q(),f.Z=t.Z,f.IE=t.H.2L()?ZC.AK(t.H.K+"-3X"):ZC.AK(t.H.K+"-1D"),f.GG=t.K+"-1N "+t.C.K+"-2w-1N zc-2w-1N",f.K=t.K+"-1N-"+h,f.iX>=t.B4.iX&&f.iX+f.I<=t.B4.iX+t.B4.I){1k(1a g=!1,B=0;B<p.1h;B++)f.iX>p[B].x&&f.iX<p[B].x+p[B][ZC.1b[19]]&&(g=!0);!g&&f.AL&&(f.1v(),p.1i({x:f.iX,1s:f.I}));1a v=[[d,t.B4.iY],[d,t.B4.iY+t.B4.F]];a=ZC.P.E6(t.Z,t.H.AB),ZC.CN.1v(a,f,v)}}}if((Z.H1||c.H1)&&(t.KB=ZC.P.HO({2m:"zc-3i zc-2w-3M zc-2w-3M-6o "+t.C.K+"-2w-3M",id:t.K+"-3M-6o",wh:t.B4.I+"/"+t.B4.F,tl:t.B4.iY+"/"+t.B4.iX,1R:t.U4.A0,3k:t.U4.C6,4O:"8v",p:s})),Z.H1){t.lR=ZC.P.HO({2m:"zc-3i zc-2w-4K zc-2w-4K-1J "+t.C.K+"-2w-4K",id:t.K+"-4K-x-1J",wh:"0/"+t.B4.F,tl:t.B4.iY+"/"+t.B4.iX,1R:t.OT.A0,3k:t.OT.C6,p:s}),t.X7=ZC.P.HO({2m:"zc-3i zc-2w-4K zc-2w-4K-2x "+t.C.K+"-2w-4K",id:t.K+"-4K-x-2x",wh:"0/"+t.B4.F,tl:t.B4.iY+"/"+(t.B4.iX+t.B4.I),1R:t.OT.A0,3k:t.OT.C6,p:s}),i=t.II.I,n=t.II.F,t.KD=ZC.P.HO({2m:"zc-3i zc-2w-3M zc-2w-3M-1J "+t.C.K+"-2w-3M",id:t.K+"-3M-x-1J",wh:ZC.8U?1c:i+"/"+n,tl:ZC.1l(t.B4.iY+(t.B4.F-n)/4-t.PP/2)+"/"+ZC.1l(t.B4.iX-i/2-t.PP/2),c0:"10%",4O:"8v",p:s,1F:t.PP/2+"px 2R b0"});1a b=t.KD;if("2B"===t.H.AB&&!ZC.AK(t.K+"-3M-x-1J-2B")){1a E=ZC.P.F1("2B",ZC.1b[36]);ZC.P.G2(E,{af:"1.1",id:t.K+"-3M-x-1J-2B",1s:i,1L:n}),t.KD.2X(E),b=E}if(!ZC.AK(t.K+"-3M-x-1J-c")){1a m=ZC.P.H6({2m:"zc-no-6F",id:t.K+"-3M-x-1J-c",wh:i+"/"+n,p:b},t.H.AB);t.II.Z=m,t.II.K=t.K+"-3M-x-1J-c-2w",t.II.iX=0,t.II.iY=0,t.II.1v(),a=ZC.P.E6(t.H.2L()?t.H.K+"-3X-c":t.K+"-3M-x-1J-c",t.H.AB);1a K=t.II.AY,F=t.II.AQ;A=[[C=ZC.1l(i/2-K),o=F+3],[C,l=n-F-2],1c,[r=ZC.1l(i/2+K),o],[r,l]],t.II.CX=!0,ZC.CN.1v(a,t.II,A)}i=t.H7.I,n=t.H7.F,t.JR=ZC.P.HO({2m:"zc-3i zc-2w-3M zc-2w-3M-2x "+t.C.K+"-2w-3M",id:t.K+"-3M-x-2x",wh:ZC.8U?1c:i+"/"+n,tl:ZC.1l(t.B4.iY+t.B4.F-t.H7.F-(t.B4.F-n)/4-t.PP/2)+"/"+ZC.1l(t.B4.iX+t.B4.I-t.H7.I/2-t.PP/2),c0:"10%",4O:"8v",p:s,1F:t.PP/2+"px 2R b0"});1a D=t.JR;if("2B"===t.H.AB&&!ZC.AK(t.K+"-3M-x-2x-2B")){1a I=ZC.P.F1("2B",ZC.1b[36]);ZC.P.G2(I,{af:"1.1",id:t.K+"-3M-x-2x-2B",1s:i,1L:n}),t.JR.2X(I),D=I}if(!ZC.AK(t.K+"-3M-x-2x-c")){1a X=ZC.P.H6({2m:"zc-no-6F",id:t.K+"-3M-x-2x-c",wh:i+"/"+n,p:D},t.H.AB);t.H7.Z=X,t.H7.K=t.K+"-3M-x-2x-c-2w",t.H7.iX=0,t.H7.iY=0,t.H7.1v(),a=ZC.P.E6(t.H.2L()?t.H.K+"-3X-c":t.K+"-3M-x-2x-c",t.H.AB);1a x=t.H7.AY,y=t.H7.AQ;A=[[C=ZC.1l(i/2-x),o=y+3],[C,l=n-y-2],1c,[r=ZC.1l(i/2+x),o],[r,l]],t.H7.CX=!0,ZC.CN.1v(a,t.H7,A)}}if(c.H1){t.lS=ZC.P.HO({2m:"zc-3i zc-2w-4K zc-2w-4K-1u "+t.C.K+"-2w-4K",id:t.K+"-4K-x-1u",wh:t.B4.I+"/0",tl:t.B4.iY+"/"+t.B4.iX,1R:t.OT.A0,3k:t.OT.C6,p:s}),t.VW=ZC.P.HO({2m:"zc-3i zc-2w-4K zc-2w-4K-2a "+t.C.K+"-2w-4K",id:t.K+"-4K-x-2a",wh:t.B4.I+"/0",tl:t.B4.iY+t.B4.F+"/"+t.B4.iX,1R:t.OT.A0,3k:t.OT.C6,p:s}),i=t.J4.I,n=t.J4.F,t.KY=ZC.P.HO({2m:"zc-3i zc-2w-3M zc-2w-3M-1u "+t.C.K+"-2w-3M",id:t.K+"-3M-y-1u",wh:ZC.8U?1c:i+"/"+n,tl:ZC.1l(t.B4.iY-n/2-t.PP/2)+"/"+ZC.1l(t.B4.iX+(t.B4.I-i)/4-t.PP/2),c0:"10%",4O:"8v",p:s,1F:t.PP/2+"px 2R b0"});1a L=t.KY;if("2B"===t.H.AB&&!ZC.AK(t.K+"-3M-y-1u-2B")){1a Y=ZC.P.F1("2B",ZC.1b[36]);ZC.P.G2(Y,{af:"1.1",id:t.K+"-3M-y-1u-2B",1s:i,1L:n}),t.KY.2X(Y),L=Y}if(!ZC.AK(t.K+"-3M-y-1u-c")){1a w=ZC.P.H6({2m:"zc-no-6F",id:t.K+"-3M-y-1u-c",wh:i+"/"+n,p:L},t.H.AB);t.J4.Z=w,t.J4.K=t.K+"-3M-y-1u-c-2w",t.J4.iX=0,t.J4.iY=0,t.J4.1v(),a=ZC.P.E6(t.H.2L()?t.H.K+"-3X-c":t.K+"-3M-y-1u-c",t.H.AB);1a M=t.J4.AY,H=t.J4.AQ;l=ZC.1l(n/2-M),A=[[C=i-H-2,o=ZC.1l(n/2+M)],[r=H+3,o],1c,[C,l],[r,l]],t.J4.CX=!0,ZC.CN.1v(a,t.J4,A)}i=t.GW.I,n=t.GW.F,t.J8=ZC.P.HO({2m:"zc-3i zc-2w-3M zc-2w-3M-2a "+t.C.K+"-2w-3M",id:t.K+"-3M-y-2a",wh:ZC.8U?1c:i+"/"+n,tl:ZC.1l(t.B4.iY+t.B4.F-t.GW.F/2-t.PP/2)+"/"+ZC.1l(t.B4.iX+t.B4.I-t.GW.I-(t.B4.I-i)/4-t.PP/2),c0:"10%",4O:"8v",p:s,1F:t.PP/2+"px 2R b0"});1a N=t.J8;if("2B"===t.H.AB&&!ZC.AK(t.K+"-3M-y-2a-2B")){1a S=ZC.P.F1("2B",ZC.1b[36]);ZC.P.G2(S,{af:"1.1",id:t.K+"-3M-y-2a-2B",1s:i,1L:n}),t.J8.2X(S),N=S}if(!ZC.AK(t.K+"-3M-y-2a-c")){1a O=ZC.P.H6({2m:"zc-no-6F",id:t.K+"-3M-y-2a-c",wh:i+"/"+n,p:N},t.H.AB);t.GW.Z=O,t.GW.K=t.K+"-3M-y-2a-c-2w",t.GW.iX=0,t.GW.iY=0,t.GW.1v(),a=ZC.P.E6(t.H.2L()?t.H.K+"-3X-c":t.K+"-3M-y-2a-c",t.H.AB);1a P=t.GW.AY,k=t.GW.AQ;l=ZC.1l(n/2-P),A=[[C=i-k-2,o=ZC.1l(n/2+P)],[r=k+3,o],1c,[C,l],[r,l]],t.GW.CX=!0,ZC.CN.1v(a,t.GW,A)}}if(t.JN=0,t.HY=t.B4.I,t.MM=0,t.IQ=t.B4.F,Z.H1&&t.lN){1a G=Z.X,z=Z.A1;Z.FD&&"5z"===Z.FD.o.1I&&(G=Z.G0(Z.X,1c,1c).1E(/<br>/g," "),z=Z.G0(Z.A1,1c,1c).1E(/<br>/g," ")),t.QY=ZC.P.HO({2m:"zc-3i zc-2w-1G "+t.C.K+"-2w-1G",id:t.K+"-2h-1G",1R:t.J0.A0,3k:t.J0.C6,6U:t.J0.GB,6S:t.J0.DG,6R:t.J0.7C,1r:t.J0.BZ,3u:0,4a:G+"",p:s}),t.QY.1H.1J=t.B4.iX+"px",t.QY.1H.1u=t.B4.iY+t.B4.F+"px",t.R0=ZC.P.HO({2m:"zc-3i zc-2w-1G "+t.C.K+"-2w-1G",id:t.K+"-1V-1G",1R:t.J0.A0,3k:t.J0.C6,6U:t.J0.GB,6S:t.J0.DG,6R:t.J0.7C,1r:t.J0.BZ,3u:0,4a:z+"",p:s}),t.R0.1H.1J=t.B4.iX+t.B4.I+"px",t.R0.1H.1u=t.B4.iY+t.B4.F+"px",t.JN>ZC.A4(t.QY).1s()?t.QY.1H.1J=t.B4.iX+t.JN-ZC.A4(t.QY).1s()+"px":t.QY.1H.1J=t.B4.iX+"px",t.B4.I-t.HY>ZC.A4(t.R0).1s()?t.R0.1H.1J=t.B4.iX+t.HY+"px":t.R0.1H.1J=t.B4.iX+t.HY-ZC.A4(t.R0).1s()+"px"}t.3p(),t.BW&&(t.BW=[])}},jv:1f(){1a e=1g,t=e.C.BT("k")[0],i=e.C.BT("v",!0)[0];i||(i=e.C.BT("v")[0]),t&&i&&e.3O(t.E7,t.EF,i.GV,i.HF,!0)},3O:1f(e,t,i,n,a){1c===ZC.1d(a)&&(a=!1);1a l=1g;if(a||(e>=t&&(e=t-1),i>=n&&(i=n-1)),l.AL){1a o=l.C.BT("k")[0],r=l.C.BT("v",!0)[0];r||(r=l.C.BT("v")[0]);1a C=!0;if(a)o&&r&&(1c===ZC.1d(e)&&(e=o.X),1c===ZC.1d(t)&&(t=o.A1),1c===ZC.1d(i)&&(i=r.7I[0]?r.GV:r.B8),1c===ZC.1d(n)&&(n=r.7I[1]?r.HF:r.BS),l.3O((e-o.E7)*l.B4.I/(o.EF-o.E7),(t-o.E7)*l.B4.I/(o.EF-o.E7),l.B4.F-(n-r.GV)*l.B4.F/(r.HF-r.GV),l.B4.F-(i-r.GV)*l.B4.F/(r.HF-r.GV)));1t if(t-e<l.P3&&(l.GY===l.JR?t=e+l.P3:l.GY===l.KD&&(e=t-l.P3)),n-i<l.ZX&&(l.GY===l.J8?n=i+l.ZX:l.GY===l.KY&&(i=n-l.ZX)),e>t&&(l.GY===l.KD?l.3O(t-1,t,i,n):l.GY===l.JR&&l.3O(e,e+1,i,n),C=!1),e<0&&(l.GY===l.KD?l.3O(0,t,i,n):l.GY===l.KB&&l.3O(0,ZC.A4(l.KB).1s(),i,n),C=!1),t>l.B4.I&&(l.GY===l.JR?l.3O(e,l.B4.I,i,n):l.GY===l.KB&&l.3O(l.B4.I-ZC.A4(l.KB).1s(),l.B4.I,i,n),C=!1),i>n&&(l.GY===l.KY?l.3O(e,t,i-1,n):l.GY===l.J8&&l.3O(e,t,i,n+1),C=!1),i<0&&(l.GY===l.KY?l.3O(e,t,0,n):l.GY===l.KB&&l.3O(e,t,0,ZC.A4(l.KB).1L()),C=!1),n>l.B4.F&&(l.GY===l.J8?l.3O(e,t,i,l.B4.F):l.GY===l.KB&&l.3O(e,t,l.B4.F-ZC.A4(l.KB).1L(),l.B4.F),C=!1),C){if(o&&o.Y5){1a A=l.B4.I/(o.W.1h-(o.DK?0:1));e=A*1A.43(e/A),t=ZC.CV(A*1A.43(t/A),l.B4.I)}l.JN=e,l.HY=t,l.MM=i,l.IQ=n,o.H1&&(l.KD.1H.1J=ZC.1l(l.B4.iX+l.JN-l.II.I/2-l.PP/2)+"px",l.lR.1H.1s=ZC.1l(l.JN)+"px",l.JR.1H.1J=ZC.1l(l.B4.iX+l.HY-l.H7.I/2-l.PP/2)+"px",l.X7.1H.1J=ZC.1l(l.B4.iX+l.HY)+"px",l.X7.1H.1s=ZC.1l(l.B4.I-l.HY)+"px"),r.H1&&(l.KY.1H.1u=ZC.1l(l.B4.iY+l.MM-l.J4.F/2-l.PP/2)+"px",l.lS.1H.1L=ZC.1l(l.MM)+"px",l.J8.1H.1u=ZC.1l(l.B4.iY+l.IQ-l.GW.F/2-l.PP/2)+"px",l.VW.1H.1u=ZC.1l(l.B4.iY+l.IQ)+"px",l.VW.1H.1L=ZC.1l(l.B4.F-l.IQ)+"px"),(o.H1||r.H1)&&(l.KB.1H.1J=ZC.1l(l.B4.iX+l.JN)+"px",l.KB.1H.1s=ZC.1l(l.HY-l.JN)+"px",l.KB.1H.1u=ZC.1l(l.B4.iY+l.MM)+"px",l.KB.1H.1L=ZC.1l(l.IQ-l.MM)+"px"),l.q4&&l.J6&&(l.C.O6=!0,l.3C(!0)),o.H1&&l.lN&&(o.FD&&"5z"===o.FD.o.1I?(l.QY.4n=o.G0(o.X,1c,1c).1E(/<br>/g," "),l.R0.4n=o.G0(o.A1,1c,1c).1E(/<br>/g," ")):(l.QY.4n=o.X,l.R0.4n=o.A1),l.JN>ZC.A4(l.QY).1s()?l.QY.1H.1J=l.B4.iX+l.JN-ZC.A4(l.QY).1s()+"px":l.QY.1H.1J=l.B4.iX+"px",l.B4.I-l.HY>ZC.A4(l.R0).1s()?l.R0.1H.1J=l.B4.iX+l.HY+"px":l.R0.1H.1J=l.B4.iX+l.HY-ZC.A4(l.R0).1s()+"px")}}},3C:1f(e){1k(1a t,i=1g,n={4u:i.C.K,2w:1,aw:i.LH,h8:!0,cj:e},a=i.C.BK,l=i.C.BT("k")[0],o=i.C.BT("v")[0],r=0,C=a.1h;r<C;r++)if(t=a[r]){1a A=1===t.L?"":"-"+t.L;if("k"===t.AF){if(l.H1){1a s=i.LH?i.NH[t.BB].yq:t.E7,Z=i.LH?i.NH[t.BB].yp:t.EF;n["7L"+A]=!0,n["4r"+A]=ZC.1l(i.JN/i.B4.I*(Z-s)),n["4m"+A]=ZC.1l(i.HY/i.B4.I*(Z-s))}}1t if(o.H1){1a c=i.LH?i.NH[t.BB].q3:t.GV,u=i.LH?i.NH[t.BB].qh:t.HF;n["7P"+A]=!0,n["5s"+A]=c+(i.B4.F-i.IQ)/i.B4.F*(u-c),n["5r"+A]=c+(i.B4.F-i.MM)/i.B4.F*(u-c)}}i.H.PQ(n)},3h:1f(){1a e=1g;ZC.A4("."+e.C.K+"-2w-3M").3h("6I 4D",e.YE),ZC.A4("."+e.C.K+"-2w-4K").3h("3F",e.qk),ZC.A4(2e.3o).3h("7R 6k",e.US),ZC.A4(2e.3o).3h("6f 5P",e.VJ),e.lO=!1},3p:1f(){1a e=1g;if(!e.lO){1a t=e.H.K,i=0,n=0;e.qk=1f(i){if(i.6L(),e.H.H3){e.H.H3.C=e.C,e.H.H3.1q();1a n=ZC.P.M8(i),a=ZC.A4("#"+t+"-1u").1Y();if(-1!==i.2T.id.1K("2w-4K-x-1J")||-1!==i.2T.id.1K("2w-4K-x-2x")){1a l=n[0]-a.1J-e.B4.iX,o=e.HY-e.JN;l-o/2<0?(e.JN=0,e.HY=o):l+o/2>e.B4.I?(e.JN=e.B4.I-o,e.HY=e.B4.I):(e.JN=ZC.1l(l-o/2),e.HY=ZC.1l(l+o/2))}1t{1a r=n[1]-a.1u-e.B4.iY,C=e.IQ-e.MM;r-C/2<0?(e.MM=0,e.IQ=C):r+C/2>e.B4.F?(e.MM=e.B4.F-C,e.IQ=e.B4.F):(e.MM=ZC.1l(r-C/2),e.IQ=ZC.1l(r+C/2))}1m e.J6=!1,e.C.O6=!1,e.3O(e.JN,e.HY,e.MM,e.IQ),e.3C(!1),!1}},e.YE=1f(a){if(a.6L(),e.H.H3){e.H.H3.C=e.C,e.H.H3.1q();1k(1a l=a.2T;l&&"lE"!==l.8h.5D()&&-1===ZC.P.SW(l).1K("zc-2w-3M");)l=l.6s;if((ZC.2H||!(a.8T>1))&&l){1a o=ZC.P.M8(a),r=ZC.ak(e.H.K),C=ZC.A4("#"+t+"-1u").1Y(),A=(o[0]-C.1J)/r[0]-e.B4.iX,s=(o[1]-C.1u)/r[1]-e.B4.iY;1m-1!==l.id.1K("3M-x-1J")?e.GY=e.KD:-1!==l.id.1K("3M-x-2x")?e.GY=e.JR:-1!==l.id.1K("3M-y-1u")?e.GY=e.KY:-1!==l.id.1K("3M-y-2a")?e.GY=e.J8:-1!==l.id.1K("3M-6o")&&(e.GY=e.KB,i=A-e.JN,n=s-e.MM),ZC.A4(2e.3o).3p("7R 6k",e.US),ZC.A4(2e.3o).3p("6f 5P",e.VJ),e.J6=!0,e.h4=!1,!1}}},e.US=1f(a){if(e.J6){e.h4=!0,1o.3j(e.H.K,"qx",{4B:"8F,8u"});1a l=ZC.ak(e.H.K),o=ZC.P.M8(a),r=ZC.A4("#"+t+"-1u").1Y(),C=(o[0]-r.1J)/l[0]-e.B4.iX,A=(o[1]-r.1u)/l[1]-e.B4.iY;e.GY===e.KD?e.3O(C,e.HY,e.MM,e.IQ):e.GY===e.JR?e.3O(e.JN,C,e.MM,e.IQ):e.GY===e.KY?e.3O(e.JN,e.HY,A,e.IQ):e.GY===e.J8?e.3O(e.JN,e.HY,e.MM,A):e.GY===e.KB&&e.3O(C-i,C-i+ZC.A4(e.KB).1s(),A-n,A-n+ZC.A4(e.KB).1L())}1m!1},e.VJ=1f(){1m 1o.3j(e.H.K,"qx",{4B:""}),e.J6&&(ZC.A4(2e.3o).3h("7R 6k",e.US),ZC.A4(2e.3o).3h("6f 5P",e.VJ),e.J6=!1,e.C.O6=!1,e.h4&&e.3C(!1),e.h4=!1),!1},ZC.A4("."+e.C.K+"-2w-3M").3p("6I 4D",e.YE),ZC.A4("."+e.C.K+"-2w-4K").3p("3F",e.qk),e.lO=!0}},gc:1f(){ZC.AO.gc(1g,["Z","C5","o","HU","JO","C","H","B4","U4","KD","JR","KY","J8","KB","J4","H7","GW","II","9G","OT","lR","X7","lS","VW"])}}),ZC.hG=ZC.CZ.C7({$i:1f(e,t){1g.b(e);1a i=1g;i.C=e,i.H=e.A,i.J6=!1,i.Z=1c,i.BJ=0,i.BD=0,i.hy="",i.d2="yx"===i.C.AJ.3t,i.AF=i.hA=i.yh="1X-"+(t||"x"),i.d2&&(i.AF+="i",i.hA="1X-xi"===i.AF?"1X-y":"1X-x")},1q:1f(){1a e,t=1g;t.K=t.C.K+"-"+t.hA,t.4y([["1Y-x","BJ"],["1Y-y","BD"]]);1a i="("+t.C.AF+").",n=t.H.B9;t.AZ=1n ZC.HQ(t.C),n.2t(t.AZ.o,[i+"1X.2Q",i+t.AF+".2Q"]),1c!==ZC.1d(e=t.o.2Q)&&t.AZ.1C(e),t.AZ.1q(),t.AW=1n ZC.HQ(t.C),n.2t(t.AW.o,[i+"1X.3n",i+t.AF+".3n"]),1c!==ZC.1d(e=t.o.3n)&&t.AW.1C(e),t.AW.1q()},1v:1f(){1a e=1g,t=e.C.BT("k")[0],i=e.C.BT("v")[0],n=e.C.Q;if(("1X-x"===e.AF||"1X-xi"===e.AF)&&t.E7===t.X&&t.EF===t.A1||("1X-y"===e.AF||"1X-yi"===e.AF)&&i.GV===i.B8&&i.HF===i.BS)1m e.3h(),ZC.A4("#"+e.C.K+"-"+e.AF+"-3n").3m(),ZC.A4("#"+e.C.K+"-"+e.AF+"-2Q").3m(),8j ZC.P.IL(e.Z,e.H.AB,e.C.iX,e.C.iY,e.C.I,e.C.F);e.Z=ZC.AK(e.C.K+"-"+e.yh+"-c");1a a=ZC.AK(e.H.K+"-1u");"1X-x"===e.AF||"1X-yi"===e.AF?(e.AZ.iX=n.iX+e.BJ,e.AZ.iY=n.iY+n.F+t.AY-1+e.BD,e.AZ.I=n.I,e.d2?(e.AW.I=ZC.1l(ZC.BN(4,e.AZ.I*((i.BS-i.B8)/(i.HF-i.GV)))),i.GV===i.B8?i.AR?e.AW.iX=e.AZ.iX+e.AZ.I-e.AW.I:e.AW.iX=e.AZ.iX:i.HF===i.BS?i.AR?e.AW.iX=e.AZ.iX:e.AW.iX=e.AZ.iX+e.AZ.I-e.AW.I:i.AR?e.AW.iX=ZC.1l(e.AZ.iX+e.AZ.I-e.AW.I-e.AZ.I*(i.B8-i.GV)/(i.HF-i.GV)):e.AW.iX=ZC.1l(e.AZ.iX+e.AZ.I*(i.B8-i.GV)/(i.HF-i.GV))):(e.AW.I=ZC.1l(ZC.BN(4,e.AZ.I*((t.A1-t.X)/(t.EF-t.E7)))),t.E7===t.X?t.AR?e.AW.iX=e.AZ.iX+e.AZ.I-e.AW.I:e.AW.iX=e.AZ.iX:t.EF===t.A1?t.AR?e.AW.iX=e.AZ.iX:e.AW.iX=e.AZ.iX+e.AZ.I-e.AW.I:t.AR?e.AW.iX=ZC.1l(e.AZ.iX+e.AZ.I-e.AW.I-e.AZ.I*(t.X-t.E7)/(t.EF-t.E7)):e.AW.iX=ZC.1l(e.AZ.iX+e.AZ.I*(t.X-t.E7)/(t.EF-t.E7))),ZC.AK(e.K+"-3n")?(ZC.A4("#"+e.K+"-3n").2K("1J",e.AW.iX+"px").2K(ZC.1b[19],ZC.BN(15,e.AW.I-0*e.AW.AQ)+"px"),e.6E()):(e.yT=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-x-2Q "+e.C.K+"-1X-x-2Q",id:e.K+"-2Q",wh:e.AZ.I+"/"+e.AZ.F,tl:e.AZ.iY+"/"+e.AZ.iX,3k:0,p:a}),e.Z3=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-x-3n "+e.C.K+"-1X-x-3n",id:e.K+"-3n",wh:ZC.BN(15,e.AW.I+4)+"/"+e.AZ.F,tl:e.AZ.iY+"/"+(e.AW.iX-2),1R:"#2O",3k:0,p:a}),e.Z3.1H.4O="8v",e.6E(),e.J6||e.3p())):(e.AZ.iX=n.iX-e.AZ.I-1+e.BJ,e.AZ.iY=n.iY+e.BD,e.AZ.F=n.F,e.d2?(e.AW.F=ZC.1l(ZC.BN(4,e.AZ.F*((t.A1-t.X)/(t.EF-t.E7)))),t.E7===t.X?t.AR?e.AW.iY=e.AZ.iY:e.AW.iY=e.AZ.iY+e.AZ.F-e.AW.F:t.EF===t.A1?t.AR?e.AW.iY=e.AZ.iY+e.AZ.F-e.AW.F:e.AW.iY=e.AZ.iY:t.AR?e.AW.iY=ZC.1l(e.AZ.iY+e.AZ.F*(t.X-t.E7)/(t.EF-t.E7)):e.AW.iY=ZC.1l(e.AZ.iY+e.AZ.F-e.AW.F-e.AZ.F*(t.X-t.E7)/(t.EF-t.E7))):(e.AW.F=ZC.1l(ZC.BN(4,e.AZ.F*((i.BS-i.B8)/(i.HF-i.GV)))),i.GV===i.B8?i.AR?e.AW.iY=e.AZ.iY:e.AW.iY=e.AZ.iY+e.AZ.F-e.AW.F:i.HF===i.BS?i.AR?e.AW.iY=e.AZ.iY+e.AZ.F-e.AW.F:e.AW.iY=e.AZ.iY:i.AR?e.AW.iY=ZC.1l(e.AZ.iY+e.AZ.F*(i.B8-i.GV)/(i.HF-i.GV)):e.AW.iY=ZC.1l(e.AZ.iY+e.AZ.F-e.AW.F-e.AZ.F*(i.B8-i.GV)/(i.HF-i.GV))),ZC.AK(e.K+"-3n")?(ZC.A4("#"+e.K+"-3n").2K("1u",e.AW.iY+"px").2K(ZC.1b[20],ZC.BN(15,e.AW.F-0*e.AW.AQ)+"px"),e.6E()):(e.yG=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-y-2Q "+e.C.K+"-1X-y-2Q",id:e.K+"-2Q",wh:e.AZ.I+"/"+e.AZ.F,tl:e.AZ.iY+"/"+e.AZ.iX,3k:0,p:a}),e.Z1=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-y-3n "+e.C.K+"-1X-y-3n",id:e.K+"-3n",wh:e.AZ.I+"/"+ZC.BN(15,e.AW.F+4),tl:e.AW.iY-2+"/"+e.AZ.iX,1R:"#2O",3k:0,p:a}),e.Z1.1H.4O="8v",e.6E(),e.J6||e.3p()))},3C:1f(e){1k(1a t,i,n,a=1g,l={4u:a.C.K,cj:e,1X:!0},o=a.C.BK,r=a.C.BT("k")[0],C=a.C.BT("v")[0],A=0,s=o.1h;A<s;A++)if(t=o[A]){1a Z=1===t.L?"":"-"+t.L;if(r.H1&&"1X-x"===a.AF&&"k"===t.AF&&!a.d2){1a c=t.A1-t.X;l["7L"+Z]=!0,i=(a.AW.iX-a.AZ.iX)/a.AZ.I,n=(a.AW.iX-a.AZ.iX+a.AW.I)/a.AZ.I,r.AR?(l["4r"+Z]=t.EF-ZC.1l(n*(t.EF-t.E7)),l["4m"+Z]=t.EF-ZC.1l(i*(t.EF-t.E7))):(l["4r"+Z]=t.E7+ZC.1l(i*(t.EF-t.E7)),l["4m"+Z]=t.E7+ZC.1l(n*(t.EF-t.E7))),l["4m"+Z]-l["4r"+Z]!==c&&(l["4m"+Z]===t.EF?l["4r"+Z]=l["4m"+Z]-c:l["4m"+Z]=l["4r"+Z]+c)}1t C.H1&&"1X-y"===a.AF&&"v"===t.AF&&!a.d2?(l["7P"+Z]=!0,i=(a.AZ.F-(a.AW.iY-a.AZ.iY+a.AW.F))/a.AZ.F,n=(a.AZ.F-(a.AW.iY-a.AZ.iY))/a.AZ.F,C.AR?(l["5s"+Z]=t.HF-ZC.1W(n*(t.HF-t.GV)),l["5r"+Z]=t.HF-ZC.1W(i*(t.HF-t.GV))):(l["5s"+Z]=t.GV+ZC.1W(i*(t.HF-t.GV)),l["5r"+Z]=t.GV+ZC.1W(n*(t.HF-t.GV)))):r.H1&&"1X-xi"===a.AF&&"k"===t.AF&&a.d2?(l["7L"+Z]=!0,i=(a.AZ.F-a.AW.iY+a.AZ.iY-a.AW.F)/a.AZ.F,n=(a.AZ.F-a.AW.iY+a.AZ.iY)/a.AZ.F,r.AR?(l["4r"+Z]=t.EF-ZC.1l(n*(t.EF-t.E7)),l["4m"+Z]=t.EF-ZC.1l(i*(t.EF-t.E7))):(l["4r"+Z]=t.E7+ZC.1l(i*(t.EF-t.E7)),l["4m"+Z]=t.E7+ZC.1l(n*(t.EF-t.E7)))):C.H1&&"1X-yi"===a.AF&&"v"===t.AF&&a.d2&&(l["7P"+Z]=!0,i=(a.AW.iX-a.AZ.iX)/a.AZ.I,n=(a.AW.iX-a.AZ.iX+a.AW.I)/a.AZ.I,C.AR?(l["5s"+Z]=t.HF-ZC.1W(n*(t.HF-t.GV)),l["5r"+Z]=t.HF-ZC.1W(i*(t.HF-t.GV))):(l["5s"+Z]=t.GV+ZC.1W(i*(t.HF-t.GV)),l["5r"+Z]=t.GV+ZC.1W(n*(t.HF-t.GV))))}a.H.PQ(l)},6E:1f(){1a e,t,i=1g;ZC.P.IL(i.Z,i.H.AB,i.C.iX,i.C.iY,i.C.I,i.C.F),"1X-x"===i.AF||"1X-yi"===i.AF?((e=1n ZC.HQ(i)).K=i.C.K+"-1X-x-2Q",e.1Q(i.AZ),e.Z=e.C5=i.Z,e.iX=i.AZ.iX,e.iY=i.AZ.iY,e.I=i.AZ.I,e.F=i.AZ.F,e.1v(),(t=1n ZC.HQ(i)).K=i.C.K+"-1X-x-3n",t.1Q(i.AW),t.Z=t.C5=i.Z,t.iX=i.AW.iX,t.iY=i.AZ.iY+(i.AZ.F-i.AW.F)/2-1,t.I=ZC.BN(15,i.AW.I),t.iX+t.I>i.C.Q.iX+i.C.Q.I&&(t.iX=i.C.Q.iX+i.C.Q.I-t.I),t.iX<i.C.Q.iX&&(t.iX=i.C.Q.iX),t.F=i.AW.F,t.1v(),ZC.A4("#"+i.K+"-3n").2K("1J",t.iX+"px")):((e=1n ZC.HQ(i)).K=i.C.K+"-1X-y-2Q",e.1Q(i.AZ),e.Z=e.C5=i.Z,e.iX=i.AZ.iX,e.iY=i.AZ.iY,e.I=i.AZ.I,e.F=i.AZ.F,e.1v(),(t=1n ZC.HQ(i)).K=i.C.K+"-1X-y-3n",t.1Q(i.AW),t.Z=t.C5=i.Z,t.iX=i.AZ.iX+(i.AZ.I-i.AW.I)/2,t.iY=i.AW.iY,t.I=i.AW.I,t.F=ZC.BN(15,i.AW.F),t.iY+t.F>i.C.Q.iY+i.C.Q.F&&(t.iY=i.C.Q.iY+i.C.Q.F-t.F),t.iY<i.C.Q.iY&&(t.iY=i.C.Q.iY),t.1v(),ZC.A4("#"+i.K+"-3n").2K("1u",t.iY+"px"))},h3:1f(e){1a t=1g;if(t.C.O6=e,t.C.H3&&ZC.2q(t.C.H3.o.6a))1k(1a i=0;i<t.H.AI.1h;i++)t.H.AI[i].H3&&ZC.2q(t.H.AI[i].H3.o.6a)&&(t.H.AI[i].O6=e)},3O:1f(e){1a t=1g;"1X-x"===t.AF||"1X-yi"===t.AF?(t.AW.iX=e,ZC.A4("#"+t.K+"-3n").2K("1J",e+"px"),t.6E()):(t.AW.iY=e,ZC.A4("#"+t.K+"-3n").2K("1u",e+"px"),t.6E()),t.J6&&(t.h3(!0),t.3C(!0))},3h:1f(){1a e=1g;ZC.A4("."+e.C.K+"-"+e.AF+"-3n").3h("6I 4D",e.R7),ZC.A4("."+e.C.K+"-"+e.AF+"-2Q").3h("3F",e.R8)},g6:1f(e){1a t=1g,i=t.C.HX();i.1I=e,ZC.AO.C2("g6",t.H,i)},3p:1f(){1a e=1g,t=e.H.K,i=0,n=0;e.R7=1f(a){if(a.6L(),!(a.76>1)&&(e.hy=e.H.KL.2I(","),e.H.KL.1i(ZC.1b[38],"yt",ZC.1b[39],ZC.1b[40],ZC.1b[41]),e.H.H3)){e.H.H3.C=e.C,e.H.H3.1q();1k(1a l=a.2T;l&&"lE"!==l.8h.5D()&&-1===ZC.P.SW(l).1K("zc-"+e.AF+"-3n");)l=l.6s;if((ZC.2H||!(a.8T>1))&&l){1a o=ZC.P.M8(a),r=ZC.A4("#"+t+"-1u").1Y();if("1X-x"===e.AF||"1X-yi"===e.AF){1a C=o[0]-r.1J;i=C-e.AW.iX}1t{1a A=o[1]-r.1u;n=A-e.AW.iY}1m ZC.A4(2e.3o).3p("7R 6k",e.R9),ZC.A4(2e.3o).3p("6f 5P",e.ND),e.J6=!0,!1}}},e.R9=1f(a){if(e.J6){e.h3(!1);1a l=ZC.P.M8(a),o=ZC.A4("#"+t+"-1u").1Y();if("1X-x"===e.AF||"1X-yi"===e.AF){1a r=l[0]-o.1J;r-i<e.AZ.iX&&(r<e.AZ.iX-15&&e.g6("1X-x-1J"),r=e.AZ.iX+i),r-i+e.AW.I>e.AZ.iX+e.AZ.I&&(r>e.AZ.iX+e.AZ.I+15&&e.g6("1X-x-2x"),r=e.AZ.iX+e.AZ.I+i-e.AW.I),e.3O(r-i)}1t{1a C=l[1]-o.1u;C-n<e.AZ.iY&&(C<e.AZ.iY-15&&e.g6("1X-y-1u"),C=e.AZ.iY+n),C-n+e.AW.F>e.AZ.iY+e.AZ.F&&(C>e.AZ.iY+e.AZ.F+15&&e.g6("1X-y-2a"),C=e.AZ.iY+e.AZ.F+n-e.AW.F),e.3O(C-n)}}1m!1},e.ND=1f(t){1m e.H.KL=e.hy.2l(","),e.J6&&(ZC.A4(2e.3o).3h("7R 6k",e.R9),ZC.A4(2e.3o).3h("6f 5P",e.ND),e.J6=!1,e.h3(!1),t&&e.3C(!1)),!1},e.R8=1f(i){e.J6=!1,e.h3(!1);1a n=ZC.P.M8(i),a=ZC.A4("#"+t+"-1u").1Y();"1X-x"===e.AF||"1X-yi"===e.AF?n[0]-a.1J>e.AW.iX?e.3O(ZC.CV(e.AZ.iX+e.AZ.I-e.AW.I-2*e.AW.AQ,e.AW.iX+(n[0]-a.1J-e.AW.iX)/4)):e.3O(ZC.BN(e.AZ.iX,n[0]-a.1J+(e.AW.iX-n[0]+a.1J-e.AW.I)/4)):n[1]-a.1u>e.AW.iY?e.3O(ZC.CV(e.AZ.iY+e.AZ.F-e.AW.F-2*e.AW.AQ,e.AW.iY+(n[1]-a.1u-e.AW.iY)/4)):e.3O(ZC.BN(e.AZ.iY,n[1]-a.1u+(e.AW.iY-n[1]+a.1u-e.AW.F)/4)),e.3C(!1)},ZC.A4("."+e.C.K+"-"+e.hA+"-3n").3p("6I 4D",e.R7),ZC.A4("."+e.C.K+"-"+e.hA+"-2Q").3p("3F",e.R8)}}),ZC.rz=ZC.CZ.C7({$i:1f(e,t){1g.b(e);1a i=1g;i.BC=e,i.J6=!1,i.Z=1c,i.hy="",i.KP=1,i.GT=1,i.AF="1X-"+(t||"y")},1q:1f(){1a e,t=1g;t.K=t.BC.K+"-1U-"+t.AF;1a i=t.BC.A.H.B9,n="("+t.BC.A.AF+")";t.AZ=1n ZC.HQ(t.BC),i.2t(t.AZ.o,[n+".1U.1X.2Q",t.AF+".2Q"]),1c!==ZC.1d(e=t.o.2Q)&&t.AZ.1C(e),t.AZ.1q(),t.AW=1n ZC.HQ(t.BC),i.2t(t.AW.o,[n+".1U.1X.3n",t.AF+".3n"]),1c!==ZC.1d(e=t.o.3n)&&t.AW.1C(e),t.AW.1q()},1v:1f(){1a e,t=1g;if(!t.J6){t.Z=ZC.AK(t.BC.A.K+"-1U-1X-c");1a i=ZC.AK(t.H.K+"-1u");"1X-y"===t.AF?(t.AZ.iX=t.BC.iX+t.BC.I-t.AZ.I-1,t.AZ.iY=t.BC.EJ,t.AZ.F=t.BC.F-(t.BC.KG?t.BC.KG.F:0)-(t.BC.EJ-t.BC.iY),e=1A.4h(t.BC.B5.1h/t.GT-t.BC.EE/t.GT)+1,t.AW.F=t.AZ.F/e,t.AW.iY=t.AZ.iY,0!==t.BC.D2.2h&&(t.AW.iY+=t.BC.D2.2h/t.GT*t.AW.F),ZC.AK(t.K+"-1U-3n")?(ZC.A4("#"+t.K+"-1U-3n").2K("1J",t.AZ.iX+"px").2K("1u",t.AW.iY+"px").2K(ZC.1b[20],t.AW.F-0*t.AW.AQ+"px"),ZC.A4("#"+t.K+"-1U-2Q").2K("1J",t.AZ.iX+"px").2K("1u",t.AZ.iY+"px"),ZC.A4("#"+t.BC.K+"-9S").2K("1J",t.BC.iX+"px").2K("1u",t.BC.EJ+"px"),t.6E()):(t.yG=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-y-2Q "+t.BC.K+"-1X-y-1U-2Q",id:t.K+"-1U-2Q",wh:t.AZ.I+"/"+t.AZ.F,tl:t.AZ.iY+"/"+t.AZ.iX,1R:"#2O",3k:0,8s:1,p:i}),t.Z1=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-y-3n "+t.BC.K+"-1X-y-1U-3n",id:t.K+"-1U-3n",wh:t.AZ.I-0*t.AW.AQ+"/"+(t.AW.F-0*t.AW.AQ),tl:t.AW.iY+"/"+t.AZ.iX,1R:"#2O",3k:0,8s:1,p:i}),t.Z1.1H.4O="8v",t.6E())):"1X-x"===t.AF&&(t.AZ.iX=t.BC.iX,t.AZ.iY=t.BC.iY+t.BC.F-t.AZ.F-1,t.AZ.I=t.BC.I,e=1A.4h(t.BC.B5.1h/t.KP-t.BC.EE/t.KP)+1,t.AW.I=t.AZ.I/e,t.AW.iX=t.AZ.iX,0!==t.BC.D2.2h&&(t.AW.iX+=t.BC.D2.2h/t.KP*t.AW.I),ZC.AK(t.K+"-1U-3n")?(ZC.A4("#"+t.K+"-1U-3n").2K("1J",t.AW.iX+"px").2K("1u",t.AZ.iY+"px").2K(ZC.1b[19],t.AW.I-0*t.AW.AQ+"px"),ZC.A4("#"+t.K+"-1U-2Q").2K("1J",t.AZ.iX+"px").2K("1u",t.AZ.iY+"px"),ZC.A4("#"+t.BC.K+"-9S").2K("1J",t.BC.iX+"px").2K("1u",t.BC.EJ+"px"),t.6E()):(t.yT=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-x-2Q "+t.BC.K+"-1X-x-1U-2Q",id:t.K+"-1U-2Q",wh:t.AZ.I+"/"+t.AZ.F,tl:t.AZ.iY+"/"+t.AZ.iX,1R:"#2O",3k:0,8s:1,p:i}),t.Z3=ZC.P.HO({2m:"zc-3i zc-1X zc-1X-x-3n "+t.BC.K+"-1X-x-1U-3n",id:t.K+"-1U-3n",wh:t.AW.I-0*t.AW.AQ+"/"+(t.AZ.F-0*t.AW.AQ),tl:t.AZ.iY+"/"+t.AW.iX,1R:"#2O",3k:0,8s:1,p:i}),t.Z3.1H.4O="8v",t.6E())),ZC.3l||t.3p()}},6E:1f(){1a e,t,i=1g;"1X-y"===i.AF?((e=1n ZC.HQ(i)).K=i.BC.K+"-1X-y-1U-2Q",e.1Q(i.AZ),e.Z=i.Z,e.iX=i.AZ.iX,e.iY=i.AZ.iY,e.I=i.AZ.I,e.F=i.AZ.F,e.1v(),(t=1n ZC.HQ(i)).K=i.BC.K+"-1X-y-1U-3n",t.1Q(i.AW),t.Z=i.Z,t.iX=i.AZ.iX,t.iY=i.AW.iY,t.I=i.AW.I,t.F=i.AW.F,t.1v()):"1X-x"===i.AF&&((e=1n ZC.HQ(i)).K=i.BC.K+"-1X-x-1U-2Q",e.1Q(i.AZ),e.Z=i.Z,e.iX=i.AZ.iX,e.iY=i.AZ.iY,e.I=i.AZ.I,e.F=i.AZ.F,e.1v(),(t=1n ZC.HQ(i)).K=i.BC.K+"-1X-x-1U-3n",t.1Q(i.AW),t.Z=i.Z,t.iX=i.AW.iX,t.iY=i.AZ.iY,t.I=i.AW.I,t.F=i.AZ.F,t.1v())},3O:1f(e){1a t,i,n,a,l,o,r=1g,C=r.BC;if("1X-y"===r.AF){if(e<r.AW.iY&&!1,e===r.AW.iY)1m;r.AW.iY=e,ZC.A4("#"+r.K+"-1U-3n").2K("1u",e+"px"),t=r.AW.iY-r.AZ.iY,a=1A.4h(C.B5.1h/r.GT-C.EE/r.GT)+1,i=r.AZ.F/a,o=r.GT}1t if("1X-x"===r.AF){if(e>r.AW.iX&&!1,e===r.AW.iX)1m;r.AW.iX=e,ZC.A4("#"+r.K+"-1U-3n").2K("1J",e+"px"),t=r.AW.iX-r.AZ.iX,a=1A.4h(C.B5.1h/r.KP-C.EE/r.KP)+1,i=r.AZ.I/a,o=r.KP}n=1A.43(t/i),l=C.B5.1h-C.EE,C.B5.1h%o&&(l+=o-C.B5.1h%o),C.D2.2h=1A.2h(n*o,l),C.D2.1V=C.D2.2h+C.EE,C.W6(),C.3v(!1),C.1q(),C.1v(),r.6E(),r.3p()},3h:1f(){1a e=1g;ZC.A4("."+e.BC.K+"-"+e.AF+"-1U-3n").3h("6I 4D",e.R7),ZC.A4("."+e.BC.K+"-"+e.AF+"-1U-2Q").3h("3F",e.R8)},3p:1f(){1a e=1g,t=e.H.K,i=0,n=0;e.R7=1f(a){if(a.6L(),!(a.76>1)){1k(1a l=a.2T;l&&"lE"!==l.8h.5D()&&-1===ZC.P.SW(l).1K("zc-"+e.AF+"-3n");)l=l.6s;if((ZC.2H||!(a.8T>1))&&l){1a o=ZC.P.M8(a),r=ZC.A4("#"+t+"-1u").1Y();if("1X-y"===e.AF){1a C=o[1]-r.1u;n=C-e.AW.iY}1t if("1X-x"===e.AF){1a A=o[0]-r.1J;i=A-e.AW.iX}1m ZC.A4(2e.3o).3p("7R 6k",e.R9),ZC.A4(2e.3o).3p("6f 5P",e.ND),e.J6=!0,!1}}},e.R9=1f(a){if(a.6L(),e.J6){1a l=ZC.P.M8(a),o=ZC.A4("#"+t+"-1u").1Y();if("1X-y"===e.AF){1a r=l[1]-o.1u;r-n<e.AZ.iY&&(r=e.AZ.iY+n),r-n+e.AW.F>e.AZ.iY+e.AZ.F&&(r=e.AZ.iY+e.AZ.F+n-e.AW.F),e.3O(r-n)}1t if("1X-x"===e.AF){1a C=l[0]-o.1J;C-i<e.AZ.iX&&(C=e.AZ.iX+i),C-i+e.AW.I>e.AZ.iX+e.AZ.I&&(C=e.AZ.iX+e.AZ.I+i-e.AW.I),e.3O(C-i)}}1m!1},e.ND=1f(){1m e.H.KL=e.hy.2l(","),e.J6&&(ZC.A4(2e.3o).3h("7R 6k",e.R9),ZC.A4(2e.3o).3h("6f 5P",e.ND),e.J6=!1),!1},e.Aq=1f(t){(t.z3?-120*t.z3:t.15C)/120>0?e.3O(ZC.BN(e.AZ.iY,e.AW.iY-e.AW.F)):e.3O(ZC.CV(e.AZ.iY+e.AZ.F-e.AW.F,e.AW.iY+e.AW.F))},e.R8=1f(i){e.J6=!0;1a n=ZC.P.M8(i),a=ZC.A4("#"+t+"-1u").1Y();"1X-y"===e.AF?n[1]-a.1u>e.AW.iY?e.3O(ZC.CV(e.AZ.iY+e.AZ.F-e.AW.F,e.AW.iY+e.AW.F)):e.3O(ZC.BN(e.AZ.iY,e.AW.iY-e.AW.F)):"1X-x"===e.AF&&(n[0]-a.1J>e.AW.iX?e.3O(ZC.CV(e.AZ.iX+e.AZ.I-e.AW.I,e.AW.iX+e.AW.I)):e.3O(ZC.BN(e.AZ.iX,e.AW.iX-e.AW.I))),e.J6=!1},ZC.A4("."+e.BC.K+"-"+e.AF+"-1U-3n").3p("6I 4D",e.R7),ZC.A4("."+e.BC.K+"-"+e.AF+"-1U-2Q").3p("3F",e.R8)}}),ZC.p7=ZC.DQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.O9="1U",t.B5=1c,t.PX=1c,t.N9="x1",t.ID="5c",t.QU="",t.PL="",t.UJ=!1,t.UU=!1,t.TN="1Z",t.U2="5S",t.EE=6J,t.DC=1c,t.BQ=1c,t.ZE=1c,t.A2=1c,t.NE=1c,t.FK=1c,t.KG=1c,t.Q4=0,t.KZ=0,t.YL=!0,t.EJ=0,t.GH=0,t.pZ="",t.JQ="",t.D2={3Z:!1,2h:-1,1V:-1,3b:-1,9Q:-1},t.LY=!1,t.N4=!1,t.N7=-1,t.RY=!1,t.f8=1,t.WO=0,t.L7=!1,t.XI=!1,t.YB=!1,t.XE=[]},eu:1f(e){1a t,i,n=1g,a=!1,l=ZC.3l,o=n.L7;-1!==e&&(o=n.L7||n.A.AX.A7[e].L7),n.o.1N&&1c!==ZC.1d(t=n.o.1N["5M-1N"])&&(a=ZC.2q(t),1c===ZC.1d(n.o["5M-1U"])&&1c===n.A.AX.A7[e].o["5M-1U"]&&(o=a)),(a||o)&&(a&&(n.E["5M-1N"]=e),o&&(n.E["5M-1U"]=ZC.1l(e)),i=n.pM(ZC.1l(e)),n.W6(),n.3v(!0,i),n.YL=!0,n.1q(),n.mC(!0),n.1v(),ZC.3l=l)},pM:1f(e){1a t,i,n=1g,a=!1;1m e>=0&&(e<n.D2.2h||e>=n.D2.1V)&&(a=!0,"1X"===n.TN?(e%(i="1X-y"===n.DC.AF?n.DC.GT:n.DC.KP)&&(e-=e%i),n.D2.2h=e,n.D2.1V=e+n.EE,n.D2.1V>n.B5.1h&&(n.D2.2h=n.B5.1h-n.EE,n.B5.1h%i&&(n.D2.2h=n.D2.2h+(i-n.B5.1h%i)),n.D2.1V=n.B5.1h)):"3b"===n.TN&&(t=1A.4i(e/n.EE),n.D2.2h=t*n.EE,n.D2.1V=n.D2.2h+n.EE,n.D2.3b=t+1)),a},1q:1f(){1a e,t,i,n=1g;n.E["ei-f3"]=!0,n.Q4=0,n.KZ=0,1c!==ZC.1d(e=n.A.A.E["2U-"+n.A.K+"-1U-6w"])&&(n.o.x=e.x-n.A.iX,n.o.y=e.y-n.A.iY);1a a;if(ZC.3l)n.FK&&n.FK.1q(),n.KG&&n.KG.1q();1t{a=n.A.H.B9;1a l="("+n.A.AF+")";n.b(),n.4y([["hs","LY","b"],["lA","UJ","b"],["15h","UU","b"],["6a","RY","b"],["9R","TN"],["1V-2z","EE","i"],["5Z","f8","i"],["15g-3M","U2"],["5M-1B","WO","b"],["5M-1U","L7","b"],["3s","pZ"],["9r-3s","JQ"]]),n.LY&&!n.UJ&&(n.LY=!1),1o.3G.pL&&(n.E["yW-3s-2G"]||(n.mz({3s:n.pZ,"9r-3s":n.JQ,3t:n.N9}),n.E["yW-3s-2G"]=!0)),n.WO&&1c===ZC.1d(n.o["5M-1U"])&&(n.L7=n.WO),n.BQ=1n ZC.DQ(n),a.2t(n.BQ.o,l+".1U.1N"),n.o.1N&&1c===ZC.1d(n.o.1N.2f)&&(n.o.1N.2f=!0),n.BQ.1C(n.o.1N),n.BQ.1q(),n.ZE=1n ZC.DQ(n),a.2t(n.ZE.o,l+".1U.1N-6N"),n.o["1N-6N"]&&1c===ZC.1d(n.o["1N-6N"].2f)&&(n.o["1N-6N"].2f=!0),n.ZE.1C(n.o["1N-6N"]),n.ZE.1q(),n.A2=1n ZC.DS(n),a.2t(n.A2.o,l+".1U.1O"),n.o.1O&&1c===ZC.1d(n.o.1O.2f)&&(n.o.1O.2f=!0),n.A2.1C(n.o.1O),n.A2.E.1I="2n",n.A2.E["4k-1O"]=!0,n.A2.E["4k-1y"]=!1,1c!==ZC.1d(e=n.A2.o.1I)&&(n.A2.E.1I=e),1c!==ZC.1d(e=n.A2.o["4k-1y"])&&(n.A2.E["4k-1y"]=ZC.2q(e)),1c!==ZC.1d(e=n.BQ.o["1O-1H"])&&(n.A2.E.1I=e),1c!==ZC.1d(e=n.BQ.o["4k-1y"])&&(n.A2.E["4k-1y"]=ZC.2q(e)),1c!==ZC.1d(e=n.BQ.o["4k-1O"])&&(n.A2.o.2f=ZC.2q(e)),n.A2.1q(),n.NE=1n ZC.DS(n),a.2t(n.NE.o,l+".1U.1O-6N"),n.o["1O-6N"]&&(n.o["1O-6N"].2f=!0),n.NE.1C(n.o["1O-6N"]),n.NE.E.1I="2n",n.NE.E["4k-1O"]=!0,n.NE.E["4k-1y"]=!1,1c!==ZC.1d(e=n.NE.o.1I)&&(n.NE.E.1I=e),1c!==ZC.1d(e=n.NE.o["4k-1y"])&&(n.NE.E["4k-1y"]=ZC.2q(e)),1c!==ZC.1d(e=n.BQ.o["1O-1H"])&&(n.NE.E.1I=e),1c!==ZC.1d(e=n.BQ.o["4k-1y"])&&(n.NE.E["4k-1y"]=ZC.2q(e)),1c!==ZC.1d(e=n.BQ.o["4k-1O"])&&(n.NE.o.2f=ZC.2q(e)),n.NE.1q(),(1c!==ZC.1d(e=n.o.5S)||n.UU||n.UJ)&&(n.FK=1n ZC.DQ(n),n.FK.O9="15f",n.FK.GG="zc-1U-1N "+n.K+"-5S",n.FK.K=n.K+"-5S",a.2t(n.FK.o,l+".1U.5S"),n.FK.o.1D=n.FK.o.1D||" ",n.FK.1C(e),n.FK.1q(),n.FK.AL||(n.FK=1c)),1c!==ZC.1d(e=n.o.9P)&&(n.KG=1n ZC.DQ(n),n.KG.O9="15e",n.KG.GG="zc-1U-1N "+n.K+"-9P",n.KG.K=n.K+"-9P",a.2t(n.KG.o,l+".1U.9P"),n.KG.1C(e),n.KG.1q(),n.KG.AL||(n.KG=1c));1a o=n.A.AX.A7;1c!==ZC.1d(e=n.o.3t)?n.N9=e:25*o.1h>n.A.F&&(n.N9="x"+1A.4h(25*o.1h/n.A.F)),1c!==ZC.1d(e=n.o[ZC.1b[54]])&&(n.ID=e),n.QU=n.PL=n.ID,1c!==ZC.1d(n.o.1N)&&1c!==ZC.1d(e=n.o.1N[ZC.1b[54]])&&(n.QU=e),1c!==ZC.1d(n.o.1O)&&1c!==ZC.1d(e=n.o.1O[ZC.1b[54]])&&(n.PL=e);1k(n.B5=[],t=0,i=o.1h;t<i;t++){1a r=n.A.AX.LG[t],C=1n ZC.DQ(n);C.1Q(n.BQ),C.1C(o[r].o["1U-1N"]),1c===ZC.1d(C.o.1D)&&1c!==ZC.1d(e=o[r].nq)&&(C.o.1D=e),1c===ZC.1d(C.o.1D)&&1c!==ZC.1d(e=o[r].AP)&&(C.o.1D=e),C.AP=1c===ZC.1d(C.o.1D)?"km "+(r+1):C.o.1D,C.E.6H=r,C.E.2V=r,1c!==ZC.1d(o[r].o["1U-1N"])&&1c!==ZC.1d(e=o[r].o["1U-1N"].6H)&&(C.E.6H=ZC.5m(ZC.1l(e)-1,0,i-1)),-1!==C.AP.1K("%")&&(C.KC=1f(e){if(o[t]&&o[t].FO(0)){1a i=ZC.AO.OS(n.BQ.o,o[t].o);e=o[t].FO(0).KC(e,i)}1m e}),C.1q(),n.B5.1i(C)}(e=n.A.E["1U-6w"])&&(n.N4=e.eo)}if(n.B5&&n.A2){"3b"===n.TN?((e=n.A.E["1U-6w"])?(n.D2.2h=e.2h,n.D2.1V=e.1V,n.D2.3b=e.3b):(n.D2.2h=0,n.D2.1V=n.EE,n.D2.3b=1),n.D2.9Q=1A.4h(n.B5.1h/n.EE),n.D2.3b>n.D2.9Q&&(n.D2.3b=n.D2.9Q,n.D2.2h=(n.D2.3b-1)*n.EE,n.D2.1V=n.D2.3b*n.EE-1),n.D2.3b=ZC.CV(n.D2.3b,n.D2.9Q)):"1X"===n.TN?(e=n.A.E["1U-6w"])?(n.D2.2h=e.2h,n.D2.1V=e.1V,n.D2.3b=e.3b):(n.D2.2h=0,n.D2.1V=n.EE,n.D2.3b=1):(n.D2.2h=0,n.D2.1V="9c"===n.TN?n.EE:n.B5.1h,n.D2.3b=1),n.W6(!1),n.o["9m-ek"]&&n.B5.9m();1a A=.9*n.A.I;1c!==ZC.1d(n.o[ZC.1b[19]])&&(A=n.I);1a s=0,Z=0,c=-ZC.3q,u=-ZC.3q,p=n.A2.E["4k-1y"]?3:2,h=0,1b=1,d=1;if("8Z"===n.N9){1k(t=0,i=n.B5.1h;t<i;t++)if(h+=n.B5[t].AL?1:0,!(t<n.D2.2h||t>=n.D2.1V||n.N4)&&n.B5[t].AL){1a f=n.B5[t].I+n.B5[t].DZ+n.B5[t].E3+p*n.B5[t].DG;u=ZC.BN(u,n.B5[t].F+n.B5[t].E2+n.B5[t].DN),s+f>A?(c=ZC.BN(c,s),Z+=u,s=f,u=ZC.BN(u,n.B5[t].F+n.B5[t].E2+n.B5[t].DN)):s+=f}c=ZC.BN(c,s),u!==-ZC.3q&&(Z+=u),c!==-ZC.3q&&(s=c)}1t{1a g=0;1k(t=0,i=n.B5.1h;t<i;t++)h+=n.B5[t].AL?1:0,t<n.D2.2h||t>=n.D2.1V||n.N4||(g+=n.B5[t].AL?1:0);1a B=ZC.AN.g5(n.N9,g);1k(1b=B[0],d=B[1],t=0,i=n.B5.1h;t<i;t++)(t<n.D2.2h||t>=n.D2.1V||n.N4)&&("1X"!==n.TN||h<=n.EE)||n.B5[t].AL&&(c=ZC.BN(c,n.B5[t].I+n.B5[t].DZ+n.B5[t].E3+p*n.B5[t].DG),u=ZC.BN(u,n.B5[t].F+n.B5[t].E2+n.B5[t].DN),1===d&&(Z+=n.B5[t].F+n.B5[t].E2+n.B5[t].DN));s=d*c,Z=1b*u}if("3b"===n.TN&&h>n.EE&&(n.D2.3Z=!0),"1X"===n.TN&&h>n.EE&&(n.DC||(!1b||1b>d?(n.DC=1n ZC.rz(n,"y"),a.2t(n.DC.o,".1X-y")):(n.DC=1n ZC.rz(n,"x"),a.2t(n.DC.o,".1X-x")),n.DC.1C(n.o.1X),n.DC.KP=1b,n.DC.GT=d,n.DC.1q()),n.N4||("1X-y"===n.DC.AF?s+=n.DC.AZ.I:Z+=n.DC.AZ.F)),n.FK){1a v=n.FK.I;n.UU&&"aF"===n.U2?(v+=15,n.UJ&&(v+=25)):n.UJ&&(v+=15),s=ZC.BN(s,v)}n.KG&&(s=ZC.BN(s,n.KG.I));1a b=!1,E=!1;if(1c===ZC.1d(n.o[ZC.1b[19]])&&(n.o[ZC.1b[19]]=s,b=!0),1c===ZC.1d(n.o[ZC.1b[20]])&&(n.o[ZC.1b[20]]=Z,E=!0),n.iX=-1,n.iY=-1,!ZC.3l&&n.FK&&1c!==ZC.1d(e=n.A.A.E["1U"+n.A.L+"-xy-fD"])){n.9p();1a m=n.I+n.EO+n.FN,K=n.F+n.FM+n.FV,F=n.RY?n.A.A:n.A;n.iX=F.I*e[0],n.iX=ZC.BN(n.iX,1.1),n.o.x=n.iX=ZC.CV(n.iX,F.I-m-2),n.iY=(F.F-n.FK.F)*e[1],n.iY=ZC.BN(n.iY,1.1),n.o.y=n.iY=ZC.CV(n.iY,F.F-K-n.FK.F-2)}if(n.9p(),1c!==ZC.1d(n.o.2G)&&1w n.E["2G-6w"]!==ZC.1b[31]?(n.E["2G-6w"][0]>.5&&(n.Q4+=n.EO+n.FN),n.E["2G-6w"][1]>.5?n.KZ+=n.FM+n.FV:(n.FK&&(n.KZ-=n.FK.F),n.KG&&(n.KZ-=n.KG.F),n.D2&&n.D2.3Z&&(n.KZ-=20))):((0===n.A.iX||n.iX+n.I/2>n.A.iX+n.A.I/2)&&(n.Q4+=n.EO+n.FN),(0===n.A.iY||n.iY+n.F/2>n.A.iY+n.A.F/2)&&(n.KZ+=n.FM+n.FV)),!ZC.3l&&(e=n.A.A.E["2U-"+n.A.K+"-1U-6w"])&&(e.x&&(n.iX=e.x),e.y&&(n.iY=e.y)),n.GH=n.F,n.EJ=n.iY,n.FK&&(n.F+=n.FK.F,n.EJ+=n.FK.F,n.KZ+=n.FK.F),n.KG&&(n.F+=n.KG.F,n.KZ+=n.KG.F),n.D2.3Z&&!n.N4){1a D=1n ZC.DQ(n);D.AP=" ",D.1C(n.o["3b-6Q"]),1c!==ZC.1d(D.o.1D)&&""!==D.o.1D||(D.o.1D="#"),D.1q(),n.F+=D.F+4,n.KZ+=D.F+4}b&&(n.o[ZC.1b[19]]=1c),E&&(n.o[ZC.1b[20]]=1c),n.N4||(n.I+=n.EO+n.FN,n.F+=n.FM+n.FV),n.E["2n-1s"]&&(n.I=n.E["2n-1s"])}},mz:1f(e){1a t=1g;if(1c!==ZC.1d(e)){1a i=t.A.H.B9.B9.2U.1U,n=e.3s||i.3s,a=e["9r-3s"]||i["9r-3s"],l=e.3t||i.3t;(n||a)&&("3E"===n?(1c===ZC.1d(t.o.3t)&&(l=t.o.3t="cd"),t.o.2G="50% "):t.o.2G="1J"===n?"0% ":"100% ",t.o.2G+="6o"===a?"50%":"2a"===a?"100%":"0%","cd"!==l&&"6o"!==a||(t.o["94-3t"]=!0))}},W6:1f(e){1a t=1g;1w e===ZC.1b[31]&&(e=!0),t.A.E["1U-6w"]={eo:t.N4,2h:t.D2.2h,1V:t.D2.1V,3b:t.D2.3b},e&&(t.A.A.E["2U-"+t.A.K+"-1U-6w"]={x:t.iX,y:t.iY})},3v:1f(e,t){1c===ZC.1d(e)&&(e=!1),1c===ZC.1d(t)&&(t=!1);1a i=1g,n=i.A.K+"-1U-",a=1c;ZC.A4("."+n+"1N",a).3m(),ZC.A4("."+n+"5S",a).3m(),ZC.A4("."+n+"9P",a).3m(),ZC.A4("#"+n+"3b-6Q",a).3m(),e&&!t||(ZC.3l||i.3h(),ZC.A4("."+n+"3b-1M",a).3m(),ZC.A4("."+n+"5S-1M",a).3m(),ZC.A4("."+n+"1N-1M",a).3m(),ZC.A4("."+n+"1O-1M",a).3m()),ZC.3l?ZC.P.IL(ZC.AK(n+"c"),i.A.H.AB,i.A.iX,i.A.iY,i.A.I,i.A.F):ZC.P.IL(ZC.AK(n+"c"),i.A.H.AB,i.iX-2*i.AQ-2*i.JP,i.iY-2*i.AQ-2*i.JP,i.I+4*i.AQ+4*i.JP,i.F+4*i.AQ+4*i.JP),i.DC&&ZC.P.IL(ZC.AK(n+"1X-c"),i.A.H.AB,i.A.iX,i.A.iY,i.A.I,i.A.F)},3h:1f(){1a e=1g;ZC.A4("#"+e.K+"-9S").4f(ZC.P.C1("6Z"),e.r7).4f(ZC.P.C1("7B"),e.r5),ZC.A4("#"+e.K+"-3l-1M").4f(ZC.P.C1(ZC.1b[47]),e.YW),ZC.A4("#"+e.K+"-lA-1M").4f(ZC.P.C1("3F"),e.XO),ZC.A4("."+e.K+"-3b-1M").4f(ZC.P.C1("3F"),e.Y9),e.DC&&e.DC.3h(),e.BQ&&e.BQ.o.rD&&ZC.A4("."+e.A.K+"-1U-1N-1M").4f(ZC.1b[47],e.VL)},mC:1f(e){1a t=1g;if(t.YL&&1c===ZC.1d(t.o.y)||e){if(!t.o.2G&&e||(t.iX-=t.Q4),t.iX<t.DZ&&(t.DZ<t.E3||-2===t.E3)&&(t.iX=t.DZ),!t.o.2G&&e||(t.iY-=t.KZ,t.EJ-=t.KZ),t.iY<t.E2&&(t.E2<t.DN||-2===t.DN)){1a i=t.EJ-t.iY;t.iY=t.E2,t.EJ=t.E2+i}t.YL=!1}},EH:1f(e){1a t=1g;t.FK&&t.FK.EH(e),t.KG&&t.KG.EH(e);1k(1a i=0;i<t.XE.1h;i++)t.XE[i].EH(e)},1v:1f(e){1a t,i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d=1g;if(d.AL&&(d.E["2n-1s"]||(d.E["2n-1s"]=d.I),d.B5)){1a f=ZC.AK(d.H.K+"-1u"),g=d.A.AX.A7,B=0;1k(o=0,r=d.B5.1h;o<r;o++)o<d.D2.2h||o>=d.D2.1V||d.N4||(B+=d.B5[o].AL?1:0);d.ll=!0,d.b(),d.FK&&(d.FK.iX=d.iX,d.FK.iY=d.iY,d.FK.I=d.I,d.FK.Z=d.FK.C5=d.Z,d.FK.1v(),ZC.3l||"3a"!==d.A.A.AB&&d.FK.EH(),d.UU&&"aF"===d.U2&&((n=1n ZC.DS(d)).Z=d.Z,n.B6="#4e",n.AY=1,n.DP="1y",n.1C(d.o.aF),a=d.FK.iX+d.FK.I-10,l=d.FK.iY+d.FK.F/2,n.D=[[a-7,l],[a+7,l],1c,[a,l-7],[a,l+7],1c,[a-6,l-1],[a-6,l+1],1c,[a-5,l-2],[a-5,l+2],1c,[a+6,l-1],[a+6,l+1],1c,[a+5,l-2],[a+5,l+2],1c,[a-1,l-6],[a+1,l-6],1c,[a-2,l-5],[a+2,l-5],1c,[a-1,l+6],[a+1,l+6],1c,[a-2,l+5],[a+2,l+5]],n.1q(),n.1v()),d.UJ&&((i=1n ZC.DS(d)).Z=d.Z,i.B6=ZC.AO.rs(d.A0,"#2O","#4e"),i.AY=1,i.1C(d.o.aF),i.DP="1y",a=d.FK.iX+d.FK.I-10-(d.UU&&"aF"===d.U2?20:0),l=d.FK.iY+d.FK.F/2,i.D=[[a-7,l-2],[a+2,l-2],[a+2,l+7],[a-7,l+7],[a-7,l-2],[a+2,l-2],1c,[a-4,l-5],[a+5,l-5],[a+5,l+4],[a-4,l+4],[a-4,l-5],[a+5,l-5]],i.1q(),i.1v())),d.KG&&(d.KG.iX=d.iX,d.KG.iY=d.iY+d.F-d.KG.F,d.KG.I=d.I,d.KG.Z=d.KG.C5=d.Z,d.KG.1v(),ZC.3l||"3a"!==d.A.A.AB&&d.KG.EH());1a v=ZC.AN.g5(d.N9,B),b=v[0],E=v[1],m=d.I/E,K=d.GH/b,F=0,D=0;d.PX=[];1a I,X=0,x=-ZC.3q,y=d.A2.E["4k-1y"]?3:2,L=1c,Y=0;1k(d.XI=!1,o=0,r=d.B5.1h;o<r;o++)if(!(Y<d.D2.2h||Y>=d.D2.1V||d.N4)){1a w=1n ZC.DQ(d);w.1Q(d.B5[o]),d.E["5M-1U"]===o&&(w.1C({6u:!0}),1c!==ZC.1d(d.o.1N)&&w.1C(d.o.1N["5M-3U"])),I=w.E.2V;1a M=1n ZC.DQ(d);M.O9="151",M.K=d.K+"-7E"+I,M.GG="zc-1U-1N "+d.K+"-1N",M.1Q(w),d.A.E["1B"+I+".2f"]&&"6N"!==g[I].o["1U-6Q"]||M.1C(d.ZE.o),M.1C(g[I].o["1U-1N"]),M.KC=1f(t){1a i=t;if(1c===ZC.1d(e)&&(e=0),g[I]&&g[I].S[e]){1a n=ZC.AO.OS(d.BQ.o,g[I].o);t=g[I].FO(e).KC(t,n)}1m d.XI=d.XI||t!==i,t},M.1q(),M.AL&&(Y++,"8Z"===d.N9?(x=ZC.BN(x,w.F),1c===ZC.1d(L)?(w.iX=d.iX+d.EO+w.DZ+y*w.DG,w.iY=d.EJ+d.FM+w.E2,X=d.EJ):(w.iX=L.iX+L.I+L.E3+w.DZ+y*w.DG,ZC.1l(w.iX+w.I+w.E3)>ZC.1l(d.iX+d.I)&&(w.iX=d.iX+d.EO+w.DZ+y*w.DG,X+=x+w.E2+w.DN,x=-ZC.3q),w.iY=X+d.FM+w.E2)):(w.iX=d.iX+(0===D?d.EO:0)+D*m+w.DZ+y*w.DG,w.iY=d.EJ+d.FM+F*K+w.E2,++D===E&&(D=0,F++)),L=w,M.iX=w.iX=ZC.1l(w.iX),M.iY=w.iY=ZC.1l(w.iY),M.Z=M.C5=d.Z,M.iX+=d.BJ,M.iY+=d.BD,I===d.N7&&(d.E["lx-y"]&&(d.E["lx-y"]=!1,d.E["9t-1Y-y"]=d.E["9t-y"]-M.iY),M.iY=d.E["9t-y"]-d.E["9t-1Y-y"]-M.DG/4),M.1v(),1w d.E.lW!==ZC.1b[31]&&1c!==ZC.1d(d.E.lW)||ZC.3l||("3a"!==d.A.A.AB?M.EH():d.XE.1i(M)));1a H=d.A2.E.1I;1c!==ZC.1d(t=g[I].o["1U-1O"])&&1c!==ZC.1d(t.1I)&&(H=t.1I);1a N=!1;"ln"!==H&&"5n"!==H||(N=!0,H=1c!==ZC.1d(t=g[I].A2.o.1I)?t:"2n");1a S;1P(-1!==ZC.AT(["2n","9o"],H)?S=1n ZC.HQ(d):(S=1n ZC.DS(d)).DP=H,S.O9="158",S.1C(d.A2.o),d.A.E["1B"+I+".2f"]&&"6N"!==g[I].o["1U-6Q"]||S.1C(d.NE.o),S.N1=g[I].N1,g[I].AF){1j"3L":1j"7k":1j"96":1j"5A":1j"6M":1j"6d":1j"7v":1j"8q":1j"80":1j"1M":1j"81":1j"8M":1j"ao":1j"ap":1j"aV":S.A0=g[I].A0,S.AC=g[I].AC,S.GK=g[I].GK,S.HE=g[I].HE;1p;1j"6t":1j"8t":1j"5h":1j"6z":S.A0="-1"!==g[I].A2.A0?g[I].A2.A0:g[I].A0,S.AC="-1"!==g[I].A2.AC?g[I].A2.AC:g[I].AC,S.GK=""!==g[I].A2.GK?g[I].A2.GK:g[I].GK,S.HE=""!==g[I].A2.HE?g[I].A2.HE:g[I].HE;1p;2n:S.A0=g[I].B6,S.AC=g[I].B6}"1y"!==S.DP&&"1M"!==S.DP||(S.B6=S.A0,S.AY=2),N&&S.1C(g[I].A2.o),S.o["1y-1H"]="2R",S.o.1I=S.DP,S.1C(g[I].o["1U-1O"]),N&&(S.o.1I=S.DP),S.E["4k-1O"]=!0,S.E["4k-1y"]=!1,1c!==ZC.1d(t=S.o["4k-1y"])&&(S.E["4k-1y"]=ZC.2q(t)),1c!==ZC.1d(t=M.o["4k-1y"])&&(S.E["4k-1y"]=ZC.2q(t)),1c!==ZC.1d(t=M.o["4k-1O"])&&(S.o.2f=ZC.2q(t)),-1!==ZC.AT(["2n","9o"],H)&&1c!==ZC.1d(t=S.o[ZC.1b[21]])&&(1c===ZC.1d(S.o[ZC.1b[19]])&&(S.o[ZC.1b[19]]=2*ZC.1l(t)),1c===ZC.1d(S.o[ZC.1b[20]])&&(S.o[ZC.1b[20]]=2*ZC.1l(t))),S.K=d.K+"-aH"+I,S.Z=S.C5=d.Z,S.iX=M.iX-y*M.DG+(y-1)*M.DG/2+M.DG/2,S.iY=M.iY+(M.F-M.DG)/2+M.DG/2,S.1q(),d.E["5M-1U"]===o&&(S.1C({2b:S.AH+1,1s:S.I+2,1L:S.F+2}),g[I]&&g[I].S[e]&&g[I].S[e].GE&&S.1C({A0:g[I].S[e].GE.A0,AC:g[I].S[e].GE.AC}),1c!==ZC.1d(d.o.1O)&&S.1C(d.o.1O["5M-3U"]),S.1q()),"1y"===S.DP?(S.o.2S=[[S.iX-1.75*S.AH,S.iY],[S.iX+1.75*S.AH,S.iY]],S.1q()):"1M"===S.DP&&(S.o.2S=[[S.iX-1.75*S.AH,S.iY+S.AH],[S.iX+1.75*S.AH,S.iY+S.AH],[S.iX+1*S.AH,S.iY-S.AH/2],[S.iX,S.iY],[S.iX-1.25*S.AH,S.iY-S.AH],[S.iX-1.75*S.AH,S.iY+S.AH]],S.1q());1a O=S.iX+S.BJ,P=S.iY+S.BD;if(-1!==ZC.AT(["2n","9o"],H)&&(S.iX-=S.I/2,S.iY-=S.F/2),d.A.E["1B"+I+".2f"]&&"6N"!==g[I].o["1U-6Q"]||(S.C6/=4),M.AL&&S.E["4k-1y"]){1a k=ZC.P.E6(d.Z,d.A.H.AB),G=1n ZC.CZ(d);G.Z=d.Z,G.1Q(g[I]),G.o["1y-1H"]=d.A2.G8,G.1C(g[I].o),G.1C(d.A2.o),G.1C(g[I].o["1U-1N"]),G.1C(g[I].o["1U-1O"]),G.1q(),d.A.E["1B"+I+".2f"]||(G.C6=.25);1a z=[],T=S.AL?2:1;C="3B"===S.DP?S.I/2:S.AH,z.1i([O-T*C-(G.AY>1?1:0),P-(G.AY>1?.5:0)]),z.1i([O+T*C,P-(G.AY>1?.5:0)]),G.CX=!0,ZC.CN.1v(k,G,z)}I===d.N7&&(S.iY=d.E["9t-y"]-d.E["9t-1Y-y"]/2),S.AL&&M.AL&&S.1v(),d.PX.1i(S);1a J=!0;if(1c!==ZC.1d(t=d.BQ.o.9L)&&(J=ZC.2q(t)),d.E["1N.9L"]=J,(M.AL||S.AL)&&-1===ZC.AT(d.A.H.KL,ZC.1b[41])){1a Q=S.BJ+("3B"===S.DP?S.iX+S.I/2:S.iX),W=S.BD+("3B"===S.DP?S.iY+S.F/2:S.iY);C="3B"===S.DP?S.I/2:S.AH,A="3B"===S.DP?S.F/2:S.AH;1a R=(S.E["4k-1y"]?2:1)*C;ZC.AK(M.K+"-1M")||(S.AL&&"lo"!==d.PL&&"lo"!==S.o[ZC.1b[54]]&&(ZC.AK(S.K+"-1M")||ZC.P.HO({2m:d.K+"-1O-1M zc-1U-1O-1M zc-3i",id:S.K+"-1M",wh:2*R+"/"+2*A,tl:W-A+"/"+(Q-R),3k:0,1R:"#2O",4O:S.IM,p:f,8s:1})),M.AL&&"lo"!==d.QU&&"lo"!==M.o[ZC.1b[54]]&&(ZC.AK(M.K+"-1M")||ZC.P.HO({2m:d.K+"-1N-1M zc-1U-1N-1M zc-3i",id:M.K+"-1M",wh:M.I+"/"+M.F,tl:M.iY+M.BD+"/"+(M.iX+M.BJ),3k:0,1R:"#2O",4O:M.IM,p:f,8s:1})))}}if(d.DC&&!d.N4&&(d.DC.1v(),ZC.AK(d.K+"-1X-c").1H.3J="8K"),d.DC&&d.N4&&(ZC.AK(d.K+"-1X-c").1H.3J="1Z"),d.D2.3Z&&!d.N4){1a V=1n ZC.DQ(d);V.Z=V.C5=d.Z,V.K=d.K+"-3b-6Q",V.AP=ZC.HA["1U-yV"].1E("%3b%",d.D2.3b).1E("%9Q%",d.D2.9Q),V.1C(d.o["3b-6Q"]),V.1q(),d.I<V.I+48&&(V.AP=d.D2.3b+"/"+d.D2.9Q,V.1q()),V.iX=d.iX+d.I/2-V.I/2,V.iY=d.iY+d.F-(d.KG?d.KG.F:0)-V.F-4,V.AL&&V.1v();1a U=d.A.H.B9,j="("+d.A.AF+")",q={"1R-1r":"#4J"},$={"1R-1r":"#yU"};U.2t(q,j+".1U.3b-6N"),U.2t($,j+".1U.3b-on"),(Z=1n ZC.DS(d)).Z=Z.C5=d.Z,Z.K=d.K+"-3b-yS",Z.A0=Z.AC=d.D2.3b>1?$[ZC.1b[0]]:q[ZC.1b[0]],Z.1C(d.D2.3b>1?d.o["3b-on"]:d.o["3b-6N"]),s=d.iX+d.I/2-V.I/2-6,c=V.iY+V.F/2,Z.1q(),Z.AH=ZC.BN(Z.AH,8),1b=ZC.1l(.75*Z.AH),Z.D=[[s,c-1b],[s,c+1b],[s-Z.AH,c],[s,c-1b]],Z.1q(),Z.AL&&Z.1v(),(p=1n ZC.DS(d)).Z=p.C5=d.Z,p.K=d.K+"-3b-qG",p.A0=p.AC=d.D2.3b<d.D2.9Q?$[ZC.1b[0]]:q[ZC.1b[0]],p.1C(d.D2.3b<d.D2.9Q?d.o["3b-on"]:d.o["3b-6N"]),u=d.iX+d.I/2+V.I/2+6,h=V.iY+V.F/2,p.1q(),p.AH=ZC.BN(p.AH,8),1b=ZC.1l(.75*p.AH),p.D=[[u,h-1b],[u,h+1b],[u+p.AH,h],[u,h-1b]],p.1q(),p.AL&&p.1v()}if(!ZC.3l){1a ee=d.F,te=d.iY;d.FK&&(ee-=d.FK.F,te+=d.FK.F),ZC.AK(d.K+"-9S")?ZC.A4("#"+d.K+"-9S").2K("1u",te+"px").2K("1J",d.iX+"px").2K(ZC.1b[19],d.I+"px").2K(ZC.1b[20],ee+"px"):ZC.P.HO({2m:"zc-3i zc-1U-9S "+d.K+"-9S",id:d.K+"-9S",wh:d.I+"/"+ee,tl:te+"/"+d.iX,3k:0,1R:"#2O",p:f,8s:0}),d.D2.3Z&&!d.N4&&(d.D2.3b>1&&ZC.P.HO({2m:d.K+"-3b-1M zc-1U-3b-1M zc-3i",id:d.K+"-3b-yS-1M",wh:Z.AH+"/"+2*Z.AH,tl:ZC.1l(c+Z.BD-Z.AH)+"/"+ZC.1l(s+Z.BJ-Z.AH),3k:0,p:f,8s:1}),d.D2.3b<d.D2.9Q&&ZC.P.HO({2m:d.K+"-3b-1M zc-1U-3b-1M zc-3i",id:d.K+"-3b-qG-1M",wh:p.AH+"/"+2*p.AH,tl:ZC.1l(h+Z.BD-p.AH)+"/"+ZC.1l(u+p.BJ),3k:0,p:f,8s:1}));1a ie,ne;d.FK&&d.UU&&("aF"===d.U2?(ne=ZC.1l(d.FK.iY+ZC.3y+n.BD)+"/"+ZC.1l(d.FK.iX+d.FK.I-20+ZC.3y+n.BJ),ie="20/"+d.FK.F):(ne=ZC.1l(d.FK.iY+ZC.3y)+"/"+ZC.1l(d.FK.iX+ZC.3y),ie=d.FK.I-(d.UJ?23:0)+"/"+d.FK.F),ZC.P.HO({2m:d.K+"-5S-1M zc-1U-5S-1M zc-3i",id:d.K+"-3l-1M",wh:ie,tl:ne,3k:0,p:f,8s:1})),d.UJ&&(d.UU&&"aF"===d.U2?(ne=ZC.1l(d.FK.iY+ZC.3y+i.BD)+"/"+ZC.1l(d.FK.iX+d.FK.I-41+ZC.3y+i.BJ),ie="20/"+d.FK.F):(ne=ZC.1l(d.FK.iY+ZC.3y+i.BD)+"/"+ZC.1l(d.FK.iX+d.FK.I-22+ZC.3y+i.BJ),ie="20/"+d.FK.F),ZC.P.HO({2m:d.K+"-5S-1M zc-1U-5S-1M zc-3i",id:d.K+"-lA-1M",wh:ie,tl:ne,3k:0,p:f,8s:1})),d.OO=0,d.ZN=0,d.r7=1f(){d.YB=!0},d.r5=1f(){d.YB=!1},d.YW=1f(e){if(e.6L(),d.H.9h(),ZC.3l=!0,ZC.2H||!(e.8T>1)){d.A.A.E["2U-"+d.A.K+"-1U-6w"]=1c;1a t=ZC.P.M8(e),i=ZC.A4("#"+d.A.A.K+"-1u").1Y();d.OO=t[0]-i.1J-d.FK.iX,d.ZN=t[1]-i.1u-d.FK.iY,d.qS=2e.3o.1H.4O,2e.3o.1H.4O="3l",ZC.A4(2e.3o).3p(ZC.P.C1(ZC.1b[48]),d.YY),ZC.A4(2e.3o).3p(ZC.P.C1(ZC.1b[49]),d.qF)}},d.YY=1f(e){1a t=ZC.P.M8(e),i=ZC.A4("#"+d.A.A.K+"-1u").1Y(),n=t[0]-i.1J-d.OO,a=t[1]-i.1u-d.ZN;if(d.RY?(n=ZC.BN(n,d.H.iX+2),n=ZC.CV(n,d.H.iX+d.H.I-d.I-2),a=ZC.BN(a,d.H.iY+2),a=ZC.CV(a,d.H.iY+d.H.F-d.F-4)):(n=ZC.BN(n,d.A.iX+2),n=ZC.CV(n,d.A.iX+d.A.I-d.I-2),a=ZC.BN(a,d.A.iY+2),a=ZC.CV(a,d.A.iY+d.A.F-d.F-4)),d.RY||(n-=d.A.iX,a-=d.A.iY),d.o.x=n,d.o.y=a,d.o.2G=1c,d.3v(!0),d.1q(),d.1v(),d.FK){1a l=d.RY?d.A.A:d.A;d.A.A.E["1U"+d.A.L+"-xy-fD"]=[n/l.I,a/(l.F-d.FK.F)]}},d.qF=1f(){ZC.3l=!1,2e.3o.1H.4O=d.qS,4o d.qS,ZC.A4(2e.3o).3h(ZC.P.C1(ZC.1b[48]),d.YY),ZC.A4(2e.3o).3h(ZC.P.C1(ZC.1b[49]),d.qF),d.XE=[],d.3v(!1),d.1q(),d.1v(),d.W6()},d.Y9=1f(e){d.E["2n-1s"]=1c,-1!==(e.9O||e.2T.id).1K("-3b-qG-1M")?(d.D2.2h+=d.EE,d.D2.1V+=d.EE,d.D2.3b+=1):(d.D2.2h-=d.EE,d.D2.1V-=d.EE,d.D2.3b-=1),(!(t=d.A.A.E["2U-"+d.A.K+"-1U-6w"])||1c===ZC.1d(t.x)&&1c===ZC.1d(t.y))&&(d.iX=1c,d.iY=1c),d.W6(),d.A.K2()},d.XO=1f(e){1a t=d.N4?"yL":"gE";e&&(d.A.A.E["1U-qW"]=1),1o.3j(d.A.H.K,t,{4u:d.A.L}),e&&(d.A.A.E["1U-qW"]=0),e&&(d.A.A.E["g"+d.A.L+"-1U-eo"]="gE"===t)},d.MH=1f(e){ZC.3l=!0;1a t=ZC.P.M8(e),i=ZC.A4("#"+d.A.A.K+"-1u").1Y(),n=t[0]-i.1J,a=t[1]-i.1u;d.E["9t-x"]=n,d.E["9t-y"]=a,d.W6(),d.3v(!1),d.1q(),d.1v()},d.VL=1f(e){if(e.6L(),d.H.9h(),d.IM=2e.3o.1H.4O,2e.3o.1H.4O="3l",ZC.2H||!(e.8T>1)){1a t=1n 5o("-1U-7E([0-9]+)-1M","g").3j(e.2T.id);t&&(d.E["9t-1Y-y"]=0,d.E["lx-y"]=!0,d.E["9t-x"]=0,d.E["9t-y"]=0,d.N7=ZC.1l(t[1]),d.qO=ZC.AT(d.A.AX.LG,d.N7),ZC.A4(2e.3o).3p(ZC.P.C1(ZC.1b[48]),d.MH),ZC.A4(2e.3o).3p(ZC.P.C1(ZC.1b[49]),d.X1))}},d.X1=1f(){1a e=d.N7,t=d.qO;if(d.N7=-1,d.qO=-1,d.E["lx-y"]=!1,2e.3o.1H.4O=d.IM,ZC.3l||(e=-1,t=-1),ZC.A4(2e.3o).3h(ZC.P.C1(ZC.1b[48]),d.MH),ZC.A4(2e.3o).3h(ZC.P.C1(ZC.1b[49]),d.X1),ZC.3l&&-1!==e){1k(1a i=d.A.AX.A7,n=d.A.AX.LG,a=0,l=i.1h;a<l;a++)i[a].o["1U-1N"]=i[a].o["1U-1N"]||{},1c===ZC.1d(i[a].o["1U-1N"].6H)&&(i[a].o["1U-1N"].6H=ZC.1l(i[a].o["z-2V"]||a+1));1k(1a o=i[e].o["1U-1N"].6H,r=-1,C=0,A=d.PX.1h;C<A;C++)d.E["9t-y"]-d.E["9t-1Y-y"]/2>d.PX[C].iY&&(r=C);1k(i[e].o["1U-1N"].6H=-1===r?.5:i[n[r]].o["1U-1N"].6H+.5,C=0,A=d.PX.1h;C<A;C++)r>t?i[C].o["1U-1N"].6H<i[e].o["1U-1N"].6H&&i[C].o["1U-1N"].6H>o&&i[C].o["1U-1N"].6H--:i[C].o["1U-1N"].6H>i[e].o["1U-1N"].6H&&i[C].o["1U-1N"].6H<o&&i[C].o["1U-1N"].6H++;1k(i[e].o["1U-1N"].6H=r>t?1A.4i(i[e].o["1U-1N"].6H):1A.4h(i[e].o["1U-1N"].6H),C=0,A=d.PX.1h;C<A;C++)d.A.o[ZC.1b[11]][C]["z-2V"]=i[C].o["1U-1N"].6H}d.A.AX.E["1B-3V"]=!0,ZC.3l=!1,d.3v(!1),d.A.K2()},ZC.A4("#"+d.K+"-9S").4c(ZC.P.C1("6Z"),d.r7).4c(ZC.P.C1("7B"),d.r5),ZC.A4("#"+d.K+"-3l-1M").4c(ZC.P.C1(ZC.1b[47]),d.YW),ZC.A4("#"+d.K+"-lA-1M").4c(ZC.P.C1("3F"),d.XO),ZC.A4("."+d.K+"-3b-1M").4c(ZC.P.C1("3F"),d.Y9),d.BQ.o.rD&&ZC.A4("."+d.A.K+"-1U-1N-1M").4c(ZC.1b[47],d.VL)}d.E.lW=1c,1===d.A.A.E["1U-qW"]||ZC.3l||(d.LY&&1c===ZC.1d(d.A.A.E["g"+d.A.L+"-1U-eo"])||d.A.A.E["g"+d.A.L+"-1U-eo"]&&!d.N4)&&(2u.5G(1f(){d.XO(!0)},0),d.A.A.E["g"+d.A.L+"-1U-eo"]=!0)}},gc:1f(){ZC.AO.gc(1g,["B5","D","PX","Z","C5","o","JO","HU","KG","FK","BQ","ZE","H","A","A2","NE","D2"])}}),ZC.vO=ZC.DS.C7({$i:1f(e){1g.b(e);1a t=1g;t.MS=1c,t.BA=1c,t.M=1c,t.JJ=0,t.BE=1c,t.G9="2a",t.KW=40,t.fS=[2,4]},1q:1f(){1a e,t=1g;if(t.4y([["z-2V","JJ","i"],["1h","KW","i"],["7e","fS"],["bB","G9"]]),1c===ZC.1d(t.o.6l)&&1c===ZC.1d(t.o.to)&&1c!==ZC.1d(t.o.x)&&1c!==ZC.1d(t.o.y)&&1c!==ZC.1d(t.o.1h)&&1c!==ZC.1d(t.o.2c)){1a i,n;i="2Y"==1w t.o.x?t.A.UX(t.o.x)[0]:ZC.1l(t.o.x),n="2Y"==1w t.o.y?t.A.UX(t.o.y)[1]:ZC.1l(t.o.y),t.o.6l={x:i+t.KW*ZC.EL(t.AA+180),y:n+t.KW*ZC.ED(t.AA+180)},t.o.to={x:i+t.KW*ZC.EL(t.AA),y:n+t.KW*ZC.ED(t.AA)}}1c!==ZC.1d(e=t.o.6l)&&(t.MS=1n ZC.DS(t.A),t.MS.1C(e),1c!==e.7r&&(t.MS.E.7r=e.7r),t.MS.1q(),"2Y"==1w e&&(t.MS.E.7r=e)),1c!==ZC.1d(e=t.o.to)&&(t.BA=1n ZC.DS(t.A),t.BA.1C(e),1c!==e.7r&&(t.BA.E.7r=e.7r),t.BA.1q(),"2Y"==1w e&&(t.BA.E.7r=e)),(1c!==ZC.1d(e=t.o.1G)||""!==t.o.1D&&1w t.o.1D!==ZC.1b[31])&&(t.M=1n ZC.DQ(t),t.M.1C(t.o),t.M.1C(e),t.M.1q()),t.b()},1v:1f(){1a e,t,i=1g;if(i.AL&&(1c!==i.MS||1c!==i.BA))if(i.AH<1&&(i.AH=1),!i.MS||1c===ZC.1d(e=i.MS.E.7r)||(t=i.A.UX(e),i.MS.iX=t[0],i.MS.iY=t[1],i.MS.iX+=i.MS.BJ,i.MS.iY+=i.MS.BD,ZC.DU(i.MS.iX,i.A.Q.iX-2,i.A.Q.iX+i.A.Q.I+2)&&ZC.DU(i.MS.iY,i.A.Q.iY-2,i.A.Q.iY+i.A.Q.F+2)))if(!i.BA||1c===ZC.1d(e=i.BA.E.7r)||(t=i.A.UX(e),i.BA.iX=t[0],i.BA.iY=t[1],i.BA.iX+=i.BA.BJ,i.BA.iY+=i.BA.BD,ZC.DU(i.BA.iX,i.A.Q.iX-2,i.A.Q.iX+i.A.Q.I+2)&&ZC.DU(i.BA.iY,i.A.Q.iY-2,i.A.Q.iY+i.A.Q.F+2))){1a n,a;if(i.MS&&i.BA)n=[i.MS.iX,i.MS.iY],a=[i.BA.iX,i.BA.iY];1t if(i.MS&&!i.BA)1P(n=[i.MS.iX,i.MS.iY],i.G9){1j"1u":a=[i.MS.iX,i.MS.iY+i.KW];1p;1j"2x":a=[i.MS.iX+i.KW,i.MS.iY];1p;1j"2a":a=[i.MS.iX,i.MS.iY-i.KW];1p;1j"1J":a=[i.MS.iX-i.KW,i.MS.iY]}1t if(!i.MS&&i.BA)1P(a=[i.BA.iX,i.BA.iY],i.G9){1j"1u":n=[i.BA.iX,i.BA.iY+i.KW];1p;1j"2x":n=[i.BA.iX-i.KW,i.BA.iY];1p;1j"2a":n=[i.BA.iX,i.BA.iY-i.KW];1p;1j"1J":n=[i.BA.iX+i.KW,i.BA.iY]}1a l,o=a[0]-n[0],r=a[1]-n[1],C=ZC.TF(1A.nR(r,o)),A=1A.5B(o*o+r*r),s=[];if(s.1i(n),l=ZC.AN.BM(n[0],n[1],i.AH/2,C+90),s.1i(l),l=ZC.AN.BM(l[0],l[1],A-i.fS[1]*i.AH/2,C),s.1i(l),l=ZC.AN.BM(l[0],l[1],i.fS[0]*i.AH/2,C+90),s.1i(l),s.1i(a),l=ZC.AN.BM(l[0],l[1],(2*i.fS[0]+2)*i.AH/2,C-90),s.1i(l),l=ZC.AN.BM(l[0],l[1],i.fS[0]*i.AH/2,C+90),s.1i(l),l=ZC.AN.BM(n[0],n[1],i.AH/2,C-90),s.1i(l),s.1i(n),i.BE=1n ZC.DS(i.A),i.BE.K=i.K,i.BE.Z=i.BE.C5=i.Z,i.BE.1Q(i),i.BE.D=s,i.BE.CX=!1,i.BE.1q(),i.BE.1v(),1c!==i.M&&i.M.AL){i.M.Z=i.Z,i.M.K=i.A.K+"-7G-1G-"+i.GX,i.M.GG=i.A.K+"-7G-1G zc-7G-1G";1a Z=ZC.AN.JK(n[0],n[1],a[0],a[1]);i.M.iX=Z[0],i.M.iY=Z[1],i.M.BJ-=i.M.I/2,i.M.BD-=i.M.F/2,1c!==ZC.1d(i.M.o["2p-2c"])&&"5n"===i.M.o["2p-2c"]&&(i.M.AA=C),i.M.1v(),i.M.EH()}}1t i.AL=!1;1t i.AL=!1}}),ZC.K1=ZC.C9.C7({$i:1f(e){1a t=1g;t.H=e,t.S0=!1,t.C4=1c,t.YJ=1c,t.PZ=1c,t.m8=1c},3h:1f(){1a e=1g;e.C4&&2u.9N(e.C4),e.YJ&&2u.9N(e.YJ),ZC.A4(2e.3o).3h("7R 4D 6k",e.PZ),ZC.A4(2e.3o).3h("5P",e.m8)},3p:1f(){1f e(){!Z&&c&&(c.E["2g-6D-1B"]=1c),ZC.K1.5R&&ZC.K1.5R[n]&&!ZC.K1.5R[n].jf&&ZC.K1.i3(n),Z=1c}1a t,i=1g,n=i.H.K,a=ZC.AK(n+"-2g-c"),l=ZC.P.E6(a,i.H.AB),o={},r={},C={},A={},s=1c,Z=1c,c=1c;ZC.2H||1c!==ZC.1d(ZC.YJ)||(i.YJ=2u.fH(1f(){1k(1a t=!0,a=0,l=1o.HP.1h;a<l;a++)if(n===1o.HP[a].K)if(ZC.AK(1o.HP[a].K+"-1u")){1a o=ZC.ak(n),r=ZC.A4("#"+1o.HP[a].K+"-1u").1Y();ZC.DT[0]>=r.1J&&ZC.DT[0]<=r.1J+1o.HP[a].I*o[0]&&ZC.DT[1]>=r.1u&&ZC.DT[1]<=r.1u+1o.HP[a].F*o[1]&&(t=!1)}1t 2u.9N(i.YJ);t&&(e(),ZC.K1.5R&&ZC.K1.5R[n]&&ZC.K1.5R[n].6D&&(ZC.AO.C2("vk",i.H,i.H.FH()),ZC.K1.5R[n].6D=!1))},na)),i.PZ=1f(u){if(1o.hg=u,!u.2T.id||-1===u.2T.id.1K("-2y-1N-")){1a p,h,1b,d,f,g,B,v,b,E,m,K,F,D,I,X,x,y,L,Y,w,M,H,N,S;ZC.3q,ZC.3q;1k(p=0;p<1o.HP.1h;p++)if(1o.HP[p].K!==i.H.K&&-1!==1o.HP[p].K.1K("-5T"))1m;if((ZC.6O||u.1I!==ZC.1b[48]||!ZC.bO)&&-1!==u.2T.id.1K(i.H.K+"-")&&(!ZC.3l||ZC.2H)){if(i.H.ZH||!ZC.AK(n+"-1u"))1m!1;if(!ZC.P.o7(ZC.AK(n+"-1u")))1m!1;1a O=[],P=ZC.P.M8(u),k=P[0],G=P[1];if(1c!==ZC.1d(u.dK)&&(k=u.dK),1c!==ZC.1d(u.i2)&&(G=u.i2),1c===ZC.1d(u.dK)&&1c===ZC.1d(u.i2)){1a z=ZC.A4("#"+n+"-1u").1Y();1b=k-z.1J,d=G-z.1u}1t 1b=k,d=G;1a T=ZC.ak(i.H.K);1k(1b/=T[0],d/=T[1],p=0,h=i.H.AI.1h;p<h;p++)f=i.H.AI[p].Q,ZC.DU(1b,f.iX-15,f.iX+f.I+15)&&ZC.DU(d,f.iY-15,f.iY+f.F+15)&&(Z=i.H.AI[p]),ZC.DU(1b,i.H.AI[p].iX,i.H.AI[p].iX+i.H.AI[p].I)&&ZC.DU(d,i.H.AI[p].iY,i.H.AI[p].iY+i.H.AI[p].F)&&(s=i.H.AI[p]);1a J=1c,Q=!1;if(Z){if(ZC.K1.5R=ZC.K1.5R||{},ZC.K1.5R[n]=ZC.K1.5R[n]||{},u.uj||(ZC.K1.5R[n].jf=!1,ZC.K1.5R[n].6D=!0),c=Z,Z.D0&&"2J"===Z.D0.o.7T){1c!==ZC.1d(Z.E["2g-6D-1B"])&&(J=Z.E["2g-6D-1B"]);1a W=/(.+)-cu-1B-(.+)-2o-(.+)/.3j(u.2T.id);if(W&&W.1h&&(J=5w(W[2],10),Z.E["2g-6D-1B"]=J),1c===ZC.1d(J))1m}if(!Z.eH)1m 8j e();1k(O.1i(Z),Z&&Z.D0&&(Q=1c!==ZC.1d(Z.D0.o.6a)&&ZC.2q(Z.D0.o.6a)),p=0,h=i.H.AI.1h;p<h;p++)if(i.H.AI[p]!==Z){f=i.H.AI[p].Q;1a R=i.H.AI[p].D0,V=i.H.AI[p].K5,U=R&&1c!==ZC.1d(R.o.6a)&&ZC.2q(R.o.6a);U&&("xy"===Z.AJ.3t&&"xy"===i.H.AI[p].AJ.3t&&(R||V)&&ZC.DU(1b,f.iX-5,f.iX+f.I+5)&&(ZC.DU(d,f.iY-5,f.iY+f.F+5)||Q&&U)||"yx"===Z.AJ.3t&&"yx"===i.H.AI[p].AJ.3t&&(R||V)&&ZC.DU(d,f.iY-5,f.iY+f.F+5)&&(ZC.DU(1b,f.iX-5,f.iX+f.I+5)||Q&&U))&&O.1i(i.H.AI[p])}}1t if(ZC.K1.5R)1k(1a j in ZC.K1.5R)if(ZC.K1.5R[j]&&ZC.K1.5R[j].6D){1a q=1o.79(j);H=q.FH(),ZC.AO.C2("vk",q,H),ZC.K1.5R[j].6D=!1}if(0===O.1h&&(o={},r={},C={},i.S0&&(1c===ZC.1d(u.dK)&&e(),i.S0=!1),c&&c.A.A8&&s&&s.K!==c.K&&c.A.A8.5c()),O.1h>0){i.S0=!0;1k(1a $=!1,ee=0,te=O.1h;ee<te;ee++){1a ie=!1;if(1c===ZC.1d(o[ee])&&(o[ee]={}),1c===ZC.1d(r[ee])&&(r[ee]={}),1c===ZC.1d(C[ee])&&(C[ee]={}),(O[ee].D0||O[ee].K5)&&"9i"===O[ee].M7){1a ne,ae=[],le=[],oe=[],re=!1,Ce="",Ae=[],se=[],Ze=[],ce=[],ue={},pe={},he=[];f=O[ee].Q;1a 6m=O[ee].D0&&1c!==ZC.1d(O[ee].D0.o.np)&&ZC.2q(O[ee].D0.o.np),de=-1;O[ee].D0&&(de=ZC.1l(ZC.7O(O[ee].D0.o.a1||-1))),ZC.3q,ZC.3q;1a fe=!0,ge=[],Be="";O[ee].D0&&(1c!==ZC.1d(O[ee].D0.o["1B-1G"])&&ZC.1d(1c!==(t=O[ee].D0.o["1B-1G"].a7))&&(fe=ZC.2q(t)),1c!==ZC.1d(O[ee].D0.o["1S-1G"])&&ZC.1d(1c!==(t=O[ee].D0.o["1S-1G"].a7))&&(fe=ZC.2q(t)));1a ve,be;1k(Y=0,w=O[ee].AX.A7.1h;Y<w;Y++)if(!O[ee].AX.A7[Y].LN&&(p=Y,O[ee].D0&&O[ee].D0.o["9m-ek"]&&(p=w-Y-1),O[ee].E["1B"+p+".2f"])){if(1c!==ZC.1d(J)&&p!==J)dO;if(!(ve=O[ee].BL(O[ee].AX.A7[p].BT("k")[0])))dO;if(ve.D9){1a Ee=ve.AR?ve.iY+ve.BV:ve.iY+ve.A6,me=ve.AR?ve.iY+ve.F-ve.BV:ve.iY+ve.F-ve.A6;d=ZC.5m(d,Ee,me),g=ve.EC&&O[ee].AX.A7[p].EC?ve.O4(d,O[ee].AX.A7[p]):ve.O4(d)}1t{1a Ke=ve.AR?ve.iX+ve.BV:ve.iX+ve.A6,Fe=ve.AR?ve.iX+ve.I-ve.A6:ve.iX+ve.I-ve.BV;1b=ZC.5m(1b,Ke,Fe),g=ve.EC&&O[ee].AX.A7[p].EC?ve.O4(1b,O[ee].AX.A7[p]):ve.O4(1b)}if(1c===ZC.1d(g))dO;1a De=[];if(De=1w g.1h===ZC.1b[31]||0===g.1h?[g]:g,O[ee].D0){1k(1a Ie=0,Xe=De.1h;Ie<Xe;Ie++)if(g=De[Ie],B=O[ee].AX.A7[p].FO(g)){ne=B,B.2E(),B.N?(ZC.ay=[B.N.BZ,B.N.A0,B.N.AC,B.N.BU,B.N.B6],B.N3&&ZC.ay.1i(B.N3.A0,B.N3.AC,B.N3.BU,B.N3.B6)):ZC.ay=[],B.A.IJ&&1w B.E.hu!==ZC.1b[31]&&B.1v(!0),D=B.iX,I=B.iY,1w B.E.hu!==ZC.1b[31]&&(D=5w(B.E.hu,10)),1w B.E.jw!==ZC.1b[31]&&(I=5w(B.E.jw,10)),K=D,F=I,ue[p]={2V:g,y:I},O[ee].BC&&O[ee].BC.XI&&(O[ee].BC.3v(!0),O[ee].BC.1q(),O[ee].BC.EJ-=O[ee].BC.KZ,O[ee].BC.iY-=O[ee].BC.KZ,O[ee].BC.KZ=0,O[ee].BC.1v(g)),(v=1n ZC.DQ(ve)).Z=v.C5=a,v.K=O[ee].K+"-2g-1G-"+g+"-"+p,v.GG=O[ee].A.K+"-2g-1G "+O[ee].K+"-2g-1G zc-2g-1G",fe&&(L=B.jo(),v.AP=B.A.JT),fe?v.1C(O[ee].D0.o["1B-1G[a7]"]):v.1C(O[ee].D0.o["1B-1G[bq]"]),v.1C(O[ee].D0.o["1B-1G"]),v.1C(O[ee].D0.o["1S-1G"]),v.1C(O[ee].AX.A7[p].o["2g-1G"]),m=ZC.AO.OS(v.o,O[ee].AX.A7[p].o),v.KC=1f(e){1m B?B.KC(e,m):e},B.iF();1a xe="3e";if(1c!==ZC.1d(t=v.o[ZC.1b[7]])&&(xe=t),v.E[ZC.1b[7]]=xe,v.KN=fe,v.E.7i=B.A.L,v.E.7l=B.L,v.1q(),M=1c!==ZC.1d(v.o.6T)?ZC.1l(v.o.6T):6,v.E4&&v.E4.1h&&(v.JC=1f(e){1m e=B?B.KC(e,m):e.1E(/(%i)|(%2o-2V)/g,g)},v.DD()&&v.1q()),v.IA&&B&&(v.H9(v,v,1c,B.MK(1c,!1),v.OC),v.1q()),ZC.DU(B.iX,f.iX-.5,f.iX+f.I+.5)){1P(fe||(0===le.1h&&(1c===ZC.1d(v.o["5S-1D"])||re||(re=!0,Be+=B.KC(v.o["5S-1D"],m)+"<br>"),1c!==ZC.1d(v.o["9P-1D"])&&""===Ce&&(Ce=B.KC(v.o["9P-1D"],m)+"<br>")),v.AL&&""!==v.AP&&(ZC.2q(v.o["bq-1D"])?ge.1i(B.KC(v.AP,m)):ge.1i(B.KC(v.AP,m)+"<br>"))),v.E.uB=le.1h,v.E["2o-1S"]=B.CM,v.E["1O-x"]=D,v.E["1O-y"]=I,v.E["2g-1H"]=B.jo(),xe){2n:1c===ZC.1d(v.o.x)?ve.D9?B.iY<=f.iY+f.F/2?(v.iY=I-v.F-M,v.EQ="2a"):(v.iY=I+M,v.EQ="1u"):B.iX>=f.iX+f.I/2?(v.iX=D-v.I-M,v.EQ="2x"):(v.iX=D+M,v.EQ="1J"):v.iX-=f.iX,1c===ZC.1d(v.o.y)?ve.D9?(v.iX=D-v.I/2,v.iX<f.iX&&(v.iX=f.iX),v.iX+v.I>f.iX+f.I&&(v.iX=f.iX+f.I-v.I)):(v.iY=I-v.F/2,v.iY<f.iY&&(v.iY=f.iY),v.iY+v.F>f.iY+f.F&&(v.iY=f.iY+f.F-v.F)):v.iY-=f.iY,v.DI=[D,I];1p;1j"1J":v.iX=D-v.I-M,v.iY=I-v.F/2,v.DI=[D,I];1p;1j"2x":v.iX=D+M,v.iY=I-v.F/2,v.DI=[D,I];1p;1j"1u":ve.D9?(v.iX=f.iX+f.I-v.I,v.iY=I-v.F/2,v.EQ="1J",v.DI=[f.iX+f.I-v.I-M,I]):(v.iX=D-v.I/2,v.iY=f.iY,v.EQ="2a",v.DI=[D,v.iY+v.F+M]);1p;1j"2o-1u":ve.D9?(v.iX=D+2*M,v.iY=I-v.F/2,v.EQ="1J",v.DI=[D+M,I]):(v.iX=D-v.I/2,v.iY=I-v.F-2*M,v.EQ="2a",v.DI=[D,I-M]);1p;1j"2a":ve.D9?(v.iX=f.iX,v.iY=I-v.F/2,v.EQ="2x",v.DI=[f.iX+v.I+M,I]):(v.iX=D-v.I/2,v.iY=f.iY+f.F-v.F,v.EQ="1u",v.DI=[D,v.iY-M])}ae.1i({3S:B.A.L,5Q:B.L,hF:B.BX||ve.W[B.L],1S:B.AE,1D:v.AP,x:v.iX,y:v.iY,15s:D,15r:I}),-1===ZC.AT(oe,v.AP)&&(A[v]=B,oe.1i(v.AP)),ve.D9?v.E.8A=6m||-1!==de?ZC.2i(I-d):-1:v.E.8A=6m||-1!==de?ZC.2i(D-1b):-1,v.AL&&le.1i(v),r[ee][p]=v,ie=!0}}if(!B)dO}1a ye,Le,Ye,we,Me,He,Ne,Se;if(O[ee].D0&&ZC.DU(B.iX,f.iX-1,f.iX+f.I+1)){if(E=1n ZC.DQ(ve),E.Z=E.C5=a,E.K=O[ee].K+"-2g-1z-x-1G-"+p,E.GG=O[ee].A.K+"-2g-1G "+O[ee].K+"-2g-1G zc-2g-1G",E.A0=E.AC=ve.B6,E.BZ=O[ee].AJ["3d"]?"#4J":"#2O",E.1C(O[ee].D0.o["1z-1G"]),E.1C(O[ee].D0.o[ve.BB+"-1G"]),E.1C(O[ee].AX.A7[p].o["1z-1G"]),E.KN=!0,E.E.7l=B.L,m=ZC.AO.OS(E.o),E.KC=1f(e){e=ve.KC(e,g,ve.EC&&O[ee].AX.A7[p].EC?O[ee].AX.A7[p]:1c,m,!0);1a t=O[ee].AX.A7[p].L8;if(B&&t)1k(1a i in t){1a n;n=t[i]3z 3K?ZC.7O(t[i][B.L],""):ZC.7O(t[i],""),e=e.1E("%1T-"+i,n,"g")}1m e},E.1q(),M=1c!==ZC.1d(E.o.6T)?ZC.1l(E.o.6T):6,E.E4&&E.E4.1h&&(E.JC=1f(e){1m e=B?B.KC(e,m):e.1E(/(%i)|(%2o-2V)/g,g)},E.DD()&&E.1q()),E.IA&&B&&(E.H9(E,E,1c,B.MK(1c,!1),E.OC),E.1q()),pe[ve.BB]=E.AP,ye=ZC.2q(E.o["6B-2G"]),Le=E.o.x,Ye=E.o.y,"5u"!==ve.B7?ve.D9?(we="2x",He=ve.E.iX-E.I-M,Me=[ve.E.iX,F],Ne=F-E.F/2):(we="1u",He=K-E.I/2,Me=[K,ve.E.iY],Ne=ve.E.iY+M):ve.D9?(we="1J",He=ve.E.iX+M,Me=[ve.E.iX,F],Ne=F-E.F/2):(we="2a",He=K-E.I/2,Me=[K,ve.E.iY],Ne=ve.E.iY-E.F-M),ye||(E.EQ=we),Le||(E.iX=He),ye||Le||Ye||(E.DI=Me),Ye||(E.iY=Ne),E.AL&&ve.AL&&""!==E.AP){1a Oe=!1;if(he.1h)1k(1a Pe=0;Pe<he.1h;Pe++)E.AP+"@"+ve.BB===he[Pe]&&(Oe=!0);Oe||(he.1i(E.AP+"@"+ve.BB),ve.D9?E.E.8A=6m||-1!==de?ZC.2i(F-d):-1:E.E.8A=6m||-1!==de?ZC.2i(K-1b):-1,Ze.1i(E)),ce.1i(ve.BB),C[ee][p]=E,ie=!0}-1!==5X(O[ee].D0.o[ZC.1b[4]]).1K("%")&&(Se=ZC.IB(O[ee].D0.o[ZC.1b[4]]))>0&&Se<=1&&(O[ee].D0.AY=ZC.1l(Se*ve.A9)),ve.D9?Ae.1i([6m||-1!==de?ZC.2i(F-d):-1,[1c,[ve.E.iX,F],[O[ee].Q.iX+("5u"===ve.B7?0:O[ee].Q.I),F]]]):Ae.1i([6m||-1!==de?ZC.2i(K-1b):-1,[1c,[K,ve.E.iY],[K,O[ee].Q.iY+("5u"===ve.B7?O[ee].Q.F:0)]]])}if(be=O[ee].BL(O[ee].AX.A7[p].BT("v")[0]),-1===ZC.AT(ce,be.BB)&&O[ee].K5&&("xy"===O[ee].AJ.3t&&ZC.DU(d,be.iY,be.iY+be.F)||"yx"===O[ee].AJ.3t&&ZC.DU(d,be.iX,be.iX+be.I))){1a ke="bq";O[ee].K5.o.1I&&"a7"===O[ee].K5.o.1I&&(ke="a7"),"a7"===ke&&1c!==ZC.1d(ue[p])&&(be.D9?1b=ue[p].x:d=ue[p].y),(E=1n ZC.DQ(be)).Z=E.C5=a,E.K=O[ee].K+"-2g-1z-y-1G-"+p,E.GG=O[ee].A.K+"-2g-1G "+O[ee].K+"-2g-1G zc-2g-1G";1a Ge=be.B6;"a7"===ke&&(Ge=O[ee].AX.A7[p].B6),E.A0=E.AC=Ge,E.BZ=O[ee].AJ["3d"]&&"a7"!==ke?"#4J":"#2O",E.1C(O[ee].K5.o["1z-1G"]),E.1C(O[ee].K5.o[be.BB+"-1G"]),E.KN=!0;1a ze=be.D9?be.N8(1b,!0):be.N8(d,!0),Te=ze;m=be.MG(),ZC.2A(ZC.AO.OS(E.o,be.o),m),1c===ZC.1d(m[ZC.1b[12]])&&(m[ZC.1b[12]]=0),ze=be.G0(0,ze,m),E.o.1D=ze,E.1q(),M=1c!==ZC.1d(E.o.6T)?ZC.1l(E.o.6T):6,E.E4&&E.E4.1h&&(E.JC=1f(e){1m e=e.1E(/(%v)|(%1z-1S)/g,Te).1E(/(%t)|(%1z-1D)/g,ze).1E(/(%mu)/,be.D9?1b:d)},E.DD()&&E.1q()),E.IA&&B&&(E.H9(E,E,1c,{1S:Te,1D:ze,mu:be.D9?1b:d},E.OC),E.1q()),pe[be.BB]=E.AP,ye=ZC.2q(E.o["6B-2G"]),Le=E.o.x,Ye=E.o.y,"5u"!==be.B7?be.D9?(we="1u",He=1b-E.I/2,Ne=be.E.iY+M,Me=[1b,be.E.iY]):(we="2x",He=be.E.iX-E.I-M,Ne=d-E.F/2,Me=[be.E.iX,d]):be.D9?(we="2a",He=1b-E.I/2,Ne=be.E.iY-E.F-M,Me=[1b,be.E.iY]):(we="1J",He=be.E.iX+M,Ne=d-E.F/2,Me=[be.E.iX,d]),ye||(E.EQ=we),Le||(E.iX=He),ye||Le||Ye||(E.DI=Me),Ye||(E.iY=Ne),E.AL&&be.AL&&(E.E.8A=-1,Ze.1i(E),"a7"===ke&&1c!==ZC.1d(ue[p])||ce.1i(be.BB),C[ee][p]=E,ie=!0),-1!==5X(O[ee].K5.o[ZC.1b[4]]).1K("%")&&(Se=ZC.IB(O[ee].K5.o[ZC.1b[4]]))>0&&Se<=1&&(O[ee].K5.AY=ZC.1l(Se*be.A9)),be.D9?se.1i(1c,[1b,be.E.iY],[1b,O[ee].Q.iY+("5u"===be.B7?O[ee].Q.F:0)]):se.1i(1c,[be.E.iX,d],[O[ee].Q.iX+("5u"===be.B7?0:O[ee].Q.I),d])}}1k(b=ZC.3q,p=0,h=le.1h;p<h;p++)le[p].E.8A>=0&&(b=ZC.CV(le[p].E.8A,b));-1!==de&&(b=ZC.BN(b,de));1a Je=!1,Qe=1,We=!1;le[0]&&(We=ZC.2q(le[0].o["bq-1D"]),le[0].o["6q-oE"]&&ZC.2q(le[0].o["4a-4B"])&&(Je=!0,Qe=ZC.1l(le[0].o["6q-oE"]||"1"),Be+=\'<6q 3g="zc-2g-1G-6q \'+i.H.K+\'-2g-1G-6q">\')),!fe&&le.1h>0&&("uD"!==le[0].o["3V-by-1S"]&&"15E"!==le[0].o["3V-by-1S"]||le.3V(1f(e,t){1m(e.E["2o-1S"]-t.E["2o-1S"])*("uD"===le[0].o["3V-by-1S"]?1:-1)}));1a Re=0;1k(N=0,S=le.1h;N<S&&(!(-1===le[N].E.8A||le[N].E.8A<=b)||(Je?(Re%Qe==0&&(Be+="<tr>"),Be+="<td>"+ge[N]+"</td>",Re%Qe==Qe-1&&(Be+="</tr>"),Re++):Be+=ge[le[N].E.uB],Je||!We));N++);if(Je&&(Re%Qe!=Qe-1&&(Be+="</tr>"),Be+="</6q>"),""!==Ce&&(Be+=Ce),!fe&&le.1h>0&&(1b=D=K,d=I=F,""!==Be&&(le[0].o.1D=Je||We?Be:Be.2s(0,Be.1h-4),le[0].1q()),M=1c!==ZC.1d(v.o.6T)?ZC.1l(v.o.6T):6,1c===ZC.1d(v.o.x)?ve.D9?1b<O[ee].iX+O[ee].I/2?le[0].iX=1b+M+14:le[0].iX=1b-le[0].I-M-14:ne&&ne.iX>=f.iX+f.I/2?le[0].iX=D-le[0].I-M:le[0].iX=D+M:le[0].iX-=f.iX,1c===ZC.1d(v.o.y)?ve.D9?ne&&ne.iY>=f.iY+f.F/2?le[0].iY=I-le[0].F-M:le[0].iY=I+M:d<O[ee].iY+O[ee].F/2?le[0].iY=d+M+14:le[0].iY=d-le[0].F-M-14:le[0].iY-=f.iY),ie){1a Ve=-1,Ue=-1;if($||(1c===ZC.1d(u.dK)&&e(),$=!0),Ae.1h>0){1a je=[];1k(b=ZC.3q,X=0,x=Ae.1h;X<x;X++)Ae[X][0]>=0&&(b=ZC.CV(Ae[X][0],b));1k(-1!==de&&(b=ZC.BN(b,de)),X=0,x=Ae.1h;X<x;X++)1c!==ZC.1d(Ae[X])&&(-1===Ae[X][0]||Ae[X][0]<=b)&&(O[ee].D0&&O[ee].D0.o["bq-1y"]&&ZC.2q(O[ee].D0.o["bq-1y"])?(je=[].4w(Ae[X][1]),"xy"===O[ee].AJ.3t?Ve=ZC.4t(Ae[X][1][1][0]):"yx"===O[ee].AJ.3t&&(Ue=ZC.4t(Ae[X][1][1][1]))):je=je.4w(Ae[X][1]));if(O[ee].D0.o.4K){1a qe=-1;je.1h>1&&je[1]&&(qe=je[1][0]||-1),O[ee].D0.9G||(O[ee].D0.9G=1n ZC.HQ(O[ee]),O[ee].D0.9G.1C({"1R-1r":"#2O",2k:.85}),O[ee].D0.9G.1C(O[ee].D0.o.4K),O[ee].D0.9G.Z=a,O[ee].D0.9G.1q()),O[ee].D0.9G.iX=qe,O[ee].D0.9G.iY=O[ee].Q.iY,O[ee].D0.9G.I=1A.1V(2,O[ee].Q.iX+O[ee].Q.I-qe+2),O[ee].D0.9G.F=O[ee].Q.F,O[ee].D0.9G.1v()}if(O[ee].AJ["3d"])1k(O[ee].NW(),X=0,x=je.1h;X<x;X++)je[X]&&(y=1n ZC.CF(O[ee],je[X][0]-ZC.AM.E1,je[X][1]-ZC.AM.E0,0),je[X][0]=y.E9[0],je[X][1]=y.E9[1]);O[ee].D0.K=O[ee].K+"-9w-x",ZC.CN.1v(l,O[ee].D0,je)}if(se.1h>0){if(O[ee].AJ["3d"])1k(O[ee].NW(),X=0,x=se.1h;X<x;X++)1c!==ZC.1d(se[X])&&(y=1n ZC.CF(O[ee],se[X][0]-ZC.AM.E1,se[X][1]-ZC.AM.E0,0),se[X][0]=y.E9[0],se[X][1]=y.E9[1]);ZC.CN.1v(l,O[ee].K5,se)}if(fe){1k(p=le.1h-1;p>=0;p--)ZC.DU(le[p].DI[0],f.iX-5,f.iX+f.I+5)&&ZC.DU(le[p].DI[1],f.iY-5,f.iY+f.F+5)||le.6p(p,1);if(le.1h>1)1k(1a $e=!0;$e;)1k($e=!1,p=0;p<le.1h-1;p++)if(le[p].AL&&(be.D9&&le[p].iX>le[p+1].iX||!be.D9&&le[p].iY>le[p+1].iY)){1a et=le[p];le[p]=le[p+1],le[p+1]=et,$e=!0}if(le.1h>0){1a tt=[],it=[];1k(p=0;p<le.1h;p++)1c!==ZC.1d(le[p].o.x)&&1c!==ZC.1d(le[p].o.y)&&it.1i(le[p]);1k(1a nt,at,lt,ot=!0,rt=0,Ct=le.1h*le.1h;ot&&rt<Ct;)1k(rt++,ot=!1,p=0;p<le.1h-1;p++)if(le[p].AL&&-1===ZC.AT(it,le[p]))if(ve.D9){if(le[p+1].iX<le[p].iX+le[p].I){if(le[p+1].iX-le[p].I-4<f.iX&&-1===ZC.AT(tt,le[p])&&(tt.1i(le[p]),le[p].iX=f.iX),le[p+1].iX=le[p].iX+le[p].I+4,le[p+1].iX+le[p+1].I>f.iX+f.I)1k(lt=le[p+1].iX-(f.iX+f.I-le[p+1].I),nt=0,at=le.1h;nt<at;nt++)le[nt].iX-lt>=f.iX?le[nt].iX-=lt:(le[nt].iX=f.iX,nt>0&&(le[p+1].E["1O-y"]<f.iY+f.F/2?le[nt].iY=le[nt-1].iY+le[nt-1].F+4:le[nt].iY=le[nt-1].iY-le[nt].F-4));ot=!0}}1t if(le[p+1].iY<le[p].iY+le[p].F){if(le[p+1].iY-le[p].F-4<f.iY&&-1===ZC.AT(tt,le[p])&&(tt.1i(le[p]),le[p].iY=f.iY),le[p+1].iY=le[p].iY+le[p].F+4,le[p+1].iY+le[p+1].F>f.iY+f.F)1k(lt=le[p+1].iY-(f.iY+f.F-le[p+1].F),nt=0,at=le.1h;nt<at;nt++)le[nt].iY-lt>=f.iY?le[nt].iY-=lt:(le[nt].iY=f.iY,nt>0&&(le[p+1].E["1O-x"]<f.iX+f.I/2?le[nt].iX=le[nt-1].iX+le[nt-1].I+4:le[nt].iX=le[nt-1].iX-le[nt].I-4));ot=!0}}}1a At=!1;1k(p=0,h=Ze.1h;p<h;p++)if(-1===Ze[p].E.8A||Ze[p].E.8A<=b){1a st=Ze[p];O[ee].AJ["3d"]&&(O[ee].NW(),y=1n ZC.CF(O[ee],st.iX+st.I/2-ZC.AM.E1,st.iY+st.F/2-ZC.AM.E0,0),st.iX=y.E9[0]-st.I/2,st.iY=y.E9[1]-st.F/2,y=1n ZC.CF(O[ee],st.DI[0]-ZC.AM.E1,st.DI[1]-ZC.AM.E0,0),st.DI[0]=y.E9[0],st.DI[1]=y.E9[1]),O[ee].D0&&O[ee].D0.o["bq-1y"]&&ZC.2q(O[ee].D0.o["bq-1y"])?("xy"===O[ee].AJ.3t&&Ve===ZC.4t(st.iX+st.I/2)||"yx"===O[ee].AJ.3t&&Ue===ZC.4t(st.iY+st.F/2))&&!At&&(st.1v(),At=!0):st.1v()}1k(b=ZC.3q,N=0,S=le.1h;N<S;N++)le[N].E.8A>=0&&(b=ZC.CV(le[N].E.8A,b));1k(-1!==de&&(b=ZC.BN(b,de)),Y=0,N=0,S=le.1h;N<S;N++)if(-1===le[N].E.8A||le[N].E.8A<=b){1a Zt=ZC.DU(le[N].DI[0],f.iX-5,f.iX+f.I+5)&&ZC.DU(le[N].DI[1],f.iY-5,f.iY+f.F+5);if(!fe||Zt){if(le[N].AL){1P(le[N].E[ZC.1b[7]]){1j"1u":ve.D9?le[N].DI[0]=le[N].iX-le[N].G1:le[N].DI[1]=le[N].iY+le[N].F+le[N].G1;1p;1j"2a":ve.D9?le[N].DI[0]=le[N].iX+le[N].I+le[N].G1:le[N].DI[1]=le[N].iY-le[N].G1}if(-1!==ZC.AT(["1u","2a"],le[N].E[ZC.1b[7]])){1a ct=le[N].iX+le[N].I/2;le[N].iX=ZC.BN(le[N].iX,0),le[N].iX=ZC.CV(le[N].iX,i.H.I-le[N].I),le[N].iY=ZC.BN(le[N].iY,0),le[N].iY=ZC.CV(le[N].iY,i.H.F-le[N].F),1c===ZC.1d(le[N].o["6B-1Y"])&&(le[N].EU=5w(100*(ct-le[N].iX-le[N].I/2)/(le[N].I-le[N].H0),10))}if(O[ee].AJ["3d"]&&(O[ee].NW(),y=1n ZC.CF(O[ee],le[N].iX+le[N].I/2-ZC.AM.E1,le[N].iY+le[N].F/2-ZC.AM.E0,0),le[N].iX=y.E9[0]-le[N].I/2,le[N].iY=y.E9[1]-le[N].F/2,y=1n ZC.CF(O[ee],le[N].DI[0]-ZC.AM.E1,le[N].DI[1]-ZC.AM.E0,0),le[N].DI[0]=y.E9[0],le[N].DI[1]=y.E9[1],"1J"===le[N].EQ?le[N].iX=le[N].DI[0]+M:le[N].iX=le[N].DI[0]-le[N].I-M),O[ee].AJ["3d"]||fe||0!==Y||(le[N].iX=ZC.BN(f.iX-5,le[N].iX),le[N].iY=ZC.BN(f.iY-5,le[N].iY),le[N].iX=ZC.CV(f.iX+f.I-le[N].I+5,le[N].iX),le[N].iY=ZC.CV(f.iY+f.F-le[N].F+5,le[N].iY)),fe||!fe&&0===Y){1a ut=fe?N:0;(!fe||"3a"===i.H.AB&&le[ut].o["1R-4d"]&&""!==le[ut].o["1R-4d"])&&le[ut].1q(),le[ut].1v(),Y++}}if(Zt){1a pt=1n ZC.DS(i);if(i.H.B9.2t(pt.o,"("+O[ee].AF+").2g.1O"),pt.K=le[N].K+"-1O",pt.Z=pt.C5=a,pt.iX=le[N].E["1O-x"],pt.iY=le[N].E["1O-y"],O[ee].AJ["3d"]&&(O[ee].NW(),y=1n ZC.CF(O[ee],pt.iX-ZC.AM.E1,pt.iY-ZC.AM.E0,0),pt.iX=y.E9[0],pt.iY=y.E9[1]),L=le[N].E["2g-1H"],pt.A0=pt.AC=ZC.AO.JE(L[ZC.1b[0]]),pt.BU=L.1r,pt.1C(O[ee].D0.o.1O),pt.1C(O[ee].AX.A7[le[N].E.7i].o["2g-1O"]),"5n"===pt.o.1I){1a ht=O[ee].AX.A7[le[N].E.7i];ht.A2&&ht.A2.o.1I&&(pt.o.1I=ht.A2.o.1I)}pt.1q(),pt.AL&&"1Z"!==pt.DP&&pt.AH>1&&pt.1v()}}}(H=O[ee].HX()).2z=ae,H.2g={x:D,y:I},H.ev=u,H["1z-1G"]=pe,ZC.AO.C2("uS",i.H,H),O[ee].QF(!0)}1t(H={}).2g={x:D,y:I},H.ev=u,ZC.AO.C2("uS",i.H,H)}}}}}},i.m8=1f(){0!==1o.3G.og&&2u.5G(1f(){e()},ZC.1l(1o.3G.og))},ZC.A4(2e.3o).3p("7R 4D 6k",i.PZ),ZC.A4(2e.3o).3p("5P",i.m8)}}),ZC.K1.i3=1f(e){1a t=1o.79(e);if(t){1o.hg=1c;1a i=ZC.AK(e+"-2g-c"),n=ZC.A4(i).1s(),a=ZC.A4(i).1L();ZC.A4("."+e+"-2g-1G").3m(),ZC.P.IL(i,t.AB,0,0,n,a),ZC.A4("#"+e+"-lX").9s().4Z(1f(){1g.id&&-1!==1g.id.1K("-2g-1G-")&&ZC.P.ES(1g.id)})}},1o.mf("17z",1f(e,t){"2Y"==1w(t=t||{})&&(t=3c.1q(t)),ZC.K1.5R[e]=ZC.K1.5R[e]||{},ZC.K1.5R[e].jf=!1,ZC.K1.i3(e)}),1o.mf("17y",1f(e,t){"2Y"==1w(t=t||{})&&(t=3c.1q(t));1a i,n,a=1o.79(e),l=a.C8(t[ZC.1b[3]]),o=l.BL(ZC.1b[50]);"xy"===l.AJ.3t?(i=t.x||o.B2(t.hF),n=l.iY+l.F/2):(i=l.iX+l.I/2,n=t.y||o.B2(t.hF));1a r={dK:i,i2:n,1I:ZC.2H?"4D":ZC.1b[48],2T:{id:e+"-5U"}};ZC.K1.5R=ZC.K1.5R||{},ZC.K1.5R[e]=ZC.K1.5R[e]||{},ZC.K1.5R[e].jf=!0,ZC.K1.i3(e),r.uj=!0,a.D5.PZ(r)}),ZC.uq=ZC.C9.C7({$i:1f(e,t){1a i=1g;i.o=1c,i.C=e,i.NP=t},1q:1f(){1a e,t=1g;t.o=t.C.o;1a i,n,a,l,o,r,C,A,s,Z=t.NP,c="\\r\\n",u=",",p=!1,h=1c,1b=1c,d=1c,f=1c,g=1c,B=!1,v=!1,b=1c,E={};if(1c!==ZC.1d(e=t.o["ig-6K"])&&(E=e),1c!==ZC.1d(e=t.o.6K)&&(E=e),1c!==ZC.1d(e=E.8P)&&(u=e),1c!==ZC.1d(e=E.vh)&&(p=ZC.2q(e)),1c!==ZC.1d(e=E.5F)&&(h=ZC.2q(e)),1c!==ZC.1d(e=E["2Y-6g"])&&(v=ZC.2q(e)),p?(1c!==ZC.1d(e=E["cd-cb"])&&(d=ZC.2q(e)),1c!==ZC.1d(e=E["9r-cb"])&&(1b=ZC.2q(e))):(1c!==ZC.1d(e=E["cd-cb"])&&(1b=ZC.2q(e)),1c!==ZC.1d(e=E["9r-cb"])&&(d=ZC.2q(e))),1c!==ZC.1d(e=E["eK-3w"])&&(f=ZC.2q(e)),1c!==ZC.1d(e=E["17x-3w"])&&(g=ZC.2q(e)),1c!==ZC.1d(e=E["17w-5K"])&&(B=ZC.2q(e)),1c!==ZC.1d(e=E.oE)&&(b=e),1c!==ZC.1d(b)&&b.1h>0){i=[],1c!==ZC.1d(e=E["5j-8P"])?c=e:Z.2l(/\\n/).1h>0?c="\\n":Z.2l(/\\r/).1h>0&&(c="\\r");1a m=Z.2l(c),K=0;1k(l=0,o=m.1h;l<o;l++)if(""!==m[l].1E(/\\s+/g,"")){i[K]=[];1k(1a F=0,D=0;F<m[l].1h-1;)a=m[l].2s(F,F+b[D]),i[K].1i(a),F+=b[D],D++;K++}}1t{i=[[]],n=1c!==ZC.1d(e=E["5j-8P"])?1n 5o("(\\\\"+u+"|"+e+\'|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\\\\'+u+e+"]*))","gi"):1n 5o("(\\\\"+u+\'|\\\\r?\\\\n|\\\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\\\\'+u+"\\\\r\\\\n]*))","gi");1k(1a I=1c;I=n.3j(Z);){1a X=I[1];X.1h&&X!==u&&i.1i([]),a=I[2]?I[2].1E(1n 5o(\'""\',"g"),\'"\'):I[3],i[i.1h-1].1i(a)}}1a x=[];1k(l=0,o=i.1h;l<o;l++)0!==i[l].2I("").1E(/\\s+/g,"").1h&&x.1i(i[l]);1a y=0,L=0;if((1c===ZC.1d(h)||h)&&(x.1h>1&&1===x[0].1h?(1c===ZC.1d(t.o.5F)?t.o.5F={1D:x[0][0]}:1c===ZC.1d(t.o.5F.1D)&&(t.o.5F.1D=x[0][0]),h=!0):h=!1),h&&y++,p){1k(i=[],h&&i.1i(x[0]),r=y,C=x.1h;r<C;r++)1k(A=0,s=x[r].1h;A<s;A++)1c===ZC.1d(i[A+y])&&(i[A+y]=[]),i[A+y].1i(x[r][A]);x=i}if("1f"==1w 1o.um)1k(r=0,C=x.1h;r<C;r++)1k(A=0,s=x[r].1h;A<s;A++)x[r][A]=1o.um.4s(1g,x[r][A],r,A,t.C.A.K);1a Y=0;1k(l=0,o=x.1h;l<o;l++)Y=ZC.BN(Y,x[l].1h);1a w=[];if(1c===ZC.1d(1b)){1a M=x[y].2I("").1h;1b=x[y].2I("").1E(/[0-9]/g,"").1h/M>.75}1b&&(w=x[y],y++);1a H=[];if(1c===ZC.1d(d))if(1b&&-1!==w[0].1K("\\\\"))d=!0;1t{1a N="";1k(r=y,C=x.1h;r<C;r++)N+=x[r][0];1a S=N.1h;d=N.1E(/[0-9]/g,"").1h/S>.75}if(d){1k(r=y,C=x.1h;r<C;r++)B?H.1i(ZC.1l(x[r][L])):H.1i(x[r][L]);L++}1a O=[],P=[];1k(A=L;A<Y;A++){P[A-L]=[];1a k=1c,G=1c,z=0,T=1c;1k(r=y,C=x.1h;r<C;r++)if(1c!==ZC.1d(x[r][A])&&""!==x[r][A]&&1w x[r][A]!==ZC.1b[31]){a=x[r][A],1c!==ZC.1d(T)||v||(T=a.1E(/[0-9\\-\\,\\.\\+\\e]+/g,"%v")),v||(a=a.1E(/[^0-9\\-\\,\\.\\+\\e]+/g,""));1a J=a.1K("."),Q=a.1K(",");-1!==J&&-1!==Q?J<Q?(k=".",G=",",z=ZC.BN(0,a.1h-Q)):(k=",",G=".",z=ZC.BN(0,a.1h-J)):-1===J&&-1!==Q?a.1h-Q-1==3?(k=",",G="."):(k=".",G=",",z=ZC.BN(0,a.1h-Q)):-1!==J&&-1===Q&&(a.1h-J-1==3?(k=".",G=","):(k=",",G=".",z=ZC.BN(0,a.1h-J))),"."===k&&(a=a.1E(/\\./g,"").1E(/,/g,".")),","===k&&(a=a.1E(/,/g,"")),P[A-L].1i(v?a:ZC.1W(a))}1t P[A-L].1i(1c);O[A-L]={},1c!==ZC.1d(T)&&(O[A-L].5K=T),1c!==ZC.1d(k)&&(O[A-L][ZC.1b[13]]=k),1c!==ZC.1d(k)&&(O[A-L][ZC.1b[14]]=G),0!==z&&(O[A-L][ZC.1b[12]]=z)}if(B)1k(l=0,o=P.1h;l<o;l++)1k(1a W=0;W<P[l].1h;W++)P[l][W]=[H[W],P[l][W]];1a R=[];1P(t.C.AF){1j"1y":1j"1M":1j"5A":1j"6d":1j"8Y":1j"81":1j"6M":1j"7v":1j"9q":1c===ZC.1d(t.o[ZC.1b[50]])&&(t.o[ZC.1b[50]]={});1a V=[];d&&1c!==ZC.1d(w[0])&&(V=w[0].2l(/\\\\/)),1c!==ZC.1d(V[0])&&(1c===ZC.1d(t.o[ZC.1b[50]].1G)&&(t.o[ZC.1b[50]].1G={}),1c===ZC.1d(t.o[ZC.1b[50]].1G.1D)&&(t.o[ZC.1b[50]].1G.1D=V[0])),d&&(1c===ZC.1d(t.o[ZC.1b[50]][ZC.1b[5]])?t.o[ZC.1b[50]][ZC.1b[5]]=H:1c===ZC.1d(t.o[ZC.1b[50]][ZC.1b[10]])&&(t.o[ZC.1b[50]][ZC.1b[10]]=H));1a U=[];if(1c!==ZC.1d(g)&&g)1k(l=0,o=P.1h;l<o;l++)U[l]=ZC.1b[51]+(0===l?"":"-"+(l+1));1t if(1c!==ZC.1d(f)&&f){1a j={},q=0,$=[];1k(l=0,o=P.1h;l<o;l++){1k(1a ee=0,te=0,ie=P[l].1h;te<ie;te++)ee+=P[l][te];ee/=P[l].1h;1a ne=1A.43(ZC.HH(ee)/1A.bm/2);1c===ZC.1d(j[ne])&&(j[ne]=ZC.1b[51]+(0===q?"":"-"+(q+1))),-1===ZC.AT($,O[l].5K)?(U[l]=ZC.1b[51]+(0===q?"":"-"+(q+1)),q++):(U[l]=j[ne],q++),$.1i(O[l].5K)}}1k(0===U.1h&&(U[0]=ZC.1b[51]),1c===ZC.1d(t.o[ZC.1b[11]])&&(t.o[ZC.1b[11]]=[]),l=0,o=P.1h;l<o;l++)1c===ZC.1d(t.o[ZC.1b[11]][l])&&(t.o[ZC.1b[11]][l]={}),t.o[ZC.1b[11]][l][ZC.1b[5]]=P[l],1b&&(1c===ZC.1d(t.o[ZC.1b[11]][l].1D)&&(t.o[ZC.1b[11]][l].1D=w[l+L],R.1i(w[l+L])),1c===ZC.1d(t.o[ZC.1b[11]][l]["1U-1D"])&&(t.o[ZC.1b[11]][l]["1U-1D"]=w[l+L],R.1i(w[l+L])),1c===ZC.1d(t.o[ZC.1b[11]][l]["2C-1D"])&&1c!==ZC.1d(O[l].5K)&&(t.o[ZC.1b[11]][l]["2C-1D"]=O[l].5K)),1c!==ZC.1d(U[l])&&(1c===ZC.1d(t.o[U[l]])&&(t.o[U[l]]={}),1c!==ZC.1d(V[1])&&(1c===ZC.1d(t.o[U[l]].1G)&&(t.o[U[l]].1G={}),1c===ZC.1d(t.o[U[l]].1G.1D)&&(t.o[U[l]].1G.1D=V[1])),1c===ZC.1d(t.o[ZC.1b[11]][l].3w)&&(t.o[ZC.1b[11]][l].3w="1z-x,"+U[l]),1c===ZC.1d(t.o[U[l]][ZC.1b[12]])&&1c!==ZC.1d(O[l][ZC.1b[12]])&&(t.o[U[l]][ZC.1b[12]]=O[l][ZC.1b[12]]),1c===ZC.1d(t.o[U[l]][ZC.1b[13]])&&1c!==ZC.1d(O[l][ZC.1b[13]])&&(t.o[U[l]][ZC.1b[13]]=O[l][ZC.1b[13]]),1c===ZC.1d(t.o[U[l]][ZC.1b[14]])&&1c!==ZC.1d(O[l][ZC.1b[14]])&&(t.o[U[l]][ZC.1b[14]]=O[l][ZC.1b[14]]),1c===ZC.1d(t.o[U[l]].5K)&&1c!==ZC.1d(O[l].5K)&&(t.o[U[l]].5K=O[l].5K));1p;1j"3L":1j"7k":1j"8M":1j"96":if(1c===ZC.1d(t.o.1z)&&(t.o.1z={}),d&&1c!==ZC.1d(w[0])){1a ae=w[0].2l(/\\\\/);1c===ZC.1d(t.o.1z.1G)&&(t.o.1z.1G={}),1c===ZC.1d(t.o.1z.1G.1D)&&(t.o.1z.1G.1D=ae[0])}1k(d&&(1c===ZC.1d(t.o.1z[ZC.1b[5]])?t.o.1z[ZC.1b[5]]=H:1c===ZC.1d(t.o.1z[ZC.1b[10]])&&(t.o.1z[ZC.1b[10]]=H)),1c===ZC.1d(t.o[ZC.1b[11]])&&(t.o[ZC.1b[11]]=[]),l=0,o=P.1h;l<o;l++)1c===ZC.1d(t.o[ZC.1b[11]][l])&&(t.o[ZC.1b[11]][l]={}),t.o[ZC.1b[11]][l][ZC.1b[5]]=P[l],1b&&(1c===ZC.1d(t.o[ZC.1b[11]][l].1D)&&(t.o[ZC.1b[11]][l].1D=w[l+L],R.1i(w[l+L])),1c===ZC.1d(t.o[ZC.1b[11]][l]["1U-1D"])&&(t.o[ZC.1b[11]][l]["1U-1D"]=w[l+L],R.1i(w[l+L])),1c===ZC.1d(t.o[ZC.1b[11]][l]["2C-1D"])&&1c!==ZC.1d(O[l].5K)&&(t.o[ZC.1b[11]][l]["2C-1D"]=O[l].5K)),1c===ZC.1d(t.o[ZC.1b[52]])&&(t.o[ZC.1b[52]]={}),1c===ZC.1d(t.o[ZC.1b[52]][ZC.1b[12]])&&1c!==ZC.1d(O[l][ZC.1b[12]])&&(t.o[ZC.1b[52]][ZC.1b[12]]=O[l][ZC.1b[12]]),1c===ZC.1d(t.o[ZC.1b[52]][ZC.1b[13]])&&1c!==ZC.1d(O[l][ZC.1b[13]])&&(t.o[ZC.1b[52]][ZC.1b[13]]=O[l][ZC.1b[13]]),1c===ZC.1d(t.o[ZC.1b[52]][ZC.1b[14]])&&1c!==ZC.1d(O[l][ZC.1b[14]])&&(t.o[ZC.1b[52]][ZC.1b[14]]=O[l][ZC.1b[14]]),1c===ZC.1d(t.o[ZC.1b[52]].5K)&&1c!==ZC.1d(O[l].5K)&&(t.o[ZC.1b[52]].5K=O[l].5K)}1m""!==R.2I("")&&1c===ZC.1d(t.o.1U)&&(t.o.1U={}),t.o=3c.1q(3c.5d(t.o).1E(/\\\\\\\\/g,"\\\\")),t.o}}),ZC.JS=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.O2="uo",t.H=e,t.AF="",t.IT=1c,t.KH=1c,t.MP=1c,t.S2=1c,t.Q=1c,t.BI=1c,t.I5=1c,t.I6=1c,t.wn=1,t.V9=1,t.wj=1,t.L=0,t.HI=1c,t.M6=[1,0],t.oc=1c,t.CB=!1,t.KO="5e",t.BK=[],t.BW=[],t.XX=[],t.FE=[],t.LD=[],t.AX=1n ZC.LE(t),t.H3=1c,t.BC=1c,t.A8=1c,t.D0=1c,t.K5=1c,t.lV="17v",t.vx=!0,t.M7="",t.RK=1c,t.LH=!1,t.UG=!1,t.N2=0,t.Y7=!1,t.PY=!1,t.F7={7J:1,2c:45,5q:40,"x-2c":0,"y-2c":0,"z-2c":0,3C:1},t.AJ={"4S-2g":!1,"4S-2w":!1,"4S-1X":!1,"4S-cj":!0,"3d":!1,3r:!1,3t:"","4S-8N":!0,"2c-2h":15,"2c-1V":75,"x-2c-2h":-65,"x-2c-1V":65,"y-2c-2h":-65,"y-2c-1V":65,"z-2c-2h":-65,"z-2c-1V":65},t.O6=!1,t.il=!1,t.Ds=[],t.eH=!0,1w ZC.PA!==ZC.1b[31]&&(t.LR=1n ZC.PA(t)),t.GA=!1,t.CW={},t.JZ=[],t.KM=!1,t.HC=!1,t.L3=0,t.BO=[],t.qZ=!0,t.UE=1o.3G.p6,-1===t.UE&&(t.UE=0)},aj:1f(){1a e=1g.b();1m 1g.ef(e,"2V","L"),e},8b:1f(){1a e,t=1g,i="5c";1m t.BC&&""!==t.E["1U-84-7T"]&&1w t.E["1U-84-7T"]!==ZC.1b[31]?i="1N"===t.E["1U-84-7T"]?t.BC.QU:t.BC.PL:(t.o.1U&&(e=t.o.1U[ZC.1b[54]])&&(i=e),t.o.1U&&t.o.1U.1N&&(e=t.o.1U.1N[ZC.1b[54]])&&(i=e)),(t.A.K3||t.E["9L-7Y-3m"])&&(i="3m"),i},BT:1f(e,t){1w t===ZC.1b[31]&&(t=!1);1k(1a i=[],n=1g,a=0,l=n.BK.1h;a<l;a++)n.BK[a].AF===e&&(!t||t&&n.BK[a].W.1h>0)&&i.1i(n.BK[a]);1m i},BL:1f(e){1k(1a t=1g,i=0,n=t.BK.1h;i<n;i++)if(t.BK[i].BB===e)1m t.BK[i];1m 1c},cE:1f(e){1m e},un:1f(e){1m 1n ZC.uq(1g,e)},ci:1f(){1k(1a e=1g,t=0,i=e.BK.1h;t<i;t++){1a n=e.BK[t],a=n.BB;e.A.B9.2t(n.o,["("+e.AF+").4z","("+e.AF+")."+a.1E(/\\-[0-9]+/,""),"("+e.AF+")."+a.1E(/\\-[0-9]+/,"-n"),"("+e.AF+")."+a],!1,!0);1a l=a.1E(/\\-[0-9]+/,"")+"-n";e.o[l]&&n.1C(e.o[l]),e.o[a]&&n.1C(e.o[a]),e.AJ["3d"]&&e.A.B9.2t(n.o,["("+e.AF+").4z[3d]","("+e.AF+")."+a.1E(/\\-[0-9]+/,"")+"[3d]","("+e.AF+")."+a.1E(/\\-[0-9]+/,"-n")+"[3d]","("+e.AF+")."+a+"[3d]"],!1,!0),e.AJ["3d"]&&n.1C(e.o[a+"[3d]"]),n.1q()}},i7:1f(){1m 1c},pc:1f(e){1a t,i,n=1g,a=0,l=n.AX.A7.1h;1k(t=0;t<l;t++)a=ZC.BN(a,n.AX.A7[t].S.1h);1a o;1k(t=0,i=n.BK.1h;t<i;t++)(o=n.BK[t]).7j(e),2===e&&(o.JC=1f(e){1m e=e.1E(/(%N|%2o-fb)/g,a),e=e.1E(/(%P|%1B-fb)/g,l),e=e.1E(/(%S|%1z-6g-fb)/g,o.W.1h)},o.DD()&&o.1q()),1c===ZC.1d(o.o["1V-2z"])&&1c===ZC.1d(o.o["1V-cb"])&&o.er(),1c===ZC.1d(o.o["1V-9J"])&&o.mg()},UX:1f(){},NW:1f(){},qA:1f(){},pA:1f(){},mA:1f(){1a e=1g,t=e.A.B9,i="("+e.AF+")";e.Q=1n ZC.HQ(e),e.Q.O9="2r",e.Q.K=e.K+"-2r";1a n=[i+".2r"];if(e.BI&&n.1i(i+".2r[2w]"),e.AJ["3d"]&&n.1i(i+".2r[3d]"),t.2t(e.Q.o,n),e.Q.1C(e.o.aL),e.Q.1C(e.o.2r),e.BI&&e.Q.1C(e.o["2r[2w]"]),e.AJ["3d"]&&e.Q.1C(e.o["2r[3d]"]),"4M"===e.Q.o[ZC.1b[57]]||"4M"===e.Q.o[ZC.1b[58]]||"4M"===e.Q.o[ZC.1b[59]]||"4M"===e.Q.o[ZC.1b[60]]){1a a=5X(e.Q.o.2v||"").2l(/\\s+|;|,/),l=a.1h>0?a[0]:"",o=a.1h>1?a[1]:"",r=a.1h>0?a[2]||a[0]:"",C=a.1h>1?a[3]||a[1]:"";"4M"===e.Q.o[ZC.1b[57]]&&(l="4M"),"4M"===e.Q.o[ZC.1b[58]]&&(o="4M"),"4M"===e.Q.o[ZC.1b[59]]&&(r="4M"),"4M"===e.Q.o[ZC.1b[60]]&&(C="4M"),e.Q.o.2v=[l,o,r,C].2I(" ")}if(e.E["2r-f3"]?e.Q.o.2v=e.E["2r-2v"]:(e.E["2r-f3"]=!0,e.E["2r-2v"]=e.Q.o.2v,e.E["2r-2v-1u"]=e.Q.o[ZC.1b[57]],e.E["2r-2v-2x"]=e.Q.o[ZC.1b[58]],e.E["2r-2v-2a"]=e.Q.o[ZC.1b[59]],e.E["2r-2v-1J"]=e.Q.o[ZC.1b[60]]),1w e.E["2r-p-x"]!==ZC.1b[31]&&(e.Q.E["p-x"]=e.E["2r-p-x"],e.Q.E["p-y"]=e.E["2r-p-y"],e.Q.E["p-1s"]=e.E["2r-p-1s"],e.Q.E["p-1L"]=e.E["2r-p-1L"]),1c!==ZC.1d(e.Q.o["94-3t"])&&ZC.2q(e.Q.o["94-3t"])&&(e.Q.o.2v="4M"),e.Q.1q(),e.AJ["3d"]&&!e.F7.7J){1a A=ZC.2i(ZC.1l(e.F7.5q*ZC.EL(e.F7.2c)));e.Q.iY+=A,e.Q.F-=A,e.Q.I-=ZC.1l(e.F7.5q*ZC.ED(e.F7.2c))}if(1w e.E["2r-p-x"]!==ZC.1b[31])1k(1a s=0,Z=e.BK.1h;s<Z;s++)e.BK[s].gX(),e.BK[s].IW()},nu:1f(){1a e,t,i,n=1g,a=["1u","2x","2a","1J"],l={};1k(t=0;t<a.1h;t++)l[a[t]]=!1,n.E["2r.d-2v-"+a[t]]&&(n.o.2r["2v-"+a[t]]=1c),n.o.2r&&"4M"===n.o.2r["2v-"+a[t]]&&(l[a[t]]=!0,n.o.2r["2v-"+a[t]]="20");1a o=!1,r={};if("xy"===n.AJ.3t&&(o=!0),("xy"===n.AJ.3t||"yx"===n.AJ.3t)&&(n.Q.E["d-2v"]||n.E["2r.d-2v"])){1k(1a C=0,A=n.BK.1h;C<A;C++){1a s=0,Z=0,c="",u=n.BK[C];if(u.AL&&u.T1){"k"===u.AF?c=u.D9?"2n"===u.B7?"1J":"2x":"2n"===u.B7?"2a":"1u":"v"===u.AF&&(c=u.D9?"2n"===u.B7?"2a":"1u":"2n"===u.B7?"1J":"2x");1a p=0;if(n.Q.E["d-2v-"+c]||n.E["2r.d-2v-"+c]){1a h=1n ZC.DQ(u);h.1Q(u.BQ);1a 1b=ZC.BN(1,ZC.1l((u.A1-u.X)/u.EE));1k(t=u.X;t<=u.A1;t+=1b)if(h.AP=u.G0(t),h.hU&&("k"===u.AF&&!u.D9||"v"===u.AF&&u.D9)&&(h.o[ZC.1b[19]]=ZC.1l(.9*u.A9)),h.1q(),h.AL)if(Z=ZC.BN(Z,h.AA%180==0?h.F:h.I),s=ZC.BN(s,h.AA%180==0?h.I:h.F),p=ZC.BN(p,1.5*h.DG*(h.AP||"").2l(/<br>|<br\\/>|<br \\/>|\\n/).1h),"1u"===c||"2a"===c){if(p=ZC.BN(p,.oB*h.DG+1.mt*ZC.2i(ZC.EL(h.AA))*ZC.BN(h.I,h.F)),s=h.I,Z=p,o&&"k"===u.AF){r[u.BB]||(r[u.BB]=[]);1a d=1c===ZC.1d(h.o["3e-3s"])||ZC.2q(h.o["3e-3s"]),f=.oB*h.DG+1.mt*ZC.2i(ZC.ED(h.AA))*ZC.BN(h.I,h.F);"2n"===u.B7?(d&&(ZC.DU(ZC.i0(h.AA),90,180)||ZC.DU(ZC.i0(h.AA),3T,2j))&&r[u.BB].1i(f),d||r[u.BB].1i(f/2)):(d&&(ZC.DU(ZC.i0(h.AA),0,90)||ZC.DU(ZC.i0(h.AA),180,3T))&&r[u.BB].1i(f),d||r[u.BB].1i(f/2))}}1t s=p=ZC.BN(p,.oB*h.DG+1.mt*ZC.2i(ZC.ED(h.AA))*ZC.BN(h.I,h.F)),Z=h.F;1a g=1n ZC.DQ(u);g.1Q(u.M),g.AP=u.M.AP,g.1q(),""!==g.AP&&g.AL&&(Z+=g.AA%180==0?g.F:g.I,s+=g.AA%180==0?g.I:g.F)}if(n.o.2r||(n.o.2r={}),("4M"===n.o.2r["2v-"+c]||n.Q.E["d-2v-"+c])&&(n.Q.E["d-2v-"+c]=!1,l[c]=!0,n.o.2r["2v-"+c]="0"),l[c]){n.o.2r["2v-"+c]=ZC.1W(n.o.2r["2v-"+c]||"0"),n.E[u.BB+"-6T"]=n.o.2r["2v-"+c];1a B=("1u"===c||"2a"===c?ZC.1l(Z):ZC.1l(s))+10+(n.AJ["3d"]?20:0);if(u.V7?n.o.2r["2v-"+c]=ZC.BN(n.o.2r["2v-"+c],B):n.o.2r["2v-"+c]+=B,1c!==ZC.1d(n.o.2r["2v-"+c+"-1Y"])&&(n.o.2r["2v-"+c]+=ZC.1l(n.o.2r["2v-"+c+"-1Y"])),!n.A.TR){1a v={},b=n.A.DE.dP;n.A.B9.2t(v,"6C.5f.dP"),b&&ZC.2A(b,v),1===n.A.o[ZC.1b[16]].1h&&n.A.o[ZC.1b[16]][0].5f&&(e=n.A.o[ZC.1b[16]][0].5f.dP)&&ZC.2A(e,v);1a E=v.2G||"br";-1===ZC.AT(["tl","tr","br","bl"],E)&&(E="br"),("2a"!==c||"bl"!==E&&"br"!==E)&&("1u"!==c||"tl"!==E&&"tr"!==E)||(n.o.2r["2v-"+c]+=15)}"2a"===c&&("xy"===n.AJ.3t&&n.I5||"yx"===n.AJ.3t&&n.I6)&&(n.o.2r["2v-"+c]+=15),"1J"===c&&("xy"===n.AJ.3t&&n.I6||"yx"===n.AJ.3t&&n.I5)&&(n.o.2r["2v-"+c]+=15),n.E["2r.d-2v-"+c]=!0}}}if(o&&l.1J&&1c!==ZC.1d(n.o.2r[ZC.1b[60]]))1k(1a m in r){1a K=n.BL(m);1k(t=0;t<r[m].1h;t++)ZC.1l(n.o.2r[ZC.1b[60]])+t*K.A9+(K.DK?K.A9/2:0)-r[m][t]<0&&(n.o.2r[ZC.1b[60]]=r[m][t]-t*K.A9-(K.DK?K.A9/2:0))}ZC.P.IL(ZC.AK(n.K+"-2r-c"),n.H.AB,n.Q.iX,n.Q.iY,n.Q.I,n.Q.F,n.K),n.E["2r.1v"]=!0,n.mA();1a F=2,D=6;1c!==ZC.1d(e=n.Q.o["4K-a1"])&&(e 3z 3K?(F=D=ZC.1l(e[0]),e.1h>1&&(D=ZC.1l(e[1]))):F=D=ZC.1l(e)),"2B"===n.H.AB?((e=ZC.AK(n.K+"-3r-2P"))&&e.4l("2S",n.M1(F,"2B")),(e=ZC.AK(n.K+"-3r-2J-2P"))&&e.4l("2S",n.M1(D,"2B"))):(ZC.A4("#"+n.K+" 3A").4Z(1f(){""!==1g.1H.3r&&(1g.1H.3r=n.M1(F))}),(e=ZC.AK(n.K+"-2J"))&&""!==e.1H.3r&&(e.1H.3r=n.M1(D)))}1k(t=0,i=n.BK.1h;t<i;t++)n.BK[t].gX(),n.BK[t].IW()},1q:1f(){1a e,t,i,n,a,l,o,r,C,A=1g,s=A.A.B9,Z="("+A.AF+")";(e=A.A.E["2U-3U-"+A.L])&&(A.E=3c.1q(e),1c===ZC.1d(A.E["2g-on"])||ZC.2q(A.E["2g-on"])||(A.eH=!1)),A.E.rO||(A.A.E["2U-"+A.K+"-1U-6w"]=1c),A.E.rO=1c,A.M7="1q.lY",A.b(),A.qA(),-1!==3c.5d(A.o).1K("1o.4U")&&(A.o.2r=A.o.2r||{},A.o.2r.2v=0);1a c=1c;if(!1o.4C.8l&&((e=A.o["ig-6K"])&&(A.RK=e["ig-3P"]),(e=A.o.6K)&&("4g"==1w e?e.3P?A.RK=e.3P:e["1T-2Y"]&&(c=e["1T-2Y"]):A.RK=e),""!==A.RK&&1c!==ZC.1d(A.A.m6[A.RK])&&(c=A.A.m6[A.RK]),A.H.NP&&(c=A.H.NP),c)){1a u=A.un(c);A.o=u.1q()}if(A.LH=1o.ui,A.4y([["ch","UG","b"],["cn","N2","f"],["aw","LH","b"],["nv","CB","b"],["7H-1I","KO"],["Bj-1I","lV"],["3P-1T","oc"],["3b","L3","i"],["6V","BO"],["3V-2F","qZ","b"]]),A.BO.1h>0)1k(s.B9.6V=[],n=0;n<A.BO.1h;n++){1a p=A.BO[n],h=ZC.AO.JE(A.BO[n],10),1b=ZC.AO.QJ(A.BO[n],10);s.B9.6V.1i(["#2O",p,h,1b])}"7k"===A.AF&&(A.F7.7J=!0),(A.AJ["3d"]||A.A.dm)&&(A.LH=!1),A.pA(),-1===ZC.AT(A.H.KL,ZC.1b[41])&&((1c!==ZC.1d(e=A.o.2w)||s.PG("2w",A.AF))&&A.AJ[ZC.1b[56]]&&(A.BI&&!A.E["ei-2w-1q"]||1w ZC.oi===ZC.1b[31]||(A.E["ei-2w-1q"]=!1,A.BI=1n ZC.oi(A),A.BI.O9="2w",s.2t(A.BI.o,Z+".2w"),(t=A.o.2r)&&A.BI.1C({"1R-1r":t[ZC.1b[0]],"1R-1r-1":t["1R-1r-1"],"1R-1r-2":t["1R-1r-2"],"4Y-rT":t["4Y-rT"],"4Y-hX":t["4Y-hX"]}),A.BI.1C(e),A.BI.1q())),(1c!==ZC.1d(e=A.o["1X-x"])||s.PG("1X-x",A.AF))&&A.AJ["4S-1X"]&&(A.I5||1w ZC.hG===ZC.1b[31]||(A.I5=1n ZC.hG(A,"x"),A.I5.O9="17j",s.2t(A.I5.o,Z+".1X-x"),A.I5.1C(e),A.I5.1q())),(1c!==ZC.1d(e=A.o["1X-y"])||s.PG("1X-y",A.AF))&&A.AJ["4S-1X"]&&(A.I6||1w ZC.hG===ZC.1b[31]||(A.I6=1n ZC.hG(A,"y"),A.I6.O9="17q",s.2t(A.I6.o,Z+".1X-y"),A.I6.1C(e),A.I6.1q()))),A.mA(),A.NW(),A.BK=[],A.ci(),A.pc(1),1c!==ZC.1d(e=A.o[ZC.1b[11]])&&(A.AX.o=e);1a d=A.AX.o;1k(n=0;n<d.1h;n++)if(d[n].aK)1k(C=0;C<d.1h;C++)d[C].id&&d[C].id===d[n].aK&&(A.AX.o[n][ZC.1b[5]]=[].4w(A.AX.o[C][ZC.1b[5]]));if(A.AX.1q(),A.pc(2),(1c!==ZC.1d(e=A.o.5F)||s.PG("5F",A.AF))&&(A.IT=1n ZC.DQ(A),A.IT.O9="5F",s.2t(A.IT.o,Z+".5F"),A.IT.1C(e),A.IT.K=A.K+"-5F",A.IT.K3=!0,A.IT.1q(),1c===ZC.1d(A.IT.o.x))){1a f=A.iX,g=A.I;1P("2r"===A.IT.o["3E-fO"]&&(f=A.Q.iX,g=A.Q.I),A.IT.O3){1j"1J":A.IT.iX=f;1p;1j"3E":A.IT.iX=f+g/2-A.IT.I/2;1p;1j"2x":A.IT.iX=f+g-A.IT.I}}(1c!==ZC.1d(e=A.o.7X)||s.PG("7X",A.AF))&&(A.KH=1n ZC.DQ(A),A.KH.O9="7X",s.2t(A.KH.o,Z+".7X"),A.KH.1C(e),A.KH.K=A.K+"-7X",A.KH.1q()),1c!==ZC.1d(e=A.o.7d)&&(A.MP=1n ZC.DQ(A),A.MP.O9="7d",s.2t(A.MP.o,Z+".7d"),A.MP.1C(e),A.MP.K=A.K+"-7d",A.MP.1q()),1w ZC.p7!==ZC.1b[31]&&(1c!==ZC.1d(e=A.o.1U)||s.PG("1U",A.AF))&&(A.BC=1n ZC.p7(A),A.BC.K=A.K+"-1U",1w e.2k!==ZC.1b[31]&&e.2k<.1&&1w e[ZC.1b[62]]===ZC.1b[31]&&1w e["1F-2k"]===ZC.1b[31]&&(e["1F-2k"]=e.2k),s.2t(A.BC.o,Z+".1U"),A.BC.mz(e),(1c!==ZC.1d(e)&&1c!==ZC.1d(e.2G)||1c!==ZC.1d(A.BC.o.2G))&&s.2t(A.BC.o,Z+".1U[2G]"),A.BC.1C(e),ZC.2q(A.BC.o.6a)&&(A.BC.E["p-x"]=A.A.iX,A.BC.E["p-y"]=A.A.iY,A.BC.E["p-1s"]=A.A.I,A.BC.E["p-1L"]=A.A.F),A.BC.mz(e),A.BC.1q());1a B=!1,v=A.iX,b=A.iY,E=A.I,m=A.F,K="";if(A.IT&&A.IT.AL&&A.IT.o["94-3t"]&&(B=!0,(i=A.IT.iY+A.IT.F/2)<b+m/2&&(K="1u",m=b+m-A.IT.F-A.IT.iY,b=A.IT.iY+A.IT.F,A.KH&&A.KH.o["94-3t"]))){1a F=A.KH.iY+A.KH.F/2;F<b+m/2&&F>i&&(m-=A.KH.F,b+=A.KH.F)}if(A.MP&&A.MP.AL&&A.MP.o["94-3t"]&&(B=!0,(i=A.MP.iY+A.MP.F/2)>b+m/2&&(m-=A.MP.F)),A.BI&&A.BI.AL&&A.BI.o["94-3t"]&&(B=!0,(i=A.BI.B4.iY+A.BI.B4.F/2)>b+m/2?m-=A.BI.B4.F+A.BI.B4.DN:(b=A.BI.B4.iY+A.BI.B4.F,m-=A.BI.B4.F)),A.BC&&A.BC.AL&&A.BC.o["94-3t"]){B=!0;1a D=A.BC.D2&&A.BC.D2.3Z?15:5;if("1u"===K&&A.BC.iY<A.IT.iY+A.IT.F+5){if(1c!==ZC.1d(A.BC.o.2G)){1a I=(""+A.BC.o.2G).2l(" ");A.BC.o.2G=I[0]+" "+(A.IT.iY-A.iY+A.IT.F+A.BC.KZ+D)}1t A.BC.o[ZC.1b[57]]=A.IT.iY-A.iY+A.IT.F+A.BC.KZ;A.BC.1q()}A.BC.mC(),i=A.BC.iY+A.BC.F/2;1a X="",x=(ZC.3q,A.BC.E["2G-6w"]),y={hP:A.BC.iY-A.iY,hN:A.iY+A.F-A.BC.iY-A.BC.F,hW:A.BC.iX-A.iX,i8:A.iX+A.I-A.BC.iX-A.BC.I},L="";L=A.BC.I/A.BC.F>2?"v":A.BC.F/A.BC.I>2?"h":1A.1V(y.i8*A.F,y.hW*A.F)/1A.1V(y.hN*A.I,y.hP*A.I)>1?"h":"v",x?x[0]>=.8?X=x[1]<=.2?"v"===L?"1u":"2x":x[1]>=.8&&"v"===L?"2a":"2x":x[0]<=.2?X=x[1]<=.2?"v"===L?"1u":"1J":x[1]>=.8&&"v"===L?"2a":"1J":x[1]<=.2?X="1u":x[1]>=.8&&(X="2a"):1A.2h(y.hN,y.hP)/1A.1V(y.hN,y.hP)<1A.2h(y.i8,y.hW)/1A.1V(y.i8,y.hW)?y.hN>y.hP?(X="1u",A.BC.E2):(X="2a",A.BC.DN):y.i8>y.hW?(X="1J",A.BC.DZ):(X="2x",A.BC.E3);1a Y=0;"1u"===X&&(m=b+m-A.BC.F-A.BC.iY,b=A.BC.iY+A.BC.F),"2a"===X&&(m-=Y=m-A.BC.iY+b+A.BC.FM+A.BC.FV),"1J"===X&&(v+=Y=A.BC.iX-A.iX+A.BC.I,E-=Y),"2x"===X&&(E-=Y=E-(A.BC.iX-A.iX)+A.BC.EO+A.BC.FN)}1t A.BC&&A.BC.mC();B&&(A.E["2r-p-x"]=v,A.E["2r-p-y"]=b,A.E["2r-p-1s"]=E,A.E["2r-p-1L"]=m,A.mA()),A.nu(),A.AX.jU&&A.AX.jU(!0),A.BI&&A.BI.o["94-3t"]&&(1c===ZC.1d(A.BI.JO.x)&&(A.BI.B4.iX=A.Q.iX),1c===ZC.1d(A.BI.JO[ZC.1b[19]])&&(A.BI.B4.I=A.Q.I));1a w=0;1k(n=0;n<A.AX.A7.1h;n++)w+=A.AX.A7[n].S.1h;1c!==ZC.1d(e=A.o["no-1T"])&&0===w?(A.S2=1n ZC.DQ(A),A.S2.O9="iO",s.2t(A.S2.o,Z+".17o"),A.S2.1C({x:A.Q.iX,y:A.Q.iY,1s:A.Q.I,1L:A.Q.F}),A.S2.1C(e),A.S2.K=A.K+"-iO",A.S2.1q()):A.S2=1c,A.E["2r-f3"]&&(A.E["2r-f3"]=1c,A.o.2r=A.o.2r||{},A.o.2r.2v=A.E["2r-2v"],A.o.2r[ZC.1b[57]]=A.E["2r-2v-1u"],A.o.2r[ZC.1b[58]]=A.E["2r-2v-2x"],A.o.2r[ZC.1b[59]]=A.E["2r-2v-2a"],A.o.2r[ZC.1b[60]]=A.E["2r-2v-1J"]);1a M=["1u","2x","2a","1J"];1k(n=0;n<M.1h;n++)A.E["2r.d-2v-"+M[n]]=1c;if(ZC.P.ES(A.A.K+"-2C"),1w A.E.bL!==ZC.1b[31]&&1c!==ZC.1d(A.E.bL)&&A.E.bL.1h>0&&"3a"!==A.H.AB&&A.AX.A7)1k(1a H=0,N=A.AX.A7.1h;H<N;H++){if(A.AX.A7[H].S.1h<A.E.bL[H])1k(o=A.AX.A7[H].S.1h,r=A.E.bL[H];o<r;o++)l=A.K+ZC.1b[35]+H+"-2o-"+o,ZC.P.ES([l+"-2M",l+"-1M-2M",l+"-sh-2M"]),-1!==ZC.AT(["6t","5h"],A.AF)&&ZC.P.ES([l+"-1O-4Y",l+"-1O-2M",l+"-1O-sh-2M",l+"-1O-3x",l+"-1O-sh-3x"]),A.EN[H+"-"+o]=1c;if(-1===ZC.AT(["6t","5h"],A.AF)||ZC.A4.6A.7A)1k(o=0,r=A.E.bL[H];o<r;o++)l=A.K+ZC.1b[35]+H+"-2o-"+o,ZC.P.ES([l+"-1O-4Y",l+"-1O-2M",l+"-1O-sh-2M",l+"-1O-3x",l+"-1O-sh-3x"])}1k(A.E.bL=1c,n=0,a=A.AX.A7.1h;n<a;n++)A.GA=A.GA||A.AX.A7[n].GA;(A.HC||1w ZC.PA===ZC.1b[31])&&(A.GA=!1),A.GA&&(A.LR.kZ=1f(){A.M7="9i"}),-1===ZC.AT(A.H.KL,ZC.1b[41])&&(A.H3=1n ZC.HQ(A),A.H3.K=A.K+"-3C",s.2t(A.H3.o,Z+".3C"),A.H3.1C(A.o.3C),A.A8=1n ZC.DQ(A),A.A8.O9="2C",A.o.2C&&A.o.2C[ZC.1b[7]]&&A.o.2C[ZC.1b[7]].1K("2o")>-1?s.2t(A.A8.o,Z+".2C[4M]"):s.2t(A.A8.o,Z+".2C"),A.A8.1C(A.o.2C),A.A8.PR=!0,A.A8.1q(),1c!==ZC.1d(e=A.o.2g)&&(A.o["9w-x"]=e),(1c!==ZC.1d(e=A.o["9w-x"])||s.PG("2g",A.AF)||s.PG("9w-x",A.AF))&&A.AJ[ZC.1b[23]]&&(A.D0=1n ZC.CZ(A),A.D0.O9="17n",s.2t(A.D0.o,[Z+".2g",Z+".9w-x"],!0,!0),A.D0.1C(e),A.D0.1q(),A.E["2g-on"]=!0),(1c!==ZC.1d(e=A.o["9w-y"])||s.PG("9w-y",A.AF))&&A.AJ[ZC.1b[23]]&&(A.K5=1n ZC.CZ(A),A.K5.O9="17m",s.2t(A.K5.o,[Z+".2g",Z+".9w-y"],!0,!0),A.K5.1C(e),A.K5.1q(),A.E["2g-on"]=!0)),A.OU(),ZC.AO.C2("17l",A.A,A.HX()),1c!==ZC.1d(e=A.o.cO)&&(A.HI={1I:"jc",ds:10,jp:"7g",9E:"kI","94-1z":!1,"1V-9J":20,"jv-iC":100,"8y-iC":0,hh:!1,"hh-2b":5L},ZC.2A(e,A.HI),A.UE=1),A.M7="1q.aE"},OU:1f(){},PV:1f(){},M1:1f(e,t,i){1a n=1g,a=(i=i||n.Q).iX,l=i.iY,o=i.I,r=i.F;if("2B"===t){if(n.AJ["3d"]){1a C,A=[];e=1;1a s,Z,c,u,p=[],h=a-ZC.AM.E1,1b=l-ZC.AM.E0;C=1n ZC.CF(n,h+o/2-e,1b-e,ZC.AM.FQ),u=ZC.1l(C.E9[1]),C=1n ZC.CF(n,h+o/2-e,1b-e,0),c=ZC.1l(C.E9[1]),p.1i(1n ZC.CF(n,h-e,1b-e,u<c?ZC.AM.FQ:0),1n ZC.CF(n,h+o+e,1b-e,u<c?ZC.AM.FQ:0)),C=1n ZC.CF(n,h+o-e,1b+r/2-e,ZC.AM.FQ),s=ZC.1l(C.E9[0]),C=1n ZC.CF(n,h+o-e,1b+r/2-e,0),Z=ZC.1l(C.E9[0]),p.1i(1n ZC.CF(n,h+o+e,1b-e,s>Z?ZC.AM.FQ:0),1n ZC.CF(n,h+o+e,1b+r+e,s>Z?ZC.AM.FQ:0)),C=1n ZC.CF(n,h+o/2-e,1b+r+e,ZC.AM.FQ),u=ZC.1l(C.E9[1]),C=1n ZC.CF(n,h+o/2-e,1b+r+e,0),c=ZC.1l(C.E9[1]),p.1i(1n ZC.CF(n,h+o+e,1b+r+e,u>c?ZC.AM.FQ:0),1n ZC.CF(n,h-e,1b+r+e,u>c?ZC.AM.FQ:0)),C=1n ZC.CF(n,h-e,1b+r/2-e,ZC.AM.FQ),s=ZC.1l(C.E9[0]),C=1n ZC.CF(n,h-e,1b+r/2-e,0),Z=ZC.1l(C.E9[0]),p.1i(1n ZC.CF(n,h-e,1b+r+e,s<Z?ZC.AM.FQ:0),1n ZC.CF(n,h-e,1b-e,s<Z?ZC.AM.FQ:0)),p.1i(p[0]);1k(1a d=0;d<p.1h;d++)C=p[d],A.1i([ZC.1l(C.E9[0]),ZC.1l(C.E9[1])].2I(","));1m A.2I(" ")}1m[[a-e,l-e].2I(","),[a+o+e,l-e].2I(","),[a+o+e,l+r+e].2I(","),[a-e,l+r+e].2I(","),[a-e,l-e].2I(",")].2I(" ")}1m"3B"===t?a-e+","+(l-e)+","+(o+2*e)+","+(r+2*e):(n.AJ["3d"]&&(e+=10),"5t("+(l-e)+"px,"+(a+o+e)+"px,"+(l+r+e)+"px,"+(a-e)+"px)")},nV:1f(){1a e,t=1g;if(t.AJ["3d"]&&t.F7["3e-gw"]){1a i=!1;1k(t.F7.3C=1;!i&&t.F7.3C>.25;){i=!0;1a n=t.M1(0,"2B").2l(" ");1k(e=0;e<n.1h;e++){1a a=n[e].2l(",");(ZC.1l(a[0])<t.iX+t.Q.DZ||ZC.1l(a[0])>t.iX+t.I-t.Q.E3||ZC.1l(a[1])<t.iY+t.Q.E2||ZC.1l(a[1])>t.iY+t.F-t.Q.DN)&&(i=!1)}i||(t.F7.3C-=.hE),i&&(t.F7.3C-=.mt)}}},8e:1f(){1a e,t,i,n,a,l,o,r,C=1g,A=C.A.I+"/"+C.A.F,s="0/0";if(C.nV(),!C.H.2L()){1a Z=2,c=6;if(1c!==ZC.1d(e=C.Q.o["4K-a1"])&&(e 3z 3K?(Z=c=ZC.1l(e[0]),e.1h>1&&(c=ZC.1l(e[1]))):Z=c=ZC.1l(e)),"2B"===C.A.AB&&C.AJ.3r&&(ZC.P.ES([C.K+"-3r",C.K+"-3r-2J",C.K+"-3r-2w"]),C.A.K8.2X(ZC.P.XA({id:C.K+"-3r",2M:C.M1(Z,"2B")})),C.A.K8.2X(ZC.P.XA({id:C.K+"-3r-2J",2M:C.M1(c,"2B")})),C.BI)){1a u=C.AJ["3d"];C.AJ["3d"]=!1,C.A.K8.2X(ZC.P.XA({id:C.K+"-3r-2w",2M:C.M1(0,"2B",C.BI.B4)})),C.AJ["3d"]=u}1a p=!C.AJ.3r,h=p?1c:C.M1(Z),1b=p?1c:"3P(#"+C.K+"-3r)",d=p?1c:C.M1(c),f=p?1c:"3P(#"+C.K+"-3r-2J)";if(C.BI&&(a=p?1c:C.M1(0,C.A.AB,C.BI.B4),l=p?1c:"3P(#"+C.K+"-3r-2w)"),ZC.P.JU({2m:"zc-3i",id:C.K,p:ZC.AK(C.A.K+"-aZ"),tl:s,wh:A},C.A.AB),C.A.NN.2U&&ZC.P.H6({2m:ZC.1b[24]+" zc-vp",id:C.K+"-c",p:ZC.AK(C.K),wh:A},C.A.AB),ZC.P.JU({id:C.K+"-2r",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A"},C.A.AB),C.o.2r&&C.A.NN.2r&&ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2r-c",p:ZC.AK(C.K+"-2r"),wh:A},C.A.AB),"1c"!==C.AF&&C.A.NN.4j){1k(ZC.P.JU({id:C.K+"-3w-bl",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A","3r-2M":1b,3r:h},C.A.AB),t=0;t<C.wn;t++)ZC.P.H6({2m:ZC.1b[24],id:C.K+"-3w-bl-"+t+"-c",p:ZC.AK(C.K+"-3w-bl"),wh:A},C.A.AB);if(C.AX.E["1B-3V"]){1k(t=0,i=C.AX.A7.1h;t<i;t++){1k(C.AX.A7[t].UH={},n=0;n<C.AX.A7[t].SK;n++)ZC.P.ES(C.K+"-4j-bl-"+n);1k(n=0;n<C.AX.A7[t].jM;n++)ZC.P.ES(C.K+"-4j-fl-"+n)}4o C.AX.E["1B-3V"]}if(C.A.K3||C.AJ["3d"])ZC.AK(C.K+"-4j-bl")||ZC.P.JU({id:C.K+"-4j-bl",p:ZC.AK(C.K),9e:ZC.AK(C.K+"-3w-bl"),tl:s,wh:A,2G:"4A","3r-2M":1b,3r:h},C.A.AB),(o=ZC.P.H6({2m:"zc-3i zc-6r zc-bl",id:C.K+"-4j-bl-c",p:ZC.AK(C.K+"-4j-bl"),wh:A},C.A.AB)).4l("1T-3r",C.M1(Z,"3B"));1t 1k(t=0,i=C.AX.A7.1h;t<i;t++)1k(r=C.AX.LG[t],n=C.AX.A7[t].SK-1;n>=0;n--)ZC.AK(C.K+"-4j-bl-"+n)||ZC.P.JU({id:C.K+"-4j-bl-"+n,p:ZC.AK(C.K),9e:ZC.AK(C.K+"-3w-bl"),tl:s,wh:A,2G:"4A","3r-2M":1b,3r:h},C.A.AB),(o=ZC.P.H6({2m:"zc-3i zc-6r zc-bl",id:C.K+"-1B-"+r+"-bl-"+n+"-c",p:ZC.AK(C.K+"-4j-bl-"+n),wh:A},C.A.AB)).4l("1T-3r",C.M1(Z,"3B")),o.1H.3J="8K";1k(t=0;t<C.V9;t++)ZC.P.H6({2m:ZC.1b[24],id:C.K+"-3w-ml-"+t+"-c",p:ZC.AK(C.K),wh:A},C.A.AB);if(C.A.K3||C.AJ["3d"])ZC.AK(C.K+"-4j-fl")||ZC.P.JU({id:C.K+"-4j-fl",p:ZC.AK(C.K),9e:ZC.AK(C.K+"-3w-ml-"+(C.V9-1)+"-c"),tl:s,wh:A,2G:"4A"},C.A.AB),(o=ZC.P.H6({2m:"zc-3i zc-6r zc-fl",id:C.K+"-4j-fl-c",p:ZC.AK(C.K+"-4j-fl"),wh:A},C.A.AB)).4l("1T-3r",C.M1(c,"3B"));1t 1k(t=0,i=C.AX.A7.1h;t<i;t++)1k(r=C.AX.LG[t],n=C.AX.A7[t].jM-1;n>=0;n--)ZC.AK(C.K+"-4j-fl-"+n)||ZC.P.JU({id:C.K+"-4j-fl-"+n,p:ZC.AK(C.K),9e:ZC.AK(C.K+"-3w-ml-"+(C.V9-1)+"-c"),tl:s,wh:A,2G:"4A"},C.A.AB),(o=ZC.P.H6({2m:"zc-3i zc-6r zc-fl",id:C.K+"-1B-"+r+"-fl-"+n+"-c",p:ZC.AK(C.K+"-4j-fl-"+n),wh:A},C.A.AB)).4l("1T-3r",C.M1(c,"3B")),o.1H.3J="8K";1k(1o.3G.l1&&(ZC.P.JU({id:C.K+"-4j-2J",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A"},C.A.AB),ZC.P.H6({2m:"zc-3i zc-6r zc-fl",id:C.K+"-4j-2J-c",p:ZC.AK(C.K+"-4j-2J"),wh:A},C.A.AB)),ZC.P.JU({id:C.K+"-3w-fl",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A","3r-2M":1b,3r:h},C.A.AB),t=0;t<C.wj;t++)ZC.P.H6({2m:ZC.1b[24],id:C.K+"-3w-fl-"+t+"-c",p:ZC.AK(C.K+"-3w-fl"),wh:A},C.A.AB);if(C.BI&&(ZC.P.JU({id:C.K+"-2w",p:ZC.AK(C.A.K+"-b5"),tl:s,wh:A,2G:"4A","3r-2M":l,3r:a},C.A.AB),ZC.P.H6({2m:"zc-3i",id:C.K+"-2w-c",p:ZC.AK(C.K+"-2w"),wh:A},C.A.AB)),ZC.P.JU({id:C.K+"-1X",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A"},C.A.AB),C.o["1X-x"]&&ZC.P.H6({2m:"zc-3i",id:C.K+"-1X-x-c",p:ZC.AK(C.K+"-1X"),wh:A},C.A.AB),C.o["1X-y"]&&ZC.P.H6({2m:"zc-3i",id:C.K+"-1X-y-c",p:ZC.AK(C.K+"-1X"),wh:A},C.A.AB),ZC.P.JU({id:C.K+"-4j-vb",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A"},C.A.AB),C.A.NN[ZC.1b[17]])if(C.A.K3||C.AJ["3d"])ZC.P.H6({2m:"zc-3i zc-6r zc-vb",id:C.K+"-4j-vb-c",p:ZC.AK(C.K+"-4j-vb"),wh:A},C.A.AB);1t 1k(t=0,i=C.AX.A7.1h;t<i;t++)ZC.P.H6({2m:"zc-3i zc-6r zc-vb",id:C.K+"-1B-"+t+"-vb-c",p:ZC.AK(C.K+"-4j-vb"),wh:A},C.A.AB)}(C.o.5F||C.o.7X||C.o.7d||C.o["no-1T"])&&(ZC.P.JU({id:C.K+"-gQ",p:ZC.AK(C.K),tl:s,wh:A,2G:"4A"},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-gQ-c",p:ZC.AK(C.K+"-gQ"),wh:A},C.A.AB)),ZC.P.JU({2m:"zc-3i",wh:A,id:C.K+"-2J",p:ZC.AK(C.A.K+"-2J"),"3r-2M":f,3r:d},C.A.AB),"3a"===C.A.AB&&(ZC.AK(C.K+"-2J").1H.3r=d),ZC.P.H6({2m:ZC.1b[24],id:C.K+ZC.1b[22],p:ZC.AK(C.K+"-2J"),wh:A},C.A.AB),C.A.NN.4U&&-1!==3c.5d(C.o).1K("1o.4U")&&(ZC.P.JU({2m:"zc-3i",wh:A,id:C.K+"-2F-4U",p:ZC.AK(C.A.K+"-2F-4U"),"3r-2M":f,3r:d},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2F-4U-sh-c",p:ZC.AK(C.K+"-2F-4U"),wh:A},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2F-4U-c",p:ZC.AK(C.K+"-2F-4U"),wh:A},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2F-4U-3F-c",p:ZC.AK(C.K+"-2F-4U"),wh:A},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2F-4U-2J-c",p:ZC.AK(C.K+"-2F-4U"),wh:A},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-2F-4U-6F-c",p:ZC.AK(C.K+"-2F-4U"),wh:A,3J:"1Z"},C.A.AB)),C.pB(),C.o.1U&&(ZC.P.H6({2m:ZC.1b[24],id:C.K+"-1U-c",p:ZC.AK(C.A.K+"-1U"),wh:A},C.A.AB),ZC.P.H6({2m:ZC.1b[24],id:C.K+"-1U-1X-c",p:ZC.AK(C.A.K+"-1U"),wh:A},C.A.AB))}C.Z=C.H.2L()?C.H.mc():ZC.AK(C.K+"-c")},pB:1f(){1a e=1g,t=e.A.I+"/"+e.A.F;!ZC.AK(e.K+"-2F-2a")&&e.A.NN["2F-2a"]&&(e.o.5W||e.o[ZC.1b[10]]||e.o.e9||e.o.8D)&&(ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-2a",p:ZC.AK(e.A.K+"-2F-2a")},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-2a-sh-c",p:ZC.AK(e.K+"-2F-2a"),wh:t},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-2a-c",p:ZC.AK(e.K+"-2F-2a"),wh:t},e.A.AB)),!ZC.AK(e.K+"-2F-1u")&&e.A.NN["2F-1u"]&&(e.o.5W||e.o[ZC.1b[10]]||e.o.e9||e.o.8D)&&(ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-1u",p:ZC.AK(e.A.K+"-2F-1u")},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-1u-sh-c",p:ZC.AK(e.K+"-2F-1u"),wh:t},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-1u-c",p:ZC.AK(e.K+"-2F-1u"),wh:t},e.A.AB)),(e.A.NN["2F-2a"]||e.A.NN["2F-1u"])&&(e.o.5W||e.o[ZC.1b[10]]||e.o.e9)&&ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-6F-c",p:ZC.AK(e.K+"-2F-1u"),wh:t,3J:"1Z"},e.A.AB),!ZC.AK(e.K+"-2F-3F")&&(e.A.NN["2F-2a"]||e.A.NN["2F-1u"])&&(e.o.5W||e.o[ZC.1b[10]]||e.o.e9||e.o.8D)&&(ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-3F",p:ZC.AK(e.A.K+"-2J")},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-3F-c",p:ZC.AK(e.K+"-2F-3F"),wh:t},e.A.AB)),!ZC.AK(e.K+"-2F-2J")&&(e.A.NN["2F-2a"]||e.A.NN["2F-1u"])&&(e.o.5W||e.o[ZC.1b[10]]||e.o.e9||e.o.8D)&&(ZC.P.JU({2m:"zc-3i",wh:t,id:e.K+"-2F-2J",p:ZC.AK(e.A.K+"-2J")},e.A.AB),ZC.P.H6({2m:ZC.1b[24],id:e.K+"-2F-2J-c",p:ZC.AK(e.K+"-2F-2J"),wh:t},e.A.AB))},gm:1f(){},qB:1f(){},9M:1f(){1a e,t=1g;1c!==ZC.1d(e=t.A.S5[t.K])&&"bH"===t.HI.1I&&(e.8r("1o.kD"),e.7p(),t.A.S5[t.K]=1c),t.GA&&t.LR.8y(!0),t.M7="3v.lY",t.3h(),t.BC&&t.BC.3h(),t.BI&&t.BI.3h(),t.I5&&t.I5.3h(),t.I6&&t.I6.3h(),t.M7="3v.aE"},3v:1f(e,t){1c===ZC.1d(e)&&(e=!1),1c===ZC.1d(t)&&(t=!1);1a i,n,a,l,o=1g;o.T8={},1c===ZC.1d(i=o.A.S5[o.K])||e||"bH"===o.HI.1I&&(i.8r("1o.kD"),i.7p(),o.A.S5[o.K]=1c),o.GA&&o.LR.8y(!0),o.M7="3v.lY",o.3h(e),o.gm(!1,!0),o.LK(),o.LK("3F"),o.LK("2g",!0),o.LK("6F",!0),o.LK("lw",!0),e||(!o.BI||o.BI&&!o.BI.LH)&&o.LK("8F",!0),o.AX.YG=[],o.A.SL=[],1o.4C.e8||o.BC&&o.BC.3v(),o.E.bL=[];1a r=ZC.6O?ZC.AK(o.A.K):1c;if(ZC.2H||ZC.6O)ZC.A4("."+o.K+"-2o-1M",r).3m();1t if(ZC.AK(o.A.K+"-5U")&&ZC.AK(o.A.K+"-2Z")){ZC.AK(o.A.K+"-5U").4l("nO","");1a C=ZC.AK(o.A.K+"-2Z").kP(!0);1k(n=(a=C.6W.1h)-1;n>=0;n--)-1!==C.6W[n].7V.1K(o.K+"-2o-1M")&&C.aN(C.6W[n]);ZC.P.ES(o.A.K+"-2Z"),ZC.AK(o.A.K+"-1u").2X(C),ZC.AK(o.A.K+"-5U").4l("nO","#"+o.A.K+"-2Z")}1P(o.AX.HK=[],ZC.A4("."+o.K+"-1S-3B",r).3m(),ZC.A4("."+o.K+"-1z-1O-1G",r).3m(),ZC.A4("."+o.K+"-1z-1N",r).3m(),ZC.A4("."+o.K+"-1z-1G",r).3m(),ZC.A4("."+o.K+"-2g-1G",r).3m(),ZC.A4("."+o.K+"-2P-1G",r).3m(),ZC.A4("."+o.K+"-nK-1G",r).3m(),e||ZC.A4("."+o.K+"-2w-1N",r).3m(),o.A.AB){1j"2B":1k(n=0,a=o.AX.A7.1h;n<a;n++)o.AX.A7[n].HB=1c;ZC.A4("#"+o.A.K+"-lX").9s().4Z(1f(){"17i"!==1g.8h.5D()&&(0!==1g.id.1K(o.K+"-")&&1!==o.A.AI.1h||(e?1g.id!==o.K+"-4Y"&&-1===1g.id.1K("-2w-4Y")&&-1===1g.id.1K("-2y-7T-4Y")&&-1!==1g.id.1K(o.K+ZC.1b[35])&&(t&&o.GA||(-1!==1g.id.1K(o.K+"-1U-")?1o.4C.e8||ZC.A4(1g).3m():ZC.A4(1g).3m())):-1===1g.id.1K("zc-2y-")&&-1===1g.id.1K("-2y-7T-")&&(-1!==1g.id.1K(o.K+"-1U-")?1o.4C.e8||ZC.A4(1g).3m():o.BI&&o.BI.LH?-1===1g.id.1K("-2w-4Y")&&ZC.A4(1g).3m():ZC.A4(1g).3m())))}),e||ZC.P.ES([o.K+"-3r",o.K+"-3r-2J",o.K+"-3r-2w"]),ZC.A4("#"+o.A.K+"-2B").9s().4Z(1f(){1a e=o.K+"-";"vn"===1g.8h.aJ()&&1g.id.2s(0,e.1h)===e&&1g.id!==o.K+"-3r"&&1g.id!==o.K+"-3r-2J"&&1g.id!==o.K+"-3r-2w"&&ZC.P.ES(1g.id)})}if(ZC.P.ES(o.K+"-iO"),ZC.P.ES(o.A.K+"-2C-1D-8Z"),e||(ZC.P.ES([o.K+"-5F",o.K+"-7X",o.K+"-7d",o.K+"-2J"]),1o.4C.e8||o.BC&&(ZC.P.ES(o.K+"-1U-c"),ZC.P.ES(o.K+"-1U-1X-c"),ZC.A4("."+o.K+"-1U-1N-1M",r).3m(),ZC.A4("."+o.K+"-1U-1O-1M",r).3m(),ZC.A4("."+o.K+"-1U-1N",r).3m(),ZC.A4("."+o.K+"-1U-5S",r).3m(),ZC.A4("."+o.K+"-1U-9P",r).3m(),ZC.A4("."+o.K+"-1U-9S",r).3m(),o.BC.gc(),o.BC=1c),o.BI&&(o.BI.LH&&!o.A.E.bM||(o.BI.3h(),ZC.A4("."+o.K+"-2w-3M").3m(),ZC.A4("."+o.K+"-2w-4K").3m(),ZC.A4("#"+o.K+"-2w").3m(),o.BI.gc(),o.BI=1c)),o.I5&&(o.I5.3h(),o.I5=1c),ZC.P.IL(ZC.AK(o.K+"-1X-x-c"),o.A.AB,o.iX,o.iY,o.I,o.F,o.K),ZC.P.IL(ZC.AK(o.K+"-1X-y-c"),o.A.AB,o.iX,o.iY,o.I,o.F,o.K),ZC.A4("#"+o.K+"-1X-x-3n").3m(),ZC.A4("#"+o.K+"-1X-x-2Q").3m(),o.I6&&(o.I6.3h(),o.I6=1c),ZC.A4("#"+o.K+"-1X-y-3n").3m(),ZC.A4("#"+o.K+"-1X-y-2Q").3m(),ZC.A4("#"+o.K+"-c").ly(),o.H.QH[0]!==o.H.QH[1]&&""!==o.H.QH[1]&&("3a"===o.H.AB&&ZC.A4("#"+o.K+" 3a").4Z(1f(){1g.1s=1,1g.1L=1,ZC.P.ES(1g)}),ZC.A4("#"+o.K+" 3A").4Z(1f(){ZC.P.ES(1g)}),ZC.P.ES(o.K))),ZC.A4("#"+o.K+" .zc-6r").4Z(1f(){1a i=ZC.P.SW(1g);if(-1===i.1K("zc-vp")){if(e&&(1g.id===o.K+"-2r-c"||1g.id===o.K+"-gQ-c"))1m;if(-1===1g.id.1K(o.K+"-1B-")&&-1===1g.id.1K(o.K+"-4j-"))ZC.P.IL(1g,o.H.AB,o.iX,o.iY,o.I,o.F,o.K);1t if(t&&o.GA&&!o.HC){if("3a"!==o.H.AB)1k(1a n=0,a=o.AX.A7.1h;n<a;n++)o.E.bL[n]=o.AX.A7[n].S.1h;(l=o.A.K3?1n 5o("-4j-[a-z]+-c","g").3j(1g.id):1n 5o("-1B-(\\\\d+)-[a-z]+-\\\\d+-","g").3j(1g.id))&&(!o.E["1B"+l[1]+".2f"]&&"3m"===o.8b()||o.A.K3)&&ZC.P.IL(1g,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),-1===i.1K("zc-vb")&&-1===i.1K("zc-fl")||ZC.P.IL(1g,o.H.AB,o.iX,o.iY,o.I,o.F,o.K)}1t ZC.P.IL(1g,o.H.AB,o.iX,o.iY,o.I,o.F,o.K)}}),-1!==ZC.AT(o.H.KL,ZC.1b[44])){1a A,s,Z;(A=ZC.AK(o.H.K+"-3X-c"))&&ZC.P.IL(A,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),(s=ZC.AK(o.H.K+"-3X-c-1u"))&&ZC.P.IL(s,o.H.AB,o.iX,o.iY,o.I,o.F,o.K),(Z=ZC.AK(o.H.K+ZC.1b[15]))&&ZC.P.IL(Z,o.H.AB,o.iX,o.iY,o.I,o.F,o.K)}o.qB(),o.A.E.bM=!1,o.M7="3v.aE"},3h:1f(e,t){1c===ZC.1d(e)&&(e=!1);1a i=1g;(-1===ZC.AT(i.H.KL,ZC.1b[41])||t)&&(ZC.A4("."+i.K+"-2o-1M").4f("6I 6Z 4D",i.WT).4f("6f 7B 5P",i.rq).4f("7R 6k",i.rw).4f("3F",i.T3).4f("fm",i.T3).4f("9v",i.rf),i.BC&&(1o.4C.e8||(ZC.A4("."+i.K+"-1U-1N-1M").4f("6f 4D",i.SH).4f("fh",i.9x).4f("ar",i.9x),ZC.A4("."+i.K+"-1U-1O-1M").4f("6f 4D",i.SH).4f("fh",i.9x).4f("ar",i.9x),ZC.A4("#"+i.K+"-1U-9S").4f("fh",i.9x).4f("ar",i.9x),ZC.2H||(ZC.A4("."+i.K+"-1U-1N-1M").4f(ZC.P.C1("6Z"),i.QR).4f(ZC.P.C1("7B"),i.R2).4f(ZC.P.C1(ZC.1b[48]),i.PH),ZC.A4("."+i.K+"-1U-1O-1M").4f(ZC.P.C1("6Z"),i.QR).4f(ZC.P.C1("7B"),i.R2).4f(ZC.P.C1(ZC.1b[48]),i.PH))))),i.qu()},qu:1f(){},S7:1f(){},QF:1f(){},KE:1f(){},S9:1f(){},RU:1f(){},LK:1f(e,t){1a i=1g;e=e||"2J",1c===ZC.1d(t)&&(t=!1);1a n=ZC.AK((t?i.A.K:i.K)+"-"+e+"-c");n&&(ZC.P.IL(n,i.H.AB,i.iX,i.iY,i.I,i.F,i.K,"lw"===e),ZC.A4("."+i.K+"-1G-2J").3m()),"2J"===e&&(ZC.P.IL(ZC.AK(i.K+"-2F-2J-c"),i.H.AB,i.iX,i.iY,i.I,i.F,i.K),ZC.P.IL(ZC.AK(i.K+"-2F-4U-2J-c"),i.H.AB,i.iX,i.iY,i.I,i.F,i.K),1o.3G.l1&&ZC.P.IL(ZC.AK(i.K+"-4j-2J-c"),i.H.AB,i.iX,i.iY,i.I,i.F,i.K)),"3F"===e&&(ZC.P.IL(ZC.AK(i.K+"-2F-3F-c"),i.H.AB,i.iX,i.iY,i.I,i.F,i.K),ZC.P.IL(ZC.AK(i.K+"-2F-4U-3F-c"),i.H.AB,i.iX,i.iY,i.I,i.F,i.K)),i.pk(e,t)},pk:1f(){},tS:1f(e,t){1a i,n=1g;if(1c!==ZC.1d(e)&&1c!==ZC.1d(t)){1a a=n.AX.A7[e].IV,l=n.AX.A7[e].RE;if("1Z"===a)1m;if(1c!==ZC.1d(n.CW["p"+e])){if(1c!==ZC.1d(n.CW["p"+e]["n"+t])){if(4o n.CW["p"+e]["n"+t],l)1k(i=0;i<n.AX.A7.1h;i++)4o n.CW["p"+i]["n"+t]}1t if("2U"===a?(n.CW={},n.CW["p"+e]={}):"1B"===a&&(n.CW["p"+e]={}),n.CW["p"+e]["n"+t]=!0,l)1k(i=0;i<n.AX.A7.1h;i++)n.CW["p"+i]=n.CW["p"+i]||{},n.CW["p"+i]["n"+t]=!0}1t if("2U"===a&&(n.CW={}),n.CW["p"+e]={},n.CW["p"+e]["n"+t]=!0,l)1k(i=0;i<n.AX.A7.1h;i++)n.CW["p"+i]=n.CW["p"+i]||{},n.CW["p"+i]["n"+t]=!0}1c!==ZC.1d(e)&&1c!==ZC.1d(t)&&(n.HC=!0,n.K2(!0,!0))},1v:1f(e){1f t(){if(C.AJ["3d"]){1a e=ZC.DF.DA(C.Q,C,C.Q.iX-ZC.AM.E1,C.Q.iX-ZC.AM.E1+C.Q.I,C.Q.iY-ZC.AM.E0,C.Q.iY-ZC.AM.E0+C.Q.F,ZC.AM.FQ+10,ZC.AM.FQ+10,"y"),t=ZC.DF.DA(C.Q,C,C.Q.iX-ZC.AM.E1,C.Q.iX-ZC.AM.E1+C.Q.I,C.Q.iY-ZC.AM.E0,C.Q.iY-ZC.AM.E0+C.Q.F,ZC.AM.FQ,ZC.AM.FQ,"y");t.K=C.K+"-2r",t.P1=e.D,C.CH.2N(t)}1t{C.Q.Z=C.Q.C5=C.H.2L()?C.H.mc():ZC.AK(C.K+"-2r-c");1a n,a=[C.Q.iX,C.Q.iY,C.Q.I,C.Q.F],l=C.Q.AQ,o=C.Q.AQ,r=C.Q.AQ,A=C.Q.AQ;""!==(i=C.Q.PS)&&(n=i.2l(/\\s/),l=ZC.1l(n[0])),""!==(i=C.Q.OA)&&(n=i.2l(/\\s/),o=ZC.1l(n[0])),""!==(i=C.Q.NK)&&(n=i.2l(/\\s/),r=ZC.1l(n[0])),""!==(i=C.Q.P4)&&(n=i.2l(/\\s/),A=ZC.1l(n[0])),C.Q.iX-=A+1,C.Q.iY-=l+1,C.Q.I+=A+o+1,C.Q.F+=l+r+1,C.Q.1v(),C.Q.iX=a[0],C.Q.iY=a[1],C.Q.I=a[2],C.Q.F=a[3]}}1c===ZC.1d(e)&&(e=!1);1a i,n,a,l,o,r,C=1g;C.A.qH=C.K,C.UW=e,2u.iQ(ZC.nU[C.K]),C.A.q8("vb"+C.L);1a A,s,Z,c,u,p,h,1b=C.BT("k")[0],d=ZC.3q,f=-ZC.3q,g={},B=C.AX.A7,v=0;1k(c=0;c<B.1h;c++)if(B[c].o.aK)1k(Z=0;Z<B.1h;Z++)if(B[Z].o.id&&B[Z].o.id===B[c].o.aK){v++,h=!0;1a b=[];1k(o=0;o<B[Z].S.1h;o++)(1b.EC?B[Z].S[o].BX>=1b.B8&&B[Z].S[o].BX<=1b.BS:B[Z].S[o].L>=1b.X&&B[Z].S[o].L<=1b.A1)?(A=B[Z].S[o].AE,d=1A.2h(d,A),f=1A.1V(f,A),h?(h=!1,B[Z].S[o].BX?b.1i([B[Z].S[o].BX,0]):b.1i(0),p=A):B[Z].S[o].BX?b.1i([B[Z].S[o].BX,100*(A-p)/p]):b.1i(100*(A-p)/p)):B[Z].S[o].BX?b.1i([B[Z].S[o].BX,0]):b.1i(0);g["p-"+c]=[].4w(b)}if(v>0){1k(d=ZC.3q,f=-ZC.3q,c=0;c<B.1h;c++)if(B[c].o.aK&&g["p-"+c])1k(o=0;o<B[c].S.1h;o++)2===(s=g["p-"+c][o]).1h?(A=s[1],B[c].W[o]=s,B[c].S[o].AE=B[c].S[o].CM=s[1]):(A=s,B[c].W[o]=B[c].S[o].AE=B[c].S[o].CM=s),B[c].FO(o),d=1A.2h(d,A),f=1A.1V(f,A);1a E=C.BT("v")[0];E.RN(d,f,!0),E.IW()}1k(C.A.E["g-"+C.L+"-aW"]&&(C.CW=3c.1q(C.A.E["g-"+C.L+"-aW"])),C.KM=!1,n=0,a=C.AX.A7.1h;n<a;n++)C.JZ[n]=!1;1k(n in C.CW)if(C.CW.8d(n)){1a m=ZC.1l(n.1E("p",""));1k(u in C.CW[n])if(C.CW[n].8d(u)){C.JZ[m]=!0,C.KM=!0;1p}}if(C.A.gP(),C.NW(),C.UW?C.E["2r.1v"]&&(t(),C.E["2r.1v"]=1c):(C.8e(),C.Z&&(C.C5=C.Z,C.b()),t()),"xy"===C.AJ.3t||"yx"===C.AJ.3t){1a K=C.BT("v"),F=1c;1k(o=0;o<K.1h;o++)(0===o||K[o].o["3N-d9"])&&K[o].GV<=0&&K[o].HF>=0&&K[o].T1&&(F=o);if(1c!==ZC.1d(F)){1a D=K[F].B2(0);1k(o=0;o<K.1h;o++)if(o!==F&&K[o].o["rF-d9"]&&K[o].GV<=0&&K[o].HF>=0&&K[o].T1){1a I=K[o].B2(0);if(ZC.2i(I-D)>=1)1k(1a X=!0,x=0;X;)I>D?K[o].D9?K[o].AR?K[o].A6+=1:K[o].BV+=1:K[o].AR?K[o].BV+=1:K[o].A6+=1:K[o].D9?K[o].AR?K[o].BV+=1:K[o].A6+=1:K[o].AR?K[o].A6+=1:K[o].BV+=1,x++,K[o].IW(),K[o].er(),(x>(K[o].D9?C.Q.I:C.Q.F)||ZC.2i(K[o].B2(0)-D)<1)&&(X=!1)}}}1k(o=0,r=C.BK.1h;o<r;o++)C.BK[o].Z=C.BK[o].C5=C.H.2L()?C.H.mc():ZC.AK(C.K+"-3w-bl-0-c"),C.A.O1=!0,C.BK[o].1v(),C.A.ZK(),C.A.O1=!1;1a y=1w C.E["6a-3C"]!==ZC.1b[31]&&1c!==ZC.1d(C.E["6a-3C"])&&C.E["6a-3C"];if(C.BI&&C.BI.LH?C.BI.HS&&(C.BI.HS=!0,C.BI.1v()):C.E["b7-2w"]||!C.BI||C.UW&&!C.BI.HS||y||(C.BI.HS=!0,C.BI.1v()),C.E["6a-3C"]=1c,C.E["b7-2w"]=1c,C.I5&&C.I5.1v(),C.I6&&C.I6.1v(),C.UW||(l=C.H.2L()?C.H.mc():ZC.AK(C.K+"-gQ-c"),C.IT&&C.IT.AL&&1c!==ZC.1d(C.IT.AP)&&(C.IT.Z=C.IT.C5=l,C.IT.1v(),!C.IT.K3&&ZC.AK(C.A.K+"-2Z")&&(ZC.AK(C.A.K+"-2Z").4n+=ZC.AO.NZ(C.K,C.IT))),C.KH&&C.KH.AL&&1c!==ZC.1d(C.KH.AP)&&(C.KH.Z=C.KH.C5=l,C.KH.1v(),!C.KH.K3&&ZC.AK(C.A.K+"-2Z")&&(ZC.AK(C.A.K+"-2Z").4n+=ZC.AO.NZ(C.K,C.KH))),C.MP&&C.MP.AL&&1c!==ZC.1d(C.MP.AP)&&(C.MP.Z=C.MP.C5=l,C.MP.1v(),!C.MP.K3&&ZC.AK(C.A.K+"-2Z")&&(ZC.AK(C.A.K+"-2Z").4n+=ZC.AO.NZ(C.K,C.MP))),C.S2&&C.S2.AL&&1c!==ZC.1d(C.S2.AP)&&(C.S2.Z=C.S2.C5=l,C.S2.1v())),C.IT&&C.IT.EH(),C.KH&&C.KH.EH(),C.MP&&C.MP.EH(),C.AJ["3d"]||C.U6(),C.A.O1=!C.GA,1o.3G.bA&&(C.A.O1=!1),C.A.E["2U."+C.K+".lP"])1k(o=0,r=C.AX.A7.1h;o<r;o++)C.AX.A7[o].GA=!1;C.AX.1v(),C.H.rJ()},U6:1f(){},f7:1f(){1a e=1g;e.BI&&(ZC.P.IL(ZC.AK(e.K+"-2w-c"),e.A.AB,e.iX,e.iY,e.I,e.F,e.K),e.A.H3&&!e.A.H3.mI&&e.BI.jv(),e.BI.HS=!0)},bC:1f(){},fk:1f(){1f e(e){1a t,i,n=(e.9O||e.2T.id).1E("-1M-2M","").1E("-2M","").1E(/--([a-zA-Z0-9]+)/,"").1E("-1O","").1E("-3x","").2l("-").9m();1m"2o"===n[1]&&(t=n[2],i=n[0]),[t,i]}1a t,i,n,a,l=1g;1k(l.E["9L-7Y-3m"]=1c,l.GA||l.A.ZK(),l.A.O1=!1,(l.LH||!l.GA||l.H.E["2U."+l.K+".lP"]||!l.AJ[ZC.1b[55]]||-1!==ZC.AT(l.H.KL,ZC.1b[41])||1o.4C.aS)&&(l.M7="9i"),"vE"===l.lV&&(l.vx=!1,l.H.E["2U."+l.K+".lP"]=!0),i=0,n=l.BK.1h;i<n;i++)l.BK[i].6E();if(!l.A.E["cw-2t"]){1a o=ZC.AO.C2("16D",l.A,l.HX(),!0);if(o)1k(1a r=[ZC.1b[10],"5W","16V","e9"],C=0;C<r.1h;C++)o[r[C]]&&(l.o[r[C]]=(l.o[r[C]]||[]).4w(o[r[C]]))}if(l.AJ["3d"]||(l.bC(),l.PV(),l.KE(),-1===ZC.AT(l.H.KL,ZC.1b[41])&&l.RU()),-1===ZC.AT(l.H.KL,ZC.1b[41])){1a A=ZC.A4("."+l.K+"-2o-1M");l.WT=1f(t){if(!(1o.aM&&"6Z"===1o.lm&&"6Z"===t.1I||(1o.hl=l.A.K,1o.aM=t,1o.lm=t.1I,ZC.3l||l.BC&&l.BC.YB||-1===ZC.P.SW(t.2T).1K("zc-2o-1M")||"9i"!==l.M7))){ZC.2H&&(l.E["2o-2T-id"]=t.2T.id,ZC.3l=!1,l.H.9h(),1c===l.H.DE||1c===ZC.1d(l.H.DE["3b-1X"])||l.H.DE["3b-1X"]||t.6L(),l.A.YQ(t));1a a=e(t);if(l.AX.A7[a[0]]){1a o=l.AX.A7[a[0]].FO(a[1]);if(o&&(o.N?(ZC.ay=[o.N.BZ,o.N.A0,o.N.AC,o.N.BU,o.N.B6],o.N3&&ZC.ay.1i(o.N3.A0,o.N3.AC,o.N3.BU,o.N3.B6)):ZC.ay=[],l.E["1B"+a[0]+".2f"])){1a r=ZC.2H?"6I":t.eY||t.1I;(ZC.2H||r!==ZC.1b[47])&&l.A.A8&&l.A8&&l.A8.AL&&l.A.A8.eI(t);1a C=l.AX.A7[a[0]];if("1B"===C.kS)1k(i=0,n=C.S.1h;i<n;i++)C.S[i]&&C.FO(i).6e("2J");1t o.6e("2J");o.WY(t,r),o.A.WX(t,r),l.BC&&(ZC.3l=!0,l.BC.RY?l.L===l.A.AI.1h-1&&l.BC.eu(a[0]):l.BC.eu(a[0]),ZC.3l=!1)}}}},A.4c("6I 6Z 4D",l.WT),l.rq=1f(t){if(1o.aM=1o.lm=1c,1o.hl=1c,!(ZC.3l||l.BC&&l.BC.YB)){1a i=t.2T;if(ZC.2H&&2e.vN){1a n=ZC.P.M8(t),a=1A.1V(2u.vy,2e.eJ.aG,2e.3o.aG),o=1A.1V(2u.vI,2e.eJ.aI,2e.3o.aI);if((i=2e.vN(n[0]-a,n[1]-o))&&l.E["2o-2T-id"]&&l.E["2o-2T-id"]!==i.id)1m}if(-1!==ZC.P.SW(t.2T).1K("zc-2o-1M")&&"9i"===l.M7){ZC.2H&&l.A.OP(t);1a r=e(t),C=l.AX.A7[r[0]].FO(r[1]);if(C){if(l.E["1B"+r[0]+".2f"]){l.A.A8&&l.A8&&l.A8.AL&&l.A.A8.eT(t),l.AX.A7[r[0]].D=[],C.LK(),l.LK();1a A=ZC.2H?"6f":t.eY||t.1I;C.WY(t,A),C.A.WX(t,A),l.BC&&(ZC.3l=!0,l.BC.RY?l.L===l.A.AI.1h-1&&l.BC.eu(-1):l.BC.eu(-1),ZC.3l=!1)}!ZC.2H||l.H.ep||ZC.3l||(1o.S6(t),l.T3(t))}}}},A.4c("6f 7B 5P",l.rq),l.rw=1f(t){if(1o.aM=t,1o.hl=l.A.K,1o.lm=t.1I,-1!==ZC.P.SW(t.2T).1K("zc-2o-1M")&&"9i"===l.M7){ZC.2H&&l.A.OP(t);1a i=e(t);l.E["1B"+i[0]+".2f"]&&l.A.A8&&l.A8&&l.A8.AL&&l.A.A8.gx(t)}},A.4c("7R 6k",l.rw),l.T3=1f(t){if((t.9O||-1!==ZC.P.SW(t.2T).1K("zc-2o-1M"))&&"9i"===l.M7){1a i=e(t),n=l.AX.A7[i[0]].FO(i[1]);if(n&&("1Z"===n.A.IV||!ZC.2H&&0!==t.76||(l.A.E[ZC.1b[53]]=!0,l.f7(),l.tS(n.A.L,n.L)),n.WY(t,"3F"),n.A.WX(t,"3F"),1c!==ZC.1d(n.A.E5)&&"hJ"!==n.A.E5))if(n.A.E5 3z 3K)1k(1a a=0;a<n.A.E5.1h;a++){1a o=n.A.FC;n.A.FC 3z 3K&&(o=n.A.FC[a]||"2U="+(l.o.id||"")),a===n.L&&l.UQ(t,n.KC(n.A.E5[a],1c,1c,!0),o)}1t l.UQ(t,n.KC(n.A.E5,1c,1c,!0),n.A.FC||"2U="+(l.o.id||""))}},l.rf=1f(t){if(-1!==ZC.P.SW(t.2T).1K("zc-2o-1M")&&"9i"===l.M7){1a i=e(t),n=l.AX.A7[i[0]].FO(i[1]);n&&(n.WY(t,"vL"),n.A.WX(t,"vL"))}},ZC.2H||A.4c("3F",l.T3).4c("fm",l.T3).4c("9v",l.rf)}if(l.pd(),l.A.E["tr-ev-"+l.L]?(l.A.E["tr-ev-"+l.L]=1c,l.pJ()):l.pJ(),l.il){l.il=!1;1a s={4u:l.K};1k(i=0,n=l.BT("k").1h;i<n;i++){1a Z=l.BT("k")[i];1c!==ZC.1d(t=Z.LO)&&(s["7L"+(a=1===Z.L?"":"-"+Z.L)]=!0,s["4r"+a]=t[0],s["4m"+a]=t[1])}1k(i=0,n=l.BT("v").1h;i<n;i++){1a c=l.BT("v")[i];1c!==ZC.1d(t=c.LO)&&(s["7P"+(a=1===c.L?"":"-"+c.L)]=!0,s["5s"+a]=t[0],s["5r"+a]=t[1])}if(s.qz=!0,l.A.FW){1k(1a u in l.A.FW)ZC.AK(u).2X(l.A.FW[u]);l.A.FW=1c}l.A.PQ(s)}},pd:1f(){},pJ:1f(){1a e=1g;if(e.A.hp<e.A.AI.1h&&(e.A.hp++,ZC.AO.C2("16y",e.A,e.HX())),ZC.AO.C2("16x",e.A,e.HX()),e.BI&&(e.BI.HS=!1),1o.aM&&1o.hl&&1o.hl===e.A.K){1a t=ZC.A4("#"+e.A.K+"-1u"),i=ZC.DT[0]-t.1Y().1J,n=ZC.DT[1]-t.1Y().1u,a=1o.3j(e.A.K,"vK",{x:i,y:n});if(a)1k(1a l=0;l<a.1h;l++)if("2o"===a[l].hm&&a[l].hn<10){1a o=a[l].4u+ZC.1b[35]+a[l].7i+"-2o-"+a[l].7l;1o.aM&&1o.aM.2T&&1o.aM.2T.id===o&&(e.WT(1o.aM),1o.aM=1c)}}1o.hg&&e.A.D5&&e.A.D5.PZ(1o.hg),e.A.lD<e.A.AI.1h?e.A.lD++:(e.A.lD=1,e.A.hp===e.A.AI.1h&&(e.A.hp++,e.A.E["cw-2t"]=!0,e.LH&&e.AX.A7.1h>1&&(1o.4C.9Z||ZC.AO.C2("2t",e.A,e.A.FH()))),e.A.E["cw-aE"]=!0,(e.E["2U-K2"]||e.LH&&e.AX.A7.1h>1)&&(1o.4C.9Z||ZC.AO.C2("aE",e.A,e.A.FH()),e.E["2U-K2"]=1c)),0!==e.A.QI.1h&&e.A.QI[e.A.QI.1h-1]===e.A.E.4F||(e.A.QI[e.A.NS]!==e.A.E.4F&&(e.A.QI.1h=e.A.NS+1),e.A.QI[e.A.NS]=e.A.E.4F)},K2:1f(e,t){1a i=1g;1c===ZC.1d(e)&&(e=!1),1c===ZC.1d(t)&&(t=!1),i.A.MV(i),i.E["2U-K2"]=!0,i.3v(e,t),i.1q(),i.U1&&i.U1(),i.1v(e),i.BI&&i.BI.pO(),i.HC=!1,1o.4C.8l=!1},UQ:1f(ev,E5,FC){if(2!==ev.76){1a s=1g,C,P0=[""];1P(1c!==ZC.1d(FC)&&(P0=FC.2l("=")),P0[0]){1j"pR":2u.bu(E5,"pR");1p;1j"vC":2u.1u.7W.7K=E5;1p;1j"vB":2u.vM.7W.7K=E5;1p;1j"2u":1c!==ZC.1d(P0[1])&&""!==P0[1]&&(2u.1u[P0[1]].7W.7K=E5);1p;1j"2U":1a XT=1c;if("()"===E5.2s(E5.1h-2)||"7u:"===E5.2s(0,11))4I{1a EG=E5.1E("7u:","").1E("()","");7t(EG)&&(XT=7t(EG).4s(s))}4G(e){}1c!==ZC.1d(P0[1])&&""!==P0[1]?"vC"===P0[1]||"vB"===P0[1]?(s.A.MV(),XT?1o.3j(s.A.K,"b4",{1T:XT}):s.A.2t(1c,E5)):(C=s.A.OQ(P0[1]))&&(s.A.MV(C),s.A.E["tr-ev-"+C.L]=!0,s.A.NS++,XT?1o.3j(s.A.K,"b4",{4u:P0[1],1T:XT}):s.A.2t(P0[1],E5)):(C=s.A.AI[0],s.A.MV(C),XT?1o.3j(s.A.K,"b4",{4u:C.K,1T:XT}):(s.A.E["tr-ev-"+C.L]=!0,s.A.NS++,s.A.2t(C.K,E5)));1p;2n:2u.7W.7K=E5}}},HZ:1f(e,t,i){1a n=1g;if(1c===ZC.1d(i)&&(i=n.AX.A7.1h-1),1c!==ZC.1d(e)&&1w e!==ZC.1b[31])1m n.AX.A7[e];if(1c===ZC.1d(t)||1w t===ZC.1b[31])1m n.AX.A7[i];1k(1a a=0,l=n.AX.A7.1h;a<l;a++)if(t===n.AX.A7[a].GX)1m n.AX.A7[a];1m 1c},pU:1f(e,t){1a i,n,a=1g;(e=e||{})[ZC.1b[54]]=e[ZC.1b[54]]||a.8b();1a l=1c;if(1w e.3S!==ZC.1b[31]&&(l=ZC.1l(e.3S)),-1===l)1k(l=[],i=0,n=a.AX.A7.1h;i<n;i++)l.1i(i);l 3z 3K||(l=[l]);1a o=e.4W||"";o 3z 3K||(o=[o]);1a r=[];1k(i=0,n=ZC.BN(l.1h,o.1h);i<n;i++){1a C=a.HZ(l[i],o[i]);if(C){1a A={};ZC.2A(e,A);1a s=C.L;A.3S=s,A.4W=C.GX,("4k"===t&&!a.E["1B"+s+".2f"]||"5c"===t&&a.E["1B"+s+".2f"])&&r.1i(A)}}1k(i=0,n=r.1h;i<n;i++)a.A.o[ZC.1b[16]][a.L][ZC.1b[11]][r[i].3S].2f="4k"===t,i===n-1&&(r[i].K2=1),a.Q2(r[i])},Q2:1f(e){1a t,i,n,a=1g;a.A.E["2U."+a.K+".lP"]=!1,e=e||{};1a l=!1;1c!==ZC.1d(e.b7)&&e.b7&&(l=!0);1a o=!1;e[ZC.1b[54]]=e[ZC.1b[54]]||a.8b(),1c!==ZC.1d(t=e["bK-1U"])&&(o=ZC.2q(t));1a r=a.HZ(e.3S,e.4W);if(r){1a C=r.L;1P(e[ZC.1b[54]]){1j"5c":if(a.BC&&(a.BC.E.lW=!0),a.E["1B"+C+".2f"]=!a.E["1B"+C+".2f"],1c!==ZC.1d(a.A.o[ZC.1b[16]][a.L][ZC.1b[11]])&&(a.A.o[ZC.1b[16]][a.L][ZC.1b[11]][C].2f=a.E["1B"+C+".2f"]),a.AJ["3d"])o=!0,l||a.K2();1t{1a A=a.E["1B"+C+".2f"]?"8K":"1Z";if(1o.3G.bA||ZC.A4("."+a.K+ZC.1b[35]+C+"-2o-1M").4Z(1f(){if("vS"===1g.8h.5D()){1a e=ZC.A4(1g),t=e.3Q("9n"),n=e.3Q("2P");"1Z"===A?(t="-"+t.1E(/,/g,",-"),"5t"===n?4===(i=t.2l(",")).1h&&(t=[i[2],i[3],i[0],i[1]].2I(",")):"3x"===n&&3===(i=t.2l(",")).1h&&(t=[i[0],i[1],-i[2]].2I(","))):(t=t.1E(/\\-/g,""),"5t"===n&&4===(i=t.2l(",")).1h&&(t=[i[2],i[3],i[0],i[1]].2I(","))),e.3Q("9n",t)}}),a.A.K3)ZC.AK(a.K+"-4j-bl-c").1H.3J=A,ZC.AK(a.K+"-4j-fl-c").1H.3J=A,ZC.AK(a.K+"-4j-vb-c").1H.3J=A;1t{1k(n=0;n<r.SK;n++)(t=ZC.AK(a.K+"-1B-"+C+"-bl-"+n+"-c"))&&(t.1H.3J=A);1k(n=0;n<r.jM;n++)(t=ZC.AK(a.K+"-1B-"+C+"-fl-"+n+"-c"))&&(t.1H.3J=A);(t=ZC.AK(a.K+"-1B-"+C+"-vb-c"))&&(t.1H.3J=A)}1a s=ZC.A4("."+a.K+"-1B-"+C+"-1S-3B");a.E["1B"+C+".2f"]?(s.4k(),ZC.A4("."+a.K+ZC.1b[35]+C+"-2w").4k()):(s.5c(),ZC.A4("."+a.K+ZC.1b[35]+C+"-2w").5c())}1p;1j"3m":a.f7(),o=!0,a.E["9L-7Y-3m"]=!0,a.E["1B"+C+".2f"]=!a.E["1B"+C+".2f"],e.K2&&(l||(a.LT("on-1U-9L"),a.K2(!0,!0)))}a.BC&&!o&&(a.BC.3v(),a.BC.1v())}},LT:1f(e){1a t=1g,i=!0,n=t.o.1B||{};1c!==ZC.1d(n.8N)&&1c!==ZC.1d(n.8N[e])&&(i=ZC.2q(n.8N[e])),t.HC="vE"===t.lV||!i},HX:1f(){1m{id:1g.A.K,Bq:1g.L,4u:1g.K.1E(1g.A.K+"-2U-",""),x:1g.iX,y:1g.iY,1s:1g.I,1L:1g.F,6C:1g.A.FH()}},TK:1f(){},TJ:1f(){},gc:1f(){1k(1a e=0;e<1g.BK.1h;e++)1g.BK[e].gc();1k(1a t=0;t<1g.AX.A7.1h;t++)1g.AX.A7[t].gc();ZC.AO.gc(1g.AX,["A","C","H","F3","o","HU","JO"]),ZC.AO.gc(1g,["Z","C5","AJ","IT","KH","MP","F7"])}}),ZC.JS.5a.PV=1f(){1a e,t,i,n,a,l,o,r,C=1g;C.pB(),C.BW=[],C.FE=[],C.XX=[],C.LD=[],C.FJ=[],C.X2={};1a A,s=C.A.B9,Z="("+C.AF+")";if(1c!==ZC.1d(A=C.o[ZC.1b[10]]))1k(t=0,i=A.1h;t<i;t++){A[t].id||(A[t].id="16q"+t+"1b"+ZC.hc(5L,6J)),n=A[t].id||t,a=!1,l=!1,C.E["2F.e7"]&&-1===ZC.AT(C.E["2F.e7"],n)&&(a=!0,l=!0),A[t].cX&&(a=!0);1a c=1o.5Y.ai("DQ",C,C.K+"-1G-"+n,a);if(!l||!c.pY){if(s.2t(c.o,Z+".1G"),c.1C(A[t]),1c!==ZC.1d(e=c.o.vM))1k(1a u=0;u<C.BW.1h;u++)if(""+C.BW[u].GX==""+e){c.E["p-x"]=C.BW[u].iX,c.E["p-y"]=C.BW[u].iY,c.E["p-1s"]=C.BW[u].I,c.E["p-1L"]=C.BW[u].F;1p}if(c.GX=n,c.K=C.K+"-1G-"+n,c.GG=C.K+"-1G zc-1G",1c!==ZC.1d(e=A[t].7r)&&(c.E.7r=e),c.KC=1f(t){if(!t||-1===(""+t).1K("%"))1m t;t=""+t;1a i,n=[];n.1i(["%id",C.A.K]),n.1i(["%4u",C.K.1E(C.A.K+"-2U-","")]);1a a=C.E.3O;1k(1a l in a)n.1i(["%"+l,a[l]]);n.3V(ZC.m2);1k(1a o=0,r=n.1h;o<r;o++)i=1n 5o(n[o][0],"g"),t=t.1E(i,n[o][1]);1a A=c.o["2n-1S"]||" ";i=1n 5o("(%1B-([0-9]+?)-1S(-*)([0-9]*?))|(%1B-1S-([0-9]+?))|(%1B-1S)|(%8o)|(%2o-8k-1S)","g"),t=t.1E(i,A),i=1n 5o("\\\\((.+?)\\\\)\\\\(([0-9]*)\\\\)\\\\(([0-9]*)\\\\)");1k(1a s,Z,u,p;s=i.3j(t);)if("%2o-1S"===s[1]){Z="";1a h=0,1b=0;""!==(e=s[2])&&(h=ZC.1l(e)),""!==(e=s[3])&&(1b=ZC.1l(e)),(p=C.AX.A7[h])&&(u=p.FO(1b,3))&&(Z=u.KC(s[1])),t=t.1E(s[0],Z)}1m t},c.1q(),A[t]["3d"]){1a p=1n ZC.CF(C,c.iX+c.I/2-ZC.AM.E1,c.iY+c.F/2-ZC.AM.E0,ZC.1l(A[t].z||"0"));c.iX=p.E9[0]-c.I/2,c.iY=p.E9[1]-c.F/2}}C.BW.1i(c),C.FJ.1i({1I:"1G",2V:t,a9:c.JJ}),C.X2[n]={2P:"1G",bI:t}}1a h;if(1c!==ZC.1d(h=C.o.e9))1k(t=0,i=h.1h;t<i;t++){1a 1b=1n ZC.vO(C);s.2t(1b.o,Z+".7G"),1b.1C(h[t]),n=h[t].id||t,1b.K=C.K+"-7G-"+n,1b.1q(),C.XX.1i(1b),C.FJ.1i({1I:"7G",2V:t,a9:1b.JJ})}1a d,f=0;if(1c!==ZC.1d(d=C.o.5W))1k(t=0,i=d.1h;t<i;t++)if(1c===ZC.1d(d[t].1I)||0!==d[t].1I.1K("1o.")){d[t].id||(d[t].id="16p"+t+"1b"+ZC.hc(5L,6J)),n=d[t].id||t,l=1c!==ZC.1d(1o.5Y[C.K+"-2P-"+n])&&1o.4C.lT,a=!1,C.E["2F.e7"]&&-1===ZC.AT(C.E["2F.e7"],n)&&(a=!0,l=!0),d[t].cX&&(a=!0),d[t]["3d"]?((o=1o.5Y.ai("DS",C,C.K+"-2P-"+n,!0)).o=d[t],("4x"!==d[t].1I||d[t]["2Z-1N"])&&(l=!1)):(1c!==ZC.1d(d[t].1G)?(o=1o.5Y.ai("QL",C,C.K+"-2P-"+n,a)).WG=d[t]:((o=1o.5Y.ai("DS",C,C.K+"-2P-"+n,a)).o=d[t],o.1C({},!0)),a&&o.pY||(l=!1)),l||(o.GX=n,o.K=C.K+"-2P-"+n,o.O1=!0,d[t]["2Z-1N"]&&(o.O1=!1),o.1q()),1c!==ZC.1d(e=d[t].7r)&&(o.E.7r=e);1a g,B,v;if(d[t]["3d"]){if(d[t]["2Z-1N"]){1k(g=[],B=0,v=o.D.1h;B<v;B++)1c!==o.D[B]?(r=1n ZC.CF(C,o.D[B][0]-ZC.AM.E1,o.D[B][1]-ZC.AM.E0,ZC.1l(o.D[B][2]||d[t].z||"0")),g.1i(r.E9)):g.1i(1c);o.D=g,C.FE.1i(o),C.FJ.1i({1I:"2P",2V:f,a9:o.JJ,eQ:r.eA}),C.X2[n]={2P:o.DP,bI:f}}1t if("4x"===d[t].1I){1a b=ZC.DF.D6(o,C,d[t].2S,!1);C.CH.2N(b),C.FE.1i(1c)}1t{if(o.D.1h>0){1k(g=[],B=0,v=o.D.1h;B<v;B++)r=1n ZC.CF(C,o.D[B][0]-ZC.AM.E1,o.D[B][1]-ZC.AM.E0,ZC.1l(o.D[B][2]||d[t].z||"0")),g.1i(r.E9);o.D=g}1t r=1n ZC.CF(C,o.iX-ZC.AM.E1,o.iY-ZC.AM.E0,ZC.1l(d[t].z||"0")),o.iX=ZC.1l(r.E9[0]),o.iY=ZC.1l(r.E9[1]);C.FE.1i(o),C.FJ.1i({1I:"2P",2V:f,a9:o.JJ,eQ:r.eA})}o.E["wc"]=!0,o.E["3d"]=!0}1t C.FE.1i(o),o 3z ZC.QL?(C.FJ.1i({1I:"2P",2V:f,a9:o.BE.JJ}),C.X2[n]={2P:o.BE.DP,bI:f}):(C.FJ.1i({1I:"2P",2V:f,a9:o.JJ}),C.X2[n]={2P:o.DP,bI:f});f++}1a E;if(1c!==ZC.1d(E=C.o.8D))1k(t=0,i=E.1h;t<i;t++){1a m=E[t].4T;if(ZC.4b.1T[m]){1a K=1n ZC.HQ(C);K.1C({"1R-6G":"no-6G","1R-4d":m,1s:ZC.4b.1T[m].1s,1L:ZC.4b.1T[m].1L}),K.1C(E[t]),n=E[t].id||t,K.GX=n,K.K=C.K+"-4d-"+n,K.L=t,K.1q(),C.LD.1i(K),C.FJ.1i({1I:"4d",2V:t,a9:K.JJ})}}C.E["2F.e7"]=1c,C.FJ=C.FJ.3V(1f(e,t){1m 1c!==ZC.1d(e.eQ)&&1c!==ZC.1d(t.eQ)?e.eQ-t.eQ>0?1:-1:0}),C.FJ=C.FJ.3V(1f(e,t){1m e.a9-t.a9==0?e.2V-t.2V:e.a9-t.a9})},ZC.JS.5a.gm=1f(e,t){1w e===ZC.1b[31]&&(e=!1),1w t===ZC.1b[31]&&(t=!1);1a i,n=1g,a=[n.K+"-2F-2a-sh-c",n.K+"-2F-2a-c",n.K+"-2F-1u-sh-c",n.K+"-2F-1u-c",n.K+"-2F-5l-c",n.K+"-2F-6F-c"];ZC.eP||a.1i(n.K+"-2F-4U-sh-c",n.K+"-2F-4U-c");1k(1a l=0;l<a.1h;l++)(i=ZC.AK(a[l]))&&ZC.P.IL(i,n.H.AB,n.iX,n.iY,n.I,n.F,n.K);"3a"===n.A.AB&&!1o.hz&&ZC.bN||(ZC.A4("."+n.K+"-1G").3m(),ZC.A4("."+n.K+"-2P-1G").3m(),ZC.A4("."+n.K+"-7G-1G").3m()),e||(ZC.A4("."+n.K+"-1G-1M").4Z(1f(){if(-1===ZC.AT([n.K+"-5F-1M",n.K+"-7X-1M",n.K+"-7d-1M"],1g.id)){1a e=1n 5o("16o(x|y|k|v)-(7E|aH)([0-9]+)").3j(1g.id);!t&&e&&e.1h||ZC.P.ES(1g.id)}}),ZC.A4("."+n.K+"-2P-1M").4Z(1f(){(!ZC.eP||ZC.eP&&"1"!==1g.bT("1T-2Z"))&&ZC.P.ES(1g.id)}),ZC.A4("."+n.K+"-7G-1M").3m()),"2B"===n.A.AB&&ZC.A4("#"+n.A.K+"-2B").9s().4Z(1f(){1a e=n.K+"-1G-";"vn"===1g.8h.aJ()&&1g.id.2s(0,e.1h)===e&&ZC.P.ES(1g.id)})},ZC.JS.5a.qu=1f(){1a e=1g;(e.H.NN["2F-1u"]||e.H.NN["2F-2a"])&&(ZC.A4("."+e.K+"-1G-1M").4f(ZC.2H?"4D":"6I 6Z",e.ZP).4f(ZC.2H?"5P":"6f 7B",e.nD).4f(ZC.2H?"6k":ZC.1b[48],e.ZS),ZC.2H||ZC.A4("."+e.K+"-1G-1M").4f("3F",e.UC).4f("9v",e.UC),ZC.A4("."+e.K+"-2P-1M").4f(ZC.2H?"4D":"6I 6Z",e.ZM).4f(ZC.2H?"5P":"6f 7B",e.rP).4f(ZC.2H?"6k":ZC.1b[48],e.ZW),ZC.2H||ZC.A4("."+e.K+"-2P-1M").4f("3F",e.UB).4f("9v",e.UB))},ZC.JS.5a.OU=1f(){1a e,t,i=1g;i.Y7=!1;1a n,a;if(1c!==ZC.1d(n=i.o[ZC.1b[10]]))1k(e=0,t=n.1h;e<t;e++){1a l=""+(n[e].1D||"");if(-1!==l.1K("%2o-")||-1!==l.1K("%1B-")||-1!==l.1K("%8o")||-1!==l.1K("%2o-8k-1S")||ZC.2q(n[e].4M)){i.Y7=!0;1p}}if(1c!==ZC.1d(a=i.o.5W))1k(e=0,t=a.1h;e<t;e++)if(ZC.2q(a[e].4M)){i.Y7=!0;1p}},ZC.JS.5a.QF=1f(e){1a t=1g;ZC.eP=!0,t.gm(e),t.PV(),t.KE(e),ZC.eP=!1},ZC.JS.5a.KE=1f(e){1w e===ZC.1b[31]&&(e=!1);1a t,i,n,a=1g,l=[],o=[];if(a.H.q8("1G"),a.FJ)1k(i=0,n=a.FJ.1h;i<n;i++){1a r=a.FJ[i].2V;1P(a.FJ[i].1I){1j"7G":!1f(e){1a t=a.XX[e];if(t.AL&&(t.Z=t.C5=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(t.JJ<0?"2a":"1u")+"-c"),t.1v(),t.AL&&ZC.AK(a.A.K+"-2Z"))){1a i=t.BE.lL(),n=ZC.P.GC(i[0],t.BE.E5,t.BE.IM)+\'3g="\'+a.K+\'-7G-1M zc-7G-1M" id="\'+t.BE.K+\'-1M" 9n="\'+i[1]+\'" />\';"1u"===t.o[ZC.1b[7]]?o.1i(n):l.1i(n)}}(r);1p;1j"2P":!1f(e){if(a.FE[e]){1a i=a.FE[e],n=i 3z ZC.QL?i.BE:i;if((!ZC.eP||!n.o["2Z-1N"])&&n.AL){if(1c!==ZC.1d(t=i.E.7r)){1a r=a.UX(t);-1!==r[0]&&(n.iX=ZC.1l(r[0])),-1!==r[1]&&(n.iY=ZC.1l(r[1]))}if(!i.E["3d"]||i.E["wc"]){i.Z=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(n.JJ<0?"2a":"1u")+"-c"),i.C5=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(n.JJ<0?"2a":"1u")+"-sh-c"),n.o["2Z-1N"]&&(i.Z=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-4U-c"),i.C5=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-4U-sh-c"));1a C="";1c!==ZC.1d(t=n.o.vT)&&("x"===t?C="x":"y"===t?C="y":"xy"===t&&(C="xy")),(""===C||"x"===C&&ZC.DU(n.iX-n.BJ,a.Q.iX-2,a.Q.iX+a.Q.I+2)||"y"===C&&ZC.DU(n.iY-n.BD,a.Q.iY-2,a.Q.iY+a.Q.F+2)||"xy"===C&&ZC.DU(n.iX+n.BJ,a.Q.iX-2,a.Q.iX+a.Q.I-2)&&ZC.DU(n.iY+n.BD,a.Q.iY-2,a.Q.iY+a.Q.F+2))&&(i.VX=!1,i.E["6F-3a"]=a.K+"-"+(n.o["2Z-1N"]?"4U":"2F")+ZC.1b[15],i.1v())}if(!i.K3&&!a.PY&&"5e"===1o.ed){1a A=n.lL();if(ZC.AK(a.A.K+"-2Z"))1k(1a s=1,Z=A.1h;s<Z;s++)if(""!==A[s]){1a c=n.o["2Z-1N"]&&!n.o["2Z-b7-z-3V"]?\' 1T-2Z="1"\':"",u=ZC.P.GC(A[0],n.E5,n.IM)+\'3g="\'+a.K+\'-2P-1M zc-2P-1M" id="\'+n.K+"-1M"+(s>1?"--"+s:"")+ZC.1b[30]+A[s]+\'" 1T-z-3V="\'+n.lJ+\'"\'+c+" />";"1u"===i.o[ZC.1b[7]]?o.1i(u):l.1i(u)}}}}}(r);1p;1j"4d":!1f(e){1a t=a.LD[e];if(t.AL)if(t.Z=t.C5=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(t.JJ<0?"2a":"1u")+"-c"),1c!==ZC.1d(t.o.6G)&&ZC.2q(t.o.6G)){1a i=ZC.1l(ZC.7O(t.o.2z,0)),n=1c;if(t.o.f5&&((n=1n ZC.HQ(t.A)).1Q(t),n.1C(t.o.f5),n.1q(),n.Z=n.C5=t.Z),i>0||n){1a l=ZC.1l(ZC.7O(t.o.16n,-1)),o=ZC.1l(ZC.7O(t.o.16m,-1)),r=ZC.1l(ZC.7O(t.o["8O-x"],0)),C=ZC.1l(ZC.7O(t.o["8O-y"],0)),A=ZC.1l(ZC.7O(t.o["1Y-5j"],0)),s=ZC.1l(ZC.7O(t.o["1Y-mH"],0));-1!==l&&-1===o?o=1A.4h(i/l):-1===l&&-1!==o?l=1A.4h(i/o):-1===l&&-1===o&&(o=1A.4h(1A.5B(i)),l=1A.4h(i/o));1k(1a Z=t.iX,c=t.iY,u=t.K,p=0;p<l;p++)1k(1a h=0;h<o;h++)t.iX=Z+h*r+p*A,t.iY=c+p*C+h*s,t.K=u+(p*o+h),p*o+h<i?t.1v():n&&(n.iX=t.iX,n.iY=t.iY,n.K=t.K,n.1v())}1t t.1v()}1t t.1v()}(r);1p;1j"1G":!1f(e){1a i=a.BW[e];if(i.AL){if(i.E.sX="1G",1c!==ZC.1d(t=i.E.7r)){1a n=a.UX(t);if(-1===n[0]&&-1===n[1])1m;if(-1!==n[0]&&(i.iX=n[0]),-1!==n[1]&&(i.iY=n[1]),1c===ZC.1d(n[2])||i.o.bh||1c!==ZC.1d(n[2].3E)&&n[2].3E&&(i.iX-=i.I/2,i.iY-=i.F/2),i.o.bh&&i.gU(),i.o["3d"]){1a r=0;n[2]&&n[2].z?r=n[2].z:i.o.z&&(r=ZC.1l(i.o.z));1a C=1n ZC.CF(a,i.iX+i.I/2-ZC.AM.E1,i.iY+i.F/2-ZC.AM.E0,r);i.iX=C.E9[0]-i.I/2,i.iY=C.E9[1]-i.F/2}}i.iX=ZC.1l(i.iX),i.iY=ZC.1l(i.iY),i.IE=ZC.AK(a.A.K+"-1D"),i.Z=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(i.JJ<0?"2a":"1u")+"-c"),i.C5=a.H.2L()?a.H.mc("1u"):ZC.AK(a.K+"-2F-"+(i.JJ<0?"2a":"1u")+"-sh-c");1a A="";if(1c!==ZC.1d(t=i.o.vT)&&("x"===t?A="x":"y"===t?A="y":"xy"===t&&(A="xy")),(""===A||"x"===A&&ZC.DU(i.iX-i.BJ,a.Q.iX-i.I/2-2,a.Q.iX+a.Q.I-i.I/2+2)||"y"===A&&ZC.DU(i.iY-i.BD,a.Q.iY-i.F/2-2,a.Q.iY+a.Q.F-i.F/2+2)||"xy"===A&&ZC.DU(i.iX+i.BJ,a.Q.iX-i.I/2-2,a.Q.iX+a.Q.I-i.I/2+2)&&ZC.DU(i.iY+i.BD,a.Q.iY-i.F/2-2,a.Q.iY+a.Q.F-i.F/2+2))&&(i.VX=!1,i.1v(),i.EH(ZC.AK(a.K+"-2F-6F-c")),!i.K3&&!a.PY&&"5e"===1o.ed&&ZC.AK(a.A.K+"-2Z"))){1a s=ZC.AO.NZ(a.K,i);"1u"===i.o[ZC.1b[7]]?o.1i(s):l.1i(s)}}}(r)}}1k(i=0;i<a.AX.A7.1h;i++)a.AX.A7[i].RB=1c;if(!e&&"5e"===1o.ed&&(o.1h>0||l.1h>0)&&ZC.AK(a.A.K+"-2Z")){if(a.qZ){1a C=1f(e,t){1m-1!==e.1K("1T-2Z")&&-1!==t.1K("1T-2Z")?ZC.AO.MW(t)-ZC.AO.MW(e):ZC.AO.MW(e)-ZC.AO.MW(t)};o.3V(C),l.3V(C)}1o.3G.n9?2u.5G(1f(){ZC.AK(a.A.K+"-2Z").4n=o.2I("")+ZC.AK(a.A.K+"-2Z").4n+l.2I("")},33):ZC.AK(a.A.K+"-2Z").4n=o.2I("")+ZC.AK(a.A.K+"-2Z").4n+l.2I("")}a.A.E["cw-2t"]||ZC.AO.C2("16l",a.A,a.HX())},ZC.JS.5a.S9=1f(e,t,i,n){1a a,l,o,r,C=1g;1P(i=i||"2J",e){1j"2P":1a A=C.FE[t],s=A 3z ZC.QL?A.BE:A;if(1c!==ZC.1d(s.o[i+"-3U"])){if(!n&&s.o.5Z)1k(o=0,r=C.FE.1h;o<r;o++)o!==t&&(C.FE[o].o.5Z===s.o.5Z||C.FE[o].BE&&C.FE[o].BE.o.5Z===s.o.5Z)&&C.S9(e,o,i,!0);if((a=1n ZC.DS(C)).1C(s.o),a.1C(s.o[i+"-3U"]),l=s.o.id||t,a.GX=l+"-"+i,a.K=C.K+"-2P-"+l+"-"+i,a.1q(),A.E["3d"]&&(a.D=s.D,a.iX=A.iX,a.iY=A.iY),a.AL)if(a.Z=a.C5=ZC.AK(C.K+"-2F-"+i+"-c"),a.o["2Z-1N"]&&(a.Z=a.C5=ZC.AK(C.K+"-2F-4U-"+i+"-c")),a.o["2Z-1N"]&&1o.4U.ur&&"3a"!==C.A.AB){if("2B"===C.A.AB){1a Z=ZC.A4("#"+C.K+"-2P-"+a.GX+"-bx-2M");C.E["2Z-2P-6w"]={3f:Z.3Q("3f"),3Y:Z.3Q("3Y"),"3Y-1s":Z.3Q("3Y-1s")},"4x"===a.DP?(Z.3Q("3f",a.A0),Z.3Q("3Y-1s",a.AQ),Z.3Q("3Y",a.BU)):"1y"===a.DP&&(Z.3Q("3Y-1s",a.AY),Z.3Q("3Y",a.B6))}1t if("3I"===C.A.AB){1a c=ZC.AK(C.K+"-2P-"+a.GX+"-bx-2M"),u=ZC.A4(c.6W[1]),p=ZC.A4(c.6W[2]);C.E["2Z-2P-6w"]={3f:""+p.3Q("1r"),3Y:""+u.3Q("1r"),"3Y-1s":""+u.3Q("7a")},"4x"===a.DP?(p.3Q("1r",a.A0),u.3Q("7a",a.AQ),u.3Q("1r",a.BU)):"1y"===a.DP&&(u.3Q("7a",a.AY),u.3Q("1r",a.B6))}}1t a.1v(),"3a"===C.A.AB&&1o.hz&&A.M&&(A.M.Z=A.M.C5=ZC.AK(C.K+"-2F-"+i+"-c"),A.M.1v())}1p;1j"1G":1a h=C.BW[t];if(h&&1c!==ZC.1d(h.o[i+"-3U"])){if(!n&&h.o.5Z)1k(o=0,r=C.BW.1h;o<r;o++)o!==t&&C.BW[o].o.5Z===h.o.5Z&&C.S9(e,o,i,!0);1a 1b=1o.5Y.ai("DQ",C,C.K+"-1G-"+i);1b.1C(h.o),1b.1C(h.o[i+"-3U"]),l=h.id||t,1b.GX=l+"-"+i,1b.K=C.K+"-1G-"+l+"-"+i,1b.GG=C.K+"-1G "+C.K+"-1G-"+i+" zc-1G zc-1G-"+i,1b.IE=ZC.AK(C.A.K+"-1D"),1b.1q(),1b.AL&&(1b.iX=h.iX,1b.iY=h.iY,1b.I=h.I,1b.F=h.F,1b.Z=1b.C5=ZC.AK(C.K+"-2F-"+i+"-c"),ZC.AK(C.K+"-1G-"+l)&&(ZC.AK(C.K+"-1G-"+l).1H.3J="1Z"),1b.1v())}}},ZC.JS.5a.RU=1f(){1f e(e){1k(1a t=(e.9O||e.2T.id).1E(/\\-\\-\\d+/g,"").1E(i.K+"-2P-","").1E("-bx-1M","").1E("-1M",""),n=-1,a=1c,l=0,o=i.FE.1h;l<o;l++)if(i.FE[l]&&""+i.FE[l].GX==""+t){n=l,a=i.FE[l]3z ZC.QL?i.FE[l].BE:i.FE[l];1p}if(!a&&e.2T.bT("1T-mT"))1m{gD:e.2T.id,mT:!0,ev:e};if(-1===n)1m 1c;1a r={gD:t,gI:n,2C:a.o.2C?1:0,2P:{id:t,2V:n,2m:a.DJ,x:a.iX,y:a.iY,1I:a.DP,ul:a.o["2Z-1N"],2S:a.D,1s:a.I,1L:a.F,2b:a.AH,w4:a.KU,2c:a.AA,9V:a.JJ},ev:e};1k(1a C in a.o)a.o.8d(C)&&"1T-"===C.2s(0,5)&&(r[C]=a.o[C]);1m r}1f t(e){1a t,o=e.9O||e.2T.id;if(o===i.K+"-5F-1M"||o===i.K+"-7X-1M"||o===i.K+"-7d-1M"){1a r=1c,C=-1;1P(t=o.1E(i.K+"-","").1E("-1M","")){1j"5F":r=i.IT,C=-1;1p;1j"7X":r=i.KH,C=-2;1p;1j"7d":r=i.MP,C=-3}1m{1I:"2U-"+t,dw:r.K,fj:C,1D:r.AP,1G:{id:r.K,2V:C,1D:r.AP},ev:e}}if(-1===o.1K("-1z")||-1===o.1K("-1N")&&-1===o.1K("-1O")){if(-1!==o.1K("-1S-3B-")){n=o.1E(i.K+ZC.1b[35],"").1E("-1S-3B-1M",""),a=n.2l("-2o-");1a A=i.AX.A7[ZC.1l(a[0])].FO(ZC.1l(a[1]));1m A?{1I:ZC.1b[17],dw:"ud"+a.2I("1b"),3S:ZC.1l(a[0]),5Q:ZC.1l(a[1]),1D:A.AE,1G:{id:"ud"+a.2I("1b"),1D:A.AE},ev:e}:1c}n=o.1E(i.K+"-1G-","").1E("-1M","");1k(1a s=-1,Z=1c,c=0,u=i.BW.1h;c<u;c++)if(""+i.BW[c].GX==""+n){s=c,Z=i.BW[c];1p}if(l=-1===s?"":i.BW[s].AP,-1===s)1m 1c;1a p={1I:"1G",dw:n,fj:s,1D:l,2C:Z.o.2C?1:0,1G:{id:n,2V:s,2m:Z.DJ,x:Z.iX+Z.BJ,y:Z.iY+Z.BD,1s:Z.I,1L:Z.F,1D:l},ev:e};1k(1a h in Z.o)Z.o.8d(h)&&"1T-"===h.2s(0,5)&&(p[h]=Z.o[h]);1m p}n=o.1E(i.K+"-","").1E("-1M","");1a 1b=(a=n.2l("-"))[1].2l("1b"),d=0;2===1b.1h?d=ZC.1l(1b[1]):3===1b.1h&&(d=ZC.1l(1b[2]));1a f,g=a[0].1E(/1b/g,"-"),B=i.BL(g);1m-1!==o.1K("-1N")?(t="1z-1N",f="16t"+a[1].1E("7E",""),l=B.BW[d]||B.W[d],"16C"===f&&(l=B.M.AP)):(t="1z-1O",f="16N"+a[1].1E("aH",""),l=B.E["zi"+d]||""),{1I:t,dw:f,fj:d,1z:g,1D:l,2C:B.o.2C||B.o.1N&&B.o.1N.2C?1:0,1G:{id:f,2V:d,1D:l},ev:e}}1a i=1g;if(i.H.NN["2F-1u"]||i.H.NN["2F-2a"]){i.ZM=1f(t){ZC.2H&&(i.LK(),ZC.3l=!1,i.H.9h(),1c===i.H.DE||1c===ZC.1d(i.H.DE["3b-1X"])||i.H.DE["3b-1X"]||t.6L(),i.A.YQ(t));1a n=e(t);n.2C&&i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.eI(t);1a a=ZC.2H?"6I":t.eY||t.1I;n.mT||i.S9("2P",n.gI),i.TJ(a,n)},i.rP=1f(t){ZC.2H&&(i.H.ep||ZC.3l||(1o.S6(t),i.UB(t)),i.A.OP(t)),i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.eT(t),ZC.2H||i.LK();1a n=ZC.2H?"6f":t.eY||t.1I,a=e(t);if(a.2P&&a.2P.ul&&1o.4U.ur&&"3a"!==i.A.AB)if("2B"===i.A.AB){1a l=ZC.A4("#"+i.K+"-2P-"+a.2P.id+"-bx-2M");"4x"===a.2P.1I&&l.3Q("3f",i.E["2Z-2P-6w"].3f),l.3Q("3Y",i.E["2Z-2P-6w"].3Y),l.3Q("3Y-1s",i.E["2Z-2P-6w"]["3Y-1s"])}1t if("3I"===i.A.AB){1a o=ZC.AK(i.K+"-2P-"+a.2P.id+"-bx-2M"),r=o.6W[1],C=o.6W[2],A=i.E["2Z-2P-6w"];"4x"===a.2P.1I&&ZC.P.G2(C,{1r:A.3f}),ZC.P.G2(r,{7a:A["3Y-1s"],1r:A.3Y})}i.TJ(n,a)},i.ZW=1f(t){1a n=e(t);n.2C&&i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.gx(t),i.TJ(ZC.1b[48],n)},i.UB=1f(t){1a n=e(t);if("9v"!==t.1I){t.iB||i.LK("3F"),i.T8=i.T8||{},i.T8["rr"+n.gD]?(i.T8["rr"+n.gD]=1c,i.LK("3F")):(t.iB||(i.T8={}),i.T8["rr"+n.gD]=1,i.S9("2P",n.gI,"3F")),i.TJ("3F",n);1a a=i.FE[n.gI].BE||i.FE[n.gI];if(a&&a.E5&&"hJ"!==a.E5)if(a.E5 3z 3K)1k(1a l=0;l<a.E5.1h;l++)1c!==ZC.1d(a.FC[l])&&i.UQ(t,a.E5[l],a.FC[l]);1t i.UQ(t,a.E5,a.FC)}1t i.TJ("9v",n)},ZC.A4("."+i.K+"-2P-1M").4c(ZC.2H?"4D":"6I 6Z",i.ZM).4c(ZC.2H?"5P":"6f 7B",i.rP).4c(ZC.2H?"6k":ZC.1b[48],i.ZW),ZC.2H||ZC.A4("."+i.K+"-2P-1M").4c("3F",i.UB).4c("9v",i.UB);1a n,a,l;i.ZP=1f(e){ZC.2H&&(i.LK(),ZC.3l=!1,i.H.9h(),1c===i.H.DE||1c===ZC.1d(i.H.DE["3b-1X"])||i.H.DE["3b-1X"]||e.6L(),i.A.YQ(e));1a n=t(e);if(n.2C&&i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.eI(e),1c!==n&&"1G"===n.1I){1a a=ZC.2H?"6I":e.eY||e.1I;n["1T-6D"]||i.S9("1G",n.fj),i.TK(a,n)}},i.nD=1f(e){ZC.2H&&(i.H.ep||ZC.3l||(1o.S6(e),i.UC(e)),i.A.OP(e)),i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.eT(e),ZC.2H||i.LK();1a n=t(e);if(1c!==n){1a a=ZC.2H?"6f":e.eY||e.1I;ZC.AK(i.K+"-1G-"+n.1G.id)&&(ZC.AK(i.K+"-1G-"+n.1G.id).1H.3J="8K"),i.TK(a,n)}},i.ZS=1f(e){1a n=t(e);n.2C&&i.A8&&i.A.A8&&i.A8.AL&&i.A.A8.gx(e),i.TK(ZC.1b[48],n)},i.UC=1f(e){1a n=t(e);if("9v"!==e.1I){e.iB||i.LK("3F"),i.T8=i.T8||{},i.T8["r6"+n.dw]?(i.T8["r6"+n.dw]=1c,i.LK("3F")):(e.iB||(i.T8={}),i.T8["r6"+n.dw]=1,i.S9("1G",n.fj,"3F")),i.TK("3F",n);1a a=i.BW[n.fj];if(!a)1P(n.1I){1j"2U-5F":a={E5:i.IT.E5,FC:i.IT.FC};1p;1j"2U-7X":a={E5:i.KH.E5,FC:i.KH.FC};1p;1j"2U-7d":a={E5:i.MP.E5,FC:i.MP.FC}}if(a&&a.E5&&"hJ"!==a.E5)if(a.E5 3z 3K)1k(1a l=0;l<a.E5.1h;l++)1c!==ZC.1d(a.FC[l])&&(a.E5[l]=a.E5[l].1E("%id",i.A.K),a.E5[l]=a.E5[l].1E("%4u",i.K.1E(i.A.K+"-2U-","")),i.UQ(e,a.E5[l],a.FC[l]));1t a.E5=a.E5.1E("%id",i.A.K),a.E5=a.E5.1E("%4u",i.K.1E(i.A.K+"-2U-","")),i.UQ(e,a.E5,a.FC)}1t i.TK("9v",n)},ZC.A4("."+i.K+"-1G-1M").4c(ZC.2H?"4D":"6I 6Z",i.ZP).4c(ZC.2H?"5P":"6f 7B",i.nD).4c(ZC.2H?"6k":ZC.1b[48],i.ZS),ZC.2H||ZC.A4("."+i.K+"-1G-1M").4c("3F",i.UC).4c("9v",i.UC)}},ZC.JS.5a.TK=1f(e,t){1a i=1g;ZC.2A(i.HX(),t),t.ev=ZC.A4.C1(t.ev),ZC.AO.C2("16M"+e,i.A,t)},ZC.JS.5a.TJ=1f(e,t){1a i=1g;ZC.2A(i.HX(),t),t.ev=ZC.A4.C1(t.ev),ZC.AO.C2("16E"+e,i.A,t)},ZC.JS.5a.UX=1f(e){1a t,i=1g;if("2Y"==1w e){1a n={},a=e.2l(":");if(2===a.1h){n.1I=a[0];1k(1a l=0,o=(a=a[1].2l(/\\s|,|;/)).1h;l<o;l++){1a r=a[l].2l("=");n[r[0]]=r[1]}}e=n}1a C,A=[-1,-1];1P(i.E.Ag=!0,e.1I){1j"1z":1a s="",Z=-1,c=1c;1c!==ZC.1d(t=e.8L)&&(s=t),1c!==ZC.1d(t=e.2V)&&(Z=ZC.1l(t)),1c!==ZC.1d(t=e[ZC.1b[9]])&&(c=ZC.1l(t)),C=1c;1a u,p,h;if(""===s&&(s=ZC.1b[50]),C=i.BL(s))1P(C.I3&&-1!==Z?h=C.I3(Z):C.B2&&(1c!==ZC.1d(c)?h=C.B2(c):-1!==Z&&(h=C.B2(C.W[Z]))),i.AJ.3t){1j"74":1j"8M":u=h[0],p=h[1];1p;1j"xy":"k"===C.AF?(u=h,p=C.iY,"2n"===C.B7&&(p+=C.F)):"v"===C.AF&&(p=h,u=C.iX,"5u"===C.B7&&(u+=C.I));1p;1j"yx":"k"===C.AF?(p=h,u=C.iX,"5u"===C.B7&&(u+=C.I)):"v"===C.AF&&(u=h,p=C.iY,"2n"===C.B7&&(p+=C.F))}A=[u,p,{3E:!0}];1p;1j"2o":1a 1b=-1,d=1c,f=1c,g=1c,B=1c;1c!==ZC.1d(t=e.1B)&&(g=t),1c!==ZC.1d(t=e.3S)&&(g=t),1c!==ZC.1d(t=e.4W)&&(B=t);1a v=i.HZ(g,B);1c!==ZC.1d(t=e.2V)&&(1b=ZC.1l(t)),1c!==ZC.1d(t=e[ZC.1b[9]])&&(d=t),1c!==ZC.1d(t=e.hF)&&(f=t);1a b=1c;if(v){if(-1!==1b&&v.S[1b])b=v.FO(1b,3);1t if(1c!==ZC.1d(d)||1c!==ZC.1d(f)){C=v.C.BL(v.BK[0]);1a E,m;if(1c!==f&&1c===d&&v.S.1h>16K&&C.FD&&"5z"===C.FD.o.1I&&1c!==(E=ZC.mS(f,v,0,v.S.1h-1))&&(b=v.FO(E,3)),!b)1k(E=0,m=v.S.1h;E<m;E++)v.S[E]&&(1c!==d&&v.S[E].AE==d&&(b=v.FO(E,3)),1c!==f&&1c!==ZC.1d(v.S[E].BX)&&v.S[E].BX==f&&(b=v.FO(E,3)))}b&&(b.2E(),A=b.UX(e),!b.J7&&ZC.DU(A[0],i.Q.iX,i.Q.iX+i.Q.I)&&ZC.DU(A[1],i.Q.iY,i.Q.iY+i.Q.F)&&(b.J7=!0),b.J7&&b.AL&&b.A.AL&&b.C.E["1B"+b.A.L+".2f"]||(A=[-1,-1])),v.E["z-9T"]&&(A[2].z=v.E["z-9T"])}}1m 1c!==ZC.1d(e.x)&&(A[0]=ZC.1l(e.x)),1c!==ZC.1d(e.y)&&(A[1]=ZC.1l(e.y)),1c!==ZC.1d(t=e["1Y-x"])&&(A[0]+=ZC.1l(t)),1c!==ZC.1d(t=e["1Y-y"])&&(A[1]+=ZC.1l(t)),A},1o.p9=1f(e,t,i){2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d=!(1c!==ZC.1d(i.3O)&&!ZC.2q(i.3O)),f=!!i.4M&&ZC.2q(i.4M),g=1o.79(e);if(g)1P(t){1j"tO":if((n=g.C8(i[ZC.1b[3]]))&&i.1T){if(s=i.1T 3z 3K,Z=s?[]:{},ZC.2A(i.1T,Z),a=i.1I||"1G",s)1k(r=0,C=Z.1h;r<C;r++)a=i.1I||Z[r].mK||"1G",n.o[a+"s"]||(n.o[a+"s"]=[]),f&&(Z[r]["2Z-1N"]=!1),n.o[a+"s"].1i(Z[r]);1t n.o[a+"s"]||(n.o[a+"s"]=[]),f&&(Z["2Z-1N"]=!1),n.o[a+"s"].1i(Z);d&&(n.OU(),n.QF(f))}i.5I&&"1f"==1w i.5I&&i.5I(i);1p;1j"tL":if(n=g.C8(i[ZC.1b[3]]),i["3g"]&&(i.2m=i["3g"]),n&&(i.id||i.2m||i.5Z)){a=i.1I||"1G",A=n.o[a+"s"]||[],l=i.id?"2Y"==1w i.id?[i.id]:i.id:[],o=i.2m?"2Y"==1w i.2m?[i.2m]:i.2m:[],c=!1;1a B=[];1k(r=A.1h-1;r>=0;r--)(1c!==ZC.1d(A[r].id)&&-1!==ZC.AT(l,A[r].id)||1c!==ZC.1d(A[r].2m)&&-1!==ZC.AT(o,A[r].2m)||1c!==ZC.1d(A[r]["3g"])&&-1!==ZC.AT(o,A[r]["3g"])||i.5Z&&A[r].5Z===i.5Z)&&(1c!==ZC.1d(A[r].id)&&B.1i(A[r].id),A.6p(r,1),c=!0);1k(r=0;r<B.1h;r++)ZC.P.ES([n.K+"-1G-"+B[r]+"-4Y",n.K+"-1G-"+B[r]+"-1u-4Y",n.K+"-2P-"+B[r]+"-4Y",n.K+"-2P-"+B[r]+"-1u-4Y",n.K+"-2P-"+B[r]+"-bx-4Y",n.K+"-2P-"+B[r]+"-bx-1u-4Y"]);c&&d&&(n.OU(),n.QF(f))}i.5I&&"1f"==1w i.5I&&i.5I(i);1p;1j"16J":if(i["3g"]&&(i.2m=i["3g"]),(n=g.C8(i[ZC.1b[3]]))&&i.1T){n.E["2F.e7"]=[],a=i.1I||"1G",A=n.o[a+"s"]||[],1b="1G"===a?n.BW:n.FE,Z=(s=i.1T 3z 3K)?[]:{},ZC.2A(i.1T,Z),c=!1;1a v=1f(e,t){1a i,l,o,r=n.X2[e.id||""],C=!1;if(r&&("1G"===r.2P?(o=n.BW[r.bI],93.cr&&3===93.cr(e).1h&&1c!==ZC.1d(e.x)&&1c!==ZC.1d(e.y)&&(o.iX=e.x,o.iY=e.y,C=!0)):(o=n.FE[r.bI],"3x"===r.2P?93.cr&&3===93.cr(e).1h&&1c!==ZC.1d(e.x)&&1c!==ZC.1d(e.y)&&(o.BE?(o.BE.iX=e.x,o.BE.iY=e.y):(o.iX=e.x,o.iY=e.y),C=!0):"1y"===r.2P&&93.cr&&2===93.cr(e).1h&&1c!==ZC.1d(e.2S)&&(o.BE?o.BE.D=e.2S:o.D=e.2S,C=!0))),C||n.E["2F.e7"].1i(e.id),ZC.2A(e,t),1c!==ZC.1d(e.8N)){1a A=1c;if("1G"===a){1k(i=0,l=n.BW.1h;i<l;i++)if(n.BW[i].GX===e.id){A=n.BW[i];1p}}1t if("2P"===a)1k(i=0,l=n.FE.1h;i<l;i++)if(n.FE[i].GX===e.id){A=n.FE[i]3z ZC.QL?n.FE[i].BE:n.FE[i];1p}1a s=n.LR,Z={};if(ZC.2A(e,Z),1c!==ZC.1d(Z.x)&&(Z.x+=n.iX),1c!==ZC.1d(Z.y)&&(Z.y+=n.iY),1c!==ZC.1d(Z.2S))1k(i=0,l=Z.2S.1h;i<l;i++)1c!==ZC.1d(Z.2S[i])&&(Z.2S[i][0]+=n.iX,Z.2S[i][1]+=n.iY,1c!==ZC.1d(Z.2S[i][2])&&(Z.2S[i][2]+=n.iX),1c!==ZC.1d(Z.2S[i][3])&&(Z.2S[i][3]+=n.iY));Z.8N=1c;1a u=1n ZC.E8(A,Z,ZC.1l(e.8N.oZ||"eF"),ZC.1l(e.8N.Ap||"0"),ZC.E8.RJ[ZC.1l(e.8N.9E||"0")],1f(){1c!==ZC.1d(e.8N.6n)&&e.8N.6n.4s()});n.PY=!0,2u.5G(1f(){s.2N(u)},33)}c=!0};if(s){1a b=!1,E=!1;1k(r=0,C=Z.1h;r<C;r++){if(1c!==ZC.1d(Z[r].mK)&&(A=n.o[Z[r].mK+"s"]),A)1k(u=0,p=A.1h;u<p;u++)1c!==ZC.1d(Z[r].id)&&1c!==ZC.1d(A[u].id)&&A[u].id===Z[r].id&&v(Z[r],A[u]);1c!==ZC.1d(Z[r].8N)?b=!0:E=!0,E&&b&&n.PV()}}1t if(i.5Z)1k(u=0,p=A.1h;u<p;u++)A[u].5Z===i.5Z&&(Z.id=A[u].id,v(Z,A[u]));1t if(i.2m)1k(u=0,p=A.1h;u<p;u++)A[u].2m===i.2m&&(Z.id=A[u].id,v(Z,A[u]));1t 1k(e=Z.id||i.id,u=0,p=A.1h;u<p;u++)1c!==ZC.1d(A[u].id)&&1c!==ZC.1d(e)&&A[u].id===e&&(Z.id=e,v(Z,A[u]));!c||!d&&n.PY||n.PY||(n.OU(),n.QF(f))}i.5I&&"1f"==1w i.5I&&i.5I(i);1p;1j"16G":(n=g.C8(i[ZC.1b[3]]))&&(n.OU(),n.QF(f)),i.5I&&"1f"==1w i.5I&&i.5I(i);1p;1j"16F":if(i["3g"]&&(i.2m=i["3g"]),n=g.C8(i[ZC.1b[3]]),l=[],n&&i.2m){a=i.1I||"1G",A=n.o[a+"s"]||[];1a m=i.2m 3z 3K?i.2m:[i.2m];1k(r=0,C=A.1h;r<C;r++)-1===ZC.AT(m,A[r].2m)&&-1===ZC.AT(m,A[r]["3g"])||1c===ZC.1d(A[r].id)||l.1i(A[r].id)}1m l;1j"Gh":1j"Gf":1a K={x:"iX",y:"iY",1s:"I",1L:"F",1r:"BZ",hd:"B6",cY:"AY",gt:"BU",gr:"AQ",gj:"A0",g9:"AC",2b:"AH",1I:"DP",1D:"AP",6S:"DG",6B:"KN",Gn:"EQ",lg:"BJ",j1:"BD"};if(n=g.C8(i[ZC.1b[3]]),a=i.1I||"1G","Gh"===t&&"1G"!==a||"Gf"===t&&"2P"!==a)1m 1c;if(e=i.id||"",n&&""!==e){1b=[],"1G"===a?1b=n.BW:"2P"===a&&(1b=n.FE);1a F=1c;1k(r=0,C=1b.1h;r<C;r++)1b[r].GX===e&&(F=1b[r]);if(F){1a D={};if("2P"===a){if(F.M){D.1G={};1k(h in K)D.1G[h]=F.M[K[h]]}F.BE&&(F=F.BE)}1k(h in K)D[h]=F[K[h]];1m D}}1m 1c;1j"16H":1o.ed="5e",i.4B&&"7M"===i.4B&&(1o.ed="7M");1p;1j"16I":ZC.bN=!1,i.4B&&"2G"===i.4B&&(ZC.bN=!0)}1m 1c},ZC.JS.5a.pw=1f(){1a e,t,i=1g,n=0;1k(e=0,t=i.BK.1h;e<t;e++)"k"===i.BK[e].AF&&i.o[i.BK[e].BB]&&i.o[i.BK[e].BB][ZC.1b[5]]&&(n=ZC.BN(n,i.o[i.BK[e].BB][ZC.1b[5]].1h));1k(e=0,t=i.AX.A7.1h;e<t;e++)1c!==ZC.1d(i.o[ZC.1b[11]][e])&&i.o[ZC.1b[11]][e][ZC.1b[5]]&&(n=ZC.BN(n,i.o[ZC.1b[11]][e][ZC.1b[5]].1h));1m n},ZC.JS.5a.U1=1f(){1a e,t=1g;if(t.HI)1k(1a i=t.pw(),n=0,a=t.BK.1h;n<a;n++)"k"===t.BK[n].AF&&(t.BK[n].D9?(e=(t.BK[n].F-t.BK[n].A6-t.BK[n].BV)/ZC.1l(t.HI["1V-9J"]),t.BK[n].OF=ZC.BN(0,t.BK[n].F-i*e)):(e=(t.BK[n].I-t.BK[n].A6-t.BK[n].BV)/ZC.1l(t.HI["1V-9J"]),t.BK[n].OF=ZC.BN(0,t.BK[n].I-i*e)),ZC.2q(t.HI["94-1z"])&&(t.BK[n].OF=0),t.BK[n].A6=t.BK[n].s6+t.BK[n].OF,t.A.E[t.BK[n].BB+"-bH-1Y-46"]=t.BK[n].A6,t.BK[n].X=ZC.BN(0,t.BK[n].A1-t.HI["1V-9J"]+1),t.BK[n].IW())},ZC.JS.5a.pd=1f(){1a s=1g,G,ML,ws;if(s.E["6l-7o"]&&(2u.iQ(ZC.eO[s.K]),4o s.E["6l-7o"]),s.HI){1a OM=ZC.1l(s.HI.ds);if(OM=OM>=50?OM:5L*OM,"jc"===s.HI.1I)"7g"===s.HI.jp?ZC.eO[s.K]=2u.5G(1f(){s.A.MV(s),ZC.YZ(1f(){s.A.2t(s.K,s.oc)})},OM):"h5"===s.HI.jp&&ZC.h5&&(s.H.S5[s.K]?"kI"===s.HI.9E&&(ZC.eO[s.K]=2u.5G(1f(){s.H.S5[s.K].8r("1o.gT")},OM)):(ws=1n qt(s.HI.3P,"1o"),ws.Bt=1f(){ws.8r("1o."+s.HI.1I),ws.8r("1o."+s.HI.9E),ws.8r("1o.gT")},ws.Br=1f(e){"9i"===s.M7&&(s.A.MV(s),s.M7="jc",ZC.YZ(1f(){1o.3j(s.A.K,"b4",{4u:s.K,1T:e.1T,16L:!0})}))},s.H.S5[s.K]=ws));1t if("bH"===s.HI.1I&&1c!==ZC.1d(s.HI.3P)){if(1c!==ZC.1d(s.HI.e5)){1a O5=s.BT("k");if(O5.1h>0&&(ZC.P.ES(s.K+"-e5-t"),O5[0].OF>0)){1a LW=1n ZC.DQ(s);s.A.B9.2t(LW.o,"("+s.AF+").cO.e5"),LW.1C(s.HI.e5),LW.1q(),LW.AL&&(O5[0].D9&&LW.F<=O5[0].OF||!O5[0].D9&&LW.I<=O5[0].OF)&&(LW.K=s.K+"-e5-t",LW.IE=ZC.AK(s.A.K+"-1D-1u"),O5[0].D9?(LW.F>O5[0].OF&&(LW.AP="",LW.1q()),LW.iX=s.Q.iX,LW.iY=O5[0].AR?s.Q.iY:s.Q.iY+s.Q.F-O5[0].OF,LW.I=s.Q.I,LW.F=O5[0].OF):(LW.I>O5[0].OF&&(LW.AP="",LW.1q()),LW.iX=O5[0].AR?s.Q.iX+s.Q.I-O5[0].OF:s.Q.iX,LW.iY=s.Q.iY,LW.I=O5[0].OF,LW.F=s.Q.F),LW.Z=LW.C5=ZC.AK(s.K+"-3w-ml-0-c"),LW.1v())}}1a h6=s.HI.jp,pF=ZC.1l(s.HI["jv-iC"]),pX=ZC.1l(s.HI["8y-iC"]),pT=ZC.2q(s.HI.hh),j6=!0;1c!==ZC.1d(s.HI["dp-1T"])&&(j6=ZC.2q(s.HI["dp-1T"]));1a kH=1f(K7){1k(1a TB=7t("("+K7+")"),i,A5,qE=TB 3z 3K?TB:[TB],r=0,Ft=qE.1h;r<Ft;r++){1a DH=qE[r];1k(i=0,A5=s.BK.1h;i<A5;i++)if("k"===s.BK[i].AF){1a BB=s.BK[i].BB;1c!==ZC.1d(DH[BB])&&1c!==ZC.1d(s.o[BB])&&(1c===ZC.1d(s.o[BB][ZC.1b[5]])&&(s.H.o[ZC.1b[16]][s.L][BB][ZC.1b[5]]=[],s.o[BB][ZC.1b[5]]=[]),s.o[BB][ZC.1b[5]].1i(DH[BB]),!j6&&s.o[BB][ZC.1b[5]].1h>ZC.1l(s.HI["1V-9J"])&&s.o[BB][ZC.1b[5]].6p(0,1),s.H.o[ZC.1b[16]][s.L][BB][ZC.1b[5]].1i(DH[BB]),(s.o[BB][ZC.1b[5]].1h>pF||1===s.M6[1])&&(s.H.o[ZC.1b[16]][s.L][BB][ZC.1b[5]]=[],s.o[BB][ZC.1b[5]]=[],s.H.E["2U"+s.L+".3C"]&&(s.H.E["2U"+s.L+".3C"].4r=1c,s.H.E["2U"+s.L+".3C"].4m=1c),s.I5&&(s.I5.3h(),ZC.P.IL(ZC.AK(s.K+"-1X-x-c"),s.A.AB,s.iX,s.iY,s.I,s.F,s.K),ZC.A4("#"+s.K+"-1X-x-3n").3m(),ZC.A4("#"+s.K+"-1X-x-2Q").3m()),s.I6&&(s.I6.3h(),ZC.P.IL(ZC.AK(s.K+"-1X-y-c"),s.A.AB,s.iX,s.iY,s.I,s.F,s.K),ZC.A4("#"+s.K+"-1X-y-3n").3m(),ZC.A4("#"+s.K+"-1X-y-2Q").3m())),ZC.pP&&pT&&ZC.AO.hh.1i("1o.1z."+s.K+"."+BB,""+DH[BB]))}1k(i=0,A5=s.AX.A7.1h;i<A5;i++)if(1c!==ZC.1d(s.o[ZC.1b[11]][i])){1a gJ=1c;1c!==ZC.1d(G=DH["1B-"+i])?gJ=G:1c!==ZC.1d(G=DH["1B"+i])&&(gJ=G),"xy"===s.AJ.3t||"yx"===s.AJ.3t?(s.H.o[ZC.1b[16]][s.L][ZC.1b[11]][i][ZC.1b[5]].1i(gJ),!j6&&s.H.o[ZC.1b[16]][s.L][ZC.1b[11]][i][ZC.1b[5]].1h>ZC.1l(s.HI["1V-9J"])&&s.H.o[ZC.1b[16]][s.L][ZC.1b[11]][i][ZC.1b[5]].6p(0,1)):s.H.o[ZC.1b[16]][s.L][ZC.1b[11]][i][ZC.1b[5]]=[gJ],ZC.pP&&pT&&("4g"==1w(G=DH["1B"+i])&&(G=G.2I("###")),ZC.AO.hh.1i("1o.1B."+s.K+".1B"+i,""+G)),(s.o[ZC.1b[11]][i][ZC.1b[5]].1h>pF||1===s.M6[1])&&(ZC.AO.C2("16O",s.A,s.HX(),DH),s.H.o[ZC.1b[16]][s.L][ZC.1b[11]][i][ZC.1b[5]]=[])}ML=s.pw()}("9i"===s.M7||s.GA)&&(1===s.M6[1]&&(s.M6[1]=0),(ML<=pX||0===pX)&&(s.M7="bH",ZC.YZ(1f(){ZC.AK(s.A.K+"-3X")&&(ZC.AO.C2("16P",s.H,s.HX(),s.o),s.1q(),s.3v(!0),s.U1(),s.1v(!0,!0))})))};if("7g"===h6||"js"===h6){1a E5=s.HI.3P;ZC.eO[s.K]=2u.5G(1f(){if(1===s.M6[0]||1===s.M6[1])if(s.A.MV(s),"7g"===h6){1a F6=["f0-2Y"===s.A.MZ?"eG="+1A.cW():"",1o.hw?"ja="+s.H.AB:""].2I("&");ZC.A4.av({1I:"bp",3P:E5,dh:1f(e){s.A.RR.1T||"7g-fu"!==s.A.MZ||e.d0(ZC.1b[45],"d5, 8E d3 du 6P:6P:6P di")},1T:F6,q2:"1D",4L:1f(){},aD:1f(e){kH(e)}})}1t if("()"===E5.2s(E5.1h-2)||"7u:"===E5.2s(0,11))4I{1a EG=E5.1E("7u:","").1E("()","");7t(EG)&&7t(EG).4s(s,1f(e){kH(e)},s.HX())}4G(e){}},OM)}1t"h5"===h6&&ZC.h5&&(s.H.S5[s.K]?"kI"===s.HI.9E&&(ZC.eO[s.K]=2u.5G(1f(){s.H.S5[s.K].8r("1o.gT")},OM)):(ws=1n qt(s.HI.3P,"1o"),ws.Bt=1f(){ws.8r("1o."+s.HI.1I),ws.8r("1o."+s.HI.9E),ws.8r("1o.pz"),"kI"===s.HI.9E&&ws.8r("1o.gT")},ws.Br=1f(e){1!==s.M6[0]&&1!==s.M6[1]||kH(e.1T)},s.H.S5[s.K]=ws))}}},1o.ql=1f(e,t,i){1a n;2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a a=1o.79(e);if(a){1a l=a.C8(i[ZC.1b[3]]);1P(t){1j"16Q":l.M6[1]=1,0===l.M6[0]&&ZC.YZ(1f(){l.1q(),l.3v(!0),l.U1(),l.1v(!0,!0)});1p;1j"16R":1m l.HI.ds;1j"16S":ZC.AO.C2("16T",a,l.HX()),l.o.cO=l.o.cO||{},l.o.cO.ds=i.ds||1;1p;1j"kD":1===l.M6[0]&&(ZC.AO.C2("16U",a,l.HX()),l.M6[0]=0,1c!==ZC.1d(n=a.S5[l.K])&&n.8r("1o.kD"));1p;1j"pz":0===l.M6[0]&&(ZC.AO.C2("16B",a,l.HX()),l.M6[0]=1,1c!==ZC.1d(n=a.S5[l.K])&&n.8r("1o.pz"),ZC.YZ(1f(){l.1q(),l.3v(!0),l.U1(),l.1v(!0,!0)}))}}1m 1c},ZC.AO.pQ=1f(e){1k(1a t={},i=[],n=0,a=(i="4g"==1w e?e:3c.1q(e)).1h;n<a;n++)if(1c!==ZC.1d(e=i[n])){t["p"+n]={};1a l=[];if("4g"==1w e)l=e;1t if("2Y"==1w e&&/\\d+\\-\\d+/.5x(e)){1a o=e.2l("-");if(2===o.1h){l=[];1k(1a r=ZC.1l(o[0]);r<=ZC.1l(o[1]);r++)l.1i(r)}}1t l=[e];1k(1a C=0,A=l.1h;C<A;C++)t["p"+n]["n"+l[C]]=!0}1m t},ZC.JS.5a.pA=1f(){1a e,t=1g;1c!==ZC.1d(e=t.o.aW)&&(t.CW=ZC.AO.pQ(e),t.o.aW=1c)},1o.pC=1f(e,t,i){1a n,a,l,o,r,C,A,s,Z;2e.cA("zc-5T")&&(e="zc-5T"),"2Y"==1w(i=i||{})&&(i=3c.1q(i));1a c=1o.79(e);if(c)1P(t){1j"16r":if(a=c.C8(i[ZC.1b[3]])){1k(a.CW={},l=0,o=a.AX.A7.1h;l<o;l++)a.JZ[l]=!1;a.HC=!0,a.f7(),a.K2(!0,!0)}1p;1j"16k":if(a=c.C8(i[ZC.1b[3]])){1k(C=[],l=0,o=a.AX.A7.1h;l<o;l++)if(C[l]=1c,1c!==ZC.1d(a.CW["p"+l])){1a u=[];1k(A in a.CW["p"+l])a.CW["p"+l].8d(A)&&a.CW["p"+l][A]&&u.1i(ZC.1l(A.1E("n","")));C[l]=u}1m C}1m{};1j"16s":1a p={};C=[],1c!==ZC.1d(n=i.aW)&&(p=ZC.AO.pQ(n)),(a=c.C8(i[ZC.1b[3]]))&&(a.CW=p,a.HC=!0,a.f7(),a.K2(!0,!0));1p;1j"9K":1j"pN":1a h=[],1b=1f(e){1a i=!1;1c!==ZC.1d(n=e.9L)&&(i=ZC.2q(n));1a a=c.C8(e[ZC.1b[3]]);if(a){1k(l=0,o=a.AX.A7.1h;l<o;l++)a.JZ[l]=!1;1a C=1c,u=1c;if(1c!==ZC.1d(n=e.3S))if("4g"==1w n)C=n;1t if("2Y"==1w n&&/\\d+\\-\\d+/.5x(n)){if(2===(r=n.2l("-")).1h)1k(C=[],Z=ZC.1l(r[0]);Z<=ZC.1l(r[1]);Z++)C.1i(Z)}1t C=[n];if(1c!==ZC.1d(n=e.5Q))if("4g"==1w n)u=n;1t if("2Y"==1w n&&/\\d+\\-\\d+/.5x(n)){if(2===(r=n.2l("-")).1h)1k(u=[],Z=ZC.1l(r[0]);Z<=ZC.1l(r[1]);Z++)u.1i(Z)}1t u=[n];if(1c===ZC.1d(C))1k(C=[],l=0,o=a.AX.A7.1h;l<o;l++)C.1i(l);1k(l=0,o=C.1h;l<o;l++){1a p=C[l];if(a.AX.A7[p])if(1c===ZC.1d(a.CW["p"+p])&&(a.CW["p"+p]={}),1c===ZC.1d(u))1k(A=0,s=a.AX.A7[p].S.1h;A<s;A++)"9K"===t?i&&a.CW["p"+p]["n"+A]?4o a.CW["p"+p]["n"+A]:a.CW["p"+p]["n"+A]=!0:"pN"===t&&4o a.CW["p"+p]["n"+A];1t 1k(A=0,s=u.1h;A<s;A++)"9K"===t?i&&a.CW["p"+p]["n"+u[A]]?4o a.CW["p"+p]["n"+u[A]]:a.CW["p"+p]["n"+u[A]]=!0:"pN"===t&&4o a.CW["p"+p]["n"+u[A]]}-1===ZC.AT(h,a)&&h.1i(a)}};if(i 3z 3K)1k(Z=0;Z<i.1h;Z++)1b(i[Z]);1t 1b(i);1k(Z=0;Z<h.1h;Z++)h[Z].HC=!0,h[Z].f7(),h[Z].K2(!0,!0)}1m 1c},ZC.JS.5a.NW=1f(){1a e=1g;e.AJ["3d"]&&1w ZC.AM!==ZC.1b[31]&&(ZC.AM.fg=2.5*ZC.BN(e.I,e.F),ZC.AM.E1=e.Q.iX+e.Q.I/2,ZC.AM.E0=e.Q.iY+e.Q.F/2,ZC.AM.FQ=ZC.1l(e.F7.5q),ZC.AM.E1+=e.F7["1Y-x"],ZC.AM.E0+=e.F7["1Y-y"])},ZC.JS.5a.qA=1f(){1a e,t,i=1g;if(i.AJ["3d"]&&1w ZC.AM!==ZC.1b[31]){if(i.A.B9.2t(i.F7,"2U.3d-7e"),i.A.B9.2t(i.F7,i.AF+".3d-7e"),1c!==ZC.1d(e=i.o[ZC.1b[26]])&&ZC.2A(e,i.F7),"7k"===i.AF&&i.o.1B&&i.o.1B.Cm){1a n=ZC.5m(ZC.1W(i.o.1B.Cm),1,3);i.F7[ZC.1b[27]]=25+(n-1)/2*(i.AJ["x-2c-1V"]-i.AJ["x-2c-2h"])}1a a=["2c","5q",ZC.1b[27],ZC.1b[28],ZC.1b[29],"3C","1Y-x","1Y-y"];1k(t=0;t<a.1h;t++)i.F7[a[t]]=ZC.1W(i.F7[a[t]]);1a l=["2c",ZC.1b[27],ZC.1b[28],ZC.1b[29]];1k(t=0;t<l.1h;t++)ZC.DU(i.F7[l[t]],i.AJ[l[t]+"-2h"],i.AJ[l[t]+"-1V"])||(i.F7[l[t]]=i.AJ[l[t]+"-2h"]);i.F7.7J=ZC.2q(i.F7.7J)}},ZC.JS.5a.S7=1f(){1a e,t,i,n,a=1g;3!==1o.cQ&&(1o.cQ=a.F7.7J?1:2);1a l=a.CH.f1.1h;1k(e=0;e<l;e++)(t=a.CH.f1[e]).Ck(),a.F7.7J?3===1o.cQ?a.CH.WD[e]=[ZC.1W(t.ZJ.4v(1))*t.M9[2],e]:a.CH.WD[e]=[[ZC.1W(t.SG.4v(1))*t.M9[0],ZC.1W(t.lf.4v(1))*t.M9[1],ZC.1W(t.ZJ.4v(1))*t.M9[2],ZC.1W(t.hf.4v(1))],e]:a.CH.WD[e]=[[ZC.1W(t.SG.4v(1))*t.M9[0],ZC.1W(t.la.4v(1))*t.M9[1],ZC.1W(t.l9.4v(1))*t.M9[2],ZC.1l(t.FS)],e];a.CH.WD.3V(a.CH.Cc);1a o=1n ZC.DS(a);1k(i=a.H.2L()?a.H.mc():ZC.AK(a.K+"-4j-bl-c"),n=ZC.P.E6(i,a.H.AB),e=0;e<l;e++){1a r=[],C=a.CH.WD[e][1],A=(t=a.CH.f1[C]).D.1h;if(A>0){1k(1a s=0;s<A;s++)r.1i(t.D[s].E9);r.1i(t.D[0].E9),o.$i(a),o.K=a.K+"-16u-"+(""!==t.K?t.K:ZC.bW++),o.1Q(t.N),o.CX=!1,o.Z=i,o.9p(1),o.D=r,o.DP="4x",o.9p(2),o.1v()}}1a Z=[];1k(1a c in a.CH.SA)Z.1i([c,a.CH.SA[c].9V]);Z.3V(1f(e,t){1m t[1]-e[1]});1k(1a u=0;u<Z.1h;u++){1a p=a.CH.SA[Z[u][0]];ZC.CN.2E(n,p.1H),ZC.CN.1v(n,p.1H,p.2S)}},ZC.JS.5a.U6=1f(){if(!1o.4C.e8){1a e,t=1g;if(t.BC){if(t.BC.RY&&t.L!==t.A.AI.1h-1&&!t.BC.o.ei)1m;t.BC.Z=t.BC.C5=t.H.2L()?t.H.mc("1u"):ZC.AK(t.K+"-1U-c"),t.BC.1v(),-1===ZC.AT(t.H.KL,ZC.1b[41])&&(t.QR=1f(e){1a i,n;if(!ZC.3l){t.A8&&t.A.A8&&t.A8.AL&&t.A.A8.eI(e);1a a=e.9O||e.2T.id,l=ZC.1l(a.1E(t.K,"").1E("-1U-7E","").1E("-1U-aH","").1E("-1M","").1E("-1O","")),o=t.AX.A7[l];if(o.FT&&(t.BC.WO||o.I4)&&o.S.1h)1k(i=0,n=o.S.1h;i<n;i++)1c!==o.S[i]&&o.S[i].J7&&o.FO(i).6e("5M");ZC.3l=!0;1a r=ZC.AT(t.AX.LG,l);t.BC.eu(r),ZC.3l=!1;1a C=t.AX.A7[l].UP(e);t.E["1U-7Y-2V"]=l,ZC.AO.C2("16v",t.A,C)}},t.PH=1f(e){ZC.3l||t.A8&&t.A.A8&&t.A8.AL&&t.A.A8.gx(e)},t.R2=1f(e){if(!ZC.3l){t.A8&&t.A.A8&&t.A8.AL&&t.A.A8.eT(e),t.LK(),ZC.3l=!0,t.BC.eu(-1),ZC.3l=!1;1a i=ZC.7O(t.E["1U-7Y-2V"],0),n=t.AX.A7[i].UP(e);ZC.AO.C2("16w",t.A,n)}},t.9x=1f(e){t.BC.DC&&"1X-y"===t.BC.DC.AF&&(e.6L(),t.BC.DC.Aq(e))},t.SH=1f(i){if(t.E.rO=!0,!(ZC.3l||(1o.S6(i),i.8T>1))){1a n,a,l,o=i.9O||i.2T.id,r=ZC.2q(t.BC.BQ.o.rD);ZC.2H&&t.H.A8&&t.H.A8.5c();1a C="1N";-1!==o.1K("-1U-aH")&&(C="1O"),t.LK(),i.6L();1a A=t.BC.ID;"1N"===C?A=t.BC.QU:"1O"===C&&(A=t.BC.PL),t.A.K3&&(A="3m"),t.E["1U-84-7T"]=C;1a s=ZC.1l(o.1E(t.K+"-1U-7E","").1E(t.K+"-1U-aH","").1E("-1M",""));if(t.o[ZC.1b[11]]&&t.o[ZC.1b[11]][s]){if(1c!==ZC.1d(e=t.o[ZC.1b[11]][s]["1U-1N"])){1a Z=e.3P||"",c=e.2T||"";""!==Z&&t.UQ(i,Z,c)}t.o[ZC.1b[11]][s].2f=!0}1a u=t.AX.A7[s].UP(i);u.2f=ZC.2q(t.E["1B"+s+".2f"]),ZC.AO.C2("16z"+C+"16A",t.A,u);1a p,h,1b;1P(A){2n:1p;1j"5c":1j"3m":if(i.Ab){1a d=0;1k(n=0,a=t.AX.A7.1h;n<a;n++)if(n!==s&&(d++,l=d===a-1,t.Q2({"bK-1U":r,K2:l,3S:n,"9L-7Y":A}),t.BC.RY))1k(p=0,h=t.H.AI.1h;p<h;p++)(1b=t.H.AI[p]).BC&&1b.BC.RY&&1b.BC.f8===t.BC.f8&&1b.K!==t.K&&1b.Q2({"bK-1U":!0,K2:l,3S:n,"9L-7Y":A})}1t if(t.Q2({"bK-1U":r,K2:1,3S:s,"9L-7Y":A}),t.BC.RY)1k(p=0,h=t.H.AI.1h;p<h;p++)(1b=t.H.AI[p]).BC&&1b.BC.RY&&1b.BC.f8===t.BC.f8&&1b.K!==t.K&&1b.Q2({"bK-1U":!0,K2:1,3S:s,"9L-7Y":A})}"5c"===A&&t.E.Ag&&(t.OU(),t.QF())}},ZC.A4("."+t.K+"-1U-1N-1M").4c("6f 4D",t.SH).4c("fh",t.9x).4c("ar",t.9x),ZC.A4("."+t.K+"-1U-1O-1M").4c("6f 4D",t.SH).4c("fh",t.9x).4c("ar",t.9x),ZC.A4("#"+t.K+"-1U-9S").4c("fh",t.9x).4c("ar",t.9x),ZC.2H||(ZC.A4("."+t.K+"-1U-1N-1M").4c(ZC.P.C1("6Z"),t.QR).4c(ZC.P.C1("7B"),t.R2).4c(ZC.P.C1(ZC.1b[48]),t.PH),ZC.A4("."+t.K+"-1U-1O-1M").4c(ZC.P.C1("6Z"),t.QR).4c(ZC.P.C1("7B"),t.R2).4c(ZC.P.C1(ZC.1b[48]),t.PH)))}}},ZC.Ao=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="1c",t.AJ.3r=!0,t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0}}),ZC.zZ=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="qR",t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ["x-2c-2h"]=-eR,t.AJ["x-2c-1V"]=eR,t.AJ["y-2c-2h"]=-eR,t.AJ["y-2c-1V"]=eR,t.AJ["z-2c-2h"]=-eR,t.AJ["z-2c-1V"]=eR,1o.cQ=3},3v:1f(){1a e=1g;e.b(),e.CH.3v()},1v:1f(){1a e=1g;e.b(),e.PV(),e.S7(),e.bC(),e.KE(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.NA=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="xy",t.AJ.3r=!0,t.AJ.3t="xy"},MI:1f(e){1a t=1g;1P(e){1j"x":1m 1n ZC.SS(t);1j"y":1m 1n ZC.SV(t)}},ci:1f(){1a e,t=1g,i=t.MI("x",ZC.1b[50]);1k(i.BB=ZC.1b[50],i.K=t.K+"-1z-x",t.BK.1i(i),e=2;e<50;e++)if(1c!==ZC.1d(t.o["1z-x-"+e])){1a n=t.MI("x","1z-x-"+e);n.L=e,n.BB="1z-x-"+e,n.K=t.K+"-1z-x-"+e,t.BK.1i(n)}1a a=t.MI("y",ZC.1b[51]);1k(a.BB=ZC.1b[51],a.K=t.K+"-1z-y",t.BK.1i(a),e=2;e<50;e++)if(1c!==ZC.1d(t.o["1z-y-"+e])){1a l=t.MI("y","1z-y-"+e);l.L=e,l.BB="1z-y-"+e,l.K=t.K+"-1z-y-"+e,t.BK.1i(l)}t.b()}}),ZC.nM=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="1y",t.AX=1n ZC.nZ(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0}}),ZC.nN=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="1M",t.AX=1n ZC.nY(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0}}),ZC.Bg=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="bF",t.AJ.3t="yx",t.AX=1n ZC.Dr(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0},MI:1f(e){1P(e){1j"x":1m 1n ZC.UM(1g);1j"y":1m 1n ZC.UL(1g)}}}),ZC.Bf=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="bE",t.AJ.3t="yx",t.AX=1n ZC.Dq(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0},MI:1f(e){1P(e){1j"x":1m 1n ZC.UM(1g);1j"y":1m 1n ZC.UL(1g)}}}),ZC.kU=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5A",t.AX=1n ZC.jS(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0},MI:1f(e,t){1P(e){1j"x":1a i=1g.b(e,t);1m i.DK=!0,i;1j"y":1m 1g.b(e,t)}}}),ZC.kV=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="6d",t.AJ.3t="yx",t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0,t.AX=1n ZC.jR(t)},MI:1f(e){1P(e){1j"x":1a t=1n ZC.UM(1g);1m t.DK=!0,t;1j"y":1m 1n ZC.UL(1g)}}}),ZC.qU=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="9q",t.AX=1n ZC.Z4(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0},MI:1f(e,t){1P(e){1j"x":1a i=!1;if(1g.o[ZC.1b[11]])1k(1a n=0;n<1g.o[ZC.1b[11]].1h;n++)if(1g.o[ZC.1b[11]][n]&&1g.o[ZC.1b[11]][n].1I&&-1!==ZC.AT(["2Q","5A","eZ","8q","8f","6M"],1g.o[ZC.1b[11]][n].1I)){1a a=(1g.o[ZC.1b[11]][n].3w||"1z-x,1z-y").2l(",");-1!==ZC.AT(a,t)&&(i=!0)}1a l=1g.b(e,t);1m l.DK=i,l;1j"y":1m 1g.b(e,t)}}}),ZC.Bd=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="iw",t.AJ.3t="yx",t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0,t.AX=1n ZC.Z4(t)},MI:1f(e,t){1P(e){1j"x":1a i=1n ZC.UM(1g),n=!1;if(1g.o[ZC.1b[11]])1k(1a a=0;a<1g.o[ZC.1b[11]].1h;a++)if(1g.o[ZC.1b[11]][a]&&1g.o[ZC.1b[11]][a].1I&&-1!==ZC.AT(["6d","80"],1g.o[ZC.1b[11]][a].1I)){1a l=(1g.o[ZC.1b[11]][a].3w||"1z-x,1z-y").2l(",");-1!==ZC.AT(l,t)&&(n=!0)}1m i.DK=n,i;1j"y":1m 1n ZC.UL(1g)}}}),ZC.qX=ZC.qU.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="b1",t.AX=1n ZC.Z4(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0},3v:1f(){1a e=1g;e.b(),e.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Bb=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="6t",t.AX=1n ZC.Gx(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0}}),ZC.Ba=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8t",t.AJ.3t="yx",t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0,t.AX=1n ZC.Dt(t)},MI:1f(e){1P(e){1j"x":1m 1n ZC.UM(1g);1j"y":1m 1n ZC.UL(1g)}}}),ZC.AS=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5h",t.AX=1n ZC.Do(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ["4S-1X"]=!0}}),ZC.Ar=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="6z",t.AJ.3t="yx",t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ["4S-1X"]=!0,t.AX=1n ZC.Dx(t)},MI:1f(e){1P(e){1j"x":1m 1n ZC.UM(1g);1j"y":1m 1n ZC.UL(1g)}}}),ZC.nI=ZC.JS.C7({$i:1f(e){1g.b(e),1g.AF="3L",1g.AX=1n ZC.o2(1g)},cE:1f(){1m""},MI:1f(e){1P(e){1j"m":1m 1n ZC.XU(1g);1j"v":1m 1n ZC.ZB(1g);1j"r":1m 1n ZC.tq(1g)}},ci:1f(){1a e=1g,t=e.MI("m","1z"),i=e.MI("v",ZC.1b[52]),n=e.MI("r","1z-r");t.BB="1z",t.K=e.K+"-1z",e.o[ZC.1b[11]]&&e.o[ZC.1b[11]].1h&&e.o[ZC.1b[11]][0][ZC.1b[5]]&&(t.N9="1x"+e.o[ZC.1b[11]][0][ZC.1b[5]].1h),i.BB=ZC.1b[52],i.K=e.K+"-1z-v",n.BB="1z-r",n.K=e.K+"-1z-r",e.BK.1i(t,i,n),e.b()},qB:1f(){1a e=1g;-1!==ZC.AT(["2B","3I"],e.H.AB)&&ZC.A4("#"+e.K+" .zc-6r").4Z(1f(){/\\-1B-\\d+\\-bl\\-\\d+\\-/.5x(1g.id)&&ZC.A4(1g).9s().4Z(1f(){/\\-97\\-2M/.5x(1g.id)&&ZC.P.ES(1g)})})}}),ZC.Ay=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="96",t.AX=1n ZC.DO(t)},cE:1f(){1m""},MI:1f(e){1P(e){1j"m":1m 1n ZC.XU(1g)}},ci:1f(){1a e=1g,t=e.MI("m","1z");t.BB="1z",t.K=e.K+"-1z",e.BK.1i(t),e.b()}}),ZC.Ax=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;if(t.AF="74",t.AJ.3t="74",t.AX=1n ZC.Ea(t),-1!==ZC.AT(t.A.K,"pn")){1k(1a i=1,n=0;n<t.A.M4.ek.1h;n++)i=ZC.BN(i,t.A.M4.ek[n][ZC.1b[5]].1h);i=1A.43(2j/i).aq(),1c===ZC.1d(t.A.M4.1B)?t.A.M4.1B={7e:"1M"}:ZC.2A({7e:"1M"},t.A.M4.1B),1c===ZC.1d(t.A.M4["1z-k"])?t.A.M4["1z-k"]={7e:"3x",5K:"%v\\Cs",6g:"0:Ef:"+i}:ZC.2A({7e:"3x",5K:"%v\\Cs",6g:"0:Ef:"+i},t.A.M4["1z-k"],!0)}},cE:1f(){1m""},MI:1f(e){1a t=1g;1P(e){1j"m":1m 1n ZC.XU(t);1j"k":1m 1n ZC.yg(t);1j"v":1m 1n ZC.yv(t)}},ci:1f(){1a e=1g,t=e.MI("k","1z-k");t.BB="1z-k",t.K=e.K+"-1z-k",e.BK.1i(t);1a i=e.MI("v",ZC.1b[52]);i.BB=ZC.1b[52],i.K=e.K+"-1z-v",e.BK.1i(i);1a n=e.MI("m","1z");n.BB="1z",n.K=e.K+"-1z",e.BK.1i(n),e.b()}}),ZC.Et=ZC.kU.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8q",t.AX=1n ZC.Eb(t),t.AJ[ZC.1b[55]]=!1}}),ZC.Es=ZC.kV.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="80",t.AJ.3t="yx",t.AX=1n ZC.Dw(t),t.AJ[ZC.1b[55]]=!1}}),ZC.Em=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5O",t.AX=1n ZC.Dm(t),t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0},i7:1f(e){1a t=1g;if("v"===e){1a i=[];if(t.o[ZC.1b[11]]&&t.o[ZC.1b[11]].1h)1k(1a n=0;n<t.o[ZC.1b[11]].1h;n++)i.1i(t.o[ZC.1b[11]][n].1D||"17k "+(n+1));1m i}},MI:1f(e){1P(e){1j"x":1a t=1n ZC.SS(1g);1m t.DK=!0,t;1j"y":1a i=1n ZC.SV(1g);1m i.DK=!0,i.1C({6Y:1,"7m-6Y":!0}),i}}}),ZC.El=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="ao",t.AX=1n ZC.Cw(t),t.AJ[ZC.1b[55]]=!1,t.AJ["4S-cj"]=!1,t.AJ["4S-1X"]=!1},MI:1f(e,t){1P(e){1j"x":1a i=1g.b(e,t);1m i.DK=!0,i;1j"y":1a n=1g.b(e,t);1m n.DK=!0,n}},i7:1f(e){1a t=1g;if("v"===e){1k(1a i=[],n=0;n<t.o[ZC.1b[11]].1h;n++)i.1i("Ej "+(n+1));1m i}},1v:1f(){1k(1a e=1g,t=0,i=e.BK.1h;t<i;t++)"v"===e.BK[t].AF&&(e.BK[t].AR=!e.BK[t].AR);e.b()}}),ZC.Ek=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="ap",t.AX=1n ZC.Dl(t),t.AJ[ZC.1b[55]]=!1,t.AJ["4S-cj"]=!1,t.AJ["4S-1X"]=!1},i7:1f(e){1a t=1g;if("v"===e){1k(1a i=[],n=0;n<t.o[ZC.1b[11]].1h;n++)i.1i("Ej "+(n+1));1m i}},MI:1f(e){1P(e){1j"x":1a t=1n ZC.UM(1g);1m t.DK=!0,t;1j"y":1a i=1n ZC.UL(1g);1m i.DK=!0,i}}}),ZC.Ei=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8f",t.AX=1n ZC.Dk(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0,t.AJ[ZC.1b[56]]=!0},MI:1f(e,t){1P(e){1j"x":1a i=1g.b(e,t);1m i.DK=!0,i;1j"y":1m 1g.b(e,t)}}}),ZC.Eh=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8M",t.AJ.3t="8M",t.AX=1n ZC.Dj(t)},cE:1f(){1m""},MI:1f(e){1a t=1g;1P(e){1j"m":1m 1n ZC.XU(t);1j"r":1m 1n ZC.ym(t);1j"v":1m 1n ZC.ZB(t)}},ci:1f(){1a e,t=1g,i=t.MI("m","1z");1k(i.BB="1z",i.K=t.K+"-1z",t.BK.1i(i),e=2;e<10;e++)if(1c!==ZC.1d(t.o["1z-"+e])){1a n=t.MI("m","1z-"+e);n.L=e,n.BB="1z-"+e,n.K=t.K+"-1z-"+e,t.BK.1i(n)}1a a=t.MI("r","1z-r");1k(a.BB="1z-r",a.K=t.K+"-1z-r",t.BK.1i(a),e=2;e<10;e++)if(1c!==ZC.1d(t.o["1z-r-"+e])){1a l=t.MI("r","1z-r-"+e);l.L=e,l.BB="1z-r-"+e,l.K=t.K+"-1z-r-"+e,t.BK.1i(l)}t.b()},pk:1f(){1a e=1g;ZC.A4("#"+e.K+"-4j-bl-2").9s().4Z(1f(){ZC.P.IL(1g,e.H.AB,e.iX,e.iY,e.I,e.F,e.K)})}}),ZC.Ev=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5y",t.AX=1n ZC.Dg(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0,t.AJ[ZC.1b[56]]=!0}}),ZC.Eo=ZC.NA.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5y",t.AJ.3t="yx",t.AX=1n ZC.Df(t),t.AJ[ZC.1b[23]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0,t.AJ[ZC.1b[56]]=!1},MI:1f(e){1P(e){1j"x":1m 1n ZC.UM(1g);1j"y":1m 1n ZC.UL(1g)}}}),ZC.Fm=ZC.nI.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="7k",t.AX=1n ZC.Dd(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["x-2c-2h"]=15,t.AJ["x-2c-1V"]=75,t.AJ["y-2c-2h"]=0,t.AJ["y-2c-1V"]=0,t.AJ["z-2c-2h"]=0,t.AJ["z-2c-1V"]=0},3v:1f(){1a e=1g;e.b(),e.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Fk=ZC.kV.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="7v",t.AX=1n ZC.Da(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[56]]=!1,t.AJ[ZC.1b[55]]=!1,t.AJ["x-2c-2h"]=-20,t.AJ["x-2c-1V"]=20,t.AJ["y-2c-2h"]=-20,t.AJ["y-2c-1V"]=0},3v:1f(){1a e=1g;e.b(),e.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Fi=ZC.kU.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="6M",t.AX=1n ZC.Dc(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0},3v:1f(e,t){1a i=1g;i.b(e,t),i.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Ff=ZC.nM.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8Y",t.AX=1n ZC.Cy(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0},3v:1f(e,t){1a i=1g;i.b(e,t),i.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Ey=ZC.nN.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="81",t.AX=1n ZC.Cx(t),t.CH=1n ZC.UR,t.AJ["3d"]=!0,t.AJ[ZC.1b[56]]=!0,t.AJ[ZC.1b[55]]=!1,t.AJ["4S-1X"]=!0},3v:1f(e,t){1a i=1g;i.b(e,t),i.CH.3v()},1v:1f(){1a e=1g;e.b(),e.S7(),e.bC(),e.PV(),e.FJ.1h&&(e.CH.3v(),e.KE(),e.S7()),e.U6(),-1===ZC.AT(e.H.KL,ZC.1b[41])&&e.RU()}}),ZC.Dn=ZC.JS.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="aV",t.AX=1n ZC.Ed(t)},cE:1f(){1m""},MI:1f(e){1a t=1g;1P(e){1j"m":1m 1n ZC.XU(t)}},1q:1f(){1a e=1g;e.b(),e.BC&&(e.BC.ID="3m",e.BC.QU="3m",e.BC.PL="3m")},ci:1f(){1a e=1g,t=e.MI("m","1z");t.BB="1z",t.K=e.K+"-1z",e.BK.1i(t),e.b()}}),ZC.LE=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.C=e,t.H=t.C.A,t.A7=[],t.HK=1c,t.K6=[],t.JY=[],t.PR=!0,t.F3=1c,t.kj=!0,t.YG=[]},5i:1f(){1m 1n ZC.I8(1g)},1q:1f(){1a e,t,i,n=1g;1k(n.K=n.A.K+"-cu",n.F3=1c,t=n.o.1h-1;t>=0;t--)1w n.o[t]===ZC.1b[31]&&n.o.6p(t,1);if(1c===ZC.1d(n.E["1B-3V"])&&(n.E["1B-3V"]=!1),n.o.1h>1){1k(t=0,i=n.o.1h;t<i;t++)1w n.o[t].6V===ZC.1b[31]&&(n.o[t].6V=t);1a a=[],l=[];1k(t=0,i=n.o.1h;t<i;t++)l[t]=t,a[t]={"z-2V":n.o[t]["z-2V"]||0};1k(1a o=!1;!o;)1k(o=!0,t=0,i=a.1h;t<i-1;t++)if(a[t]["z-2V"]>a[t+1]["z-2V"]){n.E["1B-3V"]=!0;1a r=a[t];a[t]=a[t+1],a[t+1]=r;1a C=l[t];l[t]=l[t+1],l[t+1]=C,o=!1}n.LG=l}1t n.LG=[0];1k(n.A7=[],t=0,i=n.o.1h;t<i;t++){1a A="";n.A.o.1B&&1c!==ZC.1d(e=n.A.o.1B.1I)&&(A=e),1c!==ZC.1d(e=n.o[t].1I)&&(A=e);1a s=n.5i(A,t);s.O9=s.AF+"1B",s.L=t,s.JJ=t,n.C.A.B9.2t(s.o,["("+s.AF+").1B"]),s.dz&&n.C.A.B9.2t(s.o,["("+s.dz+").1B"]),n.C.A.B9.2t(s.o,["("+s.AF+").1B.8N"]),1c!==ZC.1d(e=n.A.o.1B)&&s.1C(e),s.1C(n.o[t]),s.CB=n.A.CB,s.1q(),n.A7.1i(s)}1a Z={},c=[],u=[],p={},h={},1b=0,d=0;1k(t=0,i=n.A7.1h;t<i;t++)if(1c!==ZC.1d(n.A.A.E["g-"+n.A.L+"-p-"+t+".2f"])&&(n.C.E["1B"+t+".2f"]=n.A.A.E["g-"+n.A.L+"-p-"+t+".2f"]),!n.A7[t].IU&&(n.C.E["1B"+t+".2f"]||"5c"===n.C.8b())){n.A7[t].CB?(-1===(d=ZC.AT(u,n.A7[t].DV))&&(u.1i(n.A7[t].DV),d=u.1h-1),1c===ZC.1d(c[d])?c[d]=[t]:c[d].1i(t)):(u.1i(-1),d=u.1h-1,1c===ZC.1d(c[d])?c[d]=[t]:c[d].1i(t));1a f=n.A7[t].AF;if(n.A7[t].o.1I&&f!==n.A7[t].o.1I){1a g=f.1K("3d"),B=n.A7[t].o.1I.1K("3d");(-1===g&&-1!==B||-1===g&&-1===B)&&(f=n.A7[t].o.1I)}-1!==ZC.AT(["2Q","ej","eZ"],f)&&(f="v"+f),-1===ZC.AT(["5A","6d","8q","80","8f","6M","7v"],f)||n.A7[t].IU||(1c===ZC.1d(p[f])&&(p[f]=[]),1c===ZC.1d(h[f])&&(h[f]=[]),n.A7[t].CB?(1c===ZC.1d(Z[n.A7[t].DV])?Z[n.A7[t].DV]=1:Z[n.A7[t].DV]++,-1===(1b=ZC.AT(h[f],n.A7[t].DV))&&(h[f].1i(n.A7[t].DV),1b=h[f].1h-1),1c===ZC.1d(p[f][1b])?p[f][1b]=[t]:p[f][1b].1i(t)):(h[f].1i(-1),1b=h[f].1h-1,1c===ZC.1d(p[f][1b])?p[f][1b]=[t]:p[f][1b].1i(t)))}if(n.K6=c,n.JY=p,n.WM)1k(1a v in n.WM)n.WM[v].3V();1k(n.jN=[],t=0;t<n.K6.1h;t++)n.jN.1i(n.K6[t][n.K6[t].1h-1])},1v:1f(){1f e(i){1a n=t.LG[i];(t.A7[n].IA||t.A7[n].E4.1h&&t.A.BI||"1Z"!==t.A7[n].IV)&&(t.H.O1=!1),t.kj=!0;1a a=t.C.8b();t.C.AJ["3d"]?t.C.E["1B"+n+".2f"]&&(t.A7[n].1v(),t.H.ZK()):(t.C.E["1B"+n+".2f"]||"5c"===a)&&(1w t.C.E["1B-"+n+"-iT-nr"]!==ZC.1b[31]&&(t.A7[n].TG=0),t.A7[n].1v(),t.A7[n].TG=0,t.H.ZK(),t.C.E["1B"+n+".2f"]||"5c"!==a||(t.C.E["1B"+n+".2f"]=!0,t.A.Q2({3S:n,"bK-1U":!0}))),t.C.E["1B-"+n+"-iT-nr"]=!1,i<t.A7.1h-1?t.C.LH?ZC.nU[t.C.K]=2u.5G(1f(){e(i+1)},10):t.A7.1h<=100&&e(i+1):(!t.C.LH||t.C.LH&&t.kj)&&t.fk()}1a t=1g;if(t.HK=[],t.A7.1h>0)if(t.A7.1h>100&&!t.C.LH)1k(1a i=0;i<t.A7.1h;i++)e(i);1t e(0);1t t.fk()},fk:1f(){1f e(e){1a t=0,n=e.1K(ZC.1b[35]),a=e.1K("-2o-",n);1m-1!==n&&-1!==a&&(t=e.5v(n+14,a-n-14)),1w i.A7[t].E["z-9T"]!==ZC.1b[31]?i.A7[t].E["z-9T"]:t}1a t,i=1g;i.RS=1c,i.VE=1c;1k(1a n=0;n<i.C.BK.1h;n++)i.C.BK[n].ER=1c,i.C.BK[n].WN=1c;1a a=["5h","6z","8q","80","74","6M","7v","9q","b1","7k","iw","17r"];(t=ZC.AK(i.C.A.K+"-2Z"))&&!i.H.dm&&(-1===ZC.AT(a,i.C.AF)&&1!==1o.tQ||i.HK.3V(1f(t,n){1m"7k"===i.C.AF?ZC.AO.MW(t)>ZC.AO.MW(n)?1:ZC.AO.MW(t)<ZC.AO.MW(n)?-1:0:e(t)>e(n)&&i.A.AJ["3d"]?1:e(t)<e(n)&&i.A.AJ["3d"]?-1:ZC.AO.MW(t)>ZC.AO.MW(n)?1:ZC.AO.MW(t)<ZC.AO.MW(n)?-1:0}),1o.3G.Du?2u.5G(1f(){t.4n+=i.HK.2I("")},na):t.4n+=i.HK.2I("")),i.EZ=1c,i.D4=1c,i.C.Ds=[],i.A.fk()}}),ZC.nZ=ZC.LE.C7({5i:1f(){1m 1n ZC.QD(1g)}}),ZC.nY=ZC.LE.C7({5i:1f(){1m 1n ZC.QC(1g)}}),ZC.Dr=ZC.LE.C7({5i:1f(){1a e=1n ZC.QD(1g);1m e.OK=!0,e}}),ZC.Dq=ZC.LE.C7({5i:1f(){1a e=1n ZC.QC(1g);1m e.OK=!0,e}}),ZC.jS=ZC.LE.C7({5i:1f(){1m 1n ZC.QS(1g)}}),ZC.jR=ZC.LE.C7({5i:1f(){1m 1n ZC.QB(1g)}}),ZC.Z4=ZC.LE.C7({5i:1f(e){1a t=1g;1P(e){2n:1m 1n ZC.QD(t);1j"bF":1a i=1n ZC.QD(t);1m i.OK=!0,i;1j"4x":1a n=1n ZC.P8(t);1m n.k4=!0,n.dz="4x",n;1j"1M":1m 1n ZC.QC(t);1j"bE":1a a=1n ZC.QC(t);1m a.OK=!0,a;1j"2Q":1j"5A":1m 1n ZC.QS(t);1j"6d":1m 1n ZC.QB(t);1j"6t":1m 1n ZC.P8(t);1j"8t":1m 1n ZC.P8(t,"8t");1j"5h":1m 1n ZC.RV(t);1j"6z":1m 1n ZC.RV(t,"6z");1j"8f":1m 1n ZC.V3(t);1j"5y":1m 1n ZC.TT(t);1j"8Y":1m 1n ZC.UA(t);1j"81":1m 1n ZC.UD(t);1j"ej":1j"6M":1m 1n ZC.UI(t);1j"eZ":1j"8q":1m 1n ZC.T5(t);1j"80":1m 1n ZC.T7(t)}}}),ZC.Gx=ZC.LE.C7({5i:1f(){1m 1n ZC.P8(1g)}}),ZC.17t=ZC.LE.C7({5i:1f(){1a e=1n ZC.P8(1g);1m e.k4=!0,e.dz="4x",e}}),ZC.Dt=ZC.LE.C7({5i:1f(){1m 1n ZC.P8(1g,"8t")}}),ZC.Do=ZC.LE.C7({5i:1f(){1m 1n ZC.RV(1g)}}),ZC.Dx=ZC.LE.C7({5i:1f(){1m 1n ZC.RV(1g,"6z")}}),ZC.o2=ZC.LE.C7({$i:1f(e){1g.b(e);1a t=1g;t.KF=[],t.P7=[],t.TQ=[]},5i:1f(){1m 1n ZC.W4(1g)},jU:1f(e){1a t,i,n,a,l=1g;e&&(l.TQ=[],l.P7=[]);1a o,r=l.A.BL("1z-r"),C=l.A.BL("1z"),A=.9,s=1;l.A7.1h>=10&&(s=1),l.A7.1h>=20&&(s=1.25),l.A7.1h>=30&&(s=1.5);1a Z=r.DM;1k(t=0,i=l.A7.1h;t<i;t++)1c!==ZC.1d(l.A7[t].o["3N-2c"])&&(Z=l.A7[t].DM);1k(t=0,i=l.A7.1h;t<i;t++)if(l.C.E["1B"+t+".2f"]||"5c"===l.C.8b())1k(1a c=0,u=l.A7[t].S.1h;c<u;c++)if(l.A7[t].S[c]){l.Y4["n"+c]=l.Y4["n"+c]||[];1a p=l.A7[t].S[c];1c===ZC.1d(l.P7[c])&&(l.P7[c]=Z);1a h,1b;h=1c!==ZC.1d(a=l.A7[t].o[ZC.1b[1]])?ZC.1W(a):l.P7[c],1b=l.KF[c],1c!==ZC.1d(l.A7[t].o.iD)&&1c!==ZC.1d(l.A7[t].o.iD[c])&&(1b=l.KF[c]=ZC.1W(l.A7[t].o.iD[c])),n=0===1b?h+r.EM*(1/i):0===p.AE&&l.A7[t].TO?h+r.EM*(.t8*l.KF[c])/1b:h+r.EM*p.AE/1b,l.P7[c]=n,p.B1=h,p.BH=n;1a d=p.H5(!0);if("4R"===d.o[ZC.1b[7]]&&d.AL){1a f=ZC.1l((h+n)/2);l.Y4["n"+c][t]=f-Z,o=ZC.CV(C.I/2-s*d.I-d.DR-35,C.F/2-s*d.F-d.DR-15),A=ZC.CV(A,2*o/ZC.CV(C.I,C.F))}}if("7k"===l.A.AF&&(A*=.75),A=ZC.BN(.1,ZC.CV(.9,A)),"3e"===C.o["2b-7b"]&&(C.JI=A),e)1k(1a g in l.Y4)l.Y4[g]=ZC.AN.Dy(l.Y4[g],Z)},1q:1f(){1a e=1g;e.A.o.1B&&"3e"===e.A.o.1B.3t&&(1c===ZC.1d(e.A.o.1B["3N-2c"])&&(e.A.o.1B["3N-2c"]=-90),e.o.3V(1f(e,t){1m t[ZC.1b[5]][0]-e[ZC.1b[5]][0]})),e.TQ=[],e.KF=[],e.P7=[],e.Y4={},e.b();1k(1a t=0,i=e.A7.1h;t<i;t++)1k(1a n=0,a=e.A7[t].S.1h;n<a;n++)e.A7[t].S[n]&&e.A7[t].S[n]&&(e.C.E["1B"+t+".2f"]||"5c"===e.C.8b())&&0===e.A7[t].S[n].AE&&e.A7[t].TO&&(e.KF[n]+=.t8*e.KF[n]);e.jU()}}),ZC.DO=ZC.LE.C7({$i:1f(e){1g.b(e);1a t=1g;t.KF=[],t.P7=[]},5i:1f(){1m 1n ZC.TA(1g)},1q:1f(){1a e=1g;e.KF=[],e.P7=[],e.b();1k(1a t,i=e.A.BL("1z"),n=i.iX+i.I/2,a=1,l=0,o=e.A7.1h;l<o;l++)if(e.C.E["1B"+l+".2f"]||"5c"===e.C.8b())1k(1a r=0,C=e.A7[l].S.1h;r<C;r++)if(e.A7[l].S[r]){1a A=e.A7[l].S[r];1c===ZC.1d(e.P7[r])&&(e.P7[r]=e.A7[l].DM);1a s=e.P7[r],Z=s+2j*A.AE/e.KF[r];e.P7[r]=Z,A.B1=s,A.BH=Z;1a c=A.H5(!0);if(c&&"in"!==c.o[ZC.1b[7]]){1a u=ZC.1l((s+Z)/2);t=((u>=0&&u<=90||u>=3T&&u<=2j?i.iX+i.I-(c.I+25):i.iX+(c.I+25))-n)/ZC.ED(u),a=ZC.CV(a,2*t/i.I),t=i.F/2-(c.F/2+10),a=ZC.CV(a,2*t/i.F)}}a=ZC.BN(.15,ZC.CV(.85,a)),"3e"===i.o["2b-7b"]&&(i.o["2b-7b"]=i.JI=a)}}),ZC.Ea=ZC.LE.C7({iN:{},$i:1f(e){1g.b(e)},5i:1f(){1m 1n ZC.X0(1g)},1v:1f(){1a e=1g;e.iN={},e.b()}}),ZC.Eb=ZC.jS.C7({5i:1f(){1m 1n ZC.T5(1g)}}),ZC.Dw=ZC.jR.C7({5i:1f(){1m 1n ZC.T7(1g)}}),ZC.Dm=ZC.LE.C7({5i:1f(){1m 1n ZC.X9(1g)}}),ZC.nW=ZC.LE.C7({1q:1f(){1a e,t,i,n,a,l=1g;1k(l.B8=ZC.3q,l.BS=-ZC.3q,l.dC=[],l.SF=[],l.b(),e=0,t=l.A7.1h;e<t;e++)1k(i=0,n=l.A7[e].S.1h;i<n;i++)l.A7[e].S[i]&&(a=l.A7[e].S[i],1c===ZC.1d(l.SF[i])&&(l.SF[i]=ZC.3q),1c===ZC.1d(l.dC[i])&&(l.dC[i]=-ZC.3q),l.SF[i]=ZC.CV(l.SF[i],a.AE),l.dC[i]=ZC.BN(l.dC[i],a.AE));1k(e=0,t=l.A7.1h;e<t;e++)1k(i=0,n=l.A7[e].S.1h;i<n;i++)l.A7[e].S[i]&&(a=l.A7[e].S[i],l.B8=ZC.CV(l.B8,a.AE),l.BS=ZC.BN(l.BS,a.AE))}}),ZC.Cw=ZC.nW.C7({5i:1f(){1m 1n ZC.V1(1g)}}),ZC.Dl=ZC.nW.C7({5i:1f(){1m 1n ZC.V2(1g)}}),ZC.Dk=ZC.LE.C7({5i:1f(){1m 1n ZC.V3(1g)}}),ZC.Dj=ZC.LE.C7({5i:1f(){1m 1n ZC.X5(1g)}}),ZC.Dg=ZC.LE.C7({5i:1f(){1m 1n ZC.TT(1g)}}),ZC.Df=ZC.LE.C7({5i:1f(){1a e=1n ZC.TT(1g);1m e.OK=!0,e}}),ZC.Dd=ZC.o2.C7({5i:1f(){1m 1n ZC.X6(1g)}}),ZC.Dc=ZC.jS.C7({5i:1f(){1m 1n ZC.UI(1g)}}),ZC.Da=ZC.jR.C7({5i:1f(){1m 1n ZC.VK(1g)}}),ZC.Cy=ZC.nZ.C7({5i:1f(){1m 1n ZC.UA(1g)}}),ZC.Cx=ZC.nY.C7({5i:1f(){1m 1n ZC.UD(1g)}}),ZC.Ed=ZC.LE.C7({$i:1f(e){1g.b(e),1g.DX=[],1g.NO=[],1g.XB=[]},5i:1f(){1m 1n ZC.YO(1g)},1v:1f(){1f e(e,t){1a i=ZC.2i(e[0]-t[0]),n=ZC.2i(e[1]-t[1]);1m 1A.5B(i*i+n*n)}1a t,i,n,a,l,o,r,C,A,s,Z=1g,c=Z.A.BL("1z"),u=ZC.CV(c.G7,c.GF),p=-ZC.3q,h=ZC.CV(3,Z.A7.1h);1k(t=0,i=h;t<i;t++)1k(s=Z.A7[t].S,l=ZC.AO.OS(Z.A7[t].o[ZC.1b[17]],Z.A7[t].o),n=0,a=s.1h;n<a;n++)s[n].2E(),p=ZC.BN(p,s[n].AE),s[n].W9=ZC.AO.GM(Z.A7[t].u6[n],l);1a 1b=u/(4*1A.5B(p/1A.PI)),d=[],f=[],g=[],B=[],v=1c;Z.NO=[];1a b,E,m;1k(t=0,i=h;t<i;t++)1k(d[t]||(d[t]=[]),f[t]||(f[t]=[],g[t]=[]),Z.DX[t]||(Z.DX[t]=[]),s=Z.A7[t].S,B=Z.A7[t+1]&&t+1<3?Z.A7[t+1].S:Z.A7[0].S,n=0,a=s.1h;n<a;n++){Z.NO[n]||(Z.NO[n]=[]),Z.XB[n]||(Z.XB[n]={}),s[n].W8=B[n].AE,0===t?(b=1b*1A.5B(s[n].AE/1A.PI),E=1b*1A.5B(s[n].W8/1A.PI),d[t][n]=1b*ZC.AN.jP(s[n].AE,s[n].W8,s[n].W9),f[t][n]=s[n].iX-ZC.BN(b,E)/2,g[t][n]=s[n].iY+s[n].F/4):1===t?(d[t][n]=1b*ZC.AN.jP(s[n].AE,s[n].W8,s[n].W9),f[t][n]=f[0][n]+d[0][n],g[t][n]=g[0][n],2===h&&(m=(f[0][n]-b-(c.GF-(f[1][n]+E)))/2,Z.A7[t-1].S[n].iX-=m,f[1][n]-=m,Z.DX[0][n].x-=m,Z.NO[n][0][0]-=m,Z.A7[t-1].S[n].iY=c.iY+c.G7/2,g[1][n]=c.iY+c.G7/2,Z.DX[0][n].y=c.iY+c.G7/2)):2===t&&(d[t][n]=1b*ZC.AN.jP(s[n].AE,s[n].W8,s[n].W9),r=(d[0][n]*d[0][n]-d[1][n]*d[1][n]+d[2][n]*d[2][n])/(2*d[0][n]),f[t][n]=f[0][n]+r,C=1A.5B(d[2][n]*d[2][n]-r*r),g[t][n]=g[0][n]-C,3===h&&(m=(f[0][n]-b-(c.GF-(f[1][n]+E)))/2,Z.A7[0].S[n].iX-=m,Z.A7[1].S[n].iX-=m,Z.DX[0][n].x-=m,Z.DX[1][n].x-=m,Z.NO[n][0][0]-=m,f[2][n]-=m)),s[n].iX=f[t][n]+c.iX,s[n].iY=g[t][n],s[n].I=1b*1A.5B(s[n].AE/1A.PI),s[n].F=1b*1A.5B(s[n].AE/1A.PI),s[n].AH=1b*1A.5B(s[n].AE/1A.PI),1c===ZC.1d(v)&&(v=s[n].AE/(1A.PI*s[n].AH*s[n].AH));1a K=1b*1A.5B(s[n].AE/1A.PI),F=1b*1A.5B(s[n].W8/1A.PI),D=K+F-d[t][n],I=(2*D*F-D*D)/(2*(K+F-D)),X=D-I;if(Z.DX[t][n]={x:f[t][n],y:g[t][n],sz:s[n].AH,r1:K,r2:F,eC:X,eq:I},0===t?(C=1A.5B(K*K-(K-I)*(K-I)),Z.NO[n].1i([f[0][n]+K-I,g[0][n]-C])):2===t&&(K=Z.DX[1][n].r1,F=Z.DX[1][n].r2,X=Z.DX[1][n].eC,I=Z.DX[1][n].eq,o=ZC.TF(1A.nC((g[1][n]-g[2][n])/d[1][n]))-ZC.TF(1A.jO((K-I)/K)),Z.NO[n].1i([f[1][n]-K*ZC.ED(o)-m,g[1][n]-K*ZC.EL(o)]),K=Z.DX[2][n].r1,F=Z.DX[2][n].r2,X=Z.DX[2][n].eC,I=Z.DX[2][n].eq,o=ZC.TF(1A.nC((g[0][n]-g[2][n])/d[2][n]))-ZC.TF(1A.jO((F-X)/F)),Z.NO[n].1i([f[0][n]+F*ZC.ED(o)-m,g[0][n]-F*ZC.EL(o)])),t===h-1)if(3===h){if(1c!==ZC.1d(Z.A7[0].kg[n]))Z.XB[n].1M=Z.A7[0].kg[n];1t{1a x=[-1],y=[-1];x[1]=e(Z.NO[n][0],Z.NO[n][2]),x[2]=e(Z.NO[n][0],Z.NO[n][1]),x[3]=e(Z.NO[n][2],Z.NO[n][1]),y[1]=Z.DX[0][n].sz,y[2]=Z.DX[1][n].sz,y[3]=Z.DX[2][n].sz;1a L=.25*1A.5B((x[1]+x[2]+x[3])*(x[1]+x[2]-x[3])*(x[1]+x[3]-x[2])*(x[2]+x[3]-x[1]));1k(A=1;A<=3;A++)L+=y[A]*y[A]*1A.nC(x[A]/(2*y[A]))-x[A]/4*1A.5B(4*y[A]*y[A]-x[A]*x[A]);Z.XB[n].1M=v*L}Z.DX[0][n].eW=ZC.AN.iI(Z.DX[0][n].x,Z.DX[0][n].y,Z.DX[1][n].x,Z.DX[1][n].y,Z.DX[0][n].r1-(Z.DX[0][n].eC+Z.DX[0][n].eq)/2),Z.DX[1][n].eW=ZC.AN.iI(Z.DX[1][n].x,Z.DX[1][n].y,Z.DX[2][n].x,Z.DX[2][n].y,-(Z.DX[1][n].r1-(Z.DX[1][n].eC+Z.DX[1][n].eq)/2)),Z.DX[2][n].eW=ZC.AN.iI(Z.DX[2][n].x,Z.DX[2][n].y,Z.DX[0][n].x,Z.DX[0][n].y,-(Z.DX[2][n].r1-(Z.DX[2][n].eC+Z.DX[2][n].eq)/2)),Z.XB[n].xy=[(Z.NO[n][0][0]+Z.NO[n][1][0]+Z.NO[n][2][0])/3,(Z.NO[n][0][1]+Z.NO[n][1][1]+Z.NO[n][2][1])/3]}1t Z.DX[0][n].eW=ZC.AN.iI(Z.DX[0][n].x,Z.DX[0][n].y,Z.DX[1][n].x,Z.DX[1][n].y,Z.DX[0][n].r1-(Z.DX[0][n].eC+Z.DX[0][n].eq)/2),Z.DX[1][n].eW=[-6J,-6J]}if(3===h)1k(t=0,i=h;t<i;t++)1k(l=ZC.AO.OS(Z.A7[t].o[ZC.1b[17]],Z.A7[t].o),1c!==ZC.1d(l[ZC.1b[12]])&&-1!==l[ZC.1b[12]]||(l[ZC.1b[12]]=0),n=0,a=Z.A7[t].S.1h;n<a;n++)Z.XB[n].1M=ZC.AO.GM(Z.XB[n].1M,l);Z.b()}}),ZC.I8=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.C=e.A,t.H=t.C.A,t.ub={},t.IU=!1,t.SK=3,t.jM=1,t.W=[],t.L8={},t.S=[],t.AF="",t.dz=1c,t.I7=1c,t.RE=!1,t.IV="1Z",t.O0="1B",t.UK=!0,t.SR=1c,t.SX=1c,t.TI={},t.A2=1c,t.G6=1c,t.PI=1c,t.PD=1c,t.BO=1c,t.L=-1,t.BK=[],t.CB=!1,t.KO="5e",t.DV=0,t.U=1c,t.NX=1c,t.A8=1c,t.JL=1c,t.AP=1c,t.JT=1c,t.nq=1c,t.YA=1c,t.DW=-1,t.HN=-1,t.RA=1c,t.RT=1c,t.ZT=!1,t.SC=2,t.f2=!1,t.TP="",t.ZL="vm",t.CS=1c,t.b6=1c,t.MN=1c,t.RP=1c,t.XV=!0,t.XK=1c,t.Y0=1,t.R3=!1,t.RH=!0,t.JJ=0,t.XR=1c,t.SP=1c,t.PR=!0,t.JW=1c,t.Ci=1,t.lB=1,t.RX=[],t.J5=1c,t.EC=!1,t.SQ=[],t.jC=-1,t.GA=!1,t.L6=0,t.J9=.6,t.L4=0,t.17s=0,t.17h=1c,t.TG=0,t.FR=1c,t.IJ=!1,t.YI=!0,t.so=!1,t.XS=1,t.YF=0,t.I4=!1,t.L7=!1,t.kS="2o",t.LN=!1,t.R1=-1,t.RC=0,t.Q3=!1,t.GJ=[1c,1c,1c,1c],t.PE="1y"},k3:1f(){1a e,t=1g;1c!==ZC.1d(e=t.E["l-2k"])&&1c===ZC.1d(t.JO.2k)&&(t.C6=e),1c!==ZC.1d(e=t.E["bg-2k"])&&1c===ZC.1d(t.JO["2k-1M"])&&(t.o["2k-1M"]=e)},FO:1f(e,t){1a i=1g;1m(1w t===ZC.1b[31]||!i.GJ[t]&&i.GJ[1])&&(t=1),e=5w(e,10),!i.IJ||"xy"!==i.C.AJ.3t&&"yx"!==i.C.AJ.3t?i.S[e]:i.S[e]&&i.GJ[t]?(i.GJ[t].K=i.K+"-2o-"+e,i.GJ[t].o={1S:i.W[e]},"2Y"==1w i.W[e]&&(i.GJ[t].hK=!0),i.GJ[t].L=e,"1y"!==i.AF&&"1M"!==i.AF&&"bF"!==i.AF&&"bE"!==i.AF||i.U?i.GJ[t].1q():1c===i.S[e].BX&&1w i.C.E["1B-"+i.L+"-iT-nr"]===ZC.1b[31]||i.GJ[t].1q(),"1y"===i.AF||"1M"===i.AF||"bF"===i.AF||"bE"===i.AF?"xy"===i.C.AJ.3t?(1c!==i.S[e].BX?i.GJ[t].iX=i.S[e].iX=i.B0.B2(i.S[e].BX):i.GJ[t].iX=i.S[e].iX=i.B0.I3(e),i.CB&&"100%"===i.KO?i.GJ[t].iY=i.S[e].iY=i.CI.B2(100*i.S[e].CM/i.A.F3[e]["%6i-"+i.DV]):i.GJ[t].iY=i.S[e].iY=i.CI.B2(i.S[e].CM)):(1c!==i.S[e].BX?i.GJ[t].iY=i.S[e].iY=i.B0.B2(i.S[e].BX):i.GJ[t].iY=i.S[e].iY=i.B0.I3(e),i.CB&&"100%"===i.KO?i.GJ[t].iX=i.S[e].iX=i.CI.B2(100*i.S[e].CM/i.A.F3[e]["%6i-"+i.DV]):i.GJ[t].iX=i.S[e].iX=i.CI.B2(i.S[e].CM)):i.GJ[t].SU(),i.GJ[t].J7=i.S[e].J7,i.GJ[t]):1c},UT:1f(e,t){1a i=1g;i.JW[e]||(i.JW[e]=[]),(!i.IJ||i.IJ&&-1===ZC.AT(i.JW[e],t))&&i.JW[e].1i(t)},TL:1f(){1m 1n ZC.M5(1g)},oI:1f(){1m{}},NV:1f(){1m 1g.ZA("6V","jC","i"),1g.C.A.B9.ny(-1!==1g.jC?1g.jC:1g.L,1g.C.AF)},NJ:1f(){1a e=1g;if(e.BO[4]){1a t,i={};1k(1a n in e.BO[4])-1===(t=n.1K("."))?1c===ZC.1d(e.o[n])&&(i[n]=!0,e.o[n]=e.BO[4][n]):n.2s(0,t)===e.AF&&(1c===ZC.1d(e.o[n.2s(t+1)])||i[n.2s(t+1)])&&(e.o[n.2s(t+1)]=e.BO[4][n])}},I1:1f(e,t){1a i,n,a=1g,l=!1,o="";if("1Z"!==a.IV&&(a.C.JZ[a.L]||a.C.KM)){1a r=!(e.E[ZC.1b[73]]||e.E[ZC.1b[72]]);a.C.CW["p"+a.L]&&a.C.CW["p"+a.L]["n"+e.L]?1o.3G.jL&&r&&a.TI[ZC.1b[73]]?(n=a.TI[ZC.1b[73]],l=!0):(o=ZC.1b[73],(n=1n ZC.DQ(a)).1Q(t),e.E[ZC.1b[73]]?n.OH=e.E[ZC.1b[73]]:n.OH=a.SR?a.SR.o:{}):"1Z"!==a.O0&&("1B"===a.O0&&a.C.JZ[a.L]||"2U"===a.O0&&a.C.KM)&&(1o.3G.jL&&r&&a.TI[ZC.1b[72]]?(n=a.TI[ZC.1b[72]],l=!0):(o=ZC.1b[72],(n=1n ZC.DQ(a)).1Q(t),e.E[ZC.1b[72]]?n.OH=e.E[ZC.1b[72]]:n.OH=a.SX?a.SX.o:{})),l||(n?(n.PR=!0,n.1q()):(n=1n ZC.DQ(a)).1Q(t),1o.3G.jL&&r&&""!==o&&(a.TI[o]=n))}1t(n=1n ZC.DQ(a)).1Q(t);1m 1c!==ZC.1d(i=a.SQ[e.L])&&(0===e.A.E4.1h&&(e.A.E4=[{}]),"2Y"==1w a.SQ[e.L]?n.1C({"1R-1r":ZC.AO.JE(i,20)+" "+i,"1y-1r":i,"1F-1r":ZC.AO.JE(i,20)}):n.1C(a.SQ[e.L]),n.1q()),n.Z=t.Z,n.C5=t.C5,n},BT:1f(e){1a t=1g,i=[];if(1c!==ZC.1d(e))1k(1a n=0,a=t.BK.1h;n<a;n++){1a l=t.C.BL(t.BK[n]);l&&l.AF===e&&i.1i(t.BK[n])}1t i=t.BK;1m i},MG:1f(){1a e=1g;1m{8g:e.ZL,"mr-8P":e.RA,"6h-8P":e.RT,6h:e.DW,"1V-6h":e.HN,"5E":e.f2,"5E-e1":e.TP,a8:e.ZT,"a8-6h":e.SC}},1q:1f(){1f e(e){1a t=["("+l.AF+").1B."+e];1m l.dz&&t.1i("("+l.dz+").1B."+e),t}1a t,i,n,a,l=1g;if(l.UH={},l.b(),l.JW={},1c!==ZC.1d(t=l.o.3w))1k(l.BK=t.2l(/,|;|\\s/),n=0;n<l.BK.1h;n++)l.BK[n]=ZC.U9(ZC.GO(l.BK[n]));if(l.C.o.1U&&l.C.o.1U["5M-1B"]&&(l.I4=!0),1c!==ZC.1d(l.o.iK)&&1c===ZC.1d(l.o["5E"])&&(l.o["5E"]=l.o.iK),1c!==ZC.1d(l.o["3F-1O"])&&1c===ZC.1d(l.o["aW-4B"])&&1c===ZC.1d(l.o["ex-1O"])&&(l.o["aW-4B"]="a7",l.o["ex-1O"]={},ZC.2A(l.o["3F-1O"],l.o["ex-1O"])),l.KO=l.C.KO,l.4y([["bK","IU","b"],["a8","ZT","b"],[ZC.1b[25],"SC","ia"],[ZC.1b[12],"DW","ia"],["1V-6h","HN","i"],["2w","RH","b"],["nv","CB","b"],["7H-1I","KO"],["np","R3","b"],["1D","AP"],["2C-1D","JT"],["1U-1D","nq"],["sd","YA"],["7H","DV","i"],["z-2V","JJ","i"],["7e","CS"],["4B","b6"],["17g","XS","f"],["1V-cZ","MN"],["1V-ng","RP"],["f6-ng","XV","b"],["dM-6Y","XK","i"],["1X-6Y-iK","Y0","i"],["3P","E5"],["2T","FC"],[ZC.1b[14],"RT"],[ZC.1b[13],"RA"],["5E","f2","b"],["8g","ZL"],["5E-e1","TP"],["8u-ac","so","b"],["Ai","RX"],["au","SQ"],["Eu","Q3","b"],["5M","I4","b"],["5M-1U","L7","b"],["2J-4B","kS"],["9T-fO","UK","b"],["16Z","LN","b"],["Cu-2V","R1","i"],["Cu-1Y","RC","i"],["Bj","GA","b"],["Aw","L6","i"],["oZ","J9","f"],["aW-4B","IV"],["5Z-170","RE","b"],["1R-4B","O0"],["172-6g","YF","ia"]]),l.pf=l.R3,!l.E["Av-1q"]){if(ZC.6v(l.SQ),l.I4&&(1c===ZC.1d(l.C.o.1U)||1c===ZC.1d(l.C.o.1U["5M-1U"]))&&ZC.1d(1c===l.o["5M-1U"])&&(l.L7=l.I4),1c!==ZC.1d(t=l.o.8N)){l.GA=!0;1a o;1c!==ZC.1d(i=t.Aw)&&(0===(i+"").1K("jY")&&1c!==ZC.1d(o=ZC.aS[(i+"").2s(10)])&&(i=o),l.L6=ZC.1l(i),0===l.L6&&(l.GA=!1)),1c!==ZC.1d(i=t.oZ)&&(0===(i+"").1K("jY")&&1c!==ZC.1d(o=ZC.aS[(i+"").2s(10)])&&(i=o),l.J9=ZC.1W(i)),1c!==ZC.1d(i=t.Ap)&&(l.L2=ZC.1W(i)),1c!==ZC.1d(i=t.9E)&&(0===(i+"").1K("jY")&&1c!==ZC.1d(o=ZC.aS[(i+"").2s(10)])&&(i=o),l.L4=ZC.1l(i)),1c!==ZC.1d(i=t.173)&&(0===(i+"").1K("jY")&&1c!==ZC.1d(o=ZC.aS[(i+"").2s(10)])&&(i=o),l.TG=ZC.1l(i)),1c!==ZC.1d(i=t.174)&&(l.FR=i)}l.J9<10&&(l.J9*=5L),l.L2<10&&(l.L2*=5L),1w ZC.PA!==ZC.1b[31]&&(l.J9=ZC.BN(ZC.PA.TV,l.J9)),("8u"===l.b6||1w ZC.PA===ZC.1b[31]||1o.4C.aS)&&(l.GA=!1),l.H.dm&&(l.GA=!1),-1!==ZC.AT(["1y","1M","5A","6d","8f","6t","5h","74","5O"],l.AF)&&("8u"===l.b6?l.IJ=!0:"5e"===l.b6||l.GA||-1!==3c.5d(l.o).1K(\'"ac"\')||-1!==3c.5d(l.o).1K(\'"js-cz"\')||0!==l.SQ.1h||-1!==l.H.E.4F.1K(\'"7c"\')||-1!==l.H.E.4F.1K(\'"Ai"\')||"1Z"!==l.IV?l.IJ=!1:l.IJ=!0);1k(1a r in l.o)if("1T-"===r.2s(0,5)){1a C=r.2s(5);l.L8[C]=l.o[r]}1a A=l.H.B9;if(l.I7=1n ZC.CZ(l),l.I7.1C(l.o),A.2t(l.I7.o,e(ZC.1b[71])),l.I7.1C(l.o[ZC.1b[71]]),1c!==ZC.1d(l.o[ZC.1b[71]])||"1y"!==l.AF&&"1M"!==l.AF||(l.I7.AL=!1),l.I4&&(l.RZ=1n ZC.CZ(l),A.2t(l.RZ.o,e("5M-3U")),l.RZ.1C(l.o),1c!==ZC.1d(t=l.o["5M-3U"])&&l.RZ.1C(t),1c===ZC.1d(l.RZ.o.3H)&&(l.RZ.o.3H=!0)),1c!==ZC.1d(t=l.o[ZC.1b[73]])&&(l.SR=1n ZC.CZ(l),A.2t(l.SR.o,e(ZC.1b[73])),l.SR.1C(t)),1c!==ZC.1d(t=l.o[ZC.1b[72]])&&(l.SX=1n ZC.CZ(l),A.2t(l.SX.o,e(ZC.1b[72])),l.SX.1C(t)),l.A2=1n ZC.CZ(l),A.2t(l.A2.o,e("1O")),A.2t(l.A2.o,e("1O["+l.CS+"]")),l.A2.1C(l.o.1O),"3e"===l.A2.o.1I){1a s=["3x","9o","Ah","Af","Ac"];l.A2.o.1I=s[l.L%s.1h]}if(l.A2.1q(),(l.A2.E4.1h>0||l.SQ.1h>0||l.A2.o["1u-3U"])&&(l.YI=!1),l.G6=1n ZC.CZ(l),A.2t(l.G6.o,e("2J-1O")),l.G6.1C(l.o.1O),l.G6.1C(l.o["2J-1O"]),1c!==ZC.1d(t=l.o["ex-1O"])&&(l.PI=1n ZC.CZ(l),A.2t(l.PI.o,e("ex-1O")),l.PI.1C(t)),1c!==ZC.1d(t=l.o["1R-1O"])&&(l.PD=1n ZC.CZ(l),A.2t(l.PD.o,e("1R-1O")),l.PD.1C(t)),l.I4&&(l.UZ=1n ZC.CZ(l),l.UZ.1C(l.o.1O),1c!==ZC.1d(t=l.o["5M-1O"])&&(A.2t(l.UZ.o,e("5M-1O")),l.UZ.1C(t))),"5e"!==l.b6&&(l.SR||l.PI)&&(l.IJ=!1),"8u"===l.b6&&(l.IJ=!0),l.A8=1n ZC.DQ(l),l.o.2C&&l.o.2C.6c&&l.o.2C.6c.1K("2o")>-1?A.2t(l.A8.o,"("+l.AF+").2C[4M]"):A.2t(l.A8.o,l.AF+".2C"),l.A8.1C(l.o.2C),1c!==ZC.1d(t=l.o.4L)&&(l.J5=1n ZC.DS(l),A.2t(l.J5.o,e("4L")),l.J5.1C(t),1c===ZC.1d(l.J5.o[ZC.1b[21]])&&(l.J5.o[ZC.1b[21]]=4)),1c!==ZC.1d(t=l.o[ZC.1b[17]])){if(t 3z 3K)1k(l.U=1n ZC.CZ(l),A.2t(l.U.o,e(ZC.1b[17])),1c!==ZC.1d(i=l.C.o.1B)&&l.U.1C(i[ZC.1b[17]]),l.U.1C(t[0]),t.1h>1&&(l.NX=[]),n=1;n<t.1h;n++)l.NX[n-1]=1n ZC.CZ(l),A.2t(l.NX[n-1].o,e(ZC.1b[17])),1c!==ZC.1d(i=l.C.o.1B)&&l.NX[n-1].1C(i[ZC.1b[17]]),l.NX[n-1].1C(t[n]);1t l.U=1n ZC.CZ(l),A.2t(l.U.o,e(ZC.1b[17])),1c!==ZC.1d(i=l.C.o.1B)&&l.U.1C(i[ZC.1b[17]]),l.U.1C(t);l.U.1q()}l.H.QT&&(l.AL=ZC.kn["g-"+l.C.L+"-p-"+l.L]);1a Z=!1;1k(1w l.C.E["1B"+l.L+".2f"]===ZC.1b[31]&&(Z=!0),Z?l.C.E["1B"+l.L+".2f"]=!0:l.AL=l.C.E["1B"+l.L+".2f"],l.AL||Z&&(l.C.E["1B"+l.L+".2f"]=!1),n=0,a=l.C.BK.1h;n<a;n++)1c!==ZC.1d(l.C.BK[n].o[ZC.1b[5]])?l.C.BK[n].T1=!0:-1!==ZC.AT(l.BK,l.C.BK[n].BB)&&("3m"===l.C.8b()||l.C.A.K3?l.AL&&l.C.E["1B"+l.L+".2f"]&&(l.C.BK[n].T1=!0):l.C.BK[n].T1=!0);1a c=1c;if(l.K=l.A.K+"-1B-"+l.L,l.S=[],l.A.F3||(l.A.F3={}),-1!==l.AF.1K("1M")&&-1===l.AF.1K("3d")&&l.CB){l.A.WM||(l.A.WM={}),l.A.WM["s"+l.DV]||(l.A.WM["s"+l.DV]=[]);1a u=!1;if(1c!==ZC.1d(l.o[ZC.1b[5]]))1k(n=0,a=l.o[ZC.1b[5]].1h;n<a;n++)if("4g"==1w l.o[ZC.1b[5]][n]&&1c!==ZC.1d(l.o[ZC.1b[5]][n])){u=!0;1p}u&&(l.GA=!1,l.IA||0!==l.E4.1h||(l.IJ=!0,-1===1o.3G.p6&&(l.C.UE=1)))}l.B0=l.C.BL(l.BT("k")[0]),l.CI=l.C.BL(l.BT("v")[0]);1a p;if(1c!==ZC.1d(l.o[ZC.1b[5]])&&""!==l.AF){l.W=l.o[ZC.1b[5]];1a h=1c;l.PU=[ZC.3q,-ZC.3q];1a 1b=[],d=[],f=0;1k(n=0,a=l.W.1h;n<a;n++){1a g=!1;if(l.o["Cd-ts"]||(1c!==ZC.1d(l.W[n])&&"4g"==1w l.W[n]&&l.W[n].1h>1?(1c===ZC.1d(l.W[n][1])||"2Y"==1w l.W[n][1]&&"hJ"===l.W[n][1].5D())&&(g=!0):(1c===ZC.1d(l.W[n])||"2Y"==1w l.W[n]&&"hJ"===l.W[n].5D())&&(g=!0),"5O"===l.C.AF&&(g=!1)),g)l.S.1i(1c);1t{!l.IJ||"xy"!==l.C.AJ.3t&&"yx"!==l.C.AJ.3t?c=l.TL():l.GJ[1]||("5h"===l.AF||"6t"===l.AF?l.GJ[1]=c=l.TL():(l.GJ[0]=l.TL(),l.GJ[1]=c=l.TL(),l.GJ[2]=l.TL(),l.GJ[3]=l.TL())),c.K=l.K+"-2o-"+n,"2Y"==1w l.W[n]&&1o.Cb&&(l.W[n]=ZC.1W(l.W[n])),c.o={1S:l.W[n]},"2Y"==1w l.W[n]&&(c.hK=!0),c.L=n,l.o["Cd-ts"]?(c.E.7i=l.L,c.E.7l=c.L,c.K=l.K+"-2o-"+c.L,c.BX=l.W[n][0],c.AE=l.W[n][1]):c.1q(),(a<bz||1o.3G.pa)&&1c!==ZC.1d(c.AE)&&2===(p=c.AE.aq().2l(".")).1h&&(f=ZC.BN(f,p[1].1h)),c.BX&&(1c!==h&&ZC.2i(c.BX-h)>0&&1b.1i(ZC.2i(c.BX-h)),h=c.BX),l.A.WM=l.A.WM||{};1a B=l.A.WM["s"+l.DV];if(B&&(1c!==h?-1===ZC.AT(B,c.BX)&&B.1i(c.BX):-1===ZC.AT(B,n)&&B.1i(n)),!l.IJ||"xy"!==l.C.AJ.3t&&"yx"!==l.C.AJ.3t)l.S.1i(c);1t{1a v={iX:c.iX,iY:c.iY,L:c.L,BX:c.BX,AE:c.AE,CM:c.AE,DL:c.DL,J7:c.J7};"5h"===l.AF&&(v.SJ=c.SJ),l.S.1i(v)}1c!==c.BX&&(l.PU[0]=1A.2h(l.PU[0],c.BX),l.PU[1]=1A.1V(l.PU[1],c.BX)),l.C.E["1B"+l.L+".2f"]&&(1o.3G.kk||"100%"===l.KO)&&l.CB&&(1c===ZC.1d(l.A.F3[n])?(l.A.F3[n]={},l.A.F3[n]["%6i-"+l.DV]=c.AE):1c===ZC.1d(l.A.F3[n]["%6i-"+l.DV])?l.A.F3[n]["%6i-"+l.DV]=c.AE:l.A.F3[n]["%6i-"+l.DV]+=c.AE),1o.3G.kk&&(d.1i(c.AE),l.JL?(l.JL["%1B-1V-2V"]=n,l.JL["%1B-8c"]+=c.AE,a<bz&&(l.JL["%1B-6g"]+=","+c.AE)):l.JL={"%1B-2h-2V":n,"%1B-1V-2V":n,"%1B-8c":c.AE,"%1B-6g":c.AE},l.A.F3||(l.A.F3={}),l.AL&&(1c===ZC.1d(l.A.F3["%aT-"+n+"-"+l.DV+"-8c"])?(l.A.F3["%aT-"+n+"-"+l.DV+"-8c"]=c.AE,l.A.F3["%aT-"+n+"-"+l.DV+"-7H-1h"]=1):(l.A.F3["%aT-"+n+"-"+l.DV+"-8c"]+=c.AE,l.A.F3["%aT-"+n+"-"+l.DV+"-7H-1h"]+=1)))}}(l.W.1h<bz||1o.3G.pa)&&l.JL&&1c!==ZC.1d(l.JL["%1B-8c"])&&2===(p=l.JL["%1B-8c"].aq().2l(".")).1h&&ZC.1l(p[1])>f&&(l.JL["%1B-8c"]=ZC.1W(l.JL["%1B-8c"].4v(ZC.CV(20,f)))),1o.3G.kk?(l.JL&&(l.JL["%1B-dq"]=l.JL["%1B-8c"]/l.W.1h,l.JL["%1B-dq"]=ZC.1W(l.JL["%1B-dq"].4v(ZC.CV(20,f+2)))),d.1h>0&&(l.JL["%1B-2h-1S"]=ZC.dS(d),l.JL["%1B-1V-1S"]=ZC.dT(d))):l.JL={"%1B-2h-2V":0,"%1B-1V-2V":l.W.1h,"%1B-8c":-1,"%1B-6g":"","%1B-dq":-1,"%1B-2h-1S":-1,"%1B-1V-1S":-1},h&&1b.1h>0&&(l.Ci=ZC.dS(1b),l.lB=ZC.dT(1b))}}},az:1f(e,t){1k(1a i=1g,n=i.C.Q,a=i.C.BI.B4,l=[],o=0,r=e.1h;o<r;o++)if(e[o]){"3I"===i.H.AB&&t&&(e[o][0]=e[o][0]/10,e[o][1]=e[o][1]/10);1a C=(e[o][0]-n.iX)/n.I,A=(e[o][1]-n.iY)/n.F,s=a.iX+a.AQ+C*(a.I-2*a.AQ),Z=a.iY+a.AQ+A*(a.F-2*a.AQ);l.1i([s,Z])}1t l.1i(1c);1m l},1v:1f(){1a e=1g,t=e.C.Q.I;1P(e.C.AF){1j"6t":1j"5h":t=hH;1p;1j"6d":1j"7v":t=e.C.Q.F}1c===ZC.1d(e.MN)&&(e.MN=ZC.1l(t/4)),1c===ZC.1d(e.RP)&&(e.RP=ZC.1l(t/4)),e.YI&&(e.H4=1c,e.HB=1c,e.R6=1c,e.Q8=1c)},XF:1f(e){1a t,i,n,a=1g;1k(t=0,i=a.S.1h;t<i;t++)a.S[t]&&(a.S[t].J7=!1);1a l=a.C.Q;if(a.QX=!1,a.FT=!0,a.TW=!1,n=0,a.C.O6||1w a.pf!==ZC.1b[31]&&(a.R3=a.pf),e)a.QX=!0,a.RP<a.S.1h&&(a.FT=!1);1t{if(a.B0.EC&&a.EC){1k(t=0,i=a.S.1h;t<i;t++)a.S[t]&&(a.B0.IH.1h>0||ZC.DU(a.S[t].BX,a.B0.W[a.B0.X],a.B0.W[a.B0.A1]))&&n++;a.RP<n&&(a.FT=!1),n*a.XS>l.I&&(a.TW=!0),a.MN>=n&&(a.QX=!0)}1t a.MN>a.B0.A1-a.B0.X&&(a.QX=!0);a.Y=1,a.B0.EC&&a.EC||(n=a.B0.A1-a.B0.X,a.RP<n&&(a.FT=!1),n*a.XS>l.I&&(a.TW=!0),!a.R3&&n*a.XS>l.I&&(a.Y=ZC.BN(1,ZC.1l(n*a.XS/l.I)))),a.B0.EC&&a.EC&&(a.R3||n*a.XS>l.I&&(a.Y=ZC.BN(1,ZC.1l(n*a.XS/l.I)))),a.C.O6&&(a.R3=!1,a.Y*=a.Y0)}1c!==ZC.1d(a.XK)&&a.Y>a.XK&&(a.Y=a.XK)},OZ:1f(e){1f t(e,i){1k(1a n=e;n<ZC.CV(e+i,l.S.1h);n++)l.S[n]?((o=l.FO(n)).Z=l.K9,o.1v(),o.J7=!0,l.S[n].J7=!0):"74"===l.C.AF&&(n===l.S.1h-1?"1y"!==l.CS&&"1M"!==l.CS&&"5y"!==l.CS||ZC.CN.1v(l.Q0,l,l.D):l.D.1i(1c));e+i<l.S.1h?l.C.LH?2u.5G(1f(){t(e+i,i)},10):t(e+i,i):l.C.LH&&l.L===l.A.A7.1h-1&&l.A.fk()}1a i,n,a,l=1g;1c!==ZC.1d(e)&&e||(e=!1),l.B0&&"2W"===l.B0.CA&&(e=!0),l.XF(e);1a o=1c;if(e||l.LN)l.A.kj=!1,t(0,ZC.cF||ZC.2H?p4:ox);1t{1a r="5A"!==l.AF&&"6d"!==l.AF;if(l.B0.EC&&l.EC){a=l.G5=l.H8=l.Y;1a C=!0,A=0,s=0;1k(i=0,n=l.S.1h;i<n;i+=a)r&&(n-i==1?(l.G5=a,l.H8=1):n-i<l.Y&&(l.G5=l.Y,l.H8=n-i-1,a=n-i-1)),l.S[i]&&(l.B0.IH.1h>0||ZC.DU(l.S[i].BX,l.B0.W[l.B0.X],l.B0.W[l.B0.A1])||r&&C&&l.S[i+a]&&l.S[i+a].BX>=l.B0.W[l.B0.X])&&(r&&C&&l.S[i-a]&&((o=l.FO(i-a)).Z=l.K9,o.1v(),o.J7=!0,C=!1,s++),(o=l.FO(i)).Z=l.K9,o.1v(),o.J7=!0,s++,C=!1,A=i);r&&s>0&&l.S[A+a]&&((o=l.FO(A+a)).Z=l.K9,o.1v(),o.J7=!0)}1t{a=l.G5=l.H8=l.Y;1a Z=0,c=1,u=1c;if(!r){1a p="5A"===l.AF?l.C.Q.I:l.C.Q.F;Z=4/("5A"===l.AF?l.C.Q.F:l.C.Q.I)*(l.CI.BS-l.CI.B8),c=1+ZC.1l((l.B0.A1-l.B0.X)/(2*p)),a=1}1k(i=l.B0.X;i<=l.B0.A1;i+=a)(l.B0.A1-l.B0.X)%l.Y!=0&&r&&(l.B0.A1-i==0?(l.G5=a,l.H8=1):l.B0.A1-i<=l.Y&&(l.G5=l.Y,l.H8=l.B0.A1-i,a=l.B0.A1-i)),l.S[i]?(o=l.FO(i),(r||l.R3||!r&&1c===u||ZC.2i(o.AE-u)>Z||i%c==0)&&(o.Z=l.K9,o.1v(),o.J7=!0,l.S[i].J7=!0),u=o.AE):l.CB&&-1!==ZC.AT(["5A","6d","6M","7v"],l.AF)&&l.QE()}}},CL:1f(e,t){1a i=1g;if(i.UH[e+t])1m i.UH[e+t];1a n=1c;1m n=i.H.2L()?ZC.AK(i.H.K+"-3X-c"+("fl"===e?"-1u":"")):i.H.K3||i.C.AJ["3d"]?ZC.AK(i.C.K+"-4j-"+e+"-c"):ZC.AK(i.C.K+"-1B-"+i.L+"-"+e+"-"+t+"-c"),i.UH[e+t]||(i.UH[e+t]=n),n},UP:1f(e){1a t=1g;1m{id:t.H.K,4u:t.C.K,Bq:t.C.L,4W:t.GX,3S:t.L,ev:e?ZC.A4.C1(e):1c,hI:t.L8}},WX:1f(e,t){ZC.AO.C2("16Y"+t,1g.H,1g.UP(e))},kC:1f(e,t,i){1a n,a=1g;if(n=e.o["js-cz-2B"]){1a l=ZC.AK(t),o=ZC.kh(n.1E("7u:","").1E("()",""),2u);if(l&&o)4I{1a r=o.4s(a,i);1k(1a C in r)l.4l(C,r[C])}4G(A){}}},k0:1f(){1a e=1g,t=e.C,i=t.Q;if(t.o["1z-z"]&&t.E["1B"+e.L+".2f"]){1a n,a,l,o,r;if(n=1n ZC.CF(t,i.iX+i.I-ZC.AM.E1+10,i.iY+i.F-ZC.AM.E0,e.E["z-9T"]),a=1n ZC.DQ(e),a.GG=t.K+"-1z-z-1N "+t.K+"-1z-1N zc-1z-1N",a.K=t.K+"-1z-z-7E"+e.L,a.AP=t.o["1z-z"][ZC.1b[5]][e.L],a.Z=a.C5=e.H.2L()?e.H.mc():ZC.AK(t.K+"-3w-ml-0-c"),r=ZC.P.E6(a.Z,e.H.AB),a.IE=e.H.2L()?ZC.AK(e.H.K+"-3X"):ZC.AK(e.H.K+"-1D"),a.1C(t.o["1z-z"].1N),a.1q(),a.AA+=a.V0?0:ZC.DF.si(t,a),a.iX=n.E9[0],a.iY=n.E9[1],a.o["3e-3s"]&&a.V0&&(a.iY-=a.F/2),a.1v(),1c===ZC.1d(e.E["1z-z-1N-1V-1s"])&&(e.E["1z-z-1N-1V-1s"]=0),e.E["1z-z-1N-1V-1s"]=ZC.BN(e.E["1z-z-1N-1V-1s"],a.I),e.E["z-83"]===e.E["z-4j"]-1&&t.o["1z-z"].1G){n=1n ZC.CF(t,i.iX+i.I-ZC.AM.E1+20+e.E["1z-z-1N-1V-1s"],i.iY+i.F-ZC.AM.E0,ZC.AM.FQ/2),(a=1n ZC.DQ(e)).GG=t.K+"-1z-z-1G "+t.K+"-1z-1G zc-1z-1G",a.K=t.K+"-1z-z-1G",a.Z=a.C5=e.H.2L()?e.H.mc():ZC.AK(t.K+"-3w-ml-0-c"),r=ZC.P.E6(a.Z,e.H.AB),a.IE=e.H.2L()?ZC.AK(e.H.K+"-3X"):ZC.AK(e.H.K+"-1D"),a.1C(t.o["1z-z"].1G),a.1q();1a C,A;C=1n ZC.CF(t,i.iX+i.I-ZC.AM.E1,i.iY+i.F-ZC.AM.E0,0),A=1n ZC.CF(t,i.iX+i.I-ZC.AM.E1,i.iY+i.F-ZC.AM.E0,ZC.AM.FQ);1a s=ZC.TF(1A.aA((A.E9[1]-C.E9[1])/(A.E9[0]-C.E9[0])));a.AA+=a.V0?0:s,a.iX=n.E9[0],a.iY=n.E9[1],a.1v()}if(t.o["1z-z"].3W&&(o=1n ZC.DS(e),o.B6="#e0",o.AY=1,o.AH=6,o.1C(t.o["1z-z"].3W),o.1q(),o.AL&&o.AY>0)){o.K=t.K+"-1z-z-3W-"+e.L;1k(1a Z=[],c=[[i.iX+i.I,i.iY+i.F],[i.iX+i.I+o.AH,i.iY+i.F]],u=0;u<c.1h;u++)n=1n ZC.CF(t,c[u][0]-ZC.AM.E1,c[u][1]-ZC.AM.E0,e.E["z-9T"]),Z.1i([n.E9[0],n.E9[1]]);ZC.CN.1v(r,o,Z)}if(0===e.E["z-83"]&&((o=1n ZC.CZ(e)).B6="#e0",o.AY=1,o.1C(t.o["1z-z"].cf),o.1q(),o.AY>0&&o.AL&&(o.A0=o.AC=o.B6,(l=ZC.DF.DA(o,t,i.iX+i.I-ZC.AM.E1-o.AY,i.iX+i.I-ZC.AM.E1,i.iY+i.F-ZC.AM.E0,i.iY+i.F-ZC.AM.E0,0,ZC.AM.FQ,"x")).K=t.K+"-1z-z-cf",t.CH.2N(l))),e.E["z-83"]>0&&t.o["1z-z"].2g&&((o=1n ZC.CZ(e)).B6="#e0",o.AY=1,o.1C(t.o["1z-z"].2g),o.1q(),o.AY>0&&o.AL&&(o.A0=o.AC=o.B6,(l=ZC.DF.DA(o,t,i.iX-ZC.AM.E1,i.iX+i.I-ZC.AM.E1,i.iY+i.F-ZC.AM.E0,i.iY+i.F-ZC.AM.E0+o.AY,e.E["z-83"]*e.E["z-5q"],e.E["z-83"]*e.E["z-5q"],"y")).K=t.K+"-1z-z-177-"+e.L,t.CH.2N(l),(l=ZC.DF.DA(o,t,i.iX-ZC.AM.E1,i.iX-ZC.AM.E1,i.iY-ZC.AM.E0,i.iY+i.F-ZC.AM.E0,e.E["z-83"]*e.E["z-5q"],e.E["z-83"]*e.E["z-5q"]+o.AY,"y")).K=t.K+"-1z-z-179-"+e.L,t.CH.2N(l))),t.o["1z-z"].2z&&t.o["1z-z"].2z.1h){(o=1n ZC.CZ(e)).A0=o.AC="#17a",o.C6=.25;1a p=e.E["z-83"]%t.o["1z-z"].2z.1h;o.1C(t.o["1z-z"].2z[p]),o.1q(),(l=ZC.DF.DA(o,t,i.iX-ZC.AM.E1,i.iX+i.I-ZC.AM.E1,i.iY+i.F-ZC.AM.E0,i.iY+i.F-ZC.AM.E0,e.E["z-83"]*e.E["z-5q"],e.E["z-83"]*e.E["z-5q"]+e.E["z-5q"],"z")).K=e.K+"-1N-",t.CH.2N(l)}}},gc:1f(){if(1g.S)1k(1a e=0;e<1g.S.1h;e++)1g.S[e]&&1g.S[e].A&&ZC.AO.gc(1g.S[e],["Z","C5","o","JO","HU","A","C","H","N","N3"]);ZC.AO.gc(1g,["W","S","GJ","JW","UY","A8","Z","C5","UH","A2","TM","H4","G6","I7","K9","Q0","B0","CI","S","GJ","JW","JL","o","JO","HU","A","C","H"])}}),ZC.W2=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.Aj=!0,t.AF="xy",t.BK=[ZC.1b[50],ZC.1b[51]]},1v:1f(){1g.b()}}),ZC.QD=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="1y",t.CS="a5",t.Y=1,t.SE="6o",t.UY=[],t.Q6=!1,t.OK=!1},TL:1f(){1m 1n ZC.tR(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.NJ(),e.b(),e.4y([["6Y-46","SE"],["eK-dM","Q6","b"]]),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0])},1v:1f(){1a e,t,i,n,a,l,o,r=1g;r.b(),r.UY=[];1a C=r.OK;if(r.K9=r.CL("bl",0),r.Q0=ZC.P.E6(r.CL("bl",1),r.H.AB),!r.IJ||r.C.AJ["3d"])r.OZ(),r.D=1c;1t{r.XF(),r.C5=r.CL("bl",0);1a A=!0;(1c!==ZC.1d(r.A2.o.2f)&&!ZC.2q(r.A2.o.2f)||1c!==ZC.1d(r.A.o.1I)&&"1Z"===r.A2.o.1I)&&(A=!1);1a s=[],Z=[],c=[],u=!0,p=0,h=1c;n=0;1a 1b=-1,d=-1,f=r.A.A7[0].RX&&r.A.A7[0].RX.1h,g=r.Y,B=r.CS;if(r.Y>1&&"4V"===B&&(B="a5"),r.B0.EC&&r.EC){1k(i=r.Y,e=0,t=r.S.1h;e<t;e+=i)d-e<=r.Y&&(i=ZC.BN(1,d-e)),r.S[e]&&(r.B0.IH.1h>0||ZC.DU(r.S[e].BX,r.B0.W[r.B0.X],r.B0.W[r.B0.A1])||u&&r.S[e+i]&&r.S[e+i].BX>=r.B0.W[r.B0.X])&&(u&&r.S[e-i]&&(-1===1b&&(1b=e-i),d=e-i,u=!1,p++),-1===1b&&(1b=e),d=e,p++,u=!1,n=e);p>0&&r.S[n+i]&&(-1===1b&&(1b=n+i),d=n+i,r.S[n+i].J7=!0)}1t 1b=r.B0.X,d=r.LN?r.S.1h:r.B0.A1;r.Y=g;1a v=-1;i=r.Y;1a b=1c,E=1c,m=0,K=1;n=1b,C?d-1b>r.C.Q.F&&(m=4/r.C.Q.I*(r.CI.BS-r.CI.B8),K=ZC.1l((d-1b)/(4*r.C.Q.F))):d-1b>r.C.Q.I&&(m=4/r.C.Q.F*(r.CI.BS-r.CI.B8),K=ZC.1l((d-1b)/(4*r.C.Q.I))),r.o["dM-kp"]&&(m*=1A.1V(1,(d-1b)/ZC.1l(r.o["dM-kp"])),K*=1A.1V(1,(d-1b)/ZC.1l(r.o["dM-kp"])));1k(r.D=[],e=1b;e<=d;e+=i){1a F=!1;if(((d-1b)%r.Y!=0||r.B0.EC&&r.EC)&&d-e<=r.Y&&(i=ZC.BN(1,d-e),F=!0),r.Q6&&!F&&r.S[e])if(1c===ZC.1d(b))b=r.S[e].CM,n=e,E=0;1t{if(1A.3i(r.S[e].CM-b)<m&&e-n<K&&(!r.EC||r.S[e].BX-E<4*r.B0.SB))dO;b=r.S[e].CM,E=r.S[e].BX,n=e}if(0,h=r.FO(e)){1P(r.S[e].J7=!0,(r.FT||r.LN)&&h.1v(!0),-1===v&&(v=h.iX),B){2n:s.1i([h.iX,h.iY]);1p;1j"4V":C?(Z.1i(h.iX),c.1i(h.iY),1===Z.1h&&(Z.1i(h.iX),c.1i(h.iY))):(Z.1i(h.iY),c.1i(h.iX),1===Z.1h&&(Z.1i(h.iY),c.1i(h.iX)));1p;1j"es":1P(r.SE){2n:(l=r.FO(e-i,0))&&(l.2E(),a=ZC.AN.JK(r.S[e-i].iX,r.S[e-i].iY,h.iX,h.iY),s.1i(C?[h.iX,a[1]]:[a[0],h.iY])),s.1i([h.iX,h.iY]),(o=r.FO(e+i,0))&&(o.2E(),a=ZC.AN.JK(h.iX,h.iY,r.S[e+i].iX,r.S[e+i].iY),s.1i(C?[h.iX,a[1]]:[a[0],h.iY]));1p;1j"fr":(l=r.FO(e-i,0))&&(l.2E(),s.1i([r.S[e-i].iX,r.S[e-i].iY],[r.S[e-i].iX,h.iY])),s.1i([h.iX,h.iY]);1p;1j"9e":s.1i([h.iX,h.iY]),(o=r.FO(e+i,0))&&(o.2E(),s.1i([r.S[e+i].iX,h.iY],[r.S[e+i].iX,r.S[e+i].iY]))}1p;1j"Bh":(l=r.FO(e-i,0))?(l.2E(),a=ZC.AN.JK(r.S[e-i].iX,r.S[e-i].iY,h.iX,h.iY),s.1i(C?[h.iX,a[1]]:[a[0],h.iY])):s.1i(C?[h.iX,h.iY-r.B0.A9/2]:[h.iX-r.B0.A9/2,h.iY]),s.1i([h.iX,h.iY]),(o=r.FO(e+i,0))?(o.2E(),a=ZC.AN.JK(h.iX,h.iY,r.S[e+i].iX,r.S[e+i].iY),s.1i(C?[h.iX,a[1]]:[a[0],h.iY])):s.1i(C?[h.iX,h.iY+r.B0.A9/2]:[h.iX+r.B0.A9/2,h.iY]),s.1i(1c)}f&&h.N0(ZC.P.E6(r.CL("fl",0),r.H.AB)),(r.QX&&A||r.FT)&&h.P6(),h.J7=!0}1t 1c!==ZC.1d(r.o["k9-k8"])&&ZC.2q(r.o["k9-k8"])||(s.1i(1c),Z.1i(1c),c.1i(1c))}if("4V"===B){Z.1i(Z[Z.1h-1]),c.1i(c[c.1h-1]),s=[];1k(1a D=1;D<Z.1h-1;D++){1a I=[Z[D-1],Z[D],Z[D+1],Z[D+2]],X=ZC.2i(c[D+1]-c[D]),x=ZC.AN.XZ(r.Q3,I,X);1k(e=0;e<x.1h;e++)1c!==ZC.1d(x[e][0])&&1c!==ZC.1d(x[e][1])?C?s.1i([x[e][1],c[D]+(r.B0.AR?1:-1)*x[e][0]*X]):s.1i([c[D]+(r.B0.AR?-1:1)*x[e][0]*X,x[e][1]]):s.1i(1c)}}r.CX=!1;1a y=r.H.O1;if(r.H.O1=!1,r.E["8u-dZ-2M"]=!0,ZC.CN.2E(r.Q0,r),ZC.CN.1v(r.Q0,r,s),r.H.O1=y,r.C.BI&&r.C.BI.HS&&r.RH){1a L=r.az(s,!0),Y=ZC.P.E6(r.C.BI.Z,r.H.AB),w=1n ZC.CZ(r);w.1Q(r),w.K=r.K+"-2w",w.DJ=r.K+"-2w",w.AY=1;1a M=r.o["2w-3U"];M&&(w.1C(M),w.1q()),ZC.CN.1v(Y,w,L,1c,3)}}}}),ZC.QC=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="1M",t.Y=1,t.CS="a5",t.SK=3,t.HM=t.C.AJ["3d"]?1:.5,t.SE="6o",t.op=!0,t.UY=[],t.Q6=!1,t.X8=!1,t.OK=!1},TL:1f(){1m 1n ZC.tA(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.C.AJ["3d"]||"2R"===e.o["1R-1r-1H"]?e.A0=e.AC=e.BO[1]:(e.A0=e.BO[0],e.AC=e.BO[1]),e.NJ(),e.b(),e.k3(),e.4y([["2k-1M","HM","f",0,1],["6Y-46","SE"],["6D-1M","X8","b"],["kd-on-1u","op","b"],["eK-dM","Q6","b"]]),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0])},1v:1f(){1a e,t,i,n,a,l,o,r,C,A,s,Z=1g;Z.b(),Z.UY=[];1a c=Z.OK;if(-1===ZC.AT(["a5","4V","es"],Z.CS)&&(Z.CS="a5"),Z.K9=Z.CL("bl",0),Z.jB=ZC.P.E6(Z.CL("bl",1),Z.H.AB),Z.Q0=ZC.P.E6(Z.CL("bl",Z.op?2:1),Z.H.AB),A=Z.C.Q,!Z.IJ||Z.C.AJ["3d"]){1a u=ZC.3q,p=-ZC.3q;1k(e=0,t=Z.S.1h;e<t;e++)Z.S[e]&&(u=ZC.CV(u,Z.S[e].CM),p=ZC.BN(p,Z.S[e].CM));1a h=Z.CI.B2(u),1b=Z.CI.B2(p),d=Z.CI.B2(Z.CI.GZ);if(ZC.DU(d,h,1b)&&(Z.CI.AR?d<h&&(h=d):d>1b&&(1b=d)),Z.E["2h-y"]=1A.2h(h,1b),Z.E["1V-y"]=1A.1V(h,1b),Z.CB&&Z.A.EZ){1a f=ZC.3q,g=-ZC.3q;1k(e=0,t=Z.A.EZ.1h;e<t;e++)if(Z.A.EZ[e])1k(1a B=0,v=Z.A.EZ[e].1h;B<v;B++)f=ZC.CV(f,Z.A.EZ[e][B][1]),g=ZC.BN(g,Z.A.EZ[e][B][1]);Z.CI.AR?Z.E["2h-y"]=f:Z.E["1V-y"]=g}Z.E["1V-y"]-Z.E["2h-y"]<100&&(Z.E["1V-y"]+=50,Z.E["2h-y"]-=50),Z.OZ(),Z.D=1c,Z.D4=1c,Z.AG=1c}1t{Z.XF(),Z.C5=Z.CL("bl",0);1a b=!0;(1c!==ZC.1d(Z.A2.o.2f)&&!ZC.2q(Z.A2.o.2f)||1c!==ZC.1d(Z.A.o.1I)&&"1Z"===Z.A2.o.1I)&&(b=!1);1a E=Z.CB&&0===Z.C.UE,m=[],K=[],F=[],D=[],I=[],X=Z.CI.GZ;Z.o["3N-1S"]&&(X=ZC.1W(Z.o["3N-1S"]));1a x=Z.CI.B2(X);c?"xy"===Z.C.AJ.3t?(x=Z.B0.B2(X),x=ZC.5m(x,Z.B0.iX,Z.B0.iX+Z.B0.I)):x=ZC.5m(x,Z.CI.iX,Z.CI.iX+Z.CI.I):"yx"===Z.C.AJ.3t?(x=Z.B0.B2(X),x=ZC.5m(x,Z.B0.iY,Z.B0.iY+Z.B0.F)):x=ZC.5m(x,Z.CI.iY,Z.CI.iY+Z.CI.F);1a y=!0,L=0,Y=1c;i=0;1a w=-1,M=-1,H=Z.A.A7[0].RX&&Z.A.A7[0].RX.1h,N=Z.Y,S=Z.CS;if(Z.Y>1&&"4V"===S&&(S="a5"),Z.B0.EC&&Z.EC){1k(n=Z.Y,e=0,t=Z.S.1h;e<t;e+=n)M-e<=Z.Y&&(n=ZC.BN(1,M-e)),Z.S[e]&&(Z.B0.IH.1h>0||ZC.DU(Z.S[e].BX,Z.B0.W[Z.B0.X],Z.B0.W[Z.B0.A1])||y&&Z.S[e+n]&&Z.S[e+n].BX>=Z.B0.W[Z.B0.X])&&(y&&Z.S[e-n]&&(-1===w&&(w=e-n),M=e-n,y=!1,L++),-1===w&&(w=e),M=e,L++,y=!1,i=e);L>0&&Z.S[i+n]&&(-1===w&&(w=i+n),M=i+n,Z.S[i+n].J7=!0)}1t w=Z.B0.X,M=Z.LN?Z.S.1h:Z.B0.A1;Z.Y=N,E||Z.A.D4&&(K=Z.A.D4.9m());1a O=1c,P=1c,k=0,G=1;i=w,c?M-w>Z.C.Q.F&&(k=4/Z.C.Q.I*(Z.CI.BS-Z.CI.B8),G=ZC.1l((M-w)/(4*Z.C.Q.F))):M-w>Z.C.Q.I&&(k=4/Z.C.Q.F*(Z.CI.BS-Z.CI.B8),G=ZC.1l((M-w)/(4*Z.C.Q.I)));1a z=!1,T=!1,J=-1;n=Z.Y,z=!0,!Z.A.RS&&E&&(Z.A.RS={},Z.A.VE={});1a Q=1c,W=1c;if(Z.A.RS&&!Z.A.RS["s"+Z.DV]&&E){Z.A.RS["s"+Z.DV]={},Z.A.VE["s"+Z.DV]={};1a R=Z.A.WM["s"+Z.DV];1k(e=0;e<=R.1h;e++)1c!==ZC.1d(R[e])&&(a=Z.B0.EC?ZC.1l(Z.B0.B2(R[e])):ZC.1l(Z.B0.I3(R[e])),Z.A.RS["s"+Z.DV][a]=x,Z.A.VE["s"+Z.DV][a]=x)}1k(E&&(Q=Z.A.RS["s"+Z.DV],W=Z.A.VE["s"+Z.DV]),e=w;e<=M;e+=n){1a V=!1;if(((M-w)%Z.Y!=0||Z.B0.EC&&Z.EC)&&M-e<=Z.Y&&(n=ZC.BN(1,M-e),V=!0),Z.Q6&&!V&&Z.S[e])if(1c===ZC.1d(O))O=Z.S[e].CM,i=e,P=0;1t{if(1A.3i(Z.S[e].CM-O)<k&&e-i<G&&(!Z.EC||Z.S[e].BX-P<4*Z.B0.SB))dO;O=Z.S[e].CM,P=Z.S[e].BX,i=e}if(Y=Z.FO(e)){1P(Z.S[e].J7=!0,(Z.FT||Z.LN)&&Y.1v(!0),(T||("a5"===S||"es"===S)&&e===w&&0===K.1h)&&(E||(K.1i(c?[x,Y.iY]:[Y.iX,x]),T&&F.1i(c?[x,Y.iY]:[Y.iX,x]))),T=!1,-1===J&&(J=Y.iX),S){2n:E||z&&(c?Y.iY>Z.B0.iY&&(F.1i([x,Z.B0.iY]),F.1i([x,Y.iY]),K.1i([x,Y.iY])):Y.iX>Z.B0.iX&&(F.1i([Z.B0.iX,x]),F.1i([Y.iX,x]),K.1i([Y.iX,x])),z=!1),m.1i([Y.iX,Y.iY]),E?c?W[ZC.1l(Y.iY)]=Y.iX:W[ZC.1l(Y.iX)]=Y.iY:(F.1i([Y.iX,Y.iY]),K.1i([Y.iX,Y.iY]));1p;1j"4V":c?(D.1i(Y.iX),I.1i(Y.iY),1===D.1h&&(D.1i(Y.iX),I.1i(Y.iY))):(D.1i(Y.iY),I.1i(Y.iX),1===D.1h&&(D.1i(Y.iY),I.1i(Y.iX)));1p;1j"es":1a U=Z.B0.AR?-1:1;1P(Z.SE){2n:(o=Z.FO(e-n,0))&&(o.2E(),l=ZC.AN.JK(Z.S[e-n].iX,Z.S[e-n].iY,Y.iX,Y.iY),m.1i(c?[Y.iX,l[1]]:[l[0],Y.iY]),E?c?W[ZC.1l(l[1])-U]=Y.iX:W[ZC.1l(l[0])+U]=Y.iY:(F.1i(c?[Y.iX,l[1]]:[l[0],Y.iY]),K.1i(c?[Y.iX,l[1]]:[l[0],Y.iY]))),m.1i([Y.iX,Y.iY]),E?c?W[ZC.1l(Y.iY)]=Y.iX:W[ZC.1l(Y.iX)]=Y.iY:(F.1i([Y.iX,Y.iY]),K.1i([Y.iX,Y.iY])),(r=Z.FO(e+n,0))&&(r.2E(),l=ZC.AN.JK(Y.iX,Y.iY,Z.S[e+n].iX,Z.S[e+n].iY),m.1i(c?[Y.iX,l[1]]:[l[0],Y.iY]),E?c?W[ZC.1l(l[1])+U]=Y.iX:W[ZC.1l(l[0])-U]=Y.iY:(F.1i(c?[Y.iX,l[1]]:[l[0],Y.iY]),K.1i(c?[Y.iX,l[1]]:[l[0],Y.iY])));1p;1j"fr":(o=Z.FO(e-n,0))&&(o.2E(),m.1i([Z.S[e-n].iX,Z.S[e-n].iY],[Z.S[e-n].iX,Y.iY]),E?c?(W[ZC.1l(Y.iY)+U]=Z.S[e-n].iX,W[ZC.1l(Y.iY)]=Z.S[e-n].iX):(W[ZC.1l(Z.S[e-n].iX)]=Z.S[e-n].iY,W[ZC.1l(Z.S[e-n].iX)+U]=Y.iY):(F.1i([Z.S[e-n].iX,Z.S[e-n].iY],[Z.S[e-n].iX,Y.iY]),K.1i([Z.S[e-n].iX,Z.S[e-n].iY],[Z.S[e-n].iX,Y.iY]))),m.1i([Y.iX,Y.iY]),E?c?W[ZC.1l(Y.iY)]=Y.iX:W[ZC.1l(Y.iX)]=Y.iY:(F.1i([Y.iX,Y.iY]),K.1i([Y.iX,Y.iY]));1p;1j"9e":m.1i([Y.iX,Y.iY]),E?c?W[ZC.1l(Y.iY)]=Y.iX:W[ZC.1l(Y.iX)]=Y.iY:(F.1i([Y.iX,Y.iY]),K.1i([Y.iX,Y.iY])),(r=Z.FO(e+n,0))&&(r.2E(),m.1i([Z.S[e+n].iX,Y.iY],[Z.S[e+n].iX,Z.S[e+n].iY]),E?c?(W[ZC.1l(Y.iY)-U]=Z.S[e+n].iX,W[ZC.1l(Z.S[e+n].iY)]=Z.S[e+n].iX):(W[ZC.1l(Z.S[e+n].iX)-U]=Y.iY,W[ZC.1l(Z.S[e+n].iX)]=Z.S[e+n].iY):(F.1i([Z.S[e+n].iX,Y.iY],[Z.S[e+n].iX,Z.S[e+n].iY]),K.1i([Z.S[e+n].iX,Y.iY],[Z.S[e+n].iX,Z.S[e+n].iY])))}}H&&Y.N0(ZC.P.E6(Z.CL("fl",0),Z.H.AB)),(Z.QX&&b||Z.FT)&&Y.P6(),Y.J7=!0}1t 1c!==ZC.1d(Z.o["k9-k8"])&&ZC.2q(Z.o["k9-k8"])||(m.1i(1c),D.1i(1c),I.1i(1c),E||(K.1h-1>=0&&K.1i(c?[x,K[K.1h-1][1]]:[K[K.1h-1][0],x]),F.1h-1>=0&&F.1i(c?[x,K[K.1h-1][1]]:[K[K.1h-1][0],x]),T=!0))}if("a5"!==S&&"es"!==S||E||K.1h-1>=0&&(c?K.1i([x,K[K.1h-1][1]]):K.1i([K[K.1h-1][0],x])),"4V"===S){D.1i(D[D.1h-1]),I.1i(I[I.1h-1]),m=[],E||K.1i(c?[x,I[0]]:[I[0],x]);1k(1a j=1;j<D.1h-1;j++){1a q=[D[j-1],D[j],D[j+1],D[j+2]],$=ZC.2i(I[j+1]-I[j]),ee=ZC.AN.XZ(Z.Q3,q,$);1k(e=0;e<ee.1h;e++)1c!==ZC.1d(ee[e][0])&&1c!==ZC.1d(ee[e][1])?(C=c?[ee[e][1],I[j]+(Z.B0.AR?1:-1)*ee[e][0]*$]:[I[j]+(Z.B0.AR?-1:1)*ee[e][0]*$,ee[e][1]],m.1i(C),E?c?W[ZC.1l(C[1])]=C[0]:W[ZC.1l(C[0])]=C[1]:(K.1i(C),F.1i(C))):m.1i(1c)}E||K.1i(c?[x,K[K.1h-1][1]]:[K[K.1h-1][0],x])}if(!E&&F.1h>0){1a te=F[F.1h-1];c||te[0]<Z.B0.iX+Z.B0.I&&(F.1i(c?[x,te[1]]:[te[0],x]),F.1i(c?[x,Z.B0.iY]:[Z.B0.iX+Z.B0.I,x]))}if(E){1a ie=[],ne=[],ae=[],le=[];1k(s in W)ae.1i([s,W[s]]);ae.3V(1f(e,t){1m e[0]-t[0]});1k(s in Q)le.1i([s,Q[s]]);1k(le.3V(1f(e,t){1m e[0]-t[0]}),e=0;e<ae.1h;e++)c?ie.1i([ae[e][1],ae[e][0]]):ie.1i([ae[e][0],ae[e][1]]);1k(e=0;e<le.1h;e++)c?ne.1i([le[e][1],le[e][0]]):ne.1i([le[e][0],le[e][1]]);(K=ie.4w(ne.9m()))[0]&&K.1i(K[0]),Q=Z.A.RS["s"+Z.DV]={};1k(s in W)Q[s]=W[s]}1a oe=1n ZC.DS(Z);if(oe.1Q(Z),oe.CX=!0,oe.L1=!0,oe.AY=0,oe.AQ=0,oe.EW=0,oe.G4=0,oe.N1=Z.OK?180:90,oe.1q(),oe.C6=Z.HM,oe.Z=Z.CL("bl",Z.C.CB?0:1),oe.D=K,oe.eN(),oe.K=Z.K+"-1M",oe.1v(),Z.CX=!1,ZC.CN.2E(Z.Q0,Z),ZC.CN.1v(Z.Q0,Z,m),Z.C.BI&&Z.C.BI.HS&&Z.RH){1a re,Ce=Z.C.BI,Ae=Z.az(K),se=1n ZC.DS(Z.A);se.1Q(Z),se.CX=!0,se.L1=!0,se.AY=0,se.AQ=0,se.EW=0,se.G4=0,se.C6=Z.HM,se.CY=[A.iX,A.iY,A.iX+A.I,A.iY+A.F],se.K=Z.K+"-1M-2w",se.DJ=Z.K+"-2w",se.Z=Ce.Z;1a Ze=Z.o["2w-3U"];Ze&&(1c!==ZC.1d(Ze["2k-1M"])?(re=Ze.2k,Ze.2k=Z.o["2w-3U"]["2k-1M"]):Ze.2k=se.C6,se.1C(Ze),se.1q(),1c!==ZC.1d(re)?Ze.2k=re:4o Ze.2k),se.D=Ae,se.1v();1a ce=Z.az(m),ue=ZC.P.E6(Ce.Z,Z.H.AB),pe=1n ZC.CZ(Z);pe.1Q(Z),pe.CX=!0,pe.L1=!0,pe.K=Z.K+"-1y-2w",pe.DJ=Z.K+"-2w",pe.AY=1,Ze&&(pe.1C(Ze),pe.1q()),ZC.CN.1v(ue,pe,ce,1c,3)}Z.CB&&(Z.A.D4=F)}}}),ZC.i6=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="2Q",t.u4="2Q",t.F0=.1,t.D1=0,t.ow=!1,t.YK=-1,t.CC=.1,t.CO=.1,t.EX=0,t.TO=!1,t.LU=[],t.PE="bg",t.n8=!0,t.Q6=!1},1q:1f(){1a e=1g;if(e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.BU=e.BO[1],e.A0=e.BO[1],e.AC=e.BO[2],e.NJ(),e.b(),"16X"===e.CS&&(e.F0=e.CC=e.CO=0),e.4y([["5Z-k7","n8","b"],["4k-d9","TO","b"],["1Y-6g","LU"],["2Q-8O","F0","fp"],["2Q-1s","D1","fp"],["7U-1s","ow","b"],["2Q-1V-1s","YK","fp"],["k7-8O-1J","CC","fp"],["k7-8O-2x","CO","fp"],["k7-ix","EX","fp"],["eK-dM","Q6","b"]]),e.n8||(e.EX=1),0===e.F0&&0===e.CC&&0===e.CO&&(e.F9=!1),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0]),1c!==ZC.1d(e.o.8V)){1a t=e.o.8V.2l("/");if(2===t.1h){1a i=ZC.1l(t[0]),n=ZC.1l(t[1]),a=e.CC;e.CC>=1&&(a=e.CC/e.B0.A9);1a l=e.CO;e.CO>=1&&(l=e.CO/e.B0.A9);1a o=1-a-l,r=ZC.4t(o/(3*n+1));e.CC=a+r+3*(i-1)*r,e.CO=1-e.CC-2*r}}},QE:1f(){1a e,t=1g;if(t.RB)1m t.RB;if(t.o["8u-16i"]&&t.A.A7[0].RB)1m t.A.A7[0].RB;t.ow&&(t.4y([["2Q-1s","D1","fp"]]),t.D1=1A.43((t.B0.D9?t.B0.F:t.B0.I)*(t.D1/(t.B0.BS-t.B0.B8))));1a i,n=t.B0.A9*t.Y,a=0;1k(t.A.JY[t.AF]=t.A.JY[t.AF]||[],e=0;e<t.A.JY[t.AF].1h;e++){1a l=t.A.JY[t.AF][e][0];t.A.A7[l].BK[0]===t.BK[0]&&a++}if(t.LN)1k(a=0,e=0;e<t.A.A7.1h;e++)"2Q"===t.A.A7[e].u4&&(a=ZC.BN(a,t.A.A7[e].S.1h));if(1c===ZC.1d(t.B0.ER)&&(t.B0.ER=0,t.B0.WN={}),t.CB&&1c!==ZC.1d(t.B0.WN["7H-"+t.DV]))i=t.B0.WN["7H-"+t.DV];1t{1k(i=t.B0.ER,e=0;e<t.L;e++)if((t.A.A7[e].AL||"5c"===t.C.8b())&&t.BK[0]===t.A.A7[e].BK[0]&&t.A.A7[e].AF===t.AF&&(!t.CB||t.A.A7[e].DV!==t.DV)&&!t.A.A7[e].IU){i++;1p}t.B0.ER=i,t.B0.WN["7H-"+t.DV]=i}1k(1a o=!0,r=0,C=[],A=0;A<t.A.A7.1h;A++)t.A.A7[A].D1<=1?o=!1:1c!==ZC.1d(t.A.A7[A].D1)&&(t.A.A7[A].CB&&-1!==ZC.AT(C,t.A.A7[A].DV)||(C.1i(t.A.A7[A].DV),r+=t.A.A7[A].D1));1a s=t.CC;s<=1&&(s*=n);1a Z=t.CO;Z<=1&&(Z*=n),s=ZC.1l(s),Z=ZC.1l(Z);1a c,u,p,h,1b,d=t.EX;1m o?(c=r,0===t.EX||a<=1?((u=t.F0)<=1&&(u*=c/a),Z=(h=n-c-(u=ZC.BN(0,u))*(a-1))-(s=h*(1b=0===Z?1:s/Z)/(1+1b)),s<1&&(s=Z=0,u=n-c,a>1&&(u/=a-1),u<0&&(c=n-s-Z-(u=0)*(a-1))),p=(c=ZC.BN(c,1*a))/a):a>1&&(u=0,p=c/a,d<=1&&(d*=p),Z=(h=n-(c=a*(p-(d=ZC.CV(d,p)))+d)-u*(a-1))-(s=h*(1b=0===Z?1:s/Z)/(1+1b)),s<1&&(c-=1-s))):(c=n-s-Z,0===t.EX||a<=1?((u=t.F0)<=1&&(u*=c/a),Z=(h=n-c-(u=ZC.BN(0,u))*(a-1))-(s=h*(1b=0===Z?1:s/Z)/(1+1b)),s<1&&(s=Z=0,u=n-c,a>1&&(u/=a-1),u<0&&(c=n-s-Z-(u=0)*(a-1))),p=(c=ZC.BN(c,1*a))/a):a>1&&(u=0,p=c/a,d>1&&(d=p/d),d*=p=c/(a-a*d+d),Z=(h=n-c-u*(a-1))-(s=h*(1b=0===Z?1:s/Z)/(1+1b)),s<1&&(c-=1-s))),-1!==t.YK&&p>t.YK&&!t.E.bw&&(t.D1=t.YK,t.E.bw=!0,t.QE(),t.E.bw=1c),t.RB={A9:n,ER:i,CC:s,CO:Z,F0:u,D1:p,EX:d},{A9:n,ER:i,CC:s,CO:Z,F0:u,D1:p,EX:d}},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0);1a t=e.F9;e.kQ=!1,e.S3=1c;1a i=1;e.B0.EC&&(i=e.S.1h/(e.B0.EF-e.B0.E7)),0!==e.E4.1h||e.IA||e.C.KM||"2B"!==e.H.AB||!(e.B0.A1-e.B0.X>oy||e.B0.EC&&i*(e.B0.A1-e.B0.X)>oy)||(e.kQ=!0,1c===ZC.1d(e.o["5t-FI"])&&(e.F9=!0)),e.F9||(e.kQ=!1),e.OZ(),e.F9=t,e.16h=1c,e.W0=1c}}),ZC.QS=ZC.i6.C7({$i:1f(e){1g.b(e),1g.AF="5A"},TL:1f(){1m 1n ZC.Z6(1g)}}),ZC.QB=ZC.i6.C7({$i:1f(e){1g.b(e),1g.AF="6d"},TL:1f(){1m 1n ZC.Z9(1g)}}),ZC.P8=ZC.W2.C7({$i:1f(e,t){1g.b(e),1g.AF=t||"6t",1g.PE="jZ",1g.k4=!1,1g.HM=.5},TL:1f(){1m 1n ZC.Bz(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.A0=e.BO[1],e.AC=e.BO[1],e.B6=e.BO[2],e.BU=e.BO[2],e.NJ(),e.b(),e.4y([["2k-1M","HM","f",0,1]]),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0])},1v:1f(){1a e,t,i,n=1g;if(n.b(),n.K9=n.CL("bl",0),n.oC=ZC.P.E6(n.CL("bl",0),n.H.AB),!n.IJ||n.C.AJ["3d"]||"8u"!==n.b6||0!==n.RP)n.OZ(!0);1t{1a a=1c,l=n.B0,o=n.CI;n.XF(!0);1a r=1n ZC.DS(n.A);1k(r.Z=n.CL("bl",1),r.C5=n.CL("bl",0),r.B6=n.BO[3],r.BU=n.BO[3],r.A0=n.BO[2],"5h"===n.AF||"6z"===n.AF?r.AC=n.BO[1]:r.AC=n.BO[2],r.1C(n.A2.o),r.1q(),t=0;t<=n.S.1h;t++)if(a=n.FO(t)){1a C=!1;l.D9?ZC.DU(a.iX,o.iX+(o.AR?o.BV:o.A6)-1,o.iX+o.I-(o.AR?o.A6:o.BV)+1)&&ZC.DU(a.iY,l.iY+(l.AR?l.BV:l.A6)-1,l.iY+l.F-(l.AR?l.A6:l.BV)+1)&&(C=!0):ZC.DU(a.iX,l.iX+(l.AR?l.BV:l.A6)-1,l.iX+l.I-(l.AR?l.A6:l.BV)+1)&&ZC.DU(a.iY,o.iY+(o.AR?o.A6:o.BV)-1,o.iY+o.F-(o.AR?o.BV:o.A6)+1)&&(C=!0),C&&(a.J7=!0,n.S[t].J7=!0,r.K=a.K+"-1O",r.iX=a.iX,r.iY=a.iY,"3x"!==r.DP&&r.1q(),"1Z"!==n.IV&&(n.C.JZ[n.L]||n.C.KM)&&(r.o={},r.OH={},n.C.CW["p"+n.L]&&n.C.CW["p"+n.L]["n"+t]?r.OH=n.PI?n.PI.o:{}:"1Z"!==n.O0&&("1B"===n.O0&&n.C.JZ[t]||"2U"===n.O0&&n.C.KM)&&(r.OH=n.PD?n.PD.o:{}),r.B6=n.BO[3],r.BU=n.BO[3],r.A0=n.BO[2],"5h"===n.AF||"6z"===n.AF?r.AC=n.BO[1]:r.AC=n.BO[2],r.1C(n.A2.o),r.1q()),r.1v())}}if(n.k4){1k(e=[],t=0,i=n.S.1h;t<i;t++)e.1i([n.S[t].iX,n.S[t].iY]);e.1h&&e.1i(e[0]);1a A=1n ZC.DS(n);A.1Q(n),A.C6=n.HM,A.CX=!0,A.L1=!0,A.AY=0,A.AQ=0,A.EW=0,A.G4=0,A.Z=n.K9,A.D=e,A.eN(),A.K=n.K+"-1M",A.1v(),n.CX=!1,ZC.CN.2E(n.oC,n),ZC.CN.1v(n.oC,n,e)}}}),ZC.RV=ZC.W2.C7({$i:1f(e,t){1g.b(e),1g.AF=t||"5h",1g.VP=1c,1g.VM=1c,1g.k1=1,1g.JI=1,1g.oD="1M",1g.PE="jZ"},TL:1f(){1m 1n ZC.Bl(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.A0=e.BO[2],e.AC=e.BO[1],e.B6=e.BO[2],e.BU=e.BO[2],e.NJ(),e.b(),e.4y([["2h-2b","VP","i"],["1V-2b","VM","i"],["15m","oD"],["Ga-5Z","k1","i"],["2b-7b","JI","f"]]),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0]),1c===ZC.1d(e.VP)&&(e.VP=15),1c===ZC.1d(e.VM)&&(e.VM=.75*1A.2h(e.B0.A6,e.B0.BV,e.CI.A6,e.CI.BV),e.VM=ZC.BN(25,ZC.CV(50,e.VM)))},kF:1f(e){1a t,i=1g,n=1c;1P(e=ZC.BN(e,i.RG),t=i.WA===i.RG?e-i.RG:(e-i.RG)/(i.WA-i.RG),i.oD){1j"9B":n=i.VP+i.JI*(i.VM-i.VP)*t;1p;1j"1M":1j"5B":n=i.VP+i.JI*(i.VM-i.VP)*1A.5B(t)}1m ZC.BN(i.VP,n)},1v:1f(){1a e=1g;if(e.b(),e.K9=e.CL("bl",0),1c!==ZC.1d(e.VM)){e.WA=-ZC.3q,e.RG=ZC.3q;1k(1a t=e.A.A7,i=0,n=t.1h;i<n;i++)if(t[i].k1===e.k1)1k(1a a=0,l=t[i].S.1h;a<l;a++)e.WA=ZC.BN(e.WA,ZC.2i(t[i].S[a].SJ)),e.RG=ZC.CV(e.RG,ZC.2i(t[i].S[a].SJ))}e.OZ(!0)}}),ZC.W4=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="3L",t.BK=["1z",ZC.1b[52],"1z-r"],t.PN=0,t.DM=0,t.TO=!1,t.mW=!0,t.C0=1c,t.PE="bg"},TL:1f(){1m 1n ZC.Bk(1g)},1q:1f(){1a e,t,i=1g;1c===ZC.1d(i.o[ZC.1b[17]])&&(i.o[ZC.1b[17]]={}),"9k"!==i.A.A.o.1I&&"oF"!==i.A.A.o.1I||(i.PN=.35),i.BO=i.NV(),i.BZ=i.BO[0],i.A0=i.BO[1],i.AC=i.BO[2],i.BU=i.BO[0],i.B6=i.BO[0],i.NJ(),i.b(),i.C0=1n ZC.CZ(i),i.C.A.B9.2t(i.C0.o,["2U.1B.1S-3B.97",i.AF+".1B.1S-3B.97"]),1c!==ZC.1d(e=i.C.o.1B)&&1c!==ZC.1d(e[ZC.1b[17]])&&1c!==ZC.1d(t=e[ZC.1b[17]].97)&&i.C0.1C(t),i.C0.1C(i.o[ZC.1b[17]].97),i.4y([["1Y","DR","fp"],[ZC.1b[8],"PN","fp"],["4k-d9","TO","b"],["ua","mW","b"],["3N-2c","DM","i"]]),i.DM%=2j;1k(1a n=0,a=i.S.1h;n<a;n++)i.S[n]&&(i.S[n].CK=i.PN,i.S[n]&&(i.C.E["1B"+i.L+".2f"]||"5c"===i.C.8b())&&(1c===ZC.1d(i.A.KF[n])&&(i.A.KF[n]=0),i.A.KF[n]+=ZC.1W(i.S[n].AE)))},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.OZ(!0)}}),ZC.TA=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="96",t.BK=["1z"],t.TU=0,t.SI=0,t.DM=0,t.C0=1c,t.PE="bg",t.eS=1c},TL:1f(){1m 1n ZC.Bv(1g)},1q:1f(){1a e,t,i=1g;i.BO=i.NV(),i.BZ=i.BO[0],i.A0=i.BO[1],i.AC=i.BO[2],i.BU=i.BO[0],i.B6=i.BO[0],i.NJ(),i.b(),i.U&&(i.C0=1n ZC.CZ(i),i.C.A.B9.2t(i.C0.o,["2U.1B.1S-3B.97",i.AF+".1B.1S-3B.97"]),1c!==ZC.1d(e=i.C.o.1B)&&1c!==ZC.1d(e[ZC.1b[17]])&&1c!==ZC.1d(t=e[ZC.1b[17]].97)&&i.C0.1C(t),i.C0.1C(i.o[ZC.1b[17]].97)),i.4y([["7y-46","TU","fp"],["1Y","TU","fp"],[ZC.1b[8],"TU","fp"],["Gm-8O","SI","fp"],["3N-2c","DM","i"],["Gm-15o","eS"]]),i.DM%=2j;1k(1a n=0,a=i.S.1h;n<a;n++)i.S[n]&&(i.C.E["1B"+i.L+".2f"]||"5c"===i.C.8b())&&(1c===ZC.1d(i.A.KF[n])&&(i.A.KF[n]=0),i.A.KF[n]+=ZC.1W(i.S[n].AE))},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.OZ(!0)}}),ZC.X0=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="74",t.SK=3,t.BK=["1z-k",ZC.1b[52],"1z"],t.HM=.5,t.CS="1y",t.sr=1c,t.X8=!1,t.D=[],t.AG=[]},TL:1f(){1m 1n ZC.Bw(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.A0=e.BO[3],e.AC=e.BO[3],e.NJ(),e.b(),e.k3(),e.4y([["6D-1M","X8","b"],["2k-1M","HM","f",0,1],["2c-8O","sr","f"]]),e.B0=e.C.BL("1z-k"),e.CI=e.C.BL(ZC.1b[52]),"5y"===e.CS&&(e.b6="5e",e.IJ=!1)},1v:1f(){1a e=1g;e.b(),e.B0.W.1h===e.W.1h&&-1===ZC.AT(e.W,1c)||(e.b6="5e",e.IJ=!1),e.K9=ZC.AK(e.C.K+"-1B-"+e.L+"-bl-0-c"),e.jB=ZC.P.E6(e.CL("bl",0),e.H.AB),e.Q0=ZC.P.E6(e.CL("bl",2),e.H.AB),e.OZ(!0)}}),ZC.ol=ZC.i6.C7({$i:1f(e){1g.b(e);1a t=1g;t.F0=.2,t.CC=.28,t.CO=.28,t.EX=0,t.FG=1c,t.dF=[],t.PT=[],t.Cj=!0,t.PE="bg"},oI:1f(e){1a t,i=1g;if("7w"===e){if(1c!==ZC.1d(t=i.FG.o.2C))1m t;if(1c!==ZC.1d(t=i.FG.o["2C-1D"]))1m{1D:t}}1m{}},1q:1f(){1a e,t=1g;if(t.BO=t.NV(),t.b(),1c!==ZC.1d(t.dF=t.o.hB))1k(1a i=0,n=t.dF.1h;i<n;i++)1c!==ZC.1d(t.dF[i])?"2Y"==1w t.dF[i]?t.PT[i]=ZC.AT(t.CI.JF,t.dF[i]):t.PT[i]=ZC.1W(t.dF[i]):t.PT[i]=1c;t.FG=1n ZC.HQ(t),t.FG.1Q(t),t.FG.1C({"1R-1r":t.BO[3]}),t.FG.o["2C-1D"]="%2o-7w-1S",t.H.B9.2t(t.FG.o,["("+t.AF+").1B.7w"],!0,!0),1c!==ZC.1d(e=t.o.7w)&&t.FG.1C(e),t.FG.1q()}}),ZC.T5=ZC.ol.C7({$i:1f(e){1g.b(e),1g.AF="8q"},TL:1f(){1m 1n ZC.Gg(1g)}}),ZC.T7=ZC.ol.C7({$i:1f(e){1g.b(e),1g.AF="80"},TL:1f(){1m 1n ZC.Gw(1g)}}),ZC.X9=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5O",t.CS="2k",t.tZ="1B-1V",t.Q7=.2,t.UN=1,t.PE="bg"},TL:1f(){1m 1n ZC.Fr(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.BU=e.BO[1],e.A0=e.BO[2],e.AC=e.BO[1],e.NJ(),e.b(),e.4y([["2h-fD","Q7","f",0,1],["1V-fD","UN","f",0,1],["cB","tZ",""]]),e.Q7>=e.UN&&(e.Q7=.2,e.UN=1),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0])},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.jd=e.jg=-ZC.3q,e.XY=e.WE=ZC.3q,e.u0=e.u9=0;1k(1a t=0,i=e.A.A7.1h;t<i;t++)1k(1a n=e.A.A7[t],a=0,l=n.S.1h;a<l;a++)if(n.S[a]){1a o=ZC.1W(n.S[a].AE);n.L===e.L&&(e.jd=ZC.BN(e.jd,o),e.XY=ZC.CV(e.XY,o),e.u0+=o),e.jg=ZC.BN(e.jg,o),e.WE=ZC.CV(e.WE,o),e.u9+=o}e.OZ()}}),ZC.VZ=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.KX=.1,t.NI=.1,t.LV=0,t.j8="4M",t.OR=[],t.VC=[],t.PE="bg"},1q:1f(){1a e,t,i,n,a=1g;if(a.BO=a.NV(),a.BZ=a.BO[0],a.B6=a.BO[1],a.BU=a.BO[1],a.A0=a.BO[2],a.AC=a.BO[1],a.NJ(),a.b(),a.4y([["46-1s","j8"],["2h-8i","LV","fp"],["8O-8m","KX","fp"],["8O-8i","NI","fp"],["1Y","KX","fp"],["1Y","NI","fp"]]),1c!==ZC.1d(i=a.o.8m))1k(i 3z 3K||(i=[i]),e=0,t=i.1h;e<t;e++){1a l=1n ZC.DS(a);l.o=i[e],l.1q(),a.OR.1i(l)}if(1c!==ZC.1d(n=a.o.8i))1k(n 3z 3K||(n=[n]),e=0,t=n.1h;e<t;e++){1a o=1n ZC.DS(a);o.o=n[e],o.1q(),a.VC.1i(o)}a.B0=a.C.BL(a.BT("k")[0]),a.CI=a.C.BL(a.BT("v")[0])},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.OZ()}}),ZC.V1=ZC.VZ.C7({$i:1f(e){1g.b(e),1g.AF="ao"},TL:1f(){1m 1n ZC.Fu(1g)}}),ZC.V2=ZC.VZ.C7({$i:1f(e){1g.b(e),1g.AF="ap"},TL:1f(){1m 1n ZC.Fv(1g)}}),ZC.V3=ZC.i6.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8f",t.CS="Gj",t.MR={2b:0},t.PE="bg"},TL:1f(){1m 1n ZC.Fy(1g)},1q:1f(){1g.b()},1v:1f(){1a e=1g;e.b(),e.9A()},9A:1f(){1a e=1g,t=e.C.BL(e.BT("v")[0]),i=t.B2(t.GZ);if(e.C.BI&&e.C.BI.HS&&e.RH){1k(1a n=e.C.Q,a=e.C.BI,l=[],o=[],r=!0,C=0,A=e.S.1h;C<A;C++)if(1c!==ZC.1d(e.S[C])&&1c!==ZC.1d(e.S[C].DL[2])){1a s=t.B2(e.S[C].DL[2]);r&&(o.1i([e.S[C].iX,i]),r=!1),l.1i([e.S[C].iX,s]),o.1i([e.S[C].iX,s])}o.1h&&o.1i([o[o.1h-1][0],i]);1a Z=e.az(o),c=e.o.2w||{};if("1M"===(c.1I||"1M")){1a u=1n ZC.DS(e.A);u.1Q(e),u.1C({"1R-1r":e.BU,"2k-1M":.2}),u.1C(c),u.1q(),u.CX=!0,u.L1=!0,u.AY=0,u.AQ=0,u.EW=0,u.G4=0,u.C6=ZC.1W(u.o["2k-1M"]),u.CY=[n.iX,n.iY,n.iX+n.I,n.iY+n.F],u.K=e.K+"-1M-2w",u.Z=a.Z,u.D=Z,u.1v()}1a p=e.az(l),h=ZC.P.E6(a.Z,e.H.AB),1b=1n ZC.CZ(e);1b.1Q(e),1b.1C({"1y-1r":e.BU,"1y-1s":1}),1b.1C(c),1b.1q(),ZC.CN.1v(h,1b,p,1c,3)}}}),ZC.X5=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="8M",t.SK=3,t.BK=["1z-r",ZC.1b[52],"1z"],t.HM=.5,t.HL=[10,0,0,0,0],t.PE="bg"},TL:1f(){1m 1n ZC.Gq(1g)},1q:1f(){1a e,t=1g;t.BO=t.NV(),t.BZ=t.BO[0],t.B6=t.BO[1],t.A0=t.BO[3],t.AC=t.BO[3],t.NJ(),t.b(),t.4y([["2k-1M","HM","f",0,1],["Gc","HL"]]),1c!==ZC.1d(e=t.o.15q)&&(t.HL[0]=ZC.1l(e)),t.HL=[ZC.1W(t.HL[0]||"10"),ZC.1W(t.HL[1]||"0"),ZC.1W(t.HL[2]||"0"),ZC.1W(t.HL[3]||"0"),ZC.1W(t.HL[4]||"0")]},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.OZ(!0)}}),ZC.TT=ZC.W2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="5y",t.Y=1,t.CS="a5",t.SK=3,t.HM=.5},TL:1f(){1m 1n ZC.Gt(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.B6=e.BO[1],e.A0=e.BO[0],e.AC=e.BO[1],e.NJ(),e.b(),e.k3(),e.ZA("2k-1M","HM","f",0,1),e.B0=e.C.BL(e.BT("k")[0]),e.CI=e.C.BL(e.BT("v")[0])},OZ:1f(){1a e,t,i=1g,n=i.OK;i.XF(!1);1a a=i.C.Q;i.Y=1;1a l=n?a.F:a.I;i.B0.EC||!i.R3&&5*(i.B0.A1-i.B0.X)>l&&(i.Y=ZC.1l(5*(i.B0.A1-i.B0.X)/l));1a o=i.B0.EC;if(o&&i.PU[0]===ZC.3q&&i.PU[1]===-ZC.3q&&(o=!1),o)1k(e=0,t=i.S.1h;e<t;e++)i.S[e]&&ZC.DU(i.S[e].BX,i.B0.W[i.B0.X],i.B0.W[i.B0.A1])&&(i.S[e].Z=i.K9,i.S[e].MF="2h",i.S[e].1v(),i.S[e].MF="1V",i.S[e].1v(),4o i.S[e].E["d6.2V"]);1t 1k(e=i.B0.X;e<=i.B0.A1;e+=i.Y)i.S[e]&&(i.S[e].MF="2h",i.S[e].1v(),i.S[e].MF="1V",i.S[e].1v(),4o i.S[e].E["d6.2V"])},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.jB=ZC.P.E6(e.CL("bl",1),e.H.AB),e.Q0=ZC.P.E6(e.CL("bl",2),e.H.AB),e.OZ(),e.D=1c,e.D4=1c,e.ZG=1c,e.S1=1c}}),ZC.X6=ZC.W4.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="7k",t.NG=-1},1q:1f(){1a e=1g;e.b(),e.4y([["tJ","NG","ia"]])},TL:1f(){1m 1n ZC.ux(1g)}}),ZC.UI=ZC.QS.C7({$i:1f(e){1g.b(e),1g.AF="6M"},TL:1f(){1m 1n ZC.uc(1g)},1q:1f(){1a e=1g;e.b(),1c===ZC.1d(e.o[ZC.1b[61]])&&(e.BU=e.BO[0]),1c===ZC.1d(e.o["1y-1r"])&&(e.B6=e.BO[0])},1v:1f(){1a e=1g;e.b(),e.k0()}}),ZC.VK=ZC.QB.C7({$i:1f(e){1g.b(e),1g.AF="7v"},TL:1f(){1m 1n ZC.w2(1g)},1q:1f(){1a e=1g;e.b(),1c===ZC.1d(e.o[ZC.1b[61]])&&(e.BU=e.BO[0]),1c===ZC.1d(e.o["1y-1r"])&&(e.B6=e.BO[0])}}),ZC.UA=ZC.QD.C7({$i:1f(e){1g.b(e),1g.AF="8Y"},TL:1f(){1m 1n ZC.wk(1g)},1q:1f(){1a e=1g;e.b(),1c===ZC.1d(e.o[ZC.1b[61]])&&(e.BU=e.BO[1])},1v:1f(){1a e=1g;e.b(),e.k0()}}),ZC.UD=ZC.QC.C7({$i:1f(e){1g.b(e),1g.AF="81"},TL:1f(){1m 1n ZC.vr(1g)},1q:1f(){1a e=1g;e.b(),1c===ZC.1d(e.o[ZC.1b[61]])&&(e.BU=e.BO[1])},1v:1f(){1a e=1g;e.b(),e.k0()}}),ZC.YO=ZC.I8.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="aV",t.u6=[],t.kg=[],t.BK=["1z"],t.PE="bg"},TL:1f(){1m 1n ZC.vD(1g)},1q:1f(){1a e=1g;e.BO=e.NV(),e.BZ=e.BO[0],e.BU=e.BO[1],e.A0=e.BO[3],e.AC=e.BO[3],e.NJ(),e.b(),e.4y([["2I","u6"],["152","kg"]])},1v:1f(){1a e=1g;e.b(),e.K9=e.CL("bl",0),e.OZ(!0)}}),ZC.M5=ZC.DQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.C=e.A.A,t.H=t.C.A,t.L=-1,t.AE=1c,t.DL=[],t.CM=1c,t.BX=1c,t.CJ=1c,t.JH=[],t.HS=!1,t.PR=!0,t.N=t,t.J7=!1,t.hK=!1},H9:1f(e,t){1g.b(1g.A,e,t,1g.MK(1c,!1),1g.A.OC)},UX:1f(){1m[1g.iX,1g.iY,{cB:1g,3E:!0}]},kK:1f(){1m[1g.iX,1g.iY]},cc:1f(e,t,i){1a n,a,l,o,r=1g;1P(r.1v(!0),n=r.iX,a=r.iY,l=r.I,o=r.F,t){1j"3E":n=r.iX+l/2,a=r.iY+o/2;1p;1j"1u":n=r.iX+l/2,a=r.iY,a=i?a-i:a;1p;1j"2a":n=r.iX+l/2,a=r.iY+o,a=i?a+i:a;1p;1j"1J":n=r.iX,a=r.iY+o/2,n=i?n-i:n;1p;1j"2x":n=r.iX+l,a=r.iY+o/2,n=i?n+i:n;1p;2n:n+=r.BJ,a+=r.BD}1m{x:n,y:a}},bQ:1f(e){1a t=1g;1k(1a i in e)e.8d(i)&&(t.A.IJ?t.A.S[t.L][i]=e[i]:t.E[i]=e[i])},5J:1f(e){1m 1g.A.IJ?1g.A.S[1g.L][e]:1g.E[e]},iF:1f(){1a e,t,i=1g,n=i.C.E,a=i.A.L;1c===ZC.1d(n.3O)&&(n.3O={});1a l=n.3O,o=""+i.AE,r=i.A.MG();1k(ZC.P2(o)&&ZC.1W(o)<0&&"cl"===r.8g&&(o=ZC.2i(ZC.1W(o))),r.ch=i.C.UG,r.cn=i.C.N2,o=ZC.AO.GM(o,r,i.A),l["1B-"+a+"-1S"]=o,l["1B-"+a+"-1S-0"]=o,e=0,t=i.DL.1h;e<t;e++)l["1B-"+a+"-1S-"+(e+1)]=i.DL[e];1k(l["1B-1S"]=l["1B-1S-0"]=o,e=0,t=i.DL.1h;e<t;e++)l["1B-1S-"+(e+1)]=i.DL[e]},SU:1f(){1a e,t,i=1g,n=i.A.B0,a=i.A.CI,l=[n.X,n.A1,a.X,a.A1];if(i.A.IJ&&(i.CM=i.A.S[i.L].CM),i.JH!==l){n.D9?(1c!==i.BX?i.iY=n.B2(i.BX):i.iY=n.I3(i.L),i.A.CB&&"100%"===i.A.KO?i.A.A.F3[i.L]["%6i-"+i.A.DV]>0?i.iX=a.B2(100*i.CM/i.A.A.F3[i.L]["%6i-"+i.A.DV]):i.iX=a.B2(100*i.CM):i.iX=a.B2(i.CM+0)):(1c!==i.BX?i.iX=n.B2(i.BX):i.A.LN?"2Q"===i.A.u4?i.iX=n.I3(i.A.R1):i.iX=n.I3(i.A.R1)+i.A.RC+i.L*(n.A9-2*i.A.RC)/(i.A.S.1h-1)-n.A9/2:i.iX=n.I3(i.L),i.A.CB&&"100%"===i.A.KO?i.A.A.F3[i.L]["%6i-"+i.A.DV]>0?i.iY=a.B2(100*i.CM/i.A.A.F3[i.L]["%6i-"+i.A.DV]):i.iY=a.B2(100*i.CM):i.iY=a.B2(i.CM+0)),i.A.IJ&&(i.A.S[i.L].iX=i.iX,i.A.S[i.L].iY=i.iY),i.JH=l}i.HS||(0!==i.A.E4.1h||-1===ZC.AT(["1y","1M","5A","6d","8Y","81","6M","7v"],i.A.AF)||i.A.o.7c?ZC.A4.6A.Bo?(i.1Q(i.A),i.E4=i.A.E4,i.DD(),i.1q(!1),i.N=i):i.A.o.7c?(i.1Q(i.A),i.E4=i.A.E4,i.DD(),i.1q(!1),i.N=i):(e=i.Bm(i.A.E4),1c===ZC.1d(t=i.A.ub[e])?(i.1Q(i.A),i.E4=i.A.E4,i.DD(),i.1q(!1),i.N=i,i.A.ub[e]=i):i.N=t):i.N=i.A,i.A.o.7c&&(i.N.E.7i=i.A.L,i.N.E.7l=i.L,i.N.1q(!1)),i.HS=!0)},7j:1f(){1a e,t=1g;if(t.o[ZC.1b[9]]3z 3K&&(t.CJ=t.o[ZC.1b[9]].2I(" "),"2Y"==1w t.o[ZC.1b[9]][0]?-1!==(e=ZC.AT(t.A.B0.IH,t.o[ZC.1b[9]][0]))?t.BX=e:(t.A.B0.IH.1i(t.o[ZC.1b[9]][0]),t.BX=t.A.B0.IH.1h-1):t.BX=5V(t.o[ZC.1b[9]][0]),"2Y"==1w t.o[ZC.1b[9]][1]?-1!==(e=ZC.AT(t.A.CI.JF,t.o[ZC.1b[9]][1]))?t.AE=e:(t.A.CI.JF.1i(t.o[ZC.1b[9]][1]),t.AE=t.A.CI.JF.1h-1):t.AE=5V(t.o[ZC.1b[9]][1]),1c!==t.BX&&t.A.UT(t.BX,t.L),t.A.YF>0&&t.o[ZC.1b[9]].1h>t.A.YF))1k(1a i=t.o[ZC.1b[9]].1h-t.A.YF;i<t.o[ZC.1b[9]].1h;i++)t.DL.1i(t.o[ZC.1b[9]][i])},1q:1f(e){1a t=1g;if(t.E.7i=t.A.L,t.E.7l=t.L,t.K=t.A.K+"-2o-"+t.L,1c===ZC.1d(e)&&(e=!0),e){if(t.o[ZC.1b[9]]3z 3K||t.A.Cj)t.7j();1t if(t.CJ=t.o[ZC.1b[9]],"2Y"==1w t.o[ZC.1b[9]]){1a i=ZC.AT(t.A.CI.JF,t.o[ZC.1b[9]]);-1!==i?t.AE=i:(t.A.CI.JF.1i(t.o[ZC.1b[9]]),t.AE=t.A.CI.JF.1h-1)}1t t.AE=t.o[ZC.1b[9]];1c===t.CM&&(t.CM=t.AE)}1t t.b()},JC:1f(e){1m 1g.KC(e,{})},ji:1f(){1m 1g.AE},KC:1f(AP,EP,LJ,Ch){1a s=1g,G,CJ,BG,i,A5,D3;1w LJ===ZC.1b[31]&&(LJ=!1);1a 7F,8R=s.A.JL,8G=s.A.A;if(!Ch&&"7u:"===AP.2s(0,11))4I{1a EG=AP.1E("7u:","").1E("()","");7t(EG)&&(G=0===s.DL.1h?s.AE:[s.AE].4w(s.DL),AP=7t(EG).4s(s,G,{5Q:s.L,3S:s.A.L,4W:s.A.GX,153:s.MK(1c,!1),154:s.A.UP()})||AP)}4G(e){}if(AP+="",s.A.so){CJ=s.ji(),1c!==ZC.1d(s.A.CI.JF[CJ])&&s.hK&&(CJ=s.A.CI.JF[CJ]),AP=AP.1E(/%2o-Er-1S/g,s.AE).1E(/%2o-1S/g,CJ).1E(/%2o-2V/g,s.L).1E(/%1B-1D/g,s.A.AP).1E(/%1B-2V/g,s.A.L).1E(/%1B-fb/g,8G.A7.1h).1E(/%p/g,s.A.L).1E(/%P/g,8G.A7.1h).1E(/%v/g,CJ).1E(/%V/g,s.AE).1E(/%i/g,s.L).1E(/%n/g,s.L);1k(1a F5 in s.A.L8){1a PK="";PK=s.A.L8[F5]3z 3K?1c!==s.A.L8[F5][s.L]?s.A.L8[F5][s.L]:"":1c!==s.A.L8[F5]?s.A.L8[F5]:"",7F=1n 5o("%1T-"+F5,"g"),AP=AP.1E(7F,PK)}1m AP}1a PF="",RQ="",RI="",VU="",R=s.C.BL(s.A.BT("k")[0]),V=s.C.BL(s.A.BT("v")[0]);R&&(1c!==s.BX?PF=RQ=RI=s.BX:(1c!==ZC.1d(R.W[s.L])&&(PF=RQ=RI=R.W[s.L]),1c!==ZC.1d(R.BW[s.L])&&(RI=RQ=R.BW[s.L]))),1c!==ZC.1d(G=s.A.B0.IH[PF])&&"8X"==1w PF&&(PF=G),1c!==ZC.1d(G=s.A.B0.IH[RQ])&&"8X"==1w RQ&&(RQ=G),1c!==ZC.1d(G=s.A.B0.IH[RI])&&"8X"==1w RI&&(RI=G),VU=1c!==ZC.1d(s.A.AP)?s.A.AP:"km "+(s.A.L+1),s.A.LN&&s.A.A.A7[s.L]&&(VU=s.A.A.A7[s.L].AP||"km "+s.L);1a TC=(VU+"").2l(/\\s+/),sE=PF;R&&(BG=R.MG(),EP&&EP[ZC.1b[68]]&&ZC.2A({"5H-5z":!0,"5H-5z-5K":EP[ZC.1b[67]]},BG),BG.ch=s.C.UG,BG.cn=s.C.N2,RI=RQ=ZC.AO.GM(PF,BG,R,!0),1c===ZC.1d(R.BW[s.BX])&&1c===ZC.1d(R.BW[s.L])||(RQ=RI=R.BW[s.BX]||R.BW[s.L]),BG[ZC.1b[68]]&&(RI=ZC.AO.GM(RI,BG,R,!0)));1a jD=(RQ+"").2l(/\\s+/),jE=(RI+"").2l(/\\s+/),hZ=(PF+"").2l(/\\s+/);CJ=s.ji(),s.A.CI&&1c!==ZC.1d(s.A.CI.JF[CJ])&&s.hK&&(CJ=s.A.CI.JF[CJ]);1a OI=ZC.P2(CJ)&&ZC.1W(CJ)<0;if(BG=s.A.MG(),ZC.2A(EP,BG),OI&&"cl"===BG.8g&&(CJ=ZC.2i(ZC.1W(CJ))),BG.ch=s.C.UG,BG.cn=s.C.N2,CJ=ZC.AO.GM(CJ,BG,s.A,!(!V||!V.FD)&&V.FD),"%v"===AP&&"%vv"!==AP||"%2o-1S"===AP)1m CJ;if("%t"===AP||"%1B-1D"===AP)1m VU;1a CR=s.CR||[];if(V&&V.N8){1a YC=V.MG();1c===ZC.1d(YC[ZC.1b[12]])&&(YC[ZC.1b[12]]=0);1a Bi=V.D9?V.N8(1g.iX,!0,"5O"===s.A.AF):V.N8(1g.iY,!0,"5O"===s.A.AF),W7=V.G0(0,Bi,YC);CR.1i(["%1z-1S-1S",W7],["%vv",W7]),1c!==ZC.1d(G=V.BW[s.L])?CR.1i(["%1z-1S-1G",G],["%vl",G]):CR.1i(["%1z-1S-1G",W7],["%vl",W7])}if(V&&(-1!==AP.1K("%1z-1S-1D")||-1!==AP.1K("%vt"))){-1!==(G=ZC.AT(V.W,s.AE))&&1c!==ZC.1d(V.BW)&&1c!==ZC.1d(V.BW[G])?CR.1i(["%1z-1S-1D",V.BW[G]],["%vt",V.BW[G]]):CR.1i(["%1z-1S-1D",s.AE],["%vt",s.AE]),7F=-1!==AP.1K("%vt(")?1n 5o("(%vt)\\\\(([0-9]*)\\\\)"):1n 5o("(%1z-1S-1D)\\\\(([0-9]*)\\\\)");1k(1a sy,YD,sj,sx;D3=7F.3j(AP);)YD="",""!==(G=D3[2])&&(sj=ZC.1l(G),1c!==ZC.1d(sx=s.A.A.A7[sj])&&1c!==(sy=sx.FO(s.L))&&(YD=sy.KC(D3[1]))),AP=AP.1E(D3[0],YD),""!==YD&&CR.1i([D3[0],YD])}1c!==ZC.1d(s.A.LU)&&1c!==ZC.1d(s.A.LU[s.L])&&CR.1i(["%1Y-6g",s.A.LU[s.L]]),s.A.A.jN&&CR.1i(["%7H-1u",-1!==ZC.AT(s.A.A.jN,s.A.L)?1:0]);1k(1a F5 in s.A.L8){1a PK;PK=s.A.L8[F5]3z 3K?1c!==s.A.L8[F5][s.L]?s.A.L8[F5][s.L]:"":1c!==s.A.L8[F5]?s.A.L8[F5]:"","8X"==1w PK&&(PK=ZC.AO.GM(PK,BG,s.A,!(!V||!V.FD)&&V.FD)),CR.1i(["%1T-"+F5,PK])}1k(i=0;i<jD.1h;i++)CR.1i(["%1z-7U-1G-"+i,jD[i]],["%kl"+i,jD[i]]);1k(i=0;i<jE.1h;i++)CR.1i(["%1z-7U-1D-"+i,jE[i]],["%kt"+i,jE[i]]);1k(i=0;i<hZ.1h;i++)CR.1i(["%1z-7U-1S-"+i,hZ[i]],["%kv"+i,hZ[i]],["%k"+i,hZ[i]]);CR.1i(["%1z-7U-1G",RQ],["%1z-7U-1D",RI],["%1z-7U-1S",PF],["%1z-7U-1S-ts",sE],["%155",sE],["%kt",RI],["%kl",RQ],["%kv",PF],["%k",PF],["%2o-1S",CJ],["%v",CJ],["%2o-Er-1S",s.AE],["%V",s.AE],["%2o-2V",s.L],["%2o-x",s.iX],["%2o-y",s.iY],["%aL-1s",s.H.I],["%aL-1L",s.H.F],["%i",s.L],["%n",s.L],["%2o-fb",s.A.S.1h],["%N",s.A.S.1h]);1a Eq=8R["%1B-8c"],iJ=Eq+"",Ep=8R["%1B-dq"],iu=Ep+"",rW=ZC.1W(8G.F3["%aT-"+s.L+"-"+s.A.DV+"-8c"]||"0"),jI=rW+"",En=ZC.1W(rW/8G.F3["%aT-"+s.L+"-"+s.A.DV+"-7H-1h"]),jJ=5X(En),Eg=5X(8G.F3["%aT-"+s.L+"-"+s.A.DV+"-7H-1h"]),rX=0;1c!==ZC.1d(8G.F3)&&1c!==ZC.1d(8G.F3[s.L])&&(rX=ZC.1W(8G.F3[s.L]["%6i-"+s.A.DV]||"0"));1a jK=rX+"";iJ=ZC.AO.GM(iJ,BG),iu=ZC.AO.GM(iu,BG),jK=ZC.AO.GM(jK,BG),jI=ZC.AO.GM(jI,BG),jJ=ZC.AO.GM(jJ,BG),CR.1i(["%2o-4L-8n",s.E["2o-4L-8n"]],["%2o-4L-sF",s.E["2o-4L-sF"]],["%7H-6i",jI],["%7H-dq",jJ],["%7H-1h",Eg],["%6i",jK],["%1B-2h-2V",8R["%1B-2h-2V"]],["%156",8R["%1B-2h-2V"]],["%1B-1V-2V",8R["%1B-1V-2V"]],["%157",8R["%1B-1V-2V"]],["%1B-2h-1S",8R["%1B-2h-1S"]],["%17B",8R["%1B-2h-1S"]],["%1B-1V-1S",8R["%1B-1V-1S"]],["%159",8R["%1B-1V-1S"]],["%1B-8c",iJ],["%15b",iJ],["%1B-dq",iu],["%15c",iu],["%1B-6g",8R["%1B-6g"]],["%pv",8R["%1B-6g"]]);1a Fg=100*s.AE/8R["%1B-8c"],YM=Fg+"";1c!==ZC.1d(BG[ZC.1b[12]])&&(YM=ZC.AO.GM(YM,BG)),CR.1i(["%1B-8k",YM],["%15d",YM]);1a s9=!1;1k(i=0,A5=CR.1h;i<A5;i++)if("%8o"===CR[i][0]){s9=!0;1p}if(!s9&&1c!==ZC.1d(s.A.A.F3)&&1c!==ZC.1d(s.A.A.F3[s.L])){1a JG=100*s.AE/s.A.A.F3[s.L]["%6i-"+s.A.DV],HG=JG+"";1c!==ZC.1d(BG[ZC.1b[12]])&&(HG=ZC.AO.GM(HG,BG)),CR.1i(["%2o-8k-1S",HG],["%8o",HG])}1k(i=0;i<TC.1h;i++)CR.1i(["%1B-1D-"+i,TC[i]],["%t"+i,TC[i]]);CR.1i(["%1B-1D",VU],["%t",VU],["%1B-sd",s.A.YA],["%1B-2V",s.A.L],["%p",s.A.L],["%1B-fb",8G.A7.1h],["%P",8G.A7.1h],["%id",s.H.K],["%4u",s.C.K.1E(s.H.K+"-2U-","")]),-1!==AP.1K("%8g")&&(OI&&"cl"===BG.8g?(CR.1i(["%8g","-"]),OI=!1):CR.1i(["%8g",""])),CR.1i(["%2o-x",s.iX],["%2o-y",s.iY],["%2o-1s",s.I],["%2o-1L",s.F],["%2o-2b",s.E["1O.2b"]||1]),1o.3G.Db&&CR.3V(ZC.m2),7F=1n 5o("\\\\(([^(]+?)\\\\)\\\\(([0-9]*)\\\\)(\\\\(*)([0-9]*)(\\\\)*)");1k(1a VT,AV,J;D3=7F.3j(AP);){VT="";1a CP=s.A.L,D7=s.L;""!==(G=D3[2])&&(CP=ZC.1l(G)),""!==(G=D3[4])&&(D7=ZC.1l(G)),1c!==(J=8G.A7[CP])&&1c!==(AV=J.FO(D7,3))&&(VT=AV.KC(D3[1],EP)),AP=AP.1E(D3[0],VT)}if(-1!==AP.1K("%Dz-")){7F=1n 5o("%Dz-([a-zA-Z0-9-]+)");1k(1a jV=s.aj();D3=7F.3j(AP);)1c!==ZC.1d(jV[D3[1]])&&1c!==ZC.1d(s[jV[D3[1]]])&&(AP=AP.1E(D3[0],s[jV[D3[1]]]))}1a BY;if(-1!==AP.1K("%Dp"))1k(7F=1n 5o("%Dp([0-9]*)");D3=7F.3j(AP);)""===D3[1]?(BY=s.N||s).B6||(BY=s.A):BY=8G.A7[D3[1]],AP=AP.1E(D3[0],BY?BY.B6||"#4e":"#4e");if(-1!==AP.1K("%Dv"))1k(7F=1n 5o("%Dv([0-9]*)");D3=7F.3j(AP);)""===D3[1]?(BY=s.N||s).B6||(BY=s.A):BY=8G.A7[D3[1]],AP="jZ"===s.A.PE?AP.1E(D3[0],BY&&BY.A2?BY.A2.A0||"#4e":"#4e"):AP.1E(D3[0],BY?BY.A0||"#4e":"#4e");if(-1!==AP.1K("%1r"))1k(7F=1n 5o("%1r([0-9]*)");D3=7F.3j(AP);)""===D3[1]?(BY=s.N||s).B6||(BY=s.A):BY=8G.A7[D3[1]],AP="1y"===s.A.PE?AP.1E(D3[0],BY?BY.B6||"#4e":"#4e"):"jZ"===s.A.PE?AP.1E(D3[0],BY&&BY.A2?BY.A2.A0||"#4e":"#4e"):AP.1E(D3[0],BY?BY.A0||"#4e":"#4e");1k(AP=ZC.AO.YV(AP,1g),i=0,A5=CR.1h;i<A5;i++)7F=1n 5o(CR[i][0],"g"),AP=1w CR[i][1]===ZC.1b[31]?AP.1E(7F,""):LJ?AP.1E(7F,fi(CR[i][1])):AP.1E(7F,CR[i][1]);1m AP=AP.1E(1n 5o("%1T-([a-zA-Z0-9]+)","g"),""),OI&&"cl"===BG.8g&&(AP="-"+AP),AP},1v:1f(){},6E:1f(){},82:1f(){1m{1r:1g.N.A0}},XP:1f(){1m{"1F-1r":1g.N.A0,"1R-1r":1g.N.AC,1r:1g.N.BZ}},jo:1f(){1m 1g.XP()},H5:1f(e,t){1a i,n,a,l=1g;if(t||(t=1),l.A.NX&&l.A.NX.1h>0&&l.A.NX.1h>t-1&&l.H5(e,t+1),l.AL||"3L"===l.A.AF||"7k"===l.A.AF){1a o,r=1===t?l.A.U:l.A.NX[t-2];if(r){if(l.A.sQ)(o=l.A.sQ).K=l.K+"-1S-3B-"+t,o.Z=o.C5=l.H.2L()?l.H.mc("1u"):l.C.AJ["3d"]||l.H.K3?ZC.AK(l.C.K+"-4j-vb-c"):ZC.AK(l.C.K+"-1B-"+l.A.L+"-vb-c"),o.IE=l.H.2L()?ZC.AK(l.C.A.K+"-1u"):ZC.AK(l.C.A.K+"-1D"),o.E.7i=l.A.L,o.E.7l=l.L,a=ZC.AO.OS(o.o,l.A.o),o.KC=1f(e){1m l.KC(e,a)},o.1q();1t{o=1n ZC.DQ(l.A),r.o.ac||l.A.U.IA||(n="4q",1c!==ZC.1d(i=r.o.1I)&&(n=i),"3L"===l.C.AF||"96"===l.C.AF||"7k"===l.C.AF||"4q"!==n||l.A.NX&&0!==l.A.NX.1h||(l.A.sQ=o)),o.1C(r.o),l.sC&&!e&&(o.1q(),o.1C(l.sC(o))),o.GG=l.C.K+"-1S-3B "+l.C.K+"-1B-"+l.A.L+"-1S-3B zc-1S-3B",o.K=l.K+"-1S-3B-"+t,o.Z=o.C5=l.H.2L()?l.H.mc("1u"):l.C.AJ["3d"]||l.H.K3?ZC.AK(l.C.K+"-4j-vb-c"):ZC.AK(l.C.K+"-1B-"+l.A.L+"-vb-c"),o.IE=l.H.2L()?ZC.AK(l.C.A.K+"-1u"):ZC.AK(l.C.A.K+"-1D"),a=ZC.AO.OS(o.o,l.A.o),o.KC=1f(e){1m l.KC(e,a)};1a C=l.82(o);if(1c!==ZC.1d(i=C.1r)&&(o.BZ=i),1c!==ZC.1d(i=C[ZC.1b[0]])&&(o.A0=o.AC=i),o.E.7i=l.A.L,o.E.7l=l.L,l.A.U.IA&&(l.A.U.H9(l.A.U,o,1c,l.MK(1c,!1)),o.1q()),o.1q(),o.JC=1f(e){1m l.JC(e)},o.DD()&&o.1q(),!l.A.YH){1a A=1n ZC.DQ(l.A);A.1Q(o),l.A.YH=A}if(n="4q",1c!==ZC.1d(i=r.o.1I)&&(n=i),o.AL){o.AL=!1;1a s=l.A.o[ZC.1b[17]].1D||"";if("6g("===n.2s(0,7)){1a Z=n.2s(7,n.1h).1E(")","").2l(",");-1!==ZC.AT(Z,l.AE)&&(o.AL=!0)}1t{1a c=n.2l(","),u={2h:"%1B-2h-1S",1V:"%1B-1V-1S",iT:"%1B-2h-2V",84:"%1B-1V-2V"};1k(1a p in u)-1!==ZC.AT(c,p)&&(("iT"!==p&&"84"!==p||l.L!==l.A.JL[u[p]])&&("2h"!==p&&"1V"!==p||l.AE!==l.A.JL[u[p]])||("4g"==1w s&&1c!==ZC.1d(s[p])&&(o.o.1D=s[p],o.1q()),o.AL=!0));-1!==ZC.AT(c,"4q")&&(o.AL=!0)}}}if(l.C.E["1B"+l.A.L+".2f"]||(o.E["2K-3J"]="1Z"),e)1m o;if(o.AL&&1c!==ZC.1d(o.AP)&&""!==o.AP){1a h=l.7n(o);o.E.tT=h,o.iX=h[0],o.iY=h[1];1a 1b={};if(-1!==o.iX&&-1!==o.iY){1a d=!1;if(1c!==ZC.1d(o.o.ix)&&!ZC.2q(o.o.ix)){1b={x:o.iX,y:o.iY,1s:o.I,1L:o.F};1k(1a f=0,g=l.A.A.YG.1h;f<g;f++)if(ZC.AN.XG(1b,l.A.A.YG[f])){d=!0;1p}}d||(l.C.E["1B"+l.A.L+".2f"]||(o.E["2K-3J"]="1Z"),o.E.sX="vb"+l.C.L,o.1v(),o.EH(),l.A.A.YG.1i(1b),!o.K3&&ZC.AK(l.H.K+"-2Z")&&l.A.A.HK.1i(ZC.AO.NZ(l.C.K,o)))}}1m o}}},Cn:1f(e){if(1c!==ZC.1d(e.o[ZC.1b[19]])){1a t=ZC.IB(e.o[ZC.1b[19]]);t<=1&&(t=1g.I*t),e.I=t}if(1c!==ZC.1d(e.o[ZC.1b[20]])){1a i=ZC.IB(e.o[ZC.1b[20]]);i<=1&&(i=1g.I*i),e.F=i}1m e},7n:1f(e){1a t,i=1g,n=i.C.BL(i.A.BT("v")[0]),a=i.AE>=n.L5&&!n.AR||i.AE<n.L5&&n.AR?-1:1,l="3e";if(1c!==ZC.1d(t=e.o[ZC.1b[7]])&&(l=t),"3e"===l){1a o=1c!==ZC.1d(i.A.S[i.L-1])?i.A.S[i.L-1].AE:i.AE,r=1c!==ZC.1d(i.A.S[i.L+1])?i.A.S[i.L+1].AE:i.AE;o>=i.AE&&i.AE<=r?l="2a":o<=i.AE&&i.AE>=r?l="1u":o>=i.AE&&i.AE>=r?l=o/i.AE>i.AE/r?"2a":"1u":o<=i.AE&&i.AE<=r&&(l=i.AE/o>r/i.AE?"1u":"2a")}1a C=e.I,A=e.F,s=i.iX-C/2,Z=i.iY-A/2;1P(l){1j"1u":Z-=a*(A/2+4);1p;1j"2a":Z+=a*(A/2+4);1p;1j"1J":s-=C/2+4;1p;1j"2x":s+=C/2+4}1m i.C.AJ["3d"]||(s=ZC.BN(i.C.Q.iX-C/2,s),s=ZC.CV(i.C.Q.iX+i.C.Q.I-C/2,s),Z=ZC.BN(i.C.Q.iY-A,Z),Z=ZC.CV(i.C.Q.iY+i.C.Q.F,Z)),1c!==ZC.1d(e.o.x)&&(s=e.iX),1c!==ZC.1d(e.o.y)&&(Z=e.iY),[ZC.1l(s),ZC.1l(Z)]},P6:1f(e,t){1a i,n,a,l,o,r=1g,C=["5h","6z","6t","8t"];if(1w r.A.eg===ZC.1b[31]&&(r.A.eg=-1===ZC.AT(C,r.A.AF)),(!r.C.O6||!r.A.eg)&&(1c===ZC.1d(e)&&(e=!1),1c===ZC.1d(t)&&(t=!1),ZC.DU(r.iX,r.C.Q.iX-2,r.C.Q.iX+r.C.Q.I+2)&&ZC.DU(r.iY,r.C.Q.iY-2,r.C.Q.iY+r.C.Q.F+2))){1a A=r.C.K+ZC.1b[34]+r.C.K+ZC.1b[35]+r.A.L+ZC.1b[6];if(-1===ZC.AT(r.H.KL,ZC.1b[39])&&r.A.FT){if(r.A.XV&&!1o.3G.bA){1a s=r.5J("2S");-1!==ZC.AT(r.H.KL,ZC.1b[42])&&-1!==ZC.AT(["1y","1M"],r.A.AF)&&1w s===ZC.1b[31]&&r.1v(!0),""!==(a=1w r.E.sn===ZC.1b[31]?ZC.AN.PO(ZC.AN.YU(s,ZC.BN(6,r.A.AY/2)),4):ZC.AN.PO(s,4))&&r.A.A.HK.1i(ZC.P.GC("4x",r.A.E5,r.N.IM)+\'3g="\'+A+\'" id="\'+r.K+ZC.1b[30]+a+\'" />\')}if(("1M"===r.A.AF||"81"===r.A.AF||"74"===r.A.AF&&("1M"===r.A.CS||"5y"===r.A.CS))&&r.A.X8){1a Z=r.5J("9U");""!==(a=ZC.AN.PO(Z,4))&&r.A.A.HK.1i(ZC.P.GC("4x",r.A.E5,r.A.IM)+\'3g="\'+A+\'" id="\'+r.K+\'--1M" 9n="\'+a+\'" />\')}}if(r.A.U||!r.A.IJ||!r.A.A2.o||"1Z"!==r.A.A2.o.1I&&(1c===ZC.1d(r.A.A2.o.2f)||ZC.2q(r.A.A2.o.2f))){if(t||r.A.QX){if(r.A.H4)l=r.A.H4,"2B"!==r.H.AB&&(e?(o=1n ZC.CF(r.C,r.iX-ZC.AM.E1,r.iY-ZC.AM.E0,r.A.E["z-46"]||0),l.iX=ZC.4t(o.E9[0]),l.iY=ZC.4t(o.E9[1]),r.E["dB"]=[l.iX,l.iY]):(l.iX=ZC.4t(r.iX),l.iY=ZC.4t(r.iY)),l.E.7i=r.A.L,l.E.7l=r.L,l.K=r.K+"-1O",l.1q(!0));1t{if(r.IJ?r.A.sW?l=r.A.sW:r.A.sW=l=1n ZC.DS(r.A):l=1n ZC.DS(r.A),l.K=r.K+"-1O",l.E["p-1s"]=r.A.B0.A9,l.E["p-1L"]=r.A.CI.A9,r.A.eg)l.Z=r.A.CL("fl",0),l.C5=r.A.CL("fl",0);1t if(l.Z=r.A.CL("bl",1),l.C5=r.A.CL("bl",0),93&&93.cr&&93.cr(r.C.CW).1h>0){1a c=r.C.CW["p"+r.A.L];"1Z"!==r.A.IV&&c&&c["n"+r.L]&&(l.Z=r.A.CL("bl",2))}e?(o=1n ZC.CF(r.C,r.iX-ZC.AM.E1,r.iY-ZC.AM.E0,r.A.E["z-46"]||0),l.iX=ZC.4t(o.E9[0]),l.iY=ZC.4t(o.E9[1]),r.E["dB"]=[l.iX,l.iY]):(l.iX=ZC.4t(r.iX),l.iY=ZC.4t(r.iY)),l.B6=r.A.BO[3],l.BU=r.A.BO[3],l.A0=r.A.BO[2],"5h"===r.A.AF||"6z"===r.A.AF?l.AC=r.A.BO[1]:l.AC=r.A.BO[2],l.1C(r.A.A2.o),1c!==ZC.1d(r.E["1O.2b"])&&(l.AH=r.E["1O.2b"]),l.E.7i=r.A.L,l.E.7l=r.L,"1Z"!==r.A.IV&&(r.C.JZ[r.A.L]||r.C.KM)&&(r.C.CW["p"+r.A.L]&&r.C.CW["p"+r.A.L]["n"+r.L]?l.OH=r.A.PI?r.A.PI.o:{}:"1Z"!==r.A.O0&&("1B"===r.A.O0&&r.C.JZ[r.A.L]||"2U"===r.A.O0&&r.C.KM)&&(l.OH=r.A.PD?r.A.PD.o:{})),1c!==ZC.1d(i=r.A.o.1O)&&1c!==ZC.1d(i.au)&&1c!==ZC.1d(n=i.au[r.L])&&("2Y"==1w n?l.1C({"1R-1r":ZC.AO.QJ(n,20),"1y-1r":ZC.AO.JE(n,20),"1F-1r":ZC.AO.JE(n,20)}):l.1C(n)),l.1q(),l.JC=1f(e){1m r.JC(e)},l.DD()&&l.1q()}if(r.E["1O.2b"]=ZC.BN(2.sP,r.E["1O.2b"]||l.AH),l.DJ=A,!(e||ZC.DU(l.iX,r.C.Q.iX-2,r.C.Q.iX+r.C.Q.I+2)&&ZC.DU(l.iY,r.C.Q.iY-2,r.C.Q.iY+r.C.Q.F+2)))1m;if(l.IA&&(r.A.YI=!1,l.H9(l,l,1c,r.MK(1c,!1)),l.1q()),r.N3=l,l.AL&&"1Z"!==l.AF){1a u=1f(){if(r.A.eg||r.N0(ZC.P.E6(r.A.CL("bl",0),r.H.AB)),r.E["1O.1I"]=l.DP,r.A.FT&&-1===ZC.AT(r.H.KL,ZC.1b[40])&&!1o.3G.bA){1a e=r.E["dB"]?r.E["dB"][0]:r.iX,t=r.E["dB"]?r.E["dB"][1]:r.iY;-1!==ZC.AT(["3L","9o","5t","fA"],l.DP)?r.A.A.HK.1i(ZC.P.GC("4x",r.A.E5,r.A.IM)+\'3g="\'+A+\'" id="\'+r.K+"--1O"+ZC.1b[30]+l.FB()+\'" />\'):r.A.A.HK.1i(ZC.P.GC("3x",r.A.E5,r.A.IM)+\'3g="\'+A+\'" id="\'+r.K+"--1O"+ZC.1b[30]+ZC.1l(e+l.BJ+ZC.3y)+","+5w(t+l.BD+ZC.3y,10)+","+5w(ZC.BN(ZC.2H?6:3,r.E["1O.2b"]+1)*(ZC.2H?1.25:1.hE),10)+\'" />\')}if(r.A.U&&(r.A.E.kq=r.K,r.H5()),!r.A.eg&&r.C.BI&&r.C.BI.HS&&r.A.RH&&r.C.BI.AL){1a i=r.C.Q,n=r.C.BI,a=n.B4,o=r.A.H4||l,C=1n ZC.DS(r.A);C.1Q(o);1a s=(r.iX-i.iX)/i.I,Z=(r.iY-i.iY)/i.F;C.iX=a.iX+a.AQ+s*(a.I-2*a.AQ),C.iY=a.iY+a.AQ+Z*(a.F-2*a.AQ),C.K=r.K+"-1O-2w",C.DJ=r.A.K+"-2w",C.AH=ZC.BN(2.sP,ZC.CV(s,Z)*o.AH),C.Z=C.C5=n.Z,C.1q(),C.1v()}},p=!1;if((!r.A.eg||"74"===r.A.AF&&"sp"===r.A.CS)&&(p=!0),r.A.GA&&p&&!r.C.HC){1a h=l,1b={},d=l.C6,f=l.AH,g=l.iX,B=l.iY;h.iX=g,h.iY=B,1b.x=g,1b.y=B;1a v=r.A.L6,b=r.C.Q;h.C6=0,1b.2k=d,3===v?(h.AH=2,1b.2b=f):8===v?(h.iX=g-b.iX,1b.x=g):9===v?(h.iX=g+b.iX,1b.x=g):10===v?(h.iY=B-b.iY,1b.y=B):11===v&&(h.iY=B+b.iY,1b.y=B);1a E;1k(E in r.A.FR)h[ZC.E8.GI[ZC.EB(E)]]=r.A.FR[E],1b[ZC.EB(E)]=r.N[ZC.E8.GI[ZC.EB(E)]];if(1c===ZC.1d(r.C.EN)&&(r.C.EN={}),1c!==ZC.1d(r.C.EN[r.A.L+"-"+r.L]))1k(E in r.C.EN[r.A.L+"-"+r.L])h[ZC.E8.GI[ZC.EB(E)]]=r.C.EN[r.A.L+"-"+r.L][E];r.C.EN[r.A.L+"-"+r.L]={},ZC.2A(1b,r.C.EN[r.A.L+"-"+r.L]);1a m=1n ZC.E8(h,1b,r.A.J9,r.A.L2,ZC.E8.RJ[r.A.L4],1f(){u()});m.AV=r,m.O8=1f(){r.N0(ZC.P.E6(r.A.CL("bl",0),r.H.AB))},r.LL(m)}1t{1a K="3x"===l.DP?"3x":"2M";if(r.A.HB){1a F=1f(t,i){1a n=t.kP(!1),a=r.iX,o=r.iY;if(e){1a C=1n ZC.CF(r.C,a-ZC.AM.E1,o-ZC.AM.E0,r.A.E["z-46"]||0);a=ZC.4t(C.E9[0]),o=ZC.4t(C.E9[1]),r.E["dB"]=[a,o]}n.4l("5H","7f("+ZC.1l(a-l.iX)+","+ZC.1l(o-l.iY)+") "+(n.bT("5H")||"")),n.4l("id",i),"5h"!==r.A.AF&&"6z"!==r.A.AF||n.4l("r",r.E["1O.2b"]),t.6s.2X(n)};l.M3&&F(r.A.R6,r.K+"-1O-sh-"+K),F(r.A.HB,r.K+"-1O-"+K),l.D8&&F(r.A.Q8,r.K+"-1O-5b")}1t{l.1v();1a D=l.A0!==l.AC;if(!r.C.JZ[r.A.L]&&r.A.YI&&!D)if("2B"===r.H.AB){if(-1===ZC.AT(["3L","9o","5t","fA","9u","8n","5C"],l.DP))if(r.A.H4=l,1o.3G.kw&&2e.eB){1k(1a I in r.H.FW)r.A.HB||(r.A.HB=r.H.FW[I].eB("#"+r.K+"-1O-"+K)),l.M3&&!r.A.R6&&(r.A.R6=r.H.FW[I].eB("#"+r.K+"-1O-sh-"+K)),l.D8&&!r.A.Q8&&(r.A.Q8=r.H.FW[I].eB("#"+r.K+"-1O-5b")||r.H.FW[I].eB("#"+r.K+"-1O-2M-5b"));r.A.HB||(r.A.HB=ZC.AK(r.K+"-1O-"+K),l.M3&&(r.A.R6=ZC.AK(r.K+"-1O-sh-"+K)),l.D8&&(r.A.Q8=ZC.AK(r.K+"-1O-5b")))}1t r.A.HB=ZC.AK(r.K+"-1O-"+K),l.M3&&(r.A.R6=ZC.AK(r.K+"-1O-sh-"+K)),l.D8&&(r.A.Q8=ZC.AK(r.K+"-1O-5b")||ZC.AK(r.K+"-1O-2M-5b"))}1t"5h"!==r.A.AF&&"6z"!==r.A.AF&&(e||(r.A.H4=l))}"2B"===r.H.AB&&r.A.kC(r.A.A2,r.K+"-1O-"+K,r.MK()),u()}}1t r.A.U&&r.H5()}1t r.A.U&&r.H5()}}},LL:1f(e,t){1a i,n=1g,a=n.C.LR,l=a.P9,o=n.A.TG;1P(o){2n:t&&a.2N(t),a.2N(e);1p;1j 1:1j 2:1j 3:if(t){1a r="4q";if(1===o?r="4j-5Z-"+n.L+"-1M":2===o&&(r="cZ-5Z-"+n.A.L+"-1M"),1c===ZC.1d(l[r])){1a C=1n ZC.s2(r);a.tE(C,t.X3)}l[r].2N(t)}if(i="4q",1===o?i="4j-5Z-"+n.L:2===o&&(i="cZ-5Z-"+n.A.L),1c===ZC.1d(l[i])){1a A=1n ZC.s2(i);a.tE(A,e.X3)}l[i].2N(e)}},TD:1f(e){1a t=1g;t.A.IJ&&t.A.Aj&&(t.SU(),e&&("6t"!==t.A.AF&&"8t"!==t.A.AF&&"5h"!==t.A.AF&&"6z"!==t.A.AF||t.1v(!0)));1a i=t.A.BO;t.M2({6r:e,1I:"2P",id:"1O",1O:!0,92:1f(){1g.DP=t.E["1O.1I"],1g.iX=t.iX,1g.iY=t.iY,"5h"===t.A.AF||"6z"===t.A.AF?(1g.AC=i[3],1g.A0=i[2]):(1g.B6=i[3],1g.BU=i[3],1g.A0=i[2],1g.AC=i[1]),1g.AH=t.E["1O.2b"]}})},j4:1f(e){1a t=1g;t.M2({6r:e,1I:"1y",id:"1y",92:1f(){1g.B6=t.A.BO[3]}})},M2:1f(e){if(!ZC.3l){1a t,i,n,a,l,o,r=1g,C=e.6r||"2J",A=e.id||"",s=!1;1P(r.GE=1c,1c!==ZC.1d(t=e.1O)&&(s=ZC.2q(t)),C){1j"2J":1c!==ZC.1d(r.C.CW["p"+r.A.L])&&1c!==ZC.1d(r.C.CW["p"+r.A.L]["n"+r.L])||(n=s?r.A.G6:r.A.I7,a="2J");1p;1j"5M":n=s?r.A.UZ:r.A.RZ,a="2J"}if(1c!==ZC.1d(e.3U)&&(n=e.3U),n&&r.C.E["1B"+r.A.L+".2f"]&&n.AL){1P(e.1I){1j"3B":(o=1n ZC.HQ(r.A)).PR=!0;1p;1j"1y":o=1n ZC.DS(r.A),l=ZC.P.E6(r.C.K+"-"+a+"-c",r.H.AB),o.CX=!1;1p;1j"2P":o=1n ZC.DS(r.A);1p;1j"1M":o=1n ZC.DS(r.A),l=ZC.P.E6(r.C.K+"-"+a+"-c",r.H.AB)}if(s&&(o.E["p-1s"]=r.A.B0.A9,o.E["p-1L"]=r.A.CI.A9),1o.3G.l1&&"2J"===a?o.Z=o.C5=ZC.AK(r.C.K+"-4j-2J-c"):o.Z=o.C5=ZC.AK(r.C.K+"-"+a+"-c"),o.K=r.K+"-"+(""!==A?A+"-":"")+C,o.E.7i=r.A.L,o.E.7l=r.L,"2J"!==C&&(o.t0=!0),e.92&&e.92.4s(o),o.1C(n.o),e.kL&&e.kL.4s(o),"2J"===C&&1c!==ZC.1d(t=r.A.o)&&1c!==ZC.1d(t.au)&&1c!==ZC.1d(i=t.au[r.L])&&("2Y"==1w i?o.1C({"1R-1r":i,"1y-1r":i,"1F-1r":i}):o.1C(i)),1c!==ZC.1d(t=r.A.o[C+"-3U"])&&1c!==ZC.1d(t.au)&&1c!==ZC.1d(i=t.au[r.L])&&("2Y"==1w i?o.1C({"1R-1r":i,"1y-1r":i,"1F-1r":i}):o.1C(i)),r.A.IA&&r.H9(o,C),"2J"===C&&r.A.A2&&r.A.A2.IA&&(r.A.A2.H9(r.A.A2,o,1c,r.MK(1c,!1)),o.1q()),o.1q(),o.JC=1f(e){1m r.JC(e)},o.DD()&&o.1q(),o.AL){1P(e.d1&&e.d1.4s(o),e.1I){1j"3B":1j"2P":o.9p(2),o.1v();1p;1j"1y":ZC.CN.2E(l,o),"1B"===r.A.kS?ZC.CN.1v(l,o,r.A.UY):ZC.CN.1v(l,o,r.5J("2S"));1p;1j"1M":"4V"!==r.A.CS&&(1c!==ZC.1d(t=n.o["2k-1M"])&&(o.C6=ZC.1W(t)),ZC.CN.2E(l,o),o.1v())}r.GE=o}}}},N0:1f(){},2E:1f(){},6e:1f(){},LK:1f(){1a e=1g;ZC.P.ES([e.K+"-2J-4Y",e.K+"-1O-2J-4Y",e.H.K+"-2C-1D-4Y",e.H.K+"-2C-1D-sh-4Y"])},MK:1f(e,t){1a i=1g;1w t===ZC.1b[31]&&(t=!0);1a n=!1;"1Z"!==i.A.IV&&i.C.CW&&i.C.CW["p"+i.A.L]&&i.C.CW["p"+i.A.L]["n"+i.L]&&(n=!0);1a a={id:i.C.A.K,4u:i.C.K,18v:i.C.L,4W:i.A.GX,3S:i.A.L,5Q:i.L,7U:1c===i.BX?i.L:i.BX,18r:i.A.B0?i.A.B0.W[1c===i.BX?i.L:i.BX]:1c,Aa:i.A.B0?i.A.B0.G0(i.L,1c===i.BX?1c:i.A):1c,1S:i.AE,1D:t?i.KC(i.A.JT):i.A.JT,ev:e?ZC.A4.C1(e):1c,x:i.iX,y:i.iY,1s:i.I,1L:i.F,2b:i.E["1O.2b"]||1,ex:n};1k(1a l in i.A.L8)i.A.L8[l]3z 3K?1c!==ZC.1d(i.A.L8[l][i.L])&&(a["1T-"+l]=i.A.L8[l][i.L]):a["1T-"+l]=i.A.L8[l];1m a},WY:1f(e,t){ZC.AO.C2("190"+t,1g.H,1g.MK(e))}}),ZC.tR=ZC.M5.C7({2E:1f(){1g.SU()},82:1f(){1m{1r:1g.N.B6}},XP:1f(){1m{"1R-1r":1g.N.B6,"1F-1r":1g.N.B6,1r:1g.N.BZ}},cc:1f(e,t){1m 1g.b(e,t,1g.N3.AH)},1v:1f(e){1f t(){!i.C.O6&&ZC.DU(i.iX,l.iX-1,l.iX+l.I+1)&&ZC.DU(i.iY,l.iY-1,l.iY+l.F+1)&&(i.P6(),i.N0(ZC.P.E6(i.A.CL("bl",1),i.H.AB)),i.A.U&&i.A.U.AL&&i.A.E.kq!==i.K&&i.H5())}1a i=1g;1w e===ZC.1b[31]&&(e=!1),i.b();1a n=i.A.OK,a=i.A.Q0,l=i.A.B0,o=i.A.S;if(i.2E(),!i.A.IJ||i.C.AJ["3d"]||i.A.FT){i.N.CX=i.CX=!1,i.N.C5=i.A.CL("bl",0);1a r=[],C=i.A.CS;(i.C.O6||i.A.TW)&&"4V"===i.A.CS&&(C="a5");1a A=1w i.A.G5!==ZC.1b[31]?i.A.G5:i.A.Y,s=1w i.A.H8!==ZC.1b[31]?i.A.H8:i.A.Y,Z=!0,c=!0;(1c===ZC.1d(o[i.L-A])||"2W"!==l.CA&&!l.EC&&i.L<=l.X)&&(Z=!1);1a u=i.A.LN?i.A.S.1h:l.A1;(1c===ZC.1d(o[i.L+s])||"2W"!==l.CA&&!l.EC&&i.L>=u)&&(c=!1);1a p,h,1b,d;1P(C){2n:Z&&(i.A.FO(i.L-A,0).2E(),i.A.UK&&(p=ZC.AN.JK(i.A.S[i.L-A].iX,i.A.S[i.L-A].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),r.1i(p))),r.1i([i.iX,i.iY]),c&&(i.A.FO(i.L+s,2).2E(),p=i.A.UK?ZC.AN.JK(i.A.S[i.L].iX,i.A.S[i.L].iY,i.A.S[i.L+s].iX,i.A.S[i.L+s].iY,i.N.C6):[o[i.L+s].iX,o[i.L+s].iY],r.1i(p));1p;1j"4V":if(i.A.D&&(r=i.A.D),i.A.D=[],o[i.L+1]){1a f=[],g=[];1k(h=-1;h<3;h++)o[i.L+h]?(i.A.FO(i.L+h,2).2E(),n?(f.1i(o[i.L+h].iX),g.1i(o[i.L+h].iY)):(f.1i(o[i.L+h].iY),g.1i(o[i.L+h].iX))):0===f.1h?n?(g.1i(i.iY),f.1i(i.iX)):(g.1i(i.iX),f.1i(i.iY)):(f.1i(f[f.1h-1]),g.1i(g[g.1h-1]));1a B=ZC.2i(g[2]-g[1]),v=ZC.AN.XZ(i.A.Q3,f,B);if(i.A.UK){1k(h=0;h<ZC.1l(v.1h/2)+(1===i.N.C6?1:0);h++)v[h]&&(n?r.1i([v[h][1],i.iY+(l.AR?1:-1)*v[h][0]*B]):r.1i([i.iX+(l.AR?-1:1)*v[h][0]*B,v[h][1]]));1k(h=ZC.1l(v.1h/2)-1,1b=v.1h;h<1b;h++)v[h]&&(n?i.A.D.1i([v[h][1],i.iY+(l.AR?1:-1)*v[h][0]*B]):i.A.D.1i([i.iX+(l.AR?-1:1)*v[h][0]*B,v[h][1]]))}1t 1k(h=0;h<ZC.1l(v.1h);h++)n?r.1i([v[h][1],i.iY+(l.AR?1:-1)*v[h][0]*B]):r.1i([i.iX+(l.AR?-1:1)*v[h][0]*B,v[h][1]])}1p;1j"es":if(Z)1P(i.A.FO(i.L-A,0).2E(),p=ZC.AN.JK(i.A.S[i.L-A].iX,i.A.S[i.L-A].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),i.A.SE){2n:n?r.1i([o[i.L-A].iX,p[1]],[i.iX,p[1]]):r.1i([p[0],o[i.L-A].iY],[p[0],i.iY]);1p;1j"fr":r.1i([i.A.S[i.L-A].iX,o[i.L-A].iY],[i.A.S[i.L-A].iX,i.iY]);1p;1j"9e":}if(r.1i([i.iX,i.iY]),c)1P(i.A.FO(i.L+s,0).2E(),p=ZC.AN.JK(i.A.S[i.L+A].iX,i.A.S[i.L+A].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),i.A.SE){2n:r.1i(n?[i.iX,p[1]]:[p[0],i.iY]);1p;1j"fr":1p;1j"9e":r.1i([i.A.S[i.L+A].iX,i.iY],[i.A.S[i.L+A].iX,o[i.L+s].iY])}1p;1j"Bh":Z?(i.A.FO(i.L-A,0).2E(),p=ZC.AN.JK(i.A.S[i.L-A].iX,i.A.S[i.L-A].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),r.1i(n?[i.iX,p[1]]:[p[0],i.iY])):r.1i(n?[i.iX,i.iY-l.A9/2]:[i.iX-l.A9/2,i.iY]),r.1i([i.iX,i.iY]),c?(i.A.FO(i.L+s,0).2E(),p=ZC.AN.JK(i.A.S[i.L+A].iX,i.A.S[i.L+A].iY,i.A.S[i.L].iX,i.A.S[i.L].iY),r.1i(n?[i.iX,p[1]]:[p[0],i.iY])):r.1i(n?[i.iX,i.iY+l.A9/2]:[i.iX+l.A9/2,i.iY])}if(i.bQ({2S:r}),"9i"!==i.C.M7&&(i.A.UY=i.A.UY.4w(r)),!e&&!i.C.AJ["3d"]){1a b=i.N=i.A.I1(i,i.N),E=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6];if(b.DJ=E,b.K=i.K,i.A.IA&&i.H9(b),ZC.CN.2E(a,b),i.9A(b,r),i.A.GA&&!i.C.HC){1a m=1n ZC.DS(i),K={};m.1Q(b),m.K=i.K,m.Z=i.A.CL("bl",1),m.C5=i.A.CL("bl",0),m.D=r,K.2S=r;1a F=[],D=i.A.L6,I=i.C.Q;1k(m.C6=0,K.2k=b.C6,h=0;h<r.1h;h++)2===D?F[h]=[r[h][0],I.iY+I.F/2]:3===D?F[h]=[r[h][0],I.iY-5]:4===D?F[h]=[r[h][0],I.iY+I.F+5]:5===D?F[h]=[I.iX-5,r[h][1]]:6===D?F[h]=[I.iX+I.I+5,r[h][1]]:7===D?F[h]=[I.iX+I.I/2,r[h][1]]:8===D?F[h]=[r[h][0]-I.I,r[h][1]]:9===D?F[h]=[r[h][0]+I.I,r[h][1]]:10===D?F[h]=[r[h][0],r[h][1]-I.F]:11===D?F[h]=[r[h][0],r[h][1]+I.F]:12===D?F[h]=[(r[0][0]+r[r.1h-1][0])/2,r[0][1]]:13===D&&(F[h]=[r[0][0],(r[0][1]+r[r.1h-1][1])/2]),D>1&&(m.D=F,K.2S=r);1k(d in i.A.FR)m[ZC.E8.GI[ZC.EB(d)]]=i.A.FR[d],K[ZC.EB(d)]=b[ZC.E8.GI[ZC.EB(d)]];if(i.C.EN||(i.C.EN={}),1c!==ZC.1d(i.C.EN[i.A.L+"-"+i.L]))1k(d in i.C.EN[i.A.L+"-"+i.L])m[ZC.E8.GI[ZC.EB(d)]]=i.C.EN[i.A.L+"-"+i.L][d];i.C.EN[i.A.L+"-"+i.L]={},ZC.2A(K,i.C.EN[i.A.L+"-"+i.L]);1a X=1n ZC.E8(m,K,i.A.J9,i.A.L2,ZC.E8.RJ[i.A.L4],1f(){t()});X.AV=i,X.O8=1f(){i.N0(ZC.P.E6(i.A.CL("bl",1),i.H.AB))},X.IC=a,i.LL(X)}1t ZC.CN.1v(a,b,r),t()}}},9A:1f(e,t){1a i=1g;if(i.C.BI&&i.C.BI.HS&&i.A.RH){1a n,a=i.A.az(t);i.A.VH?n=i.A.VH:(n=1n ZC.CZ(i),i.A.VH=n),n.1Q(e),n.K=i.K+"-1y-2w",n.DJ=i.A.K+"-2w";1a l=ZC.P.E6(i.C.BI.Z,i.H.AB);n.AY=1;1a o=i.o["2w-3U"];o&&(n.1C(o),n.1q()),ZC.CN.1v(l,n,a,1c,3)}},6e:1f(e){1a t=1g;ZC.3l||(t.j4(e),t.A.QX&&t.TD(e))}}),ZC.tA=ZC.M5.C7({2E:1f(){1g.SU()},82:1f(){1m{1r:1g.N.B6}},XP:1f(){1m{"1R-1r":1g.N.B6,"1F-1r":1g.N.B6,1r:1g.N.BZ}},cc:1f(e,t){1m 1g.b(e,t,1g.N3.AH)},1v:1f(e){1f t(){!s.C.O6&&ZC.DU(s.iX,u.iX-1,u.iX+u.I+1)&&ZC.DU(s.iY,u.iY-1,u.iY+u.F+1)&&(s.P6(),s.N0(ZC.P.E6(s.A.CL("bl",1),s.H.AB)),s.A.U&&s.A.U.AL&&s.A.E.kq!==s.K&&s.H5())}1a i,n,a,l,o,r,C,A,s=1g;1w e===ZC.1b[31]&&(e=!1),s.b();1a Z=s.A.OK,c=s.A.Q0,u=s.A.B0,p=s.A.CI,h=s.A.S;if(s.2E(),!s.A.IJ||s.C.AJ["3d"]||s.A.FT){s.N.CX=s.CX=!1,s.N.C5=s.A.CL("bl",1);1a 1b=p.GZ,d=p.B2(1b);d=Z?ZC.5m(d,p.iX,p.iY+p.I):ZC.5m(d,p.iY,p.iY+p.F);1a f=u.DK?u.A9/2:0,g=[],B=[],v=[],b=1c;1c!==ZC.1d(s.A.A.EZ)&&1c!==ZC.1d(s.A.A.EZ[s.L])&&(b=s.A.A.EZ[s.L]);1a E=s.A.CS;(s.C.O6||s.A.TW)&&"4V"===s.A.CS&&(E="a5"),n=s.N.AY/2-1,a="2B"===s.H.AB&&ZC.2H?s.N.HM/4:0,"3I"===s.H.AB&&s.A.GA&&(a=.5),s.C.AJ["3d"]&&(1===s.A.HM?a=1:(a=s.A.HM/3,"3a"===s.H.AB&&(ZC.A4.6A.a6||ZC.A4.6A.l8)&&(a=.5)),u.AR&&(a=-a));1a m,K=1w s.A.G5!==ZC.1b[31]?s.A.G5:s.A.Y,F=1w s.A.H8!==ZC.1b[31]?s.A.H8:s.A.Y,D=!0,I=!0;(!h[s.L-K]||"2W"!==u.CA&&!u.EC&&s.L<=u.X)&&(D=!1);1a X=s.A.LN?s.A.S.1h:u.A1;1P((!h[s.L+F]||"2W"!==u.CA&&!u.EC&&s.L>=X)&&(I=!1),E){2n:if(D)s.A.FO(s.L-K,0).2E(),s.A.UK?(o=ZC.AN.JK(h[s.L-K].iX,h[s.L-K].iY,h[s.L].iX,h[s.L].iY),v.1i([ZC.1l(o[0])-a,o[1]-n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(o[0])-a,d]),B.1i([ZC.1l(o[0])-a,o[1]+n]),g.1i([o[0],o[1]])):B.1i([ZC.1l(s.iX),d]);1t if(u.EC||s.L!==u.X)s.A.CB&&1c!==ZC.1d(b)?(m=s.A.A.A7[s.A.L-1])&&m.S[s.L]&&B.1i([ZC.1l(s.iX),m.S[s.L].iY+n]):(B.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX-u.A9/2),d]),v.1i([ZC.1l(s.iX),d]));1t if(u.AR)s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.I-u.BV-f),d]),B.1i([ZC.1l(u.iX+u.I-u.BV-f),s.iY+n]);1t{1a x=ZC.1l(u.iX+u.A6+f);s.A.LN&&(x=u.I3(s.A.R1)-u.A9/2),s.A.CB&&1c!==ZC.1d(b)||B.1i([x,d]),B.1i([x,s.iY+n])}v.1i([ZC.1l(s.iX),s.iY-n]),B.1i([ZC.1l(s.iX),s.iY+n]),g.1i([s.iX,s.iY]),I?(s.A.FO(s.L+F,2).2E(),l=s.A.UK?ZC.AN.JK(h[s.L].iX,h[s.L].iY,h[s.L+F].iX,h[s.L+F].iY):[h[s.L+F].iX,h[s.L+F].iY],v.1i([ZC.1l(l[0]),l[1]-n]),B.1i([ZC.1l(l[0]),l[1]+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(l[0]),d]),o=s.A.UK?ZC.AN.JK(h[s.L].iX,h[s.L].iY,h[s.L+F].iX,h[s.L+F].iY,s.N.C6):[h[s.L+F].iX,h[s.L+F].iY],g.1i([o[0],o[1]])):s.L===u.A1?u.AR?(B.1i([u.iX+u.A6-f,s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.A6-f),d])):(B.1i([u.iX+u.I-u.BV-f,s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.I-u.BV-f),d])):s.A.CB&&1c!==ZC.1d(b)?(m=s.A.A.A7[s.A.L-1])&&m.S[s.L]&&B.1i([ZC.1l(s.iX),m.S[s.L].iY+n]):(B.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX+u.A9/2),d]));1p;1j"4V":if(1c!==ZC.1d(s.A.D4)&&(v=s.A.D4),1c!==ZC.1d(s.A.AG)&&(B=s.A.AG),s.A.D4=[],s.A.AG=[],1c!==ZC.1d(s.A.D)&&(g=s.A.D),s.A.D=[],h[s.L+1]){1a y=[],L=[];1k(r=-1;r<3;r++)h[s.L+r]?(s.A.FO(s.L+r,2).2E(),Z?(y.1i(h[s.L+r].iX),L.1i(h[s.L+r].iY)):(y.1i(h[s.L+r].iY),L.1i(h[s.L+r].iX))):0===y.1h?Z?(L.1i(s.iY),y.1i(s.iX)):(L.1i(s.iX),y.1i(s.iY)):(y.1i(y[y.1h-1]),L.1i(L[L.1h-1]));1a Y=ZC.2i(L[2]-L[1]),w=ZC.AN.XZ(s.A.Q3,y,Y);if(s.A.UK){1k(0===B.1h&&(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[0][0]*Y),d])),r=0;r<ZC.1l(w.1h/2)+(1===s.N.C6?1:0);r++)w[r]&&(Z?g.1i([w[r][1],s.iY+(u.AR?1:-1)*w[r][0]*Y]):g.1i([s.iX+(u.AR?-1:1)*w[r][0]*Y,w[r][1]]));1k(r=0;r<ZC.1l(w.1h/2)+(1===s.N.HM?1:0);r++)v.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]-n]),B.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]]);1k(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(B[B.1h-1][0]),d]),A=1===s.HM?ZC.CV(2,ZC.1l(w.1h/2)):1,r=ZC.1l(w.1h/2)-1,C=w.1h;r<C;r++)w[r]&&(Z?s.A.D.1i([w[r][1],s.iY+(u.AR?1:-1)*w[r][0]*Y]):s.A.D.1i([s.iX+(u.AR?-1:1)*w[r][0]*Y,w[r][1]]));1k(r=ZC.1l(w.1h/2)-A,C=w.1h;r<C;r++)0===s.A.AG.1h&&(s.A.CB&&1c!==ZC.1d(b)||s.A.AG.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),d])),s.A.AG.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]]),s.A.D4.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]-n])}1t{1k(0===B.1h&&(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[0][0]*Y),d])),r=0;r<w.1h;r++)Z?g.1i([w[r][1],s.iY+(u.AR?1:-1)*w[r][0]*Y]):g.1i([s.iX+(u.AR?-1:1)*w[r][0]*Y,w[r][1]]);1k(r=0;r<w.1h;r++)v.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]-n]),B.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]]);1k(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(B[B.1h-1][0]),d]),A=1===s.HM?ZC.CV(2,ZC.1l(w.1h/2)):1,r=w.1h,C=w.1h;r<C;r++)Z?s.A.D.1i([w[r][1],s.iY+(u.AR?1:-1)*w[r][0]*Y]):s.A.D.1i([s.iX+(u.AR?-1:1)*w[r][0]*Y,w[r][1]]);1k(r=w.1h-A,C=w.1h;r<C;r++)0===s.A.AG.1h&&(s.A.CB&&1c!==ZC.1d(b)||s.A.AG.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),d])),s.A.AG.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]]),s.A.D4.1i([ZC.1l(s.iX+(u.AR?-1:1)*w[r][0]*Y),w[r][1]-n])}}1t B.1h>0&&B.1i([B[B.1h-1][0],d]);1p;1j"es":if(D)1P(s.A.FO(s.L-K,0).2E(),o=ZC.AN.JK(h[s.L-K].iX,h[s.L-K].iY,h[s.L].iX,h[s.L].iY),s.A.SE){2n:v.1i([ZC.1l(o[0])-a,s.iY-n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(o[0])-a,d]),B.1i([ZC.1l(o[0])-a,s.iY+n]),g.1i(Z?[h[s.L-K].iX,o[1]]:[o[0],h[s.L-K].iY]),g.1i(Z?[s.iX,o[1]]:[o[0],s.iY]);1p;1j"fr":v.1i([ZC.1l(h[s.L-K].iX)-a,s.iY-n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(h[s.L-K].iX)-a,d]),B.1i([ZC.1l(h[s.L-K].iX)-a,s.iY+n]),g.1i([h[s.L-K].iX,h[s.L-K].iY]),g.1i([h[s.L-K].iX,s.iY]);1p;1j"9e":v.1i([ZC.1l(s.iX)-a,s.iY-n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(s.iX)-a,d]),B.1i([ZC.1l(s.iX)-a,s.iY+n])}1t u.EC||s.L!==u.X?s.A.CB&&1c!==ZC.1d(b)?(m=s.A.A.A7[s.A.L-1])&&m.S[s.L]&&B.1i([ZC.1l(s.iX),m.S[s.L].iY+n]):(B.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX-u.A9/2),d]),v.1i([ZC.1l(s.iX),d])):u.AR?(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.I-u.BV-f),d]),B.1i([ZC.1l(u.iX+u.I-u.BV-f),s.iY+n])):(s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.A6+f),d]),B.1i([ZC.1l(u.iX+u.A6+f),s.iY+n]));if(v.1i([ZC.1l(s.iX),s.iY-n]),B.1i([ZC.1l(s.iX),s.iY+n]),g.1i([s.iX,s.iY]),I)1P(s.A.FO(s.L+F,2).2E(),o=ZC.AN.JK(h[s.L].iX,h[s.L].iY,h[s.L+F].iX,h[s.L+F].iY,s.N.C6),s.A.SE){2n:v.1i([ZC.1l(o[0]),s.iY-n]),B.1i([ZC.1l(o[0]),s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(o[0]),d]),g.1i(Z?[s.iX,o[1]]:[o[0],s.iY]);1p;1j"fr":v.1i([ZC.1l(s.iX),s.iY-n]),B.1i([ZC.1l(s.iX),s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(s.iX),d]);1p;1j"9e":v.1i([ZC.1l(h[s.L+F].iX),s.iY-n]),B.1i([ZC.1l(h[s.L+F].iX),s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(h[s.L+F].iX),d]),g.1i([h[s.L+F].iX,s.iY]),g.1i([h[s.L+F].iX,h[s.L+F].iY])}1t s.L===u.A1?u.AR?(B.1i([u.iX+u.A6-f,s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.A6-f),d])):(B.1i([u.iX+u.I-u.BV-f,s.iY+n]),s.A.CB&&1c!==ZC.1d(b)||B.1i([ZC.1l(u.iX+u.I-u.BV-f),d])):s.A.CB&&1c!==ZC.1d(b)?(m=s.A.A.A7[s.A.L-1])&&m.S[s.L]&&B.1i([ZC.1l(s.iX),m.S[s.L].iY+n]):(B.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX),d]),v.1i([ZC.1l(s.iX+u.A9/2),d]))}if(s.A.CB&&1c!==ZC.1d(b))1k(r=b.1h-1;r>=0;r--)B.1i(b[r]);if(s.bQ({2S:g,9U:B}),"9i"!==s.C.M7&&(s.A.UY=s.A.UY.4w(g)),1c===ZC.1d(s.A.A.EZ)&&(s.A.A.EZ=[]),s.A.A.EZ[s.L]=v,!e&&!s.C.AJ["3d"]){1a M=s.N=s.A.I1(s,s.N),H=s.C.K+ZC.1b[34]+s.C.K+ZC.1b[35]+s.A.L+ZC.1b[6];M.DJ=H,M.K=s.K,s.A.IA&&s.H9(M);1a N,S=s.C.Q;if(0!==s.A.E4.1h||s.A.IA||1w s.A.lb===ZC.1b[31]||s.N.o.7c||s.C.KM?((N=1n ZC.DS(s.A)).1Q(M),N.C6=s.A.HM):N=s.A.lb,s.H9(N),N.C6=ZC.1W(N.o["2k-1M"]||"1"),N.CX=!1,N.L1=!0,N.AY=0,N.AQ=0,N.EW=0,N.G4=0,N.Z=s.A.CL("bl",s.C.CB?0:1),N.D=B,N.CY=[S.iX,S.iY,S.iX+S.I,S.iY+S.F],1c!==ZC.1d(i=s.A.E["2h-y"])&&(N.E["jn-1"]=i,N.CY[1]=i),1c!==ZC.1d(i=s.A.E["1V-y"])&&(N.E["jn-3"]=i,N.CY[3]=i),N.K=s.K+"-1M",s.A.GA||(N.E.sc=!0),ZC.CN.2E(c,M),s.9A(M,g,B),s.A.GA&&!s.C.HC){1a O=1n ZC.DS(s),P={};O.1Q(M),O.K=s.K,O.Z=s.A.CL("bl",2),O.C5=s.A.CL("bl",1),O.D=g;1a k=N,G={},z=[],T=[];O.D=g,P.2S=g,k.D=B,G.2S=B;1a J=s.A.L6,Q=s.C.Q;O.C6=0,P.2k=M.C6,k.C6=0,G.2k=s.A.HM;1a W=1f(e){1k(1a t=e?B:g,i=e?T:z,n=0;n<t.1h;n++)2===J?i[n]=[t[n][0],Q.iY+s.C.Q.F/2]:3===J?i[n]=[t[n][0],Q.iY-5]:4===J?i[n]=[t[n][0],Q.iY+Q.F+5]:5===J?i[n]=[Q.iX-5,t[n][1]]:6===J?i[n]=[Q.iX+Q.I+5,t[n][1]]:7===J?i[n]=[Q.iX+Q.I/2,t[n][1]]:8===J?i[n]=[t[n][0]-Q.I,t[n][1]]:9===J?i[n]=[t[n][0]+Q.I,t[n][1]]:10===J?i[n]=[t[n][0],t[n][1]-Q.F]:11===J?i[n]=[t[n][0],t[n][1]+Q.F]:12===J?i[n]=[(t[0][0]+t[t.1h-1][0])/2,t[0][1]]:13===J&&(i[n]=[t[0][0],(t[0][1]+t[t.1h-1][1])/2]),J>1&&(e?(k.D=T,G.2S=B):(O.D=z,P.2S=g))};W(),W(!0);1a R;1k(R in s.A.FR)O[ZC.E8.GI[ZC.EB(R)]]=s.A.FR[R],P[ZC.EB(R)]=M[ZC.E8.GI[ZC.EB(R)]],k[ZC.E8.GI[ZC.EB(R)]]=s.A.FR[R],G[ZC.EB(R)]=M[ZC.E8.GI[ZC.EB(R)]];if(1c===ZC.1d(s.C.EN)&&(s.C.EN={}),1c===ZC.1d(s.C.SN)&&(s.C.SN={}),1c!==ZC.1d(s.C.EN[s.A.L+"-"+s.L])){1k(R in s.C.EN[s.A.L+"-"+s.L])O[ZC.E8.GI[ZC.EB(R)]]=s.C.EN[s.A.L+"-"+s.L][R];1k(R in s.C.SN[s.A.L+"-"+s.L])k[ZC.E8.GI[ZC.EB(R)]]=s.C.SN[s.A.L+"-"+s.L][R]}s.C.EN[s.A.L+"-"+s.L]={},ZC.2A(P,s.C.EN[s.A.L+"-"+s.L]),s.C.SN[s.A.L+"-"+s.L]={},ZC.2A(G,s.C.SN[s.A.L+"-"+s.L]);1a V=1n ZC.E8(O,P,s.A.J9,s.A.L2,ZC.E8.RJ[s.A.L4],1f(){t()});V.AV=s,V.O8=1f(){s.N0(ZC.P.E6(s.A.CL("bl",1),s.H.AB))},V.IC=c;1a U=1n ZC.E8(k,G,s.A.J9,s.A.L2,ZC.E8.RJ[s.A.L4],1f(){});U.AV=s,s.LL(V,U)}1t N.1v(),0!==s.A.E4.1h||1w s.A.lb!==ZC.1b[31]||s.N.o.7c||s.C.KM||s.C.HC||(s.A.lb=N),ZC.CN.1v(c,M,g),t()}}},9A:1f(e,t,i){1a n=1g;if(n.C.BI&&n.C.BI.HS&&n.A.RH){1a a,l=n.C.Q,o=n.C.BI,r=n.A.az(i),C=1n ZC.DS(n.A);C.1Q(e),C.CX=!0,C.L1=!0,C.AY=0,C.AQ=0,C.EW=0,C.G4=0,C.C6=n.A.HM,C.CY=[l.iX,l.iY,l.iX+l.I,l.iY+l.F],C.K=n.K+"-1M-2w",C.DJ=n.A.K+"-2w",C.Z=o.Z;1a A=n.A.o["2w-3U"];A&&(1c!==ZC.1d(A["2k-1M"])?(a=A.2k,A.2k=A["2k-1M"]):A.2k=C.C6,C.1C(A),C.1q(),1c!==ZC.1d(a)?A.2k=a:4o A.2k),C.D=r,C.1v();1a s,Z=n.A.az(t);n.A.VH?s=n.A.VH:(s=1n ZC.CZ(n),n.A.VH=s),s.1Q(e),s.K=n.K+"-1y-2w",s.DJ=n.A.K+"-2w";1a c=ZC.P.E6(o.Z,n.H.AB);s.AY=1,A&&(s.1C(A),s.1q()),ZC.CN.1v(c,s,Z,1c,3)}},6e:1f(e){1a t=1g;ZC.3l||(t.A.OK||t.M2({6r:e,1I:"1M",92:1f(){1g.A0=t.A.BO[2],1g.AC=t.A.BO[2],1g.D=t.5J("9U")||[]},d1:1f(){1g.AY=0,1g.AQ=0,1g.C6=t.A.HM;1a e=t.C.Q;1g.CY=[e.iX,e.iY,e.iX+e.I,e.iY+e.F]}}),t.j4(e),t.A.QX&&t.TD(e))}}),ZC.Z6=ZC.M5.C7({2E:1f(){1g.SU()},UX:1f(){1a e=1g;e.1v(!0);1a t=e.C.BL(e.A.BT("v")[0]);1m[e.iX+e.I/2,e.iY+(t.AR?e.F:0),{cB:e,3E:!0}]},7n:1f(e){1a t=1g,i="1u-4R",n=t.C.BL(t.A.BT("v")[0]),a=t.AE>=n.GZ&&!n.AR||t.AE<n.GZ&&n.AR?1:-1;e=t.Cn(e),1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]);1a l=e.I,o=e.F,r=t.iX+t.I/2-l/2,C=t.c4-o/2,A=e.AA%180==90,s=A?l/2:o/2,Z=A?l/2-o/2:0;1P(i){1j"1u-4R":1j"1u":C-=a*(s+5);1p;1j"1u-in":C+=a*(s+5);1p;1j"6o":C+=a*(t.F/2);1p;1j"2a-in":C+=a*(t.F-s-5);1p;1j"2a-4R":1j"2a":C+=a*(t.F+o/2+5)}if(1c!==ZC.1d(e.o.x)||1c!==ZC.1d(e.o.y))1c!==ZC.1d(e.o.x)&&(r=e.iX),1c!==ZC.1d(e.o.y)&&(C=e.iY);1t{1a c=ZC.7O(t.A.o.a1,5);if(!ZC.AN.bS(t,t.C.Q,c))1m[-1,-1]}1a u=e.o.a1||[t.C.Q.E2,t.C.Q.E3,t.C.Q.DN,t.C.Q.DZ];1m t.C.AJ["3d"]||(r=ZC.BN(t.C.Q.iX+0-u[3],r),r=ZC.CV(t.C.Q.iX+t.C.Q.I-l-0+u[1],r),C-Z<t.C.Q.iY+5-u[0]&&(C=t.C.Q.iY+5-u[0]+Z),C+Z>t.C.Q.iY+t.C.Q.F-o-5+u[2]&&(C=t.C.Q.iY+t.C.Q.F-o-5+u[2]-Z)),[ZC.1l(r),ZC.1l(C)]},aj:1f(){1a e=1g.b();1m 1g.ef(e,"18a","I"),e},1v:1f(e){1a t,i=1g;if(i.b(),!i.C.AJ["3d"]){1w e===ZC.1b[31]&&(e=!1);1a n=i.A.B0,a=i.A.CI;i.2E();1a l=a.GZ,o=a.B2(l),r=i.A.QE(),C=r.A9,A=r.ER,s=r.CC,Z=r.CO,c=r.F0,u=r.D1,p=r.EX;e?A=i.A.E["2o-"+i.L+"-2Q-2V"]:i.A.E["2o-"+i.L+"-2Q-2V"]=r.ER;1a h,1b,d,f,g;if(i.A.CB){h=0;1k(1a B=i.A.A.K6[A],v=0;v<B.1h;v++){1a b=i.A.A.A7[B[v]].S[i.L];b&&(h+=b.AE)}}1a E=1,m=1;if(i.A.CB&&(i.CM!==i.AE&&(E=(h-i.CM+i.AE)/h),m=(h-i.CM)/h),a.AR){1a K=E;E=m,m=K}i.A.LN&&(A=i.L);1a F=i.iX-C/2+s+A*(u+c)-A*p;if(F=ZC.5m(F,i.iX-C/2+s,i.iX+C/2-Z),i.A.D1>0){1a D=u;(u=i.A.D1)<=1&&(u*=D),F+=(D-u)/2}1a I=u,X=i.iY,x=1c!==ZC.1d(i.A.LU[i.L])?i.A.LU[i.L]:0;if(X=i.A.CB&&"100%"===i.A.KO?a.B2(100*(i.CM+x)/i.A.A.F3[i.L]["%6i-"+i.A.DV]):a.B2(i.CM+x),i.A.CB){1b="100%"===i.A.KO?a.B2(100*(i.CM-i.AE+x)/i.A.A.F3[i.L]["%6i-"+i.A.DV]):a.B2(i.CM-i.AE+x),X=ZC.1l(X),1b=ZC.1l(1b);1a y=!a.AR&&i.AE>=0||a.AR&&i.AE<=0?-1:1,L=0,Y=0;""!==i.A.PS?(L=i.WC(i.A.PS)[0],Y=0):L=i.A.AQ,""!==i.A.NK?(Y=i.WC(i.A.NK)[0],L=0):Y=i.A.AQ,L!==Y&&(y=0),d=X-1b+y*L,i.AE<0&&(X=1b),a.AR?d>0&&(d=ZC.2i(d),X=1b):d<0&&(d=ZC.2i(d),X=1b-d),a.AR&&i.AE<0&&(d+=Y)}1t 1b=a.B2(x),(d=X-1b)<0?(d=ZC.2i(d),X=1b-d):X=1b;if(i.A.TO&&i.A.CB&&i.A.L>0&&i.A.A.A7[i.A.L-1].S[i.L]&&0===i.A.A.A7[i.A.L-1].S[i.L].AE&&(d-=1,X+=a.AR?1:-1),d<2&&(i.AE>0||i.A.TO)&&(d=1,a.AR?i.A.CB&&i.A.L>0&&(X-=1):i.A.CB?0===i.A.L&&(X-=1):X=x?1b-1:o-2),i.I=I,i.F=d,i.iX=F,i.iY=X,a.AR?i.AE>=a.GZ?i.c4=X+i.F:i.c4=X:i.AE>=a.GZ?i.c4=X:i.c4=X+i.F,i.C.D0){1a w="6o";i.C.D0.o.1O&&1c!==ZC.1d(t=i.C.D0.o.1O.gG)&&(w=t),1c!==ZC.1d(i.A.o["2g-1O"])&&1c!==ZC.1d(t=i.A.o["2g-1O"].gG)&&(w=t),"2o"===w&&(i.E.hu=i.iX+i.I/2)}if(!e){i.bQ({x:F,y:X,w:I,h:d});1a M,H=!0;if("1Z"!==i.A.IV||i.C.JZ[i.A.L]||i.C.KM||i.A.SQ&&i.A.SQ[i.L]?(M=i.N=i.A.I1(i,i.N),H=!1):M=i.N,(0!==i.A.E4.1h||i.A.IA||i.N.o.7c||i.C.KM)&&(H=!1),i.AL){1a N;1P(i.A.CS){2n:0!==i.A.E4.1h||i.A.IA||1w i.A.VB===ZC.1b[31]||i.N.o.7c||i.C.KM?(N=1n ZC.HQ(i.A)).1Q(M):N=i.A.VB,i.A.IA&&(i.H9(N),N.1q()),N.F9=i.A.F9,N.K=i.K,N.iX=F,N.iY=X,N.I=i.I,N.F=i.F,n.A9<5&&N.I<5?(N.I=ZC.BN(1,N.I)+1,N.OG=!1,N.CX=!1):(N.OG=!0,N.CX=!0),N.I<5&&n.A1!==n.X&&i.C.Q.I/(n.A1-n.X)<1&&(N.QQ=!0);1p;1j"b9":1j"fz":0!==i.A.E4.1h||i.A.IA||1w i.A.VB===ZC.1b[31]||i.N.o.7c||i.C.KM?(N=1n ZC.DS(i.A)).1Q(M):N=i.A.VB,i.A.IA&&(i.H9(N),N.1q()),N.K=i.K,a.AR&&!i.A.CB?(g=i.AE>=0?0:i.F,f=i.AE>=0?i.F:0):(g=i.AE>=0?i.F:0,f=i.AE>=0?0:i.F),N.D=[],N.D.1i([F+i.I/2-E*i.I/2,X+g],[F+i.I/2+E*i.I/2,X+g]),i.A.CB&&0!==m?N.D.1i([F+i.I/2+m*i.I/2,X+f],[F+i.I/2-m*i.I/2,X+f]):N.D.1i([F+i.I/2,X+f]),N.D.1i([N.D[0][0],N.D[0][1]]),i.bQ({2S:N.D}),N.iX=F,N.iY=X,N.9p(2)}N.Z=i.A.CL("bl",1),N.C5=i.A.CL("bl",0),i.9A(M,H);1a S=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6];N.DJ=S;1a O=ZC.7O(i.A.o.a1,5),P=1f(){if(1w i.6E!==ZC.1b[31]&&i.6E(),i.N0(ZC.P.E6(N.Z,i.H.AB)),ZC.AN.bS(i,i.C.Q,O)&&i.A.FT&&-1===ZC.AT(i.H.KL,ZC.1b[39])){1a e=I<5?.5:-.5,t=d<3?.5:-.5,n=ZC.P.GC("5t",i.A.E5,N.IM)+\'3g="\'+S+\'" id="\'+i.K+ZC.1b[30]+ZC.1l(F+i.A.BJ+ZC.3y-e)+","+ZC.1l(X+i.A.BD+ZC.3y-t)+","+ZC.1l(F+i.A.BJ+I+ZC.3y+e)+","+ZC.1l(X+i.A.BD+d+ZC.3y+t)+\'" />\';i.A.A.HK.1i(n)}i.A.U&&i.A.U.AL&&i.H5()};if(i.A.GA&&!i.C.HC){1a k=N,G={};k.iX=F,k.iY=X,k.I=I,k.F=d,G.x=F,G.y=X,G.1s=I,G.1L=d;1a z=i.A.L6,T=i.C.Q;k.C6=0,G.2k=M.C6,2===z?(k.iY=T.iY+T.F/2,k.F=1,G.1L=i.F,G.y=X):3===z?(k.iY=T.iY,k.F=1,G.1L=i.F,G.y=X):4===z?(k.iY=T.iY+T.F,k.F=1,G.1L=i.F,G.y=X):5===z?(k.iX=T.iX,k.I=1,G.1s=i.I,G.x=F):6===z?(k.iX=T.iX+T.I,k.I=1,G.1s=i.I,G.x=F):7===z?(k.iX=T.iX+T.I/2,k.I=1,G.1s=i.I,G.x=F):8===z?(k.iX=F-T.I,G.x=F):9===z?(k.iX=F+T.I,G.x=F):10===z?(k.iY=X-T.F,G.y=X):11===z?(k.iY=X+T.F,G.y=X):12===z?(k.I=1,G.1s=i.I):13===z&&(k.F=1,G.1L=i.F);1a J;1k(J in i.A.FR)k[ZC.E8.GI[ZC.EB(J)]]=i.A.FR[J],G[ZC.EB(J)]=M[ZC.E8.GI[ZC.EB(J)]];if(1c===ZC.1d(i.C.EN)&&(i.C.EN={}),1c!==ZC.1d(i.C.EN[i.A.L+"-"+i.L]))1k(J in i.C.EN[i.A.L+"-"+i.L])k[ZC.E8.GI[ZC.EB(J)]]=i.C.EN[i.A.L+"-"+i.L][J];if(i.C.EN[i.A.L+"-"+i.L]={},ZC.2A(G,i.C.EN[i.A.L+"-"+i.L]),ZC.AN.bS(i,i.C.Q,O)){1a Q=1n ZC.E8(k,G,i.A.J9,i.A.L2,ZC.E8.RJ[i.A.L4],1f(){P()});Q.AV=i,Q.O8=1f(){i.N0(ZC.P.E6(N.Z,i.H.AB))},i.LL(Q)}}1t{if(N.AL||0===i.A.E4.1h&&!i.A.IA)if(i.A.W0||(i.A.W0={iX:N.iX,iY:N.iY,F:N.F}),i.A.kQ)if(i.A.S3)if(i.A.S3.el&&"187"===i.A.S3.el.8h.5D()){1a W=!1;if(i.A.Q6&&i.A.W0&&ZC.2i(N.iX-i.A.W0.iX)<.75&&ZC.2i(N.iY-i.A.W0.iY)<1.5&&ZC.2i(N.F-i.A.W0.F)<1.5&&(W=!0),!W){i.A.W0={iX:N.iX,iY:N.iY,F:N.F};1a R=i.A.S3.el.kP(!1);R.4l("id",i.K),R.4l("x",i.iX),R.4l("y",i.iY),R.4l(ZC.1b[20],i.F),i.A.S3.df?i.H.FW[N.Z.id].2X(R):i.A.S3.el.6s.2X(R)}}1t N.1v();1t N.1v(),i.A.S3={id:N.K+"-2M"},1o.3G.kw&&2e.eB&&i.H.FW&&i.H.FW[N.Z.id]?(i.A.S3.df=!0,i.A.S3.el=i.H.FW[N.Z.id].eB("#"+N.K+"-2M")):(i.A.S3.df=!1,i.A.S3.el=ZC.AK(i.A.S3.id));1t ZC.AN.bS(i,i.C.Q,O)&&N.1v();N.AL&&P()}"2B"===i.H.AB&&i.A.kC(i.A,i.K+"-2M",i.MK()),0!==i.A.E4.1h||i.A.IA||1w i.A.VB!==ZC.1b[31]||i.N.o.7c||i.C.KM||i.A.GA||(i.A.VB=N)}}}},9A:1f(e,t){1a i,n,a=1g;if(a.C.BI&&a.C.BI.HS&&a.A.RH){1a l=a.C.Q,o=a.C.BI,r=o.B4,C=(a.iX-l.iX)/l.I,A=(a.iY-l.iY)/l.F;a.A.s5?i=a.A.s5:(i=1n ZC.HQ(a.A),a.A.s5=i,i.1Q(e),(n=a.A.o["2w-3U"])&&(i.1C(n),i.1q())),t||(i.1Q(e),(n=a.A.o["2w-3U"])&&(i.1C(n),i.1q())),i.K=a.K+"-2w",i.DJ=a.A.K+"-2w",i.iX=r.iX+r.AQ+C*(r.I-2*r.AQ),i.iY=r.iY+r.AQ+A*(r.F-2*r.AQ),i.I=a.I/l.I*(r.I-2*r.AQ),i.F=a.F/l.F*(r.F-2*r.AQ),r.I/a.A.S.1h<10?(i.I=i.I+.5,i.OG=!1,i.CX=!1):(i.OG=!0,i.CX=!0),i.Z=i.C5=o.Z,i.1v()}},6e:1f(e){1a t=1g;if(e=e||"2J",!ZC.3l){1a i="";1P(t.A.CS){2n:i="3B";1p;1j"b9":i="2P"}t.M2({6r:e,1I:i,92:1f(){1g.A0=t.A.BO[3],1g.B6=t.A.BO[1],1g.BU=t.A.BO[1],1g.AC=t.A.BO[2]},d1:1f(){1P(t.A.CS){2n:1g.iX=t.5J("x"),1g.iY=t.5J("y"),1g.I=t.5J("w"),1g.F=t.5J("h");1a e=t.C.Q;1g.iY<e.iY&&(1g.F=1g.F-(e.iY-1g.iY),1g.iY=e.iY),1g.iY+1g.F>e.iY+e.F&&(1g.F=e.iY+e.F-1g.iY);1p;1j"b9":1j"fz":1g.D=t.5J("2S")}}}),t.N0(ZC.P.E6(t.C.K+ZC.1b[22],t.H.AB),!0),t.A.RB=1c}}}),ZC.Z9=ZC.M5.C7({2E:1f(){1g.SU()},UX:1f(){1a e=1g;e.1v(!0);1a t=e.C.BL(e.A.BT("v")[0]);1m[e.iX+(t.AR?0:e.I),e.iY+e.F/2,{cB:e,3E:!0}]},7n:1f(e){1a t=1g,i="1u-4R",n=t.C.BL(t.A.BT("v")[0]),a=t.AE>=n.GZ&&!n.AR||t.AE<n.GZ&&n.AR?-1:1;1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]);1a l=e.I,o=e.F,r=t.c2-l/2,C=t.iY+t.F/2-o/2,A=e.AA%180==90?o/2:l/2;1P(i){1j"1u-4R":1j"1u":r-=a*(A+5);1p;1j"1u-in":r+=a*(A+5);1p;1j"6o":r+=a*(t.I/2);1p;1j"2a-in":r+=a*(t.I-A-5);1p;1j"2a-4R":1j"2a":r+=a*(t.I+A+5)}if(1c!==ZC.1d(e.o.x)||1c!==ZC.1d(e.o.y))1c!==ZC.1d(e.o.x)&&(r=e.iX),1c!==ZC.1d(e.o.y)&&(C=e.iY);1t{1a s=ZC.7O(t.A.o.a1,5);if(!ZC.AN.bS(t,t.C.Q,s))1m[-1,-1]}1a Z=e.o.a1||[t.C.Q.E2,t.C.Q.E3,t.C.Q.DN,t.C.Q.DZ];1m t.C.AJ["3d"]||(r=ZC.BN(t.C.Q.iX+5-Z[3],r),r=ZC.CV(t.C.Q.iX+t.C.Q.I-l-5+Z[1],r),C=ZC.BN(t.C.Q.iY+0-Z[0],C),C=ZC.CV(t.C.Q.iY+t.C.Q.F-o/2-0+Z[2],C)),[ZC.1l(r),ZC.1l(C)]},1v:1f(e){1a t=1g;if(t.b(),!t.C.AJ["3d"]){1w e===ZC.1b[31]&&(e=!1);1a i=t.A.B0,n=t.A.CI;t.2E();1a a=t.A.QE(),l=a.A9,o=a.ER,r=a.CC,C=a.CO,A=a.F0,s=a.D1,Z=a.EX;e?o=t.A.E["2o-"+t.L+"-2Q-2V"]:t.A.E["2o-"+t.L+"-2Q-2V"]=a.ER;1a c,u,p,h,1b;if(t.A.CB){c=0;1k(1a d=t.A.A.K6[o],f=0;f<d.1h;f++){1a g=t.A.A.A7[d[f]].S[t.L];g&&(c+=g.AE)}}1a B=1,v=1;if(t.A.CB&&(t.CM!==t.AE&&(B=(c-t.CM+t.AE)/c),v=(c-t.CM)/c),n.AR){1a b=B;B=v,v=b}t.A.LN&&(o=t.L);1a E=t.iY-l/2+r+o*(s+A)-o*Z;if(E=ZC.5m(E,t.iY-l/2+r,t.iY+l/2-C),t.A.D1>0){1a m=s;(s=t.A.D1)<=1&&(s*=m),E+=(m-s)/2}1a K=s,F=t.iX,D=1c!==ZC.1d(t.A.LU[t.L])?t.A.LU[t.L]:0;if(F=t.A.CB&&"100%"===t.A.KO?n.B2(100*(t.CM+D)/t.A.A.F3[t.L]["%6i-"+t.A.DV]):n.B2(t.CM+D),t.A.CB){u="100%"===t.A.KO?n.B2(100*(t.CM-t.AE+D)/t.A.A.F3[t.L]["%6i-"+t.A.DV]):n.B2(t.CM-t.AE+D),F=ZC.1l(F),u=ZC.1l(u);1a I=!n.AR&&t.AE>=0||n.AR&&t.AE<=0?1:-1,X=0,x=0;""!==t.A.OA?(X=t.WC(t.A.OA)[0],x=0):X=t.A.AQ,""!==t.A.P4?(x=t.WC(t.A.P4)[0],X=0):x=t.A.AQ,X!==x&&(I=0),p=F-u+I*X,t.AE>0?F=u:p=ZC.2i(p),n.AR?p>0?(p=ZC.2i(p),F=u):(p=ZC.2i(p),F-=p):p<0&&(p=ZC.2i(p),F=u-p)}1t u=n.B2(D),(p=F-u)<0?(p=ZC.2i(p),F=u-p):F=u;if(t.A.TO&&t.A.CB&&t.A.L>0&&t.A.A.A7[t.A.L-1].S[t.L]&&0===t.A.A.A7[t.A.L-1].S[t.L].AE&&(p-=1,F+=n.AR?-1:1),p<1&&(t.AE>0||t.A.TO)&&(p=1,n.AR?t.A.CB?0===t.A.L&&(F-=1):F-=2:t.A.L>0&&t.A.CB&&(F-=1)),t.I=p,t.F=K,t.iX=F,t.iY=E,n.AR?t.AE>=n.GZ?t.c2=F:t.c2=F+t.I:t.AE>=n.GZ?t.c2=F+t.I:t.c2=F,!e){t.bQ({x:F,y:E,w:p,h:K});1a y;if(y="1Z"!==t.A.IV||t.C.JZ[t.A.L]||t.C.KM||t.A.SQ&&t.A.SQ[t.L]?t.N=t.A.I1(t,t.N):t.N,t.AL){1a L;1P(t.A.CS){2n:0!==t.A.E4.1h||t.A.IA||1w t.A.VB===ZC.1b[31]||t.N.o.7c||t.C.KM?(L=1n ZC.HQ(t.A)).1Q(y):L=t.A.VB,t.A.IA&&(t.H9(L),L.1q()),L.F9=t.A.F9,L.K=t.K,L.iX=F,L.iY=E,L.I=t.I,L.F=t.F,i.A9<5&&L.F<5?(L.F=ZC.BN(1,L.F)+1,L.OG=!1,L.CX=!1):(L.OG=!0,L.CX=!0),L.F<5&&i.A1!==i.X&&t.C.Q.F/(i.A1-i.X)<1&&(L.QQ=!0);1p;1j"b9":1j"fz":0!==t.A.E4.1h||t.A.IA||1w t.A.VB===ZC.1b[31]||t.N.o.7c||t.C.KM?(L=1n ZC.DS(t.A)).1Q(y):L=t.A.VB,t.A.IA&&(t.H9(L),L.1q()),L.K=t.K,n.AR&&!t.A.CB?(1b=t.AE>=0?t.I:0,h=t.AE>=0?0:t.I):(1b=t.AE>=0?0:t.I,h=t.AE>=0?t.I:0),L.D=[],L.D.1i([F+1b,E+t.F/2-B*t.F/2],[F+1b,E+t.F/2+B*t.F/2]),t.A.CB&&0!==v?L.D.1i([F+h,E+t.F/2+v*t.F/2],[F+h,E+t.F/2-v*t.F/2]):L.D.1i([F+h,E+t.F/2]),L.D.1i([L.D[0][0],L.D[0][1]]),t.E.2S=L.D,L.iX=F,L.iY=E,L.9p(2)}L.Z=t.A.CL("bl",1),L.C5=t.A.CL("bl",0);1a Y=t.C.K+ZC.1b[34]+t.C.K+ZC.1b[35]+t.A.L+ZC.1b[6];L.DJ=Y;1a w=ZC.7O(t.A.o.a1,5),M=1f(){if(1w t.6E!==ZC.1b[31]&&t.6E(),t.N0(ZC.P.E6(L.Z,t.H.AB)),ZC.AN.bS(t,t.C.Q,w)&&t.A.FT&&-1===ZC.AT(t.H.KL,ZC.1b[39])){1a e=p<3?.5:-.5,i=K<5?.5:-.5,n=ZC.P.GC("5t",t.A.E5,L.IM)+\'3g="\'+Y+\'" id="\'+t.K+ZC.1b[30]+ZC.1l(F+t.A.BJ+ZC.3y-e)+","+ZC.1l(E+t.A.BD+ZC.3y-i)+","+ZC.1l(F+t.A.BJ+p+ZC.3y+e)+","+ZC.1l(E+t.A.BD+K+ZC.3y+i)+\'" />\';t.A.A.HK.1i(n)}t.A.U&&t.A.U.AL&&t.H5()};if(t.A.GA&&!t.C.HC){1a H=L,N={};H.iX=F,H.iY=E,H.I=p,H.F=K,N.x=F,N.y=E,N.1s=p,N.1L=K;1a S=t.A.L6,O=t.C.Q;H.C6=0,N.2k=y.C6,2===S?(H.iX=O.iX+O.I/2,H.I=1,N.1s=t.I,N.x=F):3===S?(H.iX=O.iX+O.I,H.I=1,N.1s=t.I,N.x=F):4===S?(H.iX=O.iX,H.I=1,N.1s=t.I,N.x=F):5===S?(H.iY=O.iY+O.F,H.F=1,N.1L=t.F,N.y=E):6===S?(H.iY=O.iY,H.F=1,N.1L=t.F,N.y=E):7===S?(H.iY=O.iY+O.F/2,H.F=1,N.1L=t.F,N.y=E):8===S?(H.iY=E+O.F,N.y=E):9===S?(H.iY=E-O.F,N.y=E):10===S?(H.iX=F+O.I,N.x=F):11===S?(H.iX=F-O.I,N.x=F):12===S?(H.F=1,N.1L=t.F):13===S&&(H.I=1,N.1s=t.I);1a P;1k(P in t.A.FR)H[ZC.E8.GI[ZC.EB(P)]]=t.A.FR[P],N[ZC.EB(P)]=t.N[ZC.E8.GI[ZC.EB(P)]];if(1c===ZC.1d(t.C.EN)&&(t.C.EN={}),1c!==ZC.1d(t.C.EN[t.A.L+"-"+t.L]))1k(P in t.C.EN[t.A.L+"-"+t.L])H[ZC.E8.GI[ZC.EB(P)]]=t.C.EN[t.A.L+"-"+t.L][P];if(t.C.EN[t.A.L+"-"+t.L]={},ZC.2A(N,t.C.EN[t.A.L+"-"+t.L]),ZC.AN.bS(t,t.C.Q,w)){1a k=1n ZC.E8(H,N,t.A.J9,t.A.L2,ZC.E8.RJ[t.A.L4],1f(){M()});k.AV=t,k.O8=1f(){t.N0(ZC.P.E6(L.Z,t.H.AB))},t.LL(k)}}1t(L.AL||0===t.A.E4.1h&&!t.A.IA)&&ZC.AN.bS(t,t.C.Q,w)&&L.1v(),L.AL&&M();"2B"===t.H.AB&&t.A.kC(t.A,t.K+"-2M",t.MK()),0!==t.A.E4.1h||t.A.IA||1w t.A.VB!==ZC.1b[31]||t.N.o.7c||t.C.KM||t.A.GA||(t.A.VB=L)}}}},6e:1f(e){1a t=1g;if(!ZC.3l){1a i="";1P(t.A.CS){2n:i="3B";1p;1j"b9":i="2P"}t.M2({6r:e,1I:i,92:1f(){1g.B6=t.A.BO[1],1g.BU=t.A.BO[1],1g.A0=t.A.BO[3],1g.AC=t.A.BO[2]},d1:1f(){1P(t.A.CS){2n:1g.iX=t.5J("x"),1g.iY=t.5J("y"),1g.I=t.5J("w"),1g.F=t.5J("h");1a e=t.C.Q;1g.iX<e.iX&&(1g.I=1g.I-(e.iX-1g.iX),1g.iX=e.iX),1g.iX+1g.I>e.iX+e.I&&(1g.I=e.iX+e.I-1g.iX);1p;1j"b9":1j"fz":1g.D=t.5J("2S")}}}),t.N0(ZC.P.E6(t.C.K+ZC.1b[22],t.H.AB),!0),t.A.RB=1c}}}),ZC.Bz=ZC.M5.C7({2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];if(e.JH!==n){if("6t"===e.A.AF){if(e.A.LN&&e.A.PU){1a a=ZC.AN.W5(e.A.PU[0],e.A.PU[1]),l=(e.BX-a[0])/(a[1]-a[0]);e.iX=t.I3(e.A.R1)-t.A9/2+e.A.RC+l*(t.A9-2*e.A.RC)}1t e.iX=t.B2(e.BX);e.iY=i.B2(e.AE)}1t e.iY=t.B2(e.BX),e.iX=i.B2(e.AE);e.JH=n}e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},1q:1f(){1g.b(),1g.o[ZC.1b[9]]3z 3K||(1g.BX=1g.L)},82:1f(){1m{1r:"-1"===1g.A.A2.A0?1g.N.A0:1g.A.A2.A0}},cc:1f(e,t){1m 1g.b(e,t,1g.N3.AH)},XP:1f(){1m{"1R-1r":"-1"===1g.A.A2.AC?1g.N.AC:1g.A.A2.AC,"1F-1r":"-1"===1g.A.A2.AC?1g.N.AC:1g.A.A2.AC,1r:1g.N.BZ}},1v:1f(e){1a t=1g;t.b();1a i=t.A.B0,n=t.A.CI;t.2E(),e||(i.D9?ZC.DU(t.iX,n.iX+(n.AR?n.BV:n.A6)-1,n.iX+n.I-(n.AR?n.A6:n.BV)+1)&&ZC.DU(t.iY,i.iY+(i.AR?i.BV:i.A6)-1,i.iY+i.F-(i.AR?i.A6:i.BV)+1)&&t.P6(!1,!0):ZC.DU(t.iX,i.iX+(i.AR?i.BV:i.A6)-1,i.iX+i.I-(i.AR?i.A6:i.BV)+1)&&ZC.DU(t.iY,n.iY+(n.AR?n.A6:n.BV)-1,n.iY+n.F-(n.AR?n.BV:n.A6)+1)&&t.P6(!1,!0))},6e:1f(e){1a t=1g;ZC.3l||t.TD(e)}}),ZC.Bl=ZC.M5.C7({$i:1f(e){1g.b(e),1g.SJ=1c},1q:1f(){1g.b(),1g.o[ZC.1b[9]]3z 3K||(1g.BX=1g.L),1g.o[ZC.1b[9]]3z 3K&&1c!==ZC.1d(1g.o[ZC.1b[9]][2])?1g.SJ=ZC.1W(1g.o[ZC.1b[9]][2]):1g.SJ=2},82:1f(){1m{1r:"-1"===1g.A.A2.A0?1g.N.A0:1g.A.A2.A0}},cc:1f(e,t){1a i=1g,n=i.A.kF(ZC.2i(i.SJ));1m 1g.b(e,t,n)},XP:1f(){1m{"1R-1r":"-1"===1g.A.A2.AC?1g.N.AC:1g.A.A2.AC,"1F-1r":"-1"===1g.A.A2.AC?1g.N.AC:1g.A.A2.AC,1r:1g.N.BZ}},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l);1a o=ZC.AO.GM(a.SJ,l);1m a.CR=[["%v0",a.BX],["%v1",a.AE],["%v2",o],["%2o-2b-1S",o]],e=a.b(e,t,i,n)},2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];if(e.JH!==n){if("5h"===e.A.AF){if(e.A.LN&&e.A.PU){1a a=ZC.AN.W5(e.A.PU[0],e.A.PU[1]),l=(e.BX-a[0])/(a[1]-a[0]);e.iX=t.I3(e.A.R1)-t.A9/2+e.A.RC+l*(t.A9-2*e.A.RC)}1t e.iX=t.B2(e.BX);e.iY=i.B2(e.AE)}1t e.iY=t.B2(e.BX),e.iX=i.B2(e.AE);e.JH=n}e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},7n:1f(e){1a t,i=1g,n="3e";1c!==ZC.1d(t=e.o[ZC.1b[7]])&&(n=t);1a a=e.I,l=e.F,o=i.E["1O.2b"],r=i.iX-a/2,C=i.iY-l/2,A=0,s=0;1P(n){1j"1u":C-=l/2+o,s=i.iY-i.C.Q.iY+o;1p;1j"2a":C+=l/2+o,s=i.C.Q.iY+i.C.Q.F-i.iY+o;1p;1j"1J":r-=a/2+o,A=i.iX-i.C.Q.iX+o;1p;1j"2x":r+=a/2+o,A=i.C.Q.iX+i.C.Q.I-i.iX+o}1m 1c!==ZC.1d(e.o.x)&&(r=e.iX),1c!==ZC.1d(e.o.y)&&(C=e.iY),r<i.C.Q.iX&&(r=i.C.Q.iX+A),r+a>i.C.Q.iX+i.C.Q.I&&(r=i.C.Q.iX+i.C.Q.I-a-A),C<i.C.Q.iY&&(C=i.C.Q.iY+s),C+l>i.C.Q.iY+i.C.Q.F&&(C=i.C.Q.iY+i.C.Q.F-l-s),[ZC.1l(r),ZC.1l(C)]},1v:1f(e){1a t=1g;1w e===ZC.1b[31]&&(e=!1),t.b();1a i=t.A.B0,n=t.A.CI;t.2E(),t.E["1O.2b"]=t.A.kF(ZC.2i(t.SJ)),e||(i.D9?ZC.DU(t.iX,n.iX+(n.AR?n.BV:n.A6)-1,n.iX+n.I-(n.AR?n.A6:n.BV)+1)&&ZC.DU(t.iY,i.iY+(i.AR?i.BV:i.A6)-1,i.iY+i.F-(i.AR?i.A6:i.BV)+1)&&t.P6(!1,!0):ZC.DU(t.iX,i.iX+(i.AR?i.BV:i.A6)-1,i.iX+i.I-(i.AR?i.A6:i.BV)+1)&&ZC.DU(t.iY,n.iY+(n.AR?n.A6:n.BV)-1,n.iY+n.F-(n.AR?n.BV:n.A6)+1)&&t.P6(!1,!0))},6e:1f(e){1a t=1g;ZC.3l||t.TD(e)}}),ZC.Bk=ZC.M5.C7({U:1c,$i:1f(e){1g.b(e)},1q:1f(){1g.b()},iF:1f(){1g.b();1a e=1g,t=e.C.E;t.3O.8o=t.3O["2o-8k-1S"]=e.KC("%8o")},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l),-1===e.1K("%8o")&&-1===e.1K("%2o-8k-1S")||1c!==ZC.1d(l[ZC.1b[12]])&&-1!==l[ZC.1b[12]]||(l[ZC.1b[12]]=1);1a o=0,r="0";if(a.A.A.KF[a.L]>0&&(r=""+(o=100*a.AE/a.A.A.KF[a.L])),a.A.A.A7.1h>1&&a.A.L===a.A.A.A7.1h-1){1a C=0;if(1c===ZC.1d(a.A.o.iD)){1k(1a A=0;A<a.A.A.A7.1h-1;A++)if(a.A.A.A7[A].AL){1a s=0,Z="0";a.A.A.KF[a.L]>0&&(Z=""+(s=100*a.A.A.A7[A].S[a.L].AE/a.A.A.KF[a.L])),1c!==ZC.1d(l[ZC.1b[12]])&&(Z=s.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]])))),C+=ZC.1W(Z)}r=""+(o=1A.1V(0,100-C))}}1c!==ZC.1d(l[ZC.1b[12]])&&(r=o.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]]))));1a c=ZC.1W(a.A.A.KF[a.L]||"0"),u=""+c;1m 1c!==ZC.1d(l[ZC.1b[12]])&&(u=c.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]])))),a.CR=[["%2o-8k-1S",r],["%8o",r],["%3L-6i-1S",u]],e=a.b(e,t,i,n)},cc:1f(e,t){1a i,n,a,l=1g,o=(l.B1+l.BH)/2%2j;1P(t){1j"4R":n=(i=ZC.AN.BM(l.iX,l.iY,l.AH+l.DR+e.DR,o))[0]+l.BJ,a=i[1]+l.BD,o>3T&&o<=2j?a-=e.F:o>90&&o<=180?n-=e.I:o>180&&o<=3T&&(n-=e.I,a-=e.F);1p;1j"3E":n=(i=ZC.AN.BM(l.iX,l.iY,l.CK+.5*(l.AH-l.CK)+l.DR,o))[0]+l.BJ,a=i[1]+l.BD;1p;2n:n=l.iX+l.BJ,a=l.iY+l.BD}1m{x:n,y:a}},UX:1f(e){1a t,i=1g,n=(i.B1+i.BH)/2%2j,a=0;1c!==ZC.1d(t=e["1Y-r"])&&(a=ZC.1W(ZC.8C(t))),a<1&&(a*=i.AH);1a l=ZC.AN.BM(i.iX,i.iY,i.CK+.6*(i.AH-i.CK)+i.DR+a,n);1m[l[0],l[1],{cB:i,3E:!0}]},kK:1f(){1a e=1g,t=(e.B1+e.BH)/2%2j,i=ZC.AN.BM(e.iX,e.iY,e.CK+.5*(e.AH-e.CK)+e.DR,t);1m[i[0],i[1]]},2E:1f(){1a e=1g,t=e.C.BL(e.A.BT("k")[0]),i=e.L%t.GT,n=1A.4i(e.L/t.GT);e.iX=t.iX+i*t.GF+t.GF/2+t.BJ,e.iY=t.iY+n*t.G7+t.G7/2+t.BD,e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},82:1f(e){1a t,i=1g,n={},a="4R";1m 1c!==ZC.1d(t=e.o[ZC.1b[7]])&&(a=t),n.1r="4R"===a?i.A0:i.BZ,n},7n:1f(e){1a t,i=1g,n="4R";1c!==ZC.1d(t=e.o[ZC.1b[7]])&&(n=t);1a a,l,o,r,C,A=e.I,s=e.F,Z=(i.B1+i.BH)/2%2j,c=Z;if("4R"===n){Z=c=i.A.A.Y4["n"+i.L][i.A.L];1a u=1f(t,n){n<0&&(n=2j+n),n%=2j;1a a=(C=ZC.AN.BM(i.iX,i.iY,t+i.DR+e.DR+20,n))[0]+e.BJ-A/2,l=C[1]+e.BD-s/2;1m n>=0&&n<=90||n>=3T&&n<=2j?a+=A/2+10:a-=A/2+10,[a,l]},p=u(i.AH,c);a=p[0],l=p[1],i.U=e;1a h={x:a,y:l,1s:A,1L:s},1b=1o.3G.tN;r=!0;1k(1a d=0,f=0,g=-1,B=0,v=0;r&&v<iv;){r=!1;1k(1a b=0,E=i.A.A.TQ.1h;b<E;b++)o=i.A.A.TQ[b],(ZC.AN.XG(h,o)||h.x+e.I>i.C.Q.iX+i.C.Q.I||h.x<i.C.Q.iX||h.y+e.F>i.C.Q.iY+i.C.Q.F||h.y<i.C.Q.iY)&&(r=!0,0===1b?(d+=.4,g*=-1):1===1b&&(f+=2),p=u(i.AH+f,c+d*g),h.x=p[0],h.y=p[1],v++,++B>100&&(B=0,0===1b?(d=0,f+=2):1===1b&&(f=0,d+=.4,g*=-1)))}a=h.x,l=h.y,Z=c+d,o={1D:i.A.AP,x:h.x,y:h.y,1s:A,1L:s,3S:i.A.L,5Q:i.L},i.A.A.TQ.1i(o)}1t if("in"===n||"8x"===n){1a m=i.CK<30?.65:.5;a=(C=i.B1%2j==i.BH%2j?0===i.CK?[i.iX,i.iY]:ZC.AN.BM(i.iX,i.iY,i.CK+.3*(i.AH-i.CK)+i.DR+e.DR,3T):ZC.AN.BM(i.iX,i.iY,i.CK+m*(i.AH-i.CK)+i.DR+e.DR,Z))[0]-A/2+i.BJ,l=C[1]-s/2+i.BD}1t if(-1!==n.1K("7m=")){1a K=n.2l(/=|;|,/),F=(i.AH+i.CK)/2,D=Z;K[1]&&(F=(F=ZC.IB(K[1],!0))>=-1&&F<=1||-1!==K[1].1K("%")?i.CK+i.DR+F*(i.AH-i.CK):i.CK+i.DR+F),K[2]&&(D=(D=ZC.IB(K[2],!0))>=-1&&D<=1||-1!==K[2].1K("%")?i.B1+D*(i.BH-i.B1):i.B1+D),K[3]&&("+"===K[3].fq(0)||"-"===K[3].fq(0)?(D%=2j,e.AA=D+ZC.1W(K[3]),e.AA>90&&e.AA<3T&&(e.AA+=180)):e.AA=ZC.1W(K[3])),a=(C=ZC.AN.BM(i.iX,i.iY,F,D))[0]-A/2,l=C[1]-s/2}1t"3E"===n&&(a=i.iX-A/2+i.BJ,l=i.iY-s/2+i.BD);1m r&&(a=-6J,l=-6J,e.AL=!1),1c!==ZC.1d(e.o.x)&&(a=e.iX),1c!==ZC.1d(e.o.y)&&(l=e.iY),a>=-2&&(a=ZC.2i(a)),l>=-2&&(l=ZC.2i(l)),[ZC.1l(a),ZC.1l(l),Z]},sC:1f(e){1a t=1g,i={};if("8x"===e.o[ZC.1b[7]]){1a n=.9*ZC.2i(t.AH-t.CK),a=1A.PI*(t.AH+t.CK)*.9*ZC.2i(t.BH-t.B1)/2j,l=ZC.1l(1A.1V(n,a)/(.75*e.DG));if(1c===ZC.1d(e.o.2f)?i.2f=1===t.A.A.A7.1h||a>1.25*e.DG:i.2f=e.JO.2f,1c===ZC.1d(e.o["1V-sB"])&&(i["1V-sB"]=l),1c===ZC.1d(e.o.2c)){1a o=(t.B1+t.BH)/2%2j;t.A.A.A7.1h>1?a>n?o>0&&o<180?o-=90:o+=90:o>90&&o<3T&&(o+=180):o=0,i.2c=o}}1m i},H5:1f(e,t){1a i,n=1g,a=n.b(e,t);if(e)1m a;if(n.AL&&a.AL&&1c!==ZC.1d(a.AP)&&""!==a.AP){1a l="4R";if(1c!==ZC.1d(i=a.o[ZC.1b[7]])&&(l=i),"4R"===l){1a o=!0;if(1c!==ZC.1d(i=a.o.uy)&&(o=ZC.2q(i)),o){1a r=1n ZC.DS(n.A);r.Z=r.C5=n.A.CL("bl",0),r.1C(n.A.C0.o),r.K=n.K+"-97",r.B6=n.A0,r.DP="1y",r.D=[];1a C=a.E.tT,A=(n.B1+n.BH)/2%2j,s=ZC.AN.BM(n.iX,n.iY,n.AH+n.DR,A);s[0]+=n.BJ,s[1]+=n.BD,r.D.1i(s);1a Z=ZC.AN.BM(n.iX,n.iY,n.AH+n.DR+10,A);Z[0]+=n.BJ,Z[1]+=n.BD,a.iX>=n.iX?"3I"===n.H.AB?r.D.1i([C[0],C[1]+a.F/2]):r.D.1i([Z[0],Z[1],C[0],C[1]+a.F/2]):"3I"===n.H.AB?r.D.1i([C[0]+a.I+2,C[1]+a.F/2]):r.D.1i([Z[0],Z[1],C[0]+a.I+2,C[1]+a.F/2]),r.1q(),r.JC=1f(e){1m n.JC(e)},r.DD()&&r.1q(),r.AL&&r.1v()}}}},1v:1f(){1a e,t=1g;if(t.b(),!(t.AE<0)){1a i=t.C.BL(t.A.BT("k")[0]);t.2E();1a n="3L-fU-"+t.A.L+"-"+t.L;if(t.o.ug&&1w t.C.E[n]===ZC.1b[31]&&(t.C.E[n]=!0),t.AH=ZC.CV(i.G7,i.GF)/2,1c!==ZC.1d(t.A.o[ZC.1b[21]])){1a a=ZC.IB(t.A.o[ZC.1b[21]],!1);t.AH=a<=1?t.AH*a:a}1t t.AH=i.JI*t.AH;t.CK<=1&&(t.CK*=t.AH),t.CK=1A.1V(0,t.CK),t.o[ZC.1b[8]]=t.CK,t.DR<=1&&(t.DR*=t.AH),t.o["1Y-r"]=t.DR,t.C.E[n]&&(t.DR+=ZC.1l(.15*t.AH));1a l=t.N=t.A.I1(t,t);if(t.H9(l),t.AE>=0||0===t.A.A.KF[t.L]){1a o=1n ZC.DS(t.A);o.K=t.K,o.Z=t.A.CL("bl",1),o.C5=t.A.CL("bl",0),o.1Q(l);1a r=t.iX,C=t.iY;t.DR>0&&(r=(e=ZC.AN.BM(t.iX,t.iY,t.DR,(t.B1+t.BH)/2))[0],C=e[1]),o.iX=r,o.iY=C,o.AH=t.AH,o.o[ZC.1b[21]]=t.AH,o.DP="3L",o.B1=ZC.1W(t.B1),o.BH=ZC.1W(t.BH),o.CK=t.CK,o.E.7i=t.A.L,o.E.7l=t.L,o.1q(),t.FX=o;1a A=1f(){if(!t.A.K3&&t.AL){1a e=o.FB(),i=t.C.K+ZC.1b[34]+t.C.K+ZC.1b[35]+t.A.L+ZC.1b[6],n=ZC.P.GC("4x",t.A.E5,t.A.IM)+\'3g="\'+i+\'" id="\'+t.K+ZC.1b[30]+e+\'" />\';t.A.A.HK.1i(n)}t.A.U&&t.H5()};if(t.A.GA&&!t.C.HC){1a s=o,Z={};s.iX=r,s.iY=C,s.B1=t.B1,s.BH=t.BH,Z.bD=t.B1,Z.a2=t.BH,Z.x=r,Z.y=C;1a c=t.A.L6;s.C6=0,Z.2k=l.C6,2===c?(s.BH=t.B1,Z.a2=t.BH):3===c?(s.AH=t.CK,Z.2b=t.AH):4===c?(e=ZC.AN.BM(t.iX,t.iY,1.2*t.AH,(t.B1+t.BH)/2),s.iX=e[0],s.iY=e[1],Z.x=r,Z.y=C):5===c&&(s.B1=s.BH=(t.B1+t.BH)/2,Z.bD=t.B1,Z.a2=t.BH);1a u;1k(u in t.A.FR)s[ZC.E8.GI[ZC.EB(u)]]=t.A.FR[u],Z[ZC.EB(u)]=l[ZC.E8.GI[ZC.EB(u)]];if(1c===ZC.1d(t.C.EN)&&(t.C.EN={}),1c!==ZC.1d(t.C.EN[t.A.L+"-"+t.L]))1k(u in t.C.EN[t.A.L+"-"+t.L])s[ZC.E8.GI[ZC.EB(u)]]=t.C.EN[t.A.L+"-"+t.L][u];t.C.EN[t.A.L+"-"+t.L]={},ZC.2A(Z,t.C.EN[t.A.L+"-"+t.L]);1a p=1n ZC.E8(s,Z,t.A.J9,t.A.L2,ZC.E8.RJ[t.A.L4],1f(){A()});p.AV=t,t.LL(p)}1t o.1v(),A()}1t t.A.U&&t.H5()}},6e:1f(e){1a t=1g;ZC.3l||t.M2({6r:e,1I:"2P",92:1f(){if(1g.1Q(t),1g.iX=t.iX,1g.iY=t.iY,t.DR>0){1a e=ZC.AN.BM(t.iX,t.iY,t.DR,(t.B1+t.BH)/2);1g.iX=e[0],1g.iY=e[1]}1g.AH=t.AH,1g.DP="3L",1g.A0=t.A.BO[3],1g.AC=t.A.BO[2],1g.B1=ZC.1W(t.B1),1g.BH=ZC.1W(t.BH),1g.CK=t.CK},kL:1f(){1g.o[ZC.1b[21]]=t.AH,1g.o[ZC.1b[8]]=t.CK,1g.o["1Y-r"]=t.DR}})},WY:1f(e,t){1a i=1g;if(i.b(e,t),"3F"===t&&e.8T<=1&&i.A.mW){1o.4C.aS=!0,1o.4C.9Z=!0;1a n="3L-fU-"+i.A.L+"-"+i.L;i.C.E[n]=1w i.C.E[n]===ZC.1b[31]||!i.C.E[n],i.C.K2(),1o.4C.9Z=!1,1o.4C.aS=!1}}}),ZC.Bv=ZC.M5.C7({2E:1f(){1a e=1g,t=e.C.BL(e.A.BT("k")[0]);e.iX=t.iX+t.I/2+t.BJ,e.iY=t.iY+t.F/2+t.BD,e.HS||(e.1Q(e.A),e.o[ZC.1b[8]]=1c,e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},kK:1f(){1a e=1g,t=(e.B1+e.BH)/2%2j,i=ZC.AN.BM(e.iX,e.iY,e.CK+e.E.dl/2+e.DR,t);1m[i[0],i[1]]},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l);1a o=100*a.AE/a.A.A.KF[a.L],r=""+o;1m 1c!==ZC.1d(l[ZC.1b[12]])&&(r=o.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]])))),a.CR=[["%2o-8k-1S",r],["%8o",r]],e=a.b(e,t,i,n)},82:1f(e){1a t={},i="in";1m 1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]),t.1r="4R"===i?1g.A0:1g.BZ,t},7n:1f(e){1a t=1g,i="in";1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]);1a n,a,l,o=e.I,r=e.F,C=(t.B1+t.BH)/2%2j;1m"4R"===i?t.L===t.A.S.1h-1?(l=ZC.AN.BM(t.iX,t.iY,t.A.TU+t.A.S.1h*(t.E.dl+t.E.su)+15+e.DR,C),n=C>=0&&C<90||C>=3T&&C<2j?l[0]+10+t.BJ:l[0]-o-10+t.BJ,a=l[1]-r/2+t.BD):(n=-1,a=-1):(n=(l=ZC.AN.BM(t.iX,t.iY,t.CK+t.E.dl/2+e.DR,C))[0]-o/2+t.BJ,a=l[1]-r/2+t.BD),1c!==ZC.1d(e.o.x)&&(n=e.iX),1c!==ZC.1d(e.o.y)&&(a=e.iY),[ZC.1l(n),ZC.1l(a),C]},H5:1f(e){1a t=1g,i=t.b(e);if(e)1m i;if(i.AL&&1c!==ZC.1d(i.AP)&&""!==i.AP){1a n="in";if(1c!==ZC.1d(i.o[ZC.1b[7]])&&(n=i.o[ZC.1b[7]]),"4R"===n&&t.L===t.A.S.1h-1){1a a=1n ZC.DS(t.A);a.Z=a.C5=t.H.2L()?t.H.mc("1u"):t.C.AJ["3d"]||t.H.K3?ZC.AK(t.C.K+"-4j-vb-c"):ZC.AK(t.C.K+"-1B-"+t.A.L+"-vb-c"),a.1C(t.A.C0.o),a.B6=t.A0,a.DP="1y",a.D=[];1a l=(t.B1+t.BH)/2%2j,o=ZC.AN.BM(t.iX,t.iY,t.CK+t.E.dl+i.DR,l),r=ZC.AN.BM(t.iX,t.iY,t.A.TU+t.A.S.1h*(t.E.dl+t.E.su)+15+i.DR,l);o[0]+=t.BJ,r[0]+=t.BJ,o[1]+=t.BD,r[1]+=t.BD,a.D.1i(o),l>=0&&l<90||l>=3T&&l<2j?a.D.1i([r[0],r[1],r[0]+10,r[1]]):a.D.1i([r[0],r[1],r[0]-10,r[1]]),a.1q(),a.JC=1f(e){1m t.JC(e)},a.DD()&&a.1q(),a.AL&&a.1v()}}},1v:1f(){1f e(){1a e=s.FB(),t=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6],n=ZC.P.GC("4x",i.A.E5,i.A.IM)+\'3g="\'+t+\'" id="\'+i.K+ZC.1b[30]+e+\'" />\';i.A.A.HK.1i(n),i.A.U&&i.A.U.AL&&i.H5()}1a t,i=1g;i.b();1a n=i.C.BL(i.A.BT("k")[0]);i.2E(),i.AH=ZC.CV(n.I,n.F)/2,i.AH=n.JI*i.AH,i.CK=i.A.TU,i.CK<1&&(i.CK=i.A.TU*i.AH);1a a=i.A.SI;a<1&&(a=i.A.SI*i.AH);1a l=2,o=i.AH-i.CK;if(1c!==ZC.1d(i.A.eS)&&1c!==ZC.1d(i.A.eS[i.L])){(l=ZC.1W(i.A.eS[i.L]))>1&&(l/=100),l=ZC.1l(o*l),l=ZC.BN(l,2);1k(1a r=0,C=0;C<i.L;C++)r+=ZC.1W(i.A.eS[C]);r>1&&(r/=100),r=ZC.1l(o*r),i.CK+=r,i.AH=i.CK+l}1t l=(o-(i.A.S.1h-1)*a)/i.A.S.1h,l=ZC.BN(l,2),i.CK+=i.L*(l+a),i.AH=i.CK+l;1a A=i.N=i.A.I1(i,i);i.H9(A);1a s=1n ZC.DS(i.A);s.K=i.K,s.Z=i.A.CL("bl",1),s.C5=i.A.CL("bl",0),s.1Q(A),s.iX=i.iX,s.iY=i.iY,s.DP="3L",s.B1=i.B1,s.BH=i.BH,s.CK=i.CK,s.AH=i.AH,s.1q();1a Z=s.CK;if(i.E.dl=l,i.E.su=a,i.A.GA&&!i.C.HC){1a c=s,u={};c.B1=i.B1,c.BH=i.BH,u.bD=i.B1,u.a2=i.BH;1a p=i.A.L6;if(c.C6=0,u.2k=A.C6,2===p)c.BH=i.B1,u.a2=i.BH;1t if(3===p)c.CK=Z+i.E.dl,u.7y=Z;1t if(4===p){1a h=ZC.AN.BM(i.iX,i.iY,i.AH,(i.B1+i.BH)/2);c.iX=h[0],c.iY=h[1],u.x=i.iX,u.y=i.iY}1t 5===p&&(c.B1=c.BH=(i.B1+i.BH)/2,u.bD=i.B1,u.a2=i.BH);1k(t in i.A.FR)c[ZC.E8.GI[ZC.EB(t)]]=i.A.FR[t],u[ZC.EB(t)]=A[ZC.E8.GI[ZC.EB(t)]];if(i.C.EN||(i.C.EN={}),1c!==ZC.1d(i.C.EN[i.A.L+"-"+i.L]))1k(t in i.C.EN[i.A.L+"-"+i.L])c[ZC.E8.GI[ZC.EB(t)]]=i.C.EN[i.A.L+"-"+i.L][t];i.C.EN[i.A.L+"-"+i.L]={},ZC.2A(u,i.C.EN[i.A.L+"-"+i.L]);1a 1b=1n ZC.E8(c,u,i.A.J9,i.A.L2,ZC.E8.RJ[i.A.L4],1f(){e()});1b.AV=i,i.LL(1b)}1t s.1v(),e()},6e:1f(e){1a t=1g;ZC.3l||t.M2({6r:e,1I:"2P",92:1f(){1g.1Q(t),1g.iX=t.iX,1g.iY=t.iY,1g.DP="3L",1g.A0=t.A.BO[3],1g.AC=t.A.BO[2],1g.B1=t.B1,1g.BH=t.BH,1g.CK=t.CK,1g.AH=t.AH},kL:1f(){1g.o[ZC.1b[8]]=1c}})}}),ZC.Bw=ZC.M5.C7({$i:1f(e){1g.b(e);1a t=1g;t.CQ=1c,t.CT=1c,t.MF="1V"},KC:1f(e,t,i,n){1a a=1g;1m"5y"===a.A.CS&&(a.CR=[["%2o-2h-1S",a.CQ],["%2o-1V-1S",a.CT]]),e=a.b(e,t,i,n)},7j:1f(){1a e=1g;"5y"===e.A.CS&&e.o[ZC.1b[9]]3z 3K?(e.CQ=ZC.1W(e.o[ZC.1b[9]][0]),e.CT=ZC.1W(e.o[ZC.1b[9]][1]),e.AE=e.CM=e.CT,e.DL.1i(e.CQ)):e.b()},2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];if(e.JH!==n){1a a;a="5y"===e.A.CS?i.TY("2h"===e.MF?e.CQ:e.CT):i.TY(e.CM);1a l=t.lK(e.L,a);e.iX=l[0],e.iY=l[1],e.JH=n}e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},7n:1f(e){1a t,i=1g,n=i.A.B0,a=i.A.CI,l=i.C.BL("1z"),o=l.iX+l.I/2,r=l.iY+l.F/2,C=e.I,A=e.F,s="4R";1c!==ZC.1d(e.o[ZC.1b[7]])&&(s=e.o[ZC.1b[7]]);1a Z=1.15;1P(s){1j"4R":Z=1.15;1p;1j"tY":Z=1;1p;1j"in":Z=.85;1p;1j"6o":Z=.5}1a c,u,p=n.EM/(n.W.1h-(2j===n.EM||n.DK?0:1)),h=a.TY(i.CM);1P(i.A.CS){1j"9y":1j"5O":1a 1b=(ZC.CV(l.I/2,l.F/2)*l.JI-a.A6)/i.A.A.A7.1h;c=a.A6+i.A.L*1b,u=a.A6+(i.A.L+1)*1b,t=ZC.AN.BM(o,r,(c+u)/2*Z+e.DR,n.DM+(n.DK?p/2:0)+i.L*p);1p;2n:t=ZC.AN.BM(o,r,a.A6+h*Z+e.DR,n.DM+(n.DK?p/2:0)+i.L*p)}1m t[0]-=C/2,t[1]-=A/2,1c!==ZC.1d(e.o.x)&&(t[0]=e.iX),1c!==ZC.1d(e.o.y)&&(t[1]=e.iY),[ZC.1l(t[0]),ZC.1l(t[1])]},82:1f(){1m{1r:"9z"===1g.A.CS?1g.A0:1g.B6}},XP:1f(){1m{"1R-1r":"9z"===1g.A.CS?1g.A0:1g.B6,"1F-1r":"9z"===1g.A.CS?1g.A0:1g.B6,1r:1g.BZ}},1v:1f(){1f e(){if(n.A.RP>=n.A.S.1h&&n.A.XV){1a e=n.C.K+ZC.1b[34]+n.C.K+ZC.1b[35]+n.A.L+ZC.1b[6],t="",i="";-1!==ZC.AT(["1y","1M","5y"],n.A.CS)?""!==(i="5y"!==n.A.CS||n.A.X8?ZC.AN.PO(ZC.AN.YU(n.E.2S),4):ZC.AN.PO(u,4))&&(t=ZC.P.GC("4x",n.A.E5,n.A.IM)+\'3g="\'+e+\'" id="\'+n.K+ZC.1b[30]+i+\'" />\'):-1!==ZC.AT(["9z","8V","2Q","9y","5O"],n.A.CS)&&(i=A.FB(),t=ZC.P.GC("4x",n.A.E5,n.A.IM)+\'3g="\'+e+\'" id="\'+n.K+ZC.1b[30]+i+\'" 1T-z-3V="\'+(n.A.A.A7.1h-n.A.L)+\'" />\'),n.A.A.HK.1i(t)}n.A.U&&n.A.E.kq!==n.K&&n.H5()}1a t,i,n=1g;n.b();1a a=n.A.Q0,l=n.A.jB,o=n.A.B0,r=n.A.CI,C=n.A.S;n.2E(),n.CX=!1,n.C5=n.A.CL("bl",0);1a A,s,Z,c=[],u=[],p=[],h=[],1b="5y"===n.A.CS,d=n.N=n.A.I1(n,n);if(n.A.IA&&n.H9(d),-1!==ZC.AT(["1y","1M","5y"],n.A.CS)){c=[],u=[],p=[],h=[];1a f=n.iX,g=n.iY,B=n.iX,v=n.iY;1b&&(n.MF="1V",n.2E(),f=n.iX,g=n.iY,n.MF="2h",n.2E(),B=n.iX,v=n.iY),n.A.IJ&&(n.A.D.1i([f,g]),n.A.AG.1i([f,g])),n.L>o.X?(Z=C[n.L-1])&&(Z.MF="1V",Z.2E(),s=ZC.AN.JK(Z.iX,Z.iY,f,g),c.1i(s),u.1i(s),1b&&(Z.MF="2h",Z.2E(),s=ZC.AN.JK(Z.iX,Z.iY,B,v),p.1i(s),h.1i(s))):(Z=C[o.A1])&&(Z.MF="1V",Z.2E(),s=ZC.AN.JK(Z.iX,Z.iY,f,g),c.1i(s),u.1i(s),1b&&(Z.MF="2h",Z.2E(),s=ZC.AN.JK(Z.iX,Z.iY,B,v),p.1i(s),h.1i(s))),c.1i([f,g]),u.1i([f,g]),1b&&(p.1i([B,v]),h.1i([B,v])),n.L<o.A1?(Z=C[n.L+1])&&(Z.MF="1V",Z.2E(),s=ZC.AN.JK(f,g,Z.iX,Z.iY),c.1i(s),u.1i(s),1b&&(Z.MF="2h",Z.2E(),s=ZC.AN.JK(B,v,Z.iX,Z.iY),p.1i(s),h.1i(s))):(Z=C[0])&&(Z.MF="1V",Z.2E(),s=ZC.AN.JK(f,g,Z.iX,Z.iY),c.1i(s),u.1i(s),1b&&(Z.MF="2h",Z.2E(),s=ZC.AN.JK(B,v,Z.iX,Z.iY),p.1i(s),h.1i(s))),ZC.CN.2E(a,d)}1b&&(c.1i(1c),c=c.4w(p.9m()),u=u.4w(h.9m()));1a b,E,m,K,F,D=n.C.Q;b=n.C.BL("1z"),"1M"!==n.A.CS&&"5y"!==n.A.CS||(E=b.iX+b.I/2,m=b.iY+b.F/2,K=2j/o.W.1h,"1M"===n.A.CS&&u.1i([E,m]),n.A.IJ||((F=1n ZC.DS(n.A)).K=n.K+"-1M",F.Z=n.A.CL("bl",0),F.1Q(d),F.L1=!0,F.D=u,F.1q(),F.C6=n.A.HM,1===F.C6&&0===F.AQ&&(F.A0=ZC.AO.QJ(ZC.AO.G3(F.A0),20),F.AC=ZC.AO.QJ(ZC.AO.G3(F.AC),20),F.AQ=2,F.BU=F.A0),F.CY=[D.iX,D.iY,D.iX+D.I,D.iY+D.F],ZC.CN.2E(l,F))),n.E.2S=c,n.E.9U=u,n.bQ({2S:c,9U:u});1a I,X,x,y,L,Y,w,M,H,N,S;if(n.A.IJ&&n.L===o.A1&&("1M"===n.A.CS&&((F=1n ZC.DS(n.A)).K=n.K+"-1M",F.Z=n.A.CL("bl",0),F.1Q(n.A),F.L1=!0,F.D=n.A.AG,F.1q(),F.C6=n.A.HM,F.CY=[D.iX,D.iY,D.iX+D.I,D.iY+D.F],F.1v()),"1y"!==n.A.CS&&"1M"!==n.A.CS&&"5y"!==n.A.CS||(n.A.D[0]&&n.A.D.1i([n.A.D[0][0],n.A.D[0][1]]),ZC.CN.1v(a,d,n.A.D))),-1!==ZC.AT(["sp","6t","1M","1y"],n.A.CS))n.P6(!1,!0);1t if(-1!==ZC.AT(["9z","8V","2Q","5O","9y"],n.A.CS)){(A=1n ZC.DS(n.A)).K=n.K+"-3L",A.1Q(d),A.Z=n.A.CL("bl",1),A.C5=n.A.CL("bl",0),E=(b=n.C.BL("1z")).iX+b.I/2,m=b.iY+b.F/2;1a O=.1*(K=o.EM/(o.W.1h-(2j===o.EM||o.DK?0:1)));n.A.CB||(O=.1*K+.4*K*n.A.L/n.A.A.A7.1h),1c!==ZC.1d(t=n.A.sr)&&(O=t<1?K*t:t),Y=r.A6;1a P=n.A.A;n.A.CB&&1c!==ZC.1d(P.iN["7H"+n.L])&&(Y+=P.iN["7H"+n.L]);1a k=ZC.1l(r.TY(n.CM));if(n.A.CB&&(P.iN["7H"+n.L]=k),x=o.DM+n.L*K-K/2+O+(o.DK?K/2:0),y=o.DM+(n.L+1)*K-K/2-O+(o.DK?K/2:0),L=k+r.A6,"5O"===n.A.CS||"9y"===n.A.CS){1a G=(ZC.CV(b.I/2,b.F/2)*b.JI-r.A6)/n.A.A.A7.1h;L=r.A6+n.A.L*G,Y=r.A6+(n.A.L+1)*G}n.bQ({x:E,y:m,sz:L,sl:Y,as:x,ae:y}),A.iX=E,A.iY=m,A.DP="3L",A.B1=x,A.BH=y,A.AH=L,A.CK=Y,A.1q(),A.JC=1f(e){1m n.JC(e)},A.DD()&&A.1q()}if(n.A.GA&&-1!==ZC.AT(["1y","1M","9z","8V","2Q","9y","5O"],n.A.CS)){1P(n.A.CS){1j"1y":1j"1M":X={},(I=1n ZC.DS(n)).1Q(d),I.K=n.K,I.Z=n.A.CL("bl",1),I.C5=n.A.CL("bl",0),I.D=c,I.C6=0,X.2k=d.C6,X.2S=c;1a z=[];"1M"===n.A.CS&&(H={},w=[],(M=F).D=u,M.C6=0,H.2S=u,H.2k=n.A.HM);1p;1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":X={},(I=A).iX=E,I.iY=m,I.B1=x,I.BH=y,I.C6=0,X.bD=x,X.a2=y,X.x=E,X.y=m,X.2b=L,X.2k=d.C6}1a T=n.A.L6,J=n.C.Q;1P(T){1j 1:1p;1j 7:1P(n.A.CS){1j"1y":1j"1M":1k(i=0;i<c.1h;i++)z[i]=[c[i][0],J.iY+J.F/2];if(I.D=z,X.2S=c,"1M"===n.A.CS){1k(i=0;i<u.1h;i++)w[i]=[u[i][0],J.iY+J.F/2];M.D=w,H.2S=u}}1p;1j 2:1P(n.A.CS){1j"1y":1j"1M":1k(i=0;i<c.1h;i++)z[i]=[J.iX+J.I/2,c[i][1]];if(I.D=z,X.2S=c,"1M"===n.A.CS){1k(i=0;i<u.1h;i++)w[i]=[J.iX+J.I/2,u[i][1]];M.D=w,H.2S=u}1p;1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":I.BH=x,X.a2=y}1p;1j 3:1P(n.A.CS){1j"1y":1j"1M":1k(i=0;i<c.1h;i++)z[i]=[J.iX+J.I/2,J.iY+J.F/2];if(I.D=z,X.2S=c,"1M"===n.A.CS){1k(i=0;i<u.1h;i++)w[i]=[J.iX+J.I/2,J.iY+J.F/2];M.D=w,H.2S=u}1p;1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":I.AH=r.A6,X.2b=L}1p;1j 4:1P(n.A.CS){1j"1y":1j"1M":1k(i=0;i<c.1h;i++)N=J.iX+J.I/2-c[i][0],S=J.iY+J.F/2-c[i][1],z[i]=[J.iX+J.I/2-2.5*N,J.iY+J.F/2-2.5*S];if(I.D=z,X.2S=c,"1M"===n.A.CS){1k(i=0;i<u.1h;i++)N=J.iX+J.I/2-u[i][0],S=J.iY+J.F/2-u[i][1],w[i]=[J.iX+J.I/2-2.5*N,J.iY+J.F/2-2.5*S];M.D=w,H.2S=u}1p;1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":I.AH=2*L,X.2b=L}1p;1j 5:1P(n.A.CS){1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":I.B1=I.BH=(x+y)/2,X.bD=x,X.a2=y}}1a Q;1k(Q in n.A.FR)I[ZC.E8.GI[ZC.EB(Q)]]=n.A.FR[Q],X[ZC.EB(Q)]=d[ZC.E8.GI[ZC.EB(Q)]];if(1c===ZC.1d(n.C.EN)&&(n.C.EN={},"1M"===n.A.CS&&(n.C.SN={})),1c!==ZC.1d(n.C.EN[n.A.L+"-"+n.L])){1k(Q in n.C.EN[n.A.L+"-"+n.L])I[ZC.E8.GI[ZC.EB(Q)]]=n.C.EN[n.A.L+"-"+n.L][Q];if("1M"===n.A.CS)1k(Q in n.C.SN[n.A.L+"-"+n.L])M[ZC.E8.GI[ZC.EB(Q)]]=n.C.SN[n.A.L+"-"+n.L][Q]}n.C.EN[n.A.L+"-"+n.L]={},ZC.2A(X,n.C.EN[n.A.L+"-"+n.L]),"1M"===n.A.CS&&(n.C.SN[n.A.L+"-"+n.L]={},ZC.2A(H,n.C.SN[n.A.L+"-"+n.L]));1a W=1n ZC.E8(I,X,n.A.J9,n.A.L2,ZC.E8.RJ[n.A.L4],1f(){e()});W.AV=n,-1!==ZC.AT(["1y","1M"],n.A.CS)&&(W.IC=a);1a R=1c;"1M"===n.A.CS&&((R=1n ZC.E8(M,H,n.A.J9,n.A.L2,ZC.E8.RJ[n.A.L4],1f(){})).AV=n),n.LL(W,R)}1t{1P(n.A.CS){1j"1y":1j"1M":1j"5y":n.A.IJ||(ZC.CN.1v(a,d,c),"1M"!==n.A.CS&&"5y"!==n.A.CS||F.1v());1p;1j"9z":1j"8V":1j"2Q":1j"9y":1j"5O":A.1v()}e()}},6e:1f(e){1a t=1g;ZC.3l||(t.A.I7&&t.A.AL&&(-1!==ZC.AT(["1y","1M","5y"],t.A.CS)?(t.j4(e),"1M"!==t.A.CS&&"5y"!==t.A.CS||t.M2({6r:e,1I:"1M",92:1f(){1g.D=t.E.9U},d1:1f(){1g.AY=0,1g.AQ=0,1g.C6=t.A.HM;1a e=t.C.Q;1g.CY=[e.iX,e.iY,e.iX+e.I,e.iY+e.F]}})):-1!==ZC.AT(["9z","8V","2Q","9y","5O"],t.A.CS)&&t.M2({6r:e,1I:"2P",92:1f(){1g.1Q(t),1g.B6=t.A.BO[1],1g.BU=t.A.BO[1],1g.A0=t.A.BO[3],1g.AC=t.A.BO[2],1g.iX=t.5J("x"),1g.iY=t.5J("y"),1g.CK=t.5J("sl"),1g.B1=t.5J("as"),1g.BH=t.5J("ae"),1g.DP="3L",1g.AH=t.5J("sz")}})),-1!==ZC.AT(["sp","6t","1y"],t.A.CS)&&t.TD(e))}}),ZC.Gg=ZC.Z6.C7({$i:1f(e){1g.b(e),1g.FG=1c},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l);1a o=ZC.AO.GM(a.A.PT[a.L],l);1m a.CR=[["%2o-7w-1S",o],["%g",o]],e=a.b(e,t,i,n)},7n:1f(e){1a t=1g;1m"7w"===ZC.1d(e.o[ZC.1b[7]])?[t.FG.iX+t.FG.I/2-e.I/2,t.FG.iY-e.F]:t.b(e)},7j:1f(){1a e,t=1g;if(t.DL=[],t.CJ=t.o[ZC.1b[9]],"2Y"==1w t.o[ZC.1b[9]]){1a i=ZC.AT(t.A.CI.JF,t.o[ZC.1b[9]]);-1!==i?t.AE=i:(t.A.CI.JF.1i(t.o[ZC.1b[9]]),t.AE=t.A.CI.JF.1h-1)}1t t.AE=ZC.1W(t.o[ZC.1b[9]]);t.A.o.hB&&1c!==ZC.1d(e=t.A.o.hB[t.L])&&t.DL.1i(ZC.1W(e))},1v:1f(){1g.b()},6E:1f(){1a e,t,i=1g;if(1c!==ZC.1d(i.A.PT[i.L])&&i.AL){1a n=i.A.CI.B2(i.A.PT[i.L]);i.FG=1n ZC.HQ(i.A),i.FG.K=i.K+"-7w",i.FG.1Q(i.A.FG),i.FG.Z=i.A.CL("fl",0),i.FG.C5=i.A.CL("fl",0),i.FG.JC=1f(e){1m i.JC(e)},i.FG.DD()&&i.FG.1q(),1c!==ZC.1d(e=i.FG.o)&&1c!==ZC.1d(e.au)&&1c!==ZC.1d(t=e.au[i.L])&&("2Y"==1w t?i.FG.1C({"1R-1r":t}):i.FG.1C(t),i.FG.1q());1a a=.2;if(1c!==ZC.1d(e=i.FG.o.sm)&&(a=ZC.1W(e)),i.FG.iX=i.5J("x")-i.I*a,i.FG.I=i.I*(1+2*a),1c===ZC.1d(i.A.FG.o[ZC.1b[20]])&&(i.FG.F=ZC.CV(5,i.C.Q.F/30)),i.FG.iY=n-i.FG.F/2,i.FG.AL){i.FG.1v();1a l=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6];i.A.A.HK.1i(ZC.P.GC("5t",i.A.E5,i.A.IM)+\'3g="\'+l+\'" id="\'+i.K+"--7w"+ZC.1b[30]+ZC.1l(i.FG.iX+i.A.BJ+ZC.3y)+","+ZC.1l(i.FG.iY+i.A.BD+ZC.3y)+","+ZC.1l(i.FG.iX+i.A.BJ+i.FG.I+ZC.3y)+","+ZC.1l(i.FG.iY+i.A.BD+i.FG.F+ZC.3y)+\'" />\')}}},6e:1f(e){1a t=1g;if(!ZC.3l&&(t.b(e),t.FG&&t.FG.AL)){1a i=1n ZC.HQ(t.A);i.1Q(t.FG),i.Z=ZC.AK(t.C.K+ZC.1b[22]),i.M3=!1,i.iX=t.FG.iX,i.iY=t.FG.iY,i.1v()}}}),ZC.Gw=ZC.Z9.C7({$i:1f(e){1g.b(e),1g.FG=1c},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l);1a o=ZC.AO.GM(a.A.PT[a.L],l);1m a.CR=[["%2o-7w-1S",o],["%g",o]],e=a.b(e,t,i,n)},7n:1f(e){1a t=1g;1m"7w"===ZC.1d(e.o[ZC.1b[7]])?[t.FG.iX+t.FG.I,t.FG.iY+t.FG.F/2-e.F/2]:t.b(e)},7j:1f(){1a e,t=1g;if(t.DL=[],t.CJ=t.o[ZC.1b[9]],"2Y"==1w t.o[ZC.1b[9]]){1a i=ZC.AT(t.A.CI.JF,t.o[ZC.1b[9]]);-1!==i?t.AE=i:(t.A.CI.JF.1i(t.o[ZC.1b[9]]),t.AE=t.A.CI.JF.1h-1)}1t t.AE=ZC.1W(t.o[ZC.1b[9]]);t.A.o.hB&&1c!==ZC.1d(e=t.A.o.hB[t.L])&&t.DL.1i(ZC.1W(e))},1v:1f(){1g.b()},6E:1f(){1a e,t,i=1g;if(1c!==ZC.1d(i.A.PT[i.L])&&i.AL){1a n=i.A.CI.B2(i.A.PT[i.L]);i.FG=1n ZC.HQ(i.A),i.FG.K=i.K+"-7w",i.FG.1Q(i.A.FG),i.FG.Z=i.A.CL("fl",0),i.FG.C5=i.A.CL("fl",0),i.FG.JC=1f(e){1m i.JC(e)},i.FG.DD()&&i.FG.1q(),1c!==ZC.1d(e=i.FG.o)&&1c!==ZC.1d(e.au)&&1c!==ZC.1d(t=e.au[i.L])&&("2Y"==1w t?i.FG.1C({"1R-1r":t}):i.FG.1C(t),i.FG.1q());1a a=.2;if(1c!==ZC.1d(e=i.FG.o.sm)&&(a=ZC.1W(e)),i.FG.iY=i.5J("y")-i.F*a,i.FG.F=i.F*(1+2*a),1c===ZC.1d(i.A.FG.o[ZC.1b[19]])&&(i.FG.I=ZC.CV(5,i.C.Q.I/30)),i.FG.iX=n-i.FG.I/2,i.FG.AL){i.FG.1v();1a l=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6];i.A.A.HK.1i(ZC.P.GC("5t",i.A.E5,i.A.IM)+\'3g="\'+l+\'" id="\'+i.K+"--7w"+ZC.1b[30]+ZC.1l(i.FG.iX+i.A.BJ+ZC.3y)+","+ZC.1l(i.FG.iY+i.A.BD+ZC.3y)+","+ZC.1l(i.FG.iX+i.A.BJ+i.FG.I+ZC.3y)+","+ZC.1l(i.FG.iY+i.A.BD+i.FG.F+ZC.3y)+\'" />\')}}},6e:1f(e){1a t=1g;if(!ZC.3l&&(t.b(e),t.FG&&t.FG.AL)){1a i=1n ZC.HQ(t.A);i.1Q(t.FG),i.Z=ZC.AK(t.C.K+ZC.1b[22]),i.M3=!1,i.iX=t.FG.iX,i.iY=t.FG.iY,i.1v()}}}),ZC.Fr=ZC.M5.C7({7j:1f(){1a e,t=1g;t.o[ZC.1b[9]]3z 3K&&1c!==ZC.1d(t.o[ZC.1b[9]][1])&&(t.CJ=t.o[ZC.1b[9]][1],"2Y"==1w t.o[ZC.1b[9]][0]?-1!==(e=ZC.AT(t.A.B0.IH,t.o[ZC.1b[9]][0]))?t.BX=e:(t.A.B0.IH.1i(t.o[ZC.1b[9]][0]),t.BX=t.A.B0.IH.1h-1):t.BX=ZC.1W(t.o[ZC.1b[9]][0]),"2Y"==1w t.o[ZC.1b[9]][1]?-1!==(e=ZC.AT(t.A.CI.JF,t.o[ZC.1b[9]][1]))?t.AE=e:(t.A.CI.JF.1i(t.o[ZC.1b[9]][1]),t.AE=t.A.CI.JF.1h-1):t.AE=ZC.1W(t.o[ZC.1b[9]][1]),1c!==t.BX&&t.A.UT(t.BX,t.L))},2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];e.JH!==n&&(t.AR?e.iX=t.iX+t.I-t.A6-(e.L-t.X+1)*t.A9:e.iX=t.iX+t.A6+(e.L-t.X)*t.A9,i.AR?e.iY=i.iY+i.A6+(e.A.L-i.B8)*i.A9:e.iY=i.iY+i.F-i.A6-(e.A.L-i.B8+1)*i.A9,e.JH=n),e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0),e.H9(e)},7n:1f(e){1a t=1g,i="tY";1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]);1a n=e.I,a=e.F,l=t.iX+t.I/2-n/2,o=t.iY+t.F/2-a/2;1P(i){1j"1u":o-=t.F/2+a/2+2;1p;1j"1J":l-=t.I/2+n/2+2;1p;1j"2a":o+=t.F/2+a/2+2;1p;1j"2x":l+=t.I/2+n/2+2}1m 1c!==ZC.1d(e.o.x)&&(l=e.iX),1c!==ZC.1d(e.o.y)&&(o=e.iY),[ZC.1l(l),ZC.1l(o)]},82:1f(){1m{1r:"#4e"}},ji:1f(){1m 1g.CJ},KC:1f(e,t,i,n){1a a,l=1g,o=l.A.CI,r=l.A.L;1m a=1c!==ZC.1d(o.BW[r])?o.BW[r]:o.W[r],l.CR=[["%y",a],["%1z-1S-1G",a]],e=l.b(e,t,i,n)},SU:1f(){1a e=1g;e.2E();1a t,i=e.A.B0,n=e.A.CI;1P(e.A.tZ){1j"1B-1V":t=(ZC.1W(e.AE)-e.A.XY)/(e.A.jd-e.A.XY);1p;1j"1B-6i":t=(ZC.1W(e.AE)-e.A.XY)/(e.A.u0-e.A.XY);1p;1j"aL-1V":t=(ZC.1W(e.AE)-e.A.WE)/(e.A.jg-e.A.WE);1p;1j"aL-6i":t=(ZC.1W(e.AE)-e.A.WE)/(e.A.u9-e.A.WE)}1P(ZC.P2(t)||(t=.5),e.I=i.A9,e.F=n.A9,e.A.CS){1j"2k":1j"17T":e.C6=e.A.Q7+t*(e.A.UN-e.A.Q7);1p;1j"cd":e.I=1.8E+e.A.Q7*i.A9+t*i.A9*(e.A.UN-e.A.Q7),i.AR&&(e.iX=e.iX+i.A9-e.I);1p;1j"9r":e.F=1.8E+e.A.Q7*n.A9+t*n.A9*(e.A.UN-e.A.Q7),n.AR||(e.iY=e.iY+n.A9-e.F);1p;1j"2b":e.I=1.8E+e.A.Q7*i.A9+t*i.A9*(e.A.UN-e.A.Q7),e.F=1.8E+e.A.Q7*n.A9+t*n.A9*(e.A.UN-e.A.Q7),e.iX+=(i.A9-e.I)/2,e.iY+=(n.A9-e.F)/2}e.iX-=e.AQ/2,e.iY-=e.AQ/2,e.I+=e.AQ,e.F+=e.AQ},1v:1f(){1a e=1g;e.b(),e.SU();1a t=e.C.Q;if(!(e.iY+5<t.iY||e.iY+5>=t.iY+t.F)){if(e.AL){1a i=1o.5Y.ai("HQ",e,e.A.K+"-5O-3B");if(i.K=e.K,i.1Q(e),("1Z"!==e.A.IV||e.C.JZ[e.A.L]||e.C.KM||e.A.SQ&&e.A.SQ[e.L])&&i.1Q(e.A.I1(e,i)),i.iX=e.iX,i.iY=e.iY,i.I=e.I,i.F=e.F,i.Z=e.A.CL("bl",1),i.C5=e.A.CL("bl",0),(-1!==i.BU&&i.AQ>0||i.PS+i.OA+i.NK+i.P4!==""||-1!==i.A0||-1!==i.AC||""!==i.D8||""!==i.GK||""!==i.HE)&&(i.1v(),!i.K3)){1a n=e.C.K+ZC.1b[34]+e.C.K+ZC.1b[35]+e.A.L+ZC.1b[6];e.A.A.HK.1i(ZC.P.GC("5t",e.A.E5,e.A.IM)+\'3g="\'+n+\'" id="\'+e.K+ZC.1b[30]+ZC.1l(e.iX+ZC.3y)+","+ZC.1l(e.iY+ZC.3y)+","+ZC.1l(e.iX+e.I+ZC.3y)+","+ZC.1l(e.iY+e.F+ZC.3y)+\'" />\')}}e.A.U&&e.A.U.AL&&e.H5()}},6e:1f(e){1a t=1g;ZC.3l||t.M2({6r:e,1I:"3B",92:1f(){1g.AC=t.A.BO[3],1g.B6=t.A.BO[1],1g.BU=t.A.BO[1],1g.A0=t.A.BO[2]},d1:1f(){1g.iX=t.iX,1g.iY=t.iY,1g.I=t.I,1g.F=t.F}})}}),ZC.Fu=ZC.M5.C7({2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];e.JH!==n&&(t.AR?e.iX=t.iX+t.I-t.A6-(e.L+1)*t.A9:e.iX=t.iX+t.A6+e.L*t.A9,i.AR?e.iY=i.iY+i.A6+e.A.L*i.A9:e.iY=i.iY+i.F-i.A6-(e.A.L+1)*i.A9,e.JH=n),e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},KC:1f(e,t,i,n){1a a=1g,l=ZC.1W(a.A.A.F3["%aT-"+a.L+"-0-8c"]||"0"),o=a.A.MG();ZC.2A(t,o),a.CR=[];1a r,C;if(a.A.L>0&&a.A.A.A7[a.A.L-1]&&a.A.A.A7[a.A.L-1].S[a.L]?C=""+(r=100*a.AE/a.A.A.A7[a.A.L-1].S[a.L].AE):(r=100,C="100"),1c!==ZC.1d(o[ZC.1b[12]])&&(C=r.4v(ZC.BN(0,ZC.1l(o[ZC.1b[12]])))),a.CR.1i(["%bJ-8k-1S",C]),l>0){1a A=100*a.AE/l,s=""+A;1c!==ZC.1d(o[ZC.1b[12]])&&(s=A.4v(ZC.BN(0,ZC.1l(o[ZC.1b[12]])))),a.CR.1i(["%2o-8k-1S",s]),a.CR.1i(["%8o",s])}1m e=a.b(e,t,i,n)},1v:1f(){1a e,t,i,n,a,l,o,r,C,A,s,Z,c,u=1g;u.b();1a p=u.A.B0,h=u.A.CI;u.2E(),"8F"===u.A.j8?(u.C.AX.SF[u.L],e=u.C.AX.dC[u.L]):(u.C.AX.B8,e=u.C.AX.BS);1a 1b=u.A.KX;1b<=1&&(1b*=p.A9);1a d=u.A.NI;d<=1&&(d*=p.A9);1a f=u.A.LV;f<=1&&(f*=p.A9);1a g=p.A9-1b-d-f,B=f+g*(u.AE/e),v=0;u.A.L+1<u.A.A.A7.1h&&u.A.A.A7[u.A.L+1].S[u.L]&&(v=u.A.A.A7[u.A.L+1].S[u.L].AE);1a b=f+g*(v/e);u.E["8m-8i"]=[B,b];1a E=u.iX+(p.AR?d:1b)+g/2+f/2;if(n=[],h.AR?n.1i([E-B/2,u.iY],[E+B/2,u.iY],[E+b/2,u.iY+h.A9],[E-b/2,u.iY+h.A9],[E-B/2,u.iY]):n.1i([E-B/2,u.iY+h.A9],[E+B/2,u.iY+h.A9],[E+b/2,u.iY],[E-b/2,u.iY],[E-B/2,u.iY+h.A9]),u.E.2S=n,u.AL){1a m=1n ZC.DS(u.A);m.K=u.K+"-jh",m.1Q(u),m.D=n,m.1q(),m.Z=u.A.CL("bl",1),m.C5=u.A.CL("bl",0),m.1v();1a K=m.FB(),F=u.C.K+ZC.1b[34]+u.C.K+ZC.1b[35]+u.A.L+ZC.1b[6];u.A.A.HK.1i(ZC.P.GC("4x",u.A.E5,u.A.IM)+\'3g="\'+F+\'" id="\'+u.K+ZC.1b[30]+K+\'" />\')}1k(t=0,i=u.A.OR.1h;t<i;t++){1a D=u.A.OR[t];D&&1c!==ZC.1d(D.o[ZC.1b[5]])&&1c!==ZC.1d(D.o[ZC.1b[5]][u.L])&&(1c===ZC.1d(D.o[ZC.1b[19]])&&1c===ZC.1d(D.o[ZC.1b[20]])||((a=1n ZC.HQ(u.A)).1C(D.o),a.1q()),l=0,o=0,1c!==ZC.1d(D.o[ZC.1b[19]])&&(l=a.I),1c!==ZC.1d(D.o[ZC.1b[20]])&&(o=a.F),0===l&&(l=ZC.BN(20,p.A9/10)),0===o&&(o=ZC.BN(16,h.A9/10)),(r=1n ZC.DS(u.A)).K=u.K+"-7G-8m",r.1Q(u),r.1C(D.o),r.1q(),n=[],1===u.A.OR.1h?A=u.iY+h.A9/2:(s=h.A9/(u.A.OR.1h+1),A=u.iY+s+t*s),p.AR?(C=u.iX+p.A9+l-1b-g/2+(B+b)/4-f/2+2,n.1i([C,A-2*o/6],[C-2*l/3,A-o/6],[C-2*l/3,A-3*o/6],[C-l,A],[C-2*l/3,A+3*o/6],[C-2*l/3,A+o/6],[C,A+2*o/6],[C,A-2*o/6])):(C=u.iX+1b-l+g/2-(B+b)/4+f/2-2,n.1i([C,A-2*o/6],[C+2*l/3,A-o/6],[C+2*l/3,A-3*o/6],[C+l,A],[C+2*l/3,A+3*o/6],[C+2*l/3,A+o/6],[C,A+2*o/6],[C,A-2*o/6])),r.D=n,r.1q(),r.Z=u.A.CL("bl",1),r.C5=u.A.CL("bl",0),r.1v(),1c!==ZC.1d(D.o[ZC.1b[10]])&&1c!==ZC.1d(D.o[ZC.1b[10]][u.L])&&""!==D.o[ZC.1b[10]][u.L]&&(Z=D.o[ZC.1b[10]][u.L],(c=1n ZC.DQ(u.A)).K=u.K+"-8m-1G-"+t,c.GG=u.K+"-8m-1G "+u.A.K+"-8m-1G zc-8m-1G",c.1Q(u),c.o.1D=Z,c.1C(D.o),1c!==ZC.1d(D.o.1G)&&c.1C(D.o.1G),c.Z=u.A.CL("fl",0),c.1q(),p.AR?c.iX=C+2:c.iX=C-c.I-2,c.iY=A-c.F/2,c.1v(),c.EH()))}1k(t=0,i=u.A.VC.1h;t<i;t++){1a I=u.A.VC[t];I&&1c!==ZC.1d(I.o[ZC.1b[5]])&&1c!==ZC.1d(I.o[ZC.1b[5]][u.L])&&(1c===ZC.1d(I.o[ZC.1b[19]])&&1c===ZC.1d(I.o[ZC.1b[20]])||((a=1n ZC.HQ(u.A)).1C(I.o),a.1q()),l=0,o=0,1c!==ZC.1d(I.o[ZC.1b[19]])&&(l=a.I),1c!==ZC.1d(I.o[ZC.1b[20]])&&(o=a.F),0===l&&(l=ZC.BN(20,p.A9/10)),0===o&&(o=ZC.BN(16,h.A9/10)),(r=1n ZC.DS(u.A)).K=u.K+"-7G-8i",r.1Q(u),r.1C(I.o),r.1q(),n=[],1===u.A.VC.1h?A=u.iY+h.A9/2:(s=h.A9/(u.A.VC.1h+1),A=u.iY+s+t*s),p.AR?(C=u.iX+d+g/2-(B+b)/4+f/2-2,n.1i([C,A-2*o/6],[C-2*l/3,A-o/6],[C-2*l/3,A-3*o/6],[C-l,A],[C-2*l/3,A+3*o/6],[C-2*l/3,A+o/6],[C,A+2*o/6],[C,A-2*o/6])):(C=u.iX+p.A9-d-g/2+(B+b)/4-f/2+2,n.1i([C,A-2*o/6],[C+2*l/3,A-o/6],[C+2*l/3,A-3*o/6],[C+l,A],[C+2*l/3,A+3*o/6],[C+2*l/3,A+o/6],[C,A+2*o/6],[C,A-2*o/6])),r.D=n,r.1q(),r.Z=u.A.CL("bl",1),r.C5=u.A.CL("bl",0),r.1v(),1c!==ZC.1d(I.o[ZC.1b[10]])&&1c!==ZC.1d(I.o[ZC.1b[10]][u.L])&&""!==I.o[ZC.1b[10]][u.L]&&(Z=I.o[ZC.1b[10]][u.L],(c=1n ZC.DQ(u.A)).K=u.K+"-8i-1G-"+t,c.GG=u.K+"-8i-1G "+u.A.K+"-8i-1G zc-8i-1G",c.1Q(u),c.o.1D=Z,c.1C(I.o),1c!==ZC.1d(I.o.1G)&&c.1C(I.o.1G),c.1q(),c.Z=u.A.CL("fl",0),p.AR?c.iX=C-l-c.I-2:c.iX=C+l+2,c.iY=A-c.F/2,c.1v(),c.EH()))}u.A.U&&u.H5()},7n:1f(e){1a t,i=1g,n=i.A.B0,a=i.A.CI;1c!==ZC.1d(e.o[ZC.1b[7]])&&(t=e.o[ZC.1b[7]]);1a l=i.iX+n.A9/2-e.I/2,o=i.iY+a.A9/2-e.F/2,r=i.E["8m-8i"],C=(r[0]+r[1])/2;1P(t){1j"in":1j"3e":1p;1j"1u":o=i.iY+5;1p;1j"2a":o=i.iY+a.A9-e.F-5;1p;1j"1J":l=i.iX+n.A9/2-C/2+5;1p;1j"1J-4R":l=i.iX+n.A9/2-C/2-e.I-5;1p;1j"2x":l=i.iX+n.A9/2+C/2-e.I-5;1p;1j"2x-4R":l=i.iX+n.A9/2+C/2+5}1m 1c!==ZC.1d(e.o.x)&&(l=e.iX),1c!==ZC.1d(e.o.y)&&(o=e.iY),[ZC.1l(l),ZC.1l(o)]},6e:1f(){1a e=1g;if(!ZC.3l&&e.A.I7&&e.A.AL){e.b();1a t=1n ZC.DS(e.A);t.K=e.K+"-jh-2J",t.Z=ZC.AK(e.C.K+ZC.1b[22]),t.D=e.E.2S,t.1q(),t.B6=e.A.BO[1],t.BU=e.A.BO[1],t.A0=e.A.BO[2],t.AC=e.A.BO[3],t.1C(e.A.I7.o),t.1q(),t.JC=1f(t){1m e.JC(t)},t.DD()&&t.1q(),t.AL&&t.1v()}}}),ZC.Fv=ZC.M5.C7({2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];e.JH!==n&&(t.AR?e.iY=t.iY+t.A6+e.L*t.A9:e.iY=t.iY+t.F-t.A6-(e.L+1)*t.A9,i.AR?e.iX=i.iX+i.I-i.A6-(e.A.L+1)*i.A9:e.iX=i.iX+i.A6+e.A.L*i.A9,e.JH=n),e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},KC:1f(e,t,i,n){1a a=1g,l=ZC.1W(a.A.A.F3["%aT-"+a.L+"-0-8c"]||"0"),o=a.A.MG();ZC.2A(t,o),a.CR=[];1a r,C;if(a.A.L>0&&a.A.A.A7[a.A.L-1]&&a.A.A.A7[a.A.L-1].S[a.L]?C=""+(r=100*a.AE/a.A.A.A7[a.A.L-1].S[a.L].AE):(r=100,C="100"),1c!==ZC.1d(o[ZC.1b[12]])&&(C=r.4v(ZC.BN(0,ZC.1l(o[ZC.1b[12]])))),a.CR.1i(["%bJ-8k-1S",C]),l>0){1a A=100*a.AE/l,s=""+A;1c!==ZC.1d(o[ZC.1b[12]])&&(s=A.4v(ZC.BN(0,ZC.1l(o[ZC.1b[12]])))),a.CR.1i(["%2o-8k-1S",s]),a.CR.1i(["%8o",s])}1m e=a.b(e,t,i,n)},7n:1f(e){1a t,i=1g,n=i.A.B0,a=i.A.CI;1c!==ZC.1d(e.o[ZC.1b[7]])&&(t=e.o[ZC.1b[7]]);1a l=i.iX+a.A9/2-e.I/2,o=i.iY+n.A9/2-e.F/2,r=i.E["8m-8i"],C=(r[0]+r[1])/2;1P(t){1j"in":1j"3e":1p;1j"1u":l=i.iX+a.A9-e.I-5;1p;1j"2a":l=i.iX+5;1p;1j"1J":o=i.iY+n.A9/2-C/2+5;1p;1j"1J-4R":o=i.iY+n.A9/2-C/2-e.F-5;1p;1j"2x":o=i.iY+n.A9/2+C/2-e.F-5;1p;1j"2x-4R":o=i.iY+n.A9/2+C/2+5}1m 1c!==ZC.1d(e.o.x)&&(l=e.iX),1c!==ZC.1d(e.o.y)&&(o=e.iY),[ZC.1l(l),ZC.1l(o)]},1v:1f(){1a e,t,i,n,a,l,o,r,C,A,s,Z,c,u=1g;u.b();1a p=u.A.B0,h=u.A.CI;u.2E(),"8F"===u.A.j8?(u.C.AX.SF[u.L],e=u.C.AX.dC[u.L]):(u.C.AX.B8,e=u.C.AX.BS);1a 1b=u.A.KX;1b<=1&&(1b*=p.A9);1a d=u.A.NI;d<=1&&(d*=p.A9);1a f=u.A.LV;f<=1&&(f*=p.A9);1a g=p.A9-1b-d-f,B=f+g*(u.AE/e),v=0;u.A.L+1<u.A.A.A7.1h&&u.A.A.A7[u.A.L+1].S[u.L]&&(v=u.A.A.A7[u.A.L+1].S[u.L].AE);1a b=f+g*(v/e);u.E["8m-8i"]=[B,b];1a E=u.iY+(p.AR?1b:d)+g/2+f/2;if(o=[],h.AR?o.1i([u.iX+h.A9,E-B/2],[u.iX+h.A9,E+B/2],[u.iX,E+b/2],[u.iX,E-b/2],[u.iX+h.A9,E-B/2]):o.1i([u.iX,E-B/2],[u.iX,E+B/2],[u.iX+h.A9,E+b/2],[u.iX+h.A9,E-b/2],[u.iX,E-B/2]),u.E.2S=o,u.AL){1a m=1n ZC.DS(u.A);m.K=u.K+"-jh",m.1Q(u),m.D=o,m.1q(),m.Z=u.A.CL("bl",1),m.C5=u.A.CL("bl",0),m.1v();1a K=m.FB(),F=u.C.K+ZC.1b[34]+u.C.K+ZC.1b[35]+u.A.L+ZC.1b[6];u.A.A.HK.1i(ZC.P.GC("4x",u.A.E5,u.A.IM)+\'3g="\'+F+\'" id="\'+u.K+ZC.1b[30]+K+\'" />\')}1k(t=0,i=u.A.OR.1h;t<i;t++){1a D=u.A.OR[t];D&&1c!==ZC.1d(D.o[ZC.1b[5]])&&1c!==ZC.1d(D.o[ZC.1b[5]][u.L])&&(1c===ZC.1d(D.o[ZC.1b[19]])&&1c===ZC.1d(D.o[ZC.1b[20]])||((l=1n ZC.HQ(u.A)).1C(D.o),l.1q()),n=0,a=0,1c!==ZC.1d(D.o[ZC.1b[19]])&&(n=l.I),1c!==ZC.1d(D.o[ZC.1b[20]])&&(a=l.F),0===a&&(a=ZC.BN(20,p.A9/10)),0===n&&(n=ZC.BN(16,h.A9/10)),(r=1n ZC.DS(u.A)).K=u.K+"-7G-8m",r.1Q(u),r.1C(D.o),r.1q(),o=[],1===u.A.OR.1h?C=u.iX+h.A9/2:(s=h.A9/(u.A.OR.1h+1),C=u.iX+s+t*s),p.AR?(A=u.iY+1b-a+g/2-(B+b)/4+f/2-2,o.1i([C-2*n/6,A],[C+2*n/6,A],[C+n/6,A+2*a/3],[C+3*n/6,A+2*a/3],[C,A+a],[C-3*n/6,A+2*a/3],[C-n/6,A+2*a/3])):(A=u.iY+p.A9+a-1b-g/2+(B+b)/4-f/2+2,o.1i([C-2*n/6,A],[C+2*n/6,A],[C+n/6,A-2*a/3],[C+3*n/6,A-2*a/3],[C,A-a],[C-3*n/6,A-2*a/3],[C-n/6,A-2*a/3])),r.D=o,r.1q(),r.Z=u.A.CL("bl",1),r.C5=u.A.CL("bl",0),r.1v(),1c!==ZC.1d(D.o[ZC.1b[10]])&&1c!==ZC.1d(D.o[ZC.1b[10]][u.L])&&""!==D.o[ZC.1b[10]][u.L]&&(Z=D.o[ZC.1b[10]][u.L],(c=1n ZC.DQ(u.A)).K=u.K+"-8m-1G-"+t,c.GG=u.K+"-8m-1G "+u.A.K+"-8m-1G zc-8m-1G",c.1Q(u),c.o.1D=Z,c.1C(D.o),1c!==ZC.1d(D.o.1G)&&c.1C(D.o.1G),c.AP=Z,c.Z=u.A.CL("fl",0),c.1q(),c.iX=C-c.I/2,p.AR?c.iY=A-c.F-2:c.iY=A+2,c.1v(),c.EH()))}1k(t=0,i=u.A.VC.1h;t<i;t++){1a I=u.A.VC[t];I&&1c!==ZC.1d(I.o[ZC.1b[5]])&&1c!==ZC.1d(I.o[ZC.1b[5]][u.L])&&(1c===ZC.1d(I.o[ZC.1b[19]])&&1c===ZC.1d(I.o[ZC.1b[20]])||((l=1n ZC.HQ(u.A)).1C(I.o),l.1q()),n=0,a=0,1c!==ZC.1d(I.o[ZC.1b[19]])&&(n=l.I),1c!==ZC.1d(I.o[ZC.1b[20]])&&(a=l.F),0===a&&(a=ZC.BN(20,p.A9/10)),0===n&&(n=ZC.BN(16,h.A9/10)),(r=1n ZC.DS(u.A)).K=u.K+"-7G-8i",r.1Q(u),r.1C(I.o),r.1q(),o=[],1===u.A.OR.1h?C=u.iX+h.A9/2:(s=h.A9/(u.A.OR.1h+1),C=u.iX+s+t*s),p.AR?(A=u.iY+1b+g/2+(B+b)/4+f/2+2,o.1i([C-2*n/6,A],[C+2*n/6,A],[C+n/6,A+2*a/3],[C+3*n/6,A+2*a/3],[C,A+a],[C-3*n/6,A+2*a/3],[C-n/6,A+2*a/3])):(A=u.iY+p.A9-1b-g/2-(B+b)/4-f/2-2,o.1i([C-2*n/6,A],[C+2*n/6,A],[C+n/6,A-2*a/3],[C+3*n/6,A-2*a/3],[C,A-a],[C-3*n/6,A-2*a/3],[C-n/6,A-2*a/3])),r.D=o,r.1q(),r.Z=u.A.CL("bl",1),r.C5=u.A.CL("bl",0),r.1v(),1c!==ZC.1d(I.o[ZC.1b[10]])&&1c!==ZC.1d(I.o[ZC.1b[10]][u.L])&&""!==I.o[ZC.1b[10]][u.L]&&(Z=I.o[ZC.1b[10]][u.L],(c=1n ZC.DQ(u.A)).K=u.K+"-8i-1G-"+t,c.GG=u.K+"-8i-1G "+u.A.K+"-8i-1G zc-8i-1G",c.1Q(u),c.o.1D=Z,c.1C(I.o),1c!==ZC.1d(I.o.1G)&&c.1C(I.o.1G),c.AP=Z,c.Z=u.A.CL("fl",0),c.1q(),c.iX=C-c.I/2,p.AR?c.iY=A+a+2:c.iY=A-a-c.F-2,c.1v(),c.EH()))}u.A.U&&u.H5()},6e:1f(){1a e=1g;if(!ZC.3l&&e.A.I7&&e.A.AL){e.b();1a t=1n ZC.DS(e.A);t.K=e.K+"-jh-2J",t.Z=ZC.AK(e.C.K+ZC.1b[22]),t.D=e.E.2S,t.1q(),t.B6=e.A.BO[1],t.BU=e.A.BO[1],t.A0=e.A.BO[2],t.AC=e.A.BO[3],t.1C(e.A.I7.o),t.1q(),t.JC=1f(t){1m e.JC(t)},t.DD()&&t.1q(),t.AL&&t.1v()}}}),ZC.Fy=ZC.M5.C7({$i:1f(e){1g.b(e),1g.IR=1c},2E:1f(){1a e=1g,t=e.A.B0,i=e.A.CI,n=[t.X,t.A1,i.X,i.A1];if(e.JH!==n&&(1c!==e.BX?e.iX=t.B2(e.BX):e.iX=t.I3(e.L),e.iY=i.B2(e.AE),e.E.WZ=i.B2(e.AE),e.E.mJ=i.B2(e.DL[0]),e.E.iV=i.B2(e.DL[1]),e.E.V6=i.B2(e.DL[2]),e.JH=n),(!e.HS||e.A.IJ&&e.A.MR[ZC.1b[21]]<3)&&(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.IR=1n ZC.DQ(e.A),e.IR.1Q(e),e.DL[2]<e.AE&&(e.IR.A0=e.IR.AC=e.BZ,e.IR.BU=e.B6),e.DL[2]<e.AE?(e.A.o["7h-ag"]&&(e.IR.1C(e.A.o["7h-ag"]),e.IR.1q()),e.A.MR.ag||(e.A.MR.ag=1n ZC.DQ(e.A),e.A.MR.ag.1Q(e.IR),e.A.MR[ZC.1b[21]]++)):e.DL[2]>e.AE?(e.A.o["7h-up"]&&(e.IR.1C(e.A.o["7h-up"]),e.IR.1q()),e.A.MR.up||(e.A.MR.up=1n ZC.DQ(e.A),e.A.MR.up.1Q(e.IR),e.A.MR[ZC.1b[21]]++)):(e.A.o["7h-ab"]&&(e.IR.1C(e.A.o["7h-ab"]),e.IR.1q()),e.A.MR.ab||(e.A.MR.ab=1n ZC.DQ(e.A),e.A.MR.ab.1Q(e.IR),e.A.MR[ZC.1b[21]]++)),e.HS=!0),e.A.IJ){e.DL[2]<e.AE?e.IR=e.A.MR.ag:e.DL[2]>e.AE?e.IR=e.A.MR.up:e.IR=e.A.MR.ab;1a a=ZC.CV(e.E.WZ,e.E.V6),l=ZC.BN(e.E.WZ,e.E.V6)-ZC.CV(e.E.WZ,e.E.V6);l<2&&(l=2),e.E.jw=a+l/2}},KC:1f(e,t,i,n){1f a(e){1m ZC.AO.GM(e,o)}1a l=1g,o=l.A.MG();1m ZC.2A(t,o),l.CR=[["%2o-1S-8f-bu",a(l.AE)],["%bu",a(l.AE)],["%v0",a(l.AE)],["%2o-1S-8f-u3",a(l.DL[0])],["%u3",a(l.DL[0])],["%v1",a(l.DL[0])],["%2o-1S-8f-u2",a(l.DL[1])],["%u2",a(l.DL[1])],["%v2",a(l.DL[1])],["%2o-1S-8f-7p",a(l.DL[2])],["%7p",a(l.DL[2])],["%v3",a(l.DL[2])]],e=l.b(e,t,i,n)},7j:1f(){1a e,t,i=1g;if(i.DL=[],i.o[ZC.1b[9]]3z 3K&&5===i.o[ZC.1b[9]].1h)i.BX=ZC.1W(i.o[ZC.1b[9]][0]),1c!==i.BX&&(1c!==ZC.1d(i.A.JW[i.BX])&&-1!==ZC.AT(i.A.JW[i.BX],i.L)||i.A.UT(i.BX,i.L)),t=[i.o[ZC.1b[9]][1],i.o[ZC.1b[9]][2],i.o[ZC.1b[9]][3],i.o[ZC.1b[9]][4]];1t if(i.o[ZC.1b[9]][1]3z 3K){if("2Y"==1w i.o[ZC.1b[9]][0]){1a n=ZC.AT(i.A.B0.IH,i.o[ZC.1b[9]][0]);-1!==n?i.BX=n:(i.A.B0.IH.1i(i.o[ZC.1b[9]][0]),i.BX=i.A.B0.IH.1h-1)}1t i.BX=ZC.1W(i.o[ZC.1b[9]][0]);1c!==i.BX&&(1c!==ZC.1d(i.A.JW[i.BX])&&-1!==ZC.AT(i.A.JW[i.BX],i.L)||i.A.UT(i.BX,i.L)),t=i.o[ZC.1b[9]][1]}1t t=i.o[ZC.1b[9]];i.CJ=t.2I(" "),i.AE=ZC.1W(t[0]),1c!==ZC.1d(e=t[1])&&i.DL.1i(ZC.1W(e)),1c!==ZC.1d(e=t[2])&&i.DL.1i(ZC.1W(e)),1c!==ZC.1d(e=t[3])&&i.DL.1i(ZC.1W(e))},82:1f(){1a e=1g,t={};1m e.DL[2]<e.AE?t[ZC.1b[0]]=e.IR.B6:t[ZC.1b[0]]=e.IR.A0,t.1r=e.IR.BZ,t},XP:1f(){1a e=1g,t={};1m e.DL[2]<e.AE?t[ZC.1b[0]]=e.IR.B6:t[ZC.1b[0]]=e.IR.A0,t[ZC.1b[61]]=t[ZC.1b[0]],t.1r=e.IR.BZ,t},jo:1f(){1m 1g.XP()},1v:1f(){1a e,t=1g;t.b();1a i=t.A.B0;t.2E();1k(1a n=i.A9*t.A.Y,a=t.A.L,l=0,o=0;o<t.A.A.JY.8f.1h;o++)l++,-1!==ZC.AT(t.A.A.JY[t.A.AF][o],t.A.L)&&(a=o);1a r=t.A.CC;r<=1&&(r*=n);1a C=t.A.CO;C<=1&&(C*=n);1a A=n-r-C,s=t.A.F0;s<=1&&(s*=A),A<1&&(A=.8*n,r=.1*n,C=.1*n);1a Z=A,c=t.A.EX;0!==c&&(s=0),l>1&&(c>1?Z=(A-(l-1)*s+(l-1)*c)/l:c*=Z=(A-(l-1)*s)/(l-(l-1)*c)),Z=ZC.5m(Z,1,A);1a u=t.iX-n/2+r+a*(Z+s)-a*c;u=ZC.5m(u,t.iX-n/2+r,t.iX+n/2-C);1a p=Z,h=ZC.CV(t.E.WZ,t.E.V6),1b=ZC.BN(t.E.WZ,t.E.V6)-ZC.CV(t.E.WZ,t.E.V6);1b<2&&(1b=2),r+C===0&&(u-=.5,p+=1),t.I=p,t.F=1b,t.iX=u,t.E.jw=h+1b/2,t.bQ({x:u,y:h,w:p,h:1b});1a d;if(t.AL){d=ZC.P.E6(t.H.2L()?t.H.K+"-3X-c":t.H.K3?t.C.K+"-4j-bl-c":t.C.K+"-1B-"+t.A.L+"-bl-1-c",t.H.AB);1a f=t.iX+t.I/2;t.DL[2]<t.AE&&(e=t.A.o["7h-ag"])?(t.E[ZC.1b[73]]=e[ZC.1b[73]],t.E[ZC.1b[72]]=e[ZC.1b[72]]):t.DL[2]>t.AE&&(e=t.A.o["7h-up"])?(t.E[ZC.1b[73]]=e[ZC.1b[73]],t.E[ZC.1b[72]]=e[ZC.1b[72]]):t.DL[2]===t.AE&&(e=t.A.o["7h-ab"])&&(t.E[ZC.1b[73]]=e[ZC.1b[73]],t.E[ZC.1b[72]]=e[ZC.1b[72]]);1a g,B=t.A.I1(t,t.IR);1P(t.A.CS){2n:(g=[]).1i([f,t.E.mJ],[f,ZC.CV(t.E.WZ,t.E.V6)],1c,[f,t.E.iV],[f,ZC.BN(t.E.WZ,t.E.V6)]),ZC.CN.1v(d,B,g);1a v,b;b=t.DL[2]<t.AE?t.A.Gb:t.DL[2]>t.AE?t.A.Gd:t.A.Fq,0!==t.A.E4.1h||1w b===ZC.1b[31]||t.N.o.7c||t.C.KM?(v=1n ZC.HQ(t.A)).1Q(B):v=b,t.H9(v),v.Z=t.A.CL("bl",1),v.C5=t.A.CL("bl",0),v.K=t.K,v.iX=u,v.iY=h,v.I=t.I,v.F=t.F,v.1v(),0!==t.A.E4.1h||1w b!==ZC.1b[31]||t.N.o.7c||t.C.KM||(t.DL[2]<t.AE?t.A.Gb=v:t.DL[2]>t.AE?t.A.Gd=v:t.A.Fq=v);1p;1j"17X":1j"17N":(g=[]).1i([f,t.E.mJ],[f,t.E.iV],1c,[f-t.I/4,t.E.WZ],[f,t.E.WZ],1c,[f+t.I/4,t.E.V6],[f,t.E.V6]),t.H9(B),ZC.CN.1v(d,B,g)}if(t.A.FT){1a E=t.C.K+ZC.1b[34]+t.C.K+ZC.1b[35]+t.A.L+ZC.1b[6];t.A.A.HK.1i(ZC.P.GC("5t",t.A.E5,t.A.IM)+\'3g="\'+E+\'" id="\'+t.K+ZC.1b[30]+ZC.1l(u+ZC.3y)+","+ZC.1l(t.E.mJ+ZC.3y)+","+ZC.1l(u+p+ZC.3y)+","+ZC.1l(t.E.iV+ZC.3y)+\'" />\')}t.A.U&&t.A.U.AL&&t.H5()}},6e:1f(){1a e=1g;if(!ZC.3l&&e.A.I7&&e.A.AL)1P(e.b(),e.A.CS){1j"Gj":1a t=1n ZC.HQ(e.A);t.K=e.K+"-2J",t.Z=ZC.AK(e.C.K+ZC.1b[22]),t.BZ=e.A.BO[0],t.AC=e.A.BO[3],t.B6=e.A.BO[1],t.BU=e.A.BO[1],t.A0=e.A.BO[2],t.1C(e.A.I7.o),t.PR=!0,t.1q(),t.JC=1f(t){1m e.JC(t)},t.DD()&&t.1q(),e.DL[2]<e.AE&&(t.A0=t.AC=t.BZ,t.BU=t.B6),e.DL[2]<e.AE&&e.A.o["7h-ag"]?(t.1C(e.A.o["7h-ag"]),t.1C(e.A.o[ZC.1b[71]]),e.A.o["7h-ag"][ZC.1b[71]]&&t.1C(e.A.o["7h-ag"][ZC.1b[71]]),t.1q()):e.DL[2]>e.AE&&e.A.o["7h-up"]?(t.1C(e.A.o["7h-up"]),t.1C(e.A.o[ZC.1b[71]]),e.A.o["7h-up"][ZC.1b[71]]&&t.1C(e.A.o["7h-up"][ZC.1b[71]]),t.1q()):e.DL[2]===e.AE&&e.A.o["7h-ab"]&&(t.1C(e.A.o["7h-ab"]),t.1C(e.A.o[ZC.1b[71]]),e.A.o["7h-ab"][ZC.1b[71]]&&t.1C(e.A.o["7h-ab"][ZC.1b[71]]),t.1q()),t.iX=e.5J("x"),t.iY=e.5J("y"),t.I=e.5J("w"),t.F=e.5J("h");1a i=e.C.Q;t.iY<i.iY&&(t.F=t.F-(i.iY-t.iY),t.iY=i.iY),t.iY+t.F>i.iY+i.F&&(t.F=i.iY+i.F-t.iY),t.AL&&t.1v()}}}),ZC.Gq=ZC.M5.C7({2E:1f(){1a e=1g,t=e.C.BL(e.A.BT("k")[0]),i=e.C.BL(e.A.BT("v")[0]),n=e.L%t.GT,a=1A.4i(e.L/t.GT),l=i.EM/(i.BS-i.B8);e.iX=t.iX+n*t.GF+t.GF/2,e.iY=t.iY+a*t.G7+t.G7/2,e.E.2c=i.DM-i.EM/2+l*(e.AE-i.B8),i.AR&&(e.E.2c=i.DM+i.EM/2-l*(e.AE-i.B8)),e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0)},7n:1f(e){1a t,i,n,a=e.I,l=e.F,o=1g,r=o.C.BL(o.A.BT("k")[0]),C=ZC.CV(r.GF/2,r.G7/2)*r.JI,A=o.L%r.GT,s=1A.4i(o.L/r.GT),Z=r.iX+A*r.GF+r.GF/2+r.BJ,c=r.iY+s*r.G7+r.G7/2+r.BD;1P(e.o[ZC.1b[7]]){1j"3E":i=Z-a/2+o.BJ,n=c-l/2+o.BD;1p;1j"18d":i=(t=ZC.AN.BM(Z,c,C+e.DR,o.E.2c))[0]-a/2+o.BJ,n=t[1]-l/2+o.BD;1p;1j"mL":i=(t=ZC.AN.BM(Z,c,o.E[ZC.1b[21]]+e.DR,o.E.2c))[0]-a/2+o.BJ,n=t[1]-l/2+o.BD;1p;2n:i=(t=ZC.AN.BM(Z,c,C/2+e.DR,o.E.2c))[0]-a/2+o.BJ,n=t[1]-l/2+o.BD}1m 1c!==ZC.1d(e.o.x)&&(i=e.iX),1c!==ZC.1d(e.o.y)&&(n=e.iY),[ZC.1l(i),ZC.1l(n)]},82:1f(){1m{1r:1g.A0}},XP:1f(){1m{"1R-1r":1g.A0,"1F-1r":1g.B6,1r:1g.BZ}},1v:1f(){1f e(e){1a t=[],a=n.A.HL;a[4]>-1&&a[4]<1&&(a[4]=ZC.1l(a[4]*l));1a o=ZC.AN.BM(C,A,a[4],e);if(a[0]>=0)1k(i=-a[2];i<=180+a[2];i+=5)t.1i(ZC.AN.BM(o[0],o[1],a[0],e+3T-i));1t t.1i(ZC.AN.BM(o[0],o[1],ZC.2i(a[0]),e-90)),t.1i(ZC.AN.BM(o[0],o[1],ZC.2i(a[0]),e+90));if(0===a[1])t.1i(ZC.AN.BM(C,A,s>0?s:.9*l,e));1t if(a[1]>0)1k(o=ZC.AN.BM(C,A,s>0?s:.9*l,e),i=-a[3];i<=180+a[3];i+=5)t.1i(ZC.AN.BM(o[0],o[1],a[1],e-3T-i));1t o=ZC.AN.BM(C,A,(s>0?s:.9*l)+a[1],e),t.1i(ZC.AN.BM(o[0],o[1],ZC.2i(a[1]/(90/a[3])),e+90),ZC.AN.BM(o[0],o[1],ZC.2i(a[1]),e+90),ZC.AN.BM(C,A,s>0?s:.9*l,e),ZC.AN.BM(o[0],o[1],ZC.2i(a[1]),e+3T),ZC.AN.BM(o[0],o[1],ZC.2i(a[1]/(90/a[3])),e+3T));1m t.1i([t[0][0],t[0][1]]),t}1f t(){1a e=c.FB(),t=n.C.K+ZC.1b[34]+n.C.K+ZC.1b[35]+n.A.L+ZC.1b[6],i=ZC.P.GC("4x",n.A.E5,n.A.IM)+\'3g="\'+t+\'" id="\'+n.K+ZC.1b[30]+e+\'" />\';n.A.A.HK.1i(i)}1a i,n=1g;n.b(),n.2E(),n.CX=!1;1a a=n.C.BL(n.A.BT("k")[0]),l=ZC.CV(a.GF/2,a.G7/2)*a.JI,o=n.L%a.GT,r=1A.4i(n.L/a.GT),C=a.iX+o*a.GF+a.GF/2+a.BJ,A=a.iY+r*a.G7+a.G7/2+a.BD,s=ZC.IB(n.A.o[ZC.1b[21]]||"0.9",!1);s>0&&s<=1&&(s*=l),n.E[ZC.1b[21]]=s;1a Z=n.N=n.A.I1(n,n),c=1n ZC.DS(n.A);c.1Q(Z),c.Z=n.A.CL("bl",1),c.C5=n.A.CL("bl",0),c.K=n.K+"-7G";1a u=n.C.BL(n.A.BT("v")[0]),p=u.DM-u.EM/2,h=e(n.E.2c);if(n.E.2S=h,c.DP="4x",c.D=h,c.1q(),c.JC=1f(e){1m n.JC(e)},c.DD()&&c.1q(),n.A.GA&&!n.C.HC){1a 1b,d=c,f={},g=n.A.L6;d.C6=0,f.2k=Z.C6,2===g&&(d.mM=p,f.mM=n.E.2c);1k(1b in n.A.FR)d[ZC.E8.GI[ZC.EB(1b)]]=n.A.FR[1b],f[ZC.EB(1b)]=Z[ZC.E8.GI[ZC.EB(1b)]];if(n.C.EN||(n.C.EN={}),1c!==ZC.1d(n.C.EN[n.A.L+"-"+n.L]))1k(1b in n.C.EN[n.A.L+"-"+n.L]){1a B=ZC.E8.GI[ZC.EB(1b)];1c===ZC.1d(B)&&(B=1b),d[B]=n.C.EN[n.A.L+"-"+n.L][1b]}n.C.EN[n.A.L+"-"+n.L]={},ZC.2A(f,n.C.EN[n.A.L+"-"+n.L]);1a v=1n ZC.E8(d,f,n.A.J9,n.A.L2,ZC.E8.RJ[n.A.L4],1f(){t()});v.AV=n,v.ju=1f(t,i){1c!==ZC.1d(i.mM)&&(t.D=e(i.mM))},n.LL(v),n.A.U&&n.H5()}1t c.1v(),n.A.U&&n.H5(),t()},6e:1f(e){1a t=1g;ZC.3l||t.M2({6r:e,1I:"2P",92:1f(){1g.1Q(t),1g.B6=t.A.BO[1],1g.BU=t.A.BO[1],1g.A0=t.A.BO[3],1g.AC=t.A.BO[2],1g.D=t.E.2S,1g.Z=1g.C5=t.A.CL("bl",2)}})}}),ZC.Gt=ZC.M5.C7({$i:1f(e){1g.b(e);1a t=1g;t.CQ=1c,t.CT=1c,t.MF="2h"},KC:1f(e,t,i,n){1a a=1g;1m a.CR=[["%5y-mR",a.MF],["%2o-2h-1S",a.CQ],["%2o-1V-1S",a.CT]],e=a.b(e,t,i,n)},7j:1f(){1a e,t,i=1g;i.o[ZC.1b[9]][1]3z 3K?("2Y"==1w i.o[ZC.1b[9]][0]?-1!==(t=ZC.AT(i.A.B0.IH,i.o[ZC.1b[9]][0]))?i.BX=t:(i.A.B0.IH.1i(i.o[ZC.1b[9]][0]),i.BX=i.A.B0.IH.1h-1):i.BX=ZC.1W(i.o[ZC.1b[9]][0]),1c!==i.BX&&(1c!==ZC.1d(i.A.JW[i.BX])&&-1!==ZC.AT(i.A.JW[i.BX],i.L)||i.A.UT(i.BX,i.L)),e=i.o[ZC.1b[9]][1]):e=i.o[ZC.1b[9]],"2Y"==1w e[0]?-1!==(t=ZC.AT(i.A.CI.JF,e[0]))?i.CQ=t:(i.A.CI.JF.1i(e[0]),i.CQ=i.A.CI.JF.1h-1):i.CQ=ZC.1W(e[0]),i.DL.1i(i.CQ),"2Y"==1w e[1]?-1!==(t=ZC.AT(i.A.CI.JF,e[1]))?i.CT=t:(i.A.CI.JF.1i(e[1]),i.CT=i.A.CI.JF.1h-1):i.CT=ZC.1W(e[1]),i.CJ=e.2I(" "),i.AE=i.CT},2E:1f(){1a e=1g,t=e.A.OK,i=e.A.B0,n=e.A.CI,a=[i.X,i.A1,n.X,n.A1,e.MF];1c===ZC.1d(e.AG)&&(e.AG=[]),e.JH!==a&&(t?(1c!==e.BX?e.iY=i.B2(e.BX):e.iY=i.I3(e.L),e.iX=n.B2("2h"===e.MF?e.CQ:e.CT)):(1c!==e.BX?e.iX=i.B2(e.BX):e.iX=i.I3(e.L),e.iY=n.B2("2h"===e.MF?e.CQ:e.CT)),e.JH=a),e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(),e.E.N5=n.B2(e.CQ),e.E.QZ=n.B2(e.CT),e.HS=!0)},82:1f(){1m{1r:1g.B6}},XP:1f(){1m{"1R-1r":1g.B6,"1F-1r":1g.B6,1r:1g.BZ}},1v:1f(){1a e,t=1g;t.b();1a i=t.A.B0,n=t.A.Q0,a=t.A.OK,l=t.A.S;t.2E(),1c!==ZC.1d(t.A.o[t.MF+"-1y"])&&(t.1C(t.A.o[t.MF+"-1y"]),t.1q()),t.CX=!1,t.C5=t.A.CL("bl",1);1a o,r,C,A,s,Z,c,u,p,h,1b,d,f,g=[],B=[];1P(t.A.CS){2n:1a v=!0;!i.EC&&t.L<=i.X&&(v=!1),l[t.L-t.A.Y]||(v=!1),v&&(l[t.L-t.A.Y].MF=t.MF,l[t.L-t.A.Y].2E(),a?(r=[t.E.N5,t.iY],C=[l[t.L-t.A.Y].E.N5,l[t.L-t.A.Y].iY],A=[t.E.QZ,t.iY],s=[l[t.L-t.A.Y].E.QZ,l[t.L-t.A.Y].iY],Z=ZC.AN.hO(r,C,A,s),o=ZC.DU(Z[1],l[t.L-t.A.Y].iY,t.iY)?Z:ZC.AN.JK(l[t.L-t.A.Y].iX,l[t.L-t.A.Y].iY,l[t.L].iX,l[t.L].iY),B.1i([o[0],ZC.1l(o[1])]),g.1i([o[0],o[1]])):(r=[t.iX,t.E.N5],C=[l[t.L-t.A.Y].iX,l[t.L-t.A.Y].E.N5],A=[t.iX,t.E.QZ],s=[l[t.L-t.A.Y].iX,l[t.L-t.A.Y].E.QZ],Z=ZC.AN.hO(r,C,A,s),o=ZC.DU(Z[0],l[t.L-t.A.Y].iX,t.iX)?Z:ZC.AN.JK(l[t.L-t.A.Y].iX,l[t.L-t.A.Y].iY,l[t.L].iX,l[t.L].iY),B.1i([ZC.1l(o[0]),o[1]]),g.1i([o[0],o[1]]))),a?B.1i([t.iX,ZC.1l(t.iY)]):B.1i([ZC.1l(t.iX),t.iY]),g.1i([t.iX,t.iY]);1a b=!0;!i.EC&&t.L>=i.A1&&(b=!1),l[t.L+t.A.Y]||(b=!1),b&&(l[t.L+t.A.Y].MF=t.MF,l[t.L+t.A.Y].2E(),a?(r=[t.E.N5,t.iY],C=[l[t.L+t.A.Y].E.N5,l[t.L+t.A.Y].iY],A=[t.E.QZ,t.iY],s=[l[t.L+t.A.Y].E.QZ,l[t.L+t.A.Y].iY],Z=ZC.AN.hO(r,C,A,s),o=ZC.DU(Z[1],l[t.L+t.A.Y].iY,t.iY)?Z:ZC.AN.JK(l[t.L].iX,l[t.L].iY,l[t.L+t.A.Y].iX,l[t.L+t.A.Y].iY),B.1i([o[0],ZC.1l(o[1])]),g.1i([o[0],o[1]])):(r=[t.iX,t.E.N5],C=[l[t.L+t.A.Y].iX,l[t.L+t.A.Y].E.N5],A=[t.iX,t.E.QZ],s=[l[t.L+t.A.Y].iX,l[t.L+t.A.Y].E.QZ],Z=ZC.AN.hO(r,C,A,s),o=ZC.DU(Z[0],l[t.L+t.A.Y].iX,t.iX)?Z:ZC.AN.JK(l[t.L].iX,l[t.L].iY,l[t.L+t.A.Y].iX,l[t.L+t.A.Y].iY),B.1i([ZC.1l(o[0]),o[1]]),g.1i([o[0],o[1]])));1p;1j"4V":if(1w t.E["d6.2V"]===ZC.1b[31]&&(t.E["d6.2V"]=-1,l[t.L+t.A.Y])){1a E=[],m=[],K=[];1k(c=-1;c<3;c++)l[t.L+c]?(l[t.L+c].2E(),E.1i(l[t.L+c].E.N5),K.1i(l[t.L+c].E.QZ),a?m.1i(l[t.L+c].iY):m.1i(l[t.L+c].iX)):(E.1i(t.E.N5),K.1i(t.E.QZ),a?m.1i(t.iY):m.1i(t.iX));p=ZC.2i(m[2]-m[1]);1a F=ZC.AN.XZ(t.A.Q3,E,ZC.1l(p)),D=ZC.AN.XZ(t.A.Q3,K,ZC.1l(p));if(l[t.L+t.A.Y].CQ===l[t.L+t.A.Y].CT)t.E["d6.2V"]=F.1h;1t{1a I=F[0][1]-D[0][1];1k(c=1,u=F.1h;c<u;c++)if(1A.43(I*(F[c][1]-D[c][1]),2)<=0){t.E["d6.2V"]=c+1;1p}}t.E["4V.2S.2h"]=F,t.E["4V.2S.1V"]=D,t.E["4V.uO"]=p}p=t.E["4V.uO"]||i.A9,1c===ZC.1d(t.A.ZG)&&(t.A.ZG={}),1c===ZC.1d(t.A.S1)&&(t.A.S1={});1a X=[],x=[];if("2h"===t.MF){if(1c!==ZC.1d(e=t.A.S1.1V))1k(c=e.1h-1;c>=0;c--)t.AG.1i(t.A.S1.1V[c]);if(1c!==ZC.1d(e=t.A.S1.2h))1k(c=0,u=e.1h;c<u;c++)t.AG.1i(e[c])}if(1c!==ZC.1d(e=t.A.ZG[t.MF]))1k(g=[],c=0,u=e.1h;c<u;c++)g.1i(e[c]);if(l[t.L+t.A.Y]){"2h"===t.MF?h=t.E["4V.2S.2h"]:"1V"===t.MF&&(h=t.E["4V.2S.1V"]),1b=-1===t.E["d6.2V"]?ZC.1l(h.1h/2):t.E["d6.2V"];1a y=a?i.AR?1:-1:i.AR?-1:1;1k(c=0;c<1b;c++)a?(g.1i([h[c][1],t.iY+y*h[c][0]*p]),B.1i([h[c][1],ZC.1l(t.iY+y*h[c][0]*p)])):(g.1i([t.iX+y*h[c][0]*p,h[c][1]]),B.1i([ZC.1l(t.iX+y*h[c][0]*p),h[c][1]]));1a L=1===t.HM?ZC.CV(2,1b):1;1k(c=1b-1,u=h.1h;c<u;c++)a?X.1i([h[c][1],t.iY+y*h[c][0]*p]):X.1i([t.iX+y*h[c][0]*p,h[c][1]]);1k(c=1b-L,u=h.1h;c<u;c++)a?x.1i([h[c][1],ZC.1l(t.iY+y*h[c][0]*p)]):x.1i([ZC.1l(t.iX+y*h[c][0]*p),h[c][1]])}1t g.1i([l[t.L].iX,l[t.L].iY]),a?(X.1i([l[t.L].iX,ZC.1l(l[t.L].iY)]),B.1i([l[t.L].iX,ZC.1l(l[t.L].iY)]),x.1i([l[t.L].iX,ZC.1l(l[t.L].iY)])):(X.1i([ZC.1l(l[t.L].iX),l[t.L].iY]),B.1i([ZC.1l(l[t.L].iX),l[t.L].iY]),x.1i([ZC.1l(l[t.L].iX),l[t.L].iY]));t.A.ZG[t.MF]=X,t.A.S1[t.MF]=x}if("2h"===t.MF)1k(c=0,u=B.1h;c<u;c++)t.AG.1i(B[c]);1t 1k(c=B.1h-1;c>=0;c--)t.AG.1i(B[c]);if("1V"===t.MF){1a Y=1n ZC.DS(t.A);Y.K=t.K+"-1M",Y.Z=t.A.CL("bl",0),Y.1Q(t),Y.AY=0,Y.AQ=0,Y.EW=0,Y.G4=0,Y.1q(),Y.D=t.AG,Y.C6=t.A.HM;1a w=t.C.Q;1k(Y.CY=[w.iX,w.iY,w.iX+w.I,w.iY+w.F],Y.1v(),t.E.9U=[],c=0,u=t.AG.1h;c<u;c++)t.E.9U.1i(t.AG[c]);t.AG=[],t.A.FT&&(f=Y.FB(),d=t.C.K+ZC.1b[34]+t.C.K+"-1B-"+t.A.L+ZC.1b[6],t.A.A.HK.1i(ZC.P.GC("4x",t.A.E5,t.A.IM)+\'3g="\'+d+\'" id="\'+t.K+"--1M"+ZC.1b[30]+f+\'" />\'))}"2h"===t.MF?t.E.2S=g:(t.E.2S.1i(1c),t.E.2S=t.E.2S.4w(g));1a M=1n ZC.CZ(t);M.1Q(t),M.1C(t.A.o[t.MF+"-1y"]),M.1q(),ZC.CN.2E(n,M),ZC.CN.1v(n,M,g),"1V"===t.MF&&t.9A(t,t.E.2S,t.E.9U);if(a?ZC.DU(t.iY,i.iY-1,i.iY+i.F+1)&&ZC.DU(t.iX,i.iX-1,i.iX+i.I+1):ZC.DU(t.iX,i.iX-1,i.iX+i.I+1)&&ZC.DU(t.iY,i.iY-1,i.iY+i.F+1)){1a H=1n ZC.DS(t.A);H.K=t.K+"-1O-"+t.MF,H.Z=H.C5=t.A.CL("fl",0),H.iX=t.iX,H.iY=t.iY,H.B6=t.A.BO[3],H.BU=t.A.BO[3],H.A0=t.A.BO[2],H.AC=t.A.BO[2],H.1C(t.A.A2.o),t.A.o[t.MF+"-1O"]&&H.1C(t.A.o[t.MF+"-1O"]),H.1q(),H.JC=1f(e){1m t.JC(e)},H.DD()&&H.1q(),H.AL&&"1Z"!==H.AF&&(t.A.MN>i.A1-i.X&&H.1v(),t.E["1O.1I"]=H.DP,d=t.C.K+ZC.1b[34]+t.C.K+ZC.1b[35]+t.A.L+ZC.1b[6],i.AR&&g.9m(),t.A.FT&&(""!==(f=ZC.AN.PO(ZC.AN.YU(t.E.2S),4))?t.A.A.HK.1i(ZC.P.GC("4x",t.A.E5,t.A.IM)+\'3g="\'+d+\'" id="\'+t.K+"--"+t.MF+ZC.1b[30]+f+\'" />\'):t.A.A.HK.1i(ZC.P.GC("3x",t.A.E5,t.A.IM)+\'3g="\'+d+\'" id="\'+t.K+"--"+t.MF+ZC.1b[30]+ZC.1l(H.iX+ZC.3y)+","+ZC.1l(H.iY+ZC.3y)+","+ZC.1l(1.5*ZC.BN(3,H.AH))+\'" />\'))),t.A.U&&t.A.U.AL&&t.H5()}},9A:1f(e,t,i){1a n=1g;if(n.C.BI&&n.C.BI.HS&&n.A.RH){1a a=n.C.Q,l=n.C.BI,o=n.A.az(i),r=1n ZC.DS(n.A);r.1Q(e),r.CX=!0,r.L1=!0,r.AY=0,r.AQ=0,r.EW=0,r.G4=0,r.C6=n.A.HM,r.CY=[a.iX,a.iY,a.iX+a.I,a.iY+a.F],r.K=n.K+"-1M-2w",r.Z=l.Z,r.D=o,r.1v();1a C,A=n.A.az(t);n.A.VH?C=n.A.VH:(C=1n ZC.CZ(n),n.A.VH=C),C.1Q(e);1a s=ZC.P.E6(l.Z,n.H.AB);C.AY=1,ZC.CN.1v(s,C,A,1c,3)}},6e:1f(){1a e=1g,t=e.A.OK;if(!ZC.3l){1a i=e.A.B0;if(e.A.G6&&e.A.AL){1a n=ZC.P.E6(e.C.K+ZC.1b[22],e.H.AB),a=1n ZC.DS(e.A);if(a.K=e.K+"-1M-2J",a.Z=ZC.AK(e.C.K+ZC.1b[22]),a.L1=!0,a.1Q(e),a.1C(e.A.I7.o),a.D=e.E.9U,a.1q(),a.AL){a.C6=e.A.HM;1a l=e.C.Q;a.CY=[l.iX,l.iY,l.iX+l.I,l.iY+l.F],ZC.CN.2E(n,a),a.1v()}1a o=ZC.P.E6(e.C.K+ZC.1b[22],e.H.AB),r=1n ZC.CZ(e.A);r.K=e.K+"-1y-2J",r.CX=!1,r.B6=e.A.BO[3],r.1C(e.A.I7.o),r.1q(),r.JC=1f(t){1m e.JC(t)},r.DD()&&r.1q(),r.AL&&(ZC.CN.2E(o,r),ZC.CN.1v(o,r,e.E.2S))}if(e.A.MN>i.A1-i.X&&e.A.G6&&e.A.AL){e.b();1a C=1n ZC.DS(e.A);C.K=e.K+"-1O-1V-2J",C.Z=ZC.AK(e.C.K+ZC.1b[22]),C.DP=e.E["1O.1I"],t?(C.iY=e.iY,C.iX=e.E.QZ):(C.iX=e.iX,C.iY=e.E.QZ),C.B6=e.A.BO[3],C.BU=e.A.BO[3],C.A0=e.A.BO[2],C.AC=e.A.BO[2],C.1C(e.A.G6.o),C.1q(),C.JC=1f(t){1m e.JC(t)},C.DD()&&C.1q(),C.AL&&"1Z"!==C.AF&&C.1v(),C.K=e.K+"-1O-2h-2J",t?C.iX=e.E.N5:C.iY=e.E.N5,C.AL&&"1Z"!==C.AF&&C.1v()}}}}),ZC.ux=ZC.M5.C7({U:1c,$i:1f(e){1g.b(e),1g.U=1c},1q:1f(){1g.b()},iF:1f(){1g.b();1a e=1g,t=e.C.E;t.3O.8o=t.3O["2o-8k-1S"]=e.KC("%8o")},KC:1f(e,t,i,n){1a a=1g,l=a.A.MG();ZC.2A(t,l),-1===e.1K("%8o")&&-1===e.1K("%2o-8k-1S")||1c!==ZC.1d(l[ZC.1b[12]])&&-1!==l[ZC.1b[12]]||(l[ZC.1b[12]]=1);1a o=0,r="0";if(a.A.A.KF[a.L]>0&&(r=""+(o=100*a.AE/a.A.A.KF[a.L])),a.A.A.A7.1h>1&&a.A.L===a.A.A.A7.1h-1){1a C=0;if(1c===ZC.1d(a.A.o.iD)){1k(1a A=0;A<a.A.A.A7.1h-1;A++)if(a.A.A.A7[A].AL){1a s=0,Z="0";a.A.A.KF[a.L]>0&&(Z=""+(s=100*a.A.A.A7[A].S[a.L].AE/a.A.A.KF[a.L])),1c!==ZC.1d(l[ZC.1b[12]])&&(Z=s.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]])))),C+=ZC.1W(Z)}r=""+(o=1A.1V(0,100-C))}}1c!==ZC.1d(l[ZC.1b[12]])&&(r=o.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]]))));1a c=ZC.1W(a.A.A.KF[a.L]||"0"),u=""+c;1m 1c!==ZC.1d(l[ZC.1b[12]])&&(u=c.4v(ZC.BN(0,ZC.1l(l[ZC.1b[12]])))),a.CR=[["%2o-8k-1S",r],["%8o",r],["%3L-6i-1S",u]],e=a.b(e,t,i,n)},UX:1f(e){1a t,i=1g,n=(i.B1+i.BH)/2%2j,a=0;1c!==ZC.1d(t=e["1Y-r"])&&(a=ZC.1W(ZC.8C(t))),a<1&&(a*=i.AH);1a l=1n ZC.CF(i.C,(i.CK+.5*(i.AH-i.CK)+i.DR+a)*ZC.ED(n),(i.CK+.5*(i.AH-i.CK)+i.DR+a)*ZC.EL(n),0).E9;1m[l[0],l[1],{cB:i,3E:!0}]},2E:1f(){1a e=1g,t=e.C.BL(e.A.BT("k")[0]),i=e.L%t.GT,n=1A.4i(e.L/t.GT);e.iX=t.iX+i*t.GF+t.GF/2+t.BJ,e.iY=t.iY+n*t.G7+t.G7/2+t.BD,e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(),e.HS=!0)},82:1f(e){1a t={},i="4R";1m 1c!==ZC.1d(e.o[ZC.1b[7]])&&(i=e.o[ZC.1b[7]]),t.1r="4R"===i?1g.A0:1g.BZ,t},7n:1f(e){1a t,i=1g,n="4R";1c!==ZC.1d(t=e.o[ZC.1b[7]])&&(n=t);1a a,l,o,r,C,A=e.I,s=e.F,Z=(i.B1+i.BH)/2%2j,c=Z;if("4R"===n){Z=c=i.A.A.Y4["n"+i.L][i.A.L];1a u=1f(t,n){n<0&&(n=2j+n),n%=2j;1a a=ZC.AN.BM(i.iX,i.iY,t+i.DR+e.DR+20,n);C=1n ZC.CF(i.C,a[0]-ZC.AM.E1,a[1]-ZC.AM.E0,0),a[0]=C.E9[0],a[1]=C.E9[1];1a l=a[0]+e.BJ-A/2,o=a[1]+e.BD-s/2;1m n>=0&&n<=90||n>=3T&&n<=2j?l+=A/2+10:l-=A/2+10,[l,o]},p=u(i.AH,c);a=p[0],l=p[1],i.U=e;1a h={x:a,y:l,1s:A,1L:s},1b=1o.3G.tN;r=!0;1k(1a d=0,f=0,g=-1,B=0,v=0;r&&v<iv;){r=!1;1k(1a b=0,E=i.A.A.TQ.1h;b<E;b++)o=i.A.A.TQ[b],(ZC.AN.XG(h,o)||h.x+e.I>i.C.Q.iX+i.C.Q.I||h.x<i.C.Q.iX||h.y+e.F>i.C.Q.iY+i.C.Q.F||h.y<i.C.Q.iY)&&(r=!0,0===1b?(d+=.4,g*=-1):1===1b&&(f+=1),p=u(i.AH+f,c+d*g),h.x=p[0],h.y=p[1],v++,++B>100&&(B=0,0===1b?(d=0,f+=4):1===1b&&(f=0,d+=1,g*=-1)))}a=h.x,l=h.y,Z=c+d,o={1D:i.A.AP,x:h.x,y:h.y,1s:A,1L:s,3S:i.A.L,5Q:i.L},i.A.A.TQ.1i(o)}1t if("in"===n){1a m=i.CK<30?.65:.5,K=ZC.AN.BM(i.iX,i.iY,i.CK+m*(i.AH-i.CK)+i.DR+e.DR,Z);C=1n ZC.CF(i.C,K[0]-ZC.AM.E1,K[1]-ZC.AM.E0,0),K[0]=C.E9[0],K[1]=C.E9[1],a=K[0]+e.BJ-A/2,l=K[1]+e.BD-s/2}1t"3E"===n&&(a=(C=1n ZC.CF(i.C,i.iX-ZC.AM.E1,i.iY-ZC.AM.E0,0)).E9[0]+e.BJ-A/2,l=C.E9[1]+e.BD-s/2);1m r&&(a=-6J,l=-6J,e.AL=!1),1c!==ZC.1d(e.o.x)&&(a=e.iX),1c!==ZC.1d(e.o.y)&&(l=e.iY),a>=-2&&(a=ZC.2i(a)),l>=-2&&(l=ZC.2i(l)),[ZC.1l(a),ZC.1l(l),Z]},H5:1f(e,t){1a i,n=1g,a=n.b(e,t);if(e)1m a;if(n.AL&&a.AL&&1c!==ZC.1d(a.AP)&&""!==a.AP){1a l="4R";if(1c!==ZC.1d(a.o[ZC.1b[7]])&&(l=a.o[ZC.1b[7]]),"4R"===l){1a o=!0;if(1c!==ZC.1d(i=a.o.uy)&&(o=ZC.2q(i)),o){1a r=1n ZC.DS(n.A);r.Z=r.C5=n.A.CL("bl",0),r.1C(n.A.C0.o),r.B6=n.A0,r.DP="1y",r.D=[];1a C=a.E.tT,A=(n.B1+n.BH)/2%2j,s=0;A>=0&&A<=180&&(s=n.E.tJ/2);1a Z=ZC.AN.BM(n.iX,n.iY,n.AH+n.DR+a.DR,A);(Z=1n ZC.CF(n.C,Z[0]-ZC.AM.E1,Z[1]-ZC.AM.E0,s).E9)[0]+=n.BJ,Z[1]+=n.BD,r.D.1i(Z);1a c=ZC.AN.BM(n.iX,n.iY,n.AH+n.DR+a.DR+20,A);(c=1n ZC.CF(n.C,c[0]-ZC.AM.E1,c[1]-ZC.AM.E0,s).E9)[0]+=n.BJ,c[1]+=n.BD,a.iX>=n.iX?r.D.1i([c[0],c[1],C[0],C[1]+a.F/2]):r.D.1i([c[0],c[1],C[0]+a.I+2,C[1]+a.F/2]),r.1q(),r.JC=1f(e){1m n.JC(e)},r.DD()&&r.1q(),r.AL&&r.1v()}}}},1v:1f(){1a e,t,i,n,a,l,o,r,C,A=1g,s=A.C.CH,Z=A.C.BL(A.A.BT("k")[0]),c=A.C.F7[ZC.1b[27]],u=A.C.F7[ZC.1b[28]];A.2E();1a p="3L-fU-"+A.A.L+"-"+A.L;if(A.o.ug&&1w A.C.E[p]===ZC.1b[31]&&(A.C.E[p]=!0),!(A.AE<0)){1a h=ZC.BN(.7,ZC.ED(c));A.AH=ZC.CV(Z.G7/h,Z.GF)/2,1c!==ZC.1d(A.A.o[ZC.1b[21]])?A.AH=A.A.AH:A.AH=Z.JI*A.AH,A.CK<1&&(A.CK*=A.AH),A.CK=1A.1V(0,A.CK),A.o[ZC.1b[8]]=A.CK,A.DR<1&&(A.DR*=A.AH),A.o["1Y-r"]=A.DR;1a 1b=A.A.NG;-1===1b&&(1b=A.AH/5),A.E.tJ=1b;1a d=A.iX-ZC.AM.E1,f=A.iY-ZC.AM.E0;A.B1=ZC.1l(A.B1),A.BH=ZC.1l(A.BH);1a g=(A.B1+A.BH)/2;A.C.E[p]&&(A.DR+=ZC.1l(.15*A.AH)),A.DR>0&&(d+=A.DR*ZC.ED(g),f+=A.DR*ZC.EL(g));1a B=A.N=A.A.I1(A,A);B.DJ=A.K+"-gY";1a v=1n ZC.CZ(A);if(v.1Q(B),v.A0=ZC.AO.JE(ZC.AO.G3(v.A0)),v.AC=ZC.AO.JE(ZC.AO.G3(v.AC)),A.AE>=0||0===A.A.A.KF[A.L]){1k(o=[],e=A.B1,o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),0]),e=A.B1;e<=A.BH;e+=1)o.1i([d+A.AH*ZC.ED(e),f+A.AH*ZC.EL(e),0]);1k(e=A.BH,o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),0]),e=A.BH;e>=A.B1;e-=1)o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),0]);if(t=ZC.DF.D6(B,A.C,o),t.K=A.K+"-bY",s.2N(t),i=1c,A.B1%2j>=0+u&&A.B1%2j<180+u||A.BH%2j>0+u){r=A.B1,C=A.BH;1a b=1f(e,t,n){1a a,l=[];1k(a=e,l.1i([d+A.AH*ZC.ED(a),f+A.AH*ZC.EL(a),0]),a=e;a<=t;a+=1)l.1i([d+A.AH*ZC.ED(a),f+A.AH*ZC.EL(a),0]);1k(a=t,l.1i([d+A.AH*ZC.ED(a),f+A.AH*ZC.EL(a),1b]),a=t;a>=e;a-=1)l.1i([d+A.AH*ZC.ED(a),f+A.AH*ZC.EL(a),1b]);(i=ZC.DF.D6(v,A.C,l)).M9=[.8E,1,1,1],i.K=A.K+"-bX"+n,s.2N(i)};r<180&&C>2j?(b(r=r<0?r+2j:r,180,1),b(2j,C,2)):(r=ZC.BN(r,C>2j?uf:5),(C=ZC.CV(C,C>2j?17R:175))>r&&b(r,C,1))}if(l=1c,A.CK>0+u&&A.BH>180+u){1k(o=[],e=A.B1,r=A.B1,A.B1<180+u&&A.BH>180+u&&(e=180+u,r=180+u),o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),0]),e=r;e<=A.BH;e+=1)o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),0]);1k(e=A.BH,o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),1b]),e=A.BH;e>=r;e-=1)o.1i([d+A.CK*ZC.ED(e),f+A.CK*ZC.EL(e),1b]);(l=ZC.DF.D6(v,A.C,o)).K=A.K+"-bV",s.2N(l)}1a E=1f(e,t,i){1m[[d+e*ZC.ED(i),f+e*ZC.EL(i),0],[d+e*ZC.ED(i),f+e*ZC.EL(i),1b],[d+t*ZC.ED(i),f+t*ZC.EL(i),1b],[d+t*ZC.ED(i),f+t*ZC.EL(i),0]]};(n=ZC.DF.D6(v,A.C,{2S:E(A.CK,A.AH,A.B1),u8:E(A.CK+1,A.AH+1,A.B1-1)})).K=A.K+"-iq",s.2N(n),(a=ZC.DF.D6(v,A.C,{2S:E(A.CK,A.AH,A.BH),u8:E(A.CK+1,A.AH+1,A.BH+1)})).K=A.K+"-hb",s.2N(a);1a m=A.C.K+ZC.1b[34]+A.C.K+ZC.1b[35]+A.A.L+ZC.1b[6],K=ZC.P.GC("4x",A.A.E5)+\'3g="\'+m+\'" id="\'+A.K,F=A.A.A.HK;F.1i(K+\'--1u" 1T-z-3V="1" 9n="\'+t.FB()+\'" />\'),i&&F.1i(K+\'--77" 1T-z-3V="1" 9n="\'+i.FB()+\'" />\'),(A.CK>0||A.DR>0)&&(l&&F.1i(K+\'--5N" 1T-z-3V="2" 9n="\'+l.FB()+\'" />\'),F.1i(K+\'--46" 1T-z-3V="2" 9n="\'+n.FB()+\'" />\',K+\'--6n" 1T-z-3V="2" 9n="\'+a.FB()+\'" />\'))}A.A.U&&A.H5()}},WY:1f(e,t){1a i=1g;if(i.b(e,t),"3F"===t&&e.8T<=1&&i.A.mW){1a n="3L-fU-"+i.A.L+"-"+i.L;i.C.E[n]=1w i.C.E[n]===ZC.1b[31]||!i.C.E[n],i.C.K2()}}}),ZC.uc=ZC.Z6.C7({2E:1f(){1g.SU()},UX:1f(){1a e=1g;e.1v(!0);1a t=e.C.BL(e.A.BT("v")[0]),i=e.iX+e.I/2,n=e.iY+(t.AR?e.F:0),a=1n ZC.CF(e.C,i-ZC.AM.E1,n-ZC.AM.E0,e.A.E["z-46"]);1m[ZC.1l(a.E9[0]),ZC.1l(a.E9[1]),{cB:e,3E:!0}]},7n:1f(e){1a t=1g,i=t.b(e);if("-1/-1"!==i.2I("/")){1a n=1n ZC.CF(t.C,i[0]+e.I/2-ZC.AM.E1,i[1]+e.F/2-ZC.AM.E0,t.A.E["z-9T"]);1m[ZC.1l(n.E9[0])-e.I/2,ZC.1l(n.E9[1])-e.F/2]}1m i},1v:1f(e){1a t,i=1g;i.b(),1w e===ZC.1b[31]&&(e=!1);1a n=i.C.CH,a=i.A.B0,l=i.A.CI;i.2E();1a o=i.A.QE(),r=o.A9,C=o.ER,A=o.CC,s=o.CO,Z=o.F0,c=o.D1,u=o.EX;e?C=i.A.E["2o-"+i.L+"-2Q-2V"]:i.A.E["2o-"+i.L+"-2Q-2V"]=o.ER;1a p,h,1b,d,f,g,B,v,b,E,m,K,F,D,I,X;if(i.A.CB){1b=0;1a x=i.A.A.K6[C];1k(p=0;p<x.1h;p++){1a y=i.A.A.A7[x[p]].S[i.L];y&&(1b+=y.AE)}}1a L=1,Y=1;if(i.A.CB&&1b>0&&(i.CM!==i.AE&&(L=(1b-i.CM+i.AE)/1b),Y=(1b-i.CM)/1b),l.AR){1a w=L;L=Y,Y=w}i.A.LN&&(C=i.L);1a M=i.iX-r/2+A+C*(c+Z)-C*u;if(M=ZC.5m(M,i.iX-r/2+A,i.iX+r/2-s),i.A.D1>0){1a H=c;(c=i.A.D1)<=1&&(c*=H),M+=(H-c)/2}1a N=c,S=i.iY,O=1c!==ZC.1d(i.A.LU[i.L])?i.A.LU[i.L]:0;if(S=i.A.CB&&"100%"===i.A.KO?l.B2(100*(i.CM+O)/i.A.A.F3[i.L]["%6i-"+i.A.DV]):l.B2(i.CM+O),i.A.CB?(f=S-(d="100%"===i.A.KO?l.B2(100*(i.CM-i.AE+O)/i.A.A.F3[i.L]["%6i-"+i.A.DV]):l.B2(i.CM-i.AE+O)),i.AE<0&&(S=d),l.AR?f>0&&(f=ZC.2i(f),S=d):f<0&&(S=d-(f=ZC.2i(f)))):S=(f=S-(d=l.B2(O)))<0?d-(f=ZC.2i(f)):d,A+s===0&&(M-=.5,N+=1),i.I=N,i.F=f,i.iX=M,i.iY=S,l.AR?i.AE>=l.GZ?i.c4=S+i.F:i.c4=S:i.AE>=l.GZ?i.c4=S:i.c4=S+i.F,i.C.D0){1a P="6o";i.C.D0.o.1O&&1c!==ZC.1d(t=i.C.D0.o.1O.gG)&&(P=t),1c!==ZC.1d(i.A.o["2g-1O"])&&1c!==ZC.1d(t=i.A.o["2g-1O"].gG)&&(P=t),"2o"===P&&(i.E.hu=i.iX+i.I/2)}if(!e){1a k,G,z,T=M-ZC.AM.E1,J=S-ZC.AM.E0,Q=0,W=ZC.AM.FQ,R=0,V=W;if(i.A.n8){if(G=Q,"b1"===i.C.AF||"9q"===i.C.AF){1k(k=1,p=0,h=i.A.A.A7.1h;p<h;p++)"6M"!==i.A.A.A7[p].AF&&k++;G=(k-1)*(ZC.AM.FQ/k),W=ZC.1l(.9*W/k)}z=G+W}1t{if(k=0,R=-1,V=ZC.AM.FQ,"5c"===i.C.8b())k=i.A.A.A7.1h,R=i.A.L,V/=k;1t if(i.A.CB)R=0;1t{1k(p=0;p<i.A.A.A7.1h;p++)i.C.E["1B"+p+".2f"]&&R++;1k(p=0;p<i.A.A.A7.1h;p++)i.C.E["1B"+p+".2f"]&&(k++,i.A.L>p&&R--);V/=k,R=k-R-1}G=R*V+.2*V,z=(R+1)*V-.2*V}if(1c!==ZC.1d(i.A.o["z-46"])&&(G=ZC.1l(i.A.o["z-46"])),1c!==ZC.1d(i.A.o["z-6n"])&&(z=ZC.1l(i.A.o["z-6n"])),1c!==ZC.1d(i.A.o.5q)){1a U=ZC.1l(i.A.o.5q);G=R*V+V/2-U,z=R*V+V/2+U}Q=G,W=z-G,i.A.E["z-4j"]=k,i.A.E["z-83"]=R,i.A.E["z-5q"]=V,i.A.E["z-46"]=G,i.A.E["z-9T"]=(G+z)/2;1a j=i.N=i.A.I1(i,i.N);if(j.DJ=i.K+"-gY",i.A.IA&&(i.H9(j),j.1q()),j.AL){1a q=1n ZC.CZ(i);q.1Q(j),q.A0=ZC.AO.JE(ZC.AO.G3(q.A0)),q.AC=ZC.AO.JE(ZC.AO.G3(q.AC)),q.BU=ZC.AO.JE(ZC.AO.G3(q.BU));1a $=1n ZC.CZ(i);$.1Q(j),$.A0=ZC.AO.JE(ZC.AO.G3($.A0),15),$.AC=ZC.AO.JE(ZC.AO.G3($.AC),15),$.BU=ZC.AO.JE(ZC.AO.G3($.BU),15);1a ee=1n ZC.CZ(i);ee.1Q(j);1a te=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6],ie=ZC.P.GC("4x",i.A.E5,i.N.IM)+\'3g="\'+te+\'" id="\'+i.K,ne=i.C.F7.7J,ae=i.I/2,le=W/2,oe=L*ae,re=Y*ae,Ce=Y*le,Ae=L*le;l.AR&&!i.A.CB?(g=i.AE>=0?0:i.F,B=i.AE>=0?i.F:0):(g=i.AE>=0?i.F:0,B=i.AE>=0?0:i.F);1a se=i.A.A.HK,Ze=ZC.CV(le,ae),ce=i.C.F7[ZC.1b[28]],ue=i.C.F7.2c,pe=ZC.ED(ue)*le,he=ZC.EL(ue)*le;ne||(Ze=ZC.CV(2*pe,ae));1a 6m=1f(e){1a t=0,n=i.A.L,o=i.L,r=i.A.A.A7.1h,C=i.A.S.1h;1P((i.A.CB?"s":"")+(a.AR?"k":"")+(l.AR?"v":"")){1j"":1j"v":t=10*n+8p*o+e;1p;1j"sv":t=10*(r-n)+8p*o+e;1p;1j"k":t=10*n+8p*(C-o)+e;1p;1j"w9":t=10*(r-n)+8p*(C-o)+e;1p;1j"kv":t=10*n+8p*(C-o)+e;1p;1j"s":t=10*n+8p*o+e;1p;1j"sk":t=10*n+8p*(C-o)+e}1m t},de=ZC.3q,fe=-ZC.3q,ge=ZC.3q,Be=-ZC.3q,ve=ZC.3q,be=-ZC.3q,Ee=ZC.3q,me=-ZC.3q;if("tI"===i.A.CS)1k(X=0;X<=2j;X+=4)(b=1n ZC.CF(i.C,T+ZC.EL(X)*Ze+ae,J,Q+ZC.ED(X)*Ze+le)).E9[0]<ge&&(ge=b.E9[0],de=X),b.E9[0]>Be&&(Be=b.E9[0],fe=X),(b=1n ZC.CF(i.C,T+ZC.EL(X)*Ze+ae,J+i.F,Q+ZC.ED(X)*Ze+le)).E9[0]<Ee&&(Ee=b.E9[0],ve=X),b.E9[0]>me&&(me=b.E9[0],be=X);1a Ke=i.A.o.wm||{};1P(i.A.CS){2n:Ke.2a?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.2a),v.1q(),F=ZC.DF.DA(v,i.C,T+.1,T+i.I-.1,J+i.F-.1,J+i.F-.1,Q+.1,Q+W-.1,"x")):F=ZC.DF.DA(q,i.C,T+.1,T+i.I-.1,J+i.F-.1,J+i.F-.1,Q+.1,Q+W-.1,"x"),F.K=i.K+"-bY",F.FS=6m(1),n.2N(F),Ke.1u?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.1u),v.1q(),K=ZC.DF.DA(v,i.C,T+.1,T+i.I-.1,J+.1,J+.1,Q+.1,Q+W-.1,"x")):K=ZC.DF.DA(q,i.C,T+.1,T+i.I-.1,J+.1,J+.1,Q+.1,Q+W-.1,"x"),K.K=i.K+"-bX",K.FS=6m(3),n.2N(K),Ke.1J?((v=1n ZC.CZ(i)).1Q($),v.1C(Ke.1J),v.1q(),D=ZC.DF.DA(v,i.C,T+.1,T+.1,J+.1,J+i.F-.1,Q+.1,Q+W-.1,"z")):D=ZC.DF.DA($,i.C,T+.1,T+.1,J+.1,J+i.F-.1,Q+.1,Q+W-.1,"z"),D.K=i.K+"-bV",D.FS=6m(2),n.2N(D),Ke.2x?((v=1n ZC.CZ(i)).1Q($),v.1C(Ke.2x),v.1q(),I=ZC.DF.DA(v,i.C,T+i.I-.1,T+i.I-.1,J+.1,J+i.F-.1,Q+.1,Q+W-.1,"z")):I=ZC.DF.DA($,i.C,T+i.I-.1,T+i.I-.1,J+.1,J+i.F-.1,Q+.1,Q+W-.1,"z"),I.K=i.K+"-iq",I.FS=6m(4),n.2N(I),Ke.5l?((v=1n ZC.CZ(i)).1Q(ee),v.1C(Ke.5l),v.1q(),m=ZC.DF.DA(v,i.C,T+.1,T+i.I-.1,J+.1,J+i.F-.1,Q+.1,Q+.1,"y")):m=ZC.DF.DA(ee,i.C,T+.1,T+i.I-.1,J+.1,J+i.F-.1,Q+.1,Q+.1,"y"),m.K=i.K+"-hb",m.FS=6m(5),n.2N(m),i.A.FT&&(1===Y&&se.1i(ie+"--1u"+ZC.1b[30]+K.FB()+\'" />\'),se.1i(ie+"--1J"+ZC.1b[30]+D.FB()+\'" />\',ie+"--2x"+ZC.1b[30]+I.FB()+\'" />\',ie+"--5l"+ZC.1b[30]+m.FB()+\'" 1T-z-3V="-100" />\'));1p;1j"b9":Ke.2a?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.2a),v.1q(),F=ZC.DF.DA(v,i.C,T+ae-oe,T+ae+oe,J+g,J+g,Q+le-Ae,Q+le+Ae,"x")):F=ZC.DF.DA(q,i.C,T+ae-oe,T+ae+oe,J+g,J+g,Q+le-Ae,Q+le+Ae,"x"),F.K=i.K+"-bY",F.FS=6m(l.AR&&!i.A.CB?6:1),n.2N(F),E=[[T+ae-oe,J+g,Q+le-Ae],[T+ae+oe,J+g,Q+le-Ae]],i.A.CB&&0!==Y?E.1i([T+ae+re,J+B,Q+le-Ce],[T+ae-re,J+B,Q+le-Ce]):E.1i([T+ae,J+B,Q+le]),Ke.5l?((v=1n ZC.CZ(i)).1Q(j),v.1C(Ke.5l),v.1q(),m=ZC.DF.D6(v,i.C,E)):m=ZC.DF.D6(j,i.C,E),m.K=i.K+"-bX",m.FS=6m(3),n.2N(m),E=[[T+ae-oe,J+g,Q+le-Ae],[T+ae-oe,J+g,Q+le+Ae]],i.A.CB&&0!==Y?E.1i([T+ae-re,J+B,Q+le+Ce],[T+ae-re,J+B,Q+le-Ce]):E.1i([T+ae,J+B,Q+le]),Ke.1J?((v=1n ZC.CZ(i)).1Q($),v.1C(Ke.1J),v.1q(),D=ZC.DF.D6(v,i.C,E)):D=ZC.DF.D6($,i.C,E),D.K=i.K+"-bV",D.FS=6m(2),n.2N(D),E=[[T+ae+oe,J+g,Q+le-Ae],[T+ae+oe,J+g,Q+le+Ae]],i.A.CB&&0!==Y?E.1i([T+ae+re,J+B,Q+le+Ce],[T+ae+re,J+B,Q+le-Ce]):E.1i([T+ae,J+B,Q+le]),Ke.2x?((v=1n ZC.CZ(i)).1Q($),v.1C(Ke.2x),v.1q(),I=ZC.DF.D6(v,i.C,E)):I=ZC.DF.D6($,i.C,E),I.K=i.K+"-iq",I.FS=6m(4),n.2N(I),i.A.CB&&0!==Y&&(E=[[T+ae-re,J+B,Q+le-Ce],[T+ae-re,J+B,Q+le+Ce],[T+ae+re,J+B,Q+le+Ce],[T+ae+re,J+B,Q+le-Ce]],Ke.1u?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.1u),v.1q(),K=ZC.DF.D6(v,i.C,E)):K=ZC.DF.D6(q,i.C,E),K.K=i.K+"-hb",K.FS=6m(5),n.2N(K)),i.A.FT&&se.1i(ie+"--1J"+ZC.1b[30]+D.FB()+\'" />\',ie+"--2x"+ZC.1b[30]+I.FB()+\'" />\',ie+"--5l"+ZC.1b[30]+m.FB()+\'" 1T-z-3V="-100" />\');1p;1j"tI":if(E=[],ne)1k(X=0;X<=2j;X+=5)E.1i([T+ZC.EL(X)*Ze+ae,J+i.F,Q+ZC.ED(X)*Ze+le]);1t 1k(X=0;X<=2j;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze+ae+pe,S+i.F+ZC.EL(X)*(Ze/2)-he],E.1i(b);if(Ke.2a?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.2a),v.1q(),F=ZC.DF.D6(v,i.C,E,!ne)):F=ZC.DF.D6(q,i.C,E,!ne),F.K=i.K+"-bY",F.FS=6m(1),n.2N(F),E=[],ne)1k(X=0;X<=2j;X+=5)E.1i([T+ZC.EL(X)*Ze+ae,J,Q+ZC.ED(X)*Ze+le]);1t 1k(X=0;X<=2j;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze+ae+pe,S+ZC.EL(X)*(Ze/2)-he],E.1i(b);if(Ke.1u?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.1u),v.1q(),K=ZC.DF.D6(v,i.C,E,!ne)):K=ZC.DF.D6(q,i.C,E,!ne),K.K=i.K+"-bX",K.FS=6m(3),n.2N(K),E=[],ne){1k(X=ZC.CV(de,fe);X<=ZC.BN(de,fe);X+=1)E.1i([T+ZC.EL(X)*Ze+ae,J,Q+ZC.ED(X)*Ze+le]);1k(E.1i([T+ZC.EL(X)*Ze+ae,J+i.F,Q+ZC.ED(X)*Ze+le]),X=ZC.BN(ve,be);X>=ZC.CV(ve,be);X-=1)E.1i([T+ZC.EL(X)*Ze+ae,J+i.F,Q+ZC.ED(X)*Ze+le])}1t{1k(X=0;X<=180;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze+ae+pe,S+i.F+ZC.EL(X)*(Ze/2)-he],E.1i(b);1k(X=180;X>=0;X-=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze+ae+pe,S+ZC.EL(X)*(Ze/2)-he],E.1i(b)}Ke.5l?((v=1n ZC.CZ(i)).1Q(j),v.1C(Ke.5l),v.1q(),m=ZC.DF.D6(v,i.C,E,!ne)):m=ZC.DF.D6(j,i.C,E,!ne),m.K=i.K+"-bV",m.FS=6m(2),n.2N(m),i.A.FT&&se.1i(ie+"--5l"+ZC.1b[30]+m.FB()+\'" 1T-z-3V="-100" />\',ie+"--1u"+ZC.1b[30]+K.FB()+\'" />\');1p;1j"fz":if(E=[],ne)1k(X=0;X<=2j;X+=5)E.1i([T+ZC.EL(X)*Ze*L+ae,J+g,Q+ZC.ED(X)*Ze*L+le]);1t 1k(X=0;X<=2j;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze*L+ae+pe,S+g+ZC.EL(X)*(Ze/2)*L-he],E.1i(b);if(Ke.2a?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.2a),v.1q(),F=ZC.DF.D6(v,i.C,E,!ne)):F=ZC.DF.D6(q,i.C,E,!ne),F.K=i.K+"-bY",F.FS=6m(1),n.2N(F),E=[],ne){1k(X=90+ce;X<=3T+ce;X+=5)E.1i([T+ZC.EL(X)*Ze*L+ae,J+g,Q+ZC.ED(X)*Ze*L+le]);if(i.A.CB&&0!==Y)1k(X=3T+ce;X>=90+ce;X-=5)E.1i([T+ZC.EL(X)*Ze*Y+ae,J+B,Q+ZC.ED(X)*Ze*Y+le]);1t E.1i([T+ae,J+B,Q+le])}1t{1k(X=0;X<=180;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze*L+ae+pe,S+g+ZC.EL(X)*(Ze/2)*L-he],E.1i(b);if(i.A.CB&&0!==Y)1k(X=180;X>=0;X-=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze*Y+ae+pe,S+B+ZC.EL(X)*(Ze/2)*Y-he],E.1i(b);1t(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ae+pe,S+B-he],E.1i(b)}if(Ke.5l?((v=1n ZC.CZ(i)).1Q(j),v.1C(Ke.5l),v.1q(),m=ZC.DF.D6(v,i.C,E,!ne)):m=ZC.DF.D6(j,i.C,E,!ne),m.K=i.K+"-bX",m.FS=6m(2),n.2N(m),i.A.CB&&0!==Y){if(E=[],ne)1k(X=0;X<=2j;X+=5)E.1i([T+ZC.EL(X)*Ze*Y+ae,J+B,Q+ZC.ED(X)*Ze*Y+le]);1t 1k(X=0;X<=2j;X+=5)(b=1n ZC.CF(i.C,0,0,0)).E9=[M+ZC.ED(X)*Ze*Y+ae+pe,S+B+ZC.EL(X)*(Ze/2)*Y-he],E.1i(b);Ke.1u?((v=1n ZC.CZ(i)).1Q(q),v.1C(Ke.1u),v.1q(),K=ZC.DF.D6(v,i.C,E,!ne)):K=ZC.DF.D6(q,i.C,E,!ne),K.K=i.K+"-bV",n.2N(K),K.FS=6m(3)}i.A.FT&&se.1i(ie+"--5l"+ZC.1b[30]+m.FB()+\'" 1T-z-3V="-100" />\')}i.A.U&&i.A.U.AL&&i.H5()}i.9A(j)}},6e:1f(){}}),ZC.w2=ZC.Z9.C7({2E:1f(){1g.SU()},UX:1f(){1a e=1g;e.1v(!0);1a t=e.C.BL(e.A.BT("v")[0]),i=e.iX+(t.AR?0:e.I),n=e.iY+e.F/2,a=1n ZC.CF(e.C,i-ZC.AM.E1,n-ZC.AM.E0,e.A.E["z-46"]);1m[ZC.1l(a.E9[0]),ZC.1l(a.E9[1]),{cB:e,3E:!0}]},7n:1f(e){1a t=1g,i=t.b(e);if("-1/-1"!==i.2I("/")){1a n=1n ZC.CF(t.C,i[0]-ZC.AM.E1,i[1]-ZC.AM.E0,t.A.E["z-46"]);1m[ZC.1l(n.E9[0]),ZC.1l(n.E9[1])]}1m i},1v:1f(e){1a t=1g;t.b(),1w e===ZC.1b[31]&&(e=!1);1a i=t.C.CH,n=t.A.B0,a=t.A.CI;t.2E();1a l=t.A.QE(),o=l.A9,r=l.ER,C=l.CC,A=l.CO,s=l.F0,Z=l.D1,c=l.EX;e?r=t.A.E["2o-"+t.L+"-2Q-2V"]:t.A.E["2o-"+t.L+"-2Q-2V"]=l.ER;1a u,p,h,1b,d,f,g,B,v,b,E,m,K,F;if(t.A.CB){u=0;1k(1a D=t.A.A.K6[r],I=0;I<D.1h;I++){1a X=t.A.A.A7[D[I]].S[t.L];X&&(u+=X.AE)}}1a x=1,y=1;if(t.A.CB&&(t.CM!==t.AE&&(x=(u-t.CM+t.AE)/u),y=(u-t.CM)/u),a.AR){1a L=x;x=y,y=L}t.A.LN&&(r=t.L);1a Y=t.iY-o/2+C+r*(Z+s)-r*c;if(Y=ZC.5m(Y,t.iY-o/2+C,t.iY+o/2-A),t.A.D1>0){1a w=Z;(Z=t.A.D1)<=1&&(Z*=w),Y+=(w-Z)/2}1a M=Z,H=t.iX,N=1c!==ZC.1d(t.A.LU[t.L])?t.A.LU[t.L]:0;if(H=t.A.CB&&"100%"===t.A.KO?a.B2(100*(t.CM+N)/t.A.A.F3[t.L]["%6i-"+t.A.DV]):a.B2(t.CM+N),t.A.CB?(h=H-(p="100%"===t.A.KO?a.B2(100*(t.CM-t.AE+N)/t.A.A.F3[t.L]["%6i-"+t.A.DV]):a.B2(t.CM-t.AE+N)),t.AE>0?H=p:h=ZC.2i(h),a.AR?h>0?(h=ZC.2i(h),H=p):H-=h=ZC.2i(h):h<0&&(H=p-(h=ZC.2i(h)))):H=(h=H-(p=a.B2(N)))<0?p-(h=ZC.2i(h)):p,C+A===0&&(Y-=.5,M+=1),t.I=h,t.F=M,t.iX=H,t.iY=Y,a.AR?t.AE>=a.GZ?t.c2=H:t.c2=H+t.I:t.AE>=a.GZ?t.c2=H+t.I:t.c2=H,!e){1a S=H+h-ZC.AM.E1,O=Y-ZC.AM.E0,P=0,k=ZC.AM.FQ;1c!==ZC.1d(t.A.o["z-46"])&&(P=ZC.1l(t.A.o["z-46"])),1c!==ZC.1d(t.A.o["z-6n"])&&(k=ZC.1l(t.A.o["z-6n"])-P),t.A.E["z-46"]=P,t.A.E["z-9T"]=P+k/2;1a G=t.N=t.A.I1(t,t.N);if(G.DJ=t.K+"-gY",t.A.IA&&(t.H9(G),G.1q()),G.AL){1a z=1n ZC.CZ(t);z.1Q(G),z.A0=ZC.AO.JE(ZC.AO.G3(z.A0)),z.AC=ZC.AO.JE(ZC.AO.G3(z.AC)),z.BU=ZC.AO.JE(ZC.AO.G3(z.BU));1a T=1n ZC.CZ(t);T.1Q(G),T.A0=ZC.AO.JE(ZC.AO.G3(T.A0),15),T.AC=ZC.AO.JE(ZC.AO.G3(T.AC),15),T.BU=ZC.AO.JE(ZC.AO.G3(T.BU),15);1a J=1n ZC.CZ(t);J.1Q(G);1a Q=t.C.K+ZC.1b[34]+t.C.K+ZC.1b[35]+t.A.L+ZC.1b[6],W=ZC.P.GC("4x",t.A.E5,t.N.IM)+\'3g="\'+Q+\'" id="\'+t.K,R=t.C.F7.7J,V=t.F/2,U=k/2,j=x*V,q=y*V,$=y*U,ee=x*U;a.AR&&!t.A.CB?(d=t.AE>=0?0:t.I,1b=t.AE>=0?t.I:0):(d=t.AE>=0?t.I:0,1b=t.AE>=0?0:t.I);1a te=t.A.A.HK,ie=ZC.CV(U,V),ne=t.C.F7[ZC.1b[27]],ae=t.C.F7.2c,le=ZC.ED(ae)*U,oe=ZC.EL(ae)*U;R||(ie=ZC.CV(2*oe,V));1a re=1f(e){1a i=-1,l=t.A.L,o=t.L,r=t.A.A.A7.1h,C=t.A.S.1h;1P((t.A.CB?"s":"")+(n.AR?"k":"")+(a.AR?"v":"")){1j"":1j"v":1j"sv":i=10*(r-l)+8p*o+e;1p;1j"k":1j"w9":1j"kv":i=10*(r-l)+8p*(C-o)+e;1p;1j"s":i=10*l+8p*o+e;1p;1j"sk":i=10*l+8p*(C-o)+e}1m ZC.1l(i)},Ce=t.A.o.wm||{};1P(t.A.CS){2n:Ce.1J?((f=1n ZC.CZ(t)).1Q(T),f.1C(Ce.1J),f.1q(),g=ZC.DF.DA(f,t.C,S-t.I+.1,S-.1,O+.1,O+.1,P+.1,P+k-.1,"x")):g=ZC.DF.DA(T,t.C,S-t.I+.1,S-.1,O+.1,O+.1,P+.1,P+k-.1,"x"),g.K=t.K+"-bY",g.FS=re(5),i.2N(g),Ce.2x?((f=1n ZC.CZ(t)).1Q(T),f.1C(Ce.2x),f.1q(),E=ZC.DF.DA(f,t.C,S-t.I+.1,S-.1,O+t.F-.1,O+t.F-.1,P+.1,P+k-.1,"x")):E=ZC.DF.DA(T,t.C,S-t.I+.1,S-.1,O+t.F-.1,O+t.F-.1,P+.1,P+k-.1,"x"),E.K=t.K+"-bX",E.FS=re(1),i.2N(E),Ce.2a?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.2a),f.1q(),B=ZC.DF.DA(f,t.C,S-t.I+.1,S-t.I+.1,O+t.F-.1,O+.1,P+.1,P+k-.1,"z")):B=ZC.DF.DA(z,t.C,S-t.I+.1,S-t.I+.1,O+t.F-.1,O+.1,P+.1,P+k-.1,"z"),B.K=t.K+"-bV",B.FS=re(2),i.2N(B),Ce.1u?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.1u),f.1q(),v=ZC.DF.DA(f,t.C,S-.1,S-.1,O+t.F-.1,O+.1,P+.1,P+k-.1,"z")):v=ZC.DF.DA(z,t.C,S-.1,S-.1,O+t.F-.1,O+.1,P+.1,P+k-.1,"z"),v.K=t.K+"-iq",v.FS=re(3),i.2N(v),Ce.5l?((f=1n ZC.CZ(t)).1Q(J),f.1C(Ce.5l),f.1q(),b=ZC.DF.DA(f,t.C,S-t.I+.1,S-.1,O+t.F-.1,O+.1,P+.1,P+.1,"y")):b=ZC.DF.DA(J,t.C,S-t.I+.1,S-.1,O+t.F-.1,O+.1,P+.1,P+.1,"y"),b.K=t.K+"-hb",b.FS=re(4),i.2N(b),t.A.FT&&(t.A.CB||te.1i(W+"--1u"+ZC.1b[30]+v.FB()+\'" />\'),te.1i(W+"--1J"+ZC.1b[30]+g.FB()+\'" />\',W+"--2x"+ZC.1b[30]+E.FB()+\'" />\',W+"--5l"+ZC.1b[30]+b.FB()+\'" 1T-z-3V="-100" />\'));1p;1j"b9":Ce.2a?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.2a),f.1q(),B=ZC.DF.DA(f,t.C,S-d,S-d,O+V-j,O+V+j,U-ee,U+ee,"z")):B=ZC.DF.DA(z,t.C,S-d,S-d,O+V-j,O+V+j,U-ee,U+ee,"z"),B.K=t.K+"-bY",B.FS=re(a.AR&&!t.A.CB?6:1),i.2N(B),F=[[S-d,O+V-j,U-ee],[S-d,O+V+j,U-ee]],t.A.CB&&0!==y?F.1i([S-1b,O+V+q,U-$],[S-1b,O+V-q,U-$]):F.1i([S-1b,O+V,k/2]),Ce.5l?((f=1n ZC.CZ(t)).1Q(G),f.1C(Ce.5l),f.1q(),b=ZC.DF.D6(f,t.C,F)):b=ZC.DF.D6(G,t.C,F),b.K=t.K+"-bX",b.FS=re(3),i.2N(b),F=[[S-d,O+V-j,U-ee],[S-d,O+V-j,U+ee]],t.A.CB&&0!==y?F.1i([S-1b,O+V-q,U+$],[S-1b,O+V-q,U-$]):F.1i([S-1b,O+t.F/2,k/2]),Ce.1J?((f=1n ZC.CZ(t)).1Q(T),f.1C(Ce.1J),f.1q(),g=ZC.DF.D6(f,t.C,F)):g=ZC.DF.D6(T,t.C,F),g.K=t.K+"-bV",g.FS=re(4),i.2N(g),F=[[S-d,O+V+j,U-ee],[S-d,O+V+j,U+ee]],t.A.CB&&0!==y?F.1i([S-1b,O+V+q,U+$],[S-1b,O+V+q,U-$]):F.1i([S-1b,O+V,k/2]),Ce.2x?((f=1n ZC.CZ(t)).1Q(T),f.1C(Ce.2x),f.1q(),E=ZC.DF.D6(f,t.C,F)):E=ZC.DF.D6(T,t.C,F),E.K=t.K+"-iq",E.FS=re(2),i.2N(E),t.A.CB&&0!==y&&(Ce.1u?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.1u),f.1q(),v=ZC.DF.DA(f,t.C,S-1b,S-1b,O+V-q,O+V+q,U-$,U+$,"z")):v=ZC.DF.DA(z,t.C,S-1b,S-1b,O+V-q,O+V+q,U-$,U+$,"z"),v.K=t.K+"-hb",v.FS=re(5),i.2N(v)),t.A.FT&&te.1i(W+"--1J"+ZC.1b[30]+g.FB()+\'" />\',W+"--2x"+ZC.1b[30]+E.FB()+\'" />\',W+"--5l"+ZC.1b[30]+b.FB()+\'" 1T-z-3V="-100" />\');1p;1j"tI":if(F=[],R)1k(m=0;m<=2j;m+=5)F.1i([S-t.I,O+ZC.EL(m)*ie+V,P+ZC.ED(m)*ie+U]);1t 1k(m=0;m<=2j;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+ZC.ED(m)*(ie/2)+le,Y+V+ZC.EL(m)*ie-oe],F.1i(K);if(Ce.2a?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.2a),f.1q(),B=ZC.DF.D6(f,t.C,F,!R)):B=ZC.DF.D6(z,t.C,F,!R),B.K=t.K+"-bY",B.FS=re(1),i.2N(B),F=[],R){1k(m=90-ne;m<=3T-ne;m+=5)F.1i([S-t.I,O+ZC.EL(m)*ie+V,P+ZC.ED(m)*ie+U]);1k(F.1i([S,O+ZC.EL(m)*ie+V,P+ZC.ED(m)*ie+U]),m=3T-ne;m>=90-ne;m-=5)F.1i([S,O+ZC.EL(m)*ie+V,P+ZC.ED(m)*ie+U])}1t{1k(m=90;m<=3T;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+ZC.ED(m)*(ie/2)+le,Y+V+ZC.EL(m)*ie-oe],F.1i(K);1k(m=3T;m>=90;m-=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+ZC.ED(m)*(ie/2)+t.I+le,Y+V+ZC.EL(m)*ie-oe],F.1i(K)}if(Ce.5l?((f=1n ZC.CZ(t)).1Q(G),f.1C(Ce.5l),f.1q(),b=ZC.DF.D6(f,t.C,F,!R)):b=ZC.DF.D6(G,t.C,F,!R),b.K=t.K+"-bX",b.FS=re(2),i.2N(b),F=[],R)1k(m=0;m<=2j;m+=5)F.1i([S,O+ZC.EL(m)*ie+V,P+ZC.ED(m)*ie+U]);1t 1k(m=0;m<=2j;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+ZC.ED(m)*(ie/2)+t.I+le,Y+V+ZC.EL(m)*ie-oe],F.1i(K);Ce.1u?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.1u),f.1q(),v=ZC.DF.D6(f,t.C,F,!R)):v=ZC.DF.D6(z,t.C,F,!R),v.K=t.K+"-bV",v.FS=re(3),i.2N(v),t.A.FT&&te.1i(W+"--5l"+ZC.1b[30]+b.FB()+\'" 1T-z-3V="-100" />\',W+"--1u"+ZC.1b[30]+v.FB()+\'" />\');1p;1j"fz":if(F=[],R)1k(m=0;m<=2j;m+=5)F.1i([S-d,O+ZC.EL(m)*ie*x+V,ZC.ED(m)*ie*x+U]);1t 1k(m=0;m<=2j;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+1b+ZC.ED(m)*(ie/2)*x+le,Y+V+ZC.EL(m)*ie*x-oe],F.1i(K);if(Ce.2a?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.2a),f.1q(),B=ZC.DF.D6(f,t.C,F,!R)):B=ZC.DF.D6(z,t.C,F,!R),B.K=t.K+"-bY",B.FS=re(1),i.2N(B),F=[],R){1k(m=90-ne;m<=3T-ne;m+=5)F.1i([S-d,O+ZC.EL(m)*ie*x+V,ZC.ED(m)*ie*x+U]);if(t.A.CB&&0!==y)1k(m=3T-ne;m>=90-ne;m-=5)F.1i([S-1b,O+ZC.EL(m)*ie*y+V,ZC.ED(m)*ie*y+U]);1t F.1i([S-1b,O+V,ie])}1t{1k(m=90;m<=3T;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+1b+ZC.ED(m)*(ie/2)*x+le,Y+V+ZC.EL(m)*ie*x-oe],F.1i(K);if(t.A.CB&&0!==y)1k(m=3T;m>=90;m-=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+d+ZC.ED(m)*(ie/2)*y+le,Y+V+ZC.EL(m)*ie*y-oe],F.1i(K);1t(K=1n ZC.CF(t.C,0,0,0)).E9=[H+d+le,Y+V-oe],F.1i(K)}if(Ce.5l?((f=1n ZC.CZ(t)).1Q(G),f.1C(Ce.5l),f.1q(),b=ZC.DF.D6(f,t.C,F,!R)):b=ZC.DF.D6(G,t.C,F,!R),b.K=t.K+"-bX",b.FS=re(2),i.2N(b),t.A.CB&&0!==y){if(F=[],R)1k(m=0;m<=2j;m+=5)F.1i([S-1b,O+ZC.EL(m)*ie*y+V,ZC.ED(m)*ie*y+U]);1t 1k(m=0;m<=2j;m+=5)(K=1n ZC.CF(t.C,0,0,0)).E9=[H+d+ZC.ED(m)*(ie/2)*y+le,Y+V+ZC.EL(m)*ie*y-oe],F.1i(K);Ce.1u?((f=1n ZC.CZ(t)).1Q(z),f.1C(Ce.1u),f.1q(),v=ZC.DF.D6(f,t.C,F,!R)):v=ZC.DF.D6(z,t.C,F,!R),v.K=t.K+"-bV",v.FS=re(3),i.2N(v)}t.A.FT&&te.1i(W+"--5l"+ZC.1b[30]+b.FB()+\'" 1T-z-3V="-100" />\')}}t.A.U&&t.A.U.AL&&t.H5()}},6e:1f(){}}),ZC.wk=ZC.tR.C7({2E:1f(){1g.SU()},82:1f(){1m{1r:1g.N.B6}},XP:1f(){1m{"1R-1r":1g.N.B6,"1F-1r":1g.N.B6,1r:1g.N.BZ}},7n:1f(e){1a t=1g,i=t.b(e);1m 1n ZC.CF(t.C,i[0]-ZC.AM.E1,i[1]-ZC.AM.E0,t.A.E["z-46"]).E9},1v:1f(){1a e,t,i=1g;i.b();1a n,a=i.E.2S;(n="1Z"!==i.A.IV?i.N=i.A.I1(i,i.N):i.N).DJ=i.K+"-gY",i.A.IA&&i.H9(n);1a l=0,o=-1,r=ZC.AM.FQ;if("5c"===i.C.8b())i.A.CB?o=0:(l=i.A.A.A7.1h,o=i.A.L,r/=l);1t if(i.A.CB)o=0;1t{1k(e=0;e<i.A.A.A7.1h;e++)i.C.E["1B"+e+".2f"]&&o++;1k(e=0;e<i.A.A.A7.1h;e++)i.C.E["1B"+e+".2f"]&&(l++,i.A.L>e&&o--);r/=l,o=l-o-1}n.A0=n.AC=n.B6,"4V"===i.A.CS&&(n.BU=n.B6);1a C=i.A.A.HK,A=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6],s=ZC.P.GC("4x",i.A.E5,i.N.IM)+\'3g="\'+A+\'" id="\'+i.K,Z=o*r,c=(o+1)*r;if(1c!==ZC.1d(i.A.o["z-46"])&&(Z=ZC.1l(i.A.o["z-46"])),1c!==ZC.1d(i.A.o["z-6n"])&&(c=ZC.1l(i.A.o["z-6n"])),1c!==ZC.1d(i.A.o.5q)){1a u=ZC.1l(i.A.o.5q);Z=o*r+r/2-u,c=o*r+r/2+u}i.A.E["z-4j"]=l,i.A.E["z-83"]=o,i.A.E["z-5q"]=r,i.A.E["z-46"]=Z,i.A.E["z-9T"]=(Z+c)/2;1a p=[],h=[],1b=n;ZC.2i(Z-c)<=2&&(i.C.CH.SA[i.A.K]||(i.C.CH.SA[i.A.K]={9V:i.A.L,1H:n,2S:[]},i.C.CH.SA[i.A.K].1H.M3=!1,i.C.CH.SA[i.A.K].1H.AY=ZC.BN(1,ZC.1l(ZC.2i(Z-c)/1))));1k(1a d,f,g,B=0;B<a.1h-1;B++){if(ZC.2i(Z-c)>2){1a v=-ZC.1l(ZC.TF(1A.aA((a[B+1][1]-a[B][1])/(a[B+1][0]-a[B][0]))));(1b=1n ZC.CZ(i)).1Q(n),1b.A0=ZC.AO.JE(ZC.AO.G3(1b.A0),v),1b.AC=ZC.AO.JE(ZC.AO.G3(1b.AC),v),1b.BU=ZC.AO.JE(ZC.AO.G3(1b.BU),v)}1a b,E,m,K;if(i.A.tB&&ZC.2i(Z-c)<=2?((b=i.A.tB).1q(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,Z),(E=i.A.wb).1q(i.C,a[B+1][0]-ZC.AM.E1,a[B+1][1]-ZC.AM.E0,Z),(m=i.A.vi).1q(i.C,a[B+1][0]-ZC.AM.E1,a[B+1][1]-ZC.AM.E0,c-1),(K=i.A.vj).1q(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,c-1)):(b=i.A.tB=1n ZC.CF(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,Z),E=i.A.wb=1n ZC.CF(i.C,a[B+1][0]-ZC.AM.E1,a[B+1][1]-ZC.AM.E0,Z),m=i.A.vi=1n ZC.CF(i.C,a[B+1][0]-ZC.AM.E1,a[B+1][1]-ZC.AM.E0,c-1),K=i.A.vj=1n ZC.CF(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,c-1)),ZC.2i(Z-c)>2?((d=1n ZC.Z2(1b,i.C)).K=i.K+"-vG"+B,d.2N(b),d.2N(E),d.2N(m),d.2N(K),i.C.CH.2N(d)):(i.C.CH.SA[i.A.K].2S.1i(b.E9),B===a.1h-2&&i.C.CH.SA[i.A.K].2S.1i(E.E9),"4V"===i.A.CS&&(b=1n ZC.CF(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,Z-10),K=1n ZC.CF(i.C,a[B][0]-ZC.AM.E1,a[B][1]-ZC.AM.E0,c-1+10))),p.1i(b.E9),h.1i(K.E9),i.A.FT&&"4V"!==i.A.CS)if(ZC.2i(Z-c)>2)t=d.FB();1t{1k(f=ZC.AN.YU([b.E9,E.E9],4),g=0;g<f.1h;g++)f[g][0]=1A.43(f[g][0]),f[g][1]=1A.43(f[g][1]);t=f.2I(",")}"4V"!==i.A.CS&&i.A.FT&&C.1i(s+"--vd"+B+ZC.1b[30]+t+\'" />\')}"4V"===i.A.CS?(i.E.sn=!0,i.E.2S=p.4w(h.9m())):i.E.2S=1c,i.A.A2.o&&("4V"===i.A.CS||"1Z"===i.A.A2.o.1I||1c!==ZC.1d(i.A.A2.o.2f)&&!ZC.2q(i.A.A2.o.2f))&&"4V"!==i.A.CS||i.P6(!0),i.9A(n,a)},6e:1f(){}}),ZC.vr=ZC.tA.C7({2E:1f(){1g.SU()},82:1f(){1m{1r:1g.N.B6}},XP:1f(){1m{"1R-1r":1g.N.B6,"1F-1r":1g.N.B6,1r:1g.N.BZ}},7n:1f(e){1a t=1g,i=t.b(e);1m 1n ZC.CF(t.C,i[0]-ZC.AM.E1,i[1]-ZC.AM.E0,t.A.E["z-46"]).E9},1v:1f(){1a e,t,i=1g;i.b();1a n=i.A.CI,a=n.GZ,l=n.B2(a);l=ZC.5m(l,n.iY,n.iY+n.F);1a o,r=i.E.2S,C=i.E.9U;(o="1Z"!==i.A.IV?i.N=i.A.I1(i,i.N):i.N).DJ=i.K+"-gY",i.A.IA&&i.H9(o);1a A=0,s=-1,Z=ZC.AM.FQ;if("5c"===i.C.8b())i.A.CB?s=0:(A=i.A.A.A7.1h,s=i.A.L,Z/=A);1t if(i.A.CB)s=0;1t{1k(e=0;e<i.A.A.A7.1h;e++)i.C.E["1B"+e+".2f"]&&s++;1k(e=0;e<i.A.A.A7.1h;e++)i.C.E["1B"+e+".2f"]&&(A++,i.A.L>e&&s--);Z/=A,s=A-s-1}1a c=1n ZC.CZ(i);c.1Q(o),c.A0=c.AC=o.B6,"4V"===i.A.CS&&(c.BU=o.B6);1a u=1n ZC.CZ(i);u.1Q(o),u.L1=!0,u.AQ=0,u.C6=i.A.HM,u.A0=ZC.AO.QJ(ZC.AO.G3(u.A0),30),u.AC=ZC.AO.QJ(ZC.AO.G3(u.AC),30);1a p=i.A.A.HK,h=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6],1b=ZC.P.GC("4x",i.A.E5,i.N.IM)+\'3g="\'+h+\'" id="\'+i.K,d=[],f=[],g=s*Z,B=(s+1)*Z;if(1c!==ZC.1d(i.A.o["z-46"])&&(g=ZC.1l(i.A.o["z-46"])),1c!==ZC.1d(i.A.o["z-6n"])&&(B=ZC.1l(i.A.o["z-6n"])),1c!==ZC.1d(i.A.o.5q)){1a v=ZC.1l(i.A.o.5q);g=s*Z+Z/2-v,B=s*Z+Z/2+v}i.A.E["z-4j"]=A,i.A.E["z-83"]=s,i.A.E["z-5q"]=Z,i.A.E["z-46"]=g,i.A.E["z-9T"]=(g+B)/2;1a b,E,m=1n ZC.Z2(u,i.C);1k(b=0,E=C.1h;b<E;b++){1a K=1n ZC.CF(i.C,C[b][0]-ZC.AM.E1,C[b][1]-ZC.AM.E0,g);m.2N(K)}i.C.CH.2N(m),i.E.9U=C,i.L===i.A.S.1h-1&&((m=1n ZC.Z2(u,i.C)).2N(1n ZC.CF(i.C,i.iX-.5-ZC.AM.E1,i.iY-ZC.AM.E0,g)),m.2N(1n ZC.CF(i.C,i.iX-.5-ZC.AM.E1,l-ZC.AM.E0,g)),m.2N(1n ZC.CF(i.C,i.iX-.5-ZC.AM.E1,l-ZC.AM.E0,B-1)),m.2N(1n ZC.CF(i.C,i.iX-.5-ZC.AM.E1,i.iY-ZC.AM.E0,B-1)),m.K=i.K+"-164",i.C.CH.2N(m));1a F=o;1k(ZC.2i(g-B)<=2&&(i.C.CH.SA[i.A.K]||(i.C.CH.SA[i.A.K]={9V:i.A.L,1H:o,2S:[]},i.C.CH.SA[i.A.K].1H.M3=!1,i.C.CH.SA[i.A.K].1H.AY=ZC.BN(1,ZC.1l(ZC.2i(g-B)/1)))),b=0;b<r.1h-1;b++){if(ZC.2i(g-B)>2){1a D=-ZC.1l(ZC.TF(1A.aA((r[b+1][1]-r[b][1])/(r[b+1][0]-r[b][0]))));(F=1n ZC.CZ(i)).1Q(c),F.A0=ZC.AO.JE(ZC.AO.G3(F.A0),D),F.AC=ZC.AO.JE(ZC.AO.G3(F.AC),D),F.BU=ZC.AO.JE(ZC.AO.G3(F.BU),D)}1a I=1n ZC.CF(i.C,r[b][0]-ZC.AM.E1,r[b][1]-ZC.AM.E0,g),X=1n ZC.CF(i.C,r[b+1][0]-ZC.AM.E1,r[b+1][1]-ZC.AM.E0,g),x=1n ZC.CF(i.C,r[b+1][0]-ZC.AM.E1,r[b+1][1]-ZC.AM.E0,B-1),y=1n ZC.CF(i.C,r[b][0]-ZC.AM.E1,r[b][1]-ZC.AM.E0,B-1);if(ZC.2i(g-B)>2?((m=1n ZC.Z2(F,i.C)).K=i.K+"-vG"+b,m.2N(I),m.2N(X),m.2N(x),m.2N(y),i.C.CH.2N(m)):(i.C.CH.SA[i.A.K].2S.1i(I.E9),b===r.1h-2&&i.C.CH.SA[i.A.K].2S.1i(X.E9),"4V"===i.A.CS&&(I=1n ZC.CF(i.C,r[b][0]-ZC.AM.E1,r[b][1]-ZC.AM.E0,g-10),y=1n ZC.CF(i.C,r[b][0]-ZC.AM.E1,r[b][1]-ZC.AM.E0,B-1+10))),d.1i(I.E9),f.1i(y.E9),i.A.FT&&"4V"!==i.A.CS)if(ZC.2i(g-B)>2)t=m.FB();1t{1k(1a L=ZC.AN.YU([m.D[0].E9,m.D[1].E9],4),Y=0;Y<L.1h;Y++)L[Y][0]=1A.43(L[Y][0]),L[Y][1]=1A.43(L[Y][1]);t=L.2I(",")}"4V"!==i.A.CS&&i.A.FT&&p.1i(1b+"--vd"+b+ZC.1b[30]+t+\'" />\')}"4V"===i.A.CS?(i.E.sn=!0,i.E.2S=d.4w(f.9m())):i.E.2S=1c,i.A.A2.o&&("1Z"===i.A.A2.o.1I||1c!==ZC.1d(i.A.A2.o.2f)&&!ZC.2q(i.A.A2.o.2f))&&"4V"!==i.A.CS||i.P6(!0),i.9A(o,r,C)},6e:1f(){}}),ZC.vD=ZC.M5.C7({$i:1f(e){1g.b(e),1g.W8=0,1g.W9=0},KC:1f(e,t,i,n){1a a=1g,l=1c;1m l=a.A.L<a.A.A.A7.1h-1?a.A.A.A7[a.A.L+1]:a.A.A.A7[0],a.CR=[["%vF-1B-1D",l.AP],["%vF-2o-1S",l.S[a.L].AE],["%sq-1S",a.W9],["%6a-1S",1c===ZC.1d(a.A.A.XB[a.L])?0:a.A.A.XB[a.L].1M]],e=a.b(e,t,i,n)},2E:1f(){1a e=1g,t=e.C.BL("1z"),i=e.L%t.GT,n=1A.4i(e.L/t.GT);e.iX=t.iX+i*t.GF+t.GF/2+t.BJ,e.iY=t.iY+n*t.G7+t.G7/2+t.BD,e.HS||(e.1Q(e.A),e.E4=e.A.E4,e.DD()&&e.1q(!1),e.HS=!0),e.I=t.GF/2,e.F=t.G7/2},7n:1f(e){1a t=1g,i=e.I,n=e.F,a=t.iX-i/2,l=t.iY-n/2;if(3===t.A.A.A7.1h)1P(t.A.L){1j 0:a-=t.AH/4,l+=t.AH/8;1p;1j 1:a+=t.AH/4,l+=t.AH/8;1p;1j 2:l-=t.AH/4}1t 1P(t.A.L){1j 0:a-=t.AH/4;1p;1j 1:a+=t.AH/4}1m 1c!==ZC.1d(e.o.x)&&(a=e.iX),1c!==ZC.1d(e.o.y)&&(l=e.iY),a+=e.BJ,l+=e.BD,[ZC.1l(a),ZC.1l(l)]},H5:1f(){1a e,t,i=1g,n=i.b(),a=i.C.K+"-1S-3B "+i.C.K+"-1B-"+i.A.L+"-1S-3B zc-1S-3B",l=i.H.2L()?i.H.mc("1u"):i.C.AJ["3d"]||i.H.K3?ZC.AK(i.C.K+"-4j-vb-c"):ZC.AK(i.C.K+"-1B-"+i.A.L+"-vb-c"),o=i.H.2L()?ZC.AK(i.C.A.K+"-1u"):ZC.AK(i.C.A.K+"-1D");if(1c!==ZC.1d(n.o.sq)){if(0===i.A.L&&!i.C.E["vH.2f"]||1===i.A.L&&!i.C.E["vJ.2f"]||2===i.A.L&&!i.C.E["vA.2f"])1m;i.A.L<i.A.A.A7.1h-1?i.A.A.A7[i.A.L+1]:i.A.A.A7[0],e=i.A.A.DX[i.A.L][i.L].eW,(t=1n ZC.DQ(i)).1Q(n),t.o.1D=""+i.W9,t.1C(n.o.sq),t.KC=1f(e){1m i.KC(e,{})},t.1q(),t.GG=a,t.K=i.K+"-1S-3B-2I",t.Z=n.C5=l,t.IE=o,t.iX=e[0]-t.I/2,t.iY=e[1]-t.F/2,t.AL&&(t.1v(),t.EH())}if(1c!==ZC.1d(n.o.6a)&&2===i.A.L){if(!i.C.E["vA.2f"]||!i.C.E["vH.2f"]||!i.C.E["vJ.2f"])1m;e=i.A.A.XB[i.L].xy,(t=1n ZC.DQ(i)).1Q(n),t.o.1D=""+i.A.A.HK[i.A.L],t.1C(n.o.6a),t.KC=1f(e){1m i.KC(e,{})},t.1q(),t.GG=a,t.K=i.K+"-1S-3B-6a",t.Z=n.C5=l,t.IE=o,t.iX=e[0]-t.I/2,t.iY=e[1]-t.F/2,t.AL&&(t.1v(),t.EH())}},82:1f(){1m{1r:1g.B6}},XP:1f(){1m{"1R-1r":1g.BU,"1F-1r":1g.BU,1r:1g.BZ}},1v:1f(){1f e(){1a e=i.C.K+ZC.1b[34]+i.C.K+ZC.1b[35]+i.A.L+ZC.1b[6],t=ZC.P.GC("3x",i.A.E5,i.A.IM)+\'3g="\'+e+\'" id="\'+i.K+ZC.1b[30]+ZC.1l(i.iX+ZC.3y)+","+ZC.1l(i.iY+ZC.3y)+","+ZC.1l(ZC.BN(ZC.2H?6:3,i.AH)*(ZC.2H?2:1.2))+\'" />\';i.A.A.HK.1i(t),i.A.U&&i.H5()}1a t,i=1g;if(i.A.L>=3)i.A.U&&i.H5();1t{i.b();1a n=i.N=i.A.I1(i,i),a=1n ZC.DS(i.A);a.K=i.K,a.Z=i.A.CL("bl",1),a.C5=i.A.CL("bl",0),a.1Q(n);1a l=i.iX,o=i.iY;if(a.iX=l,a.iY=o,a.AH=i.AH,a.DP="3x",a.E.7i=i.A.L,a.E.7l=i.L,a.1q(),i.FL=a,i.A.GA&&!i.C.HC){1a r=a,C={};r.iX=l,r.iY=o,C.x=l,C.y=o;1a A=i.A.L6;if(r.C6=0,C.2k=n.C6,3===A)r.AH=2,C.2b=i.AH;1t if(4===A){1P(i.A.L){1j 0:r.iX=l-3*i.AH,r.iY=o;1p;1j 1:r.iX=l+3*i.AH,r.iY=o;1p;1j 2:r.iX=l,r.iY=o-3*i.AH}C.x=l,C.y=o}1k(t in i.A.FR)r[ZC.E8.GI[ZC.EB(t)]]=i.A.FR[t],C[ZC.EB(t)]=n[ZC.E8.GI[ZC.EB(t)]];if(i.C.EN||(i.C.EN={}),1c!==ZC.1d(i.C.EN[i.A.L+"-"+i.L]))1k(t in i.C.EN[i.A.L+"-"+i.L])r[ZC.E8.GI[ZC.EB(t)]]=i.C.EN[i.A.L+"-"+i.L][t];i.C.EN[i.A.L+"-"+i.L]={},ZC.2A(C,i.C.EN[i.A.L+"-"+i.L]);1a s=1n ZC.E8(r,C,i.A.J9,i.A.L2,ZC.E8.RJ[i.A.L4],1f(){e()});s.AV=i,i.LL(s)}1t a.1v(),e()}},6e:1f(e){1a t=1g;ZC.3l||t.M2({6r:e,1I:"2P",92:1f(){1g.DP="3x",1g.A0=t.A.BO[3],1g.AC=t.A.BO[3]},d1:1f(){1g.iX=t.iX,1g.iY=t.iY,1g.AH=t.AH}})}}),ZC.M5.5a.N0=1f(e,t){1a i,n,a=1g;if(1w t===ZC.1b[31]&&(t=!1),t)1w a.E.sg!==ZC.1b[31]&&((i=1n ZC.CZ(a)).1Q(a.A),a.A.J5&&(i.1Q(a.A.J5),i.1C(a.A.J5.o[ZC.1b[71]])),i.1q(),i.K=a.K+"--4L-2J",i.AL&&ZC.CN.1v(e,i,a.E.sg));1t{1a l=a.A.CI,o=a.A.B0;if(0!==a.A.RX.1h){1a r=1c,C=1c,A=!0;a.A.RX.1h<=2?(1c!==ZC.1d(a.A.RX[0])&&a.A.RX[0]3z 3K&&(A=!1),1c!==ZC.1d(a.A.RX[1])&&a.A.RX[1]3z 3K&&(A=!1)):A=!1,A?(r=a.A.RX[0],C=a.A.RX[1]):1c!==ZC.1d(n=a.A.RX[a.L])&&n 3z 3K&&(r=C=n[0],2===n.1h&&(C=n[1])),a.E["2o-4L-8n"]=r,a.E["2o-4L-sF"]=C,-1!==(r+"").1K("%")&&(r=ZC.IB(r))<=1&&(r*=a.AE),-1!==(C+"").1K("%")&&(C=ZC.IB(C))<=1&&(C*=a.AE);1a s=[],Z=ZC.IB(a.A.J5?a.A.J5.o[ZC.1b[21]]||.5:.5);Z<=1&&(Z="5A"===a.A.AF?ZC.1l(Z*a.I):"6d"===a.A.AF?ZC.1l(Z*a.F):ZC.1l(Z*o.A9));1a c,u=0;if(u=o.D9?a.F:a.I,1c!==ZC.1d(r)){1a p=l.B2(a.CM+r);o.D9?(c=l.AR?a.AE<0?a.iX+a.I:a.iX:a.AE>0?a.iX+a.I:a.iX,s.1i([p,a.iY+u/2-Z/2],[p,a.iY+u/2+Z/2],1c,[p,a.iY+u/2],[c,a.iY+u/2])):(c=l.AR?a.AE>0?a.iY+a.F:a.iY:a.AE<0?a.iY+a.F:a.iY,s.1i([a.iX+u/2-Z/2,p],[a.iX+u/2+Z/2,p],1c,[a.iX+u/2,p],[a.iX+u/2,c]))}if(1c!==ZC.1d(C)){1a h=l.B2(a.CM-C);o.D9?(c=l.AR?a.AE<0?a.iX+a.I:a.iX:a.AE>0?a.iX+a.I:a.iX,s.1i(1c,[h,a.iY+u/2-Z/2],[h,a.iY+u/2+Z/2],1c,[h,a.iY+u/2],[c,a.iY+u/2])):(c=l.AR?a.AE>0?a.iY+a.F:a.iY:a.AE<0?a.iY+a.F:a.iY,s.1i(1c,[a.iX+u/2-Z/2,h],[a.iX+u/2+Z/2,h],1c,[a.iX+u/2,h],[a.iX+u/2,c]))}(i=1n ZC.CZ(a)).1Q(a.A),a.A.J5&&i.1Q(a.A.J5),i.1q(),i.K=a.K+"--4L",i.CX=!1,ZC.CN.1v(e,i,s),a.E.sg=s}}},ZC.H2=ZC.HQ.C7({$i:1f(e){1g.b(e);1a t=1g;t.H=t.A.A,t.BB="",t.W=[],t.BW=[],t.tv=[],t.DK=!1,t.M=1c,t.BQ=1c,t.IK=1c,t.D5=1c,t.GQ=0,t.I2=1c,t.FY=1c,t.GZ=0,t.OX=1c,t.L=1,t.A6=0,t.s6=0,t.BV=0,t.AR=!1,t.D9=!1,t.A9=0,t.DW=-1,t.RA=ZC.HA[ZC.1b[13]]||"",t.RT=ZC.HA[ZC.1b[14]]||".",t.ZT=!1,t.SC=2,t.f2=!1,t.TP="",t.ZL="vm",t.CG=1c,t.AF="",t.EE=ZC.3q,t.LX=ZC.3q,t.H1=!1,t.Y5=!1,t.LO=1c,t.NL=1c,t.PX=[],t.EA=1,t.B8=-1,t.BS=-1,t.SB=-1,t.GV=-1,t.HF=-1,t.CA="m4",t.EV=10,t.FD=1c,t.OY=1,t.PR=!0,t.mn=!1,t.7I=[!1,!1],t.LP=1c,t.WH=1c,t.T1=!1,t.HN=-1,t.Y6=!1,t.B7="2n",t.QM=!1,t.V7=!1,t.QV=1,t.dI="",t.im=!0},1q:1f(){1f e(e){1a t=[A+".4z."+e,A+"."+i.BB+"."+e,A+"."+s+"."+e,A+"."+s+"["+i.B7+"]."+e,A+"."+Z+"."+e];1m i.A.AJ["3d"]&&(t=t.4w([A+".4z[3d]."+e,A+"."+i.BB+"[3d]."+e,A+"."+s+"[3d]."+e,A+"."+Z+"[3d]."+e])),t}1g.b();1a t,i=1g;if(1c!==ZC.1d(t=i.o.6Y))if(ZC.P2(t))i.EA=ZC.1W(t);1t{1a n=t.1E(/[0-9]/gi,""),a=5w(t.1E(/[^0-9]/gi,""),10);1P(a=a||1,n){1j"my":i.EA=5L*a;1p;1j"iR":i.EA=5L*a*60;1p;1j"mB":i.EA=5L*a*60*60;1p;1j"ew":i.EA=5L*a*60*60*24;1p;1j"vW":i.EA=5L*a*60*60*24*7;1p;1j"ft":i.EA=15j*a;1p;1j"mD":i.EA=15u*a}}if(1c!==ZC.1d(i.o.iK)&&1c===ZC.1d(i.o["5E"])&&(i.o["5E"]=i.o.iK),i.4y([[ZC.1b[10],"BW"],["2C-1D","tv"],["5K","CG"],["1Y-46","A6","i"],["1Y-46","s6","i"],["1Y-6n","BV","i"],["4Q-9J","GQ","i"],["2V","L","i"],["vh","AR","b"],["cj","H1","b"],["3C-15B","Y5","b"],["7m-6Y","QM","b"],["3C-to","LO"],["ei-15A","Y6","b"],["3C-to-6g","NL"],["2z-ix","mn","b"],["15z","T1","b"],["1V-cb","EE","i"],["1V-2z","EE","i"],["3N-1S","GZ","f"],[ZC.1b[12],"DW","ia"],[ZC.1b[14],"RT"],[ZC.1b[13],"RA"],["5E","f2","b"],["5E-e1","TP"],["8g","ZL"],["a8","ZT","b"],[ZC.1b[25],"SC","ia"],["fo","CA"],["2W-15y","EV","fa"],["1z-7b","OY","fa"],["4k-cb","LP"],["1V-6h","HN","i"],[ZC.1b[7],"B7"],["7b","QV","f"],["15v","dI"],["15t","V7","b"],["yu","DK","b"],["gy","im","b"]]),1c!==ZC.1d(t=i.o["3e-gw"])&&(t.1h?(i.7I[0]=ZC.2q(t[0]),i.7I[1]=ZC.2q(t[t.1h-1])):i.7I[0]=i.7I[1]=ZC.2q(t)),"2Y"==1w i.BW){1a l=i.BW.2l(":"),o=1;3===l.1h&&(o=ZC.1W(l[2])),i.BW=[];1k(1a r=ZC.1W(l[0]);r<ZC.1W(l[1]);r+=o)i.BW.1i(""+r);i.BW.1i(""+l[1])}1c!==ZC.1d(i.o["7m-2z"])&&(i.EE=ZC.3q),i.EE=ZC.BN(i.EE,2),1c!==ZC.1d(t=i.o.1Y)&&(i.A6=i.BV=ZC.1l(t),0!==ZC.1l(t)||"9q"!==i.A.AF&&"b1"!==i.A.AF||(i.DK=!1)),1c!==ZC.1d(t=i.o["1V-9J"])?i.LX=ZC.1l(t):i.LX=i.EE,i.LX=ZC.BN(2,i.LX),1c!==ZC.1d(t=i.o.5H)&&(i.FD=1n ZC.CZ,i.FD.1C(t));1a C=i.A.A.B9,A="("+i.A.AF+")",s=i.BB.1E(/\\-[0-9]/,""),Z=i.BB.1E(/\\-[0-9]/,"-n");if(1c===ZC.1d(i.o[ZC.1b[7]])&&i.L>1&&(i.B7="5u"),1c!==ZC.1d(t=i.o.15l))1k(1a c=0,u=t.1h;c<u;c++){1a p=1n ZC.zy(i);p.L=c,p.K=i.K+"-1O-"+c,C.2t(p.o,e("1O")),p.1C(t[c]),p.1q(),i.PX.1i(p)}i.OX=1n ZC.CZ(i),C.2t(i.OX.o,e("3N-1y")),i.OX.1C(i.o["3N-1y"]),"k"===i.AF&&(i.OX.AL=!1),i.OX.1q(),i.M=1n ZC.DQ(i),C.2t(i.M.o,e("1G")),i.M.1C(i.o.1G),i.M.K=i.K+"-1G",i.M.1q(),i.BQ=1n ZC.DQ(i),C.2t(i.BQ.o,e("1N")),i.BQ.1C(i.o.1N),i.BQ.K=i.K+"-1N",i.BQ.1q(),i.IK=1n ZC.CZ(i),C.2t(i.IK.o,e("3W")),i.IK.1C(i.o.3W),i.IK.1q(),i.D5=1n ZC.CZ(i),C.2t(i.D5.o,e("2g")),i.D5.1C(i.o.2g),i.D5.1q(),1c===ZC.1d(i.D5.o.2z)&&"-1"!==i.D5.A0&&"-1"!==i.D5.AC&&i.D5.A0!==i.D5.AC&&(i.D5.o.2z=[{2k:i.D5.C6,"1R-1r":i.D5.A0},{2k:i.D5.C6,"1R-1r":i.D5.AC}]),i.I2=1n ZC.CZ(i),C.2t(i.I2.o,e("4Q-3W")),i.I2.1C(i.o["4Q-3W"]),i.I2.1q(),i.FY=1n ZC.CZ(i),C.2t(i.FY.o,e("4Q-2g")),i.FY.1C(i.o["4Q-2g"]),i.FY.1q(),i.gX()},gX:1f(){1a e,t=1g,i={x:"iX",y:"iY",1s:"I",1L:"F"};1k(1a n in i){1a a=t.A.Q[i[n]];1c!==ZC.1d(t.o[n])&&(a=ZC.IB(t.o[n]))>=0&&a<=1&&(a="x"===n||"y"===n?t.A.Q["x"===n?"iX":"iY"]+ZC.1l(a*t.A.Q["x"===n?"I":"F"]):ZC.1l(a*t.A.Q[i[n]])),t[i[n]]=a}1c!==ZC.1d(e=t.o.1Y)&&(t.A6=t.BV=ZC.1W(ZC.8C(e))),1c!==ZC.1d(e=t.o["1Y-46"])&&(t.A6=ZC.1W(ZC.8C(e))),1c!==ZC.1d(e=t.o["1Y-6n"])&&(t.BV=ZC.1W(ZC.8C(e)));1a l="k"===t.AF&&!t.D9||"v"===t.AF&&t.D9?t.I:t.F;t.A6<1&&(t.A6*=l),t.BV<1&&(t.BV*=l)},YT:1f(e){1a t=1g;1c!==ZC.1d(t.o.ac)&&(t.WH||(t.WH=1n ZC.H2(t.A)),t.WH.1C(t.o),t.WH.1q(),t.WH.JC=e,t.WH.DD()&&(t.WH.1q(),t.DW=t.WH.DW,t.CG=t.WH.CG))},IW:1f(){},er:1f(){},mg:1f(){},7j:1f(){},3v:1f(){},8e:1f(){},MG:1f(){1a e,t=1g,i={8g:t.ZL,"mr-8P":t.RA,"6h-8P":t.RT,6h:t.DW,"1V-6h":t.HN,"5E":t.f2,"5E-e1":t.TP,a8:t.ZT,"a8-6h":t.SC};if(t.FD)1P(t.FD.o.1I){1j"5z":i[ZC.1b[68]]=!0,1c!==ZC.1d(e=t.FD.o.1D)&&(t.FD.o.4q=e);1a n=t.W[t.A1]-t.W[t.X],a="",l="",o={},r=["sa","my","iR","mB","ew","ft","mD"];1k(1a C in r)o[r[C]]=ZC.HA["5z-s7"][r[C]];l=0<=n&&n<=5L?"sa":5L<n&&n<=md?"my":md<n&&n<=w0?"iR":w0<n&&n<=w8?"mB":w8<n&&n<=vU?"ew":vU<n&&n<=15p?"ft":"mD",a=1c!==ZC.1d(t.FD.o[l])?t.FD.o[l]:1c!==ZC.1d(t.FD.o.4q)?t.FD.o.4q:o[l],t.E.vV=a,i[ZC.1b[67]]=t.E.vV}1m i},ZZ:1f(){1k(1a e=1g,t=e.A.AX.A7,i=-1,n=0,a=t.1h;n<a;n++){1a l=t[n].BT(e.AF);if(-1!==ZC.AT(l,e.BB)){1P(t[n].AF){1j"3L":1j"7k":1j"96":1j"5A":1j"6M":1j"6d":1j"7v":1j"8q":1j"80":1j"1M":1j"81":1j"8M":1j"ao":1j"ap":1j"aV":i=t[n].A0;1p;1j"6t":1j"5h":i=-1!==t[n].A2.A0?t[n].A2.A0:t[n].A0;1p;2n:i=t[n].B6}1p}}1m i},1v:1f(){1a e=1g;e.8e(),e.A.AJ["3d"]||e.b()},MT:1f(e,t,i,n){1a a=1g;if(1c===ZC.1d(n)&&(n=5),a.A.AJ["3d"]){1a l=1n ZC.CF(a.A,e.iX+e.I/2-ZC.AM.E1,e.iY+e.F/2-ZC.AM.E0,0+e.sG);e.iX=l.E9[0]-e.I/2+("v"===i?"2n"===a.B7?-n:n:0),e.iY=l.E9[1]-e.F/2+("h"===i?"2n"===a.B7?n:-n:0);1a o=ZC.DF.si(a.A,e);1c===ZC.1d(t)&&(t=e.AA,e.AA%90==0&&(t+=e.V0?0:o)),e.AA=t}1m t},WS:1f(e,t,i){1a n=1g,a=(i.2z,i.hi),l=i.hj,o=i.aP,r=i.aQ,C=i.gR,A=i.4a,s=[e.iX+e.BJ,e.iY+e.BD,e.I,e.F],Z=ZC.2i(e.AA%180),c=!1;Z%2j!=0&&(c=!0),c&&(s=[e.iX+e.BJ+e.I/2-e.F/2,e.iY+e.BD+e.F/2-e.I/2,e.F,e.I]);1a u=!0;if(e.AL){if(!n.mn)if(t===n.X||t===n.A1)u=!0;1t{t%l==0&&(u=!0);1k(1a p=0,h=a.1h;p<h;p++)if(ZC.AN.XG({x:s[0],y:s[1],1s:s[2],1L:s[3]},{x:a[p][0],y:a[p][1],1s:a[p][2],1L:a[p][3]})){u=!1;1p}}u&&(a.1i(s),e.1v(),0,r=ZC.BN(r,1.5*e.DG*(e.AP||"").2l("<br>").1h),"h"===C?(o+=e.F,r=ZC.BN(r,ZC.2i(ZC.EL(Z))*ZC.BN(e.I,e.F))):"w"===C&&(o+=e.I,r=ZC.BN(r,ZC.2i(ZC.ED(Z))*ZC.BN(e.I,e.F))),e.EH(),1c===ZC.1d(n.o.2C)&&e.K3||(1c!==ZC.1d(n.o.2C)&&(n.o.2C.1D=n.o.2C.1D||"%1z-1S"),A.1i(ZC.AO.NZ(n.A.K,e))))}1m{aP:o,aQ:r,uP:!u}},VA:1f(e,t){1a i=1g;if("v"===i.AF&&(i.GZ!==i.B8&&i.GZ!==i.BS||(1c===ZC.1d(i.o["3N-1y"])||1c!==ZC.1d(i.o["3N-1y"])&&1c===ZC.1d(i.o["3N-1y"].2f))&&(i.OX.AL=!1)),i.OX.K=i.K+"-3N-1y",i.W.1h>0&&i.OX.AL&&!i.A.AJ["3d"]&&i.OX.AY>0){"5n"===i.OX.o["1y-1r"]&&-1!==t&&(i.OX.B6=t);1a n=i.GZ;if("k"===i.AF&&!i.D9||"v"===i.AF&&i.D9){1a a=i.B2(n);a>=i.iX&&a<=i.iX+i.I&&ZC.CN.1v(e,i.OX,[[a,i.iY],[a,i.iY+i.F]])}1t{1a l=i.B2(n);l>=i.iY&&l<=i.iY+i.F&&ZC.CN.1v(e,i.OX,[[i.iX,l],[i.iX+i.I,l]])}}},6E:1f(){},XC:1f(){1k(1a e=1g,t=0,i=e.PX.1h;t<i;t++)e.W.1h>0&&e.PX[t].1v()},gc:1f(){ZC.AO.gc(1g,["W","BW","Z","C5","D5","BQ","M","FY","I2","OX","IK","JC","o","HU","JO","A","H"])}}),ZC.h0=ZC.H2.C7({$i:1f(e){1g.b(e);1a t=1g;t.EC=!1,t.AF="k",t.E7=-1,t.EF=-1,t.X=-1,t.A1=-1,t.UV=1,t.DW=1c,t.OF=0,t.lz=!1,t.NQ=!1,t.TX={},t.IH=[]},a4:1f(e,t){1a i=1g;if(i.H1){1c!==ZC.1d(e)?i.X=e:i.X=i.E7,1c!==ZC.1d(t)?i.A1=t:i.A1=i.EF;1a n=i.IH;if(n.1h>0?(i.B8=ZC.AT(n,i.W[i.X]),i.BS=ZC.AT(n,i.W[i.A1])):(i.B8=i.W[i.X],i.BS=i.W[i.A1]),i.H.H3.C||(i.H.H3.C=i.A),i.A.H3&&1c!==ZC.1d(i.A.H3.o.6a)&&ZC.2q(i.A.H3.o.6a)&&i.A.K===i.H.H3.C.K)1k(1a a=0,l=i.H.AI.1h;a<l;a++){1a o=i.H.AI[a];if(o.K!==i.A.K&&1c!==ZC.1d(o.H3.o.6a)&&ZC.2q(o.H3.o.6a)){1a r=o.BL(i.BB);r&&r.H1&&(e=1A.1V(r.E7,1A.2h(r.EF,i.X)),t=1A.1V(r.E7,1A.2h(r.EF,i.A1)),r.a4(e,t),ZC.AK(o.K)&&(o.3v(!0),o.E["6a-3C"]=!0,o.1v(),o.BI&&o.BI.3O(e,t,1c,1c,!0)))}}i.IW()}},15n:1f(e,t){1a i=1g;1c!==ZC.1d(e)?i.B8=e:i.B8=i.GV,1c!==ZC.1d(t)?i.BS=t:i.BS=i.HF,i.RN(i.B8,i.BS,1c===ZC.1d(e)&&1c===ZC.1d(t))},G0:1f(L,J,EP,w7){1a s=1g,CU="";J?(CU=J.S[L].BX,s.FD&&"5z"===s.FD.o.1I||"8X"==1w CU||(1c!==ZC.1d(s.BW[CU])?CU=s.BW[CU]:1c!==ZC.1d(s.W[CU])&&(CU=s.W[CU]))):CU="2W"===s.CA&&w7?L+1:1c!==ZC.1d(s.BW[L])?s.BW[L]:s.W[L],"8X"==1w CU&&1c!==ZC.1d(s.IH[CU])&&(CU=s.IH[CU]);1a OI=ZC.P2(CU)&&ZC.1W(CU)<0,BG=s.MG();if(ZC.2A(EP,BG),OI&&"cl"===BG.8g&&(CU=ZC.2i(ZC.1W(CU))),BG.ch=s.A.UG,BG.cn=s.A.N2,CU=ZC.AO.GM(CU,BG,s,!0),s.CG)if("()"===s.CG.2s(s.CG.1h-2)||"7u:"===s.CG.2s(0,11))4I{1a EG=s.CG.1E("7u:","").1E("()","");7t(EG)&&(CU=7t(EG).4s(s,CU))}4G(e){}1t CU=OI&&"cl"===BG.8g?"-"+s.CG.1E(/%v|%1z-1S/g,CU):s.CG.1E(/%v|%1z-1S/g,CU);1m CU},KC:1f(e,t,i,n,a){1a l=1g,o=l.G0(t,i,n,a),r=[];r.1i(["%1z-1G",o],["%1z-2V",t],["%1z-2G",t]),l.FD&&"5z"===l.FD.o.1I?r.1i(["%1z-1S",o],["%v",o]):"2W"===l.CA&&a?r.1i(["%1z-1S",1A.5k(l.EV,t)],["%v",1A.5k(l.EV,t)]):r.1i(["%1z-1S",ZC.7O(l.W[t],"")],["%v",ZC.7O(l.W[t],"")]),r.1i(["%l",o],["%t",o],["%i",t],["%c",t]),r.3V(ZC.m2);1k(1a C=0,A=r.1h;C<A;C++){1a s=1n 5o(r[C][0],"g");e=e.1E(s,r[C][1])}1m e},er:1f(){1a e=1g,t=ZC.BN(e.W.1h,e.BW.1h),i=0;if(t>0&&e.BQ.AA%180==0){1k(1a n=ZC.BN(1,ZC.1l(t/20)),a=0,l=0;l<t;l+=n){1k(1a o=((e.BW[l]||e.W[l])+"").2l(/<br>|<br\\/>|<br \\/>|\\n/),r=0,C=0,A=o.1h;C<A;C++)r=ZC.BN(r,10*o[C].1E(/<.+?>/gi,"").1E(/<\\/.+?>/gi,"").1h);i+=r,a++}i=.75*i/1A.1V(1,a)}1t i=15;e.D9?e.EE=ZC.1l((e.F-e.A6-e.BV)/15):e.EE=ZC.1l((e.I-e.A6-e.BV)/i),e.EE=ZC.CV(e.EE,10),(e.BS-e.B8)/e.EA+1<e.EE?e.EE=ZC.BN(e.EE,ZC.1l((e.BS-e.B8)/e.EA)+1):(e.BS-e.B8)/(2*e.EA)+1<e.EE&&(e.EE=ZC.BN(e.EE,ZC.1l((e.BS-e.B8)/(2*e.EA))+1)),e.EE=ZC.BN(2,e.EE)},mg:1f(){1a e=1g;1c===ZC.1d(e.o["1V-9J"])&&(e.LX=e.EE)},7j:1f(e){1a t,i,n,a,l,o=1g;if(1===e&&o.o.5H&&"5z"===o.o.5H.1I&&(1c===ZC.1d(o.o.5H.vc)||ZC.2q(o.o.5H.vc)||(o.NQ=!0)),1===e&&1c!==ZC.1d(o.o[ZC.1b[5]]))if(o.W=[],"4g"==1w o.o[ZC.1b[5]])1k(o.W=o.o[ZC.1b[5]],0===o.BW.1h&&(o.BW=o.W),n=0,a=o.W.1h;n<a;n++)"2Y"==1w o.W[n]&&(o.lz=!0,o.IH.1i(o.W[n]));1t{1a r=o.o[ZC.1b[5]].2l(":"),C=o.EA;if(3===r.1h&&(C=ZC.1W(r[2])),o.EA=o.SB=C,ZC.1W(r[0])>ZC.1W(r[1])){1a A=r[0];r[0]=r[1],r[1]=A}if(C<=0&&(C=1),r.1h>1){1k(1a s=0,Z=0,c=0,u=(""+C).2l("."),p=ZC.1W(r[0]);p<=ZC.1W(r[1]);p+=C){1a h=(""+p).2l(".");u.1h>1&&h.1h>1&&u[1].1h>0&&h[1].1h>=9&&ZC.2i(h[1].1h-u[1].1h)>2?(s+=u[1].1h,Z=ZC.BN(Z,u[1].1h),c++,1c!==(l=ZC.1d(o.o[ZC.1b[12]]))?o.W.1i(ZC.1W(4P(p).4v(ZC.1l(l)))):o.W.1i(ZC.1W(ZC.bn(4P(p),u[1].1h)))):(s+=h[1]?h[1].1h:0,Z=ZC.BN(Z,h[1]?h[1].1h:0),c++,1c!==(l=ZC.1d(o.o[ZC.1b[12]]))?o.W.1i(ZC.1W(4P(p).4v(ZC.1l(l)))):o.W.1i(p))}1c===ZC.1d(o.o[ZC.1b[12]])&&(s=1A.4h(s/c),o.DW=ZC.2i(Z-s)<=1?Z:s)}}if(2===e){1a 1b=0,d=[];0===o.W.1h?(t=ZC.3q,i=-ZC.3q):(t=o.W[0],i=o.W[o.W.1h-1]);1a f=o.A.AX.A7,g=!1;1k(n=0,a=f.1h;n<a;n++){1a B=f[n].BT();if(-1!==ZC.AT(B,o.BB)){1k(1a v=0===d.1h,b=0,E=f[n].S.1h;b<E;b++)if(f[n].S[b])if(1c!==f[n].S[b].BX){1a m=f[n].S[b].BX;t=ZC.CV(t,m),i=ZC.BN(i,m),o.NQ&&v&&d.1i(m),o.EC=!0,f[n].EC=!0}1t g=!0;1t o.NQ&&v&&d.1i("");f[n].EC||(1b=ZC.BN(1b,f[n].S.1h))}}if(1c!==ZC.1d(o.o[ZC.1b[5]]))1k(n=0;n<o.W.1h;n++)1c===o.W[n]&&(o.W[n]="");if(1c!==ZC.1d(o.o[ZC.1b[10]]))1k(n=0;n<o.BW.1h;n++)1c===o.BW[n]&&(o.BW[n]="");if(1b>o.W.1h&&o.W.1h>0&&!o.EC)1k(n=o.W.1h;n<1b;n++);1a K,F,D=0;1k(n=0;n<f.1h;n++)f[n].LN&&(-1===f[n].R1&&(f[n].R1=D),D++,o.DK=!0);if(0===o.W.1h)1k(n=0;n<D;n++)o.W.1i(n),o.BW.1i(n);if(0===o.W.1h)if(o.EC)g&&t>0&&(t=0),g&&i<1b-1&&(i=1b-1),1c!==ZC.1d(o.o["2h-1S"])&&(t=ZC.1W(o.o["2h-1S"])),1c!==ZC.1d(o.o["1V-1S"])&&(i=ZC.1W(o.o["1V-1S"])),i-t<o.EA&&i-t>0&&(o.EA=1A.5k(10,1A.4i(ZC.HH(i-t)/1A.bm))),o.NQ||o.RN(t,i,!0),0===t&&0===i&&"0,1"===o.W.2I(",")&&(o.W=[0]);1t if(1c!==ZC.1d(o.o["1V-1S"])){K=0,F=0,1c!==ZC.1d(o.o["2h-1S"])&&(K=ZC.1W(o.o["2h-1S"])),F=ZC.1W(o.o["1V-1S"]),n=0;1a I=K;if(o.FD&&1c!==ZC.1d(o.FD.o.1I))1P(o.FD.o.1I){1j"5z":o.EA=o.tc(K,F)}1t F-K/o.EA>8p&&(o.EA=1A.5k(10,ZC.BN(1,ZC.1l(ZC.HH(ZC.2i(F-K),10)-4))));1k(;I<F;)I=o.A.cE(n*o.EA+K),1c===ZC.1d(o.W[n])&&(o.W[n]=I),n++}1t if(K=1c!==ZC.1d(o.o["2h-1S"])?ZC.1W(o.o["2h-1S"]):0,F=K+(1b-1)*o.EA,"2W"===o.CA)o.RN(K,F,!0);1t 1k(n=0;n<1b;n++)1c===ZC.1d(o.W[n])&&(o.W[n]=o.A.cE(n*o.EA+K));o.NQ&&o.EC&&(o.W=[].4w(d),o.BW=[].4w(d))}if(o.NQ)1k(o.TX={},n=0,a=o.BW.1h;n<a;n++)o.TX[o.BW[n]]=n;if(o.X=0,o.A1=o.W.1h-1,o.E7=0,o.EF=o.W.1h-1,o.IH.1h>0?(o.B8=o.X,o.BS=o.A1):(o.B8=ZC.1W(o.W[o.X]),o.BS=ZC.1W(o.W[o.A1])),o.NL){-1===ZC.AT(o.W,o.NL[0])&&ZC.P2(o.NL[0])&&1c!==ZC.1d(o.W[0])&&-1!==o.SB&&(o.NL[0]=o.W[0]+o.SB*1A.4i((o.NL[0]-o.W[0])/o.SB)),-1===ZC.AT(o.W,o.NL[1])&&ZC.P2(o.NL[1])&&1c!==ZC.1d(o.W[0])&&-1!==o.SB&&(o.NL[1]=o.W[0]+o.SB*1A.4h((o.NL[1]-o.W[0])/o.SB));1a X=ZC.AT(o.W,o.NL[0]),x=ZC.AT(o.W,o.NL[1]);o.LO=[-1===X?0:X,-1===x?o.W.1h-1:x]}o.LO&&-1!==o.X&&-1!==o.A1&&((o.LO[0]>o.A1||o.LO[0]<o.X)&&(o.LO[0]=o.X),(o.LO[1]>o.A1||o.LO[1]<o.X)&&(o.LO[1]=o.A1));1a y=o.H.E["2U"+o.A.L+".3C"];if(1c===ZC.1d(o.H.E[ZC.1b[53]])||o.H.E[ZC.1b[53]]){1a L=1===o.L?"":"-"+o.L;1w y!==ZC.1b[31]&&1c!==ZC.1d(y["4r"+L])&&1c!==ZC.1d(y["4m"+L])&&(o.LO=[y["4r"+L],y["4m"+L]])}1t o.H.E["2U"+o.A.L+".3C"]={};o.LO&&(o.A.il=!0)},RN:1f(e,t,i){1a n,a,l,o,r=1g,C=!1,A=1c!==ZC.1d(r.o.6Y)&&-1!==(""+r.o.6Y).1K("ft");if(r.FD&&1c!==ZC.1d(r.FD.o.1I))1P(r.FD.o.1I){1j"5z":1a s=r.tc(e,t);(t-e)%s!=0&&(A||(t+=s-(t-e)%s)),n=[e,t,s,1,s],C=!0}1t if("2W"===r.CA)n=[e,t,1,1,1];1t{1a Z=1c!==ZC.1d(r.o.6Y)||1c!==ZC.1d(r.o["2h-1S"])||1c!==ZC.1d(r.o["1V-1S"]);n=e!==t?ZC.AN.W5(e,t,r.EA,r.OY,Z):[e,t,r.EA,1,r.EA]}-1===r.SB&&(r.SB=n[4]);1a c=n[0],u=n[1];o=n[2],i&&"2W"===r.CA&&(c=1A.4i(ZC.HH(c,r.EV)),u=1A.4h(ZC.HH(u,r.EV))),1c===ZC.1d(r.o.6Y)&&(u-c)/o>8p&&(o=(u-c)/8p,l=1A.4h(ZC.HH(o)/1A.bm),o=1A.5k(10,l)),1c===ZC.1d(r.o["2h-1S"])&&c!==u&&(C&&A||(c-=c%o)),1c===ZC.1d(r.o["1V-1S"])&&c!==u&&(C&&A||(u=u-u%o+(u%o==0?0:o))),l=1A.4i(ZC.HH(o)/1A.bm);1a p=n[3];l<p&&l<0&&(p=l),"2W"===r.CA&&(p=ZC.BN(1,p)),r.W=[];1a h;if(C&&A){1a 1b=ZC.AO.Y2(c,"%Y-%n-%d-%H-%i-%s",!1,0).2l("-"),d=!0,f=ZC.1l((""+r.o.6Y).1E("ft"));0===f&&(f=1);1a g=ZC.1l(1b[1]),B=ZC.1l(1b[0]);1k(r.W.1i(c);d&&c!==u;){d=!1;1a v=ZC.1l(1b[2]);g+f>=12&&B++,g=(g+f)%12,(31===v&&(3===g||5===g||8===g||10===g)||v>28&&1===g)&&(v=1===g?B%4==0&&B%100!=0||B%t6==0?29:28:30);1a b=1n 9H(B,g,v,1b[3],1b[4],1b[5]).bi();r.W.1i(b),b<u&&b<=t&&(d=!0)}}1t if(i){r.GV=e,r.HF=t,r.UV=ZC.1l((u-c)/o);1a E=(""+o).2l("."),m=1n 5X(E[1]||"0").1h;1k(a=c;a<=u;a+=o){h=a;1a K,F,D=r.DW;if("2W"===r.CA)1k(1a I=!0;I;)I=!1,F=K=1A.5k(r.EV,h),K=ZC.1W(ZC.bn(K,D)),F<1&&F!==K&&ZC.BN(F,K)/ZC.CV(F,K)>1.t8&&(I=!0,++D>ZC.CV(20,-1===r.HN?99:r.HN)&&(I=!1));1t K=1c!==D?ZC.1W(ZC.bn(h,1A.1V(D,m))):ZC.1W(ZC.bn(h,m));r.W.1i(K)}}1t 1k(o=ZC.1W((t-e)/r.UV),a=0;a<=r.UV;a++)h=e+o*a,p<0&&(h=ZC.1W(h.4v(-p))),r.W.1i(h);r.X=0,r.A1=r.W.1h-1,r.E7=0,r.EF=r.W.1h-1,r.B8=ZC.1W(r.W[r.X]),r.BS=ZC.1W(r.W[r.A1])},tc:1f(e,t,i){1a n=1g;1w i===ZC.1b[31]&&(i=!1);1a a=t-e,l=1A.4i(ZC.HH(a)/1A.bm);1m 1c===ZC.1d(n.o.6Y)||i?l<=3?1:4===l?5L:5===l?8p:6===l?17f:7===l?17e:8===l?uh:9===l?17d:10===l?17c:11===l?17b:md:n.EA},1q:1f(){1g.b()},3v:1f(){1g.b()},8e:1f(){1g.b()},1v:1f(){1g.b(),1c!==ZC.1d(1g.o[ZC.1b[5]])&&(1g.T1=!0)}}),ZC.ZB=ZC.H2.C7({$i:1f(e){1g.b(e);1a t=1g;t.AF="v",t.X=-1,t.A1=-1,t.UV=0,t.DW=1c,t.KO="5e",t.JF=[]},a4:1f(e,t){1a i,n,a=1g;if(a.H1){1c!==ZC.1d(e)?a.B8=e:a.B8=a.GV,1c!==ZC.1d(t)?a.BS=t:a.BS=a.HF,("5O"===a.A.AF||a.QM)&&(a.B8=ZC.1l(a.B8),a.BS=ZC.1l(a.BS)),a.RN(a.B8,a.BS,!1);1a l=a.A.BT("v");1k(i=0;i<l.1h;i++)l[i].BB!==a.BB&&l[i].dI===a.BB&&l[i].a4(e,t);if(""===a.dI){if(a.H.H3.C||(a.H.H3.C=a.A),a.A.H3&&1c!==ZC.1d(a.A.H3.o.6a)&&ZC.2q(a.A.H3.o.6a)&&a.A.K===a.H.H3.C.K)1k(i=0,n=a.H.AI.1h;i<n;i++){1a o=a.H.AI[i];if(o.K!==a.A.K&&1c!==ZC.1d(o.H3.o.6a)&&ZC.2q(o.H3.o.6a)){1a r=o.BL(a.BB);r&&r.H1&&(e=1A.1V(r.GV,1A.2h(r.HF,a.B8)),t=1A.1V(r.GV,1A.2h(r.HF,a.BS)),r.a4(e,t),ZC.AK(o.K)&&(o.3v(!0),o.E["6a-3C"]=!0,o.1v(),o.BI&&o.BI.3O(1c,1c,e,t,!0)))}}a.IW()}}},G0:1f(L,CU,EP){1a s=1g;1w CU===ZC.1b[31]&&(CU="",CU=1c!==ZC.1d(s.BW[L])?s.BW[L]:s.W[L]),"8X"==1w CU&&1c!==ZC.1d(s.JF[CU])&&(CU=s.JF[CU]);1a OI=ZC.P2(CU)&&ZC.1W(CU)<0,BG=s.MG();if(ZC.2A(EP,BG),1c!==ZC.1d(s.E["1V-cC"])&&(BG["1V-cC"]=s.E["1V-cC"]),OI&&"cl"===BG.8g&&(CU=ZC.2i(ZC.1W(CU))),BG.ch=s.A.UG,BG.cn=s.A.N2,CU=ZC.AO.GM(CU,BG,s,!0),s.CG)if("()"===s.CG.2s(s.CG.1h-2)||"7u:"===s.CG.2s(0,11))4I{1a EG=s.CG.1E("7u:","").1E("()","");7t(EG)&&(CU=7t(EG).4s(s,CU))}4G(e){}1t CU=OI&&"cl"===BG.8g?"-"+s.CG.1E(/%v|%1z-1S/g,CU):s.CG.1E(/%v|%1z-1S/g,CU);1m CU},er:1f(){1a e=1g,t=ZC.BN(e.W.1h,e.BW.1h);if(0===t&&(t=10),"2W"===e.CA)e.EE=4J;1t{1a i=1A.1V(15,10*ZC.BN(e.W.2I("").1h,e.BW.2I("").1h)/t);e.D9?e.EE=ZC.1l((e.I-e.A6-e.BV)/i):e.EE=ZC.1l((e.F-e.A6-e.BV)/10),e.EE=ZC.CV(e.EE,10),e.EE=ZC.BN(2,e.EE)}},mg:1f(){1a e=1g;1c===ZC.1d(e.o["1V-9J"])&&(e.LX=e.EE)},7j:1f(e){1a t,i,n,a,l,o,r,C=1g;if(""!==C.dI&&2===e){1a A=C.A.BL(C.dI);if(A)1m C.B8=A.B8,C.GV=A.GV,C.BS=A.BS,C.HF=A.HF,C.EA=A.EA,C.SB=A.SB,C.X=A.X,C.A1=A.A1,C.E7=A.E7,C.EF=A.EF,C.W=[].4w(A.W),8j(C.BW=[].4w(A.BW))}1===e&&1c===ZC.1d(C.o[ZC.1b[5]])&&1c!==ZC.1d(t=C.A.i7("v"))&&(C.o[ZC.1b[5]]=t);1a s=C.JF;if(1===e&&1c!==ZC.1d(C.o[ZC.1b[5]])){if(C.W=[],"4g"==1w C.o[ZC.1b[5]]){1a Z=C.o[ZC.1b[5]],c=ZC.dS(Z),u=ZC.dT(Z),p=!0;1k(i=0,n=Z.1h-2;i<n;i++)if("8X"==1w Z[i+2]&&"8X"==1w Z[i+1]&&"8X"==1w Z[i]&&ZC.1W(Z[i+2])-ZC.1W(Z[i+1])!=ZC.1W(Z[i+1])-ZC.1W(Z[i])){p=!1;1p}if(!p&&(C.o[ZC.1b[5]]=c+":"+u,!C.LP))1k(C.LP=[],i=0,n=Z.1h;i<n;i++)C.LP.1i(""+Z[i])}if("4g"==1w C.o[ZC.1b[5]]){1k(ZC.tf(C.o[ZC.1b[5]],C.W),0===C.BW.1h&&ZC.tf(C.BW,C.W),i=0,n=C.W.1h;i<n;i++)if("2Y"==1w C.W[i]){1a h=C.W[i],1b=ZC.AT(s,C.W[i]);-1===1b?(s.1i(C.W[i]),C.W[i]=s.1h-1):C.W[i]=1b,1c===ZC.1d(C.BW[i])&&(C.BW[i]=h)}}1t{1a d=C.o[ZC.1b[5]].2l(":");if(r=1,3===d.1h&&(r=ZC.1W(d[2])),ZC.1W(d[0])>ZC.1W(d[1])){1a f=d[0];d[0]=d[1],d[1]=f}if(r<=0&&(r=1),1c!==ZC.1d(C.o["7m-2z"])&&(r=(ZC.1W(d[1])-ZC.1W(d[0]))/ZC.BN(1,ZC.1l(C.o["7m-2z"])-1),C.UV=ZC.BN(1,ZC.1l(C.o["7m-2z"])-1)),d.1h>1){1k(1a g=0,B=0,v=0,b=(""+r).2l("."),E=ZC.1W(d[0]);E<=ZC.1W(d[1]);E+=r)a=(""+E).2l("."),b.1h>1&&a.1h>1&&b[1].1h>0&&a[1].1h>=9&&ZC.2i(a[1].1h-b[1].1h)>2?(g+=b[1].1h,B=ZC.BN(B,b[1].1h),v++,C.W.1i(ZC.1W(ZC.bn(4P(E),b[1].1h)))):(g+=ZC.1l(a[1]?a[1].1h:0),B=ZC.BN(B,a[1]?a[1].1h:0),v++,C.W.1i(E));E-ZC.1W(d[1])!=0&&ZC.2i(E-ZC.1W(d[1]))/r<1e-8&&C.W.1i(ZC.1W(d[1])),1c===ZC.1d(C.o[ZC.1b[12]])&&(g=(a=(""+r).2l("."))[1]?a[1].1h:1A.4h(g/v),C.DW=ZC.2i(B-g)<=1?B:g)}}C.X=0,C.A1=C.W.1h-1,C.EA=r,s.1h>1?(C.B8=ZC.dS(C.W),C.BS=ZC.dT(C.W)):(C.B8=C.W[0],C.BS=C.W[C.W.1h-1]),"2W"===C.CA&&C.RN(ZC.HH(C.B8,C.EV),ZC.HH(C.BS,C.EV),!1)}if(2===e){1a m={};1c===ZC.1d(C.o[ZC.1b[5]])&&(C.W=[],l=ZC.3q,o=-ZC.3q);1a K=[],F=C.A.AX.A7;1k(i=0,n=F.1h;i<n;i++)if(C.A.E["1B"+i+".2f"]||"5c"===C.A.8b()){1a D=F[i].BT();if(-1!==ZC.AT(D,C.BB))1k(1a I=-1!==ZC.AT(["5A","6d","6M","7v"],F[i].AF),X=[],x=0,y=F[i].W.1h;x<y;x++)if(F[i].S[x]){1a L=1c===F[i].S[x].BX?x:F[i].S[x].BX;if(-1!==ZC.AT(X,L))dO;X.1i(L);1a Y=F[i].LU&&1c!==ZC.1d(F[i].LU[x])?ZC.1W(F[i].LU[x]):0;if(F[i].CB)1c===ZC.1d(m[F[i].DV])&&(m[F[i].DV]=[]),1c===ZC.1d(m[F[i].DV][L])?F[i].S[x].AE>=0||!I?m[F[i].DV][L]=[F[i].S[x].AE,0]:m[F[i].DV][L]=[0,F[i].S[x].AE]:F[i].S[x].AE>=0||!I?m[F[i].DV][L][0]+=F[i].S[x].AE:m[F[i].DV][L][1]+=F[i].S[x].AE,F[i].S[x].AE>=0||!I?F[i].S[x].CM=m[F[i].DV][L][0]:F[i].S[x].CM=m[F[i].DV][L][1],1c===ZC.1d(C.o[ZC.1b[5]])&&K.1i(m[F[i].DV][L][0]+Y,m[F[i].DV][L][1]+Y);1t if(1c===ZC.1d(C.o[ZC.1b[5]])){K.1i(F[i].S[x].AE+Y),0!==Y&&K.1i(Y);1k(1a w=0,M=F[i].S[x].DL.1h;w<M;w++)K.1i(F[i].S[x].DL[w]+Y)}}}K.1h>0&&(l=ZC.dS(K),o=ZC.dT(K)),0!==C.W.1h||l!==4P.ij&&o!==4P.171||(C.W=[0,1],l=0,o=1),1c===ZC.1d(C.o[ZC.1b[5]])&&(1c!==ZC.1d(C.o["2h-1S"])&&"3e"!==C.o["2h-1S"]?l=ZC.1W(C.o["2h-1S"]):l>0&&"3e"!==C.o["2h-1S"]&&"2W"!==C.CA&&(l=0),1c!==ZC.1d(C.o["1V-1S"])&&(o=ZC.1W(C.o["1V-1S"])),l===ZC.3q&&o===-ZC.3q?(C.X=0,C.A1=0,C.B8=0,C.BS=0):"2W"===C.CA?C.RN(ZC.HH(l,C.EV),ZC.HH(o,C.EV),!1):C.RN(l,o,!0))}2===e&&(-1===C.GV&&-1===C.HF&&(C.GV=C.B8,C.HF=C.BS),-1===C.SB&&(C.SB=C.EA)),"3e"===C.o["2h-1S"]&&1c===ZC.1d(C.o["3N-1S"])&&(C.GZ=C.B8),0===C.UV&&(C.UV=ZC.1l((C.BS-C.B8)/C.EA));1a H=C.H.E["2U"+C.A.L+".3C"];if(1c===ZC.1d(C.H.E[ZC.1b[53]])||C.H.E[ZC.1b[53]]){1a N=1===C.L?"":"-"+C.L;2===e&&1w H!==ZC.1b[31]&&1c!==ZC.1d(H["5s"+N])&&1c!==ZC.1d(H["5r"+N])&&(ZC.DU(H["5s"+N],C.B8,C.BS)||(H["5s"+N]=C.B8),ZC.DU(H["5r"+N],C.B8,C.BS)||(H["5r"+N]=C.BS),C.LO=[H["5s"+N],H["5r"+N]])}1t C.H.E["2U"+C.A.L+".3C"]={};C.LO&&(C.A.il=!0)},RN:1f(e,t){1a i,n,a,l=1g;"5O"!==l.A.AF&&!l.QM&&l.JF.1h>1&&(e=0),l.TP.1h&&1c===ZC.1d(l.o["1z-7b"])&&(a=1A.4i(ZC.HH(ZC.2i(t),ZC.1W(l.TP[0]))),l.OY=1A.5k(ZC.1W(l.TP[0]),a)/1A.5k(5L,a),l.E["1V-cC"]=a);1a o,r=(o=l.FD&&"5z"===l.FD.o.1I?ZC.AN.W5(e,t,"m4"===l.CA?l.EA:1c,l.OY,l.im,l.EE):ZC.AN.W5(e,t,"m4"===l.CA?l.o.6Y:1c,l.OY,l.im,l.EE))[0],C=o[1],A=!1;"2W"===l.CA&&(n=1A.4i(o[0]),a=1A.4h(o[1]),o[1]-o[0]>=.5?A=!0:o=ZC.AN.W5(1A.5k(l.EV,o[0]),1A.5k(l.EV,o[1]),1c,l.OY,l.im));1a s=o[0],Z=o[1],c=o[2];1c!==ZC.1d(l.o["7m-2z"])&&(c=(Z-s)/ZC.BN(1,ZC.1l(l.o["7m-2z"])-1)),1!==l.QV&&(s*=l.QV,Z*=l.QV,c*=l.QV),1c!==ZC.1d(l.E["o-6h"])?l.DW=l.E["o-6h"]:l.E["o-6h"]=l.DW,1c===ZC.1d(l.o[ZC.1b[12]])&&("2W"===l.CA&&A?l.DW=n<0?1c:0:n<0&&(l.DW=o[3]));1a u,p,h,1b,d,f=!0;if(A){n=1A.4i(s),a=1A.4h(Z),h=1A.5k(l.EV,e),1b=1A.5k(l.EV,t),l.W=[];1a g,B,v=[0,2,5];1k(B=[0,1,2,3,4,5,6,7,8,9,10],i=n;i<=a;i++){1a b=o[3];if(b=i<0?1A.1V(ZC.2i(i),b):0,i===a)1k(g=0;g<v.1h;g++)d=1A.5k(l.EV,i)+v[g]*1A.5k(l.EV,i-1),d=ZC.1W(d.4v(b)),-1===ZC.AT(l.W,d)&&l.W.1i(d);1k(g=0;g<B.1h;g++)d=B[g]*1A.5k(l.EV,i),d=ZC.1W(d.4v(b)),-1===ZC.AT(l.W,d)&&l.W.1i(d)}l.W.3V(1f(e,t){1m e-t});1k(1a E=-1,m=-1,K=0;K<l.W.1h-1;K++)l.W[K]<=h&&h<=l.W[K+1]&&(E=K),l.W[K]===1b?m=K:l.W[K]<=1b&&1b<=l.W[K+1]&&(m=K+1);l.W=l.W.7y(E,m+1),0===l.W[0]&&l.W.17u(),r=ZC.HH(l.W[0],l.EV),C=ZC.HH(l.W[l.W.1h-1],l.EV)}1t{1k("2W"===l.CA&&(h=1A.5k(l.EV,e),1b=1A.5k(l.EV,t));f;){f=!1,l.W=[],u=p=s;do{p=u,p=ZC.1W(p.4v(l.DW)),-1!==ZC.AT(l.W,p)&&(f=!0),"2W"===l.CA?p>=s&&p<=Z&&l.W.1i(p):l.W.1i(p),u+=c,u=ZC.1W(u.4v(o[3]))}17p(u<=Z);f&&(l.DW+=1)}"2W"===l.CA&&(r=ZC.HH(s,l.EV),C=ZC.HH(Z,l.EV),l.W.1i(s),l.W.1i(Z),l.W.3V(1f(e,t){1m e-t}))}l.EA=c,l.X=0,l.A1=l.W.1h-1,l.B8=r,l.BS=C},1q:1f(){1a e=1g;e.4y([["7H-1I","KO"]]),(e.A.CB&&"100%"===e.A.KO||"100%"===e.KO)&&1c===ZC.1d(e.o[ZC.1b[5]])&&(e.o[ZC.1b[5]]="0:100:20",e.o.5K="%v%"),1g.b()},3v:1f(){1g.b()},8e:1f(){1g.b()},1v:1f(){1g.b(),1c===ZC.1d(1g.E[ZC.1b[12]])&&(1g.E[ZC.1b[12]]=1c!==ZC.1d(1g.DW)?1g.DW:-1),1c!==ZC.1d(1g.o[ZC.1b[5]])&&(1g.T1=!0)}}),ZC.SS=ZC.h0.C7({$i:1f(e){1g.b(e)},1q:1f(){1g.b()},IW:1f(){1a e=1g;e.A1===e.X?e.A9=e.I-e.A6-e.BV:e.A9=(e.I-e.A6-e.BV)/(e.A1-e.X+(e.DK?1:0))},7j:1f(e){1a t=1g;t.b(e),t.IW()},a4:1f(e,t){1g.b(e,t),1g.IW()},3v:1f(){},8e:1f(){1g.b()},N8:1f(e){1a t,i=1g;1m t=i.AR?(i.iX+i.I-i.A6-e)/(i.I-i.A6-i.BV):(e-i.iX-i.A6)/(i.I-i.A6-i.BV),i.B8+ZC.1W((i.BS-i.B8)*t)},O4:1f(e,t,i){1a n,a,l,o=1g;1w i===ZC.1b[31]&&(i=!1);1a r=o.DK?o.A9:0;l=o.AR?(o.iX+o.I-e-o.A6-r/2)/(o.I-o.A6-o.BV-r):(e-o.iX-o.A6-r/2)/(o.I-o.A6-o.BV-r);1a C,A=!1;if(t)1k(C in t.JW){A=!0;1p}if(t&&!o.NQ&&A){1a s=o.W[o.X];"2Y"==1w s&&(s=ZC.AT(o.IH,s)),"2W"===o.CA&&(s=ZC.HH(s,o.EV));1a Z=o.W[o.A1];"2Y"==1w Z&&(Z=ZC.AT(o.IH,Z)),"2W"===o.CA&&(Z=ZC.HH(Z,o.EV));1a c=s+ZC.1W((Z-s)*l);"2W"===o.CA&&(c=1A.5k(o.EV,c));1a u=ZC.3q;a=1c;1k(C in t.JW)(n=1A.3i(C-c))<u&&(u=n,a=t.JW[C]);if(1c===ZC.1d(a)&&(a=c),u>t.lB){1a p=1A.4h((Z-s)/(o.I-o.A6-o.BV));if(t.W.1h<2&&(p*=100),u>p)1m 1c}1m a}1a h=o.X,1b=o.A1;1m o.EC&&(1c!==ZC.1d(n=o.W[h])&&(h=n),1c!==ZC.1d(n=o.W[1b])&&(1b=n)),"2W"===o.CA&&(h=ZC.HH(h,o.EV),1b=ZC.HH(1b,o.EV)),a=i?o.DK?h+(1b-h+1)*l:h+(1b-h)*l:o.DK?o.X+(o.A1-o.X+1)*l:o.X+(o.A1-o.X)*l,"2W"===o.CA?(a=1A.5k(o.EV,a),a=1A.4i(a)-1):(a=o.DK?1A.4i(a):ZC.1l(a),a=ZC.BN(0,a),a=ZC.CV(o.EF,a)),a},I3:1f(e){1a t=1g;t.X,t.A1;1m t.EC&&!t.NQ&&(t.B8,t.BS),"2W"===t.CA&&(e=ZC.HH(e+1,t.EV)),t.AR?t.iX+t.I-t.A6-(e-t.X+(t.DK?1:0))*t.A9+(t.DK?t.A9/2:0):t.iX+t.A6+(e-t.X)*t.A9+(t.DK?t.A9/2:0)},B2:1f(e){1a t,i,n,a,l,o=1g;if("2W"===o.CA&&(e=ZC.HH(e,o.EV)),o.NQ){1a r=o.TX[e];1m o.I3(r)}1m-1!==(t=ZC.AT(o.IH,e))?o.I3(t):!o.lz&&(o.EC||o.FD&&"5z"===o.FD.o.1I)?(a=o.W[o.X],l=o.W[o.A1],"2W"===o.CA&&(a=ZC.HH(a,o.EV),l=ZC.HH(l,o.EV)),l===a?i=0:(n=l-a,i=(o.I-o.A6-o.BV-(o.DK?o.A9:0))/n),o.AR?o.iX+o.I-o.A6-(e-a)*i-(o.DK?o.A9/2:0):o.iX+o.A6+(e-a)*i+(o.DK?o.A9/2:0)):(a=o.B8,l=o.BS,"2W"===o.CA&&(a=ZC.HH(a,o.EV),l=ZC.HH(l,o.EV)),l===a?i=0:(n=l-a+(o.DK?1:0),i=(o.I-o.A6-o.BV)/n),o.AR?o.iX+o.I-o.A6-(e-a)*i-(o.DK?o.A9/2:0):o.iX+o.A6+(e-a)*i+(o.DK?o.A9/2:0))},1v:1f(){1f e(e){1m e=e.1E(/%1z-84-2G/g,g.A1-g.X),e=e.1E(/(%c)|(%1z-2G)/g,g.GN),e=e.1E(/(%i)|(%1z-2V)/g,g.JX),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(g.W[g.JX])?g.W[g.JX]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(g.BW[g.JX])?g.BW[g.JX]:""),e=e.1E(/%1z-ew-of-vW/g,ZC.AO.Y2(g.W[g.JX],"%w",g.A.UG,g.A.N2))}1f t(t,i,n,a){1a l;if(g.JX=t,u=t-g.X,(g.BQ.E4.1h>0||t===g.X||!te||g.BQ.IA||n)&&(te=1n ZC.DQ(g)),te.1Q(g.BQ),te.GG=g.K+"-1N "+g.A.K+"-1z-1N zc-1z-1N",te.K=g.A.K+"-"+g.BB.1E(/\\-/g,"1b")+"-7E"+t,te.E["p-1s"]=g.A9,g.CG=ne,g.DW=ae,n||g.YT(e),l=i?ZC.AO.Y2(t,re,g.A.UG,g.A.N2):a||g.G0(t,1c,1c),!n&&g.BQ.IA&&g.H9(g.BQ,te,1c,{2V:t,83:u,1D:l},g.BQ.OC),1c===ZC.1d(g.LP)||-1!==ZC.AT(g.LP,l)){if(te.AP=l,te.Z=te.C5=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),te.IE=g.H.2L()?ZC.AK(g.H.K+"-3X"):ZC.AK(g.H.K+"-1D"),te.E.7l=t,te.1q(),g.BQ.hU&&g.BQ.AA%180==0&&(te.o[ZC.1b[19]]=ZC.1l(.9*g.A9),te.1q()),"5n"!==g.BQ.o["2p-1r"]&&"5n"!==g.BQ.o.1r||-1===B||(te.BZ=B),n||(te.JC=e,te.DD()&&te.1q()),te.o["3e-gw"]&&(te.I=ZC.1l(g.A9)),i?(p=g.B2(t),te.iX=p-te.I/2-(g.DK?g.A9/2:0)):n?(p=g.B2(t),te.iX=p-te.I/2):g.AR?(p=g.iX+g.I-g.A6-u*g.A9,te.iX=p-te.I/2-(g.DK?g.A9/2:0)):(p=g.iX+g.A6+u*g.A9,te.iX=p-te.I/2+(g.DK?g.A9/2:0)),g.A.BI&&g.A.BI.BW&&g.A.BI.HS){1k(1a r=!1,C=0;C<g.A.BI.BW.1h;C++)g.A.BI.BW[C].1D===te.AP&&(r=!0);r||g.A.BI.BW.1i({x:ZC.1l(p),1D:te.AP})}1P(te.o[ZC.1b[7]]){1j"5N":te.iY=F?o-te.F-L:o+L;1p;1j"3N-1u":te.iY=D-te.F-L;1p;1j"3N-2a":te.iY=D+L;1p;1j"3N-3e":I&&I.S[t]?(I.FO(t).2E(),I.FO(t).iY<D?te.iY=D+L:te.iY=D-te.F-L):te.iY=D+L;1p;2n:te.iY=F?o+L:o-te.F-L}if(ie=g.MT(te,ie,"h",0),g.BQ.o["3e-3s"]&&g.BQ.AA%180!=0){1a A=ZC.DU(g.BQ.AA,0,180)?F?1:-1:F?-1:1;te.iX+=A*te.I*ZC.ED(g.BQ.AA)/2,te.iY+=A*(te.I*ZC.EL(g.BQ.AA)/2-te.F*ZC.EL(g.BQ.AA)/2)}1a s=g.WS(te,t,{2z:se,hi:Ze,hj:N,aP:Ce,aQ:Ae,gR:"h",4a:ce});if(Ce=s.aP,Ae=s.aQ,!s.uP&&i&&g.IK.AL)1P(oe.o[ZC.1b[7]]){1j"3N-3e":le.1i([p,D+L/2],[p,D-L/2],1c);1p;1j"3N-1u":le.1i([p,D-L],[p,D],1c);1p;1j"3N-2a":le.1i([p,D+L],[p,D],1c);1p;1j"5N":le.1i([p,o-(F?L:-L)],[p,o],1c);1p;1j"77":le.1i([p,o],[p,o+(F?L:-L)],1c);1p;2n:le.1i([p,o+L/2],[p,o-L/2],1c)}g.GN++}}1a i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d,f,g=1g;g.b(),1c!==ZC.1d(g.A.A.E[g.BB+"-bH-1Y-46"])&&(g.A6=g.A.A.E[g.BB+"-bH-1Y-46"]),"5h"!==g.A.AF&&"6t"!==g.A.AF||(-1===g.A6&&-1===g.BV||1===g.W.1h)&&(g.A6=g.BV=g.I/(g.W.1h+1),g.IW());1a B=g.ZZ(),v=0,b=1,E=1,m={};1k(n=0,a=g.A.BK.1h;n<a;n++)g.A.BK[n].BB.2s(0,7)===ZC.1b[50]&&g.A.BK[n].B7===g.B7&&v++,g.A.BK[n].BB.2s(0,7)===ZC.1b[50]&&("2n"===g.A.BK[n].B7?(m[g.A.BK[n].BB]=b,b++):(m[g.A.BK[n].BB]=E,E++));1a K=m[g.BB],F="2n"===g.B7,D=1c,I=1c;1k(n=0,a=g.A.AX.A7.1h;n<a;n++){1a X=g.A.AX.A7[n],x=X.BT();if(-1!==ZC.AT(x,g.BB)){1a y=g.A.BL(X.BT("v")[0]);D=y.B2(y.GZ),I=X;1p}}1a L=8;1c!==ZC.1d(g.IK.o[ZC.1b[21]])&&(L=ZC.1l(g.IK.o[ZC.1b[21]]));1a Y=4;1c!==ZC.1d(g.I2.o[ZC.1b[21]])&&(Y=ZC.1l(g.I2.o[ZC.1b[21]]));1a w=ZC.1l(g.A.E[g.BB+"-6T"]||-1);g.V7&&(w=0),"2n"===g.B7?(Z=ZC.1l(g.A.Q.DN/v),o=g.iY+g.F+(K-1)*Z,-1!==w&&(o=g.iY+g.F+w)):(Z=ZC.1l(g.A.Q.E2/v),o=g.iY-(K-1)*Z,-1!==w&&(o=g.iY-w));1a M=o;if(g.A.I5&&(g.A.I5.AL=!0,g.E7===g.X&&g.EF===g.A1&&(g.A.I5.AL=!1),g.A.I5.AL&&0===g.A.I5.AZ.BD&&"2n"===g.B7&&(o+=g.A.I5.AZ.F+g.AY/2)),g.E.iY=o,g.AL&&g.T1){1c!==ZC.1d(g.o["7m-2z"])&&(g.LX=g.EE=ZC.1l(g.o["7m-2z"]));1a H=ZC.BN(1,1A.4h((g.A1-g.X)/(g.LX-1))),N=ZC.BN(1,1A.4h((g.A1-g.X)/(g.EE-1)));1c===ZC.1d(g.o["7m-2z"])&&ZC.2q(g.o.gy)&&(H=ZC.AN.gz(H),N=ZC.AN.gz(N));1a S=0,O=g.A9*H/(g.GQ+1),P=g.AR?g.iX+g.BV:g.iX+g.A6,k=g.AR?g.iX+g.I-g.A6:g.iX+g.I-g.BV;if(1c===ZC.1d(D)&&(D=o),r=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),A=ZC.P.E6(r,g.H.AB),C=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-bl-0-c"),s=ZC.P.E6(C,g.H.AB),"5n"===g.o["1y-1r"]&&-1!==B&&(g.B6=B),g.A.AJ["3d"]){if(1b=ZC.DF.DA(g,g.A,g.iX-ZC.AM.E1,g.iX-ZC.AM.E1+g.I,o-ZC.AM.E0,o-ZC.AM.E0,-1,ZC.AM.FQ+1,"x"),1b.K=g.K+"-1y",g.A.F7.7J&&(g.A.F7[ZC.1b[27]]>0?1b.M9=[1===g.L?-100:100,1,1]:1b.M9=[1===g.L?100:-100,1,1]),g.A.CH.2N(1b),1c!==ZC.1d(g.o.cf)){1a G=1n ZC.CZ(g);G.1C(g.o.cf),G.1q(),G.A0=G.AC=G.B6,(1b=ZC.DF.DA(G,g.A,g.iX-ZC.AM.E1,g.iX-ZC.AM.E1+g.I,o-ZC.AM.E0,o-ZC.AM.E0,-G.AY/2,G.AY/2,"x")).K=g.K+"-cf",g.A.CH.2N(1b)}}1t{c=[[g.iX-1,M],[g.iX+g.I+1,M]];1a z=g.K;g.K+="-1y",ZC.CN.1v(A,g,c),g.K=z}if(g.W.1h>0&&g.D5.AL){1a T=1c===ZC.1d(g.D5.o["1Y-46"])?0:ZC.1l(g.D5.o["1Y-46"]),J=1c===ZC.1d(g.D5.o["1Y-6n"])?0:ZC.1l(g.D5.o["1Y-6n"]);if(g.D5.o.2z&&g.D5.o.2z.1h>0&&!g.A.AJ["3d"])1k(d=1n ZC.HQ(g),n=g.X;n<g.A1+(g.DK?1:0);n++)u=n-g.X,f=n%g.D5.o.2z.1h,d.1C(g.D5.o.2z[f]),d.K=g.K+"-2g-"+n,d.Z=C,d.1q(),g.AR?d.iX=g.iX+g.I-g.A6-u*g.A9-g.A9:d.iX=g.iX+g.A6+u*g.A9,d.iY=g.iY+T,d.I=g.A9,d.F=g.F-T-J,d.1v();if(g.D5.AY>0)1k(g.GN=0,n=g.X;n<=g.A1+(g.DK?1:0);n++)if(g.JX=n,n===g.X||n===g.A1+(g.DK?1:0)||(n-g.X)%H==0){(g.D5.E4.1h>0||n===g.X)&&((h=1n ZC.CZ(g)).Z=h.C5=C,h.1Q(g.D5),h.JC=e,h.DD()&&h.1q()),c=[],u=n-g.X,p=g.AR?g.iX+g.I-g.A6-u*g.A9:g.iX+g.A6+u*g.A9;1a Q=g.iY+T,W=g.F-T-J;if(h.AL)if(g.A.AJ["3d"]){1a R=1n ZC.CZ(g);R.1Q(h),1c!==ZC.1d(g.o["1z-z"])&&1c!==ZC.1d(i=g.o["1z-z"].2g)&&(R.1C(i),R.1q()),R.A0=R.AC=R.B6,1b=ZC.DF.DA(R,g.A,p-ZC.AM.E1-R.AY/2,p-ZC.AM.E1+R.AY/2,o-ZC.AM.E0,o-ZC.AM.E0,0,ZC.AM.FQ,"z"),g.A.CH.2N(1b),h.A0=h.AC=h.B6,(1b=ZC.DF.DA(h,g.A,p-ZC.AM.E1-h.AY/2,p-ZC.AM.E1+h.AY/2,Q-ZC.AM.E0,Q+W-ZC.AM.E0,ZC.AM.FQ+2,ZC.AM.FQ+2,"y")).K=g.K+"-2g-"+n,g.A.CH.2N(1b)}1t c.1i([p,Q],[p,Q+W]),h.K=g.K+"-2g-"+n,ZC.CN.1v(s,h,c);g.GN++}}if(g.W.1h>0&&g.FY.AL&&!g.A.AJ["3d"]&&g.FY.o.2z&&g.FY.o.2z.1h>0)1k(d=1n ZC.HQ(g),n=g.X;n<g.A1+(g.DK?1:0);n++)1k(g.JX=n,u=n-g.X,g.GN=0,l=1;l<=g.GQ;l++)f=g.GN%g.FY.o.2z.1h,d.1C(g.FY.o.2z[f]),d.K=g.K+"-2g-"+n+"-"+l,d.Z=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-bl-0-c"),d.1q(),g.AR?d.iX=g.iX+g.I-g.A6-u*g.A9-(l+1)*O:d.iX=g.iX+g.A6+u*g.A9+l*O,d.iY=g.iY,d.I=O,d.F=g.F,d.1v(),g.GN++;if(g.FY.AY>0)1k(n=g.X;n<g.A1+(g.DK?1:0);n++)if(g.JX=n,n%H==0)1k(u=n-g.X,g.GN=0,l=1;l<=g.GQ;l++)c=[],(h=1n ZC.CZ(g)).1Q(g.FY),h.JC=e,h.DD()&&h.1q(),p="2W"===g.CA?g.B2(g.W[n]+l*(g.W[n+1]-g.W[n])/(g.GQ+1)):g.AR?g.iX+g.I-g.A6-u*g.A9-l*O:g.iX+g.A6+u*g.A9+l*O,ZC.DU(p,P,k)&&(c.1i([p,g.iY],[p,g.iY+g.F]),h.AL&&(h.K=g.K+"-4Q-2g-"+l,ZC.CN.1v(s,h,c))),g.GN++;g.VA(s,B);1a V,U,j;if(g.W.1h>0&&g.IK.AL){1P(g.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":S+=L;1p;2n:S+=L/2}if(!1o.3G.sU||!g.FD||"5z"!==g.FD.o.1I)1k(g.GN=0,n=g.X;n<=g.A1+(g.DK?1:0);n++)if(n===g.X||n===g.A1+(g.DK?1:0)||(n-g.X)%H==0){g.JX=n;1a q=L;1P(c=[],u=n-g.X,(g.IK.E4.1h>0||n===g.X)&&((h=1n ZC.DS(g)).1Q(g.IK),"5n"===g.IK.o["1y-1r"]&&-1!==B&&(h.B6=B),h.JC=e,h.DD()&&h.1q(),h.AH>1&&(q=h.AH)),p=g.AR?g.iX+g.I-g.A6-u*g.A9:g.iX+g.A6+u*g.A9,h.o[ZC.1b[7]]){1j"3N-3e":c.1i([p,D+q/2],[p,D-q/2]);1p;1j"3N-1u":c.1i([p,D-q],[p,D]);1p;1j"3N-2a":c.1i([p,D+q],[p,D]);1p;1j"5N":c.1i([p,o-(F?q:-q)],[p,o]);1p;1j"77":c.1i([p,o],[p,o+(F?q:-q)]);1p;2n:c.1i([p,o+q/2],[p,o-q/2])}if(h.AL){1k(U=ZC.1l(h.o["1Y-x"]||"0"),j=ZC.1l(h.o["1Y-y"]||"0"),V=0;V<c.1h;V++)c[V][0]+=U,c[V][1]+=j;if(h.K=g.K+"-3W-"+n,g.A.AJ["3d"]&&g.A.F7.7J){1a $,ee=[];1k(V=0;V<c.1h;V++)$=1n ZC.CF(g.A,c[V][0]-ZC.AM.E1,c[V][1]-ZC.AM.E0,0),ee.1i([$.E9[0],$.E9[1]]);ZC.CN.1v(A,h,ee)}1t ZC.CN.1v(A,h,c)}g.GN++}}if(g.W.1h>0&&g.GQ>0&&g.I2.AL&&!g.A.AJ["3d"])1k(n=g.X;n<g.A1+(g.DK?1:0);n++)if(g.JX=n,n%H==0)1k(u=n-g.X,g.GN=0,l=1;l<=g.GQ;l++){if(c=[],(h=1n ZC.CZ(g)).1Q(g.I2),"5n"===g.I2.o["1y-1r"]&&-1!==B&&(h.B6=B),h.JC=e,h.DD()&&h.1q(),p="2W"===g.CA?g.B2(g.W[n]+l*(g.W[n+1]-g.W[n])/(g.GQ+1)):g.AR?g.iX+g.I-g.A6-u*g.A9-l*O:g.iX+g.A6+u*g.A9+l*O,ZC.DU(p,P,k)){1P(h.o[ZC.1b[7]]){1j"3N-3e":c.1i([p,D+Y/2],[p,D-Y/2]);1p;1j"3N-1u":c.1i([p,D],[p,D-Y]);1p;1j"3N-2a":c.1i([p,D],[p,D+Y]);1p;1j"5N":c.1i([p,o-(F?Y:-Y)],[p,o]);1p;1j"77":c.1i([p,o],[p,o+(F?Y:-Y)]);1p;2n:c.1i([p,o+Y/2],[p,o-Y/2])}if(h.AL){1k(U=ZC.1l(h.o["1Y-x"]||"0"),j=ZC.1l(h.o["1Y-y"]||"0"),V=0;V<c.1h;V++)c[V][0]+=U,c[V][1]+=j;h.K=g.K+"-4Q-3W-"+n,ZC.CN.1v(A,h,c)}}g.GN++}g.XC();1a te=1c,ie=1c,ne=g.CG,ae=g.DW,le=[],oe=1n ZC.DS(g);oe.1Q(g.IK);1a re,Ce=0,Ae=0,se=0,Ze=[],ce=[];if(g.o["5C-2z"])1k(n=0;n<g.o["5C-2z"].1h;n++)t(g.o["5C-2z"][n][0],!1,!0,g.o["5C-2z"][n][1]);if(g.W.1h>0&&g.BQ.AL)if(1o.3G.sU&&g.FD&&"5z"===g.FD.o.1I){1a ue=g.uz(g.W[g.A1]-g.W[g.X]),pe=ue[0];re=ue[1];1a he=ue[2],6m=ue[3];se=ue[4];1a de=he*1A.4h(g.W[g.X]/he),fe=he*1A.4i(g.W[g.A1]/he),ge="";g.GN=0;1a Be=!0;1k(n=de;n<=fe;n+=he){Be=!0;1a ve=ZC.AO.Y2(n,pe,g.A.UG,g.A.N2);if(ve!==ge){1P(6m){1j"yr":se>15&&(Be=ZC.1l(ve)%2==0);1p;1j"uI":se>15&&(Be=ZC.1l(ve)%3==0);1p;1j"ew":se>45?Be=1===ZC.1l(ve)||15===ZC.1l(ve):se>30?Be=1===ZC.1l(ve)||10===ZC.1l(ve)||20===ZC.1l(ve):se>15&&(Be=1===ZC.1l(ve)||10===ZC.1l(ve)||15===ZC.1l(ve)||20===ZC.1l(ve)||25===ZC.1l(ve));1p;1j"hr":se>45?Be=ZC.1l(ve)%12==0:se>30?Be=ZC.1l(ve)%6==0:se>15&&(Be=ZC.1l(ve)%3==0);1p;1j"2h":1j"uG":se>45?Be=ZC.1l(ve)%30==0:se>30?Be=ZC.1l(ve)%10==0:se>15&&(Be=ZC.1l(ve)%5==0)}Be&&(t(n,!0),ge=ve)}}oe.AL&&(oe.K=g.K+"-9J",ZC.CN.1v(A,oe,le))}1t 1k(g.GN=0,t(g.X),g.GN=g.A1-g.X,t(g.A1),g.GN=1,n=g.X+1;n<g.A1;n++)(n-g.X)%N==0&&t(n);if(g.M.AL&&g.M.AP&&""!==g.M.AP){(te=1n ZC.DQ(g)).1Q(g.M),te.K=g.A.K+"-"+g.BB.1E(/\\-/g,"1b")+"-lv",te.GG=g.K+"-1G "+g.A.K+"-1z-1G zc-1z-1G",te.AP=g.M.AP,te.Z=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),te.IE=g.H.2L()?ZC.AK(g.H.K+"-3X"):ZC.AK(g.H.K+"-1D"),te.1q(),"5n"!==g.M.o["2p-1r"]&&"5n"!==g.M.o.1r||-1===B||(te.BZ=B);1a be=g.iX+(g.AR?g.BV:g.A6),Ee=g.I-g.A6-g.BV;1P("aL"===te.o["3E-fO"]&&(be=g.A.iX,Ee=g.A.I),te.O3){1j"1J":te.iX=be;1p;1j"3E":te.iX=be+Ee/2-te.I/2;1p;1j"2x":te.iX=be+Ee-te.I}te.iY=F?o+S+Ae:o-te.F-S-Ae,g.M.iX=te.iX,g.M.iY=te.iY,te.AL&&(g.MT(te,1c,"h"),te.1v(),te.EH(),1c===ZC.1d(te.o.2C)&&te.K3||ce.1i(ZC.AO.NZ(g.A.K,te)))}ce.1h>0&&ZC.AK(g.A.A.K+"-2Z")&&(ZC.AK(g.A.A.K+"-2Z").4n+=ce.2I("")),1c!==ZC.1d(g.o.5H)&&"5z"===g.o.5H.1I&&g.uK()}},uz:1f(e){1a t,i,n,a,l;1m 0<=e&&e<=3*ZC.a3?(t="%q",i="%q ms",n=10,a="ms",l=ZC.1l(e/10)):3*ZC.a3<e&&e<=3*ZC.aa?(t="%s",i="%h:%i:%s %A",n=ZC.a3,a="uG",l=ZC.1l(e/ZC.a3)):3*ZC.aa<e&&e<=3*ZC.HR?(t="%i",i="%h:%i %A",n=ZC.aa,a="2h",l=ZC.1l(e/ZC.aa)):3*ZC.HR<e&&e<=3*ZC.9C?(t="%h:%i",i="%M %d, %h %A",n=ZC.HR,a="hr",l=ZC.1l(e/ZC.HR)):3*ZC.9C<e&&e<=3*ZC.ec?(t="%d",i="%M %d",n=ZC.9C,a="ew",l=ZC.1l(e/ZC.9C)):3*ZC.ec<e&&e<=3*ZC.YR?(t="%m",i="%M %Y",n=ZC.9C,a="uI",l=ZC.1l(e/ZC.ec)):(t="%Y",i="%Y",n=ZC.9C,a="yr",l=ZC.1l(e/ZC.YR)),[t,i,n,a,l]},uK:1f(){1f e(t,i){1w i===ZC.1b[31]&&(i=!1),0<=t&&t<=2*ZC.a3?(l="%q",o="%q ms",i&&e(60*t)):2*ZC.a3<t&&t<=2*ZC.aa?(l="%s",o="%h:%i:%s %A",i&&e(60*t),t>10*ZC.a3&&(C=2),t>30*ZC.a3&&(C=5),t>60*ZC.a3&&(C=10)):2*ZC.aa<t&&t<=2*ZC.HR?(l="%i",o="%h:%i %A",i&&e(24*t),t>10*ZC.aa&&(C=2),t>30*ZC.aa&&(C=5),t>60*ZC.aa&&(C=10)):2*ZC.HR<t&&t<=2*ZC.9C?(l="%h",o="%M %d, %h %A",i&&e(30*t),t>6*ZC.HR&&(C=2),t>12*ZC.HR&&(C=4),t>24*ZC.HR&&(C=6)):2*ZC.9C<t&&t<=2*ZC.ec?(l="%d",o="%M %d",i&&e(16W*t),t>12*ZC.9C&&(r=[1,5,9,13,17,21,25,29]),t>24*ZC.9C&&(r=[1,6,11,16,21,26])):2*ZC.ec<t&&t<=2*ZC.YR?(l="%m",o="%M %Y",i&&e(10*t),t>9*ZC.ec&&(r=[1,4,7,10])):(l="%Y",o="%Y",t>9*ZC.YR&&(C=3),t>16*ZC.YR&&(C=4),t>25*ZC.YR&&(C=5))}1f t(t){1a i,p;if(1c!==ZC.1d(a.W[t])&&""!==a.W[t]){if(a.NQ&&t!==a.X&&t!==a.A1&&1c!==ZC.1d(a.W[t-1])&&""!==a.W[t-1]&&1c!==ZC.1d(a.W[t])&&""!==a.W[t]){1a h=a.W[t]-a.W[t-1];1c!==ZC.1d(s)&&s!==h&&e(s,!0),s=h}1a 1b=ZC.AO.Y2(a.W[t],l,a.A.UG,a.A.N2);if(1b!==A&&ZC.1l(1b)%C==0&&(0===r.1h||-1!==ZC.AT(r,ZC.1l(1b)))){1a d,f=!0,g=t-a.X;i=a.AR?a.iX+a.I-a.A6-g*a.A9:a.iX+a.A6+g*a.A9+(a.DK?a.A9/2:0);1a B=1n ZC.DQ(a);a.H.B9.2t(B.o,"2U.4z.5H[5z].1N"),1c!==ZC.1d(d=a.o.5H.1N)&&B.1C(d),B.GG=a.K+"-1N "+a.A.K+"-1z-1N zc-1z-1N",B.K=a.K+"-5z-1N-"+t;1a v=ZC.AO.Y2(a.W[t],o,a.A.UG,a.A.N2);B.AP=v,B.Z=B.C5=a.H.2L()?a.H.mc():ZC.AK(a.A.K+"-3w-ml-0-c"),B.IE=a.H.2L()?ZC.AK(a.H.K+"-3X"):ZC.AK(a.H.K+"-1D"),B.1q(),a.AR?B.iX=i-B.I/2-(a.DK?a.A9/2:0):B.iX=i,B.iY=a.iY,a.A.AJ["3d"]&&(a.A.NW(),p=1n ZC.CF(a.A,B.iX+B.I/2-ZC.AM.E1,B.iY+B.F/2-ZC.AM.E0,0),B.iX=p.E9[0]-B.I/2,B.iY=p.E9[1]-B.F/2);1a b=[B.iX+B.BJ,B.iY+B.BD,B.I,B.F];if(B.AA%180==90&&(b=[B.iX+B.BJ+B.I/2-B.F/2,B.iY+B.BD+B.F/2-B.I/2,B.F,B.I]),a.A.BI&&a.A.BI.HS){1k(1a E=!1,m=0;m<a.A.BI.BW.1h;m++)a.A.BI.BW[m].1D===B.AP&&(E=!0);E||B.iX>=a.iX&&B.iX+B.I<=a.iX+a.I&&a.A.BI.BW.1i({x:ZC.1l(B.iX),1D:B.AP})}if(B.AL&&u){if(f=!0,!a.mn){if(t===a.X||t===a.A1)f=!0;1t 1k(1a K=0,F=Z.1h;K<F;K++)if(ZC.DU(b[0],Z[K][0],Z[K][0]+Z[K][2])||ZC.DU(b[0]+b[2],Z[K][0],Z[K][0]+Z[K][2])){f=!1;1p}B.iX+B.BJ+B.I>a.iX+a.BJ+a.I&&(f=!1)}if(f){Z.1i(b),B.1v(),B.EH();1a D=1n ZC.CZ(a);1c!==ZC.1d(d=a.o.5H.2g)&&D.1C(d),D.AY=1,D.B6="#7S",D.1q();1a I=[];if(I.1i([i,a.iY],[i,a.iY+a.F]),a.A.AJ["3d"]){a.A.NW();1k(1a X=0,x=I.1h;X<x;X++)p=1n ZC.CF(a.A,I[X][0]-ZC.AM.E1,I[X][1]-ZC.AM.E0,0),I[X][0]=p.E9[0],I[X][1]=p.E9[1]}D.AL&&ZC.CN.1v(n,D,I)}}c++}A=1b}}1a i,n,a=1g;n=ZC.P.E6(a.H.2L()?a.H.K+"-3X-c":a.A.K+"-3w-bl-0-c",a.H.AB);1a l,o,r=[],C=1;e(a.W[a.A1]-a.W[a.X]);1a A=1c,s=1c,Z=[],c=0,u=!1,p=!1;if(a.A.BI&&a.A.BI.HS&&(a.A.BI.BW=[]),a.W.1h>0&&(u=!1,1c!==ZC.1d(i=a.o.5H.1N)&&(u=!(1c!==ZC.1d(i.2f)&&!ZC.2q(i.2f))),p=!1,a.A.BI&&a.A.BI.BW&&(p=!0),u||p)){t(a.X),t(a.A1);1k(1a h=a.X+1;h<a.A1;h++)t(h)}}}),ZC.SV=ZC.ZB.C7({$i:1f(e){1g.b(e)},1q:1f(){1g.b()},IW:1f(){1a e=1g;e.A1===e.X?e.A9=e.F-e.A6-e.BV:e.A9=(e.F-e.A6-e.BV)/(e.A1-e.X+(e.DK?1:0))},7j:1f(e){1a t=1g;t.b(e),t.IW()},3v:1f(){},8e:1f(){1g.b()},a4:1f(e,t){1a i=1g;i.b(e,t),i.IW()},N8:1f(e,t,i){1a n,a=1g;n=a.AR?(e-a.iY-a.A6)/(a.F-a.A6-a.BV):(a.iY+a.F-a.A6-e)/(a.F-a.A6-a.BV);1a l=a.B8+ZC.1W((a.BS-a.B8)*n);1m i&&(l=ZC.2i(a.AR?1A.4h(l):1A.4i(l))),"2W"===a.CA&&t&&(l=1A.5k(a.EV,l)),l},B2:1f(e){1a t=1g,i=t.BS-t.B8,n=0===i?0:(t.F-t.A6-t.BV)/i;1m"2W"===t.CA&&(e=ZC.HH(e,t.EV)),t.AR?t.iY+t.A6+(e-t.B8)*n:t.iY+t.F-t.A6-(e-t.B8)*n},1v:1f(){1f e(e){1m e=e.1E(/%1z-84-2G/g,B.A1-B.X),e=e.1E(/(%c)|(%1z-2G)/g,B.GN),e=e.1E(/(%i)|(%1z-2V)/g,B.JX),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(B.W[B.JX])?B.W[B.JX]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(B.BW[B.JX])?B.BW[B.JX]:"")}1a t,i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d,f,g,B=1g;B.b(),"5h"!==B.A.AF&&"6t"!==B.A.AF||1!==B.W.1h||(B.A6=B.F/2);1a v=B.ZZ(),b=0,E=1,m=1,K={};1k(i=0,n=B.A.BK.1h;i<n;i++)B.A.BK[i].AL&&B.A.BK[i].T1&&(B.A.BK[i].BB.2s(0,7)===ZC.1b[51]&&B.A.BK[i].B7===B.B7&&b++,B.A.BK[i].BB.2s(0,7)===ZC.1b[51]&&("2n"===B.A.BK[i].B7?(K[B.A.BK[i].BB]=E,E++):(K[B.A.BK[i].BB]=m,m++)));1a F=K[B.BB],D="2n"===B.B7,I=1c,X=1c;1k(i=0,n=B.A.AX.A7.1h;i<n;i++){1a x=B.A.AX.A7[i],y=x.BT();if(-1!==ZC.AT(y,B.BB)){1a L=B.A.BL(x.BT("k")[0]);I=L.B2(L.GZ),X=x;1p}}1a Y=8;1c!==ZC.1d(B.IK.o[ZC.1b[21]])&&(Y=ZC.1l(B.IK.o[ZC.1b[21]]));1a w=4;1c!==ZC.1d(B.I2.o[ZC.1b[21]])&&(w=ZC.1l(B.I2.o[ZC.1b[21]]));1a M=ZC.1l(B.A.E[B.BB+"-6T"]||-1);B.V7&&(M=0),"2n"===B.B7?(g=ZC.1l(B.A.Q.DZ/b),a=B.iX-(F-1)*g,-1!==M&&(a=B.iX-M)):(g=ZC.1l(B.A.Q.E3/b),a=B.iX+B.I+(F-1)*g,-1!==M&&(a=B.iX+B.I+M));1a H=a;if(B.A.I6&&B.BB===ZC.1b[51]&&(B.A.I6.AL=!0,B.GV===B.B8&&B.HF===B.BS&&(B.A.I6.AL=!1),B.A.I6.AL&&0===B.A.I6.AZ.BJ&&"2n"===B.B7&&(a-=B.A.I6.AZ.I+B.AY/2)),B.E.iX=a,B.AL&&B.T1){1a N=1A.4h((B.A1-B.X)/(B.EE-1)),S=1A.4h((B.A1-B.X)/(B.LX-1)),O=0,P=B.A9*S/(B.GQ+1);if(l=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),o=ZC.P.E6(l,B.H.AB),r=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-bl-0-c"),C=ZC.P.E6(r,B.H.AB),B.T1||B.Y6||1c!==ZC.1d(B.A.o[B.BB])){if("5n"===B.o["1y-1r"]&&-1!==v&&(B.B6=v),B.A.AJ["3d"]){if(u=ZC.DF.DA(B,B.A,a-ZC.AM.E1,a-ZC.AM.E1,B.iY-ZC.AM.E0,B.iY-ZC.AM.E0+B.F,-1,ZC.AM.FQ+1,"y"),u.K=B.K+"-1y",B.A.F7.7J&&(B.A.F7[ZC.1b[28]]>0?u.M9=[1===B.L?-100:100,1,1]:u.M9=[1===B.L?100:-100,1,1]),B.A.CH.2N(u),1c!==ZC.1d(B.o.cf)){1a k=1n ZC.CZ(B);k.1C(B.o.cf),k.1q(),k.A0=k.AC=k.B6,(u=ZC.DF.DA(k,B.A,a-ZC.AM.E1,a-ZC.AM.E1,B.iY-ZC.AM.E0,B.iY-ZC.AM.E0+B.F,-k.AY/2,k.AY/2,"y")).K=B.K+"-cf",B.A.CH.2N(u)}}1t{s=[[H,B.iY+B.F],[H,B.iY]];1a G=B.K;B.K+="-1y",ZC.CN.1v(o,B,s),B.K=G}1a z=0,T=0,J=[],Q=[];if(B.T1||B.Y6){if(B.W.1h>0&&B.D5.AL){1a W=1c===ZC.1d(B.D5.o["1Y-46"])?0:ZC.1l(B.D5.o["1Y-46"]),R=1c===ZC.1d(B.D5.o["1Y-6n"])?0:ZC.1l(B.D5.o["1Y-6n"]);if(B.D5.o.2z&&B.D5.o.2z.1h>0&&!B.A.AJ["3d"])1k(B.GN=0,p=1n ZC.HQ(B),i=B.X;i<B.A1+(B.DK?1:0);i++)B.JX=i,i%S==0&&(Z=i-B.X,h=B.GN%B.D5.o.2z.1h,p.1C(B.D5.o.2z[h]),p.K=B.K+"-2g-"+i,p.Z=r,p.1q(),p.iX=B.iX+W,A="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iY+B.A6+Z*B.A9:B.iY+B.F-B.A6-Z*B.A9-B.A9*S,p.iY=A,p.I=B.I-W-R,p.F=B.A9*S,p.1v(),B.GN++);if(B.D5.AY>0)1k(B.GN=0,i=B.X;i<=B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%S==0){(B.D5.E4.1h>0||i===B.X||"2W"===B.CA)&&((c=1n ZC.CZ(B)).Z=c.C5=r,"2W"===B.CA?ZC.AN.dE(ZC.HH(B.W[i],B.EV))?c.1Q(B.D5):c.1Q(B.FY):c.1Q(B.D5),c.JC=e,c.DD()&&c.1q()),s=[],Z=i-B.X;1a V=B.iX+W,U=B.I-W-R;if(A="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iY+B.A6+Z*B.A9:B.iY+B.F-B.A6-Z*B.A9,c.AL)if(B.A.AJ["3d"]){1a j=1n ZC.CZ(B);j.1Q(c),1c!==ZC.1d(B.o["1z-z"])&&1c!==ZC.1d(t=B.o["1z-z"].2g)&&(j.1C(t),j.1q()),j.A0=j.AC=j.B6,u=ZC.DF.DA(j,B.A,a-ZC.AM.E1,a-ZC.AM.E1,A-ZC.AM.E0-j.AY/2,A-ZC.AM.E0+j.AY/2,0,ZC.AM.FQ,"y"),B.A.CH.2N(u),c.A0=c.AC=c.B6,(u=ZC.DF.DA(c,B.A,V-ZC.AM.E1,V-ZC.AM.E1+U,A-ZC.AM.E0-c.AY/2,A-ZC.AM.E0+c.AY/2,ZC.AM.FQ+2,ZC.AM.FQ+2,"x")).K=B.K+"-2g-"+i,B.A.CH.2N(u)}1t s.1i([V,A],[V+U,A]),c.K=B.K+"-2g-"+i,ZC.CN.1v(C,c,s);B.GN++}}if(B.W.1h>0&&B.FY.AL&&P>2&&!B.A.AJ["3d"]){if(B.FY.o.2z&&B.FY.o.2z.1h>0)1k(p=1n ZC.HQ(B),i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i%S==0)1k(Z=i-B.X,B.GN=0,1b=1;1b<=B.GQ;1b++)h=B.GN%B.FY.o.2z.1h,p.1C(B.FY.o.2z[h]),p.K=B.K+"-2g-"+i+"-"+1b,p.Z=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-bl-0-c"),p.1q(),p.iX=B.iX,A=B.AR?B.iY+B.A6+Z*B.A9+1b*P:B.iY+B.F-B.A6-Z*B.A9-(1b+1)*P,p.iY=A,p.I=B.I,p.F=P,p.1v(),B.GN++;if(B.FY.AY>0&&"2W"!==B.CA)1k(i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%S==0)1k(Z=i-B.X,B.GN=0,1b=1;1b<=B.GQ;1b++)s=[],(c=1n ZC.CZ(B)).1Q(B.FY),c.JC=e,c.DD()&&c.1q(),A="2W"===B.CA?B.B2(B.W[i]+1b*(B.W[i+1]-B.W[i])/(B.GQ+1)):B.AR?B.iY+B.A6+Z*B.A9+1b*P:B.iY+B.F-B.A6-Z*B.A9-1b*P,ZC.DU(A,B.iY,B.iY+B.F)&&(s.1i([B.iX,A],[B.iX+B.I,A]),c.AL&&(c.K=B.K+"-4Q-2g-"+1b,ZC.CN.1v(C,c,s))),B.GN++}B.VA(C,v);1a q,$,ee;if(B.W.1h>0&&B.IK.AL){1P(B.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":O+=Y;1p;2n:O+=Y/2}1k(B.GN=0,d=ZC.AT(B.W,0),i=B.X;i<=B.A1+(B.DK?1:0);i++){B.JX=i;1a te=-1;if(i===B.X||i===B.A1||i%S==0||ZC.2q(B.o["4k-d9"])&&i===d){1P(s=[],Z=i-B.X,(B.IK.E4.1h>0||i===B.X||"2W"===B.CA)&&(c=1n ZC.CZ(B),"2W"===B.CA?ZC.AN.dE(ZC.HH(B.W[i],B.EV))?c.1Q(B.IK):(c.1Q(B.I2),te=Y,Y=w):c.1Q(B.IK),"5n"===B.IK.o["1y-1r"]&&-1!==v&&(c.B6=v),c.JC=e,c.DD()&&c.1q()),A="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iY+B.A6+Z*B.A9:B.iY+B.F-B.A6-Z*B.A9,c.o[ZC.1b[7]]){1j"3N-2x":s.1i([I,A],[I+Y,A]);1p;1j"3N-1J":s.1i([I,A],[I-Y,A]);1p;1j"3N-3e":s.1i([I-Y/2,A],[I+Y/2,A]);1p;1j"5N":s.1i([a,A],[a+(D?Y:-Y),A]);1p;1j"77":s.1i([a,A],[a-(D?Y:-Y),A]);1p;2n:s.1i([a+Y/2,A],[a-Y/2,A])}if(-1!==te&&(Y=te,te=-1),c.AL){1k($=ZC.1l(c.o["1Y-x"]||"0"),ee=ZC.1l(c.o["1Y-y"]||"0"),q=0;q<s.1h;q++)s[q][0]+=$,s[q][1]+=ee;if(c.K=B.K+"-3W-"+i,B.A.AJ["3d"]&&B.A.F7.7J){1a ie,ne=[];1k(q=0;q<s.1h;q++)ie=1n ZC.CF(B.A,s[q][0]-ZC.AM.E1,s[q][1]-ZC.AM.E0,0),ne.1i([ie.E9[0],ie.E9[1]]);ZC.CN.1v(o,c,ne)}1t ZC.CN.1v(o,c,s)}B.GN++}}}if(B.W.1h>0&&B.I2.AL&&B.GQ>0&&P>5&&!B.A.AJ["3d"]&&"2W"!==B.CA)1k(i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%S==0)1k(Z=i-B.X,B.GN=0,1b=1;1b<=B.GQ;1b++){if(s=[],(c=1n ZC.CZ(B)).1Q(B.I2),"5n"===B.I2.o["1y-1r"]&&-1!==v&&(c.B6=v),c.JC=e,c.DD()&&c.1q(),A="2W"===B.CA?B.B2(B.W[i]+1b*(B.W[i+1]-B.W[i])/(B.GQ+1)):B.AR?B.iY+B.A6+Z*B.A9+1b*P:B.iY+B.F-B.A6-Z*B.A9-1b*P,ZC.DU(A,B.iY,B.iY+B.F)){1P(c.o[ZC.1b[7]]){1j"3N-2x":s.1i([I,A],[I+w,A]);1p;1j"3N-1J":s.1i([I,A],[I-w,A]);1p;1j"3N-3e":s.1i([I-w/2,A],[I+w/2,A]);1p;1j"5N":s.1i([a,A],[a+(D?w:-w),A]);1p;2n:s.1i([a,A],[a-(D?w:-w),A]);1p;1j"9u":s.1i([a+w/2,A],[a-w/2,A])}if(c.AL){1k($=ZC.1l(c.o["1Y-x"]||"0"),ee=ZC.1l(c.o["1Y-y"]||"0"),q=0;q<s.1h;q++)s[q][0]+=$,s[q][1]+=ee;c.K=B.K+"-4Q-3W-"+i,ZC.CN.1v(o,c,s)}}B.GN++}B.XC();1a ae=1c,le=B.CG,oe=B.DW,re=1f(t){B.JX=t,Z=t-B.X,(B.BQ.E4.1h>0||t===B.X||!f||B.BQ.IA)&&(f=1n ZC.DQ(B)),f.1Q(B.BQ),f.GG=B.K+"-1N "+B.A.K+"-1z-1N zc-1z-1N",f.K=B.A.K+"-"+B.BB.1E(/\\-/g,"1b")+"-7E"+t,B.CG=le,B.DW=oe,B.YT(e);1a i;if(i=("5O"===B.A.AF||B.QM)&&B.BW.1h?B.G0(t+B.B8):B.G0(t),B.BQ.IA&&B.H9(B.BQ,f,1c,{2V:t,83:Z,1D:i},B.BQ.OC),1c===ZC.1d(B.LP)||-1!==ZC.AT(B.LP,i)){1P(f.AP=i,f.Z=f.C5=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),f.IE=B.H.2L()?ZC.AK(B.H.K+"-3X"):ZC.AK(B.H.K+"-1D"),f.1q(),"5n"!==B.BQ.o["2p-1r"]&&"5n"!==B.BQ.o.1r||-1===v||(f.BZ=v),f.JC=e,f.DD()&&f.1q(),f.o[ZC.1b[7]]){1j"3N-1J":f.iX=I-f.I-Y;1p;1j"3N-2x":f.iX=I+Y;1p;1j"3N-3e":X&&X.S[t]?(X.FO(t).2E(),X.FO(t).iX<I?f.iX=I+Y:f.iX=I-f.I-Y):f.iX=I+Y;1p;1j"6o":f.iX=a-f.I/2;1p;1j"5N":f.iX=D?a+Y:a-f.I-Y;1p;2n:f.iX=D?a-f.I-Y:a+Y}if("2W"===B.CA?f.iY=B.B2(B.W[t])-f.F/2:B.AR?f.iY=B.iY+B.A6+Z*B.A9-f.F/2+(B.DK?B.A9/2:0):f.iY=B.iY+B.F-B.A6-Z*B.A9-f.F/2-(B.DK?B.A9/2:0),ae=B.MT(f,ae,"v"),B.BQ.o["3e-3s"]&&B.BQ.AA%180!=0){1a n=D?1:-1;90===B.BQ.AA||3T===B.BQ.AA?f.iX+=n*(f.I/2-f.F/2):ZC.DU(B.BQ.AA,0,90)||ZC.DU(B.BQ.AA,3T,2j)?(f.iX+=n*(f.I-f.I*ZC.ED(B.BQ.AA))/2,f.iY-=n*f.I*ZC.EL(B.BQ.AA)/2):ZC.DU(B.BQ.AA,90,3T)&&(f.iX+=n*(f.I+f.I*ZC.ED(B.BQ.AA))/2,f.iY+=n*f.I*ZC.EL(B.BQ.AA)/2)}1a l=B.WS(f,t,{2z:0,hi:J,hj:N,aP:z,aQ:T,gR:"w",4a:Q});z=l.aP,T=l.aQ,B.GN++}};if(B.W.1h>0&&B.BQ.AL)if("2W"===B.CA){1a Ce=[];1k(i=B.X;i<=B.A1;i++)ZC.AN.dE(ZC.HH(B.W[i],B.EV))&&(B.GN=i,re(i),Ce.1i(i));1k(i=B.X;i<=B.A1;i++)-1===ZC.AT(Ce,i)&&(B.GN=i,re(i))}1t 1k(B.GN=0,re(B.X),B.GN=B.A1-B.X,re(B.A1),-1!==(d=ZC.AT(B.W,0))&&ZC.2q(B.o["4k-d9"])&&(B.GN=d,re(d)),B.GN=1,i=B.X+1;i<B.A1;i++)i%N==0&&re(i)}if(B.M.AL&&B.M.AP&&""!==B.M.AP){(f=1n ZC.DQ(B)).1Q(B.M),f.K=B.A.K+"-"+B.BB.1E(/\\-/g,"1b")+"-lv",f.GG=B.K+"-1G "+B.A.K+"-1z-1G zc-1z-1G",f.AP=B.M.AP,f.Z=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),f.IE=B.H.2L()?ZC.AK(B.H.K+"-3X"):ZC.AK(B.H.K+"-1D"),f.1q(),"5n"!==B.M.o["2p-1r"]&&"5n"!==B.M.o.1r||-1===v||(f.BZ=v);1a Ae=B.iY+(B.AR?B.A6:B.BV),se=B.F-B.BV-B.A6;1P("aL"===f.o["3E-fO"]&&(Ae=B.A.iY,se=B.A.F),f.JQ){1j"1u":f.iY=Ae+f.I/2-f.F/2;1p;1j"6o":f.iY=Ae+se/2-f.F/2;1p;1j"2a":f.iY=Ae+se-f.I/2-f.F/2}f.iX=D?a-f.I/2-f.F/2-O-T:a+T+f.F/2+O-f.I/2,B.M.iX=f.iX,B.M.iY=f.iY,f.AL&&(B.MT(f,1c,"v",10),f.1v(),f.EH(),1c===ZC.1d(f.o.2C)&&f.K3||Q.1i(ZC.AO.NZ(B.A.K,f)))}Q.1h>0&&ZC.AK(B.A.A.K+"-2Z")&&(ZC.AK(B.A.A.K+"-2Z").4n+=Q.2I(""))}}}}),ZC.UM=ZC.h0.C7({$i:1f(e){1g.b(e),1g.D9=!0},1q:1f(){1g.b()},IW:1f(){1a e=1g;e.A1===e.X?e.A9=e.F-e.A6-e.BV:e.A9=(e.F-e.A6-e.BV)/(e.A1-e.X+(e.DK?1:0))},7j:1f(e){1a t=1g;t.b(e),t.IW()},3v:1f(){},8e:1f(){1g.b()},a4:1f(e,t){1a i=1g;i.b(e,t),i.IW()},N8:1f(e){1a t,i=1g;1m t=i.AR?(e-i.iY-i.A6)/(i.F-i.A6-i.BV):(i.iY+i.F-i.A6-e)/(i.F-i.A6-i.BV),i.B8+ZC.1W((i.BS-i.B8)*t)},O4:1f(e,t,i){1a n,a,l,o,r=1g;1w i===ZC.1b[31]&&(i=!1);1a C=r.DK?r.A9:0;l=r.AR?(e-r.iY-r.A6-C/2)/(r.F-r.A6-r.BV-C):(r.iY+r.F-e-r.A6-C/2)/(r.F-r.A6-r.BV-C);1a A=!1;if(t)1k(o in t.JW){A=!0;1p}if(t&&!r.NQ&&A){1a s=r.W[r.X];"2Y"==1w s&&(s=ZC.AT(r.IH,s)),"2W"===r.CA&&(s=ZC.HH(s,r.EV));1a Z=r.W[r.A1];"2Y"==1w Z&&(Z=ZC.AT(r.IH,Z)),"2W"===r.CA&&(Z=ZC.HH(Z,r.EV));1a c=s+ZC.1W((Z-s)*l);"2W"===r.CA&&(c=1A.5k(r.EV,c));1a u=ZC.3q;a=1c;1k(o in t.JW)(n=1A.3i(o-c))<u&&(u=n,a=t.JW[o]);if(1c===ZC.1d(a)&&(a=c),u>t.lB){1a p=1A.4h((Z-s)/(r.I-r.A6-r.BV));if(t.W.1h<2&&(p*=100),u>p)1m 1c}1m a}1a h=r.X,1b=r.A1;1m r.EC&&(1c!==ZC.1d(n=r.W[h])&&(h=n),1c!==ZC.1d(n=r.W[1b])&&(1b=n)),"2W"===r.CA&&(h=ZC.HH(h,r.EV),1b=ZC.HH(1b,r.EV)),a=i?r.DK?h+(1b-h+1)*l:h+(1b-h)*l:r.DK?r.X+(r.A1-r.X+1)*l:r.X+(r.A1-r.X)*l,"2W"===r.CA?(a=1A.5k(r.EV,a),a=1A.4i(a)-1):(a=r.DK?1A.4i(a):ZC.1l(a),a=ZC.BN(0,a),a=ZC.CV(r.EF,a)),a},I3:1f(e){1a t=1g;t.X,t.A1;1m t.EC&&!t.NQ&&(t.B8,t.BS),"2W"===t.CA&&(e=ZC.HH(e+1,t.EV)),t.AR?t.iY+t.A6+(e-t.X)*t.A9+(t.DK?t.A9/2:0):t.iY+t.F-t.A6-(e-t.X)*t.A9-(t.DK?t.A9/2:0)},B2:1f(e){1a t,i,n,a=1g;if("2W"===a.CA&&(e=ZC.HH(e,a.EV)),a.NQ){1a l=a.TX[e];1m a.I3(l)}if(-1!==(t=ZC.AT(a.IH,e)))1m a.I3(t);1a o,r;1m!a.lz&&(a.EC||a.FD&&"5z"===a.FD.o.1I)?(o=a.W[a.X],r=a.W[a.A1],"2W"===a.CA&&(o=ZC.HH(o,a.EV),r=ZC.HH(r,a.EV)),r===o?n=0:(i=r-o,n=(a.F-a.A6-a.BV-(a.DK?a.A9:0))/i),a.AR?a.iY+a.A6+(e-o)*n+(a.DK?a.A9/2:0):a.iY+a.F-a.A6-(e-o)*n-(a.DK?a.A9/2:0)):(o=a.B8,r=a.BS,"2W"===a.CA&&(o=ZC.HH(o,a.EV),r=ZC.HH(r,a.EV)),r===o?n=0:(i=r-o+(a.DK?1:0),n=(a.F-a.A6-a.BV)/i),a.AR?a.iY+a.A6+(e-o)*n+(a.DK?a.A9/2:0):a.iY+a.F-a.A6-(e-o)*n-(a.DK?a.A9/2:0))},1v:1f(){1f e(e){1m e=e.1E(/%1z-84-2G/g,g.A1-g.X),e=e.1E(/(%c)|(%1z-2G)/g,g.GN),e=e.1E(/(%i)|(%1z-2V)/g,g.JX),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(g.W[g.JX])?g.W[g.JX]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(g.BW[g.JX])?g.BW[g.JX]:"")}1f t(t){g.JX=t,Z=t-g.X,(g.BQ.E4.1h>0||t===g.X||!V||g.BQ.IA)&&(V=1n ZC.DQ(g)),V.1Q(g.BQ),V.K=g.A.K+"-"+g.BB.1E(/\\-/g,"1b")+"-7E"+t,V.GG=g.K+"-1N "+g.A.K+"-1z-1N zc-1z-1N",V.E["p-1L"]=g.A9,g.CG=j,g.DW=q,g.YT(e);1a i=g.G0(t);if(g.BQ.IA&&g.H9(g.BQ,V,1c,{2V:t,83:Z,1D:i},g.BQ.OC),1c===ZC.1d(g.LP)||-1!==ZC.AT(g.LP,i)){1P(V.AP=i,V.Z=V.C5=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),V.IE=g.H.2L()?ZC.AK(g.H.K+"-3X"):ZC.AK(g.H.K+"-1D"),V.E.7l=t,V.1q(),"5n"!==g.BQ.o["2p-1r"]&&"5n"!==g.BQ.o.1r||-1===B||(V.BZ=B),V.JC=e,V.DD()&&V.1q(),V.o["3e-gw"]&&(V.F=ZC.1l(g.A9)),V.o[ZC.1b[7]]){1j"5N":V.iX=F?o+L:o-V.I-L;1p;1j"3N-1J":V.iX=D-V.I-L;1p;1j"3N-2x":V.iX=D+L;1p;1j"3N-3e":I&&I.S[t]?(I.S[t].2E(),I.S[t].iX<D?V.iX=D+L:V.iX=D-V.I-L):V.iX=D+L;1p;2n:V.iX=F?o-V.I-L:o+L}if(g.AR?V.iY=g.iY+g.A6+Z*g.A9-V.F/2+(g.DK?g.A9/2:0):V.iY=g.iY+g.F-g.A6-Z*g.A9-V.F/2-(g.DK?g.A9/2:0),U=g.MT(V,U,"v"),g.BQ.o["3e-3s"]&&g.BQ.AA%180!=0){1a n=F?1:-1;90===g.BQ.AA||3T===g.BQ.AA?V.iX+=n*(V.I/2-V.F/2):ZC.DU(g.BQ.AA,0,90)||ZC.DU(g.BQ.AA,3T,2j)?(V.iX+=n*(V.I-V.I*ZC.ED(g.BQ.AA))/2,V.iY-=n*V.I*ZC.EL(g.BQ.AA)/2):ZC.DU(g.BQ.AA,90,3T)&&(V.iX+=n*(V.I+V.I*ZC.ED(g.BQ.AA))/2,V.iY+=n*V.I*ZC.EL(g.BQ.AA)/2)}1a a=g.WS(V,t,{2z:te,hi:ie,hj:N,aP:$,aQ:ee,gR:"w",4a:ne});$=a.aP,ee=a.aQ,g.GN++}}1a i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d,f,g=1g;if(g.AL){g.b(),1c!==ZC.1d(g.A.A.E[g.BB+"-bH-1Y-46"])&&(g.A6=g.A.A.E[g.BB+"-bH-1Y-46"]),"6z"!==g.A.AF&&"8t"!==g.A.AF||(-1===g.A6&&-1===g.BV||1===g.W.1h)&&(g.A6=g.BV=g.F/(g.W.1h+1),g.IW());1a B=g.ZZ(),v=0,b=1,E=1,m={};1k(n=0,a=g.A.BK.1h;n<a;n++)g.A.BK[n].BB.2s(0,7)===ZC.1b[50]&&g.A.BK[n].B7===g.B7&&v++,g.A.BK[n].BB.2s(0,7)===ZC.1b[50]&&("2n"===g.A.BK[n].B7?(m[g.A.BK[n].BB]=b,b++):(m[g.A.BK[n].BB]=E,E++));1a K=m[g.BB],F="2n"===g.B7,D=1c,I=1c;1k(n=0,a=g.A.AX.A7.1h;n<a;n++){1a X=g.A.AX.A7[n],x=X.BT();if(-1!==ZC.AT(x,g.BB)){1a y=g.A.BL(X.BT("v")[0]);D=y.B2(y.GZ),I=X;1p}}1a L=8;1c!==ZC.1d(g.IK.o[ZC.1b[21]])&&(L=ZC.1l(g.IK.o[ZC.1b[21]]));1a Y=4;1c!==ZC.1d(g.I2.o[ZC.1b[21]])&&(Y=ZC.1l(g.I2.o[ZC.1b[21]]));1a w=ZC.1l(g.A.E[g.BB+"-6T"]||-1);g.V7&&(w=0),"2n"===g.B7?(l=ZC.1l(g.A.Q.DZ/v),o=g.iX-(K-1)*l,-1!==w&&(o=g.iX-w)):(l=ZC.1l(g.A.Q.E3/v),o=g.iX+g.I+(K-1)*l,-1!==w&&(o=g.iX+g.I+w));1a M=o;if(g.A.I5&&g.BB===ZC.1b[50]&&(g.A.I5.AL=!0,g.E7===g.X&&g.EF===g.A1&&(g.A.I5.AL=!1),g.A.I5.AL&&0===g.A.I5.AZ.BJ&&"2n"===g.B7&&(o-=g.A.I5.AZ.I+g.AY/2)),g.E.iX=o,g.AL&&g.T1){1c!==ZC.1d(g.o["7m-2z"])&&(g.LX=g.EE=ZC.1l(g.o["7m-2z"]));1a H=1A.4h((g.A1-g.X)/(g.LX-1)),N=1A.4h((g.A1-g.X)/(g.EE-1));1c===ZC.1d(g.o["7m-2z"])&&ZC.2q(g.o.gy)&&(H=ZC.AN.gz(H),N=ZC.AN.gz(N));1a S=0,O=g.A9*H/(g.GQ+1);if(1c===ZC.1d(D)&&(D=o),r=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),C=ZC.P.E6(r,g.H.AB),A=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-bl-0-c"),s=ZC.P.E6(A,g.H.AB),"5n"===g.o["1y-1r"]&&-1!==B&&(g.B6=B),g.A.AJ["3d"])(h=ZC.DF.DA(g,g.A,o-ZC.AM.E1,o-ZC.AM.E1,g.iY-ZC.AM.E0,g.iY-ZC.AM.E0+g.F,-1,ZC.AM.FQ+1,"y")).K=g.K+"-1y",g.A.F7.7J&&(g.A.F7[ZC.1b[27]]>0?h.M9=[1===g.L?-100:100,1,1]:h.M9=[1===g.L?100:-100,1,1]),g.A.CH.2N(h);1t{c=[[M,g.iY+g.F],[M,g.iY]];1a P=g.K;g.K+="-1y",ZC.CN.1v(C,g,c),g.K=P}if(g.W.1h>0&&g.D5.AL){1a k=1c===ZC.1d(g.D5.o["1Y-46"])?0:ZC.1l(g.D5.o["1Y-46"]),G=1c===ZC.1d(g.D5.o["1Y-6n"])?0:ZC.1l(g.D5.o["1Y-6n"]);if(g.D5.o.2z&&g.D5.o.2z.1h>0&&!g.A.AJ["3d"])1k(1b=1n ZC.HQ(g),n=g.X;n<g.A1+(g.DK?1:0);n++)Z=n-g.X,f=n%g.D5.o.2z.1h,1b.1C(g.D5.o.2z[f]),1b.K=g.K+"-2g-"+n,1b.Z=A,1b.1q(),1b.iX=g.iX+k,g.AR?1b.iY=g.iY+g.A6+Z*g.A9:1b.iY=g.iY+g.F-g.A6-(Z+1)*g.A9,1b.I=g.I-k-G,1b.F=g.A9,1b.1v();if(g.D5.AY>0)1k(g.GN=0,n=g.X;n<=g.A1+(g.DK?1:0);n++)if(g.JX=n,n===g.X||n===g.A1+(g.DK?1:0)||(n-g.X)%H==0){(g.D5.E4.1h>0||n===g.X)&&((p=1n ZC.CZ(g)).Z=p.C5=A,p.1Q(g.D5),p.JC=e,p.DD()&&p.1q()),Z=n-g.X,c=[],u=g.AR?g.iY+g.A6+Z*g.A9:g.iY+g.F-g.A6-Z*g.A9;1a z=g.iX+k,T=g.I-k-G;if(p.AL)if(g.A.AJ["3d"]){1a J=1n ZC.CZ(g);J.1Q(p),1c!==ZC.1d(g.o["1z-z"])&&1c!==ZC.1d(i=g.o["1z-z"].2g)&&(J.1C(i),J.1q()),J.A0=J.AC=J.B6,h=ZC.DF.DA(J,g.A,o-ZC.AM.E1,o-ZC.AM.E1,u-ZC.AM.E0-J.AY/2,u-ZC.AM.E0+J.AY/2,0,ZC.AM.FQ,"z"),g.A.CH.2N(h),p.A0=p.AC=p.B6,(h=ZC.DF.DA(p,g.A,z-ZC.AM.E1,z-ZC.AM.E1+T,u-ZC.AM.E0-J.AY/2,u-ZC.AM.E0+J.AY/2,ZC.AM.FQ+2,ZC.AM.FQ+2,"x")).K=g.K+"-2g-"+n,g.A.CH.2N(h)}1t c.1i([z,u],[z+T,u]),p.K=g.K+"-2g-"+n,ZC.CN.1v(s,p,c);g.GN++}}if(g.W.1h>0&&g.FY.AL&&!g.A.AJ["3d"]){if(g.FY.o.2z&&g.FY.o.2z.1h>0)1k(1b=1n ZC.HQ(g),n=g.X;n<g.A1+(g.DK?1:0);n++)1k(g.JX=n,Z=n-g.X,g.GN=0,d=1;d<=g.GQ;d++)f=g.GN%g.FY.o.2z.1h,1b.1C(g.FY.o.2z[f]),1b.K=g.K+"-2g-"+n+"-"+d,1b.Z=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-bl-0-c"),1b.1q(),1b.iX=g.iX,g.AR?1b.iY=g.iY+g.A6+(Z+1)*g.A9-(d+1)*O:1b.iY=g.iY+g.F-g.A6-(Z+1)*g.A9+d*O,1b.I=g.I,1b.F=O,1b.1v(),g.GN++;if(g.FY.AY>0)1k(n=g.X;n<g.A1+(g.DK?1:0);n++)if(g.JX=n,n%H==0)1k(Z=n-g.X,g.GN=0,d=1;d<=g.GQ;d++)c=[],(p=1n ZC.CZ(g)).1Q(g.FY),p.JC=e,p.DD()&&p.1q(),u="2W"===g.CA?g.B2(g.W[n]+d*(g.W[n+1]-g.W[n])/(g.GQ+1)):g.AR?g.iY+g.A6+Z*g.A9+d*O:g.iY+g.F-g.A6-Z*g.A9-d*O,ZC.DU(u,g.iY,g.iY+g.F)&&(c.1i([g.iX,u],[g.iX+g.I,u]),p.AL&&(p.K=g.K+"-4Q-2g-"+d,ZC.CN.1v(s,p,c))),g.GN++}g.VA(s,B);1a Q,W,R;if(g.W.1h>0&&g.IK.AL&&(!g.A.AJ["3d"]||!g.A.F7.7J)){1P(g.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":S+=L;1p;2n:S+=L/2}1k(g.GN=0,n=g.X;n<=g.A1+(g.DK?1:0);n++)if(g.JX=n,n===g.X||n===g.A1+(g.DK?1:0)||(n-g.X)%H==0){1P(c=[],Z=n-g.X,(g.IK.E4.1h>0||n===g.X)&&((p=1n ZC.CZ(g)).1Q(g.IK),"5n"===g.IK.o["1y-1r"]&&-1!==B&&(p.B6=B),p.JC=e,p.DD()&&p.1q()),u=g.AR?g.iY+g.A6+Z*g.A9:g.iY+g.F-g.A6-Z*g.A9,p.o[ZC.1b[7]]){1j"3N-3e":c.1i([D-L/2,u],[D+L/2,u]);1p;1j"3N-1J":c.1i([D-L,u],[D,u]);1p;1j"3N-2x":c.1i([D+L,u],[D,u]);1p;1j"5N":c.1i([o,u],[o+(F?L:-L),u]);1p;1j"77":c.1i([o,u],[o-(F?L:-L),u]);1p;2n:c.1i([o+L/2,u],[o-L/2,u])}if(p.AL){1k(W=ZC.1l(p.o["1Y-x"]||"0"),R=ZC.1l(p.o["1Y-y"]||"0"),Q=0;Q<c.1h;Q++)c[Q][0]+=W,c[Q][1]+=R;p.K=g.K+"-3W-"+n,ZC.CN.1v(C,p,c)}g.GN++}}if(g.W.1h>0&&g.GQ>0&&g.I2.AL&&!g.A.AJ["3d"])1k(n=g.X;n<g.A1+(g.DK?1:0);n++)if(n===g.X||n===g.A1+(g.DK?1:0)||n%H==0)1k(Z=n-g.X,d=1;d<=g.GQ;d++){if(c=[],(p=1n ZC.CZ(g)).1Q(g.I2),"5n"===g.I2.o["1y-1r"]&&-1!==B&&(p.B6=B),p.JC=e,p.DD()&&p.1q(),u="2W"===g.CA?g.B2(g.W[n]+d*(g.W[n+1]-g.W[n])/(g.GQ+1)):g.AR?g.iY+g.A6+Z*g.A9+d*O:g.iY+g.F-g.A6-Z*g.A9-d*O,ZC.DU(u,g.iY,g.iY+g.F)){1P(p.o[ZC.1b[7]]){1j"3N-3e":c.1i([D-Y/2,u],[D+Y/2,u]);1p;1j"3N-1J":c.1i([D-Y,u],[D,u]);1p;1j"3N-2x":c.1i([D+Y,u],[D,u]);1p;1j"5N":c.1i([o,u],[o+(F?Y:-Y),u]);1p;1j"77":c.1i([o,u],[o-(F?Y:-Y),u]);1p;2n:c.1i([o+Y/2,u],[o-Y/2,u])}if(p.AL){1k(W=ZC.1l(p.o["1Y-x"]||"0"),R=ZC.1l(p.o["1Y-y"]||"0"),Q=0;Q<c.1h;Q++)c[Q][0]+=W,c[Q][1]+=R;p.K=g.K+"-4Q-3W-"+n,ZC.CN.1v(C,p,c)}}g.GN++}g.XC();1a V,U=1c,j=g.CG,q=g.DW,$=0,ee=0,te=0,ie=[],ne=[];if(1===g.W.1h&&g.BQ.AL)g.GN=0,t(g.X);1t if(g.W.1h>1&&g.BQ.AL)1k(g.GN=0,t(g.X),g.GN=g.A1-g.X,t(g.A1),g.GN=1,n=g.X+1;n<g.A1;n++)(n-g.X)%N==0&&t(n);if(g.M.AL&&g.M.AP&&""!==g.M.AP){(V=1n ZC.DQ(g)).1Q(g.M),V.K=g.A.K+"-"+g.BB.1E(/\\-/g,"1b")+"-lv",V.GG=g.K+"-1G "+g.A.K+"-1z-1G zc-1z-1G",V.AP=g.M.AP,V.Z=g.H.2L()?g.H.mc():ZC.AK(g.A.K+"-3w-ml-0-c"),V.IE=g.H.2L()?ZC.AK(g.H.K+"-3X"):ZC.AK(g.H.K+"-1D"),V.1q(),"5n"!==g.M.o["2p-1r"]&&"5n"!==g.M.o.1r||-1===B||(V.BZ=B);1a ae=g.iY+(g.AR?g.A6:g.BV),le=g.F-g.A6-g.BV;1P("aL"===V.o["3E-fO"]&&(ae=g.A.iY,le=g.A.F),V.JQ){1j"1u":V.iY=ae+V.I/2-V.F/2;1p;1j"6o":V.iY=ae+le/2-V.F/2;1p;1j"2a":V.iY=ae+le-V.I/2-V.F/2}V.iX=F?o-V.I/2-V.F/2-S-ee:o+V.F/2+ee+S-V.I/2,g.M.iX=V.iX,g.M.iY=V.iY,V.AL&&(g.MT(V,1c,"v"),V.1v(),V.EH(),1c===ZC.1d(V.o.2C)&&V.K3||ne.1i(ZC.AO.NZ(g.A.K,V)))}ne.1h>0&&ZC.AK(g.A.A.K+"-2Z")&&(ZC.AK(g.A.A.K+"-2Z").4n+=ne.2I(""))}}}}),ZC.UL=ZC.ZB.C7({$i:1f(e){1g.b(e),1g.D9=!0},1q:1f(){1g.b()},IW:1f(){1a e=1g;e.A1===e.X?e.A9=e.I-e.A6-e.BV:e.A9=(e.I-e.A6-e.BV)/(e.A1-e.X+(e.DK?1:0))},7j:1f(e){1a t=1g;t.b(e),t.IW()},a4:1f(e,t){1a i=1g;i.b(e,t),i.IW()},3v:1f(){},8e:1f(){1g.b()},N8:1f(e,t){1a i,n=1g;i=n.AR?(n.iX+n.I-n.A6-e)/(n.I-n.A6-n.BV):(e-n.iX-n.A6)/(n.I-n.A6-n.BV);1a a=n.B8+ZC.1W((n.BS-n.B8)*i);1m"2W"===n.CA&&t&&(a=1A.5k(n.EV,a)),a},B2:1f(e){1a t=1g,i=t.BS-t.B8,n=0===i?0:(t.I-t.A6-t.BV)/i;1m"2W"===t.CA&&(e=ZC.HH(e,t.EV)),t.AR?t.iX+t.I-t.A6-(e-t.B8)*n:t.iX+t.A6+(e-t.B8)*n},1v:1f(){1f e(e){1m e=e.1E(/%1z-84-2G/g,B.A1-B.X),e=e.1E(/(%c)|(%1z-2G)/g,B.GN),e=e.1E(/(%i)|(%1z-2V)/g,B.JX),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(B.W[B.JX])?B.W[B.JX]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(B.BW[B.JX])?B.BW[B.JX]:"")}1a t,i,n,a,l,o,r,C,A,s,Z,c,u,p,h,1b,d,f,g,B=1g;if(B.AL&&0!==B.W.1h){B.b(),"6z"!==B.A.AF&&"8t"!==B.A.AF||1!==B.W.1h||(B.A6=B.I/2);1a v=B.ZZ(),b=0,E=1,m=1,K={};1k(i=0,n=B.A.BK.1h;i<n;i++)B.A.BK[i].BB.2s(0,7)===ZC.1b[51]&&B.A.BK[i].B7===B.B7&&b++,B.A.BK[i].BB.2s(0,7)===ZC.1b[51]&&("2n"===B.A.BK[i].B7?(K[B.A.BK[i].BB]=E,E++):(K[B.A.BK[i].BB]=m,m++));1a F=K[B.BB],D="2n"===B.B7;1k(i=0,n=B.A.AX.A7.1h;i<n;i++){1a I=B.A.AX.A7[i],X=I.BT();if(-1!==ZC.AT(X,B.BB)){1a x=B.A.BL(I.BT("k")[0]);x.B2(x.GZ),I;1p}}1a y=8;1c!==ZC.1d(B.IK.o[ZC.1b[21]])&&(y=ZC.1l(B.IK.o[ZC.1b[21]]));1a L=4;1c!==ZC.1d(B.I2.o[ZC.1b[21]])&&(L=ZC.1l(B.I2.o[ZC.1b[21]]));1a Y=ZC.1l(B.A.E[B.BB+"-6T"]||-1);B.V7&&(Y=0),"2n"===B.B7?(h=ZC.1l(B.A.Q.DN/b),a=B.iY+B.F+(F-1)*h,-1!==Y&&(a=B.iY+B.F+Y)):(h=ZC.1l(B.A.Q.E2/b),a=B.iY-(F-1)*h,-1!==Y&&(a=B.iY-Y));1a w=a;if(B.A.I6&&(B.A.I6.AL=!0,B.GV===B.B8&&B.HF===B.BS&&(B.A.I6.AL=!1),B.A.I6.AL&&0===B.A.I6.AZ.BD&&"2n"===B.B7&&(a+=B.A.I6.AZ.F+B.AY/2)),B.E.iY=a,B.AL&&B.T1){1a M=1A.4h((B.A1-B.X)/(B.EE-1)),H=1A.4h((B.A1-B.X)/(B.LX-1)),N=0,S=B.A9*H/(B.GQ+1);if(l=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),o=ZC.P.E6(l,B.H.AB),r=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-bl-0-c"),C=ZC.P.E6(r,B.H.AB),B.T1||B.Y6||1c!==ZC.1d(B.A.o[B.BB])){if("5n"===B.o["1y-1r"]&&-1!==v&&(B.B6=v),B.A.AJ["3d"])(u=ZC.DF.DA(B,B.A,B.iX-ZC.AM.E1,B.iX-ZC.AM.E1+B.I,a-ZC.AM.E0,a-ZC.AM.E0,-1,ZC.AM.FQ+1,"x")).K=B.K+"-1y",B.A.F7.7J&&(B.A.F7[ZC.1b[28]]>0?u.M9=[1===B.L?-100:100,1,1]:u.M9=[1===B.L?100:-100,1,1]),B.A.CH.2N(u);1t{A=[[B.iX,w],[B.iX+B.I,w]];1a O=B.K;B.K+="-1y",ZC.CN.1v(o,B,A),B.K=O}1a P=[],k=0,G=0,z=[];if(B.T1||B.Y6){if(B.W.1h>0&&B.D5.AL){1a T=1c===ZC.1d(B.D5.o["1Y-46"])?0:ZC.1l(B.D5.o["1Y-46"]),J=1c===ZC.1d(B.D5.o["1Y-6n"])?0:ZC.1l(B.D5.o["1Y-6n"]);if(B.D5.o.2z&&B.D5.o.2z.1h>0&&!B.A.AJ["3d"])1k(B.GN=0,d=1n ZC.HQ(B),i=B.X;i<B.A1+(B.DK?1:0);i++)B.JX=i,i%H==0&&(s=i-B.X,1b=B.GN%B.D5.o.2z.1h,d.1C(B.D5.o.2z[1b]),d.K=B.K+"-2g-"+i,d.Z=r,d.1q(),Z="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iX+B.I-B.A6-s*B.A9:B.iX+B.A6+s*B.A9,d.iX=Z,d.iY=B.iY+T,d.I=B.A9*H,d.F=B.F-T-J,d.1v(),B.GN++);if(B.D5.AY>0)1k(B.GN=0,i=B.X;i<=B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%H==0){(B.D5.E4.1h>0||i===B.X||"2W"===B.CA)&&((c=1n ZC.CZ(B)).Z=c.C5=r,"2W"===B.CA?ZC.AN.dE(ZC.HH(B.W[i],B.EV))?c.1Q(B.D5):c.1Q(B.FY):c.1Q(B.D5),c.JC=e,c.DD()&&c.1q()),A=[],s=i-B.X;1a Q=B.iY+T,W=B.F-T-J;if(Z="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iX+B.I-B.A6-s*B.A9:B.iX+B.A6+s*B.A9,c.AL)if(B.A.AJ["3d"]){1a R=1n ZC.CZ(B);R.1Q(c),1c!==ZC.1d(B.o["1z-z"])&&1c!==ZC.1d(t=B.o["1z-z"].2g)&&(R.1C(t),R.1q()),R.A0=R.AC=R.B6,u=ZC.DF.DA(R,B.A,Z-ZC.AM.E1-R.AY/2,Z-ZC.AM.E1+R.AY/2,a-ZC.AM.E0,a-ZC.AM.E0,0,ZC.AM.FQ,"z"),B.A.CH.2N(u),c.A0=c.AC=c.B6,(u=ZC.DF.DA(c,B.A,Z-ZC.AM.E1-c.AY/2,Z-ZC.AM.E1+c.AY/2,Q-ZC.AM.E0,Q-ZC.AM.E0+W,ZC.AM.FQ+2,ZC.AM.FQ+2,"y")).K=B.K+"-2g-"+i,B.A.CH.2N(u)}1t A.1i([Z,Q],[Z,Q+W]),c.K=B.K+"-2g-"+i,ZC.CN.1v(C,c,A);B.GN++}}if(B.W.1h>0&&B.FY.AL&&S>2&&!B.A.AJ["3d"]){if(B.FY.o.2z&&B.FY.o.2z.1h>0)1k(d=1n ZC.HQ(B),i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i%H==0)1k(s=i-B.X,B.GN=0,p=0;p<=B.GQ;p++)1b=B.GN%B.FY.o.2z.1h,d.1C(B.FY.o.2z[1b]),d.K=B.K+"-2g-"+i+"-"+p,d.Z=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-bl-0-c"),d.1q(),Z=B.AR?B.iX+B.I-B.A6-s*B.A9-(p+1)*S:B.iX+B.A6+s*B.A9+p*S,d.iX=Z,d.iY=B.iY,d.I=S,d.F=B.F,d.1v(),B.GN++;if(B.FY.AY>0&&"2W"!==B.CA)1k(i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%H==0)1k(s=i-B.X,B.GN=0,p=1;p<=B.GQ;p++)A=[],(c=1n ZC.CZ(B)).1Q(B.FY),c.JC=e,c.DD()&&c.1q(),Z="2W"===B.CA?B.B2(B.W[i]+p*(B.W[i+1]-B.W[i])/(B.GQ+1)):B.AR?B.iX+B.I-B.A6-s*B.A9-p*S:B.iX+B.A6+s*B.A9+p*S,ZC.DU(Z,B.iX,B.iX+B.I)&&(A.1i([Z,B.iY],[Z,B.iY+B.F]),c.AL&&(c.K=B.K+"-4Q-2g-"+p,ZC.CN.1v(C,c,A))),B.GN++}B.VA(C,v);1a V,U,j;if(B.W.1h>0&&B.IK.AL&&(!B.A.AJ["3d"]||!B.A.F7.7J)){1P(B.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":N+=y;1p;2n:N+=y/2}1k(B.GN=0,f=ZC.AT(B.W,0),i=B.X;i<=B.A1+(B.DK?1:0);i++){B.JX=i;1a q=-1;if(i===B.X||i===B.A1||i%H==0||ZC.2q(B.o["4k-d9"])&&i===f){1P(A=[],s=i-B.X,(B.IK.E4.1h>0||i===B.X||"2W"===B.CA)&&(c=1n ZC.CZ(B),"2W"===B.CA?ZC.AN.dE(ZC.HH(B.W[i],B.EV))?c.1Q(B.IK):(c.1Q(B.I2),q=y,y=L):c.1Q(B.IK),"5n"===B.IK.o["1y-1r"]&&-1!==v&&(c.B6=v),c.JC=e,c.DD()&&c.1q()),Z="2W"===B.CA?B.B2(B.W[i]):B.AR?B.iX+B.I-B.A6-s*B.A9:B.iX+B.A6+s*B.A9,c.o[ZC.1b[7]]){1j"5N":A.1i([Z,a-(D?y:-y)],[Z,a]);1p;1j"77":A.1i([Z,a],[Z,a+(D?y:-y)]);1p;2n:A.1i([Z,a+y/2],[Z,a-y/2])}if(-1!==q&&(y=q,q=-1),c.AL){1k(U=ZC.1l(c.o["1Y-x"]||"0"),j=ZC.1l(c.o["1Y-y"]||"0"),V=0;V<A.1h;V++)A[V][0]+=U,A[V][1]+=j;c.K=B.K+"-3W-"+i,ZC.CN.1v(o,c,A)}B.GN++}}}if(B.W.1h>0&&B.I2.AL&&B.GQ>0&&S>5&&!B.A.AJ["3d"]&&"2W"!==B.CA)1k(i=B.X;i<B.A1+(B.DK?1:0);i++)if(B.JX=i,i===B.X||i===B.A1||i%H==0)1k(s=i-B.X,B.GN=0,p=1;p<=B.GQ;p++){if(A=[],(c=1n ZC.CZ(B)).1Q(B.I2),"5n"===B.I2.o["1y-1r"]&&-1!==v&&(c.B6=v),c.JC=e,c.DD()&&c.1q(),Z="2W"===B.CA?B.B2(B.W[i]+p*(B.W[i+1]-B.W[i])/(B.GQ+1)):B.AR?B.iX+B.I-B.A6-s*B.A9-p*S:B.iX+B.A6+s*B.A9+p*S,ZC.DU(Z,B.iX,B.iX+B.I)){1P(c.o[ZC.1b[7]]){1j"5N":A.1i([Z,a-(D?L:-L)],[Z,a]);1p;2n:A.1i([Z,a],[Z,a+(D?L:-L)]);1p;1j"9u":A.1i([Z,a+L/2],[Z,a-L/2])}if(c.AL){1k(U=ZC.1l(c.o["1Y-x"]||"0"),j=ZC.1l(c.o["1Y-y"]||"0"),V=0;V<A.1h;V++)A[V][0]+=U,A[V][1]+=j;c.K=B.K+"-4Q-3W-"+i,ZC.CN.1v(o,c,A)}}B.GN++}B.XC();1a $=1c,ee=B.CG,te=B.DW,ie=1f(t){B.JX=t,s=t-B.X,(B.BQ.E4.1h>0||t===B.X||!g||B.BQ.IA)&&(g=1n ZC.DQ(B)),g.1Q(B.BQ),g.GG=B.K+"-1N "+B.A.K+"-1z-1N zc-1z-1N",g.K=B.A.K+"-"+B.BB.1E(/\\-/g,"1b")+"-7E"+t,B.CG=ee,B.DW=te,B.YT(e);1a i;if(i=("5O"===B.A.AF||B.QM)&&B.BW.1h?B.G0(t+B.B8):B.G0(t),B.BQ.IA&&B.H9(B.BQ,g,1c,{2V:t,83:s,1D:i},B.BQ.OC),1c===ZC.1d(B.LP)||-1!==ZC.AT(B.LP,i)){1P(g.AP=i,g.Z=g.C5=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),g.IE=B.H.2L()?ZC.AK(B.H.K+"-3X"):ZC.AK(B.H.K+"-1D"),g.1q(),"5n"!==B.BQ.o["2p-1r"]&&"5n"!==B.BQ.o.1r||-1===v||(g.BZ=v),g.JC=e,g.E4=B.BQ.E4,g.DD()&&g.1q(),g.o[ZC.1b[7]]){1j"5N":g.iY=D?a-g.KI-y:a+y;1p;2n:g.iY=D?a+y:a-g.KI-y}if("2W"===B.CA?g.iX=B.B2(B.W[t])-g.I/2:B.AR?g.iX=B.iX+B.I-B.A6-s*B.A9-g.I/2-(B.DK?B.A9/2:0):g.iX=B.iX+B.A6+s*B.A9-g.I/2+(B.DK?B.A9/2:0),$=B.MT(g,$,"h"),B.BQ.o["3e-3s"]&&B.BQ.AA%180!=0){1a n=ZC.DU(B.BQ.AA,0,180)?D?1:-1:1===D?-1:1;g.iX+=n*g.I*ZC.ED(B.BQ.AA)/2,g.iY+=n*(g.I*ZC.EL(B.BQ.AA)/2-g.F*ZC.EL(B.BQ.AA)/2)}1a l=B.WS(g,t,{2z:0,hi:P,hj:M,aP:k,aQ:G,gR:"h",4a:z});k=l.aP,G=l.aQ,B.GN++}};if(B.W.1h>0&&B.BQ.AL)if("2W"===B.CA){1a ne=[];1k(i=B.X;i<=B.A1;i++)ZC.AN.dE(ZC.HH(B.W[i],B.EV))&&(B.GN=i,ie(i),ne.1i(i));1k(i=B.X;i<=B.A1;i++)-1===ZC.AT(ne,i)&&(B.GN=i,ie(i))}1t 1k(B.GN=0,ie(B.X),B.GN=B.A1-B.X,ie(B.A1),-1!==(f=ZC.AT(B.W,0))&&ZC.2q(B.o["4k-d9"])&&(B.GN=f,ie(f)),B.GN=1,i=B.X+1;i<B.A1;i++)i%M==0&&ie(i)}if(B.M.AL&&B.M.AP&&""!==B.M.AP){(g=1n ZC.DQ(B)).1Q(B.M),g.K=B.A.K+"-"+B.BB.1E(/\\-/g,"1b")+"-lv",g.GG=B.K+"-1G "+B.A.K+"-1z-1G zc-1z-1G",g.AP=B.M.AP,g.Z=B.H.2L()?B.H.mc():ZC.AK(B.A.K+"-3w-ml-0-c"),g.IE=B.H.2L()?ZC.AK(B.H.K+"-3X"):ZC.AK(B.H.K+"-1D"),g.1q(),"5n"!==B.M.o["2p-1r"]&&"5n"!==B.M.o.1r||-1===v||(g.BZ=v);1a ae=B.iX+(B.AR?B.BV:B.A6),le=B.I-B.A6-B.BV;1P("aL"===g.o["3E-fO"]&&(ae=B.A.iX,le=B.A.I),g.O3){1j"1J":g.iX=ae;1p;1j"3E":g.iX=ae+le/2-g.I/2;1p;1j"2x":g.iX=ae+le-g.I}g.iY=D?a+N+G:a-G-g.F-N,B.M.iX=g.iX,B.M.iY=g.iY,g.AL&&(B.MT(g,1c,"h"),g.1v(),g.EH(),1c===ZC.1d(g.o.2C)&&g.K3||z.1i(ZC.AO.NZ(B.A.K,g)))}z.1h>0&&ZC.AK(B.A.A.K+"-2Z")&&(ZC.AK(B.A.A.K+"-2Z").4n+=z.2I(""))}}}}}),ZC.XU=ZC.h0.C7({$i:1f(e){1g.b(e);1a t=1g;t.N9="",t.KP=1,t.GT=1,t.GF=0,t.G7=0,t.JI=.6},1q:1f(){1a e=1g;e.b(),e.iX+=e.DZ,e.iY+=e.E2,e.I-=e.DZ+e.E3,e.F-=e.E2+e.DN,e.ZA("3t","N9"),1c!==ZC.1d(e.o["2b-7b"])&&(e.JI=ZC.1W(ZC.8C(e.o["2b-7b"])))},7j:1f(e){1a t=1g;t.b(e),0===t.W.1h&&(t.W=[""]);1a i=ZC.AN.g5(t.N9,t.W.1h,!1);t.KP=i[0],t.GT=i[1],t.GF=t.I/t.GT,t.G7=t.F/t.KP},gX:1f(){1a e=1g;e.b(),e.GF=e.I/e.GT,e.G7=e.F/e.KP},3v:1f(){},8e:1f(){1g.b()},1v:1f(){1a e,t,i,n,a,l=1g;if(l.AL){if(l.b(),e=ZC.P.E6(l.H.2L()?l.H.K+"-3X-c":l.A.K+"-3w-ml-0-c",l.H.AB),t=ZC.P.E6(l.H.2L()?l.H.K+"-3X-c":l.A.K+"-3w-bl-0-c",l.H.AB),(i=[]).1i([l.iX,l.iY],[l.iX+l.I,l.iY],[l.iX+l.I,l.iY+l.F],[l.iX,l.iY+l.F],[l.iX,l.iY]),ZC.CN.1v(e,l,i),l.D5.AL){if(l.D5.o.2z&&l.D5.o.2z.1h>0)1k(n=0,a=l.W.1h;n<a;n++){1a o=n%l.GT,r=1A.4i(n/l.GT),C=1n ZC.HQ(l),A=n%l.D5.o.2z.1h;C.o=l.D5.o.2z[A],C.K=l.K+"-2g-"+n,C.Z=l.H.2L()?l.H.mc():ZC.AK(l.A.K+"-3w-bl-0-c"),C.1q(),C.iX=l.iX+o*l.GF,C.iY=l.iY+r*l.G7,C.I=l.GF,C.F=l.G7,C.1v()}if(l.D5.AY>0){1k(i=[],n=0;n<=l.GT;n++)i.1i([l.iX+n*l.GF,l.iY],[l.iX+n*l.GF,l.iY+l.F],1c);1k(n=0;n<=l.KP;n++)i.1i([l.iX,l.iY+n*l.G7],[l.iX+l.I,l.iY+n*l.G7],1c);ZC.CN.1v(t,l.D5,i)}}1a s,Z=[];if(l.BQ.AL){1k(n=0,a=l.W.1h;n<a;n++)!1f(e){(l.BQ.E4.1h>0||0===e)&&(s=1n ZC.DQ(l)),s.1Q(l.BQ);1a t=e%l.GT,i=1A.4i(e/l.GT);s.GG=l.K+"-1N "+l.A.K+"-1z-1N zc-1z-1N",s.K=l.A.K+"-"+l.BB.1E(/\\-/g,"1b")+"-7E"+e;1a n=l.G0(e);if((1c===ZC.1d(l.LP)||-1!==ZC.AT(l.LP,n))&&(s.AP=n,s.Z=l.H.2L()?l.H.mc():ZC.AK(l.A.K+"-3w-ml-0-c"),s.1q(),s.JC=1f(t){1m t=t.1E(/%i/g,e),t=t.1E(/%v/g,1c!==ZC.1d(l.W[e])?l.W[e]:""),t=t.1E(/%l/g,1c!==ZC.1d(l.BW[e])?l.BW[e]:"")},s.E4=l.BQ.E4,s.DD()&&s.1q(),s.AL)){1a a="2a";1c!==ZC.1d(l.BQ.o[ZC.1b[7]])&&(a=l.BQ.o[ZC.1b[7]]);1a o=l.iX+t*l.GF,r=l.iY+i*l.G7;1P(a){1j"1u-1J":s.iX=o,s.iY=r;1p;1j"1u-2x":s.iX=o+l.GF-s.I,s.iY=r;1p;1j"2a-1J":s.iX=o,s.iY=r+l.G7-s.F;1p;1j"2a-2x":s.iX=o+l.GF-s.I,s.iY=r+l.G7-s.F;1p;1j"1u":s.iX=o+l.GF/2-s.I/2,s.iY=r;1p;1j"2x":s.iX=o+l.GF-s.I,s.iY=r+l.G7/2-s.F/2;1p;1j"1J":s.iX=o,s.iY=r+l.G7/2-s.F/2;1p;2n:s.iX=o+l.GF/2-s.I/2,s.iY=r+l.G7-s.F}s.1v(),s.EH(),1c===ZC.1d(l.o.2C)&&s.K3||Z.1i(ZC.AO.NZ(l.A.K,s))}}(n);Z.1h>0&&ZC.AK(l.A.A.K+"-2Z")&&(ZC.AK(l.A.A.K+"-2Z").4n+=Z.2I(""))}}}}),ZC.tq=ZC.h0.C7({$i:1f(e){1g.b(e);1a t=1g;t.DM=0,t.EM=2j},1q:1f(){1a e,t=1g;t.b(),1c!==ZC.1d(e=t.o["3N-2c"])&&(t.DM=ZC.1l(e)%2j),1c!==ZC.1d(e=t.o.h1)&&(t.EM=ZC.1l(e)%2j,0===t.EM&&(t.EM=2j))}}),ZC.yn=ZC.ZB.C7({$i:1f(e){1g.b(e)},1q:1f(){1g.b()},IW:1f(){},7j:1f(e){1a t=1g;t.b(e),t.IW()},3v:1f(){1g.b()},8e:1f(){1g.b()},1v:1f(){1g.b()}}),ZC.ym=ZC.yn.C7({$i:1f(e){1g.b(e);1a t=1g;t.DM=-90,t.EM=180,t.Q1=1c,t.IO=1c,t.CS="3x"},1q:1f(){1a e,t=1g;t.b(),1c!==ZC.1d(e=t.o["3N-2c"])&&(t.DM=ZC.1l(e)%2j),1c!==ZC.1d(e=t.o.h1)&&(t.EM=ZC.1l(e)),1c!==ZC.1d(e=t.o.3E)&&(t.Q1=1n ZC.DS(t),t.Q1.1C(e),t.Q1.1q()),1c!==ZC.1d(e=t.o.9k)&&(t.IO=1n ZC.DS(t),t.H.B9.2t(t.IO.o,[t.A.AF+"."+t.BB+".9k"]),t.IO.1C(e),t.IO.1q())},7j:1f(e){1g.b(e)},3v:1f(){},8e:1f(){1g.b()},B2:1f(e){1a t=1g,i=t.A.BL("1z"),n=i.iX+i.I/2,a=i.iY+i.F/2,l=t.A.BL("1z-"+t.L);l||(l=t.A.BL("1z"));1a o=ZC.CV(l.GF/2,l.G7/2)*l.JI,r=t.BS-t.B8,C=t.EM/r;1m ZC.AN.BM(n,a,o,t.DM-t.EM/2+C*(e-t.B8))},I3:1f(e){1a t=1g;1m t.B2(t.W[e])},zk:1f(e){1a t,i=1g;if(e.F4){1a n=i.A.BL("1z-"+i.L);n||(n=i.A.BL("1z"));1a a;if(e.AL){1a l=i.A.K+"-3w-"+("1u"===e.B7?"f":"b")+"l-0-c";e.Z=e.C5=ZC.AK(i.H.2L()?n.H.K+"-3X-c":l),a=ZC.P.E6(e.Z,i.H.AB);1a o=ZC.CV(n.GF/2,n.G7/2)*n.JI,r=ZC.IB(e.o["1Y-46"]||"0");r>0&&r<1&&(r*=o);1a C=ZC.IB(e.o["1Y-6n"]||"0");C>0&&C<1&&(C*=o),e.M&&(e.M.Z=i.H.2L()?i.H.mc():ZC.AK(i.A.K+"-3w-ml-0-c"),e.M.K=e.A.A.K+"-"+e.A.BB.1E(/\\-/g,"1b")+"-aH"+e.L,e.M.GG=e.A.K+"-1O-1G "+e.A.A.K+"-1z-1O-1G zc-1z-1O-1G");1k(1a A=0;A<n.W.1h;A++){1a s,Z=A%n.GT,c=1A.4i(A/n.GT),u=n.iX+Z*n.GF+n.GF/2+n.BJ,p=n.iY+c*n.G7+n.G7/2+n.BD;1P(e.AF){1j"1y":if(e.F4.1h>0){1a h=i.DM-i.EM/2+i.EM*(e.F4[0]-i.B8)/(i.BS-i.B8);s=h;1a 1b=[];1b.1i(ZC.AN.BM(u,p,r,h)),1b.1i(ZC.AN.BM(u,p,o-C,h)),2===1b.1h&&(ZC.CN.2E(a,e),ZC.CN.1v(a,e,1b))}1p;1j"1M":if(e.F4.1h>1){1a d=i.DM-i.EM/2+i.EM*(e.F4[0]-i.B8)/(i.BS-i.B8),f=i.DM-i.EM/2+i.EM*(e.F4[1]-i.B8)/(i.BS-i.B8);s=(d+f)/2;1a g=1n ZC.DS(e);g.Z=e.Z,g.1C(e.o),g.1C({2b:o-C,7y:r,1I:"3L","2c-46":d,"2c-6n":f}),g.K=n.K+"-1O-"+e.L,g.iX=u,g.iY=p,g.1q(),g.1v()}}if(e.M){1a B;1c!==ZC.1d(t=e.M.o["1Y-r"])?B=ZC.1W(ZC.8C(t)):B<1?B*=o-C-r:B=0;1a v=ZC.AN.BM(u,p,(o-C-r)/2+B,s);e.M.iX=v[0]-e.M.I/2,e.M.iY=v[1]-e.M.F/2,e.M.1v()}}}}},1v:1f(){1f e(e){1m e=e.1E(/%i/g,i),e=e.1E(/%k/g,i),e=e.1E(/%v/g,1c!==ZC.1d(s.W[i])?s.W[i]:""),e=e.1E(/%l/g,1c!==ZC.1d(s.BW[i])?s.BW[i]:"")}1a t,i,n,a,l,o,r,C,A,s=1g;if(s.AL&&0!==s.W.1h){s.AR&&s.W.9m(),t=ZC.P.E6(s.H.2L()?s.H.K+"-3X-c":s.A.K+"-3w-bl-0-c",s.H.AB);1a Z=ZC.1l(s.IK.o[ZC.1b[21]]||8),c=ZC.1l(s.I2.o[ZC.1b[21]]||4),u=0,p=ZC.BN(1,1A.4h((s.A1-s.X)/(s.LX-1))),h=ZC.BN(1,1A.4h((s.A1-s.X)/(s.EE-1))),1b=s.A.BL("1z-"+s.L);1b||(1b=s.A.BL("1z"));1k(1a d,f,g,B=ZC.CV(1b.GF/2,1b.G7/2)*1b.JI,v=s.EM/(s.W.1h-1),b=0;b<1b.W.1h;b++){1a E=b%1b.GT,m=1A.4i(b/1b.GT),K=1b.iX+E*1b.GF+1b.GF/2+1b.BJ,F=1b.iY+m*1b.G7+1b.G7/2+1b.BD,D=1n ZC.DS(s);if(D.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),D.1Q(s),D.K=s.K+"-"+b,D.iX=K,D.iY=F,D.AH=B-.5,D.DP=2j===s.EM?"3x":"3L",D.B1=s.DM-s.EM/2+2j,D.BH=s.DM+s.EM/2+2j,D.CK=0,D.1q(),D.1v(),s.D5.AL){if(s.D5.o.2z&&s.D5.o.2z.1h>0)1k(i=0;i<s.W.1h-1;i++)D=1n ZC.DS(s),r=i%s.D5.o.2z.1h,D.1C(s.D5.o.2z[r]),D.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),D.iX=K,D.iY=F,D.K=s.K+"-3L-"+i,D.o.1I="3L",D.o[ZC.1b[21]]=B-s.BV,D.CK=s.A6,D.B1=s.DM-s.EM/2+i*v+2j,D.BH=s.DM-s.EM/2+(i+1)*v+2j,D.1q(),D.1v();if(s.D5.AY>0)1k(i=0,n=s.W.1h;i<n;i++)(d=1n ZC.CZ(s)).1Q(s.D5),d.JC=e,d.E4=s.D5.E4,d.DD()&&d.1q(),(o=[]).1i(ZC.AN.BM(K,F,B-s.BV,s.DM-s.EM/2+i*v)),o.1i(ZC.AN.BM(K,F,s.A6,s.DM-s.EM/2+i*v)),ZC.CN.1v(t,d,o)}if(s.FY.AL&&s.FY.AY>0&&s.GQ>0)1k(i=0,n=s.W.1h;i<n-1;i++)1k(C=s.DM-s.EM/2+i*v,f=v/(s.GQ+1),g=1;g<=s.GQ;g++)(d=1n ZC.CZ(s)).1Q(s.FY),d.JC=e,d.E4=s.FY.E4,d.DD()&&d.1q(),(o=[]).1i(ZC.AN.BM(K,F,B-s.BV,s.DM-s.EM/2+i*v+g*f)),o.1i(ZC.AN.BM(K,F,s.A6,s.DM-s.EM/2+i*v+g*f)),ZC.CN.1v(t,d,o);if(s.XC(),s.H.ZK(),s.IO&&((l=1n ZC.DS(s)).1C(s.IO.o),l.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),l.K=s.K+"-9k",l.iX=K,l.iY=F,2j!==s.EM?(l.o.1I="3L",a=ZC.1l(l.o[ZC.1b[21]]),a=ZC.BN(1,ZC.CV(a,B)),l.CK=B-a,l.o[ZC.1b[21]]=B,l.B1=s.DM-s.EM/2+2j,l.BH=s.DM+s.EM/2+2j):(l.o.1I="3x",a=ZC.1l(l.o[ZC.1b[21]]),a=ZC.BN(1,ZC.CV(a,B)),l.o[ZC.1b[21]]=B),l.1q(),l.AL&&a+l.AQ>0&&(l.1v(),2j===s.EM&&(l.K=s.K+"-9k-5N",l.o[ZC.1b[21]]=B-a,l.1q(),l.1v())),s.IO.o.2z&&s.IO.o.2z.1h>0||s.IO.o.ac))1k(i=0;i<s.W.1h-1;i++)(l=1n ZC.DS(s)).1C(s.IO.o),s.IO.o.2z&&(r=i%s.IO.o.2z.1h,l.1C(s.IO.o.2z[r])),l.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),l.K=s.K+"-9k-"+i,l.iX=K,l.iY=F,l.o.1I="3L",a=ZC.1l(l.o[ZC.1b[21]]),a=ZC.BN(0,ZC.CV(a,B)),l.CK=B-a,l.o[ZC.1b[21]]=B,l.B1=s.DM-s.EM/2+i*v+2j,l.BH=s.DM-s.EM/2+(i+1)*v+2j+.25,l.1q(),l.JC=e,l.E4=s.IO.E4,l.DD()&&l.1q(),l.AL&&a+l.AQ>0&&l.1v();if(s.IK.AL){1P(s.IK.o[ZC.1b[7]]){1j"77":u+=Z;1p;2n:u+=Z/2}1k(o=[],i=0,n=s.W.1h;i<n;i++)if(i===s.X||i===s.A1||i%p==0){1P(C=s.DM-s.EM/2+i*v,A=[0,0],s.IK.o[ZC.1b[7]]){1j"5N":A=[-Z,0];1p;1j"77":A=[0,Z];1p;2n:A=[-Z/2,Z/2]}o.1i(ZC.AN.BM(K,F,B+A[0],C),ZC.AN.BM(K,F,B+A[1],C),1c)}ZC.CN.1v(t,s.IK,o)}if(s.I2.AL&&s.GQ>0){1k(o=[],i=0,n=s.W.1h;i<n-1;i++)1k(C=s.DM-s.EM/2+i*v,f=v/(s.GQ+1),g=1;g<=s.GQ;g++){1P(A=[0,0],s.I2.o[ZC.1b[7]]){1j"5N":A=[-c,0];1p;1j"77":A=[0,c];1p;2n:A=[-c/2,c/2]}o.1i(ZC.AN.BM(K,F,B+A[0],C+g*f),ZC.AN.BM(K,F,B+A[1],C+g*f),1c)}ZC.CN.1v(t,s.I2,o)}if(s.BQ.AL){1a I=[];1k(i=0,n=s.W.1h;i<n;i++)if(i===s.X||i===s.A1||i%h==0){1a X=1n ZC.DQ(s);X.1C(s.BQ.o),X.GG=s.K+"-1N "+s.A.K+"-1z-1N zc-1z-1N",X.K=s.A.K+"-"+s.BB.1E(/\\-/g,"1b")+"-7E"+b+"1b"+i;1a x=s.G0(i);if(X.AP=x,X.Z=X.C5=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-ml-0-c"),X.1q(),"3e"===X.o.2c&&(X.AA=s.DM-s.EM/2+i*v+90),X.JC=e,X.E4=s.BQ.E4,X.DD()&&X.1q(),X.AL){X.F=X.KI;1a y,L=1.15*1A.5B(X.I*X.I/4+X.F*X.F/4);1P(s.BQ.o[ZC.1b[7]]){1j"5N":y=ZC.AN.BM(K,F,B+s.BQ.DR-L-5+u,s.DM-s.EM/2+i*v);1p;2n:y=ZC.AN.BM(K,F,B+s.BQ.DR+L+u,s.DM-s.EM/2+i*v)}X.iX=y[0]-X.I/2,X.iY=y[1]-X.F/2,X.1v(),X.EH(),1c===ZC.1d(s.o.2C)&&X.K3||(1c!==ZC.1d(s.o.2C)&&(s.o.2C.1D=s.o.2C.1D||"%1z-1S"),I.1i(ZC.AO.NZ(s.A.K,X)))}}I.1h>0&&ZC.AK(s.A.A.K+"-2Z")&&(ZC.AK(s.A.A.K+"-2Z").4n+=I.2I(""))}}}},6E:1f(){1a e=1g,t=e.A.BL("1z-"+e.L);t||(t=e.A.BL("1z"));1k(1a i=0;i<t.W.1h;i++){1a n=i%t.GT,a=1A.4i(i/t.GT),l=t.iX+n*t.GF+t.GF/2+t.BJ,o=t.iY+a*t.G7+t.G7/2+t.BD;if(e.Q1){1a r=1n ZC.DS(e);r.1C(e.Q1.o),r.Z=r.C5=e.H.2L()?e.H.mc("1u"):ZC.AK(e.A.K+"-3w-ml-0-c"),r.K=e.K+"-"+i+"-3E",r.iX=l,r.iY=o,r.o.1I=r.o.1I||"3x",r.1q(),r.AL&&r.1v()}}}}),ZC.yg=ZC.tq.C7({$i:1f(e){1g.b(e);1a t=1g;t.DM=0,t.CS="ys",t.DK=!1},1q:1f(){1a e=1g;e.b(),e.4y([["7e","CS"],["3N-2c","DM","i"],["yu","DK","b"]])},er:1f(){1a e=1g,t=ZC.BN(e.W.1h,e.BW.1h);e.EE=ZC.CV(30,t)},7j:1f(e){1g.b(e)},3v:1f(){},8e:1f(){1g.b()},lK:1f(e,t){1a i=1g,n=i.A.BL("1z"),a=n.iX+n.I/2,l=n.iY+n.F/2,o=i.EM/(i.W.1h-(2j===i.EM||i.DK?0:1)),r=i.A.BL(ZC.1b[52]);1m ZC.AN.BM(a,l,t+r.A6,i.DM+e*o)},I3:1f(e){1a t=1g,i=t.A.BL("1z"),n=ZC.CV(i.I/2,i.F/2)*i.JI;1m t.lK(e,n)},B2:1f(e){1a t=1g,i=ZC.AT(t.W,e);-1===i&&(i=0);1a n=t.A.BL("1z"),a=ZC.CV(n.I/2,n.F/2)*n.JI;1m t.lK(i,a)},1v:1f(){1a e,t,i,n,a,l,o,r,C=1g;if(C.AL&&0!==C.W.1h){C.b();1a A=ZC.BN(1,1A.4i((C.A1-C.X)/(C.LX-1))),s=ZC.BN(1,1A.4i((C.A1-C.X)/(C.EE-1)));e=ZC.P.E6(C.H.2L()?C.H.K+"-3X-c":C.A.K+"-3w-ml-0-c",C.H.AB),t=ZC.P.E6(C.H.2L()?C.H.K+"-3X-c":C.A.K+"-3w-bl-0-c",C.H.AB);1a Z=ZC.1l(C.IK.o[ZC.1b[21]]||8),c=0,u=C.A.BL("1z"),p=ZC.CV(u.I/2,u.F/2)*u.JI,h=C.A.BL(ZC.1b[52]),1b=u.iX+u.I/2,d=u.iY+u.F/2,f=C.EM/(C.W.1h-(2j===C.EM||C.DK?0:1));if(C.D5.AL){if(C.D5.o.2z&&C.D5.o.2z.1h>0){1a g=0;1k(i=0,n=C.W.1h-(2j===C.EM||C.DK?0:1);i<n;i+=A){if(r=C.DM+i*f,"3x"===C.CS){1a B=1n ZC.DS(C);a=g%C.D5.o.2z.1h,B.1C(C.D5.o.2z[a]),B.Z=C.H.2L()?C.H.mc():ZC.AK(C.A.K+"-3w-bl-0-c"),B.iX=1b,B.iY=d,B.o.1I="3L",B.o[ZC.1b[21]]=p,B.CK=h.A6,B.B1=r,B.BH=r+A*f,B.1q(),B.1v()}1t{1a v=1n ZC.DS(C);a=g%C.D5.o.2z.1h,v.o=C.D5.o.2z[a],v.Z=C.H.2L()?C.H.mc():ZC.AK(C.A.K+"-3w-bl-0-c"),v.AY=0,v.AQ=0,v.EW=0,v.G4=0,(l=[]).1i(ZC.AN.BM(1b,d,h.A6,r),ZC.AN.BM(1b,d,p,r),ZC.AN.BM(1b,d,p,r+A*f),ZC.AN.BM(1b,d,h.A6,r+A*f)),v.D=l,v.1q();1a b=C.A.Q;v.CY=[b.iX,b.iY,b.iX+b.I,b.iY+b.F],v.1v()}g++}}if(C.D5.AY>0)1k(i=0,n=C.W.1h+(C.DK?1:0);i<n;i+=A)r=C.DM+i*f,(o=1n ZC.CZ(C)).1Q(C.D5),o.K=C.K+"-2g-"+i,o.JC=1f(e){1m e=e.1E(/(%i)|(%1z-2V)/g,i),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(C.W[i])?C.W[i]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(C.BW[i])?C.BW[i]:"")},o.E4=C.D5.E4,o.DD()&&o.1q(),(l=[]).1i(ZC.AN.BM(1b,d,p,r),ZC.AN.BM(1b,d,h.A6,r)),ZC.CN.1v(t,o,l)}if(C.IK.AL){1P(C.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":c+=Z;1p;2n:c+=Z/2}1k(l=[],i=0,n=C.W.1h+(C.DK?1:0);i<n;i+=A){1P(r=C.DM+i*f,(o=1n ZC.CZ(C)).1Q(C.IK),o.o[ZC.1b[7]]){1j"5N":l=[ZC.AN.BM(1b,d,p-Z,r),ZC.AN.BM(1b,d,p,r)];1p;1j"77":l=[ZC.AN.BM(1b,d,p,r),ZC.AN.BM(1b,d,p+Z,r)];1p;2n:l=[ZC.AN.BM(1b,d,p-Z/2,r),ZC.AN.BM(1b,d,p+Z/2,r)]}1k(1a E=ZC.1l(o.o["1Y-x"]||"0"),m=ZC.1l(o.o["1Y-y"]||"0"),K=0;K<l.1h;K++)l[K]&&(l[K][0]+=E,l[K][1]+=m);o.K=C.K+"-3W-"+i,ZC.CN.1v(e,o,l)}}1a F,D,I=[];if(C.BQ.AL){1k(i=0,n=C.W.1h;i<n;i+=s)!1f(e){(C.BQ.E4.1h>0||0===e)&&(F=1n ZC.DQ(C)),F.1Q(C.BQ),F.GG=C.K+"-1N "+C.A.K+"-1z-1N zc-1z-1N",F.K=C.A.K+"-"+C.BB.1E(/\\-/g,"1b")+"-7E"+e;1a t=C.G0(e);if(1c===ZC.1d(C.LP)||-1!==ZC.AT(C.LP,t)){F.AP=t,F.Z=F.C5=C.H.2L()?C.H.mc():ZC.AK(C.A.K+"-3w-ml-0-c"),F.1q(),F.JC=1f(t){1m t=t.1E(/(%i)|(%1z-2V)/g,e),t=t.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(C.W[e])?C.W[e]:""),t=t.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(C.BW[e])?C.BW[e]:"")},F.E4=C.BQ.E4,F.DD()&&F.1q();1a i=ZC.IB(F.DR,!0);if(i>-1&&i<1&&(i*=p),r=C.DM+e*f+(C.DK?f/2:0),C.BQ.o["3e-3s"]){1a n=1.25;1-ZC.2i(ZC.ED(r))>.7&&(n=2.5*(1-ZC.2i(ZC.ED(r))));1a a=(1-ZC.2i(ZC.ED(r)))*F.DG*n;D=ZC.AN.BM(1b,d,p+i+c+a,r),ZC.ED(r)>0?(F.iX=D[0],F.iY=D[1]-F.F/2):(F.iX=D[0]-F.I,F.iY=D[1]-F.F/2)}1t C.BQ.o["3e-gb"]?(D=ZC.AN.BM(1b,d,p+i+c+F.F/2,r),F.iX=D[0]-F.I/2,F.iY=D[1]-F.F/2,F.AA=r+90):(D=ZC.AN.BM(1b,d,p+i+c+ZC.2i(10*ZC.EL(r))+ZC.2i(F.I/2*ZC.ED(r)),r),F.iX=D[0]-F.I/2,F.iY=D[1]-F.F/2);F.AL&&(F.1v(),F.EH(),1c===ZC.1d(C.o.2C)&&F.K3||(1c!==ZC.1d(C.o.2C)&&(C.o.2C.1D=C.o.2C.1D||"%1z-1S"),I.1i(ZC.AO.NZ(C.A.K,F))))}}(i);I.1h>0&&ZC.AK(C.A.A.K+"-2Z")&&(ZC.AK(C.A.A.K+"-2Z").4n+=I.2I(""))}}}}),ZC.yv=ZC.ZB.C7({$i:1f(e){1g.b(e)},1q:1f(){1g.b()},IW:1f(){1a e=1g,t=e.A.BL("1z"),i=ZC.CV(t.I/2,t.F/2)*t.JI;e.A9=(i-e.A6-e.BV)/(e.A1-e.X)},7j:1f(e){1a t=1g;t.b(e),t.IW()},er:1f(){1a e=1g,t=e.A.BL("1z"),i=ZC.CV(t.I/2,t.F/2)*t.JI;e.EE=ZC.BN(2,ZC.1l((i-e.A6-e.BV)/20))},TY:1f(e){1a t=1g,i=t.A.BL("1z"),n=ZC.CV(i.I/2,i.F/2)*i.JI,a=t.BS-t.B8,l=(n-t.A6-t.BV)/a;1m(e-t.B8)*l},B2:1f(e){1a t=1g,i=t.TY(e),n=t.A.BL("1z-k"),a=t.A.BL("1z"),l=a.iX+a.I/2+a.BJ,o=a.iY+a.F/2+a.BD;1m ZC.AN.BM(l,o,i,n.DM)},3v:1f(){},8e:1f(){1g.b()},1v:1f(){1f e(e){1m e=e.1E(/(%i)|(%1z-2V)/g,l),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(s.W[l])?s.W[l]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(s.BW[l])?s.BW[l]:"")}1f t(e){1m e=e.1E(/(%c)|(%1z-2G)/g,s.GN),e=e.1E(/(%i)|(%1z-2V)/g,s.JX),e=e.1E(/(%v)|(%1z-1S)/g,1c!==ZC.1d(s.W[s.JX])?s.W[s.JX]:""),e=e.1E(/(%l)|(%1z-1G)/g,1c!==ZC.1d(s.BW[s.JX])?s.BW[s.JX]:"")}1f i(e){s.JX=e,(y=1n ZC.DQ(s)).1Q(s.BQ),y.K=s.A.K+"-"+s.BB.1E(/\\-/g,"1b")+"-7E"+e,y.GG=s.K+"-1N "+s.A.K+"-1z-1N zc-1z-1N";1a i=s.G0(e);if(y.AP=i,1c===ZC.1d(s.LP)||-1!==ZC.AT(s.LP,i)){y.Z=y.C5=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-fl-0-c"),y.1q(),y.JC=t,y.DD()&&y.1q();1a n=ZC.AN.BM(d,f,s.A6+e*s.A9,Z.DM);1P(y.F=y.KI,y.I=y.NF,Z.DM%180==0?(y.iX=n[0]-y.I/2,y.iY=n[1]):(y.iX=n[0],y.iY=n[1]-y.F/2),s.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":Z.DM%180==0?y.iY+=c:y.iX+=c;1p;2n:Z.DM%180==0?y.iY+=c/2:y.iX+=c/2}y.AL&&(y.1v(),y.EH(),1c===ZC.1d(s.o.2C)&&y.K3||(1c!==ZC.1d(s.o.2C)&&(s.o.2C.1D=s.o.2C.1D||"%1z-1S"),L.1i(ZC.AO.NZ(s.A.K,y))))}}1a n,a,l,o,r,C,A,s=1g;if(s.AL&&0!==s.W.1h){s.b(),n=ZC.P.E6(s.H.2L()?s.H.K+"-3X-c":s.A.K+"-3w-ml-0-c",s.H.AB),a=ZC.P.E6(s.H.2L()?s.H.K+"-3X-c":s.A.K+"-3w-bl-0-c",s.H.AB);1a Z=s.A.BL("1z-k"),c=ZC.1l(s.IK.o[ZC.1b[21]]||8),u=1A.4h((s.A1-s.X)/(s.EE-1)),p=1A.4h((s.A1-s.X)/(s.LX-1)),h=s.A.BL("1z"),1b=ZC.CV(h.I/2,h.F/2)*h.JI,d=h.iX+h.I/2+h.BJ,f=h.iY+h.F/2+h.BD,g=Z.EM/(Z.W.1h-(2j===Z.EM||Z.DK?0:1));if(s.D5.AL){if(s.D5.o.2z&&s.D5.o.2z.1h>0)1k(l=0,o=s.W.1h;l<o-1;l++){1a B=l%s.D5.o.2z.1h;if("3x"===Z.CS){1a v=1n ZC.DS(s);v.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),v.1C(s.D5.o.2z[B]),v.o.1I="3L",v.o[ZC.1b[21]]=s.A6+(l+1)*s.A9,v.iX=d,v.iY=f,v.CK=s.A6+l*s.A9,2j===Z.EM?(v.B1=0,v.BH=2j):(v.B1=Z.DM,v.BH=Z.DM+Z.EM),v.1q(),v.1v()}1t{1a b=1n ZC.DS(s);1k(b.1C(s.D5.o.2z[B]),b.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),A=[],r=0,C=Z.W.1h;r<C;r++)A.1i(ZC.AN.BM(d,f,s.A6+l*s.A9,Z.DM+r*g));1k(2j===Z.EM&&A.1i(ZC.AN.BM(d,f,s.A6+l*s.A9,Z.DM),ZC.AN.BM(d,f,s.A6+(l+1)*s.A9,Z.DM)),r=Z.W.1h-1;r>=0;r--)A.1i(ZC.AN.BM(d,f,s.A6+(l+1)*s.A9,Z.DM+r*g));b.D=A,b.1q(),b.AY=0,b.AQ=0,b.EW=0,b.G4=0;1a E=s.A.Q;b.CY=[E.iX,E.iY,E.iX+E.I,E.iY+E.F],b.1v()}}if(s.D5.AY>0)1k(l=0,o=s.W.1h;l<o;l++)if(l===s.X||l===s.A1||l%p==0)if("3x"===Z.CS){1a m=1n ZC.DS(s);m.Z=s.H.2L()?s.H.mc():ZC.AK(s.A.K+"-3w-bl-0-c"),m.1C(s.D5.o);1a K=Z.EM;2j===K&&(K=178),m.1C({1I:"6y",2b:s.A6+l*s.A9,bD:Z.DM-.25,a2:Z.DM+K+.25}),m.K=s.K+"-2g-"+l,m.iX=d,m.iY=f,m.1q(),m.JC=e,m.E4=s.D5.E4,m.DD()&&m.1q(),m.1v()}1t{1a F=1n ZC.CZ(s);1k(F.1Q(s.D5),F.K=s.K+"-2g-"+l,F.JC=e,F.E4=s.D5.E4,F.DD()&&F.1q(),A=[],r=0,C=Z.W.1h-(2j===Z.EM||Z.DK?0:1);r<C;r++)A.1i(ZC.AN.BM(d,f,s.A6+l*s.A9,Z.DM+r*g),ZC.AN.BM(d,f,s.A6+l*s.A9,Z.DM+(r+1)*g));ZC.CN.1v(a,F,A)}}if(s.OX.AL&&s.OX.AY>0&&((A=[]).1i(ZC.AN.BM(d,f,s.A6,Z.DM),ZC.AN.BM(d,f,1b-s.BV,Z.DM)),ZC.CN.1v(n,s.OX,A)),s.IK.AL){1P(s.IK.o[ZC.1b[7]]){1j"5N":1p;1j"77":c;1p;2n:c/2}1k(A=[],l=0,o=s.W.1h;l<o;l++)if(l===s.X||l===s.A1||l%p==0){1a D=ZC.AN.BM(d,f,s.A6+l*s.A9,Z.DM);1P(s.IK.o[ZC.1b[7]]){1j"5N":A.1i([D[0],D[1]]),Z.DM%180==0?A.1i([D[0],D[1]-c]):A.1i([D[0]-c,D[1]]),A.1i(1c);1p;1j"77":A.1i([D[0],D[1]]),Z.DM%180==0?A.1i([D[0],D[1]+c]):A.1i([D[0]+c,D[1]]),A.1i(1c);1p;2n:Z.DM%180==0?A.1i([D[0],D[1]-c/2],[D[0],D[1]+c/2]):A.1i([D[0]-c/2,D[1]],[D[0]+c/2,D[1]]),A.1i(1c)}}1k(1a I=ZC.1l(s.IK.o["1Y-x"]||"0"),X=ZC.1l(s.IK.o["1Y-y"]||"0"),x=0;x<A.1h;x++)A[x]&&(A[x][0]+=I,A[x][1]+=X);ZC.CN.1v(n,s.IK,A)}1a y,L;if(L=[],s.W.1h>0&&s.BQ.AL)1k(s.GN=0,i(s.X),s.GN=s.A1-s.X,i(s.A1),s.GN=1,l=s.X+1;l<s.A1;l++)l%u==0&&i(l);L.1h>0&&ZC.AK(s.A.A.K+"-2Z")&&(ZC.AK(s.A.A.K+"-2Z").4n+=L.2I(""))}}}),ZC.zy=ZC.DS.C7({$i:1f(e){1g.b(e);1a t=1g;t.C6=.95,t.L=0,t.AF=1c,t.M=1c,t.F4=1c,t.sH=!1,t.B7="2a",t.A6=0,t.BV=0,t.ME="5e",t.NY="5e",t.PJ=[5,5],t.n1=[0,0],t.Y8=""},1q:1f(){1g.b();1a e,t=1g;t.4y([["1I","AF"],["1S-5y","sH","b"],["1Y-46","A6","i"],["1Y-6n","BV","i"],[ZC.1b[7],"B7"],["176-1z","Y8"],["1G-6c","ME"],["1G-gG","NY"],["5y","F4"]]),1c===ZC.1d(t.o.2k)&&(t.o.2k="1M"===t.AF?.25:.95),1c!==ZC.1d(e=t.o["1G-a1"])&&("4g"==1w e&&e.1h?(t.PJ[0]=ZC.1l(e[0]||"5"),t.PJ[1]=ZC.1l(e[1]||"5")):t.PJ[0]=t.PJ[1]=ZC.1l(e||"5")),t.4y([["2k","C6","f",0,1]]),1c===ZC.1d(e=t.o.1G)&&1c===ZC.1d(t.o.1D)||(t.M=1n ZC.DQ(t),t.A.A.A.B9.2t(t.M.o,["("+t.A.AF+").4z.1O.1G"]),1c!==ZC.1d(t.o.1D)&&t.M.1C({1D:t.o.1D}),t.M.1C(e),t.M.1q(),t.n1=[t.M.BJ,t.M.BD])},1v:1f(){1a e=1g;if(e.F4)if(-1===e.A.BB.1K("1z-r")){1a t,i,n,a,l,o,r;if(e.AL){1a C=e.A,A=e.A.A.Q.AQ,s=C.A.K+"-3w-"+("1u"===e.B7?"f":"b")+"l-0-c";e.Z=e.C5=ZC.AK(C.H.2L()?C.H.K+"-3X-c":s),t=ZC.P.E6(e.Z,C.H.AB);1a Z,c,u,p;l=[];1a h,1b=0,d=0;e.BJ>-1&&e.BJ<1&&(e.BJ=1A.4h(e.BJ*C.A9)),e.BD>-1&&e.BD<1&&(e.BD=1A.4h(e.BD*C.A9)),e.M&&(e.M.Z=C.H.2L()?C.H.mc():ZC.AK(C.A.K+"-3w-ml-0-c"),e.M.K=e.A.A.K+"-"+e.A.BB.1E(/\\-/g,"1b")+"-aH"+e.L,e.M.GG=e.A.K+"-1O-1G "+e.A.A.K+"-1z-1O-1G zc-1z-1O-1G");1a f,g=1f(t,i){1a n;1m-1!==(i+"").1K("%")?(n=ZC.1W(i.1E("%","")),n="k"===t.AF?ZC.1l(n*(t.EF-t.E7)/100):n*(t.HF-t.GV)/100):n=i,e.sH||"v"===t.AF?t.B2(n):t.I3(n)};if("4x"===e.AF){1a B,v,b,E;1k(f=e.A.A,"k"===C.AF?(B=C,v=""===e.Y8?f.BT("v")[0]:f.BL(e.Y8)||f.BT("v")[0]):"v"===C.AF&&(v=C,B=""===e.Y8?f.BT("k")[0]:f.BL(e.Y8)||f.BT("k")[0]),o=0,r=e.F4.1h;o<r;o++)b=g(B,e.F4[o][0]),E=v.B2(e.F4[o][1]),l.1i([b,E]),1b+=b,d+=E;if(1b/=l.1h,d/=l.1h,l.1h>=3){if(l[0].2I("/")!==l[l.1h-1].2I("/")&&l.1i([l[0][0],l[0][1]]),C.A.AJ["3d"])1k(C.A.NW(),i=0,n=l.1h;i<n;i++)a=1n ZC.CF(C.A,l[i][0]-ZC.AM.E1,l[i][1]-ZC.AM.E0,ZC.AM.FQ),l[i][0]=a.E9[0],l[i][1]=a.E9[1];(h=1n ZC.DS(e.A)).K=C.K+"-1O-"+e.L,h.Z=h.C5=C.H.2L()?C.H.mc():ZC.AK(s),h.1Q(e),h.AY=0,h.AQ=0,h.EW=0,h.G4=0,h.D=l,h.1q(),h.1v()}}1t if("1y"===e.AF){if(-1!==C.BB.1K(ZC.1b[50])?1===e.F4.1h?Z=c=g(C,e.F4[0]):2===e.F4.1h&&(Z=g(C,e.F4[0]),c=g(C,e.F4[1])):-1!==C.BB.1K(ZC.1b[51])&&(1===e.F4.1h?Z=c=g(C,e.F4[0]):2===e.F4.1h&&(Z=g(C,e.F4[0]),c=g(C,e.F4[1]))),-1!==C.BB.1K(ZC.1b[50])&&C.D9||-1!==C.BB.1K(ZC.1b[51])&&!C.D9?(l.1i([C.iX+e.A6,Z],[C.iX+C.I-e.BV,c]),e.M&&("5u"===e.ME?e.M.iX=C.iX+C.I-e.M.I-e.BV:e.M.iX=C.iX+e.A6,"5u"===e.ME?e.M.iY=c-(C.AR?0:e.M.F):e.M.iY=Z-(C.AR?0:e.M.F))):(l.1i([Z,C.iY+C.F-e.A6],[c,C.iY+e.BV]),e.M&&("5u"===e.ME?e.M.iX=c-(C.AR?e.M.I:0):e.M.iX=Z-(C.AR?e.M.I:0),"5u"===e.ME?e.M.iY=C.iY+e.M.I-e.M.F+e.BV:e.M.iY=C.iY+C.F-e.M.F-e.A6)),C.A.AJ["3d"])1k(C.A.NW(),i=0,n=l.1h;i<n;i++)a=1n ZC.CF(C.A,l[i][0]-ZC.AM.E1,l[i][1]-ZC.AM.E0,ZC.AM.FQ),l[i][0]=a.E9[0],l[i][1]=a.E9[1];2===l.1h&&(ZC.CN.2E(t,e),ZC.CN.1v(t,e,l))}1t if("1M"===e.AF&&(-1!==C.BB.1K(ZC.1b[50])?2===e.F4.1h?(Z=u=g(C,e.F4[0]),c=p=g(C,e.F4[1])):4===e.F4.1h&&(Z=g(C,e.F4[0]),c=g(C,e.F4[1]),u=g(C,e.F4[2]),p=g(C,e.F4[3])):-1!==C.BB.1K(ZC.1b[51])&&(2===e.F4.1h?(Z=u=C.B2(e.F4[0]),c=p=C.B2(e.F4[1])):4===e.F4.1h&&(Z=C.B2(e.F4[0]),c=C.B2(e.F4[1]),u=C.B2(e.F4[2]),p=C.B2(e.F4[3]))),c=Z===c?c+1:c,p=u===p?p+1:p,-1!==C.BB.1K(ZC.1b[50])&&C.D9||-1!==C.BB.1K(ZC.1b[51])&&!C.D9?(l.1i([C.iX+A,Z],[C.iX+C.I-A,u],[C.iX+C.I-A,p],[C.iX+A,c],[C.iX+A,Z]),e.M&&("5u"===e.ME?e.M.iX=C.iX+C.I-e.M.I-e.BV:e.M.iX=C.iX+e.A6,"5u"===e.ME?e.M.iY=c-(C.AR?0:e.M.F):e.M.iY=Z-(C.AR?0:e.M.F))):(l.1i([Z,C.iY+C.F-A],[u,C.iY+A],[p,C.iY+A],[c,C.iY+C.F-A],[Z,C.iY+C.F-A]),e.M&&("5u"===e.ME?e.M.iX=c-(C.AR?e.M.I:0):e.M.iX=Z-(C.AR?e.M.I:0),"5u"===e.ME?e.M.iY=C.iY+e.M.I-e.M.F+e.BV:e.M.iY=C.iY+C.F-e.M.F-e.A6)),l.1h>=4)){if(C.A.AJ["3d"])1k(C.A.NW(),i=0,n=l.1h;i<n;i++)a=1n ZC.CF(C.A,l[i][0]-ZC.AM.E1,l[i][1]-ZC.AM.E0,ZC.AM.FQ),l[i][0]=a.E9[0],l[i][1]=a.E9[1];(h=1n ZC.DS(e.A)).K=C.K+"-1O-"+e.L,h.Z=h.C5=C.H.2L()?C.H.mc():ZC.AK(s),h.1Q(e),h.AY=0,h.AQ=0,h.EW=0,h.G4=0,h.D=l,h.1q(),h.BJ=e.BJ,h.BD=e.BD,h.1v()}1a m=!0,K=C.A.Q;2===l.1h&&(-1!==C.BB.1K(ZC.1b[50])&&C.D9||-1!==C.BB.1K(ZC.1b[51])&&!C.D9?ZC.DU(l[0][1],K.iY-2,K.iY+K.F+2)&&ZC.DU(l[1][1],K.iY-2,K.iY+K.F+2)||(m=!1):ZC.DU(l[0][0],K.iX-2,K.iX+K.I+2)&&ZC.DU(l[1][0],K.iX-2,K.iX+K.I+2)||(m=!1));1a F=e.NY;if(e.M&&m&&("4x"===e.AF?(e.M.iX=ZC.1l(1b-e.M.I/2),e.M.iY=ZC.1l(d-e.M.F/2)):("3e"===e.NY&&(F=-1!==C.BB.1K(ZC.1b[50])&&!C.D9||-1!==C.BB.1K(ZC.1b[51])&&C.D9?Z<C.iX+C.I/2?"5e":"5u":Z>C.iY+C.F/2?"5e":"5u"),e.M.BJ=e.M.BD=0,(-1!==C.BB.1K(ZC.1b[50])&&!C.D9||-1!==C.BB.1K(ZC.1b[51])&&C.D9)&&1c===ZC.1d(e.M.o.2c)&&(e.M.AA=3T),-1!==C.BB.1K(ZC.1b[50])&&!C.D9||-1!==C.BB.1K(ZC.1b[51])&&C.D9?(e.M.AA%180==90&&(e.M.BJ-=(C.AR?-1:1)*(e.M.I/2-e.M.F/2),e.M.BD-=e.M.I/2-e.M.F/2,"5u"===e.ME&&(e.M.BD=-e.M.I/2+e.M.F/2),"5u"===F&&(e.M.BJ-=e.M.F)),e.M.AA%180==0&&("5u"===e.ME&&(e.M.BD=-e.M.I+e.M.F),"5u"===F&&(e.M.BJ-=e.M.I))):(e.M.AA%180==90&&(e.M.BJ-=e.M.I/2-e.M.F/2,e.M.BD-=(C.AR?-1:1)*(e.M.I/2-e.M.F/2),"5u"===e.ME&&(e.M.BJ=e.M.I/2-e.M.F/2),"5u"===F&&(e.M.BD+=e.M.I)),e.M.AA%180==0&&"5u"===F&&(e.M.BD+=e.M.F)),e.M.BJ+=e.n1[0]+e.BJ,e.M.BD+=e.n1[1]+e.BD),C.A.AJ["3d"]&&(a=1n ZC.CF(C.A,e.M.iX-ZC.AM.E1,e.M.iY-ZC.AM.E0,ZC.AM.FQ),e.M.iX=a.E9[0],e.M.iY=a.E9[1]),ZC.DU(e.M.iX+e.M.BJ+(e.M.AA%180==0?e.M.I/2:e.M.F/2),e.A.A.Q.iX-e.PJ[0],e.A.A.Q.iX+e.A.A.Q.I+e.PJ[0])&&ZC.DU(e.M.iY+e.M.BD+(e.M.AA%180==0?e.M.F/2:e.M.I/2),e.A.A.Q.iY-e.PJ[1],e.A.A.Q.iY+e.A.A.Q.F+e.PJ[1])&&(e.M.1v(),e.M.EH(),!e.M.K3&&"5e"===1o.ed&&(C.E["zi"+e.L]=e.M.AP,f=e.A.A,ZC.AK(f.A.K+"-2Z"))))){1a D=ZC.AO.NZ(f.K,e.M);ZC.AK(f.A.K+"-2Z").4n=ZC.AK(f.A.K+"-2Z").4n+D}}}1t e.A.zk(e)}}),ZC.s2=ZC.C9.C7({$i:1f(e){1a t=1g;t.LR=1c,t.l4=0,t.OV=[],t.BB=e,t.l5=!0},2N:1f(e){1a t=1g;t.OV.1i(e),e.JV=t,e.LR=t.LR,e.BY.TH=!0,e.WU=t.OV.1h-1,t.l5=!1}}),ZC.E8=ZC.C9.C7({$i:1f(e,t,i,n,a,l){1a o=1g;o.LR=1c,o.BY=e,o.AV=1c,o.go=0,o.IC=1c,o.O=t||{},o.zr=i||na,o.X3=n||-1,o.ju=1c,o.SZ=1c,o.O8=1c,1c!==ZC.1d(l)&&(o.SZ=l),o.cN=ZC.E8.9l,1c!==ZC.1d(a)&&""!==a&&(o.cN=a),o.15w={},o.C3={},o.15x=[],o.R5=ZC.1l(o.zr/ZC.PA.TV),o.R5>100&&(o.R5=100),(ZC.3I||ZC.2H)&&(o.R5=ZC.1l(o.R5/4)),o.R5<5&&(o.R5=5);1k(1a r in o.O)1c!==ZC.1d(ZC.E8.GI[r])?o.C3[r]=o.BY[ZC.E8.GI[r]]:o.C3[r]=o.BY[r];o.Y=0,o.JV=1c,o.WU=-1},6Q:1f(){1a e=1g;1m e.Y+1>e.R5?0:1},6Y:1f(){1a e,t,i,n,a,l,o=1g,r=1,C=o.LR.C.H.AB;if(o.Y++,o.Y>o.R5&&(o.Y===o.R5+1&&-1!==o.WU&&(o.JV.l4++,o.JV.l4===o.JV.OV.1h&&(o.JV.l5=!0)),r=0),r){1a A={};if(o.Y===o.R5)A=o.O,o.go=1;1t{o.go=o.cN(o.Y,0,1,o.R5);1k(1a s in o.O)1P(s){1j"2S":1a Z=[];1k(a=0,l=o.O[s].1h;a<l;a++)if(1c!==ZC.1d(o.C3[s][a])){Z[a]=[];1k(1a c=0,u=o.O[s][a].1h;c<u;c++)Z[a][c]=o.cN(o.Y,o.C3[s][a][c],o.O[s][a][c]-o.C3[s][a][c],o.R5)}A[s]=Z;1p;1j"hd":1j"gt":1j"gj":1j"g9":1a p=o.C3[s].1E("#",""),h=ZC.AO.G3(o.O[s]).1E("#",""),1b=ZC.QG(p.7y(0,2)),d=ZC.QG(p.7y(2,4)),f=ZC.QG(p.7y(4,6)),g=ZC.QG(h.7y(0,2)),B=ZC.QG(h.7y(2,4)),v=ZC.QG(h.7y(4,6)),b=ZC.ON(ZC.1l(o.cN(o.Y,1b,g-1b,o.R5)));1===b.1h&&(b="0"+b);1a E=ZC.ON(ZC.1l(o.cN(o.Y,d,B-d,o.R5)));1===E.1h&&(E="0"+E);1a m=ZC.ON(ZC.1l(o.cN(o.Y,f,v-f,o.R5)));1===m.1h&&(m="0"+m),A[s]="#"+b+E+m;1p;2n:A[s]=o.cN(o.Y,o.C3[s],o.O[s]-o.C3[s],o.R5)}}if(o.BY.1C(A),o.BY.TH=!0,o.BY.1q(),o.AV&&(1c!==ZC.1d(e=o.BY.E["jn-1"])&&(o.BY.CY[1]=e),1c!==ZC.1d(e=o.BY.E["jn-3"])&&(o.BY.CY[3]=e),"3I"===C&&1===o.Y&&(1w o.AV.A.HM!==ZC.1b[31]?o.BY.E.dr=o.AV.A.HM:o.BY.E.dr=o.AV.A.C6),o.AV.H&&(o.AV.H.E[o.AV.K+"-cJ"]=[o.AV.iX,o.AV.iY,o.AV.iX+o.AV.I,o.AV.iY+o.AV.F])),o.ju)4I{o.ju(o.BY,A)}4G(Y){}if(o.AV){1a K={id:o.AV.H.K,4u:o.AV.C.K,3S:o.AV.A.L,5Q:o.AV.L,15a:o.go,1S:o.AV.AE*o.go};ZC.AO.C2("15i",o.AV.H,K)}}if(o.AV){if(1===o.Y||"3a"===C)-1!==ZC.AT(["2B","3I"],C)?0===ZC.A4("#"+o.BY.K+"-2M").1h&&o.1v():o.1v();1t if(o.Y<=o.R5){1P(C){1j"2B":o.BY.WR(!0);1p;1j"3I":o.BY.WQ(1c,!0)}o.BY.VV&&o.BY.VV(),"3I"===C&&/\\-cu\\-1B-\\d+\\-2o\\-\\d+\\-1M/.5x(o.BY.K)&&(o.BY.AY=0),t=1c,1w o.BY.DP!==ZC.1b[31]&&"3B"===o.BY.DP&&(t=o.BY.AY,o.BY.AY=o.BY.AQ);1a F=!1;if("2B"===C&&ZC.AK(o.BY.K+"-2M")&&"5t"===ZC.AK(o.BY.K+"-2M").8h&&(F=!0),F)i=[],n=[];1t if(i=ZC.P.jb(o.BY.D,C,o.BY,!1,!0),o.BY.M3){1a D=ZC.P.sw(o.BY.D,o.BY);n=ZC.P.jb(D,C,o.BY,!1,!0)}1c!==ZC.1d(t)&&(o.BY.AY=t);1a I=o.BY.C6,X=o.BY.NU,x=o.BY.SY,y=o.BY.JP,L=o.BY.AH;1P(C){1j"2B":ZC.A4("#"+o.BY.K+"-2M").3Q("d",i.2I(" ")).3Q("3Y-3k",X).3Q("3f-3k",I),o.BY.M3&&ZC.A4("#"+o.BY.K+"-sh-2M").3Q("d",n.2I(" ")).3Q("3Y-3k",X*x).3Q("3f-3k",I*x),F&&(ZC.A4("#"+o.BY.K+"-2M").3Q("x",o.BY.iX).3Q("y",o.BY.iY).3Q(ZC.1b[19],ZC.BN(0,o.BY.I)).3Q(ZC.1b[20],ZC.BN(0,o.BY.F)),o.BY.M3&&ZC.A4("#"+o.BY.K+"-sh-2M").3Q("x",o.BY.iX+y*ZC.ED(o.BY.OB)).3Q("y",o.BY.iY+y*ZC.EL(o.BY.OB)).3Q(ZC.1b[19],ZC.BN(0,o.BY.I)).3Q(ZC.1b[20],ZC.BN(0,o.BY.F))),ZC.A4("#"+o.BY.K+"-3x").3Q("3Y-3k",X).3Q("cx",o.BY.iX).3Q("cy",o.BY.iY).3Q("r",L).3Q("3f-3k",I),o.BY.M3&&ZC.A4("#"+o.BY.K+"-sh-3x").3Q("3Y-3k",X*x).3Q("cx",o.BY.iX+y).3Q("r",L).3Q("cy",o.BY.iY+y).3Q("3f-3k",I*x),""!==o.BY.D8&&ZC.A4("#"+o.BY.K+"-2M-5b").3Q("3Y-3k",X).3Q("3f-3k",I),ZC.A4("#"+o.BY.K+"-7w-2M").3m();1p;1j"3I":ZC.A4("#"+o.BY.K+"-2M").9s().4Z(1f(){1g.v=i.2I(" "),1g.3k=I}),o.BY.M3&&ZC.A4("#"+o.BY.K+"-sh-2M").9s().4Z(1f(){1g.v=n.2I(" "),1g.3k=I*x}),ZC.A4("#"+o.BY.K+"-3x").9s().4Z(1f(){1g.3k=I}),ZC.A4("#"+o.BY.K+"-3x").4Z(1f(){1g.1H.1J=o.BY.iX-L+"px",1g.1H.1u=o.BY.iY-L+"px",1g.1H.1s=2*L+"px",1g.1H.1L=2*L+"px"}),o.BY.M3&&(ZC.A4("#"+o.BY.K+"-sh-3x").9s().4Z(1f(){1g.3k=I*x}),ZC.A4("#"+o.BY.K+"-sh-3x").4Z(1f(){1g.1H.1J=o.BY.iX-L+y+"px",1g.1H.1u=o.BY.iY-L+y+"px",1g.1H.1s=2*L+"px",1g.1H.1L=2*L+"px"})),ZC.A4("#"+o.BY.K+"-7w-2M").3m()}}}1t o.LR.C.PY=!0,o.LR.C.gm(),o.LR.C.KE();1m o.Y===o.R5+1&&1c!==ZC.1d(o.SZ)&&o.SZ(),r},1v:1f(){1a e=1g;if(1c!==ZC.1d(e.IC)?ZC.CN.1v(e.IC,e.BY,e.BY.D):e.BY.1v(),e.O8)4I{1===e.go&&e.O8()}4G(t){}}}),ZC.E8.GI={bD:"B1",a2:"BH",7y:"CK",2b:"AH",x:"iX",y:"iY",1s:"I",1L:"F",2k:"C6",2c:"AA",xh:"N1",2S:"D",cY:"AY",hd:"B6",gr:"AQ",gt:"BU",gj:"A0",g9:"AC"},ZC.E8.9l=1f(e,t,i,n){1m i*e/n+t},ZC.E8.wx=1f(e,t,i,n){1a a=(e/=n)*e;1m t+i*(4*(a*e)+-9*a+6*e)},ZC.E8.wH=1f(e,t,i,n){1a a=(e/=n)*e,l=a*e;1m t+i*(37.15k*l*a+-116.15D*a*a+134.15Y*l+-68.59*a+14.160*e)},ZC.E8.wJ=1f(e,t,i,n){1m(e/=n)<1/2.75?i*(7.kJ*e*e)+t:e<2/2.75?i*(7.kJ*(e-=1.5/2.75)*e+.75)+t:e<2.5/2.75?i*(7.kJ*(e-=2.25/2.75)*e+.161)+t:i*(7.kJ*(e-=2.162/2.75)*e+.163)+t},ZC.E8.wL=1f(e,t,i,n){1a a=(e/=n)*e;1m t+i*(a*e+-3*a+3*e)},ZC.E8.wK=1f(e,t,i,n){1a a=(e/=n)*e,l=a*e;1m t+i*(l*a+-5*a*a+10*l+-10*a+5*e)},ZC.E8.RJ=[ZC.E8.9l,ZC.E8.wx,ZC.E8.wH,ZC.E8.wJ,ZC.E8.wK,ZC.E8.wL],ZC.aS={165:166,15Z:5L,167:0,16a:1,16b:2,16c:3,16d:4,16e:5,16f:0,16g:1,169:2,15X:3,15O:1,15W:2,15G:3,15H:4,15I:5,15J:6,15K:7,15L:8,15M:9,15F:10,15Q:11,15R:12,15S:13,15T:2,15U:3,15V:4,17A:5},ZC.PA=ZC.C9.C7({$i:1f(e){1a t=1g;t.C=e,t.RL=!1,t.C4=1c,t.OV=[],t.P9={},t.kZ=1c},tE:1f(e,t){1a i=1g;1c===ZC.1d(i.P9[e.BB])&&(i.P9[e.BB]=e,e.LR=i,i.RL||(1c!==ZC.1d(t)&&t>0?2u.5G(1f(){i.46()},t+1):i.46()))},2N:1f(e){1a t=1g;e.LR=t,e.X3>0?(t.OV.1i(e),2u.5G(1f(){e.BY.TH=!0,t.RL||t.46()},e.X3+1)):(e.BY.TH=!0,t.OV.1i(e),t.RL||t.46())},46:1f(){1a e=1g;e.RL=!0,ZC.AO.C2("18H",e.C.A,{id:e.C.A.K,4u:e.C.K});1a t=!0;!1f i(){t||e.6Y(),t=!1,e.RL&&(e.C4=2u.iM(i))}()},6Y:1f(){1a e,t=1g,i=0;if(t.RL){1k(1a n=0,a=t.OV.1h;n<a;n++)i+=t.OV[n].6Q();if("3a"===t.C.H.AB)if(t.C.H.K3)1c!==ZC.1d(e=ZC.AK(t.C.K+"-4j-bl-c"))&&e.9j("2d").tz(t.C.iX,t.C.iY,t.C.I,t.C.F);1t 1k(n=0,a=t.C.AX.A7.1h;n<a;n++)1k(1a l=0;l<t.C.AX.A7[n].SK;l++)1c!==ZC.1d(e=ZC.AK(t.C.K+"-1B-"+n+"-bl-"+l+"-c"))&&e.9j("2d").tz(t.C.iX,t.C.iY,t.C.I,t.C.F);1k(n=0,a=t.OV.1h;n<a;n++)0===t.OV[n].6Y()&&(t.OV[n].BY.TH=!1);1k(1a o in t.P9)1k(t.P9[o].l5||(i+=1),n=0,a=t.P9[o].OV.1h;n<a;n++)t.P9[o].OV[n].WU===t.P9[o].l4?0===t.P9[o].OV[n].6Y()&&(t.P9[o].OV[n].BY.TH=!1):"3a"===t.C.H.AB&&t.P9[o].OV[n].1v();0===i&&(t.P9={},t.OV=[],t.8y())}},8y:1f(e){1c===ZC.1d(e)&&(e=!1);1a t,i=1g;if(e&&(i.195=!0),2u.tK(i.C4),i.C.gm(),i.C.PY=!1,ZC.AK(i.C.H.K)){i.C.KE(),2u.5G(1f(){(t=ZC.AK(i.C.A.K+"-2Z"))&&i.C.AX.HK&&(-1===ZC.AT(["5h","9q","8q","80","74"],i.C.AF)&&1!==1o.tQ||i.C.AX.HK.3V(1f(e,t){1m ZC.AO.MW(e)>ZC.AO.MW(t)?1:-1}),t.4n+=i.C.AX.HK.2I(""))},33),i.C.tS(),i.RL=!1;1k(1a n=0,a=i.OV.1h;n<a;n++)i.OV[n].SZ=1c;if(i.OV=[],i.P9={},e||ZC.AO.C2("182",i.C.A,{id:i.C.A.K,4u:i.C.K}),1c!==ZC.1d(i.kZ))4I{i.kZ()}4G(l){}}}}),ZC.PA.TV=33,1f(){1k(1a e=["ms","y0","7A","o"],t=0,i=e.1h;t<i&&!2u.iM;++t)2u.iM=2u.17S||2u[e[t]+"17Q"],2u.17O=2u.17G||2u[e[t]+"18b"]||2u[e[t]+"18l"];2u.iM||(2u.iM=1f(e){1m 2u.5G(e,ZC.PA.TV)}),2u.tK||(2u.tK=1f(e){2u.iQ(e)})}(),1o.3p(1c,"gg",1f(e,t){1k(1a i,n,a=0,l=t[ZC.1b[16]].1h;a<l;a++)if(t[ZC.1b[16]][a].1I&&-1!==ZC.AT(["3L","1y","bF","1M","bE","2Q","5A","6d","8Y","81","ej","6M","7v"],t[ZC.1b[16]][a].1I)&&t[ZC.1b[16]][a].y6){1a o=t[ZC.1b[16]][a];ZC.6v(o);1a r=o.y6||{};ZC.6v(r);1a C,A,s,Z=ZC.IB(r.kp||"10%"),c=r.18N||{1D:"18J"},u=r.c7||{},p=r[ZC.1b[8]]||"0.3",h=o[ZC.1b[11]]||[],1b=[];if("3L"===t[ZC.1b[16]][a].1I){1a d=0;1k(i=0;i<h.1h;i++)h[i][ZC.1b[5]]&&1c!==ZC.1d(h[i][ZC.1b[5]][0])&&(d+=h[i][ZC.1b[5]][0]);Z>0&&Z<1&&(Z*=d),C=[].4w(h);1a f=0,g="";1k(A=1,i=h.1h-1;i>=0;i--)h[i][ZC.1b[5]]&&1c!==ZC.1d(h[i][ZC.1b[5]][0])&&h[i][ZC.1b[5]][0]<Z&&(f+=h[i][ZC.1b[5]][0],g+=(h[i].1D||"ya no."+A)+":"+h[i][ZC.1b[5]][0]+"<br>",h[i][ZC.1b[8]]=p,1b.1i(h[i]),h.6p(i,1),A++);f>0&&(A>2?(s={6g:[f],ua:!1,"1T-5Z":[1],"2C-1D":g=g.2s(0,g.1h-4)},ZC.2A(c,s),h.1i(s),1o.3p(e.id,"xp",1f(t){if(t.hI.5Z){1a i=1o.79(t.id);if(!i)1m;1a n=1o.tw(i,t.4u);1k(1a a in n.tX())"3L-fU-"===a.2s(0,8)&&n.4l(a,1c);1o.3j(e.id,"dH",{1T:1b}),2u.5G(1f(){1a t=1o.3j(e.id,"u7",{4g:"2o",3S:0,5Q:0}),i={id:"u1",x:t.x,y:t.y,1D:"< tU",bh:"c",4O:"ib"};ZC.2A(u,i),1o.3j(e.id,"tO",{1I:"1G",1T:i})},1)}}),1o.3p(e.id,"xx",1f(t){if("u1"===t.1G.id){1a i=1o.79(t.id);if(!i)1m;1a n=1o.tw(i,t.4u);1k(1a a in n.tX())"3L-fU-"===a.2s(0,8)&&n.4l(a,1c);1o.3j(e.id,"tL",{1I:"1G",id:"u1"}),1o.3j(e.id,"dH",{1T:h})}})):o[ZC.1b[11]]=[].4w(C))}1t{1a B=0,v=[];1k(i=0;i<h.1h;i++){if(v[i]=0,h[i][ZC.1b[5]]&&h[i][ZC.1b[5]].1h)1k(n=0;n<h[i][ZC.1b[5]].1h;n++)v[i]+=ZC.2i(h[i][ZC.1b[5]][n]);B=ZC.BN(B,v[i])}Z>0&&Z<1&&(Z*=B),C=[].4w(h);1a b=[],E=[];1k(A=1,i=h.1h-1;i>=0;i--)if(v[i]<Z){if(h[i][ZC.1b[5]]&&h[i][ZC.1b[5]].1h)1k(n=0;n<h[i][ZC.1b[5]].1h;n++)b[n]=ZC.1W(b[n]||"0"),b[n]+=h[i][ZC.1b[5]][n],E[n]=E[n]||"",E[n]+=(h[i].1D||"ya no."+A)+":"+h[i][ZC.1b[5]][n]+"<br>";1b.1i(h[i]),h.6p(i,1),A++}if(b.1h)if(A>2){1k(n=0;n<E.1h;n++)E[n]=E[n].2s(0,E[n].1h-4);s={6g:b,ua:!1,"1T-5Z":[1],"1T-tt-1D":E,"2C-1D":"%1T-tt-1D"},ZC.2A(c,s),h.1i(s),1o.3p(e.id,"xp",1f(t){if(t.hI.5Z){if(!1o.79(t.id))1m;1o.3j(e.id,"dH",{1T:1b}),2u.5G(1f(){1a t=1o.3j(e.id,"u7",{4g:"2r"}),i={id:"tC",x:t.x+t.1s/2,y:t.y,1D:"< tU",bh:"c",4O:"ib"};ZC.2A(u,i),1o.3j(e.id,"tO",{1I:"1G",1T:i})},1)}}),1o.3p(e.id,"xx",1f(t){if("tC"===t.1G.id){if(!1o.79(t.id))1m;1o.3j(e.id,"tL",{1I:"1G",id:"tC"}),1o.3j(e.id,"dH",{1T:h})}})}1t o[ZC.1b[11]]=[].4w(C)}}1m t});',62,4408,'||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||var|_|null|_n_||function|this|length|push|case|for|_i_|return|new|zingchart|break|parse|color|width|else|top|paint|typeof||line|scale|Math|plot|append|text|replace|border|label|style|type|left|indexOf|height|area|item|marker|switch|copy|background|value|data|legend|max|_f_|scroll|offset|none|||||||||||bottom|size|angle||document|visible|guide|min|_a_|360|alpha|split|cls|default|node|font|_b_|plotarea|substring|load|window|margin|preview|right|menu|items|_cp_|svg|tooltip||setup|objects|position|mobile|join|hover|css|usc|path|add|fff|shape|bar|solid|points|target|graph|index|log|appendChild|string|map|||||||||||canvas|page|JSON||auto|fill|class|unbind|abs|exec|opacity|move|remove|handle|body|bind|MAX|clip|align|layout|padding|clear|scales|circle|MAPTX|instanceof|div|box|zoom||center|click|DEV|shadow|vml|display|Array|pie|handler|ref|update|url|attr|255|plotindex|270|state|sort|tick|main|stroke|enabled||||round|||start||||html|cache|live|image|000|die|object|ceil|floor|plots|show|setAttribute|xmax|innerHTML|delete|bugreport|all|xmin|call|_x_|graphid|toFixed|concat|poly|assign_a|SCALE|absolute|mode|SKIP|touchstart|form|json|catch|viewsource|try|999|mask|error|dynamic|createElement|cursor|Number|minor|out|enable|src|maps|spline|plotid|history|gradient|each|||||||||||prototype|imgfill|hide|stringify|normal|gui|GESTURE|bubble|ACQ|row|pow|front|_l_|inherit|RegExp|2px|depth|ymax|ymin|rect|opposite|substr|parseInt|test|range|date|vbar|sqrt|custom|toUpperCase|short|title|setTimeout|transform|callback|getNodeData|format|1e3|highlight|inner|piano|touchend|nodeindex|GUIDES|header|fullscreen|img|parseFloat|shapes|String|pool|group|||||||||||shared|m_|placement|hbar|A3I|mouseup|values|decimals|total|context|touchmove|from|_e|end|middle|splice|table|layer|parentNode|scatter|bold|_todash_|info|about|arc|hbubble|browser|callout|loader|active|paint_|print|repeat|order|mousedown|9999|csv|preventDefault|vbar3d|off|ie67|00|status|fontWeight|fontSize|distance|fontFamily|palette|childNodes|221F1F|step|mouseover|||||radar||button|outer|ddd|getLoader|weight|factor|override|source|aspect|translate|http|trend|plotidx|A9P|pie3d|nodeidx|fixed|ACC|api|close|zcv|hook|eachfn|eval|javascript|hbar3d|goal|important|slice|touches|webkit|mouseout|sFontWeight|span|item_|oRE|arrow|stack|aAutoFit|true3d|href|zoomx|flat|D1D3D4|_c_|zoomy|progress|mousemove|ccc|trigger|key|className|location|subtitle|action|arguments|hbullet|area3d|ABC|cnt|last||5px||1px|xls|isNaN|getToggleAction|sum|hasOwnProperty|build|stock|negation|tagName|exit|void|percent|CSV|entry|plus|npv|1e4|vbullet|send|zidx|hscatter|fast|pointer|export|radial|stop|val|diff|www|_p_|images|01|static|oPS|apply|333|nbsp|block|name|gauge|animation|space|separator|pattern|oPPI|eee|which|quirks|column|kmin|number|line3d|float|||initcb|Object|adjust||nestedpie|connector|kmax||58595B|light|hidden|navigator|after|blocker|family|hideCM|ready|getContext|ring|linear|reverse|coords|square|locate|mixed|vertical|children|dragged|cross|dblclick|crosshair|zc_legend_mousescroll|matrix|rose|paintPreview|radius|DAY|rgba|method|EVENTS|oMask|Date|rgb|ticks|select|toggle|destroy|clearInterval|targetid|footer|pages|overflow|frame|mid|pointsarea|zIndex|FONTFAMILY|change|png|EVENT|side|tolerance|angleEnd|SEC|zoomTo|segmented|msie|multiple|exponent|zindex|MIN|equal|rules|input||version|down|element|getInstance|getPMap|_tx_|setAttributeNS||root|vfunnel|hfunnel|toString|mousewheel|||styles|ajax|async|10px|COLORS|mapPointsToPreview|atan|filled|behaviors|success|complete|icon|scrollLeft|marker_|scrollTop|toLowerCase|rel|chart|NODE_EV|removeChild|rtl|tdim|mdim|message|ANIMATION|pstack|gear|venn|selection|wait|params|graphset|transparent|mixed3d|flash|render|setdata|tools|A0P|skip|pageX|pyramid|dark|||safe||togglePreviewMasks||anchor|getTime|Resource|ic_line||LN10|_fixed_|pageY|GET|single||italic|user|open|com||gshape||256|SKIPTRACKERS|direction|flatten|angleStart|varea|vline|IMAGES|feed|idx|output|ignore|datalength|resize|objmove|TOUCHEVENTS|oblique|setNodeData|textarea|_boxoverlap2_|getAttribute|theme|facet3|SEQ|facet2|facet1|ctx|lineHeight|Function|iXVal|decoration|iYVal|_INFO_|xy_|back|tab|A7A9AC|A0Z|labels|getTooltipPosition|horizontal||axis|dashstyle|utc|ACI|zooming||currency||timezone|||not|keys|viewimage||plotset|clientX|fire|||rule|getElementById|reference|power|fontStyle|A2B|ie678|defaults|000000|BUILDCODE|bounds|paddingTop|uid|drawImage|A4D|refresh|classic|V3D|textAlign|userAgent|666|fillStyle|Image|random|tween|lineWidth|nodes|setRequestHeader|setupcb|bYX|Jan|CanvasCache|Thu|intersect|goback|goforward|zero|globalAlpha|cos|hideprogresslogo||||jpeg|beforeSend|GMT|paddingLeft|false|bandwidth|A0Y|A0V||preserve|average|opacity2|interval|paddingBottom|1970|paddingRight|labelid|||sTypeX|4px|3dxy|A7J|baseVal|_int_|A2H|forw|setseriesdata|sMaster|8C8C8C|_pageX_|sin|sampling|raw|continue|watermark|org|clientY|A1H|A1E|Data|sep|visibility|xmlns|414042|vector|cccccc|unit|touch|swipe|FSID|curtain|getElementsByTagName|updates|LEGEND|arrows|A2K|textDecoration|MON|OBJECTMODE||addPMap|bBS|fromCharCode|force|bar3d|series|||moveTo|collapsed|A9I|dx2|A7V|stepped||highlightItem||day|selected|bidi|A0T|AAM|querySelector|dx1|A58|md5|300|zcrandom|A12|onmouseover|documentElement|smart|DEFAULT|charCodeAt|A0R|REFRESH_TICK|SKIPMAPS|z3d|1800|aBandWidths|onmouseout|A50|isFinite|intxy|dist|xtype|bullet|query|A4N|A4G|margins|readyState|inactive|segment|clearPreview|A4T|styleSheets||count|lon|lat|||A4H|DOMMouseScroll|encodeURIComponent|labelindex|_end_||contextmenu||progression||charAt|before||month|headers|onreadystatechange||||cone|rectangle|modal|dashdot|ratio|getstyle|reload|A11|setInterval|i18n|pdf|checked|VERSION|nodeType|download|point|wrapper|3e6c7b|viewall|A2F|submit|sel|A2O|long|dashed|application|license|getElementsByClassName|dotted|zoomout|CACHECANVASTEXT|zoomin|A1Z|overscroll|bIsBottom|A5B|backgroundColor2|A2J|rotate||widgets||head|dataparse|found||backgroundColor1|originalsource|getComputedStyle|A04|cwidth|A46|jsonsource|parentElement|borderWidth|IMG404|borderColor|generated|A3M|fit|onmousemove|normalize|A0E|hasEvent|nodekeyvalue|A8X|shapeid|legendminimize|dataurl|alignment|modules|shapeindex|A3L|AFT|underline|callEvent|bRTL|zc_loader_mousewheel|A0D|titles|dim|save|getdata|setAnchor|data_|0px|A48|3dfacet| |A3D|aperture|CDCDCD|setScrollingFlag|A5D|websockets|A0O|LICENSE|previewscale|ll_|LOCALSVGEXPORT|facet5|_r_|lineColor||A1R|GUIDE_EV|storage|lcoords|lstep|XMLHttpRequest|NODE_EV_CHART|infotype|xydistance|A3G|A1W|events||collapse||A5E|onload|ZCOUTPUT|restore|A70|CANVASTEXT|sTypeE|goals|A0M|A1X|05|keyvalue|A3B|1e6|xdata|NULL|A1V|insertBefore|showguide|Top|A4F|Bottom|addColorStop|true|View|A0Q|A23|A00|Right|colors|A0S|A22|_ang_|Close|_pageY_|clearGuide|getBoundingClientRect|b2D|A1T|ABD|Left|flags||hand|exitfullscreen||||html5|A0A||MAX_VALUE|gap|A0X|bNormalize||cleanTouchEvents|lineTo|facet4|A8Y|||A33|1024|hmixed|overlap|URL|A10|A8Z|ctrlKey|timeout|totals|AJAXEXPORT|AAQ|post|CSS|A5A|A39|multiplier|stroked|requestAnimFrame|A1Y|nodata|locale|clearTimeout|minute|protocol|first|FONTSIZE|AAY|attachEvent||||tap|offsetY|filename|A3U|A1F|xlink|A02|AD0|A2D|A5J|zcoutput|A2N|full|A4C||blocked|A3J|trapeze|getFormatValue|aMDXY|relative|exportdata|A1C|bound|A84|transport|xml|Blob||global|A09|reset|A7I|foreignObject|A20|toDataURL|A7E|A45|A66|A55|A68|borderLeft|months|borderRight|A44|A57|A34|CACHESELECTION|A1A|A1L|acos|A64|mini|A01|A0B|days|parseLayout|oMap|marginLeft|A6J|ANIMATION_|markerbg|sharedZScale|A1N|ABN|applyRGBA|bPoly|AAP|exec_flash|bars|nulls|connect|ruler|hideguide|A3O|contour||A1J|A9F|evalFn|A4M|A53|PLOTSTATS||Series|FSSTATUS|marginTop|threshold|vboxid|stream|A7D||A9A||DOMFRAGMENTS|A7M|base64|ffffff|A3S|A32|applyJsRuleSvg|stopfeed|yall|getSize|THEME|A42|pull|5625|ADH|parsecb|hasData|BLANK|filter|cloneNode|A26|A4R|A3E|plotdata|A2C|A2E|A8U|A3H|A0U|onStop|Download|PLOTSHLAYER|A1D|xall|A54|A30|A08|369|opera|A35|A41|A91||A8M||A59|offsetX||onerror|A6B|isBold|A4K|NODE_EV_TYPE|match|disabled|A0C|65535||A1K||_hex2rgb_|item_title|textprint|calculate|empty|A4W|minimize|A29|A3P|A4X|BODY|nowrap|A4O|TOUCHZOOM|A9S|AA4|A6X|A4U|A28|A15|bBind|disableanimation|LICENSEKEY|A3A|A4L|PARSE3D|A2A|A14|showhide|defs|init|929497|wh_|color2|A1G|A9C|lin|clientWidth|A9Y|addEventListener|zc_guide_touchend|clientTop|currentStyle|smooth||36e5||extendAPI|AC4|defaultView|A2X|clientLeft|undefined|||A05|iframe||setLineDash|thousands||025|coord|butt|_image|ActiveXObject|second|alignPosition|setupPlotArea|hour|fixPlacement|year|closePath|beginPath|strokeStyle|col|A06|A9W|objtype|tip|A25|250|cancel|_append_|A7P|set|_nfind_|lowlevel|A6K|pinch|A79|TTLOCK|Lucida|PATTERNS|palatte|A03|A83|A07|_txp_|AA6|595959|_h_|A36|MAPSONBOTTOM|500|parser|EQUIV|||downloadFile|trackers|AFX|miter|ABH|customprogresslogo|logo|AB2|hamburger||exact|A5Y|run|dash||setupDynamicPlotArea|stacked|dot|_unbind_|A9Q|AGQ|A18|AGM|asin|A0I|exportdataurl|dummy|_width_|A4Q|A37|AA1|mapshape|marginBottom|A5Z|A60|useMap|marginRight|A0F|atan2|A4J|modify|ASYNC_TICK|autoFit|A21|A5Q|A3Q|A3W|600|customprogresstext|A49|A5W|A9N|rotation|HTMLMODE|AAU|wrapped|A17|A8F|utf|AA5|A2I|||GUIDETIMEOUT|A1M|A8A|globalCompositeOperation|AB7|A4I|borderBottom||hidedatatable|A3V|chkcapture|email|A6S||menuid|A86|bKeyWidth|2e3|2048|A40|Guide|465|_oCtxNode|A94|columns|ring3d|AAN|A61|ABT|EDITSOURCE|A1Q|b3D|_iX|chkdata|backgroundColor|switchtolin|ABE|menuitemid|dasharray|A1B|A3K|A27|DownloadXLS|verticalAlign|viewdatatable|speed|viewasjpg|viewaspng|switchtolog|bgc2|200|focusposition|STACKINGLOGIC|A16|nextSibling|AB0|CHECKDECIMALS|disablepagescroll|A9M|ABV||AAJ|enablepagescroll|switchto3d|bgc1|switchto2d|hideLayer_|createObjectURL||polar|A7F|schemas|media|SYNTAX|urn||NOABOUT||A2V||octet|startfeed|ABQ|initObjectsLayers|AAH|createPreviewMasks|skipfs|A3R|ABL|microsoft|fillText|A81|A9U|MEDIARULES|scrollTo|deselect|setScalesInfo|webstorage|A3Z|_blank|en_us|AA0|A3N|onloadend|EXPORTURL|A4V|_POOL_|sAlign|A9L|caption|dataType|minvalue|ABR|AAK|ABA|load_|clearLabelBoxes|1999|charset||toggleMasks|A4S||loadModules|A77|maxvalue|showZCAbout|office|AEJ|ABG|get|file|AB4|A8S|KEEPSOURCE|sans|kv_|WebSocket|AC5|serif|backgroundPosition|setmode|mso|zoomto|ADC|clear_|A9G|COPYDATA|A89|A0G|next|GRAPHID|A5I|AAV|A1S|A8E|A7T|A5L|iDragPos|unicode|Custom|null3d|oldcursor|jpg|A4Z|ABY|toggling|A2Q|AAW|A52|TIMEOUT|||A9K|exportimageurl|zc_legend_mouseout|l_|zc_legend_mouseover|resource|A87|fullscreenmode||vrange|||A1I|ABF|paintCANVASText|JavaScript|xdist|ydist||xzoomed|yzoomed|pan|createDocumentFragment|A19|s_|A9Z||A5U||A0H|||A2S|ZINDEX|AAE|funnel|reorder|A0N|sync|zc_loader_touchstart_static|setseriesvalues|A51|paintHistory|A8K|A3X|RESOURCES|clearGenerated|legend_toggle_action|A0J|AFQ|textContent|A8V|stops|Page|14px|A8B|A73|_nice_number_|17px|||A24|AAZ|statusText|A4P|A3T|formats|USERCSS|bNpv|msecond|AA9|areanode|description||A5M|pointserror||A2T|A5V|||extension|polypoints|A71|dots|joined|A5S|8px||bandspace||_sh_|oPlot_|oNode_||mimeTypes|chars|appendToValueBox|xObj|A62|minus|A9R|A5R|Wait|99999|cssFloat|offsetHeight|offsetWidth|e1eaec|ABI|02|A74|score|styleFloat|changedTouches|SMARTDATELABELS|1e9|_oMarker|lbltype|A9D|Show|A1U|getPropertyValue|zcvml|C6C6C6|srcElement|AA2|400|7CA82B|005|_window_onunload_|F0F1F1||A1O|||_cpa_|passive||shader|676667|hasPassive||D1D2D3|FFF||runtimeStyle|A88||||Loading|A4A|getGraph|||clearRect|A2P|oP0|navxy_btnback|Submit|AA3|DEBOUNCESPEED|A2L|A5X|cylinder|thickness|clearAnimFrame|removeobject|Your|SPREADTYPE|addobject|CMZINDEX|SORTTRACKERS|A2R|A65|positioninfo|Back|A8T|Sans|getAttributes|over|A6W|A5T|navpie_btnback|low|high|sMetaType|A95|AC1|getobjectinfo|mathpoints|A4E|detach|A63|A6N|vb_||365|detached|6e4|ASYNC|fromAPI|Opera|mapItem|csvParser|ACF|zcgraph||AAC|LITE|IGNORESUBUNIT||removeEventListener|event|endangle|A6Q|connected|getOptimalDateInterval|createPattern|pos|Helvetica|asc|tile|Arial|sec|001|mon|A4Y|paintTransformDate|ALIAS|FASTWIDTH|quadraticCurveTo|xdiff|overlaps|coordsize|querySelectorAll|guide_mousemove|borderTop|coordorigin|trident|clientHeight|innerWidth|AD9|MAXPOOLSIZE|||||SKIPOBJCOUNT|createElementNS|createRadialGradient|createLinearGradient|THEMES|SPREADFACTOR|LOOKUPCSSTRANSFORM||uniform|face||originalEventZC|gear6|mirrored|oP2|oP3|guide_mouseout||standard|clippath|1023|persistent|ACA|A6G|ACB||ACS||fold|ABK|pageXOffset|0123456789abcdef|plot0|_parent|_top|A7G|initial|paired|facet|plot1|pageYOffset|plot2|getxyinfo|doubleclick|parent|elementFromPoint|AC6|ACP|ACV|oval|AREA|limit|316224e5|dateformat|week|bbox|childof|gradientradial|864e5|stopPropagation|A6L||size2|sigma|ownerDocument|bKeep|26784e5|skv||oP1|3dtx|ACW||_height_|AB1||AB5|A43|A6H|preserveAspectRatio|facets|A5P|responseText|hPos|vPos|userSpaceOnUse||POST|900|AAX|flexible|backEaseOut|meta|toggleabout|addmenuitem|ExcelWorkbook|ExcelWorksheets|ExcelWorksheet|WorksheetOptions|Name|FFFFFF|elasticEaseOut|dataexport|bounceEaseOut|strongEaseOut|regularEaseOut|msSaveBlob|11px|imggen|A7L|origin|AD1|thead|scope|vmin|filetype|2654435769|viewDataTable|encoding|excel|downloadXLS|||downloadCSV|MSIE|compatMode|ShockwaveFlash|options|tbody|shockwave|adj|response|responseType|anonymous||crossOrigin|UTF|fillAngle||2000|getimagedata|vmax|pathname|ABS|SaveAsImageJPG|plot_click|pop|bubblepie|PageScroll|About|Reload|Menu|A2M|label_click||DownloadCSV|downloadsvg|ExportData|FullScreen|BugReport|ViewSource|Print|ViewDataTable|LogScale|LinScale|SwitchTo2D|SwitchTo3D|downloadpdf|downloadcsv|gif|sBId|AA7|ACU|defaultsurl|FSZINDEX|keyup|rawsource|215|getFullYear|SKIPCONTEXTMENU|msg|downloadxls|moz|||ABW|contextMenu|AAO|nav|iphone|ipad|SKIPPROGRESS|Item|xmiabt|ABU|AC2||FF00FF|A82|sTypeN||f0f0f0|ABM|f6f6f6|A85|AB9|localhost|maxindex|minindex||star|skip_objects_tracking|ranged|A80|969696||AD7|AAT|AC9|b6c8cf|dataload|CHARTS|ACJ|e6e6e6|AA8|AB3|dominantBaseline|svg0html|whiteSpace|legendmaximize|strong|_rgb2hex_|AD6|tspan|AD4|0x|prev|AAB|f90|pagination|forced|textBaseline|alphabetic|dyn||_rcolor_|MODULESDIR|detail|A6I|1089B3|aaa|toStaticHTML|youremail|backgroundImage|PATTERN_|comment||Original||Parsed|constructor|xyz|marker_text_|infoemail|paintMarker|screen|jsondata|yourcomment|sendcapture|checkbox|senddata|A47|source_hide|actions|999999|A8O|AAA|FORM|A8R|A14BC9||getPlacementInfo|96C245|AAS|6B7075|_title|265E96|heatmap|clipPath|A05F18|themesloaded|support|EF8535|layers|D31E1E|29A2CC|2c4a59|globals|emailmandatory|confirm|alert|INPUT|MODULESDEP|startangle|AC7|A8W||||RESIZESPEED|||||||scaletext|shiftKey|star5|Scroll||triangle|hooks|diamond|errors|bXY|Table|Zoom|removenode||AAG|delay|A31|A7N|||May|quick|effect|A97|A6E|addnode|||||||||||||||||||A8J|||||||||||Switch|||||||A6P|A7C|Hide|A8P||A96|A99|jumped|AAR|animate|A8L|A6M|ACG|ACO|mozilla|Error|graphidx|onmessage|12px|onopen|Bug|A3Y|A6Y|showtooltip|clicknode|A5K|||||||||||||||||||||||||||||||||||||State|QUOTEDVALUES|sortFaces|hint||VML|behavior|bUrl|AAD|A9X|AD8|6px|tilt|setupValueBoxWH|author|ownerNode|child|white|xb0||cluster|Send|A6C|A6V|A76|ACH|||||||||||||||||||||||||||||||||||||A6T|SORTTOKENS|A6Z|A7W||ZCVRangePlotSet|A7U|scalevalue|scalename|A7Z|A7X|A67|A7A|AAF|A6U|linecolor|A7R|A7Q|A9E|A5N|DELAYEDTRACKERS|backgroundcolor|A6D|A6F|ACD|prop|||||||||||||||A4B||||||||||||||||||||||A7Y|A6O|nodevalue|A8N||330|A92|A9B|A9V|Step|A7H|A7S|A9T|AB6|ZCVRangeGraph|ABP|ABJ|numeric|A7K|A7O|monotone|A98|setnodevalue|addplot|A8I|maxValue_||||||||||||||||||||removeplot|||||||||||||||||minValue_|modifyplot|maxValue|Screen||A8H|A9H|Full|A8Q|minValue|A8G|Scale|A56|1AB6E3|onunload|LOGO_ABOUT|AB8|A6R|addRule|rLen|A5O|A5H|IMG|ACR|A78|Email|||||||||shortcut||||||||||||||||||||||||||||sizing|ABO|indicator|ACL||getshapeinfo|A5F|getlabelinfo|getModules|candlestick|blur|setModule|band|calloutPosition||compat|A72|ACY|you|A75|blank|lineCap|A5G|A69|sFaLLx3XKTmuZ31RzkdyTnL0khU17vrf7Tm4iT5TJ0kTXHlc2iUEmBe3vSco1APRIVgiH9rX9XbSJxgQiIob4WUh3y0BNCEIEIhUFmlqACbOoTo0|Cancel||||||||||||||||||offsetEnd|||Modified||||||||||||||||use_single_canvas|formatNumber|offsetStart|Jun||population|Jul|Aug|logBase|mandatory|vstream|execFn|Sep|Oct|stepSize|use_fast_markers|fireEvent|use_fast_mode|Since|refAngle|Nov|ext|hwaterfall||textbox|report||||FB301E||||||bug||||||||||Mar|||||||||||||||||pagescroll|9B26AF|hFUVqR7S1l8G8QQJznxCUvX|preservezoom|||E2D51A|formatDate|E80C60|strict|00BAF2|callee|populationpyramid||Apr|Network|address|WBJjiPWRH11|tooltipText|March|iVBORw0KGgoAAAANSUhEUgAAAJEAAAA1CAYAAABBVQnbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABu1JREFUeNrsXLFy4zYQBW9UR7wfSHh1iqMn6S3NxLXlLp3lL5D1ARlLkw|La0dM88io1YD|clearscroll|history_back|iPhone|iPad||||||history_forward|Android|||||||problem|||||sessionStorage||||||Windows|PPC|||||||||||Mini|BlackBerry|Mobile|QWiu3TW1Sqk65M5ukh9vPzAUV||April|gLMilDUMgAYigZUm7MzAliiDBxcPu2|CSS1Compat|February|ACK|step_|DEBUG|skip_interactivity|skip_marker_tracking|skip_segment_tracking|skip_context_menu|AEL|datetime|AEK|16777215|R0lGODlhAQABAIAAAP|_inj_|wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw|getscaleinfo|getbubblesize|aCdvBK|||||||||||||||||||||||||||mDXZPwp3r||||||||||Dec|AE0|January|decodeURIComponent||getObject|vwaterfall|your|Sunday|52575C|waterfall|Mr3cMfUhWN83PYpfQ6W|0D457D|graphs|epSuudpRmrP2rclZFf1zG7cIMfzS6zh9SuAyLfJE|plothide|874600|sent|nThank|8832B0|hideplot|D66C1C|initThemes|defineModule|2F8JpusDi3zMEzINF9Q|siKWwCkzRAy|||||||||||plugin|||||||638F12||hboxplot|||||||minIndex||||||||||dataready|mapdata|i5CcR1RvRAp3VpUL4qt9AJMyMDznvcPkoxEZZ5uZ5iw9AWPm41ihhTB1TWPJIvdeJP3KZbrBr9wVnn20IMTBrkDka|maxIndex||floatbar|wWjRZKI7TbgLtHD|vfloatbar|F7F8F8|small|getGraphInfo|Apply|iFDTf4|hfloatbar|222222|boxplot|vboxplot|DCDCDC|modulesready|808285|HideDataTable|BBBBBB|BA0505|Monday|00AE4D|0392bb||||||f9c332|||||||b79007||||||||||||||||||||||||Thursday|cc3300|ef4810|Friday||SaveAsImagePNG|a62b02|00b0e1|da9b04|SaveAsImage|007fa3|89b92e|Saturday|a7da47|9b5FpaWogBlGlnahdp7f|Feb|6a921f|20398B|sHpv2CQbwcaz686qLg7mNWoOJJY|isOXJyUK|hidetooltip|1540a0|was|coWIi|05a0cd|00bbf1|||||||||||||||||Tuesday||||||||||||||||||||QrFO8i|getPalette|edf3f5|5005onWQnHXM18l0kq||iz8B4ZeKmmw8MwBobcSg7iaSoz3|Wednesday|DownloadSVG|4d62b1|SwpRBHeB1YixfuVRG1TmnSxwWyN0IJS7c9S8PojwWgDREblQFpIiZPi|DownloadPDF|0b32a0|6e4503|84680a||563d02|unbinddocument|setpage|Message|wHBB4N651NqL6UGinMV9l0tQsFtOXVkcGK4H0uBwucLPhigzT0vSLT|UmnVcu533TixhgnyNRM0dgQgplGsPAkzYXwPzOzZnC7X81FBps0ln7DE4j7FFz7lhGSYWZ0CxLkF6pdEiin27WykHHILXKaLTuPRmQGAoidX8LoScOsD145xJQUVRD|2UJYM4scG7|1D7HmGKf99x|m6yyJ|Address|Gly8ldqZxWOBc41UBB9q8UPEmcr54GRIXwBXn|||O3FaQ||||||||||||||||||||||||||||||||||hdDFeefOUPthvBZqH6TR0X6hDUge7hiiIZZWu5jebXg8rAr0aB9|Charts|mp7POvaHfv04TPly95g0ROHNJ1Ohr7lzTc|4YZrNHz1GonGOsYcTkEe8W9YT3wVaxSr||togglesource|6FLlyk7dG3KlpaSYGCr2sa7bTe1e02977rVJPCpz7R|showplot|jIo2dCfd9c1BIrIoVy0ho7y7t|sJeiZdgFxezwleaBUzwvA5n6UkuvPugJaqoIWSfS|getrender|20p2HvtBeK16w|dA4L48Qhg5heiRpTG6|Hhx|NP0t0TXQLRA8CQR3QPta0|3WsoVJfz1EIiG6|09A9DA|toggleplot|Exporting|QQYK91VtUbjbmq8u4NNX2Q6zvNCuind1hPtMMot31k4MwB5iv0CylvaRXz6O3tO5VMGBLjozKUrDyVmw8szzFZwnEo5X1VA|00384A|RW9rdQ3KGBUxLYmGuHKG4nWk8aleqiz6XSFA5N|5vv5VEjcQJ|HuIgKZX6X7wuUGhlOxoME4FvoO1RGZ88uT6XPKAOuCgxm0aK6|8txLDPrukmci|want||||||||||togglebugreport|||||||||||||||||||||||||||Has|EtDO54vP7th1HL0CpYAaiGnGtSDVnEBONJ4Xozi|Q9MX3bb2wCfKYByGWZhvt69T0pIeyF9|beforedestroy||P1EAsGUPZcSM03|qO24SRzRMfZFbXj5bHUSrAAdVHa9l97qfWF6|Occured|DzfVs2U6u|fo5HjhzDhip7IB2j91evC|G49I2399oJuNwtCxx4OksJshWZCNDEQnYqIMymkgYZJFxgJs5gFkEBxDikrmKF91jVE1ZTFR6L9rQOkZKZCrdKVtNxOQl6aiF5GGMoTpnpBNgm9PUvYd19RNtMz2WpU6h6VPIG7|ZDnzAMIzyhNVVTYKAAorAHTVgHL5pHOS|8qbrzh3uZb2RgAeNY85a8dobWVLe40u8TgsEXDhEZJrHYnq46rTuS4XhK0nrW7uQmYw1lTTL5R4jFE|5yasb|o2iVTBMSKhQr9|ZoomIn|closemodal|stcWCMb|showhoverstate|oRz1| |YqcJkkaSwzGoqS3sUE9Lyj3yhmS6Uki4yNN7PFftH|XchRDsvhtTzeR|Tj7zU0|Edgdh2omT9RRXE1hZAfaQYvmbx|unlocktooltip|||||||||||||||||||||||b7vN6MKpZRISDhBlhwCCafwTLcO||||||||||||||lILihGF6oueUH2w2pwFxT71gtonWy9SUJDEmKK0CvGikGtjg4mJ5p9xOt8mt5ndm93bTfaS3DkfLGxu525nZ779|1GKhuWDrg7Z4|MbWyNGzvXcSgKYaAL21h6hpRb5JFSiEliszxIjHVE6l798cAShQAChBIt7N8klnbQ|iVBORw0KGgoAAAANSUhEUgAAAI0AAAA8CAYAAABbyDl1AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACGZJREFUeNrsXF9oFEccno2XRE1SI9ZQLcY0oIW21miQKoi5UPtiK7m||locktooltip|cSJtJZJwX8O959NvAUQkZDUkf8FGADBt38P1SQKxwAAAABJRU5ErkJggg|ZZAmsQUXYwbyUHTR67kghQvnYMIk4k3OwKQS|C0usUJLOMetQOYTOFYVPe0KRHcl7nAGK98k8k0dUIKCXNemIq0SK1RF4LK8iEXIbCMzAUCi37flOJ8UUWGCoLNRctAQiBLrHioLkbvAIswP0CoHtcFcF0Sg6FEFgNIGAeSSg8RbWhZ5ctuW|2fH|jxVuWAXwZANAz5HirKR|LZxDvXM|Vm9CqRWkzcP7bffRMbChpuznstfMvyCHBN2fqno2RjVY2Phsbl|Jd3QAp9Q|HfEu|3bCP3jl|Oh5wrVCj0J88z3EvzDH9HlrWwe08awtzc2YcdEiTaSphVZu|gEVkGqUcFnmWmB876F18Vzb5KmaijbjDAAiZ8k|plotshow|disable|uiGel5TWZcS4vAaRk1P7VGWotrU85wFi0nOwhLtmtQ4UtMkaJjEa20agaTGkZpGIlPS0|QCaCakp9pTZyfMoNovPssYMjT3DNPI4|aOD4pDDnRmYlAXLhs4BOdIy0ki8zEjZ2hPSkVmEqZiXSyJri|7m5HGtU7wZOAJBD0jiSLTk0SmRZqSolWkkmyzlZ4kpKaZMsttpXFkapKWe1waR0JqGolMT09yGUHCMWkkJGR6kpCkkZCkkZCkkZCkkZCQpJGQpJGQpJF4yUnj|Comment|PNDI1Tbf0BMJcuX1C2LA5Wq|||||||||||||||||||||||||||||||||||||Z5lqa6GmMaJ3ovBAinRfPjKajajJvo5|mfBxXECbZeDYIpPe0riMsGKim8qBXMDEFy4hQv6tighD|b9MOl61q6el5VUkbl5r2vXKt|2OGzTacUP7||getcharttype|c5UOj7E1Ts8BhC5zljv|Mac|WELTcgScyGV0BiDqCG6wCyBa0rRQdEZC7sxaxri1ckNggRYKcr6A|link|LpR|xhtml|FHY4MQWwxllcdiZClai09I7uPapDMHQ1dwFx3FORIcy11FYlHWRWKol0Tiavz8A|adapter|hosted|AAC1LYqunMJ6bAAAAAElFTkSuQmCC|SAvgCcGK8xwwI50SqLlQK6OSmTLrrKU|ZlVA4tExPxYQAQubERqJBDtSu6hfYb2k0isoX2ztWoke06s6woRayLWJCQ5kkhIyBKR7FQIRCQEIpJjCPFn|hQWw6ePX6Nd|reply|set3dview|1Ej7LVT54f1LOOmMYlxWO50RTCw1Zk7YE7L6XckMizSxLVN7alzJNmWTuwyDO3ZlZIVekmadI4858O0S5CuoGEkWSRpJKSmkUgX|xWR15D1fqTyEALRVtLBrU|Report|RaJXhS6LycpIqpftZkRJhMO572|get3dview|||||||||||||||our||||||||||||||||||||September||implementation|hasFeature|ZXwTNiuycKjVg6UAnU1DK2x3Wc9SQUwZijotArVk4Kk4qU5mRF3NHLUJ5HzPoAy417o6|vjr5wKFyz9||XS3nq9ZiQkdaTF|appVersion|enabledPlugin|June|getpage|July|3iet|hole|vml_flag1|syv7|BasicStructure|7dLKj0u4UboHamBpK54HEm2lgisTwgbH78ucBtDG|OFFSET|LnFKxSTOo9DkvU2rLvBFpH2hcKgFpCI9d2JELujMQNsd5CRFdVWKRU2G|showmenu|openmodal|SVG11|resources|August|IBG7ZbjiyQo9iuVCa1v99GggSadJXi70rlyWQBc5wRfXX4xbsoje3ZGThb9LcDL8Sj2UF4xYKOxvCXXdPaalnYh0J2x5Cl4qgc|via|||||||||||||||6D6E71||||||||||||||||qIGWF4EW6s8yQjTBxox9eFBBGO1NxJJEzKhLAZYebk57lCGKDtnw7b7ZCKkHLUgU1CCHt6ZtigVWa4rgMwWSJhzUcfpDikDyayldG0pLWrmu9BRFOs6klob5ZW45EUUZQX6yB5pHyMBsrlJzRZbSkpafwHjpgSBqnCTeA3Q3t2qlpEDfssghz7uT7xrbnXCp2CyJSQLhe||||||keyCode|dqKYwJd|VkTCh|receive||AGC|Q8b3mQmpqvevD3VGFhuVV95PaXnbXTkr6h5M7j0mP3UDxMNo6g3TgCkSe5tiKb2QU3ttxD8PRRN7pFxkFxB|AYKc4hVyx04biDWGx1aqwPX|showversion|fs20zVRLOz3bUd0w03sL4IbTwd|eISInsEMhdnu61hMlkggN6|4XAMkpkRRnMq7BojiP4tPB82JYwmUk|Yrbjmm0HqGPfwMbPPVOYIkPRA9yAZmYwG8Boi6gtnfJ1koXBeXhD1XGagDCN53vuoeksvabYi|kDDNP30||ZRanRwIAeIoYKRkpGDIoV2G3ita8dB5x7Z9xlp1NMsJ4S5de|91MI7WR9j|ny5sogAHv4|ACT|125px|xhhvK|vk3JIhGITEQsUCtkgtslo4K1wwMRxPoBbAIXJ|zcdestroy|sFPIO77cUufurMOB4iEfoGsPNDGag0qacrn1t345|wTEATmQruIHqrjYrMQX05bnZ7kWZUYd2Fikjw2p6RJOCmTFgUow|stylesheet|||||MaEpYHUNl1tWbF|||||||||||||||||||||||||||October||Graph|||DGfGvEVBorFq3Wnhtx6Yqy9VxUZqqe0tfBMPEIF3FD|alt|mUs6KHNRO7LazssfcSfmU|hidemenu||qVNQN7LC0R1f2qsTFecq|iJamYE8hWNRD8|JoRMu03lkd|November|Ap13G5Pl60VY2tP23ebFtYgiNlhaxARkSaLYL51a4ixsAdxXPjBJ7RsSalmz60Khpy7UVCuj9tWhHxUY41VVkEK0U92kvZ2oddI5kTsGqJTF2nsDOx0A9KlKEXhWeC4cDh5LqMtRpUVxDFLH4WRJ7pV8R2LUrPCjXUn00gXG0zZ|qJhDZWB8OmFDaG8J|December|a0kBGIVqW7w5p|dM8LpS7Z4I7AprPgKguBYXu2aA2LX7m8GlM1Nbp8FbLCKMyvrDe1wnjDqwgnUruDIzESuKHqLfGHWFU7qfp2SW8w0FVssOiETQKUzH2IviWO5wqfAoJA1cjCgtAHUsfaRrLcZ0QvWmQ9U4cadgB7DRvHtyc40JGgf2PG63RS7HplhPTZ0mTpiag0dNCcPCf8YVrowDijfYCZgY1Tkjuv4VdyIvc0P7TSIJNBKIDTKNl0jjRZaxQGZGmH1bNk87wkD0iop8dj4zWuY5HnHNxg54wlS45LyQfnjCwD3BzTBCKjggaCGCnURE10kz4jLEhMHywHTcJ4OqbsLbefqsrc8SNFyxXqh6G5|getversion|KogIo6YW9puMNDROzGSFyOjaAiWlkQaEOfPrb6aEMWqLiSKwqYrEI8ioMAdpTENupKklsc8frtf1C|feature|222|414141|680876936|1473231341|1200080426|176418897|1044525330|606105819|20px|||||||||||||||389564586||||||||||||||||outset||||||gear7|gear8|gear9|1770035416||ellipse|27px|271733878|1732584194|271733879|flow|1732584193|letter|backgroundRepeat|bite|240|45705983|gear5|droplet|60px|373897302|backgroundScale|rpoly5|643717713|1069501632|165796510|||||||||003C4F||||||||||||||||rpoly6|||||rpoly7|||||||80px|rpoly8|backgroundFit|1236535329||rpoly9|rpoly|1502002290|gear3|40341101|1804603682|1990404162|42063|gear4|1958414417|2097151|224|fillType|XMLHTTP|patternUnits|objectBoundingBox|With|radialGradient|linearGradient|gradientUnits|Requested|||||||||||||||||||||||||||||||||||||viewBox|use|getoriginaljson|Microsoft||urlencoded|toggledimension|namespaces|createStyleSheet|legendscroll|cssText|cancelBubble|legend_show|returnValue|legend_maximize|legend_hide|bgcolor|Content|getgraphlength|2047|getData|tan|gradientStops|gradientColors|65536|spacing||||||||||57343||56320|56319||||||||||||||||||||||||setData|3px|55296|inline||getplotlength|borderRadius|30px|both|getplotvalues|getImageData|getnodevalue|putImageData|AG6|13px|getnodelength|getscales|701558691|rpoly4|legend_minimize|setLabel|pieAngleEnd|1309151649|pieSlice|setlabel|1560198380|||||||||||||||||||||||||||||||||||||30611744|shadowBlur|offsetR|1873313359||2054922799||ADF|objectId|AD3|1051523|lonlat2xy|ADD|1894986606|1700485571|ACX|57434055|panning|shadowColor||1416354905|pieAngleStart|145523070|198630844|9998|Ext||||lineJoin||bezierCurveTo|||userdef|||||||||Grande||||||||||Unicode|640|linecap|linejoin||480|VMLv|ADA|ADB|miterlimit|plugins|endcap|clipart|joinstyle|ADG|render_flash|343485551|718787259|1120210379|1126891415|995338651|rpoly3|1019803690|51403784|1444681467|1163531501|ic_area|lineSegmentSize|187363961|lineStyle|ic_bars|fillOffsetY|star3|568446438|1735328473|fillOffsetX|star4|405537848|star6|660478335|khtml|pixmap|38016083|star7|star8|star9|parallelogram|1926607734|composite|1272893353|shadowAlpha|530742520|421815835|640364487|76029189|722521979|358537222|681279174|1094730640|shadowDistance|155497632|1530992060||378558|35309556||shadowAngle||borderAlpha|docked|scrollHeight|insertRule|trapezoid|container|lineGapSize|1839030562|2022574463|csvdata|togglelegend|6C6D70|script|Exit|toExponential|ADI|ACZ|nStrlng4Cu|plot_modify|tOmLlc9nc9|firstChild|Module|loaded|Forward|1073741824|AAL|Sun|AGL|Low|High|Open|Mon|Tue|plot_remove|444|plot_add|1048576|1099511627776|36393D|getMilliseconds|zc_|_colorAlpha_|587|innerText|299|setscalevalues|getMonth|getDate|node_set|getDay|getSeconds|0x4000000000000|getMinutes|getHours|getUTCFullYear||getUTCMonth||getUTCDate|getUTCDay|||||getUTCMilliseconds|getUTCSeconds|getUTCMinutes|getUTCHours|setTime|0084AA|addgraph|BLACK|onviewport|c0c0c0|bcbcbc|scalenumvalue|Wed|scalepos|scaleidx|b6b6b6|b0b0b0|acacac|a6a6a6|a0a0a0|IvQ40ajd|9c9c9c|stackType|909090|negative|Fri|Sat|maxIndex_|57585B|312F30|5a5a5a|minIndex_|03rqqtR|c6c6c6|69c|xST_SWRLyFKogwOclSB|HOSTNAME|hostname|setcharttype|Core|zflags|fhx|XKoJJLnmLPUYiWUuQKAOGnuAIWrSN_ZIj_LYvS|spark|jRkihLOSfysvRQTBtQOUUO|fcfcfc|SdgZUHWKDVQ|ececec|d0d0d0|jsNorthNine|AppIdentity|09Vczmfsf|Q5G8dRWLio||7PVG0KjUnLRqnRSPOeqf6gu|e0e0e0|hpxK6BeHRUtuasojuRTPFQYdzNGN57nxLviTf1hV4lwaFjtbv|||dcdcdc|d6d6d6|tA1g0W0k7AKV1g1ouow1nG|EJLl0khmPDSKBJa8fkP70KLNtrxt5pE2yjx|addscalevalue|BLUE|compatible|STRONG|calloutOffset|calloutExtension|rectShortcut|XLS|filters|ACM|node_remove|Export|innerHeight|Out|unicodeBidi|PDF|polygon|node_add|All|Source|originalEvent|ontouchstart|TouchEvent|createEvent|HEAD|HTML|contentDocument|SVG|JPG|FFFF00|borderRadiusBottomRight|clearLayer|control|_list_|ignoreduplicates|Enable|appendseriesvalues|detachEvent|getseriesvalues|MAP|Disable|borderRadiusTopRight|Chart|calloutHeight|parentWindow|borderRadiusBottomLeft|calloutType|offsetLeft|calloutHook|offsetTop|appendseriesdata|getseriesdata||PNG|calloutWidth|pixelLeft|contentWindow|YELLOW||0000FF|808080|vml0|removescalevalue|MAGENTA|00FF00|LIME|4B0082|INDIGO|008000|fillcolor|GREEN|textpathok|0html|GRAY|FFD700|GOLD|FUCHSIA|00FFFF|CYAN|textpath|svg0|writing|A52A2A|BROWN|canvas0|MAROON|WHITE|lock|EE82EE|VIOLET|40E0D0|Linear|bolder|TURQUOISE|700|800|Log|C0C0C0|wrap|SILVER|800000|FF0000|RED|800080|PURPLE|FFC0CB|PINK|FFA500|u2014|ORANGE|000080|NAVY|Capture|ABZ|ZoomOut|legenditem|share|nodeinfo|plotinfo|kvts|pmi|pxi|legendmarker|pxv|stage|psum|pavg|pper|legendfooter|legendheader|drag|draggable|animation_step|2629743e3|045|markers|scaling|zoomToV|widths|632448e6|csize|refy|refx|blended|31556926e3|master|ADJ|ACN|base|used|view|snap|wheelDelta|2825|desc|SLIDE_TOP|EXPAND_TOP|EXPAND_BOTTOM|EXPAND_LEFT|EXPAND_RIGHT|EXPAND_HORIZONTAL|SLIDE_LEFT|SLIDE_RIGHT|stepsize|FADE_IN|viewport|SLIDE_BOTTOM|UNFOLD_HORIZONTAL|UNFOLD_VERTICAL|EXPAND|GROW|FLY_IN|EXPAND_VERTICAL|BY_PLOT_AND_NODE|08|FAST|7475|9375|625|984375|facet99|SLOW|4e3|LINEAR||BY_NODE|BACK_EASE_OUT|ELASTIC_EASE_OUT|BOUNCE_EASE_OUT|STRONG_EASE_OUT|REGULAR_EASE_OUT|NO_SEQUENCE|BY_PLOT|RefNode|dimensions|ViewAll|getselection|objectsready|cols|rows|scale_|shp_|lbl_|clearselection|setselection|si_|3dshape|legend_mouseover|legend_mouseout|gcomplete|gload|legend_|_click|feed_start|si_title|objectsinit|shape_|getobjectsbyclass|repaintobjects|setobjectsmode|settweenmode|updateobject|4096|softclear|label_|sm_|feed_clear|feed_step|clearfeed|getinterval|setinterval|feed_interval_modify|feed_stop|imges|366|histogram|plot_|clustered|selections|MIN_VALUE|extra|sequence|attributes||pair|guideh|359|guidev|ff9900|18e5|12e5|6e5|3e4|2e4|density|ABX|LINK|scrollx|Metric|gparse|crosshairy|crosshairx|noData|while|scrolly|hmixed3d|AC0|ACE|shift|always|keyval|separate|setguide|resetguide|UNFOLD|pmv|borderRadiusTopLeft|Section|content|saveasimage|cancelAnimationFrame|ProgId|section|Calibri|FileReader|x3e|510|ohlc|cancelAnimFrame|PARSED|RequestAnimationFrame|535|requestAnimationFrame|brightness|exportimage|nORIGINAL|endif|whisker|210|readAsDataURL||downloadRAW|animation_end|1500|multipart|Built|dataToCSV|RECT|Category|vnd|barWidth|CancelAnimationFrame|400px|edge|320|source_show|Sheet|2009|Build|Excel|about_hide|CancelRequestAnimationFrame|DisplayGridlines|about_show|ExitFullScreen|GoForward|forEach|scaleval|REC|GoBack|menu_item_click|graphindex|sticky|blob|postzoom|x3c|getzoom|ShowGuide|HideGuide|Progression|dimension|result|zoomtovalues|animation_start|enctype|Others|html40|hover_image|ADE|others|CDATA|IMAGE|COMMENT|EMAIL|WIDTH|HEIGHT|RENDER|RESOLUTION|END|submitreportH5|php|webkitURL|node_|https||modifier|gte|bDead'.split('|'),0,{}))}


/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_good_table__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_good_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_good_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_daterangepicker_daterangepicker_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_daterangepicker_daterangepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_daterangepicker_daterangepicker_css__);












window.$ = __webpack_require__(32);
window.jQuery = __webpack_require__(32);
window.zingchart = __webpack_require__(242);
__webpack_require__(243);
__webpack_require__(234);


window.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
window.moment = __WEBPACK_IMPORTED_MODULE_4_moment___default.a;
window.swal = __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a;
window.FileSaver = __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_good_table___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  installComponents: true,
  load: {
    key: 'AIzaSyDHP1Nt9prUCS9RbFY_BUQDnXn8I9j4ias',

    libraries: 'places'
  }
});

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
};

if (window.localStorage.getItem('token') !== null) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.getItem('token');
}

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils_js__ = __webpack_require__(573);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    backdrop: { type: Boolean, default: true },
    callback: { type: Function, default: null },
    cancelText: { type: String, default: 'Close' },
    effect: { type: String, default: null },
    large: { type: Boolean, default: false },
    okText: { type: String, default: 'Save changes' },
    small: { type: Boolean, default: false },
    title: { type: String, default: '' },
    value: { type: Boolean, required: true },
    width: { default: null }
  },
  data: function data() {
    return {
      transition: false,
      val: null
    };
  },

  computed: {
    optionalWidth: function optionalWidth() {
      if (this.width === null) {
        return null;
      } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.width)) {
        return this.width + 'px';
      }
      return this.width;
    }
  },
  watch: {
    transition: function transition(val, old) {
      if (val === old) {
        return;
      }
      var el = this.$el;
      var body = document.body;
      if (val) {
        if (this.val) {
          el.querySelector('.modal-content').focus();
          el.style.display = 'block';
          setTimeout(function () {
            return el.classList.add('in');
          }, 0);
          body.classList.add('modal-open');
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* getScrollBarWidth */])() !== 0) {
            body.style.paddingRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils_js__["a" /* getScrollBarWidth */])() + 'px';
          }
        } else {
          el.classList.remove('in');
        }
      } else {
        this.$emit(this.val ? 'opened' : 'closed');
        if (!this.val) {
          el.style.display = 'none';
          body.style.paddingRight = null;
          body.classList.remove('modal-open');
        }
      }
    },
    val: function val(_val, old) {
      this.$emit('input', _val);
      if (old === null ? _val === true : _val !== old) this.transition = true;
    },
    value: function value(val, old) {
      if (val !== old) this.val = val;
    }
  },
  methods: {
    action: function action(val, p) {
      if (val === null) {
        return;
      }
      if (val && this.callback instanceof Function) this.callback();
      this.$emit(val ? 'ok' : 'cancel', p);
      this.val = val || false;
    }
  },
  mounted: function mounted() {
    this.val = this.value;
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer'
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Components__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Components__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Navbar__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_strap__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',
  data: function data() {
    return {
      web_texts: { "aside": {}, "breadcrumb": {}, "footer": {}, "header": { "select_system": "Seleccionar Sistema ", "profile": "Perfil", "logout": "Sortir" }, "navbar": { "general_info": "Informació general", "start": "Inici", "devices": "Dispositius", "shunttings": "Maniobres", "status_system": "Estat sistema", "notifications": "Notificacions", "messages": "Missatges", "events": "Esdeveniments", "informs": "Informes i Històrics", "maximeters": "Maxímetre", "export_inform": "Exportar Informació", "inf_energetic": "Inf. Energétic", "inf_costs": "Inf. Costos", "invoice_simulation": "Simulació Factura", "annually_inform": "Inf. Anual", "app_info": "Informació APP", "sce_info": "Informació SCE" }, "sidebar": {} },
      user: '',
      system: ''
    };
  },

  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_4__Navbar___default.a,
    dropdown: __WEBPACK_IMPORTED_MODULE_5_vue_strap__["dropdown"]
  },
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },
  created: function created() {
    this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default.a);
  },
  mounted: function mounted() {
    var out = this;
    setTimeout(function () {
      out.showUser();
    }, 350);
  },

  watch: {
    '$route': function $route(to, from) {
      this.showUser();
      this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default.a);
    }
  },
  methods: {
    changeLang: function changeLang(lang) {
      switch (lang) {
        case 'cat':
          console.log("Lang CAT");
          window.localStorage.setItem('lang', 'cat');
          window.location.reload();
          break;
        case 'es':
          console.log("Lang ES");
          window.localStorage.setItem('lang', 'es');
          window.location.reload();
          break;

        default:
          return __WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default.a;
      }
    },
    click: function click() {},
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    logout: function logout() {
      window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].STORAGE_TOKEN_KEY);
      window.localStorage.removeItem('system');
      window.localStorage.removeItem('user');
      this.$router.push({ path: 'login' });
    },
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    },
    showUser: function showUser() {
      var local_user = JSON.parse(window.localStorage.getItem('user'));
      if (local_user !== null) {
        this.user = local_user;
      } else {
        this.user = { name: "S/D" };
      }

      var local_system = JSON.parse(window.localStorage.getItem('system'));
      if (local_system !== null) {
        this.system = local_system;
      } else {
        this.system = { name: " " };
      }
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-navbar',
  created: function created() {
    this._navbar = true;
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Components__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Components__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-sidebar',
  data: function data() {
    return {
      web_texts: { "aside": {}, "breadcrumb": {}, "footer": {}, "sidebar": { "select_system": "Seleccionar Sistema ", "profile": "Perfil", "logout": "Sortir" }, "navbar": { "general_info": "Informació general", "start": "Inici", "devices": "Dispositius", "shunttings": "Maniobres", "status_system": "Estat sistema", "notifications": "Notificacions", "messages": "Missatges", "events": "Esdeveniments", "informs": "Informes i Històrics", "maximeters": "Maxímetre", "export_inform": "Exportar Informació", "inf_energetic": "Inf. Energétic", "inf_costs": "Inf. Costos", "invoice_simulation": "Simulació Factura", "annually_inform": "Inf. Anual", "app_info": "Informació APP", "sce_info": "Informació SCE" }, "header": {} },
      system: { id: 0 },
      user: { id: 0 }
    };
  },
  created: function created() {
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default.a);
  },

  watch: {
    '$route': function $route(to, from) {
      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.user = JSON.parse(window.localStorage.getItem('user'));
      this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Components___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Components___default.a);
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_2__components_Footer___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components_Breadcrumb___default.a
  },
  mounted: function mounted() {
    var system = window.localStorage.getItem('system');
    if (system === null) {
      window.localStorage.removeItem('system');
      this.$router.push('/');
    }
  },

  watch: {
    '$route': function $route(to, from) {
      var system = window.localStorage.getItem('system');
      if (system === null) {
        window.localStorage.removeItem('system');
        this.$router.push('/');
      }
    }
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_AnuallSumary__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_AnuallSumary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_AnuallSumary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_AnuallSumary__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_AnuallSumary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_AnuallSumary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      spinner_electrical_summary: true,
      web_texts: { "create_annually_inform": "Crear Informe Anual", "date_range": "Rang de dates", "create": "Crear", "annually_inform": "Informe Anual" },
      slave_type: '',
      slave_types: '',
      device: '',
      devices: '',
      user_name: '',
      user_id: '',
      showInvoiceModal: false,
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      invoices: '',
      auxiliary_array: [],
      columns: [{
        label: 'Name',
        field: 'name',
        html: true
      }, {
        label: 'Start Date',
        field: 'start_datetime',
        html: true
      }, {
        label: 'Final Date',
        field: 'end_datetime',
        html: true
      }, {
        label: 'Actions',
        field: 'actions',
        html: true
      }]
    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["electrical_summary","electrical_summary"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_AnuallSumary___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_AnuallSumary___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.user_name = JSON.parse(localStorage.getItem('user')).name;
    this.user_id = JSON.parse(localStorage.getItem('user')).id;
    this.getReportsTable();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    getReportsTable: function getReportsTable() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_informs', {
        system_id: this.system.id,
        inform_type: 'electrical_summary',
        client_device: 'd'
      }).then(function (response) {
        _this.invoices = response.data;
        _this.spinner_electrical_summary = false;
      }, function (response) {
        _this.spinner_electrical_summary = false;
        console.log(response.data);
      });
    },
    downloadInvoice: function downloadInvoice(id) {
      var _this2 = this;

      this.spinner_electrical_summary = true;
      axios.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + "/api/v1/pdf/electrical_summary/" + id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.spinner_electrical_summary = false;
        var file = new File([response.data], "Electrical_Summary_" + id + ".pdf", { type: "application/pdf" });
        FileSaver.saveAs(file);
      }, function (response) {
        console.log(response);
      });
    },
    createEnergeticInform: function createEnergeticInform() {
      var _this3 = this;

      this.spinner_electrical_summary = true;
      if (document.getElementById('daterange').value !== '-') {
        axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/create_inform', {
          system_id: this.system.id,
          inform_type: 'electrical_summary',
          date_range: document.getElementById('daterange').value,
          client_device: 'd'
        }).then(function (response) {
          console.log(response.data);
          _this3.getReportsTable();
          swal({ type: 'success', title: 'Informe creat correctament' });
        }, function (response) {
          _this3.spinner_electrical_summary = false;
          console.log(response.data);
        });
      } else {
        this.spinner_electrical_summary = false;
        swal({ type: 'error', title: 'Falta Informació' });
      }
    },
    resetEnergeticForm: function resetEnergeticForm() {
      location.reload();
    },
    deleteInformApi: function deleteInformApi(id) {
      var _this4 = this;

      this.spinner_electrical_summary = true;
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/delete_inform', {
        system_id: this.system.id,
        inform_id: id,
        client_device: 'd'
      }).then(function (response) {
        console.log(response.data);
        _this4.getReportsTable();
      }, function (response) {
        console.log(response.data);
      });
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "locale": {
            "format": "MM/YYYY",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": month + 1 + "/" + year,
          "endDate": month + 1 + "/" + year
        });
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_CabalTemp__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_CabalTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_CabalTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_CabalTemp__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_CabalTemp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_CabalTemp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      web_texts: '',
      email: '',
      password: '',
      control: true,
      cabal: "S/D"
    };
  },
  created: function created() {
    this.email = window.localStorage.getItem('email');
    this.password = window.localStorage.getItem('password');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_CabalTemp___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_CabalTemp___default.a);
  },
  mounted: function mounted() {},

  methods: {
    login: function login() {
      var out = this;
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_SERVER_URL, {
        grant_type: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_GRANT_TYPE,
        client_id: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_CLIENT_ID,
        client_secret: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_CLIENT_SECRET,
        username: out.email,
        password: out.password,
        scope: ''
      }).then(function (res) {
        var token = res.data.access_token;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].STORAGE_TOKEN_KEY, token);
        console.log(token);
        out.control = false;

        out.getRealTimeEventsGenerator();
        setInterval(function () {
          out.getRealTimeEventsGenerator();
        }, 5000);
      }).catch(function (err) {
        out.email = '';
        out.password = '';
        console.log(err.message);
      });
    },
    getRealTimeEventsGenerator: function getRealTimeEventsGenerator() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: 14,
        client_device: 'd',
        vars: '[["' + 50 + '", "R$CAL_Cabal.CABAL"]]'
      }).then(function (response) {
        _this.cabal = Math.round(response.data.value * 100) / 100;
      }, function (response) {
        console.log(response);
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_CostsInform__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_CostsInform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_CostsInform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_CostsInform__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_CostsInform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_CostsInform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "create_costs_informs": "Crear informe de costes", "date_range": "Rango de fechas", "inform_name": "Nombre del informe", "model_device": "Modelo Disp.", "select_model": "Elige Modelo", "device": "Dispositivo", "create": "Crear", "costs_inform": "Informe de costes" },
      system: '',
      report: '',
      slave_types: '',
      slave_type: '',
      devices: '',
      device: '',
      showCostsInformModal: false,
      spinner_cost_inform: true,
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      costs_informs: '',
      columns: [{
        label: 'Inform Name',
        field: 'name',
        html: true
      }, {
        label: 'Dispositiu',
        field: 'name_slave',
        html: true
      }, {
        label: 'Start Date',
        field: 'start_datetime',
        html: true
      }, {
        label: 'Final Date',
        field: 'end_datetime',
        html: true
      }, {
        label: 'Actions',
        field: 'actions',
        html: true
      }]

    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["costs_inform","costs_inform"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_CostsInform___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_CostsInform___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.getSlavesType();
    this.getReportsTable();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    getSlavesType: function getSlavesType() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/slaves_type', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.slave_types = response.data;
      }, function (response) {
        console.log(response);
      });
    },
    getDeviceNumberAndVariables: function getDeviceNumberAndVariables() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/device_name_and_variables', {
        system_id: this.system.id,
        type_slave: this.slave_type,
        client_device: 'd'
      }).then(function (response) {
        _this2.devices = response.data[0];
      }, function (response) {
        console.log(response.data);
      });
    },
    getReportsTable: function getReportsTable() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_informs', {
        system_id: this.system.id,
        inform_type: 'costs_inform',
        client_device: 'd'
      }).then(function (response) {
        _this3.costs_informs = response.data;
        _this3.spinner_cost_inform = false;
      }, function (response) {
        console.log(response.data);
      });
    },
    createCostReports: function createCostReports() {
      var _this4 = this;

      this.spinner_cost_inform = true;
      if (this.report !== null && this.slave_type !== '' && this.device !== '' && document.getElementById('daterange').value !== '-') {
        axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/create_inform', {
          system_id: this.system.id,
          inform_type: 'costs_inform',
          slave_name: this.device.name,
          name: this.report,
          date_range: document.getElementById('daterange').value,
          slave_channel: "C" + this.device.ch,
          slave_id: this.device.id,
          client_device: 'd'
        }).then(function (response) {
          console.log(response.data);
          _this4.getReportsTable();
          swal({ type: 'success', title: 'Informe creat correctament' });
        }, function (response) {
          console.log(response.data);
        });
      } else {
        this.spinner_cost_inform = false;
        swal({ type: 'error', title: 'Falta Informació' });
      }
    },
    resetCostForm: function resetCostForm() {
      location.reload();
    },
    downloadCostInform: function downloadCostInform(id) {
      var _this5 = this;

      this.spinner_cost_inform = true;
      axios.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + "/api/v1/pdf/costs_inform/" + id, {
        responseType: 'arraybuffer',
        client_device: 'd'
      }).then(function (response) {
        _this5.spinner_cost_inform = false;
        var file = new File([response.data], "Cost_Report_" + id + ".pdf", { type: "application/pdf" });
        FileSaver.saveAs(file);
      }, function (response) {
        console.log(response.data);
      });
    },
    deleteInformApi: function deleteInformApi(id) {
      var _this6 = this;

      this.spinner_cost_inform = true;
      console.log("click");
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/delete_inform', {
        system_id: this.system.id,
        inform_id: id,
        client_device: 'd'
      }).then(function (response) {
        console.log(response.data);
        _this6.getReportsTable();
      }, function (response) {
        console.log(response.data);
      });
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "timePicker": true,
          "timePicker24Hour": true,
          "timePickerIncrement": 15,
          "locale": {
            "format": "DD/MM/YYYY HH:mm",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": "1/" + (month + 1) + "/" + year + " 00:00",
          "endDate": "28/" + (month + 1) + "/" + year + " 00:00"
        });
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Device__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Device__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_device_partials_CvmAnalyzer_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_device_partials_CvmAnalyzer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_device_partials_CvmAnalyzer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_device_partials_LiteAnalyzer_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_device_partials_LiteAnalyzer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_device_partials_LiteAnalyzer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_device_partials_Net4Analyzer_vue__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_device_partials_Net4Analyzer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__partials_device_partials_Net4Analyzer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_device_partials_EnergyAnalyzer__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_device_partials_EnergyAnalyzer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__partials_device_partials_EnergyAnalyzer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Device',
  data: function data() {
    return {
      web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
      system: '',
      spinner_device: true,
      devices: '',
      selected_device: 0,
      device_type: ''
    };
  },

  components: {
    CvmAnalyzer: __WEBPACK_IMPORTED_MODULE_4__partials_device_partials_CvmAnalyzer_vue___default.a,
    LiteAnalyzer: __WEBPACK_IMPORTED_MODULE_5__partials_device_partials_LiteAnalyzer_vue___default.a,
    Net4Analyzer: __WEBPACK_IMPORTED_MODULE_6__partials_device_partials_Net4Analyzer_vue___default.a,
    EnergyAnalyzer: __WEBPACK_IMPORTED_MODULE_7__partials_device_partials_EnergyAnalyzer___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Device___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Device___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.getSlaves();
  },

  methods: {
    getSlaves: function getSlaves() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_devices', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.devices = response.data;
        for (var i = 0; i < _this.devices.length; i++) {
          if (_this.devices[i].type === "CVMNET4") {
            var channel = JSON.parse(_this.devices[i].channels);
            for (var c = 0; c < channel.length; c++) {
              _this.devices.push(channel[c]);
            }
          }
        }
        _this.spinner_device = false;
      }, function (response) {
        console.log(response);
      });
    },
    selectDevice: function selectDevice() {
      var out = this;
      this.device_type = '';
      setTimeout(function () {
        out.device_type = out.selected_device.type;
      }, 50);
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_EnergeticInform__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_EnergeticInform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_EnergeticInform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_EnergeticInform__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_EnergeticInform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_EnergeticInform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "create_energetic_inform": "Crear Informe Energetic", "date_range": "Rang de dates", "create": "Crear", "energetic_inform": "Informe Energetic" },
      spinner_energetic_inform: true,
      slave_type: '',
      slave_types: '',
      device: '',
      devices: '',
      user_name: '',
      user_id: '',
      showInvoiceModal: false,
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      invoices: '',
      auxiliary_array: [],
      columns: [{
        label: 'Name',
        field: 'name',
        html: true
      }, {
        label: 'Month',
        field: 'month',
        html: true
      }, {
        label: 'Start Date',
        field: 'start_datetime',
        html: true
      }, {
        label: 'Final Date',
        field: 'end_datetime',
        html: true
      }, {
        label: 'Actions',
        field: 'actions',
        html: true
      }]
    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["energetic_inform","energetic_inform"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_EnergeticInform___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_EnergeticInform___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.user_name = JSON.parse(localStorage.getItem('user')).name;
    this.user_id = JSON.parse(localStorage.getItem('user')).id;
    this.getReportsTable();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    getReportsTable: function getReportsTable() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_informs', {
        system_id: this.system.id,
        inform_type: 'energetic_inform',
        client_device: 'd'
      }).then(function (response) {
        for (var i = 0; i < response.data.length; ++i) {
          response.data[i].start_datetime = moment(response.data[i].start_datetime, "DDMMYYYY").format('DD/MM/YYYY');
          response.data[i].end_datetime = moment(response.data[i].end_datetime, "DDMMYYYY").format('DD/MM/YYYY');
          response.data[i].name = __WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__["a" /* default */].getmonthInYears(parseInt(moment(response.data[i].start_datetime, "DDMMYYYY").format('MM')));
        }

        _this.invoices = response.data;
        _this.spinner_energetic_inform = false;
      }, function (response) {
        _this.spinner_energetic_inform = false;
        console.log(response.data);
      });
    },
    downloadInvoice: function downloadInvoice(id) {
      var _this2 = this;

      this.spinner_energetic_inform = true;
      axios.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + "/api/v1/pdf/energetic_inform/" + id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.spinner_energetic_inform = false;
        var file = new File([response.data], "Energetic_Inform_" + id + ".pdf", { type: "application/pdf" });
        FileSaver.saveAs(file);
      }, function (response) {
        console.log(response);
      });
    },
    createEnergeticInform: function createEnergeticInform() {
      var _this3 = this;

      this.spinner_energetic_inform = true;
      if (document.getElementById('daterange').value !== '-') {
        axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/create_inform', {
          system_id: this.system.id,
          inform_type: 'energetic_inform',
          date_range: document.getElementById('daterange').value,
          client_device: 'd'
        }).then(function (response) {
          console.log(response.data);
          _this3.getReportsTable();
          swal({ type: 'success', title: 'Informe creat correctament' });
        }, function (response) {
          _this3.spinner_energetic_inform = false;
          console.log(response.data);
        });
      } else {
        this.spinner_energetic_inform = false;
        swal({ type: 'error', title: 'Falta Informació' });
      }
    },
    resetEnergeticForm: function resetEnergeticForm() {
      location.reload();
    },
    deleteInformApi: function deleteInformApi(id) {
      var _this4 = this;

      this.spinner_energetic_inform = true;
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/delete_inform', {
        system_id: this.system.id,
        inform_id: id,
        client_device: 'd'
      }).then(function (response) {
        console.log(response.data);
        _this4.getReportsTable();
      }, function (response) {
        console.log(response.data);
      });
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "locale": {
            "format": "DD/MM/YYYY",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": "1/" + (month + 1) + "/" + year,
          "endDate": "28/" + (month + 1) + "/" + year
        });
      });
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Events__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Events__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "system_events": "Esdeveniments interns del sistema" },
      system: '',
      events: [],
      spinner_eve: true,
      columns: [{
        label: 'Date',
        field: 'date',
        html: true
      }, {
        label: 'Name',
        field: 'alias',
        html: true
      }, {
        label: 'Anotation',
        field: 'annotation',
        html: true
      }, {
        label: 'Value',
        field: 'value',
        html: true
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["events","events"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Events___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Events___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.getEvents();
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default.a
  },
  methods: {
    getEvents: function getEvents() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/events', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.events = response.data;
        _this.spinner_eve = false;
      }, function (response) {
        console.log(response.data);
      });
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_ExportData__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_ExportData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_ExportData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_ExportData__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_ExportData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_ExportData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_data_transformers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__partials_GeneralSpinner_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "information_analysis": "Anàlisi d'informació", "select_device": "Slececciona Dispositiu", "date_range": "Rang de dates", "select_var": "Selecciona Variable", "tension": "Tensió", "intensity": "Intensitat", "cos_phi": "Cosinus Phi", "power_factor": "Factor Pot.", "active_energy": "Energia Act.", "reactive_energy": "Energia React.", "max_demand": "Max. Demanda", "active_power": "Potencia Act.", "harmonic_intensity": "Armonic Int.", "harmonic_tension": "Armonic Ten.", "graphic": "Gràfic", "table": "Taula", "info_to_export": "Informació a Exportar", "maximeter_historical": "Històric Maxímetre" },
      devices: '',
      device: '',
      check_boxes: [],
      checked: '',
      table_data_power: [],
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      columns: [],
      multiple_values: true,
      to_show: '',
      var_type: 0,
      units_graphs: '',
      selected_device: ''
    };
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_7__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["export_data","export_data"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_ExportData___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_ExportData___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.getDevices();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    getDevices: function getDevices() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_devices', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.devices = response.data;
      }, function (response) {
        console.log(response.data);
      });
    },
    selectTableOrGraphAndBuildRequest: function selectTableOrGraphAndBuildRequest(value) {
      var req_par, to_show_internal;

      switch (parseInt(this.var_type)) {
        case 0:
          req_par = [];
          to_show_internal = [];
          break;
        case 1:
          req_par = [[this.selected_device.id.toString(), 'VI1', 'VI2', 'VI3']];
          to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
          this.units_graphs = 'V';
          break;
        case 2:
          req_par = [[this.selected_device.id.toString(), 'AI1', 'AI2', 'AI3']];
          to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
          this.units_graphs = 'A';
          break;
        case 3:
          req_par = [[this.selected_device.id.toString(), 'COSI', 'COSI1', 'COSI2', 'COSI3']];
          to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
          this.units_graphs = 'φ';
          break;
        case 4:
          req_par = [[this.selected_device.id.toString(), 'PFI']];
          to_show_internal = [['||| FP']];
          this.units_graphs = 'φ';
          break;
        case 5:
          req_par = [[this.selected_device.id.toString(), 'AE']];
          to_show_internal = [['||| kWh']];
          this.units_graphs = 'kWh';
          break;
        case 6:
          req_par = [[this.selected_device.id.toString(), 'IE']];
          to_show_internal = [['||| kWh']];
          this.units_graphs = 'kWh';
          break;
        case 7:
          req_par = [[this.selected_device.id.toString(), 'MDAPI', 'MDI']];
          to_show_internal = [['||| kW']];
          this.units_graphs = 'kW';
          break;
        case 8:
          req_par = [[this.selected_device.id.toString(), 'API', 'API1', 'API2', 'API3']];
          to_show_internal = [['||| kW', 'L1 kW', 'L2 kW', 'L3 kW']];
          this.units_graphs = 'kW';
          break;
        case 9:
          req_par = [[this.selected_device.id.toString(), 'ARM3A1', 'ARM3A2', 'ARM3A3', 'ARM5A1', 'ARM5A2', 'ARM5A3', 'ARM7A1', 'ARM7A2', 'ARM7A3']];
          to_show_internal = [['L1 %Arm.I 3', 'L2 %Arm.I 3', 'L3 %Arm.I 3', 'L1 %Arm.I 5', 'L2 %Arm.I 5', 'L3 %Arm.I 5', 'L1 %Arm.I 7', 'L2 %Arm.I 7', 'L3 %Arm.I 7']];
          this.units_graphs = '%';
          break;
        case 10:
          req_par = [[this.selected_device.id.toString(), 'ARM3V1', 'ARM3V2', 'ARM3V3', 'ARM5V1', 'ARM5V2', 'ARM5V3', 'ARM7V1', 'ARM7V2', 'ARM7V3']];
          to_show_internal = [['L1 %Arm.T 3', 'L2 %Arm.T 3', 'L3 %Arm.T 3', 'L1 %Arm.T 5', 'L2 %Arm.T 5', 'L3 %Arm.T 5', 'L1 %Arm.T 7', 'L2 %Arm.T 7', 'L3 %Arm.T 7']];
          this.units_graphs = '%';
          break;
        case 11:
          req_par = [[this.selected_device.id.toString(), 'VMX1', 'VMX2', 'VMX3']];
          to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
          this.units_graphs = 'V';
          break;
        case 12:
          req_par = [[this.selected_device.id.toString(), 'AMX1', 'AMX2', 'AMX3']];
          to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
          this.units_graphs = 'A';
          break;
        case 13:
          req_par = [[this.selected_device.id.toString(), 'COSMX', 'COSMX1', 'COSMX2', 'COSMX3']];
          to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
          this.units_graphs = 'φ';
          break;
        case 14:
          req_par = [[this.selected_device.id.toString(), 'VMN1', 'VMN2', 'VMN3']];
          to_show_internal = [['L1 V', 'L2 V', 'L3 V']];
          this.units_graphs = 'V';
          break;
        case 15:
          req_par = [[this.selected_device.id.toString(), 'AMN1', 'AMN2', 'AMN3']];
          to_show_internal = [['L1 A', 'L2 A', 'L3 A']];
          this.units_graphs = 'A';
          break;
        case 16:
          req_par = [[this.selected_device.id.toString(), 'COSMN', 'COSMN1', 'COSMN2', 'COSMN3']];
          to_show_internal = [['||| φ', 'L1 φ', 'L2 φ', 'L3 φ']];
          this.units_graphs = 'φ';
          break;
      }

      if (value === 'graph') {
        this.getGraphArrayPower(req_par, to_show_internal);
      } else if (value === 'table') {
        this.getTableArrayPower(req_par, to_show_internal);
      } else if (value === 'csv') {
        this.getDataExport(req_par, 'csv');
      } else if (value === 'xml') {
        this.getDataExport(req_par, 'xml');
      }
    },
    getTableArrayPower: function getTableArrayPower(req_par, to_show_internal) {
      var _this2 = this;

      this.headerTable(req_par, to_show_internal[0]);

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req_par),
        date_range: document.getElementById('daterange').value
      }).then(function (response) {
        _this2.to_show = 'table';
        _this2.formatTableDate(response.data);
      }, function (response) {
        console.log(response.data);
      });
    },
    headerTable: function headerTable(req_par, to_show_internal) {
      if (to_show_internal.length > 1) {
        this.multiple_values = true;
      } else {
        this.multiple_values = false;
      }

      var header_make = '[{"label": "Data i hora"}';
      for (var i = 0; i < to_show_internal.length; i++) {
        header_make += ', {"label": "' + to_show_internal[i] + '"}';
      }
      header_make += ']';
      this.columns = JSON.parse(header_make);
    },
    getDataExport: function getDataExport(req_par, format) {
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value_to_' + format, {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req_par),
        client_device: 'd',
        date_range: document.getElementById('daterange').value
      }).then(function (response) {
        console.log(response.data);


        var file = new File([response.data], "Stored_Values." + format, { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(file);
      }, function (response) {
        console.log(response.data);
      });
    },
    getGraphArrayPower: function getGraphArrayPower(req_par, to_show_internal) {
      var _this3 = this;

      console.log(req_par);

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(req_par),
        client_device: 'd',
        date_range: document.getElementById('daterange').value
      }).then(function (response) {
        var data_resp = response.data;
        var out = _this3;
        _this3.to_show = 'graph';
        var arr_before_req = req_par;

        setTimeout(function () {
          out.printGraph(__WEBPACK_IMPORTED_MODULE_5__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(data_resp, "line", to_show_internal[0]));
        }, 25);
      }, function (response) {
        console.log(response.data);
      });
    },
    printGraph: function printGraph(data) {
      var options = {
        zoomEnabled: true,
        animationEnabled: true,
        axisX: {
          valueFormatString: "DD/MM HH:mm"
        },
        axisY: {
          suffix: this.units_graphs
        },
        data: data };

      $("#chartContainer").CanvasJSChart(options);
    },
    formatTableDate: function formatTableDate(array_date) {
      for (var i = 0; i < array_date.length; i++) {
        array_date[i].dateTime = __WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__["a" /* default */].correctDateTimeAPI(__WEBPACK_IMPORTED_MODULE_6__utilities_dates_intervals__["a" /* default */].transformDateResponse(array_date[i].dateTime));
      }
      this.table_data_power = array_date;
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "locale": {
            "format": "DD/MM/YYYY",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": "1/" + (month + 1) + "/" + year,
          "endDate": "28/" + (month + 1) + "/" + year
        });
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_home_partials_EnergyCounters_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_home_partials_EnergyCounters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_home_partials_EnergyCounters_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_home_partials_AnalyzerStatus_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_home_partials_AnalyzerStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_home_partials_AnalyzerStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_home_partials_GeneratorStatus_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_home_partials_GeneratorStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__partials_home_partials_GeneratorStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_home_partials_PumpStatus_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_home_partials_PumpStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__partials_home_partials_PumpStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
      system: '',
      devices: '',
      master_dev: '',
      energy_counters: false,
      analyzers_status: false,
      generator_status: false,
      pump_status: false,
      sele_optio: '',
      tab_selected_energy: false,
      tab_selected_analyzer: false,
      tab_selected_generator: false,
      tab_selected_pump: false
    };
  },

  components: {
    EnergyCounters: __WEBPACK_IMPORTED_MODULE_4__partials_home_partials_EnergyCounters_vue___default.a,
    AnalyzerStatus: __WEBPACK_IMPORTED_MODULE_5__partials_home_partials_AnalyzerStatus_vue___default.a,
    GeneratorStatus: __WEBPACK_IMPORTED_MODULE_6__partials_home_partials_GeneratorStatus_vue___default.a,
    PumpStatus: __WEBPACK_IMPORTED_MODULE_7__partials_home_partials_PumpStatus_vue___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Home___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Home___default.a);

    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.haveAnalyzers();
  },

  methods: {
    clickNavTabs: function clickNavTabs(tab) {
      switch (tab) {
        case 'analyzer':
          this.tab_selected_analyzer = true;
          this.tab_selected_generator = false;
          this.tab_selected_pump = false;
          this.sele_optio = 'analyzer';
          break;
        case 'generator':
          this.tab_selected_generator = true;
          this.tab_selected_analyzer = false;
          this.tab_selected_pump = false;
          this.sele_optio = 'generator';
          break;
        case 'pump':
          this.tab_selected_pump = true;
          this.tab_selected_generator = false;
          this.tab_selected_analyzer = false;
          this.sele_optio = 'pump';
          break;
        default:
          console.log('Option not registered');
          break;
      }
    },
    haveAnalyzers: function haveAnalyzers() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_devices', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        var devices = response.data;
        _this.devices = devices;
        _this.analyzers_status = true;
        _this.tab_selected_analyzer = true;
        _this.sele_optio = 'analyzer';
        _this.haveGenerator(devices);
        _this.getMastersBySystem();

        if (_this.system.id === 20) {
          _this.analyzers_status = false;
          _this.tab_selected_analyzer = false;

          _this.tab_selected_energy = true;
        }
      }, function (response) {
        _this.getMastersBySystem();
        console.log(response);
      });
    },
    haveGenerator: function haveGenerator(devices) {
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].name.indexOf("Grup") > 0) {
          this.generator_status = true;
        }
      }
    },
    getMastersBySystem: function getMastersBySystem() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_masters', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this2.master_dev = response.data[0];
        _this2.havePump(response.data[0].id);
      }, function (response) {
        console.log(response);
      });
    },
    havePump: function havePump(master_id) {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
      }).then(function (response) {
        _this3.sele_optio = 'pump';
        _this3.pump_status = true;
        if (!_this3.tab_selected_analyzer) {
          _this3.tab_selected_pump = true;
        }
      }, function (response) {
        console.log(response);
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_InfoApp__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_InfoApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_InfoApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_InfoApp__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_InfoApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_InfoApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoApp',
  data: function data() {
    return {
      web_texts: { "sys_info": "Informació Sistema", "name": "Nom", "type_invoice": "Tipus Factura", "app_info": "Informació Aplicació", "app_version": "Versió de l'Aplicació", "system_energetic_control": "Systema Control Energetic" },
      system: []
    };
  },
  created: function created() {
    window.localStorage.setItem('real_time_control', '["info_app","info_app"]');
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_InfoApp___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_InfoApp___default.a);
  },
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_InvoiceSimulation__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_InvoiceSimulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_InvoiceSimulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_InvoiceSimulation__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_InvoiceSimulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_InvoiceSimulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "create_invoice_simulation": "Crear simulació de factura", "date_range": "Rang de dates", "username": "Nom usuari", "device_model": "Model dispositiu", "select_model": "Tria Model", "device": "Dispositiu", "select_device": "Tria Dispositiu", "create": "Crear", "invoice_simulation": "Simulacions de factura" },
      spinner_invoice_simulation: true,
      slave_type: '',
      slave_types: '',
      device: '',
      devices: '',
      user_name: '',
      showInvoiceModal: false,
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      invoices: '',
      columns: [{
        label: 'Username',
        field: 'name',
        html: true
      }, {
        label: 'Device',
        field: 'name_slave',
        html: true
      }, {
        label: 'Start date',
        field: 'start_datetime',
        html: true
      }, {
        label: 'Final Date',
        field: 'end_datetime',
        html: true
      }, {
        label: 'Actions',
        field: 'actions',
        html: true
      }]
    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_4_vue_strap_src_Modal___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["invoice_simulation","invoice_simulation"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_InvoiceSimulation___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_InvoiceSimulation___default.a);

    this.system = JSON.parse(localStorage.getItem('system'));
    this.user_name = JSON.parse(localStorage.getItem('user')).name;
    this.getSlavesType();
    this.getReportsTable();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    getSlavesType: function getSlavesType() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/slaves_type', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.slave_types = response.data;
      }, function (response) {
        console.log(response);
      });
    },
    getDeviceNumberAndVariables: function getDeviceNumberAndVariables() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/device_name_and_variables', {
        system_id: this.system.id,
        type_slave: this.slave_type,
        client_device: 'd'
      }).then(function (response) {
        console.log(response.data);
        _this2.devices = response.data[0];
      }, function (response) {
        console.log(response.data);
      });
    },
    getReportsTable: function getReportsTable() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/get_informs', {
        system_id: this.system.id,
        inform_type: 'invoice_simulation',
        client_device: 'd'
      }).then(function (response) {
        _this3.invoices = response.data;
        _this3.spinner_invoice_simulation = false;
      }, function (response) {
        console.log(response.data);
      });
    },
    createInvoiceReports: function createInvoiceReports() {
      var _this4 = this;

      this.spinner_invoice_simulation = true;
      if (this.slave_type !== null && this.device !== '' && document.getElementById('daterange').value !== '-') {
        axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/create_inform', {
          system_id: this.system.id,
          inform_type: 'invoice_simulation',
          slave_name: this.device.name,
          name: this.report,
          date_range: document.getElementById('daterange').value,
          slave_channel: "C" + this.device.ch,
          slave_id: this.device.id,
          client_device: 'd'
        }).then(function (response) {
          console.log(response.data);
          _this4.getReportsTable();
          swal({ type: 'success', title: 'Informe creat correctament' });
        }, function (response) {
          console.log(response.data);
        });
      } else {
        swal({
          type: 'error',
          title: 'Falta Informació'
        });
      }
    },
    resetInvoiceForm: function resetInvoiceForm() {
      location.reload();
    },
    downloadInvoice: function downloadInvoice(id) {
      var _this5 = this;

      this.spinner_invoice_simulation = true;
      axios.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + "/api/v1/pdf/invoice_simulation/" + id, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this5.spinner_invoice_simulation = false;
        var file = new File([response.data], "Invoice_Simulation_" + id + ".pdf", { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(file);
      }, function (response) {
        console.log(response);
      });
    },
    deleteInformApi: function deleteInformApi(id) {
      var _this6 = this;

      this.spinner_invoice_simulation = true;
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/delete_inform', {
        system_id: this.system.id,
        inform_id: id
      }).then(function (response) {
        console.log(response.data);
        _this6.getReportsTable();
      }, function (response) {
        console.log(response.data);
      });
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "locale": {
            "format": "DD/MM/YYYY",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": "1/" + (month + 1) + "/" + year,
          "endDate": "28/" + (month + 1) + "/" + year
        });
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Login__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Login__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      web_texts: '',
      email: '',
      password: '',
      remember: false
    };
  },
  created: function created() {
    if (window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].STORAGE_TOKEN_KEY) !== null) {
      this.$router.push('select_system');
    }
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Login___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Login___default.a);

    this.email = window.localStorage.getItem('email');
    this.password = window.localStorage.getItem('password');
  },
  mounted: function mounted() {
    if (window.localStorage.getItem('email') !== null && window.localStorage.getItem('password') !== null) {
      this.remember = true;
    }
  },

  methods: {
    rememberMe: function rememberMe() {
      if (this.remember) {
        window.localStorage.setItem('email', this.email);
        window.localStorage.setItem('password', this.password);
      }
    },
    login: function login() {
      var out = this;
      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_SERVER_URL, {
        grant_type: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_GRANT_TYPE,
        client_id: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_CLIENT_ID,
        client_secret: __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].OAUTH_CLIENT_SECRET,
        username: out.email,
        password: out.password,
        scope: ''
      }).then(function (res) {
        var token = res.data.access_token;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].STORAGE_TOKEN_KEY, token);
        console.log(token);
        out.rememberMe();
        out.$router.push('/');
      }).catch(function (err) {
        out.email = '';
        out.password = '';
        console.log(err.message);
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translates_cat_Maximeter__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translates_cat_Maximeter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__translates_cat_Maximeter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translates_es_Maximeter__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translates_es_Maximeter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__translates_es_Maximeter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_data_transformers__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__partials_GeneralSpinner_vue__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "maximeter_analysis": "Anàlisi de maxímetre", "date_range": "Rang de dates", "all_devices": "Tots els dispositius", "graph": "Gràfic", "table": "Taula", "max_historical": "Històric Maxímetre" },
      devices: '',
      device: '',
      check_boxes: [],
      checked: '',
      table_data_power: [],
      isButtonDisabled: false,
      months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
      captions: { 'ok_button': 'Seleccionar' },
      shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
      columns: [],
      multiple_values: true,
      to_show: ''
    };
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_9__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_6__utilities_middlewares__["a" /* default */].userIsLoged();
    this.web_texts = __WEBPACK_IMPORTED_MODULE_6__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_3__translates_cat_Maximeter___default.a, __WEBPACK_IMPORTED_MODULE_4__translates_es_Maximeter___default.a);
    window.localStorage.setItem('real_time_control', '["maximeter","maximeter"]');

    this.system = JSON.parse(localStorage.getItem('system'));

    this.initializeCheckBox();
  },
  mounted: function mounted() {
    this.initializeDateRangePicker();
  },

  methods: {
    initializeCheckBox: function initializeCheckBox() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].ROOT_URL + '/api/v1/get_devices', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.devices = response.data;
        for (var i = 0; i < _this.devices.length; i++) {
          if (_this.devices[i].type === "CVMNET4") {
            var channel = JSON.parse(_this.devices[i].channels);
            for (var c = 0; c < channel.length; c++) {
              _this.devices.push(channel[c]);
            }
          }
        }

        var obj = null;
        for (var i = 0; i < _this.devices.length; i++) {
          if (_this.devices[i].hasOwnProperty('ch')) {
            var _obj;

            obj = (_obj = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj, _this.devices[i].id + "_" + _this.devices[i].ch, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj, 'id', _this.devices[i].id + "_" + _this.devices[i].ch), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj, 'type', _this.devices[i].type), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj, 'name', _this.devices[i].name), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj, 'ch', _this.devices[i].ch), _obj);
          } else {
            var _obj2;

            obj = (_obj2 = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj2, _this.devices[i].id + "_0", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj2, 'id', _this.devices[i].id + "_0"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj2, 'type', _this.devices[i].type), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_obj2, 'name', _this.devices[i].name), _obj2);
          }
          _this.check_boxes.push(obj);
        }
      }, function (response) {
        console.log(response.data);
      });
    },
    checkValue: function checkValue(device_id) {
      console.log(device_id);
      for (var i = 0; i < this.check_boxes.length; i++) {
        if (typeof this.check_boxes[i][device_id] !== "undefined" && this.check_boxes[i][device_id] === 0) {
          this.check_boxes[i][device_id] = 1;
        } else if (typeof this.check_boxes[i][device_id] !== "undefined" && this.check_boxes[i][device_id] === 1) {
          this.check_boxes[i][device_id] = 0;
        }
      }
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.check_boxes));
    },
    selectTableOrGraphAndBuildRequest: function selectTableOrGraphAndBuildRequest(graph_or_table) {
      var to_show_internal = [];
      var req_par = [];
      this.to_show = 'spinner';
      this.isButtonDisabled = true;

      console.log(this.check_boxes);

      for (var i = 0; i < this.check_boxes.length; i++) {
        if (this.checked === true || this.check_boxes[i][__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.check_boxes[i])[0]] !== 0) {
          if (this.check_boxes[i].hasOwnProperty('ch')) {
            req_par.push([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.check_boxes[i])[0].split('_')[0], "MDC" + this.check_boxes[i].ch + "I"]);
            to_show_internal.push(this.check_boxes[i]);
          } else {
            req_par.push([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.check_boxes[i])[0].split('_')[0], "MDAPI", "MDI"]);
            to_show_internal.push(this.check_boxes[i]);
          }
        }
      }

      if ('graph' === graph_or_table) {
        this.getGraphArrayPower(req_par, to_show_internal);
      } else if ('table' === graph_or_table) {
        this.getTableArrayPower(req_par, to_show_internal);
      }
    },
    getTableArrayPower: function getTableArrayPower(req_par, to_show_internal) {
      var _this2 = this;

      this.headerTable(req_par, to_show_internal);

      axios.post(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(req_par),
        date_range: document.getElementById('daterange').value
      }).then(function (response) {
        _this2.to_show = 'table';
        _this2.isButtonDisabled = false;
        _this2.formatTableDate(response.data);
      }, function (response) {
        _this2.isButtonDisabled = false;
        console.log(response.data);
      });
    },
    headerTable: function headerTable(req_par, to_show_internal) {
      if (req_par.length > 1) {
        this.multiple_values = true;
      } else {
        this.multiple_values = false;
      }

      console.log(to_show_internal);

      var header_make = '[{"label": "Data i hora"}';
      for (var i = 0; i < to_show_internal.length; i++) {
        header_make += ', {"label": "' + to_show_internal[i].name + '"}';
      }
      header_make += ']';
      this.columns = JSON.parse(header_make);
    },
    getGraphArrayPower: function getGraphArrayPower(req_par, to_show_internal) {
      var _this3 = this;

      console.log(req_par);

      axios.post(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(req_par),
        client_device: 'd',
        date_range: document.getElementById('daterange').value
      }).then(function (response) {
        var data_resp = response.data;
        var out = _this3;
        _this3.to_show = 'graph';
        _this3.isButtonDisabled = false;
        var arr_before_req = req_par;

        setTimeout(function () {
          out.printGraph(__WEBPACK_IMPORTED_MODULE_7__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(data_resp, "line", out.transformIdToName(to_show_internal)));
        }, 25);
      }, function (response) {
        _this3.isButtonDisabled = false;
        console.log(response.data);
      });
    },
    printGraph: function printGraph(data) {
      var options = {
        zoomEnabled: true,
        animationEnabled: true,
        axisX: {
          valueFormatString: "DD/MM HH:mm"
        },
        axisY: {
          suffix: "kW"
        },
        data: data };

      $("#chartContainer").CanvasJSChart(options);
    },
    transformIdToName: function transformIdToName(arr_before_req) {
      var response = [];

      for (var i = 0; i < arr_before_req.length; i++) {
        response.push(arr_before_req[i].name);
      }
      return response;
    },
    formatTableDate: function formatTableDate(array_date) {
      for (var i = 0; i < array_date.length; i++) {
        array_date[i].dateTime = __WEBPACK_IMPORTED_MODULE_8__utilities_dates_intervals__["a" /* default */].correctDateTimeAPI(__WEBPACK_IMPORTED_MODULE_8__utilities_dates_intervals__["a" /* default */].transformDateResponse(array_date[i].dateTime));
      }
      this.table_data_power = array_date;
    },
    initializeDateRangePicker: function initializeDateRangePicker() {
      $(function () {
        var date = new Date();
        var month = date.getMonth();
        var year = date.getFullYear();
        $('input[name="daterange"]').daterangepicker({
          "locale": {
            "format": "DD/MM/YYYY",
            "separator": " - ",
            "applyLabel": "Acceptar",
            "cancelLabel": "Cancel·lar",
            "fromLabel": "Des de",
            "toLabel": "Fins",
            "customRangeLabel": "Custom",
            "weekLabel": "W",
            "daysOfWeek": ["dg", "dl", "dt", "dc", "dj", "dv", "ds"],
            "monthNames": ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol ", "Agost ", "Setembre", "Octubre", "Novembre", "Desembre"],
            "firstDay": 1
          },
          "startDate": "1/" + (month + 1) + "/" + year,
          "endDate": "28/" + (month + 1) + "/" + year
        });
      });
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Messages__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Messages__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Messages',
  data: function data() {
    return {
      web_texts: { "messages": "Missatges" },
      messages: [],
      spinner_message: true,
      columns: [{
        label: 'Data',
        field: 'date',
        width: '115px',
        html: true
      }, {
        label: 'Text',
        field: 'title',
        html: true
      }]
    };
  },
  created: function created() {
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Messages___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Messages___default.a);
  },
  mounted: function mounted() {
    window.localStorage.setItem('real_time_control', '["messages","messages"]');
    var system = JSON.parse(window.localStorage.getItem('system'));
    if (system === null) {
      this.$router.push('/');
    }
    this.getMessages();
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default.a
  },
  methods: {
    getMessages: function getMessages() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */].ROOT_URL + '/api/v1/notifications/get_by_system').then(function (response) {
        console.log(response.data);
        _this.messages = response.data;

        for (var i = 0; i < _this.messages.length; i++) {
          _this.messages[i].date = _this.messages[i].date + '<br>' + _this.messages[i].time;
          _this.messages[i].title = '<b>' + _this.messages[i].title + '</b> <br>' + _this.messages[i].body;
        }
        _this.spinner_message = false;
      }, function (response) {
        console.log(response.data);
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Notifications__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Notifications__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: { "notifications": "Notificacions" },
      notifications: [],
      all_notifications: [],
      systems: [],
      system_selected: [],
      spinner_notification: true,
      columns: [{
        label: 'Data',
        field: 'date',
        html: true
      }, {
        label: 'Text',
        field: 'title',
        html: true
      }]
    };
  },
  created: function created() {
    this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Notifications___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Notifications___default.a);
  },
  mounted: function mounted() {
    window.localStorage.setItem('real_time_control', '["notifications","notifications"]');
    var out = this;
    setTimeout(function () {
      out.getNotifications();
    }, 750);
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_4__partials_GeneralSpinner_vue___default.a
  },
  methods: {
    getNotifications: function getNotifications() {
      var _this = this;

      axios.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/notifications/get_notifications_by_system').then(function (response) {
        var all_notifications_loc = response.data;
        _this.findNotificationSelection(all_notifications_loc);
        _this.spinner_notification = false;
      }, function (response) {
        console.log(response.data);
      });
    },
    findNotificationSelection: function findNotificationSelection(all_notifications_loc) {
      var system_id = JSON.parse(window.localStorage.getItem('system')).id;
      var noti_par = null;

      console.log(all_notifications_loc);

      for (var i = 0; i < all_notifications_loc.length; i++) {
        if (all_notifications_loc[i].system_id === system_id) {
          this.printNotificationSelection(noti_par = all_notifications_loc[i].value);
        }
      }
    },
    printNotificationSelection: function printNotificationSelection(notifications_loc) {
      console.log(notifications_loc);
      for (var i = 0; i < notifications_loc.length; i++) {
        var n_position = JSON.parse(notifications_loc[i].notification);
        this.notifications.push({
          date: moment(notifications_loc[i].created_at, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm:ss'),
          title: '<b>' + n_position[1] + '</b> <br>' + n_position[3]
        });
      }
      console.log(this.notifications);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Profile__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Profile__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      web_texts: '',
      name: '',
      surnames: '',
      charge: '',
      phone: '',
      email: '',
      password: '',
      password_confirmation: ''
    };
  },
  created: function created() {
    window.localStorage.setItem('real_time_control', '["profile","profile"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_3__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Profile___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Profile___default.a);
    this.getUser();
  },

  methods: {
    getUser: function getUser() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].ROOT_URL + '/api/v1/get_user').then(function (response) {
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        _this.name = response.data.name;
        _this.surnames = response.data.surnames;
        _this.charge = response.data.charge;
        _this.phone = response.data.phone;
        _this.email = response.data.email;
      }, function (response) {
        console.log(response.data);
        _this.tokenValidCalls(response, _this);
      });
    },
    personalizeUser: function personalizeUser() {
      var _this2 = this;

      var formData = new FormData(document.getElementById("user-form"));
      axios.post(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].ROOT_URL + '/api/v1/edit_user_by_user', formData).then(function (response) {
        console.log(response.data);
        _this2.getUser();
      }, function (response) {
        console.log(response.data);
      });
    },
    changePassword: function changePassword() {
      var out = this;
      axios.post(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].ROOT_URL + '/api/v1/change_user_password', {
        'password': this.password,
        'password_repeat': this.password_confirmation
      }).then(function (res) {
        if (res.data === "Passwords not mach") {
          console.log(res);
          swal({ type: 'error', title: 'No Coincidents' });
        } else if (res.data === "Passwords Short") {
          console.log(res);
          swal({ type: 'error', title: 'Massa Curta' });
        } else {
          swal({ type: 'success', title: 'Fet!' });
          out.password = null;
          out.password_confirmation = null;
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_SelectSystem__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_SelectSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_SelectSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_SelectSystem__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_SelectSystem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_SelectSystem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectSystem',
  data: function data() {
    return {
      web_texts: { "select": "Seleccionar" },
      systems: '',
      spinner_systems: true
    };
  },
  created: function created() {
    window.localStorage.removeItem('system');
    window.localStorage.setItem('real_time_control', '["select_system","select_system"]');
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_SelectSystem___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_SelectSystem___default.a);
    this.getSystems();
    this.getUser();
  },

  components: {
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_5__partials_GeneralSpinner_vue___default.a
  },
  watch: {
    '$route': function $route(to, from) {
      window.localStorage.removeItem('system');
    }
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_user').then(function (response) {
        window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        _this.spinner_systems = false;
      }, function (response) {
        console.log(response.data);
        __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].tokenValidCalls(response, _this);
      });
    },
    getSystems: function getSystems() {
      var _this2 = this;

      axios.get(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_systems_and_clients_by_user').then(function (response) {
        if (response.data.length === 1) {
          console.log(response.data[0]);
          window.localStorage.setItem('system', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data[0]));
          _this2.$router.push('home');
        }
        _this2.systems = response.data;
      }, function (response) {
        console.log(response.data);
        __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].tokenValidCalls(response, _this2);
      });
    },
    selectSystem: function selectSystem(system) {
      window.localStorage.setItem('system', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(system));
      this.$router.push('home');
    },
    goNotifications: function goNotifications(system) {
      window.localStorage.setItem('system', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(system));
      this.$router.push('notifications');
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_shuntting_partials_GeneratorShunting_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_shuntting_partials_GeneratorShunting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_shuntting_partials_GeneratorShunting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_shuntting_partials_PumpShunting_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__partials_shuntting_partials_PumpShunting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__partials_shuntting_partials_PumpShunting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_shuntting_partials_DiffShunting_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__partials_shuntting_partials_DiffShunting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__partials_shuntting_partials_DiffShunting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Shunting',
  data: function data() {
    return {
      web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
      system: '',
      devices: '',
      generator_shunt: false,
      pump_shunt: false,
      diffs_shunt: false,
      tab_selected_generator: false,
      tab_selected_pump: false,
      tab_selected_diffs: false
    };
  },

  components: {
    GeneratorShunting: __WEBPACK_IMPORTED_MODULE_5__partials_shuntting_partials_GeneratorShunting_vue___default.a,
    PumpShunting: __WEBPACK_IMPORTED_MODULE_6__partials_shuntting_partials_PumpShunting_vue___default.a,
    DiffShunting: __WEBPACK_IMPORTED_MODULE_7__partials_shuntting_partials_DiffShunting_vue___default.a,
    GeneralSpinner: __WEBPACK_IMPORTED_MODULE_8__partials_GeneralSpinner_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default.a);
    this.system = JSON.parse(window.localStorage.getItem('system'));

    this.haveGenerator();
  },

  methods: {
    clickNavTabs: function clickNavTabs(tab) {
      switch (tab) {
        case 'generator':
          this.tab_selected_generator = true;
          this.tab_selected_pump = false;
          this.tab_selected_diffs = false;
          break;
        case 'pump':
          this.tab_selected_pump = true;
          this.tab_selected_generator = false;
          this.tab_selected_diffs = false;
          break;
        case 'diffs':
          this.tab_selected_diffs = true;
          this.tab_selected_pump = false;
          this.tab_selected_generator = false;
          break;
        default:
          console.log('Option not registered');
          break;
      }
    },
    haveGenerator: function haveGenerator() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_devices', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.devices = response.data;
        var devices_local = response.data;
        for (var i = 0; i < devices_local.length; i++) {
          if (devices_local[i].name.indexOf("Grup") > 0) {
            _this.generator_shunt = true;
            _this.tab_selected_generator = true;
          }
        }
        _this.getMastersBySystem();
      }, function (response) {
        _this.getMastersBySystem();
        console.log(response);
      });
    },
    getMastersBySystem: function getMastersBySystem() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_masters', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        window.localStorage.setItem('masters', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        _this2.havePump(response.data[0].id);
      }, function (response) {
        console.log(response);
      });
    },
    havePump: function havePump(master_id) {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
      }).then(function (response) {
        _this3.pump_shunt = true;
        if (!_this3.tab_selected_generator) {
          _this3.tab_selected_pump = true;
        }
        _this3.haveMagnets(master_id);
      }, function (response) {
        _this3.haveMagnets(master_id);
        console.log(response);
      });
    },
    haveMagnets: function haveMagnets(master_id) {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master_id + '", "R$EVE_E_MagnetoDif_Pou_ON.ST", "R$EVE_E_MagnetoDif_Bassa_ON.ST"]]'
      }).then(function (response) {
        _this4.diffs_shunt = true;
        if (!_this4.tab_selected_generator && !_this4.tab_selected_pump) {
          _this4.tab_selected_diffs = true;
        }
      }, function (response) {
        console.log(response);
      });
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  data: function data() {
    return {
      show_spinner: true
    };
  },
  created: function created() {
    var out = this;
    setTimeout(function () {
      out.show_spinner = false;
    }, 7500);
  },

  methods: {
    reloadPage: function reloadPage() {
      location.reload();
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['device_select'],
  data: function data() {
    return {
      web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
      device: '',
      period: 'S/D',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi: 'S/D',
      api: 'S/D',
      ae: 'S/D',
      ie: 'S/D',
      mdapi: 'S/D',
      v1: "S/D",
      v2: "S/D",
      v3: "S/D",
      v12: "S/D",
      v23: "S/D",
      v31: "S/D"
    };
  },
  created: function created() {
    console.log("Created CVM-C10");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.device = this.device_select;
    window.localStorage.setItem('real_time_control', '["devices",' + this.device.id + ']');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default.a);
    var out = this;

    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getHeadCardsInfo();

    var cvm_c10_interval = setInterval(function () {
      console.log("Interval CVM-C10");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== out.device.id) {
        console.log("Clear CVM-C10 loop");
        clearInterval(cvm_c10_interval);
      } else {
        console.log("Dev ID: " + out.device.id);
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getHeadCardsInfo();
        out.getRealTimeValues();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues();
    this.getMonthlyActiveReactiveEnergyCVMC10();
    this.getMonthlyActivePowerCVMC10();
    this.getDiaryActiveReactiveEnergy();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseInt(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "COSI", "API", "AE", "IE", "MDAPI", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31"]])
      }).then(function (response) {
        _this2.cosi = Math.round(response.data[0].value * 100) / 100;
        _this2.api = Math.round(response.data[1].value * 10) / 10;
        _this2.ae = Math.round(response.data[2].value * 100) / 100;
        _this2.ie = Math.round(response.data[3].value * 100) / 100;
        _this2.mdapi = Math.round(response.data[4].value * 100) / 100;
        _this2.v1 = Math.round(response.data[5].value * 100) / 100;
        _this2.v2 = Math.round(response.data[6].value * 100) / 100;
        _this2.v3 = Math.round(response.data[7].value * 100) / 100;
        _this2.v12 = Math.round(response.data[8].value * 100) / 100;
        _this2.v23 = Math.round(response.data[9].value * 100) / 100;
        _this2.v31 = Math.round(response.data[10].value * 100) / 100;
        _this2.printTensionGraph();
        _this2.printPowerGraph();
        _this2.printCosiGraph();
      }, function (response) {
        console.log(response);
      });
    },
    getDiaryActiveReactiveEnergy: function getDiaryActiveReactiveEnergy() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this3.printActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActiveReactiveEnergyCVMC10: function getMonthlyActiveReactiveEnergyCVMC10() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this4.printMonthlyActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "column", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerCVMC10: function getMonthlyActivePowerCVMC10() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "API"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActivePowerCVMC10(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printTensionGraph: function printTensionGraph() {
      try {
        var options = {
          data: [{
            type: "column",
            dataPoints: [{ label: "Tensió L1", y: this.v1 }, { label: "Tensió L2", y: this.v2 }, { label: "Tensió L3", y: this.v3 }]
          }]
        };

        $("#tension-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 280,
            "values": "0:" + this.pot_contracted * 1.5 + ":" + this.pot_contracted / 5,
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, parseInt(this.pot_contracted)],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted) * 1.05],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#FEFE00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted) * 1.05, parseInt(this.pot_contracted) * 1.4],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },

            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        myConfig8.series[0].values[0] = this.api;

        zingchart.render({
          id: 'active-power-cvc10',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printActiveReactiveEnergy: function printActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#active-reactive-energy-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi <= 1 && this.cosi > 0) {
          graph_value = 5 / 3 * (this.cosi - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-cvc10',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printMonthlyActivePowerCVMC10: function printMonthlyActivePowerCVMC10(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActiveReactiveEnergy: function printMonthlyActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#energy-cvc10-act-react").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['device_select'],
  data: function data() {
    return {
      web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
      device: '',
      period: 'S/D',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi: 'S/D',
      api: 'S/D',
      ae: 'S/D',
      ie: 'S/D',
      mdapi: 'S/D',
      v1: "S/D",
      v2: "S/D",
      v3: "S/D",
      v12: "S/D",
      v23: "S/D",
      v31: "S/D"
    };
  },
  created: function created() {
    console.log("Created CVM-C10");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.device = this.device_select;
    window.localStorage.setItem('real_time_control', '["devices",' + this.device.id + ']');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default.a);
    var out = this;

    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
  },
  mounted: function mounted() {
    this.getRealTimeValues();
    this.getMonthlyActiveReactiveEnergyCVMC10();
    this.getMonthlyActivePowerCVMC10();
    this.getDiaryActiveReactiveEnergy();
    this.getDiaryActivePowerCVMC10();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseInt(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "API", "AE", "IE"]])
      }).then(function (response) {
        console.log(response.data);
        _this2.api = Math.round(response.data[0].value * 10) / 10;
        _this2.ae = Math.round(response.data[1].value * 100) / 100;
        _this2.ie = Math.round(response.data[2].value * 100) / 100;
      }, function (response) {
        console.log(response);
      });
    },
    getDiaryActiveReactiveEnergy: function getDiaryActiveReactiveEnergy() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this3.printActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getDiaryActivePowerCVMC10: function getDiaryActivePowerCVMC10() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "API"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this4.printDiaryActivePowerCVMC10(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActiveReactiveEnergyCVMC10: function getMonthlyActiveReactiveEnergyCVMC10() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "column", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerCVMC10: function getMonthlyActivePowerCVMC10() {
      var _this6 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "API"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this6.printMonthlyActivePowerCVMC10(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printTensionGraph: function printTensionGraph() {
      try {
        var options = {
          data: [{
            type: "column",
            dataPoints: [{ label: "Tensió L1", y: this.v1 }, { label: "Tensió L2", y: this.v2 }, { label: "Tensió L3", y: this.v3 }]
          }]
        };

        $("#tension-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 280,
            "values": "0:" + this.pot_contracted * 1.5 + ":" + this.pot_contracted / 5,
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, parseInt(this.pot_contracted)],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted) * 1.05],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#FEFE00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted) * 1.05, parseInt(this.pot_contracted) * 1.4],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },

            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        myConfig8.series[0].values[0] = this.api;

        zingchart.render({
          id: 'active-power-cvc10',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printActiveReactiveEnergy: function printActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#active-reactive-energy-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi <= 1 && this.cosi > 0) {
          graph_value = 5 / 3 * (this.cosi - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-cvc10',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printDiaryActivePowerCVMC10: function printDiaryActivePowerCVMC10(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#active-power-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActivePowerCVMC10: function printMonthlyActivePowerCVMC10(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-cvc10").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActiveReactiveEnergy: function printMonthlyActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#energy-cvc10-act-react").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['device_select'],
  data: function data() {
    return {
      web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
      device: '',
      period: 'S/D',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi: 'S/D',
      api: 'S/D',
      ae: 'S/D',
      ie: 'S/D',
      mdapi: 'S/D',
      v1: "S/D",
      v2: "S/D",
      v3: "S/D",
      v12: "S/D",
      v23: "S/D",
      v31: "S/D"
    };
  },
  created: function created() {
    console.log("Created CVM-lite");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.device = this.device_select;
    window.localStorage.setItem('real_time_control', '["devices",' + this.device.id + ']');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default.a);
    var out = this;

    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getHeadCardsInfo();

    var cvm_lite_interval = setInterval(function () {
      console.log("Interval CVM-lite");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== out.device.id) {
        console.log("Clear CVM-lite loop");
        clearInterval(cvm_lite_interval);
      } else {
        console.log("Dev ID: " + out.device.id);
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getHeadCardsInfo();
        out.getRealTimeValues();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues();
    this.getDiaryActiveReactiveEnergyCVMLite();
    this.getMonthlyActiveReactiveEnergyCVMLite();
    this.getMonthlyActivePowerCVMLite();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseFloat(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "COSI", "API", "AE", "IE", "MDI", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31"]])
      }).then(function (response) {
        _this2.cosi = Math.round(response.data[0].value * 100) / 100;
        _this2.api = Math.round(response.data[1].value * 10) / 10;
        _this2.ae = Math.round(response.data[2].value * 100) / 100;
        _this2.ie = Math.round(response.data[3].value * 100) / 100;
        _this2.mdapi = Math.round(response.data[4].value * 100) / 100;
        _this2.v1 = Math.round(response.data[5].value * 100) / 100;
        _this2.v2 = Math.round(response.data[6].value * 100) / 100;
        _this2.v3 = Math.round(response.data[7].value * 100) / 100;
        _this2.v12 = Math.round(response.data[8].value * 100) / 100;
        _this2.v23 = Math.round(response.data[9].value * 100) / 100;
        _this2.v31 = Math.round(response.data[10].value * 100) / 100;
        _this2.printTensionGraph();
        _this2.printPowerGraph();
        _this2.printCosiGraph();
      }, function (response) {
        console.log(response);
      });
    },
    getDiaryActiveReactiveEnergyCVMLite: function getDiaryActiveReactiveEnergyCVMLite() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this3.printActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActiveReactiveEnergyCVMLite: function getMonthlyActiveReactiveEnergyCVMLite() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this4.printMonthlyActiveReactiveEnergyCVMLite(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "column", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerCVMLite: function getMonthlyActivePowerCVMLite() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "API"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActivePowerCVMLite(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printTensionGraph: function printTensionGraph() {
      try {
        var options = {
          data: [{
            type: "column",
            dataPoints: [{ label: "Tensió L1", y: this.v1 }, { label: "Tensió L2", y: this.v2 }, { label: "Tensió L3", y: this.v3 }]
          }]
        };

        $("#tension-cvmlite").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 280,
            "values": "0:" + this.pot_contracted * 1.5 + ":" + this.pot_contracted / 5,
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, parseInt(this.pot_contracted)],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted) * 1.05],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#FEFE00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted) * 1.05, parseInt(this.pot_contracted) * 1.4],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },

            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        myConfig8.series[0].values[0] = this.api;

        zingchart.render({
          id: 'active-power-cvmlite',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printActiveReactiveEnergy: function printActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#active-reactive-energy-cvmlite").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi <= 1 && this.cosi > 0) {
          graph_value = 5 / 3 * (this.cosi - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-cvmlite',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printMonthlyActivePowerCVMLite: function printMonthlyActivePowerCVMLite(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-cvmlite").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActiveReactiveEnergyCVMLite: function printMonthlyActiveReactiveEnergyCVMLite(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#energy-cvmlite-act-react").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['device_select'],
  data: function data() {
    return {
      web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
      system: '',
      device: '',
      period: 'S/D',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi: 'S/D',
      api: 'S/D',
      ae: 'S/D',
      ie: 'S/D',
      mdapi: 'S/D',
      v1: "S/D",
      v2: "S/D",
      v3: "S/D",
      v12: "S/D",
      v23: "S/D",
      v31: "S/D"
    };
  },
  created: function created() {
    console.log("Created CVM-Net4");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.device = this.device_select;
    window.localStorage.setItem('real_time_control', '["devices", "' + this.device.id + 'ch' + this.device.ch + '"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Device___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Device___default.a);
    var out = this;

    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getHeadCardsInfo();

    var cvm_net4_interval = setInterval(function () {
      console.log("Interval CVM-Net4");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== out.device.id + 'ch' + out.device.ch) {
        console.log("Clear CVM-Net4 loop");
        clearInterval(cvm_net4_interval);
      } else {
        console.log("Dev ID: " + out.device.id + "ch" + out.device.ch);
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getHeadCardsInfo();
        out.getRealTimeValues();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues();
    this.getDiaryActiveReactiveEnergyCVMNet4();
    this.getMonthlyActiveReactiveEnergyCVMNet4();
    this.getMonthlyActivePowerCVMNet4();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseFloat(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        client_device: 'd',
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "COSC" + this.device.ch + "I", "APC" + this.device.ch + "I", "AEC" + this.device.ch, "IEC" + this.device.ch, "MDC" + this.device.ch + "I", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31"]])
      }).then(function (response) {
        _this2.cosi = Math.round(response.data[0].value * 100) / 100;
        _this2.api = Math.round(response.data[1].value * 10) / 10;
        _this2.ae = Math.round(response.data[2].value * 100) / 100;
        _this2.ie = Math.round(response.data[3].value * 100) / 100;
        _this2.mdapi = Math.round(response.data[4].value * 100) / 100;
        _this2.v1 = Math.round(response.data[5].value * 100) / 100;
        _this2.v2 = Math.round(response.data[6].value * 100) / 100;
        _this2.v3 = Math.round(response.data[7].value * 100) / 100;
        _this2.v12 = Math.round(response.data[8].value * 100) / 100;
        _this2.v23 = Math.round(response.data[9].value * 100) / 100;
        _this2.v31 = Math.round(response.data[10].value * 100) / 100;
        _this2.printTensionGraph();
        _this2.printPowerGraph();
        _this2.printCosiGraph();
      }, function (response) {
        console.log(response);
      });
    },
    getDiaryActiveReactiveEnergyCVMNet4: function getDiaryActiveReactiveEnergyCVMNet4() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        client_device: 'd',
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AEC" + this.device.ch, "IEC" + this.device.ch]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this3.printActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActiveReactiveEnergyCVMNet4: function getMonthlyActiveReactiveEnergyCVMNet4() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        client_device: 'd',
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "AEC" + this.device.ch, "IEC" + this.device.ch]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this4.printMonthlyActiveReactiveEnergyCVMNet4(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "column", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerCVMNet4: function getMonthlyActivePowerCVMNet4() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        client_device: 'd',
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.device.id, "APC" + this.device.ch + "I"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActivePowerCVMNet4(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printTensionGraph: function printTensionGraph() {
      try {
        var options = {
          data: [{
            type: "column",
            dataPoints: [{ label: "Tensió L1", y: this.v1 }, { label: "Tensió L2", y: this.v2 }, { label: "Tensió L3", y: this.v3 }]
          }]
        };

        $("#tension-cvmnet4").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 280,
            "values": "0:" + this.pot_contracted * 1.5 + ":" + this.pot_contracted / 5,
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, parseInt(this.pot_contracted)],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted) * 1.05],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#FEFE00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [parseInt(this.pot_contracted) * 1.05, parseInt(this.pot_contracted) * 1.4],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },

            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        myConfig8.series[0].values[0] = this.api;

        zingchart.render({
          id: 'active-power-cvmnet4',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printActiveReactiveEnergy: function printActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#active-reactive-energy-cvmnet4").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi <= 1 && this.cosi > 0) {
          graph_value = 5 / 3 * (this.cosi - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-cvmnet4',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printMonthlyActivePowerCVMNet4: function printMonthlyActivePowerCVMNet4(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-cvmnet4").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActiveReactiveEnergyCVMNet4: function printMonthlyActiveReactiveEnergyCVMNet4(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#energy-cvmnet4-act-react").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['devices', 'master_dev'],
  data: function data() {
    return {
      web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": { "historical_active_power_diary": "Històric diari potència activa", "cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
      period: 'S/D',
      general: '',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi_general: 'S/D',
      api_general: 'S/D',
      ae_general: 'S/D',
      ie_general: 'S/D',
      mdapi_general: 'S/D',
      system_coordinates: '',
      status_analyzer: 'S/D',
      status_show_server: 'S/D',
      status_show_eds: 'S/D',
      status_show_analyzer: 'S/D'
    };
  },
  created: function created() {
    console.log("Created Analizer");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["home","analyzer"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default.a);

    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.system_coordinates = this.system.coordinates;
    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getHeadCardsInfo();

    var general_interval = setInterval(function () {
      console.log("Interval Analizer");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

      if (contr_rt[1] !== "analyzer") {
        console.log("Clear analizer loop");
        clearInterval(general_interval);
      } else {
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getRealTimeValues();
        out.getHeadCardsInfo();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues(this.getGeneralDevice());
    this.printStatusChart("rgb(145,145,145)");
    this.getDiaryActivePowerAnalyzer();
    this.getYearlyActivePowerAnalyzer();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseInt(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getGeneralDevice: function getGeneralDevice() {
      var devices = this.devices;
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].name.indexOf("General") > 0) {
          this.general = devices[i];
          this.getRealTimeValues();
          return;
        }
      }
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "COSI", "API", "AE", "IE", "STATUS", "MDAPI", "MDI"]])
      }).then(function (response) {
        _this2.cosi_general = Math.round(response.data[0].value * 100) / 100;
        _this2.api_general = Math.round(response.data[1].value * 10) / 10;
        _this2.ae_general = Math.round(response.data[2].value * 100) / 100;
        _this2.ie_general = Math.round(response.data[3].value * 100) / 100;
        _this2.status_analyzer = parseInt(response.data[4].value);
        _this2.mdapi_general = Math.round(response.data[5].value * 100) / 100;
        _this2.printPowerGraph();
        _this2.printCosiGraph();
        if (response.data[4].value === '-') {
          _this2.status_analyzer = 'S/D';
          _this2.printStatusChart("rgb(145,145,145)");
        } else {
          _this2.status_analyzer = 'OK';
          _this2.printStatusChart("rgb(0,255,0)");
        }
      }, function (response) {
        _this2.status_analyzer = 'ERROR';
        _this2.printStatusChart("rgb(255,0,0)");
        console.log(response);
      });
    },
    getDiaryActivePowerAnalyzer: function getDiaryActivePowerAnalyzer() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "API"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this3.printActivePowerAnalyzer(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getYearlyActivePowerAnalyzer: function getYearlyActivePowerAnalyzer() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "AEE"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentYearDaterange()
      }).then(function (response) {
        _this4.printYearEnergyAnalyzer(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].dataTransYearlyFormCanvasJS(response.data, "column", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printStatusChart: function printStatusChart(color) {
      try {
        var opts = {
          angle: -0.50,
          lineWidth: 0.2,
          radiusScale: 0.80,
          pointer: {
            length: 0,
            strokeWidth: 0 },
          limitMax: false,
          limitMin: false,
          strokeColor: '#E0E0E0',
          generateGradient: true,
          highDpiSupport: true,
          staticZones: [{ strokeStyle: color, min: 0, max: 100, height: 1 }]
        };
        var target = document.getElementById('status-home-analyzer');
        var gauge = new Gauge(target).setOptions(opts);
        gauge.maxValue = 100;
        gauge.setMinValue(0);
        gauge.animationSpeed = 25;
        gauge.set(100);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      var myConfig8 = {
        "type": "gauge",
        "scale-r": {
          "aperture": 280,
          "values": "0:" + parseInt(this.pot_contracted * 1.5) + ":" + parseInt(this.pot_contracted) / 5,
          "center": {
            "size": 5,
            "background-color": "#ffff",
            "border-color": "none"
          },
          "markers": [{
            "type": "area",
            "range": [0, parseInt(this.pot_contracted)],
            "offset-start": 0,
            "offset-end": 0,
            "background-color": "#00ff00",
            "alpha": 0.7
          }, {
            "type": "area",
            "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted) * 1.05],
            "offset-start": 0,
            "offset-end": 0,
            "background-color": "#FEFE00",
            "alpha": 0.7
          }, {
            "type": "area",
            "range": [parseInt(this.pot_contracted) * 1.05, parseInt(this.pot_contracted) * 1.4],
            "offset-start": 0,
            "offset-end": 0,
            "background-color": "#DF0000",
            "alpha": 0.7
          }],
          "ring": {
            "size": 10
          },

          "item": {
            "font-color": "black",
            "font-family": "Arial",
            "font-size": 12,
            "font-weight": "bold",
            "font-style": "normal",
            "offset-r": 0,
            "angle": "auto"
          }
        },
        "plot": {
          "csize": "5%",
          "size": "100%",
          "background-color": "#ffff"
        },
        "series": [{ "values": [1.016] }]
      };

      myConfig8.series[0].values[0] = this.api_general;

      zingchart.render({
        id: 'active-power-general',
        data: myConfig8,
        height: "100%",
        width: "100%"
      });
    },
    printActivePowerAnalyzer: function printActivePowerAnalyzer(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#active-power-general-diari").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi_general <= 1 && this.cosi_general > 0) {
          graph_value = 5 / 3 * (this.cosi_general - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi_general + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-general',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printYearEnergyAnalyzer: function printYearEnergyAnalyzer(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "MM/YYYY"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#ener-act-hom-analyzer").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['devices', 'master_dev'],
  data: function data() {
    return {
      web_texts: {
        "electric_params": "Paràmetres Elèctrics",
        "generator": "Grup Electrogen",
        "pump_well": "Bomba-Bassa",
        "partials": {
          "historical_active_power_diary": "Històric diari potència activa",
          "historical_active_energy": "Finals de comptadors d'energia",
          "total_energy": "Energia Activa Total Combinada",
          "cos_phi_2": "Cosinus de phi φ",
          "pot_contracted": "Pot. Contractada",
          "pot_penalty": "Pot. Penalització",
          "current_power": "Pot. Actual",
          "status": "Estat",
          "current_active_power": "Potència Activa Instantània Combinada",
          "current_active_power_combined": "Potència Activa Instantània Combinada",
          "cos_phi": "Cosinus de Phi Instantani",
          "monthly_energy_consumed": "Històric anual d'energia consumida",
          "generator_status": "Estat Grup",
          "api_general": "Pot. General",
          "api_generator": "Pot. Grup",
          "current_tension": "Tensió actual",
          "active_power": "Potència activa",
          "active_power_now": "Potència Activa Instantània Combinada",
          "active_reactive_energy": "Energia activa reactiva",
          "Cos_phi": "Cosinus de phi",
          "monthly_active_power": "Històric potencia activa mensual",
          "pump_status": "Estat Bomba",
          "flow_pump": "Cabal Bomba",
          "counter_lecture": "Lec. Comptador",
          "vol_raft": "Niv. Bassa",
          "historical_pump_activations": "Històric activacions bomba",
          "historical_low_level": "Històric nivell bassa"
        }
      },
      period: 'S/D',
      general: '',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      cosi_general: 'S/D',
      api_general: 'S/D',
      ae_general: 'S/D',
      ie_general: 'S/D',
      mdapi_general: 'S/D',
      system_coordinates: '',
      status_analyzer: 'S/D',
      status_show_server: 'S/D',
      status_show_eds: 'S/D',
      status_show_analyzer: 'S/D',
      table_energy: [["Oficines", 0], ["Taller", 0], ["Sala Pintures", 0], ["Sala Descans", 0], ["Laboratori", 0], ["Quadre General", 0], ["Recepcio", 0]]
    };
  },
  created: function created() {
    console.log("Created Energy");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["home","energy"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default.a);

    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.system_coordinates = this.system.coordinates;
    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();

    var general_interval = setInterval(function () {
      console.log("Interval Energy");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

      if (contr_rt[1] !== "energy") {
        console.log("Clear energy loop");
        clearInterval(general_interval);
      } else {
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getRealTimeValues();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues();
    this.getYearlyActivePowerAnalyzer();
  },

  methods: {
    getRealTimeValues: function getRealTimeValues() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[42, "STATUS", "API", "AE", "IE"], [43, "STATUS", "API", "AE", "IE"], [44, "STATUS", "API", "AE", "IE"], [45, "STATUS", "API", "AE", "IE"], [46, "STATUS", "API", "AE", "IE"], [47, "STATUS", "API", "AE", "IE"], [48, "STATUS", "API", "AE", "IE"]])
      }).then(function (response) {

        _this.api_general = Math.round((parseFloat(response.data[1].value) + parseFloat(response.data[5].value) + parseFloat(response.data[9].value) + parseFloat(response.data[13].value) + parseFloat(response.data[17].value) + parseFloat(response.data[21].value) + parseFloat(response.data[25].value)) * 10) / 10;

        _this.table_energy[0][1] = Math.round(parseFloat(response.data[2].value) * 100) / 100;
        _this.table_energy[1][1] = Math.round(parseFloat(response.data[6].value) * 100) / 100;
        _this.table_energy[2][1] = Math.round(parseFloat(response.data[10].value) * 100) / 100;
        _this.table_energy[3][1] = Math.round(parseFloat(response.data[14].value) * 100) / 100;
        _this.table_energy[4][1] = Math.round(parseFloat(response.data[18].value) * 100) / 100;
        _this.table_energy[5][1] = Math.round(parseFloat(response.data[22].value) * 100) / 100;
        _this.table_energy[6][1] = Math.round(parseFloat(response.data[26].value) * 100) / 100;

        _this.printPowerGraph();
        if (response.data[24].value === '-') {
          _this.status_analyzer = 'S/D';
          _this.printStatusChart("rgb(145,145,145)");
        } else {
          _this.status_analyzer = 'OK';
          _this.printStatusChart("rgb(0,255,0)");
        }
      }, function (response) {
        _this.status_analyzer = 'ERROR';
        _this.printStatusChart("rgb(255,0,0)");
        console.log(response);
      });
    },
    getDiaryActivePowerAnalyzer: function getDiaryActivePowerAnalyzer() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "API"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this2.printActivePowerAnalyzer(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getYearlyActivePowerAnalyzer: function getYearlyActivePowerAnalyzer() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[42, "AEE"]]),
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentYearDaterange()
      }).then(function (response) {
        _this3.printYearEnergyAnalyzer(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].dataTransYearlyFormCanvasJS(response.data, "column", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printStatusChart: function printStatusChart(color) {
      try {
        var opts = {
          angle: -0.50,
          lineWidth: 0.2,
          radiusScale: 0.80,
          pointer: {
            length: 0,
            strokeWidth: 0 },
          limitMax: false,
          limitMin: false,
          strokeColor: '#E0E0E0',
          generateGradient: true,
          highDpiSupport: true,
          staticZones: [{ strokeStyle: color, min: 0, max: 100, height: 1 }]
        };
        var target = document.getElementById('status-home-analyzer');
        var gauge = new Gauge(target).setOptions(opts);
        gauge.maxValue = 100;
        gauge.setMinValue(0);
        gauge.animationSpeed = 25;
        gauge.set(100);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      var myConfig8 = {
        "type": "gauge",
        "scale-r": {
          "aperture": 280,
          "values": "0:72",
          "center": {
            "size": 5,
            "background-color": "#ffff",
            "border-color": "none"
          },
          "ring": {
            "size": 10
          },

          "item": {
            "font-color": "black",
            "font-family": "Arial",
            "font-size": 12,
            "font-weight": "bold",
            "font-style": "normal",
            "offset-r": 0,
            "angle": "auto"
          }
        },
        "plot": {
          "csize": "5%",
          "size": "100%",
          "background-color": "#ffff"
        },
        "series": [{ "values": [1.016] }]
      };

      myConfig8.series[0].values[0] = this.api_general;

      zingchart.render({
        id: 'active-power-general',
        data: myConfig8,
        height: "100%",
        width: "100%"
      });
    },
    printActivePowerAnalyzer: function printActivePowerAnalyzer(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#active-power-general-diari").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var myConfig8 = {
          "type": "gauge",
          "scale-r": {
            "aperture": 180,
            "values": "0:2:0.5",
            "center": {
              "size": 5,
              "background-color": "#ffff",
              "border-color": "none"
            },
            "markers": [{
              "type": "area",
              "range": [0, 0.91],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#DF0000",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [0.91, 1.09],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#00ff00",
              "alpha": 0.7
            }, {
              "type": "area",
              "range": [1.09, 2],
              "offset-start": 0,
              "offset-end": 0,
              "background-color": "#d4ff00",
              "alpha": 0.7
            }],
            "ring": {
              "size": 10
            },
            "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],
            "item": {
              "font-color": "black",
              "font-family": "Arial",
              "font-size": 12,
              "font-weight": "bold",
              "font-style": "normal",
              "offset-r": 0,
              "angle": "auto"
            }
          },
          "plot": {
            "csize": "5%",
            "size": "100%",
            "background-color": "#ffff"
          },
          "series": [{ "values": [1.016] }]
        };

        var graph_value = 1;
        if (this.cosi_general <= 1 && this.cosi_general > 0) {
          graph_value = 5 / 3 * (this.cosi_general - 0.4);
        } else {
          graph_value = 5 / 3 * (this.cosi_general + 1) + 1;
        }

        console.log(graph_value);

        myConfig8.series[0].values[0] = graph_value;

        zingchart.render({
          id: 'cosi-general',
          data: myConfig8,
          height: "100%",
          width: "100%"
        });
      } catch (e) {
        console.log('Catch');
      }
    },
    printYearEnergyAnalyzer: function printYearEnergyAnalyzer(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "MM/YYYY"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#ener-act-hom-analyzer").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['devices', 'master_dev'],
  data: function data() {
    return {
      web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": { "historical_active_power_diary": "Històric diari potència activa", "cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
      general: '',
      generator: '',
      generator_status: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      api_general: 'S/D',
      cosi_generator: 'S/D',
      api_generator: 'S/D',
      ae_generator: 'S/D',
      ie_generator: 'S/D',
      v1_generator: 'S/D',
      v2_generator: 'S/D',
      v3_generator: 'S/D',
      v12_generator: 'S/D',
      v23_generator: 'S/D',
      v31_generator: 'S/D',
      status_generator: 'S/D',
      mdapi_generator: 'S/D'
    };
  },
  created: function created() {
    console.log("Created Generator");
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["home","generator"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default.a);

    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.getRealTimeEventsGenerator();
    this.getHeadCardsInfo();

    var generator_interval = setInterval(function () {
      console.log("Interval Generator");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== "generator") {
        console.log("Clear generator loop");
        clearInterval(generator_interval);
      } else {
        out.getRealTimeValues();
        out.getRealTimeEventsGenerator();
        out.getHeadCardsInfo();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getRealTimeValues(this.getGeneralGeneratorDevice());
    this.getDiaryActiveReactiveEnergy();
    this.getMonthlyActivePowerGenerator();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.pot_contracted = parseInt(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getGeneralGeneratorDevice: function getGeneralGeneratorDevice() {
      var devices = this.devices;
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].name.indexOf("General") > 0) {
          this.general = devices[i];
        } else if (devices[i].name.indexOf("Grup") > 0) {
          this.generator = devices[i];
        }
      }
    },
    getRealTimeEventsGenerator: function getRealTimeEventsGenerator() {
      var _this2 = this;

      var master = this.master_dev;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master.id + '", "R$EVE_E_GrupOFF.ST"]]'
      }).then(function (response) {
        if (parseInt(response.data.value) === 0) {
          _this2.generator_status = "Grup ON";
        } else {
          _this2.generator_status = "Grup OFF";
        }
      }, function (response) {
        console.log(response);
      });
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "API"], [this.generator.id, "COSI", "API", "AE", "IE", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31", "MDAPI"]])
      }).then(function (response) {
        _this3.api_general = Math.round(response.data[0].value * 10) / 10;
        _this3.cosi_generator = Math.round(response.data[1].value * 100) / 100;
        _this3.api_generator = Math.round(response.data[2].value * 100) / 100;
        _this3.ae_generator = Math.round(response.data[3].value * 100) / 100;
        _this3.ie_generator = Math.round(response.data[4].value * 100) / 100;
        _this3.v1_generator = Math.round(response.data[5].value * 100) / 100;
        _this3.v2_generator = Math.round(response.data[6].value * 100) / 100;
        _this3.v3_generator = Math.round(response.data[7].value * 100) / 100;
        _this3.v12_generator = Math.round(response.data[8].value * 100) / 100;
        _this3.v23_generator = Math.round(response.data[9].value * 100) / 100;
        _this3.v31_generator = Math.round(response.data[10].value * 100) / 100;
        _this3.mdapi_generator = Math.round(response.data[11].value * 100) / 100;

        _this3.printTensionGraph();
        _this3.printPowerGraph();
        _this3.printCosiGraph();
      }, function (response) {
        console.log(response);
      });
    },
    getDiaryActiveReactiveEnergy: function getDiaryActiveReactiveEnergy() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.generator.id, "AE", "IE"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentDayDaterange()
      }).then(function (response) {
        _this4.printActiveReactiveEnergy(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerGenerator: function getMonthlyActivePowerGenerator() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.generator.id, "API"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActivePowerGenerator(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printTensionGraph: function printTensionGraph() {
      try {
        var options = {
          data: [{
            type: "column",
            dataPoints: [{ label: "Tensió L1", y: this.v1_generator }, { label: "Tensió L2", y: this.v2_generator }, { label: "Tensió L3", y: this.v3_generator }]
          }]
        };

        $("#tension-generator").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printPowerGraph: function printPowerGraph() {
      try {
        var opts = {
          angle: -0.35,
          lineWidth: 0.2,
          radiusScale: 0.80,
          pointer: {
            length: 0.58,
            strokeWidth: 0.029,
            color: '#000000' },
          limitMax: false,
          limitMin: false,
          strokeColor: '#E0E0E0',
          generateGradient: true,
          highDpiSupport: true,
          renderTicks: {
            divisions: 4,
            divWidth: 1.1,
            divLength: 0.7,
            divColor: '#333333',
            subDivisions: 3,
            subLength: 0.5,
            subWidth: 0.6,
            subColor: '#666666'
          },
          staticLabels: {
            font: "12px sans-serif",
            labels: [0, this.pot_contracted, this.pot_contracted * 1.05, this.pot_contracted * 1.5],
            color: "#000000",
            fractionDigits: 0 },
          staticZones: [{ strokeStyle: "rgb(0,255,0)", min: 0, max: this.pot_contracted, height: 1 }, { strokeStyle: "rgb(255,255,0)", min: this.pot_contracted + 1, max: this.pot_contracted * 1.05, height: 1 }, { strokeStyle: "rgb(255,0,0)", min: this.pot_contracted * 1.05 + 1, max: this.pot_contracted * 1.5, height: 1 }]
        };
        var target = document.getElementById('active-power-generator');
        var gauge = new Gauge(target).setOptions(opts);
        gauge.maxValue = this.pot_contracted * 1.5;
        gauge.setMinValue(0);
        gauge.animationSpeed = 25;
        gauge.set(this.api_generator);
      } catch (e) {
        console.log("Catch");
      }
    },
    printActiveReactiveEnergy: function printActiveReactiveEnergy(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "HH:mm"
          },
          axisY: {
            suffix: "kWh"
          },
          data: data };

        $("#active-reactive-energy-generator").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printCosiGraph: function printCosiGraph() {
      try {
        var opts = {
          angle: -0,
          lineWidth: 0.2,
          radiusScale: 0.55,
          pointer: {
            length: 0.58,
            strokeWidth: 0.025,
            color: '#000000' },
          limitMax: false,
          limitMin: false,
          strokeColor: '#E0E0E0',
          generateGradient: true,
          highDpiSupport: true,
          renderTicks: {
            divisions: 4,
            divWidth: 1.1,
            divLength: 0.7,
            divColor: '#333333',
            subDivisions: 3,
            subLength: 0.5,
            subWidth: 0.6,
            subColor: '#666666'
          },
          staticLabels: {
            font: "12px sans-serif",
            labels: [-0.95, 0.95],
            color: "#000000",
            fractionDigits: 2 },
          staticZones: [{ strokeStyle: "rgb(0,255,0)", min: -1, max: -0.95, height: 1 }, { strokeStyle: "rgb(255,0,0)", min: -0.94, max: 0.94, height: 1 }, { strokeStyle: "rgb(0,255,0)", min: 0.95, max: 1, height: 1 }]
        };
        var target = document.getElementById('cosi-generator');
        var gauge = new Gauge(target).setOptions(opts);
        gauge.maxValue = 1;
        gauge.setMinValue(-1);
        gauge.animationSpeed = 1;
        gauge.set(this.cosi_generator);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyActivePowerGenerator: function printMonthlyActivePowerGenerator(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-gen").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['devices', 'master_dev'],
  data: function data() {
    return {
      web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": { "historical_active_power_diary": "Històric diari potència activa", "cos_phi_2": "Cosinus de phi φ", "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "historical_pump_activations": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
      general: '',
      pump_status: 'S/D',
      flow_pump: '0',
      counter_lecture: 'S/D',
      prc_raft: 'S/D',
      vol_raft: 'S/D',
      class_card_color: 'card-success'
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["home","pump"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Home___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Home___default.a);

    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));
    console.log("Created Pump");
    this.getGeneralGeneratorDevice();
    this.getPumpWellValues();

    var pump_interval = setInterval(function () {
      console.log("Interval Pump");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));

      if (contr_rt[1] !== "pump") {
        console.log("Clear pump loop");
        clearInterval(pump_interval);
      } else {
        out.getPumpWellValues();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getMonthlyWellPercLevel();
  },

  methods: {
    getGeneralGeneratorDevice: function getGeneralGeneratorDevice() {
      var devices = this.devices;
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].name.indexOf("General") > 0) {
          this.general = devices[i];
          this.getMonthlyActivePowerGeneral();
        }
      }
    },
    getPumpWellValues: function getPumpWellValues() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + this.master_dev.id + '", "R$EVE_E_Bomba_ON.ST", "R$CAL_LecturaComptador.M3", "R$CAL_NivellBassa.PERC", "R$CAL_NivellBassa.M3"]]'
      }).then(function (response) {
        console.log(response.data);
        if (parseInt(response.data[0].value) === 1) {
          _this.pump_status = "ON";
        } else if (parseInt(response.data[0].value) === 0) {
          _this.pump_status = "OFF";
        } else {
          _this.pump_status = "S/D";
        }

        if (response.data[1].value === "-") {
          _this.counter_lecture = 'S/D';
        } else {
          _this.counter_lecture = Math.round(response.data[1].value * 100) / 100;
        }

        if (response.data[2].value === "-") {
          _this.prc_raft = 'S/D';
        } else {
          _this.prc_raft = Math.round(response.data[2].value * 100) / 100;
        }

        if (response.data[3].value === '-') {
          _this.vol_raft = "S/D";
        } else {
          _this.vol_raft = Math.round(response.data[3].value * 100) / 100;
        }
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerGeneral: function getMonthlyActivePowerGeneral() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "API"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this2.printMonthlyActivePowerGeneral(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyWellPercLevel: function getMonthlyWellPercLevel() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.master_dev.id, "R$CAL_NivellBassa.PERC"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this3.printMonthlyRaftPerc(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["Nivell Bassa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printMonthlyActivePowerGeneral: function printMonthlyActivePowerGeneral(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-gen-pump").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    printMonthlyRaftPerc: function printMonthlyRaftPerc(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "%"
          },
          data: data };

        $("#well-level").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Shuntting__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translates_cat_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Shuntting__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_es_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_es_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DiffShunting',
  data: function data() {
    return {
      web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
      system: '',
      masters: '',
      mag_dif_well: 'S/D',
      mag_dif_raft: 'S/D',
      list_events_raft: [],
      list_events_well: [],
      columns: [{
        label: 'Data',
        field: 'date',
        type: 'date',
        inputFormat: 'DD/MM/YYYY HH:mm:ss',
        width: '180px',
        html: true
      }, {
        label: 'Dispositiu',
        field: 'shunter',
        html: true
      }, {
        label: 'Estat',
        field: 'value',
        html: true
      }]
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["shunt","diffs_shunt"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_2__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_0__translates_cat_Shuntting___default.a, __WEBPACK_IMPORTED_MODULE_1__translates_es_Shuntting___default.a);
    var out = this;

    this.system = JSON.parse(window.localStorage.getItem('system'));
    this.masters = JSON.parse(window.localStorage.getItem('masters'));

    this.haveMagnets(this.masters[0].id);
    this.getEventsGenerator('well', 'R$EVE_E_MagnetoDif_Pou_ON');
    this.getEventsGenerator('raft', 'R$EVE_E_MagnetoDif_Bassa_ON');

    console.log("Created diffs Shunt");
    var diffs_shunt_interval = setInterval(function () {
      console.log("Interval diffs Shunt");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== "diffs_shunt") {
        console.log("Clear diffs Shunt");
        clearInterval(diffs_shunt_interval);
      }
    }, 5000);
  },

  methods: {
    haveMagnets: function haveMagnets(master_id) {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master_id + '", "R$EVE_E_MagnetoDif_Pou_ON.ST", "R$EVE_E_MagnetoDif_Bassa_ON.ST"]]'
      }).then(function (response) {
        if (response.data[0].value = 1) {
          _this.mag_dif_well = "ON";
        } else if (response.data[0].value = 0) {
          _this.mag_dif_well = "OFF";
        } else {
          _this.mag_dif_well = "S/D";
        }

        if (response.data[1].value = 1) {
          _this.mag_dif_raft = "ON";
        } else if (response.data[1].value = 0) {
          _this.mag_dif_raft = "OFF";
        } else {
          _this.mag_dif_raft = "S/D";
        }
      }, function (response) {
        console.log(response);
      });
    },
    getEventsGenerator: function getEventsGenerator(control_par, eve_par) {
      var _this2 = this;

      var control = control_par;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/event', {
        system_id: this.system.id,
        event: eve_par,
        client_device: 'd',
        date_range: dateRanges.currentMonthDaterange()
      }).then(function (response) {
        function reverseEve(st) {
          if (st === "ON") {
            return "OFF";
          } else {
            return "ON";
          }
        }

        var response_return = [];
        if (response.data.hasOwnProperty("record")) {
          for (var i = 0; i < response.data.record.length; i++) {
            response_return.push({
              date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
              shunter: "Grup",
              value: reverseEve(response.data.record[i].value)
            });
          }
        }

        if (control === "well") {
          _this2.list_events_well = response_return;
        } else if (control === "raft") {
          _this2.list_events_raft = response_return;
        }
      }, function (response) {
        console.log(response.data);
      });
    },
    changeStatusMagDif: function changeStatusMagDif(element_par, new_value_par) {
      var _this3 = this;

      var element = element_par;
      var new_value = new_value_par;
      swal({
        title: 'Maniobra Mag/Diff!',
        text: "Està segur que vol posar el mag/diff a " + new_value + "?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        if (result.value) {
          if (element === 'raft') {
            _this3.forceVariableFunction("LM4A-NivellBassa", "DO2", 1);
          } else {
            _this3.forceVariableFunction("EDS-Roijals", "DO5", 1);
          }
        }
      });
    },
    forceVariableFunction: function forceVariableFunction(device, var_to_change, new_value) {
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/shunting_action', {
        system_id: this.system.id,
        device: device,
        var_to_change: var_to_change,
        client_device: 'd',
        new_value: new_value
      }).then(function (response) {
        console.log(response.data);
        swal('Completat!', 'Acció completada correctament.', 'success');
      }, function (response) {
        console.log(response.data);
        swal('ERROR', 'Acció no completada', 'error');
      });
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GeneratorShunting',
  props: ['devices'],
  data: function data() {
    return {
      web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
      general: '',
      period: 'S/D',
      masters: '',
      current_datetime: 'S/D',
      pot_contracted: 'S/D',
      class_card_color: 'card-success',
      api_general: 'S/D',
      api_generator: 'S/D',
      generator_status: 'S/D',
      contactor_status: 'S/D',
      selector_status: 'S/D',
      list_events: [],
      columns: [{
        label: 'Data',
        field: 'date',
        type: 'date',
        inputFormat: 'DD/MM/YYYY HH:mm:ss',
        width: '180px',
        html: true
      }, {
        label: 'Dispositiu',
        field: 'shunter',
        html: true
      }, {
        label: 'Estat',
        field: 'value',
        html: true
      }]
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["shunt","generator_shunt"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default.a);
    var out = this;
    this.system = JSON.parse(window.localStorage.getItem('system'));

    console.log("Created Generator Shunt");
    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getHeadCardsInfo();
    this.getRealTimeValues(this.getGeneralDevice());
    this.getMasterEventsGeneratorRT(JSON.parse(window.localStorage.getItem('masters')));

    var generator_shunt_interval = setInterval(function () {
      console.log("Interval Generator Shunt");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== "generator_shunt") {
        console.log("Clear Generator Shunt");
        clearInterval(generator_shunt_interval);
      } else {
        this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        out.getHeadCardsInfo();
        out.getRealTimeValues();
        out.getMasterEventsGeneratorRT(JSON.parse(window.localStorage.getItem('masters')));
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getEventsGenerator();
    this.getMonthlyActivePowerComparator();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        client_device: 'd',
        system_id: this.system.id
      }).then(function (response) {
        _this.period = response.data.period;
        _this.pot_contracted = parseInt(response.data.pot_contracted);
      }, function (response) {
        console.log(response);
      });
    },
    getGeneralDevice: function getGeneralDevice() {
      var devices = this.devices;
      for (var i = 0; i < devices.length; i++) {
        if (devices[i].name.indexOf("General") > 0) {
          this.general = devices[i];
        } else if (devices[i].name.indexOf("Grup") > 0) {
          this.generator = devices[i];
        }
      }
    },
    getRealTimeValues: function getRealTimeValues() {
      var _this2 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.general.id, "API"], [this.generator.id, "API"]])
      }).then(function (response) {
        _this2.api_general = Math.round(response.data[0].value * 10) / 10;
        _this2.api_generator = Math.round(response.data[1].value * 10) / 10;
      }, function (response) {
        console.log(response.data);
      });
    },
    getEventsGenerator: function getEventsGenerator() {
      var _this3 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/event', {
        system_id: this.system.id,
        event: "R$EVE_E_GrupOFF",
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        function reverseEve(st) {
          if (st === "ON") {
            return "OFF";
          } else {
            return "ON";
          }
        }

        var response_return = [];
        if (response.data.hasOwnProperty("record")) {
          for (var i = 0; i < response.data.record.length; i++) {
            response_return.push({
              date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
              shunter: "Grup",
              value: reverseEve(response.data.record[i].value)
            });
          }
        }
        _this3.list_events = response_return;
      }, function (response) {
        console.log(response.data);
      });
    },
    getMasterEventsGeneratorRT: function getMasterEventsGeneratorRT(masters) {
      var _this4 = this;

      var master_id = masters[0].id;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[master_id, "R$EVE_E_GrupOFF.ST", "R$EVE_I_Selector.ST", "R$EVE_M_ContactorCamares.ST", "R$EVE_M_ContactorXarxa.ST"]])
      }).then(function (response) {
        console.log(response.data);
        if (parseInt(response.data[0].value) === 1) {
          _this4.generator_status = "OFF";
        } else if (parseInt(response.data[0].value) === 0) {
          _this4.generator_status = "ON";
        } else {
          _this4.generator_status = "S/D";
        }

        if (parseInt(response.data[1].value) === 1) {
          _this4.selector_status = "MAN";
        } else if (parseInt(response.data[1].value) === 0) {
          _this4.selector_status = "AUTO";
        } else {
          _this4.selector_status = "S/D";
        }

        if (parseInt(response.data[2].value) === 1) {
          _this4.contactor_status = "GRUP";
        } else if (parseInt(response.data[3].value) === 1) {
          _this4.contactor_status = "XARXA";
        } else {
          _this4.contactor_status = "S/D";
        }
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyActivePowerComparator: function getMonthlyActivePowerComparator() {
      var _this5 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[this.generator.id, "API"], [this.general.id, "API"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyActivePowerComparator(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["Pot. Grup", "Pot. General"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printMonthlyActivePowerComparator: function printMonthlyActivePowerComparator(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "kW"
          },
          data: data };

        $("#pot-act-gen-gru-comparador").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    changeGeneratorStatus: function changeGeneratorStatus() {
      var _this6 = this;

      swal({
        title: 'Maniobra Grup!',
        text: "Està segur que vol posar el grup a OFF?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        if (result.value) {
          _this6.forceVariableFunction(_this6.masters, "DO5", 1);
        }
      });
    },
    forceVariableFunction: function forceVariableFunction(device, var_to_change, new_value) {
      var master_name = device[0].name;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/shunting_action', {
        system_id: this.system.id,
        device: master_name,
        var_to_change: var_to_change,
        client_device: 'd',
        new_value: new_value
      }).then(function (response) {
        console.log(response.data);
        swal('Completat!', 'Acció completada correctament.', 'success');
      }, function (response) {
        console.log(response.data);
        swal('ERROR', 'Acció no completada', 'error');
      });
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__ = __webpack_require__(8);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PumpShunting',
  data: function data() {
    return {
      web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
      period: 'S/D',
      current_datetime: 'S/D',
      raft_level: 'S/D',
      class_card_color: 'card-success',
      cabdal: '0',
      pump_status: 'S/D',
      selector_status: 'S/D',
      contactor_status: 'S/D',
      meter_lecture: 'S/D',
      list_events: [],
      columns: [{
        label: 'Data',
        field: 'date',
        type: 'date',
        inputFormat: 'DD/MM/YYYY HH:mm:ss',
        width: '180px',
        html: true
      }, {
        label: 'Dispositiu',
        field: 'shunter',
        html: true
      }, {
        label: 'Estat',
        field: 'value',
        html: true
      }]
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].userIsLoged();
    window.localStorage.setItem('real_time_control', '["shunt","pump_shunt"]');
    this.web_texts = __WEBPACK_IMPORTED_MODULE_4__utilities_middlewares__["a" /* default */].selectTranslation(__WEBPACK_IMPORTED_MODULE_1__translates_cat_Shuntting___default.a, __WEBPACK_IMPORTED_MODULE_2__translates_es_Shuntting___default.a);
    var out = this;

    this.system = JSON.parse(window.localStorage.getItem('system'));

    console.log("Created pump Shunt");
    this.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
    this.getMasterEventsPumpRT(JSON.parse(window.localStorage.getItem('masters')));
    this.getPumpEvents(JSON.parse(window.localStorage.getItem('masters')));
    this.getHeadCardsInfo();

    var merter_lec_arr = 0;
    var cabal_interval = null;
    setTimeout(function () {
      merter_lec_arr = out.meter_lecture;
      cabal_interval = setInterval(function () {
        if (out.meter_lecture !== 'S/D') {
          if (out.pump_status === "ON") {
            out.cabal = (out.meter_lecture - merter_lec_arr) / 10 * 360;

            merter_lec_arr = out.meter_lecture;
          } else {
            out.cabal = 0;
          }
        }
      }, 10000);
    }, 1500);

    var pump_shunt_interval = setInterval(function () {
      console.log("Interval pump Shunt");
      var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
      if (contr_rt[1] !== "pump_shunt") {
        console.log("Clear pump Shunt");
        clearInterval(pump_shunt_interval);
        clearInterval(cabal_interval);
      } else {
        out.current_datetime = __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].getCurrentDateTime();
        var master = JSON.parse(window.localStorage.getItem('masters'));
        out.getMasterEventsPumpRT(master);
        out.getPumpEvents(master);
        out.getHeadCardsInfo();
      }
    }, 5000);
  },
  mounted: function mounted() {
    this.getMonthlyWellPercLevel(JSON.parse(window.localStorage.getItem('masters')));
    this.getEventsPump();
  },

  methods: {
    getHeadCardsInfo: function getHeadCardsInfo() {
      var _this = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
        system_id: this.system.id,
        client_device: 'd'
      }).then(function (response) {
        _this.period = response.data.period;
      }, function (response) {
        console.log(response);
      });
    },
    getMasterEventsPumpRT: function getMasterEventsPumpRT(masters) {
      var _this2 = this;

      var master_id = masters[0].id;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[master_id, "R$CAL_LecturaComptador.M3", "R$CAL_NivellBassa.PERC"]])
      }).then(function (response) {
        if (response.data[0].value !== '-') {
          _this2.meter_lecture = Math.round(parseFloat(response.data[0].value) * 100) / 100;
        } else {
          _this2.meter_lecture = "S/D";
        }
        if (response.data[1].value !== '-') {
          _this2.raft_level = Math.round(parseFloat(response.data[1].value) * 100) / 100;
        } else {
          _this2.raft_level = "S/D";
        }
      }, function (response) {
        console.log(response.data);
      });
    },
    getPumpEvents: function getPumpEvents(masters) {
      var _this3 = this;

      var master_id = masters[0].id;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/real_time_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
      }).then(function (response) {
        if (parseInt(response.data[0].value) === 1) {
          _this3.pump_status = "ON";
        } else if (parseInt(response.data[1].value) === 1) {
          _this3.pump_status = "OFF";
        } else {
          _this3.pump_status = "S/D";
        }

        console.log(response.data);

        if (parseInt(response.data[2].value) === 1) {
          _this3.contactor_status = "ON";
        } else if (parseInt(response.data[3].value) === 1) {
          _this3.contactor_status = "OFF";
        } else if (parseInt(response.data[4].value) === 1) {
          _this3.contactor_status = "AUTO";
        } else {
          _this3.contactor_status = "S/D";
        }

        if (parseInt(response.data[5].value) === 0) {
          _this3.selector_status = "AUTO";
        } else {
          _this3.selector_status = "MAN";
        }
      }, function (response) {
        console.log(response);
      });
    },
    getEventsPump: function getEventsPump() {
      var _this4 = this;

      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/event', {
        system_id: this.system.id,
        event: "R$EVE_E_Bomba_ON",
        client_device: 'd',
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        console.log(response.data);
        var response_return = [];
        if (response.data.hasOwnProperty("record")) {
          for (var i = 0; i < response.data.record.length; i++) {
            response_return.push({
              date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
              shunter: "On-line",
              value: response.data.record[i].value
            });
          }
        }
        _this4.list_events = response_return;
      }, function (response) {
        console.log(response.data);
      });
    },
    getMonthlyWellPercLevel: function getMonthlyWellPercLevel(masters) {
      var _this5 = this;

      var master_id = masters[0].id;
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/stored_value_master', {
        system_id: this.system.id,
        client_device: 'd',
        vars: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([[master_id, "R$CAL_NivellBassa.PERC"]]),
        date_range: __WEBPACK_IMPORTED_MODULE_5__utilities_dates_intervals__["a" /* default */].currentMonthDaterange()
      }).then(function (response) {
        _this5.printMonthlyRaftPerc(__WEBPACK_IMPORTED_MODULE_6__utilities_data_transformers__["a" /* default */].lineDataTransformCanvasJS(response.data, "line", ["Nivell Bassa"]));
      }, function (response) {
        console.log(response.data);
      });
    },
    printMonthlyRaftPerc: function printMonthlyRaftPerc(data) {
      try {
        var options = {
          zoomEnabled: true,
          animationEnabled: true,
          axisX: {
            valueFormatString: "DD/MM/YYYY HH:mm"
          },
          axisY: {
            suffix: "%"
          },
          data: data };

        $("#perc-aigua-bassa").CanvasJSChart(options);
      } catch (e) {
        console.log("Catch");
      }
    },
    onOffPump: function onOffPump(shunt) {
      var master = JSON.parse(window.localStorage.getItem('masters'));
      var out = this;
      switch (shunt) {
        case "ON_pump":
          swal({
            title: 'Confirmació',
            text: "Està segur que vol engegar la bomba?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(function (result) {
            if (result.value) {
              out.forceVariableFunction(master[0].name, "DO4", 1);
            }
          });
          break;
        case "OFF_pump":
          swal({
            title: 'Confirmació',
            text: "Està segur que vol apagar la bomba?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(function (result) {
            if (result.value) {
              out.forceVariableFunction(master[0].name, "DO5", 1);
            }
          });
          break;
        case "MAN":
          swal({
            title: 'Confirmació',
            text: "Està segur que col posar el mode manual?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(function (result) {
            if (result.value) {
              out.forceVariableFunction(master[0].name, "DO6", 1);
            }
          });
          break;
        case "AUTO":
          swal({
            title: 'Confirmació',
            text: "Està segur que vol posar el mode automàtic?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
          }).then(function (result) {
            if (result.value) {
              out.forceVariableFunction(master[0].name, "DO6", 0);
            }
          });
          break;
        default:
          break;
      }
    },
    forceVariableFunction: function forceVariableFunction(device, var_to_change, new_value) {
      axios.post(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].ROOT_URL + '/api/v1/shunting_action', {
        system_id: this.system.id,
        device: device,
        var_to_change: var_to_change,
        client_device: 'd',
        new_value: new_value
      }).then(function (response) {
        console.log(response.data);
      }, function (response) {
        console.log(response.data);
      });
    }
  }
});

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 109,
	"./af.js": 109,
	"./ar": 116,
	"./ar-dz": 110,
	"./ar-dz.js": 110,
	"./ar-kw": 111,
	"./ar-kw.js": 111,
	"./ar-ly": 112,
	"./ar-ly.js": 112,
	"./ar-ma": 113,
	"./ar-ma.js": 113,
	"./ar-sa": 114,
	"./ar-sa.js": 114,
	"./ar-tn": 115,
	"./ar-tn.js": 115,
	"./ar.js": 116,
	"./az": 117,
	"./az.js": 117,
	"./be": 118,
	"./be.js": 118,
	"./bg": 119,
	"./bg.js": 119,
	"./bm": 120,
	"./bm.js": 120,
	"./bn": 121,
	"./bn.js": 121,
	"./bo": 122,
	"./bo.js": 122,
	"./br": 123,
	"./br.js": 123,
	"./bs": 124,
	"./bs.js": 124,
	"./ca": 125,
	"./ca.js": 125,
	"./cs": 126,
	"./cs.js": 126,
	"./cv": 127,
	"./cv.js": 127,
	"./cy": 128,
	"./cy.js": 128,
	"./da": 129,
	"./da.js": 129,
	"./de": 132,
	"./de-at": 130,
	"./de-at.js": 130,
	"./de-ch": 131,
	"./de-ch.js": 131,
	"./de.js": 132,
	"./dv": 133,
	"./dv.js": 133,
	"./el": 134,
	"./el.js": 134,
	"./en-au": 135,
	"./en-au.js": 135,
	"./en-ca": 136,
	"./en-ca.js": 136,
	"./en-gb": 137,
	"./en-gb.js": 137,
	"./en-ie": 138,
	"./en-ie.js": 138,
	"./en-nz": 139,
	"./en-nz.js": 139,
	"./eo": 140,
	"./eo.js": 140,
	"./es": 143,
	"./es-do": 141,
	"./es-do.js": 141,
	"./es-us": 142,
	"./es-us.js": 142,
	"./es.js": 143,
	"./et": 144,
	"./et.js": 144,
	"./eu": 145,
	"./eu.js": 145,
	"./fa": 146,
	"./fa.js": 146,
	"./fi": 147,
	"./fi.js": 147,
	"./fo": 148,
	"./fo.js": 148,
	"./fr": 151,
	"./fr-ca": 149,
	"./fr-ca.js": 149,
	"./fr-ch": 150,
	"./fr-ch.js": 150,
	"./fr.js": 151,
	"./fy": 152,
	"./fy.js": 152,
	"./gd": 153,
	"./gd.js": 153,
	"./gl": 154,
	"./gl.js": 154,
	"./gom-latn": 155,
	"./gom-latn.js": 155,
	"./gu": 156,
	"./gu.js": 156,
	"./he": 157,
	"./he.js": 157,
	"./hi": 158,
	"./hi.js": 158,
	"./hr": 159,
	"./hr.js": 159,
	"./hu": 160,
	"./hu.js": 160,
	"./hy-am": 161,
	"./hy-am.js": 161,
	"./id": 162,
	"./id.js": 162,
	"./is": 163,
	"./is.js": 163,
	"./it": 164,
	"./it.js": 164,
	"./ja": 165,
	"./ja.js": 165,
	"./jv": 166,
	"./jv.js": 166,
	"./ka": 167,
	"./ka.js": 167,
	"./kk": 168,
	"./kk.js": 168,
	"./km": 169,
	"./km.js": 169,
	"./kn": 170,
	"./kn.js": 170,
	"./ko": 171,
	"./ko.js": 171,
	"./ky": 172,
	"./ky.js": 172,
	"./lb": 173,
	"./lb.js": 173,
	"./lo": 174,
	"./lo.js": 174,
	"./lt": 175,
	"./lt.js": 175,
	"./lv": 176,
	"./lv.js": 176,
	"./me": 177,
	"./me.js": 177,
	"./mi": 178,
	"./mi.js": 178,
	"./mk": 179,
	"./mk.js": 179,
	"./ml": 180,
	"./ml.js": 180,
	"./mr": 181,
	"./mr.js": 181,
	"./ms": 183,
	"./ms-my": 182,
	"./ms-my.js": 182,
	"./ms.js": 183,
	"./mt": 184,
	"./mt.js": 184,
	"./my": 185,
	"./my.js": 185,
	"./nb": 186,
	"./nb.js": 186,
	"./ne": 187,
	"./ne.js": 187,
	"./nl": 189,
	"./nl-be": 188,
	"./nl-be.js": 188,
	"./nl.js": 189,
	"./nn": 190,
	"./nn.js": 190,
	"./pa-in": 191,
	"./pa-in.js": 191,
	"./pl": 192,
	"./pl.js": 192,
	"./pt": 194,
	"./pt-br": 193,
	"./pt-br.js": 193,
	"./pt.js": 194,
	"./ro": 195,
	"./ro.js": 195,
	"./ru": 196,
	"./ru.js": 196,
	"./sd": 197,
	"./sd.js": 197,
	"./se": 198,
	"./se.js": 198,
	"./si": 199,
	"./si.js": 199,
	"./sk": 200,
	"./sk.js": 200,
	"./sl": 201,
	"./sl.js": 201,
	"./sq": 202,
	"./sq.js": 202,
	"./sr": 204,
	"./sr-cyrl": 203,
	"./sr-cyrl.js": 203,
	"./sr.js": 204,
	"./ss": 205,
	"./ss.js": 205,
	"./sv": 206,
	"./sv.js": 206,
	"./sw": 207,
	"./sw.js": 207,
	"./ta": 208,
	"./ta.js": 208,
	"./te": 209,
	"./te.js": 209,
	"./tet": 210,
	"./tet.js": 210,
	"./th": 211,
	"./th.js": 211,
	"./tl-ph": 212,
	"./tl-ph.js": 212,
	"./tlh": 213,
	"./tlh.js": 213,
	"./tr": 214,
	"./tr.js": 214,
	"./tzl": 215,
	"./tzl.js": 215,
	"./tzm": 217,
	"./tzm-latn": 216,
	"./tzm-latn.js": 216,
	"./tzm.js": 217,
	"./uk": 218,
	"./uk.js": 218,
	"./ur": 219,
	"./ur.js": 219,
	"./uz": 221,
	"./uz-latn": 220,
	"./uz-latn.js": 220,
	"./uz.js": 221,
	"./vi": 222,
	"./vi.js": 222,
	"./x-pseudo": 223,
	"./x-pseudo.js": 223,
	"./yo": 224,
	"./yo.js": 224,
	"./zh-cn": 225,
	"./zh-cn.js": 225,
	"./zh-hk": 226,
	"./zh-hk.js": 226,
	"./zh-tw": 227,
	"./zh-tw.js": 227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;

/***/ }),
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  "data-v-7733ab98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  "data-v-73e8c7f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  "data-v-10b79161",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-99f86698",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  "data-v-707b2ab5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  "data-v-7fa91412",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  "data-v-37e084dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  "data-v-673529a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  "data-v-7927e9b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-6c2ebdfb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-8db58994",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  "data-v-2becab2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-bdb11c0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  "data-v-16a401bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  "data-v-39aee5a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-d139bafe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  "data-v-79c0be86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(529),
  /* scopeId */
  "data-v-0734e18d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  "data-v-26d1361e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(528),
  /* scopeId */
  "data-v-0012e0d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  "data-v-96969640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  "data-v-5d5eb9a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  "data-v-0bf1b28b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  "data-v-2baff069",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  "data-v-27844a34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  "data-v-7d7b2618",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  "data-v-29658f6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  "data-v-089092d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(Math.round(_vm.pot_contracted * 1.05 * 100) / 100) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_penalty))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api_now))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cosi) + " φ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cosi))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi) + " φ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-cvmlite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvmlite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvmlite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-cvmlite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvmlite"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvmlite-act-react"
    }
  })])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted * 1.05) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_penalty))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api_now))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cosi) + " φ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cosi))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi) + " φ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvc10-act-react"
    }
  })])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.raft_level) + " %")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.raft_level))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.cabdal) + " m"), _c('sup', [_vm._v("3")]), _vm._v("/h")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cabdal))])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pump_status))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pump_status))])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-share font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.start_mode))])]), _vm._v(" "), (_vm.contactor_status === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-warning btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("ON\n            ")]) : (_vm.contactor_status === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("OFF\n            ")]) : (_vm.contactor_status === 'AUTO') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("AUTO\n            ")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.physical_selector))])]), _vm._v(" "), (_vm.selector_status === 'AUTO') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.onOffPump('AUTO')
      }
    }
  }, [_vm._v("\n              AUTO\n            ")]) : (_vm.selector_status === 'MAN') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.onOffPump('MAN')
      }
    }
  }, [_vm._v("\n              MAN\n            ")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-flag font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pump_status))])]), _vm._v(" "), (_vm.pump_status === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("OFF")]) : (_vm.pump_status === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("ON\n            ")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-control-end font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.shunting))])]), _vm._v(" "), (_vm.pump_status === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-warning btn-lg btn-block",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        _vm.onOffPump('ON_pump')
      }
    }
  }, [_vm._v("\n              ON\n            ")]) : (_vm.pump_status === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-warning btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        _vm.onOffPump('OFF_pump')
      }
    }
  }, [_vm._v("\n              OFF\n            ")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.historical_shunting))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.historical_raft_level))])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-compass fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "perc-aigua-bassa"
    }
  })])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.status_analyzer))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_active_power_combined))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.current_active_power_combined))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_general) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_energy))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[0][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[0][1]) + "kWh")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[1][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[1][1]) + "kWh")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[2][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[2][1]) + "kWh")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[3][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[3][1]) + "kWh")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[4][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[4][1]) + "kWh")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[5][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[5][1]) + "kWh")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#a9b3ff"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[6][0]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.table_energy[6][1]) + "kWh")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.total_energy))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(Math.round(_vm.table_energy[0][1] + _vm.table_energy[1][1] + _vm.table_energy[2][1] + _vm.table_energy[3][1] + _vm.table_energy[4][1] + _vm.table_energy[5][1] + _vm.table_energy[6][1] * 100) / 100) + " kW")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v("Estat SCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "status-home-analyzer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-general"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#576bff"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "col-md-2",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispositiu")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Lectura")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dispositiu")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Lectura")])])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.create_costs_informs))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "cost-inform",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('label', {
    attrs: {
      "for": "report"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.inform_name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report),
      expression: "report"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "report",
      "name": "report",
      "size": "1",
      "placeholder": "Nom informe"
    },
    domProps: {
      "value": (_vm.report)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.report = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "slave_type"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.model_device))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slave_type),
      expression: "slave_type"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "slave_type",
      "name": "slave_type",
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slave_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getDeviceNumberAndVariables()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_model))]), _vm._v(" "), _vm._l((_vm.slave_types), function(slave_type) {
    return (slave_type !== 'Irrimation') ? _c('option', {
      domProps: {
        "value": slave_type
      }
    }, [_vm._v("\n                      " + _vm._s(slave_type) + "\n                    ")]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "chose_device"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device),
      expression: "device"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "chose_device",
      "name": "chose_device",
      "size": "1",
      "disabled": !_vm.slave_type
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.type == 'CVM' || device.type == 'CVMNET' || device.type == 'CVMMINI') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "offset-lg-4 col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner_cost_inform
    },
    on: {
      "click": function($event) {
        _vm.createCostReports()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(_vm._s(_vm.web_texts.create))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.spinner_cost_inform
    },
    on: {
      "click": function($event) {
        _vm.resetCostForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.costs_inform))])]), _vm._v(" "), (_vm.spinner_cost_inform) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.costs_informs,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name_slave))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.start_datetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.end_datetime))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.downloadCostInform(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteInformApi(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })])])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "user-form",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Surnames")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surnames),
      expression: "surnames"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "surnames",
      "placeholder": "Surnames"
    },
    domProps: {
      "value": (_vm.surnames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surnames = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charge),
      expression: "charge"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "charge",
      "placeholder": "Charge"
    },
    domProps: {
      "value": (_vm.charge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.charge = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.personalizeUser()
      }
    }
  }, [_vm._v("Edit User")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "login-form",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "form-control-label"
  }, [_vm._v("Repeat Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_confirmation),
      expression: "password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "placeholder": "Repeat Password"
    },
    domProps: {
      "value": (_vm.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_confirmation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changePassword()
      }
    }
  }, [_vm._v("Change Password")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Editar Perfil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Canviar Constrasenya")])])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvc10-act-react"
    }
  })])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pump_status))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pump_status))])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.flow_pump) + " m"), _c('sup', [_vm._v("3")]), _vm._v("/h")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.flow_pump))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning",
    staticStyle: {
      "min-height": "82px"
    }
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "155%"
    }
  }, [_vm._v(_vm._s(_vm.counter_lecture) + " m"), _c('sup', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.counter_lecture))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.prc_raft) + " %")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.vol_raft) + " " + _vm._s(_vm.vol_raft) + " m"), _c('sup', [_vm._v("3")])])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_pump_activations))])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_low_level))])]), _vm._v(" "), _vm._m(5)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-compass fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-gen-pump"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "well-level"
    }
  })])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.contracted_power))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_general) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.general_power))])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_generator) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.generator_power))])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shunting_status))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.selector_status))])]), _vm._v(" "), (_vm.selector_status === 'AUTO') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("AUTO")]) : (_vm.selector_status === 'MAN') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("MAN")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-share font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.contactor_status))])]), _vm._v(" "), (_vm.contactor_status === 'XARXA') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.net_supply))]) : (_vm.contactor_status === 'GRUP') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.generator))]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-flag font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.generator_status))])]), _vm._v(" "), (_vm.generator_status === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("OFF")]) : (_vm.generator_status === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("ON")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-control-end font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.emergency_stop))])]), _vm._v(" "), (_vm.generator_status === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.deactivated))]) : (_vm.generator_status === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeGeneratorStatus()
      }
    }
  }, [_vm._v("OFF")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.compare_powers))])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-gen-gru-comparador"
    }
  })])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.generator_status))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.generator_status))])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_general) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_general))])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_generator) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_generator))])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12_generator) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23_generator) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31_generator) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_power))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.active_power_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_generator) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive_energy))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.active_power_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_generator) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cos_phi_2))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.Cos_phi) + " |||")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi_generator) + " φ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.monthly_active_power))])]), _vm._v(" "), _vm._m(8)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-gen"
    }
  })])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.spinner_message) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" " + _vm._s(_vm.web_texts.messages))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.messages,
      "paginate": true,
      "perPage": 10
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.information_analysis))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.select_device))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_device),
      expression: "selected_device"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-01",
      "name": "select-01"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_device))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.name !== 'Irrimation' && device.type !== 'CVMNET4' && device.type !== 'LM4A') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.select_var))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.var_type),
      expression: "var_type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-02",
      "name": "select-02"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.var_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_var))]), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.tension))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.intensity))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.cos_phi))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.power_factor))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.active_energy))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.reactive_energy))]), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.max_demand))]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.active_power))]), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.harmonic_intensity))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.harmonic_tension))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v(_vm._s('MAX. ' + _vm.web_texts.tension))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v(_vm._s('MAX. ' + _vm.web_texts.intensity))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v(_vm._s('MAX. ' + _vm.web_texts.cos_phi))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v(_vm._s('MIN. ' + _vm.web_texts.tension))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v(_vm._s('MIN. ' + _vm.web_texts.intensity))]) : _vm._e(), _vm._v(" "), (_vm.system.id !== 20) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v(_vm._s('MIN. ' + _vm.web_texts.cos_phi))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('graph')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" " + _vm._s(_vm.web_texts.graphic) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('table')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.web_texts.table) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 right"
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('csv')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" CSV\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('xml')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" XML\n              ")])])])])])])]), _vm._v(" "), (_vm.to_show === 'spinner') ? _c('GeneralSpinner') : (_vm.to_show === 'table') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.info_to_export))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.table_data_power,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.dateTime))]), _vm._v(" "), _vm._l((props.row.field), function(lectures) {
          return (_vm.multiple_values) ? _c('td', [_vm._v(_vm._s(Math.round(lectures.value * 100) / 100 + ' ' + _vm.units_graphs))]) : _vm._e()
        }), _vm._v(" "), (!_vm.multiple_values) ? _c('td', [_vm._v(_vm._s(Math.round(props.row.field.value * 100) / 100 + ' ' + _vm.units_graphs))]) : _vm._e()]
      }
    }])
  })], 1)])])]) : (_vm.to_show === 'graph') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.maximeter_historical))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "chartContainer"
    }
  })])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn margin-top-30"
  }, [(_vm.spinner_systems) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.systems), function(system) {
    return _c('div', {
      staticClass: "col-sm-6 col-md-4 col-xl-3"
    }, [_c('div', {
      staticClass: "card border-primary"
    }, [_c('div', {
      staticClass: "card-header text-center"
    }, [_vm._v("\n          " + _vm._s(system.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('gmap-map', {
      attrs: {
        "id": "mapsystem",
        "center": {
          lat: parseFloat(system.coordinates.split('#')[0]),
          lng: parseFloat(system.coordinates.split('#')[1])
        },
        "zoom": 9,
        "map-type-id": "hybrid"
      }
    }, [_c('gmap-marker', {
      attrs: {
        "position": {
          lat: parseFloat(system.coordinates.split('#')[0]),
          lng: parseFloat(system.coordinates.split('#')[1])
        }
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('div', {
      staticClass: "row flex-nowrap"
    }, [_c('div', {
      staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectSystem(system)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bullseye"
    }), _vm._v(" " + _vm._s(_vm.web_texts.select) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"
    }, [_c('button', {
      staticClass: "btn btn-outline-success btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goNotifications(system)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bell-o"
    })])])])])])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.tab_selected_energy && !_vm.analyzers_status && !_vm.generator_status && !_vm.pump_status) ? _c('GeneralSpinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-select-style col-md-12 mb-12"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill"
  }, [(_vm.analyzers_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_analyzer
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('analyzer')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.electric_params) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.generator_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_generator
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('generator')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.generator) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.pump_status) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_pump
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('pump')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.pump_well) + "\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-12"
  }, [(_vm.tab_selected_analyzer) ? _c('div', [_c('AnalyzerStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_generator) ? _c('div', [_c('GeneratorStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_pump) ? _c('div', [_c('PumpStatus', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : (_vm.tab_selected_energy) ? _c('div', [_c('EnergyCounters', {
    attrs: {
      "devices": _vm.devices,
      "master_dev": _vm.master_dev
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['modal', _vm.effect],
    attrs: {
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        _vm.backdrop && _vm.action(false, 1)
      },
      "transitionend": function($event) {
        _vm.transition = false
      }
    }
  }, [_c('div', {
    class: ['modal-dialog', {
      'modal-lg': _vm.large,
      'modal-sm': _vm.small
    }],
    style: ({
      width: _vm.optionalWidth
    }),
    attrs: {
      "role": "document"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.action(null)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("modal-header", [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 2)
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])]), _vm._v(" "), _vm._t("modal-body", [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._t("modal-footer", [_c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 3)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(true, 4)
      }
    }
  }, [_vm._v(_vm._s(_vm.okText))])])])], 2)])])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(Math.round(_vm.pot_contracted * 100) / 100) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(Math.round((_vm.pot_contracted * 100 * 1.05)) / 100) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_penalty))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_general) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.current_power))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.status_analyzer))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_active_power))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.current_active_power))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_general) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power_diary))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.current_active_power))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_general) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cos_phi_2))])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cos_phi))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi_general) + " φ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.monthly_energy_consumed))])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v("Estat SCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "status-home-analyzer"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-general"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-general-diari"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-general"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "ener-act-hom-analyzer"
    }
  })])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card page-card-margin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.web_texts.sys_info) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.name))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.type_invoice))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.access_rate))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p1_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p2_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p3_contracted) + " kW")])]), _vm._v(" "), (_vm.system.p4_contracted !== null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p4_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p5_contracted) + " kW")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.system.p6_contracted) + " kW")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      " + _vm._s(_vm.web_texts.app_info) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.app_version))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 col-form-label"
  }, [_vm._v("v3.8.1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 col-form-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.web_texts.system_energetic_control))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_vm._v("© 2019")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P4")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 col-form-label"
  }, [_c('b', [_vm._v("P6")])])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('AppHeader', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-2",
    staticStyle: {
      "width": "350px",
      "height": "350px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-bottom": "25px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-1"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 margin-top-7"
  }, [_vm._v("\n                Remember\n                "), _c('label', {
    staticClass: "switch switch-default switch-pill switch-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header text-center",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "47px",
      "width": "175px"
    },
    attrs: {
      "src": "static/img/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.create_energetic_inform))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "energetic-inform",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-3 form-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "offset-lg-4 col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner_energetic_inform
    },
    on: {
      "click": function($event) {
        _vm.createEnergeticInform()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(_vm._s(_vm.web_texts.create))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.spinner_energetic_inform
    },
    on: {
      "click": function($event) {
        _vm.resetEnergeticForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.energetic_inform))])]), _vm._v(" "), (_vm.spinner_energetic_inform) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.invoices,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v("Informe Energetic")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.start_datetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.end_datetime))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.downloadInvoice(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        })]), _vm._v(" "), (props.row.user_id !== 2) ? _c('button', {
          staticClass: "btn btn-danger ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteInformApi(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })]) : _vm._e()])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.control) ? _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-2",
    staticStyle: {
      "width": "350px",
      "height": "350px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-bottom": "25px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-1"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-2"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.control == false) ? _c('h1', [_vm._v(_vm._s(_vm.cabal))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header text-center",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "47px",
      "width": "175px"
    },
    attrs: {
      "src": "static/img/logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.create_annually_inform))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "energetic-inform",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-3 form-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "offset-lg-4 col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.spinner_electrical_summary
    },
    on: {
      "click": function($event) {
        _vm.createEnergeticInform()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(_vm._s(_vm.web_texts.create))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.spinner_electrical_summary
    },
    on: {
      "click": function($event) {
        _vm.resetEnergeticForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.annually_inform))])]), _vm._v(" "), (_vm.spinner_electrical_summary) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.invoices,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s("Informe Anual"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.start_datetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.end_datetime))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.downloadInvoice(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        })]), _vm._v(" "), (props.row.user_id !== 2) ? _c('button', {
          staticClass: "btn btn-danger ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteInformApi(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })]) : _vm._e()])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.create_invoice_simulation))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal ",
    attrs: {
      "id": "invoice-simulation",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-4 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 form-group"
  }, [_c('label', {
    attrs: {
      "for": "user-name"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.username))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_name),
      expression: "user_name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "user-name",
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "slave_type"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device_model))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slave_type),
      expression: "slave_type"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "slave_type",
      "name": "slave_type",
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slave_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getDeviceNumberAndVariables()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_model))]), _vm._v(" "), _vm._l((_vm.slave_types), function(slave_type) {
    return (slave_type !== 'Irrimation') ? _c('option', {
      domProps: {
        "value": slave_type
      }
    }, [_vm._v("\n                      " + _vm._s(slave_type) + "\n                    ")]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "chose_device"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.device))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device),
      expression: "device"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "chose_device",
      "name": "chose_device",
      "size": "1",
      "disabled": !_vm.slave_type
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.select_device))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.type == 'CVM' || device.type == 'CVMNET' || device.type == 'CVMMINI') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "offset-lg-4 col-lg-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "disabled": _vm.spinner_invoice_simulation
    },
    on: {
      "click": function($event) {
        _vm.createInvoiceReports()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" " + _vm._s(_vm.web_texts.create))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset",
      "disabled": _vm.spinner_invoice_simulation
    },
    on: {
      "click": function($event) {
        _vm.resetInvoiceForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.invoice_simulation))])]), _vm._v(" "), (_vm.spinner_invoice_simulation) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.invoices,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name_slave))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.start_datetime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.end_datetime))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.downloadInvoice(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteInformApi(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })])])]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(!_vm.generator_shunt && !_vm.pump_shunt && !_vm.diffs_shunt) ? _c('GeneralSpinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabs-select-style col-md-12 mb-12"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill"
  }, [(_vm.generator_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_generator
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('generator')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.generator) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.pump_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_pump
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('pump')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.pump) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.diffs_shunt) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tab_selected_diffs
    },
    on: {
      "click": function($event) {
        _vm.clickNavTabs('diffs')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.diffs) + "\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-12"
  }, [(_vm.tab_selected_generator) ? _c('div', [_c('GeneratorShunting', {
    attrs: {
      "devices": _vm.devices
    }
  })], 1) : (_vm.tab_selected_pump) ? _c('div', [_c('PumpShunting', {
    attrs: {
      "devices": _vm.devices
    }
  })], 1) : (_vm.tab_selected_diffs) ? _c('div', [_c('DiffShunting')], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.mag_diff_well))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))])]), _vm._v(" "), (_vm.mag_dif_well === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('well', 'OFF')
      }
    }
  }, [_vm._v("ON")]) : (_vm.mag_dif_well === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('well', 'ON')
      }
    }
  }, [_vm._v("OFF")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events_well,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.mag_diff_raft))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('i', {
    staticClass: "icon-shuffle font-2xl"
  }), _vm._v(" "), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.status))])]), _vm._v(" "), (_vm.mag_dif_raft === 'ON') ? _c('button', {
    staticClass: "btn col-md-5 btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('raft', 'OFF')
      }
    }
  }, [_vm._v("ON")]) : (_vm.mag_dif_raft === 'OFF') ? _c('button', {
    staticClass: "btn col-md-5 btn-danger btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changeStatusMagDif('raft', 'ON')
      }
    }
  }, [_vm._v("OFF")]) : _c('button', {
    staticClass: "btn col-md-5 btn-default btn-lg btn-block",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("S/D")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.partials.shuntings))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "min-height": "352px"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list_events_raft,
      "paginate": true,
      "perPage": 4,
      "defaultSortBy": {
        field: 'date',
        type: 'desc'
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.shunter))]), _vm._v(" "), _c('td', {
          class: props.row.value
        }, [_vm._v(_vm._s(props.row.value))])]
      }
    }])
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-select-styleanimated fadeIn"
  }, [(_vm.spinner_eve) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" " + _vm._s(_vm.web_texts.system_events))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.events,
      "paginate": true,
      "perPage": 10
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.maximeter_analysis))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-lg-5 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.web_texts.date_range))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.all_devices))]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.check_boxes), function(check_box) {
    return _c('span', {
      staticClass: "col-xlg-5 col-md-5 col-sm-5 col-xs-5",
      staticStyle: {
        "margin-top": "-10px",
        "margin-right": "10px"
      }
    }, [(check_box.name !== 'Irrimation' && check_box.type !== 'CVMNET4' && check_box.type !== 'LM4A') ? _c('input', {
      attrs: {
        "type": "checkbox",
        "id": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.checkValue(check_box.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (check_box.name !== 'Irrimation' && check_box.type !== 'CVMNET4' && check_box.type !== 'LM4A') ? _c('label', {
      attrs: {
        "for": "checkbox"
      }
    }, [_vm._v(_vm._s(check_box.name))]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('hr', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('graph')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(_vm._s(_vm.web_texts.graph))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "disabled": _vm.isButtonDisabled
    },
    on: {
      "click": function($event) {
        _vm.selectTableOrGraphAndBuildRequest('table')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(_vm._s(_vm.web_texts.table))])])])])])])]), _vm._v(" "), (_vm.to_show === 'spinner') ? _c('GeneralSpinner') : (_vm.to_show === 'table') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.max_historical))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.table_data_power,
      "paginate": true,
      "perPage": 5
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.dateTime))]), _vm._v(" "), _vm._l((props.row.field), function(lectures) {
          return (_vm.multiple_values) ? _c('td', [_vm._v(_vm._s(Math.round(lectures.value * 100) / 100) + " kW")]) : _vm._e()
        }), _vm._v(" "), (!_vm.multiple_values) ? _c('td', [_vm._v(_vm._s(Math.round(props.row.field.value * 100) / 100) + " kW")]) : _vm._e()]
      }
    }])
  })], 1)])])]) : (_vm.to_show === 'graph') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.web_texts.max_historical))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "chartContainer"
    }
  })])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('span', {
    staticClass: "add-on input-group-addon"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar fa fa-calendar"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "name": "daterange",
      "id": "daterange"
    }
  })])
}]}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler hidden-lg-up",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n      ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-md-down"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('span', {
    staticClass: "active"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v(_vm._s(_vm.web_texts.header.select_system))]), _vm._v(" "), _c('span', [_vm._v(" | " + _vm._s(_vm.system.name))])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('span', {}, [_vm._v("IDIOMA")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-center",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.changeLang('cat')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": 'static/img/catalonia.png',
      "height": "21",
      "width": "21"
    }
  }), _vm._v("  CATALÀ")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.changeLang('es')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": 'static/img/spain.png',
      "height": "21",
      "width": "21"
    }
  }), _vm._v("  ESPAÑOL")])])]), _vm._v("\n       \n      "), _c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default_avatar.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-down"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Settings")])]), _vm._v(" "), (_vm.$route.name !== '') ? _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.$router.push('profile')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.web_texts.header.profile))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.web_texts.header.logout))])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item hidden-md-down"
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(Math.round(_vm.pot_contracted * 1.05 * 100) / 100) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_penalty))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api_now))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cosi) + " φ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cosi))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi) + " φ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-cvmnet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvmnet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvmnet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-cvmnet"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvmnet4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvmnet4-act-react"
    }
  })])
}]}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [(_vm.$route.name !== '') ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.general_info) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/home'
    }
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.start) + " ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/device'
    }
  }, [_c('i', {
    staticClass: "icon-screen-smartphone"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.devices) + " ")])], 1), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/shunting'
    }
  }, [_c('i', {
    staticClass: "icon-wrench"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.shunttings) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.status_system) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/notifications',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.notifications))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/messages',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speech"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.messages))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/events',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-tag"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.events))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.informs) + "\n        ")]), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/maximeter',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.maximeters))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/export_data',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.export_inform))])], 1), _vm._v(" "), (_vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/energetic_inform',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-credit-card"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.inf_energetic))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/costs_inform',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-credit-card"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.inf_costs))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/invoice_simulation',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-chart"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.invoice_simulation))])], 1) : _vm._e(), _vm._v(" "), (_vm.system.id !== 11 && _vm.system.id !== 19 && _vm.user.id === 1 && _vm.system.id !== 20) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/anuall_sumary',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-chart"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.annually_inform))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n          " + _vm._s(_vm.web_texts.sidebar.app_info) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/info',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-info"
  }), _vm._v(" " + _vm._s(_vm.web_texts.sidebar.sce_info))])], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.spinner_device) ? _c('GeneralSpinner') : _c('div', [_c('div', {
    staticClass: "tabs-select-style form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_device),
      expression: "selected_device"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select",
      "name": "select"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected_device = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectDevice()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.web_texts.selected_device_t))]), _vm._v(" "), _vm._l((_vm.devices), function(device) {
    return (device.name !== 'Irrimation' && device.type !== 'CVMNET4' && device.type !== 'LM4A') ? _c('option', {
      domProps: {
        "value": device
      }
    }, [_vm._v(_vm._s(device.name))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.device_type === 'CVM') ? _c('div', [_c('CvmAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'CVMMINI' || _vm.device_type === 'CVMNET') ? _c('div', [_c('LiteAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'NET4CH') ? _c('div', [_c('Net4Analyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : (_vm.device_type === 'CEMC6' || _vm.device_type === 'CEMC30' || _vm.device_type === 'CEMC20') ? _c('div', [_c('EnergyAnalyzer', {
    attrs: {
      "device_select": _vm.selected_device
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.notifications == []) ? _c('GeneralSpinner') : _c('div', {
    staticClass: "page-card-margin row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(_vm._s(_vm.web_texts.notifications))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.notifications,
      "paginate": true,
      "perPage": 10
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Settings\n")])
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://enateinnova.com",
      "target": "_blank"
    }
  }, [_vm._v("SCE")]), _vm._v(" © 2019\n  "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("Developed by "), _c('a', {
    attrs: {
      "href": "https://enateinnova.com",
      "target": "_blank"
    }
  }, [_vm._v("ENATE Innova SL")])])])
}]}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('br'), _vm._v(" "), (_vm.show_spinner) ? _c('div', {
    staticClass: "sk-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-child"
  })]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 push-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("\n                  Vol recarregar la pagina?\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("\n                 \n                 \n            "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reloadPage()
      }
    }
  }, [_c('i', {
    staticClass: "icon-reload"
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', [_c('strong', [_vm._v("NO ES TROBEN ELEMENTS")])])])
}]}

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */
/***/ (function(module, exports) {

module.exports = {"create_annually_inform":"Crear Informe Anual","date_range":"Rang de dates","create":"Crear","annually_inform":"Informe Anual"}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"create_costs_informs":"Crear informe de costos","date_range":"Rang de dates","inform_name":"Nom de l'informe","model_device":"Model Disp.","select_model":"Tria Model","device":"Dispositiu","create":"Crear","costs_inform":"Informe de costos"}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"create_energetic_inform":"Crear Informe Energetic","date_range":"Rang de dates","create":"Crear","energetic_inform":"Informe Energetic"}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"system_events":"Esdeveniments interns del sistema"}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"information_analysis":"Anàlisi d'informació","select_device":"Slececciona Dispositiu","date_range":"Rang de dates","select_var":"Selecciona Variable","tension":"Tensió","intensity":"Intensitat","cos_phi":"Cosinus Phi","power_factor":"Factor Pot.","active_energy":"Energia Act.","reactive_energy":"Energia React.","max_demand":"Max. Demanda","active_power":"Potencia Act.","harmonic_intensity":"Armonic Int.","harmonic_tension":"Armonic Ten.","graphic":"Gràfic","table":"Taula","info_to_export":"Informació a Exportar","maximeter_historical":"Històric Maxímetre"}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"sys_info":"Informació Sistema","name":"Nom","type_invoice":"Tipus Factura","app_info":"Informació Aplicació","app_version":"Versió de l'Aplicació","system_energetic_control":"Systema Control Energetic"}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"create_invoice_simulation":"Crear simulació de factura","date_range":"Rang de dates","username":"Nom usuari","device_model":"Model dispositiu","select_model":"Tria Model","device":"Dispositiu","select_device":"Tria Dispositiu","create":"Crear","invoice_simulation":"Simulacions de factura"}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"maximeter_analysis":"Anàlisi de maxímetre","date_range":"Rang de dates","all_devices":"Tots els dispositius","graph":"Gràfic","table":"Taula","max_historical":"Històric Maxímetre"}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"messages":"Missatges"}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"notifications":"Notificacions"}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"select":"Seleccionar"}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"create_annually_inform":"Crear Informe Anual","date_range":"Rango de fechas","create":"Crear","annually_inform":"Informe Anual"}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"create_costs_informs":"Crear informe de costes","date_range":"Rango de fechas","inform_name":"Nombre del informe","model_device":"Modelo Disp.","select_model":"Elige Modelo","device":"Dispositivo","create":"Crear","costs_inform":"Informe de costes"}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"create_energetic_inform":"Crear Informe Energético","date_range":"Rango de fechas","create":"Crear","energetic_inform":"Informe Energético"}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"system_events":"Eventos internos del sistema"}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"information_analysis":"Análisis de información","select_device":"Seleccionar Dispositivo","date_range":"Rango de fechas","select_var":"Seleccionar Variable","tension":"Tension","intensity":"Intensidad","cos_phi":"Coseno Phi","power_factor":"Factor Pot.","active_energy":"Energía Act.","reactive_energy":"Energía React.","max_demand":"Max. Demanda","active_power":"Potencia Act.","harmonic_intensity":"Armónico Int.","harmonic_tension":"Armónico Ten.","graphic":"Gráfico","table":"Tabla","info_to_export":"Información a Exportar","maximeter_historical":"Histórico maxímetro"}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"sys_info":"Información Sistema","name":"Nombre","type_invoice":"Tipo Factura","app_info":"Información Aplicación","app_version":"Versión de la Aplicación","system_energetic_control":"Sistema Control Energético"}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"create_invoice_simulation":"Crear simulación de factura","date_range":"Rango de fechas","username":"Nombre usuario","device_model":"Modelo dispositivo","select_model":"Elige Modelo","device":"Dispositivo","select_device":"Elige Dispositivo","create":"Crear","invoice simulation":"Simulaciones de factura"}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"maximeter_analysis":"Análisis de maxímetro","date_range":"Rango de fechas","all_devices":"Todos los dispositivos","graph":"Gráfico","table":"Tabla","max_historical":"Histórico maxímetro"}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"messages":"Mensajes"}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"notifications":"Notificaciones"}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = {"select":"Seleccionar"}

/***/ })
],[261]);


// WEBPACK FOOTER //
// static/js/app.fe3021e087cc9d6267a9.js